
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6o1Xn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $72582f6b73f35560$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $fNobW = parcelRequire("fNobW");

var $kb4zh = parcelRequire("kb4zh");

var $grj9i = parcelRequire("grj9i");

var $8IR5c = parcelRequire("8IR5c");

var $7DYR6 = parcelRequire("7DYR6");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$72582f6b73f35560$export$2e2bcd8739ae039 = ()=>{
    const isAgentViewMounted = (0, $5uXOq.useRef)(false);
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const [issueKeys, setIssueKeys] = (0, $5uXOq.useState)([]);
    const [issuesCount, setIssuesCount] = (0, $5uXOq.useState)(0);
    const pageId = match.params.issueKey ? 'queues-issue-view' : 'queues-agent-view';
    const onIssuesChanged = (keys)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(keys, issueKeys)) setIssueKeys(keys);
    };
    const onIssuesCountChanged = (count)=>{
        setIssuesCount(count);
    };
    const issueNavigatorData = (0, $5uXOq.useMemo)(()=>{
        const { issueKey: issueKey } = match.params;
        return issueKey ? {
            issueKey: issueKey,
            issueKeys: issueKeys,
            knownIssueKeys: issueKeys.filter((key)=>!!key),
            issuesCount: issuesCount
        } : undefined;
    }, [
        issueKeys,
        issuesCount,
        match.params
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $grj9i.default), {
        pageId: pageId
    }, ({ pageContext: pageContext, queuesData: queuesData, push: push, replace: replace })=>{
        if (!pageContext) return (0, $4R6GH.fg)('add_ufo_load_hold_to_custom_queue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "queues-app-base"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
        const shouldRenderAgentView = isAgentViewMounted.current || !match.params.issueKey;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, match.params.issueKey && // todo: add_ufo_load_hold_to_custom_queue. This should no longer be relavant after the split
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7DYR6.default), {
            pageContext: pageContext,
            issueNavigatorData: issueNavigatorData,
            // @ts-expect-error - TS2322 - Type 'QueuesPush' is not assignable to type '(url: string) => void'.
            push: push,
            match: match
        }), shouldRenderAgentView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8IR5c.default), {
            queuesData: queuesData,
            push: push,
            // @ts-expect-error - TS2322 - Type '((path: string) => void | Promise<void>) | undefined' is not assignable to type '(path: string) => void | Promise<void>'.
            replace: replace,
            queueId: match.params.queueId || '',
            pageContext: pageContext,
            isQueueVisible: !match.params.issueKey,
            isAgentViewMountedRef: isAgentViewMounted,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }));
    });
};

});
parcelRegister("grj9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $412a33f5222e913d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $cf7yQ = parcelRequire("cf7yQ");

var $53AcJ = parcelRequire("53AcJ");

var $kbi2o = parcelRequire("kbi2o");

var $jF62O = parcelRequire("jF62O");

var $e33py = parcelRequire("e33py");

var $gq0sA = parcelRequire("gq0sA");

var $cz40O = parcelRequire("cz40O");

var $8XAvX = parcelRequire("8XAvX");

var $1ilU2 = parcelRequire("1ilU2");

var $g5X3G = parcelRequire("g5X3G");

var $4dRjY = parcelRequire("4dRjY");

var $doZTA = parcelRequire("doZTA");

var $k30xR = parcelRequire("k30xR");

var $6OeKD = parcelRequire("6OeKD");
const $412a33f5222e913d$var$QueuesAppBase = (props)=>{
    const { QueuesPushProvider: QueuesPushProvider, pageId: pageId } = props;
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const [{ data: pageContextData, error: error }] = (0, $gq0sA.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { baseUrl: baseUrl = '' } = tenantContext || {};
    const { projectName: projectName } = projectContext || {};
    const pageContextProps = (0, $5uXOq.useMemo)(()=>({
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }), [
        projectContext,
        serviceDeskContext,
        tenantContext
    ]);
    const projectKey = (0, $g5X3G.toProjectKey)(match.params.projectKey || '');
    const practice = (0, $1ilU2.toItsmPractice)(match.params.practiceType);
    const [categorizedQueues, categorizedQueuesLoading, categorizedError, methods] = (0, $jF62O.useCategorizedQueues)(baseUrl, projectKey, practice);
    let selectedQueueName;
    if (categorizedQueues && match.params.queueId) {
        const selectedQueue = categorizedQueues.find((queue)=>queue.id === Number(match.params.queueId));
        selectedQueueName = selectedQueue ? selectedQueue.name : undefined;
    }
    (0, $k30xR.useOnFavoritesChanged)(projectKey, practice, categorizedQueues, methods.editItemFavorite);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cz40O.SpaPageWrapper), {
        pageId: pageId,
        baseUrl: baseUrl,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: !pageContextData && !error || categorizedQueuesLoading,
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(QueuesPushProvider, {
        projectKey: projectKey
    }, ({ push: push, replace: providerReplace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e33py.ServiceDeskDocumentTitle), {
            // @ts-expect-error - TS2322 - Type '{ projectName: string | undefined; section: string; }' is not assignable to type 'IntrinsicAttributes & Diff<(Diff<RefAttributes<any> | (RefAttributes<any> & { children?: ReactNode; }), Partial<RefAttributes<...> | (RefAttributes<...> & { ...; })>> & RefAttributes<...>) | (Diff<...> & ... 1 more ... & { ...; }), InjectIntlVoidProps> & { ...; }'.
            projectName: projectName,
            section: "queues",
            subsection: selectedQueueName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children({
            push: push,
            match: match,
            replace: providerReplace,
            queuesData: {
                data: (0, $6OeKD.pageToQueues)(categorizedQueues || []),
                error: categorizedError ? categorizedError.message : undefined,
                loading: categorizedQueuesLoading
            },
            category: practice,
            // @ts-expect-error - TS2322 - Type '{ portalId?: number | undefined; canSeeNewIssueView?: boolean | undefined; userRole?: string | undefined; serviceDeskId?: number | undefined; projectId?: number | undefined; projectKey?: string | undefined; ... 11 more ...; isSiteAdmin?: boolean | undefined; }' is not assignable to type 'PageProps'.
            pageContext: pageContextProps
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null));
};
var $412a33f5222e913d$export$2e2bcd8739ae039 = (0, $9sGI6.default)($412a33f5222e913d$var$QueuesAppBase, {
    QueueProvider: (0, $kbi2o.default),
    QueuesApiDataProvider: (0, $53AcJ.default),
    QueuesPushProvider: (0, $8XAvX.default)
});

});
parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("sXYgA")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2OvSt")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("f6mEW")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1oRHz")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("sXYgA", function(module, exports) {

let $057122a3b41c04fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $057122a3b41c04fd$var$load("eNmuD"),
    $057122a3b41c04fd$var$load("chQyv")
]).then(()=>parcelRequire('hZyYK'));

});

parcelRegister("2OvSt", function(module, exports) {

let $20c8fa806ea6db90$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $20c8fa806ea6db90$var$load("eNmuD"),
    $20c8fa806ea6db90$var$load("cM9em"),
    $20c8fa806ea6db90$var$load("fr9NE"),
    $20c8fa806ea6db90$var$load("3Xgpx")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("f6mEW", function(module, exports) {

let $afe8fe3c672ff16f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $afe8fe3c672ff16f$var$load("eNmuD"),
    $afe8fe3c672ff16f$var$load("cM9em"),
    $afe8fe3c672ff16f$var$load("fr9NE"),
    $afe8fe3c672ff16f$var$load("hlGg7")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("1oRHz", function(module, exports) {

let $1051b0675adbeaab$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1051b0675adbeaab$var$load("eNmuD"),
    $1051b0675adbeaab$var$load("cM9em"),
    $1051b0675adbeaab$var$load("fr9NE"),
    $1051b0675adbeaab$var$load("eXDqW")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("53AcJ", function(module, exports) {

$parcel$export(module.exports, "AvailableQueuesConsumer", () => $f81f7587879fbe9d$export$dfebed0fc9519fcc);
$parcel$export(module.exports, "default", () => $f81f7587879fbe9d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $dd29Z = parcelRequire("dd29Z");

var $3HGy4 = parcelRequire("3HGy4");

var $5j0B5 = parcelRequire("5j0B5");

var $gm93k = parcelRequire("gm93k");

var $8nV9C = parcelRequire("8nV9C");
const $f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
// @ts-expect-error - TS2322 - Type 'Context<{ setFavorite: (...args: any[]) => void; deleteNavItem: (...args: any[]) => void; updateIssueCount: (...args: any[]) => void; markNavItemsAsStale: (...args: any[]) => void; getQueueCount: (...args: any[]) => void; setLastVisitedQueueId: (...args: any[]) => void; getLastVisitedQueueId: (...args: any[]) => voi...' is not assignable to type 'Context<QueuesContextType>'.
const $f81f7587879fbe9d$var$AvailableQueuesContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    setFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    deleteNavItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    markNavItemsAsStale: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getQueueCount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    setLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const { Provider: $f81f7587879fbe9d$var$Provider, Consumer: $f81f7587879fbe9d$export$dfebed0fc9519fcc } = $f81f7587879fbe9d$var$AvailableQueuesContext;
class $f81f7587879fbe9d$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            FavoriteSubscriber: (0, $gm93k.default),
            queuesPrefetchData: [],
            push: undefined,
            onDeleteNavItem: undefined
        };
    }
    constructor(props){
        const { onNavUpdated: onNavUpdated, onIssueCountUpdated: onIssueCountUpdated, queuesPrefetchData: queuesPrefetchData, push: push } = props;
        super(props), this.getQueueCount = ()=>{
            const { data: data } = this.state;
            return data ? Object.keys(data).filter((queueId)=>!this.deletedQueueIds.has((0, $3HGy4.toQueueIdString)(queueId))).length : 0;
        }, this.getLastVisitedQueueId = (projectKey)=>{
            const { category: category } = this.props;
            if (!projectKey) return null;
            try {
                if (category) return (0, $5j0B5.getFromLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
                return (0, $5j0B5.getFromLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                return null;
            }
        }, this.setFavorite = (queueId, newValue)=>{
            const { FavoriteSubscriber: FavoriteSubscriber } = this.props;
            FavoriteSubscriber.setFavorite(queueId, newValue);
        }, this.setLastVisitedQueueId = (queueId, projectKey)=>{
            const lastVisitedQueueId = this.getLastVisitedQueueId(projectKey);
            const { category: category } = this.props;
            // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'string | null | undefined' and 'number' have no overlap.
            if (projectKey && lastVisitedQueueId !== queueId) try {
                if (category) (0, $5j0B5.setInLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $3HGy4.fromQueueIdString)(queueId));
                else (0, $5j0B5.setInLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`, (0, $3HGy4.fromQueueIdString)(queueId));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
            // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
            }
        };
        this.queuesContext = {
            deleteNavItem: this.deleteNavItem(push),
            updateIssueCount: onIssueCountUpdated,
            markNavItemsAsStale: ()=>onNavUpdated(false),
            setFavorite: this.setFavorite,
            getQueueCount: this.getQueueCount,
            setLastVisitedQueueId: this.setLastVisitedQueueId,
            getLastVisitedQueueId: this.getLastVisitedQueueId
        };
        this.deletedQueueIds = new Set();
        this.state = {
            loading: false,
            error: undefined,
            data: queuesPrefetchData.length ? (0, $8nV9C.pageToQueues)(queuesPrefetchData) : undefined
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { queuesPrefetchData: queuesPrefetchData } = props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))((0, $8nV9C.pageToQueues)(queuesPrefetchData), state.data) && queuesPrefetchData.length) return {
            data: (0, $8nV9C.pageToQueues)(queuesPrefetchData)
        };
        return null;
    }
    componentWillUnmount() {
        const { fetchSubscription: fetchSubscription, deleteItemSubscription: deleteItemSubscription } = this;
        fetchSubscription && fetchSubscription.unsubscribe();
        deleteItemSubscription && deleteItemSubscription.unsubscribe();
    }
    deleteNavItem(push) {
        return (queueId)=>{
            const { onDeleteNavItem: onDeleteNavItem } = this.props;
            onDeleteNavItem && onDeleteNavItem((0, $3HGy4.fromQueueIdString)(queueId));
            // update queue counts to reflect the deletion
            // note that deleteQueueFromSidebar is called after the delete endpoint returns success
            const updatedQueues = {
                ...this.state.data
            };
            delete updatedQueues[(0, $3HGy4.fromQueueIdString)(queueId)];
            const deletedLastQueue = Object.keys(updatedQueues).length === 0;
            if (deletedLastQueue) push && push(`${(0, $dd29Z.getQueueFragment)()}/custom/new`);
            else push && push((0, $dd29Z.getQueueFragment)());
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f81f7587879fbe9d$var$Provider, {
            value: this.queuesContext
        }, this.props.children(this.state));
    }
}

});
parcelRegister("dd29Z", function(module, exports) {

$parcel$export(module.exports, "QUEUE_ROUTES", () => $10cfdb56a53da9cf$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $10cfdb56a53da9cf$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $10cfdb56a53da9cf$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $10cfdb56a53da9cf$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $10cfdb56a53da9cf$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $10cfdb56a53da9cf$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $10cfdb56a53da9cf$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $10cfdb56a53da9cf$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $10cfdb56a53da9cf$export$91152835d12ca65f);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $5viSR = parcelRequire("5viSR");

var $oCMSG = parcelRequire("oCMSG");

var $hzd6p = parcelRequire("hzd6p");
const $10cfdb56a53da9cf$var$LOCATION = 'servicedesk.common.navigation.queues';
let $10cfdb56a53da9cf$var$navigatorPromise;
const $10cfdb56a53da9cf$var$getPushStateNavigator = ()=>{
    if (!$10cfdb56a53da9cf$var$navigatorPromise) $10cfdb56a53da9cf$var$navigatorPromise = (0, $hzd6p.createPushStateNavigator)();
    return $10cfdb56a53da9cf$var$navigatorPromise;
};
const $10cfdb56a53da9cf$export$410a6306dae101ca = {
    [(0, $oCMSG.INCIDENTS)]: 'section/incidents',
    [(0, $oCMSG.CHANGES)]: 'section/changes',
    [(0, $oCMSG.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $oCMSG.PROBLEMS)]: 'section/problems',
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $oCMSG.NO_CATEGORY)]: 'queues'
};
const $10cfdb56a53da9cf$var$fromCategory = (category)=>$10cfdb56a53da9cf$export$410a6306dae101ca[category || (0, $oCMSG.NO_CATEGORY)];
const $10cfdb56a53da9cf$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $5viSR.emitSignal)($10cfdb56a53da9cf$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $kVLXA.Observable).fromPromise($10cfdb56a53da9cf$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $kVLXA.Observable).empty();
    }).catch(()=>(0, $kVLXA.Observable).empty());
};
const $10cfdb56a53da9cf$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $10cfdb56a53da9cf$export$86f6a6d69e87f843 = (queueId, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/edit`;
const $10cfdb56a53da9cf$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $10cfdb56a53da9cf$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $10cfdb56a53da9cf$export$a796bfaff67c9fae = (issueKey)=>`${$10cfdb56a53da9cf$export$954f428fa284c7()}/issue/${issueKey}`;
const $10cfdb56a53da9cf$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $10cfdb56a53da9cf$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("5viSR", function(module, exports) {

$parcel$export(module.exports, "emitSignal", () => $8dc3d00171ca741d$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Cypress tests.
 *
 * This acts as a bridge between the storybook application and cypress for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $8dc3d00171ca741d$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8dc3d00171ca741d$var$registerSignal = (signal, meta)=>{
    window.cySignals.allSignals.push(signal);
    const signalsByName = window.cySignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $8dc3d00171ca741d$var$initCySignals = ()=>{
    window.cySignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $8dc3d00171ca741d$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($8dc3d00171ca741d$var$isProduction()) return;
    if (!window.cySignals) $8dc3d00171ca741d$var$initCySignals();
    $8dc3d00171ca741d$var$registerSignal(signal, meta);
};

});

parcelRegister("hzd6p", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $ddde70bc55609ded$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $ddde70bc55609ded$var$REQUIRE_TIMEOUT = 100;
const $ddde70bc55609ded$var$REQUIRE_RETRIES = 5;
const $ddde70bc55609ded$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $ddde70bc55609ded$var$REQUIRE_TIMEOUT,
        tentatives: $ddde70bc55609ded$var$REQUIRE_RETRIES
    });

});


parcelRegister("3HGy4", function(module, exports) {

$parcel$export(module.exports, "toQueueId", () => $ad23a38600e1d52f$export$dae52b119ebf2444);
$parcel$export(module.exports, "fromQueueId", () => $ad23a38600e1d52f$export$999de35c9ca8105b);
$parcel$export(module.exports, "toQueueIdString", () => $ad23a38600e1d52f$export$cda0e35414946580);
$parcel$export(module.exports, "fromQueueIdString", () => $ad23a38600e1d52f$export$cde8da12f845d56f);
$parcel$export(module.exports, "LOCAL_STORAGE_SOURCE", () => $ad23a38600e1d52f$export$6e21137db7aec966);
$parcel$export(module.exports, "PREFETCHER_SOURCE", () => $ad23a38600e1d52f$export$ce13a6c409c4db7d);
$parcel$export(module.exports, "REST_SOURCE", () => $ad23a38600e1d52f$export$e85fb1a0846db30f);
$parcel$export(module.exports, "SSR_SOURCE", () => $ad23a38600e1d52f$export$c5c05bf31a872c73);
const $ad23a38600e1d52f$export$dae52b119ebf2444 = (queueId)=>queueId;
const $ad23a38600e1d52f$export$999de35c9ca8105b = (queueId)=>queueId;
const $ad23a38600e1d52f$export$cda0e35414946580 = (queueId)=>$ad23a38600e1d52f$export$dae52b119ebf2444(Number(queueId));
const $ad23a38600e1d52f$export$cde8da12f845d56f = (queueId)=>$ad23a38600e1d52f$export$999de35c9ca8105b(queueId).toString();
const $ad23a38600e1d52f$export$6e21137db7aec966 = 'LOCAL_STORAGE';
const $ad23a38600e1d52f$export$ce13a6c409c4db7d = 'PREFETCHER';
const $ad23a38600e1d52f$export$e85fb1a0846db30f = 'REST';
const $ad23a38600e1d52f$export$c5c05bf31a872c73 = 'SSR';

});

parcelRegister("5j0B5", function(module, exports) {

$parcel$export(module.exports, "getFromLocalStorage", () => $a6505ee1b0c5b1ab$export$602bc7b349337fec);
$parcel$export(module.exports, "setInLocalStorage", () => $a6505ee1b0c5b1ab$export$e7b9840f77b6b2a4);

var $bSSG7 = parcelRequire("bSSG7");

var $9vBS6 = parcelRequire("9vBS6");
const $a6505ee1b0c5b1ab$export$f016358f0af18fa0 = (0, $bSSG7.createLocalExpirableStorageProvider)('servicedesk_queues');
const $a6505ee1b0c5b1ab$var$TIME_BEFORE_EXPIRY = 1209600000; // 14 days
const $a6505ee1b0c5b1ab$export$602bc7b349337fec = (key)=>{
    try {
        return $a6505ee1b0c5b1ab$export$f016358f0af18fa0.get(key);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // .get() can trigger an exception due to a bug in 'storejs', where if
        // LS is not able to be read or written, it will not initialise the store.
        (0, $9vBS6.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure on read');
        return null;
    }
};
const $a6505ee1b0c5b1ab$export$e7b9840f77b6b2a4 = (key, value)=>{
    try {
        const now = Date.now();
        $a6505ee1b0c5b1ab$export$f016358f0af18fa0.set(key, value, now + $a6505ee1b0c5b1ab$var$TIME_BEFORE_EXPIRY);
        $a6505ee1b0c5b1ab$export$f016358f0af18fa0.removeExpiredKeys();
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        (0, $9vBS6.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure');
        return false;
    }
};

});
parcelRegister("bSSG7", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $63804f80e89e547d$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $63804f80e89e547d$export$59acef2b3ab1df90);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $dEJQ9 = parcelRequire("dEJQ9");
const $63804f80e89e547d$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>(0, $fNVZf.createStorageProvider)((0, $fNVZf.WebStorageType).LocalStorage, appPrefix, (0, $dEJQ9.makeLocalStore)()));
const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    return (0, $fNVZf.createExpirableStorageProvider)((0, $fNVZf.WebStorageType).LocalStorage, appPrefix, (0, $dEJQ9.makeLocalExpirableStore)());
});

});
parcelRegister("fNVZf", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $04caddce42518619$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "WebStorageType", () => $04caddce42518619$export$259e3a861f28589b);
$parcel$export(module.exports, "createStorageProvider", () => $04caddce42518619$export$8441605555fbd60c);
$parcel$export(module.exports, "createExpirableStorageProvider", () => $04caddce42518619$export$b793a81cf479272a);

var $fKgem = parcelRequire("fKgem");

var $bHibm = parcelRequire("bHibm");

var $4R6GH = parcelRequire("4R6GH");

var $c7J1U = parcelRequire("c7J1U");
const $04caddce42518619$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
    (0, $c7J1U.default)
];
const $04caddce42518619$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};
const $04caddce42518619$export$8441605555fbd60c = (storageType, appPrefix = '', // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>appPrefix?.trim().length ? `${appPrefix}.${key}` : key;
    const storageAPI = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? (0, $bHibm.AtlBrowserStorageLocal) : (0, $bHibm.AtlBrowserStorageSession);
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const stringValue = JSON.stringify(value);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setItem(prefixedKey, stringValue);
                else store.set(prefixedKey, stringValue);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const stringValue = JSON.stringify(value);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setStrictlyNecessaryItem(prefixedKey, stringValue);
                else throw Error('Method setStrictlyNecessaryItem is not supported.');
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                let item;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) item = storageAPI.getItem(prefixedKey);
                else item = store.get(prefixedKey);
                return item ? JSON.parse(item) : undefined;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting item from storage:', err);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.removeItem(prefixedKey);
                else store.remove(prefixedKey);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error removing item from storage:', err);
            }
        },
        clearAll: ()=>{
            if (!appPrefix) throw Error("appPrefix is necessary to access clearAll method. It's used to separate apps.");
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
                else store.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        }
    };
};
const $04caddce42518619$export$b793a81cf479272a = (storageType, appPrefix, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>`${appPrefix}.${key}`;
    const storageAPI = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? (0, $bHibm.AtlBrowserStorageLocal) : (0, $bHibm.AtlBrowserStorageSession);
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const item = {
                    value: value,
                    expiration: expiration
                };
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setItem(prefixedKey, JSON.stringify(item));
                else store.set(prefixedKey, JSON.stringify(item));
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                const item = {
                    value: value,
                    expiration: expiration
                };
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setStrictlyNecessaryItem(getKeyWithPrefix(key), JSON.stringify(item));
                else throw Error('Method setStrictlyNecessaryItem is not supported.');
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            const prefixedKey = getKeyWithPrefix(key);
            try {
                let itemStr;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) itemStr = storageAPI.getItem(prefixedKey);
                else itemStr = store.get(prefixedKey);
                if (!itemStr) return undefined;
                const item = JSON.parse(itemStr);
                if (!item.expiration || item.expiration >= Date.now()) return item.value;
                storageAPI.removeItem(prefixedKey);
                return undefined;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, error);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.removeItem(prefixedKey);
                else store.remove(prefixedKey);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error removing item with key=${key}:`, error);
            }
        },
        removeExpiredKeys: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        const itemStr = storageAPI.getItem(key);
                        if (itemStr) {
                            const item = JSON.parse(itemStr);
                            if (item.expiration && item.expiration < Date.now()) {
                                storageAPI.removeItem(key);
                                i--;
                            }
                        }
                    }
                }
                else store.removeExpiredKeys();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error removing expired keys:', error);
            }
        },
        clearAll: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
                else store.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        }
    };
};

});
parcelRegister("c7J1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $99d922a6a243a194$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $cuNKJ = parcelRequire("cuNKJ");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $99d922a6a243a194$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $cuNKJ.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $jcw0u.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $cuNKJ.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $cuNKJ.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $cuNKJ.ONE_WEEK) >= (0, $cuNKJ.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $cuNKJ.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;

});
parcelRegister("cuNKJ", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $d21613ddd27d5bbf$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $d21613ddd27d5bbf$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $d21613ddd27d5bbf$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $d21613ddd27d5bbf$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $d21613ddd27d5bbf$export$ea28dfd9333cda2d);
const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("dEJQ9", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $dcae70c06981fc99$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $dcae70c06981fc99$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $dcae70c06981fc99$export$cf816b43e73de947);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $4Zgux = parcelRequire("4Zgux");

var $2NjNT = parcelRequire("2NjNT");

var $fNVZf = parcelRequire("fNVZf");
const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $dcae70c06981fc99$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});


parcelRegister("9vBS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c5e35df79dbfac$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");
const $35c5e35df79dbfac$var$PREFIX = '[Queues]';
/** This function logs privacy safe error.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $35c5e35df79dbfac$var$safeErrorWithoutCustomerData = (location, message, event)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe warning.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $35c5e35df79dbfac$var$safeWarnWithoutCustomerData = (location, message, event)=>{
    (0, $dJl1T.default).safeWarnWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $35c5e35df79dbfac$var$safeInfoWithoutCustomerData = (location, message, event)=>{
    (0, $dJl1T.default).safeInfoWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$35c5e35df79dbfac$export$2e2bcd8739ae039 = {
    safeInfoWithoutCustomerData: $35c5e35df79dbfac$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $35c5e35df79dbfac$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $35c5e35df79dbfac$var$safeErrorWithoutCustomerData
};

});


parcelRegister("gm93k", function(module, exports) {

$parcel$export(module.exports, "default", () => $8292a018a8b0a76e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eXQym = parcelRequire("eXQym");

var $3HGy4 = parcelRequire("3HGy4");
class $8292a018a8b0a76e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    static setFavorite() {}
    render() {
        return null;
    }
    constructor(...args){
        super(...args), this.onFavoritesChanged = (items)=>{
            const queueItemsObj = items[0, $eXQym.QUEUES_ITEM_TYPE];
            if (!queueItemsObj) return;
            // Object.values gives Array<mixed> according to Flow, which is wrong.
            // https://github.com/facebook/flow/issues/2221
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const queueItems = Object.values(queueItemsObj);
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            queueItems.forEach((item)=>this.props.onFavoriteItemChanged((0, $3HGy4.toQueueIdString)(item.id), item.value));
        };
    }
}

});

parcelRegister("8nV9C", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $fe4663d2a5f926fb$export$8ada91ce992fa66f);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $3HGy4 = parcelRequire("3HGy4");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe4663d2a5f926fb$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $kVLXA.Observable).of(transformFunc(payload)));
const $fe4663d2a5f926fb$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $fe4663d2a5f926fb$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $3HGy4.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $fe4663d2a5f926fb$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});
const $fe4663d2a5f926fb$export$9fd203f323102996 = (prefetchData, queues)=>{
    if (queues === undefined) return [];
    // @ts-expect-error - TS2322 - Type '{ favourite: boolean; columns: string[]; columnsDetails: { title: string; fieldType: string; sortable: boolean; fieldId: string; sortOrder: SortOrder | undefined; }[]; id: number; name: string; ... 8 more ...; shouldSkipIssueCountRefresh?: boolean | undefined; }[]' is not assignable to type 'Page[]'.
    return Object.keys(queues).map((queueId)=>{
        const updatedQueue = queues[queueId];
        const { isFavorite: isFavorite, columns: columns, isTransient: isTransient, ...queuesData } = updatedQueue;
        const cachedPage = prefetchData.find((q)=>String(q.id) === queueId);
        return {
            ...cachedPage,
            ...queuesData,
            favourite: isFavorite,
            columns: columns.map(({ id: id })=>id),
            columnsDetails: columns.map(({ id: id, currentSorting: currentSorting, ...remaining })=>({
                    fieldId: id,
                    sortOrder: currentSorting,
                    ...remaining
                }))
        };
    });
};
const $fe4663d2a5f926fb$export$4906aa3ec3919ad9 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues;
const $fe4663d2a5f926fb$export$17bdd949b6a9952 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JSD_QUEUES_PRELOAD_PROMISES) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
};

});


parcelRegister("kbi2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd787f787343b6f$export$2e2bcd8739ae039);

var $8RXs9 = parcelRequire("8RXs9");

var $cm25K = parcelRequire("cm25K");
var $fbd787f787343b6f$export$2e2bcd8739ae039 = (0, $8RXs9.default)((0, $cm25K.default));

});
parcelRegister("cm25K", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d6194b196376c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $eae50 = parcelRequire("eae50");

var $79GY5 = parcelRequire("79GY5");

var $hN5eZ = parcelRequire("hN5eZ");

var $PyWGC = parcelRequire("PyWGC");
const $55d6194b196376c0$var$findQueue = (source, id)=>(0, $7uUwQ.getIn)(source, [
        'data',
        id
    ]);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55d6194b196376c0$export$2e2bcd8739ae039 = ({ queueId: queueId, queuesDataSource: queuesDataSource, baseUrl: baseUrl, projectKey: projectKey, children: children, intl: { formatMessage: formatMessage } })=>{
    const lastUnfoundQueue = (0, $5uXOq.useRef)('');
    if (queuesDataSource.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79GY5.default), null);
    const queue = $55d6194b196376c0$var$findQueue(queuesDataSource, queueId);
    if (queue) {
        lastUnfoundQueue.current = '';
        (0, $hN5eZ.setLastVisitedQueueIdAndCategory)(queue.id, projectKey, queue.category);
        return children(queue);
    }
    if (lastUnfoundQueue.current === queueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $PyWGC.default).notFoundHeader),
        description: formatMessage((0, $PyWGC.default).notFoundDescription),
        onRetry: ()=>{
            // If data source errors out let user retry the current page they are on.
            // Otherwise queue doesn't exist so go back to /queues
            if (queuesDataSource.error) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.reload();
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(`${baseUrl}/jira/servicedesk/projects/${projectKey}/queues`);
        }
    });
    lastUnfoundQueue.current = queueId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79GY5.default), null);
};

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $lB1Xg = parcelRequire("lB1Xg");

var $9Le4I = parcelRequire("9Le4I");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($lB1Xg))) : (0, (/*@__PURE__*/$parcel$interopDefault($9Le4I)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: (0, $4R6GH.fg)('blu-4174-enghealth-13917-filters-dir-actions-title') ? headingLevel : undefined
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("lB1Xg", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("9Le4I", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("79GY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bdab3bb4aeae840$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
// No delay on this spinner; we don't know if the monolith had previously
// provided one. Better to increase risk a very brief display of a spinner
// than have the spinner vanish and return.
const $7bdab3bb4aeae840$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7bdab3bb4aeae840$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large",
        testId: "servicedesk-common.ui.components.page-spinner.spinner"
    }));
var $7bdab3bb4aeae840$export$2e2bcd8739ae039 = $7bdab3bb4aeae840$var$LoadingSpinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bdab3bb4aeae840$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i1jfw _1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hN5eZ", function(module, exports) {

$parcel$export(module.exports, "getLastVisitedQueueIdAndCategory", () => $3f3da0d4b812d0bb$export$b5b4407b2529d2c4);
$parcel$export(module.exports, "setLastVisitedQueueIdAndCategory", () => $3f3da0d4b812d0bb$export$947aff127337ffa5);

var $gccSB = parcelRequire("gccSB");

var $3HGy4 = parcelRequire("3HGy4");

var $5j0B5 = parcelRequire("5j0B5");

var $oCMSG = parcelRequire("oCMSG");

var $1ilU2 = parcelRequire("1ilU2");
const $3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
const $3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX = 'last_visited_category';
const $3f3da0d4b812d0bb$export$b5b4407b2529d2c4 = (projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) return [
        null,
        null
    ];
    try {
        if (category === (0, $oCMSG.NO_CATEGORY)) {
            // indicates a redirect from /queues endpoint
            const categoryToRedirectTo = (0, $5j0B5.getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`);
            const queueId = (0, $5j0B5.getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${categoryToRedirectTo}`);
            return [
                queueId,
                ...(0, $1ilU2.isValidItsmPractice)(categoryToRedirectTo) ? [
                    categoryToRedirectTo
                ] : [
                    (0, $oCMSG.NO_CATEGORY)
                ]
            ];
        }
        return [
            (0, $5j0B5.getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`),
            category
        ];
    } catch (error) {
        return [
            null,
            null
        ];
    }
};
const $3f3da0d4b812d0bb$export$947aff127337ffa5 = (queueId, projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    let lastVisitedQueueId;
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) throw new Error('project key is empty');
        lastVisitedQueueId = (0, $5j0B5.getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
    } catch (error) {
        lastVisitedQueueId = null;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey) && lastVisitedQueueId !== queueId) try {
        (0, $5j0B5.setInLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $3HGy4.fromQueueIdString)(queueId));
        (0, $5j0B5.setInLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`, category);
    } catch (error) {
    // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
    }
};

});
parcelRegister("1ilU2", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $27eaa4458d2c6986$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $27eaa4458d2c6986$export$357b94e419749e3d);

var $oCMSG = parcelRequire("oCMSG");
const $27eaa4458d2c6986$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $oCMSG.INCIDENTS;
        case 'changes':
            return 0, $oCMSG.CHANGES;
        case 'service-requests':
            return 0, $oCMSG.SERVICE_REQUEST;
        case 'problems':
            return 0, $oCMSG.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $oCMSG.POST_INCIDENT_REVIEWS;
        default:
            return 0, $oCMSG.NO_CATEGORY;
    }
};
const $27eaa4458d2c6986$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $oCMSG.INCIDENTS:
        case 0, $oCMSG.CHANGES:
        case 0, $oCMSG.SERVICE_REQUEST:
        case 0, $oCMSG.PROBLEMS:
        case 0, $oCMSG.POST_INCIDENT_REVIEWS:
        case 0, $oCMSG.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});


parcelRegister("PyWGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3c71f925aa4f1e4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f3c71f925aa4f1e4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundHeader: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-header",
        "defaultMessage": "We couldn't find your queue"
    },
    notFoundDescription: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-description",
        "defaultMessage": "Looks like we\u2019re having trouble connecting, or it may have been removed."
    }
});

});



parcelRegister("jF62O", function(module, exports) {

$parcel$export(module.exports, "useCategorizedNavItems", () => $8f1bc4ac72406fd0$export$fec6561bcaa1c55b);
$parcel$export(module.exports, "useCurrentCategorizedNavItems", () => $8f1bc4ac72406fd0$export$f9b7a4e20c09f3ce);
$parcel$export(module.exports, "useCategorizedQueues", () => $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6);
$parcel$export(module.exports, "useFavouriteNavItems", () => $8f1bc4ac72406fd0$export$e27d61833d43b175);
$parcel$export(module.exports, "usePracticeMetadata", () => $8f1bc4ac72406fd0$export$f857eeb50ae9b1b2);
$parcel$export(module.exports, "usePracticeList", () => $8f1bc4ac72406fd0$export$216a9245ead6e18a);
$parcel$export(module.exports, "CategorizedQueuesStore", () => $8f1bc4ac72406fd0$export$5577ca8a6b2fed3c);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $1WlLE = parcelRequire("1WlLE");

var $oCMSG = parcelRequire("oCMSG");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $2lO5M = parcelRequire("2lO5M");
const $8f1bc4ac72406fd0$var$useCategorizedData = (category, dataSelector, customContext)=>{
    const { data: allData, loading: loading, error: error, refresh: refresh } = (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.queuesNavigationItems), customContext);
    const memoizedData = (0, $5uXOq.useMemo)(()=>dataSelector(allData, category), [
        allData,
        category,
        dataSelector
    ]);
    return [
        memoizedData,
        loading,
        error,
        refresh
    ];
};
const $8f1bc4ac72406fd0$export$fec6561bcaa1c55b = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error, refresh] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.navDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods,
        refresh
    ];
};
const $8f1bc4ac72406fd0$export$f9b7a4e20c09f3ce = ()=>{
    const projectKey = (0, $bebaD.useProjectKey)();
    const category = (0, $bebaD.useCurrentCategory)();
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6('', projectKey, category);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$1dc9816387d038aa = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.notFavouriteDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$e27d61833d43b175 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.favouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$528be43f76fe19f7 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.notFavouriteAndCanBeHiddenDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$4c168500ca36ad18 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.cannotBeHiddenAndNotFavouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.queuesDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$f857eeb50ae9b1b2 = (category = (0, $oCMSG.NO_CATEGORY), customContext)=>$8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.practiceMetadataSelector), customContext);
const $8f1bc4ac72406fd0$export$216a9245ead6e18a = (customContext)=>$8f1bc4ac72406fd0$var$useCategorizedData((0, $oCMSG.NO_CATEGORY), (0, $fyiDq.practiceListSelector), customContext);
const $8f1bc4ac72406fd0$export$5577ca8a6b2fed3c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
const $8f1bc4ac72406fd0$export$aea9dc5735ed30c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$fec6561bcaa1c55b(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
$8f1bc4ac72406fd0$export$5577ca8a6b2fed3c.defaultProps = {
    category: (0, $oCMSG.NO_CATEGORY)
};
$8f1bc4ac72406fd0$export$aea9dc5735ed30c.defaultProps = {
    category: (0, $oCMSG.NO_CATEGORY)
};

});
parcelRegister("bebaD", function(module, exports) {

$parcel$export(module.exports, "getQueuesForCategory", () => $f538431335917e3a$export$fcf9c653a5f7167a);
$parcel$export(module.exports, "setQueuesForCategory", () => $f538431335917e3a$export$7ca50bfd96f22f76);
$parcel$export(module.exports, "queuesToNavItems", () => $f538431335917e3a$export$e6491f132367997c);
$parcel$export(module.exports, "useProjectKey", () => $f538431335917e3a$export$f87be37f8e8be65);
$parcel$export(module.exports, "useCurrentCategory", () => $f538431335917e3a$export$e42116f2f5c27c35);

var $7uUwQ = parcelRequire("7uUwQ");

var $dd29Z = parcelRequire("dd29Z");

var $1ilU2 = parcelRequire("1ilU2");

var $g5X3G = parcelRequire("g5X3G");

var $doZTA = parcelRequire("doZTA");
const $f538431335917e3a$export$fcf9c653a5f7167a = (data, category)=>(0, $7uUwQ.getIn)(data, [
        category,
        'queues'
    ]);
const $f538431335917e3a$export$7ca50bfd96f22f76 = (data, category, newQueues)=>// @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'CategorizedQueueData': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    (0, $7uUwQ.updateIn)(data || {}, [
        category,
        'queues'
    ], (queues)=>{
        // We only want to update queues if they exist in a category already
        if (queues) return newQueues;
        throw new Error(`${category} does not exist in resource`);
    });
const $f538431335917e3a$export$e6491f132367997c = (queues)=>queues.map(({ id: id, name: name, projectKey: projectKey, count: count, category: category, favourite: favourite, canBeHidden: canBeHidden, shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh, lastRefreshedTime: lastRefreshedTime })=>({
            id: String(id),
            name: name,
            url: `/projects/${projectKey}/${(0, $dd29Z.getQueueFragment)(id, category)}`,
            badgeCount: count,
            starred: favourite,
            canBeHidden: canBeHidden,
            shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh,
            category: category,
            lastRefreshedTime: lastRefreshedTime
        }));
const $f538431335917e3a$export$f87be37f8e8be65 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $g5X3G.toProjectKey)(match.params.projectKey || '');
};
const $f538431335917e3a$export$e42116f2f5c27c35 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $1ilU2.toItsmPractice)(match.params.practiceType);
};

});

parcelRegister("fyiDq", function(module, exports) {

$parcel$export(module.exports, "queuesDataSelector", () => $1df222051fb5e2fa$export$fe10e38dc2f0e4c8);
$parcel$export(module.exports, "navDataSelector", () => $1df222051fb5e2fa$export$caf8de9cbdbf9102);
$parcel$export(module.exports, "notFavouriteAndCanBeHiddenDataSelector", () => $1df222051fb5e2fa$export$231e113a2e075013);
$parcel$export(module.exports, "notFavouriteDataSelector", () => $1df222051fb5e2fa$export$46aa703ec1a01e);
$parcel$export(module.exports, "cannotBeHiddenAndNotFavouriteDataSelector", () => $1df222051fb5e2fa$export$f28545acfde3f70e);
$parcel$export(module.exports, "favouriteDataSelector", () => $1df222051fb5e2fa$export$fc3fab89f453b08e);
$parcel$export(module.exports, "practiceMetadataSelector", () => $1df222051fb5e2fa$export$b0af22bb6bff9c49);
$parcel$export(module.exports, "isCountLoadingSelector", () => $1df222051fb5e2fa$export$efbcd30acb5e816f);
$parcel$export(module.exports, "hasRequestedCountSelector", () => $1df222051fb5e2fa$export$54e54a1ac5e7098f);
$parcel$export(module.exports, "practiceListSelector", () => $1df222051fb5e2fa$export$61d9fd7be029b514);

var $7uUwQ = parcelRequire("7uUwQ");

var $bebaD = parcelRequire("bebaD");
const $1df222051fb5e2fa$export$fe10e38dc2f0e4c8 = (data, category)=>(0, $bebaD.getQueuesForCategory)(data, category) || null;
const $1df222051fb5e2fa$export$caf8de9cbdbf9102 = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    return queues ? (0, $bebaD.queuesToNavItems)(queues) : null;
};
const $1df222051fb5e2fa$export$231e113a2e075013 = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    const otherQueuesData = queues ? queues.filter((q)=>q.canBeHidden && !q.favourite) : null;
    return otherQueuesData ? (0, $bebaD.queuesToNavItems)(otherQueuesData) : null;
};
const $1df222051fb5e2fa$export$46aa703ec1a01e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const otherQueuesData = queues ? queues.filter((q)=>!q.favourite) : null;
    return otherQueuesData ? (0, $bebaD.queuesToNavItems)(otherQueuesData) : null;
};
const $1df222051fb5e2fa$export$f28545acfde3f70e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    const defaultQueuesData = queues ? queues.filter((q)=>!q.canBeHidden && !q.favourite) : null;
    return defaultQueuesData ? (0, $bebaD.queuesToNavItems)(defaultQueuesData) : null;
};
const $1df222051fb5e2fa$export$fc3fab89f453b08e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const starredQueues = queues ? queues.filter((q)=>q.favourite) : null;
    return starredQueues ? (0, $bebaD.queuesToNavItems)(starredQueues) : null;
};
const $1df222051fb5e2fa$export$b0af22bb6bff9c49 = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? (0, $7uUwQ.dissoc)(practiceData, 'queues') : null;
};
const $1df222051fb5e2fa$export$efbcd30acb5e816f = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.isCountLoading : false;
};
const $1df222051fb5e2fa$export$54e54a1ac5e7098f = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.hasRequestedCount : false;
};
const $1df222051fb5e2fa$export$61d9fd7be029b514 = (data)=>// @ts-expect-error - TS2322 - Type 'string[] | null' is not assignable to type 'Data<ItsmPractice[]>'.
    data ? Object.keys(data) : null;

});

parcelRegister("2lO5M", function(module, exports) {

$parcel$export(module.exports, "useCategorizedActions", () => $ff5cc066d5a13377$export$8632bfeb0b672958);
$parcel$export(module.exports, "default", () => $ff5cc066d5a13377$export$2e2bcd8739ae039);

var $324W5 = parcelRequire("324W5");

var $1WlLE = parcelRequire("1WlLE");

var $a4M45 = parcelRequire("a4M45");
const $ff5cc066d5a13377$export$8632bfeb0b672958 = (baseUrl, projectKey, category, customContext)=>{
    const { update: update } = (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.queuesNavigationItems), customContext);
    const cachedActions = (0, $a4M45.default)(category, update, {
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    return [
        cachedActions
    ];
};
const $ff5cc066d5a13377$var$ActionsProvider = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [actions] = $ff5cc066d5a13377$export$8632bfeb0b672958(baseUrl, projectKey, category);
    return children(actions);
};
var $ff5cc066d5a13377$export$2e2bcd8739ae039 = $ff5cc066d5a13377$var$ActionsProvider;

});
parcelRegister("a4M45", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c8b4db868052f8$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6vsnF = parcelRequire("6vsnF");
const $64c8b4db868052f8$export$36d128238e6b60f5 = {
    currentCacheKey: '',
    // @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'Record<ItsmPractice, ChildrenProps>': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    actionsByCategory: {}
};
const $64c8b4db868052f8$export$8b3bc28eb06c49b6 = {
    // Actions are lazily created for each category of a project.
    // Project key is used as the cache key. Once the cache key has changed
    // the store will be reset
    getActions: (...args)=>({ getState: getState, setState: setState })=>{
            const [category, , { projectKey: projectKey }] = args;
            const { currentCacheKey: currentCacheKey, actionsByCategory: actionsByCategory } = getState();
            const categoryActions = actionsByCategory[category];
            const hasSameKey = projectKey === currentCacheKey;
            if (hasSameKey && Boolean(categoryActions)) return categoryActions;
            const newCategoryActions = (0, $6vsnF.getActions)(...args);
            setState({
                currentCacheKey: projectKey,
                // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '{ "change-management"?: Actions | undefined; "incident-management"?: Actions | undefined; "problem-management"?: Actions | undefined; "service-request"?: Actions | undefined; "post-incident-review"?: Actions | undefined; "no-category"?: Actions | undefined; }' is not assignable to type 'Record<ItsmPractice, ChildrenProps>'.
                actionsByCategory: {
                    ...hasSameKey ? actionsByCategory : {},
                    [category]: newCategoryActions
                }
            });
            return newCategoryActions;
        }
};
const $64c8b4db868052f8$var$Store = (0, $iXqE5.createStore)({
    initialState: $64c8b4db868052f8$export$36d128238e6b60f5,
    actions: $64c8b4db868052f8$export$8b3bc28eb06c49b6,
    name: 'jira-servicedesk-categorized-queues-actions-store'
});
const $64c8b4db868052f8$var$useActionsStore = (0, $3sQ5x.createHook)($64c8b4db868052f8$var$Store, {
    selector: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $64c8b4db868052f8$export$193cb0fec61d3692 = (...args)=>{
    const [, { getActions: getActions }] = $64c8b4db868052f8$var$useActionsStore();
    return getActions(...args);
};
var $64c8b4db868052f8$export$2e2bcd8739ae039 = $64c8b4db868052f8$export$193cb0fec61d3692;

});
parcelRegister("6vsnF", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $62968e378f0259c7$export$fe3955935f564b31);

var $7uUwQ = parcelRequire("7uUwQ");

var $34ck9 = parcelRequire("34ck9");


var $6s1PB = parcelRequire("6s1PB");

var $fZneA = parcelRequire("fZneA");

var $2nYuf = parcelRequire("2nYuf");

var $jHq2C = parcelRequire("jHq2C");

var $90q41 = parcelRequire("90q41");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $czC6V = parcelRequire("czC6V");

var $kTfMz = parcelRequire("kTfMz");
const $62968e378f0259c7$var$getThrottledRefresh = ()=>Number((0, $6s1PB.expVal)('jsm_dynamic_queues_issue_count_refresh_interval', 'value', '120000'));
const $62968e378f0259c7$var$getAnalyticsPayload = (err)=>{
    const wasQueueDeleted = err?.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef);
    const queueConflictOccurred = err?.statusCode === (0, $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f);
    const queueActionNotPermitted = err?.statusCode === (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3);
    return {
        wasQueueDeleted: wasQueueDeleted,
        queueConflictOccurred: queueConflictOccurred,
        queueActionNotPermitted: queueActionNotPermitted,
        isClientFetchError: (0, $fZneA.isClientFetchError)(err)
    };
};
const $62968e378f0259c7$export$fe3955935f564b31 = (category, update, restParams)=>{
    const actions = {
        addItem: (item)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.addItem)(queues, item));
                throw new Error(`Cannot add item because ${category} does not exist in resource`);
            });
        },
        deleteItem: (id)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.deleteItem)(queues, id));
                throw new Error(`Cannot delete item because ${category} does not exist in resource`);
            });
        },
        editItem: (item)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, item));
                throw new Error(`Cannot edit item because ${category} does not exist in resource`);
            });
        },
        moveItem: (from, to)=>{
            if (from !== to) update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItem)(queues, from, to);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category);
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item because ${category} does not exist in resource`);
            });
        },
        moveItemBelow: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItemBelow)(queues, queueId, targetQueueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item below because ${category} does not exist in resource`);
            });
        },
        moveItemAbove: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItemAbove)(queues, queueId, targetQueueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item above because ${category} does not exist in resource`);
            });
        },
        moveToTop: (queueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveToTop)(queues, queueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item to top because ${category} does not exist in resource`);
            });
        },
        refreshNavItems: (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((analyticsEvent)=>{
            setTimeout(()=>{
                update((data)=>{
                    const isCountLoading = (0, $fyiDq.isCountLoadingSelector)(data, category);
                    if (isCountLoading) return data;
                    if (restParams.projectKey) (0, $czC6V.refreshIssueCountForVisibleAndStarredQueues)(update, {
                        ...restParams,
                        category: category
                    }, analyticsEvent);
                    const updatedData = data ? (0, $7uUwQ.assocIn)(data, [
                        category,
                        'isCountLoading'
                    ], true) : null;
                    return updatedData;
                });
            // Jitter the call randomly between 1 - 5secs in case of multiple tab requests
            }, Math.floor(Math.random() * 5000) + 1000);
        }, $62968e378f0259c7$var$getThrottledRefresh()),
        initialFetchNavItems: (analyticsEvent)=>{
            update((data)=>{
                const isCountLoading = (0, $fyiDq.isCountLoadingSelector)(data, category);
                const hasRequestedCount = (0, $fyiDq.hasRequestedCountSelector)(data, category);
                if (!isCountLoading && !hasRequestedCount) actions.refreshNavItems(analyticsEvent);
                return data;
            });
        },
        refreshIssueCountForItems: (queueIds, analyticsEvent)=>{
            (0, $czC6V.refreshIssueCountForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds, analyticsEvent);
        },
        editItemIssueCount: (id, count)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, {
                    id: Number(id),
                    count: count,
                    lastRefreshedTime: Date.now()
                }));
                // There is no point update the issue-counts for default queue as there is no queues.
                // It might throwing exceptions if we cannot fetch queue categories.
                // Being defensive here for the rollout, if this code throw any errors, it's the same behavior as the below line.
                if (Number(id) === (0, $2nYuf.DEFAULT_QUEUE_ID)) return data;
                throw new Error(`Cannot edit item issue count because ${category} does not exist in resource for queue id ${id}`);
            });
        },
        editItemFavorite: (id, favourite)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, {
                    id: Number(id),
                    favourite: favourite
                }));
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        editVisibilityOfItems: (updatedItems, draggableId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                if (queues) {
                    (0, $90q41.updateQueuesVisibility)(baseUrl, projectKey, updatedItems).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItems)(queues, [
                        ...updatedItems
                    ]));
                }
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        enableRefreshForQueues: (queueIds)=>{
            (0, $czC6V.enableRefreshForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds);
        },
        enableIssueCountForSelectedQueues: (selectedQueueIds)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.enableSelectedQueuesVisibility)(selectedQueueIds, queues));
                throw new Error(`Cannot enable issue count for selected queues because ${category} does not exist in resource`);
            });
        }
    };
    return actions;
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("2nYuf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLUMNS", () => $55f991500b621537$export$50c19f60b9c144f7);
$parcel$export(module.exports, "DEFAULT_QUEUE_ID", () => $55f991500b621537$export$e78379cc32bff512);
$parcel$export(module.exports, "FETCH_BATCH_SIZE", () => $55f991500b621537$export$baa236d86cd0d3f5);
$parcel$export(module.exports, "FETCH_SIZE_IN_INITIAL_LOAD", () => $55f991500b621537$export$4ee65d92b7b81b6b);
const $55f991500b621537$export$50c19f60b9c144f7 = [
    'issuetype',
    'issuekey',
    'summary',
    'reporter',
    'assignee',
    'status',
    'created'
];
const $55f991500b621537$export$e78379cc32bff512 = Number.MIN_VALUE;
const $55f991500b621537$export$baa236d86cd0d3f5 = 100;
const $55f991500b621537$export$4ee65d92b7b81b6b = 30;

});

parcelRegister("jHq2C", function(module, exports) {

$parcel$export(module.exports, "setQueues", () => $7a268253f439fbe8$export$51b06787b88b2bf2);

var $eusud = parcelRequire("eusud");

var $2m5JT = parcelRequire("2m5JT");
const $7a268253f439fbe8$var$getQueuesUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues`;
const $7a268253f439fbe8$export$51b06787b88b2bf2 = (baseUrl, projectKey, queues, category)=>(0, $eusud.performPutRequest)($7a268253f439fbe8$var$getQueuesUrl(baseUrl, projectKey), {
        body: JSON.stringify((0, $2m5JT.transformQueues)(queues, category))
    });

});
parcelRegister("2m5JT", function(module, exports) {

$parcel$export(module.exports, "transformQueues", () => $21e5ad652b3de239$export$66ec85c65393edb4);

var $oCMSG = parcelRequire("oCMSG");
const $21e5ad652b3de239$export$66ec85c65393edb4 = (queues, category)=>({
        order: queues.map((queue)=>queue.id),
        id: 'com.atlassian.servicedesk.project-ui:sd-queues-custom',
        inline: true,
        deleted: [],
        ...category && category !== (0, $oCMSG.NO_CATEGORY) ? {
            category: category
        } : undefined
    });

});


parcelRegister("90q41", function(module, exports) {

$parcel$export(module.exports, "updateQueuesVisibility", () => $8ab251897e60612e$export$c0862f2fb17c23c2);

var $eusud = parcelRequire("eusud");
const $8ab251897e60612e$var$getUpdateQueuesVisibilityUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/update-visibility`;
const $8ab251897e60612e$export$c0862f2fb17c23c2 = (baseUrl, projectKey, modified)=>(0, $eusud.performPutRequest)($8ab251897e60612e$var$getUpdateQueuesVisibilityUrl(baseUrl, projectKey), {
        body: JSON.stringify({
            modified: modified
        })
    });

});

parcelRegister("czC6V", function(module, exports) {

$parcel$export(module.exports, "refreshIssueCountForVisibleAndStarredQueues", () => $d32f12b3757f33df$export$aaa6aeca5994daee);
$parcel$export(module.exports, "enableRefreshForQueues", () => $d32f12b3757f33df$export$6b0c14cefee3edf5);
$parcel$export(module.exports, "refreshIssueCountForQueues", () => $d32f12b3757f33df$export$b05e3887bfb123a8);

var $7uUwQ = parcelRequire("7uUwQ");

var $4Xk2W = parcelRequire("4Xk2W");

var $8Rkzz = parcelRequire("8Rkzz");

var $7qDUb = parcelRequire("7qDUb");

var $jcw0u = parcelRequire("jcw0u");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $l6KG9 = parcelRequire("l6KG9");
const $d32f12b3757f33df$export$defcbd4ba0fd3734 = 5;
const $d32f12b3757f33df$var$RETRY_DELAY_IN_MS = 1000;
const $d32f12b3757f33df$var$fireErrorAnalyticsForRetryFailure = (error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'retryQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $d32f12b3757f33df$export$ef7266a9f6c0de43 = ({ baseUrl: baseUrl, projectKey: projectKey, category: category }, skipHiddenQueues, update, retryCount, analyticsEvent)=>async (queueIds)=>{
        if (queueIds && queueIds.length === 0) return;
        if (retryCount >= $d32f12b3757f33df$export$defcbd4ba0fd3734) {
            (0, $l6KG9.fireManualOperationalAnalytics)({
                source: 'refreshQueueIssueCountAction',
                actionSubject: 'retryIssueCount',
                action: 'limitExceeded',
                attributes: {
                    retryCount: retryCount,
                    maxRetryCount: $d32f12b3757f33df$export$defcbd4ba0fd3734
                }
            });
            return;
        }
        setTimeout(()=>{
            try {
                const newRetryCount = retryCount + 1;
                update((data)=>{
                    const queues = (0, $bebaD.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id));
                    if (queues && queues.length > 0) {
                        const retryCallback = $d32f12b3757f33df$export$ef7266a9f6c0de43({
                            baseUrl: baseUrl,
                            projectKey: projectKey,
                            category: category
                        }, true, update, newRetryCount, analyticsEvent);
                        (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent);
                        (0, $l6KG9.fireManualOperationalAnalytics)({
                            source: 'refreshQueueIssueCountAction',
                            actionSubject: 'retryQueueIssueCount',
                            action: 'triggered',
                            attributes: {
                                retryCount: newRetryCount,
                                maxRetryCount: $d32f12b3757f33df$export$defcbd4ba0fd3734,
                                queuesCount: queues.length
                            }
                        });
                        return data ? (0, $7uUwQ.assocIn)(data, [
                            category,
                            'isCountLoading'
                        ], true) : null;
                    }
                    return data;
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                $d32f12b3757f33df$var$fireErrorAnalyticsForRetryFailure(error);
                throw error;
            }
        }, $d32f12b3757f33df$var$RETRY_DELAY_IN_MS);
    };
const $d32f12b3757f33df$export$aaa6aeca5994daee = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $bebaD.getQueuesForCategory)(data, category);
            const retryCallback = !(0, $fyiDq.hasRequestedCountSelector)(data, category) ? $d32f12b3757f33df$export$ef7266a9f6c0de43({
                baseUrl: baseUrl,
                projectKey: projectKey,
                category: category
            }, true, update, 0, analyticsEvent) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
            if (queues) {
                (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, true, update, retryCallback, analyticsEvent);
                return data ? (0, $7uUwQ.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $l6KG9.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};
const $d32f12b3757f33df$export$6b0c14cefee3edf5 = (update, { projectKey: _, category: category }, queueIds)=>{
    update((data)=>{
        const queues = (0, $bebaD.getQueuesForCategory)(data, category);
        const refreshEnabledQueues = queues?.filter((queue)=>queueIds.includes(queue.id.toString())).map((queue)=>queue.shouldSkipIssueCountRefresh ? {
                ...queue,
                shouldSkipIssueCountRefresh: false,
                count: undefined
            } : queue);
        const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(queues, 'id');
        refreshEnabledQueues?.forEach((queue)=>{
            queuesMap[queue.id] = queue;
        });
        return (0, $bebaD.setQueuesForCategory)(data, category, (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(Object.values(queuesMap), 'order'));
    });
};
const $d32f12b3757f33df$export$b05e3887bfb123a8 = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, queueIds, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $bebaD.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id.toString()));
            if (queues && queues.length > 0) {
                (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, false, update, (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), analyticsEvent);
                return data ? (0, $7uUwQ.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $l6KG9.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};

});
parcelRegister("l6KG9", function(module, exports) {

$parcel$export(module.exports, "fireManualOperationalAnalytics", () => $fa1880944e28b500$export$a9301d18019c11f9);
$parcel$export(module.exports, "fireErrorAnalyticsForRefreshCountFailure", () => $fa1880944e28b500$export$b5e2038970f91d6c);
$parcel$export(module.exports, "updateIssueCountForQueues", () => $fa1880944e28b500$export$d436cbef77099410);

var $7uUwQ = parcelRequire("7uUwQ");

var $hUobS = parcelRequire("hUobS");

var $4Xk2W = parcelRequire("4Xk2W");

var $7qDUb = parcelRequire("7qDUb");

var $dMEgP = parcelRequire("dMEgP");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $g9E9n = parcelRequire("g9E9n");

var $7ZmbO = parcelRequire("7ZmbO");

var $bebaD = parcelRequire("bebaD");
const $fa1880944e28b500$var$ERROR_DB_TIMEOUT = 'error.db-timeout';
const $fa1880944e28b500$var$ERROR_UNKNOWN = 'error.unknown';
const $fa1880944e28b500$export$cf85cf6a45b00808 = {
    FAILED: 'failed',
    SUCCESS: 'success',
    PENDING: 'pending'
};
const $fa1880944e28b500$var$MAX_ISSUECOUNT_THRESHOLD = 1000;
const $fa1880944e28b500$export$a9301d18019c11f9 = (payload)=>(0, $g9E9n.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $fa1880944e28b500$var$filterOutHiddenQueues = (queues)=>queues.filter((q)=>!(q.canBeHidden === undefined ? false : q.canBeHidden) || q.favourite);
const $fa1880944e28b500$var$filterOutBadQueues = (queues)=>queues.filter((q)=>!q.shouldSkipIssueCountRefresh);
const $fa1880944e28b500$var$getIssueCountPerGroup = (issueCounts)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(issueCounts).reduce((curr, queueId)=>{
        const res = curr;
        if (issueCounts[Number(queueId)]) {
            if (issueCounts[Number(queueId)].issueCount || issueCounts[Number(queueId)].issueCount === 0) res[Number(queueId)] = issueCounts[Number(queueId)].issueCount;
        }
        return res;
    }, {});
const $fa1880944e28b500$var$getQueuesPerGroup = (queues, skipHiddenQueues)=>{
    const starredQueues = [];
    const defaultQueues = [];
    let toGroupQueues = queues;
    let hasSkippedQueues = false;
    if (skipHiddenQueues === true) toGroupQueues = $fa1880944e28b500$var$filterOutHiddenQueues(queues);
    toGroupQueues = $fa1880944e28b500$var$filterOutBadQueues(toGroupQueues);
    let queueByGroups = {};
    toGroupQueues.forEach((queue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(queue.count) && queue.count > $fa1880944e28b500$var$MAX_ISSUECOUNT_THRESHOLD) {
            hasSkippedQueues = true;
            return;
        }
        if (queue.favourite) starredQueues.push(queue);
        else defaultQueues.push(queue);
    });
    queueByGroups = {
        starredQueues: starredQueues,
        defaultQueues: defaultQueues
    };
    if (hasSkippedQueues) $fa1880944e28b500$export$a9301d18019c11f9({
        source: 'refreshQueueIssueCountAction',
        actionSubject: 'queueIssueCountRefresh',
        action: 'skipped'
    });
    return queueByGroups;
};
const $fa1880944e28b500$var$getQueuesSortByLastRefreshedTime = (queuesBeforeSort)=>{
    let queuesSortByLastRefreshedTime = [];
    const queuesSortByGroup = [
        ...queuesBeforeSort.starredQueues,
        ...queuesBeforeSort.defaultQueues
    ];
    queuesSortByLastRefreshedTime = (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(queuesSortByGroup, [
        'lastRefreshedTime'
    ]);
    return queuesSortByLastRefreshedTime;
};
const $fa1880944e28b500$export$b5e2038970f91d6c = (error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'refreshQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $fa1880944e28b500$var$isIssueCountAlreadyFetched = (queue)=>queue.count !== undefined;
const $fa1880944e28b500$var$getSkippedQueues = (issueCounts, queuesMap)=>Object.keys(issueCounts).map((id)=>Number(id)).filter((queueId)=>issueCounts[queueId].result === $fa1880944e28b500$export$cf85cf6a45b00808.PENDING && !$fa1880944e28b500$var$isIssueCountAlreadyFetched(queuesMap[queueId]));
const $fa1880944e28b500$var$fetchIssueCountForQueueGroup = async (projectKey, queueIds)=>(0, $eusud.performPostRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/issue-counts/refresh`, {
        body: JSON.stringify(queueIds)
    });
const $fa1880944e28b500$var$getQueueGroupData = (queueIds, issueCounts, queuesMap, batchStartProcessingTime)=>{
    const queueRefreshData = {
        minLastRefreshTimeFromCurrentBatch: Number.MAX_VALUE,
        queueCountChanges: 0
    };
    return queueIds.reduce((changes, queueId)=>{
        if (issueCounts[queueId]) {
            if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) {
                const queue = queuesMap[queueId];
                const currentQueueLastRefreshedTime = queue.lastRefreshedTime !== undefined && queue.lastRefreshedTime !== 0 ? queue.lastRefreshedTime : batchStartProcessingTime;
                const minLastRefreshTimeFromCurrentBatch = Math.min(changes.minLastRefreshTimeFromCurrentBatch, currentQueueLastRefreshedTime);
                const queueCountChanges = queue.count !== issueCounts[queueId].issueCount ? changes.queueCountChanges + 1 : changes.queueCountChanges;
                return {
                    minLastRefreshTimeFromCurrentBatch: minLastRefreshTimeFromCurrentBatch,
                    queueCountChanges: queueCountChanges
                };
            }
        }
        return changes;
    }, queueRefreshData);
};
const $fa1880944e28b500$var$fetchAndUpdateCount = async (baseUrl, projectKey, queueIds, category, analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
update, batchStartProcessingTime, retryCallback)=>{
    if (queueIds.length === 0) return;
    let maxQueuesPerSd = await (0, $7ZmbO.getLimit)((0, $7ZmbO.MAX_QUEUES_PER_SD));
    if (maxQueuesPerSd === null) maxQueuesPerSd = queueIds.length;
    const queueIdsToFetch = queueIds.slice(0, maxQueuesPerSd);
    const startTime = Date.now();
    await $fa1880944e28b500$var$fetchIssueCountForQueueGroup(projectKey, queueIdsToFetch).then(({ issueCounts: issueCounts })=>{
        update((data)=>{
            const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))((0, $bebaD.getQueuesForCategory)(data, category), 'id');
            const skippedQueues = $fa1880944e28b500$var$getSkippedQueues(issueCounts, queuesMap);
            if (skippedQueues.length > 0) retryCallback(skippedQueues);
            const endTime = Date.now();
            let queueCountChanges = 0;
            let minLastRefreshTimeFromCurrentBatch = 0;
            let numberOfBadQueues = 0;
            const queueRefreshData = $fa1880944e28b500$var$getQueueGroupData(queueIds, issueCounts, queuesMap, batchStartProcessingTime);
            queueCountChanges = queueRefreshData.queueCountChanges;
            minLastRefreshTimeFromCurrentBatch = queueRefreshData.minLastRefreshTimeFromCurrentBatch;
            queueIds.forEach((queueId)=>{
                const queue = queuesMap[queueId];
                if (issueCounts[queueId]) {
                    if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) queuesMap[queueId] = {
                        ...queue,
                        count: issueCounts[queueId].issueCount,
                        lastRefreshedTime: endTime,
                        shouldSkipIssueCountRefresh: false
                    };
                    else if (issueCounts[queueId].errorCode === $fa1880944e28b500$var$ERROR_DB_TIMEOUT) {
                        numberOfBadQueues += 1;
                        queuesMap[queueId] = {
                            ...queue,
                            shouldSkipIssueCountRefresh: true
                        };
                    }
                }
            });
            if (analyticsEvent) {
                const issueCountPerGroup = $fa1880944e28b500$var$getIssueCountPerGroup(issueCounts);
                const queueIssueCounts = Object.values(issueCountPerGroup).map((queueCount)=>Number(queueCount));
                const jiraShard = (0, $j8DrX.default)('ajs-shard') || '';
                if (queueIssueCounts.length === 0) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'navigationSession poorPerformanceQueuesCountsInfo', {
                    category: category,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    timeToFetchIssueCount: endTime - startTime,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    jiraShard: jiraShard,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
                else (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'navigationSession queuesCountsInfo', {
                    category: category,
                    queues: queueIssueCounts.length,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    maxIssueCount: Math.max(...queueIssueCounts),
                    timeToFetchIssueCount: endTime - startTime,
                    timeBetweenQueueRefresh: endTime - minLastRefreshTimeFromCurrentBatch,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    noOfQueuesWithUpdatedCount: queueCountChanges,
                    jiraShard: jiraShard,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
            }
            return (0, $bebaD.setQueuesForCategory)(data, category, // Object.values is typed as Mixed[] and makes flow unhappy
            (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))((0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(queuesMap), 'order'));
        });
    }).catch((error)=>{
        $fa1880944e28b500$export$b5e2038970f91d6c(error);
    });
};
const $fa1880944e28b500$var$updateLoadingState = (category, queues, update)=>{
    update((data)=>data ? (0, $7uUwQ.chain)(data).setIn([
            category,
            'hasRequestedCount'
        ], true).setIn([
            category,
            'isCountLoading'
        ], false).value() : null);
};
const $fa1880944e28b500$export$d436cbef77099410 = async (baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent)=>{
    const queuesPerGroup = $fa1880944e28b500$var$getQueuesPerGroup(queues, skipHiddenQueues);
    const queuesSortByLastRefreshedTime = $fa1880944e28b500$var$getQueuesSortByLastRefreshedTime(queuesPerGroup);
    const queueIds = queuesSortByLastRefreshedTime.map((x)=>x.id);
    const batchStartProcessingTime = Date.now();
    try {
        // fetching the result in one call
        await $fa1880944e28b500$var$fetchAndUpdateCount(baseUrl, projectKey, queueIds, category, analyticsEvent, update, batchStartProcessingTime, retryCallback);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $fa1880944e28b500$var$updateLoadingState(category, queues, update);
        $fa1880944e28b500$export$b5e2038970f91d6c(error);
        throw error;
    }
    $fa1880944e28b500$var$updateLoadingState(category, queues, update);
};

});
parcelRegister("hUobS", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $d09a6e5a442af90c$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $d09a6e5a442af90c$var$isNumber(value) {
    return typeof value == 'number' || $fC1Kz(value) && $beQoo(value) == $d09a6e5a442af90c$var$numberTag;
}
module.exports = $d09a6e5a442af90c$var$isNumber;

});

parcelRegister("7ZmbO", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $92269289c1fdd627$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $92269289c1fdd627$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $92269289c1fdd627$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $92269289c1fdd627$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $92269289c1fdd627$export$cb3888a8c43147d2);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $92269289c1fdd627$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $92269289c1fdd627$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $92269289c1fdd627$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $92269289c1fdd627$export$c5d8aa8a650e690f);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $7f4tk = parcelRequire("7f4tk");
const $92269289c1fdd627$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $92269289c1fdd627$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $92269289c1fdd627$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $92269289c1fdd627$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $92269289c1fdd627$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $92269289c1fdd627$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $92269289c1fdd627$export$5ed1d2ac050e39d = {
    [$92269289c1fdd627$export$dca2c2105b681490]: 30,
    [$92269289c1fdd627$export$a48ac34d39e0fc22]: 30,
    [$92269289c1fdd627$export$2e0ba662d5bb7742]: 300,
    [$92269289c1fdd627$export$eb69982aa3a172b4]: 30,
    [$92269289c1fdd627$export$cb3888a8c43147d2]: 20,
    [$92269289c1fdd627$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $92269289c1fdd627$var$limitCache = {};
const $92269289c1fdd627$export$c419786abd6faaad = (limitProperty)=>{
    delete $92269289c1fdd627$var$limitCache[limitProperty];
};
const $92269289c1fdd627$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$92269289c1fdd627$var$limitCache[limitProperty]) $92269289c1fdd627$var$limitCache[limitProperty] = (0, $7f4tk.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $92269289c1fdd627$export$c419786abd6faaad(limitProperty);
        (0, $dJl1T.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $92269289c1fdd627$var$limitCache[limitProperty];
};
class $92269289c1fdd627$export$9989835030ecd317 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $92269289c1fdd627$export$5ed1d2ac050e39d[limitProperty];
        $92269289c1fdd627$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args), this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $92269289c1fdd627$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92269289c1fdd627$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});



parcelRegister("kTfMz", function(module, exports) {

$parcel$export(module.exports, "addItem", () => $98056c458719acf6$export$fb9705de59d96855);
$parcel$export(module.exports, "deleteItem", () => $98056c458719acf6$export$8d8542dbbc23fe1a);
$parcel$export(module.exports, "editItem", () => $98056c458719acf6$export$60832f4899fbf6a1);
$parcel$export(module.exports, "editItems", () => $98056c458719acf6$export$8c896bccb18e1db1);
$parcel$export(module.exports, "moveItem", () => $98056c458719acf6$export$ec937e64de6c1257);
$parcel$export(module.exports, "moveItemBelow", () => $98056c458719acf6$export$17c7ebc966cf5476);
$parcel$export(module.exports, "moveItemAbove", () => $98056c458719acf6$export$d54386016cadff45);
$parcel$export(module.exports, "moveToTop", () => $98056c458719acf6$export$f2c5cc4c3f787c3e);
$parcel$export(module.exports, "enableSelectedQueuesVisibility", () => $98056c458719acf6$export$ce58537552972d29);

var $fW7cr = parcelRequire("fW7cr");
const $98056c458719acf6$export$fb9705de59d96855 = (source, item)=>[
        ...source,
        item
    ];
const $98056c458719acf6$export$8d8542dbbc23fe1a = (source, id)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: Number(id)
    });
    if (index >= 0) result.splice(index, 1);
    return result;
};
const $98056c458719acf6$export$60832f4899fbf6a1 = (source, updatedItem)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: updatedItem.id
    });
    if (index >= 0) result[index] = {
        ...result[index],
        ...updatedItem
    };
    return result;
};
const $98056c458719acf6$export$8c896bccb18e1db1 = (source, updatedItems)=>{
    const result = source.slice();
    updatedItems.forEach((item)=>{
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: item.id
        });
        if (index >= 0) result[index] = {
            ...result[index],
            ...item
        };
    });
    return result;
};
const $98056c458719acf6$export$ec937e64de6c1257 = (source, from, to)=>{
    const result = source.slice();
    const item = result[from];
    if (from !== to && from >= 0) {
        result.splice(from, 1);
        result.splice(to, 0, item);
    }
    return result.map((page, order)=>({
            ...page,
            order: order
        }));
};
const $98056c458719acf6$export$17c7ebc966cf5476 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex + 1, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $98056c458719acf6$export$d54386016cadff45 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $98056c458719acf6$export$f2c5cc4c3f787c3e = (source, sourceId)=>{
    const result = source.slice();
    if (result.length === 0) return source;
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: sourceId
    });
    if (index > 0) {
        const sourceQueue = result[index];
        result.splice(index, 1);
        result.splice(0, 0, sourceQueue);
        return result.map((page, order)=>({
                ...page,
                order: order
            }));
    }
    return source;
};
const $98056c458719acf6$export$ce58537552972d29 = (selectedQueueIds, queues)=>queues.map((queue)=>{
        if (selectedQueueIds.some((selectedQueueId)=>selectedQueueId === queue.id)) {
            if (!queue.canBeHidden) return queue;
            return {
                ...queue,
                canBeHidden: false
            };
        }
        if (queue.canBeHidden) return queue;
        return {
            ...queue,
            canBeHidden: true
        };
    });

});
parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});






parcelRegister("e33py", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $ae40b537a934bf9c$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $ae40b537a934bf9c$export$c7841d2c1c13065e);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $2BHCj = parcelRequire("2BHCj");
const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${subsection} - ${formatMessage((0, $2BHCj.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${formatMessage((0, $2BHCj.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
        title: title
    });
};
const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, $9sGI6.default)($ae40b537a934bf9c$export$155581e8dc02007a, {
    DocumentTitle: (0, $id7K0.DocumentTitle)
});
var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("2BHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7eb5ce3479323e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "External resources"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    projectSummary: {
        "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
        "defaultMessage": "Summary"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    },
    helpCenterForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
        "defaultMessage": "Forms"
    },
    helpCenterDetails: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-details",
        "defaultMessage": "Details"
    },
    virtualAgentAiAnswers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
        "defaultMessage": "Atlassian Intelligence answers"
    },
    virtualAgentPerformance: {
        "id": "servicedesk-spa-commons.common.utils.document-title.performance",
        "defaultMessage": "Performance"
    },
    customerAccess: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-access",
        "defaultMessage": "Customer access"
    },
    supportWebsite: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website",
        "defaultMessage": "Support Website"
    },
    supportWebsiteOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-overview",
        "defaultMessage": "Support Website Overview"
    },
    supportWebsitePages: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-pages",
        "defaultMessage": "Support Website Pages"
    },
    viewsSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-settings",
        "defaultMessage": "Views Settings"
    }
});

});


parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("cz40O", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $2099b56eb86565d0$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $dJl1T = parcelRequire("dJl1T");

var $9sGI6 = parcelRequire("9sGI6");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $aTz47 = parcelRequire("aTz47");

var $cYaqS = parcelRequire("cYaqS");

var $8pMQX = parcelRequire("8pMQX");
const $2099b56eb86565d0$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, ServiceHubNotFound: ServiceHubNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ServiceHubNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GenericError, null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AccessCheck, null, children)));
    return null;
};
const $2099b56eb86565d0$export$577514961fbf4842 = (0, $9sGI6.default)($2099b56eb86565d0$export$91f88695e0d311a5, {
    AccessCheck: (0, $cYaqS.default),
    GenericError: (0, $8pMQX.GenericError),
    ProjectNotFound: (0, $8pMQX.ProjectNotFound),
    ServiceHubNotFound: (0, $8pMQX.ServiceHubNotFound),
    AuthenticationCheck: (0, $9NiTW.AuthenticationCheck),
    SubProductUpdater: (0, $9dbF6.SubProductUpdater)
});
var $2099b56eb86565d0$export$2e2bcd8739ae039 = $2099b56eb86565d0$export$577514961fbf4842;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $aTz47 = parcelRequire("aTz47");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
    const Gate = isSettingsRoute || isHelpCenterSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
const $7c914880cb332728$export$16a37d277dff22d6 = '/jira/helpcenter/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aTz47 = parcelRequire("aTz47");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) {
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ServiceHubNotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    }
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});
parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $951f6bd200bf8b89$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $tcn7E = parcelRequire("tcn7E");

var $lVQn8 = parcelRequire("lVQn8");

var $id7K0 = parcelRequire("id7K0");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");

var $4R6GH = parcelRequire("4R6GH");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).serviceHubNotFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).serviceHubNotFoundTitle),
        description: formatMessage((0, $4AdE6.default).serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).serviceHubNotFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default)).current;
    const labelStack = (0, $5uXOq.useContext)((0, $1tcYS.default))?.labelStack;
    const traceId = (0, $5uXOq.useMemo)(()=>{
        const traceContext = (0, $tcn7E.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let description = formatMessage((0, $4AdE6.default).genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $951f6bd200bf8b89$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVQn8.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        if ((0, $4R6GH.fg)('add_ufo_error_in_service_desk_genericerror')) {
            const name = 'serviceDeskGenericError';
            if (interactionId) {
                (0, $bFU4G.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack);
                // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
                // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
                const activeInteraction = (0, $bFU4G.getActiveInteraction)();
                activeInteraction?.holdActive.forEach((_, holdId)=>{
                    (0, $bFU4G.removeHoldByID)(activeInteraction.id, holdId);
                });
            } else (0, $bFU4G.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: description
    }));
};
const $951f6bd200bf8b89$var$styles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("lVQn8", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $6bb63dde5e44a95e$export$61354a7dde2c2d3c);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $kobfu = parcelRequire("kobfu");

var $hurrh = parcelRequire("hurrh");
const $6bb63dde5e44a95e$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $kobfu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hurrh.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("hurrh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $e48150d967598599$export$ced1fc74d907d387);

var $5uXOq = parcelRequire("5uXOq");

var $b8Qxt = parcelRequire("b8Qxt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $irzxp = parcelRequire("irzxp");
const $e48150d967598599$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e48150d967598599$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b8Qxt.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $e48150d967598599$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("b8Qxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fd53c1f9dbca185$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $e4VnT = parcelRequire("e4VnT");

var $1HkQx = parcelRequire("1HkQx");

var $eCBnN = parcelRequire("eCBnN");

var $9Xp6L = parcelRequire("9Xp6L");
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $4fd53c1f9dbca185$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const theme = (0, $5uXOq.useMemo)(()=>(0, $1HkQx.getCodeBlockTheme)(numLines), [
        numLines
    ]);
    const getStyles = (0, $5uXOq.useMemo)(()=>(0, $1HkQx.getCodeBlockStyles)(theme), [
        theme
    ]);
    const styles = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
        highlightedStartText,
        highlightedEndText,
        showLineNumbers,
        shouldWrapLongLines,
        getStyles
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $e4VnT.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $eCBnN.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Xp6L.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        css: styles,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text
    });
});
$4fd53c1f9dbca185$var$CodeBlock.displayName = 'CodeBlock';
var $4fd53c1f9dbca185$export$2e2bcd8739ae039 = $4fd53c1f9dbca185$var$CodeBlock;

});
parcelRegister("e4VnT", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $a32b74c088f4b53f$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $a32b74c088f4b53f$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $a32b74c088f4b53f$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("1HkQx", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $a9c1aabaca189fa1$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $a9c1aabaca189fa1$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lBXbx = parcelRequire("lBXbx");

var $8CJbG = parcelRequire("8CJbG");
const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $lBXbx.SPACING}px !important`,
        paddingLeft: (0, $lBXbx.SPACING),
        marginRight: (0, $lBXbx.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: "var(--ds-font-weight-bold, 700)"
            }
        }
    });
/**
 * Styles applied at the root element level, common across code/codeblock
 */ const $a9c1aabaca189fa1$var$getBaseCodeStyles = (theme)=>({
        fontSize: (0, $lBXbx.CODE_FONT_SIZE),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: theme.fontFamily,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(${0, $lBXbx.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $lBXbx.SPACING}px 0` : (0, $lBXbx.SPACING),
                tabSize: 4
            },
            display: 'flex',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $lBXbx.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$a9c1aabaca189fa1$var$getBaseCodeStyles(theme),
            ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                marginRight: `-${0, $lBXbx.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $lBXbx.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $lBXbx.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $8CJbG.getBaseTheme)();
    const baseStyles = $a9c1aabaca189fa1$var$getBaseCodeStyles(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $8CJbG.getBaseTheme)(),
        ...(0, $8CJbG.getColorPalette)(),
        lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("lBXbx", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $6ec31795911692d1$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $6ec31795911692d1$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $6ec31795911692d1$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $6ec31795911692d1$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $6ec31795911692d1$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $6ec31795911692d1$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $6ec31795911692d1$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
const $6ec31795911692d1$export$82ea42e772d49e5b = (0, $k5uoT.gridSize)();
const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("8CJbG", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $eac5fe855702cfc1$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $eac5fe855702cfc1$export$fe2a6478976e8b17);

var $8QpSo = parcelRequire("8QpSo");


var $kTHGn = parcelRequire("kTHGn");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $eac5fe855702cfc1$var$T800 = '#067384';
const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $kTHGn.default)('font.family.code')}`,
        backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    });
const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, $8QpSo.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
    };
});
const $eac5fe855702cfc1$var$getTheme = ()=>({
        ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
        ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
    });
var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("eCBnN", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $d00516a0f8207944$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $8Y2ZY = parcelRequire("8Y2ZY");
const $d00516a0f8207944$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $8Y2ZY.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("8Y2ZY", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $012a854d92762508$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $012a854d92762508$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'sql'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    }
];

});


parcelRegister("9Xp6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $e296c4d390ff4a21$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $c8FD2 = parcelRequire("c8FD2");
var $e296c4d390ff4a21$export$2e2bcd8739ae039 = (0, $c8FD2.default);

});
parcelRegister("c8FD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $64df4f4e00539958$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lp89O = parcelRequire("lp89O");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $64df4f4e00539958$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $lp89O.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $64df4f4e00539958$var$asyncGenerator = $64df4f4e00539958$var$generator({
    loader: ()=>(parcelRequire("7t3wc")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $64df4f4e00539958$export$2e2bcd8739ae039 = $64df4f4e00539958$var$asyncGenerator;

});
parcelRegister("lp89O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a813ccd1d5fae376$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iQkqt = parcelRequire("iQkqt");

var $jVB7m = parcelRequire("jVB7m");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $a813ccd1d5fae376$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $iQkqt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $jVB7m.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $a813ccd1d5fae376$export$2e2bcd8739ae039 = $a813ccd1d5fae376$var$Highlight;

});
parcelRegister("iQkqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dc1424d34091d6$export$2e2bcd8739ae039);

var $eJUOt = parcelRequire("eJUOt");

var $eTMIA = parcelRequire("eTMIA");

var $8bliZ = parcelRequire("8bliZ");

var $g6MVu = parcelRequire("g6MVu");
const $55dc1424d34091d6$var$newLineRegex = /\n/g;
function $55dc1424d34091d6$var$getNewLines(str) {
    return str.match($55dc1424d34091d6$var$newLineRegex);
}
function $55dc1424d34091d6$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $g6MVu.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $eJUOt.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $8bliZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $55dc1424d34091d6$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $eTMIA.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $eTMIA.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("eJUOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ccdbf71436a137$export$2e2bcd8739ae039);

var $eTMIA = parcelRequire("eTMIA");

var $5FOwT = parcelRequire("5FOwT");
function $b9ccdbf71436a137$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $eTMIA.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $5FOwT.default)(lineNumber));
            return children;
        }
    };
}
var $b9ccdbf71436a137$export$2e2bcd8739ae039 = $b9ccdbf71436a137$var$createLineGenerator;

});
parcelRegister("eTMIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df5b208b9d23752$export$2e2bcd8739ae039);

var $5FOwT = parcelRequire("5FOwT");
function $6df5b208b9d23752$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $5FOwT.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $5FOwT.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("5FOwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6257c3f70e94feb$export$2e2bcd8739ae039);
function $c6257c3f70e94feb$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("8bliZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9f6debfd276481a$export$2e2bcd8739ae039);

var $eTMIA = parcelRequire("eTMIA");
function $c9f6debfd276481a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $eTMIA.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $c9f6debfd276481a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("g6MVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8213b6c690eefe35$export$2e2bcd8739ae039);
function $8213b6c690eefe35$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("jVB7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98c01cbb865d4c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fBvqm = parcelRequire("fBvqm");
function $b98c01cbb865d4c1$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $fBvqm.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", containerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
}

});
parcelRegister("fBvqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fdda3a2c4411588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");

var $d3zI6 = parcelRequire("d3zI6");
function $2fdda3a2c4411588$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $2fdda3a2c4411588$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $31cgS.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $d3zI6.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $2fdda3a2c4411588$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $59fdc1b7b0ae96c9$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", null, bidiCharacterCode)));
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("d3zI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbc4a00f80b5d8f$export$2e2bcd8739ae039);

var $fBvqm = parcelRequire("fBvqm");
function $dcbc4a00f80b5d8f$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $fBvqm.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("7t3wc", function(module, exports) {

let $56fdf880767119f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fdf880767119f7$var$load("as9qs").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("irzxp", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $64e12044af483692$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $64e12044af483692$export$37ab3bdebc286ca);

var $5uXOq = parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");

var $3Fq5M = parcelRequire("3Fq5M");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");

var $fEogx = parcelRequire("fEogx");
const $64e12044af483692$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $64e12044af483692$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEogx.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $64e12044af483692$var$stopPropagation = (event)=>event.stopPropagation();
const $64e12044af483692$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $64e12044af483692$var$absolutePositionWrapperStyles,
        onMouseDown: $64e12044af483692$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), {
        label: "actions"
    }, children));
const $64e12044af483692$var$absolutePositionWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("fEogx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e6da05ade6347218$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $3bDjY = parcelRequire("3bDjY");
const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    },
    serviceHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
        "defaultMessage": "Service hub not found - Service project"
    },
    serviceHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
        "defaultMessage": "This service hub isn't available"
    },
    serviceHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    serviceHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
        "defaultMessage": "View a list of all service hubs"
    }
});

});





parcelRegister("8XAvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $95fd3039216adfa3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $dd29Z = parcelRequire("dd29Z");

var $lVJAU = parcelRequire("lVJAU");
/* Intended usage is to replace direct usage of history.push from react-dom-router with a Jira SPA compatible push history */ const $95fd3039216adfa3$var$QueuesPushProvider = (props)=>{
    const { projectKey: projectKey, children: children } = props;
    const { push: push, replace: replace } = (0, $lVJAU.useRouterActions)();
    const pushWithSpaCompatibleUrl = (0, $5uXOq.useCallback)((path)=>{
        const pathWithLeadingSlash = path.charAt(0) === '/' ? `${path}` : `/${path}`;
        let fullPath = pathWithLeadingSlash;
        // Don't update the url if it is already in the right format
        if (pathWithLeadingSlash.indexOf('/jira/servicedesk/projects') !== 0) fullPath = `/jira/servicedesk/projects/${projectKey}${pathWithLeadingSlash}`;
        push(fullPath);
        // Some existing consumers in queues expect this to return an observable
        return (0, $kVLXA.Observable).empty();
    }, [
        projectKey,
        push
    ]);
    const navigateWithProjectKey = (0, $5uXOq.useCallback)((path)=>(0, $dd29Z.navigate)(projectKey, path), [
        projectKey
    ]);
    if (!projectKey) return children({
        push: undefined
    });
    return __SPA__ ? children({
        push: pushWithSpaCompatibleUrl,
        replace: replace
    }) : children({
        push: navigateWithProjectKey
    });
};
var $95fd3039216adfa3$export$2e2bcd8739ae039 = $95fd3039216adfa3$var$QueuesPushProvider;

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("k30xR", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $572c407f9743cbb2$export$ddf44c597e03063d);

var $5uXOq = parcelRequire("5uXOq");

var $1sWm7 = parcelRequire("1sWm7");

var $dMEgP = parcelRequire("dMEgP");

var $eXQym = parcelRequire("eXQym");

var $4041n = parcelRequire("4041n");
const $572c407f9743cbb2$export$ddf44c597e03063d = (projectKey, category, queues, callback)=>{
    const { items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const queueItemChanges = items[0, $eXQym.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $5uXOq.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        if (queues) (0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(queues, {
                id: Number(id)
            });
            if (queue && queue.favourite !== value) callback(id, value);
        });
    }
};

});
parcelRegister("1sWm7", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $fW7cr = parcelRequire("fW7cr");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
module.exports = $1115ac3ae60cc7bc$var$find;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});



parcelRegister("6OeKD", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $b8361afc4fd34fcb$export$8ada91ce992fa66f);

var $3HGy4 = parcelRequire("3HGy4");
const $b8361afc4fd34fcb$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $b8361afc4fd34fcb$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $3HGy4.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $b8361afc4fd34fcb$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});

});


parcelRegister("8IR5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c40304aa44c38f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $aNLeB = parcelRequire("aNLeB");

var $8Z4r3 = parcelRequire("8Z4r3");

var $eOD4f = parcelRequire("eOD4f");

var $ku35Y = parcelRequire("ku35Y");

var $jy7fT = parcelRequire("jy7fT");

var $kbi2o = parcelRequire("kbi2o");

var $4S0uJ = parcelRequire("4S0uJ");

var $g5X3G = parcelRequire("g5X3G");

var $l8ruj = parcelRequire("l8ruj");

var $ausru = parcelRequire("ausru");
const $f4c40304aa44c38f$var$deprecatedAgentViewProps = {
    onAtLeastOneIssueLoaded: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $f4c40304aa44c38f$var$getInitialState = (0, $8QpSo.default)((_queue)=>{
    // Only change the reference of initial state when we transition to a new queue, to avoid unnecessary re-renders
    // This shape of prop is required to be compatible what the AgentView expects in the non-spa
    // When JSD agent view is in the SPA by the default we can probably just pass appProps directly
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const initialState = {};
    return (0, $8QpSo.default)((appProps)=>{
        initialState.appProps = appProps;
        return initialState;
    });
});
const $f4c40304aa44c38f$var$QueuesAgentViewContent = ({ queuesData: queuesData, queueId: queueId, push: push, pageContext: pageContext, isQueueVisible: isQueueVisible, isAgentViewMountedRef: isAgentViewMountedRef, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (isAgentViewMountedRef) {
            // eslint-disable-next-line no-param-reassign
            isAgentViewMountedRef.current = true;
            return ()=>{
                // eslint-disable-next-line no-param-reassign
                isAgentViewMountedRef.current = false;
            };
        }
        return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    });
    const { data: isItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    const { canSeeNewIssueView: canSeeNewIssueView, isSiteAdmin: isSiteAdmin, userRole: userRole, serviceDeskId: serviceDeskId, ...appProps } = pageContext;
    const [state] = (0, $eOD4f.useProjectBuilder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "queues-agent-view"
    }, // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('spartans_cipher_deprecation_banner') && isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ausru.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4S0uJ.PageStyle), null, isItsmProject === true && !state.isProjectBuilderOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ku35Y.ProjectTour), {
        projectId: (0, $g5X3G.toProjectId)(`${pageContext.projectId}`),
        portalUrl: pageContext.portalUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbi2o.default), {
        queuesDataSource: queuesData,
        baseUrl: "",
        queueId: queueId,
        projectKey: pageContext.projectKey
    }, (queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jy7fT.default), {
            ...$f4c40304aa44c38f$var$deprecatedAgentViewProps,
            // @ts-expect-error - TS2741 - Property 'appProps' is missing in type 'Record<string, any>' but required in type 'InitialState'.
            initialState: $f4c40304aa44c38f$var$getInitialState(queue)(appProps),
            locale: pageContext.locale,
            isQueueVisible: isQueueVisible,
            queue: queue,
            push: push,
            // set onQueueRenderFailure - undefined to satisfy flow (ignored prop)
            onQueueRenderFailure: undefined,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }))), (0, $6s1PB.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled') !== 'not-enrolled' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Z4r3.HrExpansionSpotlight), null) : null);
};
var $f4c40304aa44c38f$export$2e2bcd8739ae039 = $f4c40304aa44c38f$var$QueuesAgentViewContent;

});
parcelRegister("8Z4r3", function(module, exports) {

$parcel$export(module.exports, "HrExpansionSpotlight", () => $326bd1799f743928$export$70aac9b19a402d6);

var $5uXOq = parcelRequire("5uXOq");

var $cSWNW = parcelRequire("cSWNW");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gq0sA = parcelRequire("gq0sA");

var $itmJb = parcelRequire("itmJb");


var $b0AMP = parcelRequire("b0AMP");
const $326bd1799f743928$var$HrExpansionSpotlightWithDelay = ()=>{
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setShouldShowSpotlight(true);
        }, 2000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b0AMP.HrExpansionSpotlightView), null);
};
const $326bd1799f743928$var$ChoreographedCustomMessageComponent = (0, $cSWNW.withChoreographedRender)($326bd1799f743928$var$HrExpansionSpotlightWithDelay);
const $326bd1799f743928$var$ChoreographedHrSpotlight = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    (0, $5uXOq.useEffect)(()=>{
        if (isAdmin && (0, $6s1PB.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled') !== 'not-enrolled') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'statsigExperiment exposed', 'jsm_hr_expansion', {
            cohort: (0, $6s1PB.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled'),
            projectId: projectId,
            projectType: projectType
        });
    }, [
        createAnalyticsEvent,
        isAdmin,
        projectId,
        projectType
    ]);
    return isAdmin && (0, $6s1PB.expValEquals)('jsm_hr_expansion', 'cohort', 'experiment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($326bd1799f743928$var$ChoreographedCustomMessageComponent, {
        messageId: (0, $7445d367723e9b81$export$3508d9f7bec6727b)
    }) : null;
};
const $326bd1799f743928$export$70aac9b19a402d6 = ()=>{
    const emptyFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-servicedesk-hr-expansion-experiment-spotlight",
        packageName: "jiraServicedeskHrExpansionExperiment",
        teamName: "jsd-getting-started",
        fallback: emptyFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($326bd1799f743928$var$ChoreographedHrSpotlight, null));
};

});
const $7445d367723e9b81$export$3508d9f7bec6727b = 'JsmHRExpansionExperimentSpotlight';

parcelRegister("b0AMP", function(module, exports) {

$parcel$export(module.exports, "HrExpansionSpotlightView", () => $2a47195d3c7e1d28$export$b94d2eaac7b145e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fqbGj = parcelRequire("fqbGj");

var $e4yMr = parcelRequire("e4yMr");

var $k5uoT = parcelRequire("k5uoT");

var $58GFP = parcelRequire("58GFP");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bKCrm = parcelRequire("bKCrm");

var $5QsHM = parcelRequire("5QsHM");

var $gq0sA = parcelRequire("gq0sA");

var $ajlSd = parcelRequire("ajlSd");

var $deUKU = parcelRequire("deUKU");


var $jtGtm = parcelRequire("jtGtm");
const $2a47195d3c7e1d28$export$b94d2eaac7b145e = ()=>{
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(true);
    const JSM_HR_EXPANSION_SPOTLIGHT_SEEN_STATUS_USER_PROPERTY_KEY = 'JsmHRExpansionExperimentSpotlightSeenStatus';
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: JSM_HR_EXPANSION_SPOTLIGHT_SEEN_STATUS_USER_PROPERTY_KEY,
        isSeenValue: true,
        packageName: 'jsmHrExpansionExperiment',
        teamName: 'jsm-getting-started'
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { methods: { open: openProjectCreate } } = (0, $bKCrm.useProjectCreateDrawer)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    const renderSpotlightCard = ()=>{
        const onDismissSpotlight = ()=>{
            setShowSpotlight(false);
            markSpotlightAsSeen();
        };
        const handleTryNow = ()=>{
            onDismissSpotlight();
            markSpotlightAsSeen();
            openProjectCreate({
                defaultSelectedTemplateKey: (0, $58GFP.HR_SERVICE_PROJECT_TEAM_MANAGED_KEY)
            });
        };
        const handleLearnMore = ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightLearnMore', {
                projectId: projectId,
                projectType: projectType
            });
        };
        const LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/service-management/hr';
        const renderNudge = ()=>{
            const SpotlightRef = (0, $ajlSd.createOnboardingSpotlight)({
                actions: [
                    {
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightDismiss', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            onDismissSpotlight();
                        },
                        content: formatMessage((0, $jtGtm.default).dismiss),
                        appearance: 'subtle'
                    },
                    {
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightActivate', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            handleTryNow();
                        },
                        content: formatMessage((0, $jtGtm.default).enable),
                        appearance: 'primary'
                    }
                ],
                contentMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $jtGtm.default).description, {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                            href: LEARN_MORE_LINK,
                            target: "_blank",
                            onClick: handleLearnMore
                        }, chunks)
                })),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($deUKU))),
                    alt: "",
                    width: "320"
                }),
                headingMessage: formatMessage((0, $jtGtm.default).heading)
            });
            // eslint-disable-next-line react/no-unstable-nested-components
            return /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                    "aria-label": "hr-expansion",
                    ref: ref
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightRef, null)));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a47195d3c7e1d28$var$ModalWrapperStyles, {
            "aria-label": "hr-expansion"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "JsmHrExpansionSpotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqbGj.NudgeSpotlight), {
            setHidden: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            hidden: !showSpotlight,
            spotlightCard: renderNudge(),
            position: "bottom-end",
            zIndex: (0, $k5uoT.layers).spotlight(),
            hideSpotlightCardOnOutsideClick: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                messageId: (0, $7445d367723e9b81$export$3508d9f7bec6727b),
                name: 'JsmHrExpansionSpotlight',
                projectId: projectId,
                projectType: projectType
            }
        })));
    };
    return showSpotlight && !hasSeenSpotlight ? renderSpotlightCard() : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a47195d3c7e1d28$var$ModalWrapperStyles = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _94n5xy5q _1xi2oahv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fqbGj", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $8ea39cee960047f1$export$eebbda33f5d4d735);

var $5uXOq = parcelRequire("5uXOq");

var $jC4R5 = parcelRequire("jC4R5");

var $k8nZq = parcelRequire("k8nZq");

var $4oNEb = parcelRequire("4oNEb");

var $cBeZP = parcelRequire("cBeZP");

var $4AhK0 = parcelRequire("4AhK0");

var $4aeUu = parcelRequire("4aeUu");

var $ao4Ml = parcelRequire("ao4Ml");
const $8ea39cee960047f1$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $8ea39cee960047f1$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $4AhK0.default), nudge: Nudge = (0, $jC4R5.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $5uXOq.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $5uXOq.useRef)(null);
    const spotlightCardRef = (0, $5uXOq.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $5uXOq.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $5uXOq.useState)(false);
    const stopBlink = (0, $5uXOq.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $5uXOq.useRef)({
        fn: ()=>{}
    });
    (0, $5uXOq.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $5uXOq.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $5uXOq.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $5uXOq.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $5uXOq.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $5uXOq.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $5uXOq.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $5uXOq.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $cBeZP.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $8ea39cee960047f1$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $5uXOq.useMemo)(()=>Spotlight === (0, $4AhK0.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Nudge, {
        ref: nudgeRef,
        hasPulse: showNudge,
        onClickCapture: onTargetClick,
        onMouseEnter: markReadyToShow,
        pulseColor: pulseColor,
        pulseShadowColor: pulseShadowColor,
        pulseBorderRadius: pulseBorderRadius,
        nudgeTestId: nudgeTestId,
        tag: nudgeTag
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8nZq.default), {
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oNEb.Popper), {
        placement: position,
        referenceElement: nudgeRef.current || undefined,
        offset: offset
    }, ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4aeUu.SpotlightContainer), {
            showSpotlight: showSpotlight,
            shouldBlink: shouldBlink,
            stopBlink: stopBlink,
            zIndex: zIndex,
            ref: ref,
            containerStyles: {
                ...popperStyles,
                ...concealSpotlightOnScrollStyles(isReferenceHidden)
            },
            role: "dialog",
            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), null, (forceUpdateFnRef.current.fn = forceUpdate) && null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Spotlight, {
            ...cardConfig,
            ref: spotlightCardRef
        }))))));
});
var $8ea39cee960047f1$export$2e2bcd8739ae039 = $8ea39cee960047f1$export$eebbda33f5d4d735;

});
parcelRegister("jC4R5", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $d88355bc6c5eb74c$export$b7d614104f4a4a7c);

var $5uXOq = parcelRequire("5uXOq");

var $5XLZB = parcelRequire("5XLZB");
const $d88355bc6c5eb74c$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XLZB.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId
    }, children));

});
parcelRegister("5XLZB", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $589071e97cffed79$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k5uoT = parcelRequire("k5uoT");
function $589071e97cffed79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $589071e97cffed79$var$baseShadow = '0 0 0 3px';
const $589071e97cffed79$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P75})`;
const $589071e97cffed79$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $589071e97cffed79$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $589071e97cffed79$var$pulseAnimation = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animation: `pulseKeyframes 3000ms ${$589071e97cffed79$var$easing} infinite`
});
const $589071e97cffed79$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $589071e97cffed79$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $589071e97cffed79$var$pulseAnimation
            ]
        }
    });
const $589071e97cffed79$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $k5uoT.borderRadius)(), pulseColor: pulseColor = $589071e97cffed79$var$basePulseColor, pulseShadowColor: pulseShadowColor = $589071e97cffed79$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(CastTargetContainer, {
        css: $589071e97cffed79$export$814d9bf8c56ac913({
            hasPulse: hasPulse,
            pulseBorderRadius: pulseBorderRadius,
            pulseColor: pulseColor,
            pulseShadowColor: pulseShadowColor
        }),
        ref: ref,
        ...rest
    });
});

});


parcelRegister("4AhK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b690ab706aa80c88$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");


var $f8Sb3 = parcelRequire("f8Sb3");
function $b690ab706aa80c88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b690ab706aa80c88$var$borderRadius = 3;
const $b690ab706aa80c88$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
    borderRadius: `${$b690ab706aa80c88$var$borderRadius}px`,
    overflow: 'auto'
};
const $b690ab706aa80c88$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $b690ab706aa80c88$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $b690ab706aa80c88$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $829f609a65d26a98$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $829f609a65d26a98$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        }
    });
const $b690ab706aa80c88$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        css: $b690ab706aa80c88$var$actionItemStyles(index),
        ...rest
    });
const $b690ab706aa80c88$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $b690ab706aa80c88$export$b3ae98194e057550 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $5uXOq.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($b690ab706aa80c88$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$b690ab706aa80c88$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$headerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $b690ab706aa80c88$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$actionItemContainerStyles
    }, renderedActions))));
});
var $b690ab706aa80c88$export$2e2bcd8739ae039 = $b690ab706aa80c88$export$b3ae98194e057550;

});

parcelRegister("4aeUu", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $99a240fc01f7ca0b$export$d0f55839b708c0a0);

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $k8nZq = parcelRequire("k8nZq");
const $99a240fc01f7ca0b$export$474e8ee88cc7cd8f = 200;
const $99a240fc01f7ca0b$export$3d6f334bf7dc4597 = 120;
const $99a240fc01f7ca0b$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$99a240fc01f7ca0b$export$474e8ee88cc7cd8f}ms`
};
const $99a240fc01f7ca0b$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$99a240fc01f7ca0b$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $99a240fc01f7ca0b$var$timeoutDurations = {
    enter: 0,
    exit: $99a240fc01f7ca0b$export$3d6f334bf7dc4597
};
const $99a240fc01f7ca0b$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ahdj0.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $99a240fc01f7ca0b$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink
    }, (state)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8nZq.default), {
            zIndex: zIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...containerStyles,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$99a240fc01f7ca0b$var$defaultTransitionStyles,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$99a240fc01f7ca0b$var$statefulTransitionStyles[state]
            },
            ref: ref,
            "aria-labelledby": ariaLabelledBy,
            ...rest
        }))));

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5QsHM", function(module, exports) {

$parcel$export(module.exports, "useSeenStatus", () => $36807a4a4f35954c$export$12667e37571b0a02);

var $5uXOq = parcelRequire("5uXOq");


var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");
const $36807a4a4f35954c$var$initialState = {
    isSeen: true,
    isLoading: false,
    error: undefined
};
const $36807a4a4f35954c$export$f7ab30339d40bcd = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $36807a4a4f35954c$export$12667e37571b0a02 = ({ userPropertyKey: userPropertyKey, isSeenValue: isSeenValue, packageName: packageName, teamName: teamName, skipOnboarding: skipOnboarding })=>{
    const [state, setState] = (0, $5uXOq.useState)($36807a4a4f35954c$var$initialState);
    const { atlassianAccountId: accountId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const reportErrorDeps = (0, $5uXOq.useRef)({
        packageName: packageName,
        teamName: teamName
    });
    reportErrorDeps.current = {
        packageName: packageName,
        teamName: teamName
    };
    const reportError = (0, $5uXOq.useCallback)((errorId, error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: errorId,
                ...reportErrorDeps.current
            },
            error: error,
            attributes: {
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (accountId && !$36807a4a4f35954c$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isLoading: true
                }));
            (0, $89SaW.getUserProperty)(accountId, userPropertyKey).catch((error)=>{
                if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) // user property has not been set
                return false;
                throw error;
            }).then((value)=>{
                setState((oldState)=>({
                        ...oldState,
                        isSeen: value === isSeenValue,
                        isLoading: false
                    }));
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.fetchStatus succeeded', {
                    userPropertyKey: userPropertyKey
                });
            }).catch((error)=>{
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.fetchStatus', error);
            });
        }
    }, [
        userPropertyKey,
        accountId,
        isSeenValue,
        reportError,
        createAnalyticsEvent,
        skipOnboarding
    ]);
    const markAsSeen = (0, $5uXOq.useCallback)(()=>{
        if (accountId && !$36807a4a4f35954c$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isSeen: true,
                    isLoading: true
                }));
            (0, $89SaW.setUserProperties)(accountId, userPropertyKey, JSON.stringify(isSeenValue)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $jJZqs.default)(res.status, errResp);
                });
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false
                    }));
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.markAsSeen succeeded', {
                    userPropertyKey: userPropertyKey
                });
                return Promise.resolve();
            }).catch((error)=>{
                // leave `isSeen` as true. we don't want to block the user
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.markAsSeen', error);
            });
        }
    }, [
        accountId,
        userPropertyKey,
        isSeenValue,
        createAnalyticsEvent,
        reportError,
        skipOnboarding
    ]);
    return [
        state,
        {
            markAsSeen: markAsSeen
        }
    ];
};

});

parcelRegister("ajlSd", function(module, exports) {

$parcel$export(module.exports, "createOnboardingSpotlight", () => $208acef035d7cdaa$export$3de3bbc64fe39fe6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $9yOBd = parcelRequire("9yOBd");
var $fVnbM = parcelRequire("fVnbM");

var $5ujeO = parcelRequire("5ujeO");

var $8Bc5A = parcelRequire("8Bc5A");
const $208acef035d7cdaa$var$NudgeHeading = ({ formattedMessage: formattedMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$Title, {
        id: "nudge-spot-light-card-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$CustomHeading, null, formattedMessage));
const $208acef035d7cdaa$var$NudgeAction = ({ appearance: appearance, content: content, onClick: onClick })=>{
    // if appearance is primary, override styles with custom button
    // note CustomThemeButton is advised against and we need a better solution
    // (potentially even going with the blue button). Leaving this code for the experiment
    if (appearance === 'primary') {
        const customTheme = (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: `${"var(--ds-icon-discovery, #8270DB)"}`,
                    minWidth: '84px',
                    margin: `0 ${"var(--ds-space-050, 4px)"}`,
                    color: `${"var(--ds-text-inverse, #FFFFFF)"}`
                },
                spinnerStyles: spinnerStyles
            };
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
            appearance: appearance,
            onClick: onClick,
            theme: customTheme
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: appearance,
        onClick: onClick
    }, content);
};
const $208acef035d7cdaa$var$NudgeActions = ({ actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$Footer, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeAction, {
            key: index,
            ...action
        })));
const $208acef035d7cdaa$export$3de3bbc64fe39fe6 = ({ actions: actions, contentMessage: contentMessage, headingMessage: headingMessage, image: image, width: width = (0, $8Bc5A.DEFAULT_NUDGE_WIDTH), CustomWrapper: CustomWrapper, actionsBeforeElement: actionsBeforeElement })=>{
    const Wrapper = CustomWrapper || $208acef035d7cdaa$var$SpotlightCardWrapper;
    return /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
            image: image,
            heading: headingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeHeading, {
                formattedMessage: headingMessage
            }) : null,
            width: width,
            actionsBeforeElement: actionsBeforeElement
        }, contentMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeActions, {
            actions: actions
        }))));
};
const $208acef035d7cdaa$export$cbbb2ee263b2a558 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ focusLock: focusLock, ...rest }, ref)=>{
    const Spotlight = $208acef035d7cdaa$export$3de3bbc64fe39fe6({
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
        disabled: !focusLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Spotlight, {
        ref: ref
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $208acef035d7cdaa$var$SpotlightCardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_fkwn1bhr _tml110s3 _19yu10s3",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$CustomHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81bk4 _syaz10s3",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("deUKU", function(module, exports) {
module.exports = new URL("spotlightImage.0949772a.png", import.meta.url).toString();

});

parcelRegister("jtGtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f54521ce195b1c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4f54521ce195b1c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "service-management-hr-expansion-experiment-spotlight.description",
        "defaultMessage": "Set up your new project fast using the HR service management template, or <a>read about service management for HR.</a>"
    },
    heading: {
        "id": "service-management-hr-expansion-experiment-spotlight.heading",
        "defaultMessage": "Want to deliver better HR service experiences from day one?"
    },
    enable: {
        "id": "service-management-hr-expansion-experiment-spotlight.enable",
        "defaultMessage": "Try now"
    },
    dismiss: {
        "id": "service-management-hr-expansion-experiment-spotlight.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("eOD4f", function(module, exports) {

$parcel$export(module.exports, "useProjectBuilder", () => $06ebb99a27f60c8b$export$5891129c2551a3c0);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $06ebb99a27f60c8b$var$ProjectBuilderStore = (0, $iXqE5.createStore)({
    initialState: {
        isProjectBuilderOpen: false
    },
    actions: {
        hideProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: false
                });
            },
        showProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: true
                });
            }
    },
    name: 'projectBuilder'
});
const $06ebb99a27f60c8b$export$5891129c2551a3c0 = (0, $3sQ5x.createHook)($06ebb99a27f60c8b$var$ProjectBuilderStore);

});

parcelRegister("ku35Y", function(module, exports) {

$parcel$export(module.exports, "ProjectTour", () => $d74794e1b26f3945$export$efe5812745c27ad2);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $6xJHf = parcelRequire("6xJHf");

var $aDlds = parcelRequire("aDlds");

var $kxZPA = parcelRequire("kxZPA");

var $4Sx5B = parcelRequire("4Sx5B");

var $hPfMB = parcelRequire("hPfMB");

const $d74794e1b26f3945$var$preloadComponent = ()=>(parcelRequire("i6EgU")).then((exportedModule)=>exportedModule.ProjectTour);
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d74794e1b26f3945$var$ProjectTourInternal = (0, $kxZPA.lazy)(()=>$d74794e1b26f3945$var$preloadComponent(), {});
const $d74794e1b26f3945$export$efe5812745c27ad2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "itsm-project-tour",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPfMB.IfNavTargetsAreShowing), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xJHf.StartExperiencesOnce), {
        experiences: [
            (0, $4Sx5B.projectTourFirstStepExperience),
            (0, $aDlds.sampleSpaceTourFirstStepExperience)
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d74794e1b26f3945$var$ProjectTourInternal, props)));

});
parcelRegister("6xJHf", function(module, exports) {

$parcel$export(module.exports, "StartExperiencesOnce", () => $cbc1a6a017c8dd77$export$144439ff99ea00b7);

var $5uXOq = parcelRequire("5uXOq");

var $gdweW = parcelRequire("gdweW");

var $lc9Xi = parcelRequire("lc9Xi");
const $cbc1a6a017c8dd77$export$144439ff99ea00b7 = ({ experiences: experiences })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdweW.default), {
        mount: ()=>{
            // Only start the experiences if they haven't been started before
            experiences.filter((exp)=>exp.state.id === (0, $lc9Xi.UFOExperienceState).NOT_STARTED.id).forEach((exp)=>exp.start());
        },
        unmount: ()=>{
            // Abort the experiences on unmount
            experiences.forEach((exp)=>exp.abort());
        }
    });

});
parcelRegister("gdweW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eebc9e5a8a8844e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line jira/react/no-class-components
class $eebc9e5a8a8844e9$var$OpTrigger extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.mount();
    }
    componentWillUnmount() {
        this.props.unmount();
    }
    render() {
        return null;
    }
}
var $eebc9e5a8a8844e9$export$2e2bcd8739ae039 = $eebc9e5a8a8844e9$var$OpTrigger;

});


parcelRegister("aDlds", function(module, exports) {

$parcel$export(module.exports, "sampleSpaceTourFirstStepExperience", () => $9a9c8bc98e92f206$export$79aaeba705b81d95);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $9a9c8bc98e92f206$export$79aaeba705b81d95 = new (0, $duUGa.UFOExperience)('jsm-first-session-flow-sample-space-tour-first-step', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("4Sx5B", function(module, exports) {

$parcel$export(module.exports, "yourWorkFirstStepExperience", () => $7283d40212cf095b$export$df0fbb7740eb79c7);
$parcel$export(module.exports, "projectTourFirstStepExperience", () => $7283d40212cf095b$export$18d4c572a40cbc5b);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $7283d40212cf095b$export$df0fbb7740eb79c7 = new (0, $duUGa.UFOExperience)('jsm-first-session-flow-your-work-tour-first-step', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $7283d40212cf095b$export$18d4c572a40cbc5b = new (0, $duUGa.UFOExperience)('jsm-first-session-flow-project-tour-first-step', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("hPfMB", function(module, exports) {

$parcel$export(module.exports, "IfNavTargetsAreShowing", () => $ff73f4d1faae965c$export$88096496147f47d4);

var $5uXOq = parcelRequire("5uXOq");

var $1B1XB = parcelRequire("1B1XB");

var $16J3A = parcelRequire("16J3A");
const $ff73f4d1faae965c$var$targetName = (0, $16J3A.HOME_ITEMS_IDS).ALL_ITSM_QUEUES_SPOTLIGHT;
const $ff73f4d1faae965c$export$88096496147f47d4 = ({ children: children })=>{
    const { isTargetRendered: isTargetRendered } = (0, $1B1XB.default)();
    const isNavTargetPresent = isTargetRendered($ff73f4d1faae965c$var$targetName);
    return isNavTargetPresent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : null;
};

});
parcelRegister("1B1XB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bad88a821808218$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");
function $9bad88a821808218$export$2e2bcd8739ae039() {
    const { targets: targets } = (0, $5uXOq.useContext)((0, $imZsD.SpotlightContext));
    const targetRef = (0, $5uXOq.useRef)(targets);
    (0, $5uXOq.useEffect)(()=>{
        targetRef.current = targets;
    }, [
        targets
    ]);
    const isTargetRendered = (0, $5uXOq.useCallback)((target)=>!!targetRef.current[target], []);
    return (0, $5uXOq.useMemo)(()=>({
            isTargetRendered: isTargetRendered
        }), [
        isTargetRendered
    ]);
}

});


parcelRegister("i6EgU", function(module, exports) {

let $d2e806a73b45fcec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d2e806a73b45fcec$var$load("h2MrD"),
    $d2e806a73b45fcec$var$load("bYT2S"),
    $d2e806a73b45fcec$var$load("93nG5")
]).then(()=>parcelRequire('l5eM4'));

});


parcelRegister("jy7fT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b97afceadc188d4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $9tOEo = parcelRequire("9tOEo");

var $jzjy1 = parcelRequire("jzjy1");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $bC2fB = parcelRequire("bC2fB");

var $9noxX = parcelRequire("9noxX");

var $geBSE = parcelRequire("geBSE");

var $6z7Gx = parcelRequire("6z7Gx");

var $e9YVH = parcelRequire("e9YVH");

var $8YEE2 = parcelRequire("8YEE2");

var $dsVYa = parcelRequire("dsVYa");

var $3HGy4 = parcelRequire("3HGy4");

var $4o3DF = parcelRequire("4o3DF");

var $g5X3G = parcelRequire("g5X3G");

var $2tT7R = parcelRequire("2tT7R");

var $itmJb = parcelRequire("itmJb");

var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");

var $1WlLE = parcelRequire("1WlLE");

var $cSD7y = parcelRequire("cSD7y");

var $c2C16 = parcelRequire("c2C16");

var $SEV5o = parcelRequire("SEV5o");

var $CWMfa = parcelRequire("CWMfa");

var $e6t8P = parcelRequire("e6t8P");

var $7mC60 = parcelRequire("7mC60");

var $e8jJJ = parcelRequire("e8jJJ");

var $eiOBt = parcelRequire("eiOBt");

var $fG5Qt = parcelRequire("fG5Qt");

var $19cKl = parcelRequire("19cKl");

var $kKtyo = parcelRequire("kKtyo");

var $bEcXz = parcelRequire("bEcXz");

var $a8rnx = parcelRequire("a8rnx");
// for local dev, to be able to open Project Builder without creating project each time
const $4b97afceadc188d4$var$ProjectBuilderWithQueryParamDev = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isStagingOrDev = (0, $2tT7R.useIsStagingOrDevOrLocal)();
    const [projectBuilderQueryParamDev] = (0, $ieDtd.useQueryParam)((0, $dsVYa.SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV));
    const [isDrawerOpen] = (0, $5uXOq.useState)(()=>isStagingOrDev && projectBuilderQueryParamDev === 'true');
    if (isDrawerOpen) return (0, $8YEE2.canUseProjectBuilder)(isAdmin) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8YEE2.AsyncProjectBuilderDrawer), {
        isOpenInitial: true
    }) : null;
    return null;
};
const $4b97afceadc188d4$var$ReduxAnalytics = (0, $bC2fB.connect)(null, (dispatch)=>({
        setAnalyticsToRedux: (createAnalyticsEvent)=>{
            dispatch((0, $e6t8P.sendAnalyticCreatorAction)(createAnalyticsEvent));
        }
    }))(({ setAnalyticsToRedux: setAnalyticsToRedux, children: children })=>{
    const [isAnalyticsSet, setIsAnalyticsSet] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Save setAnalyticsToReduxRef to ref to avoid useEffect reevaluation on every rerender
    const setAnalyticsToReduxRef = (0, $5uXOq.useRef)();
    setAnalyticsToReduxRef.current = setAnalyticsToRedux;
    (0, $5uXOq.useEffect)(()=>{
        setAnalyticsToReduxRef.current && setAnalyticsToReduxRef.current(createAnalyticsEvent);
        setIsAnalyticsSet(true);
    }, [
        createAnalyticsEvent
    ]);
    // in server context we need to return children
    if (false && (0, $4R6GH.fg)('issuelist_render_ssr_state_initialisation')) return children;
    return isAnalyticsSet ? children : null;
});
// eslint-disable-next-line jira/react/no-class-components
class $4b97afceadc188d4$var$AgentApp extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            queue: undefined,
            push: undefined
        };
    }
    renderAgentView() {
        const { isQueueVisible: isQueueVisible, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, queue: queue, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged } = this.props;
        return (0, $4R6GH.fg)('jsm_flash_servicedesk_analytics_removal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a8rnx.default), {
            queue: queue,
            isQueueVisible: isQueueVisible,
            onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKtyo.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), {
            forceRenderWhileLoading: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a8rnx.default), {
            queue: queue,
            isQueueVisible: isQueueVisible,
            onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKtyo.default), null));
    }
    render() {
        const { initialState: initialState, locale: locale, onQueueRenderFailure: onQueueRenderFailure, push: push } = this.props;
        const state = {
            appProps: initialState.appProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geBSE.default), {
            appName: (0, $e9YVH.APP_NAMES).QUEUES_AGENT_VIEW,
            initialState: state,
            locale: locale,
            rootReducer: (0, $aB8eX.enableBatching)((0, $e8jJJ.default)),
            rootEpic: (0, $c2C16.default)(push),
            onErrorHandler: onQueueRenderFailure,
            ErrorView: (0, $4o3DF.QueuesErrorView),
            resetProjectContextAction: (0, $7mC60.resetProjectContextAction)
        }, // forceRenderWhileLoading guards against remounting caused by
        // ServiceDeskAnalyticsContext in rare scenarios, which can in turn
        // result in "Cannot update during an existing state transition".
        //
        // See: `this.triggerQueueChange()` called during render() in https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/servicedesk/queues-agent-view/src/view/layout/view.tsx#313
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), {
            forceRenderWhileLoading: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b97afceadc188d4$var$ReduxAnalytics, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $19cKl.default), null, this.renderAgentView()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b97afceadc188d4$var$ProjectBuilderWithQueryParamDev, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fG5Qt.ChangeManagementTour), {
            projectId: (0, $g5X3G.toProjectId)(`${state.appProps.projectId}`)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "incidentManagementTourQueues",
            packageName: "jiraServicedeskIncidentManagementTour",
            fallback: "flag"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEcXz.IncidentManagementTour), {
            projectId: (0, $g5X3G.toProjectId)(`${state.appProps.projectId}`)
        })))));
    }
}
const $4b97afceadc188d4$var$AgentViewComponent = (props)=>{
    const { isQueueVisible: isQueueVisible, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, queue: queue, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged } = props;
    return (0, $4R6GH.fg)('jsm_flash_servicedesk_analytics_removal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a8rnx.default), {
        queue: queue,
        isQueueVisible: isQueueVisible,
        onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
        onIssuesChanged: onIssuesChanged,
        onIssuesCountChanged: onIssuesCountChanged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKtyo.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), {
        forceRenderWhileLoading: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a8rnx.default), {
        queue: queue,
        isQueueVisible: isQueueVisible,
        onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
        onIssuesChanged: onIssuesChanged,
        onIssuesCountChanged: onIssuesCountChanged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKtyo.default), null));
};
const $4b97afceadc188d4$var$AgentAppComponent = (props)=>{
    const { initialState: initialState, locale: locale, onQueueRenderFailure: onQueueRenderFailure, push: push, queue: queue } = props;
    const { data: data, error: error } = (0, $2YP9W.useResource)((0, $1WlLE.issueListSsrResource));
    const ssrIssueList = data ?? null;
    const state = {
        appProps: initialState.appProps,
        persisted: {
            ssrIssuesData: {
                ssrIssueList: ssrIssueList,
                error: error,
                isInitialLoading: true
            },
            issues: (0, $eiOBt.DEFAULT_ISSUES_STATE),
            queue: (0, $4R6GH.fg)('remove_load_states_for_smooth_view_queues_ssr') ? {
                category: queue.category,
                fetchStartIndex: 0,
                pagination: {
                    currentPage: 1
                }
            } : undefined
        },
        ui: {}
    };
    if ((false || (0, $4R6GH.fg)('remove_load_states_for_smooth_view_queues_ssr')) && ssrIssueList && !error && (0, $4R6GH.fg)('issuelist_render_ssr_state_initialisation')) {
        const queueData = (0, $4R6GH.fg)('fix_ssr_sorting_bug_on_jsm_queue') ? {
            ...queue,
            // the ssr'd issue list has the sorting data and we want to include it
            columns: ssrIssueList.columns.map(({ fieldId: fieldId, columnHeaderText: columnHeaderText, sortable: sortable, fieldType: fieldType, sortOrder: sortOrder })=>({
                    id: fieldId,
                    title: columnHeaderText,
                    fieldType: fieldType,
                    sortable: sortable,
                    currentSorting: sortOrder
                }))
        } : queue;
        state.ui = {
            currentQueue: {
                ...(0, $CWMfa.createSortedQueue)(queueData)
            },
            isLoadingIssues: false
        };
        const { totalCount: totalCount, isUsingDefaultSorting: isUsingDefaultSorting, issues: issues } = (0, $SEV5o.default)(ssrIssueList, (0, $3HGy4.SSR_SOURCE), false, false);
        // @ts-expect-error - TS2322: Type 'never' is not assignable to type 'CollectionItem'.
        state.persisted.issues = (0, $eiOBt.addIssuesResponseToState)(0, totalCount, isUsingDefaultSorting, issues);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geBSE.default), {
        appName: (0, $e9YVH.APP_NAMES).QUEUES_AGENT_VIEW,
        initialState: state,
        locale: locale,
        rootReducer: (0, $aB8eX.enableBatching)((0, $e8jJJ.default)),
        rootEpic: (0, $c2C16.default)(push),
        onErrorHandler: onQueueRenderFailure,
        ErrorView: (0, $4o3DF.QueuesErrorView),
        resetProjectContextAction: (0, $7mC60.resetProjectContextAction)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "viewQueue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), {
        forceRenderWhileLoading: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b97afceadc188d4$var$ReduxAnalytics, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $19cKl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b97afceadc188d4$var$AgentViewComponent, props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b97afceadc188d4$var$ProjectBuilderWithQueryParamDev, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fG5Qt.ChangeManagementTour), {
        projectId: (0, $g5X3G.toProjectId)(`${state.appProps.projectId}`)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "incidentManagementTourQueues",
        packageName: "jiraServicedeskIncidentManagementTour",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEcXz.IncidentManagementTour), {
        projectId: (0, $g5X3G.toProjectId)(`${state.appProps.projectId}`)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            context: (0, $6z7Gx.ANALYTIC_CONTEXTS).QUEUES,
            redesign: true
        }
    })));
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $4b97afceadc188d4$var$AgentAppWithAnalytics = (0, $jzjy1.AnalyticsSource)('viewQueue', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))((0, $9tOEo.default)({
    attributes: {
        context: (0, $6z7Gx.ANALYTIC_CONTEXTS).QUEUES,
        redesign: true
    }
})($4b97afceadc188d4$var$AgentApp)); // eslint-disable-line @typescript-eslint/no-explicit-any
const $4b97afceadc188d4$var$AgentAppWithFG = (0, $cSD7y.componentWithFG)('issuelist_skip_fetch_cache_hit', $4b97afceadc188d4$var$AgentAppComponent, $4b97afceadc188d4$var$AgentAppWithAnalytics);
var $4b97afceadc188d4$export$2e2bcd8739ae039 = $4b97afceadc188d4$var$AgentAppWithFG;

});
parcelRegister("9tOEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2220d181f8eca1$export$2e2bcd8739ae039);

var $994MI = parcelRequire("994MI");

var $i4iBk = parcelRequire("i4iBk");
var /**
 * @deprecated - Just provide the data when firing analytics events.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$0d2220d181f8eca1$export$2e2bcd8739ae039 = (payload)=>(WrappedComponent)=>(0, $994MI.default)((0, $i4iBk.default)(payload))(WrappedComponent);

});

parcelRegister("9noxX", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $12b9024f66e7ef57$export$ac31f8f3368d6881);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4DPZY = parcelRequire("4DPZY");

var $8H3A4 = parcelRequire("8H3A4");
const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $5uXOq.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
$12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $8H3A4.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $4DPZY.useContainerContext)
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("geBSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1874d44b889e3ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e1AU2 = parcelRequire("e1AU2");

var $8rCP3 = parcelRequire("8rCP3");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $8ZMkT = parcelRequire("8ZMkT");

var $hMCnr = parcelRequire("hMCnr");

var $1UCHC = parcelRequire("1UCHC");

var $aLLc7 = parcelRequire("aLLc7");

var $7Mk2n = parcelRequire("7Mk2n");
// eslint-disable-next-line jira/react/no-class-components
class $b1874d44b889e3ed$var$ServiceDeskSubApp extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            children: null,
            onErrorHandler: null
        };
    }
    static{
        this.childContextTypes = {
            monolithNavigationBridge: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
        };
    }
    constructor(props){
        super(props), this.onNavigationReject = ()=>{
            this.monolithNavigationBridge && this.monolithNavigationBridge.rejectNavigation();
        }, this.onNavigationConfirm = ()=>{
            this.monolithNavigationBridge && this.monolithNavigationBridge.confirmNavigation();
        };
        this.monolithNavigationBridge = (0, $hMCnr.createMonolithNavigationBridge)();
        const navigationBridgeEpic = (0, $8ZMkT.default)(this.onNavigationConfirm, this.onNavigationReject);
        this.store = (0, $7Mk2n.createStore)(this.props.appName, this.props.initialState, this.props.rootReducer, this.props.extraMiddleware, (0, $e1AU2.combineEpics)(navigationBridgeEpic, this.props.rootEpic));
    }
    getChildContext() {
        return {
            monolithNavigationBridge: this.monolithNavigationBridge
        };
    }
    shouldComponentUpdate(nextProps) {
        const { appName: appName, rootReducer: rootReducer, rootEpic: rootEpic, children: children, extraMiddleware: extraMiddleware, onErrorHandler: onErrorHandler } = this.props;
        // If any prop other than initialState has changed
        return appName !== nextProps.appName || rootReducer !== nextProps.rootReducer || rootEpic !== nextProps.rootEpic || children !== nextProps.children || extraMiddleware !== nextProps.extraMiddleware || onErrorHandler !== nextProps.onErrorHandler;
    }
    // This state update must happens before render() is called to avoid the wrong queue from loading
    UNSAFE_componentWillUpdate(nextProps) {
        this.resetAppPropsState(this.props.initialState.appProps.projectKey, nextProps.initialState.appProps.projectKey, nextProps.initialState.appProps);
    }
    componentWillUnmount() {
        this.monolithNavigationBridge && this.monolithNavigationBridge.disable();
    }
    resetAppPropsState(currentProjectKey, nextProjectKey, appProps) {
        const { resetProjectContextAction: resetProjectContextAction } = this.props;
        if (!resetProjectContextAction) return;
        if (currentProjectKey !== nextProjectKey) this.store.dispatch(resetProjectContextAction(appProps));
    }
    render() {
        const { children: children, appName: appName, onErrorHandler: onErrorHandler, ErrorView: ErrorView } = this.props;
        // We put the error boundary below <AppBase>, to intercept errors before the error boundary
        // provided by AppBase
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aLLc7.ServiceDeskErrorBoundary), {
            appName: appName,
            onErrorHandler: onErrorHandler,
            ErrorView: ErrorView
        }, children)));
    }
}
var $b1874d44b889e3ed$export$2e2bcd8739ae039 = (0, $1UCHC.withExtraMiddleware)($b1874d44b889e3ed$var$ServiceDeskSubApp);

});
parcelRegister("8ZMkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1847dde0f28e98$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $gsw4R = parcelRequire("gsw4R");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dd1847dde0f28e98$export$2e2bcd8739ae039 = (onNavigationConfirm, onNavigationReject)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$)=>action$.ofType((0, $gsw4R.REJECT_NAVIGATION), (0, $gsw4R.CONFIRM_NAVIGATION)).switchMap((action)=>{
            switch(action.type){
                case 0, $gsw4R.REJECT_NAVIGATION:
                    onNavigationReject();
                    break;
                case 0, $gsw4R.CONFIRM_NAVIGATION:
                    onNavigationConfirm();
                    break;
                default:
                    return (0, $kVLXA.Observable).empty();
            }
            return (0, $kVLXA.Observable).empty();
        });

});
parcelRegister("gsw4R", function(module, exports) {

$parcel$export(module.exports, "REJECT_NAVIGATION", () => $d15daa3ff6491b3d$export$c3435b1d4d47dde6);
$parcel$export(module.exports, "rejectNavigationAction", () => $d15daa3ff6491b3d$export$ce226bb73ade3056);
$parcel$export(module.exports, "CONFIRM_NAVIGATION", () => $d15daa3ff6491b3d$export$612d6f3c633890da);
$parcel$export(module.exports, "confirmNavigationAction", () => $d15daa3ff6491b3d$export$949b9bb33ccd5cc0);
// REJECT_NAVIGATION
const $d15daa3ff6491b3d$export$c3435b1d4d47dde6 = 'navigation.bridge.epic.REJECT_NAVIGATION';
const $d15daa3ff6491b3d$export$ce226bb73ade3056 = ()=>({
        type: $d15daa3ff6491b3d$export$c3435b1d4d47dde6
    });
const $d15daa3ff6491b3d$export$612d6f3c633890da = 'navigation.bridge.epic.CONFIRM_NAVIGATION';
const $d15daa3ff6491b3d$export$949b9bb33ccd5cc0 = ()=>({
        type: $d15daa3ff6491b3d$export$612d6f3c633890da
    });

});


parcelRegister("hMCnr", function(module, exports) {

$parcel$export(module.exports, "createMonolithNavigationBridge", () => $b6936aced86db08b$export$e8afb3901df5306d);

var $alviN = parcelRequire("alviN");
class $b6936aced86db08b$export$dfd89a95c7765d38 {
    cleanUpPromiseCallBack() {
        delete this.resolveFn;
        delete this.rejectFn;
    }
    /**
	 * Calling setBeforeNavigateListener is deferred to here, so that we don't go through a state
	 * where setBeforeNavigateListener fails to register the new listener because there is already
	 * a listener from another page that hasn't finished cleaning up yet.
	 * This is because an instance of the old page and the new page will both be active during a
	 * navigation. I.e. we need componentWillUnmount of the old page to call #disable before setting
	 * the new listener.
	 */ block(beforeNavigateCallback) {
        (0, $alviN.RouterManager).deleteBeforeNavigateListener();
        (0, $alviN.RouterManager).setBeforeNavigateListener(this.onBeforeNavigate);
        this.beforeNavigateCallback = beforeNavigateCallback;
    }
    unblock() {
        this.beforeNavigateCallback = undefined;
    }
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBeforeNavigate = (fragment)=>{
            if (!this.beforeNavigateCallback) return Promise.resolve(null);
            this.promise = new Promise((resolve, reject)=>{
                this.resolveFn = resolve;
                this.rejectFn = reject;
            });
            this.beforeNavigateCallback(fragment);
            return this.promise;
        };
        this.confirmNavigation = ()=>{
            this.resolveFn && this.resolveFn();
            this.cleanUpPromiseCallBack();
        };
        this.rejectNavigation = ()=>{
            this.rejectFn && this.rejectFn();
            this.cleanUpPromiseCallBack();
        };
        this.disable = ()=>{
            (0, $alviN.RouterManager).deleteBeforeNavigateListener();
        };
    }
}
const $b6936aced86db08b$export$e8afb3901df5306d = ()=>new $b6936aced86db08b$export$dfd89a95c7765d38();

});
parcelRegister("alviN", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        function t(r) {
            if (n[r]) return n[r].exports;
            var o = n[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.d = function(e, n, r) {
            t.o(e, n) || Object.defineProperty(e, n, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, t.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(n, "a", n), n;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 3);
    }([
        function(e, t) {
            var n;
            n = function() {
                return this;
            }();
            try {
                n = n || Function("return this")() || (0, eval)("this");
            } catch (e) {
                "object" == typeof window && (n = window);
            }
            e.exports = n;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeRouting = e.window._jsdFeRouting || {}, e.window._jsdFeRouting;
                }
                function r() {
                    var t = n();
                    !t || t.feRouteFn || t.beforeNavigateListener || t.willNavigateListener || delete e.window._jsdFeRouting;
                }
                function o() {
                    return n().feRouteFn;
                }
                function i() {
                    delete n().feRouteFn, r();
                }
                function u(e) {
                    o() && console.error("Warning: [Service Desk Frontend routing] FeRouteFunction already exists. This function should be set only once per app."), n().feRouteFn = e;
                }
                function a() {
                    return n().beforeNavigateListener;
                }
                function s(e) {
                    a() && console.error("[Service Desk Frontend routing] beforeNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().beforeNavigateListener = e;
                }
                function c() {
                    delete n().beforeNavigateListener, r();
                }
                function l(e) {
                    var t = a();
                    return t ? t(e) : Promise.resolve();
                }
                function g() {
                    delete n().willNavigateListener, r();
                }
                function f() {
                    return n().willNavigateListener;
                }
                function d(e) {
                    f() && console.error("[Service Desk Frontend routing] willNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().willNavigateListener = e;
                }
                function y() {
                    var e = f();
                    if (!e) return void console.warn("[Service Desk Frontend routing] willNavigateListener is not defined. You should unmountComponentAtNode within a willNavigateListener. This is probably a memory leak.");
                    e();
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getFeRouteFunction = o, t.deleteFeRouteFunction = i, t.setFeRouteFunction = u, t.setBeforeNavigateListener = s, t.deleteBeforeNavigateListener = c, t.onBeforeNavigate = l, t.deleteWillNavigateListener = g, t.setWillNavigateListener = d, t.onWillNavigate = y;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeComponentRegistry = e.window._jsdFeComponentRegistry || {}, e.window._jsdFeComponentRegistry;
                }
                function r(e, t) {
                    n()[e] = t;
                }
                function o(e, t, n) {
                    return new Promise(function(r, o) {
                        a(e, t, n, i, r, o);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.registerFeComponent = r, t.renderFeComponentAsync = o;
                var i = 20, u = t.renderFeComponent = function(e, t, r) {
                    var o = n()[e];
                    if (o) return o(t, r);
                    throw new Error("FE component not found: '" + String(e) + "'");
                }, a = function e(t, n, r, o, i, a) {
                    try {
                        var s = u(t, n, r);
                        i(s);
                    } catch (u) {
                        o <= 0 ? a(u) : setTimeout(function() {
                            return e(t, n, r, o - 1, i, a);
                        }, 500);
                    }
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            function r(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return t.default = e, t;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Events = t.LegacyModuleRegistry = t.LegacyPageRegistry = t.ComponentRegistry = t.PageEnabler = t.RouterManager = void 0;
            var o = n(1), i = r(o), u = n(2), a = r(u), s = n(4), c = r(s), l = n(5), g = r(l), f = n(6), d = r(f), y = n(7), v = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(y);
            t.RouterManager = i, t.PageEnabler = v.default, t.ComponentRegistry = a, t.LegacyPageRegistry = c, t.LegacyModuleRegistry = d, t.Events = g;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n(e, t) {
                    var n = e && e.getPage && e.getPage(t);
                    return n ? n.controllerForJiraFrontend ? n && n.controllerForJiraFrontend() : Promise.reject("Page doesn't have a suitable controller method '" + t + "'") : Promise.reject("Trying to access a page that doesn't exist: '" + t + "'");
                }
                function r() {
                    return e._jsdLegacyAgentPageRegistry;
                }
                function o(t) {
                    e._jsdLegacyAgentPageRegistry = t;
                }
                function i(e) {
                    return n(r(), e);
                }
                function u() {
                    return e._jsdLegacySettingsPageRegistry;
                }
                function a(t) {
                    e._jsdLegacySettingsPageRegistry = t;
                }
                function s(e) {
                    var t = u();
                    return t ? n(t, e) : Promise.reject("Registry does not exist");
                }
                function c() {
                    e._jsdLegacyAgentPageRegistry = {}, e._jsdLegacySettingsPageRegistry = {};
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getGlobalLegacyAgentPageRegistry = r, t.registerLegacyAgentPageRegistry = o, t.runLegacyAgentPageController = i, t.getGlobalLegacySettingsPageRegistry = u, t.registerLegacySettingsPageRegistry = a, t.runLegacySettingsPageController = s, t.clearLegacyPageRegistries = c;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.__jsdLegacyEventBus = e.__jsdLegacyEventBus || {}, e.__jsdLegacyEventBus;
                }
                function r(e) {
                    return n()[e] || [];
                }
                function o(e, t) {
                    var o = n(), i = r(e);
                    i.push(t), o[e] = i;
                }
                function i(e, t) {
                    if (t) {
                        var o = n(), i = r(e);
                        o[e] = i.filter(function(e) {
                            return e !== t;
                        });
                    } else n()[e] = [];
                }
                function u(e, t) {
                    r(e).forEach(function(e) {
                        return e(t);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.on = o, t.off = i, t.trigger = u;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = t.getLegacyModuleRegistry = function() {
                    return e._jsdLegacyModuleRegistry = e._jsdLegacyModuleRegistry || {}, e._jsdLegacyModuleRegistry;
                };
                t.registerLegacyModule = function(e, t) {
                    n()[e] = t;
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function r(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function o(t) {
                    var n = new URL(e.window.location.href), r = n.href.slice(n.origin.length), o = new URL(t), i = o.href.slice(o.origin.length), u = n.hostname === o.hostname && r.startsWith(i) ? r.slice(i.length) : r;
                    return "/" === u[0] ? u : "/" + u;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = function() {
                    function e(e, t) {
                        for(var n = 0; n < t.length; n++){
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function(t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), u = n(1), a = n(2), s = function() {
                    function e() {
                        r(this, e);
                    }
                    return i(e, [
                        {
                            key: "enablePage",
                            value: function(e, t) {
                                (0, u.deleteFeRouteFunction)();
                                try {
                                    return (0, a.renderFeComponent)(e.feComponentId, t[0], {});
                                } catch (e) {
                                    return Promise.reject(e);
                                }
                            }
                        },
                        {
                            key: "updatePage",
                            value: function(e, t) {
                                var n = (0, u.getFeRouteFunction)();
                                if (t.feComponentId && n) n(o(e));
                                return Promise.resolve();
                            }
                        },
                        {
                            key: "disablePage",
                            value: function() {
                                (0, u.deleteFeRouteFunction)(), (0, u.deleteBeforeNavigateListener)(), (0, u.onWillNavigate)(), (0, u.deleteWillNavigateListener)();
                            }
                        },
                        {
                            key: "beforeNavigate",
                            value: function(e) {
                                return (0, u.onBeforeNavigate)(e);
                            }
                        }
                    ]), e;
                }();
                t.default = s;
            }).call(t, n(0));
        }
    ]);
});

});


parcelRegister("1UCHC", function(module, exports) {

$parcel$export(module.exports, "ExtraMiddlewareProvider", () => $a565536cdd7381bc$export$b1e1f11078a18473);
$parcel$export(module.exports, "withExtraMiddleware", () => $a565536cdd7381bc$export$a6e9f53935284a11);
/* eslint-disable max-classes-per-file */ 
var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
class $a565536cdd7381bc$export$b1e1f11078a18473 extends (0, $5uXOq.Component) {
    static{
        this.contextTypes = {
            extraMiddleware: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).array
        };
    }
    static{
        this.childContextTypes = {
            extraMiddleware: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).array
        };
    }
    getChildContext() {
        const extraMiddleware = this.props.extraMiddleware;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'. Caused by 3rd party lib
        const existingExtraMiddleware = this.context.extraMiddleware || [];
        return {
            extraMiddleware: [
                ...existingExtraMiddleware,
                ...extraMiddleware
            ]
        };
    }
    render() {
        return (0, $5uXOq.Children).only(this.props.children);
    }
}
const $a565536cdd7381bc$export$a6e9f53935284a11 = (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
    class ExtraMiddlewareConsumer extends (0, $5uXOq.Component) {
        static{
            this.contextTypes = {
                extraMiddleware: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).array
            };
        }
        render() {
            // @ts-expect-error - TS2339 - Property 'extraMiddleware' does not exist on type 'unknown'. Caused by 3rd party lib
            const { extraMiddleware: extraMiddleware } = this.context;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                extraMiddleware: extraMiddleware || [],
                ...this.props
            });
        }
    };

});

parcelRegister("aLLc7", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskErrorBoundary", () => $8803d19bf51a79cd$export$d999c9325a45f4cf);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $e9YVH = parcelRequire("e9YVH");
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $8803d19bf51a79cd$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $8803d19bf51a79cd$var$toErrorOrUndefined = (error)=>{
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return undefined;
};
class $8803d19bf51a79cd$export$d999c9325a45f4cf extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props), this.state = {
            hasError: false
        };
        this.triggerEvent = $8803d19bf51a79cd$var$triggerAnalyticsEvent(`${props.appName}`);
    }
    componentDidCatch(error) {
        const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
        const data = error instanceof Error ? {
            message: error.message,
            stack: error.stack
        } : {
            message: error
        };
        this.triggerEvent('error-boundary.error-caught', data);
        (0, $jcw0u.default)({
            meta: {
                id: 'unhandled',
                packageName: (0, $e9YVH.toPackageName)(appName) || 'jiraServicedeskCommon'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event: this.triggerEvent,
            error: $8803d19bf51a79cd$var$toErrorOrUndefined(error),
            sendToPrivacyUnsafeSplunk: true
        });
        // If error view is present then allow error view to handle errors.
        if (ErrorView) return;
        // Some of the non spa apps uses this call back function which doesn't have any error view
        if (onErrorHandler) onErrorHandler(error);
        else // Rethrow for error boundary handling by app-base
        throw error;
    }
    render() {
        const { hasError: hasError } = this.state;
        const { ErrorView: ErrorView, children: children } = this.props;
        if (hasError && ErrorView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorView, null);
        return children;
    }
}

});

parcelRegister("7Mk2n", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $c56b69c0c502b811$export$f51a9068ac82ea43);
parcelRequire("aBWgc");
var $dH5VL = parcelRequire("dH5VL");
var $lR075 = parcelRequire("lR075");

var $F2Mxm = parcelRequire("F2Mxm");

var $alviN = parcelRequire("alviN");
const $c56b69c0c502b811$var$combineMiddleWare = (extraMiddleware, history)=>{
    const middlewares = extraMiddleware.slice(0);
    if (history) middlewares.push((0, $lR075.default)(history));
    return middlewares;
};
const $c56b69c0c502b811$var$initStore = (storeName, initialState, rootReducer, extraMiddleware, rootEpic, history)=>{
    const middlewares = $c56b69c0c502b811$var$combineMiddleWare(extraMiddleware, history);
    return (0, $F2Mxm.default)({
        appName: storeName,
        initialState: initialState,
        rootReducer: rootReducer,
        rootEpic: rootEpic,
        middlewares: middlewares
    });
};
const $c56b69c0c502b811$export$f51a9068ac82ea43 = (storeName, initialState, rootReducer, extraMiddleware = [], rootEpic, history, basename)=>{
    const store = $c56b69c0c502b811$var$initStore(storeName, initialState, rootReducer, extraMiddleware, rootEpic, history);
    // Expose a route function to the JSD monolith, allowing its page-enabler
    // to manage routing.  We 'replace' the history here as JSD already
    // provides us with a history mechanism; avoids double-up.
    if (history) (0, $alviN.RouterManager).setFeRouteFunction((url)=>store.dispatch((0, $dH5VL.replace)(url.replace(basename || '', ''))));
    return store;
};

});
parcelRegister("aBWgc", function(module, exports) {

$parcel$export(module.exports, "ConnectedRouter", () => (parcelRequire("4CL8R")).default);
$parcel$export(module.exports, "routerReducer", () => (parcelRequire("4zerg")).routerReducer);
$parcel$export(module.exports, "push", () => (parcelRequire("dH5VL")).push);
$parcel$export(module.exports, "replace", () => (parcelRequire("dH5VL")).replace);
$parcel$export(module.exports, "routerMiddleware", () => (parcelRequire("lR075")).default);

var $4CL8R = parcelRequire("4CL8R");

var $jQMwH = parcelRequire("jQMwH");

var $4zerg = parcelRequire("4zerg");

var $dH5VL = parcelRequire("dH5VL");

var $lR075 = parcelRequire("lR075");

});
parcelRegister("4CL8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $35df477416201f6f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $12Lcw = parcelRequire("12Lcw");

var $4zerg = parcelRequire("4zerg");
function $35df477416201f6f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $35df477416201f6f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $35df477416201f6f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $35df477416201f6f$var$ConnectedRouter = function(_Component) {
    $35df477416201f6f$var$_inherits(ConnectedRouter, _Component);
    function ConnectedRouter() {
        var _temp, _this, _ret;
        $35df477416201f6f$var$_classCallCheck(this, ConnectedRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $35df477416201f6f$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.handleLocationChange = function(location) {
            _this.store.dispatch({
                type: (0, $4zerg.LOCATION_CHANGE),
                payload: location
            });
        }, _temp), $35df477416201f6f$var$_possibleConstructorReturn(_this, _ret);
    }
    ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
        var _props = this.props, propsStore = _props.store, history = _props.history, isSSR = _props.isSSR;
        this.store = propsStore || this.context.store;
        this.handleLocationChange(history.location);
        if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
    };
    ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
    };
    ConnectedRouter.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12Lcw.default), this.props);
    };
    return ConnectedRouter;
}((0, $5uXOq.Component));
$35df477416201f6f$var$ConnectedRouter.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object,
    history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node,
    isSSR: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool
};
$35df477416201f6f$var$ConnectedRouter.contextTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
var $35df477416201f6f$export$2e2bcd8739ae039 = $35df477416201f6f$var$ConnectedRouter;

});
parcelRegister("12Lcw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c2a978068c36407$export$2e2bcd8739ae039);

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $0c2a978068c36407$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $0c2a978068c36407$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0c2a978068c36407$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0c2a978068c36407$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $0c2a978068c36407$var$Router = function(_React$Component) {
    $0c2a978068c36407$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $0c2a978068c36407$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0c2a978068c36407$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $0c2a978068c36407$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $0c2a978068c36407$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$0c2a978068c36407$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node
};
$0c2a978068c36407$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
$0c2a978068c36407$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
};
var $0c2a978068c36407$export$2e2bcd8739ae039 = $0c2a978068c36407$var$Router;

});

parcelRegister("4zerg", function(module, exports) {

$parcel$export(module.exports, "LOCATION_CHANGE", () => $3535a18c22a23d18$export$be84bd1ba815d4c2);
$parcel$export(module.exports, "routerReducer", () => $3535a18c22a23d18$export$a6e30f0f4d30936a);
var $3535a18c22a23d18$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3535a18c22a23d18$export$be84bd1ba815d4c2 = '@@router/LOCATION_CHANGE';
var $3535a18c22a23d18$var$initialState = {
    location: null
};
function $3535a18c22a23d18$export$a6e30f0f4d30936a() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $3535a18c22a23d18$var$initialState;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type, payload = _ref.payload;
    if (type === $3535a18c22a23d18$export$be84bd1ba815d4c2) return $3535a18c22a23d18$var$_extends({}, state, {
        location: payload
    });
    return state;
}

});


parcelRegister("jQMwH", function(module, exports) {

var $70VoX = parcelRequire("70VoX");
var $e738840137bf1f47$export$e7fd20fad3cf4b5f = function getLocation(state) {
    return state.router.location;
};
var $e738840137bf1f47$export$a7b4d762fce9f62a = function createMatchSelector(path) {
    var lastPathname = null;
    var lastMatch = null;
    return function(state) {
        var _ref = $e738840137bf1f47$export$e7fd20fad3cf4b5f(state) || {}, pathname = _ref.pathname;
        if (pathname === lastPathname) return lastMatch;
        lastPathname = pathname;
        var match = (0, $70VoX.default)(pathname, path);
        if (!match || !lastMatch || match.url !== lastMatch.url) lastMatch = match;
        return lastMatch;
    };
};

});
parcelRegister("70VoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b50f39010f1f0a$export$2e2bcd8739ae039);

var $d4Ora = parcelRequire("d4Ora");
var $51b50f39010f1f0a$var$patternCache = {};
var $51b50f39010f1f0a$var$cacheLimit = 10000;
var $51b50f39010f1f0a$var$cacheCount = 0;
var $51b50f39010f1f0a$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $51b50f39010f1f0a$var$patternCache[cacheKey] || ($51b50f39010f1f0a$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($d4Ora)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($51b50f39010f1f0a$var$cacheCount < $51b50f39010f1f0a$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $51b50f39010f1f0a$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $51b50f39010f1f0a$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $51b50f39010f1f0a$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $51b50f39010f1f0a$export$2e2bcd8739ae039 = $51b50f39010f1f0a$var$matchPath;

});
parcelRegister("d4Ora", function(module, exports) {

var $oJ7gO = parcelRequire("oJ7gO");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $9852c5da38ba91d1$var$pathToRegexp;
module.exports.parse = $9852c5da38ba91d1$var$parse;
module.exports.compile = $9852c5da38ba91d1$var$compile;
module.exports.tokensToFunction = $9852c5da38ba91d1$var$tokensToFunction;
module.exports.tokensToRegExp = $9852c5da38ba91d1$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $9852c5da38ba91d1$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $9852c5da38ba91d1$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $9852c5da38ba91d1$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $9852c5da38ba91d1$var$escapeGroup(pattern) : asterisk ? '.*' : $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + ']+?';
    return $9852c5da38ba91d1$var$escapeString(prevText) + '|(?:(?!' + $9852c5da38ba91d1$var$escapeString(prevText) + ')[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $9852c5da38ba91d1$var$compile(str, options) {
    return $9852c5da38ba91d1$var$tokensToFunction($9852c5da38ba91d1$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $9852c5da38ba91d1$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $9852c5da38ba91d1$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $9852c5da38ba91d1$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($oJ7gO(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $9852c5da38ba91d1$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $9852c5da38ba91d1$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $9852c5da38ba91d1$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($9852c5da38ba91d1$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $9852c5da38ba91d1$var$flags(options));
    return $9852c5da38ba91d1$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$stringToRegexp(path, keys, options) {
    return $9852c5da38ba91d1$var$tokensToRegExp($9852c5da38ba91d1$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$tokensToRegExp(tokens, keys, options) {
    if (!$oJ7gO(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $9852c5da38ba91d1$var$escapeString(token);
        else {
            var prefix = $9852c5da38ba91d1$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $9852c5da38ba91d1$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $9852c5da38ba91d1$var$attachKeys(new RegExp('^' + route, $9852c5da38ba91d1$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$pathToRegexp(path, keys, options) {
    if (!$oJ7gO(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $9852c5da38ba91d1$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($oJ7gO(path)) return $9852c5da38ba91d1$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $9852c5da38ba91d1$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("oJ7gO", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});




parcelRegister("dH5VL", function(module, exports) {

$parcel$export(module.exports, "CALL_HISTORY_METHOD", () => $9f83e43ef24f87be$export$d035cdafa5d37a89);
$parcel$export(module.exports, "push", () => $9f83e43ef24f87be$export$4cbf152802aa238);
$parcel$export(module.exports, "replace", () => $9f83e43ef24f87be$export$77ad94ebf1c2b9ed);
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */ var $9f83e43ef24f87be$export$d035cdafa5d37a89 = '@@router/CALL_HISTORY_METHOD';
function $9f83e43ef24f87be$var$updateLocation(method) {
    return function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return {
            type: $9f83e43ef24f87be$export$d035cdafa5d37a89,
            payload: {
                method: method,
                args: args
            }
        };
    };
}
var $9f83e43ef24f87be$export$4cbf152802aa238 = $9f83e43ef24f87be$var$updateLocation('push');
var $9f83e43ef24f87be$export$77ad94ebf1c2b9ed = $9f83e43ef24f87be$var$updateLocation('replace');
var $9f83e43ef24f87be$export$93bb224d05b3906d = $9f83e43ef24f87be$var$updateLocation('go');
var $9f83e43ef24f87be$export$28fca2ccfd38b8f = $9f83e43ef24f87be$var$updateLocation('goBack');
var $9f83e43ef24f87be$export$994d0e87e52ba8e3 = $9f83e43ef24f87be$var$updateLocation('goForward');
var $9f83e43ef24f87be$export$95755023e698c378 = {
    push: $9f83e43ef24f87be$export$4cbf152802aa238,
    replace: $9f83e43ef24f87be$export$77ad94ebf1c2b9ed,
    go: $9f83e43ef24f87be$export$93bb224d05b3906d,
    goBack: $9f83e43ef24f87be$export$28fca2ccfd38b8f,
    goForward: $9f83e43ef24f87be$export$994d0e87e52ba8e3
};

});

parcelRegister("lR075", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8ea2bb01ae7205$export$2e2bcd8739ae039);

var $dH5VL = parcelRequire("dH5VL");
function $fe8ea2bb01ae7205$export$2e2bcd8739ae039(history) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type !== (0, $dH5VL.CALL_HISTORY_METHOD)) return next(action);
                var _action$payload = action.payload, method = _action$payload.method, args = _action$payload.args;
                history[method].apply(history, args);
            };
        };
    };
}

});




parcelRegister("6z7Gx", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $c0766aa675d05766$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $c0766aa675d05766$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $c0766aa675d05766$export$ebdbd98df5a27905);

var $jcw0u = parcelRequire("jcw0u");

var $a7EYT = parcelRequire("a7EYT");
const $c0766aa675d05766$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $c0766aa675d05766$export$cca3c4e11cb0a5ce = 1000;
const $c0766aa675d05766$export$dc391c7d81907d3a = 4000;
const $c0766aa675d05766$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $a7EYT.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $jcw0u.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $jcw0u.trackFetchErrors)(payload);
};

});
parcelRegister("a7EYT", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $99def0fa5fc488a1$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $99def0fa5fc488a1$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $99def0fa5fc488a1$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $99def0fa5fc488a1$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $99def0fa5fc488a1$export$8ef51cba9d28f819);

var $gccSB = parcelRequire("gccSB");

var $cjFoH = parcelRequire("cjFoH");

var $5HnTq = parcelRequire("5HnTq");


var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY = 'validation.error';
class $99def0fa5fc488a1$export$fee0012ae6cb3438 extends (0, $jJZqs.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(response)) this.response = response;
    }
}
const $99def0fa5fc488a1$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $99def0fa5fc488a1$var$putOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PUT'
};
const $99def0fa5fc488a1$var$postOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'POST'
};
const $99def0fa5fc488a1$var$deleteOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'DELETE'
};
const $99def0fa5fc488a1$var$patchOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PATCH'
};
const $99def0fa5fc488a1$var$processResponse = async (response)=>{
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY) throw (0, $eusud.transformValidationErrorFromServer)(jsonResponse);
        const message = $99def0fa5fc488a1$var$transformMessageErrorsFromServer(errors);
        throw new $99def0fa5fc488a1$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $99def0fa5fc488a1$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$putOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$postOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$deleteOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$patchOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);

});


parcelRegister("dsVYa", function(module, exports) {

$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM", () => $570185105586d012$export$ca06930325b64075);
$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV", () => $570185105586d012$export$bdaa4b82186a5b44);
$parcel$export(module.exports, "BLANK_PROJECT_TEMPLATES", () => $570185105586d012$export$26b62c0869751109);
const $570185105586d012$export$ca06930325b64075 = 'showProjectBuilder';
const $570185105586d012$export$bdaa4b82186a5b44 = 'showProjectBuilderDev';
const $570185105586d012$export$26b62c0869751109 = [
    'com.atlassian.servicedesk:simplified-blank-project-it',
    'com.atlassian.servicedesk:simplified-blank-project-business',
    'com.atlassian.servicedesk:company-managed-blank-service-project',
    'com.atlassian.servicedesk:team-managed-blank-service-project'
];

});

parcelRegister("4o3DF", function(module, exports) {

$parcel$export(module.exports, "QueuesErrorView", () => $3fbe3684de2c7574$export$456ee24992efc4a0);

var $5uXOq = parcelRequire("5uXOq");

var $eae50 = parcelRequire("eae50");

var $8RXs9 = parcelRequire("8RXs9");

var $81S1w = parcelRequire("81S1w");
const $3fbe3684de2c7574$var$onReloadWindow = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.reload();
};
function $3fbe3684de2c7574$var$Error(props) {
    const { onRetry: onRetry, intl: intl, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        // @ts-expect-error - TS2322 - Type '{ intl: IntlShapeV2; onRetry: (() => void) | undefined; header: string; description: string; retryMessage: MessageDescriptorV2; }' is not assignable to type 'IntrinsicAttributes & Omit<Pick<Props, "description" | "intl" | "onRetry" | "imageWidth" | "maxImageHeight" | "errorImage"> & Partial<Pick<Props, "header" | ... 3 more ... | "isSubtle">> & Partial<...>, "intl"> & { ...; } & { ...; }'. Caused by 2nd party lib
        intl: intl,
        onRetry: onRetry,
        header: formatMessage((0, $81S1w.default).errorHeader),
        description: formatMessage((0, $81S1w.default).errorMessage),
        retryMessage: (0, $81S1w.default).retry
    });
}
$3fbe3684de2c7574$var$Error.defaultProps = {
    onRetry: $3fbe3684de2c7574$var$onReloadWindow
};
const $3fbe3684de2c7574$export$456ee24992efc4a0 = (0, $8RXs9.default)($3fbe3684de2c7574$var$Error);

});
parcelRegister("81S1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b7fe1a9d24f2d20$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2b7fe1a9d24f2d20$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.error-header",
        "defaultMessage": "We couldn't load your queue"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.error-message",
        "defaultMessage": "Check your network connection, then try loading the queue again."
    },
    retry: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.retry",
        "defaultMessage": "Reload queue"
    }
});

});


parcelRegister("c2C16", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f234758e26ef5d$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $9vBS6 = parcelRequire("9vBS6");

var $itxRv = parcelRequire("itxRv");

var $8yjBN = parcelRequire("8yjBN");

var $b8EV7 = parcelRequire("b8EV7");

var $85gkX = parcelRequire("85gkX");

var $t5Eel = parcelRequire("t5Eel");

var $lSxyZ = parcelRequire("lSxyZ");

var $5KPhz = parcelRequire("5KPhz");

var $88Pxd = parcelRequire("88Pxd");

var $7DIsy = parcelRequire("7DIsy");

var $eNiyn = parcelRequire("eNiyn");

var $e8LE2 = parcelRequire("e8LE2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31f234758e26ef5d$export$2e2bcd8739ae039 = (push)=>{
    const epic = (0, $e1AU2.combineEpics)((0, $5KPhz.default)(push), (0, $b8EV7.default)(push), (0, $t5Eel.default), (0, $lSxyZ.default)(), (0, $4R6GH.fg)('migrate_sorting_to_user_property') ? (0, $eNiyn.sortEpicNew) : (0, $eNiyn.default), // @ts-expect-error - No overload matches this call.
    (0, $85gkX.default), (0, $88Pxd.default), (0, $7DIsy.default), (0, $e8LE2.default), (0, $8yjBN.default));
    return (action$, store)=>// @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type. | TS7006 - Parameter 'stream' implicitly has an 'any' type.
        epic((0, $itxRv.withUnpackedBatchActions)(action$), store).catch((error, stream)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'agentViewOps',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                error: new Error(error)
            });
            (0, $9vBS6.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops', `Unhandled error: ${error}`);
            return stream;
        });
};

});
parcelRegister("itxRv", function(module, exports) {

$parcel$export(module.exports, "withUnpackedBatchActions", () => $0ed3d4a06836091f$export$25f000f90e13af6b);

var $aB8eX = parcelRequire("aB8eX");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");
const $0ed3d4a06836091f$export$25f000f90e13af6b = (action$)=>action$.mergeMap((action)=>{
        if (action.type === (0, $aB8eX.BATCH)) return (0, $kVLXA.Observable).of(...action.payload);
        return (0, $kVLXA.Observable).of(action);
    });

});

parcelRegister("8yjBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9dc97a7836daa38$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");


var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c9dc97a7836daa38$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $fnQyW.FILTER_QUERY_SUBMITTED)).switchMap((action)=>{
        const source = action.payload.filterQuery === null || action.payload.filterQuery === '' ? (0, $36dd7e3255fc2bff$export$347de2d26274ffda) : (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a);
        return (0, $kVLXA.Observable).of((0, $fnQyW.filterQueryChangedAction)(action.payload.filterQuery), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $bzBCj.loadIssuesAction)(0, source));
    });

});
const $36dd7e3255fc2bff$export$f162a928a40c7ab8 = 'PAGE';
const $36dd7e3255fc2bff$export$3de6d8bdd297654b = 'VIEW';
const $36dd7e3255fc2bff$export$fa4dae241333de34 = 'POLL';
const $36dd7e3255fc2bff$export$d4d94a8c13e2df1d = 'SCROLL';
const $36dd7e3255fc2bff$export$2003e3fdddd4c35b = 'SORT';
const $36dd7e3255fc2bff$export$347de2d26274ffda = 'FORCE_UPDATE';
const $36dd7e3255fc2bff$export$be4c1ea173a5271a = 'FILTER';
const $36dd7e3255fc2bff$export$217a2381e50d4bff = 'SIDEBAR';
const $36dd7e3255fc2bff$export$b5ad9376033e98b2 = 'UP';
const $36dd7e3255fc2bff$export$28a694fb106a7f62 = 'DOWN';
const $36dd7e3255fc2bff$export$57022ca1771ad970 = 'UNCHANGED';

parcelRegister("fnQyW", function(module, exports) {

$parcel$export(module.exports, "FILTER_QUERY_CHANGED", () => $58c7c583556a55ce$export$9e0f2488271e98d0);
$parcel$export(module.exports, "filterQueryChangedAction", () => $58c7c583556a55ce$export$5fa47224179ff864);
$parcel$export(module.exports, "FILTER_QUERY_SUBMITTED", () => $58c7c583556a55ce$export$6a1c1f3d64af9a47);
$parcel$export(module.exports, "filterQuerySubmittedAction", () => $58c7c583556a55ce$export$d1c2b6692ed10481);
$parcel$export(module.exports, "IS_NEW_FILTER_QUERY_PENDING", () => $58c7c583556a55ce$export$8a6c9cbc89786426);
$parcel$export(module.exports, "isNewFilterQueryPendingAction", () => $58c7c583556a55ce$export$ea018c090643753b);
$parcel$export(module.exports, "IS_FILTER_FOCUSED", () => $58c7c583556a55ce$export$ec8ded223992d792);
$parcel$export(module.exports, "isFilterFocusedAction", () => $58c7c583556a55ce$export$6fd90bc7d8a253ba);
$parcel$export(module.exports, "IS_FILTER_FAILED", () => $58c7c583556a55ce$export$963953e34e913763);
$parcel$export(module.exports, "filterBadQueryAction", () => $58c7c583556a55ce$export$d0b1a5137ee88e41);
// FILTER_QUERY_CHANGED
const $58c7c583556a55ce$export$9e0f2488271e98d0 = 'state.actions.filter.FILTER_QUERY_CHANGED';
const $58c7c583556a55ce$export$5fa47224179ff864 = (filterQuery)=>({
        type: $58c7c583556a55ce$export$9e0f2488271e98d0,
        payload: {
            filterQuery: filterQuery
        }
    });
const $58c7c583556a55ce$export$6a1c1f3d64af9a47 = 'state.actions.filter.FILTER_QUERY_SUBMITTED';
const $58c7c583556a55ce$export$d1c2b6692ed10481 = (filterQuery)=>({
        type: $58c7c583556a55ce$export$6a1c1f3d64af9a47,
        payload: {
            filterQuery: filterQuery
        }
    });
const $58c7c583556a55ce$export$8a6c9cbc89786426 = 'state.actions.filter.IS_NEW_FILTER_QUERY_PENDING';
const $58c7c583556a55ce$export$ea018c090643753b = (isNewFilterQueryPending)=>({
        type: $58c7c583556a55ce$export$8a6c9cbc89786426,
        payload: {
            isNewFilterQueryPending: isNewFilterQueryPending
        }
    });
const $58c7c583556a55ce$export$ec8ded223992d792 = 'state.actions.filter.IS_FILTER_FOCUSED';
const $58c7c583556a55ce$export$6fd90bc7d8a253ba = (isFilterFocused)=>({
        type: $58c7c583556a55ce$export$ec8ded223992d792,
        payload: {
            isFilterFocused: isFilterFocused
        }
    });
const $58c7c583556a55ce$export$963953e34e913763 = 'state.actions.filter.IS_FILTER_FAILED';
const $58c7c583556a55ce$export$d0b1a5137ee88e41 = (isNewFilterQueryPending)=>({
        type: $58c7c583556a55ce$export$963953e34e913763,
        payload: {
            isNewFilterQueryPending: isNewFilterQueryPending
        }
    });

});

parcelRegister("bzBCj", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE", () => $fcdf827824d50cf1$export$1e8a1b726c043d27);
$parcel$export(module.exports, "openIssueAction", () => $fcdf827824d50cf1$export$d5542de2015b0d5f);
$parcel$export(module.exports, "LOAD_ISSUES", () => $fcdf827824d50cf1$export$447a39ee503b31ea);
$parcel$export(module.exports, "loadIssuesAction", () => $fcdf827824d50cf1$export$3eef863aa89b92c2);
$parcel$export(module.exports, "loadIssuesActionForPage", () => $fcdf827824d50cf1$export$34fd96b3e33e0d2d);
$parcel$export(module.exports, "LOAD_ISSUES_INTERNAL", () => $fcdf827824d50cf1$export$e13e56ae077f63d6);
$parcel$export(module.exports, "loadIssuesInternalAction", () => $fcdf827824d50cf1$export$71ac868813e1a9ac);
$parcel$export(module.exports, "LOAD_ISSUES_SUCCESS", () => $fcdf827824d50cf1$export$5a92ff25027c7f22);
$parcel$export(module.exports, "loadIssuesSuccessAction", () => $fcdf827824d50cf1$export$c552dcd13b2a0c6b);
$parcel$export(module.exports, "LOAD_ISSUES_FAILURE", () => $fcdf827824d50cf1$export$e91cdeca4d2aea23);
$parcel$export(module.exports, "loadIssuesFailureAction", () => $fcdf827824d50cf1$export$6b830be58d650030);


var $2nYuf = parcelRequire("2nYuf");

const $fcdf827824d50cf1$export$1e8a1b726c043d27 = 'state.actions.issue.OPEN_ISSUE';
const $fcdf827824d50cf1$export$d5542de2015b0d5f = ()=>({
        type: $fcdf827824d50cf1$export$1e8a1b726c043d27
    });
const $fcdf827824d50cf1$export$447a39ee503b31ea = 'state.actions.issue.LOAD_ISSUES';
const $fcdf827824d50cf1$export$3eef863aa89b92c2 = (startIndex, source, bypassCache = false, batchSize = (0, $2nYuf.FETCH_BATCH_SIZE))=>{
    const endIndex = startIndex + batchSize - 1;
    return {
        type: $fcdf827824d50cf1$export$447a39ee503b31ea,
        payload: {
            startIndex: startIndex,
            endIndex: endIndex,
            source: source,
            bypassCache: bypassCache
        }
    };
};
const $fcdf827824d50cf1$export$34fd96b3e33e0d2d = (currentPage)=>{
    const startIndex = (currentPage - 1) * (0, $0750463259e12908$export$f88f58d1a4b2078b);
    return $fcdf827824d50cf1$export$3eef863aa89b92c2(startIndex, (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8));
};
const $fcdf827824d50cf1$export$e13e56ae077f63d6 = 'state.actions.issue.LOAD_ISSUES_INTERNAL';
const $fcdf827824d50cf1$export$71ac868813e1a9ac = (startIndex, endIndex, source, bypassCache = false)=>({
        type: $fcdf827824d50cf1$export$e13e56ae077f63d6,
        payload: {
            startIndex: startIndex,
            endIndex: endIndex,
            source: source,
            bypassCache: bypassCache
        }
    });
const $fcdf827824d50cf1$export$5a92ff25027c7f22 = 'state.actions.issue.LOAD_ISSUES_SUCCESS';
const $fcdf827824d50cf1$export$c552dcd13b2a0c6b = (loadedIssuesResponse, queueId, startIndex, source)=>({
        type: $fcdf827824d50cf1$export$5a92ff25027c7f22,
        payload: {
            loadedIssuesResponse: loadedIssuesResponse,
            queueId: queueId,
            startIndex: startIndex,
            source: source
        }
    });
const $fcdf827824d50cf1$export$e91cdeca4d2aea23 = 'state.actions.issue.LOAD_ISSUES_FAILURE';
const $fcdf827824d50cf1$export$6b830be58d650030 = (source, error, statusCode, isQueueEmpty, traceId)=>({
        type: $fcdf827824d50cf1$export$e91cdeca4d2aea23,
        payload: {
            source: source,
            error: error,
            statusCode: statusCode,
            isQueueEmpty: isQueueEmpty,
            traceId: traceId
        }
    });

});
/**
 * Default Props for Table component
 */ const $0750463259e12908$export$258441c8a79bb589 = 40;
const $0750463259e12908$export$80fc56c6cdbfffed = true;
const $0750463259e12908$export$6fd8e343a23be522 = false;
const $0750463259e12908$export$f88f58d1a4b2078b = 10000;
const $0750463259e12908$export$ad4eb70d85e8e21f = 100;



parcelRegister("b8EV7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf764903d3172fd1$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $2Yq8S = parcelRequire("2Yq8S");

var $2n4yA = parcelRequire("2n4yA");

var $1HXBO = parcelRequire("1HXBO");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf764903d3172fd1$export$2e2bcd8739ae039 = (push)=>(0, $e1AU2.combineEpics)((0, $2n4yA.default), (0, $2Yq8S.default), (0, $1HXBO.default)(push));

});
parcelRegister("2Yq8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3b54c2e9b6529a$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $bzBCj = parcelRequire("bzBCj");

var $iIQpG = parcelRequire("iIQpG");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$be3b54c2e9b6529a$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $bzBCj.LOAD_ISSUES)).mergeMap((action)=>(0, $kVLXA.Observable).of((0, $iIQpG.stopPollAction)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $bzBCj.loadIssuesInternalAction)(action.payload.startIndex, action.payload.endIndex, // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
        action.payload.source, action.payload.bypassCache)));

});
parcelRegister("iIQpG", function(module, exports) {

$parcel$export(module.exports, "STOP_POLL", () => $cf5c1f5f9ede8273$export$beabbea0833100ca);
$parcel$export(module.exports, "stopPollAction", () => $cf5c1f5f9ede8273$export$2b79fcb148191d1);
$parcel$export(module.exports, "RESTART_POLL", () => $cf5c1f5f9ede8273$export$ea1ead92e01d02d1);
$parcel$export(module.exports, "restartPollAction", () => $cf5c1f5f9ede8273$export$ef03a991480cfcdf);
$parcel$export(module.exports, "POLL_SUCCESS", () => $cf5c1f5f9ede8273$export$270005d7201abd12);
$parcel$export(module.exports, "pollSuccessAction", () => $cf5c1f5f9ede8273$export$77220b17516f6c17);
$parcel$export(module.exports, "pollContentNotModifiedAction", () => $cf5c1f5f9ede8273$export$5dda10bc6b4052b9);
$parcel$export(module.exports, "POLL_FAILURE", () => $cf5c1f5f9ede8273$export$8cce70f9c508c33);
$parcel$export(module.exports, "pollFailureAction", () => $cf5c1f5f9ede8273$export$b98aa82aec1f8949);
$parcel$export(module.exports, "RESET_PROJECT_STATE_HASH", () => $cf5c1f5f9ede8273$export$22d4fc20a9bcbb3c);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_POLL_WARNING", () => $cf5c1f5f9ede8273$export$e03796746e3f4a62);
$parcel$export(module.exports, "displayUnsuccessfulPollWarningAction", () => $cf5c1f5f9ede8273$export$9bb3518e0ef04f1a);
$parcel$export(module.exports, "DISMISS_ALL_FLAGS", () => $cf5c1f5f9ede8273$export$8dde630a1a89a61d);
$parcel$export(module.exports, "dismissAllFlagsAction", () => $cf5c1f5f9ede8273$export$3a102aa35c9fa2b1);
$parcel$export(module.exports, "DISMISS_WARNING_FLAG", () => $cf5c1f5f9ede8273$export$ae3da4b73c471af0);
$parcel$export(module.exports, "dismissWarningFlagAction", () => $cf5c1f5f9ede8273$export$6902f66f812ce9cd);
// STOP_POLL
const $cf5c1f5f9ede8273$export$beabbea0833100ca = 'state.actions.update-metadata.STOP_POLL';
const $cf5c1f5f9ede8273$export$2b79fcb148191d1 = ()=>({
        type: $cf5c1f5f9ede8273$export$beabbea0833100ca
    });
const $cf5c1f5f9ede8273$export$ea1ead92e01d02d1 = 'state.actions.update-metadata.RESTART_POLL';
const $cf5c1f5f9ede8273$export$ef03a991480cfcdf = (skipInitialDelay = false)=>({
        type: $cf5c1f5f9ede8273$export$ea1ead92e01d02d1,
        payload: {
            skipInitialDelay: skipInitialDelay
        }
    });
const $cf5c1f5f9ede8273$export$270005d7201abd12 = 'state.actions.update-metadata.POLL_SUCCESS';
const $cf5c1f5f9ede8273$export$77220b17516f6c17 = (projectStateHash)=>({
        type: $cf5c1f5f9ede8273$export$270005d7201abd12,
        payload: {
            projectStateHash: projectStateHash
        }
    });
const $cf5c1f5f9ede8273$export$307cef20083545bd = 'state.actions.update-metadata.POLL_CONTENT_NOT_MODIFIED';
const $cf5c1f5f9ede8273$export$5dda10bc6b4052b9 = ()=>({
        type: $cf5c1f5f9ede8273$export$307cef20083545bd
    });
const $cf5c1f5f9ede8273$export$8cce70f9c508c33 = 'state.actions.update-metadata.POLL_FAILURE';
const $cf5c1f5f9ede8273$export$b98aa82aec1f8949 = ()=>({
        type: $cf5c1f5f9ede8273$export$8cce70f9c508c33
    });
const $cf5c1f5f9ede8273$export$22d4fc20a9bcbb3c = 'state.actions.update-metadata.RESET_PROJECT_STATE_HASH';
const $cf5c1f5f9ede8273$export$b3d5f4d178d2f21e = ()=>({
        type: $cf5c1f5f9ede8273$export$22d4fc20a9bcbb3c
    });
const $cf5c1f5f9ede8273$export$e03796746e3f4a62 = 'state.actions.update-metadata.DISPLAY_UNSUCCESSFUL_POLL_WARNING';
const $cf5c1f5f9ede8273$export$9bb3518e0ef04f1a = ()=>({
        type: $cf5c1f5f9ede8273$export$e03796746e3f4a62
    });
const $cf5c1f5f9ede8273$export$8dde630a1a89a61d = 'state.actions.update-metadata.DISMISS_ALL_FLAGS';
const $cf5c1f5f9ede8273$export$3a102aa35c9fa2b1 = ()=>({
        type: $cf5c1f5f9ede8273$export$8dde630a1a89a61d
    });
const $cf5c1f5f9ede8273$export$ae3da4b73c471af0 = 'state.actions.update-metadata.DISMISS_WARNING_FLAG';
const $cf5c1f5f9ede8273$export$6902f66f812ce9cd = ()=>({
        type: $cf5c1f5f9ede8273$export$ae3da4b73c471af0
    });

});


parcelRegister("2n4yA", function(module, exports) {

$parcel$export(module.exports, "default", () => $61cd97cc38106435$export$2e2bcd8739ae039);

var $aB8eX = parcelRequire("aB8eX");

var $1sWm7 = parcelRequire("1sWm7");

var $kVLXA = parcelRequire("kVLXA");

var $gg6CF = parcelRequire("gg6CF");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");
parcelRequire("fp4O3");

var $gUj6U = parcelRequire("gUj6U");


var $aOIyt = parcelRequire("aOIyt");

var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");

var $jdGLR = parcelRequire("jdGLR");

var $iIQpG = parcelRequire("iIQpG");

var $7pcZu = parcelRequire("7pcZu");

var $hYrcT = parcelRequire("hYrcT");

var $lHf6h = parcelRequire("lHf6h");

var $627A7 = parcelRequire("627A7");

var $7uXM1 = parcelRequire("7uXM1");
const $61cd97cc38106435$var$MAX_TOTAL_COUNT_DIFF = 30;
const $61cd97cc38106435$var$getManualSortFromIssueListResult = (columns, isUsingDefaultSorting)=>{
    const manualSortingColumn = isUsingDefaultSorting ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(columns, (column)=>column.currentSorting != null);
    // @ts-expect-error - TS2322 - Type '{ sortedBy: string; sortOrder: SortOrder | undefined; } | undefined' is not assignable to type 'ManualSorting | undefined'.
    return manualSortingColumn ? {
        sortedBy: manualSortingColumn.id,
        sortOrder: manualSortingColumn.currentSorting
    } : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61cd97cc38106435$export$2e2bcd8739ae039 = (action$, store)=>(0, $gUj6U.withConcurrencyLimiting)(action$.ofType((0, $bzBCj.LOAD_ISSUES_INTERNAL)), 3, (action)=>{
        const state = store.getState();
        const queueId = (0, $627A7.getQueueId)(state);
        const shouldFireGenericErrorAnalytics = (error)=>{
            if ((0, $jcw0u.getStatusCodeGroup)(new (0, $jJZqs.default)(error.statusCode)) === 'unknown' || (0, $fZneA.isClientFetchError)(error)) return false;
            return true;
        };
        const sendGenericErrorAnalytics = (error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'jsmIssueListLoading',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: new (0, $jJZqs.default)(error.statusCode),
                attributes: {
                    reasonKey: error.response.reasonKey,
                    reasonCode: error.response.reasonCode
                }
            });
        };
        const sendGenericErrorAnalyticsConditionally = (error)=>{
            if (shouldFireGenericErrorAnalytics(error)) sendGenericErrorAnalytics(error);
        };
        const sendSearchErrorAnalytics = (error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'jsmIssueListLoadingFilter',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: new (0, $jJZqs.default)(error.statusCode),
                attributes: {
                    hasPassed: false
                }
            });
        };
        const shouldFireSearchErrorAnalytics = (error)=>{
            const statusCodeGroup = (0, $jcw0u.getStatusCodeGroup)(new (0, $jJZqs.default)(error.statusCode));
            return action.payload.source === (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a) && (statusCodeGroup === '5xx' || statusCodeGroup === '4xx') && !(0, $fZneA.isClientFetchError)(error);
        };
        const sendErrorAnalytics = (error)=>{
            if (shouldFireSearchErrorAnalytics(error)) sendSearchErrorAnalytics(error);
            sendGenericErrorAnalyticsConditionally(error);
        };
        const isUpdate = [
            (0, $36dd7e3255fc2bff$export$fa4dae241333de34),
            (0, $36dd7e3255fc2bff$export$3de6d8bdd297654b)
        ].includes(// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
        action.payload.source);
        const isQueueFiltering = action.payload.source === (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a);
        const isPageLoad = action.payload.source === (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8);
        const isInitialLoad = (0, $7uXM1.getIsInitialLoad)(state);
        const dispatchRestartPollActionWhenAppIdleInInitialLoad = ()=>{
            // only run this in initial load
            if (isPageLoad && action.payload.startIndex === 0 && !isUpdate && !isQueueFiltering && isInitialLoad) (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
                // @ts-expect-error - TS2345 - Argument of type 'RestartPollAction' is not assignable to parameter of type 'State'. Type 'RestartPollAction' is missing the following properties from type 'State': appProps, ui, persisted
                store.dispatch((0, $iIQpG.restartPollAction)(true));
            });
        };
        // @ts-expect-error - TS2345 - rgument of type 'UnsetIsInitialLoad' is not assignable to parameter of type 'State'. Type 'UnsetIsInitialLoad' is missing the following properties from type 'State': appProps, ui, persisted
        const dispatchUnsetIsInitialLoadAction = ()=>store.dispatch((0, $7pcZu.unsetIsInitialLoad)());
        return (0, $aOIyt.default)(action.payload.startIndex, action.payload.endIndex, isUpdate, action.payload.source === (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8), action.payload.bypassCache, state, action.payload.source === (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a), dispatchUnsetIsInitialLoadAction, action.payload.source === (0, $36dd7e3255fc2bff$export$2003e3fdddd4c35b)).flatMap((result)=>{
            // dispatch only in initial load
            // running the blow will start the first poll as soon as TTAI finishes.
            if ((0, $4R6GH.fg)('issuelist_skip_fetch_cache_hit')) dispatchRestartPollActionWhenAppIdleInInitialLoad();
            if (isUpdate && result.totalCount - state.persisted.issues.totalCount > $61cd97cc38106435$var$MAX_TOTAL_COUNT_DIFF && (0, $4R6GH.fg)('issue_list_total_counts_mismatch')) // we're temporarily logging mismatches between total count from /issuelist (JSIS) and /issuelist/updated (JVIS) to look for any bugs
            (0, $jcw0u.default)({
                meta: {
                    id: 'jsmIssueListTotalCountMismatch',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: new Error('total count big mismatch'),
                attributes: {
                    diff: result.totalCount - state.persisted.issues.totalCount
                },
                skipSentry: true
            });
            const actions = [
                (0, $iIQpG.restartPollAction)(),
                (0, $bzBCj.loadIssuesSuccessAction)(result, queueId, action.payload.startIndex, action.payload.source)
            ];
            const sortingMigrationExcludedSources = [
                (0, $36dd7e3255fc2bff$export$fa4dae241333de34),
                (0, $36dd7e3255fc2bff$export$d4d94a8c13e2df1d),
                (0, $36dd7e3255fc2bff$export$2003e3fdddd4c35b),
                (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a)
            ];
            const shouldMigrateSorting = !sortingMigrationExcludedSources.includes(action.payload.source);
            const manualSort = $61cd97cc38106435$var$getManualSortFromIssueListResult(result.columns, result.isUsingDefaultSorting);
            if (shouldMigrateSorting && manualSort && !(0, $4R6GH.fg)('clean_local_storage_sorting') && (0, $4R6GH.fg)('migrate_sorting_to_user_property')) actions.push(// @ts-expect-error - TS2322
            (0, $jdGLR.updateSortingInfoInUserPropertyAction)(manualSort.sortedBy, manualSort.sortOrder));
            if (isInitialLoad && manualSort && (0, $4R6GH.fg)('clean_local_storage_sorting')) // @ts-expect-error - TS2322
            actions.push((0, $jdGLR.sortOrderOnLoadAction)(manualSort.sortedBy, manualSort.sortOrder));
            return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(actions));
        })// @ts-expect-error - TS2345 - Argument of type '(error: ErrorResponse) => Observable<BatchAction> | Observable<RestartPollAction>' is not assignable to parameter of type '(err: any, caught: Observable<BatchAction>) => ObservableInput<BatchAction>'.
        .catch((error)=>{
            if (error.statusCode === 304) return (0, $kVLXA.Observable).of((0, $iIQpG.restartPollAction)());
            if (// Bad query request
            error.statusCode === 400 && action.payload.source === (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a)) {
                const isNewFilterQueryPendingAction = (0, $hYrcT.getIsNewFilterQueryPending)(state);
                return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                    (0, $iIQpG.restartPollAction)(),
                    (0, $fnQyW.filterBadQueryAction)(isNewFilterQueryPendingAction)
                ]));
            }
            sendErrorAnalytics(error);
            return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                (0, $iIQpG.restartPollAction)(),
                (0, $bzBCj.loadIssuesFailureAction)(action.payload.source, error.response, error.statusCode, (0, $lHf6h.getIssueCacheSize)(state) === 0, error.traceId)
            ]));
        });
    });

});
parcelRegister("gUj6U", function(module, exports) {

$parcel$export(module.exports, "withConcurrencyLimiting", () => $0169828d93a4e745$export$1c063aa9514214db);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("bNfbF");
parcelRequire("c66Ur");
parcelRequire("64ZAE");
parcelRequire("1oQta");
parcelRequire("fPS7b");
parcelRequire("6cbqE");

var $dJl1T = parcelRequire("dJl1T");

var $fHI8h = parcelRequire("fHI8h");

var $5UKj9 = parcelRequire("5UKj9");
const $0169828d93a4e745$var$LOCATION = 'servicedesk.common.epic-util.concurrency-limiter';
const $0169828d93a4e745$var$EMPTY_SENTINEL = 'EMPTY_SENTINEL';
const $0169828d93a4e745$var$defaultOperator = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, // eslint-disable-next-line @typescript-eslint/no-explicit-any
inner)=>source.switchMap(inner);
const $0169828d93a4e745$export$1c063aa9514214db = (source, availableTokenCount, inner, operator = $0169828d93a4e745$var$defaultOperator, leaseTime)=>{
    if (availableTokenCount < 1) throw new Error(`${$0169828d93a4e745$var$LOCATION}: availableTokenCount must be at least 1`);
    const { injectableSource$: injectableSource$, inject: inject } = (0, $5UKj9.createInjectableSource)(source);
    const stateContainer = new (0, $fHI8h.default)(availableTokenCount, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    inject, leaseTime);
    const withToken = (v)=>stateContainer.withToken.call(stateContainer, v);
    return operator(injectableSource$.mergeMap(withToken), ({ returnToken: returnToken, value: value })=>inner(value) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        .defaultIfEmpty($0169828d93a4e745$var$EMPTY_SENTINEL).do(returnToken, returnToken, returnToken).catch((err)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData($0169828d93a4e745$var$LOCATION, err);
            return (0, $kVLXA.Observable).empty();
        }).do((v)=>{
            if (v === $0169828d93a4e745$var$EMPTY_SENTINEL) (0, $dJl1T.default).safeWarnWithoutCustomerData($0169828d93a4e745$var$LOCATION, 'Empty observable detected. Do not use the concurrency-limiter with empty observables.');
        }).filter((v)=>v !== $0169828d93a4e745$var$EMPTY_SENTINEL));
};

});
parcelRegister("bNfbF", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $4ZurZ = parcelRequire("4ZurZ");
$kVLXA.Observable.prototype.defaultIfEmpty = $4ZurZ.defaultIfEmpty;

});
parcelRegister("4ZurZ", function(module, exports) {

$parcel$export(module.exports, "defaultIfEmpty", () => $3a247abf96eb94c8$export$e4ca6d7b7a6dcf9b, (v) => $3a247abf96eb94c8$export$e4ca6d7b7a6dcf9b = v);
var $3a247abf96eb94c8$export$e4ca6d7b7a6dcf9b;
"use strict";

var $dd7Pj = parcelRequire("dd7Pj");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $3a247abf96eb94c8$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return $dd7Pj.defaultIfEmpty(defaultValue)(this);
}
$3a247abf96eb94c8$export$e4ca6d7b7a6dcf9b = $3a247abf96eb94c8$var$defaultIfEmpty;

});


parcelRegister("fHI8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $4037b6ac32151092$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $bxYf9 = parcelRequire("bxYf9");

var $kVLXA = parcelRequire("kVLXA");

var $9ZM2E = parcelRequire("9ZM2E");
const $4037b6ac32151092$var$DEFAULT_LEASE_TIME = 10000;
class $4037b6ac32151092$export$2e2bcd8739ae039 {
    constructor(availableTokenCount, injectCallback, leaseTime = $4037b6ac32151092$var$DEFAULT_LEASE_TIME){
        this.bufferedValue = null;
        this.onReturnToken = ()=>{
            if (this.bufferedValue) {
                const value = this.bufferedValue;
                this.bufferedValue = null;
                this.injectCallback(value);
            }
        };
        this.tokenDispenser = (0, $9ZM2E.default)(availableTokenCount);
        this.injectCallback = injectCallback;
        this.leaseTime = leaseTime;
        this.availableTokenCount = availableTokenCount;
    }
    areAllTokensTaken() {
        return this.tokenDispenser.getAvailableTokenCount() === 0;
    }
    withToken(value) {
        if (this.areAllTokensTaken()) {
            this.bufferedValue = value;
            return (0, $kVLXA.Observable).empty();
        }
        return this.tokenDispenser.takeToken().switchMap((token)=>{
            const returnToken = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>{
                token.returnToken();
                this.onReturnToken();
            });
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const leaseTimeoutId = window.setTimeout(returnToken, this.leaseTime);
            return (0, $kVLXA.Observable).of({
                returnToken: ()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.clearTimeout(leaseTimeoutId);
                    returnToken();
                },
                value: value
            });
        });
    }
}

});
parcelRegister("9ZM2E", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fbf925ec9c031cc$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("7mHDu");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $bxYf9 = parcelRequire("bxYf9");

var $kVLXA = parcelRequire("kVLXA");
const $4fbf925ec9c031cc$var$tokenDispenser = (initialTokens)=>{
    let availableTokens = initialTokens;
    const obs$ = (0, $kVLXA.Observable).create((observer)=>{
        availableTokens -= 1;
        observer.next('TOKEN');
    });
    const returnToken = ()=>{
        availableTokens += 1;
    };
    return {
        takeToken: ()=>{
            if (availableTokens) return obs$.take(1).mergeMap(()=>(0, $kVLXA.Observable).of({
                    returnToken: (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(returnToken)
                }));
            return (0, $kVLXA.Observable).empty();
        },
        getAvailableTokenCount: ()=>availableTokens
    };
};
var $4fbf925ec9c031cc$export$2e2bcd8739ae039 = $4fbf925ec9c031cc$var$tokenDispenser;

});


parcelRegister("5UKj9", function(module, exports) {

$parcel$export(module.exports, "createInjectableSource", () => $995da5b5c1645d73$export$81fae18a40db9d6c);

var $8Rkzz = parcelRequire("8Rkzz");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("djSMA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("93e44");
parcelRequire("64ZAE");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $995da5b5c1645d73$var$COMPLETE = 'servicedesk.common.epic-util.concurrency-limiter.COMPLETE_VALUE';
const $995da5b5c1645d73$export$81fae18a40db9d6c = (source)=>{
    const buffer$ = new (0, $cab1K.Subject)();
    const completeStream = ()=>{
        buffer$.next($995da5b5c1645d73$var$COMPLETE);
    };
    return {
        // When the source completes, we must also complete the buffer.
        injectableSource$: (0, $kVLXA.Observable).merge(source.do((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), completeStream, completeStream), buffer$.takeWhile((v)=>v !== $995da5b5c1645d73$var$COMPLETE)),
        inject: (value)=>{
            buffer$.next(value);
        }
    };
};

});


parcelRegister("aOIyt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bcb1d1e546e7220$export$2e2bcd8739ae039);

var $1sWm7 = parcelRequire("1sWm7");

var $kVLXA = parcelRequire("kVLXA");

var $bFU4G = parcelRequire("bFU4G");

var $x9xyg = parcelRequire("x9xyg");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $1jONP = parcelRequire("1jONP");

var $3HGy4 = parcelRequire("3HGy4");

var $jJBxp = parcelRequire("jJBxp");

var $fy6YG = parcelRequire("fy6YG");
parcelRequire("jFVZ1");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("c66Ur");
parcelRequire("eV0gs");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("d063O");

var $gabFQ = parcelRequire("gabFQ");

var $bw8gL = parcelRequire("bw8gL");

var $3jtVD = parcelRequire("3jtVD");

var $hYrcT = parcelRequire("hYrcT");

var $627A7 = parcelRequire("627A7");

var $h4yk3 = parcelRequire("h4yk3");

var $7uXM1 = parcelRequire("7uXM1");

var $k3elp = parcelRequire("k3elp");

var $CWMfa = parcelRequire("CWMfa");

var $lPEsb = parcelRequire("lPEsb");

var $SEV5o = parcelRequire("SEV5o");

var $1mTCA = parcelRequire("1mTCA");

// Number of retries. Excludes the first call.
const $3bcb1d1e546e7220$var$NUMBER_OF_RETRIES = 2;
const $3bcb1d1e546e7220$var$ISSUES_FETCH_STARTED_MARK = 'jsd.performance.profile.queues.issues.fetch.from.server.started';
const $3bcb1d1e546e7220$var$ISSUES_FETCH_COMPLETED_MARK = 'jsd.performance.profile.queues.issues.fetch.from.server.completed';
/**
 * Due to various reason (sorting field id is not longer valid, custom field has been removed, sorting field is no longer
 * visible in the queue, etc), the sorting returned from the /issuelist endpoint maybe different from what we
 * stored in the local storage. We should keep them in sync after every ajax call.
 */ // remove with FF cleanup `clean_local_storage_sorting`
const $3bcb1d1e546e7220$var$updateManualSortingInLocalStorage = (queueId, result)=>{
    const { columns: columns, isUsingDefaultSorting: isUsingDefaultSorting } = result;
    const manualSortingColumn = isUsingDefaultSorting ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(columns, (column)=>column.sortOrder != null);
    if (manualSortingColumn != null) (0, $CWMfa.storeSortOrderInLocalStorage)(queueId, manualSortingColumn.fieldId, // @ts-expect-error - TS2345 - Argument of type 'SortOrder | undefined' is not assignable to parameter of type 'SortOrder'.
    manualSortingColumn.sortOrder);
    else (0, $CWMfa.removeSortOrderInLocalStorage)(queueId);
};
const $3bcb1d1e546e7220$var$isRetryableStatusCode = (statusCode)=>statusCode === 429 || statusCode >= 500;
const $3bcb1d1e546e7220$var$MAX_RETRY_DELAY_MS = 15000;
const $3bcb1d1e546e7220$var$BASE_DELAY_MS = 5000;
/**
 * Exponential backoff with max delay and jitter
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
 */ const $3bcb1d1e546e7220$var$maxExpBackoffWithJitter = (retries, baseDelay, maxDelay)=>{
    const exponential = Math.pow(2, retries) * baseDelay;
    const delay = Math.min(exponential, maxDelay);
    const jitter = Math.random();
    const delayWithJitter = Math.floor(jitter * delay);
    return delayWithJitter;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3bcb1d1e546e7220$export$2e2bcd8739ae039 = (startIndex, endIndex, isUpdate, isSourceFromPage, bypassCache, state, isQueueFiltering = false, unsetIsInitialLoad, isSourceFromSort)=>{
    const queueId = (0, $627A7.getQueueId)(state);
    const columnIds = (0, $627A7.getColumnIds)(state);
    const columns = (0, $627A7.getColumns)(state);
    const jql = (0, $627A7.getJql)(state);
    const columnTypesAsJson = (0, $1jONP.getFieldTypesEligibleForJsonData)();
    const issuesPerPage = endIndex - startIndex + 1;
    const baseUrl = (0, $fy6YG.getBaseUrl)(state);
    const projectKey = (0, $fy6YG.getProjectKey)(state);
    const sortedBy = (0, $h4yk3.getSortedByColumn)(state);
    const isAscendingOrder = (0, $h4yk3.getIsAscendingOrder)(state);
    const sortOrder = (0, $h4yk3.getSortOrder)(state);
    const category = (0, $627A7.getCategory)(state);
    const filterQuery = (0, $hYrcT.getCurrentFilterQuery)(state);
    const isFilterRequested = filterQuery !== null;
    let retries = 0;
    const storeAndTransform = (result, source)=>{
        if (!(0, $4R6GH.fg)('clean_local_storage_sorting')) $3bcb1d1e546e7220$var$updateManualSortingInLocalStorage(queueId, result);
        if (startIndex === 0 && !isFilterRequested) {
            const createAnalyticsEvent = (0, $3jtVD.getCreateAnalyticsEvent)(state);
            (0, $lPEsb.storeIssuesInLocalStorage)(result, jql, queueId, sortedBy, sortOrder, isUpdate, createAnalyticsEvent);
        }
        return (0, $SEV5o.default)(result, source, isFilterRequested, isFilterRequested);
    };
    const fireQueueFilteringAnalytics = (result)=>{
        const createAnalyticsEvent = (0, $3jtVD.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) {
            // extract the query text from the filter query
            const queryText = filterQuery?.match(/"([^"]*)\*"/);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering searched', {
                filteredQueueLength: result.issues.length,
                filterLength: queryText ? queryText[1].length : 0
            });
        }
    };
    const fireIssueListRetryAnalyticsSuccess = (numberOfRetries)=>{
        const createAnalyticsEvent = (0, $3jtVD.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jsmIssueList retrySucceeded', {
            numberOfRetries: numberOfRetries
        });
    };
    const fireIssueListRetryAnalyticsFailed = (statusCode)=>{
        const createAnalyticsEvent = (0, $3jtVD.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jsmIssueList retryFailed', {
            statusCode: statusCode
        });
    };
    // analytic event to help study issuelist ssr
    const fireInitialLoadSsrAnalyticEvent = (0, $1mTCA.fireInitialLoadSsrAnalyticEventWithState)(state);
    const resetSorting = isSourceFromSort && sortedBy === undefined;
    const requestData = {
        projectKey: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string' for projectKey.
        projectKey,
        baseUrl: baseUrl,
        jql: jql,
        columnNames: columnIds,
        columnTypesAsJson: columnTypesAsJson,
        startIndex: startIndex,
        issuesPerPage: issuesPerPage,
        orderBy: sortedBy,
        isAscendingOrder: isAscendingOrder,
        category: category,
        resetSorting: (0, $4R6GH.fg)('migrate_sorting_to_user_property') ? resetSorting : undefined,
        queueId: (0, $4R6GH.fg)('migrate_sorting_to_user_property') ? queueId : undefined,
        filterClause: filterQuery
    };
    const getIssuesFromLocalStorage = ()=>bypassCache || startIndex !== 0 || filterQuery !== null ? (0, $kVLXA.Observable).empty() : (0, $lPEsb.getIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort);
    const ssrIssuesData = (0, $7uXM1.getSsrIssueList)(state);
    const ssrIssuesDataError = (0, $7uXM1.getSsrIssuesError)(state);
    const fetchRequestHandler = (isInitialLoad)=>{
        (0, $x9xyg.setMark)($3bcb1d1e546e7220$var$ISSUES_FETCH_STARTED_MARK);
        const fetchStartTime = performance.now();
        return (0, $gabFQ.default)(requestData).flatMap((result)=>{
            (0, $bFU4G.addSpanToAll)('fetch', 'rest/servicedesk/1/servicedesk/projectKey/issuelist', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            if (isInitialLoad) fireInitialLoadSsrAnalyticEvent((0, $0c916c88508aa500$export$57138ddc6df757ce));
            (0, $x9xyg.setMark)($3bcb1d1e546e7220$var$ISSUES_FETCH_COMPLETED_MARK);
            (0, $1mTCA.sendIssuelistStalenessAnalytics)(result, false);
            if (isQueueFiltering) fireQueueFilteringAnalytics(result);
            if (retries > 0) fireIssueListRetryAnalyticsSuccess(retries);
            return (0, $kVLXA.Observable).of(storeAndTransform(result, (0, $3HGy4.REST_SOURCE)));
        }).retryWhen((errors)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            errors.mergeMap((error)=>{
                retries += 1;
                if (!$3bcb1d1e546e7220$var$isRetryableStatusCode(error?.statusCode) || retries > $3bcb1d1e546e7220$var$NUMBER_OF_RETRIES) {
                    fireIssueListRetryAnalyticsFailed(error.statusCode);
                    return (0, $kVLXA.Observable).throw(error);
                }
                return (0, $kVLXA.Observable).of(error.statusCode).delay($3bcb1d1e546e7220$var$maxExpBackoffWithJitter(retries, $3bcb1d1e546e7220$var$BASE_DELAY_MS, $3bcb1d1e546e7220$var$MAX_RETRY_DELAY_MS));
            }));
    };
    const getIssuesFromPrefetcher = (prefetchedIssuePromise, isInitialLoad)=>(0, $kVLXA.Observable).fromPromise(prefetchedIssuePromise).map((response)=>{
            (0, $x9xyg.setMark)('jsd.performance.profile.queues.prefetch.resolved');
            (0, $jJBxp.unsetPrefetchedIssuePromise)(queueId);
            return storeAndTransform(response.data, (0, $3HGy4.PREFETCHER_SOURCE));
        }).catch(()=>fetchRequestHandler(isInitialLoad));
    if (!(0, $4R6GH.fg)('clean_local_storage_sorting')) {
        if (sortedBy) (0, $CWMfa.storeSortOrderInLocalStorage)(queueId, sortedBy, sortOrder);
        else (0, $CWMfa.removeSortOrderInLocalStorage)(queueId);
    }
    if (isUpdate) return (0, $bw8gL.default)({
        ...requestData,
        issueHash: (0, $k3elp.getIssueHash)(state)
    }).flatMap((result)=>{
        (0, $1mTCA.sendIssuelistStalenessAnalytics)(result, true);
        if (isQueueFiltering) fireQueueFilteringAnalytics(result);
        return (0, $kVLXA.Observable).of(storeAndTransform(result, (0, $3HGy4.REST_SOURCE)));
    });
    const prefetchedIssuePromise = (0, $jJBxp.getPrefetchedIssuePromise)(queueId);
    const isInitialLoad = (0, $4R6GH.fg)('issuelist_skip_fetch_cache_hit') ? startIndex === 0 && isSourceFromPage && !isFilterRequested && !isUpdate && !!(0, $7uXM1.getIsInitialLoad)(state) : false;
    if (isInitialLoad) {
        // initial load total traffic
        fireInitialLoadSsrAnalyticEvent((0, $0c916c88508aa500$export$c1927396d6c152eb));
        unsetIsInitialLoad();
        if ((0, $4R6GH.fg)('clean_local_storage_sorting') ? (0, $4R6GH.fg)('ssr_view_queues_issuelist') : sortedBy === undefined && (0, $4R6GH.fg)('ssr_view_queues_issuelist')) {
            if (ssrIssuesData && !ssrIssuesDataError) {
                // initial load SSR hit traffic
                fireInitialLoadSsrAnalyticEvent((0, $0c916c88508aa500$export$5b6950a89e720fb7));
                const loadedIssueListData = storeAndTransform(ssrIssuesData, (0, $3HGy4.SSR_SOURCE));
                return (0, $kVLXA.Observable).of(loadedIssueListData);
            }
            // initial load SSR error out traffic
            if (ssrIssuesDataError) {
                if (ssrIssuesDataError.name === 'TimeoutError') fireInitialLoadSsrAnalyticEvent((0, $0c916c88508aa500$export$7f8de25485f27a39));
                fireInitialLoadSsrAnalyticEvent((0, $0c916c88508aa500$export$932d8e2bf11ecc3d));
            }
        }
        const localStorageData = (0, $lPEsb.maybeIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder);
        if (localStorageData.isSome()) {
            // initial load cache hit traffic
            fireInitialLoadSsrAnalyticEvent((0, $0c916c88508aa500$export$431f43d5c108aa95));
            return localStorageData.cata((0, $kVLXA.Observable).empty, (0, $kVLXA.Observable).of);
        }
    }
    const issueListObservable = prefetchedIssuePromise.isSome() && !filterQuery ? prefetchedIssuePromise// @ts-expect-error - TS7006 - Parameter 'promise' implicitly has an 'any' type.
    .map((promise)=>getIssuesFromPrefetcher(promise, isInitialLoad)).orSome((0, $kVLXA.Observable).empty()) : fetchRequestHandler(isInitialLoad);
    // The concat operator is best used when you need to combine multiple observables,
    // but you want their emissions to be in a specific order, one after the other.
    return (0, $kVLXA.Observable).concat(getIssuesFromLocalStorage(), issueListObservable);
};

});
parcelRegister("1jONP", function(module, exports) {

$parcel$export(module.exports, "getFieldTypesEligibleForJsonData", () => $fbe954dc4033eebc$export$e2bd4328395b4df7);
$parcel$export(module.exports, "getFieldTypesEligibleForJsonDataAsSet", () => $fbe954dc4033eebc$export$740140e54d80c734);
$parcel$export(module.exports, "getFieldTypesToOverrideHtmlDataForAsSetOld", () => $fbe954dc4033eebc$export$e049f31fff152375);
$parcel$export(module.exports, "getFieldTypesToOverrideHtmlDataForAsSet", () => $fbe954dc4033eebc$export$dacb9fc482fbe93);

var $66FNL = parcelRequire("66FNL");

var $4f8Oj = parcelRequire("4f8Oj");

var $8QpSo = parcelRequire("8QpSo");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");
const $fbe954dc4033eebc$var$getFieldTypesFromFeatureFlagMap = (featureFlagMap)=>(0, (/*@__PURE__*/$parcel$interopDefault($66FNL)))((0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(featureFlagMap, (isAlwaysJsonOrFFKey)=>{
        if (typeof isAlwaysJsonOrFFKey === 'boolean') return isAlwaysJsonOrFFKey;
        // eslint-disable-next-line jira/ff/static-feature-flags
        return (0, $co1wz.ff)(isAlwaysJsonOrFFKey) || (0, $4R6GH.fg)(isAlwaysJsonOrFFKey);
    }));
const $fbe954dc4033eebc$export$c394db035bb5cf7d = {
    assignee: true,
    'com.atlassian.servicedesk:sd-sla-field': true,
    status: true,
    issuetype: true,
    reporter: true,
    summary: true,
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': true,
    labels: true,
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': true,
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': true,
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': 'jsm_unscreenable_field_phase_2_fg',
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': true,
    'com.atlassian.servicedesk:sd-request-participants': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': true,
    'com.atlassian.servicedesk.sentiment:sd-sentiment': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-organization': 'jcs_master_flag'
};
const $fbe954dc4033eebc$export$e2bd4328395b4df7 = (0, $8QpSo.default)(()=>$fbe954dc4033eebc$var$getFieldTypesFromFeatureFlagMap($fbe954dc4033eebc$export$c394db035bb5cf7d));
const $fbe954dc4033eebc$export$740140e54d80c734 = (0, $8QpSo.default)(()=>new Set($fbe954dc4033eebc$export$e2bd4328395b4df7()));
// @ts-expect-error(PARTIAL_RECORD) TS2740 | TS2740 - Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, status, reporter, date, and 13 more. | Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, date, labels, assignee, and 13 more.
const $fbe954dc4033eebc$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS_OLD = {
    issuekey: true,
    priority: true
};
// @ts-expect-error(PARTIAL_RECORD) TS2740 | TS2740 - Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, status, reporter, date, and 13 more. | Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, date, labels, assignee, and 13 more.
const $fbe954dc4033eebc$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS = {
    issuekey: true,
    priority: true,
    statusCategory: true
};
const $fbe954dc4033eebc$export$f418ebfb147e8448 = (0, $8QpSo.default)(()=>$fbe954dc4033eebc$var$getFieldTypesFromFeatureFlagMap($fbe954dc4033eebc$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS_OLD));
const $fbe954dc4033eebc$export$e049f31fff152375 = (0, $8QpSo.default)(()=>new Set($fbe954dc4033eebc$export$f418ebfb147e8448()));
const $fbe954dc4033eebc$export$8e81e0bb2e4fc09e = (0, $8QpSo.default)(()=>$fbe954dc4033eebc$var$getFieldTypesFromFeatureFlagMap($fbe954dc4033eebc$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS));
const $fbe954dc4033eebc$export$dacb9fc482fbe93 = (0, $8QpSo.default)(()=>new Set($fbe954dc4033eebc$export$8e81e0bb2e4fc09e()));

});

parcelRegister("jJBxp", function(module, exports) {

$parcel$export(module.exports, "transformColumns", () => $fe7782e5f812c2df$export$6e8deebce7129a99);
$parcel$export(module.exports, "transformColumnsByRemoveSortOrder", () => $fe7782e5f812c2df$export$c2dd410aebdef477);
$parcel$export(module.exports, "removeSortingFromColumns", () => $fe7782e5f812c2df$export$b4148c35c271b9a9);
$parcel$export(module.exports, "transformIssues", () => $fe7782e5f812c2df$export$a26a6de2e9ae64a0);
$parcel$export(module.exports, "getPrefetchedIssuePromise", () => $fe7782e5f812c2df$export$13bba225866f1e46);
$parcel$export(module.exports, "unsetPrefetchedIssuePromise", () => $fe7782e5f812c2df$export$56d44580e340f1f4);
$parcel$export(module.exports, "default", () => $fe7782e5f812c2df$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4Xk2W = parcelRequire("4Xk2W");

var $8KhWn = parcelRequire("8KhWn");

var $kVLXA = parcelRequire("kVLXA");

var $3HGy4 = parcelRequire("3HGy4");
const $fe7782e5f812c2df$export$6e8deebce7129a99 = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.columnHeaderText,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $fe7782e5f812c2df$export$c2dd410aebdef477 = (responseColumns)=>responseColumns.map((responseColumn)=>({
            id: responseColumn.fieldId,
            title: responseColumn.columnHeaderText,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        }));
const $fe7782e5f812c2df$export$b4148c35c271b9a9 = (columns)=>columns.map((column)=>({
            id: column.id,
            title: column.title,
            fieldType: column.fieldType,
            sortable: column.sortable
        }));
const $fe7782e5f812c2df$var$mapFieldsByColumnId = (fields)=>// @ts-expect-error - TS2322 - Type 'Dictionary<number | ResponseField | { (callbackfn: (previousValue: ResponseField, currentValue: ResponseField, currentIndex: number, array: ResponseField[]) => ResponseField): ResponseField; (callbackfn: (previousValue: ResponseField, currentValue: ResponseField, currentIndex: number, array: ResponseField[]) => Resp...' is not assignable to type 'FieldsById'. | TS2339 - Property 'fieldId' does not exist on type 'ResponseField'. | TS2339 - Property 'fieldCssClass' does not exist on type 'ResponseField'.
    (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(fields, (field)=>field.fieldId || field.fieldCssClass);
const $fe7782e5f812c2df$export$a26a6de2e9ae64a0 = (issues)=>issues.map((issue)=>({
            id: issue.id,
            key: issue.key,
            fields: $fe7782e5f812c2df$var$mapFieldsByColumnId(issue.fields),
            position: issue.position
        }));
const $fe7782e5f812c2df$export$13bba225866f1e46 = (queueId)=>(0, $8KhWn.Maybe).fromNull(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES[`queueIssues_${(0, $3HGy4.fromQueueId)(queueId)}`]);
const $fe7782e5f812c2df$export$56d44580e340f1f4 = (queueId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JSD_QUEUES_PRELOAD_PROMISES) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES[`queueIssues_${(0, $3HGy4.fromQueueId)(queueId)}`] = undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe7782e5f812c2df$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $kVLXA.Observable).of(transformFunc(payload)));

});
parcelRegister("8KhWn", function(module, exports) {
//     Monet.js 0.8.10
//     (c) 2012-2016 Chris Myers
//     Monet.js may be freely distributed under the MIT license.
//     For all details and documentation:
//     https://cwmyers.github.com/monet.js
(function(root, factory) {
    module.exports = factory(root);
})(module.exports, function(root) {
    "use strict";
    var curry = function(fn, args) {
        return function() {
            var args1 = args.append(List.fromArray(Array.prototype.slice.call(arguments)));
            return args1.size() >= fn.length ? fn.apply(this, args1.toArray().slice(0, args1.size())) : curry(fn, args1);
        };
    };
    var isFunction = function(f) {
        return !!(f && f.constructor && f.call && f.apply);
    };
    var idFunction = function(value) {
        return value;
    };
    var trueFunction = function() {
        return true;
    };
    var falseFunction = function() {
        return false;
    };
    var Monet = root.Monet = {};
    var swap = Monet.swap = function(f) {
        return function(a, b) {
            return f(b, a);
        };
    };
    var map = function(fn) {
        return this.bind(this.of.compose(fn));
    };
    var apply2 = Monet.apply2 = function(a1, a2, f) {
        return a2.ap(a1.map(f.curry()));
    };
    Monet.curry = function(fn) {
        return curry(fn, Nil);
    };
    Function.prototype.curry = function() {
        return curry(this, Nil);
    };
    // List monad
    var list;
    var List = list = root.List = function(head, tail) {
        return new List.fn.init(head, tail);
    };
    var listMap = function(fn, l) {
        return listMapC(fn, l).run();
    };
    var listMapC = function(fn, l) {
        return l.isNil ? Return(l) : Suspend(function() {
            return listMapC(fn, l.tail());
        }).map(cons.curry()(fn(l.head())));
    };
    var listEach = function(effectFn, l) {
        if (!l.isNil) {
            effectFn(l.head());
            listEach(effectFn, l.tail());
        }
    };
    var foldLeft = function(fn, acc, l) {
        function fL(acc, l) {
            return l.isNil ? Return(acc) : Suspend(function() {
                return fL(fn(acc, l.head()), l.tail());
            });
        }
        return fL(acc, l).run();
    };
    var foldRight = function(fn, l, acc) {
        function fR(l, acc) {
            return l.isNil ? Return(acc) : Suspend(function() {
                return fR(l.tail(), acc);
            }).map(function(acc1) {
                return fn(l.head(), acc1);
            });
        }
        return fR(l, acc).run();
    };
    var append = function(list1, list2) {
        function append1(list1, list2) {
            return list1.isNil ? Return(list2) : Suspend(function() {
                return append1(list1.tail(), list2).map(function(list) {
                    return list.cons(list1.head());
                });
            });
        }
        return append1(list1, list2).run();
    };
    var sequence = function(list, type) {
        return list.foldRight(type.of(Nil))(type.map2(cons));
    };
    var sequenceValidation = function(list) {
        return list.foldLeft(Success(Nil))(function(acc, a) {
            return acc.ap(a.map(function(v) {
                return function(t) {
                    return cons(v, t);
                };
            }));
        }).map(listReverse);
    };
    var listReverse = function(list) {
        return list.foldLeft(Nil)(swap(cons));
    };
    var listFilter = function(list, fn) {
        return list.foldRight(Nil)(function(a, acc) {
            return fn(a) ? cons(a, acc) : acc;
        });
    };
    var listAp = function(list1, list2) {
        return list1.bind(function(x) {
            return list2.map(function(f) {
                return f(x);
            });
        });
    };
    var cons = function(head, tail) {
        return tail.cons(head);
    };
    List.fn = List.prototype = {
        init: function(head, tail) {
            if (head == null) {
                this.isNil = true;
                this.size_ = 0;
            } else {
                this.isNil = false;
                this.head_ = head;
                this.tail_ = tail == null ? Nil : tail;
                this.size_ = tail == null ? 0 : tail.size() + 1;
            }
        },
        of: function(value) {
            return new List(value);
        },
        size: function() {
            return this.size_;
        },
        cons: function(head) {
            return List(head, this);
        },
        snoc: function(element) {
            return this.concat(List(element));
        },
        map: function(fn) {
            return listMap(fn, this);
        },
        toArray: function() {
            return foldLeft(function(acc, e) {
                acc.push(e);
                return acc;
            }, [], this);
        },
        foldLeft: function(initialValue) {
            var self = this;
            return function(fn) {
                return foldLeft(fn, initialValue, self);
            };
        },
        foldRight: function(initialValue) {
            var self = this;
            return function(fn) {
                return foldRight(fn, self, initialValue);
            };
        },
        append: function(list2) {
            return append(this, list2);
        },
        filter: function(fn) {
            return listFilter(this, fn);
        },
        flatten: function() {
            return foldRight(append, this, Nil);
        },
        flattenMaybe: function() {
            return this.flatMap(Maybe.toList);
        },
        reverse: function() {
            return listReverse(this);
        },
        bind: function(fn) {
            return this.map(fn).flatten();
        },
        each: function(effectFn) {
            listEach(effectFn, this);
        },
        // transforms a list of Maybes to a Maybe list
        sequenceMaybe: function() {
            return sequence(this, Maybe);
        },
        sequenceValidation: function() {
            return sequenceValidation(this);
        },
        sequenceEither: function() {
            return sequence(this, Either);
        },
        sequenceIO: function() {
            return sequence(this, IO);
        },
        sequenceReader: function() {
            return sequence(this, Reader);
        },
        sequence: function(monadType) {
            return sequence(this, monadType);
        },
        head: function() {
            return this.head_;
        },
        headMaybe: function() {
            return this.isNil ? None() : Some(this.head_);
        },
        tail: function() {
            return this.isNil ? Nil : this.tail_;
        },
        tails: function() {
            return this.isNil ? List(Nil, Nil) : this.tail().tails().cons(this);
        },
        ap: function(list) {
            return listAp(this, list);
        },
        isNEL: falseFunction
    };
    List.fn.init.prototype = List.fn;
    var Nil = root.Nil = new List.fn.init();
    // Aliases
    List.prototype.empty = function() {
        return Nil;
    };
    List.fromArray = function(array) {
        var l = Nil;
        for(var i = array.length; i--; i)l = l.cons(array[i]);
        return l;
    };
    List.of = function(a) {
        return new List(a, Nil);
    };
    /*
     * Non-Empty List monad
     * This is also a comonad because there exists the implementation of extract(copure), which is just head
     * and cobind and cojoin.
     *
     */ var NonEmptyList;
    var NEL = root.NEL = NonEmptyList = root.NonEmptyList = function(head, tail) {
        if (head == null) throw "Cannot create an empty Non-Empty List.";
        return new NEL.fn.init(head, tail);
    };
    NEL.of = function(a) {
        return NEL(a, Nil);
    };
    NEL.fn = NEL.prototype = {
        init: function(head, tail) {
            if (head == null) {
                this.isNil = true;
                this.size_ = 0;
            } else {
                this.isNil = false;
                this.head_ = head;
                this.tail_ = tail == null ? Nil : tail;
                this.size_ = this.tail_.size() + 1;
            }
        },
        map: function(fn) {
            return NEL(fn(this.head_), listMap(fn, this.tail_));
        },
        bind: function(fn) {
            var p = fn(this.head_);
            if (!p.isNEL()) throw "function must return a NonEmptyList.";
            var list = this.tail().foldLeft(Nil.snoc(p.head()).append(p.tail()))(function(acc, e) {
                var list2 = fn(e).toList();
                return acc.snoc(list2.head()).append(list2.tail());
            });
            return new NEL(list.head(), list.tail());
        },
        head: function() {
            return this.head_;
        },
        tail: function() {
            return this.tail_;
        },
        //NEL[A] -> NEL[NEL[A]]
        tails: function() {
            var listsOfNels = this.toList().tails().map(NEL.fromList).flattenMaybe();
            return NEL(listsOfNels.head(), listsOfNels.tail());
        },
        toList: function() {
            return List(this.head_, this.tail_);
        },
        reverse: function() {
            if (this.tail().isNil) return this;
            else {
                var reversedTail = this.tail().reverse();
                return NEL(reversedTail.head(), reversedTail.tail().append(List(this.head())));
            }
        },
        foldLeft: function(initialValue) {
            return this.toList().foldLeft(initialValue);
        },
        foldRight: function(initialValue) {
            return this.toList().foldRight(initialValue);
        },
        reduceLeft: function(fn) {
            return this.tail().foldLeft(this.head())(fn);
        },
        filter: function(fn) {
            return listFilter(this.toList(), fn);
        },
        append: function(list2) {
            return NEL.fromList(this.toList().append(list2.toList())).some();
        },
        // NEL[A] -> (NEL[A] -> B) -> NEL[B]
        cobind: function(fn) {
            return this.cojoin().map(fn);
        },
        size: function() {
            return this.size_;
        },
        isNEL: trueFunction
    };
    NEL.fromList = function(list) {
        return list.isNil ? None() : Some(NEL(list.head(), list.tail()));
    };
    NEL.fn.init.prototype = NEL.fn;
    NEL.prototype.toArray = List.prototype.toArray;
    NEL.prototype.extract = NEL.prototype.copure = NEL.prototype.head;
    NEL.prototype.cojoin = NEL.prototype.tails;
    NEL.prototype.coflatMap = NEL.prototype.mapTails = NEL.prototype.cobind;
    NEL.prototype.ap = List.prototype.ap;
    /* Maybe Monad */ var Maybe = root.Maybe = {};
    Maybe.fromNull = function(val) {
        return val == null ? Maybe.None() : Maybe.Some(val);
    };
    Maybe.of = function(a) {
        return Some(a);
    };
    var Just;
    var Some = Just = Maybe.Just = Maybe.Some = root.Some = root.Just = function(val) {
        return new Maybe.fn.init(true, val);
    };
    var Nothing;
    var None = Nothing = Maybe.Nothing = Maybe.None = root.None = function() {
        return new Maybe.fn.init(false, null);
    };
    Maybe.toList = function(maybe) {
        return maybe.toList();
    };
    Maybe.fn = Maybe.prototype = {
        init: function(isValue, val) {
            this.isValue = isValue;
            if (val == null && isValue) throw "Illegal state exception";
            this.val = val;
        },
        isSome: function() {
            return this.isValue;
        },
        isNone: function() {
            return !this.isSome();
        },
        bind: function(bindFn) {
            return this.isValue ? bindFn(this.val) : this;
        },
        some: function() {
            if (this.isValue) return this.val;
            else throw "Illegal state exception";
        },
        orSome: function(otherValue) {
            return this.isValue ? this.val : otherValue;
        },
        orElse: function(maybe) {
            return this.isValue ? this : maybe;
        },
        ap: function(maybeWithFunction) {
            var value = this.val;
            return this.isValue ? maybeWithFunction.map(function(fn) {
                return fn(value);
            }) : this;
        },
        toList: function() {
            return this.map(List).orSome(Nil);
        },
        toEither: function(failVal) {
            return this.isSome() ? Right(this.val) : Left(failVal);
        },
        toValidation: function(failVal) {
            return this.isSome() ? Success(this.val) : Fail(failVal);
        },
        fold: function(defaultValue) {
            var self = this;
            return function(fn) {
                return self.isSome() ? fn(self.val) : defaultValue;
            };
        },
        cata: function(none, some) {
            return this.isSome() ? some(this.val) : none();
        },
        filter: function(fn) {
            var self = this;
            return self.flatMap(function(a) {
                return fn(a) ? self : None();
            });
        }
    };
    // aliases
    Maybe.prototype.orJust = Maybe.prototype.orSome;
    Maybe.prototype.just = Maybe.prototype.some;
    Maybe.prototype.isJust = Maybe.prototype.isSome;
    Maybe.prototype.isNothing = Maybe.prototype.isNone;
    Maybe.fn.init.prototype = Maybe.fn;
    var Validation = root.Validation = {};
    var Success = Validation.Success = Validation.success = root.Success = function(val) {
        return new Validation.fn.init(val, true);
    };
    var Fail = Validation.Fail = Validation.fail = root.Fail = function(error) {
        return new Validation.fn.init(error, false);
    };
    Validation.of = function(v) {
        return Success(v);
    };
    Validation.fn = Validation.prototype = {
        init: function(val, success) {
            this.val = val;
            this.isSuccessValue = success;
        },
        success: function() {
            if (this.isSuccess()) return this.val;
            else throw 'Illegal state. Cannot call success() on a Validation.fail';
        },
        isSuccess: function() {
            return this.isSuccessValue;
        },
        isFail: function() {
            return !this.isSuccessValue;
        },
        fail: function() {
            if (this.isSuccess()) throw 'Illegal state. Cannot call fail() on a Validation.success';
            else return this.val;
        },
        bind: function(fn) {
            return this.isSuccess() ? fn(this.val) : this;
        },
        ap: function(validationWithFn) {
            var value = this.val;
            return this.isSuccess() ? validationWithFn.map(function(fn) {
                return fn(value);
            }) : validationWithFn.isFail() ? Validation.Fail(Semigroup.append(value, validationWithFn.fail())) : this;
        },
        acc: function() {
            var x = function() {
                return x;
            };
            return this.isSuccessValue ? Validation.success(x) : this;
        },
        cata: function(fail, success) {
            return this.isSuccessValue ? success(this.val) : fail(this.val);
        },
        failMap: function(fn) {
            return this.isFail() ? Fail(fn(this.val)) : this;
        },
        bimap: function(fail, success) {
            return this.isSuccessValue ? this.map(success) : this.failMap(fail);
        },
        toMaybe: function() {
            return this.isSuccess() ? Some(this.val) : None();
        },
        toEither: function() {
            return (this.isSuccess() ? Right : Left)(this.val);
        }
    };
    Validation.fn.init.prototype = Validation.fn;
    var Semigroup = root.Semigroup = {};
    Semigroup.append = function(a, b) {
        if (a instanceof Array) return a.concat(b);
        if (typeof a === "string") return a + b;
        if (isFunction(a.concat)) return a.concat(b);
        throw "Couldn't find a semigroup appender in the environment, please specify your own append function";
    };
    var monadT, monadTransformer, MonadTransformer;
    var MonadT = monadT = monadTransformer = MonadTransformer = root.monadTransformer = root.MonadT = root.monadT = function(monad) {
        return new MonadT.fn.init(monad);
    };
    MonadT.of = function(m) {
        return MonadT(m);
    };
    MonadT.fn = MonadT.prototype = {
        init: function(monad) {
            this.monad = monad;
        },
        map: function(fn) {
            return monadT(this.monad.map(function(v) {
                return v.map(fn);
            }));
        },
        bind: function(fn) {
            return monadT(this.monad.map(function(v) {
                return v.flatMap(fn);
            }));
        },
        ap: function(monadWithFn) {
            return monadT(this.monad.flatMap(function(v) {
                return monadWithFn.perform().map(function(v2) {
                    return v.ap(v2);
                });
            }));
        },
        perform: function() {
            return this.monad;
        }
    };
    MonadT.fn.init.prototype = MonadT.fn;
    var io;
    var IO = io = root.IO = root.io = function(effectFn) {
        return new IO.fn.init(effectFn);
    };
    IO.of = function(a) {
        return IO(function() {
            return a;
        });
    };
    IO.fn = IO.prototype = {
        init: function(effectFn) {
            if (!isFunction(effectFn)) throw "IO requires a function";
            this.effectFn = effectFn;
        },
        map: function(fn) {
            var self = this;
            return IO(function() {
                return fn(self.effectFn());
            });
        },
        bind: function(fn) {
            var self = this;
            return IO(function() {
                return fn(self.effectFn()).run();
            });
        },
        ap: function(ioWithFn) {
            var self = this;
            return ioWithFn.map(function(fn) {
                return fn(self.effectFn());
            });
        },
        run: function() {
            return this.effectFn();
        }
    };
    IO.fn.init.prototype = IO.fn;
    IO.prototype.perform = IO.prototype.performUnsafeIO = IO.prototype.run;
    /* Either Monad */ var Either = root.Either = {};
    Either.of = function(a) {
        return Right(a);
    };
    var Right = Either.Right = root.Right = function(val) {
        return new Either.fn.init(val, true);
    };
    var Left = Either.Left = root.Left = function(val) {
        return new Either.fn.init(val, false);
    };
    Either.fn = Either.prototype = {
        init: function(val, isRightValue) {
            this.isRightValue = isRightValue;
            this.value = val;
        },
        bind: function(fn) {
            return this.isRightValue ? fn(this.value) : this;
        },
        ap: function(eitherWithFn) {
            var self = this;
            return this.isRightValue ? eitherWithFn.map(function(fn) {
                return fn(self.value);
            }) : this;
        },
        leftMap: function(fn) {
            return this.isLeft() ? Left(fn(this.value)) : this;
        },
        isRight: function() {
            return this.isRightValue;
        },
        isLeft: function() {
            return !this.isRight();
        },
        right: function() {
            if (this.isRightValue) return this.value;
            else throw "Illegal state. Cannot call right() on a Either.left";
        },
        left: function() {
            if (this.isRightValue) throw "Illegal state. Cannot call left() on a Either.right";
            else return this.value;
        },
        cata: function(leftFn, rightFn) {
            return this.isRightValue ? rightFn(this.value) : leftFn(this.value);
        },
        bimap: function(leftFn, rightFn) {
            return this.isRightValue ? this.map(rightFn) : this.leftMap(leftFn);
        },
        toMaybe: function() {
            return this.isRight() ? Some(this.value) : None();
        },
        toValidation: function() {
            return this.isRight() ? Success(this.value) : Fail(this.value);
        }
    };
    Either.fn.init.prototype = Either.fn;
    var reader;
    var Reader = reader = root.Reader = function(fn) {
        return new Reader.fn.init(fn);
    };
    Reader.of = function(x) {
        return Reader(function(_) {
            return x;
        });
    };
    Reader.ask = function() {
        return Reader(idFunction);
    };
    Reader.fn = Reader.prototype = {
        init: function(fn) {
            this.f = fn;
        },
        run: function(config) {
            return this.f(config);
        },
        bind: function(fn) {
            var self = this;
            return Reader(function(config) {
                return fn(self.run(config)).run(config);
            });
        },
        ap: function(readerWithFn) {
            var self = this;
            return readerWithFn.bind(function(fn) {
                return Reader(function(config) {
                    return fn(self.run(config));
                });
            });
        },
        map: function(fn) {
            var self = this;
            return Reader(function(config) {
                return fn(self.run(config));
            });
        },
        local: function(fn) {
            var self = this;
            return Reader(function(c) {
                return self.run(fn(c));
            });
        }
    };
    Reader.fn.init.prototype = Reader.fn;
    var Free = root.Free = {};
    var Suspend = Free.Suspend = root.Suspend = function(functor) {
        return new Free.fn.init(functor, true);
    };
    var Return = Free.Return = root.Return = function(val) {
        return new Free.fn.init(val, false);
    };
    Free.of = function(a) {
        return Return(a);
    };
    Free.liftF = function(functor) {
        return Suspend(functor.map(Return));
    };
    Free.fn = Free.prototype = {
        init: function(val, isSuspend) {
            this.isSuspend = isSuspend;
            if (isSuspend) this.functor = val;
            else this.val = val;
        },
        run: function() {
            return this.go(function(f) {
                return f();
            });
        },
        bind: function(fn) {
            return this.isSuspend ? Suspend(this.functor.map(function(free) {
                return free.bind(fn);
            })) : fn(this.val);
        },
        ap: function(ff) {
            return this.bind(function(x) {
                return ff.map(function(f) {
                    return f(x);
                });
            });
        },
        resume: function() {
            return this.isSuspend ? Left(this.functor) : Right(this.val);
        },
        go1: function(f) {
            function go2(t) {
                return t.resume().cata(function(functor) {
                    return go2(f(functor));
                }, idFunction);
            }
            return go2(this);
        },
        go: function(f) {
            var result = this.resume();
            while(result.isLeft()){
                var next = f(result.left());
                result = next.resume();
            }
            return result.right();
        }
    };
    Free.fn.init.prototype = Free.fn;
    var Identity = root.Identity = function(a) {
        return new Identity.fn.init(a);
    };
    Identity.of = function(a) {
        return new Identity(a);
    };
    Identity.fn = Identity.prototype = {
        init: function(val) {
            this.val = val;
        },
        bind: function(fn) {
            return fn(this.val);
        },
        get: function() {
            return this.val;
        }
    };
    Identity.fn.init.prototype = Identity.fn;
    Function.prototype.io = function() {
        return IO(this);
    };
    Function.prototype.io1 = function() {
        var f = this;
        return function(x) {
            return IO(function() {
                return f(x);
            });
        };
    };
    Function.prototype.reader = function() {
        var f = this;
        var wrapReader = function(fn, args) {
            return function() {
                var args1 = args.append(List.fromArray(Array.prototype.slice.call(arguments)));
                var self = this;
                return args1.size() + 1 == fn.length ? Reader(function(c) {
                    return fn.apply(self, args1.append(List(c)).toArray());
                }) : wrapReader(fn, args1);
            };
        };
        return wrapReader(f, Nil);
    };
    Function.prototype.compose = Function.prototype.o = function(g) {
        var f = this;
        return function(x) {
            return f(g(x));
        };
    };
    Function.prototype.andThen = Function.prototype.map = function(g) {
        var f = this;
        return function(x) {
            return g(f(x));
        };
    };
    function addAliases(type) {
        type.prototype.flatMap = type.prototype.chain = type.prototype.bind;
        type.pure = type.unit = type.of;
        type.prototype.of = type.of;
        if (type.prototype.append != null) type.prototype.concat = type.prototype.append;
        type.prototype.point = type.prototype.pure = type.prototype.unit = type.prototype.of;
    }
    // Wire up aliases
    function addMonadOps(type) {
        type.prototype.join = function() {
            return this.flatMap(idFunction);
        };
        type.map2 = function(fn) {
            return function(ma, mb) {
                return ma.flatMap(function(a) {
                    return mb.map(function(b) {
                        return fn(a, b);
                    });
                });
            };
        };
    }
    function addFunctorOps(type) {
        if (type.prototype.map == null) type.prototype.map = function(fn) {
            return map.call(this, fn);
        };
    }
    function addApplicativeOps(type) {
        type.prototype.takeLeft = function(m) {
            return apply2(this, m, function(a, b) {
                return a;
            });
        };
        type.prototype.takeRight = function(m) {
            return apply2(this, m, function(a, b) {
                return b;
            });
        };
    }
    function decorate(type) {
        addAliases(type);
        addMonadOps(type);
        addFunctorOps(type);
        addApplicativeOps(type);
    }
    decorate(MonadT);
    decorate(Either);
    decorate(Maybe);
    decorate(IO);
    decorate(NEL);
    decorate(List);
    decorate(Validation);
    decorate(Reader);
    decorate(Free);
    decorate(Identity);
    return root;
});

});


parcelRegister("fy6YG", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $d46772aa1443fad2$export$f654b28f82155665);
$parcel$export(module.exports, "getCloudId", () => $d46772aa1443fad2$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getFabricPfDirUrl", () => $d46772aa1443fad2$export$505ebc60b5fc3b2e);
$parcel$export(module.exports, "getAtlassianAccountId", () => $d46772aa1443fad2$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getProjectKey", () => $d46772aa1443fad2$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectName", () => $d46772aa1443fad2$export$2cd058184eb75757);
$parcel$export(module.exports, "getLocale", () => $d46772aa1443fad2$export$180605366c04f0cd);
$parcel$export(module.exports, "getIsAdmin", () => $d46772aa1443fad2$export$7d046765d192af80);
$parcel$export(module.exports, "getProjectId", () => $d46772aa1443fad2$export$89040d072f281f85);
$parcel$export(module.exports, "getAppPropsForIssueTable", () => $d46772aa1443fad2$export$78632e066216024);

var $dGvGJ = parcelRequire("dGvGJ");

var $g5X3G = parcelRequire("g5X3G");
const $d46772aa1443fad2$export$876089ea65adc54 = (state)=>state.appProps;
const $d46772aa1443fad2$export$f654b28f82155665 = (_)=>'';
const $d46772aa1443fad2$export$fdd2c0ba94025c3c = (state)=>$d46772aa1443fad2$export$876089ea65adc54(state).cloudId;
const $d46772aa1443fad2$export$505ebc60b5fc3b2e = (state)=>$d46772aa1443fad2$export$876089ea65adc54(state).fabricPfDirUrl;
const $d46772aa1443fad2$export$f5baf4f0aaa47428 = (state)=>$d46772aa1443fad2$export$876089ea65adc54(state).atlassianAccountId;
const $d46772aa1443fad2$export$667f2a0f99c75faa = (state)=>$d46772aa1443fad2$export$876089ea65adc54(state).projectKey;
const $d46772aa1443fad2$export$2cd058184eb75757 = (state)=>$d46772aa1443fad2$export$876089ea65adc54(state).projectName;
const $d46772aa1443fad2$export$180605366c04f0cd = (state)=>$d46772aa1443fad2$export$876089ea65adc54(state).locale;
const $d46772aa1443fad2$export$7d046765d192af80 = (state)=>$d46772aa1443fad2$export$876089ea65adc54(state).isAdmin;
const $d46772aa1443fad2$export$89040d072f281f85 = (state)=>$d46772aa1443fad2$export$876089ea65adc54(state).projectId;
const $d46772aa1443fad2$export$78632e066216024 = (0, $dGvGJ.createSelector)($d46772aa1443fad2$export$f654b28f82155665, $d46772aa1443fad2$export$fdd2c0ba94025c3c, $d46772aa1443fad2$export$505ebc60b5fc3b2e, $d46772aa1443fad2$export$f5baf4f0aaa47428, (baseUrl, cloudId, fabricPfDirUrl, atlassianAccountId)=>({
        baseUrl: '',
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        cloudId: (0, $g5X3G.toCloudId)(cloudId),
        fabricPfDirUrl: fabricPfDirUrl,
        atlassianAccountId: atlassianAccountId
    }));

});

parcelRegister("gabFQ", function(module, exports) {

$parcel$export(module.exports, "switchingFetch", () => $50a4eb05c077d252$export$cffbcfdbac9406a3);
$parcel$export(module.exports, "default", () => $50a4eb05c077d252$export$2e2bcd8739ae039);

var $5OrSA = parcelRequire("5OrSA");

var $oCMSG = parcelRequire("oCMSG");
const $50a4eb05c077d252$var$postParams = (jql, columnNames, columnTypesAsJson, startIndex, issuesPerPage, currentIssueHash, orderBy, isAscendingOrder, category, filterClause, queueId, resetSorting)=>({
        jql: jql,
        columnNames: columnNames,
        columnTypesAsJson: columnTypesAsJson,
        startIndex: startIndex,
        issuesPerPage: issuesPerPage,
        currentIssueHash: currentIssueHash || '',
        ...orderBy ? {
            orderBy: orderBy,
            isAscendingOrder: isAscendingOrder
        } : {},
        ...category && category !== (0, $oCMSG.NO_CATEGORY) ? {
            category: category
        } : {},
        filterClause: filterClause,
        queueId: queueId,
        resetSorting: resetSorting
    });
const $50a4eb05c077d252$export$cffbcfdbac9406a3 = (args)=>{
    const { projectKey: projectKey, baseUrl: baseUrl, jql: jql, columnNames: columnNames, columnTypesAsJson: columnTypesAsJson, startIndex: startIndex, issuesPerPage: issuesPerPage, orderBy: orderBy, isAscendingOrder: isAscendingOrder, category: category, queueId: queueId, filterClause: filterClause, resetSorting: resetSorting } = args;
    // @ts-expect-error - TS2339 - Property 'issueHash' does not exist on type 'IssueListFetchArgs | UpdatedFetchArgs'.
    const issueHash = args.issueHash || null;
    const fetchUrl = `${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/issuelist${issueHash ? '/updated' : ''}`;
    const fetchOptions = {
        method: 'POST',
        body: JSON.stringify($50a4eb05c077d252$var$postParams(jql, columnNames, columnTypesAsJson, startIndex, issuesPerPage, issueHash, orderBy, isAscendingOrder, category, filterClause, queueId, resetSorting))
    };
    return (0, $5OrSA.fetchJson$)(fetchUrl, fetchOptions);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$50a4eb05c077d252$export$2e2bcd8739ae039 = (args)=>$50a4eb05c077d252$export$cffbcfdbac9406a3(args);

});
parcelRegister("5OrSA", function(module, exports) {

$parcel$export(module.exports, "fetchJson$", () => $f90c86f7d1f72b9b$export$2ba52855e389d39e);
$parcel$export(module.exports, "fetchText$", () => $f90c86f7d1f72b9b$export$64ab95a52860b608);
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $561FV = parcelRequire("561FV");

var $kVLXA = parcelRequire("kVLXA");

var $487fd = parcelRequire("487fd");

var $7f4tk = parcelRequire("7f4tk");

var $7zmUm = parcelRequire("7zmUm");
const $f90c86f7d1f72b9b$var$buildErrorResponse = (message, statusCode, traceId)=>({
        response: {
            errors: [
                {
                    errorMessage: message
                }
            ],
            reasonKey: 'generic.error',
            reasonCode: `${statusCode}`
        },
        statusCode: statusCode,
        traceId: traceId
    });
const $f90c86f7d1f72b9b$var$toAnError = (error)=>{
    const traceId = error.traceId;
    try {
        // ServiceDesk REST errors be usually be in the form of a JSON
        // object (e.g., AnError).  We'll try to parse it.
        const response = JSON.parse(error.message);
        // Normalize the shape of "simple" JSON error responses containing
        // message and status-code, as used in e.g., standard Jira
        // unauthorized response.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(response, 'message') && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(response, 'status-code')) return $f90c86f7d1f72b9b$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
        return {
            response: response,
            statusCode: error.statusCode,
            traceId: traceId
        };
    } catch (e) {
        // Message didn't parse as JSON; assume it's a plain ol' string, and
        // we'll produce an AnError-like object with it.
        return $f90c86f7d1f72b9b$var$buildErrorResponse(error.message, error.statusCode, traceId);
    }
};
const $f90c86f7d1f72b9b$export$6d71b655afe1638d = (url, opts)=>(0, $7f4tk.default)(url, opts).catch((error)=>Promise.reject($f90c86f7d1f72b9b$var$toAnError(error)));
const $f90c86f7d1f72b9b$export$2ba52855e389d39e = (url, opts)=>(0, $487fd.default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
const $f90c86f7d1f72b9b$export$64ab95a52860b608 = (url, opts)=>(0, $7zmUm.default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});

parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});



parcelRegister("bw8gL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b71ed3bdf254160$export$2e2bcd8739ae039);

var $gabFQ = parcelRequire("gabFQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b71ed3bdf254160$export$2e2bcd8739ae039 = (args)=>(0, $gabFQ.switchingFetch)(args);

});

parcelRegister("3jtVD", function(module, exports) {

$parcel$export(module.exports, "getCreateAnalyticsEvent", () => $77924e253c2e713d$export$da28c0e4cac33548);

var $a5xpi = parcelRequire("a5xpi");
const $77924e253c2e713d$export$da28c0e4cac33548 = (state)=>(0, $a5xpi.getPersisted)(state).analytic.createAnalyticsEvent;

});
parcelRegister("a5xpi", function(module, exports) {

$parcel$export(module.exports, "getPersisted", () => $fc599cf3af31b8f9$export$5239a0a7977ca4de);
$parcel$export(module.exports, "getAppProps", () => $fc599cf3af31b8f9$export$876089ea65adc54);
const $fc599cf3af31b8f9$export$5239a0a7977ca4de = (state)=>state.persisted;
const $fc599cf3af31b8f9$export$876089ea65adc54 = (state)=>state.appProps;
const $fc599cf3af31b8f9$export$180605366c04f0cd = (state)=>state.appProps.locale;

});


parcelRegister("hYrcT", function(module, exports) {

$parcel$export(module.exports, "getCurrentFilterQuery", () => $31703da3ef16426d$export$cc320d7c20cf1c31);
$parcel$export(module.exports, "getIsCurrentDataFiltered", () => $31703da3ef16426d$export$20650273aeda865c);
$parcel$export(module.exports, "getIsNewFilterQueryPending", () => $31703da3ef16426d$export$43771ef8a5224920);
$parcel$export(module.exports, "getIsFilterFocused", () => $31703da3ef16426d$export$6c44b9a0531900b1);

var $a5xpi = parcelRequire("a5xpi");
const $31703da3ef16426d$export$cc320d7c20cf1c31 = (state)=>(0, $a5xpi.getPersisted)(state).filter.filterQuery;
const $31703da3ef16426d$export$20650273aeda865c = (state)=>(0, $a5xpi.getPersisted)(state).filter.isCurrentDataFiltered;
const $31703da3ef16426d$export$43771ef8a5224920 = (state)=>(0, $a5xpi.getPersisted)(state).filter.isNewFilterQueryPending;
const $31703da3ef16426d$export$6c44b9a0531900b1 = (state)=>(0, $a5xpi.getPersisted)(state).filter.isFilterFocused;

});

parcelRegister("627A7", function(module, exports) {

$parcel$export(module.exports, "getQueuePageData", () => $02da990b8590dbc9$export$c60f26b8eba0a78a);
$parcel$export(module.exports, "getCategory", () => $02da990b8590dbc9$export$410364bbb673ddbc);
$parcel$export(module.exports, "getMetricKey", () => $02da990b8590dbc9$export$cb832de761ecab61);
$parcel$export(module.exports, "getQueueId", () => $02da990b8590dbc9$export$aed39b3e342d0167);
$parcel$export(module.exports, "getQueueName", () => $02da990b8590dbc9$export$6b633f8a8623b3f1);
$parcel$export(module.exports, "getJql", () => $02da990b8590dbc9$export$2720d348d2cbc9fe);
$parcel$export(module.exports, "getCompleteJql", () => $02da990b8590dbc9$export$6578bd82b9fd6840);
$parcel$export(module.exports, "isQueueTransient", () => $02da990b8590dbc9$export$a55400a65ac36e18);
$parcel$export(module.exports, "canManageQueue", () => $02da990b8590dbc9$export$8a3ca2900db73d42);
$parcel$export(module.exports, "getColumns", () => $02da990b8590dbc9$export$978e30a0fb8610d8);
$parcel$export(module.exports, "getColumnIds", () => $02da990b8590dbc9$export$3d88032e6be0ee47);
$parcel$export(module.exports, "getColumnType", () => $02da990b8590dbc9$export$bf02abf02e552bba);
$parcel$export(module.exports, "getColumnsInOrder", () => $02da990b8590dbc9$export$27292d0b079cd285);
$parcel$export(module.exports, "getNumberOfColumns", () => $02da990b8590dbc9$export$a3141f11a33b8412);
$parcel$export(module.exports, "getAllFieldTypes", () => $02da990b8590dbc9$export$e331c771e0c96919);
$parcel$export(module.exports, "getFetchStartIndex", () => $02da990b8590dbc9$export$4050fbf2b3dcb166);
$parcel$export(module.exports, "getCurrentQueueOrder", () => $02da990b8590dbc9$export$81ce441046ce0dc9);
$parcel$export(module.exports, "isQueueMateriallyDifferent", () => $02da990b8590dbc9$export$fd4ec8b47c12049f);

var $dGvGJ = parcelRequire("dGvGJ");

var $4Xk2W = parcelRequire("4Xk2W");

var $3HGy4 = parcelRequire("3HGy4");

var $fy6YG = parcelRequire("fy6YG");

var $oCMSG = parcelRequire("oCMSG");

var $a5xpi = parcelRequire("a5xpi");

var $jeVA9 = parcelRequire("jeVA9");
const $02da990b8590dbc9$export$c60f26b8eba0a78a = (state)=>(0, $a5xpi.getPersisted)(state).queue;
const $02da990b8590dbc9$export$410364bbb673ddbc = (state)=>$02da990b8590dbc9$export$c60f26b8eba0a78a(state).category;
const $02da990b8590dbc9$export$cb832de761ecab61 = (0, $dGvGJ.createSelector)($02da990b8590dbc9$export$410364bbb673ddbc, (category)=>category && category !== (0, $oCMSG.NO_CATEGORY) ? `servicedesk.queues.${category}.view` : 'servicedesk.queues.view');
const $02da990b8590dbc9$export$aed39b3e342d0167 = (state)=>{
    const queue = (0, $jeVA9.getCurrentQueue)(state);
    return queue ? queue.id : (0, $3HGy4.toQueueId)(-1);
};
const $02da990b8590dbc9$export$6b633f8a8623b3f1 = (state)=>{
    const queue = (0, $jeVA9.getCurrentQueue)(state);
    return queue ? queue.name : '';
};
const $02da990b8590dbc9$export$2720d348d2cbc9fe = (state)=>{
    const queue = (0, $jeVA9.getCurrentQueue)(state);
    return queue ? queue.jql : '';
};
const $02da990b8590dbc9$export$6578bd82b9fd6840 = (state)=>{
    const queue = (0, $jeVA9.getCurrentQueue)(state);
    return queue ? queue.completeJql : '';
};
const $02da990b8590dbc9$export$a55400a65ac36e18 = (state)=>{
    const queue = (0, $jeVA9.getCurrentQueue)(state);
    return !!(queue && queue.isTransient);
};
const $02da990b8590dbc9$export$8a3ca2900db73d42 = (state)=>(0, $fy6YG.getIsAdmin)(state) && !$02da990b8590dbc9$export$a55400a65ac36e18(state);
const $02da990b8590dbc9$export$978e30a0fb8610d8 = (state)=>{
    const queue = (0, $jeVA9.getCurrentQueue)(state);
    return queue ? queue.columns : [];
};
const $02da990b8590dbc9$export$3d88032e6be0ee47 = (0, $dGvGJ.createSelector)($02da990b8590dbc9$export$978e30a0fb8610d8, (columns)=>columns.map((column)=>column.id));
const $02da990b8590dbc9$export$8b87fd0c3c045ba7 = (0, $dGvGJ.createSelector)($02da990b8590dbc9$export$978e30a0fb8610d8, (columns)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(columns, 'id'));
const $02da990b8590dbc9$var$getColumnById = (state, columnId)=>$02da990b8590dbc9$export$8b87fd0c3c045ba7(state)[columnId];
const $02da990b8590dbc9$export$bf02abf02e552bba = (state, columnId)=>{
    const column = $02da990b8590dbc9$var$getColumnById(state, columnId);
    return column && column.fieldType;
};
const $02da990b8590dbc9$export$27292d0b079cd285 = (0, $dGvGJ.createSelector)($02da990b8590dbc9$export$3d88032e6be0ee47, $02da990b8590dbc9$export$8b87fd0c3c045ba7, (columnIds, columnsById)=>{
    // To prevent scenario where columnIds exist but columnsById do not
    if (columnIds.length === Object.keys(columnsById).length) {
        const checkbox = {
            id: 'checkbox',
            title: '',
            fieldType: 'checkbox',
            sortable: false
        };
        return [
            checkbox
        ].concat(columnIds.map((colId)=>columnsById[colId]));
    }
    return [];
});
const $02da990b8590dbc9$export$a3141f11a33b8412 = (state)=>$02da990b8590dbc9$export$978e30a0fb8610d8(state).length;
const $02da990b8590dbc9$export$e331c771e0c96919 = (state)=>$02da990b8590dbc9$export$978e30a0fb8610d8(state).map((column)=>column.fieldType);
const $02da990b8590dbc9$export$4050fbf2b3dcb166 = (state)=>$02da990b8590dbc9$export$c60f26b8eba0a78a(state).fetchStartIndex;
const $02da990b8590dbc9$export$81ce441046ce0dc9 = (state)=>{
    const current = (0, $jeVA9.getCurrentQueue)(state);
    return current ? current.order : -1;
};
const $02da990b8590dbc9$export$fd4ec8b47c12049f = (state, otherQueue)=>otherQueue.id !== $02da990b8590dbc9$export$aed39b3e342d0167(state) || otherQueue.jql !== $02da990b8590dbc9$export$2720d348d2cbc9fe(state) || otherQueue.columns !== $02da990b8590dbc9$export$978e30a0fb8610d8(state) || otherQueue.category !== $02da990b8590dbc9$export$410364bbb673ddbc(state);

});
parcelRegister("jeVA9", function(module, exports) {

$parcel$export(module.exports, "getCurrentQueue", () => $f144925e1ec9d4d6$export$6b47bf3b28f515da);
$parcel$export(module.exports, "getOnboardingResolved", () => $f144925e1ec9d4d6$export$edc47c0083cde3ab);
$parcel$export(module.exports, "getDeletingQueue", () => $f144925e1ec9d4d6$export$379fa75ab7e97f42);
$parcel$export(module.exports, "getDeleteModalOpen", () => $f144925e1ec9d4d6$export$fd306a625859a9fe);
$parcel$export(module.exports, "getIssueKeyContext", () => $f144925e1ec9d4d6$export$c0db69db702258b7);
$parcel$export(module.exports, "getSidebarIssueKey", () => $f144925e1ec9d4d6$export$df932d2672780b0c);
$parcel$export(module.exports, "getSidebarReactKey", () => $f144925e1ec9d4d6$export$ddbf1ddffbf956f2);
$parcel$export(module.exports, "isQueueVisible", () => $f144925e1ec9d4d6$export$acdb497766d87546);
$parcel$export(module.exports, "isInitialized", () => $f144925e1ec9d4d6$export$3f95c6f800b78024);
$parcel$export(module.exports, "isLoadingIssues", () => $f144925e1ec9d4d6$export$bd765e2c10f9e4dc);
$parcel$export(module.exports, "isQueueEmpty", () => $f144925e1ec9d4d6$export$f76a0ecd13927ba1);
$parcel$export(module.exports, "hasPageError", () => $f144925e1ec9d4d6$export$3d27fec59f3b6313);
$parcel$export(module.exports, "showIssueFailureError", () => $f144925e1ec9d4d6$export$98fc822d2fef9708);
$parcel$export(module.exports, "isRetrying", () => $f144925e1ec9d4d6$export$2d2253a53b38e901);
$parcel$export(module.exports, "shouldShowBadFilterQueryError", () => $f144925e1ec9d4d6$export$f972e8db29021436);
$parcel$export(module.exports, "isQueuesErrorHeaderDisplayed", () => $f144925e1ec9d4d6$export$4a6666492f1d4010);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $8KhWn = parcelRequire("8KhWn");

var $hYrcT = parcelRequire("hYrcT");

var $lHf6h = parcelRequire("lHf6h");
const $f144925e1ec9d4d6$var$getUIState = (state)=>state.ui;
const $f144925e1ec9d4d6$export$6b47bf3b28f515da = (state)=>$f144925e1ec9d4d6$var$getUIState(state).currentQueue;
const $f144925e1ec9d4d6$export$edc47c0083cde3ab = (state)=>$f144925e1ec9d4d6$var$getUIState(state).onboardingResolved;
const $f144925e1ec9d4d6$export$379fa75ab7e97f42 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $8KhWn.Maybe).fromNull($f144925e1ec9d4d6$var$getUIState(state).deletingQueue).orSome(false);
const $f144925e1ec9d4d6$export$fd306a625859a9fe = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $8KhWn.Maybe).fromNull($f144925e1ec9d4d6$var$getUIState(state).deleteModalOpen).orSome(false);
const $f144925e1ec9d4d6$export$c0db69db702258b7 = (state)=>$f144925e1ec9d4d6$var$getUIState(state).issueKeyContext;
const $f144925e1ec9d4d6$export$df932d2672780b0c = (state)=>$f144925e1ec9d4d6$var$getUIState(state).sidebarIssueKey;
const $f144925e1ec9d4d6$export$ddbf1ddffbf956f2 = (state)=>$f144925e1ec9d4d6$var$getUIState(state).sidebarReactKey;
const $f144925e1ec9d4d6$export$5e52d79ee962d3c1 = (state)=>$f144925e1ec9d4d6$var$getUIState(state).selectedIssueKeys;
const $f144925e1ec9d4d6$export$acdb497766d87546 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $8KhWn.Maybe).fromNull($f144925e1ec9d4d6$var$getUIState(state).isQueueVisible).orSome(true);
const $f144925e1ec9d4d6$export$3f95c6f800b78024 = (state)=>!!$f144925e1ec9d4d6$export$6b47bf3b28f515da(state);
const $f144925e1ec9d4d6$export$4814741d778a48d7 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $8KhWn.Maybe).fromNull($f144925e1ec9d4d6$var$getUIState(state).isLoadingPage).orSome(false);
const $f144925e1ec9d4d6$export$bd765e2c10f9e4dc = (state)=>(0, $8KhWn.Maybe).fromNull($f144925e1ec9d4d6$var$getUIState(state).isLoadingIssues).orSome(true) || (0, $hYrcT.getIsNewFilterQueryPending)(state);
const $f144925e1ec9d4d6$export$f76a0ecd13927ba1 = (state)=>!$f144925e1ec9d4d6$export$bd765e2c10f9e4dc(state) && (0, $lHf6h.getIssueCount)(state) === 0;
const $f144925e1ec9d4d6$var$getPageError = (state)=>(0, $8KhWn.Maybe).fromNull($f144925e1ec9d4d6$var$getUIState(state).pageError);
const $f144925e1ec9d4d6$export$3d27fec59f3b6313 = (state)=>$f144925e1ec9d4d6$var$getPageError(state).isSome();
const $f144925e1ec9d4d6$export$98fc822d2fef9708 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $8KhWn.Maybe).fromNull($f144925e1ec9d4d6$var$getUIState(state).showIssueFailureError).orSome(false);
const $f144925e1ec9d4d6$export$2d2253a53b38e901 = (state)=>$f144925e1ec9d4d6$export$3d27fec59f3b6313(state) && $f144925e1ec9d4d6$export$4814741d778a48d7(state);
const $f144925e1ec9d4d6$export$f972e8db29021436 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $8KhWn.Maybe).fromNull($f144925e1ec9d4d6$var$getUIState(state).shouldShowBadFilterQueryError).orSome(false);
const $f144925e1ec9d4d6$export$4a6666492f1d4010 = (state)=>$f144925e1ec9d4d6$var$getUIState(state).isQueuesErrorHeaderDisplayed || false;

});
parcelRegister("lHf6h", function(module, exports) {

$parcel$export(module.exports, "getIssueCount", () => $5ae4dc11c0cbada0$export$56d545f19dc75191);
$parcel$export(module.exports, "getCollection", () => $5ae4dc11c0cbada0$export$2716f3327981be5);
$parcel$export(module.exports, "getTimeWhenLastInitialized", () => $5ae4dc11c0cbada0$export$a139a3296053f37d);
$parcel$export(module.exports, "getIssueCacheSize", () => $5ae4dc11c0cbada0$export$da3bb4024398ace7);
$parcel$export(module.exports, "isFirstFieldInTable", () => $5ae4dc11c0cbada0$export$7451b0120e7484bc);
$parcel$export(module.exports, "isFieldToExperienceTrack", () => $5ae4dc11c0cbada0$export$9c6d1a54838b7308);
$parcel$export(module.exports, "getFieldPropsSelector", () => $5ae4dc11c0cbada0$export$13c62ee6bac293a0);
$parcel$export(module.exports, "getIssueStatusIdsCounts", () => $5ae4dc11c0cbada0$export$ef679118f03c956b);
$parcel$export(module.exports, "getIssueCountByAssignee", () => $5ae4dc11c0cbada0$export$337304d202b8d38e);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hm7zS = parcelRequire("hm7zS");

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");

var $6I26d = parcelRequire("6I26d");

var $82QYR = parcelRequire("82QYR");

var $cz9EJ = parcelRequire("cz9EJ");

var $k4Lqw = parcelRequire("k4Lqw");

var $a5xpi = parcelRequire("a5xpi");

var $627A7 = parcelRequire("627A7");
const $5ae4dc11c0cbada0$var$isEcClientEnabled = ()=>{
    const experiences = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $co1wz.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-inline');
};
const $5ae4dc11c0cbada0$var$STATUS_COLUMN = 'status';
const $5ae4dc11c0cbada0$var$ASSIGNEE_COLUMN = 'assignee';
const $5ae4dc11c0cbada0$var$ROWS_TO_MOUNT_EXPERIENCE_TRACKERS = 50;
const $5ae4dc11c0cbada0$var$FIELD_TYPES_TO_MOUNT_EXPERIENCE_TRACKERS = new Set([
    'status',
    'summary',
    'issuetype',
    'issuekey'
]);
const $5ae4dc11c0cbada0$var$getIssues = (state)=>(0, $a5xpi.getPersisted)(state).issues;
const $5ae4dc11c0cbada0$export$56d545f19dc75191 = (state)=>$5ae4dc11c0cbada0$var$getIssues(state).totalCount;
const $5ae4dc11c0cbada0$export$2716f3327981be5 = (state)=>$5ae4dc11c0cbada0$var$getIssues(state).collection;
const $5ae4dc11c0cbada0$var$getIssueKeys = (0, $dGvGJ.createSelector)($5ae4dc11c0cbada0$export$2716f3327981be5, (collection)=>{
    const issueKeys = [];
    collection.forEach((issue, idx)=>{
        if (issue) issueKeys[idx] = issue.key;
    });
    return issueKeys;
});
const $5ae4dc11c0cbada0$var$getIndex = (state)=>$5ae4dc11c0cbada0$var$getIssues(state).index;
const $5ae4dc11c0cbada0$export$a139a3296053f37d = (state)=>$5ae4dc11c0cbada0$var$getIssues(state).timeWhenLastInitialized;
const $5ae4dc11c0cbada0$export$da3bb4024398ace7 = (0, $dGvGJ.createSelector)($5ae4dc11c0cbada0$var$getIndex, (index)=>Object.keys(index).length);
const $5ae4dc11c0cbada0$var$doesFirstMatch = (array, expectedFirst)=>array.length > 0 && array[0] === expectedFirst;
const $5ae4dc11c0cbada0$export$7451b0120e7484bc = (state, issueKey, fieldId)=>{
    const issues = $5ae4dc11c0cbada0$var$getIssueKeys(state);
    const columns = (0, $627A7.getColumnIds)(state);
    return $5ae4dc11c0cbada0$var$doesFirstMatch(issues, issueKey) && $5ae4dc11c0cbada0$var$doesFirstMatch(columns, fieldId);
};
const $5ae4dc11c0cbada0$export$9c6d1a54838b7308 = (state, issueKey, fieldId)=>{
    const positionIndex = $5ae4dc11c0cbada0$var$getIndex(state)[issueKey];
    const columnType = (0, $627A7.getColumnType)(state, fieldId);
    const isInFirstRows = positionIndex != null && positionIndex < $5ae4dc11c0cbada0$var$ROWS_TO_MOUNT_EXPERIENCE_TRACKERS;
    const isExperienceTrackingFieldType = columnType != null && $5ae4dc11c0cbada0$var$FIELD_TYPES_TO_MOUNT_EXPERIENCE_TRACKERS.has(columnType);
    return isInFirstRows && isExperienceTrackingFieldType;
};
const $5ae4dc11c0cbada0$export$13c62ee6bac293a0 = (0, $dGvGJ.createSelector)($5ae4dc11c0cbada0$var$getIssues, (issues)=>({ issueKey: issueKey, fieldDescriptor: { fieldId: fieldId, fieldType: fieldType } }, issueFieldDispatcher)=>{
        const indexOfIssue = issues.index[issueKey];
        if (indexOfIssue >= 0) {
            const issue = issues.collection[indexOfIssue];
            if (issue && issue.key === issueKey) {
                const storedFieldValue = issue.fields[fieldId];
                const issueID = issue.id;
                if (storedFieldValue != null) {
                    // @ts-expect-error - TS7006 - Parameter 'newVal' implicitly has an 'any' type.
                    const onFieldCellChange = (newVal)=>{
                        issueFieldDispatcher(issueKey, fieldId, newVal);
                        try {
                            if ($5ae4dc11c0cbada0$var$isEcClientEnabled()) {
                                const jsisECClient = (0, $6I26d.getEcClient)();
                                const mutationObj = new (0, $82QYR.default)(issueID.toString(), (0, $cz9EJ.MutationSource).CREATE, '1', []);
                                const analyticsEventObj = {
                                    analyticsMetadata: {
                                        scenario: 'jsm-inline'
                                    }
                                };
                                jsisECClient.saveIssueMutationToCache(mutationObj, analyticsEventObj, {
                                    errorMsg: 'FAILED_JSM_INLINE',
                                    error: true
                                });
                            }
                        } catch (e) {
                            (0, $dJl1T.default).safeErrorWithoutCustomerData('jsis-ec-client', `jsm-inline-err : ${e?.toString() || ''}`);
                        }
                    };
                    return (0, $k4Lqw.transformField)(issue, storedFieldValue, fieldType, onFieldCellChange);
                }
            }
        }
        return null;
    });
const $5ae4dc11c0cbada0$export$ef679118f03c956b = (0, $dGvGJ.createSelector)($5ae4dc11c0cbada0$export$2716f3327981be5, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))(collection.map((issue)=>(0, $7uUwQ.getIn)(issue, [
            'fields',
            $5ae4dc11c0cbada0$var$STATUS_COLUMN,
            'value',
            'id'
        ])).filter((id)=>id)));
const $5ae4dc11c0cbada0$var$getIssueCountsByAssignee = (0, $dGvGJ.createSelector)($5ae4dc11c0cbada0$export$2716f3327981be5, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))(collection.map((issue)=>(0, $7uUwQ.getIn)(issue, [
            'fields',
            $5ae4dc11c0cbada0$var$ASSIGNEE_COLUMN,
            'value',
            'accountId'
        ])).filter((id)=>id)));
const $5ae4dc11c0cbada0$export$337304d202b8d38e = (state, assigneeId)=>assigneeId ? $5ae4dc11c0cbada0$var$getIssueCountsByAssignee(state)[assigneeId] || 0 : 0;

});
parcelRegister("hm7zS", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $ca2a5e84e2b42ea9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca2a5e84e2b42ea9$var$hasOwnProperty = $ca2a5e84e2b42ea9$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $ca2a5e84e2b42ea9$var$countBy = $4CZTG(function(result, value, key) {
    if ($ca2a5e84e2b42ea9$var$hasOwnProperty.call(result, key)) ++result[key];
    else $1m3dq(result, key, 1);
});
module.exports = $ca2a5e84e2b42ea9$var$countBy;

});

parcelRegister("6I26d", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $5fae311104e1f2c3$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $5fae311104e1f2c3$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $5fae311104e1f2c3$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");

var $fjcgS = parcelRequire("fjcgS");

var $eKonk = parcelRequire("eKonk");

var $cz9EJ = parcelRequire("cz9EJ");

var $iTj50 = parcelRequire("iTj50");

var $6timm = parcelRequire("6timm");
class $5fae311104e1f2c3$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $iTj50.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $iTj50.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $iTj50.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $iTj50.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $8zOmE.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $co1wz.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $iTj50.default).setBackendCache(issueMutation);
            $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $cz9EJ.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $cz9EJ.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $co1wz.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $iTj50.default).setBackendCache(issueMutations);
            $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $cz9EJ.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $cz9EJ.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $cz9EJ.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $eKonk.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $5fae311104e1f2c3$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $7f4tk.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $5fae311104e1f2c3$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $6timm.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $5fae311104e1f2c3$var$ecClient = new $5fae311104e1f2c3$export$a736992aaac2307a();
function $5fae311104e1f2c3$export$c9342bd32f51406b(tenantContext = {}) {
    $5fae311104e1f2c3$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $5fae311104e1f2c3$var$ecClient;
}
var $5fae311104e1f2c3$export$2e2bcd8739ae039 = $5fae311104e1f2c3$var$ecClient;

});
parcelRegister("cz9EJ", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $ae51bde1e2afd7bd$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $ae51bde1e2afd7bd$export$ba193b555633db78);
const $ae51bde1e2afd7bd$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $ae51bde1e2afd7bd$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("iTj50", function(module, exports) {

$parcel$export(module.exports, "default", () => $54a03fc66154e7ea$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $8Op28 = parcelRequire("8Op28");

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");

var $7f4tk = parcelRequire("7f4tk");

var $82QYR = parcelRequire("82QYR");

var $cz9EJ = parcelRequire("cz9EJ");

var $6timm = parcelRequire("6timm");
const $54a03fc66154e7ea$var$MAX_AGE_MIN = 5;
const $54a03fc66154e7ea$var$MAX_AGE = $54a03fc66154e7ea$var$MAX_AGE_MIN * 60000;
const $54a03fc66154e7ea$var$CACHE_SIZE = 100;
const $54a03fc66154e7ea$var$CACHE_KEY_PREFIX = '__storejs';
const $54a03fc66154e7ea$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $54a03fc66154e7ea$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $54a03fc66154e7ea$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $8Op28.Cache)({
            size: $54a03fc66154e7ea$var$CACHE_SIZE,
            storageType: (0, $cz9EJ.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $8Op28.Cache)({
            size: $54a03fc66154e7ea$var$CACHE_SIZE,
            storageType: (0, $cz9EJ.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID) $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID) $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.userID) $54a03fc66154e7ea$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $54a03fc66154e7ea$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$54a03fc66154e7ea$var$CACHE_KEY_PREFIX}_${this.namespace}_${$54a03fc66154e7ea$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $82QYR.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($54a03fc66154e7ea$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $54a03fc66154e7ea$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $82QYR.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($54a03fc66154e7ea$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($54a03fc66154e7ea$export$2e2bcd8739ae039.userID || '');
            (0, $7f4tk.default)($54a03fc66154e7ea$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $82QYR.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $6timm.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $6timm.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $82QYR.default)(value, (0, $cz9EJ.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $82QYR.default)(data, (0, $cz9EJ.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $co1wz.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $82QYR.default)(value, (0, $cz9EJ.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $82QYR.default)(issueId, (0, $cz9EJ.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $82QYR.default)) {
                    if ($54a03fc66154e7ea$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $82QYR.default)(String(issueId), (0, $cz9EJ.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $82QYR.default)(String(issueId), (0, $cz9EJ.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $82QYR.default)(String(issueId), (0, $cz9EJ.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $82QYR.default)(key, (0, $cz9EJ.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $82QYR.default)(data, (0, $cz9EJ.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $co1wz.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($54a03fc66154e7ea$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $54a03fc66154e7ea$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $54a03fc66154e7ea$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("8Op28", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3e46065a4b1d2500$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $3e46065a4b1d2500$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");

var $dJl1T = parcelRequire("dJl1T");


var $1NZBJ = parcelRequire("1NZBJ");
const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $1NZBJ.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, $bSSG7.createLocalStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        else storage = (0, $eNf8a.createSessionStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $dJl1T.default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $1NZBJ.default).scopes.current !== (0, $1NZBJ.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e46065a4b1d2500$var$cacheMap = {};
const $3e46065a4b1d2500$var$getCache = async (props)=>{
    await (0, $1NZBJ.scopeGuard)().catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
    return $3e46065a4b1d2500$var$cacheMap[cacheKey];
};
const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
    Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;

});
parcelRegister("eNf8a", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $b98f887ad675a269$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $b98f887ad675a269$export$e0a2e9a062c6a695);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $j9Vq5 = parcelRequire("j9Vq5");
const $b98f887ad675a269$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>(0, $fNVZf.createStorageProvider)((0, $fNVZf.WebStorageType).SessionStorage, appPrefix, (0, $j9Vq5.makeSessionStore)()));
const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $fNVZf.createExpirableStorageProvider)((0, $fNVZf.WebStorageType).SessionStorage, appPrefix, (0, $j9Vq5.makeSessionExpirableStore)());
});

});
parcelRegister("j9Vq5", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $93ac2abe604287b3$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $93ac2abe604287b3$export$a8f626c8ded9a06c);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $2NjNT = parcelRequire("2NjNT");

var $c74za = parcelRequire("c74za");

var $fNVZf = parcelRequire("fNVZf");
const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});


const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';

parcelRegister("1NZBJ", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $e0fd77b45718946f$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $e0fd77b45718946f$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $e0fd77b45718946f$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");
let $e0fd77b45718946f$var$resolveCachePromise;
const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
    $e0fd77b45718946f$var$resolveCachePromise = resolve;
});
const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
const $e0fd77b45718946f$var$TIMEOUT = 10000;
const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
const $e0fd77b45718946f$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $e0fd77b45718946f$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;

});


parcelRegister("82QYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $07dcfaa1e79d8d31$export$2e2bcd8739ae039);
class $07dcfaa1e79d8d31$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("6timm", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $9f26803814916d08$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $9f26803814916d08$export$71923bad28063cb1);

var $j8DrX = parcelRequire("j8DrX");
function $9f26803814916d08$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $9f26803814916d08$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $9f26803814916d08$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $j8DrX.default)('ajs-shard') || '',
        userId: (0, $j8DrX.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $j8DrX.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});



parcelRegister("k4Lqw", function(module, exports) {

$parcel$export(module.exports, "transformField", () => $338269cbb6619e1f$export$fbce423ada1f57a0);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $9vBS6 = parcelRequire("9vBS6");

var $efjrs = parcelRequire("efjrs");

var $hzJNc = parcelRequire("hzJNc");
const $338269cbb6619e1f$var$LOCATION = 'servicedesk.queues.selectors.fields-transformers';
const $338269cbb6619e1f$var$skipTransformer = (fieldType, field)=>{
    const errMessage = `No transformer for the field of type '${fieldType}', passing it straight to issue-table from redux`;
    (0, $jcw0u.default)({
        meta: {
            id: 'selectorsFieldsTransformers',
            packageName: 'jiraServicedeskQueuesAgentView',
            teamName: 'jsd-shield'
        },
        error: new Error(errMessage)
    });
    (0, $9vBS6.default).safeErrorWithoutCustomerData($338269cbb6619e1f$var$LOCATION, errMessage);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        // @ts-expect-error - TS2352 - Conversion of type '{ fieldId: string; value: User | null; isEditable: boolean; noJsonFieldTransformer: boolean; fieldType: string; } | { fieldId: string; value: User; isEditable: boolean; noJsonFieldTransformer: boolean; fieldType: string; } | ... 9 more ... | { ...; }' to type 'FieldDataSelectorChildrenProps' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
        noJsonFieldTransformer: true,
        fieldType: fieldType,
        ...field
    };
};
const $338269cbb6619e1f$export$fbce423ada1f57a0 = (issue, field, fieldType, storedFieldUpdater)=>{
    const htmlOverrideFieldTransformer = (0, $4R6GH.fg)('jsm_queues_ssr_migrate_status_category_styling') ? (0, $hzJNc.getHtmlOverrideFieldTransformer)(fieldType) : (0, $hzJNc.getHtmlOverrideFieldTransformerOld)(fieldType);
    if (htmlOverrideFieldTransformer) return htmlOverrideFieldTransformer(issue, field);
    // @ts-expect-error - TS2339 - Property 'fieldAsHtml' does not exist on type 'ResponseField'. | TS2339 - Property 'fieldCssClass' does not exist on type 'ResponseField'.
    if (field.fieldAsHtml != null || field.fieldCssClass != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $efjrs.htmlTransformer)(field);
    const jsonFieldTransformer = (0, $hzJNc.getJsonTransformer)(fieldType);
    if (!jsonFieldTransformer) return $338269cbb6619e1f$var$skipTransformer(fieldType, field);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const storedValue = field;
    const transformerInputParams = {
        storedValue: storedValue,
        storedFieldUpdater: storedFieldUpdater
    };
    if ((0, $4R6GH.fg)('handle-queues-column-exceptions')) {
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GenericFieldDataTransformerInput<AssigneeFieldResponse> & GenericFieldDataTransformerInput<CreatorFieldResponse> & ... 9 more ... & GenericFieldDataTransformerInput<...>'.
        const transformedFieldData = jsonFieldTransformer(transformerInputParams);
        // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'unknown'.
        const { value: responseValue } = storedValue;
        if (responseValue && responseValue.error) return {
            ...transformedFieldData,
            value: responseValue
        };
        return transformedFieldData;
    }
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GenericFieldDataTransformerInput<AssigneeFieldResponse> & GenericFieldDataTransformerInput<CreatorFieldResponse> & ... 9 more ... & GenericFieldDataTransformerInput<...>'.
    return jsonFieldTransformer(transformerInputParams);
};

});
parcelRegister("efjrs", function(module, exports) {

$parcel$export(module.exports, "htmlTransformer", () => $c473fbfa9b08af89$export$7237dba103a5f934);
const $c473fbfa9b08af89$export$7237dba103a5f934 = (storedValue)=>{
    const { fieldAsHtml: fieldRenderedValue, fieldCssClass: fieldCssClass } = storedValue;
    return {
        fieldRenderedValue: fieldRenderedValue,
        fieldCssClass: fieldCssClass
    };
};

});

parcelRegister("hzJNc", function(module, exports) {

$parcel$export(module.exports, "getJsonTransformer", () => $a7b2b2973587569c$export$437c449f44600e71);
$parcel$export(module.exports, "getHtmlOverrideFieldTransformerOld", () => $a7b2b2973587569c$export$3ce922203698bede);
$parcel$export(module.exports, "getHtmlOverrideFieldTransformer", () => $a7b2b2973587569c$export$bd0e12633e105768);

var $1jONP = parcelRequire("1jONP");

var $5OldR = parcelRequire("5OldR");

var $5M9TU = parcelRequire("5M9TU");
const $a7b2b2973587569c$var$FIELD_DATA_TRANSFORMERS = {
    assignee: (0, $5M9TU.assigneeFieldTransformer),
    creator: (0, $5M9TU.creatorFieldTransformer),
    'com.atlassian.servicedesk:sd-sla-field': (0, $5OldR.SlaFieldTransformer),
    status: (0, $5M9TU.statusFieldTransformer),
    issuetype: (0, $5M9TU.issueTypeTransformer),
    reporter: (0, $5M9TU.reporterFieldTransformer),
    summary: (0, $5M9TU.summaryFieldTransformer),
    labels: (0, $5M9TU.labelsFieldTransformer),
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': (0, $5OldR.serviceEntityFieldTransformer),
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': (0, $5OldR.cmdbFieldTransformer),
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': (0, $5OldR.respondersFieldTransformer),
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': (0, $5OldR.majorIncidentFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': (0, $5OldR.multiUserPickerTransformer),
    'com.atlassian.servicedesk:sd-request-participants': (0, $5M9TU.requestParticipantsPickerTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': (0, $5OldR.multiCheckBoxesFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': (0, $5OldR.multiSelectFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': (0, $5OldR.multiVersionFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': (0, $5OldR.multiGroupPickerTransformer),
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': (0, $5OldR.entitlementFieldTransformer),
    'com.atlassian.servicedesk.sentiment:sd-sentiment': (0, $5OldR.sentimentFieldTransformer),
    'com.atlassian.servicedesk.customer-context:sd-csm-organization': (0, $5OldR.organizationFieldTransformer)
};
const $a7b2b2973587569c$export$437c449f44600e71 = (fieldType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FieldDataTransformers'.
    const transformer = $a7b2b2973587569c$var$FIELD_DATA_TRANSFORMERS[fieldType];
    return transformer;
};
const $a7b2b2973587569c$var$HTML_OVERRIDE_TRANSFORMERS_OLD = {
    issuekey: (0, $5M9TU.issueKeyTransformer),
    priority: (0, $5M9TU.priorityTransformer)
};
const $a7b2b2973587569c$var$HTML_OVERRIDE_TRANSFORMERS = {
    issuekey: (0, $5M9TU.issueKeyTransformer),
    priority: (0, $5M9TU.priorityTransformer),
    statusCategory: (0, $5M9TU.statusCategoryTransformer)
};
const $a7b2b2973587569c$export$3ce922203698bede = (fieldType)=>(0, $1jONP.getFieldTypesToOverrideHtmlDataForAsSetOld)().has(fieldType) ? $a7b2b2973587569c$var$HTML_OVERRIDE_TRANSFORMERS_OLD[fieldType] : undefined;
const $a7b2b2973587569c$export$bd0e12633e105768 = (fieldType)=>(0, $1jONP.getFieldTypesToOverrideHtmlDataForAsSet)().has(fieldType) ? $a7b2b2973587569c$var$HTML_OVERRIDE_TRANSFORMERS[fieldType] : undefined;

});
parcelRegister("5OldR", function(module, exports) {

$parcel$export(module.exports, "SlaFieldTransformer", () => $47d21a59d3fda482$export$631ca5fe503ed873);
$parcel$export(module.exports, "serviceEntityFieldTransformer", () => $47d21a59d3fda482$export$71a2c8878bbf90c0);
$parcel$export(module.exports, "cmdbFieldTransformer", () => $47d21a59d3fda482$export$29b1e5041a029737);
$parcel$export(module.exports, "respondersFieldTransformer", () => $47d21a59d3fda482$export$7cbfbf5c2db25ae9);
$parcel$export(module.exports, "majorIncidentFieldTransformer", () => $47d21a59d3fda482$export$61023cbab62d778a);
$parcel$export(module.exports, "multiCheckBoxesFieldTransformer", () => $47d21a59d3fda482$export$ff4e3a9e8bd4c54e);
$parcel$export(module.exports, "multiSelectFieldTransformer", () => $47d21a59d3fda482$export$b2cbc32d83bc65fc);
$parcel$export(module.exports, "multiUserPickerTransformer", () => $47d21a59d3fda482$export$80f3565c0e85deed);
$parcel$export(module.exports, "multiVersionFieldTransformer", () => $47d21a59d3fda482$export$63aceefa091c51d7);
$parcel$export(module.exports, "multiGroupPickerTransformer", () => $47d21a59d3fda482$export$4ae5e1efce8cc8a3);
$parcel$export(module.exports, "entitlementFieldTransformer", () => $47d21a59d3fda482$export$38764a4ff2cdd62e);
$parcel$export(module.exports, "sentimentFieldTransformer", () => $47d21a59d3fda482$export$2a202309361bd23b);
$parcel$export(module.exports, "organizationFieldTransformer", () => $47d21a59d3fda482$export$7705af841a48f502);

var $gwejS = parcelRequire("gwejS");
var $it1wb = parcelRequire("it1wb");
var $pyK8a = parcelRequire("pyK8a");

var $dwDIK = parcelRequire("dwDIK");
var $7CMcV = parcelRequire("7CMcV");

var $dJl1T = parcelRequire("dJl1T");

var $koVbs = parcelRequire("koVbs");



var $DVljb = parcelRequire("DVljb");

var $leRCk = parcelRequire("leRCk");

var $aX4SK = parcelRequire("aX4SK");
const $47d21a59d3fda482$var$LOCATION = 'servicedesk.queues.selectors.fields-transformers.json-fields.custom-fields';
const $47d21a59d3fda482$var$checkCycleValidity = (cycle)=>{
    const { remainingTime: remainingTime, goalDuration: goalDuration, elapsedTime: elapsedTime } = cycle;
    const undefinedValues = [];
    if (!remainingTime) undefinedValues.push('remainingTime');
    if (!goalDuration) undefinedValues.push('goalDuration');
    if (!elapsedTime) undefinedValues.push('elapsedTime');
    return undefinedValues;
};
const $47d21a59d3fda482$var$isCompletedCycleValid = (cycle)=>{
    const undefinedValues = $47d21a59d3fda482$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($47d21a59d3fda482$var$LOCATION, `[FD-4303] CompletedCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $47d21a59d3fda482$var$isOngoingCycleValid = (cycle)=>{
    const undefinedValues = $47d21a59d3fda482$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($47d21a59d3fda482$var$LOCATION, `[FD-4303] OngoingCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $47d21a59d3fda482$var$getLastCompletedCycle = (completedCycles)=>{
    let lastCompletedCycle = completedCycles[0];
    completedCycles.forEach((cycle)=>{
        if (cycle.stopTime.epochMillis > lastCompletedCycle.stopTime.epochMillis) lastCompletedCycle = cycle;
    });
    return lastCompletedCycle;
};
const $47d21a59d3fda482$var$getDays = (timezone)=>{
    const date = (0, $7CMcV.default)(new Date(), timezone);
    return [
        (0, $it1wb.default)(date),
        (0, $it1wb.default)((0, $gwejS.default)(date, 1)),
        (0, $it1wb.default)((0, $pyK8a.default)(date, 1))
    ];
};
// This shall be deleted when localised time shown feature is fully rolled out
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $47d21a59d3fda482$var$getMatchingDay = (receivedDate, timezone, formatMessage)=>{
    const [today, tomorrow, yesterday] = $47d21a59d3fda482$var$getDays(timezone);
    const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
    const isToday = isSame(today, receivedDate);
    const isTomorrow = isSame(tomorrow, receivedDate);
    const isYesterday = isSame(yesterday, receivedDate);
    let defaultDayFormat = (0, $dwDIK.default)(receivedDate, 'd MMM');
    isToday && (defaultDayFormat = formatMessage((0, $aX4SK.default).today));
    isTomorrow && (defaultDayFormat = formatMessage((0, $aX4SK.default).tomorrow));
    isYesterday && (defaultDayFormat = formatMessage((0, $aX4SK.default).yesterday));
    return defaultDayFormat;
};
const $47d21a59d3fda482$export$9015300e6978c54b = (timeInEpochMillis, userTimezone, formatMessage)=>{
    if (timeInEpochMillis) {
        const breachTimeTz = (0, $7CMcV.default)(timeInEpochMillis, userTimezone);
        return `${$47d21a59d3fda482$var$getMatchingDay(breachTimeTz, userTimezone, formatMessage)} ${(0, $dwDIK.default)(breachTimeTz, 'hh:mm a', {
            timeZone: userTimezone
        })}`;
    }
    return '';
};
const $47d21a59d3fda482$export$631ca5fe503ed873 = ({ storedValue: storedValue })=>{
    const { value: responseValue } = storedValue;
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const userTimezone = loggedInUser?.timeZone || 'America/Toronto';
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $koVbs.default)();
    let locale = (0, $DVljb.useLocale)();
    if (locale === undefined) locale = 'en_US';
    const localeString = locale.replace('_', '-');
    const dateTimeFormat = new Intl.DateTimeFormat(localeString, {
        hour: 'numeric'
    });
    const isBrowserLocale24h = ()=>!dateTimeFormat.format(0).match(/[A/P]M/);
    const getMatchingDayForLocale = (receivedDate, timeInEpochMillis)=>{
        const [today, tomorrow, yesterday] = $47d21a59d3fda482$var$getDays(userTimezone);
        const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
        const isToday = isSame(today, receivedDate);
        const isTomorrow = isSame(tomorrow, receivedDate);
        const isYesterday = isSame(yesterday, receivedDate);
        let defaultDayFormat = formatDate(timeInEpochMillis, {
            timeZone: userTimezone,
            day: '2-digit',
            month: 'short'
        });
        isToday && (defaultDayFormat = formatMessage((0, $aX4SK.default).today));
        isTomorrow && (defaultDayFormat = formatMessage((0, $aX4SK.default).tomorrow));
        isYesterday && (defaultDayFormat = formatMessage((0, $aX4SK.default).yesterday));
        return defaultDayFormat;
    };
    const getTimeInSlaFriendlierFormatForLocale = (timeInEpochMillis)=>{
        if (timeInEpochMillis) {
            const breachTimeTz = (0, $7CMcV.default)(timeInEpochMillis, userTimezone);
            return `${getMatchingDayForLocale(breachTimeTz, timeInEpochMillis)} ${formatDate(timeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        }
        return '';
    };
    const getTimeRemainingInMinutes = (timeInHourSpaceMinutes)=>{
        const isTimeInMinus = timeInHourSpaceMinutes.indexOf('-') === 0;
        const absoluteTime = isTimeInMinus ? timeInHourSpaceMinutes.substring(1) : timeInHourSpaceMinutes;
        const millis = parseInt(absoluteTime, 10);
        const totalMinutes = millis / 60000;
        return isTimeInMinus ? -1 * totalMinutes : totalMinutes;
    };
    const getPercentageOfTimeTaken = (goalTime, remainingTime)=>{
        const goalTimeInMinutes = getTimeRemainingInMinutes(goalTime);
        const remainingTimeInMinutes = getTimeRemainingInMinutes(remainingTime);
        let percentage = (goalTimeInMinutes - remainingTimeInMinutes) / goalTimeInMinutes;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
        percentage = (percentage * 100).toFixed(2);
        // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
        return Math.round(parseInt(percentage, 10)).toString();
    };
    const getBreachTimeInLocalStringForLocale = (breachTimeInEpochMillis)=>{
        if (breachTimeInEpochMillis) {
            const BREACH_DATE = (0, $7CMcV.default)(breachTimeInEpochMillis, userTimezone);
            return `${formatDate(breachTimeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })} GMT${(0, $dwDIK.default)(BREACH_DATE, 'xx', {
                timeZone: userTimezone
            })}`;
        }
        return `${formatMessage((0, $aX4SK.default).notApplicable)}`;
    };
    const getHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly)=>{
        const isTimeInMinus = remainingTimeFriendly.indexOf('-') === 0;
        let remainingTimeString;
        let timeStatus;
        if (isTimeInMinus) {
            remainingTimeString = remainingTimeFriendly.substring(1);
            timeStatus = formatMessage((0, $aX4SK.default).past);
        } else {
            remainingTimeString = remainingTimeFriendly;
            timeStatus = formatMessage((0, $aX4SK.default).left);
        }
        if (closed === true) {
            timeStatus = isTimeInMinus ? formatMessage((0, $aX4SK.default).breached) : formatMessage((0, $aX4SK.default).met);
            const percentage = getPercentageOfTimeTaken(goalTimeMillis, remainingTimeMillis);
            const hoverContentCompleted = `${isTimeInMinus ? `-${remainingTimeString}` : remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${percentage}% of ${goalTimeLongFriendly} ${String.fromCodePoint(0x2022)} ${getBreachTimeInLocalStringForLocale(breachTime)}`;
            return hoverContentCompleted;
        }
        const hoverContent = `${remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${formatMessage((0, $aX4SK.default).due) ?? ''}: ${getBreachTimeInLocalStringForLocale(breachTime)}`;
        return hoverContent;
    };
    const friendlierHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly, slaDisplayFormat)=>slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? getHoverContent(closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly) : undefined;
    // @ts-expect-error - TS2339 - Property 'errorMessage' does not exist on type 'Sla | SlaError'.
    if (responseValue && responseValue.errorMessage) return {
        fieldType: (0, $d0df6a2b823cf08a$export$f790c24298ed441b),
        value: responseValue
    };
    if (responseValue && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    responseValue.ongoingCycle && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    $47d21a59d3fda482$var$isOngoingCycleValid(responseValue.ongoingCycle)) {
        const { paused: paused, remainingTime: remainingTime, breached: breached, breachTime: breachTime, goalDuration: goalDuration, elapsedTime: elapsedTime, withinCalendarHours: withinCalendarHours } = responseValue.ongoingCycle;
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $c8b70567b277fe50$export$13ecaaf97b049384);
        // When an SLA is paused due to being outside of working hours, the paused value is false
        const status = paused || !withinCalendarHours ? (0, $d0df6a2b823cf08a$export$3ad39751a33c16b8) : (0, $d0df6a2b823cf08a$export$d1917132a74c7b93);
        const timeRemainingInMinutes = Math.floor(remainingTime.millis / 60000);
        const breachTimeFriendly = breachTime ? breachTime.friendly : undefined;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(breachTime?.epochMillis).toString();
        return {
            fieldType: (0, $d0df6a2b823cf08a$export$f790c24298ed441b),
            value: {
                status: status,
                timeRemainingFriendly: slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                breachTime: breachTimeFriendly,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: withinCalendarHours,
                hoverContent: friendlierHoverContent(false, `${remainingTime.millis}`, breachTime?.epochMillis, goalDuration.millis, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    if (responseValue && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles.length !== 0) {
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $c8b70567b277fe50$export$13ecaaf97b049384);
        // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
        const lastCompletedCycle = $47d21a59d3fda482$var$getLastCompletedCycle(responseValue.completedCycles);
        if (!$47d21a59d3fda482$var$isCompletedCycleValid(lastCompletedCycle)) return {
            fieldType: (0, $d0df6a2b823cf08a$export$f790c24298ed441b)
        };
        const timeRemainingInMinutes = Math.floor(lastCompletedCycle.remainingTime.millis / 60000);
        const { remainingTime: remainingTime, breached: breached, goalDuration: goalDuration, elapsedTime: elapsedTime, stopTime: stopTime, breachTime: breachTime } = lastCompletedCycle;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(stopTime.epochMillis).toString();
        return {
            fieldType: (0, $d0df6a2b823cf08a$export$f790c24298ed441b),
            value: {
                status: (0, $d0df6a2b823cf08a$export$fc332a617fd34192),
                timeRemainingFriendly: slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                // A completed cycle doesn't have a breachTime value
                breachTime: undefined,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: undefined,
                hoverContent: friendlierHoverContent(true, `${remainingTime.millis}`, breachTime?.epochMillis, `${goalDuration.millis}`, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    return {
        fieldType: (0, $d0df6a2b823cf08a$export$f790c24298ed441b)
    };
};
const $47d21a59d3fda482$export$71a2c8878bbf90c0 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$991960fb6e9ea7dd),
        value: value ? value.map((obj)=>obj.id) : []
    });
const $47d21a59d3fda482$export$29b1e5041a029737 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$b84257e6dcaab24d),
        value: value
    });
const $47d21a59d3fda482$export$7cbfbf5c2db25ae9 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$dd2fa454b47497da),
        value: value
    });
const $47d21a59d3fda482$export$61023cbab62d778a = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$f0f60e2d773695fc),
        value: value
    });
const $47d21a59d3fda482$export$ff4e3a9e8bd4c54e = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$d8fae0f9b622e615),
        value: value || []
    });
const $47d21a59d3fda482$export$b2cbc32d83bc65fc = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$155ae54d06c908ea),
        value: value || []
    });
const $47d21a59d3fda482$export$80f3565c0e85deed = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$2ddc21f5fedfaf92),
        value: value ? value.map((user)=>({
                name: user.displayName,
                email: user.emailAddress,
                avatarUrl: user.avatarUrls['48x48']
            })) : []
    });
const $47d21a59d3fda482$export$63aceefa091c51d7 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$5ae60777f05f3dfa),
        value: value ? value.map((version)=>({
                value: version.name,
                self: version.self,
                id: version.id
            })) : []
    });
const $47d21a59d3fda482$export$4ae5e1efce8cc8a3 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$734a41c9fe85799a),
        value: value ? value.map((group)=>({
                value: group.name,
                self: group.self,
                id: group.groupId
            })) : []
    });
const $47d21a59d3fda482$export$38764a4ff2cdd62e = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$80b6ff34fe6a6e00),
        value: value
    });
const $47d21a59d3fda482$export$2a202309361bd23b = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$37cb0de8d249ef22),
        value: value
    });
const $47d21a59d3fda482$export$7705af841a48f502 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $d0df6a2b823cf08a$export$a370b4fb11e50a66),
        value: value
    });

});
const $d0df6a2b823cf08a$export$d1917132a74c7b93 = 'ONGOING';
const $d0df6a2b823cf08a$export$fc332a617fd34192 = 'COMPLETED';
const $d0df6a2b823cf08a$export$3ad39751a33c16b8 = 'PAUSED';
const $d0df6a2b823cf08a$export$f790c24298ed441b = 'com.atlassian.servicedesk:sd-sla-field';
const $d0df6a2b823cf08a$export$991960fb6e9ea7dd = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $d0df6a2b823cf08a$export$b84257e6dcaab24d = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $d0df6a2b823cf08a$export$dd2fa454b47497da = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $d0df6a2b823cf08a$export$f0f60e2d773695fc = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $d0df6a2b823cf08a$export$794539092c70e595 = 'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype';
const $d0df6a2b823cf08a$export$2ddc21f5fedfaf92 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $d0df6a2b823cf08a$export$d8fae0f9b622e615 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $d0df6a2b823cf08a$export$155ae54d06c908ea = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $d0df6a2b823cf08a$export$5ae60777f05f3dfa = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $d0df6a2b823cf08a$export$734a41c9fe85799a = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $d0df6a2b823cf08a$export$80b6ff34fe6a6e00 = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $d0df6a2b823cf08a$export$37cb0de8d249ef22 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $d0df6a2b823cf08a$export$a370b4fb11e50a66 = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';

const $c8b70567b277fe50$export$aad60a8e044b5914 = 'OLD_SLA_FORMAT';
const $c8b70567b277fe50$export$13ecaaf97b049384 = 'NEW_SLA_FORMAT';

parcelRegister("aX4SK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0914e4d2feffb5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2f0914e4d2feffb5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.title",
        "defaultMessage": "SLAs"
    },
    past: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.past",
        "defaultMessage": "past"
    },
    left: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.left",
        "defaultMessage": "left"
    },
    met: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.met",
        "defaultMessage": "met"
    },
    breached: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.breached",
        "defaultMessage": "breached"
    },
    due: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.due",
        "defaultMessage": "Due"
    },
    today: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.today",
        "defaultMessage": "Today"
    },
    tomorrow: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.tomorrow",
        "defaultMessage": "Tomorrow"
    },
    yesterday: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.yesterday",
        "defaultMessage": "Yesterday"
    },
    notApplicable: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.not-applicable",
        "defaultMessage": "Breach time not found"
    }
});

});


parcelRegister("5M9TU", function(module, exports) {

$parcel$export(module.exports, "assigneeFieldTransformer", () => $064d29a5df08e60e$export$c06a1d947706df0d);
$parcel$export(module.exports, "creatorFieldTransformer", () => $064d29a5df08e60e$export$e084c35a52aac478);
$parcel$export(module.exports, "issueKeyTransformer", () => $064d29a5df08e60e$export$f2658e11d37b4233);
$parcel$export(module.exports, "priorityTransformer", () => $064d29a5df08e60e$export$c94a7bc669e96e93);
$parcel$export(module.exports, "statusCategoryTransformer", () => $064d29a5df08e60e$export$83a524f00f1402c);
$parcel$export(module.exports, "issueTypeTransformer", () => $064d29a5df08e60e$export$fb98dd6a5625192e);
$parcel$export(module.exports, "statusFieldTransformer", () => $064d29a5df08e60e$export$72090e970546b9fd);
$parcel$export(module.exports, "reporterFieldTransformer", () => $064d29a5df08e60e$export$e3cfac85b17dd6f4);
$parcel$export(module.exports, "summaryFieldTransformer", () => $064d29a5df08e60e$export$7eadf4b26c5ed08);
$parcel$export(module.exports, "labelsFieldTransformer", () => $064d29a5df08e60e$export$6e9eafdaf42a340d);
$parcel$export(module.exports, "requestParticipantsPickerTransformer", () => $064d29a5df08e60e$export$1d7e6e4518ca808f);

var $gKZoD = parcelRequire("gKZoD");


var $4R6GH = parcelRequire("4R6GH");

var $jcw0u = parcelRequire("jcw0u");
const $064d29a5df08e60e$var$onChangeAssignee = (originalStoredValue, storedFieldUpdater)=>(issueKey, newValue)=>{
        let newValueReverseTransformed = null;
        if (newValue) {
            const { displayName: displayName, avatarUrl: avatarUrl, accountId: accountId, emailAddress: emailAddress } = newValue;
            newValueReverseTransformed = {
                displayName: displayName,
                avatarUrls: {
                    '48x48': avatarUrl
                },
                accountId: accountId,
                emailAddress: emailAddress
            };
        }
        storedFieldUpdater({
            value: newValueReverseTransformed
        }, originalStoredValue);
    };
const $064d29a5df08e60e$export$c06a1d947706df0d = ({ storedValue: storedValue, storedFieldUpdater: storedFieldUpdater })=>{
    const { isEditable: isEditable, value: responseValue } = storedValue;
    let value;
    if (responseValue) {
        const { accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: { '48x48': avatarUrl } } = responseValue;
        value = {
            displayName: displayName,
            avatarUrl: avatarUrl,
            accountId: accountId,
            emailAddress: emailAddress
        };
    }
    return {
        fieldType: 'assignee',
        value: value,
        key: responseValue ? responseValue.key : undefined,
        isEditable: isEditable,
        onChange: $064d29a5df08e60e$var$onChangeAssignee(storedValue, storedFieldUpdater)
    };
};
const $064d29a5df08e60e$export$e084c35a52aac478 = ({ storedValue: storedValue })=>{
    const { value: { accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: { '48x48': avatarUrl } } } = storedValue;
    const value = {
        displayName: displayName,
        avatarUrl: avatarUrl,
        accountId: accountId,
        emailAddress: emailAddress
    };
    return {
        fieldType: 'creator',
        value: value
    };
};
const $064d29a5df08e60e$export$f2658e11d37b4233 = (issue)=>({
        fieldType: 'issuekey',
        value: issue.key
    });
const $064d29a5df08e60e$export$c94a7bc669e96e93 = (issue)=>{
    (0, $gKZoD.di)(window);
    const parser = new DOMParser();
    // @ts-expect-error: Property 'fieldAsHtml' does not exist on type 'ResponseField'.
    const doc = parser.parseFromString(issue.fields.priority.fieldAsHtml, 'text/html');
    const priorityHtml = doc.querySelector('img');
    if (!priorityHtml) {
        // Remove when cleaning up, just for monitoring rollout
        if (typeof window !== 'undefined' && window.location.pathname.includes('/escalations') && (0, $4R6GH.fg)('jsm_cs_fix_escalations_priority_field')) (0, $jcw0u.default)({
            meta: {
                id: 'priorityTransformer',
                packageName: 'servicedeskQueuesCommon',
                teamName: 'boysenberry'
            },
            error: new Error('Priority field not in html format'),
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            fieldType: 'priority',
            value: undefined
        };
    }
    return {
        fieldType: 'priority',
        value: {
            name: priorityHtml.title,
            iconUrl: priorityHtml.src
        }
    };
};
const $064d29a5df08e60e$var$matchCssClassToStatusCategory = (cssClass)=>{
    switch(cssClass){
        case 'jira-issue-status-lozenge-green':
            return 'done';
        case 'jira-issue-status-lozenge-yellow':
            return 'inProgress';
        default:
            return 'toDo';
    }
};
const $064d29a5df08e60e$var$handleStatusCategoryTransformerError = (errorMsg)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'statusCategoryTransformer',
            packageName: 'servicedeskQueuesCommon',
            teamName: 'jsd-shield'
        },
        error: new Error(errorMsg),
        sendToPrivacyUnsafeSplunk: true
    });
    return {
        fieldType: 'statusCategory',
        value: undefined
    };
};
const $064d29a5df08e60e$export$83a524f00f1402c = (_, field)=>{
    // we are sure that if we are in this transformer that fieldAsHtml will exist
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const htmlString = field.fieldAsHtml;
    if (!htmlString) return $064d29a5df08e60e$var$handleStatusCategoryTransformerError('Status category field not found in html format');
    // the regex to capture the value in between the span tag eg. >In Progress<
    const categoryNameRegex = />(.*)</;
    const categoryName = htmlString.match(categoryNameRegex);
    // only 3 status categories exist: todo, in progress and done
    const categoryCssRegex = /jira-issue-status-lozenge-(blue-gray|yellow|green)/;
    const categoryCssMatch = htmlString.match(categoryCssRegex);
    if (!categoryName) return $064d29a5df08e60e$var$handleStatusCategoryTransformerError('Could not extract status category name from html');
    // technically we don't need to match the CSS to determine the lozenge style
    // since we know the categories are predefined already but doing it just in case
    if (!categoryCssMatch) return $064d29a5df08e60e$var$handleStatusCategoryTransformerError('Could not extract status category styles from html');
    return {
        fieldType: 'statusCategory',
        value: {
            name: categoryName[1],
            category: $064d29a5df08e60e$var$matchCssClassToStatusCategory(categoryCssMatch[0])
        }
    };
};
const $064d29a5df08e60e$var$onChangeStatus = (originalStoredValue, storedFieldUpdater)=>(issueKey, newValue)=>{
        let newValueReverseTransformed = null;
        const { description: description, name: name, id: id, statusCategory: { id: statusCategoryId } } = newValue;
        newValueReverseTransformed = {
            id: id,
            description: description,
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        };
        storedFieldUpdater({
            value: newValueReverseTransformed
        }, originalStoredValue);
    };
const $064d29a5df08e60e$export$fb98dd6a5625192e = ({ storedValue: storedValue })=>{
    const { value: { name: name, iconUrl: iconUrl, description: description } } = storedValue;
    const value = {
        name: name,
        iconUrl: iconUrl,
        description: description
    };
    return {
        fieldType: 'issuetype',
        value: value
    };
};
const $064d29a5df08e60e$export$72090e970546b9fd = ({ storedValue: storedValue, storedFieldUpdater: storedFieldUpdater })=>{
    const { value: { id: id, name: name, description: description, statusCategory: { id: statusCategoryId } }, isEditable: isEditable } = storedValue;
    const value = {
        id: id,
        name: name,
        description: description,
        statusCategory: {
            id: statusCategoryId
        }
    };
    return {
        key: value.id.toString(),
        fieldType: 'status',
        value: value,
        onChange: $064d29a5df08e60e$var$onChangeStatus(storedValue, storedFieldUpdater),
        isEditable: isEditable
    };
};
const $064d29a5df08e60e$export$e3cfac85b17dd6f4 = ({ storedValue: storedValue })=>{
    const { value: value } = storedValue;
    if (!value) return {
        fieldType: 'reporter',
        value: null
    };
    const { displayName: displayName, emailAddress: emailAddress, active: active } = value;
    const transformedValue = {
        displayName: displayName,
        emailAddress: emailAddress,
        active: !!active
    };
    return {
        fieldType: 'reporter',
        value: transformedValue
    };
};
const $064d29a5df08e60e$export$7eadf4b26c5ed08 = ({ storedValue: storedValue })=>({
        fieldType: 'summary',
        value: storedValue.value
    });
const $064d29a5df08e60e$export$6e9eafdaf42a340d = ({ storedValue: storedValue })=>({
        fieldType: 'labels',
        value: storedValue.value.map((label)=>({
                name: label,
                href: `/issues/?jql=labels+%3D+${label}`
            }))
    });
const $064d29a5df08e60e$export$1d7e6e4518ca808f = ({ storedValue: { value: value } })=>({
        fieldType: (0, $ff417e86d915450f$export$e918afe651ac9e7a),
        value: value ? value.map((user)=>({
                name: user.displayName,
                email: user.emailAddress,
                avatarUrl: user.avatarUrls['48x48']
            })) : []
    });

});
const $ff417e86d915450f$export$e918afe651ac9e7a = 'com.atlassian.servicedesk:sd-request-participants';







parcelRegister("h4yk3", function(module, exports) {

$parcel$export(module.exports, "getSortedByColumn", () => $4608ed20aa1f7ba7$export$89e3e8c1d19874d1);
$parcel$export(module.exports, "getSortFieldType", () => $4608ed20aa1f7ba7$export$8d69ea9f7db079ef);
$parcel$export(module.exports, "getSortOrder", () => $4608ed20aa1f7ba7$export$c11dbba94a24125);
$parcel$export(module.exports, "isManuallySorted", () => $4608ed20aa1f7ba7$export$abe45b95ac16d893);
$parcel$export(module.exports, "getIsAscendingOrder", () => $4608ed20aa1f7ba7$export$19e36eff55595869);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $8KhWn = parcelRequire("8KhWn");


var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");
const $4608ed20aa1f7ba7$var$maybeManualSorting = (state)=>{
    const queue = (0, $jeVA9.getCurrentQueue)(state);
    return (0, $8KhWn.Maybe).fromNull(queue && queue.manualSorting || (0, $627A7.getQueuePageData)(state).manualSorting);
};
const $4608ed20aa1f7ba7$export$89e3e8c1d19874d1 = (state)=>$4608ed20aa1f7ba7$var$maybeManualSorting(state)// @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    .map((manualSorting)=>manualSorting.sortedBy).orSome(undefined);
const $4608ed20aa1f7ba7$export$8d69ea9f7db079ef = (state)=>{
    const sortedColumn = (0, $627A7.getColumns)(state).find((column)=>Boolean(column.currentSorting));
    return sortedColumn ? sortedColumn.fieldType : undefined;
};
const $4608ed20aa1f7ba7$export$c11dbba94a24125 = (state)=>$4608ed20aa1f7ba7$var$maybeManualSorting(state)// @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    .map((manualSorting)=>manualSorting.sortOrder).orSome((0, $ff4189e925fd251d$export$1dee026a19752d6b));
const $4608ed20aa1f7ba7$export$abe45b95ac16d893 = (state)=>$4608ed20aa1f7ba7$export$89e3e8c1d19874d1(state) !== undefined;
const $4608ed20aa1f7ba7$export$19e36eff55595869 = (state)=>$4608ed20aa1f7ba7$export$c11dbba94a24125(state) === (0, $ff4189e925fd251d$export$1dee026a19752d6b);

});
const $ff4189e925fd251d$export$1dee026a19752d6b = 'ASC';
const $ff4189e925fd251d$export$b6abcf7fa1d94f65 = 'DESC';
const $ff4189e925fd251d$export$c53d0f541b41b88e = 'NONE';


parcelRegister("7uXM1", function(module, exports) {

$parcel$export(module.exports, "getSsrIssueList", () => $3d6beb8b65f015fd$export$b00c26bb659fae04);
$parcel$export(module.exports, "getIsInitialLoad", () => $3d6beb8b65f015fd$export$f4ff973e05a3a506);
$parcel$export(module.exports, "getSsrIssuesError", () => $3d6beb8b65f015fd$export$7d0b4d99fd869d11);
const $3d6beb8b65f015fd$export$b00c26bb659fae04 = (state)=>state.persisted.ssrIssuesData?.ssrIssueList;
const $3d6beb8b65f015fd$export$f4ff973e05a3a506 = (state)=>state.persisted.ssrIssuesData?.isInitialLoading;
const $3d6beb8b65f015fd$export$7d0b4d99fd869d11 = (state)=>state.persisted.ssrIssuesData?.error;

});

parcelRegister("k3elp", function(module, exports) {

$parcel$export(module.exports, "getProjectStateHash", () => $1485f6cce1b97173$export$6b15279c446fd00d);
$parcel$export(module.exports, "getIssueHash", () => $1485f6cce1b97173$export$57f7822280b6c408);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $8KhWn = parcelRequire("8KhWn");

var $a5xpi = parcelRequire("a5xpi");
const $1485f6cce1b97173$var$maybeUpdateMetadata = (state)=>(0, $8KhWn.Maybe).fromNull((0, $a5xpi.getPersisted)(state).updateMetadata);
const $1485f6cce1b97173$export$6b15279c446fd00d = (state)=>$1485f6cce1b97173$var$maybeUpdateMetadata(state)// @ts-expect-error - TS7006 - Parameter 'updateMetadata' implicitly has an 'any' type.
    .flatMap((updateMetadata)=>(0, $8KhWn.Maybe).fromNull(updateMetadata.projectStateHash)).orSome('');
const $1485f6cce1b97173$export$57f7822280b6c408 = (state)=>$1485f6cce1b97173$var$maybeUpdateMetadata(state)// @ts-expect-error - TS7006 - Parameter 'updateMetadata' implicitly has an 'any' type.
    .flatMap((updateMetadata)=>(0, $8KhWn.Maybe).fromNull(updateMetadata.issueHash)).orSome('');

});

parcelRegister("CWMfa", function(module, exports) {

$parcel$export(module.exports, "storeSortOrderInLocalStorage", () => $3f96937ea2f3ded4$export$70ad8071224202a8);
$parcel$export(module.exports, "removeSortOrderInLocalStorage", () => $3f96937ea2f3ded4$export$27624a2b25e61084);
$parcel$export(module.exports, "addSortingToQueues", () => $3f96937ea2f3ded4$export$406ba23a25949900);
$parcel$export(module.exports, "createSortedQueue", () => $3f96937ea2f3ded4$export$e8964ed223410f32);

var $7uUwQ = parcelRequire("7uUwQ");

var $1sWm7 = parcelRequire("1sWm7");

var $jSYEh = parcelRequire("jSYEh");

var $8KhWn = parcelRequire("8KhWn");

var $jcw0u = parcelRequire("jcw0u");


var $8zOmE = parcelRequire("8zOmE");

var $9vBS6 = parcelRequire("9vBS6");

var $3HGy4 = parcelRequire("3HGy4");

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");

// remove with ff cleanup `clean_local_storage_sorting`
const $3f96937ea2f3ded4$var$getKey = (queueId)=>`${0, $3ce1d25fa44e4264$export$380a2d1eea3be734}${queueId}`;
const $3f96937ea2f3ded4$export$aa821bfb3308a1f5 = (0, $bSSG7.createLocalStorageProvider)('servicedesk_queues');
const $3f96937ea2f3ded4$export$70ad8071224202a8 = (queueId, fieldId, sortOrder)=>{
    try {
        if ((0, $4R6GH.fg)('jsm_queue_localstorage_compliance')) {
            $3f96937ea2f3ded4$export$aa821bfb3308a1f5.set($3f96937ea2f3ded4$var$getKey((0, $3HGy4.fromQueueId)(queueId).toString()), {
                fieldId: fieldId,
                sortOrder: sortOrder
            });
            return;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.localStorage.setItem($3f96937ea2f3ded4$var$getKey((0, $3HGy4.fromQueueId)(queueId).toString()), JSON.stringify({
            fieldId: fieldId,
            sortOrder: sortOrder
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        const errMessage = 'Local storage failure for sorting';
        (0, $jcw0u.default)({
            meta: {
                id: 'servicesSort',
                packageName: 'jiraServicedeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            attributes: {
                type: 'localStorageFull'
            },
            error: new Error(errMessage)
        });
        (0, $9vBS6.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.services', errMessage);
    }
};
const $3f96937ea2f3ded4$export$27624a2b25e61084 = (queueId)=>{
    try {
        if ((0, $4R6GH.fg)('jsm_queue_localstorage_compliance')) {
            $3f96937ea2f3ded4$export$aa821bfb3308a1f5.remove($3f96937ea2f3ded4$var$getKey((0, $3HGy4.fromQueueId)(queueId).toString()));
            return;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.localStorage.removeItem($3f96937ea2f3ded4$var$getKey((0, $3HGy4.fromQueueId)(queueId).toString()));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        const errMessage = 'Local storage deletion failure for sorting';
        (0, $jcw0u.default)({
            meta: {
                id: 'servicesSortLocalstorageDelete',
                packageName: 'jiraServiceDeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            attributes: {
                type: 'localStorageDelete'
            },
            error: new Error(errMessage)
        });
        (0, $9vBS6.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.services', errMessage);
    }
};
const $3f96937ea2f3ded4$export$b0fb563b02669fb1 = (queueId, createAnalyticsEvent)=>{
    try {
        let stored = null;
        if ((0, $4R6GH.fg)('jsm_queue_localstorage_compliance')) stored = $3f96937ea2f3ded4$export$aa821bfb3308a1f5.get($3f96937ea2f3ded4$var$getKey(queueId)) ? JSON.stringify($3f96937ea2f3ded4$export$aa821bfb3308a1f5.get($3f96937ea2f3ded4$var$getKey(queueId))) : null;
        else stored = typeof window !== 'undefined' ? window.localStorage.getItem($3f96937ea2f3ded4$var$getKey(queueId)) : null;
        if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueuesSortingFromLocalStorage updated', {
            hasSorting: stored !== null
        });
        if (stored !== null) {
            const storedSortOrder = JSON.parse(stored);
            if (storedSortOrder.fieldId && storedSortOrder.fieldId.length > 0 && (storedSortOrder.sortOrder === (0, $ff4189e925fd251d$export$1dee026a19752d6b) || storedSortOrder.sortOrder === (0, $ff4189e925fd251d$export$b6abcf7fa1d94f65))) return (0, $8KhWn.Maybe).of({
                sortedBy: storedSortOrder.fieldId,
                sortOrder: storedSortOrder.sortOrder
            });
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        const errMessage = 'Local storage for sorting getItem failure';
        (0, $jcw0u.default)({
            meta: {
                id: 'servicesSortLocalstorageGet',
                packageName: 'jiraServiceDeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            attributes: {
                type: 'localStorageGet'
            },
            error: new Error(errMessage)
        });
        (0, $9vBS6.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.services', errMessage);
    }
    return (0, $8KhWn.Maybe).None();
};
const $3f96937ea2f3ded4$var$applyManualSortingToColumns = (columns, manualSorting)=>columns.map((column)=>{
        if (column.id === manualSorting.sortedBy) return (0, $7uUwQ.assoc)(column, 'currentSorting', manualSorting.sortOrder);
        return (0, $7uUwQ.dissoc)(column, 'currentSorting');
    });
const $3f96937ea2f3ded4$export$bdc8ae2ac7632444 = (queue, maybeManualSorting)=>maybeManualSorting.cata(()=>queue, // @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    (manualSorting)=>(0, $7uUwQ.updateIn)(queue, [
            'columns'
        ], (columns)=>// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Column[]'.
            $3f96937ea2f3ded4$var$applyManualSortingToColumns(columns, manualSorting)));
const $3f96937ea2f3ded4$var$addSortingToQueuesInternal = (currentQueueId, queues)=>// @ts-expect-error - TS2322 - Type '[string, SortedQueue]' is not assignable to type 'SortedQueues'. | TS2345 - Argument of type '(acc: Record<string, any>, [queueId, queue]: [number, Queue]) => Record<string, any>' is not assignable to parameter of type '(previousValue: Record<string, any>, currentValue: [string, SortedQueue], currentIndex: number, array: [string, SortedQueue][]) => Record<string, any>'. | TS2304 - Cannot find name 'Queue'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, (/*@__PURE__*/$parcel$interopDefault($jSYEh)))(queues).reduce((acc, [queueId, queue])=>{
        const maybeManualSorting = $3f96937ea2f3ded4$export$b0fb563b02669fb1(String(queueId));
        const newQueue = $3f96937ea2f3ded4$export$bdc8ae2ac7632444(queue, maybeManualSorting);
        acc[queueId] = newQueue;
        return acc;
    }, {});
const $3f96937ea2f3ded4$export$406ba23a25949900 = (currentQueueId, queues)=>{
    const updatedQueues = $3f96937ea2f3ded4$var$addSortingToQueuesInternal(currentQueueId, queues);
    const currentQueueIdString = (0, $3HGy4.fromQueueId)(currentQueueId).toString();
    if (!updatedQueues[currentQueueIdString]) return {
        queues: updatedQueues
    };
    const manualSortColumn = updatedQueues[currentQueueIdString].columns.find((column)=>column.currentSorting);
    if (!manualSortColumn || !manualSortColumn.currentSorting) return {
        queues: updatedQueues
    };
    return {
        queues: updatedQueues,
        manualSorting: {
            sortedBy: manualSortColumn.id,
            sortOrder: manualSortColumn.currentSorting
        }
    };
};
// SHIELD-3415 Methods used by queue quality only
const $3f96937ea2f3ded4$var$createQueueFromManualSorting = (queue, manualSorting)=>{
    const { columns: columns } = queue;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(columns, {
        id: manualSorting.sortedBy
    })) return {
        ...queue,
        columns: $3f96937ea2f3ded4$var$applyManualSortingToColumns(columns, manualSorting),
        manualSorting: manualSorting
    };
    return queue;
};
const $3f96937ea2f3ded4$export$e8964ed223410f32 = (queue, createAnalyticsEvent)=>$3f96937ea2f3ded4$export$b0fb563b02669fb1((0, $3HGy4.fromQueueIdString)(queue.id), createAnalyticsEvent).cata(()=>queue, // @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    (manualSorting)=>{
        const sortedQueue = $3f96937ea2f3ded4$var$createQueueFromManualSorting(queue, manualSorting);
        if (!sortedQueue.manualSorting) $3f96937ea2f3ded4$export$27624a2b25e61084(sortedQueue.id);
        return sortedQueue;
    });

});
parcelRegister("jSYEh", function(module, exports) {

var $i8saS = parcelRequire("i8saS");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */ var $e7a21b07870b5d21$var$toPairs = $i8saS($66FNL);
module.exports = $e7a21b07870b5d21$var$toPairs;

});
parcelRegister("i8saS", function(module, exports) {

var $ePDPz = parcelRequire("ePDPz");

var $jtBGw = parcelRequire("jtBGw");

var $f1B3k = parcelRequire("f1B3k");

var $cir7h = parcelRequire("cir7h");
/** `Object#toString` result references. */ var $d33ed43950bf1011$var$mapTag = '[object Map]', $d33ed43950bf1011$var$setTag = '[object Set]';
/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */ function $d33ed43950bf1011$var$createToPairs(keysFunc) {
    return function(object) {
        var tag = $jtBGw(object);
        if (tag == $d33ed43950bf1011$var$mapTag) return $f1B3k(object);
        if (tag == $d33ed43950bf1011$var$setTag) return $cir7h(object);
        return $ePDPz(object, keysFunc(object));
    };
}
module.exports = $d33ed43950bf1011$var$createToPairs;

});
parcelRegister("ePDPz", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");
/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */ function $acc4b9adaa827983$var$baseToPairs(object, props) {
    return $1nIHN(props, function(key) {
        return [
            key,
            object[key]
        ];
    });
}
module.exports = $acc4b9adaa827983$var$baseToPairs;

});

parcelRegister("cir7h", function(module, exports) {
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */ function $8f3c33364ffffb3b$var$setToPairs(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = [
            value,
            value
        ];
    });
    return result;
}
module.exports = $8f3c33364ffffb3b$var$setToPairs;

});



// SORT_PREFIX needs to be kept consistent with what prefetcher uses
// remove with ff cleanup `clean_local_storage_sorting`
const $3ce1d25fa44e4264$export$380a2d1eea3be734 = 'QUEUE_ORDER_BY_';


parcelRegister("lPEsb", function(module, exports) {

$parcel$export(module.exports, "storeIssuesInLocalStorage", () => $1bef23d0613709d4$export$265b10942ef9ca4d);
$parcel$export(module.exports, "maybeIssuesInLocalStorage", () => $1bef23d0613709d4$export$889a3e4f0169c0d7);
$parcel$export(module.exports, "getIssuesInLocalStorage", () => $1bef23d0613709d4$export$a260c6806177a9f6);

var $k8IPx = parcelRequire("k8IPx");

var $ajpes = parcelRequire("ajpes");

var $8KhWn = parcelRequire("8KhWn");

var $kVLXA = parcelRequire("kVLXA");

var $x9xyg = parcelRequire("x9xyg");

var $8zOmE = parcelRequire("8zOmE");

var $1jONP = parcelRequire("1jONP");

var $3HGy4 = parcelRequire("3HGy4");

var $jJBxp = parcelRequire("jJBxp");

var $5j0B5 = parcelRequire("5j0B5");

var $4R6GH = parcelRequire("4R6GH");

var $SEV5o = parcelRequire("SEV5o");
const $1bef23d0613709d4$var$ISSUES_KEY = 'issues';
const $1bef23d0613709d4$var$getLocalStorageData = (queueId)=>(0, $8KhWn.Maybe).fromNull((0, $5j0B5.getFromLocalStorage)(`${$1bef23d0613709d4$var$ISSUES_KEY}_${(0, $3HGy4.fromQueueId)(queueId)}`));
const $1bef23d0613709d4$var$localStorageMatchesIssueListResponse = (localStorage, issueListResponse, jql, sortedBy, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
sortOrder)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(localStorage.jql, jql) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(localStorage.issueListResponse.issueHash, issueListResponse.issueHash) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(localStorage.issueListResponse.columns, issueListResponse.columns) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(localStorage.sortedBy, sortedBy) && (!sortedBy || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(localStorage.sortOrder, sortOrder));
const $1bef23d0613709d4$export$265b10942ef9ca4d = (issueListResponse, jql, queueId, sortedBy, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
sortOrder, isUpdate, createAnalyticsEvent)=>{
    if (!isUpdate) {
        const localStorageData = $1bef23d0613709d4$var$getLocalStorageData(queueId);
        const hasData = localStorageData.isSome();
        const hasLatestData = localStorageData.cata(()=>false, // @ts-expect-error - TS7006 - Parameter 'localStorage' implicitly has an 'any' type.
        (localStorage)=>$1bef23d0613709d4$var$localStorageMatchesIssueListResponse(localStorage, issueListResponse, jql, sortedBy, sortOrder));
        if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueuesLocalStorageData updated', {
            hasData: hasData,
            hasLatestData: hasLatestData
        });
    }
    (0, $5j0B5.setInLocalStorage)(`${$1bef23d0613709d4$var$ISSUES_KEY}_${(0, $3HGy4.fromQueueId)(queueId)}`, {
        jql: jql,
        issueListResponse: issueListResponse,
        jsonColumns: (0, $1jONP.getFieldTypesEligibleForJsonData)(),
        sortedBy: sortedBy,
        sortOrder: sortOrder
    });
};
const $1bef23d0613709d4$var$checkIfSortingInfoMatches = (localStorageSortedBy, localStorageSortOrder, sortedBy, sortOrder)=>{
    if ((0, $4R6GH.fg)('clean_local_storage_sorting')) return true;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(localStorageSortedBy, sortedBy) && (!sortedBy || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(localStorageSortOrder, sortOrder));
};
const $1bef23d0613709d4$var$localStorageMatchesStore = (localStorage, jql, columns, columnTypesAsJson, sortedBy, sortOrder, isSourceFromSort = false)=>{
    // when clean_local_storage_sorting is on we are still comparing the columns but disregard the sorting
    // also cache match logic determines the show of the UI loading in case of sort update
    const isColumnsMatch = !isSourceFromSort && (0, $4R6GH.fg)('clean_local_storage_sorting') ? (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))((0, $jJBxp.transformColumnsByRemoveSortOrder)(localStorage.issueListResponse.columns), (0, $jJBxp.removeSortingFromColumns)(columns)) : (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))((0, $jJBxp.transformColumns)(localStorage.issueListResponse.columns), columns);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(localStorage.jql, jql) && isColumnsMatch && (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(localStorage.jsonColumns, columnTypesAsJson).length === 0 && $1bef23d0613709d4$var$checkIfSortingInfoMatches(localStorage.sortedBy, localStorage.sortOrder, sortedBy, sortOrder);
};
const $1bef23d0613709d4$var$maybeIssuesInLocalStorageInternal = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort)=>{
    try {
        return $1bef23d0613709d4$var$getLocalStorageData(queueId)// @ts-expect-error - TS7006 - Parameter 'localStorage' implicitly has an 'any' type.
        .map((localStorage)=>{
            if ($1bef23d0613709d4$var$localStorageMatchesStore(localStorage, jql, columns, columnTypesAsJson, sortedBy, sortOrder, isSourceFromSort)) {
                (0, $x9xyg.setMark)('jsd.performance.profile.queues.localstorage.received');
                return (0, $8KhWn.Maybe).Some((0, $SEV5o.default)(localStorage.issueListResponse, (0, $3HGy4.LOCAL_STORAGE_SOURCE), filterQuery !== null, false));
            }
            return (0, $8KhWn.Maybe).None();
        }).orSome((0, $8KhWn.Maybe).None());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return (0, $8KhWn.Maybe).None();
    }
};
const $1bef23d0613709d4$export$889a3e4f0169c0d7 = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort)=>{
    const maybeIssueList = $1bef23d0613709d4$var$maybeIssuesInLocalStorageInternal(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort);
    return maybeIssueList;
};
const $1bef23d0613709d4$export$a260c6806177a9f6 = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort)=>$1bef23d0613709d4$export$889a3e4f0169c0d7(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort).cata((0, $kVLXA.Observable).empty, (0, $kVLXA.Observable).of);

});
parcelRegister("SEV5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef6761450abe0fe$export$2e2bcd8739ae039);

var $jJBxp = parcelRequire("jJBxp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ef6761450abe0fe$export$2e2bcd8739ae039 = (issueListResponse, source, isFilterRequested, isFiltered)=>({
        issues: (0, $jJBxp.transformIssues)(issueListResponse.issues),
        issueHash: issueListResponse.issueHash,
        totalCount: issueListResponse.total,
        columns: (0, $jJBxp.transformColumns)(issueListResponse.columns),
        isUsingDefaultSorting: issueListResponse.isUsingDefaultSorting,
        source: source,
        isFilterRequested: isFilterRequested,
        isFiltered: isFiltered
    });

});


parcelRegister("1mTCA", function(module, exports) {

$parcel$export(module.exports, "sendIssuelistStalenessAnalytics", () => $ccab27ffd9b204a2$export$63318741cbb194f3);
$parcel$export(module.exports, "fireInitialLoadSsrAnalyticEventWithState", () => $ccab27ffd9b204a2$export$6ef7fec9c936098);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $g9E9n = parcelRequire("g9E9n");

var $3jtVD = parcelRequire("3jtVD");
const $ccab27ffd9b204a2$var$STALENESS_THRESHOLD_FOR_FETCH = 3600000;
const $ccab27ffd9b204a2$var$STALENESS_THRESHOLD_FOR_UPDATE = 180000;
// @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
const $ccab27ffd9b204a2$var$fireManualOperationalAnalytics = (payload)=>(0, $g9E9n.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $ccab27ffd9b204a2$export$63318741cbb194f3 = (result, isUpdate)=>{
    const { metadata: metadata } = result;
    const currentTimeInMs = Date.now();
    const delayInMs = currentTimeInMs - metadata.lastUpdatedTimeInMs;
    const thresholdInMs = isUpdate ? $ccab27ffd9b204a2$var$STALENESS_THRESHOLD_FOR_UPDATE : $ccab27ffd9b204a2$var$STALENESS_THRESHOLD_FOR_FETCH;
    const jiraShard = (0, $j8DrX.default)('ajs-shard') || '';
    $ccab27ffd9b204a2$var$fireManualOperationalAnalytics({
        source: 'viewQueueScreen',
        actionSubject: 'issuelist',
        action: isUpdate ? 'updated' : 'fetched',
        attributes: {
            issuelistStale: delayInMs > thresholdInMs,
            delayInMs: delayInMs,
            currentTimeInMs: currentTimeInMs,
            thresholdInMs: thresholdInMs,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            browserTabVisibilityState: document.visibilityState,
            jiraShard: jiraShard,
            ...metadata
        }
    });
};
const $ccab27ffd9b204a2$export$6ef7fec9c936098 = (state)=>{
    return (event)=>{
        if (!(0, $4R6GH.fg)('jsm_flash_issuelist_analytics')) return;
        const createAnalyticsEvent = (0, $3jtVD.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `jsmIssueList ${event}`, {});
    };
};

});

const $0c916c88508aa500$export$c1927396d6c152eb = 'initialLoadAll';
const $0c916c88508aa500$export$5b6950a89e720fb7 = 'initialLoadSsrHit';
const $0c916c88508aa500$export$932d8e2bf11ecc3d = 'initialLoadSsrError';
const $0c916c88508aa500$export$7f8de25485f27a39 = 'initialLoadSsrTimeoutError';
const $0c916c88508aa500$export$431f43d5c108aa95 = 'initialLoadCacheHit';
const $0c916c88508aa500$export$57138ddc6df757ce = 'initialLoadBrowserIssueListFetch';


parcelRegister("jdGLR", function(module, exports) {

$parcel$export(module.exports, "TABLE_CHANGED", () => $81e986267dbf0fe2$export$68b362e6b981d575);
$parcel$export(module.exports, "tableChangedAction", () => $81e986267dbf0fe2$export$3c516629fbb0d924);
$parcel$export(module.exports, "activeItemChangedAction", () => $81e986267dbf0fe2$export$ce58420b2705f9ee);
$parcel$export(module.exports, "activeItemRemovedAction", () => $81e986267dbf0fe2$export$42120e4638639b68);
$parcel$export(module.exports, "PAGE_CHANGED", () => $81e986267dbf0fe2$export$e09b596b5ad52fee);
$parcel$export(module.exports, "pageChangedAction", () => $81e986267dbf0fe2$export$ef479dcaff4dd067);
$parcel$export(module.exports, "SORT_ORDER_CHANGED", () => $81e986267dbf0fe2$export$25e584dfc9e3eff4);
$parcel$export(module.exports, "sortOrderChangedAction", () => $81e986267dbf0fe2$export$6053015c901f4a6f);
$parcel$export(module.exports, "SORT_ORDER_OPTIMISTIC_UPDATE", () => $81e986267dbf0fe2$export$acc4e88a28a7b0a0);
$parcel$export(module.exports, "sortOrderOptimisticUpdateAction", () => $81e986267dbf0fe2$export$fc03e6e4f23c5a8f);
$parcel$export(module.exports, "SORT_ORDER_OPTIMISTIC_RESET", () => $81e986267dbf0fe2$export$533ed746a3d5dc9c);
$parcel$export(module.exports, "sortOrderOptimisticResetAction", () => $81e986267dbf0fe2$export$c1c6e7ee5582b9c8);
$parcel$export(module.exports, "SORT_ORDER_ON_LOAD", () => $81e986267dbf0fe2$export$d4e7f6a156826402);
$parcel$export(module.exports, "sortOrderOnLoadAction", () => $81e986267dbf0fe2$export$d2ecbc20e3155b0f);
$parcel$export(module.exports, "RESET_SORT_ORDER", () => $81e986267dbf0fe2$export$2f4dfac96c2f056a);
$parcel$export(module.exports, "resetSortOrderAction", () => $81e986267dbf0fe2$export$203744a3e48fd32);
$parcel$export(module.exports, "TOGGLE_QUEUE_HEADER", () => $81e986267dbf0fe2$export$4ee6cf3ac95ffd6f);
$parcel$export(module.exports, "toggleQueueHeaderAction", () => $81e986267dbf0fe2$export$246f86636f1800cd);
$parcel$export(module.exports, "FETCH_ISSUE_DATA_ONSCROLL", () => $81e986267dbf0fe2$export$5b6c833dfdf472fa);
$parcel$export(module.exports, "fetchIssueDataOnScrollAction", () => $81e986267dbf0fe2$export$1ebcd0c4bc8d1a17);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_FETCH_WARNING", () => $81e986267dbf0fe2$export$b01127fa720badfd);
$parcel$export(module.exports, "displayUnsuccessfulFetchWarningAction", () => $81e986267dbf0fe2$export$533da0160b901b24);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_FETCH_ERROR", () => $81e986267dbf0fe2$export$9288a47530ff1e41);
$parcel$export(module.exports, "displayUnsuccessfulFetchErrorOnScrollAction", () => $81e986267dbf0fe2$export$9af7482c09c5cf94);
$parcel$export(module.exports, "UPDATE_SORTING_INFO_IN_USER_PROPERTY", () => $81e986267dbf0fe2$export$3858906dc81c7152);
$parcel$export(module.exports, "updateSortingInfoInUserPropertyAction", () => $81e986267dbf0fe2$export$165448dd459ec76e);
const $81e986267dbf0fe2$export$68b362e6b981d575 = 'state.actions.table.TABLE_CHANGED';
const $81e986267dbf0fe2$export$3c516629fbb0d924 = (analyticsEvent)=>({
        type: $81e986267dbf0fe2$export$68b362e6b981d575,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $81e986267dbf0fe2$export$bf878f94e95fcc5d = 'state.actions.table.ACTIVE_ITEM_CHANGED';
const $81e986267dbf0fe2$export$ce58420b2705f9ee = (rowId, colId)=>({
        type: $81e986267dbf0fe2$export$bf878f94e95fcc5d,
        payload: {
            rowId: rowId,
            colId: colId
        }
    });
const $81e986267dbf0fe2$export$dff3d0f13dc2a535 = 'state.actions.table.ACTIVE_ITEM_REMOVED';
const $81e986267dbf0fe2$export$42120e4638639b68 = ()=>({
        type: $81e986267dbf0fe2$export$dff3d0f13dc2a535
    });
const $81e986267dbf0fe2$export$e09b596b5ad52fee = 'state.actions.table.PAGE_CHANGED';
const $81e986267dbf0fe2$export$ef479dcaff4dd067 = (currentPage)=>({
        type: $81e986267dbf0fe2$export$e09b596b5ad52fee,
        payload: {
            currentPage: currentPage
        }
    });
const $81e986267dbf0fe2$export$25e584dfc9e3eff4 = 'state.actions.table.SORT_ORDER_CHANGED';
const $81e986267dbf0fe2$export$6053015c901f4a6f = (sortedBy, sortOrder)=>({
        type: $81e986267dbf0fe2$export$25e584dfc9e3eff4,
        payload: {
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });
const $81e986267dbf0fe2$export$acc4e88a28a7b0a0 = 'state.actions.table.SORT_ORDER_OPTIMISTIC_UPDATE';
const $81e986267dbf0fe2$export$fc03e6e4f23c5a8f = (queueId, sortedBy, sortOrder)=>({
        type: $81e986267dbf0fe2$export$acc4e88a28a7b0a0,
        payload: {
            queueId: queueId,
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });
const $81e986267dbf0fe2$export$533ed746a3d5dc9c = 'state.actions.table.SORT_ORDER_OPTIMISTIC_RESET';
const $81e986267dbf0fe2$export$c1c6e7ee5582b9c8 = ()=>({
        type: $81e986267dbf0fe2$export$533ed746a3d5dc9c
    });
const $81e986267dbf0fe2$export$d4e7f6a156826402 = 'state.actions.table.SORT_ORDER_ON_LOAD';
const $81e986267dbf0fe2$export$d2ecbc20e3155b0f = (sortedBy, sortOrder)=>({
        type: $81e986267dbf0fe2$export$d4e7f6a156826402,
        payload: {
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });
const $81e986267dbf0fe2$export$2f4dfac96c2f056a = 'state.actions.table.RESET_SORT_ORDER';
const $81e986267dbf0fe2$export$203744a3e48fd32 = ()=>({
        type: $81e986267dbf0fe2$export$2f4dfac96c2f056a
    });
const $81e986267dbf0fe2$export$4ee6cf3ac95ffd6f = 'state.actions.table.TOGGLE_QUEUE_HEADER';
const $81e986267dbf0fe2$export$246f86636f1800cd = (scrollDirection)=>({
        type: $81e986267dbf0fe2$export$4ee6cf3ac95ffd6f,
        payload: scrollDirection
    });
const $81e986267dbf0fe2$export$5b6c833dfdf472fa = 'state.actions.table.FETCH_ISSUE_DATA_ONSCROLL';
const $81e986267dbf0fe2$export$1ebcd0c4bc8d1a17 = (startIndex)=>({
        type: $81e986267dbf0fe2$export$5b6c833dfdf472fa,
        payload: startIndex
    });
const $81e986267dbf0fe2$export$b01127fa720badfd = 'state.actions.table.DISPLAY_UNSUCCESSFUL_FETCH_WARNING';
const $81e986267dbf0fe2$export$533da0160b901b24 = ()=>({
        type: $81e986267dbf0fe2$export$b01127fa720badfd
    });
const $81e986267dbf0fe2$export$9288a47530ff1e41 = 'state.actions.table.DISPLAY_UNSUCCESSFUL_FETCH_ERROR';
const $81e986267dbf0fe2$export$9af7482c09c5cf94 = ()=>({
        type: $81e986267dbf0fe2$export$9288a47530ff1e41
    });
const $81e986267dbf0fe2$export$3858906dc81c7152 = 'state.actions.table.UPDATE_SORTING_INFO_IN_USER_PROPERTY';
const $81e986267dbf0fe2$export$165448dd459ec76e = (sortedBy, sortOrder)=>({
        type: $81e986267dbf0fe2$export$3858906dc81c7152,
        payload: {
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });

});

parcelRegister("7pcZu", function(module, exports) {

$parcel$export(module.exports, "unsetIsInitialLoad", () => $d70757bd5dc1f8f6$export$2fa696454aa7ac86);
$parcel$export(module.exports, "default", () => $d70757bd5dc1f8f6$export$2e2bcd8739ae039);
const $d70757bd5dc1f8f6$var$UNSET_IS_INITIAL_LOAD = 'state.actions.page.UNSET_IS_INITIAL_LOAD';
const $d70757bd5dc1f8f6$export$2fa696454aa7ac86 = ()=>({
        type: $d70757bd5dc1f8f6$var$UNSET_IS_INITIAL_LOAD
    });
const $d70757bd5dc1f8f6$export$1650419e431d3ba3 = (state = null, action)=>{
    switch(action.type){
        case $d70757bd5dc1f8f6$var$UNSET_IS_INITIAL_LOAD:
            return {
                ...state,
                isInitialLoading: false
            };
        default:
            return state || null;
    }
};
var $d70757bd5dc1f8f6$export$2e2bcd8739ae039 = $d70757bd5dc1f8f6$export$1650419e431d3ba3;

});


parcelRegister("1HXBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e42c6cf811e1a3d$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $dd29Z = parcelRequire("dd29Z");

var $3HGy4 = parcelRequire("3HGy4");

var $fy6YG = parcelRequire("fy6YG");

var $bzBCj = parcelRequire("bzBCj");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e42c6cf811e1a3d$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $bzBCj.OPEN_ISSUE)).switchMap(()=>{
            const state = store.getState();
            const projectKey = (0, $fy6YG.getProjectKey)(state);
            const queueId = (0, $627A7.getQueueId)(state);
            const issueKey = (0, $jeVA9.getIssueKeyContext)(state);
            const category = (0, $627A7.getCategory)(state);
            if (issueKey != null && issueKey !== '') {
                if (push) return push((0, $dd29Z.getQueueIssueFragment)((0, $3HGy4.fromQueueId)(queueId), issueKey, category));
                // Fallback to push state navigator.
                return (0, $dd29Z.navigate)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                projectKey, (0, $dd29Z.getQueueIssueFragment)((0, $3HGy4.fromQueueId)(queueId), issueKey, category));
            }
            return (0, $kVLXA.Observable).empty();
        });

});


parcelRegister("85gkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $183107e0df2a5dca$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("jFVZ1");
parcelRequire("fp4O3");
parcelRequire("64ZAE");
parcelRequire("eV0gs");
parcelRequire("1oQta");
parcelRequire("6cbqE");

var $3HGy4 = parcelRequire("3HGy4");


var $bzBCj = parcelRequire("bzBCj");

var $jdGLR = parcelRequire("jdGLR");

var $iIQpG = parcelRequire("iIQpG");
const $183107e0df2a5dca$export$68fb821c332f6a6 = 600000;
const $183107e0df2a5dca$export$e6b4578b8d511a17 = 2000;
const $183107e0df2a5dca$export$a2949fb7526d3e7a = 500;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$183107e0df2a5dca$export$2e2bcd8739ae039 = (action$)=>{
    let isFailing = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isSuccess = (action)=>action.type === (0, $bzBCj.LOAD_ISSUES_SUCCESS) && action.payload.loadedIssuesResponse.source !== (0, $3HGy4.LOCAL_STORAGE_SOURCE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFirstPollFailure = (action)=>action.type === (0, $iIQpG.POLL_FAILURE) && isFailing === false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInCachedQueue = (action)=>action.type === (0, $bzBCj.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8) && !action.payload.isQueueEmpty;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInEmptyQueue = (action)=>action.type === (0, $bzBCj.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8) && action.payload.isQueueEmpty;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInSortQueue = (action)=>action.type === (0, $bzBCj.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $36dd7e3255fc2bff$export$2003e3fdddd4c35b);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldShowWarning = (action)=>isFetchFailureInCachedQueue(action) || isFetchFailureInSortQueue(action) || isFirstPollFailure(action);
    // show error flag only in case of failure during scroll. Show warning in all other cases
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldShowError = (action)=>action.type === (0, $bzBCj.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $36dd7e3255fc2bff$export$d4d94a8c13e2df1d);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldDismissAllFlags = (action)=>isSuccess(action) || isFetchFailureInEmptyQueue(action);
    return action$.ofType((0, $iIQpG.POLL_FAILURE), (0, $bzBCj.LOAD_ISSUES_SUCCESS), (0, $bzBCj.LOAD_ISSUES_FAILURE)).filter((action)=>shouldDismissAllFlags(action) || shouldShowWarning(action) || shouldShowError(action))// @ts-expect-error - TS2345: Types of property 'type' are incompatible. Type 'state.actions.update-metadata.DISMISS_ALL_FLAGS' is not assignable to type 'state.actions.update-metadata.DISPLAY_UNSUCCESSFUL_POLL_WARNING'.
    .switchMap((action)=>{
        if (shouldShowWarning(action) || shouldShowError(action)) {
            let returnObservable = (0, $kVLXA.Observable).of((0, $iIQpG.displayUnsuccessfulPollWarningAction)());
            if (shouldShowError(action)) // @ts-expect-error - TS2322 - Type 'Observable<DisplayUnsuccessfulFetchErrorOnScrollAction | DismissWarningFlagAction>' is not assignable to type 'Observable<DisplayUnsuccessfulPollWarningAction>'.
            returnObservable = (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $iIQpG.dismissWarningFlagAction)()), (0, $kVLXA.Observable).of((0, $jdGLR.displayUnsuccessfulFetchErrorOnScrollAction)()).delay($183107e0df2a5dca$export$a2949fb7526d3e7a));
            else if (isFetchFailureInCachedQueue(action)) // @ts-expect-error - TS2322 - Type 'Observable<DisplayUnsuccessfulFetchWarningAction>' is not assignable to type 'Observable<DisplayUnsuccessfulPollWarningAction>'.
            returnObservable = (0, $kVLXA.Observable).of((0, $jdGLR.displayUnsuccessfulFetchWarningAction)());
            return returnObservable.do(()=>{
                isFailing = true;
            }).delay(isFirstPollFailure(action) ? $183107e0df2a5dca$export$68fb821c332f6a6 : $183107e0df2a5dca$export$e6b4578b8d511a17);
        }
        if (shouldDismissAllFlags(action)) {
            isFailing = false;
            return (0, $kVLXA.Observable).of((0, $iIQpG.dismissAllFlagsAction)());
        }
        return (0, $kVLXA.Observable).empty();
    });
};

});

parcelRegister("t5Eel", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbcd8d8aceab1756$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $kptWE = parcelRequire("kptWE");

var $cUY3O = parcelRequire("cUY3O");

var $fRcyR = parcelRequire("fRcyR");
var // @ts-expect-error - TS2345: Type 'unknown' is not assignable to type 'Action'.
$bbcd8d8aceab1756$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $cUY3O.default), (0, $fRcyR.default), (0, $kptWE.default));

});
parcelRegister("kptWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $827e55c1a2eb859c$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("2HNfr");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");


var $bzBCj = parcelRequire("bzBCj");

var $4uvJ3 = parcelRequire("4uvJ3");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$827e55c1a2eb859c$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $4uvJ3.CHANGE_VISIBILITY)).switchMap((action)=>{
        const state = store.getState();
        const newVisibility = action.payload.isQueueVisible;
        if ((0, $jeVA9.isQueueVisible)(state) === newVisibility) return (0, $kVLXA.Observable).of();
        const result = (0, $kVLXA.Observable).of((0, $4uvJ3.setQueueVisibilityAction)(newVisibility));
        if (newVisibility) return result.concat((0, $kVLXA.Observable).of((0, $bzBCj.loadIssuesAction)((0, $627A7.getFetchStartIndex)(state), (0, $36dd7e3255fc2bff$export$3de6d8bdd297654b))));
        return result;
    });

});
parcelRegister("4uvJ3", function(module, exports) {

$parcel$export(module.exports, "SET_QUEUE_VISIBILITY", () => $fd44fd2659c305a9$export$92fe62de9bdb5843);
$parcel$export(module.exports, "setQueueVisibilityAction", () => $fd44fd2659c305a9$export$64da69d76b8c2108);
$parcel$export(module.exports, "CHANGE_VISIBILITY", () => $fd44fd2659c305a9$export$9c635dbaffb42239);
$parcel$export(module.exports, "changeVisibilityAction", () => $fd44fd2659c305a9$export$dcdfcd96c3c9f5d1);
$parcel$export(module.exports, "RESET_STATE", () => $fd44fd2659c305a9$export$7431817582ed8a25);
$parcel$export(module.exports, "resetStateAction", () => $fd44fd2659c305a9$export$d6c39c41a445a29f);
$parcel$export(module.exports, "LOAD_PAGE_DATA", () => $fd44fd2659c305a9$export$1b8361138f3b24e8);
$parcel$export(module.exports, "loadPageDataAction", () => $fd44fd2659c305a9$export$68ce54e2208e7a36);
$parcel$export(module.exports, "RELOAD_PAGE_DATA", () => $fd44fd2659c305a9$export$54fb7345a7b2e0f3);
$parcel$export(module.exports, "reloadPageDataAction", () => $fd44fd2659c305a9$export$9455bc428956d0f);
$parcel$export(module.exports, "LOAD_PAGE_DATA_SUCCESS", () => $fd44fd2659c305a9$export$6fd4caf8424e356b);
$parcel$export(module.exports, "loadPageDataSuccessAction", () => $fd44fd2659c305a9$export$308c96ca263cb52);
$parcel$export(module.exports, "LOAD_PAGE_DATA_FAILURE", () => $fd44fd2659c305a9$export$65b7c02925f4c6d8);
$parcel$export(module.exports, "loadPageDataFailureAction", () => $fd44fd2659c305a9$export$3fbdb12567de364c);
$parcel$export(module.exports, "DISPLAY_QUEUES_ERROR_HEADER", () => $fd44fd2659c305a9$export$464be1c8e7c172ad);
$parcel$export(module.exports, "displayQueuesErrorHeaderAction", () => $fd44fd2659c305a9$export$da47c211f950cb59);
const $fd44fd2659c305a9$export$92fe62de9bdb5843 = 'state.actions.page.SET_QUEUE_VISIBILITY';
const $fd44fd2659c305a9$export$64da69d76b8c2108 = (isQueueVisible)=>({
        type: $fd44fd2659c305a9$export$92fe62de9bdb5843,
        payload: {
            isQueueVisible: isQueueVisible
        }
    });
const $fd44fd2659c305a9$export$9c635dbaffb42239 = 'state.actions.page.CHANGE_VISIBILITY';
const $fd44fd2659c305a9$export$dcdfcd96c3c9f5d1 = (isQueueVisible)=>({
        type: $fd44fd2659c305a9$export$9c635dbaffb42239,
        payload: {
            isQueueVisible: isQueueVisible
        }
    });
const $fd44fd2659c305a9$export$7431817582ed8a25 = 'state.actions.page.RESET_STATE';
const $fd44fd2659c305a9$export$d6c39c41a445a29f = (queueId)=>({
        type: $fd44fd2659c305a9$export$7431817582ed8a25,
        payload: {
            queueId: queueId
        }
    });
const $fd44fd2659c305a9$export$1b8361138f3b24e8 = 'state.actions.page.LOAD_PAGE_DATA';
const $fd44fd2659c305a9$export$68ce54e2208e7a36 = (queueId)=>({
        type: $fd44fd2659c305a9$export$1b8361138f3b24e8,
        payload: {
            queueId: queueId
        }
    });
const $fd44fd2659c305a9$export$54fb7345a7b2e0f3 = 'state.actions.page.RELOAD_PAGE_DATA';
const $fd44fd2659c305a9$export$9455bc428956d0f = (queueId)=>({
        type: $fd44fd2659c305a9$export$54fb7345a7b2e0f3,
        payload: {
            queueId: queueId
        }
    });
const $fd44fd2659c305a9$export$6fd4caf8424e356b = 'state.actions.page.LOAD_PAGE_DATA_SUCCESS';
const $fd44fd2659c305a9$export$308c96ca263cb52 = (queuesWithSorting)=>({
        type: $fd44fd2659c305a9$export$6fd4caf8424e356b,
        payload: {
            queuesWithSorting: queuesWithSorting
        }
    });
const $fd44fd2659c305a9$export$65b7c02925f4c6d8 = 'state.actions.page.LOAD_PAGE_DATA_FAILURE';
const $fd44fd2659c305a9$export$3fbdb12567de364c = (error, statusCode)=>({
        type: $fd44fd2659c305a9$export$65b7c02925f4c6d8,
        payload: {
            error: error,
            statusCode: statusCode
        }
    });
const $fd44fd2659c305a9$export$464be1c8e7c172ad = 'state.actions.page.DISPLAY_QUEUES_ERROR_HEADER';
const $fd44fd2659c305a9$export$da47c211f950cb59 = ()=>({
        type: $fd44fd2659c305a9$export$464be1c8e7c172ad
    });

});


parcelRegister("cUY3O", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7207be0967b481$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");


var $hh2Va = parcelRequire("hh2Va");

var $bzBCj = parcelRequire("bzBCj");

var $4uvJ3 = parcelRequire("4uvJ3");

var $WS8Y1 = parcelRequire("WS8Y1");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ce7207be0967b481$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $4uvJ3.LOAD_PAGE_DATA)).switchMap((action)=>{
        const state = store.getState();
        return (0, $hh2Va.default)(action.payload.queueId, state).flatMap((result)=>(0, $kVLXA.Observable).of((0, $4uvJ3.loadPageDataSuccessAction)(result), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $bzBCj.loadIssuesAction)((0, $WS8Y1.getCurrentPageStartIndex)(state), (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8)))).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'opsPageLoad',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                // @ts-expect-error - TS2345 - Argument of type 'ErrorResponse' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            (0, $dJl1T.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops.page.load', `[FD-3358] Error while trying to load page data: ${JSON.stringify(error.response.errors)}`);
            return (0, $kVLXA.Observable).of((0, $4uvJ3.loadPageDataFailureAction)(error.response, error.statusCode));
        });
    });

});
parcelRegister("hh2Va", function(module, exports) {

$parcel$export(module.exports, "default", () => $a228159a08aa41c4$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $jJBxp = parcelRequire("jJBxp");

var $fy6YG = parcelRequire("fy6YG");

var $2wftl = parcelRequire("2wftl");

var $h6exE = parcelRequire("h6exE");

var $CWMfa = parcelRequire("CWMfa");
const $a228159a08aa41c4$var$prefetcherTransformFunc = (queueId, prefetcherPageResponse)=>(0, $CWMfa.addSortingToQueues)(queueId, (0, $h6exE.pageToQueues)(prefetcherPageResponse.data.queues));
const $a228159a08aa41c4$var$pageResponseTransformFunc = (queueId)=>(pageResponse)=>(0, $CWMfa.addSortingToQueues)(queueId, (0, $h6exE.pageToQueues)(pageResponse.queues));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a228159a08aa41c4$export$2e2bcd8739ae039 = (queueId, state)=>{
    const prefetchedPagePromise = (0, $h6exE.getPrefetchedPagePromise)();
    if (prefetchedPagePromise.isSome()) return (0, $kVLXA.Observable).fromPromise(prefetchedPagePromise.some()).map((data)=>{
        (0, $h6exE.unsetPrefetchedPagePromise)();
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PrefetcherPageResponse'.
        return $a228159a08aa41c4$var$prefetcherTransformFunc(queueId, data);
    }).catch(()=>(0, $jJBxp.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        (0, $2wftl.default)((0, $fy6YG.getProjectKey)(state), (0, $fy6YG.getBaseUrl)(state)), $a228159a08aa41c4$var$pageResponseTransformFunc(queueId)));
    return (0, $jJBxp.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $2wftl.default)((0, $fy6YG.getProjectKey)(state), (0, $fy6YG.getBaseUrl)(state)), $a228159a08aa41c4$var$pageResponseTransformFunc(queueId));
};

});
parcelRegister("2wftl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bac9f8c43b767b8$export$2e2bcd8739ae039);

var $5OrSA = parcelRequire("5OrSA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3bac9f8c43b767b8$export$2e2bcd8739ae039 = (projectKey, baseUrl)=>(0, $5OrSA.fetchJson$)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/page`, {
        method: 'GET'
    });

});

parcelRegister("h6exE", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $af22533d1a4870e4$export$8ada91ce992fa66f);
$parcel$export(module.exports, "getPrefetchedPagePromise", () => $af22533d1a4870e4$export$4906aa3ec3919ad9);
$parcel$export(module.exports, "unsetPrefetchedPagePromise", () => $af22533d1a4870e4$export$17bdd949b6a9952);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $8KhWn = parcelRequire("8KhWn");

var $3HGy4 = parcelRequire("3HGy4");
const $af22533d1a4870e4$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $af22533d1a4870e4$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $3HGy4.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $af22533d1a4870e4$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite
        };
        return acc;
    }, {});
const $af22533d1a4870e4$export$4906aa3ec3919ad9 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (0, $8KhWn.Maybe).fromNull(window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues);
const $af22533d1a4870e4$export$17bdd949b6a9952 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JSD_QUEUES_PRELOAD_PROMISES) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
};

});


parcelRegister("WS8Y1", function(module, exports) {

$parcel$export(module.exports, "getCurrentPage", () => $4ebcaee55b2487e5$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getCurrentPageStartIndex", () => $4ebcaee55b2487e5$export$e4d555459a632790);
$parcel$export(module.exports, "getTotalPages", () => $4ebcaee55b2487e5$export$652b307566494a6);
$parcel$export(module.exports, "getIssueKeysForPage", () => $4ebcaee55b2487e5$export$c1360f0f194316c8);

var $dGvGJ = parcelRequire("dGvGJ");


var $lHf6h = parcelRequire("lHf6h");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");
const $4ebcaee55b2487e5$var$LOADING_ROW_COUNT = 10;
const $4ebcaee55b2487e5$export$7107d372eaf3477f = (state)=>(0, $627A7.getQueuePageData)(state).pagination;
const $4ebcaee55b2487e5$export$7945ba8eb1c827e6 = (state)=>$4ebcaee55b2487e5$export$7107d372eaf3477f(state).currentPage;
const $4ebcaee55b2487e5$export$e4d555459a632790 = (state)=>($4ebcaee55b2487e5$export$7945ba8eb1c827e6(state) - 1) * (0, $0750463259e12908$export$f88f58d1a4b2078b);
const $4ebcaee55b2487e5$export$652b307566494a6 = (state)=>Math.max(1, Math.ceil((0, $lHf6h.getIssueCount)(state) / (0, $0750463259e12908$export$f88f58d1a4b2078b)));
const $4ebcaee55b2487e5$export$303dbf47f10892ce = (state)=>$4ebcaee55b2487e5$export$7945ba8eb1c827e6(state) * (0, $0750463259e12908$export$f88f58d1a4b2078b) - 1;
const $4ebcaee55b2487e5$export$e81b7cdc3b6d6b1f = (state)=>{
    const maxPageEndIndex = $4ebcaee55b2487e5$export$303dbf47f10892ce(state);
    const minPageEndIndex = $4ebcaee55b2487e5$export$e4d555459a632790(state) - 1;
    return Math.min(Math.max((0, $lHf6h.getIssueCount)(state) - 1, minPageEndIndex), maxPageEndIndex);
};
const $4ebcaee55b2487e5$export$c1360f0f194316c8 = (0, $dGvGJ.createSelector)((0, $lHf6h.getCollection), $4ebcaee55b2487e5$export$e4d555459a632790, $4ebcaee55b2487e5$export$e81b7cdc3b6d6b1f, (0, $jeVA9.isLoadingIssues), (issues, startIndex, endIndex, isLoading)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueKeys = [];
    const isNewDataSet = isLoading && issues.length === 0;
    // If we are expecting data from a new source like a queue or a page.
    // If the collection has not been cleared we want to show
    // existing row until loading is complete
    if (isNewDataSet) {
        issueKeys.length = $4ebcaee55b2487e5$var$LOADING_ROW_COUNT;
        if (endIndex - startIndex + 1 === (0, $0750463259e12908$export$f88f58d1a4b2078b)) issueKeys.length = (0, $0750463259e12908$export$f88f58d1a4b2078b);
        return issueKeys;
    }
    issueKeys.length = endIndex - startIndex + 1;
    for(let i = startIndex; i <= endIndex; i += 1){
        const issue = issues[i];
        if (issue) issueKeys[i - startIndex] = issue.key;
    }
    return issueKeys;
});

});


parcelRegister("fRcyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $39c0f1cefb02ae58$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");

var $4uvJ3 = parcelRequire("4uvJ3");

var $iIQpG = parcelRequire("iIQpG");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$39c0f1cefb02ae58$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $4uvJ3.RELOAD_PAGE_DATA)).switchMap((action)=>{
        const { queueId: queueId } = action.payload;
        return (0, $kVLXA.Observable).of((0, $iIQpG.stopPollAction)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $4uvJ3.resetStateAction)(queueId), (0, $4uvJ3.loadPageDataAction)(queueId));
    });

});


parcelRegister("lSxyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a051553c6620a3$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("8n054");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $dOAU7 = parcelRequire("dOAU7");

var $kVLXA = parcelRequire("kVLXA");

var $4R6GH = parcelRequire("4R6GH");


var $biTBc = parcelRequire("biTBc");

var $bzBCj = parcelRequire("bzBCj");

var $gILZy = parcelRequire("gILZy");

var $iIQpG = parcelRequire("iIQpG");

var $hYrcT = parcelRequire("hYrcT");

var $627A7 = parcelRequire("627A7");
const $61a051553c6620a3$var$INITIAL_POLLING_INTERVAL = 5000;
const $61a051553c6620a3$export$8201d195ec654b2c = 60000;
const $61a051553c6620a3$export$8403745c406d60ee = 300000;
const $61a051553c6620a3$export$acdfd55989a32c36 = 2000;
const $61a051553c6620a3$var$BROWSER_TAB_VISIBLE_STATE = 'visible';
const $61a051553c6620a3$var$getInterval = (initialInterval)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.visibilityState !== $61a051553c6620a3$var$BROWSER_TAB_VISIBLE_STATE) return $61a051553c6620a3$export$acdfd55989a32c36;
    return initialInterval;
};
const $61a051553c6620a3$var$getNextInterval = (interval, statusCode)=>{
    if (statusCode >= 500 && (0, $4R6GH.fg)('jsm_queue_polling_exponential_backoff')) {
        const nextInterval = interval * 5;
        return Math.min($61a051553c6620a3$export$8403745c406d60ee, nextInterval);
    }
    const nextInterval = interval * 1.1;
    return Math.min($61a051553c6620a3$export$8201d195ec654b2c, nextInterval);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61a051553c6620a3$export$2e2bcd8739ae039 = (initialInterval = $61a051553c6620a3$var$INITIAL_POLLING_INTERVAL, scheduler)=>(action$, store)=>{
        let isShutdown = false;
        return action$.ofType((0, $gILZy.SHUTDOWN), (0, $iIQpG.STOP_POLL), (0, $iIQpG.RESTART_POLL)).switchMap((action)=>{
            if (action.type === (0, $gILZy.SHUTDOWN) || isShutdown) {
                isShutdown = true;
                return (0, $kVLXA.Observable).empty();
            }
            if (action.type === (0, $iIQpG.STOP_POLL)) return (0, $kVLXA.Observable).empty();
            const pollingInterval$ = new (0, $dOAU7.BehaviorSubject)($61a051553c6620a3$var$getInterval(initialInterval));
            return pollingInterval$.switchMap((interval)=>{
                let initialDelay = interval;
                if (action.payload?.skipInitialDelay) initialDelay = 0;
                return (0, $kVLXA.Observable).timer(initialDelay, interval, scheduler).switchMap(()=>(0, $kVLXA.Observable).of(interval));
            }).switchMap((interval)=>{
                const state = store.getState();
                // If browser tab is not visible, do nothing.
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (document.visibilityState !== $61a051553c6620a3$var$BROWSER_TAB_VISIBLE_STATE) {
                    pollingInterval$.next($61a051553c6620a3$var$getInterval(initialInterval));
                    return (0, $kVLXA.Observable).empty();
                }
                return (0, $biTBc.default)(state).mergeMap((result)=>{
                    // going back to the original interval if there is new data
                    pollingInterval$.next($61a051553c6620a3$var$getInterval(initialInterval));
                    if ((0, $hYrcT.getIsCurrentDataFiltered)(state)) return (0, $kVLXA.Observable).of((0, $iIQpG.pollSuccessAction)(result.projectStateHash));
                    return (0, $kVLXA.Observable).of((0, $iIQpG.pollSuccessAction)(result.projectStateHash), // @ts-expect-error - TS2769 - No overload matches this call.
                    (0, $bzBCj.loadIssuesAction)((0, $627A7.getFetchStartIndex)(state), (0, $36dd7e3255fc2bff$export$fa4dae241333de34)));
                })// 304 returned by endpoint
                // @ts-expect-error - TS2345 - Argument of type '(error: ErrorResponse) => Observable<PollContentNotModifiedAction> | Observable<PollFailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<PollSuccessAction>) => ObservableInput<PollContentNotModifiedAction>'.
                .catch((error)=>{
                    // going back to the original interval if there is new data
                    pollingInterval$.next($61a051553c6620a3$var$getNextInterval(interval, error.statusCode));
                    if (error.statusCode === 304) return (0, $kVLXA.Observable).of((0, $iIQpG.pollContentNotModifiedAction)());
                    return (0, $kVLXA.Observable).of((0, $iIQpG.pollFailureAction)());
                });
            });
        });
    };

});
parcelRegister("biTBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $692848b5fb3ec1df$export$2e2bcd8739ae039);

var $jJBxp = parcelRequire("jJBxp");

var $fy6YG = parcelRequire("fy6YG");

var $6dMFl = parcelRequire("6dMFl");

var $k3elp = parcelRequire("k3elp");
const $692848b5fb3ec1df$var$transformFunction = (pollResponse)=>pollResponse;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$692848b5fb3ec1df$export$2e2bcd8739ae039 = (state)=>(0, $jJBxp.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $6dMFl.default)((0, $fy6YG.getProjectKey)(state), (0, $fy6YG.getBaseUrl)(state), (0, $k3elp.getProjectStateHash)(state)), $692848b5fb3ec1df$var$transformFunction);

});
parcelRegister("6dMFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c4a9bdb8f29baa$export$2e2bcd8739ae039);

var $5OrSA = parcelRequire("5OrSA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$19c4a9bdb8f29baa$export$2e2bcd8739ae039 = (projectKey, baseUrl, projectStateHash)=>{
    const hashString = projectStateHash ? `?projectStateHash=${projectStateHash}` : '';
    return (0, $5OrSA.fetchJson$)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/poll${hashString}`, {
        method: 'GET'
    });
};

});


parcelRegister("gILZy", function(module, exports) {

$parcel$export(module.exports, "SHUTDOWN", () => $134654f32a9baca7$export$9d68ba11045ae7c3);
$parcel$export(module.exports, "shutdownAction", () => $134654f32a9baca7$export$d45c0b180c9b57f7);
// SHUTDOWN
const $134654f32a9baca7$export$9d68ba11045ae7c3 = 'state.actions.lifecycle.SHUTDOWN';
const $134654f32a9baca7$export$d45c0b180c9b57f7 = ()=>({
        type: $134654f32a9baca7$export$9d68ba11045ae7c3
    });

});


parcelRegister("5KPhz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3fa6b54ed0d55e$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $9PvPY = parcelRequire("9PvPY");

var $9ZIJu = parcelRequire("9ZIJu");

var $1UoL4 = parcelRequire("1UoL4");

var $5gpxh = parcelRequire("5gpxh");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b3fa6b54ed0d55e$export$2e2bcd8739ae039 = (push)=>// @ts-expect-error - TS2322: Type 'unknown' is not assignable to type 'Action'.
    (0, $e1AU2.combineEpics)((0, $1UoL4.default)(push), (0, $5gpxh.default)(push), (0, $9ZIJu.default)(push), (0, $9PvPY.default));

});
parcelRegister("9PvPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc63a62ebb3ccd5$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");

var $aB8eX = parcelRequire("aB8eX");

var $kVLXA = parcelRequire("kVLXA");

var $4R6GH = parcelRequire("4R6GH");

var $1jONP = parcelRequire("1jONP");

var $2nYuf = parcelRequire("2nYuf");


var $lPEsb = parcelRequire("lPEsb");

var $CWMfa = parcelRequire("CWMfa");

var $haCWn = parcelRequire("haCWn");

var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");

var $4uvJ3 = parcelRequire("4uvJ3");

var $dOWTu = parcelRequire("dOWTu");

var $jdGLR = parcelRequire("jdGLR");

var $3jtVD = parcelRequire("3jtVD");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");

var $7uXM1 = parcelRequire("7uXM1");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0cc63a62ebb3ccd5$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $dOWTu.QUEUE_CHANGED)).switchMap((action)=>{
        const state = store.getState();
        const isInitialLoad = (0, $7uXM1.getIsInitialLoad)(state);
        const { queue: queue } = action.payload;
        const createAnalyticsEvent = (0, $3jtVD.getCreateAnalyticsEvent)(state);
        const sortedQueue = (0, $4R6GH.fg)('clean_local_storage_sorting') ? queue : (0, $CWMfa.createSortedQueue)(queue, createAnalyticsEvent);
        const queueId = sortedQueue.id;
        if ((0, $jeVA9.hasPageError)(state)) return (0, $kVLXA.Observable).of((0, $4uvJ3.reloadPageDataAction)(queueId));
        if (!(0, $627A7.isQueueMateriallyDifferent)(state, sortedQueue)) return (0, $kVLXA.Observable).of((0, $dOWTu.setQueueAction)(sortedQueue));
        const columnTypesAsJson = (0, $1jONP.getFieldTypesEligibleForJsonData)();
        // remove manual sorting with clean_local_storage_sorting feature flag removal
        const { columns: columns, jql: jql, manualSorting: manualSorting } = sortedQueue;
        // in initial load, fetch a smaller batch size for performance concerns
        const shouldOverwriteFetchSize = (0, $4R6GH.fg)('issuelist_reduce_issue_count_in_initial_load') && isInitialLoad;
        const actions = [
            (0, $haCWn.experienceTrackingResetAction)(),
            (0, $fnQyW.filterQueryChangedAction)(null),
            (0, $dOWTu.setQueueAction)(sortedQueue),
            (0, $jdGLR.pageChangedAction)(1),
            (0, $bzBCj.loadIssuesAction)(0, (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8), true, shouldOverwriteFetchSize ? (0, $2nYuf.FETCH_SIZE_IN_INITIAL_LOAD) : undefined)
        ];
        // clean up with clean_local_storage_sorting feature flag removal
        const sortedBy = manualSorting && manualSorting.sortedBy;
        const sortOrder = manualSorting && manualSorting.sortOrder;
        return (0, $lPEsb.maybeIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, null, // remove next two lines with clean_local_storage_sorting feature flag removal
        (0, $4R6GH.fg)('clean_local_storage_sorting') ? undefined : sortedBy, (0, $4R6GH.fg)('clean_local_storage_sorting') ? undefined : sortOrder).cata(()=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(actions)), // @ts-expect-error - TS7006 - Parameter 'issues' implicitly has an 'any' type.
        (issues)=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                ...actions,
                (0, $bzBCj.loadIssuesSuccessAction)(issues, queueId, 0, (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8))
            ])));
    });

});
parcelRegister("haCWn", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_TRACKING_RESET", () => $f14cd6c2a57e046f$export$70281a0b6f2c039e);
$parcel$export(module.exports, "experienceTrackingResetAction", () => $f14cd6c2a57e046f$export$ce671cb9c43406e2);
// EXPERIENCE_TRACKING_RESET
const $f14cd6c2a57e046f$export$70281a0b6f2c039e = 'state.actions.experience-tracking.EXPERIENCE_TRACKING_RESET';
const $f14cd6c2a57e046f$export$ce671cb9c43406e2 = ()=>({
        type: $f14cd6c2a57e046f$export$70281a0b6f2c039e
    });

});

parcelRegister("dOWTu", function(module, exports) {

$parcel$export(module.exports, "EDIT_QUEUE", () => $2499117d363fe7a0$export$e6f7be4f3096aeae);
$parcel$export(module.exports, "editQueueAction", () => $2499117d363fe7a0$export$f6652267a5390fe1);
$parcel$export(module.exports, "CLONE_QUEUE", () => $2499117d363fe7a0$export$83e90b00e7702db8);
$parcel$export(module.exports, "cloneQueueAction", () => $2499117d363fe7a0$export$1db711c2821ce3f4);
$parcel$export(module.exports, "QUEUE_CHANGED", () => $2499117d363fe7a0$export$6c2e1579a5716bb5);
$parcel$export(module.exports, "queueChangedAction", () => $2499117d363fe7a0$export$1e1b815e3dd544e);
$parcel$export(module.exports, "SET_QUEUE", () => $2499117d363fe7a0$export$45923f75df5860e7);
$parcel$export(module.exports, "setQueueAction", () => $2499117d363fe7a0$export$a22fe719d6fd366f);
const $2499117d363fe7a0$export$e6f7be4f3096aeae = 'state.actions.queue.EDIT_QUEUE';
const $2499117d363fe7a0$export$f6652267a5390fe1 = ()=>({
        type: $2499117d363fe7a0$export$e6f7be4f3096aeae
    });
const $2499117d363fe7a0$export$83e90b00e7702db8 = 'state.actions.queue.CLONE_QUEUE';
const $2499117d363fe7a0$export$1db711c2821ce3f4 = (category)=>({
        type: $2499117d363fe7a0$export$83e90b00e7702db8,
        payload: {
            category: category
        }
    });
const $2499117d363fe7a0$export$6c2e1579a5716bb5 = 'state.actions.queue.QUEUE_CHANGED';
const $2499117d363fe7a0$export$1e1b815e3dd544e = (queue)=>({
        type: $2499117d363fe7a0$export$6c2e1579a5716bb5,
        payload: {
            queue: queue
        }
    });
const $2499117d363fe7a0$export$45923f75df5860e7 = 'state.actions.queue.SET_QUEUE';
const $2499117d363fe7a0$export$a22fe719d6fd366f = (queue)=>({
        type: $2499117d363fe7a0$export$45923f75df5860e7,
        payload: {
            queue: queue
        }
    });

});


parcelRegister("9ZIJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $464bdaf312945053$export$2e2bcd8739ae039);
parcelRequire("6cbqE");

var $dd29Z = parcelRequire("dd29Z");

var $3HGy4 = parcelRequire("3HGy4");

var $fy6YG = parcelRequire("fy6YG");

var $dOWTu = parcelRequire("dOWTu");

var $627A7 = parcelRequire("627A7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$464bdaf312945053$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $dOWTu.CLONE_QUEUE)).switchMap((action)=>{
            const { payload: { category: category } } = action;
            const state = store.getState();
            const projectKey = (0, $fy6YG.getProjectKey)(state);
            const queueId = (0, $627A7.getQueueId)(state);
            if (push) return push((0, $dd29Z.getCloneQueueFragment)((0, $3HGy4.fromQueueId)(queueId), category));
            // fallback to push state nav in case anything goes wrong.
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            return (0, $dd29Z.navigate)(projectKey, (0, $dd29Z.getCloneQueueFragment)((0, $3HGy4.fromQueueId)(queueId), category));
        });

});

parcelRegister("1UoL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $76fdab4465d1d286$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $hhweD = parcelRequire("hhweD");

var $dd29Z = parcelRequire("dd29Z");

var $fy6YG = parcelRequire("fy6YG");

var $1i8ey = parcelRequire("1i8ey");

var $dWFvu = parcelRequire("dWFvu");

var $627A7 = parcelRequire("627A7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$76fdab4465d1d286$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $dWFvu.DELETE_QUEUE)).switchMap((action)=>{
            const state = store.getState();
            const { payload: { queueId: queueId, onDeleteComplete: onDeleteComplete }, meta: { analyticsEvent: analyticsEvent } } = action;
            const queueName = (0, $627A7.getQueueName)(state);
            const payload = {
                deleted: [
                    queueId
                ]
            };
            return (0, $1i8ey.default)(payload, state).flatMap(()=>{
                const analyticsProperties = {
                    action: 'deleted',
                    containerType: 'project',
                    containerId: (0, $fy6YG.getProjectId)(state).toString(),
                    objectType: 'queue',
                    objectId: queueId,
                    attributes: {
                        redesign: true
                    }
                };
                // @ts-expect-error TS2345 | TS2345 - Argument of type '{ action: string; containerType: string; containerId: string; objectType: string; objectId: number; attributes: { redesign: boolean; }; }' is not assignable to parameter of type 'Readonly<Readonly<{ name?: string | undefined; containerId?: string | undefined; containers?: Containers | undefined; containerType?: string | undefined; objectType?: string | undefined; objectId?: string | undefined; readonly tags?: readonly string[] | undefined; attributes?: Readonly<...> | undefined; }> & { ...; }>'. | Argument of type '{ action: string; containerType: string; containerId: string; objectType: string; objectId: number; attributes: { redesign: boolean; }; }' is not assignable to parameter of type 'Readonly<Readonly<{ name?: string | undefined; containerId?: string | undefined; containers?: Containers | undefined; containerType?: string | undefined; objectType?: string | undefined; objectId?: string | undefined; readonly tags?: readonly string[] | undefined; attributes?: Readonly<...> | undefined; }> & { ...; }>'.
                (0, $hhweD.fireTrackAnalytics)(analyticsEvent, analyticsProperties);
                onDeleteComplete(queueId);
                if (push) {
                    const category = (0, $627A7.getCategory)(state);
                    return push((0, $dd29Z.getQueueFragment)(undefined, category));
                }
                return (0, $kVLXA.Observable).of((0, $dWFvu.setDeleteModalVisibilityAction)(false), // @ts-expect-error - TS2769 - No overload matches this call.
                (0, $dWFvu.setModalIsDeletingAction)(false));
            }).catch((error)=>(0, $kVLXA.Observable).of((0, $dWFvu.setDeleteModalVisibilityAction)(false), // @ts-expect-error - TS2769 - No overload matches this call.
                (0, $dWFvu.deleteQueueFailureAction)(queueName, error.response), (0, $dWFvu.setModalIsDeletingAction)(false)));
        });

});
parcelRegister("1i8ey", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98cc5f12b928aef$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updateQueuePromise", () => $d98cc5f12b928aef$export$f234ead1318b17ac);

var $jJBxp = parcelRequire("jJBxp");

var $fy6YG = parcelRequire("fy6YG");

var $2CJzp = parcelRequire("2CJzp");

var $h6exE = parcelRequire("h6exE");
const $d98cc5f12b928aef$export$7adc0d541825d917 = (page)=>(0, $h6exE.pageToQueues)(page);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d98cc5f12b928aef$export$2e2bcd8739ae039 = (payload, state)=>// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $jJBxp.default)((0, $2CJzp.default)((0, $fy6YG.getProjectKey)(state), (0, $fy6YG.getBaseUrl)(state), payload), $d98cc5f12b928aef$export$7adc0d541825d917);
const $d98cc5f12b928aef$export$f234ead1318b17ac = (payload, projectKey)=>(0, $2CJzp.default)(projectKey, '', payload).toPromise().then($d98cc5f12b928aef$export$7adc0d541825d917);

});
parcelRegister("2CJzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea9d4df741e28c92$export$2e2bcd8739ae039);

var $5OrSA = parcelRequire("5OrSA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ea9d4df741e28c92$export$2e2bcd8739ae039 = (projectKey, baseUrl, payload)=>(0, $5OrSA.fetchJson$)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    });

});


parcelRegister("dWFvu", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_RESOLVED", () => $0f9bb432948670dc$export$bc6edc14c190bba8);
$parcel$export(module.exports, "onboardingResolvedAction", () => $0f9bb432948670dc$export$796732fe0ca79daa);
$parcel$export(module.exports, "SET_DELETE_MODAL_VISIBILITY", () => $0f9bb432948670dc$export$f22130204a023293);
$parcel$export(module.exports, "setDeleteModalVisibilityAction", () => $0f9bb432948670dc$export$190dceccabe571f5);
$parcel$export(module.exports, "SET_MODAL_IS_DELETING", () => $0f9bb432948670dc$export$f95c039bb3ac7543);
$parcel$export(module.exports, "setModalIsDeletingAction", () => $0f9bb432948670dc$export$99f97fd8f5eb3051);
$parcel$export(module.exports, "DELETE_QUEUE", () => $0f9bb432948670dc$export$5ab05b9e296b458f);
$parcel$export(module.exports, "deleteQueueAction", () => $0f9bb432948670dc$export$582ac7ef548f7ea3);
$parcel$export(module.exports, "DELETE_QUEUE_FAILURE", () => $0f9bb432948670dc$export$c87901f527c6ecbf);
$parcel$export(module.exports, "deleteQueueFailureAction", () => $0f9bb432948670dc$export$c9318fa931763930);
$parcel$export(module.exports, "SET_NAV_COLLAPSED", () => $0f9bb432948670dc$export$a3657f3e279415da);
$parcel$export(module.exports, "setNavCollapsedAction", () => $0f9bb432948670dc$export$24eece95a2a56eca);
$parcel$export(module.exports, "SET_ISSUE_KEY_CONTEXT", () => $0f9bb432948670dc$export$ad460ac72e5ca5db);
$parcel$export(module.exports, "setIssueKeyContext", () => $0f9bb432948670dc$export$e203161ddfaf33fa);
$parcel$export(module.exports, "SET_SIDEBAR_ISSUE_KEY", () => $0f9bb432948670dc$export$8d3ef3d3f35457dd);
$parcel$export(module.exports, "setSidebarIssueKey", () => $0f9bb432948670dc$export$31f0fd7bef8d8084);
$parcel$export(module.exports, "SET_SIDEBAR_REACT_KEY", () => $0f9bb432948670dc$export$e61a8facd12c5b11);
$parcel$export(module.exports, "SET_SELECTED_ISSUE_KEYS", () => $0f9bb432948670dc$export$ff2fe70017e5b8bb);
$parcel$export(module.exports, "setSelectedIssueKeys", () => $0f9bb432948670dc$export$bf3ca5f3d49d924b);
$parcel$export(module.exports, "REFRESH_SIDEBAR_ISSUE_VIEW", () => $0f9bb432948670dc$export$1801c47649c78d8c);
$parcel$export(module.exports, "refreshSidebarIssueView", () => $0f9bb432948670dc$export$38079ab67858e297);
const $0f9bb432948670dc$export$bc6edc14c190bba8 = 'state.actions.ui.ONBOARDING_RESOLVED';
const $0f9bb432948670dc$export$796732fe0ca79daa = (onboardingResolved)=>({
        type: $0f9bb432948670dc$export$bc6edc14c190bba8,
        payload: {
            onboardingResolved: onboardingResolved
        }
    });
const $0f9bb432948670dc$export$f22130204a023293 = 'state.actions.ui.SET_DELETE_MODAL_VISIBILITY';
const $0f9bb432948670dc$export$190dceccabe571f5 = (isVisible)=>({
        type: $0f9bb432948670dc$export$f22130204a023293,
        payload: {
            isVisible: isVisible
        }
    });
const $0f9bb432948670dc$export$f95c039bb3ac7543 = 'state.actions.ui.SET_MODAL_IS_DELETING';
const $0f9bb432948670dc$export$99f97fd8f5eb3051 = (isDeleting)=>({
        type: $0f9bb432948670dc$export$f95c039bb3ac7543,
        payload: {
            isDeleting: isDeleting
        }
    });
const $0f9bb432948670dc$export$5ab05b9e296b458f = 'state.actions.ui.DELETE_QUEUE';
const $0f9bb432948670dc$export$582ac7ef548f7ea3 = (queueId, onDeleteComplete, analyticsEvent)=>({
        type: $0f9bb432948670dc$export$5ab05b9e296b458f,
        payload: {
            queueId: queueId,
            onDeleteComplete: onDeleteComplete
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $0f9bb432948670dc$export$c87901f527c6ecbf = 'state.actions.ui.DELETE_QUEUE_FAILURE';
const $0f9bb432948670dc$export$c9318fa931763930 = (queueName, error)=>({
        type: $0f9bb432948670dc$export$c87901f527c6ecbf,
        payload: {
            error: error,
            queueName: queueName
        }
    });
const $0f9bb432948670dc$export$a3657f3e279415da = 'state.actions.ui.SET_NAV_COLLAPSED';
const $0f9bb432948670dc$export$24eece95a2a56eca = (isNavCollapsed)=>({
        type: $0f9bb432948670dc$export$a3657f3e279415da,
        payload: {
            isNavCollapsed: isNavCollapsed
        }
    });
const $0f9bb432948670dc$export$ad460ac72e5ca5db = 'state.actions.ui.SET_ISSUE_KEY_CONTEXT';
const $0f9bb432948670dc$export$e203161ddfaf33fa = (issueKey)=>({
        type: $0f9bb432948670dc$export$ad460ac72e5ca5db,
        payload: {
            issueKey: issueKey
        }
    });
const $0f9bb432948670dc$export$8d3ef3d3f35457dd = 'state.actions.ui.SET_SIDEBAR_ISSUE_KEY';
const $0f9bb432948670dc$export$31f0fd7bef8d8084 = (sidebarIssueKey)=>({
        type: $0f9bb432948670dc$export$8d3ef3d3f35457dd,
        payload: {
            sidebarIssueKey: sidebarIssueKey
        }
    });
const $0f9bb432948670dc$export$e61a8facd12c5b11 = 'state.actions.ui.SET_SIDEBAR_REACT_KEY';
const $0f9bb432948670dc$export$f3d2a7eb1d1eb1db = (sidebarReactKey)=>({
        type: $0f9bb432948670dc$export$e61a8facd12c5b11,
        payload: {
            sidebarReactKey: sidebarReactKey
        }
    });
const $0f9bb432948670dc$export$ff2fe70017e5b8bb = 'state.actions.ui.SET_SELECTED_ISSUE_KEYS';
const $0f9bb432948670dc$export$bf3ca5f3d49d924b = (selectedIssueKeys)=>({
        type: $0f9bb432948670dc$export$ff2fe70017e5b8bb,
        payload: {
            selectedIssueKeys: selectedIssueKeys
        }
    });
const $0f9bb432948670dc$export$1801c47649c78d8c = 'state.actions.ui.REFRESH_SIDEBAR_ISSUE_VIEW';
const $0f9bb432948670dc$export$38079ab67858e297 = ({ issueKey: issueKey } = {})=>({
        type: $0f9bb432948670dc$export$1801c47649c78d8c,
        payload: {
            issueKey: issueKey
        }
    });

});


parcelRegister("5gpxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dae2a113075c984$export$2e2bcd8739ae039);
parcelRequire("6cbqE");

var $dd29Z = parcelRequire("dd29Z");

var $3HGy4 = parcelRequire("3HGy4");

var $fy6YG = parcelRequire("fy6YG");

var $dOWTu = parcelRequire("dOWTu");

var $627A7 = parcelRequire("627A7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2dae2a113075c984$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $dOWTu.EDIT_QUEUE)).switchMap(()=>{
            const state = store.getState();
            const projectKey = (0, $fy6YG.getProjectKey)(state);
            const queueId = (0, $627A7.getQueueId)(state);
            const category = (0, $627A7.getCategory)(state);
            if (push) return push((0, $dd29Z.getEditQueueFragment)((0, $3HGy4.fromQueueId)(queueId), category));
            // fallback to push state nav in case anything goes wrong.
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            return (0, $dd29Z.navigate)(projectKey, (0, $dd29Z.getEditQueueFragment)((0, $3HGy4.fromQueueId)(queueId), category));
        });

});


parcelRegister("88Pxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f518ea5dd13a373a$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $9vBS6 = parcelRequire("9vBS6");

var $fy6YG = parcelRequire("fy6YG");

var $acLoP = parcelRequire("acLoP");

var $4uvJ3 = parcelRequire("4uvJ3");

var $dOWTu = parcelRequire("dOWTu");

var $627A7 = parcelRequire("627A7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f518ea5dd13a373a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $4uvJ3.LOAD_PAGE_DATA), (0, $dOWTu.QUEUE_CHANGED)).switchMap((action)=>{
        const { payload: payload, type: type } = action;
        const queueId = type === (0, $4uvJ3.LOAD_PAGE_DATA) ? payload.queueId : payload.queue.id;
        const state = store.getState();
        const baseUrl = (0, $fy6YG.getBaseUrl)(state);
        const projectKey = (0, $fy6YG.getProjectKey)(state);
        if ((0, $627A7.isQueueTransient)(state)) return (0, $kVLXA.Observable).empty();
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        return (0, $acLoP.default)(baseUrl, projectKey, queueId).switchMap(()=>(0, $kVLXA.Observable).empty()).catch((error)=>{
            (0, $9vBS6.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.ops.recent.add', `Failed to add recent queue - error: ${JSON.stringify(error)}`, {
                queueId: queueId
            });
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("acLoP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce14dde50557028d$export$2e2bcd8739ae039);

var $bFU4G = parcelRequire("bFU4G");

var $5OrSA = parcelRequire("5OrSA");

var $3HGy4 = parcelRequire("3HGy4");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ce14dde50557028d$export$2e2bcd8739ae039 = (baseUrl, projectKey, queueId)=>{
    const fetchStartTime = performance.now();
    const result = (0, $5OrSA.fetchJson$)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues-history?queueId=${(0, $3HGy4.fromQueueId)(queueId)}`, {
        method: 'POST'
    });
    (0, $bFU4G.addSpanToAll)('fetch', 'rest/servicedesk/1/servicedesk/projectKey/queues-history?queueId=', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    return result;
};

});


parcelRegister("7DIsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbcd090b395da97f$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");


var $bzBCj = parcelRequire("bzBCj");

var $jdGLR = parcelRequire("jdGLR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fbcd090b395da97f$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $jdGLR.FETCH_ISSUE_DATA_ONSCROLL)).switchMap((action)=>(0, $kVLXA.Observable).of((0, $bzBCj.loadIssuesAction)(action.payload, (0, $36dd7e3255fc2bff$export$d4d94a8c13e2df1d))));

});

parcelRegister("eNiyn", function(module, exports) {

$parcel$export(module.exports, "sortEpicNew", () => $295145d5d4fd7fe8$export$574b0a1dcfa6db0d);
$parcel$export(module.exports, "default", () => $295145d5d4fd7fe8$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $3C2IL = parcelRequire("3C2IL");

var $5Cc9F = parcelRequire("5Cc9F");

var $hx8oz = parcelRequire("hx8oz");

var $iA9LF = parcelRequire("iA9LF");
const $295145d5d4fd7fe8$export$574b0a1dcfa6db0d = (0, $e1AU2.combineEpics)((0, $3C2IL.default), (0, $hx8oz.default), (0, $5Cc9F.default), (0, $iA9LF.default));
var // cleanup migrate_sorting_to_user_property
$295145d5d4fd7fe8$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $3C2IL.default), (0, $hx8oz.default));

});
parcelRegister("3C2IL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd74cbb1ee0dd7a$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");


var $bzBCj = parcelRequire("bzBCj");

var $jdGLR = parcelRequire("jdGLR");

var $627A7 = parcelRequire("627A7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ddd74cbb1ee0dd7a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jdGLR.SORT_ORDER_CHANGED)).switchMap((action)=>{
        const state = store.getState();
        const queueId = (0, $627A7.getQueueId)(state);
        const { sortedBy: sortedBy, sortOrder: sortOrder } = action.payload;
        return (0, $kVLXA.Observable).of((0, $jdGLR.sortOrderOptimisticUpdateAction)(queueId, sortedBy, sortOrder), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $bzBCj.loadIssuesAction)(0, (0, $36dd7e3255fc2bff$export$2003e3fdddd4c35b)));
    });

});

parcelRegister("5Cc9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bed81a6f18c7c4a$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $9vBS6 = parcelRequire("9vBS6");

var $kkYZg = parcelRequire("kkYZg");

var $jdGLR = parcelRequire("jdGLR");

var $3jtVD = parcelRequire("3jtVD");

var $627A7 = parcelRequire("627A7");

var $koOIX = parcelRequire("koOIX");
const $3bed81a6f18c7c4a$var$epic = (action$, store)=>action$.ofType((0, $jdGLR.RESET_SORT_ORDER)).switchMap(()=>{
        const state = store.getState();
        const accountId = (0, $koOIX.getAccountId)(state);
        const queueId = (0, $627A7.getQueueId)(state);
        const createAnalyticsEvent = (0, $3jtVD.getCreateAnalyticsEvent)(state);
        return (0, $kkYZg.removeQueueIssuesSortingDataUserProperty)(queueId, accountId).switchMap(()=>{
            if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueueManualSortingToUserProperty reset');
            return (0, $kVLXA.Observable).empty();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'opsRemoveQueueSorting',
                    packageName: 'jira-servicedesk-queues-agent-view',
                    teamName: 'Flash'
                }
            });
            (0, $9vBS6.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops', 'User properties failure for reset sorting');
            return (0, $kVLXA.Observable).empty();
        });
    });
var $3bed81a6f18c7c4a$export$2e2bcd8739ae039 = $3bed81a6f18c7c4a$var$epic;

});
parcelRegister("kkYZg", function(module, exports) {

$parcel$export(module.exports, "removeQueueIssuesSortingDataUserProperty", () => $93049d0e7b128499$export$6f099fa03e8e42e9);
$parcel$export(module.exports, "updateQueueIssuesSortingDataUserProperty", () => $93049d0e7b128499$export$d117216f4f9bafb6);

var $5OrSA = parcelRequire("5OrSA");

const $93049d0e7b128499$export$2f7635a22c9f0f05 = (queueId)=>`${0, $3ce1d25fa44e4264$export$380a2d1eea3be734}${queueId}`;
const $93049d0e7b128499$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $93049d0e7b128499$var$MISSING_ACCOUNT_ID_ERROR_MSG = 'accountId is missing.';
const $93049d0e7b128499$export$6f099fa03e8e42e9 = (queueId, accountId)=>{
    if (!accountId) throw new Error($93049d0e7b128499$var$MISSING_ACCOUNT_ID_ERROR_MSG);
    return (0, $5OrSA.fetchJson$)($93049d0e7b128499$export$f474e53c8191800a(accountId, $93049d0e7b128499$export$2f7635a22c9f0f05(queueId)), {
        method: 'DELETE'
    });
};
const $93049d0e7b128499$export$d117216f4f9bafb6 = (data, queueId, accountId)=>{
    if (!accountId) throw new Error($93049d0e7b128499$var$MISSING_ACCOUNT_ID_ERROR_MSG);
    return (0, $5OrSA.fetchText$)($93049d0e7b128499$export$f474e53c8191800a(accountId, $93049d0e7b128499$export$2f7635a22c9f0f05(queueId)), {
        method: 'PUT',
        body: JSON.stringify(data)
    });
};

});

parcelRegister("koOIX", function(module, exports) {

$parcel$export(module.exports, "getAccountId", () => $418b83993932e10c$export$c1e0336bde96e2dc);
const $418b83993932e10c$export$c1e0336bde96e2dc = (state)=>state.appProps.atlassianAccountId;

});


parcelRegister("hx8oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e245263f8b3fc1$export$2e2bcd8739ae039);
parcelRequire("d0pqD");

var $kVLXA = parcelRequire("kVLXA");

var $4R6GH = parcelRequire("4R6GH");


var $bzBCj = parcelRequire("bzBCj");

var $jdGLR = parcelRequire("jdGLR");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66e245263f8b3fc1$export$2e2bcd8739ae039 = (action$)=>(0, $4R6GH.fg)('clean_local_storage_sorting') ? action$.ofType((0, $jdGLR.RESET_SORT_ORDER)).switchMap(()=>(0, $kVLXA.Observable).of((0, $jdGLR.sortOrderOptimisticResetAction)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $bzBCj.loadIssuesAction)(0, (0, $36dd7e3255fc2bff$export$2003e3fdddd4c35b)))) : action$.ofType((0, $jdGLR.RESET_SORT_ORDER)).map(()=>(0, $bzBCj.loadIssuesAction)(0, (0, $36dd7e3255fc2bff$export$2003e3fdddd4c35b)));

});

parcelRegister("iA9LF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5dbed787a83b6f$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $9vBS6 = parcelRequire("9vBS6");

var $kkYZg = parcelRequire("kkYZg");

var $jdGLR = parcelRequire("jdGLR");

var $3jtVD = parcelRequire("3jtVD");

var $627A7 = parcelRequire("627A7");

var $koOIX = parcelRequire("koOIX");
const $fa5dbed787a83b6f$var$epic = (action$, store)=>// remove UPDATE_SORTING_INFO_IN_USER_PROPERTY as part of the ff clean_local_storage_sorting
    action$.ofType((0, $jdGLR.SORT_ORDER_CHANGED), (0, $jdGLR.UPDATE_SORTING_INFO_IN_USER_PROPERTY)).switchMap((action)=>{
        const state = store.getState();
        const queueId = (0, $627A7.getQueueId)(state);
        const manualSorting = action.payload;
        const accountId = (0, $koOIX.getAccountId)(state);
        const createAnalyticsEvent = (0, $3jtVD.getCreateAnalyticsEvent)(state);
        return (0, $kkYZg.updateQueueIssuesSortingDataUserProperty)(manualSorting, queueId, accountId).switchMap(()=>{
            if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueueManualSortingToUserProperty updated');
            return (0, $kVLXA.Observable).empty();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'opsUpdateQueueSorting',
                    packageName: 'jira-servicedesk-queues-agent-view',
                    teamName: 'Flash'
                }
            });
            (0, $9vBS6.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops', 'User properties failure for update sorting');
            return (0, $kVLXA.Observable).empty();
        });
    });
var $fa5dbed787a83b6f$export$2e2bcd8739ae039 = $fa5dbed787a83b6f$var$epic;

});


parcelRegister("e8LE2", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbf49da2b6641a6e$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $hhweD = parcelRequire("hhweD");

var $3HGy4 = parcelRequire("3HGy4");

var $fy6YG = parcelRequire("fy6YG");

var $jdGLR = parcelRequire("jdGLR");

var $lHf6h = parcelRequire("lHf6h");

var $WS8Y1 = parcelRequire("WS8Y1");

var $6pmxE = parcelRequire("6pmxE");

var $627A7 = parcelRequire("627A7");

var $h4yk3 = parcelRequire("h4yk3");

var $jeVA9 = parcelRequire("jeVA9");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbf49da2b6641a6e$var$onTableChange = (state, analyticsEvent)=>{
    const queueId = (0, $627A7.getQueueId)(state);
    const issueKeys = (0, $WS8Y1.getIssueKeysForPage)(state);
    const sortedBy = (0, $h4yk3.getSortedByColumn)(state);
    const sortOrder = (0, $h4yk3.getSortOrder)(state);
    const atlassianAccountId = (0, $fy6YG.getAtlassianAccountId)(state);
    const issueStatusIdsCountsInQueue = (0, $lHf6h.getIssueStatusIdsCounts)(state);
    const numberOfIssuesAssignedToCurrentUser = (0, $lHf6h.getIssueCountByAssignee)(state, atlassianAccountId);
    !(0, $jeVA9.isLoadingIssues)(state) && (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
        containerType: 'project',
        containerId: `${(0, $fy6YG.getProjectId)(state)}`,
        action: 'viewed',
        objectType: 'queue',
        objectId: `${(0, $3HGy4.fromQueueId)(queueId)}`,
        actionSubjectId: `${(0, $3HGy4.fromQueueId)(queueId)}`,
        attributes: {
            isAdmin: (0, $fy6YG.getIsAdmin)(state),
            isTransient: (0, $627A7.isQueueTransient)(state),
            numberOfIssuesDisplayed: issueKeys.length,
            numberOfColumnsDisplayed: (0, $627A7.getNumberOfColumns)(state),
            displayedColumnsInOrder: (0, $627A7.getAllFieldTypes)(state),
            sortedByColumnId: sortedBy,
            sortOrder: sortOrder,
            // store as a list of 1 to prevent amplitude creating too many attributes
            issueStatusIdsCountsInQueue: [
                issueStatusIdsCountsInQueue
            ],
            numberOfIssuesAssignedToCurrentUser: numberOfIssuesAssignedToCurrentUser,
            ...(0, $6pmxE.isItsmProject)(state) ? {
                itsmPractices: (0, $6pmxE.getEnabledPractices)(state)
            } : {}
        }
    });
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$fbf49da2b6641a6e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jdGLR.TABLE_CHANGED)).switchMap((action)=>{
        $fbf49da2b6641a6e$var$onTableChange(store.getState(), action.meta.analyticsEvent);
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("6pmxE", function(module, exports) {

$parcel$export(module.exports, "getEnabledPractices", () => $aaa9b795b61e53d6$export$8f33cbf43c24a6e7);
$parcel$export(module.exports, "isItsmProject", () => $aaa9b795b61e53d6$export$90859dc8800b0a1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $hqTkp = parcelRequire("hqTkp");

var $oCMSG = parcelRequire("oCMSG");

var $a5xpi = parcelRequire("a5xpi");

var $627A7 = parcelRequire("627A7");
const $aaa9b795b61e53d6$var$getProjectPractices = (state)=>(0, $a5xpi.getPersisted)(state).practices;
const $aaa9b795b61e53d6$export$8f33cbf43c24a6e7 = (0, $dGvGJ.createSelector)((0, $627A7.getCategory), (category = (0, $oCMSG.NO_CATEGORY))=>category === (0, $oCMSG.NO_CATEGORY) ? [] : [
        category
    ]);
const $aaa9b795b61e53d6$export$90859dc8800b0a1b = (0, $dGvGJ.createSelector)($aaa9b795b61e53d6$var$getProjectPractices, (practiceList)=>(0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(practiceList, (0, $oCMSG.NO_CATEGORY)).length > 0);

});
parcelRegister("hqTkp", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, values) : [];
});
module.exports = $cb0fc8686550aa11$var$without;

});




parcelRegister("e6t8P", function(module, exports) {

$parcel$export(module.exports, "SEND_ANALYTIC_CREATOR", () => $5765c4b843ff159c$export$2f4a111814bf0140);
$parcel$export(module.exports, "sendAnalyticCreatorAction", () => $5765c4b843ff159c$export$632dfc648efd02eb);
const $5765c4b843ff159c$export$2f4a111814bf0140 = 'state.actions.analytic.SEND_ANALYTIC_CREATOR';
const $5765c4b843ff159c$export$632dfc648efd02eb = (createAnalyticsEvent)=>({
        type: $5765c4b843ff159c$export$2f4a111814bf0140,
        payload: {
            createAnalyticsEvent: createAnalyticsEvent
        }
    });

});

parcelRegister("7mC60", function(module, exports) {

$parcel$export(module.exports, "RESET_PROJECT_CONTEXT", () => $f80bde55847748a4$export$dfc3064c33d1270a);
$parcel$export(module.exports, "resetProjectContextAction", () => $f80bde55847748a4$export$6a8d4f70c30642d0);
const $f80bde55847748a4$export$dfc3064c33d1270a = 'state.actions.page.RESET_PROJECT_CONTEXT';
const $f80bde55847748a4$export$6a8d4f70c30642d0 = (projectContext)=>({
        type: $f80bde55847748a4$export$dfc3064c33d1270a,
        payload: {
            projectContext: projectContext
        }
    });

});

parcelRegister("e8jJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70d20325a5740f$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $xGXdz = parcelRequire("xGXdz");

var $YXENx = parcelRequire("YXENx");

var $2tDcp = parcelRequire("2tDcp");
const $0f70d20325a5740f$var$combinedReducer = (0, $3f2cs.combineReducers)({
    appProps: $xGXdz.default,
    persisted: $YXENx.default,
    ui: $2tDcp.default
});
var $0f70d20325a5740f$export$2e2bcd8739ae039 = $0f70d20325a5740f$var$combinedReducer;

});
parcelRegister("xGXdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d7b613f95393230$export$2e2bcd8739ae039);

var $7mC60 = parcelRequire("7mC60");
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $8d7b613f95393230$var$reducer = (state, action)=>{
    switch(action.type){
        case 0, $7mC60.RESET_PROJECT_CONTEXT:
            return {
                ...state,
                ...action.payload.projectContext
            };
        default:
            {
                // @ts-expect-error - TS2322 - Type 'ResetProjectContextAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state || null;
            }
    }
};
var $8d7b613f95393230$export$2e2bcd8739ae039 = $8d7b613f95393230$var$reducer;

});

parcelRegister("YXENx", function(module, exports) {

$parcel$export(module.exports, "default", () => $83de00592ca89ccf$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $2oqkf = parcelRequire("2oqkf");

var $d3UmX = parcelRequire("d3UmX");

var $hhDWN = parcelRequire("hhDWN");

var $b12Q0 = parcelRequire("b12Q0");

var $7fH4W = parcelRequire("7fH4W");

var $kQNj8 = parcelRequire("kQNj8");

var $7pcZu = parcelRequire("7pcZu");

var $8CVcG = parcelRequire("8CVcG");
const $83de00592ca89ccf$var$combinedReducer = (0, $3f2cs.combineReducers)({
    issues: $b12Q0.default,
    queue: $kQNj8.default,
    updateMetadata: $8CVcG.default,
    experienceTracking: $d3UmX.default,
    practices: $7fH4W.default,
    filter: $hhDWN.default,
    analytic: $2oqkf.default,
    ssrIssuesData: $7pcZu.default
});
var $83de00592ca89ccf$export$2e2bcd8739ae039 = $83de00592ca89ccf$var$combinedReducer;

});
parcelRegister("2oqkf", function(module, exports) {

$parcel$export(module.exports, "default", () => $078592059ad38576$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $e6t8P = parcelRequire("e6t8P");

var $dmprn = parcelRequire("dmprn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$078592059ad38576$export$2e2bcd8739ae039 = (state = (0, $dmprn.initialState), action)=>{
    switch(action.type){
        case 0, $e6t8P.SEND_ANALYTIC_CREATOR:
            {
                const { createAnalyticsEvent: createAnalyticsEvent } = action.payload;
                return (0, $7uUwQ.assoc)(state, 'createAnalyticsEvent', createAnalyticsEvent);
            }
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("dmprn", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d1fc25a5e8538100$export$d4c72bab9d6cc13a);
const $d1fc25a5e8538100$export$d4c72bab9d6cc13a = {
    createAnalyticsEvent: undefined
};

});


parcelRegister("d3UmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $91c320b20f577321$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $4R6GH = parcelRequire("4R6GH");

var $3HGy4 = parcelRequire("3HGy4");



var $haCWn = parcelRequire("haCWn");

var $bzBCj = parcelRequire("bzBCj");

var $4uvJ3 = parcelRequire("4uvJ3");
const $91c320b20f577321$var$initialExperienceTrackingState = {
    initialDataLoadStatus: (0, $d86382c25b911bd9$export$2fc553b73365b8c4),
    hasLoadedIssueDataFromCache: false
};
const $91c320b20f577321$var$ERROR_STATUS_CODE_ALLOWLIST_OLD = [
    403,
    401,
    429
];
const $91c320b20f577321$var$ERROR_STATUS_CODE_ALLOWLIST = [
    400,
    401,
    403,
    429
];
// We don't want to cover all 400 errors because some might be a bug, in most cases issuelist shouldn't return 400.
const $91c320b20f577321$var$NON_EXPERIENCE_FAILURE_REASON_KEY = [
    'sd.issue.search.invalid.project',
    'Invalid category'
];
const $91c320b20f577321$var$isStatusCodeAnExperienceFailureOld = (statusCode)=>// This indicates that browser has no connectivity
    // @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    Boolean(statusCode) && !$91c320b20f577321$var$ERROR_STATUS_CODE_ALLOWLIST_OLD.includes(statusCode);
const $91c320b20f577321$var$isStatusCodeAnExperienceFailure = (statusCode)=>// This indicates that browser has no connectivity
    // @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    Boolean(statusCode) && !$91c320b20f577321$var$ERROR_STATUS_CODE_ALLOWLIST.includes(statusCode);
const $91c320b20f577321$var$isProjectOrCategoryNotFound = (error, statusCode)=>statusCode === 400 && $91c320b20f577321$var$NON_EXPERIENCE_FAILURE_REASON_KEY.includes(error?.reasonKey);
const $91c320b20f577321$var$isAnExperienceFailure = (error, statusCode)=>{
    if ((0, $4R6GH.fg)('exclude_issue_list_400_from_view_queue')) return $91c320b20f577321$var$isStatusCodeAnExperienceFailure(statusCode);
    return $91c320b20f577321$var$isStatusCodeAnExperienceFailureOld(statusCode) && !$91c320b20f577321$var$isProjectOrCategoryNotFound(error, statusCode);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$91c320b20f577321$export$2e2bcd8739ae039 = (state = $91c320b20f577321$var$initialExperienceTrackingState, action)=>{
    switch(action.type){
        case 0, $bzBCj.LOAD_ISSUES_SUCCESS:
            {
                let newStateChain = (0, $7uUwQ.chain)(state);
                if (action.payload.loadedIssuesResponse.source === (0, $3HGy4.LOCAL_STORAGE_SOURCE)) newStateChain = newStateChain.assoc('hasLoadedIssueDataFromCache', true);
                else if (action.payload.source === (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8)) // Do no set status to true if the payload is from localstorage, that doesn't count
                newStateChain = newStateChain.assoc('initialDataLoadStatus', (0, $d86382c25b911bd9$export$d3ab616c5a76689d));
                return newStateChain.value();
            }
        case 0, $bzBCj.LOAD_ISSUES_FAILURE:
            if (action.payload.source === (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8)) {
                if ($91c320b20f577321$var$isAnExperienceFailure(action.payload.error, action.payload.statusCode)) {
                    if ((0, $4R6GH.fg)('adding-more-data-for-viewqueue-and-viewnav-event')) return {
                        ...state,
                        initialDataLoadStatus: (0, $d86382c25b911bd9$export$70ef9aa03c29b42b),
                        errorStatusCode: action.payload.statusCode,
                        errorMessages: action.payload.error?.errors,
                        errorKey: action.payload.error?.reasonKey,
                        traceId: action.payload.traceId
                    };
                    return {
                        ...state,
                        initialDataLoadStatus: (0, $d86382c25b911bd9$export$70ef9aa03c29b42b),
                        errorStatusCode: action.payload.statusCode
                    };
                }
                return (0, $7uUwQ.assoc)(state, 'initialDataLoadStatus', (0, $d86382c25b911bd9$export$d3ab616c5a76689d));
            }
            return state;
        case 0, $4uvJ3.LOAD_PAGE_DATA_FAILURE:
            if ($91c320b20f577321$var$isStatusCodeAnExperienceFailure(action.payload.statusCode)) return (0, $7uUwQ.assoc)(state, 'initialDataLoadStatus', (0, $d86382c25b911bd9$export$70ef9aa03c29b42b));
            return state;
        case 0, $4uvJ3.RESET_STATE:
        case 0, $haCWn.EXPERIENCE_TRACKING_RESET:
            return $91c320b20f577321$var$initialExperienceTrackingState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
const $d86382c25b911bd9$export$2fc553b73365b8c4 = 'pending';
const $d86382c25b911bd9$export$70ef9aa03c29b42b = 'failed';
const $d86382c25b911bd9$export$d3ab616c5a76689d = 'succeeded';


parcelRegister("hhDWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $51cf9848cd5ebf89$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");

var $8EHZw = parcelRequire("8EHZw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$51cf9848cd5ebf89$export$2e2bcd8739ae039 = (state = (0, $8EHZw.initialState), action)=>{
    switch(action.type){
        case 0, $bzBCj.LOAD_ISSUES_SUCCESS:
            {
                const filtered = action.payload.loadedIssuesResponse.isFiltered;
                return (0, $7uUwQ.chain)(state).assoc('isCurrentDataFiltered', filtered).assoc('isNewFilterQueryPending', false).value();
            }
        case 0, $fnQyW.FILTER_QUERY_CHANGED:
            {
                const { filterQuery: filterQuery } = action.payload;
                return (0, $7uUwQ.assoc)(state, 'filterQuery', filterQuery);
            }
        case 0, $fnQyW.IS_NEW_FILTER_QUERY_PENDING:
            {
                const { isNewFilterQueryPending: isNewFilterQueryPending } = action.payload;
                return (0, $7uUwQ.assoc)(state, 'isNewFilterQueryPending', isNewFilterQueryPending);
            }
        case 0, $fnQyW.IS_FILTER_FOCUSED:
            {
                const { isFilterFocused: isFilterFocused } = action.payload;
                return (0, $7uUwQ.assoc)(state, 'isFilterFocused', isFilterFocused);
            }
        case 0, $fnQyW.IS_FILTER_FAILED:
            return (0, $7uUwQ.chain)(state).assoc('isCurrentDataFiltered', true).assoc('isNewFilterQueryPending', false).value();
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("8EHZw", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $268f0dc04e4fa1c0$export$d4c72bab9d6cc13a);
const $268f0dc04e4fa1c0$export$d4c72bab9d6cc13a = {
    filterQuery: null,
    isNewFilterQueryPending: false,
    isCurrentDataFiltered: false,
    isFilterFocused: false
};

});


parcelRegister("b12Q0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe9b90c8341a2419$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $6sLXW = parcelRequire("6sLXW");

var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");

var $4uvJ3 = parcelRequire("4uvJ3");

var $jdGLR = parcelRequire("jdGLR");

var $eiOBt = parcelRequire("eiOBt");
const $fe9b90c8341a2419$var$DEFAULT_ISSUES_STATE = {
    collection: [],
    index: {},
    totalCount: 0
};
const $fe9b90c8341a2419$var$resetIssuesState = ()=>({
        ...$fe9b90c8341a2419$var$DEFAULT_ISSUES_STATE,
        timeWhenLastInitialized: (0, $6RCeq.default).now()
    });
// @ts-expect-error - TS2314 - Generic type 'Reducer' requires 1 type argument(s). | TS1016 - A required parameter cannot follow an optional parameter.
const $fe9b90c8341a2419$var$reducer = (state, action)=>{
    if (state === undefined) return $fe9b90c8341a2419$var$resetIssuesState();
    switch(action.type){
        case 0, $4uvJ3.RESET_STATE:
            return $fe9b90c8341a2419$var$resetIssuesState();
        case 0, $jdGLR.PAGE_CHANGED:
            return (0, $7uUwQ.chain)(state).assoc('collection', []).assoc('index', {}).assoc('timeWhenLastInitialized', (0, $6RCeq.default).now()).value();
        case 0, $fnQyW.IS_FILTER_FAILED:
            return (0, $7uUwQ.chain)(state).assoc('totalCount', 0).value();
        case 0, $bzBCj.LOAD_ISSUES_SUCCESS:
            {
                // This is here because setting the mark in a side effect
                // doesn't guarantee this is fired straight away.
                if (!(0, $x9xyg.getMark)('jsd.performance.profile.queues.issues.loaded')) (0, $x9xyg.setMark)('jsd.performance.profile.queues.issues.loaded');
                const { startIndex: startIndex, loadedIssuesResponse: { totalCount: totalCount, isUsingDefaultSorting: isUsingDefaultSorting }, loadedIssuesResponse: { issues: issues } } = action.payload;
                return (0, $eiOBt.addIssuesResponseToState)(startIndex, totalCount, isUsingDefaultSorting, issues, state);
            }
        case 0, $6sLXW.CHANGE_ISSUE_FIELD_VALUE:
            {
                const { issueKey: issueKey, columnId: columnId, newValue: newValue } = action.payload;
                const issueIndex = state.index[issueKey];
                return (0, $7uUwQ.updateIn)(state, [
                    'collection'
                ], (issueCollection)=>{
                    // TODO FREE-2659 - unfortunately need to ensure the index entry wasn't stale, restructure issue object array + index -> a store where issues can be accessed by key
                    const issue = issueCollection[issueIndex];
                    if (issue && issue.key === issueKey) {
                        const newIssueValue = (0, $7uUwQ.updateIn)(issue, [
                            'fields',
                            columnId
                        ], (storedValue)=>(0, $7uUwQ.merge)(storedValue, newValue));
                        return (0, $7uUwQ.chain)(issueCollection).set(issueIndex, newIssueValue).value();
                    }
                    return issueCollection;
                });
            }
        case 0, $jdGLR.SORT_ORDER_CHANGED:
            return (0, $7uUwQ.assoc)(state, 'timeWhenLastInitialized', (0, $6RCeq.default).now());
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $fe9b90c8341a2419$export$2e2bcd8739ae039 = $fe9b90c8341a2419$var$reducer;

});
parcelRegister("6sLXW", function(module, exports) {

$parcel$export(module.exports, "CHANGE_ISSUE_FIELD_VALUE", () => $e5e4d57a31067687$export$cfdceb3f950b2ccc);
$parcel$export(module.exports, "changeIssueFieldValueAction", () => $e5e4d57a31067687$export$138172374138566d);
// CHANGE_ISSUE_FIELD_VALUE
const $e5e4d57a31067687$export$cfdceb3f950b2ccc = 'state.actions.issue.field.CHANGE_ISSUE_FIELD_VALUE';
const $e5e4d57a31067687$export$138172374138566d = (issueKey, columnId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
newValue)=>({
        type: $e5e4d57a31067687$export$cfdceb3f950b2ccc,
        payload: {
            issueKey: issueKey,
            columnId: columnId,
            newValue: newValue
        }
    });

});

parcelRegister("eiOBt", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ISSUES_STATE", () => $eb3e3b9f3e487a89$export$95fccf325af63293);
$parcel$export(module.exports, "addIssuesResponseToState", () => $eb3e3b9f3e487a89$export$b2c48a44510b4c8);

var $7uUwQ = parcelRequire("7uUwQ");

var $ajpes = parcelRequire("ajpes");

var $fr1K2 = parcelRequire("fr1K2");
const $eb3e3b9f3e487a89$export$95fccf325af63293 = {
    collection: [],
    index: {},
    totalCount: 0,
    timeWhenLastInitialized: 0,
    isUsingDefaultSorting: false
};
const $eb3e3b9f3e487a89$var$updateCollection = (collection, index, issue, startIndex)=>{
    const { key: key } = issue;
    const position = issue.position + startIndex;
    const newCollection = collection;
    // Find where the issue used to live in the collection, and delete if it exists
    if (index[key] != null) {
        const oldPosition = index[key];
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        if (newCollection[oldPosition] != null && newCollection[oldPosition].key === key) delete newCollection[oldPosition];
    }
    newCollection[position] = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(issue, 'position');
    return newCollection;
};
const $eb3e3b9f3e487a89$var$updateIndex = (index, issue, startIndex)=>{
    const { key: key } = issue;
    const position = startIndex + issue.position;
    const newIndex = index;
    newIndex[key] = position;
    return newIndex;
};
const $eb3e3b9f3e487a89$export$b2c48a44510b4c8 = (startIndex, totalCount, isUsingDefaultSorting, issues, state = $eb3e3b9f3e487a89$export$95fccf325af63293)=>{
    // Slice as any issues in collection that exist beyond totalCount need to be deleted
    const collection = state.collection.slice(0, totalCount);
    const index = {
        ...state.index
    };
    issues.forEach((newIssue)=>{
        $eb3e3b9f3e487a89$var$updateCollection(collection, index, newIssue, startIndex);
        $eb3e3b9f3e487a89$var$updateIndex(index, newIssue, startIndex);
    });
    if (state.totalCount === totalCount && state.isUsingDefaultSorting === isUsingDefaultSorting && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(state.index, index) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(state.collection, collection)) return state;
    return (0, $7uUwQ.chain)(state).assoc('collection', collection).assoc('index', index).assoc('totalCount', totalCount).assoc('isUsingDefaultSorting', isUsingDefaultSorting).value();
};

});


parcelRegister("7fH4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $32782fcaa0fd021c$export$2e2bcd8739ae039);

var $ktE3b = parcelRequire("ktE3b");
const $32782fcaa0fd021c$var$defaultPracticesState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$32782fcaa0fd021c$export$2e2bcd8739ae039 = (state = $32782fcaa0fd021c$var$defaultPracticesState, action)=>{
    switch(action.type){
        case 0, $ktE3b.SET_ENABLED_PRACTICES:
            return action.payload.practices;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("ktE3b", function(module, exports) {

$parcel$export(module.exports, "SET_ENABLED_PRACTICES", () => $29f3913b7772d5c8$export$2c78e2c3ded512ec);
$parcel$export(module.exports, "setEnabledPracticesAction", () => $29f3913b7772d5c8$export$d050127f311d3c95);
const $29f3913b7772d5c8$export$2c78e2c3ded512ec = 'state.actions.practices.SET_ENABLED_PRACTICES';
const $29f3913b7772d5c8$export$d050127f311d3c95 = (practices)=>({
        type: $29f3913b7772d5c8$export$2c78e2c3ded512ec,
        payload: {
            practices: practices
        }
    });

});


parcelRegister("kQNj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $07025a30dd48a503$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $21Uac = parcelRequire("21Uac");


var $bzBCj = parcelRequire("bzBCj");

var $4uvJ3 = parcelRequire("4uvJ3");

var $dOWTu = parcelRequire("dOWTu");

var $jdGLR = parcelRequire("jdGLR");
const $07025a30dd48a503$var$DEFAULT_QUEUE_STATE = {
    pagination: {
        currentPage: 1
    },
    fetchStartIndex: 0,
    category: undefined
};
var // SHIELD-3575 This reducer describes queue page data and should be renamed to
// avoid ambiguity with state in ui/current-queue
// eslint-disable-next-line jira/import/no-anonymous-default-export
$07025a30dd48a503$export$2e2bcd8739ae039 = (state = $07025a30dd48a503$var$DEFAULT_QUEUE_STATE, action)=>{
    switch(action.type){
        case 0, $4uvJ3.LOAD_PAGE_DATA:
        case 0, $4uvJ3.RESET_STATE:
            {
                const { queueId: queueId } = action.payload;
                return (0, $7uUwQ.assoc)($07025a30dd48a503$var$DEFAULT_QUEUE_STATE, 'queueId', queueId);
            }
        case 0, $4uvJ3.LOAD_PAGE_DATA_SUCCESS:
            if (action.payload.queuesWithSorting.manualSorting) return (0, $7uUwQ.assoc)(state, 'manualSorting', action.payload.queuesWithSorting.manualSorting);
            return state;
        case 0, $jdGLR.PAGE_CHANGED:
            {
                const { currentPage: actionPage } = action.payload;
                let currentPage = Math.max(1, Math.ceil(actionPage));
                if ((0, (/*@__PURE__*/$parcel$interopDefault($21Uac)))(currentPage)) currentPage = 1;
                return (0, $7uUwQ.assocIn)(state, [
                    'pagination',
                    'currentPage'
                ], currentPage);
            }
        case 0, $jdGLR.SORT_ORDER_CHANGED:
            return (0, $7uUwQ.assoc)(state, 'manualSorting', undefined);
        case 0, $jdGLR.RESET_SORT_ORDER:
            return (0, $7uUwQ.dissoc)(state, 'manualSorting');
        case 0, $bzBCj.LOAD_ISSUES_SUCCESS:
            /* Due to various reason (sorting field id is not longer valid, custom field has been removed, sorting field
    is no longer visible in the queue, etc), the sorting returned from the /issuelist endpoint maybe different
    from what we stored in the state. We should keep them in sync after we got the response. */ return action.payload.source === (0, $36dd7e3255fc2bff$export$2003e3fdddd4c35b) || action.payload.source === (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a) ? (0, $7uUwQ.assocIn)(state, [
                'pagination',
                'currentPage'
            ], 1) : state;
        case 0, $jdGLR.FETCH_ISSUE_DATA_ONSCROLL:
            return (0, $7uUwQ.assoc)(state, 'fetchStartIndex', action.payload);
        case 0, $dOWTu.QUEUE_CHANGED:
            return (0, $7uUwQ.assoc)(state, 'category', action.payload.queue.category);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("21Uac", function(module, exports) {

var $hUobS = parcelRequire("hUobS");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $17a73daff2076455$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $hUobS(value) && value != +value;
}
module.exports = $17a73daff2076455$var$isNaN;

});


parcelRegister("8CVcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e58aa37461de4337$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $bzBCj = parcelRequire("bzBCj");

var $iIQpG = parcelRequire("iIQpG");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e58aa37461de4337$export$2e2bcd8739ae039 = (state = {}, action)=>{
    switch(action.type){
        case 0, $bzBCj.LOAD_ISSUES_SUCCESS:
            {
                const { issueHash: issueHash } = action.payload.loadedIssuesResponse;
                return (0, $7uUwQ.assoc)(state, 'issueHash', issueHash);
            }
        case 0, $iIQpG.POLL_SUCCESS:
            return (0, $7uUwQ.assoc)(state, 'projectStateHash', action.payload.projectStateHash);
        case 0, $iIQpG.RESET_PROJECT_STATE_HASH:
            return (0, $7uUwQ.unset)(state, 'projectStateHash');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("2tDcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9f889c5e5db0b44$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $3HGy4 = parcelRequire("3HGy4");


var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");

var $4uvJ3 = parcelRequire("4uvJ3");

var $jdGLR = parcelRequire("jdGLR");

var $dWFvu = parcelRequire("dWFvu");

var $k6G4t = parcelRequire("k6G4t");
const $d9f889c5e5db0b44$var$DEFAULT_UI_STATE = {
    onboardingResolved: false,
    isNavCollapsed: true,
    isHeaderCollapsed: false,
    sidebarIssueKey: null,
    isQueuesErrorHeaderDisplayed: false,
    sidebarReactKey: Math.random().toString()
};
const $d9f889c5e5db0b44$var$rootUiReducer = (state, action)=>{
    switch(action.type){
        case 0, $4uvJ3.SET_QUEUE_VISIBILITY:
            return (0, $7uUwQ.assoc)(state, 'isQueueVisible', action.payload.isQueueVisible);
        case 0, $dWFvu.ONBOARDING_RESOLVED:
            return (0, $7uUwQ.assoc)(state, 'onboardingResolved', action.payload.onboardingResolved);
        case 0, $dWFvu.SET_NAV_COLLAPSED:
            return (0, $7uUwQ.assoc)(state, 'isNavCollapsed', action.payload.isNavCollapsed);
        case 0, $dWFvu.SET_DELETE_MODAL_VISIBILITY:
            return (0, $7uUwQ.chain)(state).setIn([
                'deleteModalOpen'
            ], action.payload.isVisible).value();
        case 0, $dWFvu.SET_ISSUE_KEY_CONTEXT:
            return (0, $7uUwQ.assoc)(state, 'issueKeyContext', action.payload.issueKey);
        case 0, $dWFvu.SET_SIDEBAR_ISSUE_KEY:
            return (0, $7uUwQ.assoc)(state, 'sidebarIssueKey', action.payload.sidebarIssueKey);
        case 0, $dWFvu.SET_SIDEBAR_REACT_KEY:
            return (0, $7uUwQ.assoc)(state, 'sidebarReactKey', action.payload.sidebarReactKey);
        case 0, $dWFvu.SET_SELECTED_ISSUE_KEYS:
            return (0, $7uUwQ.assoc)(state, 'selectedIssueKeys', action.payload.selectedIssueKeys);
        case 0, $dWFvu.REFRESH_SIDEBAR_ISSUE_VIEW:
            if (state.sidebarIssueKey && (state.selectedIssueKeys?.includes(state.sidebarIssueKey) || state.sidebarIssueKey === action.payload.issueKey)) return (0, $7uUwQ.assoc)(state, 'sidebarReactKey', Math.random().toString());
            return state;
        case 0, $dWFvu.DELETE_QUEUE:
            return (0, $7uUwQ.assoc)(state, 'deletingQueue', true);
        case 0, $dWFvu.SET_MODAL_IS_DELETING:
            return (0, $7uUwQ.assoc)(state, 'deletingQueue', action.payload.isDeleting);
        case 0, $jdGLR.PAGE_CHANGED:
        case 0, $4uvJ3.LOAD_PAGE_DATA:
        case 0, $jdGLR.SORT_ORDER_CHANGED:
        case 0, $fnQyW.FILTER_QUERY_SUBMITTED:
        case 0, $jdGLR.RESET_SORT_ORDER:
            return (0, $7uUwQ.assoc)(state, 'isLoadingIssues', true);
        case 0, $4uvJ3.LOAD_PAGE_DATA_FAILURE:
            {
                const { error: error } = action.payload;
                return (0, $7uUwQ.chain)(state).assoc('isLoadingPage', false).assoc('pageError', error).value();
            }
        case 0, $4uvJ3.LOAD_PAGE_DATA_SUCCESS:
            return (0, $7uUwQ.chain)(state).assoc('isLoadingPage', false).dissoc('pageError').value();
        case 0, $bzBCj.LOAD_ISSUES_SUCCESS:
            {
                const { isFiltered: isFiltered, isFilterRequested: isFilterRequested } = action.payload.loadedIssuesResponse;
                const isLoadingIssues = isFilterRequested !== isFiltered;
                const areIssuesLoadedFromServer = action.payload.loadedIssuesResponse.source === (0, $3HGy4.REST_SOURCE);
                return (0, $7uUwQ.chain)(state).assoc('isLoadingIssues', isLoadingIssues).assoc('areIssuesLoadedFromServer', areIssuesLoadedFromServer).dissoc('showIssueFailureError').dissoc('shouldShowBadFilterQueryError').value();
            }
        case 0, $bzBCj.LOAD_ISSUES_FAILURE:
            {
                const { source: source, isQueueEmpty: isQueueEmpty } = action.payload;
                const updatedState = (0, $7uUwQ.chain)(state).assoc('isLoadingIssues', false);
                if (source === (0, $36dd7e3255fc2bff$export$f162a928a40c7ab8) && isQueueEmpty) updatedState.assoc('showIssueFailureError', true);
                return updatedState.value();
            }
        case 0, $4uvJ3.RESET_STATE:
            return (0, $7uUwQ.chain)(state).assoc('isLoadingPage', true).assoc('isLoadingIssues', true).assoc('areIssuesLoadedFromServer', false).assoc('isQueueVisible', true).dissoc('showIssueFailureError').dissoc('shouldShowBadFilterQueryError').value();
        case 0, $jdGLR.TOGGLE_QUEUE_HEADER:
            {
                const direction = action.payload;
                if (direction === (0, $36dd7e3255fc2bff$export$57022ca1771ad970)) return state;
                return (0, $7uUwQ.assoc)(state, 'isHeaderCollapsed', direction === (0, $36dd7e3255fc2bff$export$28a694fb106a7f62));
            }
        case 0, $fnQyW.IS_FILTER_FAILED:
            return (0, $7uUwQ.chain)(state).assoc('isLoadingIssues', false).assoc('issueCount', 0).assoc('shouldShowBadFilterQueryError', true).value();
        case 0, $4uvJ3.DISPLAY_QUEUES_ERROR_HEADER:
            return (0, $7uUwQ.assoc)(state, 'isQueuesErrorHeaderDisplayed', true);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$d9f889c5e5db0b44$export$2e2bcd8739ae039 = (state = $d9f889c5e5db0b44$var$DEFAULT_UI_STATE, action)=>{
    const { currentQueue: currentQueue } = state;
    const nextState = $d9f889c5e5db0b44$var$rootUiReducer(state, action);
    const nextQueue = (0, $k6G4t.default)(currentQueue, action);
    // Do not return a new object if no changes are made.
    // Or else anything using this state as reference will
    // cause a re-render even if leaf values are the same
    if (state === nextState && currentQueue === nextQueue) return state;
    return {
        ...nextState,
        currentQueue: nextQueue
    };
};

});
parcelRegister("k6G4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5466cd67f68953e$export$2e2bcd8739ae039);

var $ajpes = parcelRequire("ajpes");

var $l2T6l = parcelRequire("l2T6l");

var $bzBCj = parcelRequire("bzBCj");

var $dOWTu = parcelRequire("dOWTu");

var $jdGLR = parcelRequire("jdGLR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c5466cd67f68953e$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 0, $dOWTu.SET_QUEUE:
            return action.payload.queue;
        case 0, $bzBCj.LOAD_ISSUES_SUCCESS:
            {
                const { loadedIssuesResponse: { columns: columns, isUsingDefaultSorting: isUsingDefaultSorting } } = action.payload;
                const newState = (0, $l2T6l.chainUnsafe)(state);
                if (state && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(columns, state.columns)) newState.assoc('columns', columns);
                return isUsingDefaultSorting ? newState.dissoc('manualSorting').value() : newState.value();
            }
        case 0, $jdGLR.SORT_ORDER_CHANGED:
            return (0, $l2T6l.assocUnsafe)(state, 'manualSorting', action.payload);
        case 0, $jdGLR.SORT_ORDER_OPTIMISTIC_UPDATE:
            {
                const { sortedBy: sortedBy, sortOrder: sortOrder } = action.payload;
                return (0, $l2T6l.updateInUnsafe)(state, [
                    'columns'
                ], (columns)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'column' implicitly has an 'any' type.
                    columns.map((column)=>(0, $l2T6l.assocUnsafe)(column, 'currentSorting', column.id === sortedBy ? sortOrder : undefined)));
            }
        case 0, $jdGLR.SORT_ORDER_OPTIMISTIC_RESET:
            return (0, $l2T6l.updateInUnsafe)(state, [
                'columns'
            ], (columns)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'column' implicitly has an 'any' type.
                columns.map((column)=>(0, $l2T6l.dissocUnsafe)(column, 'currentSorting')));
        case 0, $jdGLR.SORT_ORDER_ON_LOAD:
            return (0, $l2T6l.assocUnsafe)(state, 'manualSorting', action.payload);
        case 0, $jdGLR.RESET_SORT_ORDER:
            return (0, $l2T6l.dissocUnsafe)(state, 'manualSorting');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("l2T6l", function(module, exports) {

$parcel$export(module.exports, "assocUnsafe", () => $10cc07b888293773$export$a759ec8fde46de77);
$parcel$export(module.exports, "dissocUnsafe", () => $10cc07b888293773$export$e0867c1b5da854fe);
$parcel$export(module.exports, "assocInUnsafe", () => $10cc07b888293773$export$1bfac1118aad2c2f);
$parcel$export(module.exports, "updateInUnsafe", () => $10cc07b888293773$export$f920b8c255ec1192);
$parcel$export(module.exports, "chainUnsafe", () => $10cc07b888293773$export$181c753256d1c9a0);

var $7uUwQ = parcelRequire("7uUwQ");
const $10cc07b888293773$export$a759ec8fde46de77 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assoc(collection, key, value);
const $10cc07b888293773$export$9b65d21cdbb50a87 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.set(collection, key, value);
const $10cc07b888293773$export$e0867c1b5da854fe = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.dissoc(collection, key);
const $10cc07b888293773$export$958195bad0a3dbcf = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.unset(collection, key);
const $10cc07b888293773$export$1bfac1118aad2c2f = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assocIn(collection, path, value);
const $10cc07b888293773$export$565e6fa2e54b66b3 = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.setIn(collection, path, value);
const $10cc07b888293773$export$75197f11bfe5de5f = (collection, path)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.getIn(collection, path);
const $10cc07b888293773$export$f920b8c255ec1192 = (collection, path, callback)=>$7uUwQ.updateIn(collection, path, callback);
class $10cc07b888293773$var$IcepickUnsafeWrapper {
    constructor(collection){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.wrapper = $7uUwQ.chain(collection);
    }
    value() {
        return this.wrapper.value();
    }
    freeze() {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.freeze().value());
    }
    assoc(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assoc(key, value).value());
    }
    set(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.set(key, value).value());
    }
    dissoc(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.dissoc(key).value());
    }
    unset(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.unset(key).value());
    }
    assocIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assocIn(path, value).value());
    }
    setIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.setIn(path, value).value());
    }
    getIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.getIn(path, value).value());
    }
    updateIn(path, callback) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.updateIn(path, callback).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3, s4).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3, s4).value());
    }
    merge(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.merge(source).value());
    }
    thru(val) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.thru(val).value());
    }
}
const $10cc07b888293773$export$181c753256d1c9a0 = (collection)=>new $10cc07b888293773$var$IcepickUnsafeWrapper(collection);

});




parcelRegister("fG5Qt", function(module, exports) {

$parcel$export(module.exports, "ChangeManagementTour", () => $4d4519298eb67858$export$b9e679128cfbb66a);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $aNLeB = parcelRequire("aNLeB");

var $iNDEP = parcelRequire("iNDEP");

var $oCMSG = parcelRequire("oCMSG");

var $bmKPg = parcelRequire("bmKPg");
const $4d4519298eb67858$export$b9e679128cfbb66a = (props)=>{
    const [practiceType] = (0, $bmKPg.usePathParam)('practiceType');
    const { data: isItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    if (isItsmProject !== true) return null;
    return practiceType === (0, $oCMSG.SHORT_FORM_CHANGES) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, ({ data: data })=>data && data.isProjectAdmin === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNDEP.AsyncChangeManagementTourQueues), props) : null) : null;
};

});
parcelRegister("iNDEP", function(module, exports) {

$parcel$export(module.exports, "AsyncChangeManagementTourIssue", () => $1e74b9d011ff779c$export$1ed01ce8c1ac7746);
$parcel$export(module.exports, "AsyncChangeManagementTourQueues", () => $1e74b9d011ff779c$export$fb9c9876407ca830);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $aXpQP = parcelRequire("aXpQP");

var $kxZPA = parcelRequire("kxZPA");

const $1e74b9d011ff779c$var$ChangeManagementTourIssueComponent = ()=>(parcelRequire("9z09r"));

const $1e74b9d011ff779c$var$ChangeManagementTourQueuesComponent = ()=>(parcelRequire("lSPBP"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e74b9d011ff779c$var$ChangeManagementTourIssue = (0, $kxZPA.lazy)(()=>$1e74b9d011ff779c$var$ChangeManagementTourIssueComponent(), {});
const $1e74b9d011ff779c$export$1ed8a177940b97cb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "change-management-tour-issue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e74b9d011ff779c$var$ChangeManagementTourIssue, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e74b9d011ff779c$var$ChangeManagementTourQueues = (0, $kxZPA.lazy)(()=>$1e74b9d011ff779c$var$ChangeManagementTourQueuesComponent(), {});
const $1e74b9d011ff779c$export$2e6a672121096a76 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "change-management-tour-queues",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e74b9d011ff779c$var$ChangeManagementTourQueues, props));
const $1e74b9d011ff779c$export$1ed01ce8c1ac7746 = (0, $aXpQP.withShouldRenderWithinItsmSampleProject)($1e74b9d011ff779c$export$1ed8a177940b97cb, false);
const $1e74b9d011ff779c$export$fb9c9876407ca830 = (0, $aXpQP.withShouldRenderWithinItsmSampleProject)($1e74b9d011ff779c$export$2e6a672121096a76, false);

});
parcelRegister("aXpQP", function(module, exports) {

$parcel$export(module.exports, "withShouldRenderWithinItsmSampleProject", () => $371915e6e53a1f42$export$226e9fc1ef19c2cf);

var $5uXOq = parcelRequire("5uXOq");

var $7HThi = parcelRequire("7HThi");
const $371915e6e53a1f42$export$226e9fc1ef19c2cf = (WrappedComponent, shouldRenderWithinItsmSampleProject)=>{
    const WithShouldRenderWithinItsmSampleProject = (props)=>{
        const { data: isItsmSampleProject } = (0, $7HThi.useIsItsmSampleProject)();
        const shouldRender = shouldRenderWithinItsmSampleProject === isItsmSampleProject;
        // @ts-expect-error - TS2322 - Type 'Props' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<Component, PropsWithChildren<PropsWithoutRef<Props> & RefAttributes<any>>>'.
        return shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
    WithShouldRenderWithinItsmSampleProject.displayName = `WithShouldRenderWithinItsmSampleProject(${WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'})`;
    // @ts-expect-error - TS2322 - Type '{ (props: Props): false | JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Props, any>'.
    return WithShouldRenderWithinItsmSampleProject;
};

});
parcelRegister("7HThi", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $1bd32a46a0882e8f$export$b8afdaba4bd6f483);

var $hGgHi = parcelRequire("hGgHi");

var $aNLeB = parcelRequire("aNLeB");

var $g4ge5 = parcelRequire("g4ge5");
const $1bd32a46a0882e8f$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $g4ge5.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("g4ge5", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $09e24bc2f005ce6a$export$9b4078600f2ad4d2);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4DPZY = parcelRequire("4DPZY");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dciEf = parcelRequire("dciEf");

var $6LFnT = parcelRequire("6LFnT");
const $09e24bc2f005ce6a$export$d4c72bab9d6cc13a = {};
const $09e24bc2f005ce6a$export$bf108b10a3a0ab90 = (0, $iXqE5.createStore)({
    name: 'IsDemoProject',
    initialState: $09e24bc2f005ce6a$export$d4c72bab9d6cc13a,
    actions: (0, $dciEf.actions)
});
const $09e24bc2f005ce6a$var$useIsDemoProjectStore = (0, $3sQ5x.createHook)($09e24bc2f005ce6a$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $09e24bc2f005ce6a$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $09e24bc2f005ce6a$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $g5X3G.toProjectId)(String(numProjectId));
    const baseUrl = (0, $g5X3G.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $09e24bc2f005ce6a$var$useIsDemoProjectStore();
    const memoizedState = $09e24bc2f005ce6a$var$useStateMemo({
        ...state[projectId] ?? (0, $6LFnT.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("dciEf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ffc7e95937855e49$export$e324594224ef24da);

var $4MUdY = parcelRequire("4MUdY");
const $ffc7e95937855e49$export$e324594224ef24da = {
    fetchIsDemoProject: $4MUdY.fetchIsDemoProject
};

});
parcelRegister("4MUdY", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $19341c0fa64f8930$export$feaee63a215b34da);

var $hGgHi = parcelRequire("hGgHi");

var $i8xPd = parcelRequire("i8xPd");

var $6LFnT = parcelRequire("6LFnT");
const $19341c0fa64f8930$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $6LFnT.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $i8xPd.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("i8xPd", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $aef4f72f73469a32$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $aef4f72f73469a32$export$c498e29d716efe7a);

var $38QcJ = parcelRequire("38QcJ");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");
const $aef4f72f73469a32$var$onFetchErrorCacheHandler = (error)=>{
    if (error.statusCode === 404) return {
        value: false
    };
    throw error;
};
const $aef4f72f73469a32$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        if ((0, $6s1PB.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) {
            const response = await (0, $38QcJ.performGetRequestWithCache)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`, $aef4f72f73469a32$var$onFetchErrorCacheHandler);
            return !!response && !!response.value;
        }
        const response = await (0, $eusud.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $aef4f72f73469a32$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $eusud.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});
parcelRegister("38QcJ", function(module, exports) {

$parcel$export(module.exports, "performGetRequestWithCache", () => $babbea8c3a621dad$export$2df9cfe22532d245);

var $eusud = parcelRequire("eusud");

var $aDezs = parcelRequire("aDezs");
const $babbea8c3a621dad$export$2df9cfe22532d245 = (0, $aDezs.withCache)((0, $eusud.performGetRequest));

});
parcelRegister("aDezs", function(module, exports) {

$parcel$export(module.exports, "withCache", () => $807c4ec3ea856331$export$33b32b3abf8170f0);

var $x9xyg = parcelRequire("x9xyg");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4sfTg = parcelRequire("4sfTg");

var $dw7IP = parcelRequire("dw7IP");

var $4ZYuM = parcelRequire("4ZYuM");
const $807c4ec3ea856331$export$33b32b3abf8170f0 = (fn)=>async (url, onFnErrorCacheHandler, maxAge = (0, $4ZYuM.SEVEN_DAYS_IN_MILLIS), options = {})=>{
        if (false) return fn(url, options);
        try {
            if (!(0, $6s1PB.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) return fn(url, options);
            const cachedKey = (0, $4sfTg.createCacheKey)(url);
            const readMeasureName = 'indexed-db-cache-read';
            const readStartMark = `${readMeasureName}:start`;
            const readEndMark = `${readMeasureName}:end`;
            (0, $x9xyg.setMark)(readStartMark);
            const cachedData = await (0, $dw7IP.jiraCache).get(cachedKey);
            (0, $x9xyg.setMark)(readEndMark);
            (0, $x9xyg.setMeasure)(readMeasureName, readStartMark, readEndMark);
            if (cachedData !== undefined && Date.now() < cachedData.expiresAt) return cachedData.data;
            let data;
            try {
                data = await fn(url, options);
            } catch (error) {
                if (onFnErrorCacheHandler) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                data = onFnErrorCacheHandler(error);
                else throw error;
            }
            const writeMeasureName = 'indexed-db-cache-write';
            const writeStartMark = `${writeMeasureName}:start`;
            const writeEndMark = `${writeMeasureName}:end`;
            (0, $x9xyg.setMark)(writeStartMark);
            (0, $dw7IP.jiraCache).set(cachedKey, {
                data: data,
                expiresAt: Date.now() + maxAge
            }).then(()=>{
                (0, $x9xyg.setMark)(writeEndMark);
                (0, $x9xyg.setMeasure)(writeMeasureName, writeStartMark, writeEndMark);
            });
            return data;
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'withCache',
                    packageName: (0, $4ZYuM.PACKAGE_NAME),
                    teamName: (0, $4ZYuM.TEAM_NAME)
                },
                error: new Error('Error in JCL withCache'),
                attributes: {
                    cause: error instanceof Error ? error.message : 'Not known'
                },
                sendToPrivacyUnsafeSplunk: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                skipSentry: (0, $jcw0u.isNetworkError)(error)
            });
            return fn(url, options);
        }
    };

});
parcelRegister("4sfTg", function(module, exports) {

$parcel$export(module.exports, "createCacheKey", () => $ae7ce70bbd907415$export$aa68fd26e593cc7e);

var $4Pf62 = parcelRequire("4Pf62");
const $ae7ce70bbd907415$export$aa68fd26e593cc7e = (endpoint)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const url = new URL(endpoint, window.location.origin);
    const searchParams = new URLSearchParams(url.search);
    const sortedParams = new URLSearchParams([
        ...searchParams.entries()
    ].sort());
    url.search = sortedParams.toString();
    const prefix = (atlassianAccountId + cloudId).replace(/-/g, '');
    const endpointWithSearch = prefix + url.pathname + url.search;
    return endpointWithSearch.replace(/[/?&=]/g, '-').substring(1);
};

});

parcelRegister("dw7IP", function(module, exports) {

$parcel$export(module.exports, "jiraCache", () => $646f3c3ba9013057$export$8b9e5c9ea3bf5aac);

var $sn9QA = parcelRequire("sn9QA");

var $4ZYuM = parcelRequire("4ZYuM");
const $646f3c3ba9013057$export$8b9e5c9ea3bf5aac = (0, $sn9QA.createIndexedDBStorageProvider)((0, $4ZYuM.CACHE_NAME_PREFIX), {
    shouldAutoReconnect: true
});

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});



parcelRegister("4ZYuM", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $14fef84cc1d179c0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $14fef84cc1d179c0$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SEVEN_DAYS_IN_MILLIS", () => $14fef84cc1d179c0$export$b14f1fa28090cb18);
$parcel$export(module.exports, "CACHE_NAME_PREFIX", () => $14fef84cc1d179c0$export$7c8c9e2fd09cd6cd);
const $14fef84cc1d179c0$export$b8b9d90f9e5bd72b = 'jiraCachingLayer';
const $14fef84cc1d179c0$export$d57b6b390e78d90f = 'itops-mithril';
const $14fef84cc1d179c0$export$b14f1fa28090cb18 = 604800000;
const $14fef84cc1d179c0$export$7c8c9e2fd09cd6cd = 'jira-cache';

});





parcelRegister("6LFnT", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $21d88e1743f1ae3e$export$f6365b0f25aeae62);
const $21d88e1743f1ae3e$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});






parcelRegister("9z09r", function(module, exports) {

let $6f677ff50a31bc30$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6f677ff50a31bc30$var$load("kWrFZ"),
    $6f677ff50a31bc30$var$load("h2MrD"),
    $6f677ff50a31bc30$var$load("bYT2S"),
    $6f677ff50a31bc30$var$load("30QTG")
]).then(()=>parcelRequire('jX5aX'));

});

parcelRegister("lSPBP", function(module, exports) {

let $fee6aca0bde7a3bc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fee6aca0bde7a3bc$var$load("h2MrD"),
    $fee6aca0bde7a3bc$var$load("bYT2S"),
    $fee6aca0bde7a3bc$var$load("aresG")
]).then(()=>parcelRequire('yEJ2o'));

});



parcelRegister("19cKl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7672682c678794$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");

var $gdp77 = parcelRequire("gdp77");
const $4e7672682c678794$var$mapStateToProps = (state)=>({
        queueId: (0, $627A7.getQueueId)(state),
        isQueueVisible: (0, $jeVA9.isQueueVisible)(state)
    });
var $4e7672682c678794$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($4e7672682c678794$var$mapStateToProps, {})((0, $gdp77.default));

});
parcelRegister("gdp77", function(module, exports) {

$parcel$export(module.exports, "default", () => $b269956dc1709483$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2i4sA = parcelRequire("2i4sA");

var $3HGy4 = parcelRequire("3HGy4");

var $efvDm = parcelRequire("efvDm");

var $9OXo1 = parcelRequire("9OXo1");

var $bv4xh = parcelRequire("bv4xh");
function $b269956dc1709483$export$2e2bcd8739ae039(props) {
    const { queueId: queueId, children: children, isQueueVisible: isQueueVisible } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
            analyticsSource: "queues",
            experience: "viewQueue",
            experienceId: (0, $3HGy4.fromQueueIdString)(queueId),
            application: (0, $efvDm.JIRA_SERVICE_DESK),
            edition: tenantContext.appEditions.serviceDesk,
            isExperienceReady: isQueueVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv4xh.default), null), children));
}

});
parcelRegister("bv4xh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c5534b5af8700e3$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $IrNQw = parcelRequire("IrNQw");

var $cMiIv = parcelRequire("cMiIv");
const $4c5534b5af8700e3$var$mapStateToProps = (state)=>({
        initialFetchStatus: (0, $IrNQw.getExperienceTrackingInitialFetchStatus)(state),
        initialFetchFailureEventAttributes: (0, $IrNQw.getInitialFetchErrorEventAttributes)(state)
    });
var $4c5534b5af8700e3$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($4c5534b5af8700e3$var$mapStateToProps, {})((0, $cMiIv.default));

});
parcelRegister("IrNQw", function(module, exports) {

$parcel$export(module.exports, "getExperienceTrackingInitialFetchStatus", () => $1e54c2d334b55457$export$ec3d1bbe6bde55e);
$parcel$export(module.exports, "getHasLoadedIssueDataFromCache", () => $1e54c2d334b55457$export$c50657eec51e9e);
$parcel$export(module.exports, "getInitialFetchErrorEventAttributes", () => $1e54c2d334b55457$export$711bef1cfb497c56);

var $dGvGJ = parcelRequire("dGvGJ");

var $4R6GH = parcelRequire("4R6GH");


var $a5xpi = parcelRequire("a5xpi");
const $1e54c2d334b55457$export$3c50a15364b58a95 = (state)=>(0, $a5xpi.getPersisted)(state).experienceTracking;
const $1e54c2d334b55457$export$ec3d1bbe6bde55e = (state)=>$1e54c2d334b55457$export$3c50a15364b58a95(state).initialDataLoadStatus;
const $1e54c2d334b55457$export$c50657eec51e9e = (state)=>$1e54c2d334b55457$export$3c50a15364b58a95(state).hasLoadedIssueDataFromCache;
const $1e54c2d334b55457$var$getErrorStatusCode = (state)=>$1e54c2d334b55457$export$3c50a15364b58a95(state).errorStatusCode;
const $1e54c2d334b55457$var$getErrorMessage = (state)=>$1e54c2d334b55457$export$3c50a15364b58a95(state).errorMessages;
const $1e54c2d334b55457$var$getErrorKey = (state)=>$1e54c2d334b55457$export$3c50a15364b58a95(state).errorKey;
const $1e54c2d334b55457$var$getTraceId = (state)=>$1e54c2d334b55457$export$3c50a15364b58a95(state).traceId;
const $1e54c2d334b55457$var$constructErrorMessage = (statusCode, errorMessage, errorKey)=>`Initial fetch failed status code: ${statusCode}, error: ${JSON.stringify(errorMessage)}, errorKey: ${errorKey}`;
const $1e54c2d334b55457$export$711bef1cfb497c56 = (0, $dGvGJ.createSelector)($1e54c2d334b55457$export$ec3d1bbe6bde55e, $1e54c2d334b55457$export$c50657eec51e9e, $1e54c2d334b55457$var$getErrorStatusCode, $1e54c2d334b55457$var$getErrorMessage, $1e54c2d334b55457$var$getErrorKey, $1e54c2d334b55457$var$getTraceId, (initialDataLoadStatus, hasLoadedIssueDataFromCache, errorStatusCode, errorMessage, errorKey, traceId)=>{
    if (initialDataLoadStatus === (0, $d86382c25b911bd9$export$70ef9aa03c29b42b)) {
        if ((0, $4R6GH.fg)('adding-more-data-for-viewqueue-and-viewnav-event')) return {
            didFallbackOnIssueCache: hasLoadedIssueDataFromCache,
            errorMessage: $1e54c2d334b55457$var$constructErrorMessage(errorStatusCode, errorMessage, errorKey),
            traceId: traceId || 'no-trace-id'
        };
        return {
            didFallbackOnIssueCache: hasLoadedIssueDataFromCache,
            errorMessage: errorStatusCode !== undefined ? `Initial fetch failed with status code ${errorStatusCode}` : 'Initial fetch failed'
        };
    }
    return undefined;
});

});

parcelRegister("cMiIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10d3f05980dcdc3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g0Gtc = parcelRequire("g0Gtc");

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c10d3f05980dcdc3$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceResultFromPropsTracker), {
        location: "failed-fetching-initial-data",
        hasSucceeded: props.initialFetchStatus === (0, $d86382c25b911bd9$export$d3ab616c5a76689d),
        hasFailed: props.initialFetchStatus === (0, $d86382c25b911bd9$export$70ef9aa03c29b42b),
        failureEventAttributes: props.initialFetchFailureEventAttributes
    });

});




parcelRegister("kKtyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $243bc5ca1c6f592b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $2ao8E = parcelRequire("2ao8E");
var $7HGHK = parcelRequire("7HGHK");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $7aC5E = parcelRequire("7aC5E");
class $243bc5ca1c6f592b$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
            onMount: this.onMount
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ao8E.AsyncFlagsDispatcher), {
            mapperFactory: this.getFlagsMapperFactory((0, $7aC5E.default))
        }));
    }
    constructor(...args){
        super(...args), this.onMount = (analyticsEvent)=>{
            this.flagsAnalyticEvent = analyticsEvent;
        }, this.getFlagsMapperFactory = (0, $8QpSo.default)((factory)=>(args)=>{
                const mapper = factory(args);
                return (action, state)=>{
                    const flagConfig = mapper(action, state);
                    if (flagConfig) {
                        const { type: type } = action;
                        let analyticsAction = 'viewed';
                        // Only type of DismissFlag has command field
                        // @ts-expect-error - TS2339 - Property 'command' does not exist on type 'DismissFlag | Flag'.
                        if (flagConfig.command) analyticsAction = (0, $7HGHK.DISMISS_COMMAND).toLowerCase();
                        this.flagsAnalyticEvent.update({
                            action: analyticsAction
                        });
                        (0, $8zOmE.fireUIAnalytics)(this.flagsAnalyticEvent, `flag ${analyticsAction}`, {
                            actionType: type.split('.').pop()
                        });
                    }
                    return flagConfig;
                };
            });
    }
}

});
parcelRegister("2ao8E", function(module, exports) {

$parcel$export(module.exports, "AsyncFlagsDispatcher", () => $39628664321f8857$export$7bcb9f5644d87fa4);

var $5uXOq = parcelRequire("5uXOq");

var $gJBT6 = parcelRequire("gJBT6");

var $iNWLk = parcelRequire("iNWLk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $7HGHK = parcelRequire("7HGHK");
const $39628664321f8857$var$createFlagsDispatcherImpl = (mapperFactory, props, { FlagsDispatcher: FlagsDispatcher, toFlagId: toFlagId, dismissFlag: dismissFlag })=>{
    const mapper = mapperFactory({
        dismissFlag: dismissFlag,
        toFlagId: toFlagId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagsDispatcher, {
        ...props,
        mapper: mapper
    });
};
// We create flags mappers dynamically, in part, to allow a closure to be established.
// This is memoized to retain any state provided via a closure.
const $39628664321f8857$var$createFlagsDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($39628664321f8857$var$createFlagsDispatcherImpl);
const $39628664321f8857$var$getFlagsDispatcher = (module, props)=>{
    if ('mapperFactory' in props) {
        const { mapperFactory: mapperFactory, ...dispatcherProps } = props;
        const flagsDispatcher = $39628664321f8857$var$createFlagsDispatcher(mapperFactory, dispatcherProps, module);
        return flagsDispatcher;
    }
    const { FlagsDispatcher: FlagsDispatcher } = module;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagsDispatcher, props);
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $39628664321f8857$var$LazyFlagsDispatcher = (0, $kxZPA.lazy)(()=>(parcelRequire("3u104")).then((module)=>(props)=>$39628664321f8857$var$getFlagsDispatcher(module, props)), {
    moduleId: "./src/packages/platform/ui/flags/src/index.tsx"
});
const $39628664321f8857$export$7bcb9f5644d87fa4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-flags-dispatcher",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: "async-flags-dispatcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($39628664321f8857$var$LazyFlagsDispatcher, props)));

});
parcelRegister("3u104", function(module, exports) {

let $2894f30a9959d551$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2894f30a9959d551$var$load("9Z6ti").then(()=>parcelRequire('g2X17'));

});


parcelRegister("7aC5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fd7fe6c894a3bb3$export$2e2bcd8739ae039);

var $ajpes = parcelRequire("ajpes");

var $jdGLR = parcelRequire("jdGLR");

var $dWFvu = parcelRequire("dWFvu");

var $iIQpG = parcelRequire("iIQpG");

var $i3yJK = parcelRequire("i3yJK");
const $8fd7fe6c894a3bb3$var$WARNING_FLAG_ID = 'WARNING_FLAG_ID';
const $8fd7fe6c894a3bb3$var$FETCH_WARNING_FLAG_ID = 'FETCH_WARNING_FLAG_ID';
const $8fd7fe6c894a3bb3$var$ERROR_FLAG_ID = 'ERROR_FLAG_ID';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8fd7fe6c894a3bb3$export$2e2bcd8739ae039 = ({ dismissFlag: dismissFlag, toFlagId: toFlagId })=>{
    let unsuccessfulFlagId;
    const isErrorFlagDisplayed = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(unsuccessfulFlagId, toFlagId($8fd7fe6c894a3bb3$var$ERROR_FLAG_ID));
    const flagsMapper = (action)=>{
        switch(action.type){
            case 0, $dWFvu.DELETE_QUEUE_FAILURE:
                return (0, $i3yJK.deleteQueueErrorConfig)(action.payload.queueName);
            case 0, $iIQpG.DISPLAY_UNSUCCESSFUL_POLL_WARNING:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($8fd7fe6c894a3bb3$var$WARNING_FLAG_ID);
                return (0, $i3yJK.unsuccessfulPollFlagConfig)(unsuccessfulFlagId);
            case 0, $jdGLR.DISPLAY_UNSUCCESSFUL_FETCH_WARNING:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($8fd7fe6c894a3bb3$var$FETCH_WARNING_FLAG_ID);
                return (0, $i3yJK.unsuccessfulFetchFlagConfig)(unsuccessfulFlagId);
            case 0, $jdGLR.DISPLAY_UNSUCCESSFUL_FETCH_ERROR:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($8fd7fe6c894a3bb3$var$ERROR_FLAG_ID);
                return (0, $i3yJK.unsuccessfulFetchErrorFlagConfig)(unsuccessfulFlagId);
            case 0, $iIQpG.DISMISS_ALL_FLAGS:
                {
                    if (!unsuccessfulFlagId) return undefined;
                    const dismissAllFlagsConfig = dismissFlag(unsuccessfulFlagId);
                    unsuccessfulFlagId = undefined;
                    return dismissAllFlagsConfig;
                }
            case 0, $iIQpG.DISMISS_WARNING_FLAG:
                {
                    if (!unsuccessfulFlagId || isErrorFlagDisplayed()) return undefined;
                    const dismissWarningFlagConfig = dismissFlag(unsuccessfulFlagId);
                    unsuccessfulFlagId = undefined;
                    return dismissWarningFlagConfig;
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return undefined;
                }
        }
    };
    return flagsMapper;
};

});
parcelRegister("i3yJK", function(module, exports) {

$parcel$export(module.exports, "unsuccessfulFetchFlagConfig", () => $f7d77bddba730a3e$export$1c654f36e3d7dd60);
$parcel$export(module.exports, "unsuccessfulFetchErrorFlagConfig", () => $f7d77bddba730a3e$export$e39d17f9389fd3ea);
$parcel$export(module.exports, "unsuccessfulPollFlagConfig", () => $f7d77bddba730a3e$export$84de65b00282fe10);
$parcel$export(module.exports, "deleteQueueErrorConfig", () => $f7d77bddba730a3e$export$894642f3f2ceae70);

var $kADcf = parcelRequire("kADcf");
const $f7d77bddba730a3e$var$reload = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.reload();
};
const $f7d77bddba730a3e$export$1c654f36e3d7dd60 = (id)=>({
        id: id,
        type: 'warning',
        title: (0, $kADcf.default).warningTitle,
        description: (0, $kADcf.default).warningDescription,
        appearance: 'warning',
        messageId: 'servicedesk-queues-agent-view.flags.warning.unsuccessfulFetch',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $kADcf.default).tryAgainButton,
                onClick: $f7d77bddba730a3e$var$reload
            }
        ]
    });
const $f7d77bddba730a3e$export$e39d17f9389fd3ea = (id)=>({
        id: id,
        type: 'error',
        title: (0, $kADcf.default).errorTitle,
        description: (0, $kADcf.default).errorOnScrollDescription,
        appearance: 'error',
        messageId: 'servicedesk-queues-agent-view.flags.error.unsuccessfulFetch',
        messageType: 'transactional'
    });
const $f7d77bddba730a3e$export$84de65b00282fe10 = (id)=>({
        id: id,
        type: 'warning',
        title: (0, $kADcf.default).warningTitle,
        description: (0, $kADcf.default).warningDescription,
        appearance: 'warning',
        messageId: 'servicedesk-queues-agent-view.flags.warning.unsuccessfulPoll',
        messageType: 'transactional'
    });
const $f7d77bddba730a3e$export$894642f3f2ceae70 = (queueName)=>({
        type: 'error',
        title: (0, $kADcf.default).queueDeleteFlagErrorTitle,
        description: [
            (0, $kADcf.default).queueDeleteFlagErrorDescription,
            {
                queueName: queueName
            }
        ],
        messageId: 'servicedesk-queues-agent-view.flags.error.deleteQueue',
        messageType: 'transactional'
    });

});
parcelRegister("kADcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f48bd8b392e612a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f48bd8b392e612a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    warningTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.warning-title",
        "defaultMessage": "Queue data may be outdated"
    },
    warningDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.warning-description",
        "defaultMessage": "We are unable to refresh the queue data. Check your internet connection."
    },
    errorTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.error-title",
        "defaultMessage": "Problem loading queue"
    },
    errorDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.error-description",
        "defaultMessage": "We couldn't load the queue. Give it a few seconds, then try again."
    },
    errorOnScrollDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.error-on-scroll-description",
        "defaultMessage": "We couldn't load some requests. Check your internet connection."
    },
    tryAgainButton: {
        "id": "servicedesk.queues.agent-view.flags.message.try-again-button",
        "defaultMessage": "Try again"
    },
    queueDeleteFlagErrorTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.queue-delete-flag-error-title",
        "defaultMessage": "Problem deleting queue"
    },
    queueDeleteFlagErrorDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.queue-delete-flag-error-description",
        "defaultMessage": "'{queueName}' couldn't be deleted. Please try again in a few seconds."
    }
});

});




parcelRegister("bEcXz", function(module, exports) {

$parcel$export(module.exports, "IncidentManagementTour", () => $89cb35bf4fc5e190$export$f345c7b8b33c1ee8);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $aNLeB = parcelRequire("aNLeB");

var $jBZp1 = parcelRequire("jBZp1");

var $oCMSG = parcelRequire("oCMSG");

var $bmKPg = parcelRequire("bmKPg");
const $89cb35bf4fc5e190$export$f345c7b8b33c1ee8 = (props)=>{
    const [practiceType] = (0, $bmKPg.usePathParam)('practiceType');
    const { data: isItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    if (isItsmProject !== true) return null;
    return practiceType === (0, $oCMSG.SHORT_FORM_INCIDENTS) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, ({ data: data })=>data && data.isProjectAdmin === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jBZp1.AsyncIncidentManagementTourQueues), props) : null) : null;
};

});
parcelRegister("jBZp1", function(module, exports) {

$parcel$export(module.exports, "AsyncIncidentManagementTourIssue", () => $b5eb7a7713132876$export$2dc985b4b00b6eec);
$parcel$export(module.exports, "AsyncIncidentManagementTourQueues", () => $b5eb7a7713132876$export$a33c87c292735e8b);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $aXpQP = parcelRequire("aXpQP");

var $kxZPA = parcelRequire("kxZPA");

const $b5eb7a7713132876$var$IncidentManagementTourIssueComponent = ()=>(parcelRequire("hakIH"));

const $b5eb7a7713132876$var$IncidentManagementTourQueuesComponent = ()=>(parcelRequire("9t3ty"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b5eb7a7713132876$var$IncidentManagementTourIssueNew = (0, $kxZPA.lazy)(()=>$b5eb7a7713132876$var$IncidentManagementTourIssueComponent(), {});
const $b5eb7a7713132876$var$AsyncIncidentManagementTourIssueNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "incident-management-tour-issue",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5eb7a7713132876$var$IncidentManagementTourIssueNew, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b5eb7a7713132876$var$IncidentManagementTourQueuesNew = (0, $kxZPA.lazy)(()=>$b5eb7a7713132876$var$IncidentManagementTourQueuesComponent(), {});
const $b5eb7a7713132876$var$AsyncIncidentManagementTourQueuesNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "incident-management-tour-queues",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5eb7a7713132876$var$IncidentManagementTourQueuesNew, props));
const $b5eb7a7713132876$export$2dc985b4b00b6eec = (0, $aXpQP.withShouldRenderWithinItsmSampleProject)($b5eb7a7713132876$var$AsyncIncidentManagementTourIssueNew, false);
const $b5eb7a7713132876$export$a33c87c292735e8b = (0, $aXpQP.withShouldRenderWithinItsmSampleProject)($b5eb7a7713132876$var$AsyncIncidentManagementTourQueuesNew, false);

});
parcelRegister("hakIH", function(module, exports) {

let $c7f37167b0e76728$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c7f37167b0e76728$var$load("h2MrD"),
    $c7f37167b0e76728$var$load("bYT2S"),
    $c7f37167b0e76728$var$load("juVHQ")
]).then(()=>parcelRequire('7fRpC'));

});

parcelRegister("9t3ty", function(module, exports) {

let $6e4984ab179c5dbb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6e4984ab179c5dbb$var$load("h2MrD"),
    $6e4984ab179c5dbb$var$load("bYT2S"),
    $6e4984ab179c5dbb$var$load("jpwfw")
]).then(()=>parcelRequire('hRm6C'));

});



parcelRegister("a8rnx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bc2606327d77128$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $8QpSo = parcelRequire("8QpSo");

var $hZHze = parcelRequire("hZHze");

var $8n3se = parcelRequire("8n3se");

var $jRCeJ = parcelRequire("jRCeJ");

var $bC2fB = parcelRequire("bC2fB");


var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");

var $gILZy = parcelRequire("gILZy");

var $4uvJ3 = parcelRequire("4uvJ3");

var $dOWTu = parcelRequire("dOWTu");

var $dWFvu = parcelRequire("dWFvu");

var $iIQpG = parcelRequire("iIQpG");

var $3jtVD = parcelRequire("3jtVD");

var $a5xpi = parcelRequire("a5xpi");

var $hYrcT = parcelRequire("hYrcT");

var $lHf6h = parcelRequire("lHf6h");

var $6pmxE = parcelRequire("6pmxE");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");

var $4pghP = parcelRequire("4pghP");

var $hSVQT = parcelRequire("hSVQT");

var $jHJR0 = parcelRequire("jHJR0");

var $dHKfC = parcelRequire("dHKfC");

var $1Ef3e = parcelRequire("1Ef3e");

var $deqET = parcelRequire("deqET");

var $iAhQx = parcelRequire("iAhQx");

var $jpEHR = parcelRequire("jpEHR");

var $8TeCx = parcelRequire("8TeCx");

var $83KYM = parcelRequire("83KYM");

var $7Dcqp = parcelRequire("7Dcqp");
const $2bc2606327d77128$var$getColumnsMemoized = ()=>(0, $dGvGJ.createSelector)((0, $627A7.getColumns), (res)=>res);
const $2bc2606327d77128$var$EMPTY_LIST = [];
const $2bc2606327d77128$var$mapStateToPropsFactory = ()=>{
    const getColumnsInstance = $2bc2606327d77128$var$getColumnsMemoized();
    return (state)=>({
            Header: $dHKfC.default,
            UsageSampler: $83KYM.default,
            EmptyQueue: $hSVQT.default,
            ErrorState: $jHJR0.default,
            isQueueEmpty: (0, $jeVA9.isQueueEmpty)(state),
            showIssueFailureError: (0, $jeVA9.showIssueFailureError)(state),
            isLoadingIssues: (0, $jeVA9.isLoadingIssues)(state),
            issueCount: (0, $lHf6h.getIssueCount)(state),
            onboardingResolved: (0, $jeVA9.getOnboardingResolved)(state),
            isCurrentDataFiltered: (0, $hYrcT.getIsCurrentDataFiltered)(state),
            Table: $8TeCx.default,
            EmptyFilteredQueue: $4pghP.default,
            NavUpdater: $iAhQx.default,
            ViewTracker: $hZHze.default,
            QueuesBreadcrumb: $jpEHR.default,
            IssueContextListener: $1Ef3e.default,
            ItsmContextListener: $deqET.default,
            baseUrl: '',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            projectKey: (0, $a5xpi.getAppProps)(state).projectKey,
            isInitialized: (0, $jeVA9.isInitialized)(state),
            category: (0, $627A7.getCategory)(state),
            itsmPractices: (0, $6pmxE.isItsmProject)(state) ? (0, $6pmxE.getEnabledPractices)(state) : $2bc2606327d77128$var$EMPTY_LIST,
            issueCollection: (0, $lHf6h.getCollection)(state),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            projectId: (0, $a5xpi.getAppProps)(state).projectId,
            columns: getColumnsInstance(state),
            jql: (0, $627A7.getJql)(state),
            shouldShowBadFilterQueryError: (0, $jeVA9.shouldShowBadFilterQueryError)(state),
            createAnalyticsEvent: (0, $3jtVD.getCreateAnalyticsEvent)(state),
            sidebarIssueKey: (0, $jeVA9.getSidebarIssueKey)(state),
            sidebarReactKey: (0, $jeVA9.getSidebarReactKey)(state),
            isQueuesErrorHeaderDisplayed: (0, $jeVA9.isQueuesErrorHeaderDisplayed)(state)
        });
};
const $2bc2606327d77128$var$mapDispatchToProps = (dispatch)=>({
        onPageVisibilityChanged: (isQueueVisible)=>{
            dispatch((0, $4uvJ3.changeVisibilityAction)(isQueueVisible));
            if (!isQueueVisible) dispatch((0, $iIQpG.stopPollAction)());
        },
        onUnmount: ()=>{
            dispatch((0, $gILZy.shutdownAction)());
        },
        onQueueChanged: (queue)=>{
            dispatch((0, $dOWTu.queueChangedAction)(queue));
        },
        onOnboardingResolved: (resolved)=>dispatch((0, $dWFvu.onboardingResolvedAction)(resolved)),
        onNavCollapseChange: (isNavCollapsed)=>{
            dispatch((0, $dWFvu.setNavCollapsedAction)(isNavCollapsed));
        },
        onWindowFocus: ()=>{
            dispatch((0, $iIQpG.restartPollAction)());
        },
        onFilterClear: ()=>{
            dispatch((0, $fnQyW.filterQueryChangedAction)(null));
            dispatch((0, $fnQyW.filterQuerySubmittedAction)(null));
        },
        onIssueChange: ()=>{
            dispatch((0, $fnQyW.isNewFilterQueryPendingAction)(true));
            dispatch((0, $bzBCj.loadIssuesAction)(0, (0, $36dd7e3255fc2bff$export$217a2381e50d4bff)));
        },
        onSetIssueKey: (key)=>{
            dispatch((0, $dWFvu.setSidebarIssueKey)(key));
        },
        onNonPremiumSLAColumnError: ()=>(0, $4uvJ3.displayQueuesErrorHeaderAction)
    });
const $2bc2606327d77128$var$getSidebarApiProps = (0, $8QpSo.default)((sidebarApiProps)=>sidebarApiProps);
const $2bc2606327d77128$var$LayoutWithSidebarApi = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8n3se.UIControllerSubscriber), null, ({ state: sidebarState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRCeJ.NavigationUISubscriber), null, (_, navActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Dcqp.default), {
                ...props,
                sidebarApi: $2bc2606327d77128$var$getSidebarApiProps({
                    navActions: navActions,
                    isCollapsed: sidebarState.isCollapsed
                })
            })));
const $2bc2606327d77128$var$ConnectedLayout = (0, $bC2fB.connect)($2bc2606327d77128$var$mapStateToPropsFactory, $2bc2606327d77128$var$mapDispatchToProps)($2bc2606327d77128$var$LayoutWithSidebarApi);
var $2bc2606327d77128$export$2e2bcd8739ae039 = $2bc2606327d77128$var$ConnectedLayout;

});
parcelRegister("8n3se", function(module, exports) {

$parcel$export(module.exports, "UIControllerSubscriber", () => $1bb3c61faedab1f7$export$8e3db525e646de2c);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7XYc4 = parcelRequire("7XYc4");

var $gPQRI = parcelRequire("gPQRI");

var $3HwlS = parcelRequire("3HwlS");

var $6qnkT = parcelRequire("6qnkT");
// Nav3
const $1bb3c61faedab1f7$var$UIControllerSubscriberOld = ({ children: children })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $gPQRI.useLeftSidebarController)();
    const { isCollapsed: isCollapsed, width: width } = (0, $gPQRI.useLeftSidebarState)();
    const stateRef = (0, $5uXOq.useRef)({
        state: {
            isCollapsed: isCollapsed,
            isResizing: false,
            isResizeDisabled: false,
            productNavWidth: width
        },
        collapse: collapseLeftSidebar,
        expand: expandLeftSidebar,
        toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
    });
    const navigationUIController = (0, $5uXOq.useMemo)(()=>({
            state: {
                isCollapsed: isCollapsed,
                isResizing: false,
                isResizeDisabled: false,
                productNavWidth: width
            },
            collapse: collapseLeftSidebar,
            expand: expandLeftSidebar,
            toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
        }), [
        collapseLeftSidebar,
        expandLeftSidebar,
        isCollapsed,
        width
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $1bb3c61faedab1f7$var$defaultState = {
    state: {
        isCollapsed: false,
        isResizing: false,
        isResizeDisabled: false,
        productNavWidth: 0
    },
    collapse: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    expand: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleCollapse: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
// Nav4
const $1bb3c61faedab1f7$var$UIControllerSubscriberNew = ({ children: children })=>{
    const toggleSideNav = (0, $6qnkT.useToggleSideNav)();
    const stateRef = (0, $5uXOq.useRef)({
        ...$1bb3c61faedab1f7$var$defaultState,
        toggleCollapse: toggleSideNav
    });
    const navigationUIController = (0, $5uXOq.useMemo)(()=>({
            ...$1bb3c61faedab1f7$var$defaultState,
            toggleCollapse: toggleSideNav
        }), [
        toggleSideNav
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $1bb3c61faedab1f7$export$8e3db525e646de2c = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $1bb3c61faedab1f7$var$UIControllerSubscriberNew, $1bb3c61faedab1f7$var$UIControllerSubscriberOld);

});

parcelRegister("4pghP", function(module, exports) {

$parcel$export(module.exports, "default", () => $710277632c55f5cb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $4R6GH = parcelRequire("4R6GH");

var $kjIEI = parcelRequire("kjIEI");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $7Mned = parcelRequire("7Mned");

var $egZon = parcelRequire("egZon");
const $710277632c55f5cb$var$EmptyView = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $4R6GH.fg)('jsm_queues_consolidate_jfe_assets') ? (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $kjIEI.default)) : undefined,
        imageUrl: (0, $4R6GH.fg)('jsm_queues_consolidate_jfe_assets') ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($7Mned))),
        header: formatMessage((0, $egZon.default).header),
        description: formatMessage((0, $egZon.default).description),
        headingLevel: 2
    });
};
var $710277632c55f5cb$export$2e2bcd8739ae039 = $710277632c55f5cb$var$EmptyView;

});
parcelRegister("kjIEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b511ca53b54ba8ce$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("540HS")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $4aihJ = parcelRequire("4aihJ");

var $540HS = parcelRequire("540HS");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $b511ca53b54ba8ce$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($540HS)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4aihJ))
});
var $b511ca53b54ba8ce$export$2e2bcd8739ae039 = $b511ca53b54ba8ce$var$Illustration;
// for advanced use only
const $b511ca53b54ba8ce$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("4aihJ", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("540HS", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("7Mned", function(module, exports) {
module.exports = new URL("no-search-results.6374065e.svg", import.meta.url).toString();

});

parcelRegister("egZon", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea00b2cdc26bb871$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ea00b2cdc26bb871$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "servicedesk.queues.agent-view.layout.empty-filtered-queue.header",
        "defaultMessage": "We couldn't find any requests that match your search"
    },
    description: {
        "id": "servicedesk.queues.agent-view.layout.empty-filtered-queue.description",
        "defaultMessage": "Check for typos, or try another search term"
    }
});

});


parcelRegister("hSVQT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eec23fcd4df2a3b$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $fy6YG = parcelRequire("fy6YG");

var $fniIF = parcelRequire("fniIF");

var $eHaGU = parcelRequire("eHaGU");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");

var $f1uep = parcelRequire("f1uep");

var $iK66R = parcelRequire("iK66R");

var $7gAy1 = parcelRequire("7gAy1");
const $5eec23fcd4df2a3b$var$mapStateToProps = (state)=>({
        emptyStateMessage: (0, $iK66R.getEmptyStateMessage)(state),
        projectId: (0, $fy6YG.getProjectId)(state),
        queueId: (0, $627A7.getQueueId)(state),
        isQueueVisible: (0, $jeVA9.isQueueVisible)(state),
        category: (0, $627A7.getCategory)(state),
        EmptyQueueComponent: $eHaGU.default,
        DemoDripFeed: $f1uep.default,
        ReadyForUser: $fniIF.ReadyForUser,
        metricKey: (0, $627A7.getMetricKey)(state)
    });
var $5eec23fcd4df2a3b$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($5eec23fcd4df2a3b$var$mapStateToProps, {})((0, $7gAy1.default));

});
parcelRegister("fniIF", function(module, exports) {

$parcel$export(module.exports, "ReadyForUser", () => $79a837c3cbd9b8cd$export$c05d1149dfea94a1);

var $5uXOq = parcelRequire("5uXOq");

var $x9xyg = parcelRequire("x9xyg");

var $br2Pa = parcelRequire("br2Pa");
const $79a837c3cbd9b8cd$export$c05d1149dfea94a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79a837c3cbd9b8cd$export$5efccbb976d3d994, props);
class $79a837c3cbd9b8cd$export$5efccbb976d3d994 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            context: undefined,
            onLoadEnd: (0, $br2Pa.end)
        };
    }
    componentDidMount() {
        this.recordEndMetric();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.context !== this.props.context) this.recordEndMetric();
    }
    recordEndMetric() {
        const { onLoadEnd: onLoadEnd } = this.props;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const location = window.location.pathname;
        (0, $x9xyg.setMark)('jsd.performance.profile.record.metric.end');
        onLoadEnd(location);
        var emitSignal;
    }
    render() {
        return null;
    }
}

});
parcelRegister("br2Pa", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    return function(t) {
        function e(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
        }
        var r = {};
        return e.m = t, e.c = r, e.d = function(t, r, n) {
            e.o(t, r) || Object.defineProperty(t, r, {
                configurable: !1,
                enumerable: !0,
                get: n
            });
        }, e.n = function(t) {
            var r = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(r, "a", r), r;
        }, e.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, e.p = "", e(e.s = 43);
    }([
        function(t, e) {
            var r = Array.isArray;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(22), o = "object" == typeof self && self && self.Object === Object && self, u = n || o || Function("return this")();
            t.exports = u;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = u(t, e);
                return o(r) ? r : void 0;
            }
            var o = r(75), u = r(78);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return null == t ? void 0 === t ? a : c : f && f in Object(t) ? u(t) : i(t);
            }
            var o = r(5), u = r(52), i = r(53), c = "[object Null]", a = "[object Undefined]", f = o ? o.toStringTag : void 0;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return null != t && "object" == typeof t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(1), o = n.Symbol;
            t.exports = o;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(65), u = r(66), i = r(67), c = r(68), a = r(69);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                for(var r = t.length; r--;)if (o(t[r][0], e)) return r;
                return -1;
            }
            var o = r(31);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(2), o = n(Object, "create");
            t.exports = o;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = t.__data__;
                return o(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
            }
            var o = r(87);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                if ("string" == typeof t || o(t)) return t;
                var e = t + "";
                return "0" == e && 1 / t == -u ? "-0" : e;
            }
            var o = r(18), u = 1 / 0;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) ? o(t) : u(t);
            }
            var o = r(49), u = r(58), i = r(13);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
            }
            var n = 9007199254740991;
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return null != t && u(t.length) && !o(t);
            }
            var o = r(28), u = r(12);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Map");
            t.exports = u;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(79), u = r(86), i = r(88), c = r(89), a = r(90);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                if (o(t)) return !1;
                var r = typeof t;
                return !("number" != r && "symbol" != r && "boolean" != r && null != t && !u(t)) || c.test(t) || !i.test(t) || null != e && t in Object(e);
            }
            var o = r(0), u = r(18), i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return "symbol" == typeof t || u(t) && o(t) == i;
            }
            var o = r(3), u = r(4), i = "[object Symbol]";
            t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t) {
                return !isNaN(parseInt(t, 10));
            }
            function u(t) {
                return new RegExp("[A-Z0-9]+-\\d+").test(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var i = r(44), c = n(i), a = r(127), f = n(a), s = r(129), p = n(s), l = r(42);
            e.default = function(t) {
                var e = (0, p.default)([
                    t.module,
                    t.item,
                    t.secondaryItem,
                    t.tertiaryItem,
                    t.quaternaryItem,
                    t.quinternaryItem
                ]), r = (0, f.default)(e, function(t) {
                    return o(t) ? "ENTITY_ID" : u(t) ? "ISSUE_KEY" : t;
                }).join(".");
                return (0, c.default)((0, l.getKeyTransformers)(), function(t, e) {
                    return e(t);
                }, r);
            };
        },
        function(t, e, r) {
            var n = r(46), o = r(62), u = o(n);
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(51), o = r(4), u = Object.prototype, i = u.hasOwnProperty, c = u.propertyIsEnumerable, a = n(function() {
                return arguments;
            }()) ? n : function(t) {
                return o(t) && i.call(t, "callee") && !c.call(t, "callee");
            };
            t.exports = a;
        },
        function(t, e, r) {
            (function(e) {
                var r = "object" == typeof e && e && e.Object === Object && e;
                t.exports = r;
            }).call(e, r(23));
        },
        function(t, e) {
            var r;
            r = function() {
                return this;
            }();
            try {
                r = r || Function("return this")() || (0, eval)("this");
            } catch (t) {
                "object" == typeof window && (r = window);
            }
            t.exports = r;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(1), o = r(54), u = "object" == typeof e && e && !e.nodeType && e, i = u && "object" == typeof t && t && !t.nodeType && t, c = i && i.exports === u, a = c ? n.Buffer : void 0, f = a ? a.isBuffer : void 0, s = f || o;
                t.exports = s;
            }).call(e, r(25)(t));
        },
        function(t, e) {
            t.exports = function(t) {
                return t.webpackPolyfill || (t.deprecate = function() {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                    enumerable: !0,
                    get: function() {
                        return t.l;
                    }
                }), Object.defineProperty(t, "id", {
                    enumerable: !0,
                    get: function() {
                        return t.i;
                    }
                }), t.webpackPolyfill = 1), t;
            };
        },
        function(t, e) {
            function r(t, e) {
                var r = typeof t;
                return !!(e = null == e ? n : e) && ("number" == r || "symbol" != r && o.test(t)) && t > -1 && t % 1 == 0 && t < e;
            }
            var n = 9007199254740991, o = /^(?:0|[1-9]\d*)$/;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(55), o = r(56), u = r(57), i = u && u.isTypedArray, c = i ? o(i) : n;
            t.exports = c;
        },
        function(t, e, r) {
            function n(t) {
                if (!u(t)) return !1;
                var e = o(t);
                return e == c || e == a || e == i || e == f;
            }
            var o = r(3), u = r(14), i = "[object AsyncFunction]", c = "[object Function]", a = "[object GeneratorFunction]", f = "[object Proxy]";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return "function" == typeof t ? t : null == t ? i : "object" == typeof t ? c(t) ? u(t[0], t[1]) : o(t) : a(t);
            }
            var o = r(63), u = r(114), i = r(41), c = r(0), a = r(123);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__ = new o(t);
                this.size = e.size;
            }
            var o = r(6), u = r(70), i = r(71), c = r(72), a = r(73), f = r(74);
            n.prototype.clear = u, n.prototype.delete = i, n.prototype.get = c, n.prototype.has = a, n.prototype.set = f, t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return t === e || t !== t && e !== e;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                if (null != t) {
                    try {
                        return o.call(t);
                    } catch (t) {}
                    try {
                        return t + "";
                    } catch (t) {}
                }
                return "";
            }
            var n = Function.prototype, o = n.toString;
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, i, c) {
                return t === e || (null == t || null == e || !u(t) && !u(e) ? t !== t && e !== e : o(t, e, r, i, n, c));
            }
            var o = r(91), u = r(4);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n, f, s) {
                var p = r & c, l = t.length, v = e.length;
                if (l != v && !(p && v > l)) return !1;
                var d = s.get(t);
                if (d && s.get(e)) return d == e;
                var y = -1, h = !0, b = r & a ? new o : void 0;
                for(s.set(t, e), s.set(e, t); ++y < l;){
                    var x = t[y], _ = e[y];
                    if (n) var j = p ? n(_, x, y, e, t, s) : n(x, _, y, t, e, s);
                    if (void 0 !== j) {
                        if (j) continue;
                        h = !1;
                        break;
                    }
                    if (b) {
                        if (!u(e, function(t, e) {
                            if (!i(b, e) && (x === t || f(x, t, r, n, s))) return b.push(e);
                        })) {
                            h = !1;
                            break;
                        }
                    } else if (x !== _ && !f(x, _, r, n, s)) {
                        h = !1;
                        break;
                    }
                }
                return s.delete(t), s.delete(e), h;
            }
            var o = r(92), u = r(95), i = r(96), c = 1, a = 2;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return t === t && !o(t);
            }
            var o = r(14);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return function(r) {
                    return null != r && r[t] === e && (void 0 !== e || t in Object(r));
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                e = o(e, t);
                for(var r = 0, n = e.length; null != t && r < n;)t = t[u(e[r++])];
                return r && r == n ? t : void 0;
            }
            var o = r(38), u = r(10);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return o(t) ? t : u(t, e) ? [
                    t
                ] : i(c(t));
            }
            var o = r(0), u = r(17), i = r(116), c = r(119);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;)o[r] = e(t[r], r, t);
                return o;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r) {
                e = o(e, t);
                for(var n = -1, s = e.length, p = !1; ++n < s;){
                    var l = f(e[n]);
                    if (!(p = null != t && r(t, l))) break;
                    t = t[l];
                }
                return p || ++n != s ? p : !!(s = null == t ? 0 : t.length) && a(s) && c(l, s) && (i(t) || u(t));
            }
            var o = r(38), u = r(21), i = r(0), c = r(26), a = r(12), f = r(10);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            (function(t) {
                function n(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                }
                function o(t, e, r) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = r, t;
                }
                function u(e, r) {
                    t.window._jsdApdex ? (0, d.default)(t.window._jsdApdex, e) || (t.window._jsdApdex[e] = r) : t.window._jsdApdex = o({}, e, r);
                }
                function i() {
                    return t.window._jsdApdex || {};
                }
                function c(t) {
                    u("metricsRecorder", t);
                }
                function a() {
                    return i().metricsRecorder ? i().metricsRecorder : (console.error("APDEX metrics recorder not initialized. Not recording APDEX."), {
                        start: l.default,
                        end: l.default
                    });
                }
                function f(t) {
                    u("keyTransformers", t);
                }
                function s() {
                    return i().keyTransformers || [];
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var p = r(41), l = n(p), v = r(130), d = n(v);
                e.installMetricsRecorder = c, e.getMetricsRecorder = a, e.installKeyTransformers = f, e.getKeyTransformers = s;
            }).call(e, r(23));
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t) {
                return "object" === (void 0 === t ? "undefined" : f(t)) ? (0, p.default)(t) : "string" == typeof t ? (0, v.default)(t) : "";
            }
            function u(t, e) {
                (0, y.installMetricsRecorder)(t), (0, y.installKeyTransformers)(e);
            }
            function i(t, e) {
                var r = o(t);
                return (0, d.withStartEventFiltering)(r, function(t) {
                    (0, y.getMetricsRecorder)().start(t, e);
                });
            }
            function c(t) {
                var e = o(t);
                return (0, d.withEndEventFiltering)(e, function(t) {
                    (0, y.getMetricsRecorder)().end(t);
                });
            }
            function a(t) {
                return c(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.getExpectedRedirect = e.hasExpectedRedirect = e.hasExpectedRedirectOf = void 0;
            var f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            };
            e.install = u, e.start = i, e.end = c, e.readyForUser = a;
            var s = r(19), p = n(s), l = r(132), v = n(l), d = r(133), y = r(42);
            e.hasExpectedRedirectOf = d.hasExpectedRedirectOf, e.hasExpectedRedirect = d.hasExpectedRedirect, e.getExpectedRedirect = d.getExpectedRedirect;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = a(t) ? o : c, f = arguments.length < 3;
                return n(t, i(e, 4), r, f, u);
            }
            var o = r(45), u = r(20), i = r(29), c = r(126), a = r(0);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e, r, n) {
                var o = -1, u = null == t ? 0 : t.length;
                for(n && u && (r = t[++o]); ++o < u;)r = e(r, t[o], o, t);
                return r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return t && o(t, e, u);
            }
            var o = r(47), u = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(48), o = n();
            t.exports = o;
        },
        function(t, e) {
            function r(t) {
                return function(e, r, n) {
                    for(var o = -1, u = Object(e), i = n(e), c = i.length; c--;){
                        var a = i[t ? c : ++o];
                        if (!1 === r(u[a], a, u)) break;
                    }
                    return e;
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = i(t), n = !r && u(t), s = !r && !n && c(t), l = !r && !n && !s && f(t), v = r || n || s || l, d = v ? o(t.length, String) : [], y = d.length;
                for(var h in t)!e && !p.call(t, h) || v && ("length" == h || s && ("offset" == h || "parent" == h) || l && ("buffer" == h || "byteLength" == h || "byteOffset" == h) || a(h, y)) || d.push(h);
                return d;
            }
            var o = r(50), u = r(21), i = r(0), c = r(24), a = r(26), f = r(27), s = Object.prototype, p = s.hasOwnProperty;
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = Array(t); ++r < t;)n[r] = e(r);
                return n;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return u(t) && o(t) == i;
            }
            var o = r(3), u = r(4), i = "[object Arguments]";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = i.call(t, a), r = t[a];
                try {
                    t[a] = void 0;
                    var n = !0;
                } catch (t) {}
                var o = c.call(t);
                return n && (e ? t[a] = r : delete t[a]), o;
            }
            var o = r(5), u = Object.prototype, i = u.hasOwnProperty, c = u.toString, a = o ? o.toStringTag : void 0;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return o.call(t);
            }
            var n = Object.prototype, o = n.toString;
            t.exports = r;
        },
        function(t, e) {
            function r() {
                return !1;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) && u(t.length) && !!c[o(t)];
            }
            var o = r(3), u = r(12), i = r(4), c = {};
            c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c["[object Arguments]"] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c["[object Map]"] = c["[object Number]"] = c["[object Object]"] = c["[object RegExp]"] = c["[object Set]"] = c["[object String]"] = c["[object WeakMap]"] = !1, t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return function(e) {
                    return t(e);
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(22), o = "object" == typeof e && e && !e.nodeType && e, u = o && "object" == typeof t && t && !t.nodeType && t, i = u && u.exports === o, c = i && n.process, a = function() {
                    try {
                        var t = u && u.require && u.require("util").types;
                        return t || c && c.binding && c.binding("util");
                    } catch (t) {}
                }();
                t.exports = a;
            }).call(e, r(25)(t));
        },
        function(t, e, r) {
            function n(t) {
                if (!o(t)) return u(t);
                var e = [];
                for(var r in Object(t))c.call(t, r) && "constructor" != r && e.push(r);
                return e;
            }
            var o = r(59), u = r(60), i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = t && t.constructor;
                return t === ("function" == typeof e && e.prototype || n);
            }
            var n = Object.prototype;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(61), o = n(Object.keys, Object);
            t.exports = o;
        },
        function(t, e) {
            function r(t, e) {
                return function(r) {
                    return t(e(r));
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return function(r, n) {
                    if (null == r) return r;
                    if (!o(r)) return t(r, n);
                    for(var u = r.length, i = e ? u : -1, c = Object(r); (e ? i-- : ++i < u) && !1 !== n(c[i], i, c););
                    return r;
                };
            }
            var o = r(13);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = u(t);
                return 1 == e.length && e[0][2] ? i(e[0][0], e[0][1]) : function(r) {
                    return r === t || o(r, t, e);
                };
            }
            var o = r(64), u = r(113), i = r(36);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n) {
                var a = r.length, f = a, s = !n;
                if (null == t) return !f;
                for(t = Object(t); a--;){
                    var p = r[a];
                    if (s && p[2] ? p[1] !== t[p[0]] : !(p[0] in t)) return !1;
                }
                for(; ++a < f;){
                    p = r[a];
                    var l = p[0], v = t[l], d = p[1];
                    if (s && p[2]) {
                        if (void 0 === v && !(l in t)) return !1;
                    } else {
                        var y = new o;
                        if (n) var h = n(v, d, l, t, e, y);
                        if (!(void 0 === h ? u(d, v, i | c, n, y) : h)) return !1;
                    }
                }
                return !0;
            }
            var o = r(30), u = r(33), i = 1, c = 2;
            t.exports = n;
        },
        function(t, e) {
            function r() {
                this.__data__ = [], this.size = 0;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__, r = o(e, t);
                return !(r < 0) && (r == e.length - 1 ? e.pop() : i.call(e, r, 1), --this.size, !0);
            }
            var o = r(7), u = Array.prototype, i = u.splice;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__, r = o(e, t);
                return r < 0 ? void 0 : e[r][1];
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(this.__data__, t) > -1;
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__, n = o(r, t);
                return n < 0 ? (++this.size, r.push([
                    t,
                    e
                ])) : r[n][1] = e, this;
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n() {
                this.__data__ = new o, this.size = 0;
            }
            var o = r(6);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = this.__data__, r = e.delete(t);
                return this.size = e.size, r;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.get(t);
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.has(t);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__;
                if (r instanceof o) {
                    var n = r.__data__;
                    if (!u || n.length < c - 1) return n.push([
                        t,
                        e
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new i(n);
                }
                return r.set(t, e), this.size = r.size, this;
            }
            var o = r(6), u = r(15), i = r(16), c = 200;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return !(!i(t) || u(t)) && (o(t) ? d : f).test(c(t));
            }
            var o = r(28), u = r(76), i = r(14), c = r(32), a = /[\\^$.*+?()[\]{}|]/g, f = /^\[object .+?Constructor\]$/, s = Function.prototype, p = Object.prototype, l = s.toString, v = p.hasOwnProperty, d = RegExp("^" + l.call(v).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return !!u && u in t;
            }
            var o = r(77), u = function() {
                var t = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "");
                return t ? "Symbol(src)_1." + t : "";
            }();
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(1), o = n["__core-js_shared__"];
            t.exports = o;
        },
        function(t, e) {
            function r(t, e) {
                return null == t ? void 0 : t[e];
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n() {
                this.size = 0, this.__data__ = {
                    hash: new o,
                    map: new (i || u),
                    string: new o
                };
            }
            var o = r(80), u = r(6), i = r(15);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(81), u = r(82), i = r(83), c = r(84), a = r(85);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n() {
                this.__data__ = o ? o(null) : {}, this.size = 0;
            }
            var o = r(8);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = this.has(t) && delete this.__data__[t];
                return this.size -= e ? 1 : 0, e;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__;
                if (o) {
                    var r = e[t];
                    return r === u ? void 0 : r;
                }
                return c.call(e, t) ? e[t] : void 0;
            }
            var o = r(8), u = "__lodash_hash_undefined__", i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__;
                return o ? void 0 !== e[t] : i.call(e, t);
            }
            var o = r(8), u = Object.prototype, i = u.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__;
                return this.size += this.has(t) ? 0 : 1, r[t] = o && void 0 === e ? u : e, this;
            }
            var o = r(8), u = "__lodash_hash_undefined__";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = o(this, t).delete(t);
                return this.size -= e ? 1 : 0, e;
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = typeof t;
                return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return o(this, t).get(t);
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(this, t).has(t);
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = o(this, t), n = r.size;
                return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n, h, x) {
                var _ = f(t), j = f(e), g = _ ? d : a(t), m = j ? d : a(e);
                g = g == v ? y : g, m = m == v ? y : m;
                var w = g == y, O = m == y, A = g == m;
                if (A && s(t)) {
                    if (!s(e)) return !1;
                    _ = !0, w = !1;
                }
                if (A && !w) return x || (x = new o), _ || p(t) ? u(t, e, r, n, h, x) : i(t, e, g, r, n, h, x);
                if (!(r & l)) {
                    var E = w && b.call(t, "__wrapped__"), P = O && b.call(e, "__wrapped__");
                    if (E || P) {
                        var R = E ? t.value() : t, S = P ? e.value() : e;
                        return x || (x = new o), h(R, S, r, n, x);
                    }
                }
                return !!A && (x || (x = new o), c(t, e, r, n, h, x));
            }
            var o = r(30), u = r(34), i = r(97), c = r(101), a = r(108), f = r(0), s = r(24), p = r(27), l = 1, v = "[object Arguments]", d = "[object Array]", y = "[object Object]", h = Object.prototype, b = h.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.__data__ = new o; ++e < r;)this.add(t[e]);
            }
            var o = r(16), u = r(93), i = r(94);
            n.prototype.add = n.prototype.push = u, n.prototype.has = i, t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.set(t, n), this;
            }
            var n = "__lodash_hash_undefined__";
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.has(t);
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length; ++r < n;)if (e(t[r], r, t)) return !0;
                return !1;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t, e) {
                return t.has(e);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, n, o, w, A) {
                switch(r){
                    case m:
                        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                        t = t.buffer, e = e.buffer;
                    case g:
                        return !(t.byteLength != e.byteLength || !w(new u(t), new u(e)));
                    case l:
                    case v:
                    case h:
                        return i(+t, +e);
                    case d:
                        return t.name == e.name && t.message == e.message;
                    case b:
                    case _:
                        return t == e + "";
                    case y:
                        var E = a;
                    case x:
                        var P = n & s;
                        if (E || (E = f), t.size != e.size && !P) return !1;
                        var R = A.get(t);
                        if (R) return R == e;
                        n |= p, A.set(t, e);
                        var S = c(E(t), E(e), n, o, w, A);
                        return A.delete(t), S;
                    case j:
                        if (O) return O.call(t) == O.call(e);
                }
                return !1;
            }
            var o = r(5), u = r(98), i = r(31), c = r(34), a = r(99), f = r(100), s = 1, p = 2, l = "[object Boolean]", v = "[object Date]", d = "[object Error]", y = "[object Map]", h = "[object Number]", b = "[object RegExp]", x = "[object Set]", _ = "[object String]", j = "[object Symbol]", g = "[object ArrayBuffer]", m = "[object DataView]", w = o ? o.prototype : void 0, O = w ? w.valueOf : void 0;
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(1), o = n.Uint8Array;
            t.exports = o;
        },
        function(t, e) {
            function r(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t, n) {
                    r[++e] = [
                        n,
                        t
                    ];
                }), r;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t) {
                    r[++e] = t;
                }), r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, n, i, a) {
                var f = r & u, s = o(t), p = s.length;
                if (p != o(e).length && !f) return !1;
                for(var l = p; l--;){
                    var v = s[l];
                    if (!(f ? v in e : c.call(e, v))) return !1;
                }
                var d = a.get(t);
                if (d && a.get(e)) return d == e;
                var y = !0;
                a.set(t, e), a.set(e, t);
                for(var h = f; ++l < p;){
                    v = s[l];
                    var b = t[v], x = e[v];
                    if (n) var _ = f ? n(x, b, v, e, t, a) : n(b, x, v, t, e, a);
                    if (!(void 0 === _ ? b === x || i(b, x, r, n, a) : _)) {
                        y = !1;
                        break;
                    }
                    h || (h = "constructor" == v);
                }
                if (y && !h) {
                    var j = t.constructor, g = e.constructor;
                    j != g && "constructor" in t && "constructor" in e && !("function" == typeof j && j instanceof j && "function" == typeof g && g instanceof g) && (y = !1);
                }
                return a.delete(t), a.delete(e), y;
            }
            var o = r(102), u = 1, i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(t, i, u);
            }
            var o = r(103), u = r(105), i = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = e(t);
                return u(t) ? n : o(n, r(t));
            }
            var o = r(104), u = r(0);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = e.length, o = t.length; ++r < n;)t[o + r] = e[r];
                return t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(106), o = r(107), u = Object.prototype, i = u.propertyIsEnumerable, c = Object.getOwnPropertySymbols, a = c ? function(t) {
                return null == t ? [] : (t = Object(t), n(c(t), function(e) {
                    return i.call(t, e);
                }));
            } : o;
            t.exports = a;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = 0, u = []; ++r < n;){
                    var i = t[r];
                    e(i, r, t) && (u[o++] = i);
                }
                return u;
            }
            t.exports = r;
        },
        function(t, e) {
            function r() {
                return [];
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(109), o = r(15), u = r(110), i = r(111), c = r(112), a = r(3), f = r(32), s = f(n), p = f(o), l = f(u), v = f(i), d = f(c), y = a;
            (n && "[object DataView]" != y(new n(new ArrayBuffer(1))) || o && "[object Map]" != y(new o) || u && "[object Promise]" != y(u.resolve()) || i && "[object Set]" != y(new i) || c && "[object WeakMap]" != y(new c)) && (y = function(t) {
                var e = a(t), r = "[object Object]" == e ? t.constructor : void 0, n = r ? f(r) : "";
                if (n) switch(n){
                    case s:
                        return "[object DataView]";
                    case p:
                        return "[object Map]";
                    case l:
                        return "[object Promise]";
                    case v:
                        return "[object Set]";
                    case d:
                        return "[object WeakMap]";
                }
                return e;
            }), t.exports = y;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "DataView");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Promise");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Set");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "WeakMap");
            t.exports = u;
        },
        function(t, e, r) {
            function n(t) {
                for(var e = u(t), r = e.length; r--;){
                    var n = e[r], i = t[n];
                    e[r] = [
                        n,
                        i,
                        o(i)
                    ];
                }
                return e;
            }
            var o = r(35), u = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return c(t) && a(e) ? f(s(t), e) : function(r) {
                    var n = u(r, t);
                    return void 0 === n && n === e ? i(r, t) : o(e, n, p | l);
                };
            }
            var o = r(33), u = r(115), i = r(121), c = r(17), a = r(35), f = r(36), s = r(10), p = 1, l = 2;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = null == t ? void 0 : o(t, e);
                return void 0 === n ? r : n;
            }
            var o = r(37);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(117), o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, u = /\\(\\)?/g, i = n(function(t) {
                var e = [];
                return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function(t, r, n, o) {
                    e.push(n ? o.replace(u, "$1") : r || t);
                }), e;
            });
            t.exports = i;
        },
        function(t, e, r) {
            function n(t) {
                var e = o(t, function(t) {
                    return r.size === u && r.clear(), t;
                }), r = e.cache;
                return e;
            }
            var o = r(118), u = 500;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(u);
                var r = function() {
                    var n = arguments, o = e ? e.apply(this, n) : n[0], u = r.cache;
                    if (u.has(o)) return u.get(o);
                    var i = t.apply(this, n);
                    return r.cache = u.set(o, i) || u, i;
                };
                return r.cache = new (n.Cache || o), r;
            }
            var o = r(16), u = "Expected a function";
            n.Cache = o, t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return null == t ? "" : o(t);
            }
            var o = r(120);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                if ("string" == typeof t) return t;
                if (i(t)) return u(t, n) + "";
                if (c(t)) return s ? s.call(t) : "";
                var e = t + "";
                return "0" == e && 1 / t == -a ? "-0" : e;
            }
            var o = r(5), u = r(39), i = r(0), c = r(18), a = 1 / 0, f = o ? o.prototype : void 0, s = f ? f.toString : void 0;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return null != t && u(t, e, o);
            }
            var o = r(122), u = r(40);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return null != t && e in Object(t);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) ? o(c(t)) : u(t);
            }
            var o = r(124), u = r(125), i = r(17), c = r(10);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return function(e) {
                    return null == e ? void 0 : e[t];
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return function(e) {
                    return o(e, t);
                };
            }
            var o = r(37);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e, r, n, o) {
                return o(t, function(t, o, u) {
                    r = n ? (n = !1, t) : e(r, t, o, u);
                }), r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return (c(t) ? o : i)(t, u(e, 3));
            }
            var o = r(39), u = r(29), i = r(128), c = r(0);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = -1, n = u(t) ? Array(t.length) : [];
                return o(t, function(t, o, u) {
                    n[++r] = e(t, o, u);
                }), n;
            }
            var o = r(20), u = r(13);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                for(var e = -1, r = null == t ? 0 : t.length, n = 0, o = []; ++e < r;){
                    var u = t[e];
                    u && (o[n++] = u);
                }
                return o;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return null != t && u(t, e, o);
            }
            var o = r(131), u = r(40);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return null != t && o.call(t, e);
            }
            var n = Object.prototype, o = n.hasOwnProperty;
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                if (Array.isArray(t)) {
                    for(var e = 0, r = Array(t.length); e < t.length; e++)r[e] = t[e];
                    return r;
                }
                return Array.from(t);
            }
            function o(t) {
                return f.test(t) ? t.replace(f, "") : s.test(t) ? t.replace(s, "") : p.test(t) ? t.replace(p, "") : t.substr(1);
            }
            function u(t, e, r, n, o, u) {
                return {
                    module: t,
                    item: e,
                    secondaryItem: r,
                    tertiaryItem: n,
                    quaternaryItem: o,
                    quinternaryItem: u
                };
            }
            function i(t) {
                var e = o(t);
                return u.apply(void 0, n(e.split("/")));
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.stateFromRoute = i;
            var c = r(19), a = function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }(c), f = /^\/servicedesk\/admin\/[A-Z][A-Z0-9]{1,9}\//, s = /^\/projects\/[A-Z][A-Z0-9]{1,9}\//, p = /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]{1,9}\//;
            e.default = function(t) {
                return (0, a.default)(i(t));
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = RegExp("\\.REDIRECT$"), o = void 0, u = e.getExpectedRedirect = function(t) {
                return t.replace(n, "");
            }, i = e.hasExpectedRedirect = function(t) {
                return n.test(t);
            }, c = (e.hasExpectedRedirectOf = function(t) {
                return t + ".REDIRECT";
            }, function(t) {
                return i(t) ? o = u(t) : (o = void 0, t);
            });
            e.resetSuppressedEvent = function() {
                o = void 0;
            }, e.withStartEventFiltering = function(t, e) {
                if (u(t) === o) return c(t);
                var r = c(t);
                return e(r), r;
            }, e.withEndEventFiltering = function(t, e) {
                return i(t) ? u(t) : (e(t), t);
            };
        }
    ]);
});

});


parcelRegister("eHaGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a70ae55108da700e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $hxoiH = parcelRequire("hxoiH");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jF62O = parcelRequire("jF62O");

var $fd5HN = parcelRequire("fd5HN");

var $5OlTx = parcelRequire("5OlTx");

var $hdpfh = parcelRequire("hdpfh");


var $lq0lY = parcelRequire("lq0lY");
const $a70ae55108da700e$export$fdbb6e83492670a7 = (props)=>{
    const { category: category, projectId: projectId, showCTA: showCTA = true } = props;
    const [practices] = (0, $jF62O.usePracticeList)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const isDarkMode = colorMode === 'dark';
    const openCreateIssueDialogModern = (0, $5uXOq.useCallback)((_event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            isAnyWorkCategoryEnabled: false
        });
        openIssueCreateModal({
            triggerPointKey: (0, $hULKg.JSM_EMPTY_QUEUE_CREATE_REQUEST)
        });
    }, [
        openIssueCreateModal
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const primaryAction = (0, $5uXOq.useMemo)(()=>{
        if (showCTA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            onClick: openCreateIssueDialogModern,
            "data-pid": projectId,
            testId: "servicedesk-queues-empty-queue.create-issue-button"
        }, formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $lq0lY.default).emptyQueueButtonLabelIssueTermRefresh : (0, $lq0lY.default).emptyQueueButtonLabel));
    }, [
        formatMessage,
        openCreateIssueDialogModern,
        projectId,
        showCTA
    ]);
    // If ITSM Project, render the ITSM empty states
    if (category !== undefined && practices && practices.length > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdpfh.EmptyPracticeQueue), {
        projectId: projectId
    });
    const IPHButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
        articleId: "5b7BuVaVJqmbyCZ2mbMYHD",
        appearance: "link",
        spacing: "none",
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            target: "_blank",
            href: (0, $7ce02bc2e6cada96$export$f960f87b7b043226)
        }, formatMessage((0, $lq0lY.default).emptyQueueLearnMoreText))
    }, formatMessage((0, $lq0lY.default).emptyQueueLearnMoreText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $lq0lY.default).emptyQueueHeader),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $lq0lY.default).emptyQueueDescriptionIssueTermRefresh : (0, $lq0lY.default).emptyQueueDescription,
            values: {
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                p: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, chunks),
                IPHArticle: IPHButton,
                break: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
            }
        }),
        imageUrl: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($5OlTx))) : (0, (/*@__PURE__*/$parcel$interopDefault($fd5HN))),
        maxImageWidth: (0, $7ce02bc2e6cada96$export$caaf33f9dba14d10),
        maxImageHeight: (0, $7ce02bc2e6cada96$export$3465603c26b84396),
        primaryAction: primaryAction
    });
};
var $a70ae55108da700e$export$2e2bcd8739ae039 = $a70ae55108da700e$export$fdbb6e83492670a7;

});
parcelRegister("fd5HN", function(module, exports) {
module.exports = new URL("generic.28da7925.svg", import.meta.url).toString();

});

parcelRegister("5OlTx", function(module, exports) {
module.exports = new URL("genericDark.a2b43fbb.svg", import.meta.url).toString();

});

parcelRegister("hdpfh", function(module, exports) {

$parcel$export(module.exports, "EmptyPracticeQueue", () => $34b9b44698668f31$export$b66e73d71b13aaba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $eZJjh = parcelRequire("eZJjh");

var $hxoiH = parcelRequire("hxoiH");

var $6BZYo = parcelRequire("6BZYo");

var $4R6GH = parcelRequire("4R6GH");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $8zOmE = parcelRequire("8zOmE");

var $6lwh1 = parcelRequire("6lwh1");

var $oCMSG = parcelRequire("oCMSG");

var $1ilU2 = parcelRequire("1ilU2");

var $bmKPg = parcelRequire("bmKPg");


var $2VsSH = parcelRequire("2VsSH");

var $iDSFq = parcelRequire("iDSFq");
const $34b9b44698668f31$var$openCreateIssueDialog = (queueCategory = (0, $oCMSG.NO_CATEGORY))=>(event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            queueCategory: queueCategory
        });
        const buttonElement = event.currentTarget;
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $6BZYo.loadBridge)({
            name: 'quick-edit/init/create-dialogs',
            wrmKeys: 'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap'
        }).then(({ showCreateDialog: showCreateDialog })=>{
            // the issue create dialog will read attributes off the event's target,
            // which in the case of our AK button could be the outer `button`, outer `span` or
            // or inner `span` so we reassign the target to the button so that those attributes
            // will always be present
            const eventWithButtonTarget = {
                ...event,
                target: buttonElement
            };
            showCreateDialog(eventWithButtonTarget);
        });
    };
const $34b9b44698668f31$export$6c775f6de634e0f7 = ()=>Boolean(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.IssueCreate && window.IssueCreate.Visibility && window.IssueCreate.Visibility.isEnabled);
const $34b9b44698668f31$export$b66e73d71b13aaba = (props)=>{
    const { projectId: projectId } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [practiceType] = (0, $bmKPg.usePathParam)('practiceType');
    const practice = (0, $1ilU2.toItsmPractice)(practiceType);
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const openCreateIssueDialogModern = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            queueCategory: practice
        });
        openIssueCreateModal({
            triggerPointKey: (0, $hULKg.JSM_EMPTY_QUEUE_CREATE_REQUEST)
        });
    }, [
        openIssueCreateModal,
        practice
    ]);
    const onClickHandler = (0, $5uXOq.useMemo)(()=>{
        if ($34b9b44698668f31$export$6c775f6de634e0f7()) return openCreateIssueDialogModern;
        return $34b9b44698668f31$var$openCreateIssueDialog(practice);
    }, [
        openCreateIssueDialogModern,
        practice
    ]);
    const { data: data, loading: loading, error: error } = (0, $6lwh1.default)(projectId, practice);
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, buttonLabel: buttonLabel, getImageUrl: getImageUrl, renderImage: renderImage } = (0, $2VsSH.PRACTICE_DATA)[practice];
    const itsmCategoryToPreSelect = practice !== (0, $oCMSG.NO_CATEGORY) ? (0, $1ilU2.toItsmPractice)(practice) : undefined;
    const primaryAction = (0, $5uXOq.useMemo)(()=>{
        if (!error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: onClickHandler,
            "data-pid": projectId,
            "data-itsm-category": itsmCategoryToPreSelect,
            // rendered as `data-testid` on the button element
            testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.create-issue-button"
        }, formatMessage(buttonLabel));
    }, [
        buttonLabel,
        error,
        formatMessage,
        itsmCategoryToPreSelect,
        onClickHandler,
        projectId
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34b9b44698668f31$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
    if (practice !== (0, $oCMSG.NO_CATEGORY) && data && !data.ticketTypes.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDSFq.EmptyUnconfiguredPracticeQueue), null);
    const renderImageWithSize = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)(renderImage)({
            maxImageHeight: 250,
            maxImageWidth: 250
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, $4R6GH.fg)('jsm_queues_consolidate_jfe_assets') ? undefined : getImageUrl(colorMode),
        renderImage: (0, $4R6GH.fg)('jsm_queues_consolidate_jfe_assets') ? renderImageWithSize : undefined,
        header: formatMessage(headerMessage),
        description: formatMessage(descriptionMessage),
        headingLevel: 2,
        primaryAction: primaryAction,
        maxImageWidth: (0, $7ce02bc2e6cada96$export$caaf33f9dba14d10),
        maxImageHeight: (0, $7ce02bc2e6cada96$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-practice-queue"
    });
};
// matches the margin and max-width of atlaskit EmptyState component
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34b9b44698668f31$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkoahv _2hwx1wug _otyroahv _18u01wug _p12f1pl1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6lwh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa39ecd88b51ee31$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $a7EYT = parcelRequire("a7EYT");

var $oCMSG = parcelRequire("oCMSG");
const $aa39ecd88b51ee31$var$usePracticeRequestTypesService = (projectId, practice)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const request = (0, $5uXOq.useCallback)(()=>(0, $a7EYT.performGetRequest)(`/rest/servicedesk/1/servicedesk/${projectId}/request-types?practices=${practice}`), [
        projectId,
        practice
    ]);
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $ld2hZ.useService)(request);
    (0, $5uXOq.useEffect)(()=>{
        if (practice !== (0, $oCMSG.NO_CATEGORY)) fetch();
    }, [
        practice,
        fetch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (data) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'practiceRequestTypes fetched');
    }, [
        data,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $jcw0u.default)({
            meta: {
                id: 'practiceRequestTypes',
                packageName: 'jiraServicedeskQueuesCommon'
            },
            error: error,
            event: createAnalyticsEvent({}),
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error,
        createAnalyticsEvent
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};
var $aa39ecd88b51ee31$export$2e2bcd8739ae039 = $aa39ecd88b51ee31$var$usePracticeRequestTypesService;

});

const $7ce02bc2e6cada96$export$3465603c26b84396 = 250;
const $7ce02bc2e6cada96$export$caaf33f9dba14d10 = 400;
const $7ce02bc2e6cada96$export$f960f87b7b043226 = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-queues/';

parcelRegister("2VsSH", function(module, exports) {

$parcel$export(module.exports, "PRACTICE_DATA", () => $dc35b21d25cd5374$export$cda75610eb70fde9);

var $5AGTr = parcelRequire("5AGTr");

var $jTi6A = parcelRequire("jTi6A");

var $88Gxu = parcelRequire("88Gxu");

var $j0J3u = parcelRequire("j0J3u");

var $c73Mt = parcelRequire("c73Mt");

var $3bt7q = parcelRequire("3bt7q");

var $oCMSG = parcelRequire("oCMSG");

var $hssWu = parcelRequire("hssWu");

var $cQ1t6 = parcelRequire("cQ1t6");

var $kLPJE = parcelRequire("kLPJE");

var $011Dy = parcelRequire("011Dy");

var $erbCj = parcelRequire("erbCj");

var $8K3f6 = parcelRequire("8K3f6");

var $6qMDX = parcelRequire("6qMDX");

var $fn8KU = parcelRequire("fn8KU");

var $jLYQe = parcelRequire("jLYQe");

var $lw5Wf = parcelRequire("lw5Wf");

var $7Epkb = parcelRequire("7Epkb");

var $6sOGM = parcelRequire("6sOGM");

var $aif35 = parcelRequire("aif35");
const $dc35b21d25cd5374$var$LIGHT_MODE = 'light';
const $dc35b21d25cd5374$var$DARK_MODE = 'dark';
const $dc35b21d25cd5374$var$AUTO = 'auto';
const $dc35b21d25cd5374$export$cda75610eb70fde9 = {
    [(0, $oCMSG.SERVICE_REQUEST)]: {
        headerMessage: (0, $aif35.default).serviceRequestsHeader,
        descriptionMessage: (0, $aif35.default).serviceRequestsDescription,
        buttonLabel: (0, $aif35.default).serviceRequestsCreateIssueButtonText,
        renderImage: (0, $j0J3u.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7Epkb))),
        getImageUrl: (currentTheme)=>currentTheme === $dc35b21d25cd5374$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($6sOGM))) : (0, (/*@__PURE__*/$parcel$interopDefault($7Epkb))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-service-requests/'
    },
    [(0, $oCMSG.INCIDENTS)]: {
        headerMessage: (0, $aif35.default).incidentsHeader,
        descriptionMessage: (0, $aif35.default).incidentsDescription,
        buttonLabel: (0, $aif35.default).incidentsCreateIssueButtonText,
        renderImage: (0, $3bt7q.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($erbCj))),
        getImageUrl: (currentTheme)=>currentTheme === $dc35b21d25cd5374$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($8K3f6))) : (0, (/*@__PURE__*/$parcel$interopDefault($erbCj))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-incidents/'
    },
    [(0, $oCMSG.PROBLEMS)]: {
        headerMessage: (0, $aif35.default).problemsHeader,
        descriptionMessage: (0, $aif35.default).problemsDescription,
        buttonLabel: (0, $aif35.default).problemsCreateIssueButtonText,
        renderImage: (0, $jTi6A.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jLYQe))),
        getImageUrl: (currentTheme)=>currentTheme === $dc35b21d25cd5374$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($lw5Wf))) : (0, (/*@__PURE__*/$parcel$interopDefault($jLYQe))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-problems/'
    },
    [(0, $oCMSG.CHANGES)]: {
        headerMessage: (0, $aif35.default).changesHeader,
        descriptionMessage: (0, $aif35.default).changesDescription,
        buttonLabel: (0, $aif35.default).changesCreateIssueButtonText,
        renderImage: (0, $5AGTr.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kLPJE))),
        getImageUrl: (currentTheme)=>currentTheme === $dc35b21d25cd5374$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($011Dy))) : (0, (/*@__PURE__*/$parcel$interopDefault($kLPJE))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-changes/'
    },
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $aif35.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $aif35.default).postIncidentReviewsDescription,
        buttonLabel: (0, $aif35.default).postIncidentReviewsCreateIssueButtonText,
        renderImage: (0, $c73Mt.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6qMDX))),
        getImageUrl: (currentTheme)=>currentTheme === $dc35b21d25cd5374$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($fn8KU))) : (0, (/*@__PURE__*/$parcel$interopDefault($6qMDX))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-post-incident-reviews/'
    },
    [(0, $oCMSG.NO_CATEGORY)]: {
        headerMessage: (0, $aif35.default).allTicketsHeader,
        descriptionMessage: (0, $aif35.default).allTicketsDescription,
        buttonLabel: (0, $aif35.default).allTicketsCreateIssueButtonText,
        renderImage: (0, $88Gxu.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hssWu))),
        getImageUrl: (currentTheme)=>currentTheme === $dc35b21d25cd5374$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($cQ1t6))) : (0, (/*@__PURE__*/$parcel$interopDefault($hssWu))),
        learnMoreUrl: undefined
    }
};

});
parcelRegister("5AGTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $48626ad01c0a2838$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = g4nfj272vxmnnng6jh384m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/g4nfj272vxmnnng6jh384m

var $dCLgq = parcelRequire("dCLgq");

var $1FjZD = parcelRequire("1FjZD");
const $48626ad01c0a2838$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1FjZD)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1FjZD))
});
var $48626ad01c0a2838$export$2e2bcd8739ae039 = $48626ad01c0a2838$var$Illustration;
// for advanced use only
const $48626ad01c0a2838$export$a179c88182cb9d56 = [
    0,
    0,
    497,
    318
];

});
parcelRegister("1FjZD", function(module, exports) {
module.exports = new URL("software-development.a5df06ef.svg", import.meta.url).toString();

});


parcelRegister("jTi6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $300a94eee1fd3384$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = q7cns859w734758qv5wmgpm
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/q7cns859w734758qv5wmgpm

var $dCLgq = parcelRequire("dCLgq");

var $24E79 = parcelRequire("24E79");

var $474qp = parcelRequire("474qp");
const $300a94eee1fd3384$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($474qp)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($24E79))
});
var $300a94eee1fd3384$export$2e2bcd8739ae039 = $300a94eee1fd3384$var$Illustration;
// for advanced use only
const $300a94eee1fd3384$export$a179c88182cb9d56 = [
    0,
    0,
    223,
    189
];

});
parcelRegister("24E79", function(module, exports) {
module.exports = new URL("target-single-darkmode.5d8fc324.svg", import.meta.url).toString();

});

parcelRegister("474qp", function(module, exports) {
module.exports = new URL("target-single.a1a07a4f.svg", import.meta.url).toString();

});


parcelRegister("88Gxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $72c5cdfd371efc62$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = hrv73kh63rncntxr5mpzh
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/hrv73kh63rncntxr5mpzh

var $dCLgq = parcelRequire("dCLgq");

var $cUt4J = parcelRequire("cUt4J");
const $72c5cdfd371efc62$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cUt4J)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cUt4J))
});
var $72c5cdfd371efc62$export$2e2bcd8739ae039 = $72c5cdfd371efc62$var$Illustration;
// for advanced use only
const $72c5cdfd371efc62$export$a179c88182cb9d56 = [
    0,
    0,
    233,
    235
];

});
parcelRegister("cUt4J", function(module, exports) {
module.exports = new URL("ticket-dispensor.f4a024b2.svg", import.meta.url).toString();

});


parcelRegister("j0J3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdebb5a4bc49e1d1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $fqEao = parcelRequire("fqEao");

var $4dpcD = parcelRequire("4dpcD");
const $bdebb5a4bc49e1d1$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4dpcD)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fqEao))
});
var $bdebb5a4bc49e1d1$export$2e2bcd8739ae039 = $bdebb5a4bc49e1d1$var$Illustration;
// for advanced use only
const $bdebb5a4bc49e1d1$export$a179c88182cb9d56 = [
    0,
    0,
    595,
    601
];

});
parcelRegister("fqEao", function(module, exports) {
module.exports = new URL("balloons-darkmode.7d1967f8.svg", import.meta.url).toString();

});

parcelRegister("4dpcD", function(module, exports) {
module.exports = new URL("balloons.8acbde79.svg", import.meta.url).toString();

});


parcelRegister("c73Mt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bc539d7c4ea0de6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $dNKzK = parcelRequire("dNKzK");
const $5bc539d7c4ea0de6$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dNKzK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dNKzK))
});
var $5bc539d7c4ea0de6$export$2e2bcd8739ae039 = $5bc539d7c4ea0de6$var$Illustration;
// for advanced use only
const $5bc539d7c4ea0de6$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    282
];

});
parcelRegister("dNKzK", function(module, exports) {
module.exports = new URL("people-working-on-computers.c86cef7c.svg", import.meta.url).toString();

});


parcelRegister("3bt7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ac09af3ccced4f9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $jWRcK = parcelRequire("jWRcK");
const $1ac09af3ccced4f9$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jWRcK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jWRcK))
});
var $1ac09af3ccced4f9$export$2e2bcd8739ae039 = $1ac09af3ccced4f9$var$Illustration;
// for advanced use only
const $1ac09af3ccced4f9$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    386
];

});
parcelRegister("jWRcK", function(module, exports) {
module.exports = new URL("task-board-with-people.e468116d.svg", import.meta.url).toString();

});


parcelRegister("hssWu", function(module, exports) {
module.exports = new URL("all-tickets.e438cf2e.svg", import.meta.url).toString();

});

parcelRegister("cQ1t6", function(module, exports) {
module.exports = new URL("all-ticketsDark.5aecc647.svg", import.meta.url).toString();

});

parcelRegister("kLPJE", function(module, exports) {
module.exports = new URL("changes.0ea22c65.svg", import.meta.url).toString();

});

parcelRegister("011Dy", function(module, exports) {
module.exports = new URL("changesDark.e78f0f3f.svg", import.meta.url).toString();

});

parcelRegister("erbCj", function(module, exports) {
module.exports = new URL("incidents.c1cdd3ac.svg", import.meta.url).toString();

});

parcelRegister("8K3f6", function(module, exports) {
module.exports = new URL("incidentsDark.aba376a8.svg", import.meta.url).toString();

});

parcelRegister("6qMDX", function(module, exports) {
module.exports = new URL("post-incident-reviews.28e33ce7.svg", import.meta.url).toString();

});

parcelRegister("fn8KU", function(module, exports) {
module.exports = new URL("post-incident-reviewsDark.79dea6fc.svg", import.meta.url).toString();

});

parcelRegister("jLYQe", function(module, exports) {
module.exports = new URL("problems.9524f82d.svg", import.meta.url).toString();

});

parcelRegister("lw5Wf", function(module, exports) {
module.exports = new URL("problemsDark.2e76c8e2.svg", import.meta.url).toString();

});

parcelRegister("7Epkb", function(module, exports) {
module.exports = new URL("service-requests.266aad3f.svg", import.meta.url).toString();

});

parcelRegister("6sOGM", function(module, exports) {
module.exports = new URL("service-requestsDark.ce6d6e11.svg", import.meta.url).toString();

});

parcelRegister("aif35", function(module, exports) {

$parcel$export(module.exports, "default", () => $272d4b477b6e155e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $272d4b477b6e155e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    allTicketsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-header",
        "defaultMessage": "All of your requests will show up here"
    },
    allTicketsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-description",
        "defaultMessage": "Talk with customers, notify your teammates and track work all in one place. Create a request of your own to see it in action."
    },
    allTicketsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-create-issue-button-text",
        "defaultMessage": "Create a request"
    },
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-header",
        "defaultMessage": "Solve service requests"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-description",
        "defaultMessage": "Track requests for support, monitor SLAs, and communicate with help seekers."
    },
    serviceRequestsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-create-issue-button-text",
        "defaultMessage": "Create a service request"
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-header",
        "defaultMessage": "Resolve disruptions"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-description",
        "defaultMessage": "Detect, respond to and resolve incidents. Catch issues early with alerts and on-call scheduling, and keep stakeholders updated at every step."
    },
    incidentsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-create-issue-button-text",
        "defaultMessage": "Report an incident"
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-header",
        "defaultMessage": "Fix all the things"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-description",
        "defaultMessage": "Investigate the root cause of repeat incidents and track their resolution from start to finish."
    },
    problemsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-create-issue-button-text",
        "defaultMessage": "Investigate a problem"
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-header",
        "defaultMessage": "Make things happen"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-description",
        "defaultMessage": "Get full visibility of scheduled changes. Set approval steps, minimize disruption, create change records, and keep impacted stakeholders updated."
    },
    changesCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-create-issue-button-text",
        "defaultMessage": "Create a change request"
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-header",
        "defaultMessage": "Learn from post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-description",
        "defaultMessage": "Bring your team together to capture the causes and impacts of an incident, and learn how to prevent similar incidents from happening again."
    },
    postIncidentReviewsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-create-issue-button-text",
        "defaultMessage": "Start a post-incident review"
    }
});

});


parcelRegister("iDSFq", function(module, exports) {

$parcel$export(module.exports, "EmptyUnconfiguredPracticeQueue", () => $cb461669dbca473b$export$da55df0aa01118ce);

var $5uXOq = parcelRequire("5uXOq");

var $dFOAR = parcelRequire("dFOAR");

var $8jOID = parcelRequire("8jOID");

var $ks0ka = parcelRequire("ks0ka");
const $cb461669dbca473b$export$da55df0aa01118ce = ()=>{
    const [{ data: data }] = (0, $dFOAR.useServiceDeskContext)();
    const isAgentAdmin = data?.userRole === 'agent-project-admin';
    return isAgentAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jOID.EmptyQueueAdminView), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ks0ka.EmptyQueueAgentView), null);
};

});
parcelRegister("8jOID", function(module, exports) {

$parcel$export(module.exports, "EmptyQueueAdminView", () => $39bb862ed12edb10$export$c52b9754879a0252);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $hxoiH = parcelRequire("hxoiH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $1ilU2 = parcelRequire("1ilU2");

var $bmKPg = parcelRequire("bmKPg");


var $eOrUh = parcelRequire("eOrUh");

var $gIziC = parcelRequire("gIziC");
const $39bb862ed12edb10$export$c52b9754879a0252 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const baseUrl = '';
    const [practice] = (0, $bmKPg.usePathParam)('practiceType');
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // practice should always be set in case of an unconfigured queue, if not this is a wrong route
    if (practice === undefined) return null;
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, getImageUrl: getImageUrl, learnMoreText: learnMoreText, learnMoreUrl: learnMoreUrl } = (0, $eOrUh.EMPTY_STATE_DATA)[(0, $1ilU2.toItsmPractice)(practice)];
    const getHref = ()=>{
        if (projectKey == null) return undefined;
        return `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/request-types/category/${practice}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage(headerMessage),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($39bb862ed12edb10$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...descriptionMessage,
            values: {
                // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                p: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, chunks),
                a: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                        target: "_blank",
                        href: learnMoreUrl
                    }, learnMoreText && formatMessage(learnMoreText))
            }
        })),
        imageUrl: getImageUrl(colorMode),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            href: getHref()
        }, formatMessage((0, $gIziC.default).addRequestTypeButtonText)),
        maxImageWidth: (0, $7ce02bc2e6cada96$export$caaf33f9dba14d10),
        maxImageHeight: (0, $7ce02bc2e6cada96$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.empty-queue-admin-view"
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $39bb862ed12edb10$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eOrUh", function(module, exports) {

$parcel$export(module.exports, "EMPTY_STATE_DATA", () => $3fca2e267e513c81$export$cfb3b7ce372d6279);

var $oCMSG = parcelRequire("oCMSG");

var $2VsSH = parcelRequire("2VsSH");

var $3rkzd = parcelRequire("3rkzd");

var $gIziC = parcelRequire("gIziC");
const $3fca2e267e513c81$export$cfb3b7ce372d6279 = {
    [(0, $oCMSG.SERVICE_REQUEST)]: {
        headerMessage: (0, $gIziC.default).serviceRequestsHeader,
        descriptionMessage: (0, $gIziC.default).serviceRequestsDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.SERVICE_REQUEST].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.SERVICE_REQUEST].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.SERVICE_REQUEST].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).serviceRequestsLearnMore
    },
    [(0, $oCMSG.INCIDENTS)]: {
        headerMessage: (0, $gIziC.default).incidentsHeader,
        descriptionMessage: (0, $gIziC.default).incidentsDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.INCIDENTS].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.INCIDENTS].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.INCIDENTS].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).incidentsLearnMore
    },
    [(0, $oCMSG.PROBLEMS)]: {
        headerMessage: (0, $gIziC.default).problemsHeader,
        descriptionMessage: (0, $gIziC.default).problemsDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.PROBLEMS].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.PROBLEMS].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.PROBLEMS].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).problemsLearnMore
    },
    [(0, $oCMSG.CHANGES)]: {
        headerMessage: (0, $gIziC.default).changesHeader,
        descriptionMessage: (0, $gIziC.default).changesDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.CHANGES].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.CHANGES].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.CHANGES].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).changesLearnMore
    },
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $gIziC.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $gIziC.default).postIncidentReviewsDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.POST_INCIDENT_REVIEWS].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.POST_INCIDENT_REVIEWS].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.POST_INCIDENT_REVIEWS].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).postIncidentReviewsLearnMore
    },
    // NO_CATEGORY will never be a valid case in case of unconfigured queue, need to do this to keep Flow happy
    [(0, $oCMSG.NO_CATEGORY)]: {
        ...(0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.NO_CATEGORY],
        learnMoreText: undefined
    }
};

});
parcelRegister("3rkzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2180d7ecbc52c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9d2180d7ecbc52c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    serviceRequestsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.service-requests-learn-more",
        "defaultMessage": "Learn more about service requests"
    },
    incidentsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.incidents-learn-more",
        "defaultMessage": "Learn more about incident management"
    },
    problemsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.problems-learn-more",
        "defaultMessage": "Learn more about problem management"
    },
    changesLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.changes-learn-more",
        "defaultMessage": "Learn more about change management"
    },
    postIncidentReviewsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.post-incident-reviews-learn-more",
        "defaultMessage": "Learn more about post-incident reviews"
    }
});

});

parcelRegister("gIziC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f725cb4c32fac1bc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f725cb4c32fac1bc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.service-requests-header",
        "defaultMessage": "Get started with service requests"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.service-requests-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the service requests category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.incidents-header",
        "defaultMessage": "Get started with incident management"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.incidents-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the incidents category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.problems-header",
        "defaultMessage": "Get started with problem management"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.problems-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the problems category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.changes-header",
        "defaultMessage": "Get started with change management"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.changes-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the changes category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.post-incident-reviews-header",
        "defaultMessage": "Get started with post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.post-incident-reviews-description",
        "defaultMessage": "<p>To start using your new queue, create a new request type, or assign an existing request type to the post-incident review category. <a></a>.</p>"
    },
    addRequestTypeButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.add-request-type-button-text",
        "defaultMessage": "Add request types"
    }
});

});



parcelRegister("ks0ka", function(module, exports) {

$parcel$export(module.exports, "EmptyQueueAgentView", () => $fc101c185d440950$export$c7fde069a1782c75);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hTEpF = parcelRequire("hTEpF");

var $hxoiH = parcelRequire("hxoiH");

var $koVbs = parcelRequire("koVbs");

var $1ilU2 = parcelRequire("1ilU2");

var $bmKPg = parcelRequire("bmKPg");


var $3IoJm = parcelRequire("3IoJm");
const $fc101c185d440950$export$c7fde069a1782c75 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [practice] = (0, $bmKPg.usePathParam)('practiceType');
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // practice should always be set in case of an unconfigured queue, if not this is a wrong route
    if (practice === undefined) return null;
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, getImageUrl: getImageUrl, learnMoreText: learnMoreText, learnMoreUrl: learnMoreUrl } = (0, $3IoJm.EMPTY_STATE_DATA)[(0, $1ilU2.toItsmPractice)(practice)];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage(headerMessage),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc101c185d440950$var$Description, null, formatMessage(descriptionMessage)),
        imageUrl: getImageUrl(colorMode),
        primaryAction: learnMoreText && learnMoreUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc101c185d440950$var$LearnMoreLink, {
            target: "_blank",
            href: learnMoreUrl
        }, formatMessage(learnMoreText)),
        maxImageWidth: (0, $7ce02bc2e6cada96$export$caaf33f9dba14d10),
        maxImageHeight: (0, $7ce02bc2e6cada96$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.empty-queue-agent-view"
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fc101c185d440950$var$LearnMoreLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _otyrgx6n _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $fc101c185d440950$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf _y3gn1e5h _1bsb189v",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3IoJm", function(module, exports) {

$parcel$export(module.exports, "EMPTY_STATE_DATA", () => $be5418638c5cfb32$export$cfb3b7ce372d6279);

var $oCMSG = parcelRequire("oCMSG");

var $2VsSH = parcelRequire("2VsSH");

var $3rkzd = parcelRequire("3rkzd");

var $6RhAq = parcelRequire("6RhAq");
const $be5418638c5cfb32$export$cfb3b7ce372d6279 = {
    [(0, $oCMSG.SERVICE_REQUEST)]: {
        headerMessage: (0, $6RhAq.default).serviceRequestsHeader,
        descriptionMessage: (0, $6RhAq.default).serviceRequestsDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.SERVICE_REQUEST].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.SERVICE_REQUEST].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.SERVICE_REQUEST].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).serviceRequestsLearnMore
    },
    [(0, $oCMSG.INCIDENTS)]: {
        headerMessage: (0, $6RhAq.default).incidentsHeader,
        descriptionMessage: (0, $6RhAq.default).incidentsDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.INCIDENTS].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.INCIDENTS].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.INCIDENTS].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).incidentsLearnMore
    },
    [(0, $oCMSG.PROBLEMS)]: {
        headerMessage: (0, $6RhAq.default).problemsHeader,
        descriptionMessage: (0, $6RhAq.default).problemsDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.PROBLEMS].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.PROBLEMS].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.PROBLEMS].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).problemsLearnMore
    },
    [(0, $oCMSG.CHANGES)]: {
        headerMessage: (0, $6RhAq.default).changesHeader,
        descriptionMessage: (0, $6RhAq.default).changesDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.CHANGES].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.CHANGES].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.CHANGES].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).changesLearnMore
    },
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $6RhAq.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $6RhAq.default).postIncidentReviewsDescription,
        imageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.POST_INCIDENT_REVIEWS].imageUrl,
        getImageUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.POST_INCIDENT_REVIEWS].getImageUrl,
        learnMoreUrl: (0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.POST_INCIDENT_REVIEWS].learnMoreUrl,
        learnMoreText: (0, $3rkzd.default).postIncidentReviewsLearnMore
    },
    // NO_CATEGORY will never be a valid case in case of unconfigured queue, need to do this to keep Flow happy
    [(0, $oCMSG.NO_CATEGORY)]: {
        ...(0, $2VsSH.PRACTICE_DATA)[0, $oCMSG.NO_CATEGORY],
        learnMoreText: undefined
    }
};

});
parcelRegister("6RhAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $20dec2ea6004bc88$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $20dec2ea6004bc88$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.service-requests-header",
        "defaultMessage": "Welcome to your new service requests queue"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.service-requests-description",
        "defaultMessage": "Your admin is setting up a service request management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the service requests category. Contact your admin for more information."
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.incidents-header",
        "defaultMessage": "Welcome to your new incidents queue"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.incidents-description",
        "defaultMessage": "Your admin is setting up an incident management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the incidents category. Contact your admin for more information."
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.problems-header",
        "defaultMessage": "Welcome to your new problems queue"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.problems-description",
        "defaultMessage": "Your admin is setting up a problem management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the problems category. Contact your admin for more information."
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.changes-header",
        "defaultMessage": "Welcome to your new changes queue"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.changes-description",
        "defaultMessage": "Your admin is setting up a change management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the changes category. Contact your admin for more information."
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.post-incident-reviews-header",
        "defaultMessage": "Get started with post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.post-incident-reviews-description",
        "defaultMessage": "Your admin is setting up a post-incident review queue to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the post-incident review category. Contact your admin for more information."
    }
});

});





parcelRegister("lq0lY", function(module, exports) {

$parcel$export(module.exports, "default", () => $82a408ef2748e70d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82a408ef2748e70d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyQueueHeader: {
        "id": "servicedesk-queues-empty-queue.empty-queue-header",
        "defaultMessage": "Your queue is empty"
    },
    emptyQueueDescription: {
        "id": "servicedesk-queues-empty-queue.empty-queue-description",
        "defaultMessage": "<p>Incoming requests from multiple channels are filtered and displayed in your queues as issues, ready to be triaged and assigned. {break} {IPHArticle} </p>"
    },
    emptyQueueButtonLabel: {
        "id": "servicedesk-queues-empty-queue.empty-queue-button-label",
        "defaultMessage": "Create an issue"
    },
    emptyQueueLearnMoreText: {
        "id": "servicedesk-queues-empty-queue.empty-queue-learn-more-text",
        "defaultMessage": "Learn more about queues"
    },
    emptyQueueDescriptionIssueTermRefresh: {
        "id": "servicedesk-queues-empty-queue.empty-queue-description-issue-term-refresh",
        "defaultMessage": "<p>Incoming requests from multiple channels are filtered and displayed in your queues as work items, ready to be triaged and assigned. {break} {IPHArticle} </p>"
    },
    emptyQueueButtonLabelIssueTermRefresh: {
        "id": "servicedesk-queues-empty-queue.empty-queue-button-label-issue-term-refresh",
        "defaultMessage": "Create a work item"
    }
});

});


parcelRegister("f1uep", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb7627cc8ab2350$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $fy6YG = parcelRequire("fy6YG");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");

var $aXrZ5 = parcelRequire("aXrZ5");
const $4cb7627cc8ab2350$var$mapStateToProps = (state)=>({
        queueOrder: (0, $627A7.getCurrentQueueOrder)(state),
        isQueueVisible: (0, $jeVA9.isQueueVisible)(state),
        isLoadingIssues: (0, $jeVA9.isLoadingIssues)(state),
        projectId: (0, $fy6YG.getProjectId)(state),
        baseUrl: (0, $fy6YG.getBaseUrl)(state)
    });
var $4cb7627cc8ab2350$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($4cb7627cc8ab2350$var$mapStateToProps, {})((0, $aXrZ5.default));

});
parcelRegister("aXrZ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90e65d1e5274927$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $eub8C = parcelRequire("eub8C");
class $a90e65d1e5274927$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    shouldDripFeed() {
        const { queueOrder: queueOrder, isQueueVisible: isQueueVisible, isLoadingIssues: isLoadingIssues } = this.props;
        // Ideally, we would like to drip-feed further issues only on the "All Open" queue of a demo project.
        // However, there is no reliable way to figure out the exact queue we are on. Thus, we rely on the initial
        // ordering of the queues. We accept the risk of users missing the drip-feed altogether when they re-order
        // their queues. The DemoProjectDripFeed component itself will check if we are actually on a demo project.
        // Also make sure that queues page is visible.
        if (queueOrder !== 0 || !isQueueVisible || isLoadingIssues) return false;
        return true;
    }
    render() {
        return this.shouldDripFeed() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eub8C.DemoProjectDripFeed), {
            baseUrl: this.props.baseUrl,
            projectId: this.props.projectId
        }) : null;
    }
}

});
parcelRegister("eub8C", function(module, exports) {

$parcel$export(module.exports, "DemoProjectDripFeed", () => $c7d8698ea4ebaa48$export$3fb4ae8058b3efa3);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g4ge5 = parcelRequire("g4ge5");

var $7HThi = parcelRequire("7HThi");

var $648j5 = parcelRequire("648j5");
const $c7d8698ea4ebaa48$export$3fb4ae8058b3efa3 = ({ baseUrl: baseUrl, projectId: projectId })=>{
    const { data: isDemoProject } = (0, $g4ge5.useIsDemoProject)();
    const { data: isItsmSampleProject } = (0, $7HThi.useIsItsmSampleProject)();
    const [isRequestCreated, setIsRequestCreated] = (0, $5uXOq.useState)(false);
    const shouldCreateRequest = // Allow request creation for demo and non ITSM sample project
    !isRequestCreated && isDemoProject === true && isItsmSampleProject === false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldCreateRequest) {
            setIsRequestCreated(true);
            (0, $648j5.default)({
                baseUrl: baseUrl,
                projectId: projectId,
                analyticsEvent: createAnalyticsEvent({})
            });
        }
    }, [
        shouldCreateRequest,
        setIsRequestCreated,
        baseUrl,
        projectId,
        createAnalyticsEvent
    ]);
    return null;
};

});
parcelRegister("648j5", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ad326af712ef1b$export$2e2bcd8739ae039);

var $23ls2 = parcelRequire("23ls2");

var $3Xh18 = parcelRequire("3Xh18");

var $jzpUT = parcelRequire("jzpUT");
const $39ad326af712ef1b$var$service = async ({ baseUrl: baseUrl, projectId: projectId, analyticsEvent: analyticsEvent })=>{
    const createdAliases = await (0, $3Xh18.default)({
        baseUrl: baseUrl,
        projectId: projectId
    });
    const requestAlias = (0, $jzpUT.default)({
        createdAliases: createdAliases
    });
    if (!requestAlias) return;
    await (0, $23ls2.default)({
        baseUrl: baseUrl,
        projectId: projectId,
        requestAlias: requestAlias,
        analyticsEvent: analyticsEvent
    });
};
var $39ad326af712ef1b$export$2e2bcd8739ae039 = $39ad326af712ef1b$var$service;

});
parcelRegister("23ls2", function(module, exports) {

$parcel$export(module.exports, "default", () => $701cd4078397ec68$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $782Cm = parcelRequire("782Cm");

var $hgb7r = parcelRequire("hgb7r");
const $701cd4078397ec68$var$service = async ({ baseUrl: baseUrl, projectId: projectId, requestAlias: requestAlias, analyticsEvent: analyticsEvent })=>{
    try {
        await (0, $hgb7r.post)(baseUrl, projectId, requestAlias);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        !(0, $fZneA.isClientFetchError)(error) && (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'createRequest',
                packageName: (0, $782Cm.PACKAGE_NAME),
                teamName: 'jsm-getting-started'
            },
            attributes: {
                demoDripFeedRequestAlias: requestAlias
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return false;
    }
    analyticsEvent && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${(0, $782Cm.PACKAGE_NAME)} requestCreated`, {
        demoDripFeedRequestAlias: requestAlias
    });
    return true;
};
var $701cd4078397ec68$export$2e2bcd8739ae039 = $701cd4078397ec68$var$service;

});
parcelRegister("782Cm", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $722e9f696fcce1a5$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "CREATED_DEMO_REQUESTS_PROPERTY_KEY", () => $722e9f696fcce1a5$export$e5714b96e7139e44);
$parcel$export(module.exports, "REQUEST_CREATION_ORDER", () => $722e9f696fcce1a5$export$b3140adec43d0709);
const $722e9f696fcce1a5$export$b8b9d90f9e5bd72b = 'jiraServicedeskQueuesDemoProjectDripFeed';
const $722e9f696fcce1a5$export$e5714b96e7139e44 = 'jsd.demo-project.created-demo-requests';
const $722e9f696fcce1a5$export$c2fc572f1ae12c8 = {
    triageRequests: 'TRIAGE_REQUESTS',
    highPriority: 'HIGH_PRIORITY',
    trackPerformance: 'TRACK_PERFORMANCE'
};
const $722e9f696fcce1a5$export$b3140adec43d0709 = [
    $722e9f696fcce1a5$export$c2fc572f1ae12c8.triageRequests,
    $722e9f696fcce1a5$export$c2fc572f1ae12c8.highPriority,
    $722e9f696fcce1a5$export$c2fc572f1ae12c8.trackPerformance
];

});

parcelRegister("hgb7r", function(module, exports) {

$parcel$export(module.exports, "post", () => $ccb1a76a73593cca$export$299ba2dee77727e9);

var $eusud = parcelRequire("eusud");
const $ccb1a76a73593cca$var$constructEndpoint = (baseUrl, projectId, requestAlias)=>`${baseUrl}/rest/servicedesk/onboarding/1/create-demo-requests/${projectId}/${requestAlias}`;
const $ccb1a76a73593cca$export$299ba2dee77727e9 = (baseUrl, projectId, requestAlias)=>{
    const url = $ccb1a76a73593cca$var$constructEndpoint(baseUrl, projectId, requestAlias);
    return (0, $eusud.performPostRequest)(url);
};

});


parcelRegister("3Xh18", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c30f037aab61b90$export$2e2bcd8739ae039);

var $782Cm = parcelRequire("782Cm");

var $8JmiV = parcelRequire("8JmiV");
const $4c30f037aab61b90$var$service = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        const response = await (0, $8JmiV.get)(baseUrl, projectId, (0, $782Cm.CREATED_DEMO_REQUESTS_PROPERTY_KEY));
        return response.value || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return [];
    }
};
var $4c30f037aab61b90$export$2e2bcd8739ae039 = $4c30f037aab61b90$var$service;

});
parcelRegister("8JmiV", function(module, exports) {

$parcel$export(module.exports, "get", () => $870bcd52abc77d02$export$3988ae62b71be9a3);

var $eusud = parcelRequire("eusud");
const $870bcd52abc77d02$export$a5b7a8c3b1c6e775 = (baseUrl, projectId, propertyKey)=>`${baseUrl}/rest/api/3/project/${projectId}/properties/${propertyKey}`;
const $870bcd52abc77d02$export$3988ae62b71be9a3 = (baseUrl, projectId, propertyKey)=>{
    const url = $870bcd52abc77d02$export$a5b7a8c3b1c6e775(baseUrl, projectId, propertyKey);
    return (0, $eusud.performGetRequest)(url);
};

});


parcelRegister("jzpUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f8ceca270c2936$export$2e2bcd8739ae039);

var $74ySO = parcelRequire("74ySO");

var $782Cm = parcelRequire("782Cm");
const $d5f8ceca270c2936$var$service = ({ createdAliases: createdAliases })=>(0, $782Cm.REQUEST_CREATION_ORDER).find((issueAlias)=>!(0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(createdAliases, issueAlias));
var $d5f8ceca270c2936$export$2e2bcd8739ae039 = $d5f8ceca270c2936$var$service;

});





parcelRegister("iK66R", function(module, exports) {

$parcel$export(module.exports, "getEmptyStateMessage", () => $986b8eb185ee47c9$export$383ed4a3403ea4fc);

var $gJBT6 = parcelRequire("gJBT6");

var $627A7 = parcelRequire("627A7");

var $26dXT = parcelRequire("26dXT");
const $986b8eb185ee47c9$export$6d2dfff2bbcb7a21 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(()=>{
    const randomNumber = Math.floor(Math.random() * Math.floor(4));
    switch(randomNumber){
        case 0:
            return {
                header: (0, $26dXT.default).emptyQueueHeaderOne,
                description: (0, $26dXT.default).emptyQueueDescriptionOne
            };
        case 1:
            return {
                header: (0, $26dXT.default).emptyQueueHeaderTwo,
                description: (0, $26dXT.default).emptyQueueDescriptionTwo
            };
        case 2:
            return {
                header: (0, $26dXT.default).emptyQueueHeaderThree,
                description: (0, $26dXT.default).emptyQueueDescriptionThree
            };
        default:
            return {
                header: (0, $26dXT.default).emptyQueueHeaderFour,
                description: (0, $26dXT.default).emptyQueueDescriptionFour
            };
    }
});
const $986b8eb185ee47c9$export$383ed4a3403ea4fc = (state)=>// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
    $986b8eb185ee47c9$export$6d2dfff2bbcb7a21((0, $627A7.getQueueId)(state));

});
parcelRegister("26dXT", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e2e31e35ddfd4a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31e2e31e35ddfd4a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyQueueHeaderOne: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-one",
        "defaultMessage": "Your queue is empty but what is empty?"
    },
    emptyQueueDescriptionOne: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-one",
        "defaultMessage": "Time to ponder the mysteries of the Universe."
    },
    emptyQueueHeaderTwo: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-two",
        "defaultMessage": "You\u2019ve cleaned up here perfectly!"
    },
    emptyQueueDescriptionTwo: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-two",
        "defaultMessage": "The only thing left to clean is your computer screen."
    },
    emptyQueueHeaderThree: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-three",
        "defaultMessage": "Queue\u2019s empty! Dance party!"
    },
    emptyQueueDescriptionThree: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-three",
        "defaultMessage": "Congratulate yourself on a job well done!"
    },
    emptyQueueHeaderFour: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-four",
        "defaultMessage": "Your queue is empty."
    },
    emptyQueueDescriptionFour: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-four",
        "defaultMessage": "Cupcakes for all!"
    }
});

});


parcelRegister("7gAy1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa637690852dd00$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $iXVV6 = parcelRequire("iXVV6");

var $3TpKp = parcelRequire("3TpKp");

var $hiKo9 = parcelRequire("hiKo9");

var $3HGy4 = parcelRequire("3HGy4");

var $dZw8H = parcelRequire("dZw8H");

var $cPF3j = parcelRequire("cPF3j");
function $7fa637690852dd00$export$fdbb6e83492670a7({ intl: { formatMessage: formatMessage }, projectId: projectId, isQueueVisible: isQueueVisible, queueId: queueId, EmptyQueueComponent: EmptyQueueComponent, DemoDripFeed: DemoDripFeed, emptyStateMessage: { header: header, description: description }, metricKey: metricKey, category: category }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReadyOnUpdate), {
        comparer: [
            queueId
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "emptyQueue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EmptyQueueComponent, {
        projectId: projectId,
        header: formatMessage(header),
        description: formatMessage(description),
        category: category
    })), isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TpKp.JsmPageInteractiveEvent), {
        key: (0, $3HGy4.fromQueueIdString)(queueId),
        metricKey: metricKey,
        withMarks: (0, $hiKo9.getAgentViewMarks)(),
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: (0, $cPF3j.serviceViewPageLoad),
        extra: {
            category: category || 'no-category',
            empty: true
        }
    }), DemoDripFeed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DemoDripFeed, null) : null);
}
var $7fa637690852dd00$export$2e2bcd8739ae039 = (0, $8RXs9.default)($7fa637690852dd00$export$fdbb6e83492670a7);

});
parcelRegister("3TpKp", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $bbb7386cf97044f2$export$c4ba40c380ee9a11);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");
const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), args);
$bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("hiKo9", function(module, exports) {

$parcel$export(module.exports, "getAgentViewMarks", () => $449f14431a76ad6a$export$551d840952c7afcf);

var $9XE6b = parcelRequire("9XE6b");

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $hXKq5 = parcelRequire("hXKq5");
const $449f14431a76ad6a$var$PREFIX = 'servicedesk.queues';
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $449f14431a76ad6a$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $449f14431a76ad6a$var$triggerAnalyticsFunction = $449f14431a76ad6a$var$triggerAnalyticsEvent($449f14431a76ad6a$var$PREFIX);
var /**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$449f14431a76ad6a$export$2e2bcd8739ae039 = (eventNameSuffix, data)=>{
    $449f14431a76ad6a$var$triggerAnalyticsFunction(eventNameSuffix, data);
};
const $449f14431a76ad6a$var$getName = (mark)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(mark, 'name', undefined);
const $449f14431a76ad6a$export$551d840952c7afcf = ()=>[
        (0, $8PRuf.appBundleReadyMark),
        (0, $8PRuf.prefetchApiReadyMark),
        $449f14431a76ad6a$var$getName((0, $x9xyg.getMark)('jsd.performance.profile.queues.issuetable.mount')),
        $449f14431a76ad6a$var$getName((0, $x9xyg.getMark)('jsd.performance.profile.queues.firstfield.render')),
        $449f14431a76ad6a$var$getName((0, $x9xyg.getMark)('jsd.performance.profile.queues.issues.loaded')),
        $449f14431a76ad6a$var$getName((0, $x9xyg.getMark)('jsd.performance.profile.queues.localstorage.received'))
    ].filter(Boolean).map((0, $hXKq5.getPrefixedMarkName));

});

parcelRegister("cPF3j", function(module, exports) {

$parcel$export(module.exports, "serviceViewPageLoad", () => $aee05aef68964186$export$61008c925a90a363);

var $dGrdR = parcelRequire("dGrdR");
const $aee05aef68964186$export$61008c925a90a363 = (0, $dGrdR.metrics).pageLoad({
    key: 'service-management.queues.view'
});

});



parcelRegister("jHJR0", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e136b5ffdcdc53$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $jeVA9 = parcelRequire("jeVA9");

var $4GNG7 = parcelRequire("4GNG7");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $66e136b5ffdcdc53$var$reloadWindow = ()=>window.location.reload();
const $66e136b5ffdcdc53$var$mapStateToProps = (state)=>({
        isLoading: (0, $jeVA9.isRetrying)(state)
    });
const $66e136b5ffdcdc53$var$mapDispatchToProps = ()=>({
        onRetry: $66e136b5ffdcdc53$var$reloadWindow
    });
var $66e136b5ffdcdc53$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($66e136b5ffdcdc53$var$mapStateToProps, $66e136b5ffdcdc53$var$mapDispatchToProps)((0, $4GNG7.default));

});
parcelRegister("4GNG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $211aeac8ff322933$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eae50 = parcelRequire("eae50");

var $koVbs = parcelRequire("koVbs");

var $8GQ1N = parcelRequire("8GQ1N");
function $211aeac8ff322933$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        isLoading: isLoading,
        onRetry: onRetry,
        header: formatMessage((0, $8GQ1N.default).errorHeader),
        description: formatMessage((0, $8GQ1N.default).errorMessage)
    });
}
$211aeac8ff322933$var$Error.defaultProps = {
    isLoading: false
};
var $211aeac8ff322933$export$2e2bcd8739ae039 = $211aeac8ff322933$var$Error;

});
parcelRegister("8GQ1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $2164c98ccc4807dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2164c98ccc4807dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.error-state.error-header",
        "defaultMessage": "We couldn't load your queue"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.error-state.error-message",
        "defaultMessage": "Give it a few seconds, then try again."
    },
    reload: {
        "id": "servicedesk.queues.agent-view.layout.error-state.reload",
        "defaultMessage": "Reload"
    }
});

});



parcelRegister("dHKfC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b454a6023cdc5474$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $4uvJ3 = parcelRequire("4uvJ3");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");

var $5RwzW = parcelRequire("5RwzW");

var $eA5yC = parcelRequire("eA5yC");

var $1uZTI = parcelRequire("1uZTI");

var $d0ovW = parcelRequire("d0ovW");
const $b454a6023cdc5474$var$mapStateToProps = (state)=>({
        Actions: $5RwzW.default,
        IssueCount: $1uZTI.default,
        IssueSearch: $eA5yC.default,
        queueName: (0, $627A7.getQueueName)(state),
        isQueuesErrorHeaderDisplayed: (0, $jeVA9.isQueuesErrorHeaderDisplayed)(state)
    });
const $b454a6023cdc5474$var$mapDispatchToProps = {
    renderDisplayError: (0, $4uvJ3.displayQueuesErrorHeaderAction)
};
var $b454a6023cdc5474$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($b454a6023cdc5474$var$mapStateToProps, $b454a6023cdc5474$var$mapDispatchToProps)((0, $d0ovW.default));

});
parcelRegister("5RwzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $924e218df9374fdd$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $627A7 = parcelRequire("627A7");

var $h4yk3 = parcelRequire("h4yk3");

var $jeVA9 = parcelRequire("jeVA9");

var $81UCW = parcelRequire("81UCW");

var $1C7B1 = parcelRequire("1C7B1");

var $1Jfwr = parcelRequire("1Jfwr");

var $dKjrt = parcelRequire("dKjrt");

var $icta3 = parcelRequire("icta3");
const $924e218df9374fdd$var$mapStateToProps = (state)=>({
        ActionsMenu: $81UCW.default,
        ResetSortingButton: $dKjrt.default,
        FavoriteButton: $1C7B1.default,
        OpenInIssueNavButton: $1Jfwr.default,
        canManageQueue: (0, $627A7.canManageQueue)(state),
        isManuallySorted: (0, $h4yk3.isManuallySorted)(state),
        isFavoriteEnabled: !(0, $627A7.isQueueTransient)(state),
        showIssueFailureError: (0, $jeVA9.showIssueFailureError)(state)
    });
var $924e218df9374fdd$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($924e218df9374fdd$var$mapStateToProps, {})((0, $icta3.default));

});
parcelRegister("81UCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b80151d66bcbb38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b80151d66bcbb38$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("gYUew")), {
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/header/actions/async-actions-menu/actions-menu/index.tsx"
});
const $5b80151d66bcbb38$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "queues-agent-view-actions-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b80151d66bcbb38$var$LoadingComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b80151d66bcbb38$var$LazyComponent, props));
var $5b80151d66bcbb38$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5b80151d66bcbb38$var$Component;
const $5b80151d66bcbb38$var$LoadingComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb14no _4t3i1tcg _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gYUew", function(module, exports) {

let $c5cddeb2c5163468$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c5cddeb2c5163468$var$load("2nkw1").then(()=>parcelRequire('5NaIv'));

});


parcelRegister("1C7B1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fde75c23c6475ce$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8lxl7 = parcelRequire("8lxl7");

var $bC2fB = parcelRequire("bC2fB");

var $jazcX = parcelRequire("jazcX");

var $627A7 = parcelRequire("627A7");

var $4ZuVx = parcelRequire("4ZuVx");
const $1fde75c23c6475ce$var$mapStateToProps = (state)=>({
        isFavorite: (0, $jazcX.isQueueFavorited)(state),
        queueId: (0, $627A7.getQueueId)(state)
    });
var $1fde75c23c6475ce$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8lxl7.default)((state)=>({
        attributes: {
            queueId: (0, $627A7.getQueueId)(state),
            isFavorite: !(0, $jazcX.isQueueFavorited)(state)
        }
    })), (0, $bC2fB.connect)($1fde75c23c6475ce$var$mapStateToProps, {}))(// @ts-expect-error - Argument of type '({ isFavorite, queueId }: Props) => JSX.Element' is not assignable to parameter of type 'ComponentType<unknown>'.
(0, $4ZuVx.default));

});
parcelRegister("8lxl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3768e8b105140d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $daJ0i = parcelRequire("daJ0i");

var $bC2fB = parcelRequire("bC2fB");

var $cAj1I = parcelRequire("cAj1I");

var $i4iBk = parcelRequire("i4iBk");
const $d3768e8b105140d5$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $5uXOq.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $8QpSo.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $i4iBk.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $bC2fB.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $cAj1I.default)(prevAttributes, nextAttributes) && (0, $cAj1I.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $d3768e8b105140d5$export$2e2bcd8739ae039 = $d3768e8b105140d5$var$ReduxAnalyticsData;

});
parcelRegister("cAj1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d580e76a13b783$export$2e2bcd8739ae039);
const $95d580e76a13b783$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d580e76a13b783$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$95d580e76a13b783$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $95d580e76a13b783$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


parcelRegister("jazcX", function(module, exports) {

$parcel$export(module.exports, "isQueueFavorited", () => $794e76ebc9543663$export$a8538c0c3c892848);

var $jeVA9 = parcelRequire("jeVA9");
const $794e76ebc9543663$export$a8538c0c3c892848 = (state)=>{
    const queue = (0, $jeVA9.getCurrentQueue)(state);
    return queue ? queue.isFavorite : false;
};

});

parcelRegister("4ZuVx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4db9625d323727b$export$2e2bcd8739ae039);
/* eslint-disable jira/react-no-inline-function-prop */ 
var $5uXOq = parcelRequire("5uXOq");

var $hcObS = parcelRequire("hcObS");

var $eXQym = parcelRequire("eXQym");

var $4041n = parcelRequire("4041n");

var $53AcJ = parcelRequire("53AcJ");

var $3HGy4 = parcelRequire("3HGy4");
const $c4db9625d323727b$var$FavoriteButton = ({ isFavorite: isFavorite, queueId: queueId })=>{
    const { changeFavorite: changeFavorite, items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const getIsPending = ()=>{
        const queueItemChanges = items[0, $eXQym.QUEUES_ITEM_TYPE];
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const itemChanged = queueItemChanges[(0, $3HGy4.fromQueueIdString)(queueId)];
        return itemChanged ? itemChanged.pending : false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53AcJ.AvailableQueuesConsumer), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
            isFavorite: isFavorite,
            pending: getIsPending(),
            onClick: (analyticsEvent)=>{
                changeFavorite({
                    id: (0, $3HGy4.fromQueueIdString)(queueId),
                    value: !isFavorite,
                    type: (0, $eXQym.QUEUES_ITEM_TYPE)
                }, analyticsEvent);
            }
        }));
};
var $c4db9625d323727b$export$2e2bcd8739ae039 = $c4db9625d323727b$var$FavoriteButton;

});


parcelRegister("1Jfwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf97986e61923d7a$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $fy6YG = parcelRequire("fy6YG");

var $627A7 = parcelRequire("627A7");

var $kdjEW = parcelRequire("kdjEW");
const $bf97986e61923d7a$var$mapStateToProps = (state)=>({
        projectKey: (0, $fy6YG.getProjectKey)(state),
        queueJql: (0, $627A7.getCompleteJql)(state)
    });
var $bf97986e61923d7a$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($bf97986e61923d7a$var$mapStateToProps, {})((0, $kdjEW.OpenInIssueNavButton));

});
parcelRegister("kdjEW", function(module, exports) {

$parcel$export(module.exports, "OpenInIssueNavButton", () => $58cd5432ca2dbdd5$export$72e8ee1dd9380293);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7paD5 = parcelRequire("7paD5");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $glSfI = parcelRequire("glSfI");

var $4R6GH = parcelRequire("4R6GH");
const $58cd5432ca2dbdd5$var$getIssueNavUrl = (projectKey, queueJql)=>projectKey ? `/jira/servicedesk/projects/${projectKey}/issues/?jql=${encodeURIComponent(queueJql)}` : `/issues/?jql=${encodeURIComponent(queueJql)}`;
const $58cd5432ca2dbdd5$export$72e8ee1dd9380293 = (_props)=>{
    const { projectKey: projectKey, queueJql: queueJql } = _props;
    const issueNavUrl = $58cd5432ca2dbdd5$var$getIssueNavUrl(projectKey, queueJql);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigateToIssueNavFromQueues', {
            hasProjectKey: typeof projectKey === 'string'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $glSfI.default).openWithIssueNavIssueTermRefresh : (0, $glSfI.default).openWithIssueNav)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "servicedesk-queues-agent-view.layout.header.actions.open-in-issue-nav-button.open-in-issue-nav-button",
        href: issueNavUrl,
        target: "_blank",
        onClick: onClick,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        appearance: "subtle"
    }));
};

});
parcelRegister("glSfI", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd07e65a4727891$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $abd07e65a4727891$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deleteQueue: {
        "id": "servicedesk.queues.common.delete-queue",
        "defaultMessage": "Delete queue"
    },
    resetSorting: {
        "id": "servicedesk.queues.common.reset-sorting",
        "defaultMessage": "Reset sorting"
    },
    openWithIssueNav: {
        "id": "servicedesk.queues.common.open-with-issue-nav",
        "defaultMessage": "Open in issue navigator"
    },
    openWithIssueNavIssueTermRefresh: {
        "id": "servicedesk.queues.common.open-with-issue-nav-issue-term-refresh",
        "defaultMessage": "Go to filter view"
    }
});

});



parcelRegister("dKjrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $89f8dca1dd169100$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8lxl7 = parcelRequire("8lxl7");

var $iQv12 = parcelRequire("iQv12");

var $bC2fB = parcelRequire("bC2fB");

var $jdGLR = parcelRequire("jdGLR");

var $h4yk3 = parcelRequire("h4yk3");

var $jq4T2 = parcelRequire("jq4T2");
var $89f8dca1dd169100$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onResetSorting: 'resetSorting'
}), (0, $8lxl7.default)((state)=>({
        attributes: {
            fieldId: (0, $h4yk3.getSortedByColumn)(state),
            sortOrder: (0, $h4yk3.getSortOrder)(state)
        }
    })), (0, $bC2fB.connect)(null, {
    onResetSorting: (0, $jdGLR.resetSortOrderAction)
}))((0, $jq4T2.default));

});
parcelRegister("jq4T2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f004df59f05091$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $8RXs9 = parcelRequire("8RXs9");

var $glSfI = parcelRequire("glSfI");
function $a3f004df59f05091$export$ce3eb8345b6d11e3(props) {
    const { intl: { formatMessage: formatMessage }, onResetSorting: onResetSorting } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onResetSorting
    }, formatMessage((0, $glSfI.default).resetSorting));
}
var $a3f004df59f05091$export$2e2bcd8739ae039 = (0, $8RXs9.default)($a3f004df59f05091$export$ce3eb8345b6d11e3);

});


parcelRegister("icta3", function(module, exports) {

$parcel$export(module.exports, "default", () => $674d345d3f34ebff$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2FOni = parcelRequire("2FOni");
function $674d345d3f34ebff$export$2e2bcd8739ae039({ canManageQueue: canManageQueue, isManuallySorted: isManuallySorted, isFavoriteEnabled: isFavoriteEnabled, onDeleteComplete: onDeleteComplete, showIssueFailureError: showIssueFailureError, ActionsMenu: ActionsMenu, FavoriteButton: FavoriteButton, ResetSortingButton: ResetSortingButton, OpenInIssueNavButton: OpenInIssueNavButton }) {
    const shouldShowResetSortingButton = !showIssueFailureError && !canManageQueue && isManuallySorted;
    const hasMultipleActions = isFavoriteEnabled && (canManageQueue || shouldShowResetSortingButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($674d345d3f34ebff$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FOni.AsyncQueuesAutomationMenu), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OpenInIssueNavButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($674d345d3f34ebff$var$Spacer, null)), isFavoriteEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteButton, null), hasMultipleActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($674d345d3f34ebff$var$Spacer, null), canManageQueue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ActionsMenu, {
        onDeleteComplete: onDeleteComplete
    }), shouldShowResetSortingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResetSortingButton, null));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $674d345d3f34ebff$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $674d345d3f34ebff$var$Spacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbftgi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2FOni", function(module, exports) {

$parcel$export(module.exports, "AsyncQueuesAutomationMenu", () => $c43706cf5fd7e0a6$export$a6b9948799694c4f);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $iBNo2 = parcelRequire("iBNo2");
const $c43706cf5fd7e0a6$var$runtimeProps = {};
const $c43706cf5fd7e0a6$var$entryPointParams = {};
const $c43706cf5fd7e0a6$export$a6b9948799694c4f = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $iBNo2.queuesAutomationMenuEntryPoint), $c43706cf5fd7e0a6$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jsm.queues.automation.menu",
        packageName: (0, $72ef5d9b7fb63da0$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $c43706cf5fd7e0a6$var$runtimeProps,
        errorFallback: "flag"
    });
};

});
const $72ef5d9b7fb63da0$export$b8b9d90f9e5bd72b = 'jiraServicedeskQueuesAutomationMenu';
const $72ef5d9b7fb63da0$export$d57b6b390e78d90f = 'jsd-shield';

parcelRegister("iBNo2", function(module, exports) {

$parcel$export(module.exports, "queuesAutomationMenuEntryPoint", () => $4b0e6b387da4e463$export$3165d8c5913e99eb);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4b0e6b387da4e463$export$3165d8c5913e99eb = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cT1SP")), {
        moduleId: "2f0e15f7"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cT1SP", function(module, exports) {

let $961c150e88ff4fc1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $961c150e88ff4fc1$var$load("h2MrD"),
    $961c150e88ff4fc1$var$load("bYT2S"),
    $961c150e88ff4fc1$var$load("LLN5o")
]).then(()=>parcelRequire('7Uyre'));

});





parcelRegister("eA5yC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afdfe770c0f43bb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $6E8HE = parcelRequire("6E8HE");

const $0afdfe770c0f43bb$var$LazyComponent = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dQ2uI")), {
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/header/async-issue-search/issue-search/index.tsx"
});
const $0afdfe770c0f43bb$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "queues-agent-view-issue-search",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6E8HE.SkeletonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
            height: "32px",
            width: "240px"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0afdfe770c0f43bb$var$LazyComponent, props));
var $0afdfe770c0f43bb$export$2e2bcd8739ae039 = $0afdfe770c0f43bb$var$Component;

});
parcelRegister("6E8HE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdbb990603770154$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SkeletonWrapper", () => $cdbb990603770154$export$6069cbe61f690103);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $ip0rq = parcelRequire("ip0rq");

var $gMMNe = parcelRequire("gMMNe");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $2CJH2 = parcelRequire("2CJH2");
const $cdbb990603770154$var$TextFieldWidth = 240;
const $cdbb990603770154$var$createJQLClause = (text)=>`summary ~ "${text}*" OR description ~ "${text}*"`;
const $cdbb990603770154$var$IssueSearchView = ({ onChange: onChange, onChangedIsPendingSubmission: onChangedIsPendingSubmission, onFocusChange: onFocusChange, queueId: queueId, filterQuery: filterQuery })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { placeholder: placeholder, placeholderIssueTermRefresh: placeholderIssueTermRefresh } = (0, $2CJH2.default);
    const [value, setValue] = (0, $5uXOq.useState)('');
    const [isIconHovered, setHovered] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setValue('');
    }, [
        queueId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (filterQuery === null) setValue('');
    }, [
        filterQuery
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            onFocusChange(false);
        }, [
        onFocusChange
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
        const filterJQL = query === '' ? null : $cdbb990603770154$var$createJQLClause(query);
        onChange(filterJQL);
        onChangedIsPendingSubmission(true);
    }, 2000), [
        onChange
    ]);
    // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    const handleSearchChange = (event)=>{
        setValue(event.target.value);
        debouncedSearch(event.target.value);
    };
    const onFocusHandle = ()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering clicked');
        onFocusChange(true);
    };
    const onBlurHandle = ()=>onFocusChange(false);
    const onMouseEnterButton = (0, $5uXOq.useCallback)(()=>setHovered(true), []);
    const onMouseLeaveButton = (0, $5uXOq.useCallback)(()=>setHovered(false), []);
    const clearSearch = ()=>{
        setValue('');
        onChange(null);
        onChangedIsPendingSubmission(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdbb990603770154$var$MinWidthWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isCompact: true,
        width: $cdbb990603770154$var$TextFieldWidth,
        placeholder: (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage(placeholderIssueTermRefresh) : formatMessage(placeholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gMMNe))), {
            spacing: "spacious",
            label: ""
        }),
        onChange: handleSearchChange,
        value: value,
        onFocus: onFocusHandle,
        onBlur: onBlurHandle,
        elemAfterInput: value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $2CJH2.default).clearSearch)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdbb990603770154$var$ClearSearchWrapper, {
            onClick: clearSearch,
            onMouseEnter: onMouseEnterButton,
            onMouseLeave: onMouseLeaveButton,
            "data-testid": "servicedesk-queues-agent-view.layout.header.async-issue-search.issue-search.clear-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
            color: isIconHovered ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-disabled, #091E424F)",
            label: formatMessage((0, $2CJH2.default).clearSearch),
            spacing: "none"
        })))
    }));
};
var $cdbb990603770154$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $cdbb990603770154$var$IssueSearchView;
const $cdbb990603770154$var$ClearSearchWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _80omtlke _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); /*
     * these styles are used for accomodating smaller screen sizes with the introduction of the split filters
     *
     * the min-width is needed to prevent the text area from shrinking to 0 size
     * the flex-shrink is used to give width priority to the active issue types / portal groups filters
     * the text-overflow is used when the text input is shrunken
     */ 
const $cdbb990603770154$var$MinWidthWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkx0bf _1bsbp3fh _1ul953f4 _1o9z15gg _509t1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cdbb990603770154$export$6069cbe61f690103 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkx0bf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ip0rq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f38a712ca2a7ec6c029336fe6611116d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d65ae76e92cae981$var$_react = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d65ae76e92cae981$var$_crossCircle = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("hI6SY")));

var $d65ae76e92cae981$var$_selectClear = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("673MF")));
function $d65ae76e92cae981$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d65ae76e92cae981$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $d65ae76e92cae981$var$_react.default.createElement($d65ae76e92cae981$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $d65ae76e92cae981$var$_selectClear.default
    }, props));
$d65ae76e92cae981$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $d65ae76e92cae981$var$_default = module.exports.default = $d65ae76e92cae981$var$CrossCircleIcon;

});

parcelRegister("2CJH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $78188bb3f58c170f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $78188bb3f58c170f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "servicedesk.queues.agent-view.layout.header.async-issue-search.issue-search.placeholder",
        "defaultMessage": "Search for issues"
    },
    clearSearch: {
        "id": "servicedesk.queues.agent-view.layout.header.async-issue-search.issue-search.clear-search",
        "defaultMessage": "Clear search"
    },
    placeholderIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.header.async-issue-search.issue-search.placeholder-issue-term-refresh",
        "defaultMessage": "Search for work items"
    }
});

});


parcelRegister("dQ2uI", function(module, exports) {

let $a132110cad32d415$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a132110cad32d415$var$load("54T1N").then(()=>parcelRequire('30ln6'));

});


parcelRegister("1uZTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e0d78f97c3fb326$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");


var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");

var $hYrcT = parcelRequire("hYrcT");

var $lHf6h = parcelRequire("lHf6h");

var $jeVA9 = parcelRequire("jeVA9");

var $iTWAO = parcelRequire("iTWAO");
const $1e0d78f97c3fb326$var$mapDispatchToProps = (dispatch)=>({
        onFilterReloadClick: ()=>{
            dispatch((0, $fnQyW.isNewFilterQueryPendingAction)(true));
            dispatch((0, $bzBCj.loadIssuesAction)(0, (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a)));
        }
    });
const $1e0d78f97c3fb326$var$mapStateToProps = (state)=>({
        issueCount: (0, $lHf6h.getIssueCount)(state),
        isCurrentDataFiltered: (0, $hYrcT.getIsCurrentDataFiltered)(state),
        isLoadingIssues: (0, $jeVA9.isLoadingIssues)(state)
    });
var $1e0d78f97c3fb326$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($1e0d78f97c3fb326$var$mapStateToProps, $1e0d78f97c3fb326$var$mapDispatchToProps)((0, $iTWAO.default));

});
parcelRegister("iTWAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0917b1fd89c3ec$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $jOrGg = parcelRequire("jOrGg");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $1wbtX = parcelRequire("1wbtX");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6AxbM = parcelRequire("6AxbM");
const $5f0917b1fd89c3ec$export$542fba90cc9c1bd1 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { issueCount: issueCount, isCurrentDataFiltered: isCurrentDataFiltered, isLoadingIssues: isLoadingIssues, onFilterReloadClick: onFilterReloadClick } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleReloadClick = ()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering reloaded');
        onFilterReloadClick();
    };
    if (!isCurrentDataFiltered && issueCount !== 0 && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0917b1fd89c3ec$export$e6dfd72ab29f8598, null, formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $6AxbM.default).numberOfIssuesIssueTermRefresh : (0, $6AxbM.default).numberOfIssues, {
        issueCount: issueCount
    }));
    if (isCurrentDataFiltered && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0917b1fd89c3ec$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0917b1fd89c3ec$var$Layout, null, formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $6AxbM.default).numberOfFilteredIssuesIssueTermRefresh : (0, $6AxbM.default).numberOfFilteredIssues, {
        filteredIssueCount: issueCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5f0917b1fd89c3ec$var$spacerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: formatMessage((0, $6AxbM.default).refreshResults)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": formatMessage((0, $6AxbM.default).refreshResults),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
            label: formatMessage((0, $6AxbM.default).refreshResults),
            LEGACY_size: "small"
        }),
        "data-testId": "servicedesk-queues-agent-view.layout.header.issue-count.reload-button",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleReloadClick
    }))));
    return isLoadingIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0917b1fd89c3ec$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        height: "24px",
        width: "100px",
        "data-testid": "servicedesk-queues-agent-view.layout.header.issue-count.skeleton"
    })) : null;
};
var $5f0917b1fd89c3ec$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $5f0917b1fd89c3ec$export$542fba90cc9c1bd1;
const $5f0917b1fd89c3ec$var$Layout = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5f0917b1fd89c3ec$var$spacerStyles = (0, $8CUq3.xcss)({
    width: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5f0917b1fd89c3ec$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq _19pkutpp _otyr1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jOrGg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e77e094a0aa1d7ca1d4c9b1f496feee5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6c828a42ee64c30$var$_react = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6c828a42ee64c30$var$_refresh = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("gPelT")));

var $e6c828a42ee64c30$var$_refresh2 = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("75Jbm")));
function $e6c828a42ee64c30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6c828a42ee64c30$var$RefreshIcon = (props)=>/*#__PURE__*/ $e6c828a42ee64c30$var$_react.default.createElement($e6c828a42ee64c30$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $e6c828a42ee64c30$var$_refresh2.default
    }, props));
$e6c828a42ee64c30$var$RefreshIcon.Name = 'RefreshIconMigration';
var $e6c828a42ee64c30$var$_default = module.exports.default = $e6c828a42ee64c30$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f34e41ee33b1e524435b178556b66735>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});

parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});


parcelRegister("6AxbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cbd01e1beb6ec7a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3cbd01e1beb6ec7a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    numberOfIssues: {
        "id": "servicedesk.queues.agent-view.layout.header.issue-count.number-of-issues",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} issue}\n            other {{issueCount, number} issues}\n            }"
    },
    numberOfFilteredIssues: {
        "id": "servicedesk.queues.agent-view.layout.header.issue-count.number-of-filtered-issues",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} issue found}\n            other {{filteredIssueCount, number} issues found}\n            }"
    },
    refreshResults: {
        "id": "servicedesk.queues.agent-view.layout.header.issue-count.refresh-results",
        "defaultMessage": "Refresh results"
    },
    numberOfIssuesIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.header.issue-count.number-of-issues-issue-term-refresh",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} work item}\n            other {{issueCount, number} work items}\n            }"
    },
    numberOfFilteredIssuesIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.header.issue-count.number-of-filtered-issues-issue-term-refresh",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} work item found}\n            other {{filteredIssueCount, number} work items found}\n            }"
    }
});

});



parcelRegister("d0ovW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e15a032581a27f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $cS37j = parcelRequire("cS37j");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $bS0zk = parcelRequire("bS0zk");

var $flhvf = parcelRequire("flhvf");

var $bcnxD = parcelRequire("bcnxD");
function $d5e15a032581a27f$export$2e2bcd8739ae039(props) {
    const [addTopMargin, setAddTopMargin] = (0, $5uXOq.useState)(false);
    const { queueName: queueName, onDeleteComplete: onDeleteComplete, renderDisplayError: renderDisplayError, Actions: Actions, IssueCount: IssueCount, IssueSearch: IssueSearch, isQueuesErrorHeaderDisplayed: isQueuesErrorHeaderDisplayed } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleError = (location)=>{
        if (location === 'common.error-boundary.queue-page-header') setAddTopMargin(true);
        renderDisplayError();
    };
    const handleReload = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    };
    const errorSectionDefaultStyles = (0, $8CUq3.xcss)({
        marginTop: 'space.0'
    });
    const errorMarginTopStyles = (0, $8CUq3.xcss)({
        marginTop: 'space.400'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
        onError: handleError,
        id: "queue-page-header-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
        onError: handleError,
        id: "queue-page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Actions, {
            onDeleteComplete: onDeleteComplete
        }),
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bS0zk.default), null)
    }, queueName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.400",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            errorSectionDefaultStyles,
            addTopMargin && errorMarginTopStyles
        ]
    }, isQueuesErrorHeaderDisplayed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: formatMessage((0, $bcnxD.messages).errorSectionTitle),
        appearance: "error",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            onClick: handleReload
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bcnxD.messages).reloadPageLinkText))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bcnxD.messages).errorSectionBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
        onError: renderDisplayError,
        id: "queue-issue-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueSearch, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueCount, null)))));
}

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$containerStyles = (0, $8CUq3.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $a97355a0cc6aeb06$var$bleedStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
const $a97355a0cc6aeb06$var$contentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: 'font.body'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        // props for new icon
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map((action, id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            role: "listitem",
            key: id
        }, action))))));
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $5uXOq = parcelRequire("5uXOq");

var $btivG = parcelRequire("btivG");

var $7nnPp = parcelRequire("7nnPp");

var $2hXfb = parcelRequire("2hXfb");

var $eJS47 = parcelRequire("eJS47");

var $gtreQ = parcelRequire("gtreQ");

const $d1d7dced94bb00f5$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eJS47))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$export$faa35441caff5bb6[appearance] || $d1d7dced94bb00f5$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
const $2e844da07d79ea04$var$styles = {
    common: "_11c81oud _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor)
        }, children);
        if (onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable)
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span",
            testId: testId
        }, children);
    }
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});

parcelRegister("bS0zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7fb96d4d34f5f48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jS4lj = parcelRequire("jS4lj");

var $cSD7y = parcelRequire("cSD7y");
const $f7fb96d4d34f5f48$var$QueuesBreadcrumbRendererLegacy = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f7fb96d4d34f5f48$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null));
const $f7fb96d4d34f5f48$var$QueuesBreadcrumbRendererNew = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null);
var $f7fb96d4d34f5f48$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('jsm-fission-decompose-queue-page-header', $f7fb96d4d34f5f48$var$QueuesBreadcrumbRendererNew, $f7fb96d4d34f5f48$var$QueuesBreadcrumbRendererLegacy);
const $f7fb96d4d34f5f48$var$wrapperStyles = (0, $8CUq3.xcss)({
    /* negates margin added by original component */ marginLeft: 'space.negative.050'
});

});

parcelRegister("flhvf", function(module, exports) {

$parcel$export(module.exports, "FFErrorBoundary", () => $bacd41638c79a53c$export$1a99c46b1b67cad6);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $bacd41638c79a53c$export$1a99c46b1b67cad6 = ({ children: children, onError: onError, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        onError: onError,
        id: id,
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount",
        teamName: "jsd-shield"
    }, children);

});

parcelRegister("bcnxD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9d7ddb5aa81a579a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9d7ddb5aa81a579a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorSectionTitle: {
        "id": "servicedesk.queues.agent-view.layout.header.error-section-title",
        "defaultMessage": "We currently have an outage"
    },
    errorSectionBody: {
        "id": "servicedesk.queues.agent-view.layout.header.error-section-body",
        "defaultMessage": "We're working hard to resolve temporary glitches with this page. But rest assured, the key functions on this page remain fully operational."
    },
    reloadPageLinkText: {
        "id": "servicedesk.queues.agent-view.layout.header.reload-page-link-text",
        "defaultMessage": "Reload the page"
    }
});

});



parcelRegister("1Ef3e", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d24e8a0981c22cb$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dWFvu = parcelRequire("dWFvu");

var $n8wvn = parcelRequire("n8wvn");
const $6d24e8a0981c22cb$var$mapDispatchToProps = {
    onSetIssueKeyContext: (0, $dWFvu.setIssueKeyContext)
};
var $6d24e8a0981c22cb$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(null, $6d24e8a0981c22cb$var$mapDispatchToProps)((0, $n8wvn.IssueContextListener));

});
parcelRegister("n8wvn", function(module, exports) {

$parcel$export(module.exports, "IssueContextListener", () => $11f7c3d1a752950e$export$3581168f8217134);

var $5uXOq = parcelRequire("5uXOq");

var $1WkNJ = parcelRequire("1WkNJ");
function $11f7c3d1a752950e$export$3581168f8217134({ onSetIssueKeyContext: onSetIssueKeyContext }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1WkNJ.IssueContextSubscriber), null, ({ issueKeyContext: issueKeyContext })=>{
        onSetIssueKeyContext(issueKeyContext);
        return null;
    });
}

});
parcelRegister("1WkNJ", function(module, exports) {

$parcel$export(module.exports, "IssueContextSubscriber", () => $ec306f66bdcf9b4a$export$d5fe934bda9e4605);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $lkcBS = parcelRequire("lkcBS");
const $ec306f66bdcf9b4a$export$93db6a8f3342dddf = (0, $gg7kZ.createContainer)((0, $lkcBS.default));
const $ec306f66bdcf9b4a$export$d5fe934bda9e4605 = (0, $51nlc.createSubscriber)((0, $lkcBS.default));
const $ec306f66bdcf9b4a$export$95e128ed686255dc = (0, $3sQ5x.createHook)((0, $lkcBS.default));

});
parcelRegister("lkcBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6532639fe84bfd84$export$2e2bcd8739ae039);

var $iXqE5 = parcelRequire("iXqE5");

var $aymdt = parcelRequire("aymdt");
const $6532639fe84bfd84$var$initialState = {
    issueKeyContext: undefined
};
var $6532639fe84bfd84$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'issue-context',
    initialState: $6532639fe84bfd84$var$initialState,
    actions: $aymdt.default
});

});
parcelRegister("aymdt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d6ffff3fa830c8c$export$2e2bcd8739ae039);
const $1d6ffff3fa830c8c$var$actions = {
    setIssueKeyContext: (issueKey)=>({ setState: setState })=>setState({
                issueKeyContext: issueKey
            })
};
var $1d6ffff3fa830c8c$export$2e2bcd8739ae039 = $1d6ffff3fa830c8c$var$actions;

});





parcelRegister("deqET", function(module, exports) {

$parcel$export(module.exports, "default", () => $727903bd4a039328$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $ktE3b = parcelRequire("ktE3b");

var $cKBuj = parcelRequire("cKBuj");
var $727903bd4a039328$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(null, (dispatch)=>({
        onUpdatePractices: (practiceList)=>{
            dispatch((0, $ktE3b.setEnabledPracticesAction)(practiceList));
        }
    }))((0, $cKBuj.default));

});
parcelRegister("cKBuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c8fce435501ccfc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jF62O = parcelRequire("jF62O");
const $0c8fce435501ccfc$var$ItsmContextListener = ({ projectKey: projectKey, onUpdatePractices: onUpdatePractices })=>{
    const practicesBelongsToRef = (0, $5uXOq.useRef)('');
    const [practices, loading, error] = (0, $jF62O.usePracticeList)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const canUpdatePractices = !loading && !error && practicesBelongsToRef.current !== projectKey;
        if (canUpdatePractices) {
            practicesBelongsToRef.current = projectKey;
            onUpdatePractices(practices || []);
        }
    }, [
        projectKey,
        loading,
        error,
        onUpdatePractices,
        practices
    ]);
    return null;
};
$0c8fce435501ccfc$var$ItsmContextListener.defaultProps = {
    projectKey: '',
    onUpdatePractices: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $0c8fce435501ccfc$export$2e2bcd8739ae039 = $0c8fce435501ccfc$var$ItsmContextListener;

});


parcelRegister("iAhQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f71f16af4b0bd4b$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");

var $hYrcT = parcelRequire("hYrcT");

var $lHf6h = parcelRequire("lHf6h");

var $k3elp = parcelRequire("k3elp");

var $2vzXT = parcelRequire("2vzXT");
const $6f71f16af4b0bd4b$var$mapStateToProps = (state)=>({
        issueCount: (0, $lHf6h.getIssueCount)(state),
        projectStateHash: (0, $k3elp.getProjectStateHash)(state),
        isCurrentDataFiltered: (0, $hYrcT.getIsCurrentDataFiltered)(state)
    });
var $6f71f16af4b0bd4b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $bC2fB.connect)($6f71f16af4b0bd4b$var$mapStateToProps, {}), (0, $2OMDV.AnalyticsEventToProps)('navUpdate', {
    onProjectStateHashUpdate: 'queuesCountsRefreshed'
}))((0, $2vzXT.default));

});
parcelRegister("2vzXT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b859b88ff184b96b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");
class $b859b88ff184b96b$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            onQueueIssueCountUpdated: undefined,
            onProjectStateHashUpdate: undefined
        };
    }
    componentDidMount() {
        this.updateIssueCount();
    }
    componentDidUpdate(prevProps) {
        const { projectStateHash: projectStateHash, onProjectStateHashUpdate: onProjectStateHashUpdate, issueCount: issueCount } = this.props;
        if (prevProps.issueCount !== issueCount) this.updateIssueCount();
        if (// Only call again if it isn't immediately following an initialization call (projectStateHash = null)
        !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(prevProps.projectStateHash) && prevProps.projectStateHash !== projectStateHash && onProjectStateHashUpdate) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        onProjectStateHashUpdate();
    }
    updateIssueCount() {
        const { queueId: queueId, issueCount: issueCount, onQueueIssueCountUpdated: onQueueIssueCountUpdated, isCurrentDataFiltered: isCurrentDataFiltered } = this.props;
        !isCurrentDataFiltered && onQueueIssueCountUpdated && onQueueIssueCountUpdated(queueId, issueCount);
    }
    render() {
        return null;
    }
}

});


parcelRegister("jpEHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af2d0d5834b46c2$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $fy6YG = parcelRequire("fy6YG");

var $627A7 = parcelRequire("627A7");

var $gnYBB = parcelRequire("gnYBB");
var $3af2d0d5834b46c2$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectKey: (0, $fy6YG.getProjectKey)(state),
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectName: (0, $fy6YG.getProjectName)(state),
        baseUrl: (0, $fy6YG.getBaseUrl)(state),
        category: (0, $627A7.getCategory)(state)
    }), {})((0, $gnYBB.default));

});
parcelRegister("gnYBB", function(module, exports) {

$parcel$export(module.exports, "default", () => $118a82826ee42594$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dd29Z = parcelRequire("dd29Z");

var $iRVw7 = parcelRequire("iRVw7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$118a82826ee42594$export$2e2bcd8739ae039 = ({ children: children, category: category, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iRVw7.default), {
        ...rest,
        category: category,
        href: (0, $dd29Z.getQueueUrl)({
            projectKey: rest.projectKey,
            category: category,
            queueId: null
        })
    }, children);

});
parcelRegister("iRVw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $393b4b8bb0e44ada$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e0Brz = parcelRequire("e0Brz");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $koVbs = parcelRequire("koVbs");

var $jF62O = parcelRequire("jF62O");

var $oCMSG = parcelRequire("oCMSG");

var $kVZSN = parcelRequire("kVZSN");

var $9R8yq = parcelRequire("9R8yq");
const $393b4b8bb0e44ada$var$getBreadcrumbText = (category)=>{
    if (!category) return (0, $9R8yq.default).queues;
    switch(category){
        case 0, $oCMSG.INCIDENTS:
            return (0, $kVZSN.default).incidents;
        case 0, $oCMSG.CHANGES:
            return (0, $kVZSN.default).changes;
        case 0, $oCMSG.SERVICE_REQUEST:
            return (0, $kVZSN.default).serviceRequests;
        case 0, $oCMSG.PROBLEMS:
            return (0, $kVZSN.default).problems;
        case 0, $oCMSG.POST_INCIDENT_REVIEWS:
            return (0, $kVZSN.default).postIncidentReviews;
        default:
            return (0, $kVZSN.default).queues;
    }
};
const $393b4b8bb0e44ada$var$QueuesBreadcrumbManager = ({ children: children, projectKey: projectKey, projectName: projectName, baseUrl: baseUrl, href: href, text: text = '', type: type = 'queues', category: category })=>{
    const [practiceList] = (0, $jF62O.usePracticeList)();
    const hasPractices = Boolean(practiceList && practiceList.length > 1);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            href: href,
            text: text || formatMessage($393b4b8bb0e44ada$var$getBreadcrumbText(hasPractices ? category : undefined)),
            type: type
        }
    }, children)));
};
var $393b4b8bb0e44ada$export$2e2bcd8739ae039 = $393b4b8bb0e44ada$var$QueuesBreadcrumbManager;

});
parcelRegister("9R8yq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7fac70db420455c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c7fac70db420455c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    queues: {
        "id": "servicedesk-queues-breadcrumb.queues-breadcrumb-manager.queues",
        "defaultMessage": "Queues"
    }
});

});




parcelRegister("8TeCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $476a1f28182d59fc$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");

var $jzjy1 = parcelRequire("jzjy1");

var $iQv12 = parcelRequire("iQv12");

var $17JMK = parcelRequire("17JMK");


var $dRmTW = parcelRequire("dRmTW");

var $bC2fB = parcelRequire("bC2fB");

var $2Pbdb = parcelRequire("2Pbdb");

var $fy6YG = parcelRequire("fy6YG");

var $bzBCj = parcelRequire("bzBCj");

var $4uvJ3 = parcelRequire("4uvJ3");

var $jdGLR = parcelRequire("jdGLR");

var $dWFvu = parcelRequire("dWFvu");

var $iIQpG = parcelRequire("iIQpG");

var $IrNQw = parcelRequire("IrNQw");

var $hYrcT = parcelRequire("hYrcT");

var $lHf6h = parcelRequire("lHf6h");

var $WS8Y1 = parcelRequire("WS8Y1");

var $627A7 = parcelRequire("627A7");

var $h4yk3 = parcelRequire("h4yk3");

var $hbago = parcelRequire("hbago");

var $jeVA9 = parcelRequire("jeVA9");

var $f1uep = parcelRequire("f1uep");

var $jATd4 = parcelRequire("jATd4");

var $8Dyvh = parcelRequire("8Dyvh");

var $aDlXC = parcelRequire("aDlXC");

var $c6Ds1 = parcelRequire("c6Ds1");
const $476a1f28182d59fc$var$onActiveItemChanged = (payload)=>payload && (0, $jdGLR.activeItemChangedAction)(payload.rowId, payload.columnId) || (0, $jdGLR.activeItemRemovedAction)();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $476a1f28182d59fc$var$mapStateToProps = (state, ownProps)=>{
    const isLoading = (0, $jeVA9.isLoadingIssues)(state);
    return {
        appProps: (0, $hbago.getIssueTableAppProps)(state),
        queueId: (0, $627A7.getQueueId)(state),
        queueName: (0, $4R6GH.fg)('jsm_virtual_table_a11y') ? (0, $627A7.getQueueName)(state) : undefined,
        queueCategory: (0, $627A7.getCategory)(state),
        columns: (0, $627A7.getColumnsInOrder)(state),
        DemoDripFeed: $f1uep.default,
        FieldDataSelector: $jATd4.default,
        issueKeys: (0, $WS8Y1.getIssueKeysForPage)(state),
        IssueTable: $dRmTW.default,
        KeyboardShortcutListener: $8Dyvh.default,
        AsyncBulkActionToolbar: $2Pbdb.AsyncBulkActionToolbar,
        SelectedIssuesSubscriber: $17JMK.SelectedIssuesSubscriber,
        currentPage: (0, $WS8Y1.getCurrentPage)(state),
        totalPages: (0, $WS8Y1.getTotalPages)(state),
        sortedBy: (0, $h4yk3.getSortedByColumn)(state),
        sortOrder: (0, $h4yk3.getSortOrder)(state),
        isQueueVisible: (0, $jeVA9.isQueueVisible)(state),
        isQueueTransient: (0, $627A7.isQueueTransient)(state),
        projectKey: (0, $fy6YG.getProjectKey)(state),
        isLoading: isLoading,
        isContentStale: isLoading && (0, $lHf6h.getCollection)(state).length > 0,
        metricKey: (0, $627A7.getMetricKey)(state),
        hasLoadedIssueDataFromCache: (0, $IrNQw.getHasLoadedIssueDataFromCache)(state),
        canFocusTable: !(0, $hYrcT.getIsFilterFocused)(state),
        useJSMQueueDurationEvent: ownProps.useJSMQueueDurationEvent,
        renderSidebarIcon: ownProps.renderSidebarIcon,
        shouldRerenderRowOnHover: ownProps.shouldRerenderRowOnHover,
        width: ownProps.width,
        tableWidth: ownProps.tableWidth
    };
};
// We want to avoid creating a new anonymous function every time the state has changed, so that later in `issue-table`
// we can compare the prop to decide whether we should update the component.
const $476a1f28182d59fc$var$onSortOrderChangedGenerator = (0, $8QpSo.default)((dispatch)=>(sortedBy, sortOrder)=>dispatch((0, $jdGLR.sortOrderChangedAction)(sortedBy, sortOrder)));
const $476a1f28182d59fc$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
        onActiveItemChanged: (payload)=>dispatch($476a1f28182d59fc$var$onActiveItemChanged(payload)),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onPageChange: (event, newPage)=>{
            dispatch((0, $jdGLR.pageChangedAction)(newPage));
            dispatch((0, $bzBCj.loadIssuesActionForPage)(newPage));
        },
        onSortOrderChanged: $476a1f28182d59fc$var$onSortOrderChangedGenerator(dispatch),
        onIssueDataRequested: (startIndex)=>dispatch((0, $jdGLR.fetchIssueDataOnScrollAction)(startIndex)),
        onVerticalScrollChanged: (verticalPosition)=>dispatch((0, $jdGLR.toggleQueueHeaderAction)(verticalPosition.direction)),
        onTableChange: (analyticsEvent)=>dispatch((0, $jdGLR.tableChangedAction)(analyticsEvent)),
        onSetSelectedIssueKeys: (selectedIssueKeys)=>dispatch((0, $dWFvu.setSelectedIssueKeys)(selectedIssueKeys)),
        onRefreshSidebar: ({ issueKey: issueKey } = {})=>{
            dispatch((0, $dWFvu.refreshSidebarIssueView)({
                issueKey: issueKey
            }));
        },
        onSetIssueKey: (key)=>{
            dispatch((0, $dWFvu.setSidebarIssueKey)(key));
        },
        onNonPremiumSLAColumnError: ()=>dispatch((0, $4uvJ3.displayQueuesErrorHeaderAction)()),
        controlPolling: {
            restartPolling: ()=>{
                dispatch((0, $dWFvu.refreshSidebarIssueView)());
                dispatch((0, $iIQpG.restartPollAction)());
            },
            stopPolling: ()=>dispatch((0, $iIQpG.stopPollAction)())
        }
    });
const $476a1f28182d59fc$var$getColumnsForIssueTableFactory = (0, $8QpSo.default)((columns, onSortOrderChanged)=>(0, $aDlXC.getColumnsForIssueTable)(columns, onSortOrderChanged));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $476a1f28182d59fc$var$mergeProps = (stateProps, dispatchProps)=>({
        ...stateProps,
        ...dispatchProps,
        columns: $476a1f28182d59fc$var$getColumnsForIssueTableFactory(stateProps.columns, dispatchProps.onSortOrderChanged)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $476a1f28182d59fc$var$connectedTable = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onPageChange: (event, newPage)=>({
            name: 'queue',
            pageNumber: newPage,
            startIndex: (0, $0750463259e12908$export$f88f58d1a4b2078b) * (newPage - 1) + 1
        })
}), (0, $bC2fB.connect)($476a1f28182d59fc$var$mapStateToProps, $476a1f28182d59fc$var$mapDispatchToProps, $476a1f28182d59fc$var$mergeProps), (0, $jzjy1.AnalyticsSubject)('queue'))((0, $c6Ds1.default));
var $476a1f28182d59fc$export$2e2bcd8739ae039 = $476a1f28182d59fc$var$connectedTable;

});
parcelRegister("17JMK", function(module, exports) {

$parcel$export(module.exports, "SelectedIssuesContainer", () => $174a994d8feda318$export$738cdb08d2b14320);
$parcel$export(module.exports, "SelectedIssuesSubscriber", () => $174a994d8feda318$export$e95e49d0cb3be823);
$parcel$export(module.exports, "useSelectedIssues", () => $174a994d8feda318$export$a435421a00d3bee);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $j9A44 = parcelRequire("j9A44");

const $174a994d8feda318$export$d4c72bab9d6cc13a = {
    issueKeys: [],
    limit: (0, $9074633c7c24dd04$export$81a88ed305997a6d),
    isLocked: false
};
const $174a994d8feda318$var$Store = (0, $iXqE5.createStore)({
    name: 'issue-table-selection',
    initialState: $174a994d8feda318$export$d4c72bab9d6cc13a,
    actions: $j9A44
});
const $174a994d8feda318$export$738cdb08d2b14320 = (0, $gg7kZ.createContainer)($174a994d8feda318$var$Store);
const $174a994d8feda318$export$e95e49d0cb3be823 = (0, $51nlc.createSubscriber)($174a994d8feda318$var$Store, {
    displayName: 'SelectedIssuesSubscriber'
});
const $174a994d8feda318$export$ded196a925e981e1 = (0, $51nlc.createSubscriber)($174a994d8feda318$var$Store, {
    displayName: 'SelectedIssuesActionsSubscriber',
    selector: null
});
const $174a994d8feda318$export$a435421a00d3bee = (0, $3sQ5x.createHook)($174a994d8feda318$var$Store);
var $174a994d8feda318$export$2e2bcd8739ae039 = $174a994d8feda318$var$Store;

});
parcelRegister("j9A44", function(module, exports) {

$parcel$export(module.exports, "selectIssues", () => (parcelRequire("cAmvn")).selectIssues);
$parcel$export(module.exports, "deselectIssues", () => (parcelRequire("k2tZ0")).deselectIssues);
$parcel$export(module.exports, "deselectAllIssues", () => (parcelRequire("iGgFM")).deselectAllIssues);
$parcel$export(module.exports, "refreshSelection", () => (parcelRequire("i7yqY")).refreshSelection);
$parcel$export(module.exports, "getCurrentlySelectedIssues", () => (parcelRequire("6p7Yv")).getCurrentlySelectedIssues);
$parcel$export(module.exports, "lockSelection", () => (parcelRequire("9aahR")).lockSelection);
$parcel$export(module.exports, "unlockSelection", () => (parcelRequire("e48Gz")).unlockSelection);
$parcel$export(module.exports, "refreshSelectionLimit", () => (parcelRequire("8vV4b")).refreshSelectionLimit);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $cAmvn = parcelRequire("cAmvn");

var $k2tZ0 = parcelRequire("k2tZ0");

var $iGgFM = parcelRequire("iGgFM");

var $i7yqY = parcelRequire("i7yqY");

var $6p7Yv = parcelRequire("6p7Yv");

var $9aahR = parcelRequire("9aahR");

var $e48Gz = parcelRequire("e48Gz");

var $8vV4b = parcelRequire("8vV4b");

});
parcelRegister("cAmvn", function(module, exports) {

$parcel$export(module.exports, "selectIssues", () => $2f7108b524e79db0$export$1e9b66e71acaf40b);

var $k8IPx = parcelRequire("k8IPx");

var $gccSB = parcelRequire("gccSB");

var $e4v2N = parcelRequire("e4v2N");

var $8zOmE = parcelRequire("8zOmE");
const $2f7108b524e79db0$export$1e9b66e71acaf40b = (selectedIssueKeys, analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys, limit: limit } = getState();
        const newlySelectedIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(selectedIssueKeys, issueKeys);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(newlySelectedIssueKeys)) {
            const newIssueKeys = issueKeys.concat(...newlySelectedIssueKeys);
            setState({
                issueKeys: (0, (/*@__PURE__*/$parcel$interopDefault($e4v2N)))(newIssueKeys, limit)
            });
            analyticsEvent && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'bulkSelection added', {
                selectionTruncated: newIssueKeys.length > limit,
                desiredIssuesCount: newIssueKeys.length,
                selectedIssuesCount: Math.min(newIssueKeys.length, limit),
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});
parcelRegister("e4v2N", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");

var $kPZpS = parcelRequire("kPZpS");
/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */ function $a3e985251d714418$var$take(array, n, guard) {
    if (!(array && array.length)) return [];
    n = guard || n === undefined ? 1 : $kPZpS(n);
    return $dM3Z8(array, 0, n < 0 ? 0 : n);
}
module.exports = $a3e985251d714418$var$take;

});


parcelRegister("k2tZ0", function(module, exports) {

$parcel$export(module.exports, "deselectIssues", () => $04f7c3eee594fed4$export$2d010dfcbbe2bfe4);

var $4wVpT = parcelRequire("4wVpT");

var $gccSB = parcelRequire("gccSB");

var $hqTkp = parcelRequire("hqTkp");

var $8zOmE = parcelRequire("8zOmE");
const $04f7c3eee594fed4$export$2d010dfcbbe2bfe4 = (deselectedIssueKeys, analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        const newlyDeselectedIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(deselectedIssueKeys, issueKeys);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(newlyDeselectedIssueKeys)) {
            const newIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(issueKeys, ...newlyDeselectedIssueKeys);
            setState({
                issueKeys: newIssueKeys
            });
            analyticsEvent && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'bulkSelection reduced', {
                selectedIssuesCount: newIssueKeys.length,
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});
parcelRegister("4wVpT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
    var mapped = $1nIHN(arrays, $d9Hx6);
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
});
module.exports = $34c6b050456654f8$var$intersection;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});



parcelRegister("iGgFM", function(module, exports) {

$parcel$export(module.exports, "deselectAllIssues", () => $8c884674fa40da3d$export$dd4a406c0382217f);

var $gccSB = parcelRequire("gccSB");

var $8zOmE = parcelRequire("8zOmE");
const $8c884674fa40da3d$export$dd4a406c0382217f = (analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueKeys)) {
            setState({
                issueKeys: []
            });
            analyticsEvent && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'bulkSelection reduced', {
                selectedIssuesCount: 0,
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});

parcelRegister("i7yqY", function(module, exports) {

$parcel$export(module.exports, "refreshSelection", () => $eb8b9b61ce2f8d21$export$86ff8cf593d1a265);

var $k8IPx = parcelRequire("k8IPx");

var $gccSB = parcelRequire("gccSB");

var $e4v2N = parcelRequire("e4v2N");

var $hqTkp = parcelRequire("hqTkp");

const $eb8b9b61ce2f8d21$export$86ff8cf593d1a265 = (existingIssueKeys)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        const deselectIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(issueKeys, existingIssueKeys);
        !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(deselectIssueKeys) && setState({
            issueKeys: (0, (/*@__PURE__*/$parcel$interopDefault($e4v2N)))((0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(issueKeys, ...deselectIssueKeys), (0, $9074633c7c24dd04$export$81a88ed305997a6d))
        });
    };

});
const $9074633c7c24dd04$export$81a88ed305997a6d = 150;


parcelRegister("6p7Yv", function(module, exports) {

$parcel$export(module.exports, "getCurrentlySelectedIssues", () => $08ed55e4aaef5942$export$d6e9b99bcd1d7d6c);
const $08ed55e4aaef5942$export$d6e9b99bcd1d7d6c = ()=>({ getState: getState })=>{
        const { issueKeys: issueKeys } = getState();
        return issueKeys;
    };

});

parcelRegister("9aahR", function(module, exports) {

$parcel$export(module.exports, "lockSelection", () => $38a5eb61bb5a45ea$export$790a7f6053d9b4a1);
const $38a5eb61bb5a45ea$export$790a7f6053d9b4a1 = ()=>({ setState: setState })=>setState({
            isLocked: true
        });

});

parcelRegister("e48Gz", function(module, exports) {

$parcel$export(module.exports, "unlockSelection", () => $18cae9acd3ceecf2$export$a90d629fd06371e4);
const $18cae9acd3ceecf2$export$a90d629fd06371e4 = ()=>({ setState: setState })=>setState({
            isLocked: false
        });

});

parcelRegister("8vV4b", function(module, exports) {

$parcel$export(module.exports, "refreshSelectionLimit", () => $38b3dc8c830e134e$export$53f550a8d1ce7a3c);

const $38b3dc8c830e134e$export$53f550a8d1ce7a3c = (numSelected)=>({ setState: setState })=>{
        if (numSelected > 0) setState({
            limit: Math.max((0, $9074633c7c24dd04$export$81a88ed305997a6d) - numSelected, 0)
        });
    };

});



parcelRegister("dRmTW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaffc936a710db9f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $2ao8E = parcelRequire("2ao8E");

var $17JMK = parcelRequire("17JMK");

var $fVir9 = parcelRequire("fVir9");

var $8jMQq = parcelRequire("8jMQq");

var $bIL7p = parcelRequire("bIL7p");

var $gtrZ5 = parcelRequire("gtrZ5");

var $1GPUJ = parcelRequire("1GPUJ");

var $7NCXO = parcelRequire("7NCXO");

var $lewnw = parcelRequire("lewnw");

var $45OTQ = parcelRequire("45OTQ");

var $ak3tm = parcelRequire("ak3tm");

var $lFJsG = parcelRequire("lFJsG");

var $jxVFn = parcelRequire("jxVFn");

var $iQFwo = parcelRequire("iQFwo");

var $p64Ah = parcelRequire("p64Ah");

var $fLxJ8 = parcelRequire("fLxJ8");





// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'tableProps' implicitly has an 'any' type.
const $eaffc936a710db9f$var$BulkSelectionAwareTableStateUpdater = ({ store: store, tableProps: tableProps })=>{
    const { dispatch: dispatch } = store;
    const state = store.getState();
    const { columns: columns, issueKeys: issueKeys, currentPage: currentPage, isDisabled: isDisabled, contentKey: contentKey, onIssueViewTransition: onIssueViewTransition, useJSMQueueDurationEvent: useJSMQueueDurationEvent, renderSidebarIcon: renderSidebarIcon, refreshSidebar: refreshSidebar } = tableProps;
    const [{ issueKeys: selectedIssueKeys }, actions] = (0, $17JMK.useSelectedIssues)();
    const hasBulkSelection = selectedIssueKeys.length > 0;
    (0, $5uXOq.useEffect)(()=>{
        actions.refreshSelection([]);
    }, [
        actions,
        contentKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2322 - Type 'BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/issue-table-selection/src/services/actions/index")>' is not assignable to type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/issue-table-selection/src/services/actions/index")'.
        dispatch((0, $bIL7p.setSelectionServiceActionsAction)({
            actions: actions
        }));
        dispatch((0, $bIL7p.setHasSelectionAction)({
            hasSelection: hasBulkSelection
        }));
        if (hasBulkSelection) {
            dispatch(// @ts-expect-error - TS7006 - Parameter 'c' implicitly has an 'any' type.
            (0, $gtrZ5.updateColumnsAction)(columns.map((c)=>({
                    ...c,
                    isDisabled: hasBulkSelection
                }))));
            dispatch((0, $45OTQ.setIsTableDisabled)(hasBulkSelection));
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(columns, (0, $lFJsG.getColumns)(state)) && !hasBulkSelection) {
            dispatch((0, $gtrZ5.updateColumnsAction)(columns));
            dispatch((0, $1GPUJ.unlockAllFieldsAction)());
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(issueKeys, (0, $jxVFn.getProvidedIssueKeys)(state))) dispatch((0, $7NCXO.updateProvidedIssueKeysAction)(issueKeys));
        if (currentPage !== (0, $iQFwo.getCurrentPage)(state)) {
            dispatch((0, $1GPUJ.unlockAllFieldsAction)());
            dispatch((0, $45OTQ.setCurrentPageAction)(currentPage));
        }
        if (isDisabled !== (0, $iQFwo.isTableDisabled)(state) && !hasBulkSelection) dispatch((0, $45OTQ.setIsTableDisabled)(isDisabled || false));
    }, [
        actions,
        columns,
        currentPage,
        dispatch,
        hasBulkSelection,
        isDisabled,
        issueKeys,
        state
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onIssueViewTransition && onIssueViewTransition !== (0, $iQFwo.getOnIssueViewTransition)(state)) dispatch((0, $45OTQ.setOnIssueViewTransition)(onIssueViewTransition));
    }, [
        dispatch,
        onIssueViewTransition,
        state,
        tableProps
    ]);
    (0, $5uXOq.useEffect)(()=>{
        useJSMQueueDurationEvent && dispatch((0, $45OTQ.setJSMQueueDurationEvent)(useJSMQueueDurationEvent));
    }, [
        dispatch,
        useJSMQueueDurationEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        renderSidebarIcon && dispatch((0, $45OTQ.setRenderSidebarIcon)(renderSidebarIcon));
    }, [
        dispatch,
        renderSidebarIcon
    ]);
    (0, $5uXOq.useEffect)(()=>{
        refreshSidebar && dispatch((0, $45OTQ.setRefreshSidebar)(refreshSidebar));
    }, [
        dispatch,
        refreshSidebar
    ]);
    return null;
};
class $eaffc936a710db9f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    focusContent() {
        this.tableFocusFunction && this.tableFocusFunction();
    }
    scrollToTop() {
        this.tableRef && this.tableRef.resetVerticalScrollOffset();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $p64Ah.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ao8E.AsyncFlagsDispatcher), {
            store: this.store,
            mapper: (0, $fVir9.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eaffc936a710db9f$var$BulkSelectionAwareTableStateUpdater, {
            store: this.store,
            tableProps: this.props
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLxJ8.default), {
            ...this.props,
            tableRef: this.onSetTableRef,
            onTableFocusFunctionChanged: this.onTableFocusFunctionChanged,
            onTableRefChanged: this.onTableRefChanged
        })));
    }
    constructor(...args){
        super(...args), this.onTableFocusFunctionChanged = (tableFocusFunction)=>{
            this.tableFocusFunction = tableFocusFunction;
        }, this.onTableRefChanged = (ref)=>{
            this.store.dispatch((0, $lewnw.setRowListRefAction)(ref));
        }, this.onSetTableRef = (ref)=>{
            this.tableRef = ref;
        }, this.store = (0, $p64Ah.createStore)((0, $8jMQq.default), {
            initialAppProps: this.props.appProps,
            ui: {
                ...(0, $ak3tm.DEFAULT_STATE),
                onIssueViewTransition: this.props.onIssueViewTransition,
                useJSMQueueDurationEvent: this.props.useJSMQueueDurationEvent
            },
            persisted: {
                columns: false ? this.props.columns : [],
                providedIssueKeys: this.props.issueKeys,
                lockedIssues: {},
                offsets: {
                    verticalScrollOffset: 0,
                    horizontalScrollOffset: 0
                },
                rowListRef: undefined
            }
        });
    }
}

});
parcelRegister("fVir9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6cd10fbfeed0c3a$export$2e2bcd8739ae039);

var $kgxrD = parcelRequire("kgxrD");

var $45OTQ = parcelRequire("45OTQ");

var $lXq56 = parcelRequire("lXq56");

var $P5lER = parcelRequire("P5lER");
const $d6cd10fbfeed0c3a$var$decodeFailure = (stringThatMayBeJson)=>{
    try {
        const obj = JSON.parse(stringThatMayBeJson);
        if (obj.errorMessages && obj.errorMessages[0]) return obj.errorMessages[0];
        if (obj.errors) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return Object.values(obj.errors)[0];
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return stringThatMayBeJson;
    }
};
// @ts-expect-error - TS7006 - Parameter 'failureReason' implicitly has an 'any' type.
const $d6cd10fbfeed0c3a$var$isPresentableFailureReason = (failureReason)=>failureReason.statusCode && failureReason.message && failureReason.message.indexOf(`: ${failureReason.statusCode}`) === -1;
const $d6cd10fbfeed0c3a$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $kgxrD.FIELD_UPDATE_FAILURE:
            {
                const { fieldName: fieldName, issueKey: issueKey, failureReason: failureReason } = action.payload;
                return (0, $P5lER.default)({
                    fieldName: fieldName,
                    issueKey: issueKey,
                    reasonMessage: failureReason.message && $d6cd10fbfeed0c3a$var$isPresentableFailureReason(failureReason) ? $d6cd10fbfeed0c3a$var$decodeFailure(failureReason.message) : undefined
                });
            }
        case 0, $45OTQ.DISABLE_USER_PICKER:
            return (0, $lXq56.default)();
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $d6cd10fbfeed0c3a$export$2e2bcd8739ae039 = $d6cd10fbfeed0c3a$var$flagsMapper;

});
parcelRegister("kgxrD", function(module, exports) {

$parcel$export(module.exports, "FIELD_UPDATE_SUBMIT", () => $0899c4e6ebb5d232$export$d8a6a3dbb4cd0e2b);
$parcel$export(module.exports, "submitFieldUpdateAction", () => $0899c4e6ebb5d232$export$94f231b4f54796b);
$parcel$export(module.exports, "updateFieldSuccessAction", () => $0899c4e6ebb5d232$export$cf3e633d76bec1c0);
$parcel$export(module.exports, "ERROR_RESPONSE", () => $0899c4e6ebb5d232$export$e7c20800d1dc6c31);
$parcel$export(module.exports, "FIELD_UPDATE_FAILURE", () => $0899c4e6ebb5d232$export$f6339a854154c99e);
$parcel$export(module.exports, "updateFieldFailureErrorResponseAction", () => $0899c4e6ebb5d232$export$80effa926bcee3a6);
// LOCK_FIELD
const $0899c4e6ebb5d232$export$d8a6a3dbb4cd0e2b = 'state.actions.field.update.FIELD_UPDATE_SUBMIT';
const $0899c4e6ebb5d232$export$94f231b4f54796b = (issueKey, fieldId, fieldValue, onSuccess, onFailure)=>({
        type: $0899c4e6ebb5d232$export$d8a6a3dbb4cd0e2b,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId,
            fieldValue: fieldValue,
            onSuccess: onSuccess,
            onFailure: onFailure
        }
    });
const $0899c4e6ebb5d232$export$4374b1b680dead41 = 'state.actions.field.update.FIELD_UPDATE_SUCCESS';
const $0899c4e6ebb5d232$export$cf3e633d76bec1c0 = (issueKey, fieldId)=>({
        type: $0899c4e6ebb5d232$export$4374b1b680dead41,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId
        }
    });
const $0899c4e6ebb5d232$export$e7c20800d1dc6c31 = 'ERROR_RESPONSE';
const $0899c4e6ebb5d232$export$f6339a854154c99e = 'state.actions.field.update.FIELD_UPDATE_FAILURE';
const $0899c4e6ebb5d232$export$80effa926bcee3a6 = (issueKey, fieldId, fieldType, fieldName, error)=>({
        type: $0899c4e6ebb5d232$export$f6339a854154c99e,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId,
            fieldType: fieldType,
            fieldName: fieldName,
            failureReason: {
                type: $0899c4e6ebb5d232$export$e7c20800d1dc6c31,
                statusCode: error.statusCode,
                message: error.message
            }
        }
    });

});

parcelRegister("45OTQ", function(module, exports) {

$parcel$export(module.exports, "SHOW_PAGINATION", () => $a705e6c276c287ea$export$5d9390342a7644ac);
$parcel$export(module.exports, "setPaginationVisibility", () => $a705e6c276c287ea$export$c1bc18f3f5aacbab);
$parcel$export(module.exports, "SET_EDITING_FIELD_POSITION", () => $a705e6c276c287ea$export$c89eb1efa157bec9);
$parcel$export(module.exports, "setEditingFieldPositionAction", () => $a705e6c276c287ea$export$300d660c6d75f0cc);
$parcel$export(module.exports, "SET_CURRENT_PAGE", () => $a705e6c276c287ea$export$483508f263cba397);
$parcel$export(module.exports, "setCurrentPageAction", () => $a705e6c276c287ea$export$6f9713cf11255bd4);
$parcel$export(module.exports, "SET_IS_TABLE_DISABLED", () => $a705e6c276c287ea$export$a871a4533fe0415c);
$parcel$export(module.exports, "setIsTableDisabled", () => $a705e6c276c287ea$export$adbd404608132b43);
$parcel$export(module.exports, "DISABLE_USER_PICKER", () => $a705e6c276c287ea$export$a3bc24c2e3b7c2a2);
$parcel$export(module.exports, "disableUserPickerAction", () => $a705e6c276c287ea$export$da8d58cd19fa9174);
$parcel$export(module.exports, "SET_ON_ISSUE_VIEW_TRANSITION", () => $a705e6c276c287ea$export$91f1228c532af4);
$parcel$export(module.exports, "setOnIssueViewTransition", () => $a705e6c276c287ea$export$fa4a37077fc8610b);
$parcel$export(module.exports, "SET_JSM_QUEUE_DURATION_EVENT", () => $a705e6c276c287ea$export$c00a50fc22eee33c);
$parcel$export(module.exports, "setJSMQueueDurationEvent", () => $a705e6c276c287ea$export$834790f742597c01);
$parcel$export(module.exports, "SET_RENDER_SIDE_BAR_ICON", () => $a705e6c276c287ea$export$9699e624bf23e2bb);
$parcel$export(module.exports, "setRenderSidebarIcon", () => $a705e6c276c287ea$export$28433d58f8f5bf2);
$parcel$export(module.exports, "SET_REFRESH_SIDE_BAR", () => $a705e6c276c287ea$export$dd236613845bdbce);
$parcel$export(module.exports, "setRefreshSidebar", () => $a705e6c276c287ea$export$a6ee15011295b023);
const $a705e6c276c287ea$export$5d9390342a7644ac = 'state.actions.ui.SHOW_PAGINATION';
const $a705e6c276c287ea$export$c1bc18f3f5aacbab = (payload)=>({
        type: $a705e6c276c287ea$export$5d9390342a7644ac,
        payload: payload
    });
const $a705e6c276c287ea$export$c89eb1efa157bec9 = 'state.actions.ui.SET_EDITING_FIELD_POSITION';
const $a705e6c276c287ea$export$300d660c6d75f0cc = (horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight)=>({
        type: $a705e6c276c287ea$export$c89eb1efa157bec9,
        payload: {
            horizontalOffset: horizontalOffset,
            verticalOffset: verticalOffset,
            fieldWidth: fieldWidth,
            tableWidth: tableWidth,
            tableHeight: tableHeight
        }
    });
const $a705e6c276c287ea$export$483508f263cba397 = 'state.actions.ui.SET_CURRENT_PAGE';
const $a705e6c276c287ea$export$6f9713cf11255bd4 = (payload)=>({
        type: $a705e6c276c287ea$export$483508f263cba397,
        payload: payload
    });
const $a705e6c276c287ea$export$a871a4533fe0415c = 'state.actions.ui.SET_IS_TABLE_DISABLED';
const $a705e6c276c287ea$export$adbd404608132b43 = (isDisabled)=>({
        type: $a705e6c276c287ea$export$a871a4533fe0415c,
        payload: isDisabled
    });
const $a705e6c276c287ea$export$a3bc24c2e3b7c2a2 = 'state.actions.ui.DISABLE_USER_PICKER';
const $a705e6c276c287ea$export$da8d58cd19fa9174 = ()=>({
        type: $a705e6c276c287ea$export$a3bc24c2e3b7c2a2
    });
const $a705e6c276c287ea$export$91f1228c532af4 = 'state.actions.ui.SET_ON_ISSUE_VIEW_TRANSITION';
const $a705e6c276c287ea$export$fa4a37077fc8610b = (onIssueViewTransition)=>({
        type: $a705e6c276c287ea$export$91f1228c532af4,
        payload: onIssueViewTransition
    });
const $a705e6c276c287ea$export$c00a50fc22eee33c = 'state.actions.ui.SET_JSM_QUEUE_DURATION_EVENT';
const $a705e6c276c287ea$export$834790f742597c01 = (useJSMQueueDurationEvent)=>({
        type: $a705e6c276c287ea$export$c00a50fc22eee33c,
        payload: useJSMQueueDurationEvent
    });
const $a705e6c276c287ea$export$9699e624bf23e2bb = 'state.actions.ui.SET_RENDER_SIDE_BAR_ICON';
const $a705e6c276c287ea$export$28433d58f8f5bf2 = (renderSidebarIcon)=>({
        type: $a705e6c276c287ea$export$9699e624bf23e2bb,
        payload: renderSidebarIcon
    });
const $a705e6c276c287ea$export$dd236613845bdbce = 'state.actions.ui.SET_REFRESH_SIDE_BAR';
const $a705e6c276c287ea$export$a6ee15011295b023 = (refreshSidebar)=>({
        type: $a705e6c276c287ea$export$dd236613845bdbce,
        payload: refreshSidebar
    });

});

parcelRegister("lXq56", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d630193d860705$export$2e2bcd8739ae039);

var $k6gLU = parcelRequire("k6gLU");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$45d630193d860705$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: (0, $k6gLU.default).title,
        description: (0, $k6gLU.default).description,
        messageId: 'issue-table.flags.field.assignee.error',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $k6gLU.default).refresh,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ]
    });

});
parcelRegister("k6gLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa3c4201120e3c6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4fa3c4201120e3c6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-table.flags.field.assignee.error.title",
        "defaultMessage": "Looks like there was a problem"
    },
    description: {
        "id": "issue-table.flags.field.assignee.error.description",
        "defaultMessage": "The assignee field cannot be edited. Try refreshing the page."
    },
    refresh: {
        "id": "issue-table.flags.field.assignee.error.refresh",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("P5lER", function(module, exports) {

$parcel$export(module.exports, "default", () => $202ca6aee57ec2a7$export$2e2bcd8739ae039);

var $2fudZ = parcelRequire("2fudZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$202ca6aee57ec2a7$export$2e2bcd8739ae039 = ({ issueKey: issueKey, fieldName: fieldName, reasonMessage: reasonMessage })=>{
    if (reasonMessage) return {
        type: 'error',
        title: (0, $2fudZ.default).title,
        description: [
            (0, $2fudZ.default).description,
            {
                issueKey: issueKey,
                fieldName: fieldName.toLowerCase(),
                reasonMessage: reasonMessage
            }
        ],
        messageId: 'issue-table.flags.field.update.error',
        messageType: 'transactional'
    };
    return {
        type: 'error',
        title: (0, $2fudZ.default).title,
        description: [
            (0, $2fudZ.default).simpleDescription,
            {
                issueKey: issueKey,
                fieldName: fieldName.toLowerCase()
            }
        ]
    };
};

});
parcelRegister("2fudZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c5217061cad4f94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c5217061cad4f94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-table.flags.field.update.error.title",
        "defaultMessage": "Issue could not be updated"
    },
    description: {
        "id": "issue-table.flags.field.update.error.description",
        "defaultMessage": "The ''{fieldName}'' field of {issueKey} could not be updated. {reasonMessage}"
    },
    simpleDescription: {
        "id": "issue-table.flags.field.update.error.simple-description",
        "defaultMessage": "The ''{fieldName}'' field of {issueKey} could not be updated. Please try again later."
    }
});

});



parcelRegister("8jMQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf970ede90fa02b$export$2e2bcd8739ae039);
parcelRequire("c66Ur");

var $e1AU2 = parcelRequire("e1AU2");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $3ORnc = parcelRequire("3ORnc");

var $cBenX = parcelRequire("cBenX");

var $iNIX4 = parcelRequire("iNIX4");

var $evCa2 = parcelRequire("evCa2");

var $l7LqN = parcelRequire("l7LqN");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$caf970ede90fa02b$export$2e2bcd8739ae039 = (action$, store)=>(0, $e1AU2.combineEpics)(...[
        (0, $iNIX4.default),
        (0, $cBenX.default),
        (0, $l7LqN.default),
        (0, $evCa2.default),
        (0, $3ORnc.default)
    ])(action$, store).catch((error, stream)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('issue-table.ops', 'Unhandled error');
        (0, $jcw0u.default)({
            meta: {
                id: 'opsUnhandledError',
                packageName: 'jiraIssueTable',
                teamName: 'jsd-shield'
            },
            error: new Error(error)
        });
        return stream;
    });

});
parcelRegister("3ORnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a598fcb49c92e92$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $g99kU = parcelRequire("g99kU");

var $lLpMQ = parcelRequire("lLpMQ");
var // @ts-expect-error - No overload matches this call
$4a598fcb49c92e92$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $lLpMQ.default), (0, $g99kU.default));

});
parcelRegister("g99kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a15ebf9a05109c$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $g5X3G = parcelRequire("g5X3G");

var $bIL7p = parcelRequire("bIL7p");

var $1GPUJ = parcelRequire("1GPUJ");

var $7NCXO = parcelRequire("7NCXO");

var $6ymL0 = parcelRequire("6ymL0");

var $jxVFn = parcelRequire("jxVFn");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$14a15ebf9a05109c$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $1GPUJ.UNLOCK_FIELD), (0, $1GPUJ.LOCK_FIELD), (0, $1GPUJ.UNLOCK_ALL_FIELDS), (0, $7NCXO.UPDATE_PROVIDED_ISSUE_KEYS)).switchMap(()=>{
        const state = store.getState();
        const selectionServiceActions = (0, $6ymL0.getSelectionServiceActions)(state);
        if (!selectionServiceActions) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue-table.ops.bulk-select.refresh-selection', 'selectionServiceActions is not set.');
            (0, $jcw0u.default)({
                meta: {
                    id: 'opsRefreshSelection',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
            return (0, $kVLXA.Observable).empty();
        }
        const { refreshSelection: refreshSelection } = selectionServiceActions;
        const issues = (0, $jxVFn.mergeIssueKeysWithLockedIssues)(state);
        refreshSelection(issues.map((0, $g5X3G.toIssueKey)));
        return (0, $kVLXA.Observable).of((0, $bIL7p.setHasSelectionAction)({
            hasSelection: issues.length > 0
        }));
    });

});
parcelRegister("bIL7p", function(module, exports) {

$parcel$export(module.exports, "SELECT_ROW", () => $b3a1c4a775d22849$export$23dac9ed99690a9c);
$parcel$export(module.exports, "selectRowAction", () => $b3a1c4a775d22849$export$dd5cc62656892181);
$parcel$export(module.exports, "SET_LAST_CLICKED_ROW", () => $b3a1c4a775d22849$export$30e11d52d9d0165c);
$parcel$export(module.exports, "setLastClickedRowAction", () => $b3a1c4a775d22849$export$18aafbbe21119db1);
$parcel$export(module.exports, "SET_SELECTION_SERVICE_ACTIONS", () => $b3a1c4a775d22849$export$b0dea82abc030a23);
$parcel$export(module.exports, "setSelectionServiceActionsAction", () => $b3a1c4a775d22849$export$b43829a128a6202f);
$parcel$export(module.exports, "SET_HAS_SELECTION", () => $b3a1c4a775d22849$export$7e3b4dceab941566);
$parcel$export(module.exports, "setHasSelectionAction", () => $b3a1c4a775d22849$export$6647d68ebe704b97);
const $b3a1c4a775d22849$export$23dac9ed99690a9c = 'state.actions.bulk-selection.SELECT_ROW';
const $b3a1c4a775d22849$export$dd5cc62656892181 = (data, analyticsEvent)=>({
        type: $b3a1c4a775d22849$export$23dac9ed99690a9c,
        payload: data,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b3a1c4a775d22849$export$30e11d52d9d0165c = 'state.actions.bulk-selection.SET_LAST_CLICKED_ROW';
const $b3a1c4a775d22849$export$18aafbbe21119db1 = (data)=>({
        type: $b3a1c4a775d22849$export$30e11d52d9d0165c,
        payload: data
    });
const $b3a1c4a775d22849$export$b0dea82abc030a23 = 'state.actions.bulk-selection.SET_SELECTION_SERVICE_ACTIONS';
const $b3a1c4a775d22849$export$b43829a128a6202f = (data)=>({
        type: $b3a1c4a775d22849$export$b0dea82abc030a23,
        payload: data
    });
const $b3a1c4a775d22849$export$7e3b4dceab941566 = 'state.actions.bulk-selection.SET_HAS_SELECTION';
const $b3a1c4a775d22849$export$6647d68ebe704b97 = (data)=>({
        type: $b3a1c4a775d22849$export$7e3b4dceab941566,
        payload: data
    });

});

parcelRegister("1GPUJ", function(module, exports) {

$parcel$export(module.exports, "LOCK_FIELD", () => $eb29135e0aa6b55e$export$9577624537ff74ab);
$parcel$export(module.exports, "lockFieldAction", () => $eb29135e0aa6b55e$export$293db56aa8facb7a);
$parcel$export(module.exports, "UNLOCK_FIELD", () => $eb29135e0aa6b55e$export$aa4a28625eb23c44);
$parcel$export(module.exports, "unlockFieldAction", () => $eb29135e0aa6b55e$export$539db32098e03442);
$parcel$export(module.exports, "UNLOCK_ALL_FIELDS", () => $eb29135e0aa6b55e$export$43011103b4549dc1);
$parcel$export(module.exports, "unlockAllFieldsAction", () => $eb29135e0aa6b55e$export$4db21b2c60d7d96);
// LOCK_FIELD
const $eb29135e0aa6b55e$export$9577624537ff74ab = 'state.actions.field.lock.LOCK_FIELD';
const $eb29135e0aa6b55e$export$293db56aa8facb7a = (issueKey, fieldId, positionIndex)=>({
        type: $eb29135e0aa6b55e$export$9577624537ff74ab,
        payload: {
            issueKey: issueKey,
            positionIndex: positionIndex,
            fieldId: fieldId
        }
    });
const $eb29135e0aa6b55e$export$aa4a28625eb23c44 = 'state.actions.field.lock.UNLOCK_FIELD';
const $eb29135e0aa6b55e$export$539db32098e03442 = (issueKey, fieldId)=>({
        type: $eb29135e0aa6b55e$export$aa4a28625eb23c44,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId
        }
    });
const $eb29135e0aa6b55e$export$43011103b4549dc1 = 'state.actions.field.lock.UNLOCK_ALL_FIELDS';
const $eb29135e0aa6b55e$export$4db21b2c60d7d96 = ()=>({
        type: $eb29135e0aa6b55e$export$43011103b4549dc1
    });

});

parcelRegister("7NCXO", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PROVIDED_ISSUE_KEYS", () => $544ccf4fd18a4c7c$export$c3876599022b4e78);
$parcel$export(module.exports, "updateProvidedIssueKeysAction", () => $544ccf4fd18a4c7c$export$7435108bc993705e);
$parcel$export(module.exports, "ISSUE_EDIT_STARTED", () => $544ccf4fd18a4c7c$export$1e3bdce3d6fbd74a);
$parcel$export(module.exports, "issueEditStartedAction", () => $544ccf4fd18a4c7c$export$f5109cd21d1574dd);
const $544ccf4fd18a4c7c$export$c3876599022b4e78 = 'state.actions.issues.UPDATE_PROVIDED_ISSUE_KEYS';
const $544ccf4fd18a4c7c$export$7435108bc993705e = (issueKeys)=>({
        type: $544ccf4fd18a4c7c$export$c3876599022b4e78,
        payload: {
            issueKeys: issueKeys
        }
    });
const $544ccf4fd18a4c7c$export$1e3bdce3d6fbd74a = 'state.actions.issues.ISSUE_EDIT_STARTED';
const $544ccf4fd18a4c7c$export$f5109cd21d1574dd = (fieldType, issueKey, analyticsEvent)=>({
        type: $544ccf4fd18a4c7c$export$1e3bdce3d6fbd74a,
        payload: {
            issueKey: issueKey,
            fieldType: fieldType
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("6ymL0", function(module, exports) {

$parcel$export(module.exports, "getLastClickedRow", () => $cf023105973700c4$export$ec93017dc2536f2e);
$parcel$export(module.exports, "getSelectionServiceActions", () => $cf023105973700c4$export$e9a1d97035e6d261);
const $cf023105973700c4$export$ec93017dc2536f2e = (state)=>state.bulkSelection.lastClickedRow;
const $cf023105973700c4$export$e9a1d97035e6d261 = (state)=>state.bulkSelection.selectionServiceActions;
const $cf023105973700c4$export$2cf0f4905f25f4a4 = (state)=>state.bulkSelection.hasSelection;

});

parcelRegister("jxVFn", function(module, exports) {

$parcel$export(module.exports, "getProvidedIssueKeys", () => $153d970b5159576c$export$af07af04b01adfd5);
$parcel$export(module.exports, "mergeIssueKeysWithLockedIssues", () => $153d970b5159576c$export$12a917ff04fbe0e8);
$parcel$export(module.exports, "getAllKnownIssueKeys", () => $153d970b5159576c$export$ef16b3729204077d);
$parcel$export(module.exports, "getIssueKeyPositionIndex", () => $153d970b5159576c$export$7424fd062ec0b8e4);
$parcel$export(module.exports, "isIssueKnown", () => $153d970b5159576c$export$46d566aafca01d9e);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $7qDUb = parcelRequire("7qDUb");

var $8QpSo = parcelRequire("8QpSo");

var $g5X3G = parcelRequire("g5X3G");

var $37Hsj = parcelRequire("37Hsj");

var $kMqdJ = parcelRequire("kMqdJ");

var $hxijc = parcelRequire("hxijc");
const $153d970b5159576c$export$af07af04b01adfd5 = (state)=>(0, $37Hsj.getPersisted)(state).providedIssueKeys;
const $153d970b5159576c$export$48c3724a62ab72dc = (0, $8QpSo.default)((0, $hxijc.getIndexesOfStringArray));
const $153d970b5159576c$var$areLockedIssuesAlreadyInPosition = (lockedIssuesByKey, originalIssueKeys)=>Object.entries(lockedIssuesByKey).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    ([issueKey, lockedIssue])=>originalIssueKeys[lockedIssue.positionIndex] === issueKey);
const $153d970b5159576c$var$desparsify = (issueKeys)=>{
    const resultArray = [];
    issueKeys.forEach((issueKey, positionIndex)=>resultArray.push({
            issueKey: issueKey,
            positionIndex: positionIndex
        }));
    return resultArray;
};
const $153d970b5159576c$export$12a917ff04fbe0e8 = (0, $dGvGJ.createSelector)((0, $kMqdJ.getLockedIssues), $153d970b5159576c$export$af07af04b01adfd5, (lockedIssuesByKey, originalIssueKeys)=>{
    // Performance shortcut
    if ($153d970b5159576c$var$areLockedIssuesAlreadyInPosition(lockedIssuesByKey, originalIssueKeys)) return originalIssueKeys;
    const resultIssueKeys = [];
    const originalIssueKeysIterator = new (0, $hxijc.IteratorWrapper)($153d970b5159576c$var$desparsify(originalIssueKeys));
    const lockedRowsIterator = new (0, $hxijc.IteratorWrapper)((0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(lockedIssuesByKey, (lockedIssue)=>lockedIssue.positionIndex));
    let issueIndexOffset = 0;
    let newArrayLength = originalIssueKeys.length + issueIndexOffset;
    do {
        const nextIssue = originalIssueKeysIterator.current;
        const nextLockedIssue = lockedRowsIterator.current;
        if (nextIssue.done) {
            if (!nextLockedIssue.done) {
                const latestPossibleInsertionPoint = Math.min(nextLockedIssue.value.positionIndex, newArrayLength);
                resultIssueKeys[latestPossibleInsertionPoint] = nextLockedIssue.value.issueKey;
                lockedRowsIterator.next();
                issueIndexOffset += 1;
            }
        } else {
            const realNextIssueIndex = nextIssue.value.positionIndex + issueIndexOffset;
            if (nextLockedIssue.done) {
                if (!lockedIssuesByKey[nextIssue.value.issueKey]) resultIssueKeys[realNextIssueIndex] = nextIssue.value.issueKey;
                else issueIndexOffset -= 1;
                originalIssueKeysIterator.next();
            } else if (realNextIssueIndex >= nextLockedIssue.value.positionIndex) {
                if (realNextIssueIndex === nextLockedIssue.value.positionIndex && nextLockedIssue.value.issueKey === nextIssue.value.issueKey) {
                    resultIssueKeys[nextLockedIssue.value.positionIndex] = nextLockedIssue.value.issueKey;
                    originalIssueKeysIterator.next();
                    lockedRowsIterator.next();
                } else {
                    resultIssueKeys[nextLockedIssue.value.positionIndex] = nextLockedIssue.value.issueKey;
                    lockedRowsIterator.next();
                    issueIndexOffset += 1;
                }
            } else if (lockedIssuesByKey[nextIssue.value.issueKey]) {
                originalIssueKeysIterator.next();
                issueIndexOffset -= 1;
            } else {
                resultIssueKeys[realNextIssueIndex] = nextIssue.value.issueKey;
                originalIssueKeysIterator.next();
            }
        }
        newArrayLength = originalIssueKeys.length + issueIndexOffset;
    }while (!originalIssueKeysIterator.current.done || !lockedRowsIterator.current.done);
    resultIssueKeys.length = Math.max(0, newArrayLength);
    return resultIssueKeys;
});
const $153d970b5159576c$export$ef16b3729204077d = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $153d970b5159576c$export$12a917ff04fbe0e8(state).reduce((result, issueKey)=>{
        !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueKey) && result.push((0, $g5X3G.toIssueKey)(issueKey));
        return result;
    }, []);
const $153d970b5159576c$export$7424fd062ec0b8e4 = (0, $dGvGJ.createSelector)($153d970b5159576c$export$12a917ff04fbe0e8, // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type. | TS7006 - Parameter 'issueKeyToFind' implicitly has an 'any' type.
(state, issueKeyToFind)=>issueKeyToFind, (issueKeys, issueKeyToFind)=>$153d970b5159576c$export$48c3724a62ab72dc(issueKeys)[issueKeyToFind]);
const $153d970b5159576c$export$46d566aafca01d9e = (state, issueKey)=>$153d970b5159576c$export$7424fd062ec0b8e4(state, issueKey) !== undefined;

});
parcelRegister("37Hsj", function(module, exports) {

$parcel$export(module.exports, "getPersisted", () => $cc8ecbfe0b466aeb$export$5239a0a7977ca4de);
$parcel$export(module.exports, "getFieldInitialization", () => $cc8ecbfe0b466aeb$export$4b5927991797d9ed);
$parcel$export(module.exports, "getInitialAppProps", () => $cc8ecbfe0b466aeb$export$776ca926a037ba63);
const $cc8ecbfe0b466aeb$export$5239a0a7977ca4de = (state)=>state.persisted;
const $cc8ecbfe0b466aeb$export$4b5927991797d9ed = (state)=>state.fieldInitialization;
const $cc8ecbfe0b466aeb$export$776ca926a037ba63 = (state)=>state.initialAppProps;

});

parcelRegister("kMqdJ", function(module, exports) {

$parcel$export(module.exports, "getLockedIssues", () => $a4565527d2ef2712$export$a17d008b40b9a206);
$parcel$export(module.exports, "getLockedIssueCountAssumingIssueKeyWillBeLocked", () => $a4565527d2ef2712$export$d1184755c39ce1f8);
$parcel$export(module.exports, "getIsFieldLocked", () => $a4565527d2ef2712$export$3954fe8afa4b46a);

var $37Hsj = parcelRequire("37Hsj");
const $a4565527d2ef2712$export$a17d008b40b9a206 = (state)=>(0, $37Hsj.getPersisted)(state).lockedIssues;
const $a4565527d2ef2712$export$d1184755c39ce1f8 = (state, issueKey)=>{
    const issueKeys = Object.keys($a4565527d2ef2712$export$a17d008b40b9a206(state));
    issueKeys.push(issueKey);
    return new Set(issueKeys).size;
};
const $a4565527d2ef2712$export$3954fe8afa4b46a = (state, props)=>{
    const { issueKey: issueKey, fieldDescriptor: { fieldId: fieldId } } = props;
    const lockedIssue = $a4565527d2ef2712$export$a17d008b40b9a206(state)[issueKey];
    return lockedIssue && !!lockedIssue.fields[fieldId];
};

});

parcelRegister("hxijc", function(module, exports) {

$parcel$export(module.exports, "getIndexesOfStringArray", () => $92e90064846435af$export$2b158dd2191953a2);
$parcel$export(module.exports, "IteratorWrapper", () => $92e90064846435af$export$8dbb1a760abb7548);
const $92e90064846435af$export$2b158dd2191953a2 = (issueKeys)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const positionIndexByIssueKey = {};
    issueKeys.forEach((value, index)=>{
        positionIndexByIssueKey[value] = index;
    });
    return positionIndexByIssueKey;
};
class $92e90064846435af$export$8dbb1a760abb7548 {
    constructor(sourceArray){
        this.iterator = sourceArray.values();
        // @ts-expect-error - TS2322 - Type 'IteratorResult<T, any>' is not assignable to type 'IteratorResult<T>'.
        this.current = this.iterator.next();
        this.lastNonDoneValue = this.current.done ? undefined : this.current.value;
    }
    next() {
        // @ts-expect-error - TS2322 - Type 'IteratorResult<T, any>' is not assignable to type 'IteratorResult<T>'.
        this.current = this.iterator.next();
        return this.current;
    }
}

});



parcelRegister("lLpMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $04441df202a58373$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $7qDUb = parcelRequire("7qDUb");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $g5X3G = parcelRequire("g5X3G");

var $bIL7p = parcelRequire("bIL7p");

var $6ymL0 = parcelRequire("6ymL0");

var $jxVFn = parcelRequire("jxVFn");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$04441df202a58373$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bIL7p.SELECT_ROW)).switchMap((action)=>{
        const state = store.getState();
        const selectionServiceActions = (0, $6ymL0.getSelectionServiceActions)(state);
        if (!selectionServiceActions) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue-table.ops.bulk-select.select-rows', 'selectionServiceActions is not set.');
            (0, $jcw0u.default)({
                meta: {
                    id: 'opsSelectRows',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
            return (0, $kVLXA.Observable).empty();
        }
        const { selectIssues: selectIssues, deselectIssues: deselectIssues } = selectionServiceActions;
        const { rowId: rowId, selection: selection, isShiftKeyDown: isShiftKeyDown } = action.payload;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const lastClickedRow = (0, $6ymL0.getLastClickedRow)(state);
        if (isShiftKeyDown && !!lastClickedRow) {
            const allIssues = (0, $jxVFn.getAllKnownIssueKeys)(state);
            const [start, end] = (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))([
                allIssues.indexOf((0, $g5X3G.toIssueKey)(rowId)),
                allIssues.indexOf((0, $g5X3G.toIssueKey)(lastClickedRow))
            ]);
            const issuesIncluded = allIssues.slice(start, end + 1);
            (selection ? selectIssues : deselectIssues)(issuesIncluded, analyticsEvent);
            return (0, $kVLXA.Observable).of((0, $bIL7p.setLastClickedRowAction)({
                rowId: rowId
            }));
        }
        (selection ? selectIssues : deselectIssues)([
            (0, $g5X3G.toIssueKey)(rowId)
        ], analyticsEvent);
        return (0, $kVLXA.Observable).of((0, $bIL7p.setLastClickedRowAction)({
            rowId: rowId
        }));
    });

});


parcelRegister("cBenX", function(module, exports) {

$parcel$export(module.exports, "default", () => $289d5a4029d60b6a$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $d7wpe = parcelRequire("d7wpe");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$289d5a4029d60b6a$export$2e2bcd8739ae039 = (action$, store)=>(0, $e1AU2.combineEpics)((0, $d7wpe.default)())(action$, store);

});
parcelRegister("d7wpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $73857eb1ffba72e4$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("6cbqE");

var $gtrZ5 = parcelRequire("gtrZ5");

var $k0aCV = parcelRequire("k0aCV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73857eb1ffba72e4$export$2e2bcd8739ae039 = ()=>{
    const initializeActionDispatchedFields = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (action$)=>action$.ofType((0, $gtrZ5.UPDATE_COLUMNS)).switchMap((action)=>{
            const initializationColumnsArray = action.payload.columns// @ts-expect-error - TS7006 - Parameter 'columnProp' implicitly has an 'any' type.
            .filter((columnProp)=>{
                const fieldConfiguration = (0, $k0aCV.getJsonColumnConfiguration)(columnProp.fieldType);
                return fieldConfiguration && fieldConfiguration.needsInitialization;
            })// @ts-expect-error - TS7006 - Parameter 'columnProp' implicitly has an 'any' type.
            .filter((columnProp)=>{
                const fieldIdSet = initializeActionDispatchedFields[columnProp.fieldType];
                const needsInitialize = !fieldIdSet || !fieldIdSet.has(columnProp.id);
                if (fieldIdSet) fieldIdSet.add(columnProp.id);
                else initializeActionDispatchedFields[columnProp.fieldType] = new Set([
                    columnProp.id
                ]);
                return needsInitialize;
            }).map((0, $gtrZ5.initializeColumnAction));
            return (0, $kVLXA.Observable).from(initializationColumnsArray);
        });
};

});
parcelRegister("gtrZ5", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLUMNS", () => $0e8796820ea4084f$export$c9ad0e7c9c02af77);
$parcel$export(module.exports, "updateColumnsAction", () => $0e8796820ea4084f$export$3d6d47022c85b605);
$parcel$export(module.exports, "INITIALIZE_COLUMN", () => $0e8796820ea4084f$export$8531a79f419258d8);
$parcel$export(module.exports, "initializeColumnAction", () => $0e8796820ea4084f$export$12f5c79cbb2fd6b4);
const $0e8796820ea4084f$export$c9ad0e7c9c02af77 = 'state.actions.columns.UPDATE_COLUMNS';
const $0e8796820ea4084f$export$3d6d47022c85b605 = (columns)=>({
        type: $0e8796820ea4084f$export$c9ad0e7c9c02af77,
        payload: {
            columns: columns
        }
    });
const $0e8796820ea4084f$export$8531a79f419258d8 = 'state.actions.columns.INITIALIZE_COLUMN';
const $0e8796820ea4084f$export$12f5c79cbb2fd6b4 = (column)=>({
        type: $0e8796820ea4084f$export$8531a79f419258d8,
        payload: {
            column: column
        }
    });

});

parcelRegister("k0aCV", function(module, exports) {

$parcel$export(module.exports, "getJsonColumnConfiguration", () => $36aa90ea016ae509$export$34c320c31bc4122b);
$parcel$export(module.exports, "default", () => $36aa90ea016ae509$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $9XE6b = parcelRequire("9XE6b");

var $5mon3 = parcelRequire("5mon3");

var $l66N2 = parcelRequire("l66N2");

var $gwbmu = parcelRequire("gwbmu");

var $WFrhP = parcelRequire("WFrhP");

var $cORU2 = parcelRequire("cORU2");
const $36aa90ea016ae509$var$getAdditionalColumnWidth = (index, totalColumns)=>(index > 0 ? (0, $WFrhP.COLUMN_GUTTER).left : 0) + (index < totalColumns - 1 ? (0, $WFrhP.COLUMN_GUTTER).right : 0);
const $36aa90ea016ae509$var$finaliseColumnConfiguration = (config, index, totalColumns)=>{
    const additionalWidth = $36aa90ea016ae509$var$getAdditionalColumnWidth(index, totalColumns);
    return (0, $7uUwQ.chain)(config)// @ts-expect-error - TS2571 - Object is of type 'unknown'.
    .updateIn([
        'minWidth'
    ], (minWidth)=>Math.max((0, $5mon3.MIN_WIDTH), minWidth + additionalWidth))// @ts-expect-error - TS2571 - Object is of type 'unknown'.
    .updateIn([
        'maxWidth'
    ], (maxWidth)=>Math.max((0, $5mon3.MIN_WIDTH), maxWidth + additionalWidth)).value();
};
const $36aa90ea016ae509$var$getKnownFieldType = (fieldType)=>// @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'keyof DataSelectorPropsMap | null'.
    (0, $5mon3.BUILTIN_COLUMN_CONFIGURATIONS)[fieldType] ? fieldType : null;
const $36aa90ea016ae509$export$34c320c31bc4122b = (fieldType)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5mon3.BUILTIN_COLUMN_CONFIGURATIONS), fieldType);
const $36aa90ea016ae509$var$getJsonColumnProps = (fieldType, columnProps)=>{
    const builtinJsonColumnConfiguration = $36aa90ea016ae509$export$34c320c31bc4122b(fieldType);
    return {
        ...builtinJsonColumnConfiguration,
        fieldId: columnProps.id,
        fieldType: fieldType
    };
};
const $36aa90ea016ae509$var$getHtmlColumnProps = (columnProps)=>{
    const { fieldType: fieldType } = columnProps;
    const columnConfiguration = (0, $5mon3.BUILTIN_HTML_COLUMN_CONFIGURATIONS)[fieldType] || (0, $5mon3.FALLBACK_COLUMN_CONFIGURATION);
    return {
        ...columnConfiguration,
        fieldId: columnProps.id,
        fieldType: fieldType
    };
};
const $36aa90ea016ae509$var$transformJsonColumnProps = (fieldType, columnProps, FieldDataSelector, HeaderComponent, createCell)=>{
    const { id: id, title: title } = columnProps;
    const mergedColumnProps = $36aa90ea016ae509$var$getJsonColumnProps(fieldType, columnProps);
    const { minWidth: minWidth, maxWidth: maxWidth, canBeMultiLine: canBeMultiLine, FieldComponent: FieldComponent } = mergedColumnProps;
    const jsonComponentArgs = {
        fieldType: fieldType,
        FieldComponent: FieldComponent
    };
    return {
        id: id,
        title: title,
        minWidth: columnProps.minWidth || minWidth,
        maxWidth: columnProps.maxWidth || maxWidth,
        canBeMultiLine: canBeMultiLine,
        // @ts-expect-error - TS2345 - Argument of type '{ fieldType: T; FieldComponent: ComponentType<JsonComponentProps<T>>; }' is not assignable to parameter of type 'JsonComponentArgs<keyof DataSelectorPropsMap>'.
        CellComponent: createCell(jsonComponentArgs, mergedColumnProps, FieldDataSelector),
        HeaderComponent: HeaderComponent
    };
};
const $36aa90ea016ae509$var$transformHtmlColumnProps = (// @ts-expect-error - TS7006 - Parameter 'columnProps' implicitly has an 'any' type.
columnProps, FieldDataSelector, HeaderComponent, createCell)=>{
    const { id: id, title: title } = columnProps;
    const mergedColumnProps = $36aa90ea016ae509$var$getHtmlColumnProps(columnProps);
    const { minWidth: minWidth, maxWidth: maxWidth, canBeMultiLine: canBeMultiLine } = mergedColumnProps;
    return {
        id: id,
        title: title,
        minWidth: columnProps.minWidth || minWidth,
        maxWidth: columnProps.maxWidth || maxWidth,
        canBeMultiLine: canBeMultiLine,
        CellComponent: createCell(null, mergedColumnProps, FieldDataSelector),
        HeaderComponent: HeaderComponent
    };
};
const $36aa90ea016ae509$export$6e8deebce7129a99 = (FieldDataSelector, columns, createCell)=>columns.map((column)=>{
        const knownFieldType = $36aa90ea016ae509$var$getKnownFieldType(column.fieldType);
        if (column.fieldType === 'checkbox') return {
            id: 'checkbox',
            title: '',
            minWidth: 25,
            maxWidth: 25,
            CellComponent: (0, $gwbmu.default),
            HeaderComponent: (0, $l66N2.default)
        };
        if (knownFieldType) return $36aa90ea016ae509$var$transformJsonColumnProps(knownFieldType, column, FieldDataSelector, // @ts-expect-error - Argument of type 'ConnectedComponent<ComponentType<any>, { [x: string]: any; [x: number]: any; [x: symbol]: any; context?: Context<ReactReduxContextValue<any, AnyAction>> | undefined; store?: Store<...> | undefined; } | { ...; }>' is not assignable to parameter of type 'ComponentType<HeaderComponentProps>'.
        (0, $cORU2.default), createCell);
        return $36aa90ea016ae509$var$transformHtmlColumnProps(column, FieldDataSelector, // @ts-expect-error - Argument of type 'ConnectedComponent<ComponentType<any>, { [x: string]: any; [x: number]: any; [x: symbol]: any; context?: Context<ReactReduxContextValue<any, AnyAction>> | undefined; store?: Store<...> | undefined; } | { ...; }>' is not assignable to parameter of type 'ComponentType<HeaderComponentProps>'.
        (0, $cORU2.default), createCell);
    })// @ts-expect-error - TS2345 - Argument of type '(column: TableColumn, index: number) => TableColumn' is not assignable to parameter of type '(value: { id: any; title: any; minWidth: any; maxWidth: any; canBeMultiLine: boolean | undefined; CellComponent: CellComponentType; HeaderComponent: ComponentType<HeaderComponentProps>; } | { ...; }, index: number, array: ({ ...; } | { ...; })[]) => TableColumn'.
    .map((column, index)=>$36aa90ea016ae509$var$finaliseColumnConfiguration(column, index, columns.length));
var $36aa90ea016ae509$export$2e2bcd8739ae039 = $36aa90ea016ae509$export$6e8deebce7129a99;

});
parcelRegister("5mon3", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_COLUMN_CONFIGURATION", () => $7d52835a64c6b871$export$9b544c2606a30a3a);
$parcel$export(module.exports, "MIN_WIDTH", () => $7d52835a64c6b871$export$1d9fdc71b83a8eac);
$parcel$export(module.exports, "BUILTIN_COLUMN_CONFIGURATIONS", () => $7d52835a64c6b871$export$a7c09d12ef8597c0);
$parcel$export(module.exports, "BUILTIN_HTML_COLUMN_CONFIGURATIONS", () => $7d52835a64c6b871$export$9f3c8ab747beea8);

var $7uUwQ = parcelRequire("7uUwQ");

var $gwIPs = parcelRequire("gwIPs");



var $l0utm = parcelRequire("l0utm");

var $5isHq = parcelRequire("5isHq");

var $fvOC5 = parcelRequire("fvOC5");

var $gP8gO = parcelRequire("gP8gO");

var $bX58l = parcelRequire("bX58l");

var $39WmR = parcelRequire("39WmR");

var $ebFN1 = parcelRequire("ebFN1");

var $cV5BJ = parcelRequire("cV5BJ");

var $4Q2yp = parcelRequire("4Q2yp");

var $f7C6x = parcelRequire("f7C6x");

var $gsmqm = parcelRequire("gsmqm");

var $13uif = parcelRequire("13uif");

var $fs78R = parcelRequire("fs78R");

var $5N53W = parcelRequire("5N53W");

var $j3MEX = parcelRequire("j3MEX");

var $ggDB2 = parcelRequire("ggDB2");

var $2GyKG = parcelRequire("2GyKG");

var $5khw6 = parcelRequire("5khw6");

var $kz8zy = parcelRequire("kz8zy");

var $8nUnt = parcelRequire("8nUnt");

var $8jtul = parcelRequire("8jtul");

var $2oRcM = parcelRequire("2oRcM");

var $eJplt = parcelRequire("eJplt");
const $7d52835a64c6b871$export$9b544c2606a30a3a = (0, $7uUwQ.freeze)({
    minWidth: (0, $gwIPs.gridSize) * 20,
    maxWidth: (0, $gwIPs.gridSize) * 20,
    canBeMultiLine: true
});
const $7d52835a64c6b871$var$USER_FIELD_CONFIGURATION = {
    minWidth: 100,
    maxWidth: 300,
    canBeMultiLine: true
};
const $7d52835a64c6b871$var$USER_FIELD_TYPES = [
    'creator',
    'reporter',
    'com.atlassian.jira.plugin.system.customfieldtypes:userpicker'
];
const $7d52835a64c6b871$var$MULTI_USER_FIELD_CONFIGURATION = {
    minWidth: 100,
    maxWidth: 200,
    canBeMultiLine: true
};
const $7d52835a64c6b871$var$MULTI_USER_FIELD_TYPES = [
    'com.atlassian.servicedesk:sd-request-participants',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker'
];
const $7d52835a64c6b871$var$FEATURED_DATE_FIELD_CONFIGURATION = {
    minWidth: 90,
    maxWidth: 90,
    doNotRenderTooltip: true,
    canBeMultiLine: true
};
const $7d52835a64c6b871$var$FEATURED_DATE_FIELD_TYPES = [
    'created',
    'updated',
    'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
];
const $7d52835a64c6b871$var$STANDARD_DATE_FIELD_CONFIGURATION = {
    minWidth: 90,
    maxWidth: 90,
    canBeMultiLine: true
};
const $7d52835a64c6b871$var$STANDARD_DATE_FIELD_TYPES = [
    'duedate',
    'resolutiondate'
];
const $7d52835a64c6b871$var$DATETIME_FIELD_CONFIGURATION = {
    minWidth: (0, $gwIPs.gridSize) * 11,
    maxWidth: (0, $gwIPs.gridSize) * 18,
    doNotRenderTooltip: true
};
const $7d52835a64c6b871$var$DATETIME_FIELD_TYPES = [
    'lastViewed',
    'com.atlassian.jira.plugin.system.customfieldtypes:datetime'
];
const $7d52835a64c6b871$var$SHORT_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $gwIPs.gridSize) * 12,
    maxWidth: (0, $gwIPs.gridSize) * 25,
    canBeMultiLine: true
};
const $7d52835a64c6b871$var$SHORT_TEXT_FIELD_TYPES = [
    'com.atlassian.servicedesk:vp-origin',
    'components',
    'com.atlassian.jira.plugin.system.customfieldtypes:select',
    'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
    'resolution',
    'timespent',
    'aggregatetimespent',
    'timeoriginalestimate',
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement',
    'com.atlassian.servicedesk.sentiment:sd-sentiment',
    'com.atlassian.servicedesk.customer-context:sd-csm-organization'
];
const $7d52835a64c6b871$var$LONG_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $gwIPs.gridSize) * 20,
    maxWidth: (0, $gwIPs.gridSize) * 75,
    canBeMultiLine: true
};
const $7d52835a64c6b871$var$LONG_TEXT_FIELD_TYPES = [
    'summary',
    'com.atlassian.jira.plugin.system.customfieldtypes:textfield'
];
const $7d52835a64c6b871$var$MULTI_SELECT_FIELD_CONFIGURATION = {
    minWidth: (0, $gwIPs.gridSize) * 12,
    maxWidth: (0, $gwIPs.gridSize) * 20,
    canBeMultiLine: true
};
// Atlaskit/Tag doesn't truncate long tags until 180px
const $7d52835a64c6b871$var$JSON_MULTI_SELECT_FIELD_CONFIGURATION = {
    minWidth: (0, $gwIPs.gridSize) * 21,
    maxWidth: (0, $gwIPs.gridSize) * 21,
    canBeMultiLine: true
};
const $7d52835a64c6b871$var$MULTI_SELECT_FIELD_TYPES = [
    'com.atlassian.servicedesk:sd-customer-organizations',
    'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    'fixVersions',
    'issuelinks'
];
const $7d52835a64c6b871$var$JSON_MULTI_SELECT_FIELD_TYPES = [
    'labels',
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion',
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker'
];
const $7d52835a64c6b871$var$MULTILINE_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $gwIPs.gridSize) * 20,
    maxWidth: (0, $gwIPs.gridSize) * 75,
    canBeMultiLine: true
};
const $7d52835a64c6b871$var$MULTILINE_TEXT_FIELD_TYPES = [
    'description',
    'com.atlassian.jira.plugin.system.customfieldtypes:textarea'
];
const $7d52835a64c6b871$var$NUMERIC_FIELD_CONFIGURATION = {
    minWidth: (0, $gwIPs.gridSize) * 8,
    maxWidth: (0, $gwIPs.gridSize) * 16
};
const $7d52835a64c6b871$var$NUMERIC_FIELD_TYPES = [
    'com.atlassian.jira.plugin.system.customfieldtypes:float'
];
const $7d52835a64c6b871$var$FIELD_CONFIGURATION_CATEGORIES = [
    {
        fieldTypes: $7d52835a64c6b871$var$USER_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$USER_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$MULTI_USER_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$MULTI_USER_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$FEATURED_DATE_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$FEATURED_DATE_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$STANDARD_DATE_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$STANDARD_DATE_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$DATETIME_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$DATETIME_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$SHORT_TEXT_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$SHORT_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$LONG_TEXT_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$LONG_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$MULTILINE_TEXT_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$MULTILINE_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$MULTI_SELECT_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$MULTI_SELECT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$JSON_MULTI_SELECT_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$JSON_MULTI_SELECT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $7d52835a64c6b871$var$NUMERIC_FIELD_TYPES,
        configuration: $7d52835a64c6b871$var$NUMERIC_FIELD_CONFIGURATION
    }
];
const $7d52835a64c6b871$var$buildFieldConfigurationsFromCategories = (categories)=>categories.reduce((acc, { fieldTypes: fieldTypes, configuration: configuration })=>{
        fieldTypes.forEach((fieldType)=>{
            if (acc[fieldType] != null) throw new Error(`Field configuration for ${fieldType} already defined`);
            acc[fieldType] = configuration;
        });
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
const $7d52835a64c6b871$export$ec8fde615467a6e1 = (0, $7uUwQ.freeze)({
    ...$7d52835a64c6b871$var$buildFieldConfigurationsFromCategories($7d52835a64c6b871$var$FIELD_CONFIGURATION_CATEGORIES),
    issuekey: {
        minWidth: 85,
        maxWidth: 100
    },
    issuetype: {
        minWidth: 16,
        maxWidth: 16,
        // Prevent ellipsis from rendering in IE & Edge
        canBeMultiLine: true
    },
    status: {
        minWidth: 150,
        maxWidth: 200,
        doNotRenderTooltip: true
    },
    priority: {
        minWidth: 16,
        maxWidth: 16
    },
    assignee: {
        minWidth: 100,
        maxWidth: 220,
        canBeMultiLine: true,
        needsInitialization: true
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        minWidth: 182,
        maxWidth: 200
    },
    'com.atlassian.servicedesk:sd-request-feedback': {
        minWidth: (0, $gwIPs.gridSize) * 11,
        maxWidth: (0, $gwIPs.gridSize) * 11
    },
    summary: {
        minWidth: (0, $gwIPs.gridSize) * 20,
        maxWidth: (0, $gwIPs.gridSize) * 75,
        canBeMultiLine: true
    },
    date: {
        minWidth: (0, $gwIPs.gridSize) * 25,
        maxWidth: (0, $gwIPs.gridSize) * 25,
        doNotRenderTooltip: true
    },
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': {
        minWidth: (0, $gwIPs.gridSize) * 25,
        maxWidth: (0, $gwIPs.gridSize) * 25,
        doNotRenderTooltip: true
    },
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': {
        minWidth: (0, $gwIPs.gridSize) * 25,
        maxWidth: (0, $gwIPs.gridSize) * 25
    },
    meatball: {
        minWidth: (0, $gwIPs.gridSize) * 3,
        maxWidth: (0, $gwIPs.gridSize) * 3
    },
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': {
        minWidth: (0, $gwIPs.gridSize) * 22,
        maxWidth: (0, $gwIPs.gridSize) * 25
    },
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': {
        minWidth: (0, $gwIPs.gridSize) * 15,
        maxWidth: (0, $gwIPs.gridSize) * 20
    }
});
const $7d52835a64c6b871$export$1d9fdc71b83a8eac = 48;
const $7d52835a64c6b871$export$a7c09d12ef8597c0 = (0, $7uUwQ.freeze)({
    assignee: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.assignee,
        canBeMultiLine: false,
        FieldComponent: (0, $5isHq.default)
    },
    reporter: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.reporter,
        FieldComponent: (0, $ggDB2.default)
    },
    reporterWithIcon: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.assignee,
        canBeMultiLine: false,
        FieldComponent: (0, $5isHq.default)
    },
    creator: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.creator,
        FieldComponent: (0, $gP8gO.default)
    },
    issuekey: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.issuekey,
        FieldComponent: (0, $ebFN1.default)
    },
    issuetype: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.issuetype,
        FieldComponent: (0, $4Q2yp.default)
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$f790c24298ed441b],
        FieldComponent: (0, $kz8zy.default)
    },
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$991960fb6e9ea7dd],
        FieldComponent: (0, $l0utm.AsyncAffectedServices)
    },
    labels: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.labels,
        FieldComponent: (0, $f7C6x.default)
    },
    status: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.status,
        FieldComponent: (0, $8nUnt.default)
    },
    statusCategory: {
        // using the same width config as status here since its also rendering lozenges
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.status,
        FieldComponent: (0, $eJplt.default)
    },
    summary: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.summary,
        FieldComponent: (0, $8jtul.default)
    },
    priority: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.priority,
        FieldComponent: (0, $j3MEX.default)
    },
    date: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.date,
        FieldComponent: (0, $bX58l.default)
    },
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$b84257e6dcaab24d],
        FieldComponent: (0, $fvOC5.CmdbObjects)
    },
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$dd2fa454b47497da],
        FieldComponent: (0, $2GyKG.default)
    },
    meatball: {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1.meatball,
        FieldComponent: (0, $cV5BJ.default)
    },
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$f0f60e2d773695fc],
        FieldComponent: (0, $gsmqm.default)
    },
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$794539092c70e595],
        FieldComponent: (0, $2oRcM.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$d8fae0f9b622e615],
        FieldComponent: (0, $fs78R.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$155ae54d06c908ea],
        FieldComponent: (0, $fs78R.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$2ddc21f5fedfaf92],
        FieldComponent: (0, $13uif.default)
    },
    'com.atlassian.servicedesk:sd-request-participants': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $ff417e86d915450f$export$e918afe651ac9e7a],
        FieldComponent: (0, $13uif.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$5ae60777f05f3dfa],
        FieldComponent: (0, $fs78R.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$734a41c9fe85799a],
        FieldComponent: (0, $fs78R.default)
    },
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$80b6ff34fe6a6e00],
        FieldComponent: (0, $39WmR.default)
    },
    'com.atlassian.servicedesk.sentiment:sd-sentiment': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$37cb0de8d249ef22],
        FieldComponent: (0, $5khw6.default)
    },
    'com.atlassian.servicedesk.customer-context:sd-csm-organization': {
        ...$7d52835a64c6b871$export$ec8fde615467a6e1[0, $d0df6a2b823cf08a$export$a370b4fb11e50a66],
        FieldComponent: (0, $5N53W.default)
    }
});
const $7d52835a64c6b871$export$9f3c8ab747beea8 = (0, $7uUwQ.freeze)({
    ...$7d52835a64c6b871$export$ec8fde615467a6e1
});
// @ts-expect-error - Property 'parent' is missing
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$7d52835a64c6b871$export$a7c09d12ef8597c0
});

});
parcelRegister("l0utm", function(module, exports) {

$parcel$export(module.exports, "AsyncAffectedServices", () => $0240ae0bf2ec1adf$export$6f7aec38b8acafe4);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $0240ae0bf2ec1adf$var$LazyAffectedServices = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3NTXi")).then((module)=>module.AffectedServices), {
    moduleId: "./src/packages/issue-table/src/common/fields/affected-services/index.tsx"
});
const $0240ae0bf2ec1adf$export$6f7aec38b8acafe4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "affectedServicesField",
        packageName: "jiraIssueTable",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-affected-services",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0240ae0bf2ec1adf$var$LazyAffectedServices, props)));

});
parcelRegister("3NTXi", function(module, exports) {

let $2c515a402c488d8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2c515a402c488d8e$var$load("g8mX6").then(()=>parcelRequire('fnevj'));

});


parcelRegister("5isHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2a75a85db695e1$export$2e2bcd8739ae039);

var $iQFwo = parcelRequire("iQFwo");

var $p64Ah = parcelRequire("p64Ah");

var $hdMS4 = parcelRequire("hdMS4");

var $ckwFp = parcelRequire("ckwFp");
const $ac2a75a85db695e1$var$mapStateToProps = (state)=>({
        onRefreshSidebar: (0, $iQFwo.getRefreshSidebar)(state)
    });
// @ts-expect-error - TS2345 - Argument of type '<T extends UserFieldType>(props: FieldComponentProps<T>) => JSX.Element' is not assignable to parameter of type 'ComponentType<FieldComponentProps<"assignee" | "reporterWithIcon">>'.
const $ac2a75a85db695e1$var$AssigneeField = (0, $hdMS4.default)((0, $ckwFp.default));
var $ac2a75a85db695e1$export$2e2bcd8739ae039 = (0, $p64Ah.connect)($ac2a75a85db695e1$var$mapStateToProps, {})($ac2a75a85db695e1$var$AssigneeField);

});
parcelRegister("iQFwo", function(module, exports) {

$parcel$export(module.exports, "shouldShowPagination", () => $3c493b0b1d8165e6$export$6e158a7480642df3);
$parcel$export(module.exports, "getCurrentPage", () => $3c493b0b1d8165e6$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getEditingFieldHorizontalOffset", () => $3c493b0b1d8165e6$export$ea5cb0fb82c4318e);
$parcel$export(module.exports, "getEditingFieldVerticalOffset", () => $3c493b0b1d8165e6$export$446d316b4302b660);
$parcel$export(module.exports, "getEditingFieldWidth", () => $3c493b0b1d8165e6$export$9d6a956ae977aa72);
$parcel$export(module.exports, "getTableWidth", () => $3c493b0b1d8165e6$export$4910020ffe58186f);
$parcel$export(module.exports, "getTableHeight", () => $3c493b0b1d8165e6$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "isUserPickerDisabled", () => $3c493b0b1d8165e6$export$dd971882ae58428);
$parcel$export(module.exports, "isTableDisabled", () => $3c493b0b1d8165e6$export$739fac98c5c8c5b1);
$parcel$export(module.exports, "getOnIssueViewTransition", () => $3c493b0b1d8165e6$export$91f8b9de4d443a00);
$parcel$export(module.exports, "getOnIssueViewTransitionCallback", () => $3c493b0b1d8165e6$export$2cdb474716074fd9);
$parcel$export(module.exports, "getUseJSMQueueDurationEvent", () => $3c493b0b1d8165e6$export$95f35106d46731dd);
$parcel$export(module.exports, "getRenderSidebarIcon", () => $3c493b0b1d8165e6$export$a0841f9badd7cdca);
$parcel$export(module.exports, "getRefreshSidebar", () => $3c493b0b1d8165e6$export$c193060edd582f66);

var $8KhWn = parcelRequire("8KhWn");
const $3c493b0b1d8165e6$export$f636b7a9195cdaf0 = (state)=>state.ui;
const $3c493b0b1d8165e6$export$6e158a7480642df3 = (state)=>$3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).showPagination;
const $3c493b0b1d8165e6$export$7945ba8eb1c827e6 = (state)=>$3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).currentPage;
const $3c493b0b1d8165e6$var$maybeEditingFieldPosition = (state)=>(0, $8KhWn.Maybe).fromNull($3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).editingFieldPosition);
const $3c493b0b1d8165e6$export$ea5cb0fb82c4318e = (state)=>$3c493b0b1d8165e6$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.horizontalOffset).orSome(0);
const $3c493b0b1d8165e6$export$446d316b4302b660 = (state)=>$3c493b0b1d8165e6$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.verticalOffset).orSome(0);
const $3c493b0b1d8165e6$export$9d6a956ae977aa72 = (state)=>$3c493b0b1d8165e6$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.fieldWidth).orSome(0);
const $3c493b0b1d8165e6$export$4910020ffe58186f = (state)=>$3c493b0b1d8165e6$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.tableWidth).orSome(0);
const $3c493b0b1d8165e6$export$81ff4c821ba5ba90 = (state)=>$3c493b0b1d8165e6$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.tableHeight).orSome(0);
const $3c493b0b1d8165e6$export$dd971882ae58428 = (state)=>$3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).userPickerDisabled;
const $3c493b0b1d8165e6$export$739fac98c5c8c5b1 = (state)=>$3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).isTableDisabled;
const $3c493b0b1d8165e6$export$91f8b9de4d443a00 = (state)=>$3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).onIssueViewTransition;
const $3c493b0b1d8165e6$export$2cdb474716074fd9 = (state, issueKey)=>{
    const onIssueViewTransition = $3c493b0b1d8165e6$export$91f8b9de4d443a00(state);
    return onIssueViewTransition ? (event)=>onIssueViewTransition(issueKey, event) : undefined;
};
const $3c493b0b1d8165e6$export$95f35106d46731dd = (state)=>$3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).useJSMQueueDurationEvent;
const $3c493b0b1d8165e6$export$a0841f9badd7cdca = (state)=>$3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).renderSidebarIcon;
const $3c493b0b1d8165e6$export$c193060edd582f66 = (state)=>$3c493b0b1d8165e6$export$f636b7a9195cdaf0(state).refreshSidebar;

});

parcelRegister("p64Ah", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $277071e43bd99baf$export$f51a9068ac82ea43);
$parcel$export(module.exports, "IssueTableContext", () => $277071e43bd99baf$export$75838b369936001);
$parcel$export(module.exports, "Provider", () => $277071e43bd99baf$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $277071e43bd99baf$export$64605811ab45167f);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $F2Mxm = parcelRequire("F2Mxm");

var $bC2fB = parcelRequire("bC2fB");


var $guODM = parcelRequire("guODM");
const $277071e43bd99baf$export$f51a9068ac82ea43 = (rootEpic, initialState)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $F2Mxm.default)({
        appName: 'IssueTable',
        initialState: // @ts-expect-error - Type 'Partial<State>' is not assignable to type '{ readonly initialAppProps: { cloudId?: string | undefined; atlassianAccountId?: string | undefined; fabricPfDirUrl?: string | undefined; }; readonly persisted: { lockedIssues: { [x: string]: { issueKey: string; positionIndex: number; fields: { ...; }; } | undefined; }; columns: { ...; }[]; providedIssueKeys: string...'.
        initialState,
        rootReducer: (0, $aB8eX.enableBatching)((0, $guODM.default)),
        rootEpic: rootEpic
    });
const $277071e43bd99baf$export$75838b369936001 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $277071e43bd99baf$export$2881499e37b75b9a = (0, $bC2fB.createProvider)($277071e43bd99baf$export$75838b369936001);
const $277071e43bd99baf$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = {})=>(0, $bC2fB.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $277071e43bd99baf$export$75838b369936001,
        storeKey: (0, $beb728260d5043a2$export$b94951a11282ae6a)
    });

});
const $beb728260d5043a2$export$b94951a11282ae6a = 'issueTableStore';

parcelRegister("guODM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3428b2ad0b5ae3a$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $fmeYM = parcelRequire("fmeYM");

var $boLTJ = parcelRequire("boLTJ");

var $1Aw5o = parcelRequire("1Aw5o");

var $ak3tm = parcelRequire("ak3tm");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b3428b2ad0b5ae3a$var$noopReducer = (state)=>state || {};
var $b3428b2ad0b5ae3a$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    persisted: $1Aw5o.default,
    ui: $ak3tm.default,
    fieldInitialization: $boLTJ.default,
    bulkSelection: $fmeYM.default,
    initialAppProps: $b3428b2ad0b5ae3a$var$noopReducer
});

});
parcelRegister("fmeYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $008a763e7e405baa$export$2e2bcd8739ae039);

var $bIL7p = parcelRequire("bIL7p");
const $008a763e7e405baa$export$c9e0737591e76440 = {
    lastClickedRow: undefined,
    selectionServiceActions: undefined,
    hasSelection: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$008a763e7e405baa$export$2e2bcd8739ae039 = (state = $008a763e7e405baa$export$c9e0737591e76440, action)=>{
    switch(action.type){
        case 0, $bIL7p.SET_LAST_CLICKED_ROW:
            {
                const { rowId: lastClickedRow } = action.payload;
                return {
                    ...state,
                    lastClickedRow: lastClickedRow
                };
            }
        case 0, $bIL7p.SET_SELECTION_SERVICE_ACTIONS:
            {
                const { actions: actions } = action.payload;
                return {
                    ...state,
                    selectionServiceActions: actions
                };
            }
        // @ts-expect-error - TS2678 - Type '"state.actions.bulk-selection.SET_HAS_SELECTION"' is not comparable to type '"state.actions.bulk-selection.SET_LAST_CLICKED_ROW" | "state.actions.bulk-selection.SET_SELECTION_SERVICE_ACTIONS"'.
        case 0, $bIL7p.SET_HAS_SELECTION:
            {
                // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
                const { hasSelection: hasSelection } = action.payload;
                return {
                    ...state,
                    hasSelection: hasSelection
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("boLTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d0bc94d3908441d$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $aKuC7 = parcelRequire("aKuC7");
const $4d0bc94d3908441d$var$DEFAULT_FIELD_INITIALIZATION = {
    assignee: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d0bc94d3908441d$export$2e2bcd8739ae039 = (state = $4d0bc94d3908441d$var$DEFAULT_FIELD_INITIALIZATION, action)=>{
    switch(action.type){
        case 0, $aKuC7.SET_ASSIGNEE_INITIALIZATION_STATE:
            {
                const { avatarUrl: avatarUrl, displayName: displayName, emailAddress: emailAddress } = action.payload;
                return (0, $7uUwQ.assoc)(state, 'assignee', {
                    avatarUrl: avatarUrl,
                    displayName: displayName,
                    emailAddress: emailAddress
                });
            }
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("aKuC7", function(module, exports) {

$parcel$export(module.exports, "SET_ASSIGNEE_INITIALIZATION_STATE", () => $2e9e28d2ef8552c4$export$9b3381a1fe204800);
$parcel$export(module.exports, "setAssigneeInitializationStateAction", () => $2e9e28d2ef8552c4$export$50a032c03fced60e);
const $2e9e28d2ef8552c4$export$9b3381a1fe204800 = 'state.actions.field.initialization.SET_ASSIGNEE_INITIALIZATION_STATE';
const $2e9e28d2ef8552c4$export$50a032c03fced60e = (assigneeInitialization)=>({
        type: $2e9e28d2ef8552c4$export$9b3381a1fe204800,
        payload: assigneeInitialization
    });

});


parcelRegister("1Aw5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b592a13c5ed34f0$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $9xWGk = parcelRequire("9xWGk");

var $h2cxV = parcelRequire("h2cxV");

var $gtrZ5 = parcelRequire("gtrZ5");

var $1GPUJ = parcelRequire("1GPUJ");

var $7NCXO = parcelRequire("7NCXO");

var $ixRuS = parcelRequire("ixRuS");

var $lewnw = parcelRequire("lewnw");
const $8b592a13c5ed34f0$var$DEFAULT_PERSISTED_STATE = {
    columns: [],
    providedIssueKeys: [],
    lockedIssues: {},
    offsets: {
        verticalScrollOffset: 0,
        horizontalScrollOffset: 0
    },
    rowListRef: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b592a13c5ed34f0$export$2e2bcd8739ae039 = (state = $8b592a13c5ed34f0$var$DEFAULT_PERSISTED_STATE, action)=>{
    switch(action.type){
        case 0, $1GPUJ.UNLOCK_FIELD:
            {
                const { issueKey: issueKey, fieldId: fieldId } = action.payload;
                const newLockedIssues = (0, $h2cxV.default)(state, [
                    'lockedIssues',
                    issueKey,
                    'fields',
                    fieldId
                ]);
                const newLockedIssue = newLockedIssues.lockedIssues[issueKey];
                if (newLockedIssue && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(newLockedIssue.fields)) return (0, $h2cxV.default)(state, [
                    'lockedIssues',
                    issueKey
                ]);
                return newLockedIssues;
            }
        case 0, $1GPUJ.LOCK_FIELD:
            {
                const { issueKey: issueKey, fieldId: fieldId, positionIndex: positionIndex } = action.payload;
                return (0, $7uUwQ.updateIn)(state, [
                    'lockedIssues'
                ], (lockedIssues)=>{
                    // Clean up any other issues with the same position
                    const newLockedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))(// @ts-expect-error - TS2769 - No overload matches this call.
                    lockedIssues, (lockedIssue)=>lockedIssue.positionIndex === positionIndex && lockedIssue.issueKey !== issueKey);
                    // Overwrite/update the current locked issue details
                    return (0, $7uUwQ.updateIn)(newLockedIssues, [
                        issueKey
                    ], (lockedIssue)=>{
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const fields = {};
                        fields[fieldId] = true;
                        return (0, $7uUwQ.merge)(lockedIssue || {}, {
                            issueKey: issueKey,
                            positionIndex: positionIndex,
                            fields: fields
                        });
                    });
                });
            }
        case 0, $1GPUJ.UNLOCK_ALL_FIELDS:
            return (0, $7uUwQ.assoc)(state, 'lockedIssues', {});
        case 0, $gtrZ5.UPDATE_COLUMNS:
            {
                const { columns: columns } = action.payload;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(state.columns, columns)) return state;
                return (0, $7uUwQ.assoc)(state, 'columns', columns);
            }
        case 0, $7NCXO.UPDATE_PROVIDED_ISSUE_KEYS:
            {
                const { issueKeys: issueKeys } = action.payload;
                return (0, $7uUwQ.assoc)(state, 'providedIssueKeys', issueKeys);
            }
        case 0, $ixRuS.SET_HORIZONTAL_OFFSET:
            {
                const { horizontalOffset: horizontalOffset } = action.payload;
                return (0, $7uUwQ.assocIn)(state, [
                    'offsets',
                    'horizontalScrollOffset'
                ], horizontalOffset);
            }
        case 0, $ixRuS.SET_VERTICAL_OFFSET:
            {
                const { verticalOffset: verticalOffset } = action.payload;
                return (0, $7uUwQ.assocIn)(state, [
                    'offsets',
                    'verticalScrollOffset'
                ], verticalOffset);
            }
        case 0, $lewnw.SET_ROW_LIST_REF:
            return (0, $7uUwQ.assoc)(state, 'rowListRef', action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("h2cxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2606ddc7a8f25b8$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b2606ddc7a8f25b8$var$unsetInSingle = (state, pathToParent, key)=>{
    if (pathToParent.length === 0) return (0, $7uUwQ.unset)(state, key);
    const ret = (0, $7uUwQ.updateIn)(state, pathToParent, (parent)=>parent ? (0, $7uUwQ.unset)(parent, key) : undefined);
    return ret;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b2606ddc7a8f25b8$var$unsetInMulti = (state, pathToParent, keys)=>// @ts-expect-error - TS7006 - Parameter 'folded' implicitly has an 'any' type. | TS7006 - Parameter 'subkey' implicitly has an 'any' type.
    keys.reduce((folded, subkey)=>$b2606ddc7a8f25b8$var$unsetInSingle(folded, pathToParent, subkey), state);
var //   ['a', 'b', 'c'] - removes values at 'a/b/c'
//   ['a', ['b', 'c']] - removes values at 'a/b' and 'a/c'
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$b2606ddc7a8f25b8$export$2e2bcd8739ae039 = (state, path)=>{
    if (path.length === 0) return state;
    const pathToParent = path.slice(0, path.length - 1);
    const lastPathItem = path.slice(-1)[0];
    if (Array.isArray(lastPathItem)) return $b2606ddc7a8f25b8$var$unsetInMulti(state, pathToParent, lastPathItem);
    return $b2606ddc7a8f25b8$var$unsetInSingle(state, pathToParent, lastPathItem);
};

});

parcelRegister("ixRuS", function(module, exports) {

$parcel$export(module.exports, "UPDATE_VERTICAL_OFFSET", () => $d1bfc6238df339a4$export$676d1c528632e526);
$parcel$export(module.exports, "updateVerticalOffsetAction", () => $d1bfc6238df339a4$export$18b97acfb3435930);
$parcel$export(module.exports, "SET_VERTICAL_OFFSET", () => $d1bfc6238df339a4$export$377cee6e888818c4);
$parcel$export(module.exports, "setVerticalOffsetAction", () => $d1bfc6238df339a4$export$d4159e3b6bc6e867);
$parcel$export(module.exports, "SET_HORIZONTAL_OFFSET", () => $d1bfc6238df339a4$export$d3a9fff38ab5d354);
$parcel$export(module.exports, "setHorizontalOffsetAction", () => $d1bfc6238df339a4$export$3ed7387f47277f6a);
const $d1bfc6238df339a4$export$676d1c528632e526 = 'state.actions.offsets.UPDATE_VERTICAL_OFFSET';
const $d1bfc6238df339a4$export$18b97acfb3435930 = (totalPages, verticalPosition, onVerticalScrollOffsetChanged)=>({
        type: $d1bfc6238df339a4$export$676d1c528632e526,
        payload: {
            totalPages: totalPages,
            verticalPosition: verticalPosition,
            onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged
        }
    });
const $d1bfc6238df339a4$export$377cee6e888818c4 = 'state.actions.offsets.SET_VERTICAL_OFFSET';
const $d1bfc6238df339a4$export$d4159e3b6bc6e867 = (verticalOffset)=>({
        type: $d1bfc6238df339a4$export$377cee6e888818c4,
        payload: {
            verticalOffset: verticalOffset
        }
    });
const $d1bfc6238df339a4$export$d3a9fff38ab5d354 = 'state.actions.offsets.SET_HORIZONTAL_OFFSET';
const $d1bfc6238df339a4$export$3ed7387f47277f6a = (horizontalOffset)=>({
        type: $d1bfc6238df339a4$export$d3a9fff38ab5d354,
        payload: {
            horizontalOffset: horizontalOffset
        }
    });

});

parcelRegister("lewnw", function(module, exports) {

$parcel$export(module.exports, "SET_ROW_LIST_REF", () => $b8808559b7ad5c63$export$bb9e2ef2ff07df11);
$parcel$export(module.exports, "setRowListRefAction", () => $b8808559b7ad5c63$export$9264a3dd68126495);
const $b8808559b7ad5c63$export$bb9e2ef2ff07df11 = 'state.actions.table.SET_ROW_LIST_REF';
const $b8808559b7ad5c63$export$9264a3dd68126495 = (payload)=>({
        type: $b8808559b7ad5c63$export$bb9e2ef2ff07df11,
        payload: payload
    });

});


parcelRegister("ak3tm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_STATE", () => $839b39638005aaa4$export$a3a6a28ae8823b06);
$parcel$export(module.exports, "default", () => $839b39638005aaa4$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $45OTQ = parcelRequire("45OTQ");
const $839b39638005aaa4$export$a3a6a28ae8823b06 = {
    showPagination: false,
    currentPage: 1,
    userPickerDisabled: false,
    isTableDisabled: false,
    onIssueViewTransition: undefined,
    useJSMQueueDurationEvent: undefined,
    renderSidebarIcon: undefined,
    refreshSidebar: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$839b39638005aaa4$export$2e2bcd8739ae039 = (state = $839b39638005aaa4$export$a3a6a28ae8823b06, action)=>{
    switch(action.type){
        case 0, $45OTQ.SHOW_PAGINATION:
            return (0, $7uUwQ.assoc)(state, 'showPagination', action.payload);
        case 0, $45OTQ.SET_EDITING_FIELD_POSITION:
            return (0, $7uUwQ.assoc)(state, 'editingFieldPosition', {
                horizontalOffset: action.payload.horizontalOffset,
                verticalOffset: action.payload.verticalOffset,
                fieldWidth: action.payload.fieldWidth,
                tableWidth: action.payload.tableWidth,
                tableHeight: action.payload.tableHeight
            });
        case 0, $45OTQ.SET_CURRENT_PAGE:
            return (0, $7uUwQ.assoc)(state, 'currentPage', action.payload);
        case 0, $45OTQ.SET_IS_TABLE_DISABLED:
            return (0, $7uUwQ.assoc)(state, 'isTableDisabled', action.payload);
        case 0, $45OTQ.DISABLE_USER_PICKER:
            return (0, $7uUwQ.assoc)(state, 'userPickerDisabled', true);
        case 0, $45OTQ.SET_ON_ISSUE_VIEW_TRANSITION:
            return (0, $7uUwQ.assoc)(state, 'onIssueViewTransition', action.payload);
        case 0, $45OTQ.SET_JSM_QUEUE_DURATION_EVENT:
            return (0, $7uUwQ.assoc)(state, 'useJSMQueueDurationEvent', action.payload);
        case 0, $45OTQ.SET_RENDER_SIDE_BAR_ICON:
            return (0, $7uUwQ.assoc)(state, 'renderSidebarIcon', action.payload);
        case 0, $45OTQ.SET_REFRESH_SIDE_BAR:
            return (0, $7uUwQ.assoc)(state, 'refreshSidebar', action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("hdMS4", function(module, exports) {

$parcel$export(module.exports, "default", () => $925c676d37b56a55$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $6sO8n = parcelRequire("6sO8n");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $bwmNE = parcelRequire("bwmNE");

var $i6Q5z = parcelRequire("i6Q5z");

var $1dJrS = parcelRequire("1dJrS");
const $925c676d37b56a55$var$OVERLAY_TIMEOUT = 1000;
const $925c676d37b56a55$var$LOCATION = 'issue-table.view.fields.common.editable-field';
const $925c676d37b56a55$var$AUTOMATIC_ID_VALUE = '-1';
const $925c676d37b56a55$export$ae8818331f1797ff = (response)=>{
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const { assignee: assignee } = response ? response.fields || {} : {};
    if (assignee !== null && assignee !== undefined) {
        const currentAssignee = {
            accountId: assignee.accountId,
            displayName: assignee.displayName || '',
            emailAddress: assignee.emailAddress,
            avatarUrl: assignee.avatarUrls['48x48'] || ''
        };
        return currentAssignee;
    }
    return undefined;
};
function $925c676d37b56a55$export$2e2bcd8739ae039(ChildComponent) {
    // eslint-disable-next-line jira/react/no-class-components
    return class EditableField extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            const { dataSelectorProps: { key: key } } = props;
            if (key !== state.key) return {
                overlay: undefined,
                key: key
            };
            return null;
        }
        constructor(props){
            super(props), this.onSuccess = (fieldValue, event)=>{
                const { dataSelectorProps: { onChange: onChange, value: value, fieldType: fieldType }, tableInjectedProps: { issueKey: issueKey, issueFieldLockControls: issueFieldLockControls }, onRefreshSidebar: onRefreshSidebar } = this.props;
                this.timeoutOverlay();
                if (fieldValue && fieldValue.accountId === $925c676d37b56a55$var$AUTOMATIC_ID_VALUE) (0, $1dJrS.getCurrentAssignee)(issueKey).then((response)=>{
                    onChange && onChange(issueKey, $925c676d37b56a55$export$ae8818331f1797ff(response));
                    issueFieldLockControls.onFieldUnlock();
                }).catch((err)=>{
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'getCurrentAssigneeFailure',
                            packageName: 'jiraIssueTable',
                            teamName: 'jsd-shield'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    onChange && onChange(issueKey, fieldValue);
                    issueFieldLockControls.onFieldUnlock();
                });
                else {
                    onChange && onChange(issueKey, fieldValue);
                    issueFieldLockControls.onFieldUnlock();
                }
                onRefreshSidebar?.({
                    issueKey: issueKey
                });
                if (fieldType) (0, $bwmNE.trackUpdatedField)(event, fieldType, this.getAccountIds(fieldValue, value));
            }, this.onFailure = ()=>{
                this.setState({
                    overlay: undefined
                });
                const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls } } = this.props;
                issueFieldLockControls.onFieldUnlock();
            }, this.onEditStart = ()=>{
                const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls, onEditStart: onEditStart, issueKey: issueKey }, dataSelectorProps: { fieldType: fieldType } } = this.props;
                issueFieldLockControls.onFieldLock();
                onEditStart(fieldType, issueKey);
                this.isSelection = false;
                this.setState({
                    inEditState: true
                });
            }, this.onEditCancel = ()=>{
                if (!this.isSelection) {
                    this.setState({
                        overlay: undefined
                    });
                    const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls } } = this.props;
                    issueFieldLockControls.onFieldUnlock();
                }
                this.isSelection = false;
                this.setState({
                    inEditState: false
                });
            }, this.onEditSelection = ()=>{
                this.isSelection = true;
            }, this.onSubmit = (fieldValue)=>{
                this.childWrapperRef && this.childWrapperRef.focus();
                this.setState({
                    overlay: {
                        value: fieldValue
                    },
                    inEditState: false
                });
            }, this.onChildWrapperRefUpdate = (el)=>{
                this.childWrapperRef = el;
            }, this.getAccountIds = (fieldValue, value)=>({
                    oldId: value && value.accountId ? value.accountId : null,
                    newId: fieldValue && fieldValue.accountId ? fieldValue.accountId : null
                });
            this.state = {
                key: props.dataSelectorProps.key,
                inEditState: false
            };
        }
        componentDidUpdate(prevProps, prevState) {
            if (this.state.key !== prevState.key && this.overlayTimeoutId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearTimeout(this.overlayTimeoutId);
        }
        componentWillUnmount() {
            if (this.overlayTimeoutId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearTimeout(this.overlayTimeoutId);
        }
        getValue() {
            const { overlay: overlay } = this.state;
            if (overlay) return overlay.value;
            const { dataSelectorProps: { value: value } } = this.props;
            return value;
        }
        timeoutOverlay() {
            const { dataSelectorProps: { fieldType: fieldType } } = this.props;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            this.overlayTimeoutId = window.setTimeout(()=>{
                this.setState({
                    overlay: undefined
                });
                delete this.overlayTimeoutId;
                (0, $dJl1T.default).safeWarnWithoutCustomerData($925c676d37b56a55$var$LOCATION, `Overlay timeout reached for ${fieldType} field`);
            }, $925c676d37b56a55$var$OVERLAY_TIMEOUT);
        }
        renderChildComponent(isSaving) {
            const { dataSelectorProps: { fieldType: fieldType, key: key, isEditable: isEditable, overrideDisabledAppearance: overrideDisabledAppearance }, tableInjectedProps: { width: width, issueKey: issueKey, fieldId: fieldId, rowListRef: rowListRef, onSetEditingFieldPosition: onSetEditingFieldPosition, isFieldLocked: isFieldLocked, isUserPickerDisabled: isUserPickerDisabled, isLastColumn: isLastColumn } } = this.props;
            const props = {
                value: this.getValue(),
                fieldType: fieldType,
                fieldId: fieldId,
                width: width,
                isEditable: isEditable,
                issueKey: issueKey,
                rowListRef: rowListRef,
                onSetEditingFieldPosition: onSetEditingFieldPosition,
                isFieldLocked: isFieldLocked,
                isUserPickerDisabled: isUserPickerDisabled,
                isLastColumn: isLastColumn,
                overrideDisabledAppearance: overrideDisabledAppearance
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChildComponent, {
                ...props,
                key: key,
                onSubmit: this.onSubmit,
                onEditStart: this.onEditStart,
                onEditCancel: this.onEditCancel,
                // @ts-expect-error - TS2322 - Type '(fieldValue: FieldValue<T>, event: UIAnalyticsEventInterface) => void' is not assignable to type '(arg1: FieldValue<T>) => void'.
                onEditSuccess: this.onSuccess,
                onEditFailure: this.onFailure,
                isFieldLocked: isFieldLocked,
                isSaving: isSaving,
                onEditSelection: this.onEditSelection
            });
        }
        renderWithFocusWrapper(children) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q5z.default), {
                inEditState: this.state.inEditState
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    outline: 'none'
                },
                ref: this.onChildWrapperRefUpdate
            }, children));
        }
        render() {
            const { tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
            const { overlay: overlay } = this.state;
            return overlay ? this.renderWithFocusWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInlineEnd: isLastColumn ? 'space.0' : 'space.200'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sO8n.default), null, this.renderChildComponent(true)))) : this.renderWithFocusWrapper(this.renderChildComponent(false));
        }
    };
}

});
parcelRegister("6sO8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $d332aa7c19a695ac$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
function $d332aa7c19a695ac$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)));
}
$d332aa7c19a695ac$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d332aa7c19a695ac$var$BlanketContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$BackgroundContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$Background = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk11bn",
            __cmplp.border ? "_19it1x87" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$ComponentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _tzy4sxj9",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bwmNE", function(module, exports) {

$parcel$export(module.exports, "updateFieldValue$", () => $7efaceda7b597505$export$62b1d44da2518e20);
$parcel$export(module.exports, "trackUpdatedField", () => $7efaceda7b597505$export$a57c24e3bce9af0e);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $kIx1p = parcelRequire("kIx1p");
const $7efaceda7b597505$var$toAccountIdOrNull = (accountId)=>accountId ? (0, $g5X3G.toAccountId)(accountId) : null;
const $7efaceda7b597505$var$putUserFieldValue = (// TODO: SHIELD-3213 - Not actually UserProps being passed - also includes fieldType
value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
fieldId, issueKey)=>{
    const newUserFieldValue = value ? {
        id: $7efaceda7b597505$var$toAccountIdOrNull(value.accountId)
    } : null;
    const newFieldValues = {
        [fieldId]: newUserFieldValue
    };
    return (0, $kIx1p.putFieldValue$)((0, $g5X3G.toIssueKey)(issueKey), newFieldValues);
};
const $7efaceda7b597505$export$62b1d44da2518e20 = (issueKey, fieldId, newValue)=>{
    switch(newValue.fieldType){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
            // @ts-expect-error - TS2345 - Argument of type 'DataSelectorFieldValue<T>' is not assignable to parameter of type 'UserProps'.
            return $7efaceda7b597505$var$putUserFieldValue(newValue, fieldId, issueKey);
        default:
            return (0, $kVLXA.Observable).throw(new Error(`fieldType ${newValue.fieldType} not supported`));
    }
};
const $7efaceda7b597505$export$a57c24e3bce9af0e = (event, field, fieldData)=>{
    const { oldId: oldId, oldCategory: oldCategory, newId: newId, newCategory: newCategory } = fieldData;
    (0, $8zOmE.fireTrackAnalytics)(event, 'issueFields updated', {
        updatedField: field,
        updatedFieldOldID: oldId,
        updatedFieldNewID: newId,
        statusCategoryOld: oldCategory,
        statusCategoryNew: newCategory
    });
};

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    if ((0, $4R6GH.fg)('jsm-sentiment-analysis')) Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("kIx1p", function(module, exports) {

$parcel$export(module.exports, "putFieldValue$", () => $d2e7b23b325bb76a$export$1e79252a3a0c4801);

var $487fd = parcelRequire("487fd");
const $d2e7b23b325bb76a$var$getUpdateFieldValueUrl = (issueKey)=>`/rest/api/2/issue/${issueKey}`;
const $d2e7b23b325bb76a$export$1e79252a3a0c4801 = (issueKey, newFieldValues)=>(0, $487fd.default)($d2e7b23b325bb76a$var$getUpdateFieldValueUrl(issueKey), {
        method: 'PUT',
        body: JSON.stringify({
            fields: newFieldValues
        })
    });

});


parcelRegister("i6Q5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $afca756f75fe97d1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afca756f75fe97d1$var$preventKeyDownProp = (inEditState)=>(e)=>{
        if (inEditState || e.key === 'Enter') e.stopPropagation();
    };
const $afca756f75fe97d1$var$PreventKeyboardPropWrapper = ({ children: children, inEditState: inEditState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        onKeyDown: $afca756f75fe97d1$var$preventKeyDownProp(inEditState),
        role: "presentation"
    }, children);
var $afca756f75fe97d1$export$2e2bcd8739ae039 = $afca756f75fe97d1$var$PreventKeyboardPropWrapper;

});

parcelRegister("1dJrS", function(module, exports) {

$parcel$export(module.exports, "getCurrentAssignee", () => $1dd8697b32fd3f9f$export$7ff716f0bdf4c335);

var $7f4tk = parcelRequire("7f4tk");
const $1dd8697b32fd3f9f$var$getCurrentAssigneeUrl = (issueKey)=>`/rest/api/3/issue/${issueKey}?fields=assignee`;
const $1dd8697b32fd3f9f$export$7ff716f0bdf4c335 = (issueKey)=>(0, $7f4tk.default)($1dd8697b32fd3f9f$var$getCurrentAssigneeUrl(issueKey), {
        method: 'GET'
    });

});


parcelRegister("ckwFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53d5d6128fe5189$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2OMDV = parcelRequire("2OMDV");

var $kYYfm = parcelRequire("kYYfm");

var $5y0F0 = parcelRequire("5y0F0");

var $jFM7s = parcelRequire("jFM7s");

var $3bjyq = parcelRequire("3bjyq");

var $8PHFd = parcelRequire("8PHFd");
const $b53d5d6128fe5189$var$SingleUserSelectWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('issueField', {
    onEditSuccess: 'updated'
})((0, $8PHFd.default));
const $b53d5d6128fe5189$var$SingleUserSelect = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b53d5d6128fe5189$var$SingleUserSelectWithAnalytics, {
            UserSelect: (0, $3bjyq.default),
            ProfileCard: (0, $kYYfm.AsyncProfileCardNext),
            AssigneeButton: (0, $jFM7s.default),
            onPushAction: push,
            ...props
        }));
var $b53d5d6128fe5189$export$2e2bcd8739ae039 = $b53d5d6128fe5189$var$SingleUserSelect;

});
parcelRegister("kYYfm", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $15521008cc986085$export$a3c0845f856d4292);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $15521008cc986085$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("19c0Q")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $15521008cc986085$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15521008cc986085$var$LazyComponent, props)));
var $15521008cc986085$export$2e2bcd8739ae039 = $15521008cc986085$export$a3c0845f856d4292;

});
parcelRegister("19c0Q", function(module, exports) {

let $0d5ff32adb804d7c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0d5ff32adb804d7c$var$load("h2MrD"),
    $0d5ff32adb804d7c$var$load("bYT2S"),
    $0d5ff32adb804d7c$var$load("cM9em"),
    $0d5ff32adb804d7c$var$load("fr9NE"),
    $0d5ff32adb804d7c$var$load("ek7ue")
]).then(()=>parcelRequire('jO6eK'));

});


parcelRegister("jFM7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $958b821079dcfc1d$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $eF3Bj = parcelRequire("eF3Bj");
var $958b821079dcfc1d$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $eF3Bj.default));

});
parcelRegister("eF3Bj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5137bcc9429cabd3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $6lH51 = parcelRequire("6lH51");
const $5137bcc9429cabd3$var$AssigneeButton = ({ isLastColumn: isLastColumn, assignee: assignee, intl: intl, overrideDisabledAppearance: overrideDisabledAppearance, accountId: accountId, ProfileCard: ProfileCard, ...rest })=>{
    const [isHover, setIsHover] = (0, $5uXOq.useState)(false);
    const setIsHoverToTrue = ()=>setIsHover(true);
    const setIsHoverToFalse = ()=>setIsHover(false);
    const assigneeName = assignee ? assignee.displayName || assignee.emailAddress : intl.formatMessage((0, $6lH51.default).unassigned);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5137bcc9429cabd3$var$wrapperBaseStyles,
        paddingInlineEnd: isLastColumn ? 'space.100' : 'space.0',
        onMouseEnter: setIsHoverToTrue,
        onMouseLeave: setIsHoverToFalse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5137bcc9429cabd3$export$2d5d2ba3c7c8c40b, {
        ...rest,
        isHovered: isHover,
        "aria-label": `${assigneeName} - edit Assignee`
    }, accountId && ProfileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProfileCard, {
        accountId: accountId,
        TenantContextSubscriber: (0, $4R6GH.fg)('empanada_nin_concurrent_mode_fixes') ? undefined : (0, $9OXo1.TenantContextSubscriber),
        actions: [
            (0, $e6a2e0952e4731b8$export$23cedd3261bd8015),
            (0, $e6a2e0952e4731b8$export$6bef782d14a92db8)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: assignee && assignee.avatarUrl,
        size: "small",
        borderColor: "transparent",
        isDisabled: !overrideDisabledAppearance && rest.isButtonDisabled
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: assignee && assignee.avatarUrl,
        size: "small",
        borderColor: "transparent",
        isDisabled: !overrideDisabledAppearance && rest.isButtonDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5137bcc9429cabd3$var$Text, null, assigneeName)));
};
$5137bcc9429cabd3$var$AssigneeButton.defaultProps = {
    isLastColumn: false,
    isButtonDisabled: false,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    overrideDisabledAppearance: false
};
var $5137bcc9429cabd3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $5137bcc9429cabd3$var$AssigneeButton;
const $5137bcc9429cabd3$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isButtonDisabled: isButtonDisabled, isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ei78nn": (0, $lD23V.default)({
                cursor: 'default'
            })
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _19itidpf _2rko1l7b _12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw _4cvr1h6o _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1osq _4t3ixy5q _1reo15vq _syaz1kw7",
            !__cmplp.isButtonDisabled && __cmplp.isHovered ? "_bfhkyucn" : "_bfhk18uv",
            __cmplp.isButtonDisabled ? "_80ommkww" : "_80omtlke",
            __cmplp.className
        ])
    });
});
const $5137bcc9429cabd3$var$wrapperBaseStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.050',
    paddingRight: 'space.0',
    paddingBottom: 'space.050',
    paddingLeft: 'space.0',
    display: 'flex',
    textAlign: 'left'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5137bcc9429cabd3$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$2549357601611c61 = 'loadError';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("6lH51", function(module, exports) {

$parcel$export(module.exports, "default", () => $939e9d9be0b22a28$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $939e9d9be0b22a28$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assignToMe: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    unassigned: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.unassigned",
        "defaultMessage": "Unassigned"
    },
    automatic: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.automatic",
        "defaultMessage": "Automatic"
    },
    invitePeopleOption: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});



parcelRegister("3bjyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c3422538490d4e$export$2e2bcd8739ae039);

var $4Pf62 = parcelRequire("4Pf62");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $kgxrD = parcelRequire("kgxrD");

var $45OTQ = parcelRequire("45OTQ");

var $hAUez = parcelRequire("hAUez");

var $fmlzX = parcelRequire("fmlzX");

var $p64Ah = parcelRequire("p64Ah");

var $dDrTh = parcelRequire("dDrTh");

var $atSoo = parcelRequire("atSoo");

var $aK54Y = parcelRequire("aK54Y");
const $90c3422538490d4e$var$mapStateToProps = (state)=>({
        avatarUrl: (0, $hAUez.getAvatarUrl)(state),
        atlassianAccountId: (0, $fmlzX.getAtlassianAccountId)(state),
        displayName: (0, $hAUez.getDisplayName)(state),
        emailAddress: (0, $hAUez.getEmailAddress)(state),
        AsyncUserPicker: $atSoo.default,
        onSearchUser: $dDrTh.default,
        isAdmin: (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin
    });
var // @ts-expect-error - Parameter 'ownProps' implicitly has an 'any' type.
$90c3422538490d4e$export$2e2bcd8739ae039 = (0, $p64Ah.connect)($90c3422538490d4e$var$mapStateToProps, (dispatch, ownProps)=>({
        // @ts-expect-error - TS7006 - Parameter 'issueKey' implicitly has an 'any' type. | TS7006 - Parameter 'fieldId' implicitly has an 'any' type. | TS7006 - Parameter 'fieldValue' implicitly has an 'any' type.
        onChange: (issueKey, fieldId, fieldValue)=>{
            ownProps.onSubmit(fieldValue);
            return dispatch((0, $kgxrD.submitFieldUpdateAction)(issueKey, fieldId, fieldValue, ownProps.onEditSuccess, ownProps.onEditFailure));
        },
        onComponentLoadFailure: ()=>{
            ownProps.onComponentLoadFailure && ownProps.onComponentLoadFailure();
            dispatch((0, $45OTQ.disableUserPickerAction)());
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue-table.view.fields.common.single-user-select.user-select', '[FD-4424] Async user select failed to load');
            (0, $jcw0u.default)({
                meta: {
                    id: 'asyncUserSelectLoadFailure',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
        }
    }))((0, $aK54Y.default));

});
parcelRegister("hAUez", function(module, exports) {

$parcel$export(module.exports, "getAvatarUrl", () => $f481a0e6bdd0a20a$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "getDisplayName", () => $f481a0e6bdd0a20a$export$be63e0664592e141);
$parcel$export(module.exports, "getEmailAddress", () => $f481a0e6bdd0a20a$export$ec5591214e33605f);

var $37Hsj = parcelRequire("37Hsj");
const $f481a0e6bdd0a20a$var$getAssigneeInitialization = (state)=>(0, $37Hsj.getFieldInitialization)(state).assignee;
const $f481a0e6bdd0a20a$export$b4f8f1f54acec99b = (state)=>{
    const assignee = $f481a0e6bdd0a20a$var$getAssigneeInitialization(state);
    return assignee ? assignee.avatarUrl : undefined;
};
const $f481a0e6bdd0a20a$export$be63e0664592e141 = (state)=>{
    const assignee = $f481a0e6bdd0a20a$var$getAssigneeInitialization(state);
    return assignee ? assignee.displayName : undefined;
};
const $f481a0e6bdd0a20a$export$ec5591214e33605f = (state)=>{
    const assignee = $f481a0e6bdd0a20a$var$getAssigneeInitialization(state);
    return assignee ? assignee.emailAddress : undefined;
};

});

parcelRegister("fmlzX", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountId", () => $2a1465f696bc4858$export$f5baf4f0aaa47428);

var $37Hsj = parcelRequire("37Hsj");
const $2a1465f696bc4858$export$f5baf4f0aaa47428 = (state)=>(0, $37Hsj.getInitialAppProps)(state).atlassianAccountId;
const $2a1465f696bc4858$export$fdd2c0ba94025c3c = (state)=>(0, $37Hsj.getInitialAppProps)(state).cloudId;
const $2a1465f696bc4858$export$505ebc60b5fc3b2e = (state)=>(0, $37Hsj.getInitialAppProps)(state).fabricPfDirUrl;

});

parcelRegister("dDrTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8968666692f391be$export$2e2bcd8739ae039);


var $lpieB = parcelRequire("lpieB");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8968666692f391be$export$2e2bcd8739ae039 = (issueKey, query, fieldContext)=>{
    if (fieldContext === (0, $c63288139d0ee675$export$17e03e15c8be5abe)) return (0, $lpieB.default)(issueKey, query ?? '');
    throw new Error('Not implemented');
};

});
const $c63288139d0ee675$export$17e03e15c8be5abe = 'ASSIGNEE';
const $c63288139d0ee675$export$9c542858adf7dcd0 = 'DEFAULT';

parcelRegister("lpieB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b65eed6ca7aefc0$export$2e2bcd8739ae039);

var $iCJnk = parcelRequire("iCJnk");
const $9b65eed6ca7aefc0$var$transformResponse = (response)=>response.map((userResponse)=>({
            id: userResponse.accountId,
            avatarUrl: userResponse.avatarUrls['48x48'],
            name: userResponse.displayName,
            byline: userResponse.emailAddress,
            value: {
                accountId: userResponse.accountId,
                avatarUrl: userResponse.avatarUrls['48x48'],
                displayName: userResponse.displayName,
                emailAddress: userResponse.emailAddress
            }
        }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b65eed6ca7aefc0$export$2e2bcd8739ae039 = (issueKey, query)=>(0, $iCJnk.default)(issueKey, query).then((response)=>new Promise((resolve)=>{
            resolve($9b65eed6ca7aefc0$var$transformResponse(response));
        }));

});
parcelRegister("iCJnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $37dedcf50287bbd4$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$37dedcf50287bbd4$export$2e2bcd8739ae039 = (issueKey, query)=>(0, $7f4tk.default)(`/rest/api/latest/user/assignable/search?issueKey=${issueKey}&query=${query}`, {
        method: 'GET'
    });

});



parcelRegister("atSoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $67e5a53e45e3479f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $67e5a53e45e3479f$var$LazyUserPicker = (0, $kxZPA.lazy)(()=>(parcelRequire("kyUjS")), {
    moduleId: "../platform/packages/elements/user-picker/src/index.ts"
});
const $67e5a53e45e3479f$export$2e2bcd8739ae039 = (props)=>{
    const { onError: onError, ...userPickerProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-issue-table-user-picker",
        packageName: "jiraIssueTable",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "user-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($67e5a53e45e3479f$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($67e5a53e45e3479f$var$UserPickerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($67e5a53e45e3479f$var$LazyUserPicker, userPickerProps))));
};
const $67e5a53e45e3479f$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _kqswh2mm _154i12x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $67e5a53e45e3479f$var$UserPickerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1q5411p5 _16vph2mm _14od1wug _1etn1wug _1ospglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kyUjS", function(module, exports) {

let $ef82ab83aaaa6d7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ef82ab83aaaa6d7f$var$load("cM9em"),
    $ef82ab83aaaa6d7f$var$load("fr9NE"),
    $ef82ab83aaaa6d7f$var$load("h2MrD"),
    $ef82ab83aaaa6d7f$var$load("bYT2S"),
    $ef82ab83aaaa6d7f$var$load("8tNfl")
]).then(()=>parcelRequire('hukLm'));

});


parcelRegister("aK54Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87c66acbc70c7bf$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react-arrow-function-property-naming */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cb25w = parcelRequire("cb25w");

var $dJl1T = parcelRequire("dJl1T");

var $az4zD = parcelRequire("az4zD");

var $ecbCU = parcelRequire("ecbCU");

var $8zOmE = parcelRequire("8zOmE");


var $emsei = parcelRequire("emsei");


var $6lH51 = parcelRequire("6lH51");
const $f87c66acbc70c7bf$var$toUserForEditing = (value)=>{
    if (!value) return undefined;
    return {
        id: value.accountId,
        name: value.displayName || value.emailAddress || '',
        avatarUrl: value.avatarUrl,
        value: value
    };
};
const $f87c66acbc70c7bf$var$fireInviteItemRendererEvent = (createAnalyticsEvent, fieldId, suggestionsCount, isAdmin)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: fieldId,
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $8zOmE.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
class $f87c66acbc70c7bf$export$fc39e35a5100d3e8 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isAdmin: false,
            enablePeopleInvite: true
        };
    }
    loadAssignToMeUser() {
        const { value: value, avatarUrl: avatarUrl, atlassianAccountId: atlassianAccountId, emailAddress: emailAddress, displayName: displayName, intl: intl } = this.props;
        if (value && value.accountId === atlassianAccountId) return undefined;
        if (!emailAddress && !avatarUrl && !displayName) {
            (0, $dJl1T.default).safeWarnWithoutCustomerData('issue-table.view.fields.common.single-user-select.user-select', 'Assign-to-me not initialized in time', {});
            return undefined;
        }
        const assignToMeUser = {
            id: (0, $6609d397a0e35e52$export$34c10ac17efea7b3),
            name: intl.formatMessage((0, $6lH51.default).assignToMe),
            avatarUrl: avatarUrl,
            value: {
                emailAddress: emailAddress,
                accountId: atlassianAccountId,
                avatarUrl: avatarUrl,
                displayName: displayName
            }
        };
        return assignToMeUser;
    }
    loadUnassignedUser() {
        const { value: value, intl: intl } = this.props; // While the 'Unassigned' option is defined as value being undefined, the value can briefly have a displayName
        // of "Unassigned" when selected from the user-picker, before the issue-table polls again. To avoid this, added
        // a check of accountId as the 'Unassigned' option does not have an accountId.
        if (!value || !value.accountId) return undefined;
        const unassignedUser = {
            id: (0, $6609d397a0e35e52$export$bdab9bfb39981463),
            name: intl.formatMessage((0, $6lH51.default).unassigned)
        };
        return unassignedUser;
    }
    loadAutomaticUser() {
        const { value: value, intl: intl } = this.props;
        if (value && value.accountId === (0, $6609d397a0e35e52$export$f42e6736d1a95712)) return undefined;
        const automaticUser = {
            id: (0, $6609d397a0e35e52$export$f5d5f6bb902f1027),
            name: intl.formatMessage((0, $6lH51.default).automatic),
            value: {
                accountId: (0, $6609d397a0e35e52$export$f42e6736d1a95712),
                displayName: intl.formatMessage((0, $6lH51.default).automatic),
                avatarUrl: '',
                emailAddress: ''
            }
        };
        return automaticUser;
    }
    getInvitePeopleOption() {
        const { intl: intl, isAdmin: isAdmin } = this.props;
        return {
            id: (0, $6609d397a0e35e52$export$d875316cb0cd94f7),
            avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($emsei))),
            name: intl.formatMessage(isAdmin ? (0, $6lH51.default).invitePeopleOptionAdmin : (0, $6lH51.default).invitePeopleOption)
        };
    }
    render() {
        const { width: width, value: value, AsyncUserPicker: AsyncUserPicker, onComponentLoadFailure: onComponentLoadFailure, rowListRef: rowListRef, fieldId: fieldId, isSaving: isSaving, onSetEditingRef: onSetEditingRef } = this.props;
        const isOpen = this.state.isOpen && !isSaving; // onSetEditingRef is used to set ref of current container such that
        // UserPicker options list can render with the correct X/Y offset.
        // This is required in react-redux v8 upgrade because ref is not set properly.
        // https://hello.atlassian.net/wiki/spaces/JFP/pages/3593342635/Rollout+Strategy+For+React-Redux+V8#JSM-assignee-bug
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f87c66acbc70c7bf$var$Container // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue-table.view.fields.common.single-user-select.user-select",
            ref: onSetEditingRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AsyncUserPicker, {
            open: isOpen,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            loadOptions: this.loadUsers,
            width: width,
            value: $f87c66acbc70c7bf$var$toUserForEditing(value),
            onChange: this.onChange,
            onError: onComponentLoadFailure,
            isClearable: false,
            menuMinWidth: (0, $6609d397a0e35e52$export$eef3ca04e2ec81e0),
            menuPortalTarget: rowListRef,
            onSelection: this.onSelection,
            fieldId: fieldId
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: true
        }, this.onChange = (item)=>{
            const { onChange: onChange, issueKey: issueKey, fieldId: fieldId, fieldType: fieldType, intl: intl, enablePeopleInvite: enablePeopleInvite } = this.props;
            if (enablePeopleInvite !== true || item.id !== (0, $6609d397a0e35e52$export$d875316cb0cd94f7)) {
                if (item.value) onChange(issueKey, fieldId, {
                    ...item.value,
                    fieldType: fieldType
                });
                else onChange(issueKey, fieldId, {
                    displayName: intl.formatMessage((0, $6lH51.default).unassigned),
                    fieldType: fieldType
                });
            }
        }, this.onBlur = ()=>{
            this.setState({
                isOpen: false
            });
            this.props.onEditCancel();
        }, this.onFocus = ()=>{
            this.setState({
                isOpen: true
            });
        }, this.onSelection = (item)=>{
            const { onEditSelection: onEditSelection, createAnalyticsEvent: createAnalyticsEvent, enablePeopleInvite: enablePeopleInvite } = this.props;
            if (enablePeopleInvite === true && item.id === (0, $6609d397a0e35e52$export$d875316cb0cd94f7)) (0, $ecbCU.triggerOpenDrawer)(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            else onEditSelection();
        }, this.loadUsers = (query)=>{
            const { issueKey: issueKey, onSearchUser: onSearchUser, enablePeopleInvite: enablePeopleInvite, createAnalyticsEvent: createAnalyticsEvent, isAdmin: isAdmin, fieldId: fieldId } = this.props;
            const searchPromise = onSearchUser(issueKey, query, (0, $c63288139d0ee675$export$17e03e15c8be5abe)).then((users)=>{
                if (enablePeopleInvite === true && query !== undefined && query !== '' && users.length < 3) {
                    $f87c66acbc70c7bf$var$fireInviteItemRendererEvent(createAnalyticsEvent, fieldId, users.length, isAdmin);
                    return [
                        ...users,
                        this.getInvitePeopleOption()
                    ];
                }
                return users;
            });
            const options = [];
            const assignToMeUser = this.loadAssignToMeUser();
            if (assignToMeUser) options.push(assignToMeUser);
            const unassignedUser = this.loadUnassignedUser();
            if (unassignedUser) options.push(unassignedUser);
            const automaticUser = this.loadAutomaticUser();
            if (automaticUser) options.push(automaticUser);
            options.push(searchPromise);
            return options;
        };
    }
}
var $f87c66acbc70c7bf$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $cb25w.default)()((0, $az4zD.injectIntlV2)($f87c66acbc70c7bf$export$fc39e35a5100d3e8));
const $f87c66acbc70c7bf$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1ltvr5cr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ecbCU", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleDrawer", () => $6f07668563b12d68$export$48fb2d80745c5e67);
$parcel$export(module.exports, "triggerOpenDrawer", () => $6f07668563b12d68$export$b7dab610045052db);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $2fX5x = parcelRequire("2fX5x");
const $6f07668563b12d68$var$CONTROLLER_NAME = 'invite-people-drawer';
const $6f07668563b12d68$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $6f07668563b12d68$var$Store = (0, $iXqE5.createStore)({
    name: $6f07668563b12d68$var$CONTROLLER_NAME,
    initialState: $6f07668563b12d68$var$initialState,
    actions: {
        openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl })=>({ setState: setState })=>{
                (0, $2fX5x.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                (0, $2fX5x.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl
                });
            },
        closeDrawer: ()=>({ setState: setState })=>setState($6f07668563b12d68$var$initialState)
    }
});
const $6f07668563b12d68$export$48fb2d80745c5e67 = (0, $3sQ5x.createHook)($6f07668563b12d68$var$Store);
const $6f07668563b12d68$export$ac7fed664b4735b5 = (0, $gg7kZ.createContainer)($6f07668563b12d68$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $6f07668563b12d68$export$4358742cbaf4a6d4 = (0, $51nlc.createSubscriber)($6f07668563b12d68$var$Store, {
    displayName: 'InvitePeopleDrawerSubscriber',
    selector: (state)=>state.isOpen
});
const $6f07668563b12d68$export$b7dab610045052db = (createAnalyticsEvent, contextConfig)=>{
    (0, $bKpgX.defaultRegistry).getStore($6f07668563b12d68$var$Store)?.actions.openDrawer(createAnalyticsEvent, contextConfig);
};

});
parcelRegister("2fX5x", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $b69ddc7a728288ef$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $b69ddc7a728288ef$export$6815765da918b983);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $b69ddc7a728288ef$export$21b810258e82d438);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $8zOmE = parcelRequire("8zOmE");
var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");

var $d3xqi = parcelRequire("d3xqi");
const $b69ddc7a728288ef$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $5uXOq.useRef)((0, $fjcgS.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $lhVtI.getEvent)(analyticsEvent)));
        }
    };
};
const $b69ddc7a728288ef$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $b69ddc7a728288ef$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $fjcgS.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $b69ddc7a728288ef$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $d3xqi.getSourceByInviteFlow)(inviteFlow)
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $b69ddc7a728288ef$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        source: source != null && source !== '' ? source : 'unknown'
    };
    $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("d3xqi", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $1b54655f5f68975f$export$c35cd18e9d0123e3);
const $1b54655f5f68975f$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



parcelRegister("emsei", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});

const $6609d397a0e35e52$export$eef3ca04e2ec81e0 = 300;
const $6609d397a0e35e52$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $6609d397a0e35e52$export$bdab9bfb39981463 = 'unassigned';
const $6609d397a0e35e52$export$34c10ac17efea7b3 = 'assignToMe';
const $6609d397a0e35e52$export$f5d5f6bb902f1027 = 'automatic';
const $6609d397a0e35e52$export$f42e6736d1a95712 = '-1';



parcelRegister("8PHFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $abf29426d3e3306c$export$2e2bcd8739ae039);
/* eslint-disable react/no-find-dom-node */ 
var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fVnbM = parcelRequire("fVnbM");

var $az4zD = parcelRequire("az4zD");


var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $WFrhP = parcelRequire("WFrhP");
// eslint-disable-next-line jira/react/no-class-components
class $abf29426d3e3306c$var$SingleUserSelect extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isEditable: true
        };
    }
    constructor(props){
        super(props), this.onEditStart = ()=>{
            const { onEditStart: onEditStart } = this.props;
            onEditStart && onEditStart();
        }, this.onEditCancel = ()=>{
            const { onEditCancel: onEditCancel } = this.props;
            onEditCancel && onEditCancel();
        }, this.onSubmit = (fieldValue)=>{
            const { onSubmit: onSubmit, value: value } = this.props;
            const isValueUnchanged = value == null && fieldValue == null || value && fieldValue && value.accountId === fieldValue.accountId;
            if (isValueUnchanged) return;
            onSubmit && onSubmit(fieldValue);
        }, this.onSuccess = (fieldValue)=>{
            const { onEditSuccess: onEditSuccess } = this.props;
            onEditSuccess && onEditSuccess(fieldValue);
        }, this.onFailure = ()=>{
            const { onEditFailure: onEditFailure } = this.props;
            onEditFailure && onEditFailure();
        }, this.onMouseEnter = ()=>{
            if (this.node) {
                if (this.state.fieldVerticalOffset !== this.node.offsetTop || this.state.fieldHorizontalOffset !== this.node.offsetLeft) this.setState({
                    fieldVerticalOffset: this.node.offsetTop,
                    fieldHorizontalOffset: this.node.offsetLeft
                });
            }
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSetRef = (ref)=>{
            if (ref && ref instanceof HTMLElement) {
                this.node = ref;
                if ((this.state.fieldVerticalOffset !== ref.offsetTop || this.state.fieldHorizontalOffset !== ref.offsetLeft) && ref.offsetParent instanceof HTMLElement) this.setState({
                    fieldVerticalOffset: ref.offsetTop,
                    fieldHorizontalOffset: ref.offsetLeft
                });
            }
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSetEditingRef = (ref)=>{
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'ReactInstance | null | undefined'.
            const node = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).findDOMNode(ref);
            if (ref && node instanceof HTMLElement) {
                this.editingNode = node;
                const { onSetEditingFieldPosition: onSetEditingFieldPosition } = this.props;
                const { fieldHorizontalOffset: fieldHorizontalOffset, fieldVerticalOffset: fieldVerticalOffset } = this.state;
                this.setState({
                    fieldHorizontalOffset: fieldHorizontalOffset,
                    fieldVerticalOffset: fieldVerticalOffset
                });
                if (node.offsetParent instanceof HTMLElement) onSetEditingFieldPosition(fieldHorizontalOffset, fieldVerticalOffset, node.offsetWidth, node.offsetParent.offsetWidth, node.offsetParent.offsetHeight);
            }
        }, this.renderAssigneeButton = ()=>{
            const { value: value, AssigneeButton: AssigneeButton, isUserPickerDisabled: isUserPickerDisabled, isLastColumn: isLastColumn, isEditable: isEditable, overrideDisabledAppearance: overrideDisabledAppearance } = this.props;
            const isButtonDisabled = !isEditable || isUserPickerDisabled;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AssigneeButton, {
                assignee: value,
                isButtonDisabled: isButtonDisabled,
                overrideDisabledAppearance: overrideDisabledAppearance,
                onClick: !isButtonDisabled ? this.onEditStart : undefined,
                onMouseEnter: this.onMouseEnter,
                isLastColumn: isLastColumn
            });
        };
        this.state = {
            fieldVerticalOffset: 0,
            fieldHorizontalOffset: 0
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.width !== this.props.width && this.props.isFieldLocked && this.editingNode && this.editingNode.offsetParent instanceof HTMLElement) this.props.onSetEditingFieldPosition(this.editingNode.offsetLeft, this.editingNode.offsetTop, this.editingNode.offsetWidth, this.editingNode.offsetParent.offsetWidth, this.editingNode.offsetParent.offsetHeight);
    }
    componentWillUnmount() {
        this.node = null;
    }
    renderFullLengthAvatar() {
        const { isEditable: isEditable, issueKey: issueKey, width: width, isLastColumn: isLastColumn, value: value } = this.props;
        let assigneeButtonKey;
        if (value && value.accountId) assigneeButtonKey = `${issueKey}-${isEditable.toString()}-${value.accountId}`;
        else assigneeButtonKey = `${issueKey}-${isEditable.toString()}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                width: width || 'auto'
            },
            ref: this.onSetRef,
            "data-testid": `issue-table.view.fields.common.single-user-select.${issueKey}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            key: assigneeButtonKey,
            component: this.renderAssigneeButton
        })));
    }
    renderWithProfileCard(element) {
        if (!this.props.value) return null;
        const { ProfileCard: ProfileCard } = this.props;
        const { accountId: accountId } = this.props.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProfileCard, {
            accountId: accountId,
            TenantContextSubscriber: (0, $4R6GH.fg)('empanada_nin_concurrent_mode_fixes') ? undefined : (0, $9OXo1.TenantContextSubscriber),
            actions: [
                (0, $e6a2e0952e4731b8$export$23cedd3261bd8015),
                (0, $e6a2e0952e4731b8$export$6bef782d14a92db8)
            ]
        }, element);
    }
    renderUserSelect() {
        const { value: value, width: width, fieldType: fieldType, fieldId: fieldId, issueKey: issueKey, UserSelect: UserSelect, rowListRef: rowListRef, onSetEditingFieldPosition: onSetEditingFieldPosition, onEditSelection: onEditSelection, isSaving: isSaving } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UserSelect, {
            issueKey: issueKey,
            fieldType: fieldType,
            fieldId: fieldId,
            width: width,
            value: value,
            onSubmit: this.onSubmit,
            onEditCancel: this.onEditCancel,
            onEditSuccess: this.onSuccess,
            onEditFailure: this.onFailure,
            onEditSelection: onEditSelection,
            onComponentLoadFailure: this.onEditCancel,
            rowListRef: rowListRef,
            onSetDropdownLocation: onSetEditingFieldPosition,
            ref: this.onSetEditingRef,
            isSaving: isSaving,
            onSetEditingRef: this.onSetEditingRef
        });
    }
    render() {
        const { isFieldLocked: isFieldLocked } = this.props;
        if (isFieldLocked) return this.renderUserSelect();
        const avatarElement = this.renderFullLengthAvatar();
        if (!this.props.value || !this.props.value.accountId) return avatarElement;
        return this.renderWithProfileCard(avatarElement);
    }
}
var // @ts-expect-error - Argument of type 'typeof SingleUserSelect' is not assignable to parameter of type 'ComponentType<WithIntlProvided<{ isSaving: boolean; } & FieldComponentProps<UserFieldType> & { UserSelect: ComponentType<any>; ProfileCard: ComponentType<any>; AssigneeButton: ComponentType<...>; onEditSelection: () => void; }>> & typeof SingleUserSelect'.
$abf29426d3e3306c$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($abf29426d3e3306c$var$SingleUserSelect);

});
parcelRegister("WFrhP", function(module, exports) {

$parcel$export(module.exports, "COLUMN_GUTTER", () => $b108c2093c510418$export$515be1884a10d89);
$parcel$export(module.exports, "UnselectableChildGutterPaddingContainer", () => $b108c2093c510418$export$bc94b44cfbfbe38d);
$parcel$export(module.exports, "SelectableChildGutterPaddingContainer", () => $b108c2093c510418$export$4845bba6014b7a3e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $b108c2093c510418$export$515be1884a10d89 = {
    left: (0, $gwIPs.gridSize),
    right: (0, $gwIPs.gridSize) * 3,
    rightLastColumn: (0, $gwIPs.gridSize)
};
const $b108c2093c510418$var$breakWordStyle = {
    minWidth: '0px',
    overflowWrap: 'break-word'
};
const $b108c2093c510418$export$bc94b44cfbfbe38d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastColumn: isLastColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gg4a5j": (0, $lD23V.default)(`0px ${__cmplp.isLastColumn ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)"} 0px ${"var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt44105 _1ul9idpf _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $b108c2093c510418$export$4845bba6014b7a3e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastColumn: isLastColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf _1i4q1hna",
            __cmplp.isLastColumn ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});




parcelRegister("fvOC5", function(module, exports) {

$parcel$export(module.exports, "CmdbObjects", () => $10dc6da4efdec040$export$1db90f8a9b594ea2);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $bUUmN = parcelRequire("bUUmN");

var $fWKCI = parcelRequire("fWKCI");

var $hOUV1 = parcelRequire("hOUV1");
const $10dc6da4efdec040$export$1db90f8a9b594ea2 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(false);
    const enrichedObjects = (0, $hOUV1.filterEnrichedObjects)(props.dataSelectorProps.value);
    const [firstObject, ...remainingObjects] = (0, $hOUV1.sortCmdbObjects)(enrichedObjects);
    const handleShowMoreClick = (event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'insightObjectQueuesToggleShowMore', {
            action: isExpanded ? 'hiding' : 'showing'
        });
        setIsExpanded(!isExpanded);
    };
    const renderObject = (object)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10dc6da4efdec040$var$SingleObject, {
            key: object.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.MemoizedInsightIcon), {
            mediaClientConfig: object.avatar.mediaClientConfig,
            size: "xsmall",
            iconUrl: object.avatar.url16,
            label: object.label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10dc6da4efdec040$var$ObjectLabel, null, object.label));
    const hasMoreObjects = remainingObjects.length > 0;
    const showAllObjects = isExpanded && hasMoreObjects;
    if (!firstObject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10dc6da4efdec040$var$EmptyObject, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10dc6da4efdec040$var$MessageWrapper, null, formatMessage((0, $fWKCI.default).none)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10dc6da4efdec040$var$Wrapper, null, renderObject(firstObject), showAllObjects && remainingObjects.map(renderObject), hasMoreObjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: handleShowMoreClick
    }, isExpanded ? formatMessage((0, $fWKCI.default).showLess) : formatMessage((0, $fWKCI.default).showMore, {
        numberOfObjects: remainingObjects.length
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dc6da4efdec040$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dc6da4efdec040$var$SingleObject = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dc6da4efdec040$var$ObjectLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dc6da4efdec040$var$MessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt412v8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dc6da4efdec040$var$EmptyObject = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bUUmN", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $91b4a14cfc200b23$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $91b4a14cfc200b23$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $91b4a14cfc200b23$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $vIiRg = parcelRequire("vIiRg");
var $ujWmd = parcelRequire("ujWmd");
var $iDZjq = parcelRequire("iDZjq");

var $kOLg6 = parcelRequire("kOLg6");

var $xJtdX = parcelRequire("xJtdX");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");
const $91b4a14cfc200b23$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $91b4a14cfc200b23$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $91b4a14cfc200b23$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        baseUrl: clientAuth.mediaBaseUrl
    });
const $91b4a14cfc200b23$export$3cac96b307c02149 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    if (!mediaClientConfig || $91b4a14cfc200b23$export$d80733771196ad02(mediaClientConfig) === false) {
        if (iconUrl) return /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
            src: iconUrl,
            appearance: "square",
            size: size,
            name: label
        });
        return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $vIiRg.AVATAR_SIZES)[size],
        height: (0, $vIiRg.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $kOLg6.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>$91b4a14cfc200b23$export$a39db5532f57c7c2(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $5uXOq.createElement((0, $iDZjq.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
        return /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
            src: data.src,
            appearance: "square",
            size: size,
            name: label
        });
    });
};
const $91b4a14cfc200b23$export$c9cbd60c1615f1b8 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    const sizeInPx = (0, $vIiRg.AVATAR_SIZES)[size];
    const renderAvatar = (src)=>/*#__PURE__*/ $5uXOq.createElement("img", {
            loading: "lazy",
            src: src,
            width: sizeInPx,
            height: sizeInPx,
            alt: ""
        });
    if (!mediaClientConfig || $91b4a14cfc200b23$export$d80733771196ad02(mediaClientConfig) === false) {
        if (iconUrl) return renderAvatar(iconUrl);
        return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $vIiRg.AVATAR_SIZES)[size],
        height: (0, $vIiRg.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $kOLg6.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>$91b4a14cfc200b23$export$a39db5532f57c7c2(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $5uXOq.createElement((0, $iDZjq.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
        return renderAvatar(data.src);
    });
};
const $91b4a14cfc200b23$export$4f72cced31fa9b94 = (0, $cSD7y.componentWithFG)('jsdcloud-14092-lazy-load-img', $91b4a14cfc200b23$export$c9cbd60c1615f1b8, $91b4a14cfc200b23$export$3cac96b307c02149);
const $91b4a14cfc200b23$export$55641517b59933d7 = /*#__PURE__*/ (0, $5uXOq.memo)($91b4a14cfc200b23$export$4f72cced31fa9b94);
const $91b4a14cfc200b23$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$UnstyledInsightIconWrapper, {
        isFGEnabled: (0, $4R6GH.fg)('jsdcloud-14092-lazy-load-img')
    }, /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91b4a14cfc200b23$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFGEnabled: isFGEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y _p7r1tcjq _1ugpglyw",
            __cmplp.isFGEnabled && "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iDZjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b6b09c530db49a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $vIiRg = parcelRequire("vIiRg");
function $31b6b09c530db49a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $31b6b09c530db49a$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $vIiRg.CSS_VAR_AVATAR_BGCOLOR)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    border: `${(0, $vIiRg.BORDER_WIDTH)}px solid transparent`
});
const $31b6b09c530db49a$var$sizeStyles = Object.entries((0, $vIiRg.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`
        })
    };
}, {});
const $31b6b09c530db49a$var$radiusStyles = Object.entries((0, $vIiRg.AVATAR_RADIUS)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderRadius: `${size}px`
        })
    };
}, {});
const $31b6b09c530db49a$var$defaultRadiusStyles = {
    name: "1by8p7f",
    styles: "border-radius:var(--ds-border-radius-circle, 50%)"
};
const $31b6b09c530db49a$var$strongOpacityStyles = {
    name: "19sqbed",
    styles: "opacity:0.3"
};
const $31b6b09c530db49a$var$defaultOpacityStyles = {
    name: "1rz7oiv",
    styles: "opacity:0.15"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $31b6b09c530db49a$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $31b6b09c530db49a$var$skeletonStyles,
            $31b6b09c530db49a$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' ? $31b6b09c530db49a$var$radiusStyles[size ?? 'medium'] : $31b6b09c530db49a$var$defaultRadiusStyles,
            weight === 'strong' ? $31b6b09c530db49a$var$strongOpacityStyles : $31b6b09c530db49a$var$defaultOpacityStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $vIiRg.CSS_VAR_AVATAR_BGCOLOR)]: color ?? 'currentColor'
        }
    });
var $31b6b09c530db49a$export$2e2bcd8739ae039 = $31b6b09c530db49a$var$Skeleton;

});

parcelRegister("kOLg6", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $27dd12b02502711d$export$758a2fef95a29ad0);

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $eYKm8 = parcelRequire("eYKm8");
const $27dd12b02502711d$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYKm8.MediaImageWithMediaClient), props));

});
parcelRegister("eYKm8", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $eecef2c1b93fb3db$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iArlU = parcelRequire("iArlU");

var $10b0h = parcelRequire("10b0h");

var $VSDnB = parcelRequire("VSDnB");
const $eecef2c1b93fb3db$var$copyDivStyles = null;
const $eecef2c1b93fb3db$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $10b0h.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), (0, $VSDnB.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: copyNodeRef,
        className: (0, $bwpsq.default)([
            "_1e0cglyw"
        ])
    }), getSsrScriptProps && /*#__PURE__*/ $5uXOq.createElement("script", getSsrScriptProps()));
};
const $eecef2c1b93fb3db$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $5uXOq.useMemo)(()=>(0, $iArlU.withMediaClient)($eecef2c1b93fb3db$var$MediaImageBase), []);
    return /*#__PURE__*/ $5uXOq.createElement(MediaImageComponent, props);
};

});
parcelRegister("iArlU", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $104af301cec809a6$export$9f7977d4a2561bee);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");
const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                }))));

});

parcelRegister("10b0h", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $baceb2843b357d39$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $1Pp1U = parcelRequire("1Pp1U");
var $gFZHi = parcelRequire("gFZHi");

var $93kaw = parcelRequire("93kaw");
var $24tOd = parcelRequire("24tOd");
var $cEHh7 = parcelRequire("cEHh7");

var $8GKRF = parcelRequire("8GKRF");

var $kGpuq = parcelRequire("kGpuq");

var $01sWe = parcelRequire("01sWe");

var $3JWNV = parcelRequire("3JWNV");
var $4n1NZ = parcelRequire("4n1NZ");
var $7xRaJ = parcelRequire("7xRaJ");

var $3JZCV = parcelRequire("3JZCV");
var $jR4hE = parcelRequire("jR4hE");

var $8Kbwv = parcelRequire("8Kbwv");
const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $8Kbwv.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $8Kbwv.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $jR4hE.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $3JWNV.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $kGpuq.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $1Pp1U.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('metadata-fetch', (0, $gFZHi.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $8Kbwv.useCurrentValueRef)(()=>{
        return (0, $3JWNV.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $8Kbwv.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $8Kbwv.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $8Kbwv.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $4n1NZ.isSupportedLocalPreview)(mediaType) && (0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $3JWNV.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $8Kbwv.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $3JWNV.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $01sWe.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $3JWNV.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $3JWNV.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $3JWNV.isLocalPreview)(failedPreview);
        const isRemote = (0, $3JWNV.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $01sWe.ImageLoadError)(failedPreview?.source);
            (0, $7xRaJ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $3JWNV.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $3JWNV.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $3JZCV.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $93kaw.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("93kaw", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $d123d92fa0d5c1a9$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $cEHh7 = parcelRequire("cEHh7");

var $7wsJE = parcelRequire("7wsJE");

var $eaxUQ = parcelRequire("eaxUQ");
function $d123d92fa0d5c1a9$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $d123d92fa0d5c1a9$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const registerCopyIntentRef = $d123d92fa0d5c1a9$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $7wsJE.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $7wsJE.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) (0, $eaxUQ.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $eaxUQ.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("7wsJE", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $9a6af4835a9857e5$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $9a6af4835a9857e5$export$aacb463551da2e8f);

var $1As4I = parcelRequire("1As4I");
const $9a6af4835a9857e5$var$getRequestErrorDetails = (err)=>{
    if ((0, $1As4I.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $9a6af4835a9857e5$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $1As4I.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$9a6af4835a9857e5$var$getRequestErrorDetails(error)
        }
    };
};
const $9a6af4835a9857e5$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("eaxUQ", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $9ea95d3f3a6b1d04$export$f65ca476c09acec0);
const $9ea95d3f3a6b1d04$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("24tOd", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $768d10f5fd62ab89$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $k4CmR = parcelRequire("k4CmR");
function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const fileState = (0, $k4CmR.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("k4CmR", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $a907ffa2ecfaf54d$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $cEHh7 = parcelRequire("cEHh7");
const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("kGpuq", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $d93d75d54376e990$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $d93d75d54376e990$export$768c370ed0dbaeb3);

var $gFZHi = parcelRequire("gFZHi");

var $01sWe = parcelRequire("01sWe");
const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
        error: $d93d75d54376e990$export$88c61dcad53762da(error),
        errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
    };
};
const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, $01sWe.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("01sWe", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $fcceba16863dd854$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $fcceba16863dd854$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $fcceba16863dd854$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $fcceba16863dd854$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $fcceba16863dd854$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $fcceba16863dd854$export$7156ce7b78b49bd7);
class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(source){
        super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
    }
}
function $fcceba16863dd854$export$553696a6e769784c(err) {
    return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
}
const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($fcceba16863dd854$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("3JWNV", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $609060e8f7210c63$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $609060e8f7210c63$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $609060e8f7210c63$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $609060e8f7210c63$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $609060e8f7210c63$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $609060e8f7210c63$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $609060e8f7210c63$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $609060e8f7210c63$export$98e935d981c884d);

var $9KG2L = parcelRequire("9KG2L");

var $01sWe = parcelRequire("01sWe");

var $7xRaJ = parcelRequire("7xRaJ");

var $4n1NZ = parcelRequire("4n1NZ");
const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7xRaJ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $01sWe.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $4n1NZ.getRemotePreview)(mediaClient, id, params, traceContext);
    return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $4n1NZ.getLocalPreview)(filePreview);
    return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7xRaJ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $abbc266dbfedc514$export$b7e8ee3f7a41459);

var $aAIop = parcelRequire("aAIop");
const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $abbc266dbfedc514$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, $aAIop.createObjectURLCache)());

});
parcelRegister("aAIop", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0cfc22aea6c15367$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);

});


parcelRegister("4n1NZ", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b75ec6170865ae7$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3b75ec6170865ae7$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3b75ec6170865ae7$export$bfe20bd01db02b3);

var $jzW7G = parcelRequire("jzW7G");

var $48aIR = parcelRequire("48aIR");

var $01sWe = parcelRequire("01sWe");

var $Nl5sY = parcelRequire("Nl5sY");
const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $48aIR.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $Nl5sY.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3b75ec6170865ae7$var$getImageLocalPreview(value);
            case 'video':
                return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
            default:
                throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
};
const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $01sWe.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8ba626f637ae3df3$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("8iz07"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("8iz07", function(module, exports) {

let $60ab27a2818ad2da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60ab27a2818ad2da$var$load("7lJbN").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("8u6C4"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("8u6C4", function(module, exports) {

let $019819d3d04dcea8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $019819d3d04dcea8$var$load("jODAF").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("Nl5sY", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $33ec34d1173165de$export$4269d30173168e5c);
const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("3JZCV", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $293d53ca8ea6912a$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $293d53ca8ea6912a$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $293d53ca8ea6912a$export$de7c49925e44d75d);

var $1QRxp = parcelRequire("1QRxp");
const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $1QRxp.printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $1QRxp.printScript)([
        $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
        $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("1QRxp", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $56ce1649d25a132b$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $56ce1649d25a132b$export$8b902fb69a2f17c1);
const $56ce1649d25a132b$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;

});


parcelRegister("jR4hE", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $815e3e27cebcb154$export$d3a890b0f7844b6f);

var $3JZCV = parcelRequire("3JZCV");
const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $3JZCV.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $3JZCV.getKey)(identifier)];
};

});

parcelRegister("8Kbwv", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $7b6d905fc3b6f0e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $7b6d905fc3b6f0e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});





parcelRegister("fWKCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6aad1c58c49e9c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f6aad1c58c49e9c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showLess: {
        "id": "issue-table.common.fields.cmdb-object.show-less",
        "defaultMessage": "\u2026 Show less"
    },
    showMore: {
        "id": "issue-table.common.fields.cmdb-object.show-more",
        "defaultMessage": "\u2026 ({numberOfObjects, plural, one {# more} other {# more}})"
    },
    none: {
        "id": "issue-table.common.fields.cmdb-object.none",
        "defaultMessage": "None"
    }
});

});

parcelRegister("hOUV1", function(module, exports) {

$parcel$export(module.exports, "filterEnrichedObjects", () => $9662dd1182307721$export$91f05c2342ca3f05);
$parcel$export(module.exports, "sortCmdbObjects", () => $9662dd1182307721$export$51618eba19894675);
const $9662dd1182307721$var$baseKeys = [
    'id',
    'workspaceId',
    'objectId',
    'objectKey',
    'label',
    'avatar',
    'objectType',
    'links',
    'attributes'
];
const $9662dd1182307721$export$91f05c2342ca3f05 = (values)=>{
    const isEnrichedObject = (value)=>{
        const keys = Object.keys(value);
        return $9662dd1182307721$var$baseKeys.every((key)=>keys.includes(key));
    };
    return values.filter(isEnrichedObject);
};
const $9662dd1182307721$export$51618eba19894675 = (unsortedObjects)=>unsortedObjects.sort((objectOne, objectTwo)=>{
        if (objectOne.label.toLowerCase() < objectTwo.label.toLowerCase()) return -1;
        if (objectOne.label.toLowerCase() > objectTwo.label.toLowerCase()) return 1;
        return 0;
    });

});


parcelRegister("gP8gO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f58cf99e3ea6cd3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $1f58cf99e3ea6cd3$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: { displayName: displayName } } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, displayName);
}

});

parcelRegister("bX58l", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e65a0a2ae9e4c85$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");
function $9e65a0a2ae9e4c85$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: value } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9e65a0a2ae9e4c85$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VHMR.FormattedDate), {
        value: value,
        year: "numeric",
        month: "short",
        day: "numeric"
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e65a0a2ae9e4c85$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3idpf _n3tdu2gc _19bvu2gc _1i4q1hna",
            __cmplp.className
        ])
    });
});

});

parcelRegister("39WmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1041dd6b5ff2670f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bmFfn = parcelRequire("bmFfn");

var $6IW7j = parcelRequire("6IW7j");

var $WFrhP = parcelRequire("WFrhP");
const $1041dd6b5ff2670f$var$Entitlement = ({ dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } })=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmFfn.ReadView), {
        name: (0, $6IW7j.getNameFromFieldData)(value)
    })) : null;
var $1041dd6b5ff2670f$export$2e2bcd8739ae039 = $1041dd6b5ff2670f$var$Entitlement;

});
parcelRegister("bmFfn", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $461e7ac525ea3cb2$export$a4b5824ec1e018e1);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jbUS9 = parcelRequire("jbUS9");

var $iluUH = parcelRequire("iluUH");
const $461e7ac525ea3cb2$export$a4b5824ec1e018e1 = ({ name: name })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: [
            $461e7ac525ea3cb2$var$containerStyles,
            !name && $461e7ac525ea3cb2$var$placeholderStyles,
            $461e7ac525ea3cb2$var$overflowStyles,
            $461e7ac525ea3cb2$var$alignmentFixStyles
        ],
        testId: "servicedesk-customer-service-entitlements-field.common.ui.read-view.inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbUS9.LabelIcon), {
        size: "xsmall",
        type: "PRODUCT"
    }), name || formatMessage((0, $iluUH.default).entitlementFieldPlaceholder));
};
const $461e7ac525ea3cb2$var$containerStyles = (0, $8CUq3.xcss)({
    margin: 'space.050'
});
const $461e7ac525ea3cb2$var$placeholderStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest'
});
const $461e7ac525ea3cb2$var$overflowStyles = (0, $8CUq3.xcss)({
    overflowWrap: 'anywhere'
});
const $461e7ac525ea3cb2$var$alignmentFixStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100'
});

});
parcelRegister("jbUS9", function(module, exports) {

$parcel$export(module.exports, "LabelIcon", () => $2a46531b31edbe20$export$6722f2abd5aa752a);

var $5uXOq = parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $lSrt8 = parcelRequire("lSrt8");

var $bB6uF = parcelRequire("bB6uF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $dCm1o = parcelRequire("dCm1o");
const $2a46531b31edbe20$export$6722f2abd5aa752a = ({ size: size, type: type, label: label = '', testId: testId, ...etc })=>{
    const Icon = type === 'ORGANIZATION' ? (0, (/*@__PURE__*/$parcel$interopDefault($lSrt8))) : (0, (/*@__PURE__*/$parcel$interopDefault($bB6uF)));
    const iconSize = size === 'large' ? 'large' : 'small';
    const isLarge = size === 'large';
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $2a46531b31edbe20$var$containerStyles,
            size === 'small' && $2a46531b31edbe20$var$smallStyles,
            size === 'xsmall' && $2a46531b31edbe20$var$xsmallStyles
        ],
        testId: testId
    }, isLarge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
        icon: Icon,
        appearance: "gray",
        shape: "square",
        size: "40",
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`,
        label: label,
        ...etc
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $2a46531b31edbe20$var$containerStyles,
            size === 'large' && $2a46531b31edbe20$var$largeStyles,
            size === 'small' && $2a46531b31edbe20$var$smallStyles,
            size === 'xsmall' && $2a46531b31edbe20$var$xsmallStyles
        ],
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        LEGACY_primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`,
        LEGACY_size: iconSize,
        label: label,
        ...etc
    }));
};
const $2a46531b31edbe20$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral'
});
const $2a46531b31edbe20$var$largeStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.200',
    padding: 'space.050'
});
const $2a46531b31edbe20$var$smallStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.050'
});
const $2a46531b31edbe20$var$xsmallStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.025'
});

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $a921419639fe8f6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a921419639fe8f6f$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $a921419639fe8f6f$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $a921419639fe8f6f$var$iconTileStyles = {
    name: "1ot07ws",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;font-size:0"
};
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        css: [
            $a921419639fe8f6f$var$iconTileStyles,
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});

parcelRegister("lSrt8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::256a7838c06b0fb117b2e3d975619c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fed3f2dc0bb9ed52$var$_react = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fed3f2dc0bb9ed52$var$_officeBuilding = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("4bTdk")));

var $fed3f2dc0bb9ed52$var$_officeBuildingFilled = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("e8Dhe")));
function $fed3f2dc0bb9ed52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fed3f2dc0bb9ed52$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $fed3f2dc0bb9ed52$var$_react.default.createElement($fed3f2dc0bb9ed52$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $fed3f2dc0bb9ed52$var$_officeBuildingFilled.default
    }, props));
$fed3f2dc0bb9ed52$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $fed3f2dc0bb9ed52$var$_default = module.exports.default = $fed3f2dc0bb9ed52$var$OfficeBuildingIcon;

});
parcelRegister("4bTdk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f21072bf633f52ccad293b3c613d94e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30d304d6d8375db3$var$_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $30d304d6d8375db3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
    }, props));
$30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;

});

parcelRegister("e8Dhe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4b0479e3879f3a8$var$_react = $a4b0479e3879f3a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a4b0479e3879f3a8$var$_officeBuilding = $a4b0479e3879f3a8$var$_interopRequireDefault((parcelRequire("4bTdk")));
function $a4b0479e3879f3a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon = (props)=>/*#__PURE__*/ $a4b0479e3879f3a8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8z"/><path fill="inherit" d="M6 10h2v2H6zm0 3h2v2H6z"/><path fill="currentcolor" d="M9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/><path fill="inherit" d="M12 7h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/></g></svg>`
    }, props, {
        newIcon: $a4b0479e3879f3a8$var$_officeBuilding.default
    }));
$a4b0479e3879f3a8$var$OfficeBuildingFilledIcon.displayName = 'OfficeBuildingFilledIcon';
var $a4b0479e3879f3a8$var$_default = module.exports.default = $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon;

});



parcelRegister("iluUH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5bebffb8093304f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a5bebffb8093304f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    entitlementFieldPlaceholder: {
        "id": "servicedesk-customer-service-entitlements-field.common.read-view.entitlement-field-placeholder",
        "defaultMessage": "None"
    }
});

});


parcelRegister("6IW7j", function(module, exports) {

$parcel$export(module.exports, "getNameFromFieldData", () => $00312883dde1c26d$export$88049b8e8e0c8291);
const $00312883dde1c26d$export$88049b8e8e0c8291 = (value)=>value?.product?.name;

});


parcelRegister("ebFN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $616da4ea71d8a51f$export$2e2bcd8739ae039);

var $1bQGJ = parcelRequire("1bQGJ");

var $cSD7y = parcelRequire("cSD7y");

var $iQFwo = parcelRequire("iQFwo");

var $p64Ah = parcelRequire("p64Ah");

var $kMid8 = parcelRequire("kMid8");
const $616da4ea71d8a51f$var$mapStateToProps = (state)=>({
        useJSMQueueDurationEvent: (0, $iQFwo.getUseJSMQueueDurationEvent)(state)
    });
const $616da4ea71d8a51f$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps
    });
const $616da4ea71d8a51f$var$IssueKeyConnected = (0, $p64Ah.connect)($616da4ea71d8a51f$var$mapStateToProps, {}, $616da4ea71d8a51f$var$mergeProps)((0, $kMid8.default));
var $616da4ea71d8a51f$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('use_queues_url_for_issue_link_on_jsm_queues', (0, $1bQGJ.withRouter)($616da4ea71d8a51f$var$IssueKeyConnected), $616da4ea71d8a51f$var$IssueKeyConnected);

});
parcelRegister("kMid8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4e81a8b917ff682$export$2e2bcd8739ae039);
/* eslint-disable jira/react/no-style-attribute */ 
var $5uXOq = parcelRequire("5uXOq");


var $3bDjY = parcelRequire("3bDjY");

var $41j30 = parcelRequire("41j30");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $WFrhP = parcelRequire("WFrhP");
const $a4e81a8b917ff682$var$TruncateFirstSpan = ({ children: children, innerRef: innerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: innerRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexGrow: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 10000,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: '12px'
        }
    }, children);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a4e81a8b917ff682$var$TruncateSecondSpan = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexGrow: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexBasis: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: '12px'
        }
    }, children);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a4e81a8b917ff682$var$StandaloneTruncateDiv = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, children);
const $a4e81a8b917ff682$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'flex',
    flexGrow: 1
};
const $a4e81a8b917ff682$var$SECONDARY_LINK_STYLE = {
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N90})`
};
const $a4e81a8b917ff682$var$getSecondaryLinkStyle = ()=>$a4e81a8b917ff682$var$SECONDARY_LINK_STYLE;
const $a4e81a8b917ff682$var$PADDING_STYLE = {
    padding: `10px ${"var(--ds-space-075, 6px)"} 10px ${"var(--ds-space-075, 6px)"}`,
    width: 'auto'
};
const $a4e81a8b917ff682$var$getFocusStyle = (isFocused)=>({
        borderColor: isFocused ? `${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`}` : 'transparent',
        borderRadius: '3px',
        borderWidth: '2px',
        borderStyle: 'solid',
        boxShadow: 'none',
        outline: 'none'
    });
const $a4e81a8b917ff682$var$getFocusableTruncatingParentLinkStyle = (isFocused)=>({
        ...$a4e81a8b917ff682$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE,
        ...$a4e81a8b917ff682$var$getSecondaryLinkStyle(),
        ...$a4e81a8b917ff682$var$PADDING_STYLE,
        ...$a4e81a8b917ff682$var$getFocusStyle(isFocused)
    });
const $a4e81a8b917ff682$var$disabledStyle = {
    ...$a4e81a8b917ff682$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE,
    ...$a4e81a8b917ff682$var$getSecondaryLinkStyle(),
    padding: `${"var(--ds-space-150, 12px)"} 0px`
};
const $a4e81a8b917ff682$export$fd902cb3210d888f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            flexGrow: 10
        }
    });
const $a4e81a8b917ff682$var$renderNonInteractiveIssueKey = (isLastColumn, issueKey)=>// Monolith still relies on 'issuekey' class selector for it's webdriver tests
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
        className: "issuekey",
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4e81a8b917ff682$var$StandaloneTruncateDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: $a4e81a8b917ff682$var$disabledStyle
    }, issueKey)));
class $a4e81a8b917ff682$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            linkStyle: {}
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataSelectorProps.value !== nextProps.dataSelectorProps.value || this.props.tableInjectedProps.isTableDisabled !== nextProps.tableInjectedProps.isTableDisabled || this.state.isFocused !== nextState.isFocused || this.state.tooltipText !== nextState.tooltipText;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderIssueKeyLink(issueKey, projectKey, issueNumber) {
        // hardcode the url in href below after use_queues_url_for_issue_link_on_jsm_queues cleanup
        // as match will always exist after
        const queuesPathWithIssueKey = this.props.match ? `${this.props.match?.url}/${issueKey}` : `/browse/${issueKey}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$a4e81a8b917ff682$var$getFocusableTruncatingParentLinkStyle(this.state.isFocused),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.linkStyle
            },
            onMouseOver: this.onMouseOver,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            href: (0, $4R6GH.fg)('use_queues_url_for_issue_link_on_jsm_queues') ? queuesPathWithIssueKey : `/browse/${issueKey}`,
            onClick: this.onClick,
            onAuxClick: this.onAuxClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issue-link",
            'data-issue-key': issueKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4e81a8b917ff682$var$TruncateFirstSpan, {
            innerRef: this.onSetProjectKeyRef
        }, projectKey), "-", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4e81a8b917ff682$var$TruncateSecondSpan, null, issueNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4e81a8b917ff682$export$fd902cb3210d888f, null));
    }
    renderNonInteractiveIssueKeyFF(isLastColumn, issueKey, projectKey, issueNumber) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
            // Monolith still relies on 'issuekey' class selector for it's webdriver tests
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issuekey",
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $a4e81a8b917ff682$var$disabledStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4e81a8b917ff682$var$TruncateFirstSpan, {
            innerRef: this.onSetProjectKeyRef
        }, projectKey), "-", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4e81a8b917ff682$var$TruncateSecondSpan, null, issueNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4e81a8b917ff682$export$fd902cb3210d888f, null));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderWithTooltipIfRequired(content) {
        const { tooltipText: tooltipText } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.SelectableChildGutterPaddingContainer), {
            // Monolith still relies on 'issuekey' class selector for it's webdriver tests
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issuekey",
            isLastColumn: this.props.tableInjectedProps.isLastColumn
        }, tooltipText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            delay: 0,
            content: tooltipText
        }, content) : content);
    }
    render() {
        const { dataSelectorProps: { value: issueKey }, tableInjectedProps: { isLastColumn: isLastColumn, isTableDisabled: isTableDisabled } } = this.props;
        const splitIssueKey = issueKey.split('-');
        if (splitIssueKey && splitIssueKey.length === 2) {
            if (!isTableDisabled) return this.renderWithTooltipIfRequired(this.renderIssueKeyLink(issueKey, splitIssueKey[0], splitIssueKey[1]));
            return this.renderNonInteractiveIssueKeyFF(isLastColumn, issueKey, splitIssueKey[0], splitIssueKey[1]);
        }
        return $a4e81a8b917ff682$var$renderNonInteractiveIssueKey(isLastColumn, issueKey);
    }
    constructor(...args){
        super(...args), this.state = {
            isFocused: false,
            tooltipText: ''
        }, this.onSetProjectKeyRef = (ref)=>{
            // @ts-expect-error - TS2322 - Type 'HTMLElement | null | undefined' is not assignable to type 'null'.
            this.projectKeyRef = ref;
        }, this.onFocus = ()=>{
            this.setState({
                isFocused: true
            });
        }, this.onBlur = ()=>{
            this.setState({
                isFocused: false
            });
        }, this.onMouseOver = ()=>{
            if (this.projectKeyRef) {
                let tooltipText = '';
                // Check if the element has overflown. If yes, set the innerText in state for tooltip to display
                // @ts-expect-error - TS2339 - Property 'scrollWidth' does not exist on type 'never'. | TS2339 - Property 'offsetWidth' does not exist on type 'never'.
                if (this.projectKeyRef.scrollWidth > this.projectKeyRef.offsetWidth) tooltipText = this.props.dataSelectorProps.value;
                if (this.state.tooltipText !== tooltipText) this.setState(()=>({
                        tooltipText: tooltipText
                    }));
            }
        }, this.onClick = (event, analyticsEvent)=>{
            const { onIssueViewTransition: onIssueViewTransition } = this.props.tableInjectedProps;
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
            onIssueViewTransition?.(event);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        }, this.onAuxClick = ()=>{
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        }, this.projectKeyRef = null;
    }
}

});


parcelRegister("cV5BJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $83cbff06e8a4a7c4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9SgXQ = parcelRequire("9SgXQ");

var $jlP00 = parcelRequire("jlP00");
// TODO: Show meatball only onHover and onFocus
const $83cbff06e8a4a7c4$var$IssueOperations = ({ tableInjectedProps: { issueKey: issueKey }, dataSelectorProps: { issueId: issueId, useRefetch: useRefetch } })=>{
    const { onRefetch: onRefetch } = useRefetch();
    const [flags, setFlags] = (0, $5uXOq.useState)([]);
    const onAddFlag = (styleClass, isSuccessful)=>setFlags([
            {
                id: flags.length + 1,
                styleClass: styleClass,
                isSuccessful: isSuccessful
            },
            ...flags
        ]);
    const onDismissFlag = ()=>setFlags(flags.slice(1));
    const onIssueRefetch = ()=>onRefetch(issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83cbff06e8a4a7c4$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9SgXQ.default), {
        issueId: issueId,
        issueKey: issueKey,
        onAddFlag: onAddFlag,
        onIssueRefetch: onIssueRefetch
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlP00.default), {
        flags: flags,
        onDismiss: onDismissFlag,
        issueKey: issueKey
    }));
};
var $83cbff06e8a4a7c4$export$2e2bcd8739ae039 = $83cbff06e8a4a7c4$var$IssueOperations;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83cbff06e8a4a7c4$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9SgXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27394c83fc18533$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bJeNF = parcelRequire("bJeNF");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c27394c83fc18533$var$MeatballMenu = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5eEyK")), {
    ssr: false,
    moduleId: "./src/packages/issue-table/src/common/fields/issue-operations/meatball-menu/index.tsx"
});
const $c27394c83fc18533$var$AsyncMeatballMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c27394c83fc18533$var$MeatballMenu, props));
var $c27394c83fc18533$export$2e2bcd8739ae039 = $c27394c83fc18533$var$AsyncMeatballMenu;

});
parcelRegister("5eEyK", function(module, exports) {

let $3cfdb8cc244c9a1d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3cfdb8cc244c9a1d$var$load("4IY72").then(()=>parcelRequire('3HvsA'));

});


parcelRegister("jlP00", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e216136b7196bed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2i4s = parcelRequire("c2i4s");

var $dD7Zc = parcelRequire("dD7Zc");


var $7R4eB = parcelRequire("7R4eB");

var $f2BYd = parcelRequire("f2BYd");

var $koVbs = parcelRequire("koVbs");

var $6czss = parcelRequire("6czss");

var $dQwAa = parcelRequire("dQwAa");
const $0e216136b7196bed$var$NotificationFlagGroup = ({ flags: flags, onDismiss: onDismiss, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2BYd.default), {
        onDismissed: onDismiss
    }, flags.map(({ id: id, styleClass: styleClass, isSuccessful: isSuccessful })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
            id: id,
            icon: isSuccessful ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
                label: "Success",
                LEGACY_size: "medium",
                spacing: "spacious",
                color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                label: "Error",
                LEGACY_size: "medium",
                spacing: "spacious",
                color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
            }),
            key: id,
            title: isSuccessful ? formatMessage((0, $6czss.default).successTitle) : formatMessage((0, $6czss.default).errorTitle),
            description: isSuccessful ? formatMessage((0, $6czss.default)[(0, $dQwAa.getMessageId)(styleClass)], {
                issueKey: issueKey
            }) : formatMessage((0, $6czss.default).errorDesc, {
                issueKey: issueKey
            }),
            messageId: "issue-table.common.fields.issue-operations.notification-flag-group.auto-dismiss-flag",
            messageType: "transactional"
        })));
};
var $0e216136b7196bed$export$2e2bcd8739ae039 = $0e216136b7196bed$var$NotificationFlagGroup;

});
parcelRegister("f2BYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3780c7e328dbb70e$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$3780c7e328dbb70e$export$2e2bcd8739ae039 = (0, $3KRpp.FlagGroup);

});

parcelRegister("6czss", function(module, exports) {

$parcel$export(module.exports, "default", () => $b019aa73c9d2f474$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b019aa73c9d2f474$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    thanksIssueUpdated: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-updated",
        "defaultMessage": "{issueKey} has been updated."
    },
    thanksIssueAssigned: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-assigned",
        "defaultMessage": "{issueKey} has been assigned."
    },
    thanksIssueCommented: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-commented",
        "defaultMessage": "{issueKey} has been updated with your comment."
    },
    thanksIssueWorklogged: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-worklogged",
        "defaultMessage": "Work has been logged on {issueKey}."
    },
    thanksIssueVoted: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-voted",
        "defaultMessage": "Your vote on {issueKey} has been updated."
    },
    thanksIssueWatched: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-watched",
        "defaultMessage": "Your watcher status on {issueKey} has been updated."
    },
    thanksIssueMoved: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-moved",
        "defaultMessage": "{issueKey} has been moved."
    },
    thanksIssueLinked: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-linked",
        "defaultMessage": "The links on {issueKey} have been updated."
    },
    thanksIssueCloned: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-cloned",
        "defaultMessage": "{issueKey} has been cloned."
    },
    thanksIssueLabelled: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-labelled",
        "defaultMessage": "The labels on {issueKey} have been updated."
    },
    thanksIssueDeleted: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-deleted",
        "defaultMessage": "{issueKey} has been deleted."
    },
    thanksIssueAttached: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-attached",
        "defaultMessage": "The file(s) have been attached to {issueKey}."
    },
    successTitle: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.success-title",
        "defaultMessage": "Issue updated"
    },
    errorTitle: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.error-title",
        "defaultMessage": "Error"
    },
    errorDesc: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.error-desc",
        "defaultMessage": "Your operation on {issueKey} could not be performed."
    }
});

});

parcelRegister("dQwAa", function(module, exports) {

$parcel$export(module.exports, "getMessageId", () => $02b68bb05a4d70d4$export$7a6ec380c1221521);

var $7EVfN = parcelRequire("7EVfN");
const $02b68bb05a4d70d4$export$7a6ec380c1221521 = (styleClass)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "issueaction-assign-issue": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; readonly "issueaction-assign-to-me hide-from-opsbar": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; ... 5 more ...; readonly "issueaction-edit-labels": { ...; }; }'.
    (0, $7EVfN.DIALOG_DATA)[styleClass]?.issueMsg ?? 'thanksIssueUpdated';

});
parcelRegister("7EVfN", function(module, exports) {

$parcel$export(module.exports, "RANK_TO_TOP", () => $50b536fc90271654$export$a1d82a1fb322eabf);
$parcel$export(module.exports, "RANK_TO_BOTTOM", () => $50b536fc90271654$export$264804825e75ec82);
$parcel$export(module.exports, "OPERATION_IDS", () => $50b536fc90271654$export$498178c427a35252);
$parcel$export(module.exports, "LINK_IDS", () => $50b536fc90271654$export$1fff534c17344ccf);
$parcel$export(module.exports, "DIALOG_FIELDS", () => $50b536fc90271654$export$5ae74c325a8e870e);
$parcel$export(module.exports, "SKIP_FIELDS", () => $50b536fc90271654$export$cb2989a570fe66ad);
$parcel$export(module.exports, "URL_OVERRIDE_FIELDS", () => $50b536fc90271654$export$b86499b7cf24c281);
$parcel$export(module.exports, "DIALOG_DATA", () => $50b536fc90271654$export$f57e70208d0fb8b9);
const $50b536fc90271654$var$EDIT_ISSUE = 'issueaction-edit-issue';
const $50b536fc90271654$var$ASSIGN = 'issueaction-assign-issue';
const $50b536fc90271654$var$ASSIGN_TO_ME = 'issueaction-assign-to-me hide-from-opsbar';
const $50b536fc90271654$var$COMMENT_ISSUE = 'issueaction-comment-issue add-issue-comment';
const $50b536fc90271654$var$LOG_WORK = 'issueaction-log-work';
const $50b536fc90271654$var$AGILE_BOARD = 'issueaction-greenhopper-rapidboard-operation js-rapidboard-operation-issue';
const $50b536fc90271654$export$a1d82a1fb322eabf = 'issueaction-greenhopper-rank-top-operation';
const $50b536fc90271654$export$264804825e75ec82 = 'issueaction-greenhopper-rank-bottom-operation';
const $50b536fc90271654$var$ATTACH_FILE = 'unified-attach-file';
const $50b536fc90271654$var$ATTACH_SCREENSHOT = 'issueaction-attach-screenshot-html5';
const $50b536fc90271654$var$ADD_VOTE = 'issueaction-vote-issue';
const $50b536fc90271654$var$REMOVE_VOTE = 'issueaction-unvote-issue';
const $50b536fc90271654$var$VIEW_VOTERS = 'issueaction-view-voters';
const $50b536fc90271654$var$WATCH_ISSUE = 'issueaction-watch-issue';
const $50b536fc90271654$var$UNWATCH_ISSUE = 'issueaction-unwatch-issue';
const $50b536fc90271654$var$WATCHERS = 'issueaction-manage-watchers';
const $50b536fc90271654$var$CREATE_SUBTASK = 'issueaction-create-subtask';
const $50b536fc90271654$var$CONVERT_TO_ISSUE = 'issueaction-subtask-to-issue';
const $50b536fc90271654$var$CONVERT_TO_SUBTASK = 'issueaction-issue-to-subtask';
const $50b536fc90271654$var$CREATE_BRANCH = 'devstatus-cta-link';
const $50b536fc90271654$var$CREATE_LINKED_ISSUE = 'issueaction-create-linked-issue';
const $50b536fc90271654$var$MOVE = 'issueaction-move-issue';
const $50b536fc90271654$var$LINK = 'issueaction-link-issue';
const $50b536fc90271654$var$CLONE = 'issueaction-clone-issue';
const $50b536fc90271654$var$LABELS = 'issueaction-edit-labels';
const $50b536fc90271654$var$DELETE = 'issueaction-delete-issue';
const $50b536fc90271654$var$ADD_FIELD = 'issueaction-fields-add';
const $50b536fc90271654$var$PERMISSION_HELPER = 'permissionhelper-trigger';
const $50b536fc90271654$var$NOTIFICATION_HELPER = 'notificationhelper-trigger';
const $50b536fc90271654$var$LINK_ISSUE = 'add-jira-issue-link-link';
const $50b536fc90271654$var$LINK_CONFLUENCE_PAGE = 'add-confluence-page-link-link';
const $50b536fc90271654$var$ADD_WEB_LINK = 'add-web-link-link';
const $50b536fc90271654$export$498178c427a35252 = {
    EDIT_ISSUE: $50b536fc90271654$var$EDIT_ISSUE,
    ASSIGN: $50b536fc90271654$var$ASSIGN,
    ASSIGN_TO_ME: $50b536fc90271654$var$ASSIGN_TO_ME,
    COMMENT_ISSUE: $50b536fc90271654$var$COMMENT_ISSUE,
    LOG_WORK: $50b536fc90271654$var$LOG_WORK,
    AGILE_BOARD: $50b536fc90271654$var$AGILE_BOARD,
    RANK_TO_TOP: $50b536fc90271654$export$a1d82a1fb322eabf,
    RANK_TO_BOTTOM: $50b536fc90271654$export$264804825e75ec82,
    ATTACH_FILE: $50b536fc90271654$var$ATTACH_FILE,
    ATTACH_SCREENSHOT: $50b536fc90271654$var$ATTACH_SCREENSHOT,
    ADD_VOTE: $50b536fc90271654$var$ADD_VOTE,
    REMOVE_VOTE: $50b536fc90271654$var$REMOVE_VOTE,
    VIEW_VOTERS: $50b536fc90271654$var$VIEW_VOTERS,
    WATCH_ISSUE: $50b536fc90271654$var$WATCH_ISSUE,
    UNWATCH_ISSUE: $50b536fc90271654$var$UNWATCH_ISSUE,
    WATCHERS: $50b536fc90271654$var$WATCHERS,
    CREATE_SUBTASK: $50b536fc90271654$var$CREATE_SUBTASK,
    CONVERT_TO_ISSUE: $50b536fc90271654$var$CONVERT_TO_ISSUE,
    CONVERT_TO_SUBTASK: $50b536fc90271654$var$CONVERT_TO_SUBTASK,
    CREATE_BRANCH: $50b536fc90271654$var$CREATE_BRANCH,
    CREATE_LINKED_ISSUE: $50b536fc90271654$var$CREATE_LINKED_ISSUE,
    MOVE: $50b536fc90271654$var$MOVE,
    LINK: $50b536fc90271654$var$LINK,
    CLONE: $50b536fc90271654$var$CLONE,
    LABELS: $50b536fc90271654$var$LABELS,
    DELETE: $50b536fc90271654$var$DELETE,
    ADD_FIELD: $50b536fc90271654$var$ADD_FIELD,
    PERMISSION_HELPER: $50b536fc90271654$var$PERMISSION_HELPER,
    NOTIFICATION_HELPER: $50b536fc90271654$var$NOTIFICATION_HELPER
};
const $50b536fc90271654$export$1fff534c17344ccf = {
    LINK_ISSUE: $50b536fc90271654$var$LINK_ISSUE,
    LINK_CONFLUENCE_PAGE: $50b536fc90271654$var$LINK_CONFLUENCE_PAGE,
    ADD_WEB_LINK: $50b536fc90271654$var$ADD_WEB_LINK
};
const $50b536fc90271654$export$5ae74c325a8e870e = [
    $50b536fc90271654$var$EDIT_ISSUE,
    $50b536fc90271654$var$COMMENT_ISSUE,
    $50b536fc90271654$var$LOG_WORK,
    $50b536fc90271654$export$a1d82a1fb322eabf,
    $50b536fc90271654$export$264804825e75ec82,
    $50b536fc90271654$var$ATTACH_FILE,
    $50b536fc90271654$var$ADD_VOTE,
    $50b536fc90271654$var$REMOVE_VOTE,
    $50b536fc90271654$var$WATCH_ISSUE,
    $50b536fc90271654$var$UNWATCH_ISSUE,
    $50b536fc90271654$var$LINK,
    $50b536fc90271654$var$CLONE,
    $50b536fc90271654$var$LABELS,
    $50b536fc90271654$var$DELETE,
    $50b536fc90271654$var$ADD_FIELD,
    $50b536fc90271654$var$PERMISSION_HELPER,
    $50b536fc90271654$var$NOTIFICATION_HELPER,
    $50b536fc90271654$var$ASSIGN,
    $50b536fc90271654$var$ASSIGN_TO_ME,
    $50b536fc90271654$var$ATTACH_SCREENSHOT,
    $50b536fc90271654$var$CREATE_LINKED_ISSUE,
    $50b536fc90271654$var$CREATE_SUBTASK
];
const $50b536fc90271654$export$cb2989a570fe66ad = [
    $50b536fc90271654$var$EDIT_ISSUE,
    $50b536fc90271654$var$ASSIGN,
    $50b536fc90271654$var$ASSIGN_TO_ME,
    $50b536fc90271654$var$ATTACH_SCREENSHOT,
    $50b536fc90271654$var$CREATE_LINKED_ISSUE,
    $50b536fc90271654$var$CREATE_BRANCH,
    $50b536fc90271654$var$LINK
];
const $50b536fc90271654$export$b86499b7cf24c281 = {
    [$50b536fc90271654$var$PERMISSION_HELPER]: '/secure/admin/PermissionHelperAdmin.jspa',
    [$50b536fc90271654$var$NOTIFICATION_HELPER]: '/secure/admin/NotificationHelperAdmin.jspa'
};
const $50b536fc90271654$export$f57e70208d0fb8b9 = {
    [$50b536fc90271654$var$ASSIGN]: {
        id: 'assign-dialog',
        issueMsg: 'thanksIssueAssigned'
    },
    [$50b536fc90271654$var$ASSIGN_TO_ME]: {
        id: 'assign-dialog',
        issueMsg: 'thanksIssueAssigned'
    },
    [$50b536fc90271654$var$COMMENT_ISSUE]: {
        id: 'comment-add-dialog',
        issueMsg: 'thanksIssueCommented'
    },
    [$50b536fc90271654$var$ATTACH_FILE]: {
        id: 'attach-file-dialog',
        issueMsg: 'thanksIssueAttached'
    },
    [$50b536fc90271654$var$DELETE]: {
        id: 'delete-issue-dialog',
        issueMsg: 'thanksIssueDeleted'
    },
    [$50b536fc90271654$var$CLONE]: {
        id: 'clone-issue-dialog',
        issueMsg: 'thanksIssueCloned'
    },
    [$50b536fc90271654$var$LOG_WORK]: {
        id: 'edit-log-work-dialog',
        issueMsg: 'thanksIssueWorklogged'
    },
    [$50b536fc90271654$var$LABELS]: {
        id: 'edit-labels-dialog',
        issueMsg: 'thanksIssueLabelled'
    }
};

});




parcelRegister("4Q2yp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c008055fe2c17958$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $WFrhP = parcelRequire("WFrhP");
function $c008055fe2c17958$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: { iconUrl: iconUrl, description: description, name: name } }, tableInjectedProps: { isLastColumn: isLastColumn } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c008055fe2c17958$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        height: "16",
        width: "16",
        src: iconUrl,
        alt: description,
        title: name
    })));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c008055fe2c17958$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _ca0q19bv _u5f3u2gc _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("f7C6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd5670b82b69faf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $g1aHY = parcelRequire("g1aHY");
const $dbd5670b82b69faf$var$Labels = ({ tableInjectedProps: { isLastColumn: isLastColumn }, dataSelectorProps: { value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1aHY.default), {
        // @ts-expect-error - TS2322 - Type 'LabelsProps' is not assignable to type 'TagData[]'.
        tags: value,
        isLastColumn: isLastColumn,
        ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
            isColored: true
        } : {}
    });
var $dbd5670b82b69faf$export$2e2bcd8739ae039 = $dbd5670b82b69faf$var$Labels;

});
parcelRegister("g1aHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2046f67c83777f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9laXL = parcelRequire("9laXL");

var $6UXEc = parcelRequire("6UXEc");

var $koVbs = parcelRequire("koVbs");

var $7ldcY = parcelRequire("7ldcY");

var $WFrhP = parcelRequire("WFrhP");

var $gCwiK = parcelRequire("gCwiK");
const $5a2046f67c83777f$var$Tags = ({ tags: tags, isLastColumn: isLastColumn, isColored: isColored })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (tags.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a2046f67c83777f$var$MessageWrapper, null, formatMessage((0, $gCwiK.default).none)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a2046f67c83777f$var$TagWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UXEc.default), null, tags.map((tag, index)=>// @ts-expect-error - ts2322 - Type 'string' is not assignable to type 'TagColor'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9laXL.default), {
            key: index,
            appearance: "default",
            text: tag.name,
            href: tag.href,
            isRemovable: false,
            ...isColored ? {
                color: (0, $7ldcY.getAutoGeneratedColorForLabelsTag)(tag.name)
            } : {}
        })))));
};
var $5a2046f67c83777f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5a2046f67c83777f$var$Tags;
const $5a2046f67c83777f$var$TagWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s87c40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a2046f67c83777f$var$MessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9laXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63a49f20b6f0a05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c543i = parcelRequire("c543i");

var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $35XSW = parcelRequire("35XSW");
var $lM16U = parcelRequire("lM16U");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");

var $frUcV = parcelRequire("frUcV");
const $d63a49f20b6f0a05$var$cssVar = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        }
    }
};
var $d63a49f20b6f0a05$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($d63a49f20b6f0a05$var$TagStatus || {});
const $d63a49f20b6f0a05$var$packageName = "platform-pkg";
const $d63a49f20b6f0a05$var$packageVersion = "0.0.0-use.local";
const $d63a49f20b6f0a05$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $d63a49f20b6f0a05$var$removingStyles = null;
const $d63a49f20b6f0a05$var$RemovableTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $d63a49f20b6f0a05$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $eGmKJ.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $5uXOq.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $5uXOq.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $c543i.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $d63a49f20b6f0a05$var$packageName,
            packageVersion: $d63a49f20b6f0a05$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $5uXOq.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $5uXOq.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $5uXOq.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $5uXOq.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ $5uXOq.createElement((0, $frUcV.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ $5uXOq.createElement((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [$d63a49f20b6f0a05$var$cssVar.color.background.hover]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalHoverBackgroundColors),
        // Tag background color on press
        [$d63a49f20b6f0a05$var$cssVar.color.background.active]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalActiveBackgroundColors),
        // The tag text on hover of remove button
        [$d63a49f20b6f0a05$var$cssVar.color.text.default]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors),
        // 'elemBefore' text on press of remove button
        [$d63a49f20b6f0a05$var$cssVar.color.text.active]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors),
        // The tag link text on hover of remove button
        [$d63a49f20b6f0a05$var$cssVar.color.text.link]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors)
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $35XSW.default), null, !(status === "removed") && /*#__PURE__*/ $5uXOq.createElement((0, $lM16U.default), null, (motion)=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5oSQr.default), {
            ref: (0, $5JjdN.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5uXOq.createElement((0, $aXLIT.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $bwpsq.default)([
                status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $d63a49f20b6f0a05$var$RemovableTag = /*#__PURE__*/ (0, $5uXOq.memo)($d63a49f20b6f0a05$var$RemovableTagComponent);
var $d63a49f20b6f0a05$export$2e2bcd8739ae039 = $d63a49f20b6f0a05$var$RemovableTag;

});
parcelRegister("lM16U", function(module, exports) {

$parcel$export(module.exports, "default", () => $c624c149830103aa$export$2e2bcd8739ae039);

var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $35XSW = parcelRequire("35XSW");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $c624c149830103aa$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    const exiting = (0, $35XSW.useExitingPersistence)();
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    const setTimeout = (0, $bh8Xz.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $fsENI.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $lObw7.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $lObw7.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $c624c149830103aa$export$2e2bcd8739ae039 = $c624c149830103aa$var$ShrinkOut;

});
parcelRegister("3GP8X", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $19cc13cbd0e78f53$export$ff879f35a69d56b7);

var $5uXOq = parcelRequire("5uXOq");
const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $5uXOq.useRef)(null);
    const setRef = (0, $5uXOq.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
// Text colors
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $5b444d8505b9cc3c$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $5b444d8505b9cc3c$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});

parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");
const $db35d9df42c66ff0$var$cssVar = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = null;
const $db35d9df42c66ff0$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = null;
const $db35d9df42c66ff0$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = null;
const $db35d9df42c66ff0$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = null;
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $2hnSR.textColors)['standardLink'] : (0, $2hnSR.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$db35d9df42c66ff0$var$cssVar.color.borderColor]: (0, $2hnSR.borderColors)[color],
            [$db35d9df42c66ff0$var$cssVar.color.text.default]: (0, $2hnSR.textColors)[color],
            [$db35d9df42c66ff0$var$cssVar.color.text.hover]: (0, $2hnSR.textHoverColors)[color],
            [$db35d9df42c66ff0$var$cssVar.color.text.active]: (0, $2hnSR.textActiveColors)[color],
            [$db35d9df42c66ff0$var$cssVar.color.text.link]: textLinkColors,
            [$db35d9df42c66ff0$var$cssVar.color.background.default]: (0, $2hnSR.backgroundColors)[color],
            [$db35d9df42c66ff0$var$cssVar.color.background.hover]: backgroundHoverColors,
            [$db35d9df42c66ff0$var$cssVar.color.background.active]: backgroundActiveColors,
            [$db35d9df42c66ff0$var$cssVar.color.focusRing]: (0, $2hnSR.focusRingColors),
            [$db35d9df42c66ff0$var$cssVar.color.removeButton.default]: (0, $2hnSR.removeButtonColors)[color],
            [$db35d9df42c66ff0$var$cssVar.color.removeButton.hover]: (0, $2hnSR.removeButtonHoverColors)[color],
            [$db35d9df42c66ff0$var$cssVar.borderRadius]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});

parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $4b11e671062d0fc5$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = null;
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = null;
const $c46b06918fbe54e8$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = null;
const $c46b06918fbe54e8$var$linkStyles = null;
const $c46b06918fbe54e8$var$hasAfterStylesOld = null;
const $c46b06918fbe54e8$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = null;
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ $5uXOq.createElement(Link, {
        href: href,
        "data-color": color,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c81oud _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c81oud _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ])
    }, text);
    else return /*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c81oud _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c81oud _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ])
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});

parcelRegister("frUcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $625906158e0f3c21$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");
const $625906158e0f3c21$var$removeButtonStyles = {
    root: "_19itglyw _2rkogqwt _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1fxt _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr3166n _1di61dty"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $625906158e0f3c21$var$removeButtonStylesOld = {
    root: "_19itglyw _2rko1l5z _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _ahbqze3t _12l2ze3t _1pfhze3t _6rthze3t _kqswstnw _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1bah _80omtlke _lcxv1wug _1ah3ze3t _30l31eu2"
};
const $625906158e0f3c21$var$removeButtonStylesOldIcon = {
    root: "_rjxpze3t"
};
const $625906158e0f3c21$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $625906158e0f3c21$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)(// TODO: When cleaning up all these feature gates, they should just be converged into a single `styles` object.
        (0, $VSDnB.fg)('platform-component-visual-refresh') && $625906158e0f3c21$var$removeButtonStyles.root, !(0, $VSDnB.fg)('platform-component-visual-refresh') && $625906158e0f3c21$var$removeButtonStylesOld.root, $625906158e0f3c21$var$removeButtonStylesOldIcon.root, (0, $VSDnB.fg)('platform-visual-refresh-icons') && $625906158e0f3c21$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$625906158e0f3c21$export$2e2bcd8739ae039 = $625906158e0f3c21$var$RemoveButton;

});


parcelRegister("6UXEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c2d1dcb54418fac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2c2d1dcb54418fac$var$baseStyles = null;
const $2c2d1dcb54418fac$var$justifyStartStyles = null;
const $2c2d1dcb54418fac$var$justifyEndStyles = null;
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $2c2d1dcb54418fac$var$TagGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ])
    }, children);
});
var $2c2d1dcb54418fac$export$2e2bcd8739ae039 = $2c2d1dcb54418fac$var$TagGroup;

});

parcelRegister("7ldcY", function(module, exports) {

$parcel$export(module.exports, "getAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$97056d4b28203ee9);
$parcel$export(module.exports, "getAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a3f5334e7a13e57a);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a80529ae8ec44f02);

var $gJBT6 = parcelRequire("gJBT6");

var $1L3S5 = parcelRequire("1L3S5");

var $fzY6y = parcelRequire("fzY6y");

var $96pcJ = parcelRequire("96pcJ");
const $7fa3a87d53177c9e$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $1L3S5.GREY_META).name;
};
const $7fa3a87d53177c9e$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $1L3S5.GREY_META).tagColor;
};
const $7fa3a87d53177c9e$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$97056d4b28203ee9);
const $7fa3a87d53177c9e$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$a3f5334e7a13e57a);

});
parcelRegister("1L3S5", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $0d4a83e59182b411$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $0d4a83e59182b411$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $0d4a83e59182b411$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $0d4a83e59182b411$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $0d4a83e59182b411$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $0d4a83e59182b411$export$7c14120abebd4749);


var $9GtPC = parcelRequire("9GtPC");
// Grey
const $0d4a83e59182b411$var$N100 = '#F0F1F4';
const $0d4a83e59182b411$var$N300 = (0, $829f609a65d26a98$exports).N60A;
const $0d4a83e59182b411$var$N500 = (0, $829f609a65d26a98$exports).N800;
const $0d4a83e59182b411$var$Y200 = (0, $829f609a65d26a98$exports).Y75;
const $0d4a83e59182b411$var$R500 = '#601E16';
const $0d4a83e59182b411$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: `var(--ds-background-neutral, ${$0d4a83e59182b411$var$N100})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
    messageLabel: (0, $9GtPC.default).greyLightest
};
const $0d4a83e59182b411$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
    messageLabel: (0, $9GtPC.default).greyLighter
};
const $0d4a83e59182b411$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: `var(--ds-background-neutral-pressed, ${$0d4a83e59182b411$var$N300})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
    messageLabel: (0, $9GtPC.default).grey
};
const $0d4a83e59182b411$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).greyDarker
};
const $0d4a83e59182b411$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: `var(--ds-background-neutral-bold-pressed, ${$0d4a83e59182b411$var$N500})`,
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).greyDarkest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLightest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLighter
};
const $0d4a83e59182b411$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purple
};
const $0d4a83e59182b411$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).purpleDarker
};
const $0d4a83e59182b411$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).purpleDarkest
};
const $0d4a83e59182b411$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLightest
};
const $0d4a83e59182b411$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLighter
};
const $0d4a83e59182b411$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blue
};
const $0d4a83e59182b411$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).blueDarker
};
const $0d4a83e59182b411$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).blueDarkest
};
const $0d4a83e59182b411$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLightest
};
const $0d4a83e59182b411$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLighter
};
const $0d4a83e59182b411$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).teal
};
const $0d4a83e59182b411$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).tealDarker
};
const $0d4a83e59182b411$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).tealDarkest
};
const $0d4a83e59182b411$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLightest
};
const $0d4a83e59182b411$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLighter
};
const $0d4a83e59182b411$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).green
};
const $0d4a83e59182b411$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).greenDarker
};
const $0d4a83e59182b411$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).greenDarkest
};
const $0d4a83e59182b411$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLightest
};
const $0d4a83e59182b411$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLighter
};
const $0d4a83e59182b411$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).lime
};
const $0d4a83e59182b411$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).limeDarker
};
const $0d4a83e59182b411$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).limeDarkest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLightest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: `var(--ds-background-accent-yellow-subtler, ${$0d4a83e59182b411$var$Y200})`,
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLighter
};
const $0d4a83e59182b411$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellow
};
const $0d4a83e59182b411$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).yellowDarker
};
const $0d4a83e59182b411$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).yellowDarkest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLightest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLighter
};
const $0d4a83e59182b411$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orange
};
const $0d4a83e59182b411$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).orangeDarker
};
const $0d4a83e59182b411$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).orangeDarkest
};
const $0d4a83e59182b411$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLightest
};
const $0d4a83e59182b411$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLighter
};
const $0d4a83e59182b411$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).red
};
const $0d4a83e59182b411$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).redDarker
};
const $0d4a83e59182b411$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).redDarkest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: `var(--ds-text-accent-magenta-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).magentaLightest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: `var(--ds-text-accent-magenta-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).magentaLighter
};
const $0d4a83e59182b411$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: `var(--ds-text-accent-magenta-bolder, ${$0d4a83e59182b411$var$R500})`,
    messageLabel: (0, $9GtPC.default).magenta
};
const $0d4a83e59182b411$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).magentaDarker
};
const $0d4a83e59182b411$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    messageLabel: (0, $9GtPC.default).magentaDarkest
};
const $0d4a83e59182b411$export$270aee965367aeb3 = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
const $0d4a83e59182b411$export$941ef40ef5fdd2b1 = `var(--ds-text, ${(0, $829f609a65d26a98$exports).N500})`;
const $0d4a83e59182b411$export$7f42563469df7e01 = [
    $0d4a83e59182b411$var$GREY_LIGHTEST_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTEST_META,
    $0d4a83e59182b411$var$BLUE_LIGHTEST_META,
    $0d4a83e59182b411$var$TEAL_LIGHTEST_META,
    $0d4a83e59182b411$var$GREEN_LIGHTEST_META,
    $0d4a83e59182b411$var$LIME_LIGHTEST_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTEST_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTEST_META,
    $0d4a83e59182b411$var$RED_LIGHTEST_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META,
    $0d4a83e59182b411$var$GREY_LIGHTER_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTER_META,
    $0d4a83e59182b411$var$BLUE_LIGHTER_META,
    $0d4a83e59182b411$var$TEAL_LIGHTER_META,
    $0d4a83e59182b411$var$GREEN_LIGHTER_META,
    $0d4a83e59182b411$var$LIME_LIGHTER_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTER_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTER_META,
    $0d4a83e59182b411$var$RED_LIGHTER_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTER_META,
    $0d4a83e59182b411$export$11b75436f568ab00,
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$BLUE_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$LIME_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$7c314e2461a7241b,
    $0d4a83e59182b411$var$BLUE_DARKER_META,
    $0d4a83e59182b411$export$6daaa1cc3f46f41,
    $0d4a83e59182b411$var$GREEN_DARKER_META,
    $0d4a83e59182b411$var$LIME_DARKER_META,
    $0d4a83e59182b411$var$YELLOW_DARKER_META,
    $0d4a83e59182b411$var$ORANGE_DARKER_META,
    $0d4a83e59182b411$var$RED_DARKER_META,
    $0d4a83e59182b411$var$MAGENTA_DARKER_META,
    $0d4a83e59182b411$var$GREY_DARKEST_META,
    $0d4a83e59182b411$var$PURPLE_DARKEST_META,
    $0d4a83e59182b411$export$69c4eac71b813fba,
    $0d4a83e59182b411$var$TEAL_DARKEST_META,
    $0d4a83e59182b411$var$GREEN_DARKEST_META,
    $0d4a83e59182b411$var$LIME_DARKEST_META,
    $0d4a83e59182b411$var$YELLOW_DARKEST_META,
    $0d4a83e59182b411$var$ORANGE_DARKEST_META,
    $0d4a83e59182b411$var$RED_DARKEST_META,
    $0d4a83e59182b411$var$MAGENTA_DARKEST_META
];
const $0d4a83e59182b411$export$2c649adf8351b065 = [
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$11b75436f568ab00
];
const $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$0d4a83e59182b411$export$2c649adf8351b065.forEach((option)=>{
    $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $0d4a83e59182b411$export$7c14120abebd4749 = {};
$0d4a83e59182b411$export$7f42563469df7e01.forEach((option)=>{
    $0d4a83e59182b411$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("9GtPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8610941b4777e2f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8610941b4777e2f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("fzY6y", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $899e3507d4080274$export$e352defce701b36e);

const $899e3507d4080274$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $37d3405989cb4520$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $37d3405989cb4520$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $37d3405989cb4520$export$d15e38bcd75fda7c = 256;
const $37d3405989cb4520$export$e143f4b09221a374 = 1000000007;


parcelRegister("96pcJ", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $9ffc042ff38af51a$export$cb0dffe2d2ae675a);

var $1L3S5 = parcelRequire("1L3S5");
const $9ffc042ff38af51a$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("gCwiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaae329c0c2c4b71$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aaae329c0c2c4b71$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-table.common.fields.common.tags.none",
        "defaultMessage": "None"
    }
});

});



parcelRegister("gsmqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f7f6f7d9ae0afe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6yU6C = parcelRequire("6yU6C");

var $49O3E = parcelRequire("49O3E");
const $b9f7f6f7d9ae0afe$var$MajorIncident = ({ dataSelectorProps: { value: value } })=>value === (0, $6yU6C.MAJOR_INCIDENT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $49O3E.MajorIncidentLozenge), null) : null;
var $b9f7f6f7d9ae0afe$export$2e2bcd8739ae039 = $b9f7f6f7d9ae0afe$var$MajorIncident;

});
parcelRegister("6yU6C", function(module, exports) {

$parcel$export(module.exports, "MAJOR_INCIDENT", () => $957a46ec71e11098$export$f5d2c3c7bebeaa98);
$parcel$export(module.exports, "SPOTLIGHT_ID", () => $957a46ec71e11098$export$1222b4ae9a94b9ec);

var $eNHSy = parcelRequire("eNHSy");
const $957a46ec71e11098$export$f5d2c3c7bebeaa98 = 'MAJOR_INCIDENT';
const $957a46ec71e11098$var$MAJOR_INCIDENT_FIELD_KEY = 'major-incident-field';
const $957a46ec71e11098$export$1222b4ae9a94b9ec = `${(0, $eNHSy.ISSUE_FIELD_SPOTLIGHT_PREFIX)}${$957a46ec71e11098$var$MAJOR_INCIDENT_FIELD_KEY}`;

});
parcelRegister("eNHSy", function(module, exports) {

$parcel$export(module.exports, "BOARD_SIDEBAR", () => $6311dd6d260a77f5$export$d84e7970e2d564af);
$parcel$export(module.exports, "EDIT_FIELD", () => $6311dd6d260a77f5$export$256eddbefbf4b2ce);
$parcel$export(module.exports, "GIVE_FEEDBACK", () => $6311dd6d260a77f5$export$3c1bb52064935485);
$parcel$export(module.exports, "STATUS_AND_APPROVAL_SPOTLIGHT", () => $6311dd6d260a77f5$export$988f0f6f6457039a);
$parcel$export(module.exports, "STATUS_SPOTLIGHT", () => $6311dd6d260a77f5$export$b11eec52127ca1f1);
$parcel$export(module.exports, "ISSUE_FIELD_SPOTLIGHT_PREFIX", () => $6311dd6d260a77f5$export$2028cf1423b28cf8);
const $6311dd6d260a77f5$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $6311dd6d260a77f5$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $6311dd6d260a77f5$export$3c1bb52064935485 = 'GIVE_FEEDBACK';
const $6311dd6d260a77f5$export$95f98990d7202b31 = 'SHOW_MORE';
const $6311dd6d260a77f5$export$988f0f6f6457039a = 'status-and-approval-spotlight';
const $6311dd6d260a77f5$export$b11eec52127ca1f1 = 'status-spotlight';
const $6311dd6d260a77f5$export$e5820f3349d3bcf0 = 'reporter-spotlight';
const $6311dd6d260a77f5$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $6311dd6d260a77f5$export$43c3daf5ccfeb2da = {
    ASSIGNEE: {
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.assignee.time-to.render-initial-suggestions',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.assignee.time-to.reflect-input-results',
        TIME_TO_REFLECT_SELECTED: 'jira.fe.issue.fields.assignee.time-to.reflect-selected',
        TIME_TO_ASSIGN_TO_ME_VIA_SHORTCUT: 'jira.fe.issue.fields.assignee.time-to.assign-to-me-via-shortcut'
    },
    SUMMARY: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.summary.time-to.render-edit-view',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.summary.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.summary.time-to.render-read-view-on-cancel'
    },
    LABELS: {
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.labels.time-to.render-initial-suggestions',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.labels.time-to.reflect-input-results',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.labels.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.labels.time-to.render-read-view-on-cancel',
        TIME_TO_REFLECT_SELECTED_EXISTING: 'jira.fe.issue.fields.labels.time-to.reflect-selected-existing',
        TIME_TO_REFLECT_SELECTED_NEW: 'jira.fe.issue.fields.labels.time-to.reflect-selected-new',
        TIME_TO_REFLECT_REMOVED_EXISTING: 'jira.fe.issue.fields.labels.time-to.reflect-removed-existing'
    },
    STORY_POINTS: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.story-points.time-to.render-edit-view',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.story-points.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.story-points.time-to.render-read-view-on-cancel'
    },
    ISSUE_LINKS: {
        TIME_TO_REFLECT_SELECTED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.reflect-selected-issue',
        TIME_TO_REFLECT_REMOVED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.reflect-removed-issue',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.issue-links.time-to.reflect-input-results',
        TIME_TO_RENDER_LINKED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.render-linked-issue',
        TIME_TO_RENDER_NEW_LINKED_ISSUE_INPUT: 'jira.fe.issue.fields.issue-links.time-to.render-new-linked-issue-input'
    },
    SPRINT: {
        TIME_TO_REFLECT_SELECTED_SPRINT: 'jira.fe.issue.fields.sprint.time-to.reflect-selected-sprint',
        TIME_TO_REFLECT_REMOVED_SPRINT: 'jira.fe.issue.fields.sprint.time-to.reflect-removed-sprint',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.sprint.time-to.reflect-input-results',
        TIME_TO_RENDER_READ_VIEW: 'jira.fe.issue.fields.sprint.time-to.render-read-view',
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.sprint.time-to.render-initial-suggestions'
    },
    PRIORITY: {
        TIME_TO_RENDER_READ_VIEW: 'jira.fe.issue.fields.priority.time-to.render-read-view',
        TIME_TO_RENDER_SUGGESTIONS: 'jira.fe.issue.fields.priority.time-to.render-suggestions',
        TIME_TO_REFLECT_PRIORITY_UPDATE: 'jira.fe.issue.fields.priority.time-to.reflect-priority-update'
    },
    COMMENTS: {
        TIME_TO_RENDER_NEW_COMMENT_EDITOR: 'jira.fe.issue.fields.comments.time-to.render-new-comment-editor',
        TIME_TO_RENDER_SAVED_COMMENT: 'jira.fe.issue.fields.comments.time-to.render-saved-comment'
    },
    DESCRIPTION: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.description.time-to.render-edit-view',
        TIME_TO_SAVE_UPDATED_DESCRIPTION: 'jira.fe.issue.field.description.time-to.save-updated-description',
        TIME_TO_SAVE_UNCHANGED_DESCRIPTION: 'jira.fe.issue.field.description.time-to.save-unchanged-description'
    },
    EPIC_LINKS: {
        TIME_TO_FETCH_INPUT_RESULTS_EPIC_PICKER_ENABLED: 'jira.fe.issue.fields.epic-link.time-to.fetch-input-results.epic-picker-enabled',
        TIME_TO_FETCH_INPUT_RESULTS_EPIC_PICKER_DISABLED: 'jira.fe.issue.fields.epic-link.time-to.fetch-input-results.epic-picker-disabled'
    }
};

});


parcelRegister("49O3E", function(module, exports) {

$parcel$export(module.exports, "MajorIncidentLozenge", () => $015fe90eea53ee1c$export$d005b05e81381a5a);
$parcel$export(module.exports, "MajorIncidentLozengeWithTooltip", () => $015fe90eea53ee1c$export$1f7421f79cdd882a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lj8SI = parcelRequire("lj8SI");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $kLoIs = parcelRequire("kLoIs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $le1ca = parcelRequire("le1ca");

var $koeKL = parcelRequire("koeKL");

var $6yU6C = parcelRequire("6yU6C");

var $9iRV4 = parcelRequire("9iRV4");

var $k8QoX = parcelRequire("k8QoX");
const $015fe90eea53ee1c$export$d005b05e81381a5a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "removed"
    }, formatMessage((0, $k8QoX.default).lozengeLabel));
};
const $015fe90eea53ee1c$export$1f7421f79cdd882a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isEntitled: isMIMEntitled } = (0, $le1ca.useJsmMimEntitlementResource)((0, $koeKL.useCloudId)());
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [{ value: value }] = (0, $9iRV4.useMajorIncidentField)({
        issueKey: issueKey
    });
    const isIssueOfIncidentsPractice = (0, $kLoIs.useIsIssueOfIncidentsPractice)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const shouldRenderLozenge = isMIMEntitled && isIssueOfIncidentsPractice && value === (0, $6yU6C.MAJOR_INCIDENT);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRenderLozenge) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'majorIncidentLozenge viewed', {
            action: 'viewed',
            actionSubjectId: 'majorIncidentLozenge',
            teamName: 'jsm-getting-started'
        });
    }, [
        createAnalyticsEvent,
        shouldRenderLozenge
    ]);
    return shouldRenderLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($015fe90eea53ee1c$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $k8QoX.default).tootltipContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($015fe90eea53ee1c$export$d005b05e81381a5a, null))) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $015fe90eea53ee1c$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2gCtH", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $9e67f38435565e11$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $9e67f38435565e11$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $9e67f38435565e11$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $9e67f38435565e11$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $9e67f38435565e11$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $9e67f38435565e11$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $9e67f38435565e11$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $9e67f38435565e11$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $9e67f38435565e11$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $9e67f38435565e11$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $9e67f38435565e11$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $9e67f38435565e11$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $9e67f38435565e11$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $9e67f38435565e11$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $9e67f38435565e11$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $9e67f38435565e11$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $9e67f38435565e11$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $9e67f38435565e11$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $9e67f38435565e11$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $9e67f38435565e11$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiEnabledForIssue", () => $9e67f38435565e11$export$db5174c7538abe4b);
$parcel$export(module.exports, "useIsJiraIssue", () => $9e67f38435565e11$export$cf5fc815f761fb4b);

var $5uXOq = parcelRequire("5uXOq");


var $2vSU6 = parcelRequire("2vSU6");

var $4Pf62 = parcelRequire("4Pf62");

var $93Yeu = parcelRequire("93Yeu");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7trqb = parcelRequire("7trqb");

var $hqBSi = parcelRequire("hqBSi");

var $koiRX = parcelRequire("koiRX");
const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $koiRX.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $koiRX.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $koiRX.useIssueContextStoreIsModal)();
    return isModal;
};
const $9e67f38435565e11$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $koiRX.useIssueContextStoreIssueId)();
    return issueId;
};
const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $koiRX.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $koiRX.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return (0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
};
const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $koiRX.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView, setActivityLayoutView: setActivityLayoutView }] = (0, $koiRX.useIssueContextStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView,
            setActivityLayoutView: setActivityLayoutView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView,
        setActivityLayoutView
    ]);
    return [
        undefined,
        actions
    ];
};
const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $koiRX.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $koiRX.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $9e67f38435565e11$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $koiRX.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $koiRX.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $koiRX.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $koiRX.useIssueContextStoreViewMode)();
    return viewMode;
};
const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $koiRX.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $koiRX.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $9e67f38435565e11$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $koiRX.useIssueContextStoreBoardId)();
    return boardId;
};
const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $koiRX.useIssueContextStoreBoardType)();
    return boardType;
};
const $9e67f38435565e11$export$bff44cb64b56644d = ()=>{
    const [activityLayoutView] = (0, $koiRX.useIssueContextStoreActivityLayoutView)();
    return activityLayoutView;
};
const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $koiRX.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $koiRX.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $koiRX.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $koiRX.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $koiRX.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const licenseStates = (0, $7trqb.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
};
const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
};
const $9e67f38435565e11$export$db5174c7538abe4b = ()=>{
    const [isAiEnabledForIssue] = (0, $koiRX.useIssueContextIsAiEnabledForIssue)();
    return isAiEnabledForIssue;
};
const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $9e67f38435565e11$export$22108eca27445997();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    return [
        (0, $2vSU6.SOFTWARE_PROJECT),
        (0, $2vSU6.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("93Yeu", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $5f0f9360597cdbd8$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $5f0f9360597cdbd8$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $5f0f9360597cdbd8$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectStyle", () => $5f0f9360597cdbd8$export$27e24febf0f5c3bc);
$parcel$export(module.exports, "useProjectContext", () => $5f0f9360597cdbd8$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $5f0f9360597cdbd8$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $5f0f9360597cdbd8$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $5f0f9360597cdbd8$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $5f0f9360597cdbd8$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $5f0f9360597cdbd8$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $5f0f9360597cdbd8$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $5f0f9360597cdbd8$export$80bef597b440cf71);

var $5uXOq = parcelRequire("5uXOq");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $buby4 = parcelRequire("buby4");

var $1daUm = parcelRequire("1daUm");
const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $buby4.useProjectContextActionStore)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $buby4.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $5f0f9360597cdbd8$export$27e24febf0f5c3bc = (projectKey)=>{
    const [projectStyle] = (0, $buby4.useProjectContextJiraProjectStyleStore)({
        projectKey: projectKey
    });
    return projectStyle;
};
const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $efvDm.getApplicationForProject)(projectType);
};
const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $ldyPw.getEdition)(application, appEditions);
};
const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
    return (0, $1daUm.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $buby4.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $buby4.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("buby4", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $42c27dedc1310bb2$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $42c27dedc1310bb2$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextJiraProjectStyleStore", () => $42c27dedc1310bb2$export$b291cf203d6481a4);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $42c27dedc1310bb2$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $42c27dedc1310bb2$export$f73e9904779f6be5);

var $2vSU6 = parcelRequire("2vSU6");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aDpiK = parcelRequire("aDpiK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42c27dedc1310bb2$var$initialState = {};
const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'project-context',
    initialState: $42c27dedc1310bb2$var$initialState,
    actions: $aDpiK
});
const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: null
});
const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $42c27dedc1310bb2$export$8b09478b33186ec = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectContext
});
const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $42c27dedc1310bb2$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
};
const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectType
});
const $42c27dedc1310bb2$export$b291cf203d6481a4 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getJiraProjectStyle
});
const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $42c27dedc1310bb2$export$9469fde70658518 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectName
});
const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getIssueTypes
});

});
parcelRegister("aDpiK", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $ad16c28ce51d4ccf$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $ad16c28ce51d4ccf$export$78f1c6052937615f);
const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("1daUm", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $7afb7a15cd46bd62$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");
const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
            $7afb7a15cd46bd62$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $7afb7a15cd46bd62$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $7afb7a15cd46bd62$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    }
    return $7afb7a15cd46bd62$export$27e0678365e5dcff();
};

});
parcelRegister("65mz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7178ba5d31d0f054$export$2e2bcd8739ae039);
const $7178ba5d31d0f054$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;

});



parcelRegister("7trqb", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $5fcaa3f734e9c444$export$268651a63abe408a);

var $9OXo1 = parcelRequire("9OXo1");
const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("koiRX", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $35da250daae5206d$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $35da250daae5206d$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $35da250daae5206d$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $35da250daae5206d$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $35da250daae5206d$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $35da250daae5206d$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $35da250daae5206d$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $35da250daae5206d$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $35da250daae5206d$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $35da250daae5206d$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $35da250daae5206d$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $35da250daae5206d$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $35da250daae5206d$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $35da250daae5206d$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $35da250daae5206d$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreActivityLayoutView", () => $35da250daae5206d$export$fe67bc1c560f679b);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $35da250daae5206d$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $35da250daae5206d$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $35da250daae5206d$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $35da250daae5206d$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $35da250daae5206d$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $35da250daae5206d$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $35da250daae5206d$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $35da250daae5206d$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", () => $35da250daae5206d$export$455ae7fd9d68b157);
$parcel$export(module.exports, "IssueContextContainer", () => $35da250daae5206d$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $35da250daae5206d$export$965360ae27fcae98);

var $g5X3G = parcelRequire("g5X3G");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $fMAcJ = parcelRequire("fMAcJ");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $35da250daae5206d$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $g5X3G.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $edJtc.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false,
    isAiEnabledForIssue: false,
    activityLayoutView: 'VERTICAL'
};
const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-context',
    initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
    actions: $fMAcJ.actions
});
const $35da250daae5206d$var$getIssueContext = (state)=>state;
const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $35da250daae5206d$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
const $35da250daae5206d$var$getActivityLayoutView = (state)=>state.activityLayoutView;
const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueContext
});
const $35da250daae5206d$export$abdbea56d86b4aac = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesLimit)
});
const $35da250daae5206d$export$326ff2b963d51c5c = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesIssueLimitUrls)
});
const $35da250daae5206d$export$44bcaaabb74e402b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueKey
});
const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueId
});
const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsArchived
});
const $35da250daae5206d$export$b9eebaa1da421997 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsClassifyEditEnabled
});
const $35da250daae5206d$export$daa47fd600e43a32 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsModal
});
const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewScreenId
});
const $35da250daae5206d$export$74d38d6c437efc1b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getAnalyticsSource
});
const $35da250daae5206d$export$2092528ee170d9e7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewMap
});
const $35da250daae5206d$export$57898374e6239a5a = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getMaxTokenLength
});
const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoadedWithPage
});
const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getEstimationStatistic
});
const $35da250daae5206d$export$fe7085456138f0fc = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoading
});
const $35da250daae5206d$export$c339e36468c12443 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewMode
});
const $35da250daae5206d$export$fe67bc1c560f679b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getActivityLayoutView
});
const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBackButtonUrl
});
const $35da250daae5206d$export$8accd063c74cd455 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueNavigatorData
});
const $35da250daae5206d$export$e7edffc2a20027e7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardId
});
const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardType
});
const $35da250daae5206d$export$4a4b96bcf5166327 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsSpaEnabled
});
const $35da250daae5206d$export$bbd8ba0180545556 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getLoginRedirectUrl
});
const $35da250daae5206d$export$aaa89627762c7d00 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getOnIssueKeyChange
});
const $35da250daae5206d$export$796589b0ec52848a = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewId
});
const $35da250daae5206d$export$7e70ee570119a0a7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsAiOptInEnabled
});
const $35da250daae5206d$export$455ae7fd9d68b157 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getisAiEnabledForIssue
});
const $35da250daae5206d$export$93db6a8f3342dddf = (0, $gg7kZ.createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
const $35da250daae5206d$export$965360ae27fcae98 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("fMAcJ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $043cabfbcc6107f0$export$e324594224ef24da);

var $7l48d = parcelRequire("7l48d");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $iElCl.getChildIssuesLimit)(getState());
const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $edJtc.getViewModeFromLocalStorage)()
        });
    };
const $043cabfbcc6107f0$export$832c05372975f76f = (layoutView = 'VERTICAL')=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            activityLayoutView: layoutView
        });
    };
const $043cabfbcc6107f0$export$e324594224ef24da = {
    setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
    mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
    getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
    getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
    getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
    getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
    getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
    setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
    resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78,
    setActivityLayoutView: $043cabfbcc6107f0$export$832c05372975f76f
};

});
parcelRegister("7l48d", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $e736233a6ed098e3$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $e736233a6ed098e3$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $e736233a6ed098e3$export$a13f7f627010bccd);

var $bSSG7 = parcelRequire("bSSG7");
const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_issue_view');
const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("iElCl", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $fde75c94a28741e3$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $fde75c94a28741e3$export$8f43520910e8128c);

var $dJl1T = parcelRequire("dJl1T");

var $7l48d = parcelRequire("7l48d");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $7l48d.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("edJtc", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $75ce4ce78f606e67$export$cae7c4c591dcc261);

var $7l48d = parcelRequire("7l48d");
const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>{
    if (false) return 'DEFAULT';
    return (0, $7l48d.localStorage).get((0, $7l48d.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};

});




parcelRegister("kLoIs", function(module, exports) {

$parcel$export(module.exports, "usePracticesFieldValue", () => $4220f7dda2897aac$export$edecf7b484763b0d);
$parcel$export(module.exports, "useIsAgentOrProjectAdmin", () => $4220f7dda2897aac$export$e1f1a212ffd431eb);
$parcel$export(module.exports, "useIsIssueOfIncidentsPractice", () => $4220f7dda2897aac$export$3d5b53ead0d10d84);
$parcel$export(module.exports, "useIsIssueOfPostIncidentReviewPractice", () => $4220f7dda2897aac$export$2a245b8b8b1276b1);
$parcel$export(module.exports, "useIsIssueOfDeveloperEscalationPractice", () => $4220f7dda2897aac$export$4f9a7f08c8bc7afb);
$parcel$export(module.exports, "useIsIssueOfServiceRequestPractice", () => $4220f7dda2897aac$export$5b58271f0207861c);

var $2gCtH = parcelRequire("2gCtH");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $20mDG = parcelRequire("20mDG");

var $dFOAR = parcelRequire("dFOAR");

var $oCMSG = parcelRequire("oCMSG");
const $4220f7dda2897aac$export$edecf7b484763b0d = ({ issueKey: issueKey })=>(0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.SERVICEDESK_PRACTICES_TYPE)
    });
const $4220f7dda2897aac$export$e1f1a212ffd431eb = ()=>{
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (error) return false;
    return data?.userRole === (0, $20mDG.USER_JSM_PROJECT_ROLE).AGENT_ROLE || data?.userRole === (0, $20mDG.USER_JSM_PROJECT_ROLE).AGENT_PROJECT_ADMIN_ROLE;
};
const $4220f7dda2897aac$export$3d5b53ead0d10d84 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [practices] = $4220f7dda2897aac$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $oCMSG.INCIDENTS));
};
const $4220f7dda2897aac$export$2a245b8b8b1276b1 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [practices] = $4220f7dda2897aac$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $oCMSG.POST_INCIDENT_REVIEWS));
};
const $4220f7dda2897aac$export$4f9a7f08c8bc7afb = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [practices] = $4220f7dda2897aac$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $oCMSG.DEVELOPER_ESCALATION));
};
const $4220f7dda2897aac$export$5b58271f0207861c = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [practices] = $4220f7dda2897aac$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices.includes((0, $oCMSG.SERVICE_REQUEST));
};

});
parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $ddbc380ab4ee430c$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $51nlc.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("20mDG", function(module, exports) {

$parcel$export(module.exports, "USER_JSM_PROJECT_ROLE", () => $9a4dc3177f5f851e$export$a9054e41660c4d00);
const $9a4dc3177f5f851e$var$AGENT_ROLE = 'agent';
const $9a4dc3177f5f851e$var$AGENT_PROJECT_ADMIN_ROLE = 'agent-project-admin';
const $9a4dc3177f5f851e$var$JIRA_ROLE = 'jira-user';
const $9a4dc3177f5f851e$export$a9054e41660c4d00 = {
    AGENT_ROLE: $9a4dc3177f5f851e$var$AGENT_ROLE,
    AGENT_PROJECT_ADMIN_ROLE: $9a4dc3177f5f851e$var$AGENT_PROJECT_ADMIN_ROLE,
    JIRA_ROLE: $9a4dc3177f5f851e$var$JIRA_ROLE
};

});


parcelRegister("le1ca", function(module, exports) {

$parcel$export(module.exports, "useJsmMimEntitlementResource", () => $67730a14ed64e9c1$export$db2d9c66103c357c);

var $5uXOq = parcelRequire("5uXOq");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $67730a14ed64e9c1$var$getDataLoader = ()=>(parcelRequire("bxh4b"));
const $67730a14ed64e9c1$export$972b28729379ca5f = (0, $2M1hQ.createResource)({
    type: 'JSM_MIM_ENTITLEMENT',
    getKey: ()=>'JSM_MIM_ENTITLEMENT',
    getDataLoader: $67730a14ed64e9c1$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $67730a14ed64e9c1$export$db2d9c66103c357c = (cloudId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($67730a14ed64e9c1$export$972b28729379ca5f);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (error || loading || !data || !cloudId) return {
            isEntitled: false
        };
        const { isEntitled: isEntitled } = data;
        return {
            isEntitled: isEntitled
        };
    }, [
        data,
        loading,
        error,
        cloudId
    ]);
};

});
parcelRegister("bxh4b", function(module, exports) {

let $866003d32f573b4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $866003d32f573b4e$var$load("alSQR").then(()=>parcelRequire('c1U8F'));

});


parcelRegister("9iRV4", function(module, exports) {

$parcel$export(module.exports, "useMajorIncidentField", () => $9a0176d2d08fef1b$export$91517ada3bce1236);

var $lQE94 = parcelRequire("lQE94");

var $ilTj3 = parcelRequire("ilTj3");
const $9a0176d2d08fef1b$export$91517ada3bce1236 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, onSubmit: onSubmit })=>{
    const { majorIncidentFieldIdKey: fieldKey, fieldType: fieldType } = (0, $ilTj3.useMajorIncidentConfig)(issueKey);
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        issueKey: issueKey,
        fieldKey: fieldKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            loading: loading,
            error: error
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("lQE94", function(module, exports) {

$parcel$export(module.exports, "useContextualIssueIdForIssueKey", () => $c31e2d123e024ddc$export$76d937477b5f784a);
$parcel$export(module.exports, "useEditField", () => $c31e2d123e024ddc$export$343e962d356c0af1);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3BIWb = parcelRequire("3BIWb");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $ctrpc = parcelRequire("ctrpc");

var $d6AeP = parcelRequire("d6AeP");

var $2gCtH = parcelRequire("2gCtH");

var $afs7f = parcelRequire("afs7f");

var $15WDX = parcelRequire("15WDX");

var $biQrn = parcelRequire("biQrn");

var $8zOmE = parcelRequire("8zOmE");

var $3fAi8 = parcelRequire("3fAi8");

var $99cgx = parcelRequire("99cgx");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, $99cgx.defaultSaveField), saveFieldById: saveFieldById = (0, $99cgx.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $99cgx.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $99cgx.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $biQrn.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const resetError = (0, $5uXOq.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: actualFieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                analytics: analyticsEvent,
                attributes: {
                    fieldType: actualFieldType,
                    isInlineEditing: !(0, $d6AeP.getIsEditFromIssueView)(analyticsEvent),
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $jJZqs.ValidationError);
            if (!isValidationError) (0, $dJl1T.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(ex)
            });
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $2gCtH.useIssueId)();
    const contextualIssueKey = (0, $2gCtH.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $c31e2d123e024ddc$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
    if (!meta || typeof meta === 'object') return {
        ...meta ?? {},
        isEditFromIssueView: isEditFromIssueView
    };
    return meta;
};
const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $15WDX.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? $c31e2d123e024ddc$var$getAdditionalProperties(meta, (0, $d6AeP.getIsEditFromIssueView)(event)) : meta);
        if (!shouldPreventIssueViewSoftRefresh && !(0, $d6AeP.getIsEditFromIssueView)(event)) try {
            const reason = (0, $afs7f.Reason).SoftRefresh;
            await (0, $3BIWb.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("3BIWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65e83eb4ced9ce9$export$2e2bcd8739ae039);
const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = 'ON_DEMAND')=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
    removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
    refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
};

});

parcelRegister("d6AeP", function(module, exports) {

$parcel$export(module.exports, "getIsEditFromIssueView", () => $843704b157f0fa59$export$8846558eb0b5fa3);

var $hBuqR = parcelRequire("hBuqR");

var $lhVtI = parcelRequire("lhVtI");
const $843704b157f0fa59$export$8846558eb0b5fa3 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $lhVtI.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hBuqR.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("afs7f", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $90b3aba4b3cc23bb$export$fe867595c4640fb1);
const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});

parcelRegister("15WDX", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $947bdf396d8056bc$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $947bdf396d8056bc$export$f9eb49cc2f0e28ce);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5YMLs = parcelRequire("5YMLs");

var $3z81P = parcelRequire("3z81P");
const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $947bdf396d8056bc$var$actions = {
    fieldChanged: $947bdf396d8056bc$var$fieldChanged,
    fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
    fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
    registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
};
// this is a global state
const $947bdf396d8056bc$var$store = (0, $iXqE5.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $947bdf396d8056bc$var$actions
});
const $947bdf396d8056bc$export$444af741f6d8f512 = (0, $3sQ5x.createHook)($947bdf396d8056bc$var$store, {
    selector: null
});
const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, $gg7kZ.createContainer)($947bdf396d8056bc$var$store);

});
parcelRegister("5YMLs", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $1da8cbd2b672325c$export$d951e3c38e10736d);

var $bMD69 = parcelRequire("bMD69");

var $5fc53 = parcelRequire("5fc53");

var $1pF6B = parcelRequire("1pF6B");

var $lTnWS = parcelRequire("lTnWS");
const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $5fc53.RADIO_GQL_FIELD:
        case 0, $5fc53.TEAM_VIEW_GQL_FIELD:
        case 0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PEOPLE_GQL_FIELD:
        case 0, $5fc53.SECURITY_GQL_FIELD:
        case 0, $5fc53.NUMBER_GQL_FIELD:
        case 0, $5fc53.TEXT_GQL_FIELD:
        case 0, $5fc53.USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PRIORITY_GQL_FIELD:
        case 0, $5fc53.URL_GQL_FIELD:
        case 0, $5fc53.DATE_PICKER_GQL_FIELD:
        case 0, $5fc53.PROJECT_GQL_FIELD:
        case 0, $5fc53.DATE_TIME_GQL_FIELD:
        case 0, $5fc53.COLOR_GQL_FIELD:
        case 0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $5fc53.ISSUE_TYPE_GQL_FIELD:
        case 0, $5fc53.VOTES_GQL_FIELD:
        case 0, $5fc53.WATCHES_GQL_FIELD:
        case 0, $5fc53.RESOLUTION_GQL_FIELD:
        case 0, $5fc53.STATUS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $5fc53.RICH_TEXT_GQL_FIELD:
            return (0, $lTnWS.transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
        case 0, $5fc53.PARENT_GQL_FIELD:
            return (0, $1pF6B.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $5fc53.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $5fc53.TIME_TRACKING_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                originalEstimate: fieldValue.originalEstimate,
                remainingEstimate: fieldValue.remainingEstimate,
                timeSpent: fieldValue.timeSpent
            })?.value;
        case 0, $5fc53.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $5fc53.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                components: fieldValue.components,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $5fc53.TEXT_GQL_FIELD)]: 'text',
        [(0, $5fc53.NUMBER_GQL_FIELD)]: 'number',
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $5fc53.PROJECT_GQL_FIELD)]: 'project',
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $5fc53.URL_GQL_FIELD)]: 'uri',
        [(0, $5fc53.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $5fc53.VOTES_GQL_FIELD)]: 'vote',
        [(0, $5fc53.COLOR_GQL_FIELD)]: 'color',
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $5fc53.STATUS_GQL_FIELD)]: 'status',
        [(0, $5fc53.RADIO_GQL_FIELD)]: 'selectedOption',
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: 'richText'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("bMD69", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $af5e8bab0defb9c8$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $af5e8bab0defb9c8$export$ba106ff8c087e6b1);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $9bgym = parcelRequire("9bgym");

var $6iJEF = parcelRequire("6iJEF");

var $9UrtF = parcelRequire("9UrtF");

var $hsEaK = parcelRequire("hsEaK");

var $2qu1N = parcelRequire("2qu1N");

var $16Zia = parcelRequire("16Zia");

var $iv8Rf = parcelRequire("iv8Rf");

var $hDlc2 = parcelRequire("hDlc2");

var $c3LW9 = parcelRequire("c3LW9");

var $h92P3 = parcelRequire("h92P3");

var $aeO9V = parcelRequire("aeO9V");

var $6Tnq8 = parcelRequire("6Tnq8");

var $6mbsj = parcelRequire("6mbsj");

var $d3nG3 = parcelRequire("d3nG3");

var $1xW6n = parcelRequire("1xW6n");

var $fW9XR = parcelRequire("fW9XR");

var $bKMMB = parcelRequire("bKMMB");

var $7JL37 = parcelRequire("7JL37");

var $dulCG = parcelRequire("dulCG");

var $6vno6 = parcelRequire("6vno6");

var $as0vY = parcelRequire("as0vY");

var $6dPLd = parcelRequire("6dPLd");

var $gKccZ = parcelRequire("gKccZ");

var $jnUrZ = parcelRequire("jnUrZ");

var $iJtmd = parcelRequire("iJtmd");

var $iPyq0 = parcelRequire("iPyq0");

var $384lj = parcelRequire("384lj");

var $axTS6 = parcelRequire("axTS6");

var $lfJ6H = parcelRequire("lfJ6H");

var $9UXU7 = parcelRequire("9UXU7");

var $b6BoU = parcelRequire("b6BoU");

var $gak3n = parcelRequire("gak3n");

var $i47fO = parcelRequire("i47fO");

var $gvljZ = parcelRequire("gvljZ");

var $6XFn2 = parcelRequire("6XFn2");

var $6e1Ya = parcelRequire("6e1Ya");

var $640u2 = parcelRequire("640u2");

var $hBEiJ = parcelRequire("hBEiJ");

var $1XNj2 = parcelRequire("1XNj2");

var $f6zXW = parcelRequire("f6zXW");

var $fB4wX = parcelRequire("fB4wX");

var $cXBkk = parcelRequire("cXBkk");

var $iDKu3 = parcelRequire("iDKu3");

var $aGv90 = parcelRequire("aGv90");

var $19DRh = parcelRequire("19DRh");

var $lkW3a = parcelRequire("lkW3a");

var $lQAwK = parcelRequire("lQAwK");

var $8qOI6 = parcelRequire("8qOI6");

var $cbd7V = parcelRequire("cbd7V");

var $6hj44 = parcelRequire("6hj44");

var $4nh4C = parcelRequire("4nh4C");

var $hA3EZ = parcelRequire("hA3EZ");

var $2z4xE = parcelRequire("2z4xE");

var $cO2KQ = parcelRequire("cO2KQ");

var $5sETx = parcelRequire("5sETx");

var $f454b = parcelRequire("f454b");

var $aafIf = parcelRequire("aafIf");

var $2yWre = parcelRequire("2yWre");

var $lUeQj = parcelRequire("lUeQj");

var $6SWOK = parcelRequire("6SWOK");

var $cMc7B = parcelRequire("cMc7B");

var $38GNL = parcelRequire("38GNL");

var $avV20 = parcelRequire("avV20");

var $cbXvu = parcelRequire("cbXvu");

var $aSXJi = parcelRequire("aSXJi");

var $8uxcU = parcelRequire("8uxcU");

var $arKlm = parcelRequire("arKlm");

var $hCKV6 = parcelRequire("hCKV6");

var $d8wC0 = parcelRequire("d8wC0");
// We're memoising this just in case we FF another field
const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
        [(0, $5fc53.AFFECTED_SERVICES_GQL_FIELD)]: (0, $9bgym.transformAggAffectedServicesToLegacyField),
        [(0, $5fc53.BOOLEAN_GQL_FIELD)]: (0, $9UrtF.transformAggBooleanToLegacyField),
        [(0, $5fc53.CASCADING_SELECT_GQL_FIELD)]: (0, $hsEaK.transformAggCascadingSelectToLegacyField),
        [(0, $5fc53.CHECKBOX_GQL_FIELD)]: (0, $2qu1N.transformAggCheckboxToLegacyField),
        [(0, $5fc53.CMDB_GQL_FIELD)]: (0, $16Zia.transformAggCMDBToLegacyField),
        [(0, $5fc53.MULTI_SELECT_GQL_FIELD)]: (0, $19DRh.transformAggMultipleSelectToLegacyField),
        [(0, $5fc53.COMPONENTS_GQL_FIELD)]: (0, $hDlc2.transformAggComponentsToLegacyField),
        [(0, $5fc53.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $c3LW9.transformAggConnectDateTimeToLegacyField),
        [(0, $5fc53.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $h92P3.transformAggConnectMultipleSelectToLegacyField),
        [(0, $5fc53.CONNECT_NUMBER_GQL_FIELD)]: (0, $aeO9V.transformAggConnectNumberToLegacyField),
        [(0, $5fc53.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $6Tnq8.transformAggConnectRichTextToLegacyField),
        [(0, $5fc53.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $6mbsj.transformAggConnectSingleSelectToLegacyField),
        [(0, $5fc53.CONNECT_TEXT_GQL_FIELD)]: (0, $d3nG3.transformAggConnectTextToLegacyField),
        [(0, $5fc53.COLOR_GQL_FIELD)]: (0, $iv8Rf.transformAggColorToLegacyField),
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: (0, $fW9XR.transformAggDatePickerToLegacyField),
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: (0, $bKMMB.transformAggDateTimePickerToLegacyField),
        [(0, $5fc53.EPIC_LINK_GQL_FIELD)]: (0, $7JL37.transformAggEpicLinkToLegacyField),
        [(0, $5fc53.FLAG_GQL_FIELD)]: (0, $dulCG.transformAggFlagToLegacyField),
        [(0, $5fc53.FORGE_DATETIME_GQL_FIELD)]: (0, $as0vY.transformAggForgeDateTimeToLegacyField),
        [(0, $5fc53.FORGE_DATE_GQL_FIELD)]: (0, $6vno6.transformAggForgeDateToLegacyField),
        [(0, $5fc53.FORGE_GROUP_GQL_FIELD)]: (0, $6dPLd.transformAggForgeGroupToLegacyField),
        [(0, $5fc53.FORGE_GROUPS_GQL_FIELD)]: (0, $gKccZ.transformAggForgeGroupsToLegacyField),
        [(0, $5fc53.FORGE_NUMBER_GQL_FIELD)]: (0, $jnUrZ.transformAggForgeNumberToLegacyField),
        [(0, $5fc53.FORGE_OBJECT_GQL_FIELD)]: (0, $iJtmd.transformAggForgeObjectToLegacyField),
        [(0, $5fc53.FORGE_STRING_GQL_FIELD)]: (0, $iPyq0.transformAggForgeStringToLegacyField),
        [(0, $5fc53.FORGE_STRINGS_GQL_FIELD)]: (0, $384lj.transformAggForgeStringsToLegacyField),
        [(0, $5fc53.FORGE_USER_GQL_FIELD)]: (0, $axTS6.transformAggForgeUserToLegacyField),
        [(0, $5fc53.FORGE_USERS_GQL_FIELD)]: (0, $lfJ6H.transformAggForgeUsersToLegacyField),
        [(0, $5fc53.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $b6BoU.transformAggIssueRestrictionToLegacyField),
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: (0, $gak3n.transformAggIssueTypeToLegacyField),
        [(0, $5fc53.JSM_APPROVAL_GQL_FIELD)]: (0, $i47fO.transformAggJSMApprovalsToLegacyField),
        [(0, $5fc53.JSM_ASSETS_GQL_FIELD)]: (0, $6iJEF.transformAggAssetToLegacyField),
        [(0, $5fc53.JSM_MAJOR_INCIDENT_FIELD)]: (0, $6XFn2.transformAggJSMMajorIncidentToLegacyField),
        [(0, $5fc53.JSM_ORGANIZATION_GQL_FIELD)]: (0, $6e1Ya.transformAggJSMOrganizationToLegacyField),
        [(0, $5fc53.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $gvljZ.transformAggJSMEntitlementsToLegacyField),
        [(0, $5fc53.JSM_SENTIMENT_GQL_FIELD)]: (0, $cXBkk.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.JSM_PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $hBEiJ.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $5fc53.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $1XNj2.transformAggJSMRequestLanguageToLegacyField),
        [(0, $5fc53.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $f6zXW.transformAggJSMRequestTypeToLegacyField),
        [(0, $5fc53.JSM_RESPONDERS_GQL_FIELD)]: (0, $fB4wX.transformAggJSMRespondersToLegacyField),
        [(0, $5fc53.LABEL_GQL_FIELD)]: (0, $iDKu3.transformAggLabelsNodeToLegacyField),
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: (0, $6hj44.transformAggPriorityToLegacyField),
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $aGv90.transformAggMultiGroupPickerToLegacyField),
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.NUMBER_GQL_FIELD)]: (0, $8qOI6.transformAggNumberToLegacyField),
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $cbd7V.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.PROFORMA_FORMS_GQL_FIELD)]: (0, $4nh4C.transformAggProformaFormsToLegacyField),
        [(0, $5fc53.PROJECT_GQL_FIELD)]: (0, $hA3EZ.transformAggProjectToLegacyField),
        [(0, $5fc53.MULTI_VERSION_GQL_FIELD)]: (0, $lQAwK.transformAggMultipleVersionPickerToLegacyField),
        [(0, $5fc53.RADIO_GQL_FIELD)]: (0, $2z4xE.transformAggRadioSelectToLegacyField),
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: (0, $5sETx.transformAggRichTextToLegacyField),
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: (0, $cO2KQ.transformAggResolutionToLegacyField),
        [(0, $5fc53.SECURITY_GQL_FIELD)]: (0, $f454b.transformAggSecurityLevelToLegacyField),
        [(0, $5fc53.SPRINT_GQL_FIELD)]: (0, $38GNL.transformAggSprintToLegacyField),
        [(0, $5fc53.STATUS_GQL_FIELD)]: (0, $avV20.transformAggStatusToLegacyField),
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $aafIf.transformAggSingleGroupPickerToLegacyField),
        [(0, $5fc53.SINGLE_SELECT_GQL_FIELD)]: (0, $lUeQj.transformAggSingleSelectToLegacyField),
        [(0, $5fc53.TEAM_GQL_FIELD)]: (0, $cbXvu.transformAggTeamToLegacyField),
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: (0, $aSXJi.transformAggTeamViewToLegacyField),
        [(0, $5fc53.TEXT_GQL_FIELD)]: (0, $2yWre.transformAggSingleLineTextToLegacyField),
        [(0, $5fc53.TIME_TRACKING_GQL_FIELD)]: (0, $8uxcU.transformAggTimeTrackingToLegacyField),
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: (0, $6SWOK.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $5fc53.URL_GQL_FIELD)]: (0, $arKlm.transformAggUrlToLegacyField),
        [(0, $5fc53.VERSION_GQL_FIELD)]: (0, $cMc7B.transformAggSingleVersionPickerToLegacyField),
        [(0, $5fc53.VOTES_GQL_FIELD)]: (0, $hCKV6.transformAggVotesToLegacyField),
        [(0, $5fc53.WATCHES_GQL_FIELD)]: (0, $d8wC0.transformAggWatchesToLegacyField),
        [(0, $5fc53.DATA_CLASSIFICATION_FIELD)]: (0, $1xW6n.transformAggDataClassificationToLegacyField),
        [(0, $5fc53.GOALS_GQL_FIELD)]: (0, $9UXU7.transformAggGoalsToLegacyField),
        [(0, $5fc53.JCS_ORGANIZATION_GQL_FIELD)]: (0, $640u2.transformAggJCSOrganizationToLegacyField)
    });
const $af5e8bab0defb9c8$var$getTransformers = (0, $8QpSo.default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, context, projectContext)=>{
    const typename = node.__typename;
    const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
    return transformer ? transformer(node, context, projectContext) : undefined;
};
const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields, projectField)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            let projectContext;
            if ((0, $4R6GH.fg)('issue_view_move_isaienable_from_project_field')) projectContext = projectField != null ? projectField : (0, $hA3EZ.getProjectField)(fields)?.project;
            const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, fields, projectContext);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("9bgym", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $0bce5d1c363f27e8$export$231e0419515441d4);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("o7K5u", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $cfa10031dfb7ad46$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $cfa10031dfb7ad46$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $cfa10031dfb7ad46$export$b5de5f3d2de73afc);
const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("6iJEF", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b9f6b8590a60f3b3$export$2136dcd78a2ef18f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $5fc53.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("9UrtF", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $474331244347ccdb$export$4bd89b95f0d10de9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hsEaK", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $afb6a8576bf8d731$export$a8778af5ceb1017c);


var $o7K5u = parcelRequire("o7K5u");
const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            type: 'option-with-child',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2qu1N", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $3efe07b8b545ea99$export$baa5afdbd8fd12d3);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $o7K5u.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("16Zia", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $4d2c21f2e394ef74$export$93506453d9bb56ae);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $o7K5u.transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $o7K5u.transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $5fc53.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $5fc53.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iv8Rf", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $b83a62ddd17b4586$export$587c178f1b45e5e9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $5fc53.EPIC_COLOR_TYPE:
        case 0, $5fc53.COLOR_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hDlc2", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $315456e18e2330f5$export$97a9275777684b77);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ari: component.ari,
        metadata: component.metadata
    };
};
const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $5fc53.COMPONENTS_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.components, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    const value = (0, $o7K5u.transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $5fc53.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("c3LW9", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $e80217ec1ee321d5$export$e6d015aa746cbdaf);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("h92P3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $1bb7cdf99e93ff64$export$edf5c98d20696686);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (0, $o7K5u.toLegacyConnectOption));
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("aeO9V", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $b8a5823753f7873f$export$4638a5dd3285d8f2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("6Tnq8", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $f9558299012f1c2e$export$11063e1f9210f191);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f9558299012f1c2e$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $f9558299012f1c2e$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $5fc53.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("dMYPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fed9edf4c76e19$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");
const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $dJl1T.default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;

});


parcelRegister("6mbsj", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $ceb0872dd5eafe49$export$e44db7cf61369a28);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $o7K5u.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d3nG3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $145b645a3d2e801e$export$dd05277f5aa90657);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("1xW6n", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $1a8d4561538d1d2b$export$b5edfdc89a7a2932);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $5fc53.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("fW9XR", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $c44a652aaa9bff90$export$3d6e51d37c0454a9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.DUE_DATE_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $5fc53.DATE_CF_TYPE:
        case 0, $5fc53.BASELINE_START_CF_TYPE:
        case 0, $5fc53.BASELINE_END_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("bKMMB", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $fb29b1af2f1467e0$export$3de22f1277f0c239);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $fb29b1af2f1467e0$var$defaultSchema = {
    type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.RESOLUTION_DATE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.DATETIME_CF_TYPE:
        case 0, $5fc53.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $5fc53.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7JL37", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3279d658ea1a4982$export$1311f30c94840aa2);

var $7SCny = parcelRequire("7SCny");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $7SCny.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $5fc53.EPIC_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $5fc53.EPIC_TYPE),
            system: null
        }
    };
};

});
parcelRegister("7SCny", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $8e4230f608d6b965$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $8e4230f608d6b965$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $8e4230f608d6b965$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $8e4230f608d6b965$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $8e4230f608d6b965$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $8e4230f608d6b965$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $8e4230f608d6b965$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $8e4230f608d6b965$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $8e4230f608d6b965$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $8e4230f608d6b965$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $8e4230f608d6b965$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $8e4230f608d6b965$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $8e4230f608d6b965$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $8e4230f608d6b965$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $8e4230f608d6b965$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $8e4230f608d6b965$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $8e4230f608d6b965$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $8e4230f608d6b965$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $8e4230f608d6b965$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $8e4230f608d6b965$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $8e4230f608d6b965$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $8e4230f608d6b965$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $8e4230f608d6b965$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $8e4230f608d6b965$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $8e4230f608d6b965$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $8e4230f608d6b965$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $8e4230f608d6b965$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $8e4230f608d6b965$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $8e4230f608d6b965$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $8e4230f608d6b965$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $8e4230f608d6b965$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $8e4230f608d6b965$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $8e4230f608d6b965$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $8e4230f608d6b965$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $8e4230f608d6b965$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $8e4230f608d6b965$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $8e4230f608d6b965$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $8e4230f608d6b965$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $8e4230f608d6b965$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $8e4230f608d6b965$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $8e4230f608d6b965$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $8e4230f608d6b965$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $8e4230f608d6b965$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $8e4230f608d6b965$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $8e4230f608d6b965$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $8e4230f608d6b965$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $8e4230f608d6b965$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $8e4230f608d6b965$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $8e4230f608d6b965$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $8e4230f608d6b965$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $8e4230f608d6b965$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $8e4230f608d6b965$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $8e4230f608d6b965$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $8e4230f608d6b965$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $8e4230f608d6b965$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $8e4230f608d6b965$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $8e4230f608d6b965$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $8e4230f608d6b965$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $8e4230f608d6b965$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $8e4230f608d6b965$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $8e4230f608d6b965$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $8e4230f608d6b965$export$7ffdeca4b2f927a2 = 'PURPLE';
const $8e4230f608d6b965$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $8e4230f608d6b965$export$738c3b9a44c87ecc = 'BLUE';
const $8e4230f608d6b965$export$1225f83626261b80 = 'DARK_BLUE';
const $8e4230f608d6b965$export$48d4b2cd5bc0e88b = 'GREEN';
const $8e4230f608d6b965$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $8e4230f608d6b965$export$d0446fe88325854e = 'TEAL';
const $8e4230f608d6b965$export$bb848c92687e69dc = 'DARK_TEAL';
const $8e4230f608d6b965$export$aab610c505c06a8f = 'YELLOW';
const $8e4230f608d6b965$export$466af87757d343a2 = 'DARK_YELLOW';
const $8e4230f608d6b965$export$3de5e29ed1757f9b = 'ORANGE';
const $8e4230f608d6b965$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $8e4230f608d6b965$export$7d278ca694634874 = 'GREY';
const $8e4230f608d6b965$export$26453300bfc61cb8 = 'DARK_GREY';
const $8e4230f608d6b965$export$56d196d2844d1ca1 = [
    $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    $8e4230f608d6b965$export$c815fe495e8174a0,
    $8e4230f608d6b965$export$738c3b9a44c87ecc,
    $8e4230f608d6b965$export$1225f83626261b80,
    $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    $8e4230f608d6b965$export$d0446fe88325854e,
    $8e4230f608d6b965$export$bb848c92687e69dc,
    $8e4230f608d6b965$export$aab610c505c06a8f,
    $8e4230f608d6b965$export$466af87757d343a2,
    $8e4230f608d6b965$export$3de5e29ed1757f9b,
    $8e4230f608d6b965$export$da02e4820b6ab753,
    $8e4230f608d6b965$export$7d278ca694634874,
    $8e4230f608d6b965$export$26453300bfc61cb8
];
const $8e4230f608d6b965$export$792af22a0198af8d = 'purple';
const $8e4230f608d6b965$export$588af712afdcb006 = 'dark_purple';
const $8e4230f608d6b965$export$84c4918645391802 = 'blue';
const $8e4230f608d6b965$export$b8f1f5838352a33a = 'dark_blue';
const $8e4230f608d6b965$export$9384b7e350ee6542 = 'green';
const $8e4230f608d6b965$export$87d3fb8d8656d38b = 'dark_green';
const $8e4230f608d6b965$export$b0b4ce3e99e66aae = 'teal';
const $8e4230f608d6b965$export$a89b77a449bd223e = 'dark_teal';
const $8e4230f608d6b965$export$9a33b5e3cde94885 = 'yellow';
const $8e4230f608d6b965$export$33253d7862bceb8a = 'dark_yellow';
const $8e4230f608d6b965$export$6609c2b23fc42f39 = 'orange';
const $8e4230f608d6b965$export$cd994662b5911917 = 'dark_orange';
const $8e4230f608d6b965$export$1793d43e13e078c5 = 'grey';
const $8e4230f608d6b965$export$487a6e9145526564 = 'dark_grey';
const $8e4230f608d6b965$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $8e4230f608d6b965$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $8e4230f608d6b965$export$94ac87c81ed074a7 = 'ghx-label-3';
const $8e4230f608d6b965$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $8e4230f608d6b965$export$610a2c132b6fcf96 = 'ghx-label-5';
const $8e4230f608d6b965$export$8e4997dba71f1c40 = 'ghx-label-6';
const $8e4230f608d6b965$export$18a545b4e69b27b4 = 'ghx-label-7';
const $8e4230f608d6b965$export$27fff1a0d295292a = 'ghx-label-8';
const $8e4230f608d6b965$export$e57aa662a56724e1 = 'ghx-label-9';
const $8e4230f608d6b965$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $8e4230f608d6b965$export$457ecb9560f2bf83 = 'ghx-label-11';
const $8e4230f608d6b965$export$a866db37165a696c = 'ghx-label-12';
const $8e4230f608d6b965$export$9b18447c1168a1b6 = 'ghx-label-13';
const $8e4230f608d6b965$export$93b9ad4020e271b7 = 'ghx-label-14';
const $8e4230f608d6b965$export$5cd2af17b34de3e3 = 'color_1';
const $8e4230f608d6b965$export$987671fa69482a7b = 'color_2';
const $8e4230f608d6b965$export$70ba8a5b1f4c7446 = 'color_3';
const $8e4230f608d6b965$export$fcd1c42d8d3ebd36 = 'color_4';
const $8e4230f608d6b965$export$f80a5bd2fa0ba256 = 'color_5';
const $8e4230f608d6b965$export$37ad5ce8d2aeaf78 = 'color_6';
const $8e4230f608d6b965$export$9dc62d5d151cb355 = 'color_7';
const $8e4230f608d6b965$export$1ed15b30f5663f92 = 'color_8';
const $8e4230f608d6b965$export$5d23a84d55ac1644 = 'color_9';
const $8e4230f608d6b965$export$bf08c9a6ed42e349 = 'color_10';
const $8e4230f608d6b965$export$66c5d8f0b5ff279c = 'color_11';
const $8e4230f608d6b965$export$da30755a37c3a597 = 'color_12';
const $8e4230f608d6b965$export$721cf84faff6bf19 = 'color_13';
const $8e4230f608d6b965$export$4b8f8666bd7b61dd = 'color_14';
const $8e4230f608d6b965$export$c537fa0d021d010b = {
    PURPLE: $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $8e4230f608d6b965$export$c815fe495e8174a0,
    BLUE: $8e4230f608d6b965$export$738c3b9a44c87ecc,
    DARK_BLUE: $8e4230f608d6b965$export$1225f83626261b80,
    GREEN: $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    TEAL: $8e4230f608d6b965$export$d0446fe88325854e,
    DARK_TEAL: $8e4230f608d6b965$export$bb848c92687e69dc,
    YELLOW: $8e4230f608d6b965$export$aab610c505c06a8f,
    DARK_YELLOW: $8e4230f608d6b965$export$466af87757d343a2,
    ORANGE: $8e4230f608d6b965$export$3de5e29ed1757f9b,
    DARK_ORANGE: $8e4230f608d6b965$export$da02e4820b6ab753,
    GREY: $8e4230f608d6b965$export$7d278ca694634874,
    DARK_GREY: $8e4230f608d6b965$export$26453300bfc61cb8
};
const $8e4230f608d6b965$export$d33d39828a18210a = {
    SERVER_PURPLE: $8e4230f608d6b965$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $8e4230f608d6b965$export$588af712afdcb006,
    SERVER_BLUE: $8e4230f608d6b965$export$84c4918645391802,
    SERVER_DARK_BLUE: $8e4230f608d6b965$export$b8f1f5838352a33a,
    SERVER_GREEN: $8e4230f608d6b965$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $8e4230f608d6b965$export$87d3fb8d8656d38b,
    SERVER_TEAL: $8e4230f608d6b965$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $8e4230f608d6b965$export$a89b77a449bd223e,
    SERVER_YELLOW: $8e4230f608d6b965$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $8e4230f608d6b965$export$33253d7862bceb8a,
    SERVER_ORANGE: $8e4230f608d6b965$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $8e4230f608d6b965$export$cd994662b5911917,
    SERVER_GREY: $8e4230f608d6b965$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $8e4230f608d6b965$export$487a6e9145526564
};
const $8e4230f608d6b965$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $8e4230f608d6b965$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $8e4230f608d6b965$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $8e4230f608d6b965$export$94ac87c81ed074a7,
    GHX_LABEL_4: $8e4230f608d6b965$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $8e4230f608d6b965$export$610a2c132b6fcf96,
    GHX_LABEL_6: $8e4230f608d6b965$export$8e4997dba71f1c40,
    GHX_LABEL_7: $8e4230f608d6b965$export$18a545b4e69b27b4,
    GHX_LABEL_8: $8e4230f608d6b965$export$27fff1a0d295292a,
    GHX_LABEL_9: $8e4230f608d6b965$export$e57aa662a56724e1,
    GHX_LABEL_10: $8e4230f608d6b965$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $8e4230f608d6b965$export$457ecb9560f2bf83,
    GHX_LABEL_12: $8e4230f608d6b965$export$a866db37165a696c,
    GHX_LABEL_13: $8e4230f608d6b965$export$9b18447c1168a1b6,
    GHX_LABEL_14: $8e4230f608d6b965$export$93b9ad4020e271b7
};
const $8e4230f608d6b965$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $8e4230f608d6b965$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $8e4230f608d6b965$export$987671fa69482a7b,
    AGILE_COLOR_3: $8e4230f608d6b965$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $8e4230f608d6b965$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $8e4230f608d6b965$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $8e4230f608d6b965$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $8e4230f608d6b965$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $8e4230f608d6b965$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $8e4230f608d6b965$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $8e4230f608d6b965$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $8e4230f608d6b965$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $8e4230f608d6b965$export$da30755a37c3a597,
    AGILE_COLOR_13: $8e4230f608d6b965$export$721cf84faff6bf19,
    AGILE_COLOR_14: $8e4230f608d6b965$export$4b8f8666bd7b61dd
};

});


parcelRegister("dulCG", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $f31e97d89b497c1c$export$31555b6ea19f4c2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $5fc53.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6vno6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $f5e60b2709763004$export$30fccfce22948120);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("as0vY", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $3520698819975afe$export$61b1f0cbd04c7b9c);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("6dPLd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $ce6b58a5b1f45912$export$60b03d63015cbb9f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("gKccZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $256d8054300c3cdf$export$2dfa4944fba5d1f5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("jnUrZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $c68528ed0dfd109c$export$5dab8986dc45db07);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("iJtmd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $c814454c00552e79$export$fbdabdbae2a203b9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iPyq0", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $29f719811f573640$export$3a581fb4b3e578bd);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("384lj", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $0d30cb879c19e1ba$export$418a06cb5dc6aba5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("axTS6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0669940239efeaff$export$bc73c7a747f907e5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("iob0v", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $42550039db1edc00$export$d7b231260a016eaf);

const $42550039db1edc00$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $145004f7a92e2423$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $145004f7a92e2423$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
        default:
            return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
    }
};
const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $42550039db1edc00$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lfJ6H", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9UXU7", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $a8d444f432651533$export$158301a02ae4cbe7);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $5fc53.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $5fc53.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("b6BoU", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $d0a0e03637cc83cd$export$62db794d5816e28e);


var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $o7K5u = parcelRequire("o7K5u");

var $hA3EZ = parcelRequire("hA3EZ");
const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, context, projectContext)=>{
    if (node.type !== (0, $5fc53.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $o7K5u.transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    const project = (0, $4R6GH.fg)('issue_view_move_isaienable_from_project_field') ? projectContext : (0, $hA3EZ.getSystemAggJiraProject)(context);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: project?.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});
parcelRegister("hA3EZ", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $e3d5807b112803bd$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectField", () => $e3d5807b112803bd$export$b19207d974ad5e77);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $e3d5807b112803bd$export$d100105d56da4a0a);
$parcel$export(module.exports, "isAggJiraProjectClassic", () => $e3d5807b112803bd$export$3502ed01c034e451);
$parcel$export(module.exports, "transformAggSystemProjectToProjectContext", () => $e3d5807b112803bd$export$77162d1422f22f47);
$parcel$export(module.exports, "transformAggProjectToProjectContext", () => $e3d5807b112803bd$export$275f121d4e6f5165);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $e3d5807b112803bd$export$30c14b802399f417);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");



var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");
const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
    }
};
const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $2vSU6.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $e3d5807b112803bd$export$b19207d974ad5e77 = (fields)=>{
    /**
	 * The only way to get the type to return an optional value with `AggJiraProject` type
	 * is to re-assign the type wihtout throwing an error.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields?.find((edge)=>edge?.node?.__typename === (0, $5fc53.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $5fc53.PROJECT_TYPE))?.node;
};
const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ const projectField = $e3d5807b112803bd$export$b19207d974ad5e77(fields);
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
const $e3d5807b112803bd$export$3502ed01c034e451 = (project)=>!$e3d5807b112803bd$export$f7d5cb97957d02e3(project);
const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $g5X3G.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar?.large || ''
        }
    };
};
const $e3d5807b112803bd$export$77162d1422f22f47 = (project)=>{
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
        avatarUrl: avatar?.medium,
        isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
    const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
    return $e3d5807b112803bd$export$77162d1422f22f47(project);
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.PROJECT_TYPE),
            custom: (0, $5fc53.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        title: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $5fc53.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $5fc53.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $5fc53.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
    if ((0, $4R6GH.fg)('jpd_idea_panel_in_issue_view')) switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("gak3n", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $4f9b530de681b60e$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $4f9b530de681b60e$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $4f9b530de681b60e$export$de2eb3b47c7c887b);


var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4f9b530de681b60e$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $5fc53.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $5fc53.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $5fc53.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $5fc53.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)} with ${(0, $5fc53.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
        ...$4f9b530de681b60e$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $imYFg.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $5fc53.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $5fc53.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.ISSUE_TYPE),
            type: (0, $5fc53.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("imYFg", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $ccb1a8095461a82a$export$2fe6880f0073407c);

var $g4tDr = parcelRequire("g4tDr");
const $ccb1a8095461a82a$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});
parcelRegister("g4tDr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $03dd5f7faa501890$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $03dd5f7faa501890$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $03dd5f7faa501890$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $03dd5f7faa501890$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $03dd5f7faa501890$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $03dd5f7faa501890$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $03dd5f7faa501890$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $03dd5f7faa501890$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $03dd5f7faa501890$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $03dd5f7faa501890$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $03dd5f7faa501890$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $03dd5f7faa501890$export$638ac52227e67c8);
const $03dd5f7faa501890$export$2294cfc7730248df = 4;
const $03dd5f7faa501890$export$961a1d6da881600c = 3;
const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
const $03dd5f7faa501890$export$9ad20e435294162a = 1;
const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
};
const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
};
const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
};
const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};
const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};

});



parcelRegister("i47fO", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $448e6754d8bf50d1$export$b14d30f2a9e4c343);

var $9ar3z = parcelRequire("9ar3z");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $5fc53.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $g5X3G.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $5fc53.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $9ar3z.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $9ar3z.APPROVER_APPROVED:
            return 0, $9ar3z.APPROVER_APPROVED;
        case 0, $9ar3z.APPROVER_DECLINED:
            return 0, $9ar3z.APPROVER_DECLINED;
        case 0, $9ar3z.APPROVER_PENDING:
        default:
            return 0, $9ar3z.APPROVER_PENDING;
    }
};
const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $iob0v.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $o7K5u.transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $o7K5u.transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
        configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $o7K5u.transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
        excludedApprovers: (0, $o7K5u.transformAggConnection)(activeApproval.excludedApprovers, (0, $iob0v.transformJiraUserToLegacyServerUser)),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
    };
};
const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
        approvers: (0, $o7K5u.transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
    };
};
const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $o7K5u.transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("9ar3z", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $4a7fc5eda3865b0e$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $4a7fc5eda3865b0e$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $4a7fc5eda3865b0e$export$2e6187b6a4348938);
const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("gvljZ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $b281bef34e07e20f$export$850fadda8a5e6f27);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $5fc53.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ENTITLEMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6XFn2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $926c732f6621d9fd$export$d4e0b2288fb31144);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("6e1Ya", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $0e4eebb31cef7087$export$7bd14951253a7c5f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("640u2", function(module, exports) {

$parcel$export(module.exports, "transformAggJCSOrganizationToLegacyField", () => $84b085b51db539b3$export$81bfe5b16f9be413);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $84b085b51db539b3$export$81bfe5b16f9be413 = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATION_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedOrganization,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATION_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("hBEiJ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $841fa8e5b9308ced$export$c52c6988b335096);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("1XNj2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $1edf1c9b37cdb462$export$6a53240e225f742);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("f6zXW", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $8030de3237296d5c$export$5ffaab1383177efa);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $5fc53.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("fB4wX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $0ea07ade045943f7$export$5171c4d1ae5bcde5);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $5fc53.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $5fc53.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $5fc53.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $o7K5u.transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $5fc53.RESPONDERS_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("cXBkk", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $5dcf9f49c6a1536d$export$702d3754a4c7d90a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $5fc53.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SENTIMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iDKu3", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $5345161012c71e28$export$98e4f56e2e6c44fe);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5345161012c71e28$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $5fc53.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("aGv90", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $ee565846dd4aef42$export$f968da580693597d);


var $o7K5u = parcelRequire("o7K5u");
const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("19DRh", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $d83d25c034b1d99f$export$869fb8fbcb97e0ee);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("lkW3a", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $9b1f1d40e628c968$export$cdd9991119eb040e);

var $2vSU6 = parcelRequire("2vSU6");


var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $o7K5u = parcelRequire("o7K5u");

var $hA3EZ = parcelRequire("hA3EZ");

var $iob0v = parcelRequire("iob0v");
const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, context, projectContext)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE:
            {
                if (node.__typename === (0, $5fc53.MULTI_USER_PICKER_GQL_FIELD) && (0, $4R6GH.fg)('relay-migration-issue-fields-multi-user-fg')) return {
                    ...legacyFieldValues,
                    value: value
                };
                const project = (0, $4R6GH.fg)('issue_view_move_isaienable_from_project_field') ? projectContext : (0, $hA3EZ.getSystemAggJiraProject)(context);
                if ((0, $hA3EZ.getProjectType)(project?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
                // Empty array is the expected value when there are no request
                // participants.
                return {
                    ...legacyFieldValues,
                    value: value
                };
            }
        case 0, $5fc53.PARTICIPANTS_CF_TYPE:
        case 0, $5fc53.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $5fc53.APPROVERS_LIST_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("lQAwK", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $dc0acfee4cadcdcd$export$6207ea60703068d8);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $dc0acfee4cadcdcd$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $5fc53.MULTI_VERSION_CF_TYPE) && node.type !== (0, $5fc53.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $5fc53.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $o7K5u.transformAggConnection)(node.selectedVersionsConnection, (0, $149sa.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $5fc53.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    custom: (0, $5fc53.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $5fc53.AFFECTS_VERSIONS_TYPE:
        case 0, $5fc53.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("149sa", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $4617842fe98d5759$export$becef8d087e8b62b);

var $jPhQo = parcelRequire("jPhQo");
const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $jPhQo.VersionStatus).ARCHIVED,
        released: version.status === (0, $jPhQo.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("jPhQo", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $imYFg = parcelRequire("imYFg");


const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("8qOI6", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $b542e2b397d83c88$export$d754a24ed0096d2f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $5fc53.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $5fc53.STORY_POINTS_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cbd7V", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $47597066e94f8347$export$f08d02fdc74f920e);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $5fc53.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("6hj44", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $47c25f6616be0140$export$9e966ce605f800d2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $5fc53.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $5fc53.PRIORITY_TYPE),
            custom: null,
            system: (0, $5fc53.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("4nh4C", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $27d464e5749e1114$export$fdcdbf17b0d4e36f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $5fc53.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $5fc53.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $5fc53.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("2z4xE", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $b545e68fef1c7c25$export$f147f1eb3a15ccfc);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $5fc53.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("cO2KQ", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $b13d1a2c3ca9d3cb$export$179f600c7e1d0230);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $5fc53.RESOLUTION_TYPE)) return undefined;
    const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.RESOLUTION_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5sETx", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $181b5722dae42ee4$export$e65ff2ce94be106e);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $fCo6Y = parcelRequire("fCo6Y");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $181b5722dae42ee4$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $5fc53.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $5fc53.DESCRIPTION_TYPE:
        case 0, $5fc53.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $5fc53.DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $181b5722dae42ee4$var$getPlainTextValue(node),
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $fCo6Y.removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
        value: null,
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("fCo6Y", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $79bd166f69131b05$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $79bd166f69131b05$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $79bd166f69131b05$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $79bd166f69131b05$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $79bd166f69131b05$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $79bd166f69131b05$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $79bd166f69131b05$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $79bd166f69131b05$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $79bd166f69131b05$export$80a6e90c7b29d88c);

var $lmhF9 = parcelRequire("lmhF9");
var $l1C1k = parcelRequire("l1C1k");

var $dJl1T = parcelRequire("dJl1T");
const $79bd166f69131b05$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
    };
    return adf;
};
const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $79bd166f69131b05$export$9e9311e676291037(adf);
};
const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $l1C1k.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $l1C1k.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $l1C1k.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $lmhF9.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("rXFMz"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("4a7SK"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("dDoPj"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("lmhF9", function(module, exports) {

$parcel$export(module.exports, "filter", () => $cb7d90be6f5f5975$export$3dea766d36a8935f);

var $l1C1k = parcelRequire("l1C1k");
function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("rXFMz", function(module, exports) {

let $0540cf87134fa52f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0540cf87134fa52f$var$load("8Q4nN").then(()=>parcelRequire('kOFhM'));

});

parcelRegister("4a7SK", function(module, exports) {

let $307e35cca4f37f8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $307e35cca4f37f8b$var$load("ikOjy").then(()=>parcelRequire('dN5CS'));

});

parcelRegister("dDoPj", function(module, exports) {

let $9ed22ce8b7709a18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ed22ce8b7709a18$var$load("akgCU").then(()=>parcelRequire('hYNZx'));

});



parcelRegister("f454b", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $811c3c0495fb451c$export$45e25e2a6750ea5a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $o7K5u.transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $5fc53.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("aafIf", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $950a9b8297396bb3$export$e6697ec5bdac9ec0);


var $o7K5u = parcelRequire("o7K5u");
const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2yWre", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $f5309f9bc8791ddf$export$31f32b3fd9e5ab6);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f5309f9bc8791ddf$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $5fc53.EPIC_NAME_TYPE:
        case 0, $5fc53.MESSAGE_EDIT_CF_TYPE:
        case 0, $5fc53.MESSAGE_VIEW_CF_TYPE:
        case 0, $5fc53.READ_ONLY_CF_TYPE:
        case 0, $5fc53.TEXT_CF_TYPE:
        case 0, $5fc53.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $5fc53.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $5fc53.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $5fc53.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("lUeQj", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $9513f3f43c691d67$export$4e113f935e09d226);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $9513f3f43c691d67$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $5fc53.EPIC_STATUS_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
            return $9513f3f43c691d67$var$getField(node);
        case 0, $5fc53.CATEGORY_TYPE:
            return $9513f3f43c691d67$var$getField(node, (0, $5fc53.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("6SWOK", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $7348765074cf60a5$export$7bf73fc06c6d71be);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cMc7B", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $1c34fc6a70d0e0b4$export$d03f622577260442);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $5fc53.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.singlePickerVersions, (0, $149sa.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $149sa.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $5fc53.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("38GNL", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $05e0b9d6b707c3a6$export$9b5bb05d50970021);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $5fc53.SPRINT_TYPE)) return undefined;
    const sprints = (0, $o7K5u.transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("avV20", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $e8b60f3bf3251c5a$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $e8b60f3bf3251c5a$export$c80e5acb1c882c48);

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $gULOk.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $5fc53.STATUS_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.STATUS_TYPE),
            custom: null,
            system: (0, $5fc53.STATUS_TYPE)
        }
    };
};

});

parcelRegister("cbXvu", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $2c8c4053c45e92fb$export$fb1b80497e96456f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $5fc53.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("aSXJi", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $b1861ddba2f2c1e6$export$6f6aaafb49bd4769);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
        isVerified: team.jiraSuppliedIsVerified || false
    };
};
const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("8uxcU", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $63b0d60fa2cc1a3e$export$874d9bd14269ec6f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $5fc53.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.TIME_TRACKING_TYPE),
            type: (0, $5fc53.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("arKlm", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $86ba2c1106803d01$export$6e950e0ec9801f6c);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $5fc53.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $5fc53.URL_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("hCKV6", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $78b4a5963398330d$export$8966614b8594736);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $5fc53.VOTES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.VOTES_TYPE),
            type: (0, $5fc53.VOTES_TYPE)
        }
    };
};

});

parcelRegister("d8wC0", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $a83bab4858993b2f$export$6730cb17d10d6156);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $5fc53.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.WATCHES_TYPE),
            type: (0, $5fc53.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("1pF6B", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $f8196a61a82995ed$export$d8a5feb2bb0425b4);
const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});

parcelRegister("lTnWS", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", () => $51ceecc021979aad$export$b3a2c3992977726e);

var $kz2lw = parcelRequire("kz2lw");


var $fCo6Y = parcelRequire("fCo6Y");
const $51ceecc021979aad$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $51ceecc021979aad$export$b3a2c3992977726e = (richText, renderer)=>{
    if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
    if (renderer === (0, $650578330a102f55$export$a4a240cb4053b29f)) {
        if (richText.plainText !== undefined) return richText.plainText;
        return richText?.adfValue?.convertedPlainText?.plainText;
    }
    return richText?.adfValue?.json ? (0, $fCo6Y.removeCollectionFromAdf)(richText?.adfValue?.json) : $51ceecc021979aad$var$emptyAdfObject;
};

});


parcelRegister("3z81P", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $c6ffe75554a4bac3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $c6ffe75554a4bac3$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGED]: $c6ffe75554a4bac3$var$FIELD_CHANGED
};

});


parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("99cgx", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $2a246664763defba$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $2a246664763defba$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $2a246664763defba$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $2a246664763defba$export$33b78476f5d734b3);

var $eusud = parcelRequire("eusud");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("ilTj3", function(module, exports) {

$parcel$export(module.exports, "useMajorIncidentConfig", () => $336b94be25e79342$export$4fa770b3011492c);

var $5uXOq = parcelRequire("5uXOq");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");
const $336b94be25e79342$export$4fa770b3011492c = (issueKey)=>{
    const [{ value: fieldConfig }] = (0, $54wEF.useIssueFieldConfig)(issueKey);
    const [majorIncidentFieldIdKey, searchUrl, fieldType] = (0, $5uXOq.useMemo)(()=>{
        if (fieldConfig != null) {
            const fieldId = Object.keys(fieldConfig).find((fieldKey)=>fieldConfig[fieldKey].schema.custom === (0, $5fc53.MAJOR_INCIDENT_CF_TYPE));
            if (fieldId != null) {
                const majorIncidentConfig = fieldConfig[fieldId];
                const { autoCompleteUrl: autoCompleteUrl, schema: { type: type } } = majorIncidentConfig;
                return [
                    fieldId,
                    autoCompleteUrl || '',
                    type
                ];
            }
        }
        return [
            '',
            '',
            'string'
        ];
    }, [
        fieldConfig
    ]);
    return {
        majorIncidentFieldIdKey: majorIncidentFieldIdKey,
        searchUrl: searchUrl,
        fieldType: fieldType
    };
};

});
parcelRegister("54wEF", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $a5085d8f4019d625$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $a5085d8f4019d625$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $a5085d8f4019d625$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $a5085d8f4019d625$export$28a22fd0dedf31b7);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $gXz4p = parcelRequire("gXz4p");

var $biQrn = parcelRequire("biQrn");

var $2N3tQ = parcelRequire("2N3tQ");

var $28RWS = parcelRequire("28RWS");
const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $a5085d8f4019d625$var$fetchData = async (issueKey)=>{
    try {
        const response = (0, $4R6GH.fg)('jiv-20148-js-scheduler-preemption') ? await (0, $28RWS.polyfilledSchedulerPostTask)(()=>(0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
                body: JSON.stringify({
                    query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                    variables: {
                        issueKey: issueKey
                    }
                })
            }), 'background') : await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        return null;
    }
};
const $a5085d8f4019d625$var$requestSet = new Set();
const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $biQrn.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        $a5085d8f4019d625$var$requestSet.add(issueKey);
        const result = await $a5085d8f4019d625$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $a5085d8f4019d625$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldGetData = (0, $4R6GH.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $2N3tQ.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $2N3tQ.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $2N3tQ.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("iZIvy", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $ef2130f553e5234b$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $ef2130f553e5234b$export$f2fec0cacdfabaaf);

var $96nmc = parcelRequire("96nmc");

var $chLKn = parcelRequire("chLKn");

const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $chLKn.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("chLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("2N3tQ", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $0471f3f4df57179c$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $0471f3f4df57179c$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $0471f3f4df57179c$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $0471f3f4df57179c$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $0471f3f4df57179c$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $0471f3f4df57179c$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $0471f3f4df57179c$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $0471f3f4df57179c$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $0471f3f4df57179c$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dGvGJ = parcelRequire("dGvGJ");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $0471f3f4df57179c$var$actions = {
    setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
    setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
    mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
    mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
    setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
};
// this is a global state
const $0471f3f4df57179c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $0471f3f4df57179c$var$actions
});
const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$314199caf05d245 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: null
});
const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $0471f3f4df57179c$var$overridesActions = {
    setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
    resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $0471f3f4df57179c$var$overridesStore = (0, $iXqE5.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $0471f3f4df57179c$var$overridesActions
});
const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
});
const $0471f3f4df57179c$export$d94ae842140da412 = (0, $3sQ5x.createActionsHook)($0471f3f4df57179c$var$overridesStore);
const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
});
const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIsFieldBusySelector
});

});

parcelRegister("28RWS", function(module, exports) {

$parcel$export(module.exports, "polyfilledSchedulerPostTask", () => $a83d56ab935c6154$export$76fe6fc7f54a2fa6);
const $a83d56ab935c6154$export$76fe6fc7f54a2fa6 = (callback, priority)=>{
    if ('scheduler' in globalThis) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const retVal = globalThis.scheduler.postTask(callback, {
            priority: priority
        });
        return retVal;
    }
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(callback());
        });
    });
};

});




parcelRegister("k8QoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a9c7be39c7f43b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f6a9c7be39c7f43b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tootltipContent: {
        "id": "major-incident.major-incident-lozenge.tootltip-content",
        "defaultMessage": "This incident is marked as a major incident to increase visibility."
    },
    lozengeLabel: {
        "id": "major-incident.major-incident-lozenge.lozenge-label",
        "defaultMessage": "MAJOR INCIDENT"
    }
});

});



parcelRegister("13uif", function(module, exports) {

$parcel$export(module.exports, "default", () => $31c3f985e02bde53$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jnhNB = parcelRequire("jnhNB");
const $31c3f985e02bde53$var$MultiUserField = (props)=>{
    const { dataSelectorProps: { value: items } } = props;
    const userData = (0, $5uXOq.useMemo)(()=>items.map((user)=>({
                email: user.email,
                key: user.email,
                name: user.name,
                src: user.avatarUrl
            })), [
        items
    ]);
    if (!items || items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31c3f985e02bde53$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31c3f985e02bde53$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
        size: "small",
        maxCount: 5,
        appearance: "stack",
        data: userData
    })));
};
var $31c3f985e02bde53$export$2e2bcd8739ae039 = $31c3f985e02bde53$var$MultiUserField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $31c3f985e02bde53$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f31ejb _n3tdu2gc _19bvu2gc _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $31c3f985e02bde53$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fs78R", function(module, exports) {

$parcel$export(module.exports, "default", () => $549f844ad62dc056$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $d9xxV = parcelRequire("d9xxV");

var $6UXEc = parcelRequire("6UXEc");

var $jgJNO = parcelRequire("jgJNO");
const $549f844ad62dc056$var$MultiValueField = (props)=>{
    const { dataSelectorProps: { value: items }, tableInjectedProps: { fieldName: fieldName, fieldId: fieldId } } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const expandedView = (0, $5uXOq.useMemo)(()=>items.map(({ value: value }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
                key: `multi-value-${fieldId}-${index}`,
                text: value
            })), [
        items,
        fieldId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        setIsOpen,
        isOpen
    ]);
    const getContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($549f844ad62dc056$var$PopUpContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UXEc.default), null, expandedView));
    const getTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            appearance: "link",
            isSelected: isOpen,
            onClick: onToggle
        }, `${items.length} ${fieldName}`);
    if (!items || items.length === 0) return null;
    if (items.length <= 3) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($549f844ad62dc056$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($549f844ad62dc056$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UXEc.default), null, expandedView)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($549f844ad62dc056$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($549f844ad62dc056$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "issue-table.common.fields.multi-value-field.popup",
        messageType: "transactional",
        content: getContent,
        trigger: getTrigger
    })));
};
var $549f844ad62dc056$export$2e2bcd8739ae039 = $549f844ad62dc056$var$MultiValueField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $549f844ad62dc056$var$PopUpContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fnklw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $549f844ad62dc056$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f31ejb _n3tdu2gc _19bvu2gc _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $549f844ad62dc056$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ $5uXOq.createElement((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ $5uXOq.createElement((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});


parcelRegister("5N53W", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92cf9bc963e59ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9ZVa8 = parcelRequire("9ZVa8");

var $1NrcW = parcelRequire("1NrcW");

var $WFrhP = parcelRequire("WFrhP");
const $f92cf9bc963e59ff$var$Organization = ({ dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } })=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ZVa8.ReadView), {
        name: (0, $1NrcW.getNameFromOrganizationFieldData)(value)
    })) : null;
var $f92cf9bc963e59ff$export$2e2bcd8739ae039 = $f92cf9bc963e59ff$var$Organization;

});
parcelRegister("9ZVa8", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $dff59f1f92f73669$export$a4b5824ec1e018e1);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $jbUS9 = parcelRequire("jbUS9");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $2IIMc = parcelRequire("2IIMc");
const $dff59f1f92f73669$var$TextWrapper = ({ children: children })=>{
    return (0, $4R6GH.fg)('jcs-issue-view-truncate-reporter') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dff59f1f92f73669$var$textStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $dff59f1f92f73669$export$a4b5824ec1e018e1 = ({ name: name })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: [
            (0, $4R6GH.fg)('jcs-issue-view-truncate-reporter') ? $dff59f1f92f73669$var$containerStyles : $dff59f1f92f73669$var$containerStylesOld,
            !name && $dff59f1f92f73669$var$placeholderStyles
        ],
        testId: "servicedesk-customer-service-custom-fields.common.ui.organization-read-view.inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbUS9.LabelIcon), {
        size: "xsmall",
        type: "ORGANIZATION"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dff59f1f92f73669$var$TextWrapper, null, name || formatMessage((0, $2IIMc.default).none)));
};
const $dff59f1f92f73669$var$containerStylesOld = (0, $8CUq3.xcss)({
    margin: 'space.050',
    overflowWrap: 'anywhere',
    paddingLeft: 'space.100'
});
const $dff59f1f92f73669$var$containerStyles = (0, $8CUq3.xcss)({
    margin: 'space.050',
    paddingLeft: 'space.100',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
});
const $dff59f1f92f73669$var$textStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: '0px',
    flexGrow: 1
});
const $dff59f1f92f73669$var$placeholderStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest'
});

});
parcelRegister("2IIMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee39de517eb35ff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cee39de517eb35ff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "servicedesk-customer-service-custom-fields.common.ui.organization-read-view.none-non-final",
        "defaultMessage": "None"
    }
});

});


parcelRegister("1NrcW", function(module, exports) {

$parcel$export(module.exports, "getNameFromOrganizationFieldData", () => $d416c1a454e89d0e$export$33a16ab674eb1646);
const $d416c1a454e89d0e$export$33a16ab674eb1646 = (value)=>value?.name;

});


parcelRegister("j3MEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ccd455dfd89ecd9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $85IQg = parcelRequire("85IQg");
function $5ccd455dfd89ecd9$export$2e2bcd8739ae039(props) {
    if (props.dataSelectorProps.value === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85IQg.default), null);
    const { dataSelectorProps: { value: { iconUrl: iconUrl, name: name } } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ccd455dfd89ecd9$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        height: "16",
        width: "16",
        src: iconUrl,
        alt: name,
        title: name
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ccd455dfd89ecd9$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _ca0qutpp _u5f3u2gc _n3tdu2gc _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("85IQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c722c5ab4be50662$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $koVbs = parcelRequire("koVbs");

var $1g1yB = parcelRequire("1g1yB");

var $62YnN = parcelRequire("62YnN");
function $c722c5ab4be50662$var$Error(props) {
    const { isLastColumn: isLastColumn, message: message } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipMessage = typeof message === 'string' ? message : formatMessage(message);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1g1yB.default), {
        isLastColumn: isLastColumn,
        tooltipMessage: tooltipMessage,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        color: "var(--ds-icon-danger, #C9372C)",
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    });
}
$c722c5ab4be50662$var$Error.defaultProps = {
    isLastColumn: false,
    message: (0, $62YnN.default).errorMessage
};
var $c722c5ab4be50662$export$2e2bcd8739ae039 = $c722c5ab4be50662$var$Error;

});
parcelRegister("1g1yB", function(module, exports) {

$parcel$export(module.exports, "default", () => $867010f52df00ba8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hAZqC = parcelRequire("hAZqC");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $eHJxW = parcelRequire("eHJxW");

var $WFrhP = parcelRequire("WFrhP");
const $867010f52df00ba8$var$DIALOG_MAX_WIDTH = (0, $gwIPs.gridSize) * 36;
const $867010f52df00ba8$var$TABLE_LEFT_MARGIN = (0, $gwIPs.gridSize) * 5;
class $867010f52df00ba8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isLastColumn: false,
            tooltipTitle: undefined
        };
    }
    calculateDialogPosition() {
        if (this.alertRef.current) {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            const { left: left } = this.alertRef.current.getBoundingClientRect();
            if (this.alertRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            this.alertRef.current.offsetParent && left > // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            this.alertRef.current.offsetParent.getBoundingClientRect().left + $867010f52df00ba8$var$DIALOG_MAX_WIDTH + $867010f52df00ba8$var$TABLE_LEFT_MARGIN) return 'bottom-end';
        }
        return 'bottom-start';
    }
    renderDialogContent() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($867010f52df00ba8$var$DialogContainer, null, this.props.tooltipTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, this.props.tooltipTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, this.props.tooltipMessage));
    }
    render() {
        const { isLastColumn: isLastColumn, Icon: Icon, color: color, backgroundColor: backgroundColor } = this.props;
        return !(0, $4R6GH.fg)('handle-queues-column-exceptions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            placement: this.calculateDialogPosition(),
            messageId: "issue-table.common.fields.common.alert.inline-dialog",
            messageType: "transactional",
            content: this.renderDialogContent(),
            isOpen: this.state.dialogOpen,
            onClose: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($867010f52df00ba8$var$Container, {
            onClick: this.onClick,
            color: color,
            backgroundColor: backgroundColor,
            /* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type '{ current: HTMLDivElement | null; }'. */ ref: this.alertRef,
            tabIndex: 0,
            onMouseEnter: this.onMouseEnterContainer,
            onMouseLeave: this.onMouseLeaveContainer,
            isHovered: this.state.isHovered
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $867010f52df00ba8$var$IconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: color
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($867010f52df00ba8$var$Container, {
            onClick: this.onClick,
            color: color,
            backgroundColor: backgroundColor,
            /* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type '{ current: HTMLDivElement | null; }'. */ ref: this.alertRef,
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $867010f52df00ba8$var$IconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: "currentColor"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            placement: this.calculateDialogPosition(),
            content: this.renderDialogContent(),
            isOpen: this.state.dialogOpen,
            onClose: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($867010f52df00ba8$var$ErrorContainer, {
            onClick: this.onClick,
            color: color,
            backgroundColor: backgroundColor,
            /* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type '{ current: HTMLDivElement | null; }'. */ ref: this.alertRef,
            tabIndex: 0,
            onMouseEnter: this.onMouseEnterContainer,
            onMouseLeave: this.onMouseLeaveContainer,
            isHovered: this.state.isHovered,
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $867010f52df00ba8$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAZqC))), {
            label: ""
        })))));
    }
    constructor(...args){
        super(...args), this.state = {
            dialogOpen: false,
            isHovered: false
        }, this.onClick = ()=>this.setState({
                dialogOpen: !this.state.dialogOpen
            }), this.onMouseEnterContainer = ()=>this.setState({
                ...this.state,
                isHovered: true
            }), this.onMouseLeaveContainer = ()=>this.setState({
                ...this.state,
                isHovered: false
            }), this.alertRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $867010f52df00ba8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1aegsjq": (0, $lD23V.default)(`2px solid ${__cmplp.color}`),
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color),
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19it1pqh _2rkoi2wt _syaz1cj8 _bfhk3qkl _1bsb1osq _4t3i1ylp _y3gn1h6o",
            __cmplp.isHovered ? "_80omtlke" : "_80om1wug",
            __cmplp.className
        ])
    });
});
const $867010f52df00ba8$var$ErrorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastColumn: isLastColumn, backgroundColor: backgroundColor, isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gg4a5j": (0, $lD23V.default)(`0px ${__cmplp.isLastColumn ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)"} 0px ${"var(--ds-space-100, 8px)"}`),
            "--_1aegsjq": (0, $lD23V.default)(`2px solid ${__cmplp.color}`),
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color),
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt44105 _19it1pqh _2rkoi2wt _syaz1cj8 _bfhk3qkl _1bsb1osq _4t3i1ylp _y3gn1h6o _1e0c1txw _4cvr1h6o",
            __cmplp.isHovered ? "_80omtlke" : "_80om1wug",
            __cmplp.className
        ])
    });
});
const $867010f52df00ba8$var$iconContainerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.200'
});
const $867010f52df00ba8$var$IconContainer = (0, $8CUq3.xcss)({
    marginTop: 'space.025'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $867010f52df00ba8$var$DialogContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fo812",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});



parcelRegister("62YnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d420c408acf9d6df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d420c408acf9d6df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "issue-table.common.fields.error.error-message",
        "defaultMessage": "There was a problem showing this field."
    }
});

});



parcelRegister("ggDB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d14f2e5f549c9225$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $az4zD = parcelRequire("az4zD");

var $WFrhP = parcelRequire("WFrhP");

var $5EtPa = parcelRequire("5EtPa");
const $d14f2e5f549c9225$var$ANONYMOUS_STYLE = 'anonymous';
const $d14f2e5f549c9225$var$TOOLTIP_STYLE = 'tooltip';
const $d14f2e5f549c9225$var$SIMPLE_STYLE = 'simple';
const $d14f2e5f549c9225$var$getTooltipMessage = (style)=>{
    if (style.type === $d14f2e5f549c9225$var$TOOLTIP_STYLE) return `${style.displayName} - ${style.emailAddress}`;
    return null;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d14f2e5f549c9225$var$renderWithTooltipIfRequired = (content, tooltipText)=>{
    if (tooltipText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipText
    }, content);
    return content;
};
// eslint-disable-next-line jira/react/no-class-components
class $d14f2e5f549c9225$var$Reporter extends (0, $5uXOq.Component) {
    getDisplayMessage(style) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        switch(style.type){
            case $d14f2e5f549c9225$var$TOOLTIP_STYLE:
                return this.formatForDisplay(style.displayName);
            case $d14f2e5f549c9225$var$SIMPLE_STYLE:
                return this.formatForDisplay(style.value);
            case $d14f2e5f549c9225$var$ANONYMOUS_STYLE:
                return formatMessage((0, $5EtPa.default).anonymous);
            default:
                // prettier-ignore
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style;
                return '';
        }
    }
    getStyle() {
        const { dataSelectorProps: { value: value } } = this.props;
        if (!value || !value.emailAddress && !value.displayName) return {
            type: $d14f2e5f549c9225$var$ANONYMOUS_STYLE
        };
        const { emailAddress: emailAddress, displayName: displayName } = value;
        if (!emailAddress || !displayName || emailAddress === displayName) return {
            type: $d14f2e5f549c9225$var$SIMPLE_STYLE,
            value: emailAddress || displayName || ''
        };
        return {
            type: $d14f2e5f549c9225$var$TOOLTIP_STYLE,
            emailAddress: emailAddress,
            displayName: displayName
        };
    }
    formatForDisplay(name) {
        const { dataSelectorProps: { value: value }, intl: { formatMessage: formatMessage } } = this.props;
        const active = !value || value.active;
        if (active) return name;
        return formatMessage((0, $5EtPa.default).inactive, {
            name: name
        });
    }
    render() {
        const { tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
        const style = this.getStyle();
        const tooltip = $d14f2e5f549c9225$var$getTooltipMessage(style);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, $d14f2e5f549c9225$var$renderWithTooltipIfRequired(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d14f2e5f549c9225$var$ReporterWrapper, null, this.getDisplayMessage(style)), tooltip));
    }
}
var $d14f2e5f549c9225$export$2e2bcd8739ae039 // gridSize + 2 to account for summary field {padding: gridSize} + 2px from transparent border
 = (0, $az4zD.injectIntlV2)($d14f2e5f549c9225$var$Reporter);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d14f2e5f549c9225$var$ReporterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3ze3t _n3tdu2gc _19bvze3t _1i4q1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5EtPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb9568fe45899c3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7fb9568fe45899c3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    anonymous: {
        "id": "issue-table.common.fields.reporter.anonymous",
        "defaultMessage": "Anonymous"
    },
    inactive: {
        "id": "issue-table.common.fields.reporter.inactive",
        "defaultMessage": "{name} (Inactive)"
    }
});

});


parcelRegister("2GyKG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87252d6911e488ac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9Qo0U = parcelRequire("9Qo0U");
const $87252d6911e488ac$var$Responders = ({ dataSelectorProps: { value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Qo0U.RespondersInlineView), {
        values: value
    });
var $87252d6911e488ac$export$2e2bcd8739ae039 = $87252d6911e488ac$var$Responders;

});
parcelRegister("9Qo0U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "RespondersInlineView", () => $80dbc34cf29b4669$export$c1d034b633262480);
$parcel$export(module.exports, "default", () => $80dbc34cf29b4669$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d9xxV = parcelRequire("d9xxV");

var $6UXEc = parcelRequire("6UXEc");

var $kYYfm = parcelRequire("kYYfm");

const $80dbc34cf29b4669$export$c1d034b633262480 = ({ values: values })=>{
    const respondersRender = values.map((it)=>{
        const accountId = it.ari.startsWith((0, $1d7ec9d71dfa8613$export$470b0d72e4fdc43a)) ? it.ari.substring((0, $1d7ec9d71dfa8613$export$470b0d72e4fdc43a).length) : null;
        const renderTagWithProfileCardWrapper = (accountIdValue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYYfm.AsyncProfileCardNext), {
                key: it.ari,
                accountId: accountIdValue
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
                testId: "responders.ui.inline.async-tag",
                key: it.ari,
                text: it.name
            }));
        return accountId !== null ? renderTagWithProfileCardWrapper(accountId) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            testId: "responders.ui.inline.tag",
            key: it.ari,
            text: it.name
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UXEc.default), null, respondersRender);
};
var $80dbc34cf29b4669$export$2e2bcd8739ae039 = $80dbc34cf29b4669$export$c1d034b633262480;

});
const $1d7ec9d71dfa8613$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';



parcelRegister("5khw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d6c1e01900fd4d2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $WFrhP = parcelRequire("WFrhP");

var $9iCfo = parcelRequire("9iCfo");
const $9d6c1e01900fd4d2$var$Sentiment = ({ dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } })=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iCfo.ReadView), {
        id: value.id,
        name: value.name
    })) : null;
var $9d6c1e01900fd4d2$export$2e2bcd8739ae039 = $9d6c1e01900fd4d2$var$Sentiment;

});
parcelRegister("9iCfo", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $856be5d0bd899e78$export$a4b5824ec1e018e1);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $80dfn = parcelRequire("80dfn");
const $856be5d0bd899e78$export$a4b5824ec1e018e1 = ({ id: id, name: name })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, (0, $80dfn.EmojiIconForSentimentCustomField)(id, formatMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $856be5d0bd899e78$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, name)));
};
const $856be5d0bd899e78$var$contentStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.025',
    marginLeft: 'space.150',
    whiteSpace: 'nowrap'
});

});
parcelRegister("80dfn", function(module, exports) {

$parcel$export(module.exports, "EmojiIconForSentimentCustomField", () => $d73b9f0a16ca3e4b$export$48a4724ca11bcd06);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $8Qzxd = parcelRequire("8Qzxd");


var $iZbKR = parcelRequire("iZbKR");
const $d73b9f0a16ca3e4b$var$NegativeSentimentGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "96",
        height: "96",
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M61.7766 14.7403C57.4089 12.9312 52.7276 12 48 12C38.4522 12 29.2955 15.7928 22.5442 22.5442C15.7928 29.2955 12 38.4522 12 48C12 57.5478 15.7928 66.7045 22.5442 73.4558C29.2955 80.2072 38.4522 84 48 84C52.7276 84 57.4089 83.0688 61.7766 81.2597C66.1443 79.4505 70.1129 76.7988 73.4558 73.4558C76.7988 70.1129 79.4505 66.1443 81.2597 61.7766C83.0688 57.4089 84 52.7276 84 48C84 43.2724 83.0688 38.5911 81.2597 34.2234C79.4505 29.8557 76.7988 25.8871 73.4558 22.5442C70.1129 19.2012 66.1443 16.5495 61.7766 14.7403ZM76.284 48C76.284 63.6 63.6 76.284 48 76.284C32.4 76.284 19.716 63.6 19.716 48C19.7245 40.5012 22.7071 33.312 28.0095 28.0095C33.312 22.7071 40.5012 19.7245 48 19.716C63.6 19.716 76.284 32.4 76.284 48ZM38.3156 45.0357C38.9396 45.2944 39.6085 45.4277 40.284 45.428C41.6483 45.428 42.9607 44.886 43.9254 43.9214C44.89 42.9567 45.432 41.6483 45.432 40.284C45.432 38.9197 44.89 37.6113 43.9254 36.6466C42.9607 35.682 41.6523 35.14 40.288 35.14C39.6125 35.1397 38.9435 35.2725 38.3193 35.5308C37.6951 35.7891 37.1279 36.1678 36.6501 36.6452C36.1722 37.1227 35.7931 37.6896 35.5343 38.3136C35.2756 38.9376 35.1423 39.6065 35.142 40.282C35.1417 40.9575 35.2745 41.6265 35.5328 42.2507C35.7911 42.8749 36.1698 43.4421 36.6472 43.9199C37.1247 44.3978 37.6916 44.7769 38.3156 45.0357ZM52.0786 43.9214C53.0433 44.886 54.3517 45.428 55.716 45.428C57.0803 45.428 58.3887 44.886 59.3534 43.9214C60.318 42.9567 60.86 41.6483 60.86 40.284C60.86 38.9197 60.318 37.6113 59.3534 36.6466C58.3887 35.682 57.0803 35.14 55.716 35.14C54.3517 35.14 53.0433 35.682 52.0786 36.6466C51.114 37.6113 50.572 38.9197 50.572 40.284C50.572 41.6483 51.114 42.9567 52.0786 43.9214ZM38.8717 63.0827C38.2912 63.6733 37.5055 64.0176 36.6777 64.0439C35.85 64.0702 35.0439 63.7766 34.427 63.2241C33.8101 62.6716 33.4298 61.9026 33.3651 61.077C33.3005 60.2513 33.5564 59.4325 34.0798 58.7907C35.8298 56.8374 37.9718 55.2747 40.366 54.2044C42.7603 53.1341 45.3531 52.5802 47.9757 52.5787C50.5936 52.5799 53.1818 53.1319 55.5724 54.1987C57.963 55.2654 60.1024 56.8232 61.8517 58.7707C62.3954 59.4089 62.6683 60.2342 62.6123 61.0707C62.5564 61.9071 62.176 62.6887 61.5522 63.2489C60.9285 63.809 60.1106 64.1034 59.273 64.0694C58.4353 64.0354 57.644 63.6756 57.0677 63.0667C52.4357 57.9067 43.4958 57.9067 38.8717 63.0827Z",
        fill: "currentColor"
    }));
const $d73b9f0a16ca3e4b$var$NeutralSentimentGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "96",
        height: "96",
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M61.7766 14.7403C57.4089 12.9312 52.7276 12 48 12C38.4522 12 29.2955 15.7928 22.5442 22.5442C15.7928 29.2955 12 38.4522 12 48C12 57.5478 15.7928 66.7045 22.5442 73.4558C29.2955 80.2072 38.4522 84 48 84C52.7276 84 57.4089 83.0688 61.7766 81.2597C66.1443 79.4505 70.1129 76.7988 73.4558 73.4558C76.7988 70.1129 79.4505 66.1443 81.2597 61.7766C83.0688 57.4089 84 52.7276 84 48C84 43.2724 83.0688 38.5911 81.2597 34.2234C79.4505 29.8557 76.7988 25.8871 73.4558 22.5442C70.1129 19.2012 66.1443 16.5495 61.7766 14.7403ZM76.284 48C76.284 63.6 63.6 76.284 48 76.284C32.4 76.284 19.716 63.6 19.716 48C19.7245 40.5012 22.7071 33.312 28.0095 28.0095C33.312 22.7071 40.5012 19.7245 48 19.716C63.6 19.716 76.284 32.4 76.284 48ZM38.3156 45.0357C38.9396 45.2944 39.6085 45.4277 40.284 45.428C41.6483 45.428 42.9607 44.886 43.9254 43.9214C44.89 42.9567 45.432 41.6483 45.432 40.284C45.432 38.9197 44.89 37.6113 43.9254 36.6466C42.9607 35.682 41.6523 35.14 40.288 35.14C39.6125 35.1397 38.9435 35.2725 38.3193 35.5308C37.6951 35.7891 37.1279 36.1678 36.6501 36.6452C36.1722 37.1227 35.7931 37.6896 35.5343 38.3136C35.2756 38.9376 35.1423 39.6065 35.142 40.282C35.1417 40.9575 35.2745 41.6265 35.5328 42.2507C35.7911 42.8749 36.1698 43.4421 36.6472 43.9199C37.1247 44.3978 37.6916 44.7769 38.3156 45.0357ZM52.0786 43.9214C53.0433 44.886 54.3517 45.428 55.716 45.428C57.0803 45.428 58.3887 44.886 59.3534 43.9214C60.318 42.9567 60.86 41.6483 60.86 40.284C60.86 38.9197 60.318 37.6113 59.3534 36.6466C58.3887 35.682 57.0803 35.14 55.716 35.14C54.3517 35.14 53.0433 35.682 52.0786 36.6466C51.114 37.6113 50.572 38.9197 50.572 40.284C50.572 41.6483 51.114 42.9567 52.0786 43.9214ZM37 54.625C35.136 54.625 33.625 56.136 33.625 58C33.625 59.864 35.136 61.375 37 61.375L59 61.375C60.864 61.375 62.375 59.864 62.375 58C62.375 56.136 60.864 54.625 59 54.625L37 54.625Z",
        fill: "currentColor"
    }));
const $d73b9f0a16ca3e4b$export$48a4724ca11bcd06 = (sentimentId, formatMessage)=>{
    switch(sentimentId){
        case '1000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $d73b9f0a16ca3e4b$var$NegativeSentimentGlyph,
                label: formatMessage((0, $iZbKR.default).negativeSentimentIconLabel),
                primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
                size: "medium"
            });
        case '2000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $d73b9f0a16ca3e4b$var$NeutralSentimentGlyph,
                label: formatMessage((0, $iZbKR.default).neutralSentimentIconLabel),
                primaryColor: "var(--ds-icon-subtle, #44546F)",
                size: "medium"
            });
        case '3000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Qzxd))), {
                color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
                LEGACY_size: "medium",
                spacing: "spacious",
                label: formatMessage((0, $iZbKR.default).positiveSentimentIconLabel)
            });
        default:
            return null;
    }
};

});
parcelRegister("8Qzxd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7337f40decced4fdc07aaafc99a093a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $670ebe845924c4ae$var$_react = $670ebe845924c4ae$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $670ebe845924c4ae$var$_emoji = $670ebe845924c4ae$var$_interopRequireDefault((parcelRequire("cVLny")));

var $670ebe845924c4ae$var$_emoji2 = $670ebe845924c4ae$var$_interopRequireDefault((parcelRequire("agEw4")));
function $670ebe845924c4ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $670ebe845924c4ae$var$EmojiIcon = (props)=>/*#__PURE__*/ $670ebe845924c4ae$var$_react.default.createElement($670ebe845924c4ae$var$_emoji.default, Object.assign({
        LEGACY_fallbackIcon: $670ebe845924c4ae$var$_emoji2.default
    }, props));
$670ebe845924c4ae$var$EmojiIcon.Name = 'EmojiIconMigration';
var $670ebe845924c4ae$var$_default = module.exports.default = $670ebe845924c4ae$var$EmojiIcon;

});
parcelRegister("cVLny", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::135793779b3e889c5395b71036623edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $969f8f5da972f70f$var$_react = $969f8f5da972f70f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $969f8f5da972f70f$var$_baseNew = $969f8f5da972f70f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $969f8f5da972f70f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $969f8f5da972f70f$var$EmojiIcon = (props)=>/*#__PURE__*/ $969f8f5da972f70f$var$_react.default.createElement($969f8f5da972f70f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.25 6.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M11.25 9.75S10 11.5 8 11.5 4.75 9.75 4.75 9.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Zm-9-1.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$969f8f5da972f70f$var$EmojiIcon.displayName = 'EmojiIcon';
var $969f8f5da972f70f$var$_default = module.exports.default = $969f8f5da972f70f$var$EmojiIcon;

});

parcelRegister("agEw4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $779ad3b3a46edf78$var$_react = $779ad3b3a46edf78$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $779ad3b3a46edf78$var$_emoji = $779ad3b3a46edf78$var$_interopRequireDefault((parcelRequire("cVLny")));
function $779ad3b3a46edf78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $779ad3b3a46edf78$var$EmojiIcon = (props)=>/*#__PURE__*/ $779ad3b3a46edf78$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m0 16.071c3.9 0 7.071-3.171 7.071-7.071S15.9 4.929 12 4.929A7.08 7.08 0 0 0 4.929 12c0 3.9 3.171 7.071 7.071 7.071m-1.929-7.714a1.286 1.286 0 1 1 .001-2.572 1.286 1.286 0 0 1 0 2.572m3.858 0a1.286 1.286 0 1 1 0-2.572 1.286 1.286 0 0 1 0 2.572m.347 2.035a.805.805 0 0 1 1.198 1.073A4.67 4.67 0 0 1 12 16.018a4.67 4.67 0 0 1-3.469-1.548.804.804 0 0 1 1.196-1.074c1.158 1.29 3.393 1.29 4.549-.004"/></svg>`
    }, props, {
        newIcon: $779ad3b3a46edf78$var$_emoji.default
    }));
$779ad3b3a46edf78$var$EmojiIcon.displayName = 'EmojiIcon';
var $779ad3b3a46edf78$var$_default = module.exports.default = $779ad3b3a46edf78$var$EmojiIcon;

});


parcelRegister("iZbKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b6da66d1863b2f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $05b6da66d1863b2f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    negativeSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.negative-sentiment-icon-label",
        "defaultMessage": "Negative sentiment icon"
    },
    positiveSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.positive-sentiment-icon-label",
        "defaultMessage": "Positive sentiment icon"
    },
    neutralSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.neutral-sentiment-icon-label",
        "defaultMessage": "Neutral sentiment icon"
    }
});

});




parcelRegister("kz8zy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd123c83fcf070f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");


var $ewfjW = parcelRequire("ewfjW");


var $dxDQI = parcelRequire("dxDQI");
const $cd123c83fcf070f8$export$a7502422f07570ed = 'metric not found';
const $cd123c83fcf070f8$var$Sla = (props)=>{
    const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } } = props;
    const onError = (location, error, attributes)=>{
        // This check is added to supress the false burn events the client errors are creating in SLA Queue View Reliability SLOs
        // These errors are safe to be ignored
        // Platform team added a check to filter them from SFX & Splunk but still JSM Bumblebee team is seeing SLO Burn events
        // Ref: https://product-fabric.atlassian.net/browse/P2X-1109
        if ((0, $dxDQI.isClientFetchError)(error)) return;
        const errorPayload = {
            error: error,
            meta: {
                id: 'slaQueueView',
                packageName: 'jiraIssueTable'
            },
            attributes: {
                ...attributes,
                location: location,
                fieldType: (0, $d0df6a2b823cf08a$export$f790c24298ed441b)
            },
            sendToPrivacyUnsafeSplunk: true
        };
        return (0, $jcw0u.default)(errorPayload);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewfjW.AsyncLazySla), {
        isLastColumn: isLastColumn,
        value: value,
        onError: onError,
        viewMode: (0, $bb10fe9d5bb31c29$export$2e5e3c3156fc4c3c)
    });
};
var $cd123c83fcf070f8$export$2e2bcd8739ae039 = $cd123c83fcf070f8$var$Sla;

});
const $bb10fe9d5bb31c29$export$a63db8d18dae0c68 = 'card';
const $bb10fe9d5bb31c29$export$2e5e3c3156fc4c3c = 'queue';
const $bb10fe9d5bb31c29$export$6b218e85068d9955 = 'insights';

parcelRegister("ewfjW", function(module, exports) {

$parcel$export(module.exports, "AsyncLazySla", () => $becd35c254cf8313$export$e4c697b53a973eb5);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $b71gk = parcelRequire("b71gk");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

const $becd35c254cf8313$var$AsyncSla = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5UsIa")), {
    moduleId: "./src/packages/jira-issue-sla/src/ui/sla/main.tsx"
});
const $becd35c254cf8313$export$e4c697b53a973eb5 = (props)=>{
    const { viewMode: viewMode, onError: onError } = props;
    const boundary = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(`sla ${viewMode} View`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: boundary,
        packageName: "jira-issue-sla",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($becd35c254cf8313$var$AsyncSla, props)));
};

});
parcelRegister("5UsIa", function(module, exports) {

let $44d87435df3c3058$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $44d87435df3c3058$var$load("h2MrD"),
    $44d87435df3c3058$var$load("bYT2S"),
    $44d87435df3c3058$var$load("ethEL")
]).then(()=>parcelRequire('hN8Ee'));

});


parcelRegister("dxDQI", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $01355db328871ffb$export$2e7adc44463c3f4f);
const $01355db328871ffb$var$KNOWN_NETWORK_ERRORS = [
    'Failed to fetch dynamically imported module',
    'error loading dynamically imported module',
    'Importing a module script failed'
];
const $01355db328871ffb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$01355db328871ffb$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $01355db328871ffb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($01355db328871ffb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && $01355db328871ffb$var$isClientFetchErrorMessage(error.cause.message));

});


parcelRegister("8nUnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d25d42456997fd27$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g5X3G = parcelRequire("g5X3G");

var $WFrhP = parcelRequire("WFrhP");

var $fqAaJ = parcelRequire("fqAaJ");

var $jdkRG = parcelRequire("jdkRG");
class $d25d42456997fd27$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, { canRenderEditExperience: canRenderEditExperience }) {
        const { dataSelectorProps: { isEditable: isEditable }, tableInjectedProps: { shouldHydrateFully: shouldHydrateFully } } = props;
        if (shouldHydrateFully && isEditable === true && !canRenderEditExperience) return {
            canRenderEditExperience: true
        };
        return null;
    }
    enableEditExperienceIfAvailable() {
        if (this.props.dataSelectorProps.isEditable === true && !this.state.canRenderEditExperience) this.setState({
            canRenderEditExperience: true
        });
    }
    render() {
        const { dataSelectorProps: { value: { id: id, name: name, description: description, statusCategory: { id: statusCategoryId } }, isEditable: isEditable, onChange: onChange }, tableInjectedProps: { isLastColumn: isLastColumn, issueKey: issueKey, issueFieldLockControls: issueFieldLockControls } } = this.props;
        const { canRenderEditExperience: canRenderEditExperience } = this.state;
        const transformedProps = {
            value: {
                id: id.toString(),
                name: name,
                description: description,
                statusCategory: {
                    id: statusCategoryId
                }
            },
            isLastColumn: isLastColumn,
            appearance: 'lozenge',
            issueKey: (0, $g5X3G.toIssueKey)(issueKey),
            onChange: onChange,
            issueFieldLockControls: issueFieldLockControls
        };
        if (isEditable === true && canRenderEditExperience) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqAaJ.default), transformedProps));
        // SelectableChildGutterPaddingContainer, because it always renders within (possibly disabled) button.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn,
            onMouseOver: this.onMouseOver,
            onFocus: this.onFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdkRG.default), transformedProps));
    }
    constructor(...args){
        super(...args), this.state = {
            canRenderEditExperience: false
        }, this.onMouseOver = ()=>{
            this.enableEditExperienceIfAvailable();
        }, this.onFocus = ()=>{
            this.enableEditExperienceIfAvailable();
        };
    }
}

});
parcelRegister("fqAaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $955a4ecadee2ce84$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $9fZKh = parcelRequire("9fZKh");

var $fQeLt = parcelRequire("fQeLt");

var $kxZPA = parcelRequire("kxZPA");

var $bwmNE = parcelRequire("bwmNE");

var $i6Q5z = parcelRequire("i6Q5z");
const $955a4ecadee2ce84$var$FIELD_TYPE = 'status';

// TODO reevaluate phase - forPaint is simply for initial parity
const $955a4ecadee2ce84$var$IssueStatusField = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("i26aA")), {
    moduleId: "./src/packages/issue/fields/status/src/index.tsx"
});
class $955a4ecadee2ce84$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), this.onSuccess = (fieldValue, viaDialog, event)=>{
            const { onChange: onChange, issueKey: issueKey, issueFieldLockControls: issueFieldLockControls } = this.props;
            (0, $bwmNE.trackUpdatedField)(event, $955a4ecadee2ce84$var$FIELD_TYPE, this.getDataForAnalytics(fieldValue));
            // issue-field/status type does not have a description but JSD status type expects one
            const status = {
                ...fieldValue,
                description: ''
            };
            onChange && onChange(issueKey, status);
            issueFieldLockControls.onFieldUnlock();
        }, this.onSubmit = ()=>{
            this.setState({
                inEditState: false
            });
        }, this.onEditStart = ()=>{
            this.props.issueFieldLockControls.onFieldLock();
            this.setState({
                inEditState: true
            });
        }, this.onEditCancel = ()=>{
            this.props.issueFieldLockControls.onFieldUnlock();
            this.setState({
                inEditState: false
            });
        };
        this.state = {
            inEditState: false
        };
    }
    getDataForAnalytics(fieldValue) {
        const { value: value } = this.props;
        return {
            ...value ? {
                oldId: value.id,
                oldCategory: value.statusCategory.id
            } : {},
            ...fieldValue ? {
                newId: fieldValue.id,
                newCategory: fieldValue.statusCategory.id
            } : {}
        };
    }
    render() {
        const { value: value, appearance: appearance, issueKey: issueKey, issueFieldLockControls: { onFieldUnlock: onFieldUnlock } } = this.props;
        const status = {
            id: value.id,
            name: value.name,
            statusCategory: value.statusCategory
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q5z.default), {
            inEditState: this.state.inEditState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fZKh.IssueStatusFieldBoundary), {
            packageName: "issue-table",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
                value: status
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($955a4ecadee2ce84$var$IssueStatusField, {
            value: status,
            appearance: appearance,
            issueKey: issueKey,
            isOptimistic: false,
            onSubmit: this.onSubmit,
            onSuccess: this.onSuccess,
            onFailure: onFieldUnlock,
            onEditStart: this.onEditStart,
            onEditCancel: this.onEditCancel
        })));
    }
}

});
parcelRegister("9fZKh", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $0cd8b9cfe3ba1e4a$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $0cd8b9cfe3ba1e4a$export$dba9e9c892560f60);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $fQeLt = parcelRequire("fQeLt");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0cd8b9cfe3ba1e4a$var$AsyncLazyIssueStatusField = (0, $kxZPA.lazy)(()=>(parcelRequire("a86Oo")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $0cd8b9cfe3ba1e4a$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd8b9cfe3ba1e4a$var$AsyncLazyIssueStatusField, props)));
};
const $0cd8b9cfe3ba1e4a$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("fQeLt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $e065d549cea5a7d0$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $e065d549cea5a7d0$export$9f5070a985b0679b);

var $5uXOq = parcelRequire("5uXOq");

var $17mYr = parcelRequire("17mYr");
const $e065d549cea5a7d0$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false
    });
};
const $e065d549cea5a7d0$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("17mYr", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $9yOBd = parcelRequire("9yOBd");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");


var $aQhlk = parcelRequire("aQhlk");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $kGDYq = parcelRequire("kGDYq");

var $5Ax7l = parcelRequire("5Ax7l");

var $4YeLF = parcelRequire("4YeLF");
const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $390c5e7bc7d9c77b$var$StatusLozengeNew = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
    }));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $390c5e7bc7d9c77b$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    })));
const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, name)));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R300})` : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})` : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozenge = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $aQhlk.disabledColor).text : !(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $aQhlk.textColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $aQhlk.textColorOld)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $aQhlk.disabledColor).text : (0, $aQhlk.textHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o",
            (0, $kGDYq.isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StatusContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            (0, $kGDYq.isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $390c5e7bc7d9c77b$var$pressableStyles = (0, $8CUq3.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("aQhlk", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $58bc751e3aa4b554$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $58bc751e3aa4b554$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $58bc751e3aa4b554$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $58bc751e3aa4b554$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $58bc751e3aa4b554$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $58bc751e3aa4b554$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $58bc751e3aa4b554$export$b70f10fc4a6ba453);
const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
    '1': $58bc751e3aa4b554$export$61137dce61763ec3,
    '2': $58bc751e3aa4b554$export$61137dce61763ec3,
    '3': $58bc751e3aa4b554$export$132676d06d92ad48,
    '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
};
const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("kGDYq", function(module, exports) {

$parcel$export(module.exports, "isTabularGridFieldsEnabled", () => $4b98d8a4e0ed63d5$export$9605b1d5fe0c238b);

var $co1wz = parcelRequire("co1wz");
const $4b98d8a4e0ed63d5$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
const $4b98d8a4e0ed63d5$export$9605b1d5fe0c238b = ()=>(0, $co1wz.ff)($4b98d8a4e0ed63d5$export$455240e4be839479, false); // </rkarki>
 // <bento>
 // </bento>

});

parcelRegister("5Ax7l", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $bcba81c28add5d02$export$a31cbe1bf5463979);

var $5uXOq = parcelRequire("5uXOq");

var $lj8SI = parcelRequire("lj8SI");

var $aQhlk = parcelRequire("aQhlk");

const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $aQhlk.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $aQhlk.disabledColor).text,
                backgroundColor: (0, $aQhlk.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("4YeLF", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $bbacf745a667099a$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $5uXOq = parcelRequire("5uXOq");
const $bbacf745a667099a$var$containerStyles = {
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $bbacf745a667099a$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$contentStyles
    }, children));
$bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';

});



parcelRegister("a86Oo", function(module, exports) {

let $75ffef6c3d4ea6e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $75ffef6c3d4ea6e5$var$load("2Lfdl"),
    $75ffef6c3d4ea6e5$var$load("cM9em"),
    $75ffef6c3d4ea6e5$var$load("fr9NE"),
    $75ffef6c3d4ea6e5$var$load("4A1p8")
]).then(()=>parcelRequire('2azQI'));

});


parcelRegister("i26aA", function(module, exports) {

let $d20d330ee9707564$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d20d330ee9707564$var$load("2Lfdl"),
    $d20d330ee9707564$var$load("cM9em"),
    $d20d330ee9707564$var$load("fr9NE"),
    $d20d330ee9707564$var$load("h2MrD"),
    $d20d330ee9707564$var$load("bYT2S"),
    $d20d330ee9707564$var$load("bt53R")
]).then(()=>parcelRequire('gUKTg'));

});


parcelRegister("jdkRG", function(module, exports) {

$parcel$export(module.exports, "default", () => $956b331886cbe203$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fQeLt = parcelRequire("fQeLt");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$956b331886cbe203$export$2e2bcd8739ae039 = ({ value: value })=>{
    const status = {
        id: value.id,
        name: value.name,
        statusCategory: value.statusCategory
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
        value: status
    });
};

});


parcelRegister("8jtul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f500332df94b5f$export$2e2bcd8739ae039);

var $1bQGJ = parcelRequire("1bQGJ");

var $cSD7y = parcelRequire("cSD7y");

var $iQFwo = parcelRequire("iQFwo");

var $p64Ah = parcelRequire("p64Ah");

var $dgQ0R = parcelRequire("dgQ0R");
const $b6f500332df94b5f$var$mapStateToProps = (state)=>({
        useJSMQueueDurationEvent: (0, $iQFwo.getUseJSMQueueDurationEvent)(state)
    });
const $b6f500332df94b5f$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps
    });
const $b6f500332df94b5f$var$SummaryConnected = (0, $p64Ah.connect)($b6f500332df94b5f$var$mapStateToProps, {}, $b6f500332df94b5f$var$mergeProps)((0, $dgQ0R.default));
var $b6f500332df94b5f$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('use_queues_url_for_issue_link_on_jsm_queues', (0, $1bQGJ.withRouter)($b6f500332df94b5f$var$SummaryConnected), $b6f500332df94b5f$var$SummaryConnected);

});
parcelRegister("dgQ0R", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9af83b03a237316$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");

var $41j30 = parcelRequire("41j30");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $WFrhP = parcelRequire("WFrhP");
const $e9af83b03a237316$var$linkStyle = ()=>({
        boxShadow: 'none',
        outline: 'none'
    });
class $e9af83b03a237316$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    renderDisabled() {
        const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlock: "space.100",
            paddingInline: "space.0"
        }, value));
    }
    render() {
        const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn, issueKey: issueKey, isTableDisabled: isTableDisabled }, match: match } = this.props;
        // hardcode the url in href below after use_queues_url_for_issue_link_on_jsm_queues cleanup
        // as match will always exist after
        const queuesPathWithIssueKey = match ? `${match.url}/${issueKey}` : `/browse/${issueKey}`;
        if (isTableDisabled) return this.renderDisabled();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WFrhP.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9af83b03a237316$var$Container, {
            isFocused: this.state.isFocused
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $e9af83b03a237316$var$linkStyle(),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            href: (0, $4R6GH.fg)('use_queues_url_for_issue_link_on_jsm_queues') ? queuesPathWithIssueKey : `/browse/${issueKey}`,
            onClick: this.onClick,
            onAuxClick: this.onAuxClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issue-link",
            'data-issue-key': issueKey
        }, value)));
    }
    constructor(...args){
        super(...args), this.state = {
            isFocused: false
        }, this.onFocus = ()=>{
            this.setState({
                isFocused: true
            });
        }, this.onBlur = ()=>{
            this.setState({
                isFocused: false
            });
        }, this.onClick = (event, analyticsEvent)=>{
            const { onIssueViewTransition: onIssueViewTransition } = this.props.tableInjectedProps;
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            onIssueViewTransition?.(event);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        }, this.onAuxClick = ()=>{
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9af83b03a237316$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _12ji1r31 _1qu2glyw _12y31o36 _189eyh40 _1dqonqa1 _ca0qu2gc _u5f312x7 _n3tdu2gc _19bv12x7 _1bsb1wug _16qsglyw",
            __cmplp.isFocused ? "_1h6d194a" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2oRcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd94d2dce469b45$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4cd94d2dce469b45$var$WorkCategory = (props)=>{
    const { dataSelectorProps: { value: value } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, value);
};
var $4cd94d2dce469b45$export$2e2bcd8739ae039 = $4cd94d2dce469b45$var$WorkCategory;

});

parcelRegister("eJplt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd28373a8d66f404$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lj8SI = parcelRequire("lj8SI");

var $dCm1o = parcelRequire("dCm1o");

var $85IQg = parcelRequire("85IQg");
const $cd28373a8d66f404$var$statusCategoryToAppearanceMap = (statusCategory)=>{
    switch(statusCategory){
        case 'inProgress':
            return 'inprogress';
        case 'done':
            return 'success';
        default:
            return 'default';
    }
};
const $cd28373a8d66f404$var$StatusCategoryLozenge = ({ dataSelectorProps: dataSelectorProps, tableInjectedProps: tableInjectedProps })=>{
    const { value: value } = dataSelectorProps;
    const { isLastColumn: isLastColumn } = tableInjectedProps;
    if (!value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85IQg.default), {
        isLastColumn: isLastColumn
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: $cd28373a8d66f404$var$statusCategoryToAppearanceMap(value.category),
        isBold: (0, $dCm1o.isVisualRefreshEnabled)(),
        maxWidth: "192px"
    }, value.name);
};
var $cd28373a8d66f404$export$2e2bcd8739ae039 = $cd28373a8d66f404$var$StatusCategoryLozenge;

});


parcelRegister("l66N2", function(module, exports) {

$parcel$export(module.exports, "default", () => $399ac72c040162d3$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $kkJfY = parcelRequire("kkJfY");

var $17JMK = parcelRequire("17JMK");

var $jxVFn = parcelRequire("jxVFn");

var $p64Ah = parcelRequire("p64Ah");

var $eqFmJ = parcelRequire("eqFmJ");
const $399ac72c040162d3$var$getAllKnownIssueKeysFactory = ()=>(0, $dGvGJ.createSelector)((0, $jxVFn.getAllKnownIssueKeys), (res)=>res);
const $399ac72c040162d3$var$mapStateToPropsFactory = ()=>{
    const getAllKnownIssueKeysInstance = $399ac72c040162d3$var$getAllKnownIssueKeysFactory();
    return (state)=>({
            allIssueKeys: getAllKnownIssueKeysInstance(state),
            SelectedIssuesSubscriber: $17JMK.SelectedIssuesSubscriber,
            Checkbox: $kkJfY.default
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1. | TS2345 - Argument of type 'typeof CheckboxWrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$399ac72c040162d3$export$2e2bcd8739ae039 = (0, $p64Ah.connect)($399ac72c040162d3$var$mapStateToPropsFactory)((0, $eqFmJ.default));

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");


var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $3106eb14f9b0a593$var$checkboxStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $3106eb14f9b0a593$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kag1C.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hsLv2.default), null, label, isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e62YQ.default), null)));
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5"
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $7b368d644c230660$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $7b368d644c230660$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $7b368d644c230660$var$disabledStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $7b368d644c230660$var$labelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- This rule still fails because of the TS assertion
        className: xcss,
        css: [
            $7b368d644c230660$var$baseStyles,
            label && $7b368d644c230660$var$textLabelLayoutStyles,
            isDisabled && $7b368d644c230660$var$disabledStyles,
            $7b368d644c230660$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce636d67b4ff1120$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $ce636d67b4ff1120$var$labelTextStyles
    }, children);
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $d2156c28a3894cac$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $d2156c28a3894cac$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*"));
}

});


parcelRegister("eqFmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6b05af5f960afe$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gccSB = parcelRequire("gccSB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $5EqVR = parcelRequire("5EqVR");
// eslint-disable-next-line jira/react/no-class-components
class $3b6b05af5f960afe$var$CheckboxWrapperWithoutIntl extends (0, $5uXOq.Component) {
    static isSelected(state) {
        const { issueKeys: issueKeys } = state; // for isIndeterminate to work, we must always also set isSelected. Thus, this condition becomes very simple.
        return !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueKeys);
    }
    isIndeterminate(state) {
        const { issueKeys: issueKeys } = state;
        const { allIssueKeys: allIssueKeys } = this.props;
        return issueKeys.length !== allIssueKeys.length && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueKeys);
    }
    createOnChange(state, actions) {
        return (e, analyticsEvent)=>{
            const { issueKeys: issueKeys } = state;
            const { allIssueKeys: allIssueKeys } = this.props;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueKeys)) {
                actions.selectIssues(allIssueKeys, analyticsEvent);
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'issueTableHeaderBulkActionCheckbox', {
                    usage: 'selectAll'
                });
            } else {
                // allIssueKeys not guaranteed to contain all issueKeys
                actions.deselectAllIssues(analyticsEvent);
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'issueTableHeaderBulkActionCheckbox', {
                    usage: 'deselectAll'
                });
            }
        };
    }
    render() {
        const { SelectedIssuesSubscriber: SelectedIssuesSubscriber, Checkbox: Checkbox, intl: intl } = this.props;
        const isServerSideRendered = false && (0, $4R6GH.fg)('issuelist_ssr_fix_styling_for_header_checkbox');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectedIssuesSubscriber, null, (state, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b6b05af5f960afe$var$StyledWrapper, {
                isDisabled: isServerSideRendered ? true : state.isLocked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Checkbox, {
                "aria-label": intl.formatMessage((0, $5EqVR.default).selectAllCheckboxLabel),
                isDisabled: state.isLocked,
                isChecked: $3b6b05af5f960afe$var$CheckboxWrapperWithoutIntl.isSelected(state),
                isIndeterminate: this.isIndeterminate(state),
                onChange: this.createOnChange(state, actions)
            }), /* We render the real color of the checkbox on top of the actual checkbox
        	to hide the issue where it renders as black initially, and to make it non-interactable */ isServerSideRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "issue-table.common.fields.checkbox.header.div",
                className: (0, $bwpsq.default)([
                    $3b6b05af5f960afe$var$styles.shadowCheckboxWrapper
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    $3b6b05af5f960afe$var$styles.shadowCheckbox
                ])
            }))));
    }
}
const $3b6b05af5f960afe$export$eef12940a6696c78 = (0, $az4zD.injectIntlV2)($3b6b05af5f960afe$var$CheckboxWrapperWithoutIntl);
var $3b6b05af5f960afe$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3b6b05af5f960afe$export$eef12940a6696c78;
const $3b6b05af5f960afe$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_jmuphv": (0, $lD23V.default)(__cmplp.isDisabled ? 'not-allowed' : 'pointer')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_uiztglyw _vchhusvi _1bsb1osq _ca0qidpf _u5f3pxbi _n3tdidpf _19bvutpp _12ul13s5",
            __cmplp.className
        ])
    });
});
const $3b6b05af5f960afe$var$styles = {
    shadowCheckbox: "_kqswstnw _154i12x7 _1ltvu2gc _4t3i1crf _1bsb1crf _bfhk1j9a",
    shadowCheckboxWrapper: "_80om13gf _kqswstnw _1bsbzwfg _4t3izwfg _154iu2gc _1ltvv77o"
};

});
parcelRegister("5EqVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $92156841e71ef81d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $92156841e71ef81d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectAllCheckboxLabel: {
        "id": "issue-table.common.fields.checkbox.header.select-all-checkbox-label",
        "defaultMessage": "Select all issues"
    }
});

});



parcelRegister("gwbmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bdd2d57a90e125e$export$2e2bcd8739ae039);

var $bIL7p = parcelRequire("bIL7p");

var $p64Ah = parcelRequire("p64Ah");

var $6KqMc = parcelRequire("6KqMc");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bdd2d57a90e125e$var$mapDispatchToProps = (dispatch, { rowId: rowId })=>({
        // @ts-expect-error - TS7031 - Binding element 'isShiftKeyDown' implicitly has an 'any' type. | TS7031 - Binding element 'selection' implicitly has an 'any' type.
        onChange: ({ isShiftKeyDown: isShiftKeyDown, isSelected: selection }, analyticsEvent)=>dispatch((0, $bIL7p.selectRowAction)({
                rowId: rowId,
                isShiftKeyDown: isShiftKeyDown,
                selection: selection
            }, analyticsEvent))
    });
var $6bdd2d57a90e125e$export$2e2bcd8739ae039 = (0, $p64Ah.connect)(null, $6bdd2d57a90e125e$var$mapDispatchToProps)((0, $6KqMc.default));

});
parcelRegister("6KqMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad7a8eea0496e04a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $74ySO = parcelRequire("74ySO");

var $kkJfY = parcelRequire("kkJfY");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");


var $17JMK = parcelRequire("17JMK");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $7F2in = parcelRequire("7F2in");
const $ad7a8eea0496e04a$var$checkboxCellPaddingLeft = `${1.5 * (0, $gwIPs.gridSize)}px`;
// eslint-disable-next-line jira/react/no-class-components
class $ad7a8eea0496e04a$var$CheckboxWrapperWithoutIntl extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            Checkbox: (0, $kkJfY.default),
            SelectedIssuesSubscriber: (0, $17JMK.SelectedIssuesSubscriber)
        };
    }
    createOnChange({ selectedIssueKeys: selectedIssueKeys }) {
        return (event, analyticsEvent)=>{
            const { onChange: onChange, rowId: rowId } = this.props; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const isShiftKeyDown = event.nativeEvent.shiftKey;
            onChange({
                isSelected: !(0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(selectedIssueKeys, (0, $g5X3G.toIssueKey)(rowId)),
                isShiftKeyDown: isShiftKeyDown
            }, analyticsEvent);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'issueTableBulkActionCheckbox');
        };
    }
    render() {
        const { SelectedIssuesSubscriber: SelectedIssuesSubscriber, rowId: rowId, Checkbox: Checkbox, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectedIssuesSubscriber, null, ({ issueKeys: issueKeys, limit: limit, isLocked: isLocked })=>{
            const issueKey = (0, $g5X3G.toIssueKey)(rowId);
            const isChecked = (0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(issueKeys, issueKey);
            // In the SSR'd doc the checkbox should be disabled to select but with
            // enabled styling.
            if (false && (0, $4R6GH.fg)('issuelist_ssr_disable_issue_selection')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad7a8eea0496e04a$var$StyledWrapper, {
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Checkbox, {
                isChecked: false
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: intl.formatMessage((0, $7F2in.default).maximumReached, {
                    limit: (0, $9074633c7c24dd04$export$81a88ed305997a6d)
                }),
                delay: 0,
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad7a8eea0496e04a$var$TooltipHolder, null)));
            if (isLocked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad7a8eea0496e04a$var$StyledWrapper, {
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Checkbox, {
                isDisabled: true,
                isChecked: isChecked
            }));
            const isDisabled = !isChecked && issueKeys.length >= limit;
            return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad7a8eea0496e04a$var$StyledWrapper, {
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Checkbox, {
                isDisabled: true,
                isChecked: isChecked
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: intl.formatMessage((0, $7F2in.default).maximumReached, {
                    limit: (0, $9074633c7c24dd04$export$81a88ed305997a6d)
                }),
                delay: 0,
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad7a8eea0496e04a$var$TooltipHolder, null))) : // @ts-expect-error - TS2741 - Property 'isDisabled' is missing in type '{ children: Element; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { isDisabled: boolean; }, any>>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad7a8eea0496e04a$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Checkbox, {
                "aria-label": intl.formatMessage((0, $7F2in.default).selectThisCheckboxLabel, {
                    issueKey: issueKey
                }),
                isChecked: isChecked,
                onChange: this.createOnChange({
                    selectedIssueKeys: issueKeys
                })
            }));
        });
    }
}
const $ad7a8eea0496e04a$export$eef12940a6696c78 = (0, $az4zD.injectIntlV2)($ad7a8eea0496e04a$var$CheckboxWrapperWithoutIntl);
var $ad7a8eea0496e04a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ad7a8eea0496e04a$export$eef12940a6696c78;
const $ad7a8eea0496e04a$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sdlsvv": (0, $lD23V.default)($ad7a8eea0496e04a$var$checkboxCellPaddingLeft),
            "--_jmuphv": (0, $lD23V.default)(__cmplp.isDisabled ? 'not-allowed' : 'pointer')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41ah3 _uiztglyw _kqswh2mm _vchhusvi _1bsb1osq _12ul13s5",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad7a8eea0496e04a$var$TooltipHolder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80om13gf _kqswstnw _154iu2gc _1ltvu2gc _1xi2u2gc _94n5u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7F2in", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70fb4709f231008$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c70fb4709f231008$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    maximumReached: {
        "id": "issue-table.common.fields.checkbox.maximum-reached",
        "defaultMessage": "Limit reached ({limit})"
    },
    selectThisCheckboxLabel: {
        "id": "issue-table.common.fields.checkbox.select-this-checkbox-label",
        "defaultMessage": "Select issue ({issueKey})"
    }
});

});



parcelRegister("cORU2", function(module, exports) {

$parcel$export(module.exports, "default", () => $28372c7e08e55d36$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $lFJsG = parcelRequire("lFJsG");

var $p64Ah = parcelRequire("p64Ah");

var $2WcTq = parcelRequire("2WcTq");

var $3IeoX = parcelRequire("3IeoX");
const $28372c7e08e55d36$var$mapStateToProps = (state, ownProps)=>{
    const { columnId: columnId } = ownProps;
    const onSortOrderChange = (0, $lFJsG.getOnSortOrderChanged)(state, columnId);
    const sortOrder = (0, $lFJsG.getCurrentSorting)(state, columnId);
    let isSortable = false;
    if (onSortOrderChange) isSortable = true;
    return {
        columnName: (0, $lFJsG.maybeColumnTitle)(state, columnId).orSome(''),
        fieldType: (0, $lFJsG.getFieldType)(state, columnId),
        sortOrder: sortOrder,
        isDisabled: (0, $lFJsG.isDisabled)(state, columnId) && sortOrder,
        onSortOrderChange: onSortOrderChange,
        isSortable: isSortable
    };
};
var $28372c7e08e55d36$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onSortOrderChange: (fieldId, sortOrder)=>({
            name: 'sortOrderChange',
            fieldId: fieldId,
            sortOrder: sortOrder
        })
}), (0, $2WcTq.ReduxAnalyticsData)((state, ownProps)=>({
        attributes: {
            fieldId: (0, $lFJsG.getFieldType)(state, ownProps.columnId)
        }
    })), // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1.
(0, $p64Ah.connect)($28372c7e08e55d36$var$mapStateToProps))((0, $3IeoX.default));

});
parcelRegister("lFJsG", function(module, exports) {

$parcel$export(module.exports, "getColumns", () => $5123eb259ea2e265$export$978e30a0fb8610d8);
$parcel$export(module.exports, "maybeColumnTitle", () => $5123eb259ea2e265$export$7929a97abf07197e);
$parcel$export(module.exports, "getColumnTitle", () => $5123eb259ea2e265$export$7fd4bf39bc1fa7d6);
$parcel$export(module.exports, "getCurrentSorting", () => $5123eb259ea2e265$export$d31773bdd38d8c2c);
$parcel$export(module.exports, "isDisabled", () => $5123eb259ea2e265$export$30e0dc115df457ed);
$parcel$export(module.exports, "getFieldType", () => $5123eb259ea2e265$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "getOnSortOrderChanged", () => $5123eb259ea2e265$export$7d6c76fc2d097cc2);
$parcel$export(module.exports, "isLastColumn", () => $5123eb259ea2e265$export$e509b4c22370e953);
$parcel$export(module.exports, "isColumnKnown", () => $5123eb259ea2e265$export$265a5752f4c87727);

var $dGvGJ = parcelRequire("dGvGJ");

var $1sWm7 = parcelRequire("1sWm7");

var $8KhWn = parcelRequire("8KhWn");

var $37Hsj = parcelRequire("37Hsj");
const $5123eb259ea2e265$export$978e30a0fb8610d8 = (state)=>(0, $37Hsj.getPersisted)(state).columns;
const $5123eb259ea2e265$export$46d040b9076e32ab = (state, columnId)=>(0, $8KhWn.Maybe).fromNull((0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))($5123eb259ea2e265$export$978e30a0fb8610d8(state), {
        id: columnId
    }));
const $5123eb259ea2e265$export$7929a97abf07197e = (state, columnId)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    $5123eb259ea2e265$export$46d040b9076e32ab(state, columnId).map((column)=>column.title);
const $5123eb259ea2e265$export$7fd4bf39bc1fa7d6 = (state, columnId)=>$5123eb259ea2e265$export$7929a97abf07197e(state, columnId).orSome('');
const $5123eb259ea2e265$export$d31773bdd38d8c2c = (state, columnId)=>$5123eb259ea2e265$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .flatMap((column)=>(0, $8KhWn.Maybe).fromNull(column.currentSorting)).cata(()=>undefined, // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
    (order)=>order);
const $5123eb259ea2e265$export$30e0dc115df457ed = (state, columnId)=>$5123eb259ea2e265$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .flatMap((column)=>(0, $8KhWn.Maybe).fromNull(column.isDisabled)).cata(()=>false, // @ts-expect-error - TS7006 - Parameter 'disabled' implicitly has an 'any' type.
    (disabled)=>disabled);
const $5123eb259ea2e265$export$b9089a6e41ed43aa = (state, columnId)=>$5123eb259ea2e265$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .map((column)=>column.fieldType).orSome('');
const $5123eb259ea2e265$export$932a39ca74873b9d = (state, columnId)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    $5123eb259ea2e265$export$46d040b9076e32ab(state, columnId).flatMap((column)=>(0, $8KhWn.Maybe).fromNull(column.onSortOrderChanged));
const $5123eb259ea2e265$export$7d6c76fc2d097cc2 = (state, columnId)=>$5123eb259ea2e265$export$932a39ca74873b9d(state, columnId).cata(()=>undefined, // @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
    (callback)=>callback);
const $5123eb259ea2e265$export$e509b4c22370e953 = (state, columnId)=>{
    const columns = $5123eb259ea2e265$export$978e30a0fb8610d8(state);
    return columns.length > 0 && columns[columns.length - 1].id === columnId;
};
const $5123eb259ea2e265$var$indexColumnIds = (0, $dGvGJ.createSelector)($5123eb259ea2e265$export$978e30a0fb8610d8, (columns)=>new Set(columns.map((column)=>column.id)));
const $5123eb259ea2e265$export$265a5752f4c87727 = (state, columnId)=>$5123eb259ea2e265$var$indexColumnIds(state).has(columnId);

});

parcelRegister("2WcTq", function(module, exports) {

$parcel$export(module.exports, "ReduxAnalyticsData", () => $d6d04f5ebb25849c$export$eb16d2484452fbaa);

var $8lxl7 = parcelRequire("8lxl7");

var $p64Ah = parcelRequire("p64Ah");
const $d6d04f5ebb25849c$export$eb16d2484452fbaa = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, { storeKey: storeKey, ...restConnectOptions } = {})=>(0, $8lxl7.default)(mapStateToAnalytics, {
        ...restConnectOptions,
        context: (0, $p64Ah.IssueTableContext)
    });

});

parcelRegister("3IeoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2632e63ae2c4c37$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");


var $gwIPs = parcelRequire("gwIPs");

var $az4zD = parcelRequire("az4zD");

var $hcRNM = parcelRequire("hcRNM");


var $3bHym = parcelRequire("3bHym");

var $6kB8K = parcelRequire("6kB8K");
const $d2632e63ae2c4c37$var$ascendingGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.7 16.7v-5.6l-1.3 1.3c-.4.4-1 .4-1.4 0-.2-.2-.3-.5-.3-.7 0-.3.1-.5.3-.7l3-3c.2-.2.5-.3.7-.3.3 0 .5.1.7.3l3 3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-1.3-1.3v5.6c0 .6-.5 1-1 1s-1-.5-1-1z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
    }));
const $d2632e63ae2c4c37$var$descendingGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.7 8.7v5.6L14 13c.4-.4 1-.4 1.4 0 .2.2.3.5.3.7 0 .3-.1.5-.3.7l-3 3c-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.3 1.3V8.7c0-.6.4-1 1-1s1 .4 1 1z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
    }));
class $d2632e63ae2c4c37$export$99f5cf69b7ccb3ed extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDefaultSortOrder: false,
            allowClearingSort: false,
            sortOrder: (0, $ff4189e925fd251d$export$c53d0f541b41b88e),
            width: undefined,
            onSortOrderChange: undefined
        };
    }
    onKeyDownCapture(event) {
        if (event.key === 'Enter') event.stopPropagation();
    }
    getTooltipText(columnName) {
        if (typeof columnName === 'string') return `${columnName} \u{2022} ${this.getSortOrderTooltipText()}`;
        return this.getSortOrderTooltipText();
    }
    getSortOrderTooltipText() {
        switch(this.props.sortOrder){
            case 0, $ff4189e925fd251d$export$c53d0f541b41b88e:
                return this.getNoOrderTooltipText();
            case 0, $ff4189e925fd251d$export$1dee026a19752d6b:
                return this.getAscOrderTooltipText();
            case 0, $ff4189e925fd251d$export$b6abcf7fa1d94f65:
                return this.getDescOrderTooltipText();
            default:
                return 'Invalid state';
        }
    }
    getNoOrderTooltipText() {
        const { fieldType: fieldType, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $hcRNM.default)[fieldType];
        if (fieldConfigs && fieldConfigs.ascText) return format((0, $3bHym.default).sortOrder, {
            sortOrder: format(fieldConfigs.ascText)
        });
        return format((0, $3bHym.default).defaultSortOrder, {
            isAscending: true
        });
    }
    getAscOrderTooltipText() {
        const { fieldType: fieldType, isDefaultSortOrder: isDefaultSortOrder, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $hcRNM.default)[fieldType];
        if (fieldConfigs && fieldConfigs.ascText) return format((0, $3bHym.default).sortedOrder, {
            sortOrder: format(fieldConfigs.ascText),
            isDefault: isDefaultSortOrder
        });
        return format((0, $3bHym.default).defaultSortedOrder, {
            isAscending: true,
            isDefault: isDefaultSortOrder
        });
    }
    getDescOrderTooltipText() {
        const { fieldType: fieldType, isDefaultSortOrder: isDefaultSortOrder, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $hcRNM.default)[fieldType];
        if (fieldConfigs && fieldConfigs.descText) return format((0, $3bHym.default).sortedOrder, {
            sortOrder: format(fieldConfigs.descText),
            isDefault: isDefaultSortOrder
        });
        return format((0, $3bHym.default).defaultSortedOrder, {
            isAscending: false,
            isDefault: isDefaultSortOrder
        });
    }
    getNextSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $ff4189e925fd251d$export$c53d0f541b41b88e:
                return 0, $ff4189e925fd251d$export$1dee026a19752d6b;
            case 0, $ff4189e925fd251d$export$1dee026a19752d6b:
                return 0, $ff4189e925fd251d$export$b6abcf7fa1d94f65;
            case 0, $ff4189e925fd251d$export$b6abcf7fa1d94f65:
            default:
                return this.props.allowClearingSort ? (0, $ff4189e925fd251d$export$c53d0f541b41b88e) : (0, $ff4189e925fd251d$export$1dee026a19752d6b);
        }
    }
    getHeaderIcon() {
        switch(this.props.sortOrder){
            case 0, $ff4189e925fd251d$export$1dee026a19752d6b:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                    glyph: $d2632e63ae2c4c37$var$ascendingGlyph,
                    label: "Ascending icon",
                    size: "medium"
                });
            case 0, $ff4189e925fd251d$export$b6abcf7fa1d94f65:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                    glyph: $d2632e63ae2c4c37$var$descendingGlyph,
                    label: "Descending icon",
                    size: "medium"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                    glyph: $d2632e63ae2c4c37$var$ascendingGlyph,
                    label: "Sort-by icon",
                    size: "medium",
                    primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N60})`
                });
        }
    }
    getButtonWithTooltip() {
        const { columnName: columnName, sortOrder: sortOrder, width: width, isDisabled: isDisabled } = this.props;
        const buttonAppearance = sortOrder === (0, $ff4189e925fd251d$export$c53d0f541b41b88e) ? 'subtle' : 'default';
        const isHeaderSelected = sortOrder !== (0, $ff4189e925fd251d$export$c53d0f541b41b88e);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6kB8K.default), {
            isSortOrderChanged: this.state.sortOrderChanged,
            tooltipText: this.getTooltipText(columnName),
            onShow: this.onSortOrderTooltipShow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            onClick: this.onSortOrderChange,
            spacing: "none",
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2632e63ae2c4c37$var$HeaderContent, {
            hasIcon: isHeaderSelected,
            hasFixedWidth: !!width
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2632e63ae2c4c37$var$HeaderText, {
            hasIcon: isHeaderSelected,
            maxWidth: width
        }, columnName), /* The icon must be part of the tooltip target, so we can't use the
                               `iconAfter` prop of the atlaskit button */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2632e63ae2c4c37$var$IconWrapper, {
            isVisible: isHeaderSelected
        }, this.getHeaderIcon()))));
    }
    render() {
        const { isSortable: isSortable, columnName: columnName, width: width, isDisabled: isDisabled } = this.props;
        if (isSortable || isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2632e63ae2c4c37$var$HeaderWrapperExperiment, {
            onKeyDownCapture: this.onKeyDownCapture,
            "data-component-selector": "header-wrapper-experiment-component-selector"
        }, this.getButtonWithTooltip());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2632e63ae2c4c37$var$PlainHeader, {
            maxWidth: width
        }, columnName);
    }
    constructor(...args){
        super(...args), this.state = {
            sortOrderChanged: false
        }, this.onSortOrderChange = (e, analyticsEvent)=>{
            const { onSortOrderChange: onSortOrderChange, sortOrder: sortOrder, columnId: columnId } = this.props;
            const nextSortOrder = this.getNextSortOrder(sortOrder);
            onSortOrderChange && onSortOrderChange(columnId, nextSortOrder, analyticsEvent);
            this.setState({
                sortOrderChanged: true
            });
        }, this.onSortOrderTooltipShow = ()=>{
            this.setState({
                sortOrderChanged: false
            });
        };
    }
}
var $d2632e63ae2c4c37$export$2e2bcd8739ae039 /* Icon also appears under these pseudo-classes */  = (0, $az4zD.injectIntlV2)($d2632e63ae2c4c37$export$99f5cf69b7ccb3ed);
const $d2632e63ae2c4c37$var$addWhenInteracted = 'button:focus &, [data-component-selector="header-wrapper-experiment-component-selector"]:hover &'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2632e63ae2c4c37$var$HeaderWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _z29h64oc _1m1b1r31 _lt2an7od _1twe1o36 _1s3gn7od",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2632e63ae2c4c37$var$HeaderContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasFixedWidth: hasFixedWidth, hasIcon: hasIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t94dt9": (0, $lD23V.default)(`${"var(--ds-space-0, 0px)"} ${__cmplp.hasFixedWidth || __cmplp.hasIcon ? "var(--ds-space-0, 0px)" : "var(--ds-space-300, 24px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41d6p _vchhusvi _1e0c1txw _y3gn1e5h _1v7oze3t _3myyze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2632e63ae2c4c37$var$HeaderText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, hasIcon: hasIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_e2mome": (0, $lD23V.default)(__cmplp.maxWidth - (0, $gwIPs.gridSize) * (__cmplp.hasIcon ? 5 : 2), "px"),
            "--_uyt2xi": (0, $lD23V.default)(__cmplp.maxWidth - (0, $gwIPs.gridSize) * 5, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _4t3i1tcg _o5721q9c _1bto1l2s",
            __cmplp.maxWidth && "_p12f1388",
            __cmplp.maxWidth && "_1i461gch _123n1gch",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2632e63ae2c4c37$var$PlainHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz1gjq _1e0c1txw _4cvr1h6o _4t3i1tcg _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc _o5721q9c _1bto1l2s",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2632e63ae2c4c37$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16q71kw7 _1dhe1kw7",
            __cmplp.isVisible ? "_1e0c1kw7" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hcRNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd9e77ece4d7ba06$export$2e2bcd8739ae039);

var $lizCH = parcelRequire("lizCH");
// Map system field ids and custom field types to their configurations: max width, min width, asc text, desc text, etc.
const $fd9e77ece4d7ba06$var$fieldConfigurationsMap = {
    assignee: {
        ascText: (0, $lizCH.default).aToZOrder,
        descText: (0, $lizCH.default).zToAOrder
    },
    reporterWithIcon: {
        ascText: (0, $lizCH.default).aToZOrder,
        descText: (0, $lizCH.default).zToAOrder
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        ascText: (0, $lizCH.default).shortestToLongestOrder,
        descText: (0, $lizCH.default).longestToShortestOrder
    },
    components: {
        ascText: (0, $lizCH.default).aToZOrder,
        descText: (0, $lizCH.default).zToAOrder
    },
    created: {
        ascText: (0, $lizCH.default).oldestToNewestOrder,
        descText: (0, $lizCH.default).newestToOldestOrder
    },
    issuekey: {
        ascText: (0, $lizCH.default).aToZOrder,
        descText: (0, $lizCH.default).zToAOrder
    },
    issuetype: {
        ascText: (0, $lizCH.default).aToZOrder,
        descText: (0, $lizCH.default).zToAOrder
    },
    reporter: {
        ascText: (0, $lizCH.default).aToZOrder,
        descText: (0, $lizCH.default).zToAOrder
    },
    summary: {
        ascText: (0, $lizCH.default).aToZOrder,
        descText: (0, $lizCH.default).zToAOrder
    },
    updated: {
        ascText: (0, $lizCH.default).oldestToNewestOrder,
        descText: (0, $lizCH.default).newestToOldestOrder
    },
    date: {
        ascText: (0, $lizCH.default).oldestToNewestOrder,
        descText: (0, $lizCH.default).newestToOldestOrder
    }
};
var $fd9e77ece4d7ba06$export$2e2bcd8739ae039 = $fd9e77ece4d7ba06$var$fieldConfigurationsMap;

});
parcelRegister("lizCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $425a3a8d4ebec5a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $425a3a8d4ebec5a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    aToZOrder: {
        "id": "issue-table.model.fields.field-configurations-map.a-to-z-order",
        "defaultMessage": "A \u2192 Z"
    },
    zToAOrder: {
        "id": "issue-table.model.fields.field-configurations-map.z-to-a-order",
        "defaultMessage": "Z \u2192 A"
    },
    oldestToNewestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.oldest-to-newest-order",
        "defaultMessage": "oldest \u2192 newest"
    },
    newestToOldestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.newest-to-oldest-order",
        "defaultMessage": "newest \u2192 oldest"
    },
    shortestToLongestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.shortest-to-longest-order",
        "defaultMessage": "shortest \u2192 longest"
    },
    longestToShortestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.longest-to-shortest-order",
        "defaultMessage": "longest \u2192 shortest"
    },
    lowestToHighestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.lowest-to-highest-order",
        "defaultMessage": "lowest \u2192 highest"
    },
    highestToLowestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.highest-to-lowest-order",
        "defaultMessage": "highest \u2192 lowest"
    }
});

});


parcelRegister("3bHym", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f1827ca1be4555$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93f1827ca1be4555$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sortedOrder: {
        "id": "issue-table.common.sort-column-header.sorted-order",
        "defaultMessage": "Sorted {sortOrder} {isDefault, select, \n                true {(Default)}\n                other {}\n            }"
    },
    sortOrder: {
        "id": "issue-table.common.sort-column-header.sort-order",
        "defaultMessage": "Sort {sortOrder}"
    },
    defaultSortedOrder: {
        "id": "issue-table.common.sort-column-header.default-sorted-order",
        "defaultMessage": "Sorted in {isAscending, select, \n                true {ascending} \n                other {descending}\n            } order {isDefault, select, \n                true {(Default)}\n                other {}\n            }"
    },
    defaultSortOrder: {
        "id": "issue-table.common.sort-column-header.default-sort-order",
        "defaultMessage": "Sort in {isAscending, select, \n                true {ascending} \n                other {descending}\n            } order"
    }
});

});

parcelRegister("6kB8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $0979b9b511230b94$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");
const $0979b9b511230b94$var$SORT_ORDER_CHANGED_TOOLTIP_DELAY = 0;
const $0979b9b511230b94$var$TOOLTIP_DELAY = 1000;
const $0979b9b511230b94$var$TOOLTIP_POSITION = 'top';
class $0979b9b511230b94$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(nextProps, state) {
        if (nextProps.isSortOrderChanged) return {
            // force re-rendering the tooltip component to let the new delay value take into effect
            tooltipComponentKey: state.tooltipComponentKey + 1
        };
        return null;
    }
    render() {
        const { isSortOrderChanged: isSortOrderChanged, tooltipText: tooltipText, children: children } = this.props;
        const delay = isSortOrderChanged ? $0979b9b511230b94$var$SORT_ORDER_CHANGED_TOOLTIP_DELAY : $0979b9b511230b94$var$TOOLTIP_DELAY;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            delay: delay,
            position: $0979b9b511230b94$var$TOOLTIP_POSITION,
            content: tooltipText,
            onShow: this.onShow,
            key: this.state.tooltipComponentKey
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipComponentKey: 0
        }, this.onShow = ()=>{
            this.props.onShow && this.props.onShow();
        };
    }
}

});






parcelRegister("iNIX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c531f5b84257ef$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $3z4fu = parcelRequire("3z4fu");

var $MQJDY = parcelRequire("MQJDY");
var // @ts-expect-error - No overload matches this call
$07c531f5b84257ef$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $MQJDY.default), (0, $3z4fu.default));

});
parcelRegister("3z4fu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5956f020a5f45572$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $gnnyx = parcelRequire("gnnyx");
var $5956f020a5f45572$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $gnnyx.default));

});
parcelRegister("gnnyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65dcc6d0b26d409a$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $hfiJN = parcelRequire("hfiJN");

var $gtrZ5 = parcelRequire("gtrZ5");

var $aKuC7 = parcelRequire("aKuC7");

var $iQFwo = parcelRequire("iQFwo");
let $65dcc6d0b26d409a$var$cachedAssigneeInitializationResponse;
const $65dcc6d0b26d409a$export$6e5dca841bdf93e3 = ()=>{
    $65dcc6d0b26d409a$var$cachedAssigneeInitializationResponse = undefined;
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$65dcc6d0b26d409a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $gtrZ5.INITIALIZE_COLUMN)).filter((action)=>action.payload.column.fieldType === 'assignee').switchMap(()=>{
        if ((0, $iQFwo.isTableDisabled)(store.getState())) return (0, $kVLXA.Observable).empty();
        if ($65dcc6d0b26d409a$var$cachedAssigneeInitializationResponse) return (0, $kVLXA.Observable).of((0, $aKuC7.setAssigneeInitializationStateAction)($65dcc6d0b26d409a$var$cachedAssigneeInitializationResponse));
        return (0, $hfiJN.default)().mergeMap((response)=>{
            $65dcc6d0b26d409a$var$cachedAssigneeInitializationResponse = response;
            return (0, $kVLXA.Observable).of((0, $aKuC7.setAssigneeInitializationStateAction)(response));
        }).catch((error)=>{
            (0, $dJl1T.default).safeWarnWithoutCustomerData('issue-table.ops.field.initialize.assignee', `Failed to initialize assignee. Received status code ${error.statusCode}`);
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("hfiJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b68a67c46814351$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $dKbB4 = parcelRequire("dKbB4");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b68a67c46814351$export$2e2bcd8739ae039 = ()=>(0, $dKbB4.getCurrentUser$)().mergeMap((response)=>(0, $kVLXA.Observable).of({
            avatarUrl: response.avatarUrls['48x48'],
            displayName: response.displayName,
            emailAddress: response.emailAddress
        }));

});
parcelRegister("dKbB4", function(module, exports) {

$parcel$export(module.exports, "getCurrentUser$", () => $695ce2f4370bdf5a$export$87b9ee5a2e330d07);

var $487fd = parcelRequire("487fd");
const $695ce2f4370bdf5a$export$87b9ee5a2e330d07 = ()=>(0, $487fd.default)('/rest/api/3/myself', {
        method: 'GET'
    });

});




parcelRegister("MQJDY", function(module, exports) {

$parcel$export(module.exports, "default", () => $03de0a94b486298a$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $9Ga5e = parcelRequire("9Ga5e");

var $dr0zU = parcelRequire("dr0zU");
var $03de0a94b486298a$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $dr0zU.default), (0, $9Ga5e.default));

});
parcelRegister("9Ga5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $da6f4884879c74c5$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $kgxrD = parcelRequire("kgxrD");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$da6f4884879c74c5$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $kgxrD.FIELD_UPDATE_FAILURE)).switchMap((action)=>{
        const { fieldType: fieldType, failureReason: failureReason } = action.payload;
        if (failureReason.type === (0, $kgxrD.ERROR_RESPONSE)) {
            const { statusCode: statusCode } = failureReason;
            (0, $jcw0u.default)({
                meta: {
                    id: 'opsFieldUpdate',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    message: 'Error response from server attempting to update field value',
                    statusCode: statusCode,
                    fieldType: fieldType
                }
            });
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue-table.ops.field.update', `[FD-3358] Error response from server attempting to update field value. statusCode: [${statusCode}], fieldType: [${fieldType}]`);
        } else {
            (0, $jcw0u.default)({
                meta: {
                    id: 'opsFieldUpdate',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    message: 'Unknown error attempting to update field value.',
                    fieldType: fieldType
                }
            });
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue-table.ops.field.update', `[FD-3358] Unknown error attempting to update field value. fieldType: [${fieldType}]`);
        }
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("dr0zU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c29baa63a5144b3$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $bwmNE = parcelRequire("bwmNE");

var $kgxrD = parcelRequire("kgxrD");

var $lFJsG = parcelRequire("lFJsG");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$3c29baa63a5144b3$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $kgxrD.FIELD_UPDATE_SUBMIT)).switchMap((action)=>{
        const state = store.getState();
        const { issueKey: issueKey, fieldId: fieldId, fieldValue: fieldValue, onSuccess: onSuccess, onFailure: onFailure } = action.payload;
        return (0, $bwmNE.updateFieldValue$)(issueKey, fieldId, fieldValue).mergeMap(()=>{
            onSuccess(fieldValue);
            return (0, $kVLXA.Observable).of((0, $kgxrD.updateFieldSuccessAction)(issueKey, fieldId));
        }).catch((error)=>{
            onFailure();
            return (0, $kVLXA.Observable).of((0, $kgxrD.updateFieldFailureErrorResponseAction)(issueKey, fieldId, fieldValue.fieldType, (0, $lFJsG.getColumnTitle)(state, fieldId), error));
        });
    });

});



parcelRegister("evCa2", function(module, exports) {

$parcel$export(module.exports, "default", () => $37879251f0139cc6$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $1n4e5 = parcelRequire("1n4e5");
var $37879251f0139cc6$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $1n4e5.default));

});
parcelRegister("1n4e5", function(module, exports) {

$parcel$export(module.exports, "default", () => $791daf8e8138f604$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $7NCXO = parcelRequire("7NCXO");

var $kMqdJ = parcelRequire("kMqdJ");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$791daf8e8138f604$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $7NCXO.ISSUE_EDIT_STARTED)).switchMap((action)=>{
        const { fieldType: fieldType, issueKey: issueKey } = action.payload;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const state = store.getState();
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'tableRow locked', {
            fieldType: fieldType,
            lockedIssuesCount: (0, $kMqdJ.getLockedIssueCountAssumingIssueKeyWillBeLocked)(state, issueKey)
        });
        return (0, $kVLXA.Observable).empty();
    });

});


parcelRegister("l7LqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $81e1c9789e422309$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $hZa3i = parcelRequire("hZa3i");
var $81e1c9789e422309$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $hZa3i.default));

});
parcelRegister("hZa3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1695878ca461ac2$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");


var $ixRuS = parcelRequire("ixRuS");

var $45OTQ = parcelRequire("45OTQ");

var $iQFwo = parcelRequire("iQFwo");
const $a1695878ca461ac2$export$3869e16e736a9111 = (prevShowPagination, offsetFromBottom, totalPages)=>{
    if (totalPages > 1) return(// If pagination is already shown but the table has not been scrolled back up enough
    prevShowPagination && offsetFromBottom < (0, $0750463259e12908$export$ad4eb70d85e8e21f) || // Or, if no pagination is shown and table has been scrolled to the bottom
    !prevShowPagination && offsetFromBottom === 0);
    return false;
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$a1695878ca461ac2$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $ixRuS.UPDATE_VERTICAL_OFFSET)).switchMap((action)=>{
        const { totalPages: totalPages, verticalPosition: verticalPosition, onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged } = action.payload;
        const showPagination = (0, $iQFwo.shouldShowPagination)(store.getState());
        const { offsetFromTop: offsetFromTop, offsetFromBottom: offsetFromBottom } = verticalPosition;
        const nextShowPagination = $a1695878ca461ac2$export$3869e16e736a9111(showPagination, offsetFromBottom, totalPages);
        onVerticalScrollOffsetChanged && onVerticalScrollOffsetChanged(verticalPosition);
        // @ts-expect-error - TS2304 - Cannot find name 'SetVerticalOffsetAction'. | TS2304 - Cannot find name 'SetPaginationVisibilityAction'.
        const actions = [];
        if (nextShowPagination !== showPagination) actions.push((0, $45OTQ.setPaginationVisibility)(nextShowPagination));
        actions.push((0, $ixRuS.setVerticalOffsetAction)(offsetFromTop));
        return (0, $kVLXA.Observable).of(...actions);
    });

});



parcelRegister("fLxJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e373df65e4dae3dc$export$2e2bcd8739ae039);

var $ixRuS = parcelRequire("ixRuS");

var $lFJsG = parcelRequire("lFJsG");

var $jxVFn = parcelRequire("jxVFn");

var $bVGNK = parcelRequire("bVGNK");

var $iQFwo = parcelRequire("iQFwo");

var $p64Ah = parcelRequire("p64Ah");

var $glHUJ = parcelRequire("glHUJ");

var $5erZD = parcelRequire("5erZD");

var $6Zno6 = parcelRequire("6Zno6");
const $e373df65e4dae3dc$var$mapStateToProps = (state)=>({
        Table: $5erZD.default,
        columns: (0, $lFJsG.getColumns)(state),
        Pagination: $glHUJ.default,
        showPagination: (0, $iQFwo.shouldShowPagination)(state),
        editingFieldHorizontalOffset: (0, $iQFwo.getEditingFieldHorizontalOffset)(state),
        editingFieldVerticalOffset: (0, $iQFwo.getEditingFieldVerticalOffset)(state),
        editingFieldWidth: (0, $iQFwo.getEditingFieldWidth)(state),
        horizontalScrollOffset: (0, $bVGNK.getHorizontalScrollOffset)(state),
        verticalScrollOffset: (0, $bVGNK.getVerticalScrollOffset)(state),
        tableWidth: (0, $iQFwo.getTableWidth)(state),
        tableHeight: (0, $iQFwo.getTableHeight)(state),
        loadedIssueKeys: (0, $jxVFn.mergeIssueKeysWithLockedIssues)(state)
    });
const $e373df65e4dae3dc$var$mapDispatchToProps = {
    onUpdateHorizontalScrollOffset: (offset)=>(0, $ixRuS.setHorizontalOffsetAction)(offset.offsetFromLeft),
    onUpdateVerticalScrollOffset: (0, $ixRuS.updateVerticalOffsetAction)
};
// @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'ComponentType<PropsWithDefaults>'. | TS2554 - Expected 3-4 arguments, but got 2.
const $e373df65e4dae3dc$var$ConnectedIssueTable = (0, $p64Ah.connect)($e373df65e4dae3dc$var$mapStateToProps, $e373df65e4dae3dc$var$mapDispatchToProps)((0, $6Zno6.default));
var $e373df65e4dae3dc$export$2e2bcd8739ae039 = $e373df65e4dae3dc$var$ConnectedIssueTable;

});
parcelRegister("bVGNK", function(module, exports) {

$parcel$export(module.exports, "getHorizontalScrollOffset", () => $c4dae182d4cc27f5$export$624a30c8322e672b);
$parcel$export(module.exports, "getVerticalScrollOffset", () => $c4dae182d4cc27f5$export$76e51b2d87e066ab);

var $37Hsj = parcelRequire("37Hsj");
const $c4dae182d4cc27f5$export$6db1911eee044119 = (state)=>(0, $37Hsj.getPersisted)(state).offsets;
const $c4dae182d4cc27f5$export$624a30c8322e672b = (state)=>$c4dae182d4cc27f5$export$6db1911eee044119(state).horizontalScrollOffset;
const $c4dae182d4cc27f5$export$76e51b2d87e066ab = (state)=>$c4dae182d4cc27f5$export$6db1911eee044119(state).verticalScrollOffset;

});

parcelRegister("glHUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd1ff584536ee0d7$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $aE7Gm = parcelRequire("aE7Gm");

var $9yR5t = parcelRequire("9yR5t");
var $cd1ff584536ee0d7$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(()=>({
        Pagination: (0, $aE7Gm.default)
    }), {})((0, $9yR5t.default));

});
parcelRegister("aE7Gm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f494729c3201db27$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $f494729c3201db27$var$LazyPagination = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6FOi7")), {
    moduleId: "../platform/packages/design-system/pagination/src/index.tsx"
});
const $f494729c3201db27$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-issue-table-pagination",
        packageName: "issueTable",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-issue-table-pagination",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f494729c3201db27$var$LoadingComponent, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f494729c3201db27$var$LazyPagination, props)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f494729c3201db27$var$LoadingComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3izwfg _1bsb19bv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6FOi7", function(module, exports) {

let $4dbd9537235af155$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4dbd9537235af155$var$load("8WQPn").then(()=>parcelRequire('6ISO0'));

});


parcelRegister("9yR5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4d6565c420b9e8d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iASWI = parcelRequire("iASWI");

var $az4zD = parcelRequire("az4zD");

var $eP1O7 = parcelRequire("eP1O7");
function $f4d6565c420b9e8d$var$PaginationComponent(props) {
    const { currentPage: currentPage, totalPages: totalPages, Pagination: Pagination, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4d6565c420b9e8d$export$b14e02386c6038ac, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4d6565c420b9e8d$export$8c3f8ac08a926abc, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Pagination, {
        selectedIndex: currentPage - 1,
        onChange: props.onPageChange,
        i18n: {
            prev: formatMessage((0, $eP1O7.default).previousButton),
            next: formatMessage((0, $eP1O7.default).nextButton)
        },
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(1, totalPages + 1)
    })));
}
var $f4d6565c420b9e8d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = (0, $az4zD.injectIntlV2)($f4d6565c420b9e8d$var$PaginationComponent);
const $f4d6565c420b9e8d$export$b14e02386c6038ac = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _2hwx1ejb",
            __cmplp.className
        ])
    });
});
const $f4d6565c420b9e8d$export$8c3f8ac08a926abc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _n3tdu2gc _ca0qu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eP1O7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2945d27817232564$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2945d27817232564$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    previousButton: {
        "id": "issue-table.pagination.previous-button",
        "defaultMessage": "Prev"
    },
    nextButton: {
        "id": "issue-table.pagination.next-button",
        "defaultMessage": "Next"
    }
});

});



parcelRegister("5erZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb9feece281929b0$export$2e2bcd8739ae039);

var $jxVFn = parcelRequire("jxVFn");

var $2bGTB = parcelRequire("2bGTB");

var $iQFwo = parcelRequire("iQFwo");

var $p64Ah = parcelRequire("p64Ah");

var $i1iiJ = parcelRequire("i1iiJ");
const $fb9feece281929b0$var$mapStateToProps = (state)=>({
        issueKeys: (0, $jxVFn.mergeIssueKeysWithLockedIssues)(state),
        transformProps: $2bGTB.transformProps,
        renderSidebarIcon: (0, $iQFwo.getRenderSidebarIcon)(state),
        refreshSidebar: (0, $iQFwo.getRefreshSidebar)(state)
    });
// @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'ComponentType<Props>'. | TS2554 - Expected 3-4 arguments, but got 1. | TS2345 - Argument of type 'typeof Table' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
const $fb9feece281929b0$var$ConnectedIssueTable = (0, $p64Ah.connect)($fb9feece281929b0$var$mapStateToProps)((0, $i1iiJ.default));
var $fb9feece281929b0$export$2e2bcd8739ae039 = $fb9feece281929b0$var$ConnectedIssueTable;

});
parcelRegister("2bGTB", function(module, exports) {

$parcel$export(module.exports, "transformProps", () => $9b3fbfa9c8b45c48$export$7b42a0094fb00b6e);



var $k0aCV = parcelRequire("k0aCV");

var $hnPY5 = parcelRequire("hnPY5");

var $buPus = parcelRequire("buPus");
const $9b3fbfa9c8b45c48$var$transformScrollCallback = (0, $buPus.default)();
const $9b3fbfa9c8b45c48$export$7b42a0094fb00b6e = (props, createCell)=>{
    const { issueKeys: issueKeys, columns: columns, isContentStale: isContentStale, shouldSkipVirtualization: shouldSkipVirtualization, shouldHideLoadingIndicator: shouldHideLoadingIndicator, shouldRerenderRowOnHover: shouldRerenderRowOnHover, totalPages: totalPages, FieldDataSelector: FieldDataSelector, onActiveItemChanged: onActiveItemChanged, onActiveRowIdChanged: onActiveRowIdChanged, onDisplayedRowsChanged: onDisplayedRowsChanged, onTableFocusFunctionChanged: onTableFocusFunctionChanged, onTableRefChanged: onTableRefChanged, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset, selectedIssueKeys: selectedIssueKeys = [], contentKey: contentKey, ariaLabel: ariaLabel, ssrTableSize: ssrTableSize, disableRowHighlight: disableRowHighlight = false, renderSidebarIcon: renderSidebarIcon, appProps: appProps, shouldUseCssForRendering: shouldUseCssForRendering } = props;
    const { rowIds: rowIds, rowsConfiguration: rowsConfiguration } = (0, $hnPY5.default)(issueKeys, selectedIssueKeys);
    return {
        isContentStale: isContentStale,
        shouldSkipVirtualization: shouldSkipVirtualization,
        shouldHideLoadingIndicator: shouldHideLoadingIndicator,
        shouldRerenderRowOnHover: shouldRerenderRowOnHover,
        rowIds: rowIds,
        rowsConfiguration: rowsConfiguration,
        columns: (0, $k0aCV.default)(FieldDataSelector, columns, createCell),
        navigationMode: (0, $b7a603c640ae8033$export$a01cd8e028b3d34f),
        expandedColumnIds: [],
        columnWidths: {},
        hiddenColumnIds: [],
        defaultRowHeight: (0, $0750463259e12908$export$258441c8a79bb589),
        autoRowHeight: (0, $0750463259e12908$export$80fc56c6cdbfffed),
        draggableRows: (0, $0750463259e12908$export$6fd8e343a23be522),
        showDecalAtBottom: totalPages > 1,
        NonTemporaryCellWrapper: undefined,
        onActiveItemChanged: onActiveItemChanged,
        onActiveRowIdChanged: onActiveRowIdChanged,
        onDisplayedRowsChanged: onDisplayedRowsChanged,
        onVerticalScrollOffsetChanged: $9b3fbfa9c8b45c48$var$transformScrollCallback(props),
        onHorizontalScrollOffsetChanged: onUpdateHorizontalScrollOffset,
        onRowListFocusFunctionChanged: onTableFocusFunctionChanged,
        onReactPortalContainerRefChanged: onTableRefChanged,
        contentKey: contentKey,
        ariaLabel: ariaLabel,
        ssrTableSize: ssrTableSize,
        disableRowHighlight: disableRowHighlight,
        renderSidebarIcon: renderSidebarIcon,
        premiumSLAColumnIds: appProps.premiumSLAColumns,
        shouldUseCssForRendering: shouldUseCssForRendering
    };
};

});
const $b7a603c640ae8033$export$9e9986b7abe95577 = 'cellNavigation';
const $b7a603c640ae8033$export$a01cd8e028b3d34f = 'rowNavigation';
const $b7a603c640ae8033$export$8ea4ff4da61b68e4 = 'noNavigation';
const $b7a603c640ae8033$export$8a257aa81ef4a9e0 = 'activeRow';
const $b7a603c640ae8033$export$4b3489234fd17200 = 'activeCell';

parcelRegister("hnPY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7f653b84f78bee$export$2e2bcd8739ae039);

var $74ySO = parcelRequire("74ySO");

var $8QpSo = parcelRequire("8QpSo");
const $cb7f653b84f78bee$var$LOADING_ROW_CONFIGURATION = {
    isLoading: true
};
var $cb7f653b84f78bee$export$2e2bcd8739ae039 = (0, $8QpSo.default)((issueKeys, selectedIssueKeys)=>{
    const rowIds = [];
    const rowsConfiguration = {};
    for(let i = 0; i < issueKeys.length; i += 1){
        const issueKey = issueKeys[i];
        if (issueKey == null) {
            rowIds[i] = i.toString();
            rowsConfiguration[i.toString()] = $cb7f653b84f78bee$var$LOADING_ROW_CONFIGURATION;
        } else {
            rowIds[i] = issueKey;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(selectedIssueKeys, issueKey)) rowsConfiguration[issueKey] = {
                isSelected: true
            };
        }
    }
    return {
        rowIds: rowIds,
        rowsConfiguration: rowsConfiguration
    };
});

});

parcelRegister("buPus", function(module, exports) {

$parcel$export(module.exports, "default", () => $584f4ca30aa94010$export$2e2bcd8739ae039);

const $584f4ca30aa94010$var$DIRECTION_UP = 'UP';
const $584f4ca30aa94010$var$DIRECTION_DOWN = 'DOWN';
// The number of issue keys that would be fetched on scroll
const $584f4ca30aa94010$var$FETCH_BATCH_SIZE = 100;
// The number of issue keys that would be fetched on scroll
const $584f4ca30aa94010$var$OVERFETCH_SIZE = 3;
// Fetch issues only if the index changed (after scrolling) by 25% of buffer in store
const $584f4ca30aa94010$var$ISSUE_FETCH_SCROLL_THRESHOLD = 0.25;
// load more issues in the direction of scroll
const $584f4ca30aa94010$var$FETCH_BATCH_DIRECTIONAL_BIAS = 0.8;
// min rows scrolled before a fetch is requested
const $584f4ca30aa94010$var$MIN_SCROLL_BOUNDARY_DELTA = 3;
// validation functions
const $584f4ca30aa94010$var$isFirstBatch = (prevPageIssueCount, startIndex)=>startIndex === prevPageIssueCount;
const $584f4ca30aa94010$var$isLastBatch = (issueKeyCount, startIndex)=>startIndex === issueKeyCount - $584f4ca30aa94010$var$FETCH_BATCH_SIZE + $584f4ca30aa94010$var$OVERFETCH_SIZE;
const $584f4ca30aa94010$var$hasScrolledPastThreshold = (issueCountForThresholdCheck, scrollDelta)=>Math.abs(scrollDelta) > issueCountForThresholdCheck * $584f4ca30aa94010$var$ISSUE_FETCH_SCROLL_THRESHOLD;
const $584f4ca30aa94010$export$acc3c238efb0cb80 = (issueKeyCount, prevPageIssueCount, isLastPage, displayStart, displayEnd, isScrollingUp)=>{
    // Find out how many issues are rendered and how many more are needed for a batch of 100 issues.
    const extraIssuesToBeFetched = $584f4ca30aa94010$var$FETCH_BATCH_SIZE - (displayEnd - displayStart);
    // count of issues in either direction based on scroll direction
    const extraIssuesInScrollDirection = Math.floor(extraIssuesToBeFetched * $584f4ca30aa94010$var$FETCH_BATCH_DIRECTIONAL_BIAS);
    const extraIssuesOppositeScrollDirection = extraIssuesToBeFetched - extraIssuesInScrollDirection;
    const extraIssuesAtTopOfTable = isScrollingUp ? extraIssuesInScrollDirection : extraIssuesOppositeScrollDirection;
    return {
        startIndex: Math.min(Math.max(displayStart + prevPageIssueCount - extraIssuesAtTopOfTable, prevPageIssueCount), prevPageIssueCount + issueKeyCount - $584f4ca30aa94010$var$FETCH_BATCH_SIZE + (isLastPage ? $584f4ca30aa94010$var$OVERFETCH_SIZE : 0)),
        extraIssuesInScrollDirection: extraIssuesInScrollDirection,
        extraIssuesOppositeScrollDirection: extraIssuesOppositeScrollDirection
    };
};
const $584f4ca30aa94010$export$2ad5771a0a9b303a = (issueKeyCount, issueCountForThresholdCheck, prevPageIssueCount, startIndex, prevStartIndex, scrollDelta)=>{
    // fetch only if the index changes by 25% of the buffer in store in the direction of scroll
    // or if it's the first or the last batch for that page
    if (scrollDelta && startIndex !== prevStartIndex && ($584f4ca30aa94010$var$hasScrolledPastThreshold(issueCountForThresholdCheck, scrollDelta) || $584f4ca30aa94010$var$isLastBatch(issueKeyCount, startIndex) || $584f4ca30aa94010$var$isFirstBatch(prevPageIssueCount, startIndex))) return true;
    return false;
};
var // We are executing multiple IssueTable callbacks which are all tied to vertical scroll offset changes in VirtualTable
// eslint-disable-next-line jira/import/no-anonymous-default-export
$584f4ca30aa94010$export$2e2bcd8739ae039 = ()=>{
    // to keep a track of dispay boundary, used in identifying the scroll direction and offset
    let prevVisibleStart = 0;
    // to keep a track of prev indices, to not do anything if index didn't change
    let prevStartIndex;
    // to keep a track of any changes in scroll direction
    let prevScrollDirection = $584f4ca30aa94010$var$DIRECTION_DOWN;
    return (props)=>(verticalPosition)=>{
            const { onUpdateVerticalScrollOffset: onUpdateVerticalScrollOffset, onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged, onIssueDataRequested: onIssueDataRequested, issueKeys: issueKeys, currentPage: currentPage, totalPages: totalPages } = props;
            const { displayStart: displayStart, displayEnd: displayEnd, visibleStart: visibleStart, offsetFromTop: offsetFromTop, offsetFromBottom: offsetFromBottom } = verticalPosition;
            const issueKeyCount = issueKeys.length;
            const topAndBottomOffset = {
                offsetFromTop: offsetFromTop,
                offsetFromBottom: offsetFromBottom
            };
            onUpdateVerticalScrollOffset(totalPages, topAndBottomOffset, onVerticalScrollOffsetChanged);
            const scrollDelta = visibleStart - prevVisibleStart;
            // if all issues are already rendered, or no change in display boundaries, no need to fetch any more
            if (issueKeyCount < $584f4ca30aa94010$var$FETCH_BATCH_SIZE || Math.abs(scrollDelta) < $584f4ca30aa94010$var$MIN_SCROLL_BOUNDARY_DELTA) return;
            const scrollDirection = visibleStart > prevVisibleStart ? $584f4ca30aa94010$var$DIRECTION_DOWN : $584f4ca30aa94010$var$DIRECTION_UP;
            // take pagination into account
            const prevPageIssueCount = (currentPage - 1) * (0, $0750463259e12908$export$f88f58d1a4b2078b);
            const isLastPage = currentPage === totalPages;
            const { startIndex: startIndex, extraIssuesInScrollDirection: extraIssuesInScrollDirection, extraIssuesOppositeScrollDirection: extraIssuesOppositeScrollDirection } = $584f4ca30aa94010$export$acc3c238efb0cb80(issueKeyCount, prevPageIssueCount, isLastPage, displayStart, displayEnd, scrollDirection === $584f4ca30aa94010$var$DIRECTION_UP);
            // if the scroll direction was changed, the threshold must be smaller because there are less issues loaded in that direction
            const issueCountForThresholdCheck = scrollDirection === prevScrollDirection ? extraIssuesInScrollDirection : extraIssuesOppositeScrollDirection;
            // @ts-expect-error - TS2322 - Type '"UP" | "DOWN"' is not assignable to type '"DOWN"'.
            prevScrollDirection = scrollDirection;
            const shouldFetchData = $584f4ca30aa94010$export$2ad5771a0a9b303a(issueKeyCount, issueCountForThresholdCheck, prevPageIssueCount, startIndex, prevStartIndex, scrollDelta);
            onIssueDataRequested && shouldFetchData && onIssueDataRequested(startIndex);
            // unless the scroll is not enough to enforce a new fetch, do not update the previous values
            if (shouldFetchData) {
                prevStartIndex = startIndex;
                prevVisibleStart = visibleStart;
            }
        };
};

});


parcelRegister("i1iiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1a0f4cba177a10$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $iwB5c = parcelRequire("iwB5c");

var $cHNkc = parcelRequire("cHNkc");

class $8b1a0f4cba177a10$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props);
        this.createCell = (0, $cHNkc.createCellsCache)();
    }
    render() {
        const { issueKeys: issueKeys } = this.props;
        const { transformProps: transformProps, tableRef: tableRef, ...otherProps } = this.props;
        if (issueKeys && issueKeys.length > (0, $0750463259e12908$export$f88f58d1a4b2078b)) (0, $dJl1T.default).safeWarnWithoutCustomerData('issue-table', `[FD-4474] Maximum number of issues allowed by IssueTable on a page is ${(0, $0750463259e12908$export$f88f58d1a4b2078b)}`);
        const tableProps = transformProps(otherProps, this.createCell);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwB5c.default), {
            ...tableProps,
            ref: tableRef
        });
    }
}

});
parcelRegister("iwB5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d5d57a91d181a7f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $1kDks = parcelRequire("1kDks");


var $a3fP7 = parcelRequire("a3fP7");

var $8pQu6 = parcelRequire("8pQu6");

var $kSeJ5 = parcelRequire("kSeJ5");

var $jfml7 = parcelRequire("jfml7");

var $eiuAu = parcelRequire("eiuAu");

var $d15BB = parcelRequire("d15BB");

var $4xF55 = parcelRequire("4xF55");

var $6iCoB = parcelRequire("6iCoB");

var $8QnA7 = parcelRequire("8QnA7");

var $1IBHA = parcelRequire("1IBHA");

var $77TUf = parcelRequire("77TUf");
class $1d5d57a91d181a7f$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            NonTemporaryCellWrapper: undefined,
            navigationMode: (0, $b7a603c640ae8033$export$9e9986b7abe95577),
            rowIds: [],
            rowsConfiguration: {},
            defaultRowHeight: Math.max((0, $8QnA7.default).row.height, (0, $8QnA7.default).row.minHeight),
            autoRowHeight: false,
            draggableRows: false,
            columns: [],
            expandedColumnIds: [],
            columnWidths: {},
            hiddenColumnIds: [],
            onActiveItemChanged: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onRowListFocusFunctionChanged: undefined,
            contentKey: undefined,
            ariaLabel: undefined
        };
    }
    static getInitialStoreState(props) {
        if (props.shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return {
            internal: {
                ...(0, $d15BB.initialState),
                shouldUseCssForRendering: true,
                tableSize: {
                    width: 0,
                    // in case of SSR arbitrary number to allow some rows to be rendered, ideally bigger than any screen you can think of
                    // otherwise we will read it from the ref of the wrapper
                    height: false ? 10000 : 0,
                    // if we don't set it, some editable fields inside cells (e.g. assignee) don't render, and cause errors
                    widthWithoutScrollbarOffset: 0,
                    rowMargin: 0
                }
            }
        };
        return false && props.ssrTableSize ? {
            internal: {
                ...(0, $d15BB.initialState),
                tableSize: props.ssrTableSize
            }
        } : undefined;
    }
    constructor(props){
        super(props);
        const initialStoreState = $1d5d57a91d181a7f$export$2e2bcd8739ae039.getInitialStoreState(props);
        this.store = (0, $1IBHA.default)(initialStoreState);
        const consumerState = (0, $77TUf.default)(props);
        this.store.dispatch((0, $a3fP7.setStateFromProps)(consumerState, (0, $8QnA7.default)));
        if (props.renderSidebarIcon) this.store.dispatch((0, $eiuAu.setRenderSidebarIcon)(props.renderSidebarIcon));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.props, nextProps)) {
            const consumerState = (0, $77TUf.default)(nextProps);
            this.store.dispatch((0, $8pQu6.updateStateFromProps)(consumerState));
            if (nextProps.renderSidebarIcon) this.store.dispatch((0, $eiuAu.setRenderSidebarIcon)(nextProps.renderSidebarIcon));
        }
    }
    scrollToRow(rowId) {
        this.store.dispatch((0, $jfml7.scrollToRow)(rowId));
    }
    resetVerticalScrollOffset() {
        this.store.dispatch((0, $kSeJ5.setVertical)(0));
    }
    render() {
        const { defaultRowHeight: defaultRowHeight, autoRowHeight: autoRowHeight, customScrollBarOffset: customScrollBarOffset } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kDks.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6iCoB.ThemeProvider), {
            defaultRowHeight: defaultRowHeight,
            autoRowHeight: autoRowHeight,
            customScrollBarOffset: customScrollBarOffset
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xF55.default), null)));
    }
}

});
parcelRegister("1kDks", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $38cd917ba37aa0dd$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $38cd917ba37aa0dd$export$64605811ab45167f);

var $5uXOq = parcelRequire("5uXOq");

var $bC2fB = parcelRequire("bC2fB");
const $38cd917ba37aa0dd$var$STORE_KEY = 'tableStore';
const $38cd917ba37aa0dd$export$93e4b0b2cc49b648 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $38cd917ba37aa0dd$export$2881499e37b75b9a = (0, $bC2fB.createProvider)($38cd917ba37aa0dd$export$93e4b0b2cc49b648);
const $38cd917ba37aa0dd$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = {})=>(0, $bC2fB.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $38cd917ba37aa0dd$export$93e4b0b2cc49b648,
        storeKey: $38cd917ba37aa0dd$var$STORE_KEY
    });

});

parcelRegister("a3fP7", function(module, exports) {

$parcel$export(module.exports, "SET_STATE_FROM_PROPS", () => $8624aec82d4adca0$export$fa83d46c9d6439df);
$parcel$export(module.exports, "setStateFromProps", () => $8624aec82d4adca0$export$ecd61896fb1d9dfc);
const $8624aec82d4adca0$export$fa83d46c9d6439df = 'ops.hydrate.set.SET_STATE_FROM_PROPS';
const $8624aec82d4adca0$export$ecd61896fb1d9dfc = (apiState, theme)=>({
        type: $8624aec82d4adca0$export$fa83d46c9d6439df,
        payload: {
            apiState: apiState,
            theme: theme
        }
    });

});

parcelRegister("8pQu6", function(module, exports) {

$parcel$export(module.exports, "UPDATE_STATE_FROM_PROPS", () => $1398c3b052669965$export$9915f5b7a701b9dc);
$parcel$export(module.exports, "updateStateFromProps", () => $1398c3b052669965$export$129cd88740c3c561);
const $1398c3b052669965$export$9915f5b7a701b9dc = 'ops.hydrate.update.UPDATE_STATE_FROM_PROPS';
const $1398c3b052669965$export$129cd88740c3c561 = (payload)=>({
        type: $1398c3b052669965$export$9915f5b7a701b9dc,
        payload: payload
    });

});

parcelRegister("kSeJ5", function(module, exports) {

$parcel$export(module.exports, "SET_SCROLL_OFFSET", () => $1ffcd77067e4f85e$export$b62cd193236337c8);
$parcel$export(module.exports, "setVertical", () => $1ffcd77067e4f85e$export$f34530221b3f1c79);
$parcel$export(module.exports, "setHorizontal", () => $1ffcd77067e4f85e$export$dd2992a7040a040);
const $1ffcd77067e4f85e$export$226d1a200557982a = 'VERTICAL';
const $1ffcd77067e4f85e$export$608a8b0c7bb8a183 = 'HORIZONTAL';
const $1ffcd77067e4f85e$export$b62cd193236337c8 = 'ops.scrolling.offset.SET_SCROLL_OFFSET';
const $1ffcd77067e4f85e$export$adaa4cf7ef1b65be = (payload)=>({
        type: $1ffcd77067e4f85e$export$b62cd193236337c8,
        payload: payload
    });
const $1ffcd77067e4f85e$export$f34530221b3f1c79 = (offset)=>({
        type: $1ffcd77067e4f85e$export$b62cd193236337c8,
        payload: {
            offset: offset,
            direction: $1ffcd77067e4f85e$export$226d1a200557982a
        }
    });
const $1ffcd77067e4f85e$export$dd2992a7040a040 = (offset)=>({
        type: $1ffcd77067e4f85e$export$b62cd193236337c8,
        payload: {
            offset: offset,
            direction: $1ffcd77067e4f85e$export$608a8b0c7bb8a183
        }
    });

});

parcelRegister("jfml7", function(module, exports) {

$parcel$export(module.exports, "SCROLL_TO_ROW", () => $03936b02f8f5a37c$export$ac622773190ce65e);
$parcel$export(module.exports, "scrollToRow", () => $03936b02f8f5a37c$export$71590875881b540);
const $03936b02f8f5a37c$export$ac622773190ce65e = 'ops.scrolling.to-row.SCROLL_TO_ROW';
const $03936b02f8f5a37c$export$71590875881b540 = (payload)=>({
        type: $03936b02f8f5a37c$export$ac622773190ce65e,
        payload: payload
    });

});

parcelRegister("eiuAu", function(module, exports) {

$parcel$export(module.exports, "SET_VERTICAL_SCROLL_OFFSET", () => $290ccb7b202eb589$export$80ba52f206861eb4);
$parcel$export(module.exports, "setVerticalScrollOffset", () => $290ccb7b202eb589$export$326ff279ca4dfb77);
$parcel$export(module.exports, "SET_VERTICAL_SCROLL_DELTA", () => $290ccb7b202eb589$export$653d24855aaede15);
$parcel$export(module.exports, "setVerticalScrollDelta", () => $290ccb7b202eb589$export$1331c3f83dd180bd);
$parcel$export(module.exports, "SET_HORIZONTAL_SCROLL_OFFSET", () => $290ccb7b202eb589$export$e1dd7001449ed5e8);
$parcel$export(module.exports, "setHorizontalScrollOffset", () => $290ccb7b202eb589$export$22fd5ac5ac6862d2);
$parcel$export(module.exports, "SET_TABLE_SIZE", () => $290ccb7b202eb589$export$7988e33354cc36c5);
$parcel$export(module.exports, "setTableSize", () => $290ccb7b202eb589$export$ef8b504c11e86ef2);
$parcel$export(module.exports, "SET_ACTIVE_ITEM", () => $290ccb7b202eb589$export$ff7b028545454800);
$parcel$export(module.exports, "setActiveItem", () => $290ccb7b202eb589$export$375743a38c44f220);
$parcel$export(module.exports, "CLEAR_ACTIVE_ITEM", () => $290ccb7b202eb589$export$d63ae865b2dc3e7f);
$parcel$export(module.exports, "clearActiveItem", () => $290ccb7b202eb589$export$f8e43f3f64585431);
$parcel$export(module.exports, "SET_RESIZING_COLUMN", () => $290ccb7b202eb589$export$9b07079645db68ce);
$parcel$export(module.exports, "setResizingColumn", () => $290ccb7b202eb589$export$ecabdd68bb804ada);
$parcel$export(module.exports, "SET_COLUMN_SORT_ORDER", () => $290ccb7b202eb589$export$d353d2412612deea);
$parcel$export(module.exports, "setColumnSortOrder", () => $290ccb7b202eb589$export$53f60a18200636);
$parcel$export(module.exports, "SET_SORT_ORDER_WITH_OVERRIDE", () => $290ccb7b202eb589$export$bd2944db1d7878d7);
$parcel$export(module.exports, "setSortOrderWithOverride", () => $290ccb7b202eb589$export$21099b8525c19e6b);
$parcel$export(module.exports, "SET_MULTI_ADD_ANCHOR", () => $290ccb7b202eb589$export$45d5c36be62dcf8e);
$parcel$export(module.exports, "setMultiAddAnchor", () => $290ccb7b202eb589$export$ccc97b11ed34fa9c);
$parcel$export(module.exports, "CLEAR_MULTI_ADD_ANCHOR", () => $290ccb7b202eb589$export$28f3def567195a3c);
$parcel$export(module.exports, "clearMultiAddAnchor", () => $290ccb7b202eb589$export$fba9cdc0d3369b8b);
$parcel$export(module.exports, "SET_SORTED_ROW_IDS_HASH", () => $290ccb7b202eb589$export$a5a55dd3afd00236);
$parcel$export(module.exports, "setSortedRowIdsHash", () => $290ccb7b202eb589$export$7b78b0b46aa05c76);
$parcel$export(module.exports, "SET_ROW_BORDER_WIDTH", () => $290ccb7b202eb589$export$a347b798ae4b070c);
$parcel$export(module.exports, "setRowBorderWidth", () => $290ccb7b202eb589$export$a1c22b3a0006689b);
$parcel$export(module.exports, "SET_ROW_HEIGHT_MAPPING", () => $290ccb7b202eb589$export$3c2f00efa2858459);
$parcel$export(module.exports, "clearRowHeightMapping", () => $290ccb7b202eb589$export$ee45b95e009bf919);
$parcel$export(module.exports, "BATCH_UPDATE_ROW_HEIGHT_MAPPING", () => $290ccb7b202eb589$export$1e2cc4b1d7e85685);
$parcel$export(module.exports, "batchUpdateRowHeightMapping", () => $290ccb7b202eb589$export$6ad1445af83aec72);
$parcel$export(module.exports, "SET_SCROLLBAR_SIZE", () => $290ccb7b202eb589$export$1343829730561bf3);
$parcel$export(module.exports, "setScrollbarSize", () => $290ccb7b202eb589$export$dc80aaf47c2ba019);
$parcel$export(module.exports, "SET_HEADER_HEIGHT", () => $290ccb7b202eb589$export$e52e6a4be99a8322);
$parcel$export(module.exports, "setHeaderHeight", () => $290ccb7b202eb589$export$5f442def93f9b3e5);
$parcel$export(module.exports, "SET_RENDER_SIDE_BAR_ICON", () => $290ccb7b202eb589$export$9699e624bf23e2bb);
$parcel$export(module.exports, "setRenderSidebarIcon", () => $290ccb7b202eb589$export$28433d58f8f5bf2);
const $290ccb7b202eb589$export$80ba52f206861eb4 = 'state.internal.SET_VERTICAL_SCROLL_OFFSET';
const $290ccb7b202eb589$export$326ff279ca4dfb77 = (offset)=>({
        type: $290ccb7b202eb589$export$80ba52f206861eb4,
        payload: offset
    });
const $290ccb7b202eb589$export$653d24855aaede15 = 'state.internal.SET_VERTICAL_SCROLL_DELTA';
const $290ccb7b202eb589$export$1331c3f83dd180bd = (delta)=>({
        type: $290ccb7b202eb589$export$653d24855aaede15,
        payload: delta
    });
const $290ccb7b202eb589$export$e1dd7001449ed5e8 = 'state.internal.SET_HORIZONTAL_SCROLL_OFFSET';
const $290ccb7b202eb589$export$22fd5ac5ac6862d2 = (offset)=>({
        type: $290ccb7b202eb589$export$e1dd7001449ed5e8,
        payload: offset
    });
const $290ccb7b202eb589$export$7988e33354cc36c5 = 'state.internal.SET_TABLE_SIZE';
const $290ccb7b202eb589$export$ef8b504c11e86ef2 = (tableSize)=>({
        type: $290ccb7b202eb589$export$7988e33354cc36c5,
        payload: tableSize
    });
const $290ccb7b202eb589$export$ff7b028545454800 = 'state.internal.SET_ACTIVE_ITEM';
const $290ccb7b202eb589$export$375743a38c44f220 = (payload)=>({
        type: $290ccb7b202eb589$export$ff7b028545454800,
        payload: payload
    });
const $290ccb7b202eb589$export$d63ae865b2dc3e7f = 'state.internal.CLEAR_ACTIVE_ITEM';
const $290ccb7b202eb589$export$f8e43f3f64585431 = ()=>({
        type: $290ccb7b202eb589$export$d63ae865b2dc3e7f
    });
const $290ccb7b202eb589$export$9b07079645db68ce = 'state.internal.SET_RESIZING_COLUMN';
const $290ccb7b202eb589$export$ecabdd68bb804ada = (payload)=>({
        type: $290ccb7b202eb589$export$9b07079645db68ce,
        payload: payload
    });
const $290ccb7b202eb589$export$d353d2412612deea = 'state.internal.SET_COLUMN_SORT_ORDER';
const $290ccb7b202eb589$export$53f60a18200636 = (payload)=>({
        type: $290ccb7b202eb589$export$d353d2412612deea,
        payload: payload
    });
const $290ccb7b202eb589$export$bd2944db1d7878d7 = 'state.internal.SET_SORT_ORDER_WITH_OVERRIDE';
const $290ccb7b202eb589$export$21099b8525c19e6b = (payload)=>({
        type: $290ccb7b202eb589$export$bd2944db1d7878d7,
        payload: payload
    });
const $290ccb7b202eb589$export$45d5c36be62dcf8e = 'state.internal.SET_MULTI_ADD_ANCHOR';
const $290ccb7b202eb589$export$ccc97b11ed34fa9c = (payload)=>({
        type: $290ccb7b202eb589$export$45d5c36be62dcf8e,
        payload: payload
    });
const $290ccb7b202eb589$export$28f3def567195a3c = 'state.internal.CLEAR_MULTI_ADD_ANCHOR';
const $290ccb7b202eb589$export$fba9cdc0d3369b8b = ()=>({
        type: $290ccb7b202eb589$export$28f3def567195a3c
    });
const $290ccb7b202eb589$export$a5a55dd3afd00236 = 'state.internal.SET_SORTED_ROW_IDS_HASH';
const $290ccb7b202eb589$export$7b78b0b46aa05c76 = (payload)=>({
        type: $290ccb7b202eb589$export$a5a55dd3afd00236,
        payload: payload
    });
const $290ccb7b202eb589$export$a347b798ae4b070c = 'state.internal.SET_ROW_BORDER_WIDTH';
const $290ccb7b202eb589$export$a1c22b3a0006689b = (payload)=>({
        type: $290ccb7b202eb589$export$a347b798ae4b070c,
        payload: payload
    });
const $290ccb7b202eb589$export$3c2f00efa2858459 = 'state.internal.SET_ROW_HEIGHT_MAPPING';
const $290ccb7b202eb589$export$a0d036f26f10d9d2 = (payload)=>({
        type: $290ccb7b202eb589$export$3c2f00efa2858459,
        payload: payload
    });
const $290ccb7b202eb589$export$ee45b95e009bf919 = ()=>$290ccb7b202eb589$export$a0d036f26f10d9d2({});
const $290ccb7b202eb589$export$1e2cc4b1d7e85685 = 'state.internal.BATCH_UPDATE_ROW_HEIGHT_MAPPING';
const $290ccb7b202eb589$export$6ad1445af83aec72 = (rowIds, rowHeightMapping)=>({
        type: $290ccb7b202eb589$export$1e2cc4b1d7e85685,
        payload: {
            rowIds: rowIds,
            rowHeightMapping: rowHeightMapping
        }
    });
const $290ccb7b202eb589$export$1343829730561bf3 = 'state.internal.SET_SCROLLBAR_SIZE';
const $290ccb7b202eb589$export$dc80aaf47c2ba019 = (payload)=>({
        type: $290ccb7b202eb589$export$1343829730561bf3,
        payload: payload
    });
const $290ccb7b202eb589$export$e52e6a4be99a8322 = 'state.internal.SET_HEADER_HEIGHT';
const $290ccb7b202eb589$export$5f442def93f9b3e5 = (height)=>({
        type: $290ccb7b202eb589$export$e52e6a4be99a8322,
        payload: height
    });
const $290ccb7b202eb589$export$9699e624bf23e2bb = 'state.consumer.SET_RENDER_SIDE_BAR_ICON';
const $290ccb7b202eb589$export$28433d58f8f5bf2 = (payload)=>({
        type: $290ccb7b202eb589$export$9699e624bf23e2bb,
        payload: payload
    });

});

parcelRegister("d15BB", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $5f88effe4d937102$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $5f88effe4d937102$export$2e2bcd8739ae039);

var $3NMrl = parcelRequire("3NMrl");

var $eiuAu = parcelRequire("eiuAu");
const $5f88effe4d937102$export$d4c72bab9d6cc13a = {
    verticalScrollOffset: 0,
    verticalScrollDelta: 0,
    horizontalScrollOffset: 0,
    // FSN-4037 Remove draggingRowId related logic during FF cleanup
    draggingRowId: undefined,
    multiAddAnchorId: undefined,
    resizingColumnId: undefined,
    draggingColumnId: undefined,
    isSortOverrideEnabled: false,
    activeSortedColumnConfiguration: undefined,
    activeItem: undefined,
    tableSize: {
        width: 0,
        height: 0,
        widthWithoutScrollbarOffset: 0,
        rowMargin: 0
    },
    rowBorderWidth: 0,
    rowHeightMapping: {},
    scrollbarSize: 0,
    sortedRowIdsHash: {},
    headerHeight: 0,
    renderSidebarIcon: undefined,
    shouldUseCssForRendering: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f88effe4d937102$export$2e2bcd8739ae039 = (state = $5f88effe4d937102$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $eiuAu.SET_VERTICAL_SCROLL_OFFSET:
            return {
                ...state,
                verticalScrollOffset: action.payload
            };
        case 0, $eiuAu.SET_VERTICAL_SCROLL_DELTA:
            return {
                ...state,
                verticalScrollDelta: action.payload
            };
        case 0, $eiuAu.SET_HORIZONTAL_SCROLL_OFFSET:
            return {
                ...state,
                horizontalScrollOffset: action.payload
            };
        case 0, $eiuAu.SET_MULTI_ADD_ANCHOR:
            return {
                ...state,
                multiAddAnchorId: action.payload
            };
        case 0, $eiuAu.CLEAR_MULTI_ADD_ANCHOR:
            return {
                ...state,
                multiAddAnchorId: undefined
            };
        case 0, $eiuAu.SET_TABLE_SIZE:
            return {
                ...state,
                tableSize: action.payload
            };
        case 0, $eiuAu.SET_RESIZING_COLUMN:
            return {
                ...state,
                resizingColumnId: action.payload
            };
        case 0, $eiuAu.SET_COLUMN_SORT_ORDER:
            return {
                ...state,
                activeSortedColumnConfiguration: action.payload,
                isSortOverrideEnabled: false
            };
        case 0, $eiuAu.SET_ACTIVE_ITEM:
            return {
                ...state,
                activeItem: action.payload
            };
        case 0, $eiuAu.CLEAR_ACTIVE_ITEM:
            return {
                ...state,
                activeItem: undefined
            };
        case 0, $eiuAu.SET_SORT_ORDER_WITH_OVERRIDE:
            return {
                ...state,
                isSortOverrideEnabled: action.payload.isSortOverrideEnabled
            };
        case 0, $eiuAu.SET_SORTED_ROW_IDS_HASH:
            return {
                ...state,
                sortedRowIdsHash: action.payload
            };
        case 0, $eiuAu.SET_ROW_BORDER_WIDTH:
            return {
                ...state,
                rowBorderWidth: action.payload
            };
        case 0, $eiuAu.SET_ROW_HEIGHT_MAPPING:
            return {
                ...state,
                rowHeightMapping: action.payload
            };
        case 0, $eiuAu.BATCH_UPDATE_ROW_HEIGHT_MAPPING:
            {
                const { rowHeightMapping: rowHeightMapping, rowIds: rowIds } = action.payload;
                const validatedRowHeights = (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(state.rowHeightMapping, rowIds);
                return {
                    ...state,
                    rowHeightMapping: {
                        ...validatedRowHeights,
                        ...rowHeightMapping
                    }
                };
            }
        case 0, $eiuAu.SET_SCROLLBAR_SIZE:
            return {
                ...state,
                scrollbarSize: action.payload
            };
        case 0, $eiuAu.SET_HEADER_HEIGHT:
            return {
                ...state,
                headerHeight: action.payload
            };
        case 0, $eiuAu.SET_RENDER_SIDE_BAR_ICON:
            return {
                ...state,
                renderSidebarIcon: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("4xF55", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a99714acd34d617$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $1kDks = parcelRequire("1kDks");

var $dnN17 = parcelRequire("dnN17");

var $eeWa5 = parcelRequire("eeWa5");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $24bgq = parcelRequire("24bgq");

var $5KuPF = parcelRequire("5KuPF");

var $kIqbP = parcelRequire("kIqbP");
var $8a99714acd34d617$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        isAutoHeight: (0, $eeWa5.isAutoHeight)(state),
        width: (0, $5J7ao.getTableWidth)(state),
        height: (0, $iN58L.getTableHeight)(state),
        virtualBoundaries: (0, $4R6GH.fg)('jsm_flash_virtual_table_rows_number_analytics') ? (0, $iN58L.getVirtualBoundaries)(state) : undefined,
        TableMain: $kIqbP.default,
        DetailsPanel: $24bgq.default,
        shouldUseCssForRendering: (0, $5J7ao.getShouldUseCssForRendering)(state)
    }), {
    setTableSize: $dnN17.set
})((0, $5KuPF.default));

});
parcelRegister("dnN17", function(module, exports) {

$parcel$export(module.exports, "SET_TABLE_SIZE", () => $85705fd3e7c1fb17$export$7988e33354cc36c5);
$parcel$export(module.exports, "set", () => $85705fd3e7c1fb17$export$adaa4cf7ef1b65be);
// set table size
const $85705fd3e7c1fb17$export$7988e33354cc36c5 = 'ops.table-size.SET_TABLE_SIZE';
const $85705fd3e7c1fb17$export$adaa4cf7ef1b65be = (tableSize)=>({
        type: $85705fd3e7c1fb17$export$7988e33354cc36c5,
        payload: tableSize
    });

});

parcelRegister("eeWa5", function(module, exports) {

$parcel$export(module.exports, "getConsumerState", () => $c49ccf1362b2bff4$export$341d8012284373b1);
$parcel$export(module.exports, "isAutoHeight", () => $c49ccf1362b2bff4$export$db0e511b14aa0a6e);
$parcel$export(module.exports, "getAriaLabel", () => $c49ccf1362b2bff4$export$b908d89b50cd4e14);
$parcel$export(module.exports, "isContentStale", () => $c49ccf1362b2bff4$export$9039d26c291af11d);
$parcel$export(module.exports, "shouldHideLoadingIndicator", () => $c49ccf1362b2bff4$export$fffff0ed501bd482);
$parcel$export(module.exports, "shouldRerenderRowOnHover", () => $c49ccf1362b2bff4$export$21a66ad733a5f373);
$parcel$export(module.exports, "showBottomDecal", () => $c49ccf1362b2bff4$export$6587735983eaa612);
$parcel$export(module.exports, "getNavigationMode", () => $c49ccf1362b2bff4$export$d8d84b9edb2f3121);
$parcel$export(module.exports, "isInCellNavigationMode", () => $c49ccf1362b2bff4$export$164b1d002ce21ad4);
$parcel$export(module.exports, "isInRowNavigationMode", () => $c49ccf1362b2bff4$export$a7cdf0911782f4e9);
$parcel$export(module.exports, "getShouldSkipVirtualization", () => $c49ccf1362b2bff4$export$76b0eed37faf2db7);
$parcel$export(module.exports, "disableRowHighlight", () => $c49ccf1362b2bff4$export$94e08c39526945ff);
$parcel$export(module.exports, "getRowExpansionCallback", () => $c49ccf1362b2bff4$export$bd84bd77b16747b0);
$parcel$export(module.exports, "getRowAddCallback", () => $c49ccf1362b2bff4$export$6b23e7f48fb98382);
$parcel$export(module.exports, "getClearAddedRowsCallback", () => $c49ccf1362b2bff4$export$b1c02c566f8f8e21);
$parcel$export(module.exports, "getPersistAddedRowCallback", () => $c49ccf1362b2bff4$export$8f6f1d89690007b6);
$parcel$export(module.exports, "getCancelAddedRowCallback", () => $c49ccf1362b2bff4$export$549fbf34b02d3f9f);
$parcel$export(module.exports, "getColumnExpandCallback", () => $c49ccf1362b2bff4$export$d1881e0c1d23cb54);
$parcel$export(module.exports, "getChangeHiddenColumnsCallback", () => $c49ccf1362b2bff4$export$c5513fe56d491d3c);
$parcel$export(module.exports, "getActiveItemChangedCallback", () => $c49ccf1362b2bff4$export$940cf9a84f2cd566);
$parcel$export(module.exports, "getActiveRowIdChangedCallback", () => $c49ccf1362b2bff4$export$e4a9acb7b8a41ad4);
$parcel$export(module.exports, "getSortedColumnChangedCallback", () => $c49ccf1362b2bff4$export$54ab8d2edb67b6c5);
$parcel$export(module.exports, "getVerticalScrollOffsetChangedCallback", () => $c49ccf1362b2bff4$export$208a9f508202aaea);
$parcel$export(module.exports, "getHorizontalScrollOffsetChangedCallback", () => $c49ccf1362b2bff4$export$9bc70187ed1fe3de);
$parcel$export(module.exports, "getOnRowListFocusFunctionChangedCallback", () => $c49ccf1362b2bff4$export$f3043684c353f104);
$parcel$export(module.exports, "getOnReactPortalContainerRefChangedCallback", () => $c49ccf1362b2bff4$export$4b1da0361b069d9);
$parcel$export(module.exports, "getDetailsPanelComponent", () => $c49ccf1362b2bff4$export$eb8f069328f0ef13);
$parcel$export(module.exports, "getNonTemporaryCellWrapper", () => $c49ccf1362b2bff4$export$9d360b10d6c49c27);
$parcel$export(module.exports, "isDetailsPanelOpen", () => $c49ccf1362b2bff4$export$8eff1175be4b2e5d);
$parcel$export(module.exports, "isColumnConfigurationVisible", () => $c49ccf1362b2bff4$export$af0e6e54e108dbdf);
$parcel$export(module.exports, "getVisibleAdditionalColumnIds", () => $c49ccf1362b2bff4$export$95e03d3af742e020);
$parcel$export(module.exports, "getVisibleColumnIds", () => $c49ccf1362b2bff4$export$9158bf17317ec5a3);
$parcel$export(module.exports, "getVisibleColumnCount", () => $c49ccf1362b2bff4$export$a494b4888339717d);
$parcel$export(module.exports, "getDefaultAddColumnId", () => $c49ccf1362b2bff4$export$d2c4eee6843b68dc);
$parcel$export(module.exports, "getTotalDynamicColumnMaxWidth", () => $c49ccf1362b2bff4$export$b87f4bf1dea22966);
$parcel$export(module.exports, "getTotalDynamicColumnMinWidth", () => $c49ccf1362b2bff4$export$2143bc4b2542ea5d);
$parcel$export(module.exports, "getLoadingRowComponent", () => $c49ccf1362b2bff4$export$65784ca6b29dc2a3);
$parcel$export(module.exports, "getFacade", () => $c49ccf1362b2bff4$export$379c1b3c8c56422e);
$parcel$export(module.exports, "isTableFacade", () => $c49ccf1362b2bff4$export$f4b00b57da9022eb);
$parcel$export(module.exports, "isTreeTableFacade", () => $c49ccf1362b2bff4$export$428877d41520e34c);
$parcel$export(module.exports, "shouldDelayRowRenderingOnScroll", () => $c49ccf1362b2bff4$export$47cf89187102921d);
$parcel$export(module.exports, "getPremiumSLAColumns", () => $c49ccf1362b2bff4$export$bd19afa7f02ff55d);

var $dGvGJ = parcelRequire("dGvGJ");

var $co1wz = parcelRequire("co1wz");



var $9f4YM = parcelRequire("9f4YM");

var $bFTY1 = parcelRequire("bFTY1");
const $c49ccf1362b2bff4$export$341d8012284373b1 = (state)=>state.consumer;
const $c49ccf1362b2bff4$export$db0e511b14aa0a6e = (state)=>state.consumer.autoHeight;
const $c49ccf1362b2bff4$export$b908d89b50cd4e14 = (state)=>state.consumer.ariaLabel;
const $c49ccf1362b2bff4$export$9039d26c291af11d = (state)=>state.consumer.isContentStale;
const $c49ccf1362b2bff4$export$fffff0ed501bd482 = (state)=>state.consumer.shouldHideLoadingIndicator;
const $c49ccf1362b2bff4$export$21a66ad733a5f373 = (state)=>state.consumer.shouldRerenderRowOnHover;
const $c49ccf1362b2bff4$export$6587735983eaa612 = (state)=>state.consumer.showDecalAtBottom;
const $c49ccf1362b2bff4$export$d8d84b9edb2f3121 = (state)=>state.consumer.navigationMode;
const $c49ccf1362b2bff4$export$164b1d002ce21ad4 = (state)=>$c49ccf1362b2bff4$export$d8d84b9edb2f3121(state) === (0, $b7a603c640ae8033$export$9e9986b7abe95577);
const $c49ccf1362b2bff4$export$a7cdf0911782f4e9 = (state)=>$c49ccf1362b2bff4$export$d8d84b9edb2f3121(state) === (0, $b7a603c640ae8033$export$a01cd8e028b3d34f);
const $c49ccf1362b2bff4$export$76b0eed37faf2db7 = (state)=>state.consumer.shouldSkipVirtualization;
const $c49ccf1362b2bff4$export$94e08c39526945ff = (state)=>state.consumer.disableRowHighlight;
// CALLBACKS
const $c49ccf1362b2bff4$var$getConsumerCallbacks = (state)=>state.consumer.callbacks;
const $c49ccf1362b2bff4$export$bd84bd77b16747b0 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onRowExpansionChangeRequested;
const $c49ccf1362b2bff4$export$6b23e7f48fb98382 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onRowAddRequested;
const $c49ccf1362b2bff4$export$b1c02c566f8f8e21 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onClearAddedRowsRequested;
const $c49ccf1362b2bff4$export$8f6f1d89690007b6 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onPersistAddedRowRequested;
const $c49ccf1362b2bff4$export$549fbf34b02d3f9f = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onCancelAddedRowRequested;
const $c49ccf1362b2bff4$export$d1881e0c1d23cb54 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onColumnExpansionChangeRequested;
const $c49ccf1362b2bff4$export$9bc4a4d8de396706 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onColumnMoveRequested;
const $c49ccf1362b2bff4$export$c5513fe56d491d3c = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onChangeHiddenColumnsRequested;
const $c49ccf1362b2bff4$export$940cf9a84f2cd566 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onActiveItemChanged;
const $c49ccf1362b2bff4$export$e4a9acb7b8a41ad4 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onActiveRowIdChanged;
const $c49ccf1362b2bff4$export$54ab8d2edb67b6c5 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onSortedColumnChanged;
const $c49ccf1362b2bff4$export$15d0406154f187f9 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onSortedRowIdsChanged;
const $c49ccf1362b2bff4$export$80456d589232e453 = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onDisplayedRowsChanged;
const $c49ccf1362b2bff4$export$208a9f508202aaea = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onVerticalScrollOffsetChanged;
const $c49ccf1362b2bff4$export$9bc70187ed1fe3de = (state)=>$c49ccf1362b2bff4$var$getConsumerCallbacks(state).onHorizontalScrollOffsetChanged;
const $c49ccf1362b2bff4$export$f3043684c353f104 = (state)=>state.consumer.callbacks.onRowListFocusFunctionChanged;
const $c49ccf1362b2bff4$export$4b1da0361b069d9 = (state)=>state.consumer.callbacks.onReactPortalContainerRefChanged;
const $c49ccf1362b2bff4$export$eb8f069328f0ef13 = (state)=>state.consumer.DetailsPanelComponent;
const $c49ccf1362b2bff4$export$9d360b10d6c49c27 = (state)=>state.consumer.NonTemporaryCellWrapper;
const $c49ccf1362b2bff4$export$8eff1175be4b2e5d = (state)=>!!$c49ccf1362b2bff4$export$eb8f069328f0ef13(state);
const $c49ccf1362b2bff4$export$af0e6e54e108dbdf = (0, $dGvGJ.createSelector)($c49ccf1362b2bff4$export$c5513fe56d491d3c, $c49ccf1362b2bff4$export$8eff1175be4b2e5d, (hiddenColumnsCallback, detailsPanelOpen)=>hiddenColumnsCallback !== undefined && !detailsPanelOpen);
const $c49ccf1362b2bff4$export$95e03d3af742e020 = (0, $dGvGJ.createSelector)((0, $bFTY1.getColumnTree), (0, $bFTY1.getExpandedColumnIdsHash), (0, $bFTY1.getHiddenColumnsLookupHash), (0, $bFTY1.getSortedColumnIds), $c49ccf1362b2bff4$export$8eff1175be4b2e5d, (columnTree, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, isDetailsOpen)=>isDetailsOpen ? [] : (0, $9f4YM.default)(columnTree, columnTree.rootAdditionalIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds));
const $c49ccf1362b2bff4$export$9158bf17317ec5a3 = (0, $dGvGJ.createSelector)((0, $bFTY1.getVisibleCoreColumnIds), $c49ccf1362b2bff4$export$95e03d3af742e020, (coreColumnIds, additionalColumnIds)=>coreColumnIds.concat(additionalColumnIds));
const $c49ccf1362b2bff4$export$a494b4888339717d = (0, $dGvGJ.createSelector)($c49ccf1362b2bff4$export$9158bf17317ec5a3, (visibleColumnIds)=>visibleColumnIds.length);
const $c49ccf1362b2bff4$export$d2c4eee6843b68dc = (0, $dGvGJ.createSelector)((0, $bFTY1.getColumnTree), $c49ccf1362b2bff4$export$9158bf17317ec5a3, (columnTree, visibleColumnIds)=>visibleColumnIds.find((columnId)=>columnTree.columns[columnId].isDefaultAdd) || visibleColumnIds[0]);
const $c49ccf1362b2bff4$var$makeSummedDynamicColumnProperty = (accessor)=>(0, $dGvGJ.createSelector)($c49ccf1362b2bff4$export$9158bf17317ec5a3, (0, $bFTY1.getColumnTree), (visibleColumnIds, columnTree)=>visibleColumnIds.map((columnId)=>accessor(columnTree.columns[columnId])).reduce((a, b)=>a + b, 0));
const $c49ccf1362b2bff4$export$b87f4bf1dea22966 = $c49ccf1362b2bff4$var$makeSummedDynamicColumnProperty((column)=>column.maxWidth);
const $c49ccf1362b2bff4$export$2143bc4b2542ea5d = $c49ccf1362b2bff4$var$makeSummedDynamicColumnProperty((column)=>column.minWidth);
const $c49ccf1362b2bff4$export$65784ca6b29dc2a3 = (state)=>$c49ccf1362b2bff4$export$341d8012284373b1(state).LoadingRowComponent;
const $c49ccf1362b2bff4$export$379c1b3c8c56422e = (state)=>$c49ccf1362b2bff4$export$341d8012284373b1(state).facade;
const $c49ccf1362b2bff4$export$f4b00b57da9022eb = (state)=>$c49ccf1362b2bff4$export$379c1b3c8c56422e(state) === (0, $be36c2c2b492883c$export$88a597d0c7ae97b);
const $c49ccf1362b2bff4$export$428877d41520e34c = (state)=>$c49ccf1362b2bff4$export$379c1b3c8c56422e(state) === (0, $be36c2c2b492883c$export$1d9e930504ed3ddf);
const $c49ccf1362b2bff4$export$47cf89187102921d = (state)=>$c49ccf1362b2bff4$export$f4b00b57da9022eb(state);
const $c49ccf1362b2bff4$export$bd19afa7f02ff55d = (state)=>(0, $co1wz.ff)('platform.queue-page-error-boundaries_ro9zq') ? $c49ccf1362b2bff4$export$341d8012284373b1(state).premiumSLAColumnIds : undefined;

});
const $be36c2c2b492883c$export$88a597d0c7ae97b = 'TABLE';
const $be36c2c2b492883c$export$1d9e930504ed3ddf = 'TREE_TABLE';

parcelRegister("9f4YM", function(module, exports) {

$parcel$export(module.exports, "default", () => $645ada7d8f5e716e$export$2e2bcd8739ae039);

var $dtHSS = parcelRequire("dtHSS");
const $645ada7d8f5e716e$var$traverseColumns = (columnTree, columnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result)=>{
    (0, $dtHSS.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const childrenIds = (expandedColumnIdsHash[columnId] ? columnTree.columns[columnId].childrenIds : []) || [];
        if (!hiddenColumnIdsHash[columnId]) {
            result.push(columnId);
            $645ada7d8f5e716e$var$traverseColumns(columnTree, childrenIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result);
        }
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$645ada7d8f5e716e$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds)=>{
    const result = [];
    $645ada7d8f5e716e$var$traverseColumns(columnTree, rootColumnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result);
    return result;
};

});
parcelRegister("dtHSS", function(module, exports) {

$parcel$export(module.exports, "default", () => $378309330aaf7cdd$export$2e2bcd8739ae039);

var $7OFAf = parcelRequire("7OFAf");

var $k8IPx = parcelRequire("k8IPx");

var $4wVpT = parcelRequire("4wVpT");
const $378309330aaf7cdd$var$getLevelIds = (sortedColumnIds, columnIds)=>{
    if (sortedColumnIds === undefined) return columnIds;
    const levelIdsNotInSortedArray = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(columnIds, sortedColumnIds);
    const sortedIdsInLevel = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(sortedColumnIds, columnIds);
    /*  to cope with inconsistent data provided by the consumer - in case of overridden column sort order,
        we append ids that exist in the current level array but not in the sorted array (override), at the end.
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($7OFAf)))(sortedIdsInLevel, levelIdsNotInSortedArray);
};
var $378309330aaf7cdd$export$2e2bcd8739ae039 = $378309330aaf7cdd$var$getLevelIds;

});
parcelRegister("7OFAf", function(module, exports) {

var $2Z8Cv = parcelRequire("2Z8Cv");

var $ekcP3 = parcelRequire("ekcP3");

var $jHlUS = parcelRequire("jHlUS");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */ function $5b0d7592c3de24e2$var$concat() {
    var length = arguments.length;
    if (!length) return [];
    var args = Array(length - 1), array = arguments[0], index = length;
    while(index--)args[index - 1] = arguments[index];
    return $2Z8Cv($8LQ84(array) ? $jHlUS(array) : [
        array
    ], $ekcP3(args, 1));
}
module.exports = $5b0d7592c3de24e2$var$concat;

});



parcelRegister("bFTY1", function(module, exports) {

$parcel$export(module.exports, "getColumnTree", () => $816879fb8b79b106$export$626e2d661dbdbb1e);
$parcel$export(module.exports, "getColumnWidths", () => $816879fb8b79b106$export$e54c9225ca52acc);
$parcel$export(module.exports, "getDefaultComparator", () => $816879fb8b79b106$export$db92824abfb21a2e);
$parcel$export(module.exports, "getSortedColumnIds", () => $816879fb8b79b106$export$9286093f6e1ecac);
$parcel$export(module.exports, "getCellComponent", () => $816879fb8b79b106$export$cc7ae951af4ebc4e);
$parcel$export(module.exports, "getExpandedColumnIdsHash", () => $816879fb8b79b106$export$973bd9cbde2d338d);
$parcel$export(module.exports, "getHiddenColumnsLookupHash", () => $816879fb8b79b106$export$a6f67a8a23dbf9a1);
$parcel$export(module.exports, "getVisibleCoreColumnIds", () => $816879fb8b79b106$export$489e7298b8651c2e);
$parcel$export(module.exports, "getVisibleCoreColumnsWidth", () => $816879fb8b79b106$export$987e0cd3ec211c8);
$parcel$export(module.exports, "getColumnConfiguration", () => $816879fb8b79b106$export$3d6f7f2469223338);
$parcel$export(module.exports, "getColumnTitle", () => $816879fb8b79b106$export$7fd4bf39bc1fa7d6);
$parcel$export(module.exports, "getColumnHeaderComponent", () => $816879fb8b79b106$export$b4e69e5204b2a3b0);
$parcel$export(module.exports, "getColumnTooltip", () => $816879fb8b79b106$export$b165f1ee654a6c88);
$parcel$export(module.exports, "getColumnMinWidth", () => $816879fb8b79b106$export$76d9570454343133);
$parcel$export(module.exports, "getColumnColor", () => $816879fb8b79b106$export$cf34af5efc32c51);
$parcel$export(module.exports, "getColumnHasChildren", () => $816879fb8b79b106$export$55dbcdc822375b7c);
$parcel$export(module.exports, "getColumnParentId", () => $816879fb8b79b106$export$a63e62bf5f23be09);
$parcel$export(module.exports, "isColumnExpanded", () => $816879fb8b79b106$export$fd339f76e0ca945c);
$parcel$export(module.exports, "isColumnSortable", () => $816879fb8b79b106$export$19a1e000b0c7f615);
$parcel$export(module.exports, "isParentColumn", () => $816879fb8b79b106$export$d5f9813bca43da33);
$parcel$export(module.exports, "isChildColumn", () => $816879fb8b79b106$export$3289971ebd775b18);
$parcel$export(module.exports, "getParentId", () => $816879fb8b79b106$export$e6e327a97512715e);
$parcel$export(module.exports, "isFirstColumn", () => $816879fb8b79b106$export$d3671a4f3687bed);
$parcel$export(module.exports, "isVisibleCoreColumn", () => $816879fb8b79b106$export$3180485c5d58c720);
$parcel$export(module.exports, "canCellBeMultiLine", () => $816879fb8b79b106$export$f36235907d788d9d);
$parcel$export(module.exports, "hasAnyMultiLineColumn", () => $816879fb8b79b106$export$893dde5c71a334bb);
$parcel$export(module.exports, "getAllColumnIds", () => $816879fb8b79b106$export$373740f91e6ef0b9);

var $dGvGJ = parcelRequire("dGvGJ");

var $27NS3 = parcelRequire("27NS3");

var $1v8kM = parcelRequire("1v8kM");

var $3n1p3 = parcelRequire("3n1p3");

var $9f4YM = parcelRequire("9f4YM");

var $dx7kr = parcelRequire("dx7kr");
const $816879fb8b79b106$export$626e2d661dbdbb1e = (state)=>state.consumer.columnTree;
const $816879fb8b79b106$export$d6f73af294120ea1 = (state)=>state.consumer.expandedColumnIds;
const $816879fb8b79b106$export$701fee8fc287bd90 = (state)=>state.consumer.hiddenColumnIds;
const $816879fb8b79b106$export$e54c9225ca52acc = (state)=>state.consumer.columnWidths;
const $816879fb8b79b106$export$7a380d7d28b470cc = (state)=>state.consumer.columnComparators;
const $816879fb8b79b106$export$db92824abfb21a2e = (state)=>state.consumer.defaultComparator;
const $816879fb8b79b106$export$6dd907dd5b1dc40e = (state)=>state.consumer.minAdditionalColumnsWidth;
const $816879fb8b79b106$export$9286093f6e1ecac = (state)=>state.consumer.sortedColumnIds;
const $816879fb8b79b106$export$cc7ae951af4ebc4e = (state, columnId)=>$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].CellComponent;
const $816879fb8b79b106$export$78d02608cba67d5b = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$db92824abfb21a2e, $816879fb8b79b106$export$7a380d7d28b470cc, (defaultComparator, columnComparators)=>(0, $1v8kM.default)(defaultComparator, columnComparators));
const $816879fb8b79b106$export$973bd9cbde2d338d = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$d6f73af294120ea1, (expandedColumnIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    expandedColumnIds.reduce((acc, next)=>{
        // for effeciency sake we are mutating the accumulator to build up our hash
        acc[next] = true;
        return acc;
    }, {}));
const $816879fb8b79b106$export$a6f67a8a23dbf9a1 = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$701fee8fc287bd90, (hiddenColumnIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(hiddenColumnIds, (hash, id)=>({
            ...hash,
            [id]: true
        }), {}));
const $816879fb8b79b106$export$489e7298b8651c2e = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$626e2d661dbdbb1e, $816879fb8b79b106$export$973bd9cbde2d338d, $816879fb8b79b106$export$a6f67a8a23dbf9a1, $816879fb8b79b106$export$9286093f6e1ecac, (columnTree, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds)=>(0, $9f4YM.default)(columnTree, columnTree.rootCoreIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds));
const $816879fb8b79b106$export$987e0cd3ec211c8 = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$489e7298b8651c2e, $816879fb8b79b106$export$626e2d661dbdbb1e, $816879fb8b79b106$export$e54c9225ca52acc, (coreColumns, columnTree, columnWidths)=>coreColumns.length === 0 ? 0 : coreColumns.reduce((acc, columnId)=>{
        const columnWidth = columnWidths[columnId] || columnTree.columns[columnId].defaultWidth;
        return acc + columnWidth;
    }, 54));
const $816879fb8b79b106$export$3d6f7f2469223338 = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$626e2d661dbdbb1e, $816879fb8b79b106$export$a6f67a8a23dbf9a1, $816879fb8b79b106$export$9286093f6e1ecac, (columnTree, hiddenColumnIdsHash, sortedColumnIds)=>(0, $dx7kr.default)(columnTree, columnTree.rootCoreIds.concat(columnTree.rootAdditionalIds), hiddenColumnIdsHash, sortedColumnIds));
const $816879fb8b79b106$export$d12de2db7af15c1f = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$489e7298b8651c2e, (visibleCoreColumnIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(visibleCoreColumnIds, (hash, id)=>({
            ...hash,
            [id]: true
        }), {}));
const $816879fb8b79b106$export$7fd4bf39bc1fa7d6 = (state, columnId)=>$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].title;
const $816879fb8b79b106$export$b4e69e5204b2a3b0 = (state, columnId)=>$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].HeaderComponent;
const $816879fb8b79b106$export$b165f1ee654a6c88 = (state, columnId)=>$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].tooltip;
const $816879fb8b79b106$export$76d9570454343133 = (state, columnId)=>{
    const columnTree = $816879fb8b79b106$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].minWidth;
};
const $816879fb8b79b106$export$134c72f8153b1472 = (state, columnId)=>{
    const columnTree = $816879fb8b79b106$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].maxWidth;
};
const $816879fb8b79b106$export$cf34af5efc32c51 = (state, columnId)=>$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].color || '#333';
const $816879fb8b79b106$export$55dbcdc822375b7c = (state, columnId)=>{
    const columnTree = $816879fb8b79b106$export$626e2d661dbdbb1e(state);
    return !!columnTree.columns[columnId].childrenIds && // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    columnTree.columns[columnId].childrenIds.length > 0;
};
const $816879fb8b79b106$export$a63e62bf5f23be09 = (state, columnId)=>{
    const columnTree = $816879fb8b79b106$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].parentId;
};
const $816879fb8b79b106$export$588980822120b07b = (state, columnId)=>$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].resizeStrategy;
const $816879fb8b79b106$export$fd339f76e0ca945c = (state, columnId)=>{
    const expandedColumnIdsHash = $816879fb8b79b106$export$973bd9cbde2d338d(state);
    return !!expandedColumnIdsHash[columnId];
};
const $816879fb8b79b106$export$19a1e000b0c7f615 = (state, columnId)=>{
    const columnComparators = $816879fb8b79b106$export$7a380d7d28b470cc(state);
    return !!columnComparators[columnId];
};
const $816879fb8b79b106$export$d5f9813bca43da33 = (state, columnId)=>!!$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].childrenIds;
const $816879fb8b79b106$export$3289971ebd775b18 = (state, columnId)=>!!$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].parentId;
const $816879fb8b79b106$export$e6e327a97512715e = (state, columnId)=>$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].parentId;
const $816879fb8b79b106$export$d3671a4f3687bed = (state, columnId)=>$816879fb8b79b106$export$489e7298b8651c2e(state)[0] === columnId;
const $816879fb8b79b106$export$3180485c5d58c720 = (state, columnId)=>{
    const visibleColumnsLookupHash = $816879fb8b79b106$export$d12de2db7af15c1f(state);
    return !!visibleColumnsLookupHash[columnId];
};
const $816879fb8b79b106$export$f36235907d788d9d = (state, columnId)=>$816879fb8b79b106$export$626e2d661dbdbb1e(state).columns[columnId].canBeMultiLine || false;
const $816879fb8b79b106$export$893dde5c71a334bb = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$626e2d661dbdbb1e, (columnTree)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const columns = Object.values(columnTree.columns);
    return columns.filter((column)=>column.canBeMultiLine).length > 0;
});
const $816879fb8b79b106$export$1e5039fcef278b0d = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$626e2d661dbdbb1e, (columnTree)=>[
        ...columnTree.rootCoreIds,
        ...columnTree.rootAdditionalIds
    ]);
const $816879fb8b79b106$export$373740f91e6ef0b9 = (0, $dGvGJ.createSelector)($816879fb8b79b106$export$9286093f6e1ecac, $816879fb8b79b106$export$626e2d661dbdbb1e, $816879fb8b79b106$export$1e5039fcef278b0d, (sortedColumnIds, columnTree, rootColumnIds)=>(0, $3n1p3.default)(columnTree, rootColumnIds, sortedColumnIds));

});
parcelRegister("27NS3", function(module, exports) {

var $2YkAc = parcelRequire("2YkAc");

var $e7pfQ = parcelRequire("e7pfQ");

var $bxDef = parcelRequire("bxDef");

var $87mh8 = parcelRequire("87mh8");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
    var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
    return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
}
module.exports = $18c2eb891b6f17d9$var$reduce;

});
parcelRegister("87mh8", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $5e90419f1ca7764f$var$baseReduce;

});


parcelRegister("1v8kM", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c43b616f233e4c$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$20c43b616f233e4c$export$2e2bcd8739ae039 = (defaultComparator, columnComparators)=>{
    if (!defaultComparator) return undefined;
    return typeof defaultComparator === 'function' ? defaultComparator : columnComparators[defaultComparator];
};

});

parcelRegister("3n1p3", function(module, exports) {

$parcel$export(module.exports, "default", () => $05f0170c6f3e47b6$export$2e2bcd8739ae039);

var $dtHSS = parcelRequire("dtHSS");
const $05f0170c6f3e47b6$var$traverseColumns = (columnTree, columnIds, sortedColumnIds, result)=>{
    (0, $dtHSS.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const childrenIds = columnTree.columns[columnId].childrenIds || [];
        result.push(columnId);
        $05f0170c6f3e47b6$var$traverseColumns(columnTree, childrenIds, sortedColumnIds, result);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$05f0170c6f3e47b6$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, sortedColumnIds)=>{
    const result = [];
    $05f0170c6f3e47b6$var$traverseColumns(columnTree, rootColumnIds, sortedColumnIds, result);
    return result;
};

});

parcelRegister("dx7kr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4e472c6aedd5d1$export$2e2bcd8739ae039);

var $2aM3q = parcelRequire("2aM3q");

var $dtHSS = parcelRequire("dtHSS");
const $fe4e472c6aedd5d1$var$traverseColumns = (columnTree, columnIds, hiddenColumnIdsHash, sortedColumnIds, result)=>{
    (0, $dtHSS.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const column = columnTree.columns[columnId];
        const { parentId: parentId } = column;
        const isParentHidden = parentId ? !!hiddenColumnIdsHash[parentId] : false;
        const columnConfiguration = {
            id: column.id,
            title: column.title,
            // FSN-4987 Remove resize strategy related logic during cleanup
            resizeStrategy: column.resizeStrategy,
            isHidden: !!hiddenColumnIdsHash[columnId],
            isDisabled: column.isHideable === false,
            parentId: parentId,
            isParentHidden: isParentHidden,
            depth: (0, $2aM3q.default)(columnTree.columns, columnId)
        };
        if (!column.isMarkup) result.push(columnConfiguration);
        const childrenIds = column.childrenIds || [];
        $fe4e472c6aedd5d1$var$traverseColumns(columnTree, childrenIds, hiddenColumnIdsHash, sortedColumnIds, result);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe4e472c6aedd5d1$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, hiddenColumnIdsHash, sortedColumnIds)=>{
    const result = [];
    $fe4e472c6aedd5d1$var$traverseColumns(columnTree, rootColumnIds, hiddenColumnIdsHash, sortedColumnIds, result);
    return result;
};

});
parcelRegister("2aM3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c178330a32e83cd$export$2e2bcd8739ae039);

var $iLKwr = parcelRequire("iLKwr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c178330a32e83cd$export$2e2bcd8739ae039 = (tree, id)=>(0, $iLKwr.default)(tree, id).length - 1;

});
parcelRegister("iLKwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e11160c04315ced$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9e11160c04315ced$export$2e2bcd8739ae039 = (tree, id)=>{
    const path = [
        id
    ];
    let currentId = id;
    while(tree[currentId].parentId){
        const { parentId: parentId } = tree[currentId];
        // @ts-expect-error - TS2345 - Argument of type 'Optional<string>' is not assignable to parameter of type 'string'.
        path.unshift(parentId);
        // @ts-expect-error - TS2322 - Type 'Optional<string>' is not assignable to type 'string'.
        currentId = parentId;
    }
    return path;
};

});





parcelRegister("5J7ao", function(module, exports) {

$parcel$export(module.exports, "getActiveItem", () => $63285b27f590f36e$export$f0f14253205ef68f);
$parcel$export(module.exports, "getActiveRow", () => $63285b27f590f36e$export$be515f6e1df61362);
$parcel$export(module.exports, "getActiveCell", () => $63285b27f590f36e$export$70059ae5084357cb);
$parcel$export(module.exports, "getResizingColumnId", () => $63285b27f590f36e$export$db5a621909f822c0);
$parcel$export(module.exports, "getVerticalScrollOffset", () => $63285b27f590f36e$export$76e51b2d87e066ab);
$parcel$export(module.exports, "hasVerticallyScrolled", () => $63285b27f590f36e$export$e7c447ae7e47068f);
$parcel$export(module.exports, "getHorizontalScrollOffset", () => $63285b27f590f36e$export$624a30c8322e672b);
$parcel$export(module.exports, "getIsSortOverrideEnabled", () => $63285b27f590f36e$export$97b55762fc1eba7f);
$parcel$export(module.exports, "getShouldUseCssForRendering", () => $63285b27f590f36e$export$94ad9100e15f7253);
$parcel$export(module.exports, "getTableHeight", () => $63285b27f590f36e$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "getTableWidth", () => $63285b27f590f36e$export$4910020ffe58186f);
$parcel$export(module.exports, "getTableWidthWithoutScrollbarOffset", () => $63285b27f590f36e$export$cbeeb8058672c78a);
$parcel$export(module.exports, "getTableRowMargin", () => $63285b27f590f36e$export$a388e245e4b1a116);
$parcel$export(module.exports, "getDraggingRowId", () => $63285b27f590f36e$export$fdc0e8ca65eb11e);
$parcel$export(module.exports, "getActiveSortedColumnConfiguration", () => $63285b27f590f36e$export$eaa5c021c57b0ffd);
$parcel$export(module.exports, "getSortedRowIdsHash", () => $63285b27f590f36e$export$204c73f66abde0fb);
$parcel$export(module.exports, "getHeaderHeight", () => $63285b27f590f36e$export$98ba287114e9d0c3);
$parcel$export(module.exports, "getRenderSidebarIcon", () => $63285b27f590f36e$export$a0841f9badd7cdca);

const $63285b27f590f36e$export$f0f14253205ef68f = (state)=>state.internal.activeItem;
const $63285b27f590f36e$export$be515f6e1df61362 = (state)=>{
    const activeItem = $63285b27f590f36e$export$f0f14253205ef68f(state);
    return activeItem && activeItem.type === (0, $b7a603c640ae8033$export$8a257aa81ef4a9e0) ? activeItem : undefined;
};
const $63285b27f590f36e$export$70059ae5084357cb = (state)=>{
    const activeItem = $63285b27f590f36e$export$f0f14253205ef68f(state);
    return activeItem && activeItem.type === (0, $b7a603c640ae8033$export$4b3489234fd17200) ? activeItem : undefined;
};
const $63285b27f590f36e$export$db5a621909f822c0 = (state)=>state.internal.resizingColumnId;
const $63285b27f590f36e$export$76e51b2d87e066ab = (state)=>state.internal.verticalScrollOffset;
const $63285b27f590f36e$export$e7c447ae7e47068f = (state)=>state.internal.verticalScrollOffset > 0;
const $63285b27f590f36e$export$becdfc8521c14ad2 = (state)=>state.internal.verticalScrollDelta;
const $63285b27f590f36e$export$624a30c8322e672b = (state)=>state.internal.horizontalScrollOffset;
const $63285b27f590f36e$export$97b55762fc1eba7f = (state)=>state.internal.isSortOverrideEnabled;
const $63285b27f590f36e$export$94ad9100e15f7253 = (state)=>state.internal.shouldUseCssForRendering;
const $63285b27f590f36e$export$af7a4f73692b1459 = (state)=>state.internal.tableSize;
const $63285b27f590f36e$export$81ff4c821ba5ba90 = (state)=>$63285b27f590f36e$export$af7a4f73692b1459(state).height;
const $63285b27f590f36e$export$4910020ffe58186f = (state)=>$63285b27f590f36e$export$af7a4f73692b1459(state).width;
const $63285b27f590f36e$export$cbeeb8058672c78a = (state)=>$63285b27f590f36e$export$af7a4f73692b1459(state).widthWithoutScrollbarOffset;
const $63285b27f590f36e$export$a388e245e4b1a116 = (state)=>$63285b27f590f36e$export$af7a4f73692b1459(state).rowMargin;
const $63285b27f590f36e$export$fdc0e8ca65eb11e = (state)=>state.internal.draggingRowId;
const $63285b27f590f36e$export$f0d8a9d6630b9103 = (state)=>state.internal.multiAddAnchorId;
const $63285b27f590f36e$export$eaa5c021c57b0ffd = (state)=>state.internal.activeSortedColumnConfiguration;
const $63285b27f590f36e$export$204c73f66abde0fb = (state)=>state.internal.sortedRowIdsHash;
const $63285b27f590f36e$export$728dbf35b325565b = (state)=>state.internal.scrollbarSize;
const $63285b27f590f36e$export$98ba287114e9d0c3 = (state)=>state.internal.headerHeight;
const $63285b27f590f36e$export$a0841f9badd7cdca = (state)=>state.internal.renderSidebarIcon;

});

parcelRegister("iN58L", function(module, exports) {

$parcel$export(module.exports, "getRowDepth", () => $2390827df6c800a7$export$d9790c6d67ace138);
$parcel$export(module.exports, "getVisibleLoadingRowIds", () => $2390827df6c800a7$export$79bc68636023e019);
$parcel$export(module.exports, "isAddLinkShown", () => $2390827df6c800a7$export$f1f55f40e2397801);
$parcel$export(module.exports, "isGlobalAddEnabled", () => $2390827df6c800a7$export$53bdd4654b396c67);
$parcel$export(module.exports, "canLastRowAddSiblingOrChildren", () => $2390827df6c800a7$export$7c458dc02abd8dc7);
$parcel$export(module.exports, "getTableHeight", () => $2390827df6c800a7$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "getTableContentWidth", () => $2390827df6c800a7$export$bf1a6d4805ae1aa3);
$parcel$export(module.exports, "getTableContentHeight", () => $2390827df6c800a7$export$6d30ea7d886d20a8);
$parcel$export(module.exports, "getTableRowsHeight", () => $2390827df6c800a7$export$508de1ea1f8be016);
$parcel$export(module.exports, "getHorizontalScrollWidth", () => $2390827df6c800a7$export$59e4df7bc874f4dc);
$parcel$export(module.exports, "getColumn", () => $2390827df6c800a7$export$c9dd4bee4ae86f53);
$parcel$export(module.exports, "getColumnWidth", () => $2390827df6c800a7$export$dfa11a34ceba822);
$parcel$export(module.exports, "getScrollOffsetForRowIndex", () => $2390827df6c800a7$export$7f5dc96b25afd50);
$parcel$export(module.exports, "hasHorizontalScrollbar", () => $2390827df6c800a7$export$35f00941c70ac98c);
$parcel$export(module.exports, "hasVerticalScrollbar", () => $2390827df6c800a7$export$5ce15b832a232abf);
$parcel$export(module.exports, "isHorizontalScrollLeftShadowVisible", () => $2390827df6c800a7$export$482d647122d9850d);
$parcel$export(module.exports, "getMaxHorizontalScrollOffset", () => $2390827df6c800a7$export$9854f9aebd7abc1c);
$parcel$export(module.exports, "isHorizontalScrollRightShadowVisible", () => $2390827df6c800a7$export$a5fd1dde37333151);
$parcel$export(module.exports, "getVisibleAdditionalColumnsWidth", () => $2390827df6c800a7$export$c17b791581a1b518);
$parcel$export(module.exports, "getOffsetFromBottom", () => $2390827df6c800a7$export$8d5a56e5651cf107);
$parcel$export(module.exports, "getOffsetFromTop", () => $2390827df6c800a7$export$302e8799c65ec80);
$parcel$export(module.exports, "getOffsetFromLeft", () => $2390827df6c800a7$export$be46d880d5c67a2f);
$parcel$export(module.exports, "getOffsetFromRight", () => $2390827df6c800a7$export$cdbbb229c03c4259);
$parcel$export(module.exports, "getColumnSortOrder", () => $2390827df6c800a7$export$28e014ec3d91f1b2);
$parcel$export(module.exports, "getShouldVirtualize", () => $2390827df6c800a7$export$75cdbb73a780df34);
$parcel$export(module.exports, "getVirtualBoundaries", () => $2390827df6c800a7$export$3ddd5b9a27496e14);
$parcel$export(module.exports, "getNumberOfLoadingRowsInDisplayBoundary", () => $2390827df6c800a7$export$15a684dfff6d5394);
$parcel$export(module.exports, "getActiveRowIndex", () => $2390827df6c800a7$export$b455bac95fd02aad);
$parcel$export(module.exports, "getNextActiveRowIndex", () => $2390827df6c800a7$export$7b06ecd71d436a71);
$parcel$export(module.exports, "getPrevActiveRowIndex", () => $2390827df6c800a7$export$c98fb65aaf1fa4f7);
$parcel$export(module.exports, "rowIndexToRowId", () => $2390827df6c800a7$export$7bf5553e96d8acb1);
$parcel$export(module.exports, "getActiveRowId", () => $2390827df6c800a7$export$f5e04ce1033f6b64);
$parcel$export(module.exports, "isActiveRowId", () => $2390827df6c800a7$export$4fad04245eebe683);
$parcel$export(module.exports, "isActiveRowItem", () => $2390827df6c800a7$export$9b16a7f2e1834f77);
$parcel$export(module.exports, "getSetFocusOnRow", () => $2390827df6c800a7$export$cff73bbfaa0526d1);
$parcel$export(module.exports, "isCellActive", () => $2390827df6c800a7$export$c14f48cad4f0ee46);
$parcel$export(module.exports, "shouldRowHydrateFully", () => $2390827df6c800a7$export$9b148117f6b512ea);

var $dGvGJ = parcelRequire("dGvGJ");

var $7s7lq = parcelRequire("7s7lq");

var $6hiB0 = parcelRequire("6hiB0");



var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $5J7ao = parcelRequire("5J7ao");

var $4XO5t = parcelRequire("4XO5t");
const $2390827df6c800a7$export$d9790c6d67ace138 = (state, rowId)=>{
    const rowDepthAndPath = (0, $3W7mX.getStaticRowPathAndDepth)(state);
    if ((0, $3W7mX.isRowBeingAdded)(state, rowId)) {
        // @ts-expect-error - TS2339 - Property 'anchorId' does not exist on type 'Optional<TemporaryAddedRow>'. | TS2339 - Property 'position' does not exist on type 'Optional<TemporaryAddedRow>'.
        const { anchorId: anchorId, position: position } = (0, $3W7mX.getTemporaryAddedRow)(state);
        if (anchorId) return position === 'INSIDE' ? rowDepthAndPath[anchorId].depth + 1 : rowDepthAndPath[anchorId].depth;
        /* FIRST or LAST rows will be designated to the highest level */ return 0;
    }
    if (rowDepthAndPath[rowId] === undefined) return 0;
    return rowDepthAndPath[rowId].depth;
};
const $2390827df6c800a7$export$79bc68636023e019 = (0, $dGvGJ.createSelector)((0, $4XO5t.getFlattenedWithAddedRowIds), (0, $3W7mX.getRowsConfiguration), (visibleRowIds, rowsConfiguration)=>visibleRowIds.filter((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (!rowConfiguration) return false;
        return rowConfiguration.isLoading;
    }));
const $2390827df6c800a7$export$f1f55f40e2397801 = (state)=>(0, $eeWa5.getRowAddCallback)(state) !== undefined && (0, $3W7mX.getAddLinkCaption)(state) !== undefined && !(0, $3W7mX.isAnyRowBeingAdded)(state);
const $2390827df6c800a7$export$53bdd4654b396c67 = (0, $dGvGJ.createSelector)((0, $eeWa5.getRowAddCallback), (0, $3W7mX.isAnyRowBeingAdded), (0, $5J7ao.getDraggingRowId), (rowAddCallback, rowBeingAdded, draggingRowId)=>rowAddCallback !== undefined && !rowBeingAdded && !draggingRowId);
const $2390827df6c800a7$export$ffaca24172efb7ca = (0, $dGvGJ.createSelector)((0, $5J7ao.getActiveSortedColumnConfiguration), (0, $bFTY1.getDefaultComparator), (0, $3W7mX.isAnyRowBeingAdded), (activeSortedColumnConfiguration, defaultComparator, anyRowBeingAdded)=>{
    if (anyRowBeingAdded) return false;
    // If we are sorted by something, it's still ok IF it would match the default sort order
    return !activeSortedColumnConfiguration || typeof defaultComparator === 'string' && activeSortedColumnConfiguration.columnId === defaultComparator && activeSortedColumnConfiguration.sortOrder === (0, $960a7067bff9d918$export$6e386ac144cffab5);
});
const $2390827df6c800a7$export$4835fe21099e222d = (state)=>state.consumer.draggableRows;
const $2390827df6c800a7$var$isDraggablePerRow = (0, $dGvGJ.createSelector)((0, $3W7mX.getRowTree), (0, $3W7mX.getRowsConfiguration), (rowTree, rowsConfiguration)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDraggableHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (rowConfiguration) // if it is configured on a per-row basis
        isDraggableHash[rowId] = rowConfiguration.isDraggable !== undefined ? rowConfiguration.isDraggable : true;
        else // if the callback is implemented, and it has not been
        // configured, default to allow dragging
        isDraggableHash[rowId] = true;
    });
    return isDraggableHash;
});
const $2390827df6c800a7$export$f04970757ee58393 = (state, rowId)=>$2390827df6c800a7$export$4835fe21099e222d(state) && $2390827df6c800a7$var$isDraggablePerRow(state)[rowId];
const $2390827df6c800a7$export$7c458dc02abd8dc7 = (state)=>{
    const rowIds = (0, $4XO5t.getFlattenedWithAddedRowIds)(state);
    const lastRowId = rowIds[rowIds.length - 1];
    const lastRowConfig = (0, $3W7mX.getRowsConfiguration)(state)[lastRowId];
    if (lastRowConfig) return (0, $3W7mX.getRowCanAddSibling)(state, lastRowId) || (0, $3W7mX.getRowCanAddChildren)(state, lastRowId);
    return false;
};
const $2390827df6c800a7$export$81ff4c821ba5ba90 = (0, $dGvGJ.createSelector)((0, $5J7ao.getTableHeight), (0, $4XO5t.getVisibleRowsCount), (0, $eeWa5.isAutoHeight), $2390827df6c800a7$export$f1f55f40e2397801, (0, $3W7mX.getAbsoluteRowHeight), $2390827df6c800a7$export$7c458dc02abd8dc7, (0, $3W7mX.getAddBarOverflow), (0, $5J7ao.getHeaderHeight), (tableHeightInternal, visibleRowsCount, autoHeight, addLinkShown, absoluteRowHeight, hasAddBar, addBarOverflow, headerHeight)=>{
    if (autoHeight) {
        const rowMultiplier = visibleRowsCount + (addLinkShown ? 1 : 0);
        return rowMultiplier * absoluteRowHeight + (hasAddBar || addLinkShown ? addBarOverflow : 0) + headerHeight;
    }
    return tableHeightInternal;
});
const $2390827df6c800a7$export$bf1a6d4805ae1aa3 = (0, $dGvGJ.createSelector)((0, $eeWa5.isDetailsPanelOpen), (0, $bFTY1.getVisibleCoreColumnsWidth), (0, $5J7ao.getTableWidth), (isDetailsOpen, visibleCoreColumnWidth, tableWidth)=>isDetailsOpen ? visibleCoreColumnWidth : tableWidth);
const $2390827df6c800a7$export$6d30ea7d886d20a8 = (state)=>Math.max(0, $2390827df6c800a7$export$81ff4c821ba5ba90(state) - (0, $5J7ao.getHeaderHeight)(state));
const $2390827df6c800a7$export$508de1ea1f8be016 = (0, $dGvGJ.createSelector)((0, $4XO5t.getVisibleRowsCount), (0, $3W7mX.getAbsoluteRowHeight), $2390827df6c800a7$export$7c458dc02abd8dc7, $2390827df6c800a7$export$f1f55f40e2397801, (0, $3W7mX.getAddBarOverflow), (visibleRowsCount, absoluteRowHeight, hasAddBar, addLinkShown, addBarOverflow)=>visibleRowsCount * absoluteRowHeight + (hasAddBar || addLinkShown ? addBarOverflow : 0));
const $2390827df6c800a7$export$59e4df7bc874f4dc = (state)=>(0, $5J7ao.getTableWidth)(state) - (0, $bFTY1.getVisibleCoreColumnsWidth)(state);
const $2390827df6c800a7$export$99ecae6d98dc3df3 = (0, $dGvGJ.createSelector)((0, $eeWa5.getTotalDynamicColumnMinWidth), (0, $eeWa5.getTotalDynamicColumnMaxWidth), (0, $bFTY1.getColumnTree), (0, $5J7ao.getTableWidthWithoutScrollbarOffset), (0, $5J7ao.getTableRowMargin), (0, $eeWa5.getVisibleColumnIds), (0, $bFTY1.getColumnWidths), (totalDynamicMinWidth, totalDynamicMaxWidth, columnTree, tableWidth, _rowMargin, visibleColumnIds)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    const totalStaticColumnWidth = 0;
    const distributableWidth = tableWidth - totalStaticColumnWidth;
    visibleColumnIds.forEach((columnId)=>{
        if (columnTree.columns[columnId] === undefined) return;
        if (totalDynamicMaxWidth <= distributableWidth) // Plenty of space; consume as much as possible
        result[columnId] = columnTree.columns[columnId].maxWidth;
        else if (totalDynamicMinWidth >= distributableWidth) // Less space than required; consume as little as possible
        result[columnId] = columnTree.columns[columnId].minWidth;
        else {
            // Between min & max; distribute remaining space based on relative min widths.
            const { minWidth: minWidth } = columnTree.columns[columnId];
            const { maxWidth: maxWidth } = columnTree.columns[columnId];
            const scalingFactor = (maxWidth - minWidth) / (totalDynamicMaxWidth - totalDynamicMinWidth);
            result[columnId] = Math.min(maxWidth, minWidth + scalingFactor * (distributableWidth - totalDynamicMinWidth));
        }
    });
    return result;
});
const $2390827df6c800a7$export$c9dd4bee4ae86f53 = (0, $dGvGJ.createSelector)((0, $bFTY1.getColumnTree), (_, p)=>p, (columnTree, columnId)=>{
    return columnTree.columns[columnId];
});
const $2390827df6c800a7$export$dfa11a34ceba822 = (state, columnId)=>$2390827df6c800a7$export$99ecae6d98dc3df3(state)[columnId];
const $2390827df6c800a7$export$96b57a8283901306 = (state)=>Math.round(Object.values($2390827df6c800a7$export$99ecae6d98dc3df3(state)).reduce((sum, width)=>sum + width, 0));
const $2390827df6c800a7$export$354f0f01a9ec3ab0 = (0, $dGvGJ.createSelector)((0, $4XO5t.getFlattenedWithAddedRowIds), (0, $3W7mX.getRowHeightMapping), (0, $3W7mX.getAbsoluteRowHeight), (visibleRowIds, rowHeightMapping, approximateRowHeight)=>{
    if (visibleRowIds.length === 0) return [];
    // We map heights to _start_ positions of the rows, hence starting
    // with "[0]" and deleting the last. We deliberately exclude the last
    // row.
    const rowPositions = [
        0
    ];
    for(let i = 0; i < visibleRowIds.length - 1; i += 1){
        const lastHeight = rowPositions[rowPositions.length - 1];
        const nextHeight = lastHeight + (rowHeightMapping[visibleRowIds[i]] || approximateRowHeight);
        rowPositions.push(nextHeight);
    }
    return rowPositions;
});
const $2390827df6c800a7$export$7f5dc96b25afd50 = (0, $dGvGJ.createSelector)($2390827df6c800a7$export$354f0f01a9ec3ab0, // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'rowIndex' implicitly has an 'any' type.
(_, rowIndex)=>rowIndex, (rowPositionArray, rowIndex)=>{
    if (rowIndex < 0) return 0;
    if (rowIndex >= rowPositionArray.length) return rowPositionArray[rowPositionArray.length - 1];
    return rowPositionArray[rowIndex];
});
const $2390827df6c800a7$export$e04c926b10911ac2 = (0, $dGvGJ.createSelector)($2390827df6c800a7$export$354f0f01a9ec3ab0, $2390827df6c800a7$export$6d30ea7d886d20a8, (0, $3W7mX.getRowHeightMapping), (0, $4XO5t.getFlattenedWithAddedRowIds), (rowPositionArray, tableHeight, rowHeightMapping, visibleRowIds)=>{
    const lastRowStartPosition = rowPositionArray[rowPositionArray.length - 1];
    const lastRowHeight = rowHeightMapping[visibleRowIds[visibleRowIds.length - 1]];
    return lastRowStartPosition + lastRowHeight - tableHeight;
});
const $2390827df6c800a7$export$35f00941c70ac98c = (0, $dGvGJ.createSelector)($2390827df6c800a7$export$96b57a8283901306, (0, $5J7ao.getTableWidthWithoutScrollbarOffset), (allColumnWidth, tableWidth)=>allColumnWidth > tableWidth);
const $2390827df6c800a7$export$5ce15b832a232abf = (state)=>$2390827df6c800a7$export$e04c926b10911ac2(state) > 0;
const $2390827df6c800a7$export$482d647122d9850d = (0, $dGvGJ.createSelector)((0, $eeWa5.isDetailsPanelOpen), (0, $5J7ao.getHorizontalScrollOffset), (isDetailsOpen, horizontalScrollOffset)=>!isDetailsOpen && horizontalScrollOffset > 0);
const $2390827df6c800a7$export$9854f9aebd7abc1c = (0, $dGvGJ.createSelector)($2390827df6c800a7$export$96b57a8283901306, (0, $5J7ao.getTableWidthWithoutScrollbarOffset), (allColumnWidth, tableWidth)=>allColumnWidth - tableWidth);
const $2390827df6c800a7$export$a5fd1dde37333151 = (0, $dGvGJ.createSelector)((0, $eeWa5.isDetailsPanelOpen), (0, $5J7ao.getHorizontalScrollOffset), $2390827df6c800a7$export$9854f9aebd7abc1c, (isDetailsOpen, horizontalScrollOffset, maxHorizontalScrollOffset)=>!isDetailsOpen && horizontalScrollOffset < maxHorizontalScrollOffset);
const $2390827df6c800a7$export$c17b791581a1b518 = (0, $dGvGJ.createSelector)((0, $eeWa5.getVisibleAdditionalColumnIds), $2390827df6c800a7$export$99ecae6d98dc3df3, (additionalColumns, columnWidthHash)=>additionalColumns.reduce((acc, columnId)=>acc + columnWidthHash[columnId], 0));
const $2390827df6c800a7$export$a4a1496398ad37a = (distance)=>Math.max(0, Math.floor(distance));
const $2390827df6c800a7$export$8d5a56e5651cf107 = (state)=>$2390827df6c800a7$export$a4a1496398ad37a($2390827df6c800a7$export$e04c926b10911ac2(state) - (0, $5J7ao.getVerticalScrollOffset)(state));
const $2390827df6c800a7$export$302e8799c65ec80 = (state)=>$2390827df6c800a7$export$a4a1496398ad37a((0, $5J7ao.getVerticalScrollOffset)(state));
const $2390827df6c800a7$export$be46d880d5c67a2f = (state)=>$2390827df6c800a7$export$a4a1496398ad37a((0, $5J7ao.getHorizontalScrollOffset)(state));
const $2390827df6c800a7$export$cdbbb229c03c4259 = (state)=>$2390827df6c800a7$export$a4a1496398ad37a($2390827df6c800a7$export$9854f9aebd7abc1c(state) - (0, $5J7ao.getHorizontalScrollOffset)(state));
const $2390827df6c800a7$var$getSortOrderForColumns = (0, $dGvGJ.createSelector)((0, $bFTY1.getColumnTree), (0, $bFTY1.getDefaultComparator), (0, $5J7ao.getActiveSortedColumnConfiguration), (columnTree, defaultComparator, activeSortedColumnConfiguration)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const columnSortOrderHash = {};
    if (activeSortedColumnConfiguration === undefined) {
        /* When the default comparator is specified as a column id,
			 * rather than the function, we have to be explicit since
			 * sorting behaviour differs. In this case, if not actively
			 * sorting by anything, we are actively sorting by the default
			 * column (compared to passively).
			 */ if (typeof defaultComparator === 'string') columnSortOrderHash[defaultComparator] = (0, $960a7067bff9d918$export$6e386ac144cffab5);
        return columnSortOrderHash;
    }
    Object.keys(columnTree.columns).forEach((columnId)=>{
        // need to check truthy-ness again since flow disregards check outside a function call
        if (activeSortedColumnConfiguration !== undefined && columnId === activeSortedColumnConfiguration.columnId) columnSortOrderHash[columnId] = activeSortedColumnConfiguration.sortOrder;
    });
    return columnSortOrderHash;
});
const $2390827df6c800a7$export$28e014ec3d91f1b2 = (state, columnId)=>$2390827df6c800a7$var$getSortOrderForColumns(state)[columnId];
const $2390827df6c800a7$var$DEFAULT_BOUNDARIES = {
    visibleStart: 0,
    visibleEnd: 0,
    displayStart: 0,
    displayEnd: 0
};
const $2390827df6c800a7$var$DEFAULT_BUFFER_SIZE = 5;
const $2390827df6c800a7$var$getVisibleRowIndexAtOffset = (rowPositions, offsetPosition)=>{
    if (rowPositions.length === 0) return 0;
    // sortedIndex for log(n) performance.
    const idx = (0, (/*@__PURE__*/$parcel$interopDefault($7s7lq)))(rowPositions, offsetPosition);
    // sortedIndex always returns the position after the equality. To make
    // this easier to reason about, we'll check whether the index prior starts
    // at exactly the offsetPosition, and return that instead if it does.
    if (rowPositions[idx] === offsetPosition) return idx;
    return idx - 1;
};
const $2390827df6c800a7$var$calculateVirtualBoundaries = (rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize, virtualBufferSize)=>{
    if (contentHeight === 0 || rowIds.length === 0) return $2390827df6c800a7$var$DEFAULT_BOUNDARIES;
    const numberOfTotalRows = rowIds.length - 1;
    const visibleStart = Math.max($2390827df6c800a7$var$getVisibleRowIndexAtOffset(rowPositionArray, scrollTop), 0);
    const visibleEnd = Math.min($2390827df6c800a7$var$getVisibleRowIndexAtOffset(rowPositionArray, scrollTop + contentHeight), numberOfTotalRows);
    const bufferSize = shouldVirtualize ? virtualBufferSize : numberOfTotalRows;
    // if the total number of rows is rather small (up to the provided threshold) then we render all, always.
    const displayStart = Math.max(0, visibleStart - bufferSize);
    const displayEnd = Math.min(visibleEnd + bufferSize, numberOfTotalRows);
    return {
        visibleStart: visibleStart,
        visibleEnd: visibleEnd,
        displayStart: displayStart,
        displayEnd: displayEnd
    };
};
const $2390827df6c800a7$export$75cdbb73a780df34 = (0, $dGvGJ.createSelector)((0, $eeWa5.isTableFacade), (0, $4XO5t.getFlattenedWithAddedRowIds), (0, $eeWa5.getShouldSkipVirtualization), (tableFacade, rowIds, shouldSkipVirtualization)=>{
    if (shouldSkipVirtualization ?? false) return false;
    return tableFacade || rowIds.length > (0, $6hiB0.minRowsForTreeTableVirtualisation);
});
const $2390827df6c800a7$export$3ddd5b9a27496e14 = (0, $dGvGJ.createSelector)((0, $4XO5t.getFlattenedWithAddedRowIds), (0, $5J7ao.getVerticalScrollOffset), $2390827df6c800a7$export$6d30ea7d886d20a8, $2390827df6c800a7$export$354f0f01a9ec3ab0, $2390827df6c800a7$export$75cdbb73a780df34, (rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize)=>// render all rows when there are not more than minRowsForVirtualisation
    $2390827df6c800a7$var$calculateVirtualBoundaries(rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize, $2390827df6c800a7$var$DEFAULT_BUFFER_SIZE));
const $2390827df6c800a7$export$1e9cf27313ff3cdf = (0, $dGvGJ.createSelector)((0, $4XO5t.getFlattenedWithAddedRowIds), (0, $3W7mX.getRowsConfiguration), $2390827df6c800a7$export$3ddd5b9a27496e14, (visibleRowIds, rowsConfiguration, virtualBoundaries)=>{
    const { displayStart: displayStart, displayEnd: displayEnd } = virtualBoundaries;
    return visibleRowIds.slice(displayStart, displayEnd).filter((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (!rowConfiguration) return false;
        return rowConfiguration.isLoading;
    });
});
const $2390827df6c800a7$export$15a684dfff6d5394 = (state)=>$2390827df6c800a7$export$1e9cf27313ff3cdf(state).length;
const $2390827df6c800a7$export$b455bac95fd02aad = (state)=>{
    const activeItem = (0, $5J7ao.getActiveItem)(state);
    if (activeItem && activeItem.type === (0, $b7a603c640ae8033$export$8a257aa81ef4a9e0)) return activeItem.rowIndex;
    if (activeItem && activeItem.type === (0, $b7a603c640ae8033$export$4b3489234fd17200)) return (0, $4XO5t.getVisibleIndexForRowId)(state, activeItem.rowId);
    return undefined;
};
const $2390827df6c800a7$export$7b06ecd71d436a71 = (state)=>{
    const currRow = $2390827df6c800a7$export$b455bac95fd02aad(state);
    if (currRow === undefined) return 0;
    const lastVisibleRow = (0, $4XO5t.getVisibleRowsCount)(state) - 1;
    return Math.min(currRow + 1, lastVisibleRow);
};
const $2390827df6c800a7$export$c98fb65aaf1fa4f7 = (state)=>{
    const currRow = $2390827df6c800a7$export$b455bac95fd02aad(state);
    if (currRow === undefined) return 0;
    return Math.max(currRow - 1, 0);
};
const $2390827df6c800a7$export$7bf5553e96d8acb1 = (state, rowIndex)=>{
    const visibleRowIds = (0, $4XO5t.getFlattenedWithAddedRowIds)(state);
    return rowIndex == null ? undefined : visibleRowIds[rowIndex];
};
const $2390827df6c800a7$export$f5e04ce1033f6b64 = (state)=>{
    const activeItem = (0, $5J7ao.getActiveItem)(state);
    if (!activeItem) return undefined;
    switch(activeItem.type){
        case 0, $b7a603c640ae8033$export$4b3489234fd17200:
            return activeItem.rowId;
        case 0, $b7a603c640ae8033$export$8a257aa81ef4a9e0:
            {
                const { rowIndex: rowIndex } = activeItem;
                return $2390827df6c800a7$export$7bf5553e96d8acb1(state, rowIndex);
            }
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            activeItem;
            return undefined;
    }
};
const $2390827df6c800a7$export$4fad04245eebe683 = (state, rowId)=>$2390827df6c800a7$export$f5e04ce1033f6b64(state) === rowId;
const $2390827df6c800a7$export$9b16a7f2e1834f77 = (state, rowId)=>(0, $eeWa5.isInRowNavigationMode)(state) && $2390827df6c800a7$export$4fad04245eebe683(state, rowId);
const $2390827df6c800a7$export$cff73bbfaa0526d1 = (state, rowId)=>{
    const activeRow = (0, $5J7ao.getActiveRow)(state);
    return !!activeRow && $2390827df6c800a7$export$4fad04245eebe683(state, rowId) && !!activeRow.setFocusOnRow;
};
const $2390827df6c800a7$export$c14f48cad4f0ee46 = (state, rowId, columnId)=>{
    const activeItem = (0, $5J7ao.getActiveCell)(state);
    return !!activeItem && activeItem.rowId === rowId && activeItem.columnId === columnId;
};
const $2390827df6c800a7$export$eca20d464f1d2890 = (0, $dGvGJ.createSelector)((0, $4XO5t.getFlattenedWithAddedRowIds), $2390827df6c800a7$export$b455bac95fd02aad, (visibleRowIds, activeRowIndex)=>{
    if (activeRowIndex === undefined || activeRowIndex >= visibleRowIds.length) return [];
    return [
        ...Array(3).keys()
    ].map((adjacencyIndex)=>activeRowIndex + adjacencyIndex - 1).filter((rowIndex)=>rowIndex >= 0 && rowIndex < visibleRowIds.length).map((idx)=>visibleRowIds[idx]);
});
const $2390827df6c800a7$export$e333218078e16c44 = (state, rowId)=>(0, $4XO5t.getFlattenedWithAddedRowIds)(state)[0] === rowId;
const $2390827df6c800a7$export$9b148117f6b512ea = (0, $dGvGJ.createSelector)($2390827df6c800a7$export$eca20d464f1d2890, $2390827df6c800a7$export$e333218078e16c44, (_, rowId)=>rowId, (activeAndAdjacentRowIds, firstRow, rowId)=>activeAndAdjacentRowIds.length === 0 && firstRow || activeAndAdjacentRowIds.some((activeOrAdjacentRowId)=>activeOrAdjacentRowId === rowId));

});
parcelRegister("7s7lq", function(module, exports) {

var $lgK8h = parcelRequire("lgK8h");
/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */ function $56d0d866bde9dfba$var$sortedIndex(array, value) {
    return $lgK8h(array, value);
}
module.exports = $56d0d866bde9dfba$var$sortedIndex;

});
parcelRegister("lgK8h", function(module, exports) {

var $gCcNv = parcelRequire("gCcNv");

var $etyzk = parcelRequire("etyzk");

var $4faK3 = parcelRequire("4faK3");
/** Used as references for the maximum length and index of an array. */ var $f7bee090c7b0e3e2$var$MAX_ARRAY_LENGTH = 4294967295, $f7bee090c7b0e3e2$var$HALF_MAX_ARRAY_LENGTH = $f7bee090c7b0e3e2$var$MAX_ARRAY_LENGTH >>> 1;
/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function $f7bee090c7b0e3e2$var$baseSortedIndex(array, value, retHighest) {
    var low = 0, high = array == null ? low : array.length;
    if (typeof value == 'number' && value === value && high <= $f7bee090c7b0e3e2$var$HALF_MAX_ARRAY_LENGTH) {
        while(low < high){
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !$4faK3(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
            else high = mid;
        }
        return high;
    }
    return $gCcNv(array, value, $etyzk, retHighest);
}
module.exports = $f7bee090c7b0e3e2$var$baseSortedIndex;

});
parcelRegister("gCcNv", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/** Used as references for the maximum length and index of an array. */ var $c18a1f497cf1e60a$var$MAX_ARRAY_LENGTH = 4294967295, $c18a1f497cf1e60a$var$MAX_ARRAY_INDEX = $c18a1f497cf1e60a$var$MAX_ARRAY_LENGTH - 1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c18a1f497cf1e60a$var$nativeFloor = Math.floor, $c18a1f497cf1e60a$var$nativeMin = Math.min;
/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function $c18a1f497cf1e60a$var$baseSortedIndexBy(array, value, iteratee, retHighest) {
    var low = 0, high = array == null ? 0 : array.length;
    if (high === 0) return 0;
    value = iteratee(value);
    var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = $4faK3(value), valIsUndefined = value === undefined;
    while(low < high){
        var mid = $c18a1f497cf1e60a$var$nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = $4faK3(computed);
        if (valIsNaN) var setLow = retHighest || othIsReflexive;
        else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
        else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        else if (othIsNull || othIsSymbol) setLow = false;
        else setLow = retHighest ? computed <= value : computed < value;
        if (setLow) low = mid + 1;
        else high = mid;
    }
    return $c18a1f497cf1e60a$var$nativeMin(high, $c18a1f497cf1e60a$var$MAX_ARRAY_INDEX);
}
module.exports = $c18a1f497cf1e60a$var$baseSortedIndexBy;

});



parcelRegister("6hiB0", function(module, exports) {

$parcel$export(module.exports, "minRowsForTreeTableVirtualisation", () => $f8a81d0292b5c2b8$export$3c21ff0ba5a7aae2);
$parcel$export(module.exports, "childrenOperationIndicatorWidth", () => $f8a81d0292b5c2b8$export$3f2e7d270d9c828e);
$parcel$export(module.exports, "levelIndentBaseline", () => $f8a81d0292b5c2b8$export$8831b0de9d6cd1e0);
$parcel$export(module.exports, "addBarCircleSize", () => $f8a81d0292b5c2b8$export$3d6f348975bc66c6);
$parcel$export(module.exports, "akButtonHeight", () => $f8a81d0292b5c2b8$export$21cb66b1f2cfe05b);
$parcel$export(module.exports, "scrollbarWidth", () => $f8a81d0292b5c2b8$export$14c8a45ff6da16d);
// ROW BODY
const $f8a81d0292b5c2b8$export$3c21ff0ba5a7aae2 = 100;
const $f8a81d0292b5c2b8$export$3f2e7d270d9c828e = 24;
const $f8a81d0292b5c2b8$export$66910203ed6bdbb = 8;
const $f8a81d0292b5c2b8$export$a659c25736116809 = 3;
const $f8a81d0292b5c2b8$export$8831b0de9d6cd1e0 = $f8a81d0292b5c2b8$export$a659c25736116809 + $f8a81d0292b5c2b8$export$3f2e7d270d9c828e;
const $f8a81d0292b5c2b8$export$75e30597b152d012 = $f8a81d0292b5c2b8$export$a659c25736116809 + $f8a81d0292b5c2b8$export$66910203ed6bdbb;
const $f8a81d0292b5c2b8$export$1380a626586d9aba = 12;
const $f8a81d0292b5c2b8$export$9aeb22ae511a8bf4 = 5;
const $f8a81d0292b5c2b8$export$3d6f348975bc66c6 = 24;
const $f8a81d0292b5c2b8$export$21cb66b1f2cfe05b = 32;
const $f8a81d0292b5c2b8$export$15a53da47f8d8b84 = 8;
const $f8a81d0292b5c2b8$export$14c8a45ff6da16d = 5;

});

const $960a7067bff9d918$export$4670af9f718b9e66 = 'DYNAMIC_RESIZE';
const $960a7067bff9d918$export$3920b9c14da1301c = 'DRAGGABLE_RESIZE';
const $960a7067bff9d918$export$913055729e1380b2 = 'summary';
const $960a7067bff9d918$export$6e386ac144cffab5 = 'ASCENDING';
const $960a7067bff9d918$export$f634ff5a7f1c8f3 = 'DESCENDING';

parcelRegister("3W7mX", function(module, exports) {

$parcel$export(module.exports, "getRowTree", () => $4b2c1e69827011a7$export$51f19bc561029712);
$parcel$export(module.exports, "getRowsConfiguration", () => $4b2c1e69827011a7$export$7afbda1c447dab73);
$parcel$export(module.exports, "getAddedRows", () => $4b2c1e69827011a7$export$b65d941a4f06833c);
$parcel$export(module.exports, "getMaxDepth", () => $4b2c1e69827011a7$export$dc00159d5f925dca);
$parcel$export(module.exports, "getAddLinkCaption", () => $4b2c1e69827011a7$export$b08f0f9a8b4bbfe8);
$parcel$export(module.exports, "getExpandedRowIdsHash", () => $4b2c1e69827011a7$export$5874281f3f9f8f1f);
$parcel$export(module.exports, "isRowExpanded", () => $4b2c1e69827011a7$export$22559e97b2ec8b6);
$parcel$export(module.exports, "getTemporaryAddedRow", () => $4b2c1e69827011a7$export$692ae8ed13990af6);
$parcel$export(module.exports, "isAnyRowBeingAdded", () => $4b2c1e69827011a7$export$53a366bd49d883e9);
$parcel$export(module.exports, "isRowBeingAdded", () => $4b2c1e69827011a7$export$a59b29339b2950b1);
$parcel$export(module.exports, "getRowAddingStatus", () => $4b2c1e69827011a7$export$4be3de2f99f7bcb7);
$parcel$export(module.exports, "getRowHasChildren", () => $4b2c1e69827011a7$export$bac1675af7abd620);
$parcel$export(module.exports, "getRow", () => $4b2c1e69827011a7$export$42035f545ecd5428);
$parcel$export(module.exports, "getDefaultRowHeight", () => $4b2c1e69827011a7$export$d44a80f12163dfc8);
$parcel$export(module.exports, "getRowHeightMapping", () => $4b2c1e69827011a7$export$86d23b7fefef4879);
$parcel$export(module.exports, "getAbsoluteRowHeight", () => $4b2c1e69827011a7$export$d58c78cd12373bd6);
$parcel$export(module.exports, "getRowHeight", () => $4b2c1e69827011a7$export$69b171017bdea2b4);
$parcel$export(module.exports, "isAutoRowHeight", () => $4b2c1e69827011a7$export$736c13cc18282c63);
$parcel$export(module.exports, "getStaticRowPathAndDepth", () => $4b2c1e69827011a7$export$d3cd1bd0d2f257ec);
$parcel$export(module.exports, "getRowAddPosition", () => $4b2c1e69827011a7$export$d1680008a2c9c92a);
$parcel$export(module.exports, "getAddBarOverflow", () => $4b2c1e69827011a7$export$89d1c0cf2787df2d);
$parcel$export(module.exports, "isRowLoading", () => $4b2c1e69827011a7$export$a15c7e972e303897);
$parcel$export(module.exports, "getRowCanAddChildren", () => $4b2c1e69827011a7$export$da03f1b8699c006f);
$parcel$export(module.exports, "getRowCanAddSibling", () => $4b2c1e69827011a7$export$622bee8dc98ce142);
$parcel$export(module.exports, "isRowSelected", () => $4b2c1e69827011a7$export$710e11cf672b86c);

var $dGvGJ = parcelRequire("dGvGJ");

var $24ebX = parcelRequire("24ebX");

var $6hiB0 = parcelRequire("6hiB0");

var $2aM3q = parcelRequire("2aM3q");

var $iLKwr = parcelRequire("iLKwr");
const $4b2c1e69827011a7$export$51f19bc561029712 = (state)=>state.consumer.rowTree;
const $4b2c1e69827011a7$export$7afbda1c447dab73 = (state)=>state.consumer.rowsConfiguration;
const $4b2c1e69827011a7$export$b65d941a4f06833c = (state)=>state.consumer.addedRows;
const $4b2c1e69827011a7$export$dc00159d5f925dca = (state)=>state.consumer.maxDepth;
const $4b2c1e69827011a7$export$b08f0f9a8b4bbfe8 = (state)=>state.consumer.addLinkCaption;
const $4b2c1e69827011a7$export$f7d97a6a8ca8eb30 = (state)=>state.consumer.expandedRowIds;
const $4b2c1e69827011a7$export$5874281f3f9f8f1f = (0, $dGvGJ.createSelector)($4b2c1e69827011a7$export$f7d97a6a8ca8eb30, (expandedRowIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    expandedRowIds.reduce((acc, next)=>{
        // for effeciency sake we are mutating the accumulator to build up our hash
        acc[next] = true;
        return acc;
    }, {}));
const $4b2c1e69827011a7$export$22559e97b2ec8b6 = (state, rowId)=>!!$4b2c1e69827011a7$export$5874281f3f9f8f1f(state)[rowId];
const $4b2c1e69827011a7$export$692ae8ed13990af6 = (state)=>state.consumer.addedRows !== undefined ? state.consumer.addedRows.temporary : undefined;
const $4b2c1e69827011a7$export$16d7466356aaf65d = (state)=>state.consumer.addedRows !== undefined ? state.consumer.addedRows.persisted : undefined;
const $4b2c1e69827011a7$export$53a366bd49d883e9 = (state)=>$4b2c1e69827011a7$export$692ae8ed13990af6(state) !== undefined;
const $4b2c1e69827011a7$export$a59b29339b2950b1 = (state, rowId)=>{
    const temporaryAddedRow = $4b2c1e69827011a7$export$692ae8ed13990af6(state);
    return temporaryAddedRow !== undefined && temporaryAddedRow.temporaryId === rowId;
};
const $4b2c1e69827011a7$export$4be3de2f99f7bcb7 = (state, rowId)=>{
    const addedRows = $4b2c1e69827011a7$export$b65d941a4f06833c(state);
    if (addedRows !== undefined) {
        if (!!addedRows.temporary && addedRows.temporary.temporaryId === rowId) return addedRows.temporary.isPersisting ? 'PERSISTING' : 'NEW';
        if (!!addedRows.persisted && addedRows.persisted[rowId]) return 'PERSISTED';
    }
    return undefined;
};
const $4b2c1e69827011a7$export$ab5d39c3fc4e75a3 = (state, rowId)=>$4b2c1e69827011a7$export$51f19bc561029712(state).rows[rowId].parentId;
const $4b2c1e69827011a7$export$bac1675af7abd620 = (state, rowId)=>{
    // a temp child will not be included in the row tree children - need to check both.
    const temporaryAddedRow = $4b2c1e69827011a7$export$692ae8ed13990af6(state);
    const row = $4b2c1e69827011a7$export$51f19bc561029712(state).rows[rowId];
    return row && row.childrenIds.length > 0 || temporaryAddedRow !== undefined && temporaryAddedRow.anchorId === rowId && temporaryAddedRow.position === 'INSIDE';
};
const $4b2c1e69827011a7$export$42035f545ecd5428 = (state, rowId)=>$4b2c1e69827011a7$export$51f19bc561029712(state).rows[rowId];
const $4b2c1e69827011a7$export$d44a80f12163dfc8 = (state)=>state.consumer.rowHeight;
const $4b2c1e69827011a7$var$getRowBorderWidth = (state)=>state.internal.rowBorderWidth;
const $4b2c1e69827011a7$export$86d23b7fefef4879 = (state)=>state.internal.rowHeightMapping;
const $4b2c1e69827011a7$export$e61f0a8029f642f4 = (0, $dGvGJ.createSelector)($4b2c1e69827011a7$export$86d23b7fefef4879, $4b2c1e69827011a7$export$d44a80f12163dfc8, (rowHeightMapping, defaultRowHeight)=>{
    const vals = Object.values(rowHeightMapping).sort();
    const medianIdx = Math.floor(vals.length / 2);
    return vals[medianIdx] || defaultRowHeight;
});
const $4b2c1e69827011a7$export$d58c78cd12373bd6 = (state)=>Math.max(0, ($4b2c1e69827011a7$export$e61f0a8029f642f4(state) || $4b2c1e69827011a7$export$d44a80f12163dfc8(state)) - $4b2c1e69827011a7$var$getRowBorderWidth(state));
const $4b2c1e69827011a7$export$69b171017bdea2b4 = (state, rowId)=>{
    const knownRowHeight = $4b2c1e69827011a7$export$86d23b7fefef4879(state)[rowId];
    if (knownRowHeight) return Math.max(0, knownRowHeight);
    return $4b2c1e69827011a7$export$d58c78cd12373bd6(state);
};
const $4b2c1e69827011a7$export$736c13cc18282c63 = (state)=>state.consumer.autoRowHeight;
const $4b2c1e69827011a7$export$d3cd1bd0d2f257ec = (0, $dGvGJ.createSelector)($4b2c1e69827011a7$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowPathAndDepthHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const depth = (0, $2aM3q.default)(rowTree.rows, rowId);
        const path = (0, $iLKwr.default)(rowTree.rows, rowId);
        rowPathAndDepthHash[rowId] = {
            depth: depth,
            path: path
        };
    });
    return rowPathAndDepthHash;
});
const $4b2c1e69827011a7$export$829a6e4495ba9529 = (0, $dGvGJ.createSelector)($4b2c1e69827011a7$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowDepthHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const depth = (0, $2aM3q.default)(rowTree.rows, rowId);
        rowDepthHash[rowId] = {
            depth: depth
        };
    });
    return rowDepthHash;
});
const $4b2c1e69827011a7$export$ecd30898c6a65cf4 = (0, $dGvGJ.createSelector)($4b2c1e69827011a7$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowPathHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const path = (0, $iLKwr.default)(rowTree.rows, rowId);
        rowPathHash[rowId] = {
            path: path
        };
    });
    return rowPathHash;
});
const $4b2c1e69827011a7$export$e57b56ebfdae922b = (0, $dGvGJ.createSelector)($4b2c1e69827011a7$export$dc00159d5f925dca, $4b2c1e69827011a7$export$f7d97a6a8ca8eb30, (maxDepth, expandedRowIds)=>({
        maxDepth: maxDepth,
        expandedRowIds: expandedRowIds
    }));
const $4b2c1e69827011a7$export$d1680008a2c9c92a = (0, $24ebX.createWeakMapSelector)($4b2c1e69827011a7$export$42035f545ecd5428, $4b2c1e69827011a7$export$829a6e4495ba9529, $4b2c1e69827011a7$export$e57b56ebfdae922b, // @ts-expect-error - TS7006 - Parameter 'row' implicitly has an 'any' type. | TS7006 - Parameter 'rowDepth' implicitly has an 'any' type. | TS7031 - Binding element 'maxDepth' implicitly has an 'any' type. | TS7031 - Binding element 'expandedRowIds' implicitly has an 'any' type.
(row, rowDepth, { maxDepth: maxDepth, expandedRowIds: expandedRowIds })=>{
    if (row === undefined) throw new Error('row must not be undefined');
    const rowId = row.id;
    const currentRowDepth = rowDepth[rowId].depth;
    // if a row can have children and is expanded, add a child
    // if a row can have children but is collapsed, add a sibling
    if (currentRowDepth < maxDepth) {
        if (expandedRowIds.indexOf(rowId) !== -1) return 'INSIDE';
        return 'AFTER';
    }
    // otherwise it is a child row, add a sibling
    return 'AFTER';
});
const $4b2c1e69827011a7$export$89d1c0cf2787df2d = (state)=>((0, $6hiB0.addBarCircleSize) - $4b2c1e69827011a7$var$getRowBorderWidth(state)) / 2;
const $4b2c1e69827011a7$export$f9af5c27d326c0d1 = (state, rowId)=>{
    const rowConfiguration = $4b2c1e69827011a7$export$7afbda1c447dab73(state)[rowId];
    return rowConfiguration ? rowConfiguration.dragIndicatorColor : undefined;
};
const $4b2c1e69827011a7$export$a15c7e972e303897 = (state, rowId)=>{
    const rowConfiguration = $4b2c1e69827011a7$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.isLoading || false;
    return false;
};
const $4b2c1e69827011a7$export$da03f1b8699c006f = (state, rowId)=>{
    const rowConfiguration = $4b2c1e69827011a7$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.canAddChildren !== undefined ? rowConfiguration.canAddChildren : true;
    return true;
};
const $4b2c1e69827011a7$export$622bee8dc98ce142 = (state, rowId)=>{
    const rowConfiguration = $4b2c1e69827011a7$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.canAddSibling !== undefined ? rowConfiguration.canAddSibling : true;
    return true;
};
const $4b2c1e69827011a7$export$710e11cf672b86c = (state, rowId)=>{
    const rowConfiguration = $4b2c1e69827011a7$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.isSelected || false;
    return false;
};

});
parcelRegister("24ebX", function(module, exports) {

$parcel$export(module.exports, "createWeakMapSelector", () => $f4af8f8b2496e057$export$3a90d1d234e724b5);
$parcel$export(module.exports, "createSelector", () => $f4af8f8b2496e057$export$595d22ed68ca2841);
// @ts-expect-error - TS2305 - Module '"reselect"' has no exported member 'SelectorCreator'.

var $dGvGJ = parcelRequire("dGvGJ");

var $eKGsF = parcelRequire("eKGsF");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f4af8f8b2496e057$var$weakMapMemoize = (func)=>{
    const memorizer = (0, $eKGsF.createMemorizer)();
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    return (...args)=>{
        const cached = memorizer.read(args);
        if (cached !== undefined) return (0, $eKGsF.toReturnValue)(cached);
        const result = func.apply(func, args);
        memorizer.store(args, result);
        return result;
    };
};
const $f4af8f8b2496e057$export$3a90d1d234e724b5 = (0, $dGvGJ.createSelectorCreator)($f4af8f8b2496e057$var$weakMapMemoize);
const $f4af8f8b2496e057$export$595d22ed68ca2841 = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize));

});
parcelRegister("eKGsF", function(module, exports) {

$parcel$export(module.exports, "toReturnValue", () => $a725e29cfc60dcfc$export$9f3707bed4fc53c8);
$parcel$export(module.exports, "createMemorizer", () => $a725e29cfc60dcfc$export$9db09f4ba21f9d2a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$UNDEFINED = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$NULL = {};
const $a725e29cfc60dcfc$export$7abc386bcfed62e1 = (key)=>{
    if (key === undefined) return $a725e29cfc60dcfc$var$UNDEFINED;
    if (key === null) return $a725e29cfc60dcfc$var$NULL;
    return key;
};
const $a725e29cfc60dcfc$export$9f3707bed4fc53c8 = (x)=>{
    if (x === $a725e29cfc60dcfc$var$UNDEFINED) return undefined;
    if (x === $a725e29cfc60dcfc$var$NULL) return null;
    return x;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$getFromWeakMapChain = (args, index, map)=>{
    const element = map.get($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]));
    if (index < args.length - 1) {
        if (element) return $a725e29cfc60dcfc$var$getFromWeakMapChain(args, index + 1, element);
        return undefined;
    }
    return element;
};
const $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const subMap = new WeakMap();
        map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), subMap);
        $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
    } else map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), result);
};
const $a725e29cfc60dcfc$var$storeToWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const element = map.get($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]));
        if (element) $a725e29cfc60dcfc$var$storeToWeakMapChain(args, index + 1, element, result);
        else {
            const subMap = new WeakMap();
            map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), subMap);
            // we know that from now on, all chain elements need to be new maps,
            // so we move to a slightly more performent recursion
            $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
        }
    } else map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), result);
};
const $a725e29cfc60dcfc$export$9db09f4ba21f9d2a = ()=>{
    const weakMap = new WeakMap();
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store: (args, result)=>result !== undefined ? $a725e29cfc60dcfc$var$storeToWeakMapChain(args, 0, weakMap, result) : $a725e29cfc60dcfc$var$storeToWeakMapChain(args, 0, weakMap, $a725e29cfc60dcfc$var$UNDEFINED),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        read: (args)=>$a725e29cfc60dcfc$var$getFromWeakMapChain(args, 0, weakMap)
    };
};

});



parcelRegister("4XO5t", function(module, exports) {

$parcel$export(module.exports, "getFlattenedWithAddedRowIds", () => $680da2c7991c49e0$export$6e21a717b784ff6c);
$parcel$export(module.exports, "getVisibleRowsCount", () => $680da2c7991c49e0$export$b4a9f7539f5aceeb);
$parcel$export(module.exports, "getVisibleIndexForRowId", () => $680da2c7991c49e0$export$79cf3e6172c1e206);

var $dGvGJ = parcelRequire("dGvGJ");

var $3W7mX = parcelRequire("3W7mX");

var $5J7ao = parcelRequire("5J7ao");

var $y5fIl = parcelRequire("y5fIl");

var $awuX3 = parcelRequire("awuX3");
const $680da2c7991c49e0$export$53ea5f0c9428e57 = (0, $dGvGJ.createSelector)((0, $5J7ao.getSortedRowIdsHash), // FSN-4037 Remove draggingRowId related logic during FF cleanup
(0, $5J7ao.getDraggingRowId), (0, $3W7mX.getExpandedRowIdsHash), (sortedRowIdsHash, draggingRowId, expandedRowIdsHash)=>(0, $y5fIl.default)(sortedRowIdsHash, draggingRowId, expandedRowIdsHash));
// memoize and transform to expected type for insertAnchoredRowIds utility
const $680da2c7991c49e0$var$getTemporaryAddedRowHash = (0, $dGvGJ.createSelector)((0, $3W7mX.getTemporaryAddedRow), (temporaryAddedRow)=>temporaryAddedRow !== undefined ? {
        [temporaryAddedRow.temporaryId]: temporaryAddedRow
    } : undefined);
const $680da2c7991c49e0$export$6e21a717b784ff6c = (0, $dGvGJ.createSelector)($680da2c7991c49e0$export$53ea5f0c9428e57, (0, $3W7mX.getRowTree), (0, $3W7mX.getExpandedRowIdsHash), $680da2c7991c49e0$var$getTemporaryAddedRowHash, (flattenedRowIds, rowTree, expandedRowIdsHash, temporaryAddedRows)=>(0, $awuX3.default)(flattenedRowIds, rowTree, expandedRowIdsHash, temporaryAddedRows));
const $680da2c7991c49e0$export$b4a9f7539f5aceeb = (state)=>$680da2c7991c49e0$export$6e21a717b784ff6c(state).length;
const $680da2c7991c49e0$export$883d77261e4c3cdd = (0, $dGvGJ.createSelector)($680da2c7991c49e0$export$6e21a717b784ff6c, (flattenedRowIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    flattenedRowIds.reduce((acc, rowId, idx)=>{
        acc[rowId] = idx;
        return acc;
    }, {}));
const $680da2c7991c49e0$export$79cf3e6172c1e206 = (state, rowId)=>$680da2c7991c49e0$export$883d77261e4c3cdd(state)[rowId];

});
parcelRegister("y5fIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $05306dbf21457373$export$2e2bcd8739ae039);

const $05306dbf21457373$var$traverseRows = (rowIds, sortedRowIdsHash, // FSN-4037 Remove draggingRowId related logic during FF cleanup
draggingRowId, result, expandedRowIdsHash)=>{
    if (rowIds === undefined || rowIds.length === 0) return;
    rowIds.forEach((rowId)=>{
        // if an item is being dragged, its' children should be hidden
        // otherwise check if it is the list of consumer expanded rows
        const childrenIds = draggingRowId === rowId ? [] : expandedRowIdsHash[rowId] && sortedRowIdsHash[rowId] || [];
        result.push(rowId);
        $05306dbf21457373$var$traverseRows(childrenIds, sortedRowIdsHash, draggingRowId, result, expandedRowIdsHash);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$05306dbf21457373$export$2e2bcd8739ae039 = (sortedRowIdsHash, draggingRowId, expandedRowIdsHash)=>{
    const result = [];
    $05306dbf21457373$var$traverseRows(sortedRowIdsHash[0, $ad3622039daefe23$export$59c500c4e33fdb0], sortedRowIdsHash, draggingRowId, result, expandedRowIdsHash);
    return result;
};

});
const $ad3622039daefe23$export$d12b3737880ade32 = 'FIRST';
const $ad3622039daefe23$export$c7329282a8166cba = 'LAST';
const $ad3622039daefe23$export$45ce4e6476e88525 = 'BEFORE';
const $ad3622039daefe23$export$6a633207bebc1e0e = 'AFTER';
const $ad3622039daefe23$export$667b331f8de09773 = 'INSIDE';
const $ad3622039daefe23$export$a63dec0667c2f97a = 'IS_LOADING';
const $ad3622039daefe23$export$456b4a90eb507580 = 'DELAYED_RENDER';
const $ad3622039daefe23$export$59c500c4e33fdb0 = 'ROOT';


parcelRegister("awuX3", function(module, exports) {

$parcel$export(module.exports, "default", () => $381199abf564e540$export$2e2bcd8739ae039);

var $lbWm4 = parcelRequire("lbWm4");

var $5Ot1C = parcelRequire("5Ot1C");

var $67JtQ = parcelRequire("67JtQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$381199abf564e540$export$2e2bcd8739ae039 = (baseRowIds, rowTree, expandedRowIdsHash, anchoredRows)=>{
    if (!anchoredRows) return baseRowIds;
    // remove added rows from their sorted order, to be positioned by anchor instead
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($5Ot1C)))(baseRowIds, (baseRowId)=>anchoredRows !== undefined && anchoredRows[baseRowId] !== undefined);
    // for each added row, insert based on the anchor
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anchoredRows, (anchorRow, anchoredRowId)=>{
        const { anchorId: anchorId, position: position } = anchorRow;
        if (position === 'FIRST') result.unshift(anchoredRowId);
        else if (position === 'LAST') result.push(anchoredRowId);
        else if (anchorId) {
            const anchorRowLocation = result.indexOf(anchorId);
            // the anchor row may not be in the set of currently visible things
            if (anchorRowLocation !== -1) {
                if (position === 'BEFORE') result.splice(anchorRowLocation, 0, anchoredRowId);
                else if (position === 'AFTER') {
                    const spliceOffset = 1 + (0, $67JtQ.default)(anchorId, rowTree, expandedRowIdsHash);
                    result.splice(anchorRowLocation + spliceOffset, 0, anchoredRowId);
                } else if (position === 'INSIDE' && expandedRowIdsHash[anchorId]) result.splice(anchorRowLocation + 1, 0, anchoredRowId);
            }
        }
    });
    return result;
};

});
parcelRegister("5Ot1C", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $8BRGu = parcelRequire("8BRGu");

var $bxDef = parcelRequire("bxDef");

var $8LQ84 = parcelRequire("8LQ84");

var $jGJpR = parcelRequire("jGJpR");
/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */ function $43b82310b1b35f52$var$reject(collection, predicate) {
    var func = $8LQ84(collection) ? $2GdQn : $8BRGu;
    return func(collection, $jGJpR($bxDef(predicate, 3)));
}
module.exports = $43b82310b1b35f52$var$reject;

});
parcelRegister("8BRGu", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $644b6c0ae483a6c5$var$baseFilter(collection, predicate) {
    var result = [];
    $e7pfQ(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $644b6c0ae483a6c5$var$baseFilter;

});


parcelRegister("67JtQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $649e886391816662$export$2e2bcd8739ae039);

var $lbWm4 = parcelRequire("lbWm4");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$649e886391816662$export$2e2bcd8739ae039 = (rowId, rowTree, expandedRowIdsHash)=>{
    let childLength = 0;
    // @ts-expect-error - TS2304 - Cannot find name 'Identifier'.
    const traverseChildren = (parentId)=>{
        const childrenIds = expandedRowIdsHash[parentId] ? rowTree.rows[parentId].childrenIds : [];
        childLength += childrenIds.length;
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(childrenIds, (childId)=>{
            traverseChildren(childId);
        });
    };
    traverseChildren(rowId);
    return childLength;
};

});




parcelRegister("24bgq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c77a30e9cd6a3983$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eeWa5 = parcelRequire("eeWa5");

var $iN58L = parcelRequire("iN58L");

var $1yjD4 = parcelRequire("1yjD4");
var $c77a30e9cd6a3983$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        activeRowId: (0, $iN58L.getActiveRowId)(state),
        DetailsContent: (0, $eeWa5.getDetailsPanelComponent)(state)
    }), {})((0, $1yjD4.default));

});
parcelRegister("1yjD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $182d9f1452ff1bb0$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6iCoB = parcelRequire("6iCoB");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $182d9f1452ff1bb0$var$Panel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1x5895j": (0, $lD23V.default)(`1px solid ${__cmplp.theme.header.borderColor}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1kl7135k",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $182d9f1452ff1bb0$var$DetailsPanel extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        const { DetailsContent: DetailsContent } = this.props;
        // only try focus the panel if it would be open (some DetailsContent is supplied)
        DetailsContent && this.panelRef && this.panelRef.focus();
    }
    render() {
        const { activeRowId: activeRowId, DetailsContent: DetailsContent, theme: theme } = this.props;
        if (DetailsContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($182d9f1452ff1bb0$var$Panel, {
            tabIndex: 0,
            ref: (div)=>{
                this.panelRef = div;
            },
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DetailsContent, {
            activeRowId: activeRowId
        }));
        return null;
    }
}
var $182d9f1452ff1bb0$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($182d9f1452ff1bb0$var$DetailsPanel);

});
parcelRegister("6iCoB", function(module, exports) {

$parcel$export(module.exports, "withTheme", () => $0428a20288d43307$export$e8748c6a27b910dc);
$parcel$export(module.exports, "ThemeProvider", () => $0428a20288d43307$export$d8964aec282183a3);

var $5uXOq = parcelRequire("5uXOq");

var $bxVim = parcelRequire("bxVim");

var $8QnA7 = parcelRequire("8QnA7");
/*
 * This is to replace the styledComponent theme provider as part of the compiled
 * css migration at https://hello.jira.atlassian.cloud/browse/ENGHEALTH-4743.
 * Before the migration, styled-components/ThemeProvider was used at
 * jira/src/packages/servicedesk/virtual-table/src/app/table/index.tsx
 * to inject StyledTheme context for the styledComponents to consume and after
 * the migration below theme context is used instead.
 *
 * */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $0428a20288d43307$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $0428a20288d43307$export$93d4e7f90805808f = ()=>(0, $5uXOq.useContext)($0428a20288d43307$var$ThemeContext);
function $0428a20288d43307$export$e8748c6a27b910dc(Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0428a20288d43307$var$ThemeContext.Consumer, null, (defaultTheme)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                theme: defaultTheme
            }));
}
const $0428a20288d43307$export$d8964aec282183a3 = ({ children: children, defaultRowHeight: defaultRowHeight, autoRowHeight: autoRowHeight, customScrollBarOffset: customScrollBarOffset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0428a20288d43307$var$ThemeContext.Provider, {
        value: (0, $bxVim.compiledThemeWithProps)((0, $8QnA7.default), defaultRowHeight, autoRowHeight, customScrollBarOffset)
    }, children);

});
parcelRegister("bxVim", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $7c88eac27f46ae5b$export$25d302a5b900a763);
$parcel$export(module.exports, "compiledThemeWithProps", () => $7c88eac27f46ae5b$export$5a55b0960b1e154b);

var $1UikQ = parcelRequire("1UikQ");

var $8QpSo = parcelRequire("8QpSo");

var $3iQjV = parcelRequire("3iQjV");
const $7c88eac27f46ae5b$export$919aa3481b25eaec = (aTheme, anotherTheme)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, aTheme, anotherTheme);
const $7c88eac27f46ae5b$var$createRowCompiledTheme = ({ height: height, minHeight: minHeight, borderRadius: borderRadius, ...others }, autoHeight)=>({
        defaultHeight: Math.max(height, minHeight),
        height: height && !autoHeight ? `${height}px` : 'auto',
        minHeight: `${Math.max(height, minHeight)}px`,
        borderRadius: `${borderRadius}px`,
        ...others
    });
const $7c88eac27f46ae5b$var$createHeaderCompiledTheme = ({ height: height, paddingBottom: paddingBottom, paddingTop: paddingTop, ...others })=>({
        height: height ? `${height}px` : 'auto',
        paddingBottom: `${paddingBottom}px`,
        paddingTop: `${paddingTop}px`,
        ...others
    });
const $7c88eac27f46ae5b$var$createListCompiledTheme = ({ paddingTop: paddingTop })=>({
        paddingTop: `${paddingTop}px`
    });
const $7c88eac27f46ae5b$var$createCompiledTheme = (theme, autoHeight, customScrollBarOffset)=>{
    const { decal: decal, header: header, list: list, row: row, scrollbar: scrollbar, shadow: shadow } = theme;
    const scrollBarTheme = customScrollBarOffset !== undefined ? {
        ...scrollbar,
        offset: customScrollBarOffset
    } : scrollbar;
    return {
        decal: decal,
        header: $7c88eac27f46ae5b$var$createHeaderCompiledTheme(header),
        list: $7c88eac27f46ae5b$var$createListCompiledTheme(list),
        row: $7c88eac27f46ae5b$var$createRowCompiledTheme(row, autoHeight),
        scrollbar: scrollBarTheme,
        shadow: shadow
    };
};
const $7c88eac27f46ae5b$export$25d302a5b900a763 = (theme)=>$7c88eac27f46ae5b$export$919aa3481b25eaec((0, $3iQjV.default), theme);
const $7c88eac27f46ae5b$export$5a55b0960b1e154b = (0, $8QpSo.default)((theme, height, autoHeight, customScrollBarOffset)=>$7c88eac27f46ae5b$var$createCompiledTheme((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, theme, {
        row: {
            defaultHeight: height,
            height: height
        }
    }), autoHeight, customScrollBarOffset));

});
parcelRegister("3iQjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $38d927982b929b6e$export$2e2bcd8739ae039);

var /**
 * Default theme
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$38d927982b929b6e$export$2e2bcd8739ae039 = {
    list: {
        paddingTop: 0
    },
    row: {
        height: 40,
        minHeight: 40,
        borderColor: (0, $829f609a65d26a98$exports).N40,
        borderRadius: 0,
        borderWidth: 1,
        maxDepthChildrenOperationIndicatorWidth: 8,
        activeColor: (0, $829f609a65d26a98$exports).T50,
        hoveredColor: (0, $829f609a65d26a98$exports).N20
    },
    header: {
        height: 35,
        borderWidth: 1,
        borderColor: (0, $829f609a65d26a98$exports).N60,
        paddingBottom: 0,
        paddingTop: 0,
        sideMargin: 0,
        hasShadow: false
    },
    scrollbar: {
        offset: 0,
        marginTop: 0,
        marginBottom: 0,
        paddingTop: 0,
        paddingBottom: 0,
        computeHeight: false
    },
    shadow: {
        softenShadow: false,
        right: {
            display: 'none'
        },
        left: {
            borderWidth: 1,
            computeHeight: false
        },
        bottom: {
            display: 'none'
        }
    },
    decal: {
        borderWidth: 0,
        borderColor: (0, $829f609a65d26a98$exports).N50
    }
};

});


parcelRegister("8QnA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b2f1c033cb9d529$export$2e2bcd8739ae039);


var $gwIPs = parcelRequire("gwIPs");

var $bxVim = parcelRequire("bxVim");
var $1b2f1c033cb9d529$export$2e2bcd8739ae039 = (0, $bxVim.createTheme)({
    list: {
        paddingTop: (0, $gwIPs.gridSize) / 2
    },
    row: {
        height: 0,
        minHeight: (0, $gwIPs.gridSize) * 5,
        borderColor: 'transparent',
        borderRadius: (0, $gwIPs.gridSize) / 2,
        borderWidth: 0,
        maxDepthChildrenOperationIndicatorWidth: 0,
        activeColor: (0, $829f609a65d26a98$exports).N20,
        hoveredColor: (0, $829f609a65d26a98$exports).N20,
        useCssHover: true
    },
    header: {
        height: 0,
        borderColor: (0, $829f609a65d26a98$exports).N50,
        borderWidth: 2,
        paddingBottom: (0, $gwIPs.gridSize) / 2,
        paddingTop: (0, $gwIPs.gridSize),
        sideMargin: (0, $gwIPs.gridSize),
        hasShadow: true
    },
    scrollbar: {
        offset: (0, $gwIPs.gridSize) * 4,
        marginTop: (0, $gwIPs.gridSize) + (0, $gwIPs.gridSize) / 2,
        marginBottom: (0, $gwIPs.gridSize),
        paddingTop: (0, $gwIPs.gridSize),
        paddingBottom: (0, $gwIPs.gridSize) / 2,
        computeHeight: true
    },
    shadow: {
        softenShadow: true,
        right: {
            display: 'block'
        },
        left: {
            borderWidth: 0,
            computeHeight: true
        },
        bottom: {
            display: 'block'
        }
    },
    decal: {
        borderColor: (0, $829f609a65d26a98$exports).N50,
        borderWidth: 2
    }
});

});




parcelRegister("5KuPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $626d2ba837561a4f$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hlzJ2 = parcelRequire("hlzJ2");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6iCoB = parcelRequire("6iCoB");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $626d2ba837561a4f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isAutoHeight: isAutoHeight, hideVerticalScrollBar: hideVerticalScrollBar, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isAutoHeight ? "_4t3i1wug" : "_4t3i1osq",
            !__cmplp.isAutoHeight && "_16jlkb7n _1o9zidpf _i0dl1wug",
            __cmplp.hideVerticalScrollBar ? "_1reo15vq _18m915vq" : "_1reo73ad _18m973ad",
            __cmplp.className
        ])
    });
});
const $626d2ba837561a4f$var$FullHeightAutoSizer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hlzJ2.AutoSizer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iaq80",
            __cmplp.className
        ])
    });
});
const $626d2ba837561a4f$var$AutoSizedContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`),
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1hdq _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $626d2ba837561a4f$var$VirtualBoundriesTracker = ({ visibleStart: visibleStart, visibleEnd: visibleEnd })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (visibleStart === 0) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'virtualBoundaries calculated', {
            visibleEnd: visibleEnd
        });
    }, [
        visibleStart,
        visibleEnd,
        createAnalyticsEvent
    ]);
    return null;
};
// eslint-disable-next-line jira/react/no-class-components
class $626d2ba837561a4f$var$Table extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        if ((0, $4R6GH.fg)('css_support_for_virtual_table')) {
            if (this.flexRef.current) {
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                const { height: height, width: width } = this.flexRef.current.getBoundingClientRect();
                this.onResize({
                    height: height,
                    width: width
                });
            }
        }
    }
    render() {
        const { width: width, height: height, isAutoHeight: isAutoHeight, shouldUseCssForRendering: shouldUseCssForRendering, TableMain: TableMain, DetailsPanel: DetailsPanel } = this.props;
        const autoSizerStyle = isAutoHeight ? {
            height: 'auto'
        } : {};
        const hideVerticalScrollBar = false && (0, $4R6GH.fg)('issuelist_ssr_hide_scroll_bars');
        if (shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626d2ba837561a4f$var$Wrapper, {
            hideVerticalScrollBar: hideVerticalScrollBar,
            isAutoHeight: isAutoHeight,
            "data-component-selector": "virtual-table.view.table-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            ref: this.flexRef,
            xcss: [
                $626d2ba837561a4f$var$containerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TableMain, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DetailsPanel, null)), this.props.virtualBoundaries && (0, $4R6GH.fg)('jsm_flash_virtual_table_rows_number_analytics') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626d2ba837561a4f$var$VirtualBoundriesTracker, {
            visibleStart: this.props.virtualBoundaries.visibleStart,
            visibleEnd: this.props.virtualBoundaries.visibleEnd
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626d2ba837561a4f$var$Wrapper, {
            isAutoHeight: isAutoHeight,
            hideVerticalScrollBar: false && (0, $4R6GH.fg)('issuelist_ssr_hide_scroll_bars'),
            "data-component-selector": "virtual-table.view.table-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626d2ba837561a4f$var$FullHeightAutoSizer, {
            onResize: this.onResize,
            style: {
                ...autoSizerStyle
            }
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626d2ba837561a4f$var$AutoSizedContentWrapper, {
                width: width,
                height: height
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TableMain, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DetailsPanel, null))), this.props.virtualBoundaries && (0, $4R6GH.fg)('jsm_flash_virtual_table_rows_number_analytics') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626d2ba837561a4f$var$VirtualBoundriesTracker, {
            visibleStart: this.props.virtualBoundaries.visibleStart,
            visibleEnd: this.props.virtualBoundaries.visibleEnd
        }));
    }
    constructor(...args){
        super(...args), this.onResize = (size)=>{
            const { setTableSize: setTableSize, theme: theme } = this.props;
            // AutoSizer uses offsetWidth/offsetHeight for dimensions which rounds and can cause scrollbars.
            // i.e. height of 700.5 will be rounded to 701
            // We need to remove a single pixel to prevent this
            // https://github.com/bvaughn/react-virtualized/issues/1287
            const width = size.width - 1;
            const height = size.height - 1;
            setTableSize({
                height: height,
                width: width,
                widthWithoutScrollbarOffset: width - theme.scrollbar.offset,
                rowMargin: theme.header.sideMargin * 2
            });
        }, this.flexRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
}
var $626d2ba837561a4f$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($626d2ba837561a4f$var$Table);
const $626d2ba837561a4f$var$containerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%'
});

});
parcelRegister("hlzJ2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2YmwZ = parcelRequire("2YmwZ");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $ca101c26fb9a4d49$var$_interopRequireDefault($2YmwZ).default;
    }
});
Object.defineProperty(module.exports, 'AutoSizer', {
    enumerable: true,
    get: function get() {
        return $ca101c26fb9a4d49$var$_interopRequireDefault($2YmwZ).default;
    }
});
function $ca101c26fb9a4d49$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2YmwZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $knQh8 = parcelRequire("knQh8");
var $22a2a99166405134$var$_extends3 = $22a2a99166405134$var$_interopRequireDefault($knQh8);

var $29Ol4 = parcelRequire("29Ol4");
var $22a2a99166405134$var$_getPrototypeOf2 = $22a2a99166405134$var$_interopRequireDefault($29Ol4);

var $aXTp8 = parcelRequire("aXTp8");
var $22a2a99166405134$var$_classCallCheck3 = $22a2a99166405134$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $22a2a99166405134$var$_createClass3 = $22a2a99166405134$var$_interopRequireDefault($4tLNB);

var $5pMaQ = parcelRequire("5pMaQ");
var $22a2a99166405134$var$_possibleConstructorReturn3 = $22a2a99166405134$var$_interopRequireDefault($5pMaQ);

var $gHLl6 = parcelRequire("gHLl6");
var $22a2a99166405134$var$_inherits3 = $22a2a99166405134$var$_interopRequireDefault($gHLl6);

var $5uXOq = parcelRequire("5uXOq");
var $22a2a99166405134$var$React = $22a2a99166405134$var$_interopRequireWildcard($5uXOq);

var $7ydDp = parcelRequire("7ydDp");
var $22a2a99166405134$var$_detectElementResize2 = $22a2a99166405134$var$_interopRequireDefault($7ydDp);

var $8rCP3 = parcelRequire("8rCP3");
var $22a2a99166405134$var$_propTypes2 = $22a2a99166405134$var$_interopRequireDefault($8rCP3);
function $22a2a99166405134$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $22a2a99166405134$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $22a2a99166405134$var$AutoSizer = function(_React$PureComponent) {
    (0, $22a2a99166405134$var$_inherits3.default)(AutoSizer, _React$PureComponent);
    function AutoSizer() {
        var _ref;
        var _temp, _this, _ret;
        (0, $22a2a99166405134$var$_classCallCheck3.default)(this, AutoSizer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $22a2a99166405134$var$_possibleConstructorReturn3.default)(this, (_ref = AutoSizer.__proto__ || (0, $22a2a99166405134$var$_getPrototypeOf2.default)(AutoSizer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            height: _this.props.defaultHeight || 0,
            width: _this.props.defaultWidth || 0
        }, _this._onResize = function() {
            var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
            if (_this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                var _height = _this._parentNode.offsetHeight || 0;
                var _width = _this._parentNode.offsetWidth || 0;
                var win = _this._window || window;
                var _style = win.getComputedStyle(_this._parentNode) || {};
                var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
                var paddingRight = parseInt(_style.paddingRight, 10) || 0;
                var paddingTop = parseInt(_style.paddingTop, 10) || 0;
                var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
                var newHeight = _height - paddingTop - paddingBottom;
                var newWidth = _width - paddingLeft - paddingRight;
                if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                    _this.setState({
                        height: _height - paddingTop - paddingBottom,
                        width: _width - paddingLeft - paddingRight
                    });
                    onResize({
                        height: _height,
                        width: _width
                    });
                }
            }
        }, _this._setRef = function(autoSizer) {
            _this._autoSizer = autoSizer;
        }, _temp), (0, $22a2a99166405134$var$_possibleConstructorReturn3.default)(_this, _ret);
    } // uses any instead of Window because Flow doesn't have window type
    (0, $22a2a99166405134$var$_createClass3.default)(AutoSizer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var nonce = this.props.nonce;
                if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                    // Delay access of parentNode until mount.
                    // This handles edge-cases where the component has already been unmounted before its ref has been set,
                    // As well as libraries like react-lite which have a slightly different lifecycle.
                    this._parentNode = this._autoSizer.parentNode;
                    this._window = this._autoSizer.parentNode.ownerDocument.defaultView;
                    // Defer requiring resize handler in order to support server-side rendering.
                    // See issue #41
                    this._detectElementResize = (0, $22a2a99166405134$var$_detectElementResize2.default)(nonce, this._window);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                    this._onResize();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, className = _props.className, disableHeight = _props.disableHeight, disableWidth = _props.disableWidth, style = _props.style;
                var _state = this.state, height = _state.height, width = _state.width;
                // Outer div should not force width/height since that may prevent containers from shrinking.
                // Inner component should overflow and use calculated width/height.
                // See issue #68 for more information.
                var outerStyle = {
                    overflow: 'visible'
                };
                var childParams = {};
                if (!disableHeight) {
                    outerStyle.height = 0;
                    childParams.height = height;
                }
                if (!disableWidth) {
                    outerStyle.width = 0;
                    childParams.width = width;
                }
                /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */ return $22a2a99166405134$var$React.createElement('div', {
                    className: className,
                    ref: this._setRef,
                    style: (0, $22a2a99166405134$var$_extends3.default)({}, outerStyle, style)
                }, children(childParams));
            }
        }
    ]);
    return AutoSizer;
}($22a2a99166405134$var$React.PureComponent);
$22a2a99166405134$var$AutoSizer.defaultProps = {
    onResize: function onResize() {},
    disableHeight: false,
    disableWidth: false,
    style: {}
};
$22a2a99166405134$var$AutoSizer.propTypes = null;
module.exports.default = $22a2a99166405134$var$AutoSizer;

});
parcelRegister("knQh8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ed6e817027dc4fd8$export$1e511d4a378977f5, (v) => $ed6e817027dc4fd8$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ed6e817027dc4fd8$export$2e2bcd8739ae039, (v) => $ed6e817027dc4fd8$export$2e2bcd8739ae039 = v);
var $ed6e817027dc4fd8$export$1e511d4a378977f5;
var $ed6e817027dc4fd8$export$2e2bcd8739ae039;
"use strict";
$ed6e817027dc4fd8$export$1e511d4a378977f5 = true;

var $cjLx9 = parcelRequire("cjLx9");
var $ed6e817027dc4fd8$var$_assign2 = $ed6e817027dc4fd8$var$_interopRequireDefault($cjLx9);
function $ed6e817027dc4fd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$ed6e817027dc4fd8$export$2e2bcd8739ae039 = $ed6e817027dc4fd8$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("cjLx9", function(module, exports) {

module.exports = {
    "default": (parcelRequire("6qqLf")),
    __esModule: true
};

});
parcelRegister("6qqLf", function(module, exports) {
parcelRequire("lsZw3");

module.exports = (parcelRequire("dv4GG")).Object.assign;

});
parcelRegister("lsZw3", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $8EFNH = parcelRequire("8EFNH");

$8EFNH($8EFNH.S + $8EFNH.F, 'Object', {
    assign: (parcelRequire("eCvdn"))
});

});
parcelRegister("8EFNH", function(module, exports) {

var $pe18r = parcelRequire("pe18r");

var $dv4GG = parcelRequire("dv4GG");

var $gnejD = parcelRequire("gnejD");

var $kM6mh = parcelRequire("kM6mh");

var $aMccP = parcelRequire("aMccP");
var $64d27bdec060590e$var$PROTOTYPE = 'prototype';
var $64d27bdec060590e$var$$export = function(type, name, source) {
    var IS_FORCED = type & $64d27bdec060590e$var$$export.F;
    var IS_GLOBAL = type & $64d27bdec060590e$var$$export.G;
    var IS_STATIC = type & $64d27bdec060590e$var$$export.S;
    var IS_PROTO = type & $64d27bdec060590e$var$$export.P;
    var IS_BIND = type & $64d27bdec060590e$var$$export.B;
    var IS_WRAP = type & $64d27bdec060590e$var$$export.W;
    var exports = IS_GLOBAL ? $dv4GG : $dv4GG[name] || ($dv4GG[name] = {});
    var expProto = exports[$64d27bdec060590e$var$PROTOTYPE];
    var target = IS_GLOBAL ? $pe18r : IS_STATIC ? $pe18r[name] : ($pe18r[name] || {})[$64d27bdec060590e$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $aMccP(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $gnejD(out, $pe18r) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$64d27bdec060590e$var$PROTOTYPE] = C[$64d27bdec060590e$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $gnejD(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $64d27bdec060590e$var$$export.R && expProto && !expProto[key]) $kM6mh(expProto, key, out);
        }
    }
};
// type bitmap
$64d27bdec060590e$var$$export.F = 1; // forced
$64d27bdec060590e$var$$export.G = 2; // global
$64d27bdec060590e$var$$export.S = 4; // static
$64d27bdec060590e$var$$export.P = 8; // proto
$64d27bdec060590e$var$$export.B = 16; // bind
$64d27bdec060590e$var$$export.W = 32; // wrap
$64d27bdec060590e$var$$export.U = 64; // safe
$64d27bdec060590e$var$$export.R = 128; // real proto method for `library`
module.exports = $64d27bdec060590e$var$$export;

});
parcelRegister("pe18r", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $04bd3575bb3eed01$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $04bd3575bb3eed01$var$global; // eslint-disable-line no-undef

});

parcelRegister("dv4GG", function(module, exports) {
var $9d41ce6d167d80d2$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $9d41ce6d167d80d2$var$core; // eslint-disable-line no-undef

});

parcelRegister("gnejD", function(module, exports) {
// optional / simple context binding

var $jd5tk = parcelRequire("jd5tk");
module.exports = function(fn, that, length) {
    $jd5tk(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("jd5tk", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("kM6mh", function(module, exports) {

var $30LaA = parcelRequire("30LaA");

var $evesF = parcelRequire("evesF");

module.exports = (parcelRequire("hn2oF")) ? function(object, key, value) {
    return $30LaA.f(object, key, $evesF(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("30LaA", function(module, exports) {

$parcel$export(module.exports, "f", () => $2315f61bd3482fc3$export$2d1720544b23b823, (v) => $2315f61bd3482fc3$export$2d1720544b23b823 = v);
var $2315f61bd3482fc3$export$2d1720544b23b823;

var $6rs9h = parcelRequire("6rs9h");

var $dzU8d = parcelRequire("dzU8d");

var $7Af9t = parcelRequire("7Af9t");
var $2315f61bd3482fc3$var$dP = Object.defineProperty;

$2315f61bd3482fc3$export$2d1720544b23b823 = (parcelRequire("hn2oF")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $6rs9h(O);
    P = $7Af9t(P, true);
    $6rs9h(Attributes);
    if ($dzU8d) try {
        return $2315f61bd3482fc3$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("6rs9h", function(module, exports) {

var $6VwBm = parcelRequire("6VwBm");
module.exports = function(it) {
    if (!$6VwBm(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("6VwBm", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("dzU8d", function(module, exports) {



module.exports = !(parcelRequire("hn2oF")) && !(parcelRequire("5nD9T"))(function() {
    return Object.defineProperty((parcelRequire("iSIdA"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("hn2oF", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("5nD9T"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("5nD9T", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("iSIdA", function(module, exports) {

var $6VwBm = parcelRequire("6VwBm");

var $pe18r = parcelRequire("pe18r");
var $dbef91f2a743dd1e$require$document = $pe18r.document;
// typeof document.createElement is 'object' in old IE
var $dbef91f2a743dd1e$var$is = $6VwBm($dbef91f2a743dd1e$require$document) && $6VwBm($dbef91f2a743dd1e$require$document.createElement);
module.exports = function(it) {
    return $dbef91f2a743dd1e$var$is ? $dbef91f2a743dd1e$require$document.createElement(it) : {};
};

});


parcelRegister("7Af9t", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $6VwBm = parcelRequire("6VwBm");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$6VwBm(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$6VwBm(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$6VwBm(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$6VwBm(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("evesF", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("aMccP", function(module, exports) {
var $7d87daef9d4e91b8$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $7d87daef9d4e91b8$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("eCvdn", function(module, exports) {
'use strict';

var $hn2oF = parcelRequire("hn2oF");

var $8rKxD = parcelRequire("8rKxD");

var $1Jjbj = parcelRequire("1Jjbj");

var $gvEJa = parcelRequire("gvEJa");

var $8tRkg = parcelRequire("8tRkg");

var $2A2jr = parcelRequire("2A2jr");
var $aa4cd3e3ae28fa7e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$aa4cd3e3ae28fa7e$var$$assign || (parcelRequire("5nD9T"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $aa4cd3e3ae28fa7e$var$$assign({}, A)[S] != 7 || Object.keys($aa4cd3e3ae28fa7e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $8tRkg(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $1Jjbj.f;
    var isEnum = $gvEJa.f;
    while(aLen > index){
        var S = $2A2jr(arguments[index++]);
        var keys = getSymbols ? $8rKxD(S).concat(getSymbols(S)) : $8rKxD(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$hn2oF || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $aa4cd3e3ae28fa7e$var$$assign;

});
parcelRegister("8rKxD", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $aW8ua = parcelRequire("aW8ua");

var $aIGUN = parcelRequire("aIGUN");
module.exports = Object.keys || function keys(O) {
    return $aW8ua(O, $aIGUN);
};

});
parcelRegister("aW8ua", function(module, exports) {

var $aMccP = parcelRequire("aMccP");

var $59DzK = parcelRequire("59DzK");

var $7f65e7394a9ddf07$var$arrayIndexOf = (parcelRequire("6FnDv"))(false);

var $7f65e7394a9ddf07$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $59DzK(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $7f65e7394a9ddf07$var$IE_PROTO) $aMccP(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($aMccP(O, key = names[i++])) ~$7f65e7394a9ddf07$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("59DzK", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $2A2jr = parcelRequire("2A2jr");

var $ie6R6 = parcelRequire("ie6R6");
module.exports = function(it) {
    return $2A2jr($ie6R6(it));
};

});
parcelRegister("2A2jr", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $eYYzh = parcelRequire("eYYzh");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $eYYzh(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("eYYzh", function(module, exports) {
var $ae85a6d59702a8f0$var$toString = {}.toString;
module.exports = function(it) {
    return $ae85a6d59702a8f0$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("ie6R6", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("6FnDv", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $59DzK = parcelRequire("59DzK");

var $lpAeO = parcelRequire("lpAeO");

var $7XibQ = parcelRequire("7XibQ");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $59DzK($this);
        var length = $lpAeO(O.length);
        var index = $7XibQ(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("lpAeO", function(module, exports) {
// 7.1.15 ToLength

var $h2TDF = parcelRequire("h2TDF");
var $f9680adf10caefa3$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $f9680adf10caefa3$var$min($h2TDF(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("h2TDF", function(module, exports) {
// 7.1.4 ToInteger
var $c68dc842fc575f58$var$ceil = Math.ceil;
var $c68dc842fc575f58$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $c68dc842fc575f58$var$floor : $c68dc842fc575f58$var$ceil)(it);
};

});


parcelRegister("7XibQ", function(module, exports) {

var $h2TDF = parcelRequire("h2TDF");
var $5cac2746a26f7adf$var$max = Math.max;
var $5cac2746a26f7adf$var$min = Math.min;
module.exports = function(index, length) {
    index = $h2TDF(index);
    return index < 0 ? $5cac2746a26f7adf$var$max(index + length, 0) : $5cac2746a26f7adf$var$min(index, length);
};

});


parcelRegister("4BPKE", function(module, exports) {

var $35b2c2e77589c562$var$shared = (parcelRequire("inCOl"))('keys');

var $42V7x = parcelRequire("42V7x");
module.exports = function(key) {
    return $35b2c2e77589c562$var$shared[key] || ($35b2c2e77589c562$var$shared[key] = $42V7x(key));
};

});
parcelRegister("inCOl", function(module, exports) {

var $dv4GG = parcelRequire("dv4GG");

var $pe18r = parcelRequire("pe18r");
var $d6187b0aaf68f232$var$SHARED = '__core-js_shared__';
var $d6187b0aaf68f232$var$store = $pe18r[$d6187b0aaf68f232$var$SHARED] || ($pe18r[$d6187b0aaf68f232$var$SHARED] = {});

(module.exports = function(key, value) {
    return $d6187b0aaf68f232$var$store[key] || ($d6187b0aaf68f232$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $dv4GG.version,
    mode: (parcelRequire("6uq1C")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("6uq1C", function(module, exports) {
module.exports = true;

});


parcelRegister("42V7x", function(module, exports) {
var $2f23a8463a1ba411$var$id = 0;
var $2f23a8463a1ba411$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$2f23a8463a1ba411$var$id + $2f23a8463a1ba411$var$px).toString(36));
};

});



parcelRegister("aIGUN", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("1Jjbj", function(module, exports) {

$parcel$export(module.exports, "f", () => $1428df70697477af$export$2d1720544b23b823, (v) => $1428df70697477af$export$2d1720544b23b823 = v);
var $1428df70697477af$export$2d1720544b23b823;
$1428df70697477af$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("gvEJa", function(module, exports) {

$parcel$export(module.exports, "f", () => $c04f223f8947297b$export$2d1720544b23b823, (v) => $c04f223f8947297b$export$2d1720544b23b823 = v);
var $c04f223f8947297b$export$2d1720544b23b823;
$c04f223f8947297b$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("8tRkg", function(module, exports) {
// 7.1.13 ToObject(argument)

var $ie6R6 = parcelRequire("ie6R6");
module.exports = function(it) {
    return Object($ie6R6(it));
};

});






parcelRegister("29Ol4", function(module, exports) {

module.exports = {
    "default": (parcelRequire("22VpG")),
    __esModule: true
};

});
parcelRegister("22VpG", function(module, exports) {
parcelRequire("7Invg");

module.exports = (parcelRequire("dv4GG")).Object.getPrototypeOf;

});
parcelRegister("7Invg", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $8tRkg = parcelRequire("8tRkg");

var $97OQk = parcelRequire("97OQk");

(parcelRequire("8iDav"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $97OQk($8tRkg(it));
    };
});

});
parcelRegister("97OQk", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $aMccP = parcelRequire("aMccP");

var $8tRkg = parcelRequire("8tRkg");

var $6a4c34daf431297a$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
var $6a4c34daf431297a$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $8tRkg(O);
    if ($aMccP(O, $6a4c34daf431297a$var$IE_PROTO)) return O[$6a4c34daf431297a$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $6a4c34daf431297a$var$ObjectProto : null;
};

});

parcelRegister("8iDav", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $8EFNH = parcelRequire("8EFNH");

var $dv4GG = parcelRequire("dv4GG");

var $5nD9T = parcelRequire("5nD9T");
module.exports = function(KEY, exec) {
    var fn = ($dv4GG.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $8EFNH($8EFNH.S + $8EFNH.F * $5nD9T(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("aXTp8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7fba6438b4dbf46b$export$1e511d4a378977f5, (v) => $7fba6438b4dbf46b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7fba6438b4dbf46b$export$2e2bcd8739ae039, (v) => $7fba6438b4dbf46b$export$2e2bcd8739ae039 = v);
var $7fba6438b4dbf46b$export$1e511d4a378977f5;
var $7fba6438b4dbf46b$export$2e2bcd8739ae039;
"use strict";
$7fba6438b4dbf46b$export$1e511d4a378977f5 = true;
$7fba6438b4dbf46b$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("4tLNB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $342ef2b9df8992a7$export$1e511d4a378977f5, (v) => $342ef2b9df8992a7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $342ef2b9df8992a7$export$2e2bcd8739ae039, (v) => $342ef2b9df8992a7$export$2e2bcd8739ae039 = v);
var $342ef2b9df8992a7$export$1e511d4a378977f5;
var $342ef2b9df8992a7$export$2e2bcd8739ae039;
"use strict";
$342ef2b9df8992a7$export$1e511d4a378977f5 = true;

var $aWlLP = parcelRequire("aWlLP");
var $342ef2b9df8992a7$var$_defineProperty2 = $342ef2b9df8992a7$var$_interopRequireDefault($aWlLP);
function $342ef2b9df8992a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$342ef2b9df8992a7$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $342ef2b9df8992a7$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("aWlLP", function(module, exports) {

module.exports = {
    "default": (parcelRequire("cEZdw")),
    __esModule: true
};

});
parcelRegister("cEZdw", function(module, exports) {
parcelRequire("7vx5B");

var $dv4GG = parcelRequire("dv4GG");
var $9378b4ec927c6689$require$$Object = $dv4GG.Object;
module.exports = function defineProperty(it, key, desc) {
    return $9378b4ec927c6689$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("7vx5B", function(module, exports) {

var $8EFNH = parcelRequire("8EFNH");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$8EFNH($8EFNH.S + $8EFNH.F * !(parcelRequire("hn2oF")), 'Object', {
    defineProperty: (parcelRequire("30LaA")).f
});

});




parcelRegister("5pMaQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3f14a7e1704920da$export$1e511d4a378977f5, (v) => $3f14a7e1704920da$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3f14a7e1704920da$export$2e2bcd8739ae039, (v) => $3f14a7e1704920da$export$2e2bcd8739ae039 = v);
var $3f14a7e1704920da$export$1e511d4a378977f5;
var $3f14a7e1704920da$export$2e2bcd8739ae039;
"use strict";
$3f14a7e1704920da$export$1e511d4a378977f5 = true;

var $kt6ai = parcelRequire("kt6ai");
var $3f14a7e1704920da$var$_typeof3 = $3f14a7e1704920da$var$_interopRequireDefault($kt6ai);
function $3f14a7e1704920da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3f14a7e1704920da$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $3f14a7e1704920da$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("kt6ai", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ee6b4c58df698443$export$1e511d4a378977f5, (v) => $ee6b4c58df698443$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ee6b4c58df698443$export$2e2bcd8739ae039, (v) => $ee6b4c58df698443$export$2e2bcd8739ae039 = v);
var $ee6b4c58df698443$export$1e511d4a378977f5;
var $ee6b4c58df698443$export$2e2bcd8739ae039;
"use strict";
$ee6b4c58df698443$export$1e511d4a378977f5 = true;

var $5YQKd = parcelRequire("5YQKd");
var $ee6b4c58df698443$var$_iterator2 = $ee6b4c58df698443$var$_interopRequireDefault($5YQKd);

var $V3332 = parcelRequire("V3332");
var $ee6b4c58df698443$var$_symbol2 = $ee6b4c58df698443$var$_interopRequireDefault($V3332);
var $ee6b4c58df698443$var$_typeof = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && typeof $ee6b4c58df698443$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $ee6b4c58df698443$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$ee6b4c58df698443$export$2e2bcd8739ae039 = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && $ee6b4c58df698443$var$_typeof($ee6b4c58df698443$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
};

});
parcelRegister("5YQKd", function(module, exports) {

module.exports = {
    "default": (parcelRequire("hpbwm")),
    __esModule: true
};

});
parcelRegister("hpbwm", function(module, exports) {
parcelRequire("ltQ0T");
parcelRequire("fQXw1");

module.exports = (parcelRequire("3iakE")).f('iterator');

});
parcelRegister("ltQ0T", function(module, exports) {
'use strict';

var $fa34a72ca0e00838$var$$at = (parcelRequire("TnwZj"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("bH4Ac"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $fa34a72ca0e00838$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("TnwZj", function(module, exports) {

var $h2TDF = parcelRequire("h2TDF");

var $ie6R6 = parcelRequire("ie6R6");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($ie6R6(that));
        var i = $h2TDF(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("bH4Ac", function(module, exports) {
'use strict';

var $6uq1C = parcelRequire("6uq1C");

var $8EFNH = parcelRequire("8EFNH");

var $3VDKT = parcelRequire("3VDKT");

var $kM6mh = parcelRequire("kM6mh");

var $eu895 = parcelRequire("eu895");

var $jEAut = parcelRequire("jEAut");

var $8nOHH = parcelRequire("8nOHH");

var $97OQk = parcelRequire("97OQk");

var $883743f265dc0269$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
var $883743f265dc0269$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $883743f265dc0269$var$FF_ITERATOR = '@@iterator';
var $883743f265dc0269$var$KEYS = 'keys';
var $883743f265dc0269$var$VALUES = 'values';
var $883743f265dc0269$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $jEAut(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$883743f265dc0269$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $883743f265dc0269$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $883743f265dc0269$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $883743f265dc0269$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$883743f265dc0269$var$ITERATOR] || proto[$883743f265dc0269$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $97OQk($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $8nOHH(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$6uq1C && typeof IteratorPrototype[$883743f265dc0269$var$ITERATOR] != 'function') $kM6mh(IteratorPrototype, $883743f265dc0269$var$ITERATOR, $883743f265dc0269$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $883743f265dc0269$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$6uq1C || FORCED) && ($883743f265dc0269$var$BUGGY || VALUES_BUG || !proto[$883743f265dc0269$var$ITERATOR])) $kM6mh(proto, $883743f265dc0269$var$ITERATOR, $default);
    // Plug for library
    $eu895[NAME] = $default;
    $eu895[TAG] = $883743f265dc0269$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($883743f265dc0269$var$VALUES),
            keys: IS_SET ? $default : getMethod($883743f265dc0269$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $3VDKT(proto, key, methods[key]);
        } else $8EFNH($8EFNH.P + $8EFNH.F * ($883743f265dc0269$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("3VDKT", function(module, exports) {

module.exports = (parcelRequire("kM6mh"));

});

parcelRegister("eu895", function(module, exports) {
module.exports = {};

});

parcelRegister("jEAut", function(module, exports) {
'use strict';

var $l5MPs = parcelRequire("l5MPs");

var $evesF = parcelRequire("evesF");

var $8nOHH = parcelRequire("8nOHH");
var $e4ee0efba5a7f6a9$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("kM6mh"))($e4ee0efba5a7f6a9$var$IteratorPrototype, (parcelRequire("cNfss"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $l5MPs($e4ee0efba5a7f6a9$var$IteratorPrototype, {
        next: $evesF(1, next)
    });
    $8nOHH(Constructor, NAME + ' Iterator');
};

});
parcelRegister("l5MPs", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $6rs9h = parcelRequire("6rs9h");

var $hrzgw = parcelRequire("hrzgw");

var $aIGUN = parcelRequire("aIGUN");

var $f5aff1030646fd55$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
var $f5aff1030646fd55$var$Empty = function() {};
var $f5aff1030646fd55$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f5aff1030646fd55$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("iSIdA"))('iframe');
    var i = $aIGUN.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("fW23X")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $f5aff1030646fd55$var$createDict = iframeDocument.F;
    while(i--)delete $f5aff1030646fd55$var$createDict[$f5aff1030646fd55$var$PROTOTYPE][$aIGUN[i]];
    return $f5aff1030646fd55$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f5aff1030646fd55$var$Empty[$f5aff1030646fd55$var$PROTOTYPE] = $6rs9h(O);
        result = new $f5aff1030646fd55$var$Empty();
        $f5aff1030646fd55$var$Empty[$f5aff1030646fd55$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f5aff1030646fd55$var$IE_PROTO] = O;
    } else result = $f5aff1030646fd55$var$createDict();
    return Properties === undefined ? result : $hrzgw(result, Properties);
};

});
parcelRegister("hrzgw", function(module, exports) {

var $30LaA = parcelRequire("30LaA");

var $6rs9h = parcelRequire("6rs9h");

var $8rKxD = parcelRequire("8rKxD");

module.exports = (parcelRequire("hn2oF")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $6rs9h(O);
    var keys = $8rKxD(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$30LaA.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("fW23X", function(module, exports) {

var $pe18r = parcelRequire("pe18r");
var $b99ddf714ab9b2ae$require$document = $pe18r.document;
module.exports = $b99ddf714ab9b2ae$require$document && $b99ddf714ab9b2ae$require$document.documentElement;

});


parcelRegister("8nOHH", function(module, exports) {

var $30LaA = parcelRequire("30LaA");
var $61a7cd74d8b334f9$require$def = $30LaA.f;

var $aMccP = parcelRequire("aMccP");

var $61a7cd74d8b334f9$var$TAG = (parcelRequire("cNfss"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$aMccP(it = stat ? it : it.prototype, $61a7cd74d8b334f9$var$TAG)) $61a7cd74d8b334f9$require$def(it, $61a7cd74d8b334f9$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("cNfss", function(module, exports) {

var $95060d4712c30789$var$store = (parcelRequire("inCOl"))('wks');

var $42V7x = parcelRequire("42V7x");

var $pe18r = parcelRequire("pe18r");
var $95060d4712c30789$require$Symbol = $pe18r.Symbol;
var $95060d4712c30789$var$USE_SYMBOL = typeof $95060d4712c30789$require$Symbol == 'function';
var $95060d4712c30789$var$$exports = module.exports = function(name) {
    return $95060d4712c30789$var$store[name] || ($95060d4712c30789$var$store[name] = $95060d4712c30789$var$USE_SYMBOL && $95060d4712c30789$require$Symbol[name] || ($95060d4712c30789$var$USE_SYMBOL ? $95060d4712c30789$require$Symbol : $42V7x)('Symbol.' + name));
};
$95060d4712c30789$var$$exports.store = $95060d4712c30789$var$store;

});





parcelRegister("fQXw1", function(module, exports) {
parcelRequire("bSOrM");

var $pe18r = parcelRequire("pe18r");

var $kM6mh = parcelRequire("kM6mh");

var $eu895 = parcelRequire("eu895");

var $b8a9e0dc29c7f4f5$var$TO_STRING_TAG = (parcelRequire("cNfss"))('toStringTag');
var $b8a9e0dc29c7f4f5$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $b8a9e0dc29c7f4f5$var$i = 0; $b8a9e0dc29c7f4f5$var$i < $b8a9e0dc29c7f4f5$var$DOMIterables.length; $b8a9e0dc29c7f4f5$var$i++){
    var $b8a9e0dc29c7f4f5$var$NAME = $b8a9e0dc29c7f4f5$var$DOMIterables[$b8a9e0dc29c7f4f5$var$i];
    var $b8a9e0dc29c7f4f5$var$Collection = $pe18r[$b8a9e0dc29c7f4f5$var$NAME];
    var $b8a9e0dc29c7f4f5$var$proto = $b8a9e0dc29c7f4f5$var$Collection && $b8a9e0dc29c7f4f5$var$Collection.prototype;
    if ($b8a9e0dc29c7f4f5$var$proto && !$b8a9e0dc29c7f4f5$var$proto[$b8a9e0dc29c7f4f5$var$TO_STRING_TAG]) $kM6mh($b8a9e0dc29c7f4f5$var$proto, $b8a9e0dc29c7f4f5$var$TO_STRING_TAG, $b8a9e0dc29c7f4f5$var$NAME);
    $eu895[$b8a9e0dc29c7f4f5$var$NAME] = $eu895.Array;
}

});
parcelRegister("bSOrM", function(module, exports) {
'use strict';

var $hvcNK = parcelRequire("hvcNK");

var $2WIr8 = parcelRequire("2WIr8");

var $eu895 = parcelRequire("eu895");

var $59DzK = parcelRequire("59DzK");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("bH4Ac"))(Array, 'Array', function(iterated, kind) {
    this._t = $59DzK(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $2WIr8(1);
    }
    if (kind == 'keys') return $2WIr8(0, index);
    if (kind == 'values') return $2WIr8(0, O[index]);
    return $2WIr8(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$eu895.Arguments = $eu895.Array;
$hvcNK('keys');
$hvcNK('values');
$hvcNK('entries');

});
parcelRegister("hvcNK", function(module, exports) {
module.exports = function() {};

});

parcelRegister("2WIr8", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("3iakE", function(module, exports) {

$parcel$export(module.exports, "f", () => $265b1149da5b805d$export$2d1720544b23b823, (v) => $265b1149da5b805d$export$2d1720544b23b823 = v);
var $265b1149da5b805d$export$2d1720544b23b823;

$265b1149da5b805d$export$2d1720544b23b823 = (parcelRequire("cNfss"));

});



parcelRegister("V3332", function(module, exports) {

module.exports = {
    "default": (parcelRequire("5MRee")),
    __esModule: true
};

});
parcelRegister("5MRee", function(module, exports) {
parcelRequire("dV330");
parcelRequire("55SkS");
parcelRequire("8IAUf");
parcelRequire("fvEHr");

module.exports = (parcelRequire("dv4GG")).Symbol;

});
parcelRegister("dV330", function(module, exports) {
'use strict';

var $pe18r = parcelRequire("pe18r");

var $aMccP = parcelRequire("aMccP");

var $hn2oF = parcelRequire("hn2oF");

var $8EFNH = parcelRequire("8EFNH");

var $3VDKT = parcelRequire("3VDKT");

var $hXWWY = parcelRequire("hXWWY");
var $a222f66347247ddd$require$META = $hXWWY.KEY;

var $5nD9T = parcelRequire("5nD9T");

var $inCOl = parcelRequire("inCOl");

var $8nOHH = parcelRequire("8nOHH");

var $42V7x = parcelRequire("42V7x");

var $cNfss = parcelRequire("cNfss");

var $3iakE = parcelRequire("3iakE");

var $eKGZg = parcelRequire("eKGZg");

var $8yCLj = parcelRequire("8yCLj");

var $imb3o = parcelRequire("imb3o");

var $6rs9h = parcelRequire("6rs9h");

var $6VwBm = parcelRequire("6VwBm");

var $8tRkg = parcelRequire("8tRkg");

var $59DzK = parcelRequire("59DzK");

var $7Af9t = parcelRequire("7Af9t");

var $evesF = parcelRequire("evesF");

var $l5MPs = parcelRequire("l5MPs");

var $2JUNR = parcelRequire("2JUNR");

var $56mOV = parcelRequire("56mOV");

var $1Jjbj = parcelRequire("1Jjbj");

var $30LaA = parcelRequire("30LaA");

var $8rKxD = parcelRequire("8rKxD");
var $a222f66347247ddd$var$gOPD = $56mOV.f;
var $a222f66347247ddd$var$dP = $30LaA.f;
var $a222f66347247ddd$var$gOPN = $2JUNR.f;
var $a222f66347247ddd$var$$Symbol = $pe18r.Symbol;
var $a222f66347247ddd$var$$JSON = $pe18r.JSON;
var $a222f66347247ddd$var$_stringify = $a222f66347247ddd$var$$JSON && $a222f66347247ddd$var$$JSON.stringify;
var $a222f66347247ddd$var$PROTOTYPE = 'prototype';
var $a222f66347247ddd$var$HIDDEN = $cNfss('_hidden');
var $a222f66347247ddd$var$TO_PRIMITIVE = $cNfss('toPrimitive');
var $a222f66347247ddd$var$isEnum = {}.propertyIsEnumerable;
var $a222f66347247ddd$var$SymbolRegistry = $inCOl('symbol-registry');
var $a222f66347247ddd$var$AllSymbols = $inCOl('symbols');
var $a222f66347247ddd$var$OPSymbols = $inCOl('op-symbols');
var $a222f66347247ddd$var$ObjectProto = Object[$a222f66347247ddd$var$PROTOTYPE];
var $a222f66347247ddd$var$USE_NATIVE = typeof $a222f66347247ddd$var$$Symbol == 'function' && !!$1Jjbj.f;
var $a222f66347247ddd$var$QObject = $pe18r.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $a222f66347247ddd$var$setter = !$a222f66347247ddd$var$QObject || !$a222f66347247ddd$var$QObject[$a222f66347247ddd$var$PROTOTYPE] || !$a222f66347247ddd$var$QObject[$a222f66347247ddd$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $a222f66347247ddd$var$setSymbolDesc = $hn2oF && $5nD9T(function() {
    return $l5MPs($a222f66347247ddd$var$dP({}, 'a', {
        get: function() {
            return $a222f66347247ddd$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $a222f66347247ddd$var$gOPD($a222f66347247ddd$var$ObjectProto, key);
    if (protoDesc) delete $a222f66347247ddd$var$ObjectProto[key];
    $a222f66347247ddd$var$dP(it, key, D);
    if (protoDesc && it !== $a222f66347247ddd$var$ObjectProto) $a222f66347247ddd$var$dP($a222f66347247ddd$var$ObjectProto, key, protoDesc);
} : $a222f66347247ddd$var$dP;
var $a222f66347247ddd$var$wrap = function(tag) {
    var sym = $a222f66347247ddd$var$AllSymbols[tag] = $l5MPs($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $a222f66347247ddd$var$isSymbol = $a222f66347247ddd$var$USE_NATIVE && typeof $a222f66347247ddd$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $a222f66347247ddd$var$$Symbol;
};
var $a222f66347247ddd$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $a222f66347247ddd$var$ObjectProto) $a222f66347247ddd$var$$defineProperty($a222f66347247ddd$var$OPSymbols, key, D);
    $6rs9h(it);
    key = $7Af9t(key, true);
    $6rs9h(D);
    if ($aMccP($a222f66347247ddd$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$aMccP(it, $a222f66347247ddd$var$HIDDEN)) $a222f66347247ddd$var$dP(it, $a222f66347247ddd$var$HIDDEN, $evesF(1, {}));
            it[$a222f66347247ddd$var$HIDDEN][key] = true;
        } else {
            if ($aMccP(it, $a222f66347247ddd$var$HIDDEN) && it[$a222f66347247ddd$var$HIDDEN][key]) it[$a222f66347247ddd$var$HIDDEN][key] = false;
            D = $l5MPs(D, {
                enumerable: $evesF(0, false)
            });
        }
        return $a222f66347247ddd$var$setSymbolDesc(it, key, D);
    }
    return $a222f66347247ddd$var$dP(it, key, D);
};
var $a222f66347247ddd$var$$defineProperties = function defineProperties(it, P) {
    $6rs9h(it);
    var keys = $8yCLj(P = $59DzK(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$a222f66347247ddd$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $a222f66347247ddd$var$$create = function create(it, P) {
    return P === undefined ? $l5MPs(it) : $a222f66347247ddd$var$$defineProperties($l5MPs(it), P);
};
var $a222f66347247ddd$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $a222f66347247ddd$var$isEnum.call(this, key = $7Af9t(key, true));
    if (this === $a222f66347247ddd$var$ObjectProto && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !$aMccP($a222f66347247ddd$var$OPSymbols, key)) return false;
    return E || !$aMccP(this, key) || !$aMccP($a222f66347247ddd$var$AllSymbols, key) || $aMccP(this, $a222f66347247ddd$var$HIDDEN) && this[$a222f66347247ddd$var$HIDDEN][key] ? E : true;
};
var $a222f66347247ddd$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $59DzK(it);
    key = $7Af9t(key, true);
    if (it === $a222f66347247ddd$var$ObjectProto && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !$aMccP($a222f66347247ddd$var$OPSymbols, key)) return;
    var D = $a222f66347247ddd$var$gOPD(it, key);
    if (D && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !($aMccP(it, $a222f66347247ddd$var$HIDDEN) && it[$a222f66347247ddd$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $a222f66347247ddd$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $a222f66347247ddd$var$gOPN($59DzK(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$aMccP($a222f66347247ddd$var$AllSymbols, key = names[i++]) && key != $a222f66347247ddd$var$HIDDEN && key != $a222f66347247ddd$require$META) result.push(key);
    return result;
};
var $a222f66347247ddd$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $a222f66347247ddd$var$ObjectProto;
    var names = $a222f66347247ddd$var$gOPN(IS_OP ? $a222f66347247ddd$var$OPSymbols : $59DzK(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($aMccP($a222f66347247ddd$var$AllSymbols, key = names[i++]) && (IS_OP ? $aMccP($a222f66347247ddd$var$ObjectProto, key) : true)) result.push($a222f66347247ddd$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$a222f66347247ddd$var$USE_NATIVE) {
    $a222f66347247ddd$var$$Symbol = function Symbol() {
        if (this instanceof $a222f66347247ddd$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $42V7x(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $a222f66347247ddd$var$ObjectProto) $set.call($a222f66347247ddd$var$OPSymbols, value);
            if ($aMccP(this, $a222f66347247ddd$var$HIDDEN) && $aMccP(this[$a222f66347247ddd$var$HIDDEN], tag)) this[$a222f66347247ddd$var$HIDDEN][tag] = false;
            $a222f66347247ddd$var$setSymbolDesc(this, tag, $evesF(1, value));
        };
        if ($hn2oF && $a222f66347247ddd$var$setter) $a222f66347247ddd$var$setSymbolDesc($a222f66347247ddd$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $a222f66347247ddd$var$wrap(tag);
    };
    $3VDKT($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $56mOV.f = $a222f66347247ddd$var$$getOwnPropertyDescriptor;
    $30LaA.f = $a222f66347247ddd$var$$defineProperty;
    (parcelRequire("7X6HN")).f = $2JUNR.f = $a222f66347247ddd$var$$getOwnPropertyNames;
    (parcelRequire("gvEJa")).f = $a222f66347247ddd$var$$propertyIsEnumerable;
    $1Jjbj.f = $a222f66347247ddd$var$$getOwnPropertySymbols;
    if ($hn2oF && !(parcelRequire("6uq1C"))) $3VDKT($a222f66347247ddd$var$ObjectProto, 'propertyIsEnumerable', $a222f66347247ddd$var$$propertyIsEnumerable, true);
    $3iakE.f = function(name) {
        return $a222f66347247ddd$var$wrap($cNfss(name));
    };
}
$8EFNH($8EFNH.G + $8EFNH.W + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, {
    Symbol: $a222f66347247ddd$var$$Symbol
});
for(var $a222f66347247ddd$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $a222f66347247ddd$var$j = 0; $a222f66347247ddd$var$es6Symbols.length > $a222f66347247ddd$var$j;)$cNfss($a222f66347247ddd$var$es6Symbols[$a222f66347247ddd$var$j++]);
for(var $a222f66347247ddd$var$wellKnownSymbols = $8rKxD($cNfss.store), $a222f66347247ddd$var$k = 0; $a222f66347247ddd$var$wellKnownSymbols.length > $a222f66347247ddd$var$k;)$eKGZg($a222f66347247ddd$var$wellKnownSymbols[$a222f66347247ddd$var$k++]);
$8EFNH($8EFNH.S + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $aMccP($a222f66347247ddd$var$SymbolRegistry, key += '') ? $a222f66347247ddd$var$SymbolRegistry[key] : $a222f66347247ddd$var$SymbolRegistry[key] = $a222f66347247ddd$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$a222f66347247ddd$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $a222f66347247ddd$var$SymbolRegistry)if ($a222f66347247ddd$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $a222f66347247ddd$var$setter = true;
    },
    useSimple: function() {
        $a222f66347247ddd$var$setter = false;
    }
});
$8EFNH($8EFNH.S + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $a222f66347247ddd$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $a222f66347247ddd$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $a222f66347247ddd$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $a222f66347247ddd$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $a222f66347247ddd$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $a222f66347247ddd$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $a222f66347247ddd$var$FAILS_ON_PRIMITIVES = $5nD9T(function() {
    $1Jjbj.f(1);
});
$8EFNH($8EFNH.S + $8EFNH.F * $a222f66347247ddd$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $1Jjbj.f($8tRkg(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$a222f66347247ddd$var$$JSON && $8EFNH($8EFNH.S + $8EFNH.F * (!$a222f66347247ddd$var$USE_NATIVE || $5nD9T(function() {
    var S = $a222f66347247ddd$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $a222f66347247ddd$var$_stringify([
        S
    ]) != '[null]' || $a222f66347247ddd$var$_stringify({
        a: S
    }) != '{}' || $a222f66347247ddd$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$6VwBm(replacer) && it === undefined || $a222f66347247ddd$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$imb3o(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$a222f66347247ddd$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $a222f66347247ddd$var$_stringify.apply($a222f66347247ddd$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE][$a222f66347247ddd$var$TO_PRIMITIVE] || (parcelRequire("kM6mh"))($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE], $a222f66347247ddd$var$TO_PRIMITIVE, $a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$8nOHH($a222f66347247ddd$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$8nOHH(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$8nOHH($pe18r.JSON, 'JSON', true);

});
parcelRegister("hXWWY", function(module, exports) {

var $d145aca8ddc395e4$var$META = (parcelRequire("42V7x"))('meta');

var $6VwBm = parcelRequire("6VwBm");

var $aMccP = parcelRequire("aMccP");

var $30LaA = parcelRequire("30LaA");
var $d145aca8ddc395e4$require$setDesc = $30LaA.f;
var $d145aca8ddc395e4$var$id = 0;
var $d145aca8ddc395e4$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $d145aca8ddc395e4$var$FREEZE = !(parcelRequire("5nD9T"))(function() {
    return $d145aca8ddc395e4$var$isExtensible(Object.preventExtensions({}));
});
var $d145aca8ddc395e4$var$setMeta = function(it) {
    $d145aca8ddc395e4$require$setDesc(it, $d145aca8ddc395e4$var$META, {
        value: {
            i: 'O' + ++$d145aca8ddc395e4$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $d145aca8ddc395e4$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$6VwBm(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$aMccP(it, $d145aca8ddc395e4$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$d145aca8ddc395e4$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $d145aca8ddc395e4$var$setMeta(it);
    // return object ID
    }
    return it[$d145aca8ddc395e4$var$META].i;
};
var $d145aca8ddc395e4$var$getWeak = function(it, create) {
    if (!$aMccP(it, $d145aca8ddc395e4$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$d145aca8ddc395e4$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $d145aca8ddc395e4$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$d145aca8ddc395e4$var$META].w;
};
// add metadata on freeze-family methods calling
var $d145aca8ddc395e4$var$onFreeze = function(it) {
    if ($d145aca8ddc395e4$var$FREEZE && $d145aca8ddc395e4$var$meta.NEED && $d145aca8ddc395e4$var$isExtensible(it) && !$aMccP(it, $d145aca8ddc395e4$var$META)) $d145aca8ddc395e4$var$setMeta(it);
    return it;
};
var $d145aca8ddc395e4$var$meta = module.exports = {
    KEY: $d145aca8ddc395e4$var$META,
    NEED: false,
    fastKey: $d145aca8ddc395e4$var$fastKey,
    getWeak: $d145aca8ddc395e4$var$getWeak,
    onFreeze: $d145aca8ddc395e4$var$onFreeze
};

});

parcelRegister("eKGZg", function(module, exports) {

var $pe18r = parcelRequire("pe18r");

var $dv4GG = parcelRequire("dv4GG");

var $6uq1C = parcelRequire("6uq1C");

var $3iakE = parcelRequire("3iakE");

var $30LaA = parcelRequire("30LaA");
var $abd6b4ec55be4dfa$require$defineProperty = $30LaA.f;
module.exports = function(name) {
    var $Symbol = $dv4GG.Symbol || ($dv4GG.Symbol = $6uq1C ? {} : $pe18r.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $abd6b4ec55be4dfa$require$defineProperty($Symbol, name, {
        value: $3iakE.f(name)
    });
};

});

parcelRegister("8yCLj", function(module, exports) {
// all enumerable object keys, includes symbols

var $8rKxD = parcelRequire("8rKxD");

var $1Jjbj = parcelRequire("1Jjbj");

var $gvEJa = parcelRequire("gvEJa");
module.exports = function(it) {
    var result = $8rKxD(it);
    var getSymbols = $1Jjbj.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $gvEJa.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("imb3o", function(module, exports) {
// 7.2.2 IsArray(argument)

var $eYYzh = parcelRequire("eYYzh");
module.exports = Array.isArray || function isArray(arg) {
    return $eYYzh(arg) == 'Array';
};

});

parcelRegister("2JUNR", function(module, exports) {

$parcel$export(module.exports, "f", () => $1febd8a8d519c7f4$export$2d1720544b23b823, (v) => $1febd8a8d519c7f4$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $1febd8a8d519c7f4$export$2d1720544b23b823;

var $59DzK = parcelRequire("59DzK");

var $7X6HN = parcelRequire("7X6HN");
var $1febd8a8d519c7f4$require$gOPN = $7X6HN.f;
var $1febd8a8d519c7f4$var$toString = {}.toString;
var $1febd8a8d519c7f4$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $1febd8a8d519c7f4$var$getWindowNames = function(it) {
    try {
        return $1febd8a8d519c7f4$require$gOPN(it);
    } catch (e) {
        return $1febd8a8d519c7f4$var$windowNames.slice();
    }
};
$1febd8a8d519c7f4$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $1febd8a8d519c7f4$var$windowNames && $1febd8a8d519c7f4$var$toString.call(it) == '[object Window]' ? $1febd8a8d519c7f4$var$getWindowNames(it) : $1febd8a8d519c7f4$require$gOPN($59DzK(it));
};

});
parcelRegister("7X6HN", function(module, exports) {

$parcel$export(module.exports, "f", () => $5ca33ea82ab61dc4$export$2d1720544b23b823, (v) => $5ca33ea82ab61dc4$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $5ca33ea82ab61dc4$export$2d1720544b23b823;

var $aW8ua = parcelRequire("aW8ua");

var $5ca33ea82ab61dc4$var$hiddenKeys = (parcelRequire("aIGUN")).concat('length', 'prototype');
$5ca33ea82ab61dc4$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $aW8ua(O, $5ca33ea82ab61dc4$var$hiddenKeys);
};

});


parcelRegister("56mOV", function(module, exports) {

$parcel$export(module.exports, "f", () => $3b6f36f483e8e31a$export$2d1720544b23b823, (v) => $3b6f36f483e8e31a$export$2d1720544b23b823 = v);
var $3b6f36f483e8e31a$export$2d1720544b23b823;

var $gvEJa = parcelRequire("gvEJa");

var $evesF = parcelRequire("evesF");

var $59DzK = parcelRequire("59DzK");

var $7Af9t = parcelRequire("7Af9t");

var $aMccP = parcelRequire("aMccP");

var $dzU8d = parcelRequire("dzU8d");
var $3b6f36f483e8e31a$var$gOPD = Object.getOwnPropertyDescriptor;

$3b6f36f483e8e31a$export$2d1720544b23b823 = (parcelRequire("hn2oF")) ? $3b6f36f483e8e31a$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $59DzK(O);
    P = $7Af9t(P, true);
    if ($dzU8d) try {
        return $3b6f36f483e8e31a$var$gOPD(O, P);
    } catch (e) {}
    if ($aMccP(O, P)) return $evesF(!$gvEJa.f.call(O, P), O[P]);
};

});


parcelRegister("55SkS", function(module, exports) {

});

parcelRegister("8IAUf", function(module, exports) {

(parcelRequire("eKGZg"))('asyncIterator');

});

parcelRegister("fvEHr", function(module, exports) {

(parcelRequire("eKGZg"))('observable');

});





parcelRegister("gHLl6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $c295621de530ae6b$export$1e511d4a378977f5, (v) => $c295621de530ae6b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $c295621de530ae6b$export$2e2bcd8739ae039, (v) => $c295621de530ae6b$export$2e2bcd8739ae039 = v);
var $c295621de530ae6b$export$1e511d4a378977f5;
var $c295621de530ae6b$export$2e2bcd8739ae039;
"use strict";
$c295621de530ae6b$export$1e511d4a378977f5 = true;

var $2gkZm = parcelRequire("2gkZm");
var $c295621de530ae6b$var$_setPrototypeOf2 = $c295621de530ae6b$var$_interopRequireDefault($2gkZm);

var $gqjuI = parcelRequire("gqjuI");
var $c295621de530ae6b$var$_create2 = $c295621de530ae6b$var$_interopRequireDefault($gqjuI);

var $kt6ai = parcelRequire("kt6ai");
var $c295621de530ae6b$var$_typeof3 = $c295621de530ae6b$var$_interopRequireDefault($kt6ai);
function $c295621de530ae6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$c295621de530ae6b$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $c295621de530ae6b$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $c295621de530ae6b$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c295621de530ae6b$var$_setPrototypeOf2.default ? (0, $c295621de530ae6b$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("2gkZm", function(module, exports) {

module.exports = {
    "default": (parcelRequire("9Eo5e")),
    __esModule: true
};

});
parcelRegister("9Eo5e", function(module, exports) {
parcelRequire("58apJ");

module.exports = (parcelRequire("dv4GG")).Object.setPrototypeOf;

});
parcelRegister("58apJ", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $8EFNH = parcelRequire("8EFNH");

$8EFNH($8EFNH.S, 'Object', {
    setPrototypeOf: (parcelRequire("kyYcY")).set
});

});
parcelRegister("kyYcY", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $6VwBm = parcelRequire("6VwBm");

var $6rs9h = parcelRequire("6rs9h");
var $ef85afb423a719a5$var$check = function(O, proto) {
    $6rs9h(O);
    if (!$6VwBm(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("gnejD"))(Function.call, (parcelRequire("56mOV")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $ef85afb423a719a5$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $ef85afb423a719a5$var$check
};

});




parcelRegister("gqjuI", function(module, exports) {

module.exports = {
    "default": (parcelRequire("2cRis")),
    __esModule: true
};

});
parcelRegister("2cRis", function(module, exports) {
parcelRequire("8Agfc");

var $dv4GG = parcelRequire("dv4GG");
var $19b60b5f041438df$require$$Object = $dv4GG.Object;
module.exports = function create(P, D) {
    return $19b60b5f041438df$require$$Object.create(P, D);
};

});
parcelRegister("8Agfc", function(module, exports) {

var $8EFNH = parcelRequire("8EFNH");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$8EFNH($8EFNH.S, 'Object', {
    create: (parcelRequire("l5MPs"))
});

});




parcelRegister("7ydDp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $57f648f37539eed1$var$createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/ function $57f648f37539eed1$var$createDetectElementResize(nonce, hostWindow) {
    // Check `document` and `window` in case of server-side rendering
    var _window;
    if (typeof hostWindow !== 'undefined') _window = hostWindow;
    else if (typeof window !== 'undefined') _window = window;
    else if (typeof self !== 'undefined') _window = self;
    else _window = $parcel$global;
    var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
    if (!attachEvent) {
        var requestFrame = function() {
            var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                return _window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        }();
        var cancelFrame = function() {
            var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        }();
        var resetTriggers = function resetTriggers(element) {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
        };
        var scrollListener = function scrollListener(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) return;
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
        var elm = _window.document.createElement('fakeelement');
        if (elm.style.animationName !== undefined) animation = true;
        if (animation === false) {
            for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animationstartevent = startEvents[i];
                animation = true;
                break;
            }
        }
        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }
    var createStyles = function createStyles(doc) {
        if (!doc.getElementById('detectElementResize')) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName('head')[0], style = doc.createElement('style');
            style.id = 'detectElementResize';
            style.type = 'text/css';
            if (nonce != null) style.setAttribute('nonce', nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) element.attachEvent('onresize', fn);
        else {
            if (!element.__resizeTriggers__) {
                var doc = element.ownerDocument;
                var elementStyle = _window.getComputedStyle(element);
                if (elementStyle && elementStyle.position == 'static') element.style.position = 'relative';
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
                element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);
                // Store reference to original instantiated scrollListener so it can be unbound later
                element.__scrollListener__ = scrollListener;
                /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName == animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) element.detachEvent('onresize', fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                if (element.__scrollListener__) element.removeEventListener('scroll', element.__scrollListener__, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}

});




parcelRegister("kIqbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f3f51e6722c6a40$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $1bJTy = parcelRequire("1bJTy");

var $4R6GH = parcelRequire("4R6GH");

var $1kDks = parcelRequire("1kDks");

var $3W7mX = parcelRequire("3W7mX");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $4XO5t = parcelRequire("4XO5t");

var $eeWa5 = parcelRequire("eeWa5");

var $jE1xD = parcelRequire("jE1xD");

var $7nAiS = parcelRequire("7nAiS");

var $3sdFx = parcelRequire("3sdFx");

var $3iMZ2 = parcelRequire("3iMZ2");

var $7Zhvm = parcelRequire("7Zhvm");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6f3f51e6722c6a40$var$mapStateToPropsFactory = ()=>{
    const onTableChangeFactory = (0, $8QpSo.default)((containerWidth, tableHasHorizontalScrollbar, tableHasVerticalScrollbar)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (analyticsEvent)=>{
            (0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
                containerType: 'virtualTable',
                attributes: {
                    hasHorizontalScrollbar: tableHasHorizontalScrollbar,
                    hasVerticalScrollbar: tableHasVerticalScrollbar,
                    containerWidth: containerWidth
                }
            });
        });
    return (state)=>{
        const rowIds = (0, $4XO5t.getFlattenedWithAddedRowIds)(state);
        const firstRowId = rowIds[0];
        const containerWidth = (0, $5J7ao.getTableWidthWithoutScrollbarOffset)(state);
        const tableHasHorizontalScrollbar = (0, $iN58L.hasHorizontalScrollbar)(state);
        const tableHasVerticalScrollbar = (0, $iN58L.hasVerticalScrollbar)(state);
        return {
            rowIds: rowIds,
            width: (0, $iN58L.getTableContentWidth)(state),
            containerWidth: containerWidth,
            hasHorizontalScrollbar: tableHasHorizontalScrollbar,
            hasVerticalScrollbar: tableHasVerticalScrollbar,
            hasLoadingRows: (0, $3W7mX.isRowLoading)(state, firstRowId),
            shouldUseCssForRendering: (0, $5J7ao.getShouldUseCssForRendering)(state),
            ariaLabel: (0, $4R6GH.fg)('jsm_virtual_table_a11y') ? (0, $eeWa5.getAriaLabel)(state) : undefined,
            Header: $7nAiS.default,
            Content: $jE1xD.default,
            ResizeColumnOverlay: $7Zhvm.default,
            HorizontalScrollOverlay: $3iMZ2.default,
            onTableChange: onTableChangeFactory(containerWidth, tableHasHorizontalScrollbar, tableHasVerticalScrollbar)
        };
    };
};
var $6f3f51e6722c6a40$export$2e2bcd8739ae039 = (0, $1kDks.connect)($6f3f51e6722c6a40$var$mapStateToPropsFactory, {})((0, $3sdFx.default));

});
parcelRegister("jE1xD", function(module, exports) {

$parcel$export(module.exports, "default", () => $25cf5c146511dacc$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eeWa5 = parcelRequire("eeWa5");

var $iN58L = parcelRequire("iN58L");

var $9XSoq = parcelRequire("9XSoq");
var $25cf5c146511dacc$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        isHorizontalScrollVisible: (0, $iN58L.hasHorizontalScrollbar)(state),
        isContentStale: (0, $eeWa5.isContentStale)(state),
        shouldHideLoadingIndicator: (0, $eeWa5.shouldHideLoadingIndicator)(state)
    }), {})((0, $9XSoq.default));

});
parcelRegister("9XSoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e86e724cf2c067b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4R6GH = parcelRequire("4R6GH");

var $6iCoB = parcelRequire("6iCoB");

var $4NqBB = parcelRequire("4NqBB");

var $lNkdd = parcelRequire("lNkdd");

var $bR1Og = parcelRequire("bR1Og");

var $2mpZe = parcelRequire("2mpZe");

var $eGBiD = parcelRequire("eGBiD");
function $1e86e724cf2c067b$var$Content(props) {
    const { isHorizontalScrollVisible: isHorizontalScrollVisible, isContentStale: isContentStale, shouldHideLoadingIndicator: shouldHideLoadingIndicator, theme: theme } = props;
    const shouldHideScrollbars = false && (0, $4R6GH.fg)('issuelist_ssr_hide_scroll_bars');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e86e724cf2c067b$var$Wrapper, null, shouldHideScrollbars ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e86e724cf2c067b$export$f185744748c379a7, {
        theme: theme,
        ...(0, $4R6GH.fg)('jsm_virtual_table_a11y') && {
            role: 'rowgroup'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lNkdd.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGBiD.default), null)), isContentStale && // @ts-expect-error - TS2322 - Type '{ shouldHideLoadingIndicator: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<DispatchProp<any>, "dispatch">, any, any>> & Readonly<...> & Readonly<...>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4NqBB.default), {
        shouldHideLoadingIndicator: shouldHideLoadingIndicator
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mpZe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e86e724cf2c067b$export$f185744748c379a7, {
        theme: theme,
        ...(0, $4R6GH.fg)('jsm_virtual_table_a11y') && {
            role: 'rowgroup'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lNkdd.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGBiD.default), null)), isContentStale && // @ts-expect-error - TS2322 - Type '{ shouldHideLoadingIndicator: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<DispatchProp<any>, "dispatch">, any, any>> & Readonly<...> & Readonly<...>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4NqBB.default), {
        shouldHideLoadingIndicator: shouldHideLoadingIndicator
    })), isHorizontalScrollVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e86e724cf2c067b$var$HorizontalScrollBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bR1Og.default), null)));
}
$1e86e724cf2c067b$var$Content.defaultProps = {
    isContentStale: false,
    shouldHideLoadingIndicator: false
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1e86e724cf2c067b$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
const $1e86e724cf2c067b$var$hiddenScrollBarsStyles = null;
const $1e86e724cf2c067b$export$f185744748c379a7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1alg958": (0, $lD23V.default)(__cmplp.theme.row.useCssHover ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : 'inherit')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3xy5q _tjnf1580",
            __cmplp.className
        ])
    });
});
const $1e86e724cf2c067b$var$HorizontalScrollBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyru2gc _19pkutpp _n3td1b66 _kqswh2mm",
            __cmplp.className
        ])
    });
});
var $1e86e724cf2c067b$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($1e86e724cf2c067b$var$Content);

});
parcelRegister("4NqBB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1010ac1d5dfbe26a$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $5J7ao = parcelRequire("5J7ao");

var $cJzud = parcelRequire("cJzud");
var // @ts-expect-error - Expected 2-4 arguments, but got 1.
$1010ac1d5dfbe26a$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        scrollOffset: (0, $5J7ao.getVerticalScrollOffset)(state),
        width: (0, $5J7ao.getTableWidthWithoutScrollbarOffset)(state)
    }))((0, $cJzud.default));

});
parcelRegister("cJzud", function(module, exports) {

$parcel$export(module.exports, "default", () => $449c84c4b405d7e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $5TRnH = parcelRequire("5TRnH");
const $449c84c4b405d7e2$var$SPINNER_DELAY = 500;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$449c84c4b405d7e2$export$2e2bcd8739ae039 = ({ shouldHideLoadingIndicator: shouldHideLoadingIndicator, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5TRnH.Blanket), props, shouldHideLoadingIndicator ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        delay: $449c84c4b405d7e2$var$SPINNER_DELAY,
        size: "large"
    }));

});
parcelRegister("5TRnH", function(module, exports) {

$parcel$export(module.exports, "Blanket", () => $a4e8680935c4172f$export$5b927fc1ef8c468b);
/* styles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $a4e8680935c4172f$var$baseStyle = null;
const $a4e8680935c4172f$export$5b927fc1ef8c468b = ({ scrollOffset: scrollOffset, width: width, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            top: `${scrollOffset}px`,
            bottom: `${-scrollOffset}px`,
            width: (0, $4R6GH.fg)('css_support_for_virtual_table') ? `${width}px` : `${width}px !important`
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _tzy4txnc _bfhkvuon _kqswstnw _1pbyouyt"
        ])
    }, children);

});



parcelRegister("lNkdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $841d0329d2a464c1$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eckup = parcelRequire("eckup");

var $kSeJ5 = parcelRequire("kSeJ5");

var $kZksW = parcelRequire("kZksW");

var $eeWa5 = parcelRequire("eeWa5");

var $eiuAu = parcelRequire("eiuAu");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $djugm = parcelRequire("djugm");

var $10MFW = parcelRequire("10MFW");

var $6vYGr = parcelRequire("6vYGr");
var $841d0329d2a464c1$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        isAutoHeight: (0, $eeWa5.isAutoHeight)(state),
        maxHorizontalScrollOffset: (0, $iN58L.getMaxHorizontalScrollOffset)(state),
        onRowListFocusFunctionChanged: (0, $eeWa5.getOnRowListFocusFunctionChangedCallback)(state),
        onReactPortalContainerRefChanged: (0, $eeWa5.getOnReactPortalContainerRefChangedCallback)(state),
        horizontalScrollOffset: (0, $5J7ao.getHorizontalScrollOffset)(state),
        navigationMode: (0, $eeWa5.getNavigationMode)(state),
        AutoHeightList: $djugm.default,
        VirtualList: $6vYGr.default
    }), {
    setHorizontalScrollOffset: $kSeJ5.setHorizontal,
    setScrollbarSize: $kZksW.set,
    navigateToRow: $eckup.navigateToRow,
    clearActiveItem: $eiuAu.clearActiveItem
})((0, $10MFW.default));

});
parcelRegister("eckup", function(module, exports) {

$parcel$export(module.exports, "NAVIGATE_TO_ROW", () => $d9c296c89f60d89f$export$4b025a6245795408);
$parcel$export(module.exports, "navigateToRow", () => $d9c296c89f60d89f$export$2b9abf839c94a6c4);
const $d9c296c89f60d89f$export$4b025a6245795408 = 'ops.rows.navigate.NAVIGATE_TO_ROW';
const $d9c296c89f60d89f$export$2b9abf839c94a6c4 = (payload)=>({
        type: $d9c296c89f60d89f$export$4b025a6245795408,
        payload: payload
    });

});

parcelRegister("kZksW", function(module, exports) {

$parcel$export(module.exports, "SET_SCROLLBAR_SIZE", () => $b04075bb32927cff$export$1343829730561bf3);
$parcel$export(module.exports, "set", () => $b04075bb32927cff$export$adaa4cf7ef1b65be);
const $b04075bb32927cff$export$1343829730561bf3 = 'ops.scrolling.size.SET_SCROLLBAR_SIZE';
const $b04075bb32927cff$export$adaa4cf7ef1b65be = (payload)=>({
        type: $b04075bb32927cff$export$1343829730561bf3,
        payload: payload
    });

});

parcelRegister("djugm", function(module, exports) {

$parcel$export(module.exports, "default", () => $15dbdad9832ee1e2$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $4XO5t = parcelRequire("4XO5t");

var $fL5GC = parcelRequire("fL5GC");

var $2UfYh = parcelRequire("2UfYh");
var $15dbdad9832ee1e2$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        rowIds: (0, $4XO5t.getFlattenedWithAddedRowIds)(state),
        List: $fL5GC.default
    }), {})((0, $2UfYh.default));

});
parcelRegister("fL5GC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48d0d5a064274c8$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $vNXgH = parcelRequire("vNXgH");

var $1bJTy = parcelRequire("1bJTy");

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $5d5zc = parcelRequire("5d5zc");

var $gKu8Z = parcelRequire("gKu8Z");
const $c48d0d5a064274c8$var$ASSIGNEE_COLUMN = 'assignee';
const $c48d0d5a064274c8$export$8c7854b27b9ed844 = (analyticsDataByColumns)=>{
    const groupedData = {
        minDisplayStart: Number.MAX_SAFE_INTEGER,
        maxDisplayEnd: 0,
        groups: {}
    };
    analyticsDataByColumns.forEach((analyticsData)=>{
        const { mountBeginTime: mountBeginTime, mountEndTime: mountEndTime, displayStart: displayStart, displayEnd: displayEnd } = analyticsData;
        const batchSize = analyticsDataByColumns.filter((v)=>v.displayStart === displayStart).length;
        groupedData.minDisplayStart = Math.min(displayStart, groupedData.minDisplayStart);
        groupedData.maxDisplayEnd = Math.max(displayEnd, groupedData.maxDisplayEnd);
        // group each data by the display boundary and calculate the avg time for each group
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
        if (!groupedData.groups[displayStart]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
        groupedData.groups[displayStart] = {
            startTime: mountBeginTime,
            endTime: mountEndTime,
            meanMountTime: (mountEndTime - mountBeginTime) / batchSize
        };
        else {
            // Always take the earliest begin and end times
            const newStartTime = Math.min(mountBeginTime, // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].startTime);
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            const newEndTime = Math.min(mountEndTime, groupedData.groups[displayStart].endTime);
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].startTime = newStartTime;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].endTime = newEndTime;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].meanMountTime = (newEndTime - newStartTime) / batchSize;
        }
    });
    return groupedData;
};
const $c48d0d5a064274c8$export$432f698644f45d1 = (groupedData)=>{
    const sortedMountTimes = Object.values(groupedData.groups).map((v)=>v.meanMountTime).sort((a, b)=>a - b);
    const dataLength = sortedMountTimes.length;
    return {
        median: Math.round(sortedMountTimes[Math.floor(dataLength / 2)]),
        perc90: Math.round(sortedMountTimes[Math.floor(dataLength * 0.9)]),
        perc95: Math.round(sortedMountTimes[Math.floor(dataLength * 0.95)]),
        max: Math.round(sortedMountTimes[dataLength - 1])
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c48d0d5a064274c8$var$fireRowMountAnalytics = (accumulatedRowAnalyticsData)=>{
    // if the user added/removed columns or switched to a different list that has different number of columns
    // fire the analytics separately for each of them
    const uniqueColumns = (0, (/*@__PURE__*/$parcel$interopDefault($vNXgH)))(// @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
    accumulatedRowAnalyticsData.map((v)=>v.columns), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
    // Get the metrics for each batch grouped by no. of columns
    uniqueColumns.forEach((columnArray)=>{
        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
        const analyticsDataByColumns = accumulatedRowAnalyticsData.filter((v)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(v.columns, columnArray));
        const { columns: columns, numberOfColumns: numberOfColumns, numberOfRows: numberOfRows, analyticsEvent: analyticsEvent } = analyticsDataByColumns[0];
        const hasNewAssigneeField = columns.includes($c48d0d5a064274c8$var$ASSIGNEE_COLUMN);
        const groupedData = $c48d0d5a064274c8$export$8c7854b27b9ed844(analyticsDataByColumns);
        const { median: median, perc90: perc90, perc95: perc95, max: max } = $c48d0d5a064274c8$export$432f698644f45d1(groupedData);
        (0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            containerType: 'virtualTable',
            attributes: {
                totalNoOfRowsInTable: numberOfRows,
                columns: columns,
                numberOfColumns: numberOfColumns,
                numberOfRowsInEvent: analyticsDataByColumns.length,
                medianTimeTakenToMount: median,
                perc90TimeTakenToMount: perc90,
                perc95TimeTakenToMount: perc95,
                maxTimeTakenToMount: max,
                minDisplayStart: groupedData.minDisplayStart,
                maxDisplayEnd: groupedData.maxDisplayEnd,
                hasNewAssigneeField: hasNewAssigneeField
            }
        });
    });
};
const $c48d0d5a064274c8$var$getVisibleCoreColumnIdsMemoized = ()=>(0, $dGvGJ.createSelector)((state)=>[].concat(// @ts-expect-error - TS2769 - No overload matches this call.
        (0, $bFTY1.getVisibleCoreColumnIds)(state), (0, $eeWa5.getVisibleAdditionalColumnIds)(state)), (res)=>res);
const $c48d0d5a064274c8$var$mapStateToPropsFactory = ()=>{
    const getVisibleCoreColumnIdsInstance = $c48d0d5a064274c8$var$getVisibleCoreColumnIdsMemoized();
    return (state)=>{
        const hasAutoHeight = (0, $eeWa5.isAutoHeight)(state);
        const onRowContentMount = // only when table is virtualised
        !hasAutoHeight && (0, $iN58L.getShouldVirtualize)(state) ? $c48d0d5a064274c8$var$fireRowMountAnalytics : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        return {
            rowTree: (0, $3W7mX.getRowTree)(state),
            expandedRowIdsHash: (0, $3W7mX.getExpandedRowIdsHash)(state),
            addBarOverflow: (0, $3W7mX.getAddBarOverflow)(state),
            temporaryAddedRow: (0, $3W7mX.getTemporaryAddedRow)(state),
            rowHeightMapping: (0, $3W7mX.getRowHeightMapping)(state),
            absoluteRowHeight: (0, $3W7mX.getAbsoluteRowHeight)(state),
            lastRowHasAddBar: (0, $iN58L.canLastRowAddSiblingOrChildren)(state),
            addLinkShown: (0, $iN58L.isAddLinkShown)(state),
            visibleColumns: getVisibleCoreColumnIdsInstance(state),
            onRowContentMount: onRowContentMount,
            RowItem: $gKu8Z.default
        };
    };
};
var $c48d0d5a064274c8$export$2e2bcd8739ae039 = (0, $1kDks.connect)($c48d0d5a064274c8$var$mapStateToPropsFactory, {})((0, $5d5zc.default));

});
parcelRegister("vNXgH", function(module, exports) {

var $7CoLY = parcelRequire("7CoLY");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function $05f9a56040cc5a05$var$uniqWith(array, comparator) {
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return array && array.length ? $7CoLY(array, undefined, comparator) : [];
}
module.exports = $05f9a56040cc5a05$var$uniqWith;

});

parcelRegister("5d5zc", function(module, exports) {

$parcel$export(module.exports, "default", () => $23da74b6cb175f1a$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $lFKmC = parcelRequire("lFKmC");

var $x9xyg = parcelRequire("x9xyg");

var $6iCoB = parcelRequire("6iCoB");
const $23da74b6cb175f1a$var$ANALYTICS_DEBOUNCE_TIME = 5000;
// eslint-disable-next-line jira/react/no-class-components
class $23da74b6cb175f1a$var$RowList extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.fireRowMountAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.props.onRowContentMount(this.accumulatedRowAnalyticsData);
            this.accumulatedRowAnalyticsData = [];
        }, $23da74b6cb175f1a$var$ANALYTICS_DEBOUNCE_TIME), this.gatherRowMountAnalyticsData = (mountBeginTime, mountEndTime, columns, numberOfColumns, analyticsEvent)=>{
            const { displayStart: displayStart, displayEnd: displayEnd } = this.props;
            if (!displayStart) return;
            this.accumulatedRowAnalyticsData.push({
                displayStart: displayStart,
                displayEnd: displayEnd,
                mountBeginTime: mountBeginTime,
                mountEndTime: mountEndTime,
                columns: columns.slice(0).sort(),
                numberOfColumns: numberOfColumns,
                numberOfRows: this.state.rowIds.length,
                analyticsEvent: analyticsEvent
            });
            this.fireRowMountAnalytics();
        };
        const { rowIds: rowIds, displayStart: displayStart, displayEnd: displayEnd, visibleColumns: visibleColumns } = props;
        this.state = {
            rowIds: rowIds
        };
        this.accumulatedRowAnalyticsData = [];
        // TODO: Remove this once we have sufficient numbers for performance profiling
        const rowsRendered = displayEnd - displayStart + 1;
        const columnsRendered = visibleColumns.length;
        (0, $x9xyg.setMark)(`virtualtable.rowlist.render.${rowsRendered * columnsRendered}.(${rowsRendered}x${columnsRendered}).cells.start`);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rowIds: rowIds, displayStart: displayStart, displayEnd: displayEnd } = this.props;
        // if the incoming rows are different
        if (rowIds !== nextProps.rowIds || displayStart !== nextProps.displayStart || displayEnd !== nextProps.displayEnd) this.resetState(nextProps.rowIds);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { displayStart: displayStart, displayEnd: displayEnd } = this.props;
        return displayStart !== nextProps.displayStart || displayEnd !== nextProps.displayEnd || this.state.rowIds !== nextState.rowIds;
    }
    resetState(rowIds) {
        this.setState({
            rowIds: rowIds
        });
    }
    render() {
        const { displayStart: displayStart, displayEnd: displayEnd, temporaryAddedRow: temporaryAddedRow, addBarOverflow: addBarOverflow, RowItem: RowItem, absoluteRowHeight: absoluteRowHeight, rowHeightMapping: rowHeightMapping, onRowContentUpdate: onRowContentUpdate, lastRowHasAddBar: lastRowHasAddBar, addLinkShown: addLinkShown, onLoadingRowUnmount: onLoadingRowUnmount, theme: theme } = this.props;
        const { rowIds: rowIds } = this.state;
        const rows = [];
        const numberOfRows = rowIds.length - 1;
        const alwaysVisibleRows = {
            [rowIds[0]]: true,
            [rowIds[numberOfRows]]: true,
            ...temporaryAddedRow && {
                [temporaryAddedRow.temporaryId]: true
            }
        };
        let spacerHeight = 0;
        let spacerStartRow = null;
        for(let index = 0; index <= numberOfRows; index += 1){
            const isAlwaysVisible = alwaysVisibleRows[rowIds[index]];
            const isDisplay = index >= displayStart && index <= displayEnd;
            if (isAlwaysVisible || isDisplay) {
                if (spacerHeight > 0 && spacerStartRow) {
                    // by using a key which is virtual row range it represents,
                    // it can still be usefully reconciled (during dragging for example)
                    const spacerKey = `${spacerStartRow}${rowIds[index - 1]}`;
                    rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23da74b6cb175f1a$var$Spacer, {
                        key: spacerKey,
                        height: spacerHeight
                    }));
                    spacerHeight = 0;
                    spacerStartRow = null;
                }
                rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RowItem, {
                    key: rowIds[index],
                    id: rowIds[index],
                    rowIndex: index,
                    onRowContentMount: this.gatherRowMountAnalyticsData,
                    onRowContentUpdate: onRowContentUpdate,
                    onLoadingRowUnmount: onLoadingRowUnmount
                }));
            } else {
                spacerHeight += rowHeightMapping[rowIds[index]] || absoluteRowHeight;
                spacerStartRow = rowIds[index];
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23da74b6cb175f1a$var$Wrapper, {
            addPadding: lastRowHasAddBar || addLinkShown,
            addBarOverflow: addBarOverflow,
            theme: theme
        }, rows);
    }
}
var $23da74b6cb175f1a$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($23da74b6cb175f1a$var$RowList);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $23da74b6cb175f1a$var$Spacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $23da74b6cb175f1a$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addPadding: addPadding, addBarOverflow: addBarOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_g2wqu5": (0, $lD23V.default)(__cmplp.addBarOverflow, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66",
            __cmplp.addPadding ? "_n3tdhkvd" : "_n3tdze3t",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gKu8Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad033f81590a2510$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $8UBZI = parcelRequire("8UBZI");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $9IIzV = parcelRequire("9IIzV");

var $eeW7W = parcelRequire("eeW7W");

var $cAVws = parcelRequire("cAVws");
const $ad033f81590a2510$var$mapStateToProps = (state, { id: id })=>{
    const { displayStart: displayStart } = (0, $iN58L.getVirtualBoundaries)(state);
    return {
        delayRowRenderOnScroll: (0, $eeWa5.shouldDelayRowRenderingOnScroll)(state) && displayStart > 0,
        isInCreation: (0, $3W7mX.isRowBeingAdded)(state, id),
        isLoading: (0, $3W7mX.isRowLoading)(state, id),
        LoadingRow: (0, $eeWa5.getLoadingRowComponent)(state),
        isInRowNavigationMode: (0, $eeWa5.isInRowNavigationMode)(state),
        NewRow: $cAVws.default,
        DefaultRow: $9IIzV.default
    };
};
var $ad033f81590a2510$export$2e2bcd8739ae039 = (0, $1kDks.connect)($ad033f81590a2510$var$mapStateToProps, {
    // @ts-expect-error - TS7006 - Parameter 'newActiveRow' implicitly has an 'any' type.
    onSetActiveRow: (newActiveRow)=>(0, $8UBZI.setActiveRow)(newActiveRow)
})((0, $eeW7W.default));

});
parcelRegister("8UBZI", function(module, exports) {

$parcel$export(module.exports, "SET_ACTIVE_CELL", () => $209595b96a4ae2c6$export$53294753640e6bdd);
$parcel$export(module.exports, "SET_ACTIVE_ROW", () => $209595b96a4ae2c6$export$551e11108d45fd88);
$parcel$export(module.exports, "setActiveCell", () => $209595b96a4ae2c6$export$c1df6941ca12827f);
$parcel$export(module.exports, "setActiveRow", () => $209595b96a4ae2c6$export$94bb5fd7cd44d4b3);

const $209595b96a4ae2c6$export$53294753640e6bdd = 'ops.items.active.set.SET_ACTIVE_CELL';
const $209595b96a4ae2c6$export$551e11108d45fd88 = 'ops.items.active.set.SET_ACTIVE_ROW';
const $209595b96a4ae2c6$export$c1df6941ca12827f = (payload)=>({
        type: $209595b96a4ae2c6$export$53294753640e6bdd,
        payload: {
            type: (0, $b7a603c640ae8033$export$4b3489234fd17200),
            ...payload
        }
    });
const $209595b96a4ae2c6$export$94bb5fd7cd44d4b3 = (payload)=>({
        type: $209595b96a4ae2c6$export$551e11108d45fd88,
        payload: {
            type: (0, $b7a603c640ae8033$export$8a257aa81ef4a9e0),
            setFocusOnRow: false,
            ...payload
        }
    });

});

parcelRegister("9IIzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e61ed572cd5e8bee$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $2ilJf = parcelRequire("2ilJf");

var $HC68H = parcelRequire("HC68H");

var $dJpr6 = parcelRequire("dJpr6");
var $e61ed572cd5e8bee$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { id: id })=>{
    const isActiveItem = (0, $iN58L.isActiveRowItem)(state, id);
    const isRowHighlighted = isActiveItem && !(0, $eeWa5.isTreeTableFacade)(state) && !(0, $eeWa5.isContentStale)(state) && !(0, $eeWa5.disableRowHighlight)(state);
    const isRowLeftEdgeVisible = (0, $iN58L.getOffsetFromLeft)(state) === 0;
    const isRowRightEdgeVisible = (0, $iN58L.getOffsetFromRight)(state) === 0;
    return {
        isActiveItem: isActiveItem,
        isRowHighlighted: isRowHighlighted,
        isRowLeftEdgeVisible: isRowLeftEdgeVisible,
        isRowRightEdgeVisible: isRowRightEdgeVisible,
        isGlobalAddEnabled: (0, $iN58L.isGlobalAddEnabled)(state),
        setFocusOnRow: (0, $iN58L.getSetFocusOnRow)(state, id),
        isSelected: (0, $3W7mX.isRowSelected)(state, id),
        AddBar: $2ilJf.default,
        Content: $HC68H.default
    };
}, {})((0, $dJpr6.default));

});
parcelRegister("2ilJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab639b2bfb53a33e$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $4vnEY = parcelRequire("4vnEY");
var $ab639b2bfb53a33e$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { rowId: rowId })=>({
        addPosition: (0, $3W7mX.getRowAddPosition)(state, rowId),
        isRowExpanded: (0, $3W7mX.isRowExpanded)(state, rowId),
        canAddSibling: (0, $3W7mX.getRowCanAddSibling)(state, rowId),
        canAddChildren: (0, $3W7mX.getRowCanAddChildren)(state, rowId),
        onRowAddRequested: (0, $eeWa5.getRowAddCallback)(state)
    }), {})((0, $4vnEY.default));

});
parcelRegister("4vnEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e240a7973224c526$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lJcaU = parcelRequire("lJcaU");

var $7VHMR = parcelRequire("7VHMR");
var $8RXs9 = parcelRequire("8RXs9");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e240a7973224c526$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1ejb _1bsb1ejb _19pkxmi2 _18u01i6y",
            __cmplp.className
        ])
    });
});
const $e240a7973224c526$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIndented: isIndented, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dov4vr _n7zlv4vr _vchhusvi _4t3i12x7 _bfhk1rsu _tzy4idpf _80omtlke _kqswh2mm _154iv77o _19pkr5cr _o7ks134x _16l4kb7n",
            __cmplp.isIndented ? "_2hwxmgjw" : "_2hwxxmi2",
            __cmplp.className
        ])
    });
});
const $e240a7973224c526$var$messages = (0, $7VHMR.defineMessages)({
    addIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.add-bar.add-icon",
        "defaultMessage": "Click to add row"
    }
});
class $e240a7973224c526$export$3213cbaa523231e6 extends (0, $5uXOq.Component) {
    shouldComponentUpdate(nextProps) {
        const { rowId: rowId, isRowExpanded: isRowExpanded, canAddChildren: canAddChildren, canAddSibling: canAddSibling } = this.props;
        return rowId !== nextProps.rowId || canAddChildren !== nextProps.canAddChildren || canAddSibling !== nextProps.canAddSibling || isRowExpanded !== nextProps.isRowExpanded;
    }
    renderAddBar() {
        const { intl: { formatMessage: formatMessage }, isRowExpanded: isRowExpanded, rowId: rowId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e240a7973224c526$var$Wrapper, {
            isIndented: isRowExpanded,
            onClick: this.onRowAddRequested,
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.add-bar.wrapper-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e240a7973224c526$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJcaU))), {
            color: "var(--ds-icon-accent-green, #22A06B)",
            label: formatMessage($e240a7973224c526$var$messages.addIcon)
        })));
    }
    render() {
        const { canAddChildren: canAddChildren, canAddSibling: canAddSibling, addPosition: addPosition } = this.props;
        const canAddAtPosition = addPosition === 'INSIDE' && canAddChildren || addPosition === 'AFTER' && canAddSibling;
        return canAddAtPosition ? this.renderAddBar() : null;
    }
    constructor(...args){
        super(...args), this.onRowAddRequested = ()=>{
            const { rowId: rowId, addPosition: addPosition, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: rowId,
                position: addPosition
            });
        };
    }
}
var $e240a7973224c526$export$2e2bcd8739ae039 = (0, $8RXs9.default)($e240a7973224c526$export$3213cbaa523231e6);

});
parcelRegister("lJcaU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::274a3d745c0c6824dba97f9232f7df06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd173ea3fb7b31ff$var$_react = $fd173ea3fb7b31ff$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fd173ea3fb7b31ff$var$_add = $fd173ea3fb7b31ff$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $fd173ea3fb7b31ff$var$_addCircle = $fd173ea3fb7b31ff$var$_interopRequireDefault((parcelRequire("bCjxO")));
function $fd173ea3fb7b31ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd173ea3fb7b31ff$var$AddIcon = (props)=>/*#__PURE__*/ $fd173ea3fb7b31ff$var$_react.default.createElement($fd173ea3fb7b31ff$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $fd173ea3fb7b31ff$var$_addCircle.default
    }, props));
$fd173ea3fb7b31ff$var$AddIcon.Name = 'AddIconMigration';
var $fd173ea3fb7b31ff$var$_default = module.exports.default = $fd173ea3fb7b31ff$var$AddIcon;

});
parcelRegister("bCjxO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8752676d88a02e6d$var$_react = $8752676d88a02e6d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8752676d88a02e6d$var$_add = $8752676d88a02e6d$var$_interopRequireDefault((parcelRequire("dZbEw")));
function $8752676d88a02e6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8752676d88a02e6d$var$AddCircleIcon = (props)=>/*#__PURE__*/ $8752676d88a02e6d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
    }, props, {
        newIcon: $8752676d88a02e6d$var$_add.default
    }));
$8752676d88a02e6d$var$AddCircleIcon.displayName = 'AddCircleIcon';
var $8752676d88a02e6d$var$_default = module.exports.default = $8752676d88a02e6d$var$AddCircleIcon;

});




parcelRegister("HC68H", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e4d82d6a752b36$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $iN58L = parcelRequire("iN58L");

var $bYogn = parcelRequire("bYogn");

var $lGyOk = parcelRequire("lGyOk");

var $bn1qy = parcelRequire("bn1qy");

var $97B0j = parcelRequire("97B0j");

var $cZnbA = parcelRequire("cZnbA");
var $56e4d82d6a752b36$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { id: id })=>({
        isActive: (0, $iN58L.isActiveRowId)(state, id),
        coreColumnIds: (0, $bFTY1.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $eeWa5.getVisibleAdditionalColumnIds)(state),
        shouldRerenderRowOnHover: (0, $eeWa5.shouldRerenderRowOnHover)(state),
        premiumSLAColumnIds: (0, $eeWa5.getPremiumSLAColumns)(state),
        AdditionalColumnsContainer: $bYogn.default,
        CellWrapper: $lGyOk.default,
        RowChildOperationIndicator: $97B0j.default,
        ConditionalErrorBoundary: $bn1qy.default
    }), {})((0, $cZnbA.default));

});
parcelRegister("bYogn", function(module, exports) {

$parcel$export(module.exports, "default", () => $de656b480e9413bf$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $kSeJ5 = parcelRequire("kSeJ5");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $4XO5t = parcelRequire("4XO5t");

var $cjHvQ = parcelRequire("cjHvQ");
var $de656b480e9413bf$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        scrollLeft: (0, $5J7ao.getHorizontalScrollOffset)(state),
        /* This prop is not used by the component other than to force an update when the rows change.
		 * It has been done to fix the behaviour of row scroll being reset during table actions that
		 * would have previously only reconciled the elements, rather than reconstructing them.
		 * This behaviour is inherent to React and the browser, where React re-inserting nodes cause
		 * the browser to reset specific transient properties (such as scrolling or video play).
		 * Here we are forcing the re-rendering so the scroll position can be correctly
		 * inferred directly from the store.
		 * For more info see https://github.com/facebook/react/issues/13042 and the associated links.
		 */ rowIds: (0, $4XO5t.getFlattenedWithAddedRowIds)(state),
        additionalColumnsWidth: (0, $iN58L.getVisibleAdditionalColumnsWidth)(state)
    }), {
    setHorizontalScrollOffset: $kSeJ5.setHorizontal
})((0, $cjHvQ.default));

});
parcelRegister("cjHvQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a0840002d15693$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jpY8v = parcelRequire("jpY8v");

var $4R6GH = parcelRequire("4R6GH");
const $66a0840002d15693$var$isWebkit = ()=>(0, $jpY8v.isChrome)() || (0, $jpY8v.isSafari)() || (0, $jpY8v.isEdge)();
const $66a0840002d15693$var$wrapperStyles = {
    overflow: 'hidden',
    flex: '1 1 auto',
    marginBottom: 0
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a0840002d15693$var$ScrollableDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1fjgglyw _4pckglyw _1e0c1txw _n3tdidpf",
            $66a0840002d15693$var$isWebkit() && "_1cicglyw",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $66a0840002d15693$var$AdditionalColumnsContainer extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        const { scrollLeft: scrollLeft } = this.props;
        this.updateScrollLeft(scrollLeft);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.updateScrollLeft(nextProps.scrollLeft);
    }
    updateScrollLeft(scrollLeft) {
        const { scrollRef: scrollRef } = this;
        if (scrollRef && scrollRef.scrollLeft !== scrollLeft) {
            this.ignoreScrollEvent = true;
            scrollRef.scrollLeft = scrollLeft;
        }
    }
    render() {
        const { children: children } = this.props;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $66a0840002d15693$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a0840002d15693$var$ScrollableDiv, {
            ref: (div)=>{
                this.setScrollRef(div);
            },
            style: {
                overflowX: false && (0, $4R6GH.fg)('issuelist_disable_horizontal_row_scroll_ssr') ? 'hidden' : 'scroll'
            },
            onScroll: this.onScroll
        }, children)));
    }
    constructor(...args){
        super(...args), this.onScroll = (event)=>{
            const { setHorizontalScrollOffset: setHorizontalScrollOffset } = this.props;
            const { scrollRef: scrollRef, ignoreScrollEvent: ignoreScrollEvent } = this;
            if (event.currentTarget === scrollRef && !ignoreScrollEvent) setHorizontalScrollOffset(event.currentTarget.scrollLeft);
            this.ignoreScrollEvent = false;
        }, this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        };
    }
}
var $66a0840002d15693$export$2e2bcd8739ae039 = $66a0840002d15693$var$AdditionalColumnsContainer;

});


parcelRegister("lGyOk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd1c115c9a6c9c05$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $1kDks = parcelRequire("1kDks");

var $he9zu = parcelRequire("he9zu");

var $4bxwW = parcelRequire("4bxwW");

var $8UBZI = parcelRequire("8UBZI");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $2tR7j = parcelRequire("2tR7j");
var $fd1c115c9a6c9c05$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { rowId: rowId, columnId: columnId, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive })=>{
    const activeItem = (0, $5J7ao.getActiveCell)(state);
    const isActive = (0, $iN58L.isCellActive)(state, rowId, columnId);
    const activatedFrom = isActive && activeItem ? activeItem.activatedFrom : undefined;
    return {
        isInCellNavigationMode: (0, $eeWa5.isInCellNavigationMode)(state),
        shouldHydrateFully: (0, $iN58L.shouldRowHydrateFully)(state, rowId),
        shouldUseCssForRendering: (0, $5J7ao.getShouldUseCssForRendering)(state),
        width: (0, $iN58L.getColumnWidth)(state, columnId),
        column: (0, $4R6GH.fg)('css_support_for_virtual_table') ? (0, $iN58L.getColumn)(state, columnId) : undefined,
        depth: (0, $iN58L.getRowDepth)(state, rowId),
        maxDepth: (0, $3W7mX.getMaxDepth)(state),
        isActive: isActive,
        activatedFrom: activatedFrom,
        isRowHovered: isRowHovered || false,
        isRowKeyboardActive: isRowKeyboardActive || false,
        activeItemChanged: (0, $eeWa5.getActiveItemChangedCallback)(state),
        CellComponent: (0, $bFTY1.getCellComponent)(state, columnId),
        NonTemporaryCellWrapper: (0, $eeWa5.getNonTemporaryCellWrapper)(state),
        canBeMultiLine: (0, $bFTY1.canCellBeMultiLine)(state, columnId),
        parentId: (0, $bFTY1.getColumnParentId)(state, columnId),
        renderSidebarIcon: (0, $5J7ao.getRenderSidebarIcon)(state)
    };
}, {
    setActiveCell: $8UBZI.setActiveCell,
    clearActiveItem: $4bxwW.clear,
    navigateToCell: $he9zu.navigateToCell
})((0, $2tR7j.default));

});
parcelRegister("he9zu", function(module, exports) {

$parcel$export(module.exports, "NAVIGATE_TO_CELL", () => $f43a2319153784b4$export$d4980933cbdb75cc);
$parcel$export(module.exports, "navigateToCell", () => $f43a2319153784b4$export$4dc17e9d5bc2fa90);
const $f43a2319153784b4$export$d4980933cbdb75cc = 'ops.cells.navigate.NAVIGATE_TO_CELL';
const $f43a2319153784b4$export$4dc17e9d5bc2fa90 = (payload)=>({
        type: $f43a2319153784b4$export$d4980933cbdb75cc,
        payload: payload
    });

});

parcelRegister("4bxwW", function(module, exports) {

$parcel$export(module.exports, "CLEAR_ACTIVE_ITEM", () => $63fb0eeeb4525c80$export$d63ae865b2dc3e7f);
$parcel$export(module.exports, "clear", () => $63fb0eeeb4525c80$export$42ffd38884aecdac);
const $63fb0eeeb4525c80$export$d63ae865b2dc3e7f = 'ops.items.active.clear.CLEAR_ACTIVE_ITEM';
const $63fb0eeeb4525c80$export$42ffd38884aecdac = ()=>({
        type: $63fb0eeeb4525c80$export$d63ae865b2dc3e7f,
        payload: undefined
    });

});

parcelRegister("2tR7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd001c25e5de9fb$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $fW62l = parcelRequire("fW62l");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");



const $4cd001c25e5de9fb$var$getWrapperStyles = (width)=>({
        flex: '0 0 auto',
        width: `${width}px`
    });
const $4cd001c25e5de9fb$var$NAVIGATION_KEYS = {
    [(0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('up')]: (0, $bc003a5da339d04c$export$b29f845fa4b57508),
    [(0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('right')]: (0, $bc003a5da339d04c$export$1cac5500365a4eb4),
    [(0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('down')]: (0, $bc003a5da339d04c$export$c7c029a231f98d34),
    [(0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('left')]: (0, $bc003a5da339d04c$export$f981f70d61d1405a)
};
// eslint-disable-next-line jira/react/no-class-components
class $4cd001c25e5de9fb$var$CellWrapper extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRowTemporary: false,
            isRowHovered: false,
            isRowKeyboardActive: false,
            confirmToNavigate: true
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.rowId !== nextProps.rowId || this.props.columnId !== nextProps.columnId || this.props.width !== nextProps.width || this.props.depth !== nextProps.depth || this.props.maxDepth !== nextProps.maxDepth || this.props.activatedFrom !== nextProps.activatedFrom || this.props.isActive !== nextProps.isActive || this.props.shouldHydrateFully !== nextProps.shouldHydrateFully || this.props.isRowHovered !== nextProps.isRowHovered || this.props.isRowKeyboardActive !== nextProps.isRowKeyboardActive || this.props.confirmToNavigate !== nextProps.confirmToNavigate || this.props.activeItemChanged !== nextProps.activeItemChanged || this.props.renderSidebarIcon !== nextProps.renderSidebarIcon;
    }
    componentDidUpdate(prevProps) {
        const { rowId: rowId, columnId: columnId, isActive: isActive, activeItemChanged: activeItemChanged } = this.props;
        if (!prevProps.isActive && isActive) activeItemChanged({
            rowId: rowId,
            columnId: columnId
        });
    }
    render() {
        const { rowId: rowId, width: width, column: column, columnId: columnId, activatedFrom: activatedFrom, isActive: isActive, isRowTemporary: isRowTemporary, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive, CellComponent: CellComponent, NonTemporaryCellWrapper: NonTemporaryCellWrapper, onCellMount: onCellMount, canBeMultiLine: canBeMultiLine, shouldHydrateFully: shouldHydrateFully, shouldUseCssForRendering: shouldUseCssForRendering, renderSidebarIcon: renderSidebarIcon } = this.props;
        const onMultiLineCellUpdated = canBeMultiLine ? onCellMount : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        const commonProps = {
            rowId: rowId,
            width: width,
            columnId: columnId,
            activatedFrom: activatedFrom,
            isActive: isActive,
            isRowTemporary: isRowTemporary,
            isRowHovered: isRowHovered,
            isRowKeyboardActive: isRowKeyboardActive,
            onMount: onMultiLineCellUpdated,
            onUpdate: onMultiLineCellUpdated,
            canBeMultiLine: canBeMultiLine,
            shouldHydrateFully: shouldHydrateFully
        };
        /* We just use the wrapping element for bubbling */ if (renderSidebarIcon) {
            const colWidth = width;
            const renderCell = ()=>{
                if (columnId === (0, $960a7067bff9d918$export$913055729e1380b2)) {
                    // Leave 60px space for icon summary cells
                    const colAdjust = 60;
                    if (column && shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cd001c25e5de9fb$var$CellWithIconIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        xcss: [
                            $4cd001c25e5de9fb$var$cellHoverStyles
                        ],
                        style: {
                            minWidth: column.minWidth - colAdjust,
                            maxWidth: column.maxWidth - colAdjust
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellComponent, commonProps)), (isRowHovered || isRowKeyboardActive) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cd001c25e5de9fb$var$SidebarIcon, null, renderSidebarIcon(rowId)));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cd001c25e5de9fb$var$CellWithIconIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cd001c25e5de9fb$var$RestrictedWidthCell, {
                        width: colWidth - colAdjust
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellComponent, commonProps)), (isRowHovered || isRowKeyboardActive) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cd001c25e5de9fb$var$SidebarIcon, null, renderSidebarIcon(rowId)));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellComponent, commonProps);
            };
            if (column && shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                ref: this.getTargetRef,
                style: {
                    minWidth: column.minWidth,
                    maxWidth: column.maxWidth
                },
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                xcss: (0, $4R6GH.fg)('table_headers_widths_vs_column_widths') ? $4cd001c25e5de9fb$var$cellStyles : $4cd001c25e5de9fb$var$cellStylesOld,
                testId: `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
                role: (0, $4R6GH.fg)('jsm_virtual_table_a11y') ? 'cell' : 'presentation'
            }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderCell()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NonTemporaryCellWrapper, {
                Cell: CellComponent,
                ...commonProps
            }));
            return (0, $4R6GH.fg)('jsm_virtual_table_a11y') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                ref: this.getTargetRef,
                style: {
                    width: `${width}px`
                },
                xcss: $4cd001c25e5de9fb$var$cellWrapperStyles,
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                testId: `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
                role: "cell"
            }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderCell()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NonTemporaryCellWrapper, {
                Cell: CellComponent,
                ...commonProps
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.getTargetRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: $4cd001c25e5de9fb$var$getWrapperStyles(width),
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                "data-testid": `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
                role: "presentation"
            }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderCell()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NonTemporaryCellWrapper, {
                Cell: CellComponent,
                ...commonProps
            }));
        }
        if (column && shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            ref: this.getTargetRef,
            style: {
                minWidth: column.minWidth,
                maxWidth: column.maxWidth
            },
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            xcss: (0, $4R6GH.fg)('table_headers_widths_vs_column_widths') ? $4cd001c25e5de9fb$var$cellStyles : $4cd001c25e5de9fb$var$cellStylesOld,
            testId: `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
            role: (0, $4R6GH.fg)('jsm_virtual_table_a11y') ? 'cell' : 'presentation'
        }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellComponent, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NonTemporaryCellWrapper, {
            Cell: CellComponent,
            ...commonProps
        }));
        return (0, $4R6GH.fg)('jsm_virtual_table_a11y') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            ref: this.getTargetRef,
            style: {
                width: `${width}px`
            },
            xcss: $4cd001c25e5de9fb$var$cellWrapperStyles,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            testId: `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
            role: "cell"
        }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellComponent, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NonTemporaryCellWrapper, {
            Cell: CellComponent,
            ...commonProps
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: this.getTargetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $4cd001c25e5de9fb$var$getWrapperStyles(width),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
            role: "presentation"
        }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellComponent, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NonTemporaryCellWrapper, {
            Cell: CellComponent,
            ...commonProps
        }));
    }
    constructor(...args){
        super(...args), this.onFocus = ()=>{
            const { rowId: rowId, columnId: columnId, setActiveCell: setActiveCell, isInCellNavigationMode: isInCellNavigationMode } = this.props;
            if (isInCellNavigationMode) setActiveCell({
                type: (0, $b7a603c640ae8033$export$4b3489234fd17200),
                rowId: rowId,
                columnId: columnId
            });
        }, this.onBlur = ()=>{
            const { clearActiveItem: clearActiveItem, isInCellNavigationMode: isInCellNavigationMode } = this.props;
            if (isInCellNavigationMode) clearActiveItem();
        }, this.onKeyDown = (event)=>{
            const { confirmToNavigate: confirmToNavigate, isInCellNavigationMode: isInCellNavigationMode, columnId: columnId } = this.props;
            let direction;
            if (!isInCellNavigationMode) return;
            /* Special handling for enter since it can be ignored */ if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') && confirmToNavigate) direction = (0, $bc003a5da339d04c$export$c7c029a231f98d34);
            else direction = $4cd001c25e5de9fb$var$NAVIGATION_KEYS[event.keyCode];
            if (direction) {
                event.preventDefault();
                event.stopPropagation();
                const { rowId: rowId, navigateToCell: navigateToCell } = this.props;
                navigateToCell({
                    rowId: rowId,
                    columnId: columnId,
                    direction: direction
                });
            }
        }, this.getTargetRef = (div)=>{
            this.targetRef = div;
        };
    }
}
var $4cd001c25e5de9fb$export$2e2bcd8739ae039 = $4cd001c25e5de9fb$var$CellWrapper;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4cd001c25e5de9fb$var$SidebarIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $4cd001c25e5de9fb$var$RestrictedWidthCell = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});
const $4cd001c25e5de9fb$var$CellWithIconIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $4cd001c25e5de9fb$var$cellStylesOld = (0, $8CUq3.xcss)({
    width: '100%'
});
const $4cd001c25e5de9fb$var$cellStyles = (0, $8CUq3.xcss)({
    width: '100%',
    flex: '1 1 auto'
});
const $4cd001c25e5de9fb$var$cellWrapperStyles = (0, $8CUq3.xcss)({
    flex: '0 0 auto'
});
const $4cd001c25e5de9fb$var$cellHoverStyles = (0, $8CUq3.xcss)({
    width: 'calc(100% - 60px)'
});

});
const $bc003a5da339d04c$export$b29f845fa4b57508 = 'UP';
const $bc003a5da339d04c$export$c7c029a231f98d34 = 'DOWN';
const $bc003a5da339d04c$export$f981f70d61d1405a = 'LEFT';
const $bc003a5da339d04c$export$1cac5500365a4eb4 = 'RIGHT';



parcelRegister("bn1qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a296310065a2549$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eeWa5 = parcelRequire("eeWa5");

var $hQWFf = parcelRequire("hQWFf");

var $eFqPO = parcelRequire("eFqPO");
var $8a296310065a2549$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        columnsToIgnore: (0, $eeWa5.getPremiumSLAColumns)(state),
        ErrorInlineMessage: $hQWFf.default
    }), {})((0, $eFqPO.ConditionalErrorBoundary));

});
parcelRegister("hQWFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bcfbb1aeb2c144a$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $feQ6b = parcelRequire("feQ6b");
var $2bcfbb1aeb2c144a$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { columnId: columnId })=>({
        columnWidth: (0, $bFTY1.getColumnMinWidth)(state, columnId)
    }), {})((0, $feQ6b.ErrorInlineMessage));

});
parcelRegister("feQ6b", function(module, exports) {

$parcel$export(module.exports, "ErrorInlineMessage", () => $7519c8d9e571d3f7$export$ffbab3d811b5160b);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $6yUsV = parcelRequire("6yUsV");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $fmT9C = parcelRequire("fmT9C");
const $7519c8d9e571d3f7$export$ffbab3d811b5160b = ({ columnWidth: columnWidth })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const onClick = (0, $5uXOq.useCallback)(()=>window.location.reload(), []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.100",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $8CUq3.xcss)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${columnWidth}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yUsV.default), {
        appearance: "error",
        iconLabel: formatMessage((0, $fmT9C.default).errorFlagText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fmT9C.default).errorFlagText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $8CUq3.xcss)({
            color: 'color.text.accent.blue'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fmT9C.default).errorFlagLinkText))))));
};

});
parcelRegister("6yUsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c43b93305034f0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $ctg8C = parcelRequire("ctg8C");

var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $60LNO = parcelRequire("60LNO");
const $e2c43b93305034f0$var$rootStyles = null;
const $e2c43b93305034f0$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $e2c43b93305034f0$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const toggleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh018uv _38q98stv _1o0knqa1 _1yyu1kum",
            $e2c43b93305034f0$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ctg8C.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $fVnbM.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $60LNO.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText))))));
};
var $e2c43b93305034f0$export$2e2bcd8739ae039 = $e2c43b93305034f0$var$InlineMessage;

});
parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ])
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5uXOq.createElement($ed572e62fc5b1cd0$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});
parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        role: role,
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("60LNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $474777c4d72d6c07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jfSgx = parcelRequire("jfSgx");
const $474777c4d72d6c07$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
const $474777c4d72d6c07$var$iconWrapperStyles = null;
const $474777c4d72d6c07$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $474777c4d72d6c07$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $jfSgx.typesMapping);
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $474777c4d72d6c07$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $5uXOq.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious"
    }));
};
var $474777c4d72d6c07$export$2e2bcd8739ae039 = $474777c4d72d6c07$var$SelectedIcon;

});
parcelRegister("jfSgx", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $e3da74fa628ddd87$export$4d111645c0b39d5d);

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");
const $e3da74fa628ddd87$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("fmT9C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2470b3b497be9e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c2470b3b497be9e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagText: {
        "id": "virtual-table.table.content.rows.common.conditional-error-boundary.error-inline-message.error-flag-text",
        "defaultMessage": "We're having trouble loading this data. Try again later or contact Atlassian support."
    },
    errorFlagLinkText: {
        "id": "virtual-table.table.content.rows.common.conditional-error-boundary.error-inline-message.error-flag-link-text",
        "defaultMessage": "Reload"
    }
});

});



parcelRegister("eFqPO", function(module, exports) {

$parcel$export(module.exports, "ConditionalErrorBoundary", () => $05534f28b551c494$export$6465e24fd5df7a56);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $05534f28b551c494$export$6465e24fd5df7a56 = ({ children: children, columnId: columnId, columnsToIgnore: columnsToIgnore, ErrorInlineMessage: ErrorInlineMessage })=>!columnsToIgnore?.includes(columnId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "virtual-table-row-additional-column",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorInlineMessage, {
                columnId: columnId
            })
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});


parcelRegister("97B0j", function(module, exports) {

$parcel$export(module.exports, "default", () => $a421b049345b8a02$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $28voY = parcelRequire("28voY");
var $a421b049345b8a02$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { rowId: rowId })=>({
        maxDepth: (0, $3W7mX.getMaxDepth)(state),
        rowDepth: (0, $iN58L.getRowDepth)(state, rowId),
        isRowExpanded: (0, $3W7mX.isRowExpanded)(state, rowId),
        rowHasChildren: (0, $3W7mX.getRowHasChildren)(state, rowId),
        isAddEnabled: (0, $iN58L.isGlobalAddEnabled)(state) && (0, $3W7mX.getRowCanAddChildren)(state, rowId),
        onRowExpansionChangeRequested: (0, $eeWa5.getRowExpansionCallback)(state),
        onRowAddRequested: (0, $eeWa5.getRowAddCallback)(state)
    }), {})((0, $28voY.default));

});
parcelRegister("28voY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9779697b3c57ef6$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ 
var $5uXOq = parcelRequire("5uXOq");

var $99M5v = parcelRequire("99M5v");

var $c8Oei = parcelRequire("c8Oei");

var $hWZau = parcelRequire("hWZau");


var $7VHMR = parcelRequire("7VHMR");
var $8RXs9 = parcelRequire("8RXs9");

var $6iCoB = parcelRequire("6iCoB");

var $6hiB0 = parcelRequire("6hiB0");
const $d9779697b3c57ef6$var$messages = (0, $7VHMR.defineMessages)({
    collapseIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.collapse-icon",
        "defaultMessage": "Click to collapse row"
    },
    expandIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.expand-icon",
        "defaultMessage": "Click to expand row"
    },
    addIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.add-icon",
        "defaultMessage": "Click to add row"
    }
});
const $d9779697b3c57ef6$var$baseIndicatorStyles = {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    color: (0, $829f609a65d26a98$exports).N70
};
const $d9779697b3c57ef6$var$interactiveIndicatorStyles = {
    ...$d9779697b3c57ef6$var$baseIndicatorStyles,
    width: `${(0, $6hiB0.childrenOperationIndicatorWidth)}px`,
    cursor: 'pointer'
};
const $d9779697b3c57ef6$var$getDefaultIndicatorStyles = (isMaxDepth, theme)=>({
        ...$d9779697b3c57ef6$var$baseIndicatorStyles,
        width: `${isMaxDepth ? theme.row.maxDepthChildrenOperationIndicatorWidth : (0, $6hiB0.childrenOperationIndicatorWidth)}px`
    });
const $d9779697b3c57ef6$var$getAddIndicatorWrapperStyles = (isRowHovered)=>({
        height: '16px',
        width: '16px',
        visibility: isRowHovered ? 'visible' : 'hidden'
    });
class $d9779697b3c57ef6$export$20869452acc58b2a extends (0, $5uXOq.Component) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rowHasChildren: rowHasChildren, isRowExpanded: isRowExpanded } = this.props;
        /* A row that had children but now has none SHOULD NOT be expanded.
     * The general use case for this is cancelling an add operation, where the
     * temporary row was the only child. As cancelling can occur from internal or
     * external to the table, this is the only way to ensure this behaviour.
     */ if (rowHasChildren && !nextProps.rowHasChildren && isRowExpanded) this.onCollapse();
    }
    shouldComponentUpdate(nextProps) {
        const { rowId: rowId, rowDepth: rowDepth, maxDepth: maxDepth, isRowExpanded: isRowExpanded, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive, rowHasChildren: rowHasChildren, isAddEnabled: isAddEnabled } = this.props;
        return rowId !== nextProps.rowId || rowDepth !== nextProps.rowDepth || maxDepth !== nextProps.maxDepth || isRowExpanded !== nextProps.isRowExpanded || isRowHovered !== nextProps.isRowHovered || isRowKeyboardActive !== nextProps.isRowKeyboardActive || rowHasChildren !== nextProps.rowHasChildren || isAddEnabled !== nextProps.isAddEnabled;
    }
    renderCollapseIndicator() {
        const { intl: { formatMessage: formatMessage }, rowId: rowId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $d9779697b3c57ef6$var$interactiveIndicatorStyles,
            onClick: this.onCollapse,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.collapse-${rowId}`,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && this.onCollapse,
            role: "button",
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            LEGACY_size: "small",
            spacing: "compact",
            label: formatMessage($d9779697b3c57ef6$var$messages.collapseIcon)
        }));
    }
    renderExpandIndicator() {
        const { intl: { formatMessage: formatMessage }, rowId: rowId } = this.props;
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $d9779697b3c57ef6$var$interactiveIndicatorStyles,
            onClick: this.onExpand,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.expand-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
            LEGACY_size: "small",
            spacing: "compact",
            label: formatMessage($d9779697b3c57ef6$var$messages.expandIcon)
        })));
    }
    renderAddIndicator() {
        const { intl: { formatMessage: formatMessage }, isRowHovered: isRowHovered, rowId: rowId } = this.props;
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $d9779697b3c57ef6$var$interactiveIndicatorStyles,
            onClick: this.onRowAddRequested,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.add-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $d9779697b3c57ef6$var$getAddIndicatorWrapperStyles(isRowHovered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            LEGACY_size: "small",
            label: formatMessage($d9779697b3c57ef6$var$messages.addIcon)
        }))));
    }
    render() {
        const { maxDepth: maxDepth, rowDepth: rowDepth, rowHasChildren: rowHasChildren, isRowExpanded: isRowExpanded, isAddEnabled: isAddEnabled, theme: theme } = this.props;
        const isMaxDepth = rowDepth === maxDepth;
        if (!isMaxDepth) {
            if (rowHasChildren) {
                if (isRowExpanded) return this.renderCollapseIndicator();
                return this.renderExpandIndicator();
            }
            if (isAddEnabled) return this.renderAddIndicator();
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $d9779697b3c57ef6$var$getDefaultIndicatorStyles(isMaxDepth, theme)
        });
    }
    constructor(...args){
        super(...args), this.onExpand = ()=>{
            const { rowId: rowId, onRowExpansionChangeRequested: onRowExpansionChangeRequested } = this.props;
            onRowExpansionChangeRequested({
                rowId: rowId,
                shouldExpand: true
            });
        }, this.onCollapse = ()=>{
            const { rowId: rowId, onRowExpansionChangeRequested: onRowExpansionChangeRequested } = this.props;
            onRowExpansionChangeRequested({
                rowId: rowId,
                shouldExpand: false
            });
        }, this.onRowAddRequested = ()=>{
            const { rowId: rowId, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: rowId,
                position: 'INSIDE'
            });
        };
    }
}
var $d9779697b3c57ef6$export$2e2bcd8739ae039 = (0, $8RXs9.default)((0, $6iCoB.withTheme)($d9779697b3c57ef6$export$20869452acc58b2a));

});


parcelRegister("cZnbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9281c16a0ff55fb2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $8oe80 = parcelRequire("8oe80");

var $6iCoB = parcelRequire("6iCoB");
const $9281c16a0ff55fb2$var$getWrapperStyles = (backgroundColor, theme)=>{
    const style = {
        display: 'flex',
        boxSizing: 'border-box',
        borderTop: `${theme.row.borderWidth}px solid ${theme.row.borderColor}`,
        borderBottom: `${theme.row.borderWidth}px solid ${theme.row.borderColor}`,
        height: theme.row.height,
        minHeight: theme.row.minHeight,
        marginLeft: '0px',
        boxShadow: 'none'
    };
    if (theme.row.useCssHover) return style;
    return {
        ...style,
        backgroundColor: backgroundColor
    };
};
// eslint-disable-next-line jira/react/no-class-components
class $9281c16a0ff55fb2$var$RowContent extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.onMouseEnter = ()=>{
            if (!this.props.theme.row.useCssHover || (this.props.shouldRerenderRowOnHover ?? false)) this.setState({
                isHovered: true
            });
        }, this.onMouseLeave = ()=>{
            if (!this.props.theme.row.useCssHover || (this.props.shouldRerenderRowOnHover ?? false)) this.setState({
                isHovered: false
            });
        }, this.setRef = (el)=>{
            this.ref = el;
        }, this.recalculateHeight = ()=>{
            const { id: id, onRowContentUpdate: onRowContentUpdate } = this.props;
            if (this.ref && onRowContentUpdate) onRowContentUpdate(id, this.ref.getBoundingClientRect().height);
        };
        this.state = {
            isHovered: false,
            render: !props.coreColumnIds.length
        };
        this.beginTime = Date.now();
    }
    componentDidMount() {
        const { onRowContentMount: onRowContentMount, coreColumnIds: coreColumnIds, additionalColumnIds: additionalColumnIds } = this.props;
        if (!this.state.render) this.timeoutId = setTimeout(()=>this.setState({
                render: true
            }), 16);
        this.recalculateHeight();
        // @ts-expect-error - TS2769 - No overload matches this call.
        const allColumns = [].concat(coreColumnIds, additionalColumnIds);
        onRowContentMount && onRowContentMount(this.beginTime, Date.now(), allColumns, allColumns.length);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.render !== nextState.render || this.state.isHovered !== nextState.isHovered || this.props.id !== nextProps.id || this.props.isActive !== nextProps.isActive || this.props.coreColumnIds !== nextProps.coreColumnIds || this.props.additionalColumnIds !== nextProps.additionalColumnIds;
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    determineRowColor(isActive, isHovered) {
        if (isHovered) return this.props.theme.row.hoveredColor;
        if (isActive) return this.props.theme.row.activeColor;
        return (0, $829f609a65d26a98$exports).N0;
    }
    renderChildOperationIndicator() {
        const { id: id, RowChildOperationIndicator: RowChildOperationIndicator, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConditionalErrorBoundary, {
            columnId: "child-operation-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RowChildOperationIndicator, {
            rowId: id,
            isRowHovered: isHovered,
            isRowKeyboardActive: isActive
        }));
    }
    renderCoreColumns() {
        const { id: id, coreColumnIds: coreColumnIds, CellWrapper: CellWrapper, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered } = this.state;
        return coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConditionalErrorBoundary, {
                key: `${columnId}-${id}`,
                columnId: columnId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowHovered: isHovered,
                isRowKeyboardActive: isActive,
                onCellMount: this.recalculateHeight
            })));
    }
    renderAdditionalColumns() {
        const { id: id, additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, CellWrapper: CellWrapper, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered } = this.state;
        return additionalColumnIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdditionalColumnsContainer, null, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConditionalErrorBoundary, {
                key: `${columnId}-${id}`,
                columnId: columnId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowHovered: isHovered,
                isRowKeyboardActive: isActive,
                onCellMount: this.recalculateHeight
            })))) : null;
    }
    render() {
        const { isActive: isActive, theme: theme } = this.props;
        const { isHovered: isHovered } = this.state;
        const color = this.determineRowColor(isActive, isHovered);
        return this.state.render ? // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "virtual-table-row",
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            onFocus: undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: this.setRef,
            // @ts-expect-error - TS2322 - Type '{ display: string; boxSizing: string; borderTop: string; borderBottom: string; height: string; minHeight: string; marginLeft: string; boxShadow: string; } | { backgroundColor: string; display: string; ... 6 more ...; boxShadow: string; }' is not assignable to type 'CSSProperties | undefined'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $9281c16a0ff55fb2$var$getWrapperStyles(color, theme)
        }, this.renderChildOperationIndicator(), this.renderCoreColumns(), this.renderAdditionalColumns())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "virtual-table-row",
            // @ts-expect-error - TS2322 - Type '{ display: string; boxSizing: string; borderTop: string; borderBottom: string; height: string; minHeight: string; marginLeft: string; boxShadow: string; } | { backgroundColor: string; display: string; ... 6 more ...; boxShadow: string; }' is not assignable to type 'CSSProperties | undefined'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $9281c16a0ff55fb2$var$getWrapperStyles(color, theme)
        }, this.renderChildOperationIndicator(), this.renderCoreColumns());
    }
}
var $9281c16a0ff55fb2$export$2e2bcd8739ae039 = (0, $8oe80.default)('virtualTableRows', {
    onRowContentMount: 'mounted'
})((0, $6iCoB.withTheme)($9281c16a0ff55fb2$var$RowContent));

});


parcelRegister("dJpr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a10db9bad847e977$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8oe80 = parcelRequire("8oe80");

var $4R6GH = parcelRequire("4R6GH");

var $6iCoB = parcelRequire("6iCoB");

var $aBsQD = parcelRequire("aBsQD");
// regarding height & overflow:
// we set the height here to reduce positioning complexity.
// otherwise we need to consider the add bar and its' visibility
// while offsetting margins on the row
const $a10db9bad847e977$var$getOuterWrapperStyles = (isSelected)=>({
        ...isSelected ? {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)"
        } : {},
        marginLeft: "var(--ds-space-0, 0px)",
        outline: 'none'
    });
const $a10db9bad847e977$var$getContentWrapperStyles = ()=>({
        height: 'auto',
        minHeight: "var(--ds-space-500, 40px)",
        overflow: 'hidden',
        marginTop: "var(--ds-space-0, 0px)",
        borderRadius: "var(--ds-space-050, 4px)",
        flexGrow: 1
    });
// The following styles create a faux absolute element with the height and width of its flex(direction row) parent.
// We cannot use position relative on OuterWrapper as elements in virtual-table-row-list-portal
// depend on a relative parent at the table level.
const $a10db9bad847e977$var$rowHighlightWrapperStylesOld = {
    position: 'relative',
    flexShrink: 0,
    width: '100%',
    marginLeft: '-100%',
    transform: 'translateX(100%)',
    pointerEvents: 'none'
};
// eslint-disable-next-line jira/react/no-class-components
class $a10db9bad847e977$var$DefaultRow extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.myRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.state = {
            render: false
        };
    }
    componentDidMount() {
        this.timeoutId = setTimeout(()=>this.setState({
                render: true
            }), 250); // we render the AddBar quite delayed as it will only be visible when hovered
        if (this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.addEventListener('focusin', this.props.onFocusCallback);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { id: id, isActiveItem: isActiveItem, isRowHighlighted: isRowHighlighted, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, isSelected: isSelected } = this.props;
        return id !== nextProps.id || this.state.render !== nextState.render || isActiveItem !== nextProps.isActiveItem || isRowHighlighted !== nextProps.isRowHighlighted || isRowLeftEdgeVisible !== nextProps.isRowLeftEdgeVisible || isRowRightEdgeVisible !== nextProps.isRowRightEdgeVisible || isSelected !== nextProps.isSelected;
    }
    componentDidUpdate(prevProps) {
        if (this.props.isActiveItem && !prevProps.isActiveItem && this.myRef.current && this.props.setFocusOnRow) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.removeEventListener('focusin', this.props.onFocusCallback);
    }
    render() {
        const { id: id, isRowHighlighted: isRowHighlighted, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, isGlobalAddEnabled: isGlobalAddEnabled, AddBar: AddBar, Content: Content, theme: theme, onClick: onClick, onRowContentMount: onRowContentMount, onRowContentUpdate: onRowContentUpdate, isSelected: isSelected } = this.props;
        return (0, $4R6GH.fg)('jsm_virtual_table_a11y') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            // @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
            ref: this.myRef,
            onClick: onClick,
            xcss: [
                $a10db9bad847e977$var$outerWrapperStyles,
                isSelected && $a10db9bad847e977$var$selectOuterWrapperStyles
            ],
            // tabIndex is needed to be able to focus / navigate through rows and scroll vertically while navigating through the rows that are offscreen
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $a10db9bad847e977$var$innerWrapperStyles,
            role: "row"
        }, isRowHighlighted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_kqswh2mm _1o9zidpf _1bsb1osq _18u0pwvu _t9ecxwn4 _lcxvglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBsQD.RowHighlight), {
            theme: theme,
            isRowLeftEdgeVisible: isRowLeftEdgeVisible,
            isRowRightEdgeVisible: isRowRightEdgeVisible
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $a10db9bad847e977$var$contentWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, {
            id: id,
            onRowContentMount: onRowContentMount,
            onRowContentUpdate: onRowContentUpdate
        }))), isGlobalAddEnabled && this.state.render && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddBar, {
            rowId: id
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
            ref: this.myRef,
            onClick: onClick,
            role: "presentation",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $a10db9bad847e977$var$getOuterWrapperStyles(isSelected),
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                display: 'flex'
            }
        }, isRowHighlighted && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $a10db9bad847e977$var$rowHighlightWrapperStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBsQD.RowHighlight), {
            theme: theme,
            isRowLeftEdgeVisible: isRowLeftEdgeVisible,
            isRowRightEdgeVisible: isRowRightEdgeVisible
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: $a10db9bad847e977$var$getContentWrapperStyles()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, {
            id: id,
            onRowContentMount: onRowContentMount,
            onRowContentUpdate: onRowContentUpdate
        }))), isGlobalAddEnabled && this.state.render && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddBar, {
            rowId: id
        }));
    }
}
var $a10db9bad847e977$export$2e2bcd8739ae039 = (0, $8oe80.default)('rowItem', {
    onClick: 'clicked'
})((0, $6iCoB.withTheme)($a10db9bad847e977$var$DefaultRow));
const $a10db9bad847e977$var$outerWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.0',
    outline: 'none'
});
const $a10db9bad847e977$var$selectOuterWrapperStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.selected'
});
const $a10db9bad847e977$var$innerWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex'
});
const $a10db9bad847e977$var$rowHighlightWrapperStyles = null;
const $a10db9bad847e977$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    height: 'auto',
    minHeight: 'space.500',
    overflow: 'hidden',
    marginTop: 'space.0',
    borderRadius: 'space.050',
    flexGrow: 1
});

});
parcelRegister("aBsQD", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $b09601a226538f2d$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "RowHighlight", () => $b09601a226538f2d$export$c5433d3086f82ff8);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6hiB0 = parcelRequire("6hiB0");
const $b09601a226538f2d$export$85ae013617b39492 = ({ width: width, isFirstColumn: isFirstColumn })=>`
    width: ${isFirstColumn ? width + (0, $6hiB0.levelIndentBaseline) : width}px;
`;
const $b09601a226538f2d$export$3c49c185de0c2bfc = ({ width: width, isFirstColumn: isFirstColumn })=>`${isFirstColumn ? width + (0, $6hiB0.levelIndentBaseline) : width}px`;
const $b09601a226538f2d$export$c5433d3086f82ff8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRowRightEdgeVisible: isRowRightEdgeVisible, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_pbz34m": (0, $lD23V.default)(__cmplp.isRowRightEdgeVisible ? 0 : "var(--ds-space-negative-100, -8px)"),
            "--_5kefb9": (0, $lD23V.default)(__cmplp.theme.row.borderRadius)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154ix0bf _1xi2idpf _94n5x0bf _1ltvidpf _lcxvglyw _14mj1rr2 _j9jr1w01 _39yqt94y _1tv3nqa1 _8l3mmuej _18postnw _15l2idpf _32rx14cd _1x88idpf _19doidpf _aetrb3bt _11fnglyw _1bqqkb7n",
            __cmplp.isRowRightEdgeVisible ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("eeW7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $deafad3e4806aaaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");

class $deafad3e4806aaaf$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.onFocusCallback = ()=>{
            const { isInRowNavigationMode: isInRowNavigationMode, onSetActiveRow: onSetActiveRow, rowIndex: rowIndex } = this.props;
            if (isInRowNavigationMode) onSetActiveRow({
                rowIndex: rowIndex
            });
        }, this.onClick = (event, analyticsEvent)=>{
            this.props.onSetActiveRow({
                rowIndex: this.props.rowIndex
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'click', {
                rowIndex: this.props.rowIndex
            });
        };
        this.state = {
            delayRender: props.delayRowRenderOnScroll
        };
    }
    componentDidMount() {
        if (this.state.delayRender) setTimeout(()=>this.setState({
                delayRender: false
            }), 16);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.id !== nextProps.id || this.props.isInCreation !== nextProps.isInCreation || this.state.delayRender !== nextState.delayRender || this.props.rowIndex !== nextProps.rowIndex;
    }
    render() {
        const { id: id, isInCreation: isInCreation, isLoading: isLoading, rowIndex: rowIndex, onLoadingRowUnmount: onLoadingRowUnmount, NewRow: NewRow, LoadingRow: LoadingRow, onRowContentMount: onRowContentMount, onRowContentUpdate: onRowContentUpdate, DefaultRow: DefaultRow } = this.props;
        if (isInCreation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NewRow, {
            id: id
        });
        if (LoadingRow && (isLoading || this.state.delayRender)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingRow, {
            id: id,
            onClick: this.onClick,
            onUnmount: isLoading || this.state.delayRender ? onLoadingRowUnmount : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            reasonType: isLoading ? (0, $ad3622039daefe23$export$a63dec0667c2f97a) : (0, $ad3622039daefe23$export$456b4a90eb507580),
            rowIndex: rowIndex,
            onRowContentUpdate: onRowContentUpdate,
            onFocusCallback: this.onFocusCallback
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DefaultRow, {
            id: id,
            onClick: this.onClick,
            onRowContentMount: onRowContentMount,
            onRowContentUpdate: onRowContentUpdate,
            onFocusCallback: this.onFocusCallback
        });
    }
}

});

parcelRegister("cAVws", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f94bb825e9a9a7$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");


var $4bxwW = parcelRequire("4bxwW");

var $8UBZI = parcelRequire("8UBZI");

var $dTQhq = parcelRequire("dTQhq");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $bYogn = parcelRequire("bYogn");

var $lGyOk = parcelRequire("lGyOk");

var $ipzna = parcelRequire("ipzna");
var $74f94bb825e9a9a7$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { id: id })=>({
        depth: (0, $iN58L.getRowDepth)(state, id),
        maxDepth: (0, $3W7mX.getMaxDepth)(state),
        status: (0, $3W7mX.getRowAddingStatus)(state, id),
        coreColumnIds: (0, $bFTY1.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $eeWa5.getVisibleAdditionalColumnIds)(state),
        defaultAddColumnId: (0, $eeWa5.getDefaultAddColumnId)(state),
        isActive: (0, $iN58L.isActiveRowId)(state, id),
        onPersistAddedRowRequested: (0, $eeWa5.getPersistAddedRowCallback)(state),
        onCancelAddedRowRequested: (0, $eeWa5.getCancelAddedRowCallback)(state),
        navigationMode: (0, $eeWa5.getNavigationMode)(state),
        AdditionalColumnsContainer: $bYogn.default,
        CellWrapper: $lGyOk.default
    }), {
    setActiveCell: $8UBZI.setActiveCell,
    clearActiveItem: $4bxwW.clear,
    setMultiAddAnchor: $dTQhq.set
}, // @ts-expect-error - TS7031 - Binding element 'defaultAddColumnId' implicitly has an 'any' type.
({ defaultAddColumnId: defaultAddColumnId, ...stateProps }, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps,
        setMultiAddAnchor: dispatchProps.setMultiAddAnchor,
        setActiveItem: ()=>{
            if (0, $b7a603c640ae8033$export$9e9986b7abe95577) dispatchProps.setActiveCell({
                type: (0, $b7a603c640ae8033$export$4b3489234fd17200),
                rowId: ownProps.id,
                columnId: defaultAddColumnId
            });
            else if (0, $b7a603c640ae8033$export$a01cd8e028b3d34f) dispatchProps.setActiveRow({
                type: (0, $b7a603c640ae8033$export$8a257aa81ef4a9e0),
                rowIndex: ownProps.rowIndex
            });
        },
        clearActiveItem: dispatchProps.clearActiveItem
    }))((0, $ipzna.default));

});
parcelRegister("dTQhq", function(module, exports) {

$parcel$export(module.exports, "SET_MULTI_ADD_ANCHOR", () => $a0e115f5f7eef725$export$45d5c36be62dcf8e);
$parcel$export(module.exports, "set", () => $a0e115f5f7eef725$export$adaa4cf7ef1b65be);
const $a0e115f5f7eef725$export$45d5c36be62dcf8e = 'ops.rows.add-anchor.set.SET_MULTI_ADD_ANCHOR';
const $a0e115f5f7eef725$export$adaa4cf7ef1b65be = (rowId)=>({
        type: $a0e115f5f7eef725$export$45d5c36be62dcf8e,
        payload: rowId
    });

});

parcelRegister("ipzna", function(module, exports) {

$parcel$export(module.exports, "default", () => $a15f074bb3074d58$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");


var $6iCoB = parcelRequire("6iCoB");

var $6hiB0 = parcelRequire("6hiB0");
// eslint-disable-next-line jira/react/no-class-components
class $a15f074bb3074d58$var$NewRow extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        const { status: status, setActiveItem: setActiveItem } = this.props;
        if (status === 'NEW') setActiveItem();
    }
    componentDidUpdate(prevProps) {
        const { id: id, status: status, isActive: isActive, onPersistAddedRowRequested: onPersistAddedRowRequested } = this.props;
        if (prevProps.isActive && !isActive && status === 'NEW') onPersistAddedRowRequested(id);
    }
    componentWillUnmount() {
        /* If we are navigating by Cell.
     * All cells in a new row will be unmounted with it, stopping the clear callback from occurring.
     * This means anyone subscribing to the currently active cell may still refer to the temporary cells id,
     * even when that temporary value has been resolved into a "real" one.
     * We would not want to do this in the cell wrapper, as the problem does not exist for other rows, and could
     * cause side-effects.
     */ this.props.clearActiveItem();
    }
    renderCoreColumns() {
        const { id: id, coreColumnIds: coreColumnIds, CellWrapper: CellWrapper } = this.props;
        return coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowTemporary: true,
                confirmToNavigate: false
            }));
    }
    renderAdditionalColumns() {
        const { id: id, additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, CellWrapper: CellWrapper } = this.props;
        return additionalColumnIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdditionalColumnsContainer, null, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowTemporary: true,
                confirmToNavigate: false
            }))) : null;
    }
    render() {
        const { depth: depth, maxDepth: maxDepth, status: status, theme: theme } = this.props;
        const indent = (0, $6hiB0.levelIndentBaseline) + depth * (0, $6hiB0.levelIndentBaseline);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                background: status === 'PERSISTING' ? $a15f074bb3074d58$var$persistingGradient : (0, $829f609a65d26a98$exports).G50,
                marginLeft: `${indent}px`
            },
            onKeyDown: this.onCellKeyDown,
            className: (0, $bwpsq.default)([
                "_x3dooyrj _n7zloyrj _1e0c1txw _vchhusvi _4t3i1jfw _19pkze3t"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a15f074bb3074d58$var$FakeChildOperationIndicator, {
            isMaxDepth: depth === maxDepth,
            theme: theme
        }), this.renderCoreColumns(), this.renderAdditionalColumns());
    }
    constructor(...args){
        super(...args), this.onCellKeyDown = (event)=>{
            const { id: id, status: status, setMultiAddAnchor: setMultiAddAnchor, onPersistAddedRowRequested: onPersistAddedRowRequested, onCancelAddedRowRequested: onCancelAddedRowRequested } = this.props;
            if (status === 'NEW') switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter'):
                    event.stopPropagation();
                    setMultiAddAnchor(id);
                    onPersistAddedRowRequested(id);
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('escape'):
                    event.stopPropagation();
                    onCancelAddedRowRequested(id);
                    break;
                default:
                    break;
            }
        };
    }
}
var $a15f074bb3074d58$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($a15f074bb3074d58$var$NewRow);
const $a15f074bb3074d58$var$persistingGradient = `
    repeating-linear-gradient(
        315deg,
        rgba(0,0,0,0.1), rgba(0,0,0,0.1) 1px,
        ${(0, $829f609a65d26a98$exports).N0} 0, ${(0, $829f609a65d26a98$exports).N0} 5px
    )
`;
const $a15f074bb3074d58$var$rowWrapperStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a15f074bb3074d58$var$FakeChildOperationIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMaxDepth: isMaxDepth, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_eobblv": (0, $lD23V.default)(__cmplp.theme.row.maxDepthChildrenOperationIndicatorWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi",
            __cmplp.isMaxDepth ? "_1bsb1fz4" : "_1bsbg21h",
            __cmplp.className
        ])
    });
});

});




parcelRegister("2UfYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b621d61debb4bcef$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b621d61debb4bcef$export$2e2bcd8739ae039(props) {
    const { rowIds: rowIds, List: List } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(List, {
        rowIds: rowIds,
        displayStart: 0,
        displayEnd: rowIds.length
    });
}

});


parcelRegister("10MFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $994998e4b51a2fe5$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9pcWN = parcelRequire("9pcWN");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $994998e4b51a2fe5$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
class $994998e4b51a2fe5$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { isAutoHeight: isAutoHeight, AutoHeightList: AutoHeightList, VirtualList: VirtualList } = this.props;
        const Content = // tabIndex is needed to be able to focus / navigate through rows and scroll vertically while navigating through the rows that are offscreen
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($994998e4b51a2fe5$var$Wrapper, {
            tabIndex: -1,
            ref: this.onRefChanged
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: this.onDivRefChanged,
            className: "virtual-table-row-list-portal"
        }), isAutoHeight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AutoHeightList, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(VirtualList, null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9pcWN.default), null), Content);
    }
    constructor(...args){
        super(...args), this.onRefChanged = (el)=>{
            const { onRowListFocusFunctionChanged: onRowListFocusFunctionChanged } = this.props;
            if (!onRowListFocusFunctionChanged) return;
            if (el != null) onRowListFocusFunctionChanged(()=>{
                el && el.focus();
            });
            else onRowListFocusFunctionChanged(null);
        }, this.onDivRefChanged = (el)=>{
            const { onReactPortalContainerRefChanged: onReactPortalContainerRefChanged } = this.props;
            if (!onReactPortalContainerRefChanged) return;
            if (el != null) onReactPortalContainerRefChanged(el);
        };
    }
}

});
parcelRegister("9pcWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b8ad9ab929773a$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eckup = parcelRequire("eckup");

var $kSeJ5 = parcelRequire("kSeJ5");

var $eeWa5 = parcelRequire("eeWa5");

var $eiuAu = parcelRequire("eiuAu");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $1aj4z = parcelRequire("1aj4z");
const $b1b8ad9ab929773a$var$mapDispatchToProps = {
    navigateToRow: $eckup.navigateToRow,
    clearActiveItem: $eiuAu.clearActiveItem,
    setHorizontalScrollOffset: $kSeJ5.setHorizontal
};
var $b1b8ad9ab929773a$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        maxHorizontalScrollOffset: (0, $iN58L.getMaxHorizontalScrollOffset)(state),
        horizontalScrollOffset: (0, $5J7ao.getHorizontalScrollOffset)(state),
        navigationMode: (0, $eeWa5.getNavigationMode)(state),
        activeRowIndex: (0, $iN58L.getActiveRowIndex)(state),
        isContentStale: (0, $eeWa5.isContentStale)(state)
    }), $b1b8ad9ab929773a$var$mapDispatchToProps)((0, $1aj4z.default));

});
parcelRegister("1aj4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ef716d592e04e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jqONe = parcelRequire("jqONe");

var $3Tty1 = parcelRequire("3Tty1");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


const $12ef716d592e04e0$var$KeyboardShortcuts = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const HORIZONTAL_SCROLL_DISTANCE = 40;
    const SHIFT_TAB = 'shiftTab';
    const analyticsEvent = createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'rowItem'
    });
    const handleTabKey = (tabKey)=>{
        if (props.isContentStale || props.navigationMode !== (0, $b7a603c640ae8033$export$a01cd8e028b3d34f)) return;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, tabKey === SHIFT_TAB ? 'tabFieldLeft' : 'tabFieldRight', {
            rowIndex: props.activeRowIndex,
            keyPressed: tabKey
        });
    };
    const handleKeyUpOrDown = (direction, key, index)=>{
        if (props.isContentStale || props.navigationMode !== (0, $b7a603c640ae8033$export$a01cd8e028b3d34f)) return;
        props.navigateToRow({
            direction: direction
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `navigateRow${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(direction)}`, {
            keyPressed: key,
            rowIndex: index
        });
    };
    const handleKeyLeft = ()=>{
        if (props.isContentStale || props.navigationMode !== (0, $b7a603c640ae8033$export$a01cd8e028b3d34f)) return;
        const newOffset = Math.max(0, props.horizontalScrollOffset - HORIZONTAL_SCROLL_DISTANCE);
        if (props.horizontalScrollOffset !== newOffset) props.setHorizontalScrollOffset(newOffset);
    };
    const handleKeyRight = ()=>{
        if (props.isContentStale || props.navigationMode !== (0, $b7a603c640ae8033$export$a01cd8e028b3d34f)) return;
        const newOffset = Math.min(props.maxHorizontalScrollOffset, props.horizontalScrollOffset + HORIZONTAL_SCROLL_DISTANCE);
        if (props.horizontalScrollOffset !== newOffset) props.setHorizontalScrollOffset(newOffset);
    };
    const mapping = {
        tab: {
            callback: ()=>handleTabKey('tab')
        },
        'shift+tab': {
            callback: ()=>handleTabKey(SHIFT_TAB)
        },
        j: {
            callback: ()=>handleKeyUpOrDown((0, $bc003a5da339d04c$export$c7c029a231f98d34), 'j', props.activeRowIndex)
        },
        arrowdown: {
            callback: ()=>handleKeyUpOrDown((0, $bc003a5da339d04c$export$c7c029a231f98d34), 'arrowdown', props.activeRowIndex)
        },
        k: {
            callback: ()=>handleKeyUpOrDown((0, $bc003a5da339d04c$export$b29f845fa4b57508), 'k', props.activeRowIndex)
        },
        arrowup: {
            callback: ()=>handleKeyUpOrDown((0, $bc003a5da339d04c$export$b29f845fa4b57508), 'arrowup', props.activeRowIndex)
        },
        arrowleft: {
            callback: ()=>handleKeyLeft()
        },
        arrowright: {
            callback: ()=>handleKeyRight()
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: mapping
    });
};
$12ef716d592e04e0$var$KeyboardShortcuts.defaultProps = {
    isContentStale: false
};
var $12ef716d592e04e0$export$2e2bcd8739ae039 = $12ef716d592e04e0$var$KeyboardShortcuts;

});



parcelRegister("6vYGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd973d4b11c5661$export$2e2bcd8739ae039);

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $1kDks = parcelRequire("1kDks");

var $g1bZP = parcelRequire("g1bZP");

var $7LVdM = parcelRequire("7LVdM");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $4XO5t = parcelRequire("4XO5t");

var $fL5GC = parcelRequire("fL5GC");

var $jSPzm = parcelRequire("jSPzm");
const $5dd973d4b11c5661$var$mapStateToProps = (state)=>({
        rowIds: (0, $4XO5t.getFlattenedWithAddedRowIds)(state),
        contentHeight: (0, $iN58L.getTableContentHeight)(state),
        isAutoRowHeight: (0, $3W7mX.isAutoRowHeight)(state),
        defaultRowHeight: (0, $3W7mX.getDefaultRowHeight)(state),
        virtualBoundaries: (0, $iN58L.getVirtualBoundaries)(state),
        numberOfLoadingRows: (0, $iN58L.getNumberOfLoadingRowsInDisplayBoundary)(state),
        isTableFacade: (0, $eeWa5.isTableFacade)(state),
        List: $fL5GC.default
    });
const $5dd973d4b11c5661$var$mapDispatchToProps = (dispatch)=>({
        batchUpdateRowHeightMapping: (rowIds, rowHeightMapping)=>dispatch((0, $7LVdM.batchUpdateRowHeightMapping)(rowIds, rowHeightMapping)),
        onDeferredBuffering: (rowsRendered, rowsDeferred, analyticsEvent)=>{
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'virtualList deferredBuffering', {
                rowsRendered: rowsRendered,
                rowsDeferred: rowsDeferred
            });
        },
        onLoadingRowUnmount: (numberOfLoadingRows, displayStart, rowId, timeVisibleFor, reasonType, analyticsEvent)=>displayStart === 0 ? undefined : dispatch((0, $g1bZP.fireLoadingRowAnalytics)({
                rowId: rowId,
                timeVisibleFor: timeVisibleFor,
                numberOfLoadingRows: numberOfLoadingRows,
                reasonType: reasonType,
                analyticsEvent: analyticsEvent
            }))
    });
var $5dd973d4b11c5661$export$2e2bcd8739ae039 = (0, $1kDks.connect)($5dd973d4b11c5661$var$mapStateToProps, $5dd973d4b11c5661$var$mapDispatchToProps)((0, $2OMDV.AnalyticsEventToProps)('virtualList', {
    onDeferredBuffering: 'deferredBuffering'
})((0, $jSPzm.default)));

});
parcelRegister("g1bZP", function(module, exports) {

$parcel$export(module.exports, "FIRE_LOADING_ROW_ANALYTICS", () => $3603a065e3546898$export$73369b76089b13a6);
$parcel$export(module.exports, "fireLoadingRowAnalytics", () => $3603a065e3546898$export$d043bad71b13e219);
const $3603a065e3546898$export$73369b76089b13a6 = 'ops.rows.analytics.FIRE_LOADING_ROW_ANALYTICS';
const $3603a065e3546898$export$d043bad71b13e219 = (payload)=>({
        type: $3603a065e3546898$export$73369b76089b13a6,
        payload: payload
    });

});

parcelRegister("7LVdM", function(module, exports) {

$parcel$export(module.exports, "BATCH_UPDATE_ROW_HEIGHT_MAPPING", () => $ebfe5c39c05784f3$export$1e2cc4b1d7e85685);
$parcel$export(module.exports, "batchUpdateRowHeightMapping", () => $ebfe5c39c05784f3$export$6ad1445af83aec72);
const $ebfe5c39c05784f3$export$1e2cc4b1d7e85685 = 'ops.rows.row-height.BATCH_UPDATE_ROW_HEIGHT_MAPPING';
const $ebfe5c39c05784f3$export$6ad1445af83aec72 = (rowIds, rowHeightMapping)=>({
        type: $ebfe5c39c05784f3$export$1e2cc4b1d7e85685,
        payload: {
            rowIds: rowIds,
            rowHeightMapping: rowHeightMapping
        }
    });

});

parcelRegister("jSPzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba56a11abc5cae7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7HT5p = parcelRequire("7HT5p");
const $bba56a11abc5cae7$var$stateToRenderState = (state)=>{
    const { visibleStart: visibleStart, visibleEnd: visibleEnd, displayStart: displayStart, displayEnd: displayEnd, rowIds: rowIds } = state;
    return {
        virtualBoundaries: {
            visibleStart: visibleStart,
            visibleEnd: visibleEnd,
            displayStart: displayStart,
            displayEnd: displayEnd
        },
        rowIds: rowIds
    };
};
class $bba56a11abc5cae7$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.updateStateRowHeight = (rowId, rowHeight)=>{
            this.rowHeightUpdateBatch[rowId] = rowHeight;
        };
        this.state = {
            displayStart: 0,
            displayEnd: 0,
            visibleStart: 0,
            visibleEnd: 0,
            rowHeights: {},
            rowIds: props.rowIds
        };
        const { rowIds: rowIds } = props;
        this.rowIds = rowIds;
        this.rowHeightUpdateBatch = {};
        this.shouldUpdate = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isTableFacade: isTableFacade, isAutoRowHeight: isAutoRowHeight, virtualBoundaries: virtualBoundaries, rowIds: rowIds } = nextProps;
        const { visibleStart: visibleStart, visibleEnd: visibleEnd } = virtualBoundaries;
        // 1) In case of TreeTable, update the list only when we scroll and
        // pass beyond the buffer rows, rather than for every scroll update
        //      1.1) make an inclusive equality comparison. we always want at least 1
        //      item beyond the viewport so we can keyboard navigate to it
        // 2) In case of Table, the list is updated when it's scrolled past even one row.
        // This is to address the weird experience where, when scrolling the table upwards,
        // with deferred row rendering, the rows render one-by-one downwards in batches of 5 (SHIELD-3990)
        if (isTableFacade && (visibleStart < this.state.visibleStart || visibleEnd > this.state.visibleEnd) || visibleStart <= this.state.displayStart || visibleEnd >= this.state.displayEnd) {
            this.shouldUpdate = true;
            if (isTableFacade && (0, $7HT5p.shouldDeferBuffering)($bba56a11abc5cae7$var$stateToRenderState(this.state), nextProps)) {
                this.setState({
                    visibleEnd: visibleEnd,
                    visibleStart: visibleStart,
                    displayStart: visibleStart,
                    displayEnd: visibleEnd,
                    rowIds: rowIds
                });
                this.needsDisplayBufferRendered = true;
            } else {
                this.needsDisplayBufferRendered = false;
                this.cancelBuffering();
                this.setState({
                    ...virtualBoundaries,
                    rowIds: rowIds
                });
            }
        } else this.shouldUpdate = false;
        if (isAutoRowHeight) {
            const { batchUpdateRowHeightMapping: batchUpdateRowHeightMapping } = nextProps;
            if (this.batchUpdateTimeoutId == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            this.batchUpdateTimeoutId = window.setTimeout(()=>{
                this.batchUpdateTimeoutId = null;
                if (Object.keys(this.rowHeightUpdateBatch).length > 0) batchUpdateRowHeightMapping(rowIds, this.rowHeightUpdateBatch);
                this.rowHeightUpdateBatch = {};
            });
        }
    }
    shouldComponentUpdate(nextProps) {
        const { rowIds: rowIds, contentHeight: contentHeight } = this.props;
        // table has been resized or entirely new rows: we need to re-adjust - end of story.
        if (contentHeight !== nextProps.contentHeight || rowIds !== nextProps.rowIds) return true;
        // the buffer rows have been surpassed, render a new set of rows and buffers
        return this.shouldUpdate;
    }
    componentDidUpdate() {
        this.shouldUpdate = false;
        if (this.needsDisplayBufferRendered) {
            this.needsDisplayBufferRendered = false;
            const { displayStart: displayStart, displayEnd: displayEnd } = this.props.virtualBoundaries;
            this.scheduleBuffering(displayStart, displayEnd);
        }
    }
    componentWillUnmount() {
        this.cancelBuffering();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.batchUpdateTimeoutId && window.clearTimeout(this.batchUpdateTimeoutId);
    }
    afterAnimationFrame() {
        return new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            this.cancelNextAnimationFrameHandlers = ()=>{
                this.cancelNextAnimationFrameHandlers = null;
                reject(new Error('Cancelled'));
            };
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.requestAnimationFrame(()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.setTimeout(()=>{
                    this.cancelNextAnimationFrameHandlers = null;
                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                    resolve();
                });
            });
        });
    }
    cancelBuffering() {
        this.cancelNextAnimationFrameHandlers && this.cancelNextAnimationFrameHandlers();
    }
    scheduleBuffering(displayStart, displayEnd) {
        this.cancelBuffering();
        this.afterAnimationFrame().then(()=>{
            this.shouldUpdate = true;
            const rowsRendered = this.state.displayEnd - this.state.displayStart;
            const rowsDeferred = this.state.displayStart - displayStart + (displayEnd - this.state.displayEnd);
            this.props.onDeferredBuffering(rowsRendered, rowsDeferred);
            this.setState({
                displayStart: displayStart,
                displayEnd: displayEnd
            });
        }).catch(()=>{
        // presumably due to being cancelled
        });
    }
    getBoundaries() {
        if (false) return this.props.virtualBoundaries;
        return this.state;
    }
    render() {
        const { rowIds: rowIds, contentHeight: contentHeight, onLoadingRowUnmount: onLoadingRowUnmount, List: List } = this.props;
        const { displayStart: displayStart, displayEnd: displayEnd } = this.getBoundaries();
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'string[]' and 'number' have no overlap.
        if (contentHeight === 0 || rowIds === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(List, {
            rowIds: rowIds,
            displayStart: displayStart,
            displayEnd: displayEnd,
            onRowContentUpdate: this.updateStateRowHeight,
            onLoadingRowUnmount: onLoadingRowUnmount
        });
    }
}

});
parcelRegister("7HT5p", function(module, exports) {

$parcel$export(module.exports, "shouldDeferBuffering", () => $813f25a2b4e5acad$export$ae5c6ac06aadc69);
/**
 * Threshold for rows in the "buffered" region (i.e., difference of <display region> and <visible region>).
 *
 * Only the visible region will be rendered initially if more than `DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD`
 * of the "buffered" rows need to be mounted (because they were not previously rendered); rendering of the
 * buffer will be deferred.
 */ const $813f25a2b4e5acad$var$DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD = 0.3;
const $813f25a2b4e5acad$var$getRowsForBuffering = ({ virtualBoundaries: { displayStart: displayStart, visibleStart: visibleStart, visibleEnd: visibleEnd, displayEnd: displayEnd }, rowIds: rowIds })=>[
        ...rowIds.slice(displayStart, visibleStart),
        ...rowIds.slice(visibleEnd + 1, displayEnd + 1)
    ];
const $813f25a2b4e5acad$var$getPreviouslyRenderedRows = (prevRenderState)=>{
    const { rowIds: rowIds, virtualBoundaries: { displayStart: displayStart, displayEnd: displayEnd } } = prevRenderState;
    return rowIds.slice(displayStart, displayEnd + 1);
};
const $813f25a2b4e5acad$var$getBufferRowsNeedingMount = (nextRenderState, prevRenderState)=>{
    const previouslyRenderedRows = new Set($813f25a2b4e5acad$var$getPreviouslyRenderedRows(prevRenderState));
    return $813f25a2b4e5acad$var$getRowsForBuffering(nextRenderState).filter((row)=>!previouslyRenderedRows.has(row));
};
// Only allow deferred buffering when at the top of the row list for now.
const $813f25a2b4e5acad$var$canDeferBuffering = (nextRenderState)=>{
    const { virtualBoundaries: { visibleStart: visibleStart } } = nextRenderState;
    return visibleStart === 0;
};
const $813f25a2b4e5acad$export$ae5c6ac06aadc69 = (prevRenderState, nextRenderState)=>{
    if (!$813f25a2b4e5acad$var$canDeferBuffering(nextRenderState)) return false;
    const { visibleStart: visibleStart, displayStart: displayStart, visibleEnd: visibleEnd, displayEnd: displayEnd } = nextRenderState.virtualBoundaries;
    const requestedBufferSize = displayEnd - visibleEnd + (visibleStart - displayStart);
    if (requestedBufferSize === 0) return false;
    const rowsNeedingMount = $813f25a2b4e5acad$var$getBufferRowsNeedingMount(nextRenderState, prevRenderState).length;
    return rowsNeedingMount > requestedBufferSize * $813f25a2b4e5acad$var$DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD;
};

});




parcelRegister("bR1Og", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c7f789548a0bd5a$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $kSeJ5 = parcelRequire("kSeJ5");

var $bFTY1 = parcelRequire("bFTY1");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $geLeC = parcelRequire("geLeC");
var $8c7f789548a0bd5a$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        left: (0, $bFTY1.getVisibleCoreColumnsWidth)(state),
        viewportWidth: (0, $iN58L.getHorizontalScrollWidth)(state),
        contentWidth: (0, $iN58L.getVisibleAdditionalColumnsWidth)(state) + (0, $5J7ao.getTableRowMargin)(state),
        scrollLeft: (0, $5J7ao.getHorizontalScrollOffset)(state),
        shouldUseCssForRendering: (0, $5J7ao.getShouldUseCssForRendering)(state)
    }), {
    setHorizontalScrollOffset: $kSeJ5.setHorizontal
})((0, $geLeC.default));

});
parcelRegister("geLeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2937a14ed04cfd8a$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4R6GH = parcelRequire("4R6GH");

var $6iCoB = parcelRequire("6iCoB");

var $gWU4i = parcelRequire("gWU4i");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2937a14ed04cfd8a$var$StyledScrollbar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $gWU4i.StyledScrollbars), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $lD23V.default)(`${__cmplp.left}px`),
            "--_1iji1h5": (0, $lD23V.default)(__cmplp.theme.scrollbar.offset, "px"),
            "--_g4pqz5": (0, $lD23V.default)(__cmplp.width - __cmplp.theme.scrollbar.offset, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw7079 _1ltvdw55 _94n5idpf _4t3i2dgd _16mt19el",
            __cmplp.shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table') ? "_1bsbc11o" : "_1bsbby57",
            __cmplp.className
        ])
    });
});
const $2937a14ed04cfd8a$var$FakeContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1hdq _4t3it94y",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $2937a14ed04cfd8a$var$HorizontalScrollbar extends (0, $5uXOq.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { scrollRef: scrollRef } = this;
        if (scrollRef) scrollRef.scrollLeft(nextProps.scrollLeft);
    }
    render() {
        const { viewportWidth: viewportWidth, contentWidth: contentWidth, left: left, theme: theme, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2937a14ed04cfd8a$var$StyledScrollbar, {
            ref: this.setScrollRef,
            width: viewportWidth,
            left: left,
            onScrollFrame: this.onHorizontalScroll,
            theme: theme,
            shouldUseCssForRendering: shouldUseCssForRendering
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2937a14ed04cfd8a$var$FakeContent, {
            width: contentWidth
        }));
    }
    constructor(...args){
        super(...args), this.onHorizontalScroll = ({ scrollLeft: scrollLeft })=>{
            const { setHorizontalScrollOffset: setHorizontalScrollOffset } = this.props;
            setHorizontalScrollOffset(scrollLeft);
        }, this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        };
    }
}
var $2937a14ed04cfd8a$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($2937a14ed04cfd8a$var$HorizontalScrollbar);

});
parcelRegister("gWU4i", function(module, exports) {

$parcel$export(module.exports, "StyledScrollbars", () => $9f61f02565d60e17$export$8c1e030d30c518f3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $68JXT = parcelRequire("68JXT");
const $9f61f02565d60e17$export$8c1e030d30c518f3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, (/*@__PURE__*/$parcel$interopDefault($68JXT))), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nhmktnze _d39w1qh3 _ekl21fj3 _1o3o19el _iwvize3t _1dcdu2gc _1ijuu2gc _bh271c1a _145vtnze _2bk9gxqn _1t7ztlke _4bumh2mm _1a4htnze _1syn1m3d _1dni1fj3 _tqfr19el _e1uku2gc _bwqgze3t _i0vgu2gc _13411c1a _qb98tnze _1cldcdhy _8vvgtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("68JXT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Scrollbars = undefined;

var $h0BPJ = parcelRequire("h0BPJ");
var $478725227be6785f$var$_Scrollbars2 = $478725227be6785f$var$_interopRequireDefault($h0BPJ);
function $478725227be6785f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports["default"] = $478725227be6785f$var$_Scrollbars2["default"];
module.exports.Scrollbars = $478725227be6785f$var$_Scrollbars2["default"];

});
parcelRegister("h0BPJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c61fc8af42337b53$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c61fc8af42337b53$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $iz0zv = parcelRequire("iz0zv");
var $c61fc8af42337b53$var$_raf3 = $c61fc8af42337b53$var$_interopRequireDefault($iz0zv);

var $yZMAP = parcelRequire("yZMAP");
var $c61fc8af42337b53$var$_domCss2 = $c61fc8af42337b53$var$_interopRequireDefault($yZMAP);

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $c61fc8af42337b53$var$_propTypes2 = $c61fc8af42337b53$var$_interopRequireDefault($8rCP3);

var $gli1E = parcelRequire("gli1E");
var $c61fc8af42337b53$var$_isString2 = $c61fc8af42337b53$var$_interopRequireDefault($gli1E);

var $49uUZ = parcelRequire("49uUZ");
var $c61fc8af42337b53$var$_getScrollbarWidth2 = $c61fc8af42337b53$var$_interopRequireDefault($49uUZ);

var $5kT8f = parcelRequire("5kT8f");
var $c61fc8af42337b53$var$_returnFalse2 = $c61fc8af42337b53$var$_interopRequireDefault($5kT8f);

var $esutX = parcelRequire("esutX");
var $c61fc8af42337b53$var$_getInnerWidth2 = $c61fc8af42337b53$var$_interopRequireDefault($esutX);

var $6Xpxa = parcelRequire("6Xpxa");
var $c61fc8af42337b53$var$_getInnerHeight2 = $c61fc8af42337b53$var$_interopRequireDefault($6Xpxa);

var $2X8KB = parcelRequire("2X8KB");

var $1RfZp = parcelRequire("1RfZp");
function $c61fc8af42337b53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c61fc8af42337b53$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $c61fc8af42337b53$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c61fc8af42337b53$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c61fc8af42337b53$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c61fc8af42337b53$var$Scrollbars = function(_Component) {
    $c61fc8af42337b53$var$_inherits(Scrollbars, _Component);
    function Scrollbars(props) {
        var _ref;
        $c61fc8af42337b53$var$_classCallCheck(this, Scrollbars);
        for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        var _this = $c61fc8af42337b53$var$_possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [
            this,
            props
        ].concat(rest)));
        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }
    $c61fc8af42337b53$var$_createClass(Scrollbars, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.addListeners();
                this.update();
                this.componentDidMountUniversal();
            }
        },
        {
            key: 'componentDidMountUniversal',
            value: function componentDidMountUniversal() {
                // eslint-disable-line react/sort-comp
                var universal = this.props.universal;
                if (!universal) return;
                this.setState({
                    didMountUniversal: true
                });
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.update();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeListeners();
                (0, $iz0zv.cancel)(this.requestFrame);
                clearTimeout(this.hideTracksTimeout);
                clearInterval(this.detectScrollingInterval);
            }
        },
        {
            key: 'getScrollLeft',
            value: function getScrollLeft() {
                if (!this.view) return 0;
                return this.view.scrollLeft;
            }
        },
        {
            key: 'getScrollTop',
            value: function getScrollTop() {
                if (!this.view) return 0;
                return this.view.scrollTop;
            }
        },
        {
            key: 'getScrollWidth',
            value: function getScrollWidth() {
                if (!this.view) return 0;
                return this.view.scrollWidth;
            }
        },
        {
            key: 'getScrollHeight',
            value: function getScrollHeight() {
                if (!this.view) return 0;
                return this.view.scrollHeight;
            }
        },
        {
            key: 'getClientWidth',
            value: function getClientWidth() {
                if (!this.view) return 0;
                return this.view.clientWidth;
            }
        },
        {
            key: 'getClientHeight',
            value: function getClientHeight() {
                if (!this.view) return 0;
                return this.view.clientHeight;
            }
        },
        {
            key: 'getValues',
            value: function getValues() {
                var _ref2 = this.view || {}, _ref2$scrollLeft = _ref2.scrollLeft, scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop, _ref2$scrollWidth = _ref2.scrollWidth, scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth, _ref2$scrollHeight = _ref2.scrollHeight, scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight, _ref2$clientWidth = _ref2.clientWidth, clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
                return {
                    left: scrollLeft / (scrollWidth - clientWidth) || 0,
                    top: scrollTop / (scrollHeight - clientHeight) || 0,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    clientWidth: clientWidth,
                    clientHeight: clientHeight
                };
            }
        },
        {
            key: 'getThumbHorizontalWidth',
            value: function getThumbHorizontalWidth() {
                var _props = this.props, thumbSize = _props.thumbSize, thumbMinSize = _props.thumbMinSize;
                var _view = this.view, scrollWidth = _view.scrollWidth, clientWidth = _view.clientWidth;
                var trackWidth = (0, $c61fc8af42337b53$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                if (trackWidth === width) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(width, thumbMinSize);
            }
        },
        {
            key: 'getThumbVerticalHeight',
            value: function getThumbVerticalHeight() {
                var _props2 = this.props, thumbSize = _props2.thumbSize, thumbMinSize = _props2.thumbMinSize;
                var _view2 = this.view, scrollHeight = _view2.scrollHeight, clientHeight = _view2.clientHeight;
                var trackHeight = (0, $c61fc8af42337b53$var$_getInnerHeight2["default"])(this.trackVertical);
                var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                if (trackHeight === height) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(height, thumbMinSize);
            }
        },
        {
            key: 'getScrollLeftForOffset',
            value: function getScrollLeftForOffset(offset) {
                var _view3 = this.view, scrollWidth = _view3.scrollWidth, clientWidth = _view3.clientWidth;
                var trackWidth = (0, $c61fc8af42337b53$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var thumbWidth = this.getThumbHorizontalWidth();
                return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
            }
        },
        {
            key: 'getScrollTopForOffset',
            value: function getScrollTopForOffset(offset) {
                var _view4 = this.view, scrollHeight = _view4.scrollHeight, clientHeight = _view4.clientHeight;
                var trackHeight = (0, $c61fc8af42337b53$var$_getInnerHeight2["default"])(this.trackVertical);
                var thumbHeight = this.getThumbVerticalHeight();
                return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
            }
        },
        {
            key: 'scrollLeft',
            value: function scrollLeft() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollLeft = left;
            }
        },
        {
            key: 'scrollTop',
            value: function scrollTop() {
                var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollTop = top;
            }
        },
        {
            key: 'scrollToLeft',
            value: function scrollToLeft() {
                if (!this.view) return;
                this.view.scrollLeft = 0;
            }
        },
        {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (!this.view) return;
                this.view.scrollTop = 0;
            }
        },
        {
            key: 'scrollToRight',
            value: function scrollToRight() {
                if (!this.view) return;
                this.view.scrollLeft = this.view.scrollWidth;
            }
        },
        {
            key: 'scrollToBottom',
            value: function scrollToBottom() {
                if (!this.view) return;
                this.view.scrollTop = this.view.scrollHeight;
            }
        },
        {
            key: 'addListeners',
            value: function addListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.addEventListener('scroll', this.handleScroll);
                if (!(0, $c61fc8af42337b53$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.addEventListener('resize', this.handleWindowResize);
            }
        },
        {
            key: 'removeListeners',
            value: function removeListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.removeEventListener('scroll', this.handleScroll);
                if (!(0, $c61fc8af42337b53$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.removeEventListener('resize', this.handleWindowResize);
                // Possibly setup by `handleDragStart`
                this.teardownDragging();
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll(event) {
                var _this2 = this;
                var _props3 = this.props, onScroll = _props3.onScroll, onScrollFrame = _props3.onScrollFrame;
                if (onScroll) onScroll(event);
                this.update(function(values) {
                    var scrollLeft = values.scrollLeft, scrollTop = values.scrollTop;
                    _this2.viewScrollLeft = scrollLeft;
                    _this2.viewScrollTop = scrollTop;
                    if (onScrollFrame) onScrollFrame(values);
                });
                this.detectScrolling();
            }
        },
        {
            key: 'handleScrollStart',
            value: function handleScrollStart() {
                var onScrollStart = this.props.onScrollStart;
                if (onScrollStart) onScrollStart();
                this.handleScrollStartAutoHide();
            }
        },
        {
            key: 'handleScrollStartAutoHide',
            value: function handleScrollStartAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleScrollStop',
            value: function handleScrollStop() {
                var onScrollStop = this.props.onScrollStop;
                if (onScrollStop) onScrollStop();
                this.handleScrollStopAutoHide();
            }
        },
        {
            key: 'handleScrollStopAutoHide',
            value: function handleScrollStopAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleWindowResize',
            value: function handleWindowResize() {
                this.update();
            }
        },
        {
            key: 'handleHorizontalTrackMouseDown',
            value: function handleHorizontalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientX = event.clientX;
                var _target$getBoundingCl = target.getBoundingClientRect(), targetLeft = _target$getBoundingCl.left;
                var thumbWidth = this.getThumbHorizontalWidth();
                var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
        },
        {
            key: 'handleVerticalTrackMouseDown',
            value: function handleVerticalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientY = event.clientY;
                var _target$getBoundingCl2 = target.getBoundingClientRect(), targetTop = _target$getBoundingCl2.top;
                var thumbHeight = this.getThumbVerticalHeight();
                var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                this.view.scrollTop = this.getScrollTopForOffset(offset);
            }
        },
        {
            key: 'handleHorizontalThumbMouseDown',
            value: function handleHorizontalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientX = event.clientX;
                var offsetWidth = target.offsetWidth;
                var _target$getBoundingCl3 = target.getBoundingClientRect(), left = _target$getBoundingCl3.left;
                this.prevPageX = offsetWidth - (clientX - left);
            }
        },
        {
            key: 'handleVerticalThumbMouseDown',
            value: function handleVerticalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientY = event.clientY;
                var offsetHeight = target.offsetHeight;
                var _target$getBoundingCl4 = target.getBoundingClientRect(), top = _target$getBoundingCl4.top;
                this.prevPageY = offsetHeight - (clientY - top);
            }
        },
        {
            key: 'setupDragging',
            value: function setupDragging() {
                (0, $c61fc8af42337b53$var$_domCss2["default"])(document.body, $2X8KB.disableSelectStyle);
                document.addEventListener('mousemove', this.handleDrag);
                document.addEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = $c61fc8af42337b53$var$_returnFalse2["default"];
            }
        },
        {
            key: 'teardownDragging',
            value: function teardownDragging() {
                (0, $c61fc8af42337b53$var$_domCss2["default"])(document.body, $2X8KB.disableSelectStyleReset);
                document.removeEventListener('mousemove', this.handleDrag);
                document.removeEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = undefined;
            }
        },
        {
            key: 'handleDragStart',
            value: function handleDragStart(event) {
                this.dragging = true;
                event.stopImmediatePropagation();
                this.setupDragging();
            }
        },
        {
            key: 'handleDrag',
            value: function handleDrag(event) {
                if (this.prevPageX) {
                    var clientX = event.clientX;
                    var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(), trackLeft = _trackHorizontal$getB.left;
                    var thumbWidth = this.getThumbHorizontalWidth();
                    var clickPosition = thumbWidth - this.prevPageX;
                    var offset = -trackLeft + clientX - clickPosition;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
                if (this.prevPageY) {
                    var clientY = event.clientY;
                    var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(), trackTop = _trackVertical$getBou.top;
                    var thumbHeight = this.getThumbVerticalHeight();
                    var _clickPosition = thumbHeight - this.prevPageY;
                    var _offset = -trackTop + clientY - _clickPosition;
                    this.view.scrollTop = this.getScrollTopForOffset(_offset);
                }
                return false;
            }
        },
        {
            key: 'handleDragEnd',
            value: function handleDragEnd() {
                this.dragging = false;
                this.prevPageX = this.prevPageY = 0;
                this.teardownDragging();
                this.handleDragEndAutoHide();
            }
        },
        {
            key: 'handleDragEndAutoHide',
            value: function handleDragEndAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleTrackMouseEnter',
            value: function handleTrackMouseEnter() {
                this.trackMouseOver = true;
                this.handleTrackMouseEnterAutoHide();
            }
        },
        {
            key: 'handleTrackMouseEnterAutoHide',
            value: function handleTrackMouseEnterAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleTrackMouseLeave',
            value: function handleTrackMouseLeave() {
                this.trackMouseOver = false;
                this.handleTrackMouseLeaveAutoHide();
            }
        },
        {
            key: 'handleTrackMouseLeaveAutoHide',
            value: function handleTrackMouseLeaveAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'showTracks',
            value: function showTracks() {
                clearTimeout(this.hideTracksTimeout);
                (0, $c61fc8af42337b53$var$_domCss2["default"])(this.trackHorizontal, {
                    opacity: 1
                });
                (0, $c61fc8af42337b53$var$_domCss2["default"])(this.trackVertical, {
                    opacity: 1
                });
            }
        },
        {
            key: 'hideTracks',
            value: function hideTracks() {
                var _this3 = this;
                if (this.dragging) return;
                if (this.scrolling) return;
                if (this.trackMouseOver) return;
                var autoHideTimeout = this.props.autoHideTimeout;
                clearTimeout(this.hideTracksTimeout);
                this.hideTracksTimeout = setTimeout(function() {
                    (0, $c61fc8af42337b53$var$_domCss2["default"])(_this3.trackHorizontal, {
                        opacity: 0
                    });
                    (0, $c61fc8af42337b53$var$_domCss2["default"])(_this3.trackVertical, {
                        opacity: 0
                    });
                }, autoHideTimeout);
            }
        },
        {
            key: 'detectScrolling',
            value: function detectScrolling() {
                var _this4 = this;
                if (this.scrolling) return;
                this.scrolling = true;
                this.handleScrollStart();
                this.detectScrollingInterval = setInterval(function() {
                    if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                        clearInterval(_this4.detectScrollingInterval);
                        _this4.scrolling = false;
                        _this4.handleScrollStop();
                    }
                    _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                    _this4.lastViewScrollTop = _this4.viewScrollTop;
                }, 100);
            }
        },
        {
            key: 'raf',
            value: function raf(callback) {
                var _this5 = this;
                if (this.requestFrame) $c61fc8af42337b53$var$_raf3["default"].cancel(this.requestFrame);
                this.requestFrame = (0, $c61fc8af42337b53$var$_raf3["default"])(function() {
                    _this5.requestFrame = undefined;
                    callback();
                });
            }
        },
        {
            key: 'update',
            value: function update(callback) {
                var _this6 = this;
                this.raf(function() {
                    return _this6._update(callback);
                });
            }
        },
        {
            key: '_update',
            value: function _update(callback) {
                var _props4 = this.props, onUpdate = _props4.onUpdate, hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
                var values = this.getValues();
                if ((0, $c61fc8af42337b53$var$_getScrollbarWidth2["default"])()) {
                    var scrollLeft = values.scrollLeft, clientWidth = values.clientWidth, scrollWidth = values.scrollWidth;
                    var trackHorizontalWidth = (0, $c61fc8af42337b53$var$_getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                    var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                    var thumbHorizontalStyle = {
                        width: thumbHorizontalWidth,
                        transform: 'translateX(' + thumbHorizontalX + 'px)'
                    };
                    var scrollTop = values.scrollTop, clientHeight = values.clientHeight, scrollHeight = values.scrollHeight;
                    var trackVerticalHeight = (0, $c61fc8af42337b53$var$_getInnerHeight2["default"])(this.trackVertical);
                    var thumbVerticalHeight = this.getThumbVerticalHeight();
                    var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                    var thumbVerticalStyle = {
                        height: thumbVerticalHeight,
                        transform: 'translateY(' + thumbVerticalY + 'px)'
                    };
                    if (hideTracksWhenNotNeeded) {
                        var trackHorizontalStyle = {
                            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                        };
                        var trackVerticalStyle = {
                            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                        };
                        (0, $c61fc8af42337b53$var$_domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                        (0, $c61fc8af42337b53$var$_domCss2["default"])(this.trackVertical, trackVerticalStyle);
                    }
                    (0, $c61fc8af42337b53$var$_domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                    (0, $c61fc8af42337b53$var$_domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                }
                if (onUpdate) onUpdate(values);
                if (typeof callback !== 'function') return;
                callback(values);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this7 = this;
                var scrollbarWidth = (0, $c61fc8af42337b53$var$_getScrollbarWidth2["default"])();
                /* eslint-disable no-unused-vars */ var _props5 = this.props, onScroll = _props5.onScroll, onScrollFrame = _props5.onScrollFrame, onScrollStart = _props5.onScrollStart, onScrollStop = _props5.onScrollStop, onUpdate = _props5.onUpdate, renderView = _props5.renderView, renderTrackHorizontal = _props5.renderTrackHorizontal, renderTrackVertical = _props5.renderTrackVertical, renderThumbHorizontal = _props5.renderThumbHorizontal, renderThumbVertical = _props5.renderThumbVertical, tagName = _props5.tagName, hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded, autoHide = _props5.autoHide, autoHideTimeout = _props5.autoHideTimeout, autoHideDuration = _props5.autoHideDuration, thumbSize = _props5.thumbSize, thumbMinSize = _props5.thumbMinSize, universal = _props5.universal, autoHeight = _props5.autoHeight, autoHeightMin = _props5.autoHeightMin, autoHeightMax = _props5.autoHeightMax, style = _props5.style, children = _props5.children, props = $c61fc8af42337b53$var$_objectWithoutProperties(_props5, [
                    'onScroll',
                    'onScrollFrame',
                    'onScrollStart',
                    'onScrollStop',
                    'onUpdate',
                    'renderView',
                    'renderTrackHorizontal',
                    'renderTrackVertical',
                    'renderThumbHorizontal',
                    'renderThumbVertical',
                    'tagName',
                    'hideTracksWhenNotNeeded',
                    'autoHide',
                    'autoHideTimeout',
                    'autoHideDuration',
                    'thumbSize',
                    'thumbMinSize',
                    'universal',
                    'autoHeight',
                    'autoHeightMin',
                    'autoHeightMax',
                    'style',
                    'children'
                ]);
                /* eslint-enable no-unused-vars */ var didMountUniversal = this.state.didMountUniversal;
                var containerStyle = $c61fc8af42337b53$var$_extends({}, $2X8KB.containerStyleDefault, autoHeight && $c61fc8af42337b53$var$_extends({}, $2X8KB.containerStyleAutoHeight, {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }), style);
                var viewStyle = $c61fc8af42337b53$var$_extends({}, $2X8KB.viewStyleDefault, {
                    // Hide scrollbars by setting a negative margin
                    marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                    marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                }, autoHeight && $c61fc8af42337b53$var$_extends({}, $2X8KB.viewStyleAutoHeight, {
                    // Add scrollbarWidth to autoHeight in order to compensate negative margins
                    minHeight: (0, $c61fc8af42337b53$var$_isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                    maxHeight: (0, $c61fc8af42337b53$var$_isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
                }), autoHeight && universal && !didMountUniversal && {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }, universal && !didMountUniversal && $2X8KB.viewStyleUniversalInitial);
                var trackAutoHeightStyle = {
                    transition: 'opacity ' + autoHideDuration + 'ms',
                    opacity: 0
                };
                var trackHorizontalStyle = $c61fc8af42337b53$var$_extends({}, $2X8KB.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                var trackVerticalStyle = $c61fc8af42337b53$var$_extends({}, $2X8KB.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                return (0, $5uXOq.createElement)(tagName, $c61fc8af42337b53$var$_extends({}, props, {
                    style: containerStyle,
                    ref: function ref(_ref3) {
                        _this7.container = _ref3;
                    }
                }), [
                    (0, $5uXOq.cloneElement)(renderView({
                        style: viewStyle
                    }), {
                        key: 'view',
                        ref: function ref(_ref4) {
                            _this7.view = _ref4;
                        }
                    }, children),
                    (0, $5uXOq.cloneElement)(renderTrackHorizontal({
                        style: trackHorizontalStyle
                    }), {
                        key: 'trackHorizontal',
                        ref: function ref(_ref5) {
                            _this7.trackHorizontal = _ref5;
                        }
                    }, (0, $5uXOq.cloneElement)(renderThumbHorizontal({
                        style: $2X8KB.thumbHorizontalStyleDefault
                    }), {
                        ref: function ref(_ref6) {
                            _this7.thumbHorizontal = _ref6;
                        }
                    })),
                    (0, $5uXOq.cloneElement)(renderTrackVertical({
                        style: trackVerticalStyle
                    }), {
                        key: 'trackVertical',
                        ref: function ref(_ref7) {
                            _this7.trackVertical = _ref7;
                        }
                    }, (0, $5uXOq.cloneElement)(renderThumbVertical({
                        style: $2X8KB.thumbVerticalStyleDefault
                    }), {
                        ref: function ref(_ref8) {
                            _this7.thumbVertical = _ref8;
                        }
                    }))
                ]);
            }
        }
    ]);
    return Scrollbars;
}($5uXOq.Component);
module.exports["default"] = $c61fc8af42337b53$var$Scrollbars;
$c61fc8af42337b53$var$Scrollbars.propTypes = {
    onScroll: $c61fc8af42337b53$var$_propTypes2["default"].func,
    onScrollFrame: $c61fc8af42337b53$var$_propTypes2["default"].func,
    onScrollStart: $c61fc8af42337b53$var$_propTypes2["default"].func,
    onScrollStop: $c61fc8af42337b53$var$_propTypes2["default"].func,
    onUpdate: $c61fc8af42337b53$var$_propTypes2["default"].func,
    renderView: $c61fc8af42337b53$var$_propTypes2["default"].func,
    renderTrackHorizontal: $c61fc8af42337b53$var$_propTypes2["default"].func,
    renderTrackVertical: $c61fc8af42337b53$var$_propTypes2["default"].func,
    renderThumbHorizontal: $c61fc8af42337b53$var$_propTypes2["default"].func,
    renderThumbVertical: $c61fc8af42337b53$var$_propTypes2["default"].func,
    tagName: $c61fc8af42337b53$var$_propTypes2["default"].string,
    thumbSize: $c61fc8af42337b53$var$_propTypes2["default"].number,
    thumbMinSize: $c61fc8af42337b53$var$_propTypes2["default"].number,
    hideTracksWhenNotNeeded: $c61fc8af42337b53$var$_propTypes2["default"].bool,
    autoHide: $c61fc8af42337b53$var$_propTypes2["default"].bool,
    autoHideTimeout: $c61fc8af42337b53$var$_propTypes2["default"].number,
    autoHideDuration: $c61fc8af42337b53$var$_propTypes2["default"].number,
    autoHeight: $c61fc8af42337b53$var$_propTypes2["default"].bool,
    autoHeightMin: $c61fc8af42337b53$var$_propTypes2["default"].oneOfType([
        $c61fc8af42337b53$var$_propTypes2["default"].number,
        $c61fc8af42337b53$var$_propTypes2["default"].string
    ]),
    autoHeightMax: $c61fc8af42337b53$var$_propTypes2["default"].oneOfType([
        $c61fc8af42337b53$var$_propTypes2["default"].number,
        $c61fc8af42337b53$var$_propTypes2["default"].string
    ]),
    universal: $c61fc8af42337b53$var$_propTypes2["default"].bool,
    style: $c61fc8af42337b53$var$_propTypes2["default"].object,
    children: $c61fc8af42337b53$var$_propTypes2["default"].node
};
$c61fc8af42337b53$var$Scrollbars.defaultProps = {
    renderView: $1RfZp.renderViewDefault,
    renderTrackHorizontal: $1RfZp.renderTrackHorizontalDefault,
    renderTrackVertical: $1RfZp.renderTrackVerticalDefault,
    renderThumbHorizontal: $1RfZp.renderThumbHorizontalDefault,
    renderThumbVertical: $1RfZp.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

});
parcelRegister("iz0zv", function(module, exports) {

var $9s7hB = parcelRequire("9s7hB");
var $d83bf06c4f4c0123$var$root = typeof window === 'undefined' ? $parcel$global : window, $d83bf06c4f4c0123$var$vendors = [
    'moz',
    'webkit'
], $d83bf06c4f4c0123$var$suffix = 'AnimationFrame', $d83bf06c4f4c0123$var$raf = $d83bf06c4f4c0123$var$root['request' + $d83bf06c4f4c0123$var$suffix], $d83bf06c4f4c0123$var$caf = $d83bf06c4f4c0123$var$root['cancel' + $d83bf06c4f4c0123$var$suffix] || $d83bf06c4f4c0123$var$root['cancelRequest' + $d83bf06c4f4c0123$var$suffix];
for(var $d83bf06c4f4c0123$var$i = 0; !$d83bf06c4f4c0123$var$raf && $d83bf06c4f4c0123$var$i < $d83bf06c4f4c0123$var$vendors.length; $d83bf06c4f4c0123$var$i++){
    $d83bf06c4f4c0123$var$raf = $d83bf06c4f4c0123$var$root[$d83bf06c4f4c0123$var$vendors[$d83bf06c4f4c0123$var$i] + 'Request' + $d83bf06c4f4c0123$var$suffix];
    $d83bf06c4f4c0123$var$caf = $d83bf06c4f4c0123$var$root[$d83bf06c4f4c0123$var$vendors[$d83bf06c4f4c0123$var$i] + 'Cancel' + $d83bf06c4f4c0123$var$suffix] || $d83bf06c4f4c0123$var$root[$d83bf06c4f4c0123$var$vendors[$d83bf06c4f4c0123$var$i] + 'CancelRequest' + $d83bf06c4f4c0123$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$d83bf06c4f4c0123$var$raf || !$d83bf06c4f4c0123$var$caf) {
    var $d83bf06c4f4c0123$var$last = 0, $d83bf06c4f4c0123$var$id = 0, $d83bf06c4f4c0123$var$queue = [], $d83bf06c4f4c0123$var$frameDuration = 1000 / 60;
    $d83bf06c4f4c0123$var$raf = function(callback) {
        if ($d83bf06c4f4c0123$var$queue.length === 0) {
            var _now = $9s7hB(), next = Math.max(0, $d83bf06c4f4c0123$var$frameDuration - (_now - $d83bf06c4f4c0123$var$last));
            $d83bf06c4f4c0123$var$last = next + _now;
            setTimeout(function() {
                var cp = $d83bf06c4f4c0123$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $d83bf06c4f4c0123$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($d83bf06c4f4c0123$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $d83bf06c4f4c0123$var$queue.push({
            handle: ++$d83bf06c4f4c0123$var$id,
            callback: callback,
            cancelled: false
        });
        return $d83bf06c4f4c0123$var$id;
    };
    $d83bf06c4f4c0123$var$caf = function(handle) {
        for(var i = 0; i < $d83bf06c4f4c0123$var$queue.length; i++)if ($d83bf06c4f4c0123$var$queue[i].handle === handle) $d83bf06c4f4c0123$var$queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $d83bf06c4f4c0123$var$raf.call($d83bf06c4f4c0123$var$root, fn);
};
module.exports.cancel = function() {
    $d83bf06c4f4c0123$var$caf.apply($d83bf06c4f4c0123$var$root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = $d83bf06c4f4c0123$var$root;
    object.requestAnimationFrame = $d83bf06c4f4c0123$var$raf;
    object.cancelAnimationFrame = $d83bf06c4f4c0123$var$caf;
};

});
parcelRegister("9s7hB", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $6cAn5 !== "undefined" && $6cAn5 !== null && $6cAn5.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $6cAn5.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $6cAn5.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});


parcelRegister("yZMAP", function(module, exports) {

var $duo7F = parcelRequire("duo7F");

var $8Ar8M = parcelRequire("8Ar8M");
var $069319dc15593bb0$var$cache = {
    'float': 'cssFloat'
};

var $1cWd4 = parcelRequire("1cWd4");
function $069319dc15593bb0$var$style(element, property, value) {
    var camel = $069319dc15593bb0$var$cache[property];
    if (typeof camel === 'undefined') camel = $069319dc15593bb0$var$detect(property);
    // may be false if CSS prop is unsupported
    if (camel) {
        if (value === undefined) return element.style[camel];
        element.style[camel] = $1cWd4(camel, value);
    }
}
function $069319dc15593bb0$var$each(element, properties) {
    for(var k in properties)if (properties.hasOwnProperty(k)) $069319dc15593bb0$var$style(element, k, properties[k]);
}
function $069319dc15593bb0$var$detect(cssProp) {
    var camel = $8Ar8M(cssProp);
    var result = $duo7F(camel);
    $069319dc15593bb0$var$cache[camel] = $069319dc15593bb0$var$cache[cssProp] = $069319dc15593bb0$var$cache[result] = result;
    return result;
}
function $069319dc15593bb0$var$set() {
    if (arguments.length === 2) {
        if (typeof arguments[1] === 'string') arguments[0].style.cssText = arguments[1];
        else $069319dc15593bb0$var$each(arguments[0], arguments[1]);
    } else $069319dc15593bb0$var$style(arguments[0], arguments[1], arguments[2]);
}
module.exports = $069319dc15593bb0$var$set;
module.exports.set = $069319dc15593bb0$var$set;
module.exports.get = function(element, properties) {
    if (Array.isArray(properties)) return properties.reduce(function(obj, prop) {
        obj[prop] = $069319dc15593bb0$var$style(element, prop || '');
        return obj;
    }, {});
    else return $069319dc15593bb0$var$style(element, properties || '');
};

});
parcelRegister("duo7F", function(module, exports) {
var $0288c97377d3890f$var$div = null;
var $0288c97377d3890f$var$prefixes = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
module.exports = function prefixStyle(prop) {
    // re-use a dummy div
    if (!$0288c97377d3890f$var$div) $0288c97377d3890f$var$div = document.createElement('div');
    var style = $0288c97377d3890f$var$div.style;
    // prop exists without prefix
    if (prop in style) return prop;
    // borderRadius -> BorderRadius
    var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);
    // find the vendor-prefixed prop
    for(var i = $0288c97377d3890f$var$prefixes.length; i >= 0; i--){
        var name = $0288c97377d3890f$var$prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) return name;
    }
    return false;
};

});

parcelRegister("8Ar8M", function(module, exports) {

var $9R0j0 = parcelRequire("9R0j0");
/**
 * Export.
 */ module.exports = $6406bd14233f8dcc$var$toCamelCase;
/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */ function $6406bd14233f8dcc$var$toCamelCase(string) {
    return $9R0j0(string).replace(/\s(\w)/g, function(matches, letter) {
        return letter.toUpperCase();
    });
}

});
parcelRegister("9R0j0", function(module, exports) {

var $jJ1x7 = parcelRequire("jJ1x7");
/**
 * Export.
 */ module.exports = $72c94cf34774f207$var$toSpaceCase;
/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */ function $72c94cf34774f207$var$toSpaceCase(string) {
    return $jJ1x7(string).replace(/[\W_]+(.|$)/g, function(matches, match) {
        return match ? ' ' + match : '';
    }).trim();
}

});
parcelRegister("jJ1x7", function(module, exports) {
/**
 * Export.
 */ module.exports = $e5c368c4af82dc21$var$toNoCase;
/**
 * Test whether a string is camel-case.
 */ var $e5c368c4af82dc21$var$hasSpace = /\s/;
var $e5c368c4af82dc21$var$hasSeparator = /(_|-|\.|:)/;
var $e5c368c4af82dc21$var$hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */ function $e5c368c4af82dc21$var$toNoCase(string) {
    if ($e5c368c4af82dc21$var$hasSpace.test(string)) return string.toLowerCase();
    if ($e5c368c4af82dc21$var$hasSeparator.test(string)) return ($e5c368c4af82dc21$var$unseparate(string) || string).toLowerCase();
    if ($e5c368c4af82dc21$var$hasCamel.test(string)) return $e5c368c4af82dc21$var$uncamelize(string).toLowerCase();
    return string.toLowerCase();
}
/**
 * Separator splitter.
 */ var $e5c368c4af82dc21$var$separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $e5c368c4af82dc21$var$unseparate(string) {
    return string.replace($e5c368c4af82dc21$var$separatorSplitter, function(m, next) {
        return next ? ' ' + next : '';
    });
}
/**
 * Camelcase splitter.
 */ var $e5c368c4af82dc21$var$camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $e5c368c4af82dc21$var$uncamelize(string) {
    return string.replace($e5c368c4af82dc21$var$camelSplitter, function(m, previous, uppers) {
        return previous + ' ' + uppers.toLowerCase().split('').join(' ');
    });
}

});



parcelRegister("1cWd4", function(module, exports) {
/* The following list is defined in React's core */ var $0e1410abf69550f4$var$IS_UNITLESS = {
    animationIterationCount: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    stopOpacity: true,
    strokeDashoffset: true,
    strokeOpacity: true,
    strokeWidth: true
};
module.exports = function(name, value) {
    if (typeof value === 'number' && !$0e1410abf69550f4$var$IS_UNITLESS[name]) return value + 'px';
    else return value;
};

});


parcelRegister("gli1E", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $be5c9704648b36ca$var$isString;
function $be5c9704648b36ca$var$isString(maybe) {
    return typeof maybe === 'string';
}

});

parcelRegister("49uUZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $305ffc5eed77fa79$var$getScrollbarWidth;

var $yZMAP = parcelRequire("yZMAP");
var $305ffc5eed77fa79$var$_domCss2 = $305ffc5eed77fa79$var$_interopRequireDefault($yZMAP);
function $305ffc5eed77fa79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $305ffc5eed77fa79$var$scrollbarWidth = false;
function $305ffc5eed77fa79$var$getScrollbarWidth() {
    if ($305ffc5eed77fa79$var$scrollbarWidth !== false) return $305ffc5eed77fa79$var$scrollbarWidth;
    /* istanbul ignore else */ if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, $305ffc5eed77fa79$var$_domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        $305ffc5eed77fa79$var$scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else $305ffc5eed77fa79$var$scrollbarWidth = 0;
    return $305ffc5eed77fa79$var$scrollbarWidth || 0;
}

});

parcelRegister("5kT8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $3e2996150fd02e89$var$returnFalse;
function $3e2996150fd02e89$var$returnFalse() {
    return false;
}

});

parcelRegister("esutX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a86b5359dec50d8c$var$getInnerWidth;
function $a86b5359dec50d8c$var$getInnerWidth(el) {
    var clientWidth = el.clientWidth;
    var _getComputedStyle = getComputedStyle(el), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

});

parcelRegister("6Xpxa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $510c0f4292de0c42$var$getInnerHeight;
function $510c0f4292de0c42$var$getInnerHeight(el) {
    var clientHeight = el.clientHeight;
    var _getComputedStyle = getComputedStyle(el), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

});

parcelRegister("2X8KB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2267e1254b565ad0$var$containerStyleDefault = module.exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};
// Overrides containerStyleDefault properties
var $2267e1254b565ad0$var$containerStyleAutoHeight = module.exports.containerStyleAutoHeight = {
    height: 'auto'
};
var $2267e1254b565ad0$var$viewStyleDefault = module.exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};
// Overrides viewStyleDefault properties
var $2267e1254b565ad0$var$viewStyleAutoHeight = module.exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};
var $2267e1254b565ad0$var$viewStyleUniversalInitial = module.exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};
var $2267e1254b565ad0$var$trackHorizontalStyleDefault = module.exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};
var $2267e1254b565ad0$var$trackVerticalStyleDefault = module.exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};
var $2267e1254b565ad0$var$thumbHorizontalStyleDefault = module.exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};
var $2267e1254b565ad0$var$thumbVerticalStyleDefault = module.exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};
var $2267e1254b565ad0$var$disableSelectStyle = module.exports.disableSelectStyle = {
    userSelect: 'none'
};
var $2267e1254b565ad0$var$disableSelectStyleReset = module.exports.disableSelectStyleReset = {
    userSelect: ''
};

});

parcelRegister("1RfZp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $15a724db8da3c1b9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.renderViewDefault = $15a724db8da3c1b9$var$renderViewDefault;
module.exports.renderTrackHorizontalDefault = $15a724db8da3c1b9$var$renderTrackHorizontalDefault;
module.exports.renderTrackVerticalDefault = $15a724db8da3c1b9$var$renderTrackVerticalDefault;
module.exports.renderThumbHorizontalDefault = $15a724db8da3c1b9$var$renderThumbHorizontalDefault;
module.exports.renderThumbVerticalDefault = $15a724db8da3c1b9$var$renderThumbVerticalDefault;

var $5uXOq = parcelRequire("5uXOq");
var $15a724db8da3c1b9$var$_react2 = $15a724db8da3c1b9$var$_interopRequireDefault($5uXOq);
function $15a724db8da3c1b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $15a724db8da3c1b9$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/* eslint-disable react/prop-types */ function $15a724db8da3c1b9$var$renderViewDefault(props) {
    return $15a724db8da3c1b9$var$_react2["default"].createElement('div', props);
}
function $15a724db8da3c1b9$var$renderTrackHorizontalDefault(_ref) {
    var style = _ref.style, props = $15a724db8da3c1b9$var$_objectWithoutProperties(_ref, [
        'style'
    ]);
    var finalStyle = $15a724db8da3c1b9$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return $15a724db8da3c1b9$var$_react2["default"].createElement('div', $15a724db8da3c1b9$var$_extends({
        style: finalStyle
    }, props));
}
function $15a724db8da3c1b9$var$renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style, props = $15a724db8da3c1b9$var$_objectWithoutProperties(_ref2, [
        'style'
    ]);
    var finalStyle = $15a724db8da3c1b9$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return $15a724db8da3c1b9$var$_react2["default"].createElement('div', $15a724db8da3c1b9$var$_extends({
        style: finalStyle
    }, props));
}
function $15a724db8da3c1b9$var$renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style, props = $15a724db8da3c1b9$var$_objectWithoutProperties(_ref3, [
        'style'
    ]);
    var finalStyle = $15a724db8da3c1b9$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $15a724db8da3c1b9$var$_react2["default"].createElement('div', $15a724db8da3c1b9$var$_extends({
        style: finalStyle
    }, props));
}
function $15a724db8da3c1b9$var$renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style, props = $15a724db8da3c1b9$var$_objectWithoutProperties(_ref4, [
        'style'
    ]);
    var finalStyle = $15a724db8da3c1b9$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $15a724db8da3c1b9$var$_react2["default"].createElement('div', $15a724db8da3c1b9$var$_extends({
        style: finalStyle
    }, props));
}

});






parcelRegister("2mpZe", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd3cb6988eb506b$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $kSeJ5 = parcelRequire("kSeJ5");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $35pjW = parcelRequire("35pjW");
var $bdd3cb6988eb506b$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        visibleColumnCount: (0, $eeWa5.getVisibleColumnCount)(state),
        facade: (0, $eeWa5.getFacade)(state),
        isVirtualised: (0, $iN58L.getShouldVirtualize)(state),
        virtualBoundaries: (0, $iN58L.getVirtualBoundaries)(state),
        viewportHeight: (0, $iN58L.getTableContentHeight)(state),
        scrollTop: (0, $5J7ao.getVerticalScrollOffset)(state),
        defaultRowHeight: (0, $3W7mX.getDefaultRowHeight)(state),
        isHorizontalScrollVisible: (0, $iN58L.hasHorizontalScrollbar)(state),
        shouldUseCssForRendering: (0, $5J7ao.getShouldUseCssForRendering)(state)
    }), {
    setVerticalScrollOffset: $kSeJ5.setVertical
})((0, $35pjW.default));

});
parcelRegister("35pjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e004f969917542ef$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $7wqBZ = parcelRequire("7wqBZ");

var $9z3aL = parcelRequire("9z3aL");

var $4R6GH = parcelRequire("4R6GH");

var $6iCoB = parcelRequire("6iCoB");

var $6hiB0 = parcelRequire("6hiB0");

var $jTfCC = parcelRequire("jTfCC");
// eslint-disable-next-line jira/react/no-class-components
class $e004f969917542ef$var$VerticalScrollbar extends (0, $5uXOq.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { scrollRef: scrollRef } = this;
        // Changing scrollTop will prevent continuation of the scrolling
        // animation in some browsers, so make sure we're not already in a
        // scroll event before setting it.
        if (scrollRef && !this.isScrolling) scrollRef.scrollTop(nextProps.scrollTop);
    }
    render() {
        const { children: children, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "virtual-table.table.content.scrollbars.vertical.virtual-table-scrollbar-wrapper",
            ref: this.setTargetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table') ? {
                height: `calc(100% - ${this.calculateSpaceTakenByHorizontalScrollbar()}px)`
            } : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jTfCC.default), {
            onScrollbarsRef: this.setScrollRef,
            height: shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table') ? '100%' : this.calculateHeight(),
            onScrollStart: this.onScrollStart,
            onScrollStop: this.onScrollStop,
            onScrollFrame: this.onVerticalScroll,
            shouldUseCssForRendering: shouldUseCssForRendering
        }, children));
    }
    constructor(...args){
        super(...args), this.onVerticalScroll = ({ scrollTop: scrollTop })=>{
            const { setVerticalScrollOffset: setVerticalScrollOffset } = this.props;
            setVerticalScrollOffset(scrollTop);
        }, this.onScrollStart = ()=>{
            const { isVirtualised: isVirtualised, facade: facade, visibleColumnCount: visibleColumnCount, virtualBoundaries: { displayStart: displayStart, displayEnd: displayEnd } } = this.props;
            (0, $7wqBZ.getLongTasksMetrics)('scroll').start('virtual-table', undefined, {
                isVirtualised: isVirtualised,
                visibleColumnCount: visibleColumnCount,
                facade: facade,
                displayedRows: displayEnd - displayStart
            });
            this.isScrolling = true;
        }, this.onScrollStop = ()=>{
            this.isScrolling = false;
            (0, $7wqBZ.getLongTasksMetrics)('scroll').stop((0, $9z3aL.virtualTableScrollReporter));
        }, this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        }, this.setTargetRef = (ref)=>{
            this.targetRef = ref;
        }, this.calculateSpaceTakenByHorizontalScrollbar = ()=>{
            const { isHorizontalScrollVisible: isHorizontalScrollVisible, theme: theme } = this.props;
            if (theme.scrollbar.computeHeight && isHorizontalScrollVisible) {
                const spaceTakenByHorizontalScrollbar = (0, $6hiB0.scrollbarWidth) + theme.scrollbar.marginTop + theme.scrollbar.marginBottom;
                return spaceTakenByHorizontalScrollbar;
            }
            return 0;
        }, this.calculateHeight = ()=>{
            const { viewportHeight: viewportHeight, isHorizontalScrollVisible: isHorizontalScrollVisible, theme: theme, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
            if (shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return viewportHeight - this.calculateSpaceTakenByHorizontalScrollbar();
            if (theme.scrollbar.computeHeight && isHorizontalScrollVisible) {
                const spaceTakenByHorizontalScrollbar = (0, $6hiB0.scrollbarWidth) + theme.scrollbar.marginTop + theme.scrollbar.marginBottom;
                return viewportHeight - spaceTakenByHorizontalScrollbar;
            }
            return viewportHeight;
        };
    }
}
var $e004f969917542ef$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($e004f969917542ef$var$VerticalScrollbar);

});
parcelRegister("7wqBZ", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $f85af650a825558e$export$b092a8653a66aa5e);

var $gJBT6 = parcelRequire("gJBT6");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $cJpFl = parcelRequire("cJpFl");
let $f85af650a825558e$var$observer = null;
const $f85af650a825558e$var$stopObserver = ()=>{
    if ($f85af650a825558e$var$observer) {
        $f85af650a825558e$var$observer.disconnect();
        $f85af650a825558e$var$observer = null;
    }
};
const $f85af650a825558e$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $6RCeq.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $f85af650a825558e$var$stopObserver();
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                $f85af650a825558e$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $f85af650a825558e$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $f85af650a825558e$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $6RCeq.default).now && isStarted) {
                const stopTimestamp = (0, $6RCeq.default).now();
                setTimeout(()=>{
                    $f85af650a825558e$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($f85af650a825558e$var$observer && performanceMark) {
                const perfMark = (0, $x9xyg.getMark)(performanceMark);
                if (!perfMark) {
                    $f85af650a825558e$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("cJpFl", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $3e1de7ace69512d1$export$3d38a87309e205a4);
const $3e1de7ace69512d1$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("9z3aL", function(module, exports) {

$parcel$export(module.exports, "virtualTableScrollReporter", () => $26144cf68aa62b26$export$4378f1933287fdc8);

var $gZFbt = parcelRequire("gZFbt");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26144cf68aa62b26$var$aggregatedDataTimeout = {};
const $26144cf68aa62b26$export$4378f1933287fdc8 = (observationData)=>{
    if (!(0, $cJpFl.isExpandedObservationData)(observationData)) return;
    const startTime = observationData.events.map((event)=>event.timestamp);
    const analyticsData = {
        ...(0, $if7bx.generateLongTaskAnalyticsContinuousActionSummary)('virtualTableScroll', observationData.events),
        measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
    };
    const { appName: appName } = observationData;
    if ($26144cf68aa62b26$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`]) $26144cf68aa62b26$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`].data.push(analyticsData);
    else $26144cf68aa62b26$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`] = {
        data: [
            analyticsData
        ],
        extra: observationData.extra,
        timeout: setTimeout(()=>{
            const { data: data, extra: extraData } = $26144cf68aa62b26$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`];
            const triggerAppAnalytics = (0, $if7bx.triggerAnalytics)(`common.${appName}`);
            triggerAppAnalytics('long-tasks-virtual-table-scroll', {
                ...(0, $if7bx.getAverageResultsFromContinuousActions)('virtualTableScroll', data),
                ...extraData,
                avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, 'measureTimespan')
            });
            delete $26144cf68aa62b26$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`];
        }, 7000)
    };
};

});
parcelRegister("gZFbt", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $520Yb = parcelRequire("520Yb");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $c5f24a2590a3cbef$var$meanBy(array, iteratee) {
    return $520Yb(array, $bxDef(iteratee, 2));
}
module.exports = $c5f24a2590a3cbef$var$meanBy;

});
parcelRegister("520Yb", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");
/** Used as references for various `Number` constants. */ var $3a9de433504d679a$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $3a9de433504d679a$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
}
module.exports = $3a9de433504d679a$var$baseMean;

});
parcelRegister("gBzAF", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $c16bb58eedefe4cd$var$baseSum;

});



parcelRegister("if7bx", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $3a39af364070fc96$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $3a39af364070fc96$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $3a39af364070fc96$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $3a39af364070fc96$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $3a39af364070fc96$export$7e5f2df95eca342a);

var $gZFbt = parcelRequire("gZFbt");

var $iThRn = parcelRequire("iThRn");

var $6oxJH = parcelRequire("6oxJH");
const $3a39af364070fc96$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $3a39af364070fc96$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $3a39af364070fc96$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $3a39af364070fc96$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $3a39af364070fc96$export$c36fdc326d0c207c = (prefix, data)=>{
    // Do NOT inline this variable into its usage site below - it is here to mitigate an Atlaspack bug: https://product-fabric.atlassian.net/browse/AFB-1057 & https://atlassian.slack.com/archives/C0288U06PGC/p1736811949973719
    const avgLongTaskCountSum = (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterAvgLongTaskCount`);
    return {
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / avgLongTaskCountSum : 0,
        [`${prefix}Count`]: data.length
    };
};
const $3a39af364070fc96$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("iThRn", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $dc0b37ac120f9bb6$var$sum(array) {
    return array && array.length ? $gBzAF(array, $etyzk) : 0;
}
module.exports = $dc0b37ac120f9bb6$var$sum;

});

parcelRegister("6oxJH", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $gBzAF = parcelRequire("gBzAF");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $4a7f273a61dd10a7$var$sumBy(array, iteratee) {
    return array && array.length ? $gBzAF(array, $bxDef(iteratee, 2)) : 0;
}
module.exports = $4a7f273a61dd10a7$var$sumBy;

});



parcelRegister("jTfCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $634ef239e8e9209e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $gWU4i = parcelRequire("gWU4i");
class $634ef239e8e9209e$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            className: '',
            onScrollbarsRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onScrollFrame: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onScrollStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onScrollStop: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { className: className, onScrollbarsRef: onScrollbarsRef, onScrollFrame: onScrollFrame, onScrollStart: onScrollStart, onScrollStop: onScrollStop, children: children, height: height, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
        const extraProps = false && shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table') ? {
            renderView: this.renderView
        } : {};
        /* className is passed down to enable styled component composition */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gWU4i.StyledScrollbars), {
            style: {
                height: // eslint-disable-next-line jira/ff/no-preconditioning
                shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table') && typeof height === 'string' ? height : `${height}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: onScrollbarsRef,
            onScrollFrame: onScrollFrame,
            onScrollStart: onScrollStart,
            onScrollStop: onScrollStop,
            renderTrackVertical: this.renderVerticalTrack,
            renderThumbVertical: this.renderVerticalThumb,
            renderTrackHorizontal: this.renderHorizontalTrack,
            renderThumbHorizontal: this.renderHorizontalThumb,
            hideTracksWhenNotNeeded: true,
            ...extraProps
        }, children);
    }
    constructor(...args){
        super(...args), this.renderVerticalTrack = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "track-vertical"
            }), this.renderVerticalThumb = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "thumb-vertical"
            }), this.renderHorizontalTrack = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "track-horizontal"
            }), this.renderHorizontalThumb = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "thumb-horizontal"
            }), this.renderView = (props)=>{
            const finalProps = {
                ...props,
                style: {
                    ...props.style,
                    // this override is to only be used in false mode
                    // `react-custom-scrollbars` cannot calculate the width of scrollbars properly
                    // it's because typeof document !== 'undefined' there is false
                    // see https://github.com/malte-wessel/react-custom-scrollbars/blob/v4.2.1/src/utils/getScrollbarWidth.js#L7
                    marginRight: '-14px',
                    marginBottom: '-14px'
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", finalProps);
        };
    }
}

});



parcelRegister("eGBiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc46d56b07cb589e$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $4jOWP = parcelRequire("4jOWP");

var $et9he = parcelRequire("et9he");

var $aVHQs = parcelRequire("aVHQs");
var $bc46d56b07cb589e$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        coreColumnsWidth: (0, $bFTY1.getVisibleCoreColumnsWidth)(state),
        AddLink: $4jOWP.default,
        ScrollArea: $aVHQs.default
    }), {})((0, $et9he.default));

});
parcelRegister("4jOWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $841c38adc7ec0be7$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");


var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $6ISG2 = parcelRequire("6ISG2");
var $841c38adc7ec0be7$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>{
    const sortedRowIds = (0, $5J7ao.getSortedRowIdsHash)(state)[0, $ad3622039daefe23$export$59c500c4e33fdb0];
    return {
        addLinkCaption: (0, $3W7mX.getAddLinkCaption)(state),
        lastRowId: sortedRowIds && sortedRowIds[sortedRowIds.length - 1],
        isVisible: (0, $iN58L.isAddLinkShown)(state),
        onRowAddRequested: (0, $eeWa5.getRowAddCallback)(state),
        addBarOverflow: (0, $3W7mX.getAddBarOverflow)(state)
    };
}, {})((0, $6ISG2.default));

});
parcelRegister("6ISG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b90b7b3e707780ae$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $6iCoB = parcelRequire("6iCoB");

var $6hiB0 = parcelRequire("6hiB0");
const $b90b7b3e707780ae$var$wrapperBaseStyle = null;
const $b90b7b3e707780ae$var$Wrapper = ({ addBarOverflow: addBarOverflow, theme: theme, padding: padding, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            paddingRight: `${padding}px`,
            paddingTop: `${padding}px`,
            paddingBottom: `${padding}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingLeft: `${(0, $6hiB0.levelIndentBaseline)}px`,
            marginTop: `-${addBarOverflow + theme.row.borderWidth}px`
        },
        className: (0, $bwpsq.default)([
            "_otyru2gc"
        ])
    }, children);
// eslint-disable-next-line jira/react/no-class-components
class $b90b7b3e707780ae$var$AddLink extends (0, $5uXOq.PureComponent) {
    renderAddLink() {
        const { addLinkCaption: addLinkCaption, addBarOverflow: addBarOverflow, theme: theme } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b90b7b3e707780ae$var$Wrapper, {
            addBarOverflow: addBarOverflow,
            theme: theme,
            padding: (theme.row.defaultHeight - (0, $6hiB0.akButtonHeight)) / 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: this.onRowAddRequested,
            appearance: "subtle-link",
            testId: "virtual-table.table.content.utility-row.add-link.button"
        }, addLinkCaption));
    }
    render() {
        const { isVisible: isVisible } = this.props;
        return isVisible ? this.renderAddLink() : null;
    }
    constructor(...args){
        super(...args), this.onRowAddRequested = ()=>{
            const { lastRowId: lastRowId, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: lastRowId,
                position: lastRowId ? 'AFTER' : 'LAST'
            });
        };
    }
}
var $b90b7b3e707780ae$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($b90b7b3e707780ae$var$AddLink);

});


parcelRegister("et9he", function(module, exports) {

$parcel$export(module.exports, "default", () => $68dbc66a263fdd64$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
function $68dbc66a263fdd64$export$2e2bcd8739ae039(props) {
    const { coreColumnsWidth: coreColumnsWidth, AddLink: AddLink, ScrollArea: ScrollArea } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68dbc66a263fdd64$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68dbc66a263fdd64$var$CoreWidthPlaceholder, {
        width: coreColumnsWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddLink, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ScrollArea, null));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68dbc66a263fdd64$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $68dbc66a263fdd64$var$CoreWidthPlaceholder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1hdq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aVHQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37322bee6716bba$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $bYogn = parcelRequire("bYogn");

var $jvlqf = parcelRequire("jvlqf");
var $b37322bee6716bba$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        rowsHeight: (0, $iN58L.getTableRowsHeight)(state),
        contentHeight: (0, $iN58L.getTableContentHeight)(state),
        contentWidth: (0, $iN58L.getVisibleAdditionalColumnsWidth)(state),
        isAddLinkShown: (0, $iN58L.isAddLinkShown)(state),
        addBarOverflow: (0, $3W7mX.getAddBarOverflow)(state),
        AdditionalColumnsContainer: $bYogn.default
    }), {})((0, $jvlqf.default));

});
parcelRegister("jvlqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa335fad8e698da9$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6iCoB = parcelRequire("6iCoB");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa335fad8e698da9$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addBarOverflow: addBarOverflow, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`),
            "--_j34cc7": (0, $lD23V.default)(`-${__cmplp.addBarOverflow + __cmplp.theme.row.borderWidth}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4t3i2nrh _19pk1w53 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $fa335fad8e698da9$var$FakeContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`),
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1hdq _4t3i2nrh",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $fa335fad8e698da9$var$ScrollArea extends (0, $5uXOq.PureComponent) {
    getAreaHeight() {
        const { rowsHeight: rowsHeight, contentHeight: contentHeight, isAddLinkShown: isAddLinkShown, theme: theme } = this.props;
        // we are reducing Scrollbar height in src/common/components/virtual-table/view/table/content/scrollbars/vertical
        // /index-dumb.js to accommodate stuff below table within the viewport.
        // Utility Row takes whatever height is left below rowList on the viewport hence need to reduce it here as well
        // else it is introducing vertical scroll even if we do not have enough rows to scroll.
        const spareContentSpace = contentHeight - rowsHeight - (theme.scrollbar.offset - theme.scrollbar.paddingTop);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { defaultHeight: defaultHeight } = theme.row;
        const addLinkSpace = isAddLinkShown ? defaultHeight : 0;
        return spareContentSpace > 0 ? spareContentSpace : addLinkSpace;
    }
    render() {
        const { contentWidth: contentWidth, AdditionalColumnsContainer: AdditionalColumnsContainer, addBarOverflow: addBarOverflow, theme: theme } = this.props;
        const areaHeight = this.getAreaHeight();
        // there is either
        // 1) no space required to be filled, or the add link is not visible
        // 2) no visible additional rows/details panel is open (as derived by no content width)
        if (areaHeight === 0 || contentWidth === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa335fad8e698da9$var$Wrapper, {
            height: areaHeight,
            addBarOverflow: addBarOverflow,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdditionalColumnsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa335fad8e698da9$var$FakeContent, {
            width: contentWidth,
            height: areaHeight
        })));
    }
}
var $fa335fad8e698da9$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($fa335fad8e698da9$var$ScrollArea);

});





parcelRegister("7nAiS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2239ae72bb8f04$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $eir10 = parcelRequire("eir10");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $bYogn = parcelRequire("bYogn");

var $7A65G = parcelRequire("7A65G");

var $6LgIZ = parcelRequire("6LgIZ");

var $dXBPt = parcelRequire("dXBPt");
var $2d2239ae72bb8f04$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        coreColumnIds: (0, $bFTY1.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $eeWa5.getVisibleAdditionalColumnIds)(state),
        isColumnConfigurationVisible: (0, $eeWa5.isColumnConfigurationVisible)(state),
        hasVerticallyScrolled: (0, $5J7ao.hasVerticallyScrolled)(state),
        tableHasLeftShadow: (0, $iN58L.isHorizontalScrollLeftShadowVisible)(state),
        tableHasRightShadow: (0, $iN58L.isHorizontalScrollRightShadowVisible)(state),
        bottomShadowWidth: (0, $5J7ao.getTableWidthWithoutScrollbarOffset)(state),
        isAutoRowHeight: (0, $3W7mX.isAutoRowHeight)(state),
        AdditionalColumnsContainer: $bYogn.default,
        Column: $6LgIZ.default,
        ColumnConfiguration: $7A65G.default
    }), {
    setHeaderHeight: $eir10.set
})((0, $dXBPt.default));

});
parcelRegister("eir10", function(module, exports) {

$parcel$export(module.exports, "SET_HEADER_HEIGHT", () => $ce7103d12a1489a0$export$e52e6a4be99a8322);
$parcel$export(module.exports, "set", () => $ce7103d12a1489a0$export$adaa4cf7ef1b65be);
const $ce7103d12a1489a0$export$e52e6a4be99a8322 = 'ops.header.size.SET_HEADER_HEIGHT';
const $ce7103d12a1489a0$export$adaa4cf7ef1b65be = (height)=>({
        type: $ce7103d12a1489a0$export$e52e6a4be99a8322,
        payload: height
    });

});

parcelRegister("7A65G", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bb6cac65e7fdad1$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $5J7ao = parcelRequire("5J7ao");

var $4t567 = parcelRequire("4t567");
var $9bb6cac65e7fdad1$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        columnConfiguration: (0, $bFTY1.getColumnConfiguration)(state),
        headerHeight: (0, $5J7ao.getHeaderHeight)(state),
        onChangeHiddenColumnsRequested: (0, $eeWa5.getChangeHiddenColumnsCallback)(state)
    }), {})((0, $4t567.default));

});
parcelRegister("4t567", function(module, exports) {

$parcel$export(module.exports, "default", () => $b241dc5ca65cf330$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $k2tiP = parcelRequire("k2tiP");

var $7VHMR = parcelRequire("7VHMR");
var $8RXs9 = parcelRequire("8RXs9");

var $7Q7Qi = parcelRequire("7Q7Qi");
const $b241dc5ca65cf330$var$messages = (0, $7VHMR.defineMessages)({
    configureIcon: {
        "id": "virtual-table.table.header.column-configuration.configure-icon",
        "defaultMessage": "Click to expand column configuration"
    }
});
function $b241dc5ca65cf330$export$7b06a271790152c(props) {
    const { intl: { formatMessage: formatMessage }, columnConfiguration: columnConfiguration, headerHeight: headerHeight, onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b241dc5ca65cf330$var$ConfigWrapper, {
        headerHeight: headerHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...propsTrigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...propsTrigger,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
                    spacing: "spacious",
                    label: formatMessage($b241dc5ca65cf330$var$messages.configureIcon)
                }),
                appearance: "subtle",
                ref: triggerRef
            }),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Q7Qi.default), {
        columnConfiguration: columnConfiguration,
        onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested
    })));
}
var $b241dc5ca65cf330$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($b241dc5ca65cf330$export$7b06a271790152c);
const $b241dc5ca65cf330$var$ConfigWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { headerHeight: headerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3ioxf9": (0, $lD23V.default)(`${__cmplp.headerHeight}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1xi2idpf _4t3i5h89 _bfhku67f",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7Q7Qi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6814a6da833187b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $27NS3 = parcelRequire("27NS3");

var $dDkmN = parcelRequire("dDkmN");

var $hqTkp = parcelRequire("hqTkp");

var $kWow2 = parcelRequire("kWow2");

var $8mDeU = parcelRequire("8mDeU");

var $cc5sk = parcelRequire("cc5sk");
class $f6814a6da833187b$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    onSelect() {
        const { columnConfiguration: columnConfiguration, onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested } = this.props;
        if (onChangeHiddenColumnsRequested === undefined) return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
        const allHiddenColumns = (0, $cc5sk.getAllHiddenColumns)(columnConfiguration);
        const columnsMap = (0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(columnConfiguration, (hash, item)=>({
                ...hash,
                [item.id]: {
                    isHidden: item.isHidden,
                    hiddenParentColumns: (0, $cc5sk.getHiddenParentColumns)(item, columnConfiguration)
                }
            }), {});
        return (item)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const column = columnsMap[item.id];
            if (column.isHidden) {
                // show
                const columnsToShow = (0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))([
                    item.id
                ], column.hiddenParentColumns);
                onChangeHiddenColumnsRequested((0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(allHiddenColumns, ...columnsToShow));
            } else // hide
            onChangeHiddenColumnsRequested((0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))(allHiddenColumns, [
                item.id
            ]));
        };
    }
    transformColumnsToItems() {
        const { columnConfiguration: columnConfiguration } = this.props;
        const items = columnConfiguration.map((column)=>{
            const hiddenParentColumns = (0, $cc5sk.getHiddenParentColumns)(column, columnConfiguration);
            return {
                id: column.id,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8mDeU.default), {
                    key: column.id,
                    depth: column.depth,
                    title: column.title,
                    color: (0, $cc5sk.determineItemColor)(column, hiddenParentColumns),
                    isDisabled: column.isDisabled,
                    isChecked: !column.isHidden
                }),
                isDisabled: column.isDisabled
            };
        });
        return [
            {
                items: items
            }
        ];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kWow2.default), {
            items: this.transformColumnsToItems(),
            onSelect: this.onSelect()
        });
    }
}

});
parcelRegister("dDkmN", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $g7i7g = parcelRequire("g7i7g");

var $7CoLY = parcelRequire("7CoLY");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $9eceb74c74389aa2$var$union = $g7i7g(function(arrays) {
    return $7CoLY($ekcP3(arrays, 1, $f3SOL, true));
});
module.exports = $9eceb74c74389aa2$var$union;

});

parcelRegister("kWow2", function(module, exports) {

$parcel$export(module.exports, "default", () => $140a58d0c5a075d4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7uUwQ = parcelRequire("7uUwQ");

var $lFKmC = parcelRequire("lFKmC");

var $iKhOS = parcelRequire("iKhOS");

var $fW7cr = parcelRequire("fW7cr");

var $apUNl = parcelRequire("apUNl");

var $8Rkzz = parcelRequire("8Rkzz");

var $fW62l = parcelRequire("fW62l");

var $7Jxgt = parcelRequire("7Jxgt");

var $imOeZ = parcelRequire("imOeZ");

var $9Scmv = parcelRequire("9Scmv");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $140a58d0c5a075d4$var$Explanation = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _syaznsd6 _ca0qu2gc _u5f3utpp _n3tdidpf _19bvutpp",
            __cmplp.className
        ])
    });
});
const $140a58d0c5a075d4$var$ListWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxHeight: maxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1upm8ip": (0, $lD23V.default)(__cmplp.maxHeight, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18m91wug",
            __cmplp.maxHeight && "_c71l1w9o",
            __cmplp.className
        ])
    });
});
const $140a58d0c5a075d4$var$Menu = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1bsbko4j",
            __cmplp.className
        ])
    });
});
const $140a58d0c5a075d4$var$canSelect = ({ type: type })=>type !== (0, $imOeZ.itemTypes).HEADING;
// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $140a58d0c5a075d4$var$getItemKey = (keyMap, item)=>{
    if (keyMap.has(item)) return keyMap.get(item);
    const newKey = (0, $7Jxgt.v4)();
    keyMap.set(item, newKey);
    return newKey;
};
// eslint-disable-next-line jira/react/no-class-components
class $140a58d0c5a075d4$var$MultiSelectList extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            items: [],
            type: (0, $imOeZ.itemTypes).DEFAULT,
            explanation: undefined,
            maxHeight: undefined,
            canSelectBySpaceKey: true,
            onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            autoFocus: true
        };
    }
    constructor(props){
        super(props), this.onKeydown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('down'):
                    this.navigateFocus({
                        isPrev: false
                    });
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('up'):
                    this.navigateFocus({
                        isPrev: true
                    });
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter'):
                    this.triggerOnSelect();
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space'):
                    /* Searchable lists need the space key for typing in the input */ if (!this.props.canSelectBySpaceKey) return;
                    this.triggerOnSelect();
                    break;
                default:
                    return;
            }
            event.stopPropagation();
            event.preventDefault();
        }, this.navigateFocus = ({ isPrev: isPrev })=>{
            const { lastFocusedIndex: lastFocusedIndex, state: { items: items } } = this;
            let nextFocusIndex;
            if (lastFocusedIndex === undefined || lastFocusedIndex >= items.length) nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(items, $140a58d0c5a075d4$var$canSelect);
            else if (isPrev) nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($apUNl)))(items, $140a58d0c5a075d4$var$canSelect, Math.max(lastFocusedIndex - 1, 0));
            else nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(items, $140a58d0c5a075d4$var$canSelect, lastFocusedIndex + 1);
            if (nextFocusIndex !== -1) {
                this.updateFocus(nextFocusIndex);
                // disable mouse move handler when use keyboard navigation
                this.shouldBypassMouseMove();
            }
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.navigateFocusTo = (nextFocusIndex, child)=>{
            if (!this.bypassMouseMove && $140a58d0c5a075d4$var$canSelect(child)) this.updateFocus(nextFocusIndex);
        }, // should not enable mouse move focus if user keeping navigate by keyboard
        this.shouldNotByPassMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.bypassMouseMove = false;
        }, 300), /*
         when select changes potentially cause re-render,
         re-render will cause click event pass through the list and flyout close.
     */ this.triggerOnSelect = (0, (/*@__PURE__*/$parcel$interopDefault($iKhOS))).bind(this, ()=>{
            if (this.lastFocusedIndex !== undefined) this.props.onSelect(this.state.items[this.lastFocusedIndex].origin);
        });
        this.state = {
            items: []
        };
        this.keyMap = new WeakMap();
    }
    UNSAFE_componentWillMount() {
        this.transformItems(this.props);
    }
    componentDidMount() {
        const { autoFocus: autoFocus } = this.props;
        autoFocus && this.focus();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.items !== this.props.items || nextProps.type !== this.props.type) this.transformItems(nextProps);
    }
    focus() {
        this.menu && this.menu.focus();
    }
    transformItems(props) {
        const { items: items, type: type } = props;
        const { navigateFocusTo: navigateFocusTo, triggerOnSelect: triggerOnSelect } = this;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const transformedItems = items.reduce((retVal, item)=>{
            const heading = item.heading && {
                ...item.heading,
                type: (0, $imOeZ.itemTypes).HEADING,
                origin: item.heading
            };
            // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'number' and 'boolean'.
            const index = retVal.length + !!heading;
            const children = item.items.map((child, i)=>({
                    ...child,
                    isFocused: false,
                    onHover: navigateFocusTo.bind(this, i + index, child),
                    onSelect: triggerOnSelect,
                    type: type,
                    origin: child
                }));
            if (heading) // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return [
                ...retVal,
                heading,
                ...children
            ];
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return [
                ...retVal,
                ...children
            ];
        }, []);
        this.setState({
            items: transformedItems
        }, ()=>{
            const { lastFocusedIndex: lastFocusedIndex } = this;
            if (lastFocusedIndex !== undefined && transformedItems[lastFocusedIndex] && $140a58d0c5a075d4$var$canSelect(transformedItems[lastFocusedIndex])) // refocus
            this.updateFocus(lastFocusedIndex);
            else {
                // focus first selectable item
                this.lastFocusedIndex = undefined;
                this.navigateFocus({
                    isPrev: false
                });
            }
        });
    }
    shouldBypassMouseMove() {
        this.bypassMouseMove = true;
        this.shouldNotByPassMouseMove();
    }
    updateFocus(nextFocusIndex) {
        const { state: { items: items } } = this;
        if (!items[nextFocusIndex].isFocused) {
            this.lastFocusedIndex = nextFocusIndex;
            this.setState({
                items: items.map((item, index)=>(0, $7uUwQ.set)(item, 'isFocused', index === nextFocusIndex))
            }, ()=>{
                if (this.list) {
                    const focusedItem = this.list.children[nextFocusIndex];
                    const { offsetHeight: offsetHeight, scrollTop: scrollTop, offsetTop: offsetTop } = this.list;
                    const maxVisibleHeight = offsetHeight + scrollTop;
                    // @ts-expect-error - TS2339 - Property 'offsetTop' does not exist on type 'Element'.
                    const itemTop = focusedItem.offsetTop - offsetTop;
                    // @ts-expect-error - TS2339 - Property 'offsetHeight' does not exist on type 'Element'.
                    const itemBottom = focusedItem.offsetHeight + itemTop;
                    if (itemTop < scrollTop) // item is hide in the top
                    this.list.scrollTop = itemTop;
                    else if (maxVisibleHeight < itemBottom) // item is hide in the bottom
                    this.list.scrollTop = itemBottom - offsetHeight;
                }
            });
        }
    }
    renderContent() {
        const { explanation: explanation } = this.props;
        const { keyMap: keyMap, state: { items: items } } = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($140a58d0c5a075d4$var$ListWrapper, {
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            maxHeight: this.props.maxHeight,
            ref: (el)=>{
                this.list = el;
            }
        }, items.map(({ origin: origin, ...itemProps })=>// @ts-expect-error HOC + injectIntl + defaultProps don't work well together. Please migrate to functional components
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Scmv.default), {
                key: $140a58d0c5a075d4$var$getItemKey(keyMap, origin),
                ...itemProps
            }))), explanation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($140a58d0c5a075d4$var$Explanation, null, explanation));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($140a58d0c5a075d4$var$Menu, {
            ref: (el)=>{
                this.menu = el;
            },
            tabIndex: -1,
            onKeyDown: this.onKeydown,
            role: "menu",
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": "virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.menu"
        }, this.renderContent());
    }
}
var $140a58d0c5a075d4$export$2e2bcd8739ae039 = $140a58d0c5a075d4$var$MultiSelectList;

});
parcelRegister("iKhOS", function(module, exports) {

var $1gef8 = parcelRequire("1gef8");

var $g7i7g = parcelRequire("g7i7g");
/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */ var $da5a5877d5d6860c$var$defer = $g7i7g(function(func, args) {
    return $1gef8(func, 1, args);
});
module.exports = $da5a5877d5d6860c$var$defer;

});
parcelRegister("1gef8", function(module, exports) {
/** Error message constants. */ var $0eb25573bf32f124$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */ function $0eb25573bf32f124$var$baseDelay(func, wait, args) {
    if (typeof func != 'function') throw new TypeError($0eb25573bf32f124$var$FUNC_ERROR_TEXT);
    return setTimeout(function() {
        func.apply(undefined, args);
    }, wait);
}
module.exports = $0eb25573bf32f124$var$baseDelay;

});


parcelRegister("apUNl", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $kPZpS(fromIndex);
        index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
    }
    return $b5dwA(array, $bxDef(predicate, 3), index, true);
}
module.exports = $79584b713e0c6354$var$findLastIndex;

});

parcelRegister("imOeZ", function(module, exports) {

$parcel$export(module.exports, "itemTypes", () => $67a5d1aff349b3d8$export$d02ea220375e4aff);
const $67a5d1aff349b3d8$export$d02ea220375e4aff = {
    HEADING: 'HEADING',
    RADIO: 'RADIO',
    CHECKBOX: 'CHECKBOX',
    DEFAULT: 'DEFAULT'
};

});

parcelRegister("9Scmv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7381a1a7e748ecc7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $h5w7R = parcelRequire("h5w7R");

var $ky7e4 = parcelRequire("ky7e4");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $7VHMR = parcelRequire("7VHMR");
var $8RXs9 = parcelRequire("8RXs9");

var $imOeZ = parcelRequire("imOeZ");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7381a1a7e748ecc7$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldIndent: shouldIndent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _1bsb1osq _vchh131l",
            __cmplp.shouldIndent ? "_19bv1tcg" : "_19bvidpf",
            __cmplp.className
        ])
    });
});
const $7381a1a7e748ecc7$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _4t3i7vkz _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $7381a1a7e748ecc7$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $7381a1a7e748ecc7$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $7381a1a7e748ecc7$var$avatarSize = `${(0, $gwIPs.gridSize) * 2}px`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7381a1a7e748ecc7$var$Avatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gqeyu4": (0, $lD23V.default)($7381a1a7e748ecc7$var$avatarSize)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1o9zidpf _1bsbq5n1 _4t3iq5n1 _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $7381a1a7e748ecc7$var$CheckIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefaultSelected: isDefaultSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _4t3i7vkz _1bsb1tcg",
            __cmplp.isDefaultSelected ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7381a1a7e748ecc7$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasDivider: hasDivider, appearance: appearance, isDisabled: isDisabled, isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8y8c": (0, $lD23V.default)(__cmplp.appearance.color || // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.type === (0, $imOeZ.itemTypes).HEADING ? "var(--ds-text-subtle, #44546F)" : undefined))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_uiztglyw _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _syazvvkc",
            __cmplp.hasDivider && "_n7zlzgxb",
            __cmplp.type === (0, $imOeZ.itemTypes).HEADING && "_11c8qk37",
            __cmplp.isDisabled ? "_80om13gf" : __cmplp.type === (0, $imOeZ.itemTypes).HEADING && "_80omtlke",
            __cmplp.isFocused && "_bfhk1hxd",
            __cmplp.className
        ])
    });
});
const $7381a1a7e748ecc7$var$shouldShowSelect = (type)=>[
        (0, $imOeZ.itemTypes).CHECKBOX,
        (0, $imOeZ.itemTypes).RADIO
    ].indexOf(type) !== -1;
const $7381a1a7e748ecc7$var$messages = (0, $7VHMR.defineMessages)({
    selected: {
        "id": "virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.item.selected",
        "defaultMessage": "Item selected"
    }
});
const $7381a1a7e748ecc7$var$getAriaRole = (type)=>{
    if (type === (0, $imOeZ.itemTypes).CHECKBOX) return 'menuitemcheckbox';
    if (type === (0, $imOeZ.itemTypes).RADIO) return 'menuitemradio';
    return 'menuitem';
};
const $7381a1a7e748ecc7$var$getAriaChecked = (isSelected, isDefaultSelected)=>isSelected || isDefaultSelected ? 'true' : 'false';
const $7381a1a7e748ecc7$var$getAriaProps = (type, isSelected, isDefaultSelected)=>({
        role: $7381a1a7e748ecc7$var$getAriaRole(type),
        tabIndex: 0,
        ...$7381a1a7e748ecc7$var$shouldShowSelect(type) && {
            'aria-checked': $7381a1a7e748ecc7$var$getAriaChecked(isSelected, isDefaultSelected)
        }
    });
class $7381a1a7e748ecc7$export$1c8ae823384d605f extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            type: (0, $imOeZ.itemTypes).DEFAULT,
            description: undefined,
            lozenge: undefined,
            avatarUrl: undefined,
            appearance: {},
            isFocused: false,
            isSelected: false,
            isDefaultSelected: false,
            isDisabled: false,
            hasDivider: false,
            onHover: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    renderContent() {
        const { avatarUrl: avatarUrl, content: content, lozenge: lozenge, type: type } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7381a1a7e748ecc7$var$Content, null, $7381a1a7e748ecc7$var$shouldShowSelect(type) && this.renderSelect(), avatarUrl && ((0, $4R6GH.fg)('jsm_queue_a11y_improvement') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7381a1a7e748ecc7$var$Avatar, {
            src: avatarUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7381a1a7e748ecc7$var$Avatar, {
            src: avatarUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7381a1a7e748ecc7$var$Title, null, content), lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7381a1a7e748ecc7$var$LozengeWrapper, null, lozenge));
    }
    renderSelect() {
        const { type: type, isSelected: isSelected, isDefaultSelected: isDefaultSelected, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7381a1a7e748ecc7$var$CheckIconWrapper, {
            isDefaultSelected: isDefaultSelected
        }, (isSelected || isDefaultSelected) && (type === (0, $imOeZ.itemTypes).CHECKBOX ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            LEGACY_size: "small",
            label: formatMessage($7381a1a7e748ecc7$var$messages.selected)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h5w7R))), {
            color: "currentColor",
            label: formatMessage($7381a1a7e748ecc7$var$messages.selected)
        })));
    }
    renderDescription() {
        const { avatarUrl: avatarUrl, description: description, type: type } = this.props;
        // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'boolean' and 'boolean'.
        const shouldIndent = $7381a1a7e748ecc7$var$shouldShowSelect(type) + !!avatarUrl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7381a1a7e748ecc7$var$Description, {
            shouldIndent: shouldIndent
        }, description);
    }
    render() {
        const { appearance: appearance, description: description, hasDivider: hasDivider, onHover: onHover, isFocused: isFocused, isDisabled: isDisabled, type: type, id: id, isSelected: isSelected, isDefaultSelected: isDefaultSelected } = this.props;
        const ariaProps = (0, $4R6GH.fg)('jsm_queue_a11y_improvement') ? $7381a1a7e748ecc7$var$getAriaProps(type, isSelected, isDefaultSelected) : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7381a1a7e748ecc7$var$Wrapper, {
            ...(0, $4R6GH.fg)('jsm_queue_a11y_improvement') && ariaProps,
            type: type,
            onClick: this.onClick,
            isFocused: isFocused,
            isDisabled: isDisabled,
            onMouseMove: onHover,
            hasDivider: hasDivider,
            appearance: appearance,
            "data-testid": `common.components.virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.item.wrapper-${id}`
        }, this.renderContent(), description && this.renderDescription());
    }
    constructor(...args){
        super(...args), this.onClick = ()=>{
            const { isDisabled: isDisabled, onSelect: onSelect } = this.props;
            if (!isDisabled) onSelect();
        };
    }
}
var $7381a1a7e748ecc7$export$2e2bcd8739ae039 = (0, $8RXs9.default)($7381a1a7e748ecc7$export$1c8ae823384d605f);

});
parcelRegister("h5w7R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5ab1d40b7acbecb61e781f9a3cd3771a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c70bd2cddee90d52$var$_react = $c70bd2cddee90d52$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c70bd2cddee90d52$var$_baseNew = $c70bd2cddee90d52$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c70bd2cddee90d52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Node".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a non-expandable item in a page tree.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c70bd2cddee90d52$var$NodeIcon = (props)=>/*#__PURE__*/ $c70bd2cddee90d52$var$_react.default.createElement($c70bd2cddee90d52$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<circle cx="8" cy="8" r="2" fill="currentcolor"/>`
    }, props));
$c70bd2cddee90d52$var$NodeIcon.displayName = 'NodeIcon';
var $c70bd2cddee90d52$var$_default = module.exports.default = $c70bd2cddee90d52$var$NodeIcon;

});

parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::960f6ce03e4c8754204f0c1f72e1b16b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6349e25a79f10f7ca6cae195737423f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});




parcelRegister("8mDeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $580b5095306452cf$export$2e2bcd8739ae039);
/* item.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5vD8v = parcelRequire("5vD8v");

var $ky7e4 = parcelRequire("ky7e4");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $580b5095306452cf$var$ItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { depth: depth, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color),
            "--_13d8cnv": (0, $lD23V.default)(`${__cmplp.depth * 20}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _syaz1cj8 _18u01cdh _o5721q9c _1bto1l2s",
            __cmplp.isDisabled && "_80om13gf",
            __cmplp.className
        ])
    });
});
const $580b5095306452cf$var$WidthPlaceholder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbpxbi _2hwxu2gc",
            __cmplp.className
        ])
    });
});
class $580b5095306452cf$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    renderCheckOrPlaceholder() {
        const { isChecked: isChecked } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($580b5095306452cf$var$WidthPlaceholder, null, isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            LEGACY_size: "small",
            label: ""
        }));
    }
    renderTitle() {
        const { title: title } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5vD8v)))(title)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return title;
        const Title = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Title, null);
    }
    render() {
        const { depth: depth, color: color, isDisabled: isDisabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($580b5095306452cf$var$ItemWrapper, {
            depth: depth,
            color: color,
            isDisabled: isDisabled
        }, this.renderCheckOrPlaceholder(), this.renderTitle());
    }
}

});

parcelRegister("cc5sk", function(module, exports) {

$parcel$export(module.exports, "getHiddenParentColumns", () => $7e87bd864b310e4c$export$1eb020b7a0c2885a);
$parcel$export(module.exports, "getAllHiddenColumns", () => $7e87bd864b310e4c$export$be8e94436c3182a9);
$parcel$export(module.exports, "determineItemColor", () => $7e87bd864b310e4c$export$d24b05f5766e3698);

var $1sWm7 = parcelRequire("1sWm7");

var $gccSB = parcelRequire("gccSB");

var $27NS3 = parcelRequire("27NS3");

var $dDkmN = parcelRequire("dDkmN");

const $7e87bd864b310e4c$export$1eb020b7a0c2885a = (column, columnConfiguration)=>{
    if (!column.parentId) return [];
    // @ts-expect-error - TS2322 - Type 'ColumnConfiguration | undefined' is not assignable to type 'ColumnConfiguration'.
    const columnParent = (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(columnConfiguration, (configItem)=>configItem.id === column.parentId);
    const addToList = columnParent.isHidden ? [
        columnParent.id
    ] : [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))(addToList, $7e87bd864b310e4c$export$1eb020b7a0c2885a(columnParent, columnConfiguration));
};
const $7e87bd864b310e4c$export$be8e94436c3182a9 = (columnConfigurations)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(columnConfigurations, // @ts-expect-error - TS2769 - No overload matches this call.
    (list, columnConfig)=>{
        if (columnConfig.isHidden) return [
            ...list,
            columnConfig.id
        ];
        return list;
    }, []);
const $7e87bd864b310e4c$export$d24b05f5766e3698 = (column, hiddenParentColumns)=>{
    const { depth: depth, isHidden: isHidden, isDisabled: isDisabled } = column;
    const isActiveChild = depth > 0 && !isHidden;
    const hasInactiveParent = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(hiddenParentColumns);
    return isActiveChild && hasInactiveParent || isDisabled ? (0, $829f609a65d26a98$exports).N80 : 'inherit';
};

});




parcelRegister("6LgIZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7395d3562382e8f0$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $8G1Cn = parcelRequire("8G1Cn");

var $7JYB3 = parcelRequire("7JYB3");
var $7395d3562382e8f0$export$2e2bcd8739ae039 = (0, $1kDks.connect)(()=>({
        DynamicColumnComponent: $8G1Cn.default
    }), {})((0, $7JYB3.default));

});
parcelRegister("8G1Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bd3264311a4d268$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dh0WJ = parcelRequire("dh0WJ");
function $7bd3264311a4d268$export$2e2bcd8739ae039(props) {
    const { id: id } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dh0WJ.default), {
        id: id
    });
}

});
parcelRegister("dh0WJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6c2f6f8b7225fb$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $ZsJ1R = parcelRequire("ZsJ1R");

var $3ZJVS = parcelRequire("3ZJVS");
var $2e6c2f6f8b7225fb$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { id: id })=>({
        width: (0, $iN58L.getColumnWidth)(state, id),
        column: (0, $4R6GH.fg)('css_support_for_virtual_table') ? (0, $iN58L.getColumn)(state, id) : undefined,
        isFirstColumn: (0, $bFTY1.isFirstColumn)(state, id),
        DefaultColumn: $ZsJ1R.default,
        shouldUseCssForRendering: (0, $5J7ao.getShouldUseCssForRendering)(state)
    }), {})((0, $3ZJVS.default));

});
parcelRegister("ZsJ1R", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ebca22e4104308$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $WGH7J = parcelRequire("WGH7J");

var $jLgvT = parcelRequire("jLgvT");
var $35ebca22e4104308$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { id: id })=>({
        title: (0, $bFTY1.getColumnTitle)(state, id),
        HeaderComponent: (0, $bFTY1.getColumnHeaderComponent)(state, id),
        tooltip: (0, $bFTY1.getColumnTooltip)(state, id),
        isChild: (0, $bFTY1.isChildColumn)(state, id),
        isParent: (0, $bFTY1.isParentColumn)(state, id),
        parentId: (0, $bFTY1.getParentId)(state, id),
        Column: $WGH7J.default
    }), {})((0, $jLgvT.default));

});
parcelRegister("WGH7J", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed299c167b6ad67$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $6wRRF = parcelRequire("6wRRF");

var $eoaFV = parcelRequire("eoaFV");

var $304mZ = parcelRequire("304mZ");

var $ieC6z = parcelRequire("ieC6z");
var $8ed299c167b6ad67$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, props)=>({
        ChildBar: $6wRRF.default,
        ColumnChildOperationIndicator: $eoaFV.default,
        ColumnSortOperationIndicator: $304mZ.default,
        isCoreColumn: (0, $bFTY1.isVisibleCoreColumn)(state, props.id)
    }), {})((0, $ieC6z.default));

});
parcelRegister("6wRRF", function(module, exports) {

$parcel$export(module.exports, "default", () => $20d7063b44b90dd6$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $eF8jw = parcelRequire("eF8jw");
var $20d7063b44b90dd6$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { columnId: columnId })=>({
        backgroundColor: (0, $bFTY1.getColumnColor)(state, columnId)
    }), {})((0, $eF8jw.default));

});
parcelRegister("eF8jw", function(module, exports) {

$parcel$export(module.exports, "default", () => $db868ac13cd7a21c$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
function $db868ac13cd7a21c$export$2e2bcd8739ae039(props) {
    const { backgroundColor: backgroundColor } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db868ac13cd7a21c$var$BarBackground, {
        backgroundColor: backgroundColor
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db868ac13cd7a21c$var$BarBackground = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1xi2idpf _1ltvidpf _4t3iyh40 _bfhk3qkl _tzy41v3n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eoaFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $81442008e1dd497f$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $5Yxrq = parcelRequire("5Yxrq");
var $81442008e1dd497f$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { columnId: columnId })=>({
        isParentColumn: (0, $bFTY1.isParentColumn)(state, columnId),
        isColumnExpanded: (0, $bFTY1.isColumnExpanded)(state, columnId),
        columnHasChildren: (0, $bFTY1.getColumnHasChildren)(state, columnId),
        color: (0, $bFTY1.getColumnColor)(state, columnId),
        onColumnExpansionChangeRequested: (0, $eeWa5.getColumnExpandCallback)(state)
    }), {})((0, $5Yxrq.default));

});
parcelRegister("5Yxrq", function(module, exports) {

$parcel$export(module.exports, "default", () => $24df795ec12121a9$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ifxZA = parcelRequire("ifxZA");

var $lEFW3 = parcelRequire("lEFW3");

var $aUwOa = parcelRequire("aUwOa");
const $24df795ec12121a9$export$fd2a14967cd13576 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbutpp _2hwx12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $24df795ec12121a9$export$ff0bdaf3b6126558 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { columnHasChildren: columnHasChildren, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbutpp _4t3iutpp _kqswh2mm _tzy41v3n _16l4kb7n",
            __cmplp.columnHasChildren ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $24df795ec12121a9$export$53c3957bbb0bab2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf _bfhk1cj8",
            __cmplp.className
        ])
    });
});
const $24df795ec12121a9$export$b6be64795e38ec8c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
const $24df795ec12121a9$export$bebc7a423c9a9514 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $24df795ec12121a9$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_euc18": (0, $lD23V.default)((0, (/*@__PURE__*/$parcel$interopDefault($lEFW3))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1itknvb0",
            __cmplp.className
        ])
    });
});
const $24df795ec12121a9$export$169f51fb2902d283 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $24df795ec12121a9$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1oumqk1": (0, $lD23V.default)((0, (/*@__PURE__*/$parcel$interopDefault($aUwOa))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1itk1oyw",
            __cmplp.className
        ])
    });
});
const $24df795ec12121a9$export$6cdf59eef5a3aef5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $24df795ec12121a9$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1fpc7jq": (0, $lD23V.default)((0, (/*@__PURE__*/$parcel$interopDefault($ifxZA))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1itkplyw",
            __cmplp.className
        ])
    });
});
class $24df795ec12121a9$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            columnHasChildren: undefined
        };
    }
    renderExpansionIndicator() {
        const { columnHasChildren: columnHasChildren, isColumnExpanded: isColumnExpanded } = this.props;
        if (columnHasChildren === true) {
            if (isColumnExpanded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24df795ec12121a9$export$6cdf59eef5a3aef5, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24df795ec12121a9$export$169f51fb2902d283, null);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24df795ec12121a9$export$bebc7a423c9a9514, null);
    }
    renderExpansionIndicatorContainer() {
        const { color: color, columnHasChildren: columnHasChildren } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24df795ec12121a9$export$ff0bdaf3b6126558, {
            onClick: this.onColumnExpanded,
            columnHasChildren: columnHasChildren,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && this.onColumnExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24df795ec12121a9$export$53c3957bbb0bab2, {
            color: color
        }), this.renderExpansionIndicator());
    }
    render() {
        return this.props.isParentColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24df795ec12121a9$export$fd2a14967cd13576, null, this.renderExpansionIndicatorContainer());
    }
    constructor(...args){
        super(...args), this.onColumnExpanded = ()=>{
            const { columnId: columnId, isColumnExpanded: isColumnExpanded, columnHasChildren: columnHasChildren, onColumnExpansionChangeRequested: onColumnExpansionChangeRequested } = this.props;
            // neutral indicators should not be actionable
            if (columnHasChildren === true) onColumnExpansionChangeRequested({
                columnId: columnId,
                shouldExpand: !isColumnExpanded
            });
        };
    }
}

});
parcelRegister("ifxZA", function(module, exports) {
module.exports = new URL("minus-mask.a30c8bf5.svg", import.meta.url).toString();

});

parcelRegister("lEFW3", function(module, exports) {
module.exports = new URL("neutral-mask.7cced194.svg", import.meta.url).toString();

});

parcelRegister("aUwOa", function(module, exports) {
module.exports = new URL("plus-mask.26076cf9.svg", import.meta.url).toString();

});



parcelRegister("304mZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3080d24cade394a8$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $7KdZ6 = parcelRequire("7KdZ6");

var $dRlnz = parcelRequire("dRlnz");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $gMfJt = parcelRequire("gMfJt");
var $3080d24cade394a8$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, { columnId: columnId })=>({
        sortOrder: (0, $iN58L.getColumnSortOrder)(state, columnId),
        isColumnSortable: (0, $bFTY1.isColumnSortable)(state, columnId),
        isSortEnabled: !(0, $3W7mX.isAnyRowBeingAdded)(state),
        isDefaultSortColumn: (0, $bFTY1.getDefaultComparator)(state) === columnId,
        onClearAddedRowsRequested: (0, $eeWa5.getClearAddedRowsCallback)(state),
        onSortedColumnChanged: (0, $eeWa5.getSortedColumnChangedCallback)(state)
    }), {
    setColumnSortOrder: (0, $dRlnz.set),
    clearColumnSortOrder: (0, $7KdZ6.clear)
})((0, $gMfJt.default));

});
parcelRegister("7KdZ6", function(module, exports) {

$parcel$export(module.exports, "CLEAR_COLUMN_SORT_ORDER", () => $1e19ad77c8ea600f$export$875ad0918a4254f7);
$parcel$export(module.exports, "clear", () => $1e19ad77c8ea600f$export$42ffd38884aecdac);
const $1e19ad77c8ea600f$export$875ad0918a4254f7 = 'ops.columns.sorting.clear.CLEAR_COLUMN_SORT_ORDER';
const $1e19ad77c8ea600f$export$42ffd38884aecdac = ()=>({
        type: $1e19ad77c8ea600f$export$875ad0918a4254f7,
        payload: undefined
    });

});

parcelRegister("dRlnz", function(module, exports) {

$parcel$export(module.exports, "SET_COLUMN_SORT_ORDER", () => $6c006db53630a7d3$export$d353d2412612deea);
$parcel$export(module.exports, "set", () => $6c006db53630a7d3$export$adaa4cf7ef1b65be);
const $6c006db53630a7d3$export$d353d2412612deea = 'ops.columns.sorting.set.SET_COLUMN_SORT_ORDER';
const $6c006db53630a7d3$export$adaa4cf7ef1b65be = (payload)=>({
        type: $6c006db53630a7d3$export$d353d2412612deea,
        payload: payload
    });

});

parcelRegister("gMfJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $231e04c2a2c0ecc6$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $aqybX = parcelRequire("aqybX");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $231e04c2a2c0ecc6$var$SortIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { image: image, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_y0q4cp": (0, $lD23V.default)(__cmplp.image, ")", "url(")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _11q71izh _1bsbftgi _4t3i1osq _1itk1lpx _18u012x7 _80omtlke",
            __cmplp.className
        ])
    });
});
class $231e04c2a2c0ecc6$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            sortOrder: undefined
        };
    }
    setSortOrder(nextSortOrder) {
        return ()=>{
            const { columnId: columnId, setColumnSortOrder: setColumnSortOrder, onSortedColumnChanged: onSortedColumnChanged } = this.props;
            const payload = {
                columnId: columnId,
                sortOrder: nextSortOrder
            };
            setColumnSortOrder(payload);
            onSortedColumnChanged(payload);
        };
    }
    clearSortOrder() {
        return ()=>{
            const { clearColumnSortOrder: clearColumnSortOrder, onSortedColumnChanged: onSortedColumnChanged } = this.props;
            clearColumnSortOrder();
            onSortedColumnChanged(undefined);
        };
    }
    /* Along with sorting, any rows that were added since the last sort
   * and thus positioned "absolutely" should be discarded to allow for
   * explicit sorting once again.
   */ createClickAction(sortSpecificCallbacks) {
        return ()=>{
            const { onClearAddedRowsRequested: onClearAddedRowsRequested } = this.props;
            sortSpecificCallbacks();
            onClearAddedRowsRequested();
        };
    }
    renderSortOperationIndicator() {
        const { sortOrder: sortOrder, isDefaultSortColumn: isDefaultSortColumn } = this.props;
        const { nextSortOrder: nextSortOrder, image: image } = isDefaultSortColumn ? (0, $aqybX.DEFAULT_SORT_INDICATOR_METADATA)[sortOrder || 'DEFAULT'] : (0, $aqybX.INDICATOR_METADATA)[sortOrder || 'DEFAULT'];
        const clickAction = nextSortOrder === 'DEFAULT' ? this.createClickAction(this.clearSortOrder()) : this.createClickAction(this.setSortOrder(nextSortOrder));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($231e04c2a2c0ecc6$var$SortIndicator, {
            onClick: clickAction,
            image: image,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && clickAction
        });
    }
    render() {
        const { isColumnSortable: isColumnSortable, isSortEnabled: isSortEnabled } = this.props;
        return isColumnSortable && isSortEnabled ? this.renderSortOperationIndicator() : null;
    }
}

});
parcelRegister("aqybX", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SORT_INDICATOR_METADATA", () => $0ae293500153c19d$export$cc67c62619d38570);
$parcel$export(module.exports, "INDICATOR_METADATA", () => $0ae293500153c19d$export$319f25ddc8a4a7f2);


var $kN9bd = parcelRequire("kN9bd");

var $iU06l = parcelRequire("iU06l");

var $33NOD = parcelRequire("33NOD");
const $0ae293500153c19d$export$cc67c62619d38570 = {
    DESCENDING: {
        nextSortOrder: (0, $960a7067bff9d918$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($33NOD)))
    },
    ASCENDING: {
        nextSortOrder: (0, $960a7067bff9d918$export$f634ff5a7f1c8f3),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($iU06l)))
    },
    DEFAULT: {
        nextSortOrder: (0, $960a7067bff9d918$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($kN9bd)))
    }
};
const $0ae293500153c19d$export$319f25ddc8a4a7f2 = {
    DESCENDING: {
        nextSortOrder: 'DEFAULT',
        image: (0, (/*@__PURE__*/$parcel$interopDefault($33NOD)))
    },
    ASCENDING: {
        nextSortOrder: (0, $960a7067bff9d918$export$f634ff5a7f1c8f3),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($iU06l)))
    },
    DEFAULT: {
        nextSortOrder: (0, $960a7067bff9d918$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($kN9bd)))
    }
};

});
parcelRegister("kN9bd", function(module, exports) {
module.exports = new URL("sortable-indicator.e7b63888.svg", import.meta.url).toString();

});

parcelRegister("iU06l", function(module, exports) {
module.exports = new URL("sorted-indicator-asc.99c81f7a.svg", import.meta.url).toString();

});

parcelRegister("33NOD", function(module, exports) {
module.exports = new URL("sorted-indicator-desc.ee65fbfe.svg", import.meta.url).toString();

});




parcelRegister("ieC6z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6bfc361ab84267a$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5vD8v = parcelRequire("5vD8v");

var $aBsQD = parcelRequire("aBsQD");
// we only show the coloured top border for child columns that themselves are no parents
// @ts-expect-error - TS7006 - Parameter 'isChild' implicitly has an 'any' type. | TS7006 - Parameter 'isParent' implicitly has an 'any' type.
const $f6bfc361ab84267a$var$hasChildColumnAppearance = (isChild, isParent)=>isChild && !isParent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f6bfc361ab84267a$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstColumn: isFirstColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_14tplr7": (0, $lD23V.default)((0, $aBsQD.getWidth)({
                width: __cmplp.width,
                isFirstColumn: __cmplp.isFirstColumn
            }))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbssom _1e0c1txw _kqswh2mm _vchhusvi _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc _irr34m1f",
            __cmplp.className
        ])
    });
});
const $f6bfc361ab84267a$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isChild: isChild, isParent: isParent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _vwz41u1b _o5721q9c _1bto1l2s",
            $f6bfc361ab84267a$var$hasChildColumnAppearance(__cmplp.isChild, __cmplp.isParent) ? "_11c816g6" : "_11c81il0",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $f6bfc361ab84267a$var$DumbColumn extends (0, $5uXOq.PureComponent) {
    renderChildOperationIndicator() {
        const { id: id, ColumnChildOperationIndicator: ColumnChildOperationIndicator } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ColumnChildOperationIndicator, {
            columnId: id
        });
    }
    renderSortingOperationIndicator() {
        const { id: id, ColumnSortOperationIndicator: ColumnSortOperationIndicator } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ColumnSortOperationIndicator, {
            columnId: id
        });
    }
    renderChildBar() {
        const { isChild: isChild, isParent: isParent, ChildBar: ChildBar, id: id } = this.props;
        if ($f6bfc361ab84267a$var$hasChildColumnAppearance(isChild, isParent)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChildBar, {
            columnId: id
        });
        return null;
    }
    renderTitle() {
        const { title: title } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5vD8v)))(title)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return title;
        const InnerTitle = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InnerTitle, null);
    }
    render() {
        const { id: id, title: title, width: width, tooltip: tooltip, isChild: isChild, isParent: isParent, HeaderComponent: HeaderComponent, isFirstColumn: isFirstColumn } = this.props;
        return HeaderComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderComponent, {
            columnId: id,
            title: title,
            width: width
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6bfc361ab84267a$var$Wrapper, {
            // @ts-expect-error - TS2322 - Type 'Optional<string | Element>' is not assignable to type 'string | undefined'.
            title: tooltip,
            width: width,
            isFirstColumn: isFirstColumn
        }, this.renderChildOperationIndicator(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6bfc361ab84267a$var$Title, {
            isChild: isChild,
            isParent: isParent
        }, this.renderTitle()), this.renderSortingOperationIndicator(), this.renderChildBar());
    }
}
var $f6bfc361ab84267a$export$2e2bcd8739ae039 = $f6bfc361ab84267a$var$DumbColumn;

});


parcelRegister("jLgvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd36cd1e7eeadfc6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $bd36cd1e7eeadfc6$export$2e2bcd8739ae039({ Column: Column, id: id, title: title, HeaderComponent: HeaderComponent, tooltip: tooltip, width: width, isChild: isChild, isParent: isParent, parentId: parentId, isFirstColumn: isFirstColumn }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Column, {
        id: id,
        title: title,
        HeaderComponent: HeaderComponent,
        tooltip: tooltip,
        width: width,
        isChild: isChild,
        isParent: isParent,
        parentId: parentId,
        isFirstColumn: isFirstColumn
    });
}

});


parcelRegister("3ZJVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eea24861e1e76fc$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $aBsQD = parcelRequire("aBsQD");
class $9eea24861e1e76fc$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {};
    }
    render() {
        const { id: id, width: width, column: column, isFirstColumn: isFirstColumn, shouldUseCssForRendering: shouldUseCssForRendering, DefaultColumn: DefaultColumn } = this.props;
        if (shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eea24861e1e76fc$var$Wrapper, {
            column: column,
            width: width,
            isFirstColumn: isFirstColumn,
            shouldUseCssForRendering: shouldUseCssForRendering
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DefaultColumn, {
            id: id,
            width: width,
            isFirstColumn: isFirstColumn
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eea24861e1e76fc$var$Wrapper, {
            width: width,
            isFirstColumn: isFirstColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DefaultColumn, {
            id: id,
            width: width,
            isFirstColumn: isFirstColumn
        }));
    }
}
const $9eea24861e1e76fc$var$wrapperMarginLeftStylesMap = {
    firstColumn: "_18u01ejb",
    otherColumn: "_18u0ze3t"
};
const $9eea24861e1e76fc$var$Wrapper = ({ isFirstColumn: isFirstColumn, shouldUseCssForRendering: shouldUseCssForRendering, width: width, column: column, children: children })=>{
    if (column && shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            minWidth: (0, $aBsQD.getWidth)({
                width: column.minWidth,
                isFirstColumn: isFirstColumn
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: (0, $aBsQD.getWidth)({
                width: column.maxWidth,
                isFirstColumn: isFirstColumn
            })
        },
        xcss: [
            (0, $4R6GH.fg)('table_headers_widths_vs_column_widths') ? $9eea24861e1e76fc$var$wrapperStyles : $9eea24861e1e76fc$var$wrapperStylesOld,
            ...isFirstColumn ? [
                $9eea24861e1e76fc$var$firstColumnStyles
            ] : [
                $9eea24861e1e76fc$var$otherColumnStyles
            ]
        ],
        ...(0, $4R6GH.fg)('jsm_virtual_table_a11y') && {
            role: 'columnheader'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $aBsQD.getWidth)({
                width: width,
                isFirstColumn: isFirstColumn
            })
        },
        ...(0, $4R6GH.fg)('jsm_virtual_table_a11y') && {
            role: 'columnheader'
        },
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _kqswh2mm",
            $9eea24861e1e76fc$var$wrapperMarginLeftStylesMap[isFirstColumn ? 'firstColumn' : 'otherColumn']
        ])
    }, children);
};
const $9eea24861e1e76fc$var$cssWrapperStyles = null;
const $9eea24861e1e76fc$var$wrapperStylesOld = (0, $8CUq3.xcss)({
    flexGrow: 1
});
const $9eea24861e1e76fc$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    flex: '1 1 auto'
});
const $9eea24861e1e76fc$var$firstColumnStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.300'
});
const $9eea24861e1e76fc$var$otherColumnStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.0'
});

});



parcelRegister("7JYB3", function(module, exports) {

$parcel$export(module.exports, "default", () => $417f272257f2c944$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $417f272257f2c944$export$2e2bcd8739ae039(props) {
    const { id: id, DynamicColumnComponent: DynamicColumnComponent } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DynamicColumnComponent, {
        id: id
    });
}

});


parcelRegister("dXBPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a7f7985132cf01$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4R6GH = parcelRequire("4R6GH");

var $6iCoB = parcelRequire("6iCoB");
const $81a7f7985132cf01$var$getShadowWidth = ({ width: width, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible })=>width + (leftShadowVisible ? 0 : 8) + (rightShadowVisible ? 0 : 8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $81a7f7985132cf01$var$HeaderShadow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ht14a7": (0, $lD23V.default)(`${$81a7f7985132cf01$var$getShadowWidth(__cmplp)}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154ix0bf _1xi2ze3t _94n5x0bf _1ltvze3t _4t3iutpp _1bsbcyjv",
            __cmplp.className
        ])
    });
});
const $81a7f7985132cf01$var$getMargin = (hasScrolled, isShadowVisible)=>8 * $81a7f7985132cf01$var$marginMultiplier(hasScrolled, isShadowVisible);
const $81a7f7985132cf01$var$marginMultiplier = (hasScrolled, isShadowVisible)=>{
    if (isShadowVisible) return 0;
    if (hasScrolled) return -1;
    return 1;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $81a7f7985132cf01$var$InnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasScrolled: hasScrolled, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1koxo07": (0, $lD23V.default)(`${$81a7f7985132cf01$var$getMargin(__cmplp.hasScrolled, __cmplp.leftShadowVisible) * -1}px`),
            "--_1hyq4n0": (0, $lD23V.default)(`${$81a7f7985132cf01$var$getMargin(__cmplp.hasScrolled, __cmplp.rightShadowVisible) * -1}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1wug _1e0c1txw _18u0wdq9 _2hwxek4m _18m915vq",
            __cmplp.className
        ])
    });
});
const $81a7f7985132cf01$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasScrolled: hasScrolled, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_150w5uv": (0, $lD23V.default)(`${$81a7f7985132cf01$var$getMargin(__cmplp.hasScrolled, __cmplp.leftShadowVisible)}px`),
            "--_oytggz": (0, $lD23V.default)(`${$81a7f7985132cf01$var$getMargin(__cmplp.hasScrolled, __cmplp.rightShadowVisible)}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl176a _4t3i1wug _18u0t6e2 _2hwx1meq _n3td1b66 _ca0qu2gc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $81a7f7985132cf01$var$ShadowWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ht14a7": (0, $lD23V.default)(`${$81a7f7985132cf01$var$getShadowWidth(__cmplp)}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswstnw _1xi2ze3t _94n5xmi2 _1ltvze3t _4t3iutpp _1bsbcyjv _1pbykb7n _lcxvglyw",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $81a7f7985132cf01$var$ColumnHeaders extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        if (this.props.isAutoRowHeight && this.ref) this.props.setHeaderHeight(Math.ceil(this.ref.getBoundingClientRect().height));
    }
    componentDidUpdate() {
        if (this.props.isAutoRowHeight && this.ref) this.props.setHeaderHeight(Math.ceil(this.ref.getBoundingClientRect().height));
    }
    renderCoreColumns() {
        const { coreColumnIds: coreColumnIds, Column: Column } = this.props;
        return coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Column, {
                key: columnId,
                id: columnId
            }));
    }
    renderAdditionalColumns() {
        const { additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, Column: Column } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdditionalColumnsContainer, null, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Column, {
                key: columnId,
                id: columnId
            })));
    }
    render() {
        const { additionalColumnIds: additionalColumnIds, bottomShadowWidth: bottomShadowWidth, isColumnConfigurationVisible: isColumnConfigurationVisible, hasVerticallyScrolled: hasVerticallyScrolled, tableHasLeftShadow: tableHasLeftShadow, tableHasRightShadow: tableHasRightShadow, ColumnConfiguration: ColumnConfiguration, theme: theme } = this.props;
        const styledCompProps = {
            hasScrolled: hasVerticallyScrolled,
            leftShadowVisible: tableHasLeftShadow,
            rightShadowVisible: tableHasRightShadow,
            width: bottomShadowWidth
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81a7f7985132cf01$var$Wrapper, {
            ref: this.setRef,
            ...styledCompProps,
            theme: theme,
            ...(0, $4R6GH.fg)('jsm_virtual_table_a11y') && {
                role: 'row'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81a7f7985132cf01$var$InnerWrapper, {
            ...styledCompProps,
            theme: theme
        }, this.renderCoreColumns(), additionalColumnIds.length > 0 && this.renderAdditionalColumns(), isColumnConfigurationVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ColumnConfiguration, null), theme.header.hasShadow && hasVerticallyScrolled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81a7f7985132cf01$var$ShadowWrapper, {
            ...styledCompProps,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81a7f7985132cf01$var$HeaderShadow, {
            ...styledCompProps,
            theme: theme
        }))));
    }
    constructor(...args){
        super(...args), this.setRef = (el)=>{
            this.ref = el;
        };
    }
}
var $81a7f7985132cf01$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($81a7f7985132cf01$var$ColumnHeaders);

});


parcelRegister("3sdFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4072263037d4ec$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $8oe80 = parcelRequire("8oe80");

var $4R6GH = parcelRequire("4R6GH");

var $6iCoB = parcelRequire("6iCoB");
const $6a4072263037d4ec$var$ANALYTICS_DEBOUNCE_MILLIS = 1000;
// eslint-disable-next-line jira/react/no-class-components
class $6a4072263037d4ec$var$TableMain extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props);
        this.analyticsDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(props.onTableChange, $6a4072263037d4ec$var$ANALYTICS_DEBOUNCE_MILLIS);
    }
    componentDidMount() {
        const { containerWidth: containerWidth, hasLoadingRows: hasLoadingRows, onTableChange: onTableChange } = this.props;
        if (containerWidth && !hasLoadingRows) onTableChange();
    }
    // @ts-expect-error - TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    componentDidUpdate(prevProps) {
        const { rowIds: rowIds, containerWidth: containerWidth, hasLoadingRows: hasLoadingRows, hasHorizontalScrollbar: hasHorizontalScrollbar, hasVerticalScrollbar: hasVerticalScrollbar } = this.props;
        if (!hasLoadingRows && (rowIds !== prevProps.rowIds || containerWidth !== prevProps.containerWidth || hasHorizontalScrollbar !== prevProps.hasHorizontalScrollbar || hasVerticalScrollbar !== prevProps.hasVerticalScrollbar)) /*
       * send analytics event if -
       * - the window was resized
       * - the scrollbar state changed (new rows added, rows expanded, columns added)
       * - table content updated (new table/queue, pagination, sorting, asyn updates)
       *    - but not 'loading' rows
       *
       * Do this over a 1 sec timer to avoid multiple events getting fired during window resize
       * since AutoSizer keeps updating this component during every resize
       */ this.analyticsDebouncer();
    }
    render() {
        const { width: width, shouldUseCssForRendering: shouldUseCssForRendering, Header: Header, Content: Content, ResizeColumnOverlay: ResizeColumnOverlay, HorizontalScrollOverlay: HorizontalScrollOverlay, ariaLabel: ariaLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table') ? '100%' : `${width}px`
            },
            "data-testid": "virtual-table.table.main",
            ...(0, $4R6GH.fg)('jsm_virtual_table_a11y') && {
                role: 'table'
            },
            "aria-label": ariaLabel,
            className: (0, $bwpsq.default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _2lx21bp4"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a4072263037d4ec$var$HeaderWrapper, (0, $4R6GH.fg)('jsm_virtual_table_a11y') && {
            role: 'rowgroup'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a4072263037d4ec$var$ContentWrapper, {
            className: "virtual-table-content-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResizeColumnOverlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HorizontalScrollOverlay, null));
    }
}
var $6a4072263037d4ec$export$2e2bcd8739ae039 = (0, $8oe80.default)('virtualTable', {
    onTableChange: 'updated'
})((0, $6iCoB.withTheme)($6a4072263037d4ec$var$TableMain));
const $6a4072263037d4ec$var$wrapperStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a4072263037d4ec$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _u5f3xy5q",
            __cmplp.className
        ])
    });
});
const $6a4072263037d4ec$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3iMZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a90422325595a7$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $7yLSX = parcelRequire("7yLSX");
var $90a90422325595a7$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        getOffsetFromBottom: (0, $iN58L.getOffsetFromBottom)(state),
        isHorizontalScrollVisible: (0, $iN58L.hasHorizontalScrollbar)(state),
        offset: (0, $bFTY1.getVisibleCoreColumnsWidth)(state),
        showBottomDecal: (0, $eeWa5.showBottomDecal)(state),
        showLeftShadow: (0, $iN58L.isHorizontalScrollLeftShadowVisible)(state),
        showRightShadow: (0, $iN58L.isHorizontalScrollRightShadowVisible)(state),
        tableHeight: (0, $iN58L.getTableHeight)(state),
        tableWidth: (0, $5J7ao.getTableWidthWithoutScrollbarOffset)(state),
        shouldUseCssForRendering: (0, $5J7ao.getShouldUseCssForRendering)(state)
    }), {})((0, $7yLSX.default));

});
parcelRegister("7yLSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bb2c624f5fb15c$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4R6GH = parcelRequire("4R6GH");

var $6iCoB = parcelRequire("6iCoB");

var $6hiB0 = parcelRequire("6hiB0");
const $12bb2c624f5fb15c$var$softShadow = {
    '@media screen and (-webkit-min-device-pixel-ratio: 0)': {
        boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"
    },
    '@media screen and (-webkit-transition)': {
        boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"
    },
    '@-moz-document url-prefix()': {
        boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"
    }
};
const $12bb2c624f5fb15c$export$1b2ba256944351ec = 20;
// eslint-disable-next-line jira/react/no-class-components
class $12bb2c624f5fb15c$var$HorizontalScrollOverlay extends (0, $5uXOq.PureComponent) {
    render() {
        const { offset: offset, showLeftShadow: showLeftShadow, showRightShadow: showRightShadow, tableHeight: tableHeight, tableWidth: tableWidth, isHorizontalScrollVisible: isHorizontalScrollVisible, showBottomDecal: showBottomDecal, getOffsetFromBottom: getOffsetFromBottom, theme: theme, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
        const showBottomShadow = (isHorizontalScrollVisible || showBottomDecal) && getOffsetFromBottom > 0;
        const spaceTakenByHorizontalScrollbar = (0, $6hiB0.scrollbarWidth) + theme.scrollbar.marginTop + theme.scrollbar.marginBottom;
        const verticalShadowHeight = tableHeight - spaceTakenByHorizontalScrollbar;
        if (shouldUseCssForRendering && (0, $4R6GH.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !false && showLeftShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$LeftWrapper, {
            "data-testid": "virtual-table.table.overlays.horizontal-scroll.left-wrapper",
            offset: offset,
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$LeftShadow, {
            theme: theme
        })), !false && showRightShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$RightWrapper, {
            "data-testid": "virtual-table.table.overlays.horizontal-scroll.right-wrapper",
            height: "100%",
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$RightShadow, null)), showBottomShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$BottomWrapper, {
            "data-testid": "virtual-table.table.overlays.horizontal-scroll.bottom-wrapper",
            height: $12bb2c624f5fb15c$export$1b2ba256944351ec,
            tableWidth: tableWidth,
            topPositionForBottomShadow: this.calculateTopPositionForBottomShadow(spaceTakenByHorizontalScrollbar),
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$BottomShadow, null)));
        if ((0, $4R6GH.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showLeftShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$LeftWrapper, {
            offset: offset,
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$LeftShadow, {
            theme: theme
        })), showRightShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$RightWrapper, {
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$RightShadow, null)), showBottomShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$BottomWrapper, {
            height: $12bb2c624f5fb15c$export$1b2ba256944351ec,
            tableWidth: tableWidth,
            topPositionForBottomShadow: this.calculateTopPositionForBottomShadow(spaceTakenByHorizontalScrollbar),
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$BottomShadow, null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, showLeftShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$LeftWrapper, {
            offset: offset,
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$LeftShadow, {
            theme: theme
        })), showRightShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$RightWrapperOld, {
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$RightShadow, null)), showBottomShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$BottomWrapper, {
            height: $12bb2c624f5fb15c$export$1b2ba256944351ec,
            tableWidth: tableWidth,
            topPositionForBottomShadow: this.calculateTopPositionForBottomShadow(spaceTakenByHorizontalScrollbar),
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bb2c624f5fb15c$var$BottomShadow, null)));
    }
    constructor(...args){
        super(...args), this.calculateTopPositionForBottomShadow = (spaceTakenByHorizontalScrollbar)=>{
            const { isHorizontalScrollVisible: isHorizontalScrollVisible, tableHeight: tableHeight } = this.props;
            if (isHorizontalScrollVisible) return tableHeight - spaceTakenByHorizontalScrollbar - $12bb2c624f5fb15c$export$1b2ba256944351ec;
            return tableHeight - $12bb2c624f5fb15c$export$1b2ba256944351ec;
        };
    }
}
var $12bb2c624f5fb15c$export$2e2bcd8739ae039 = (0, $6iCoB.withTheme)($12bb2c624f5fb15c$var$HorizontalScrollOverlay);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $12bb2c624f5fb15c$var$BottomShadow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvze3t _1bsb1osq _4t3i19bv _wxnd9g9j _16pl9g9j _5hft9g9j",
            __cmplp.className
        ])
    });
});
const $12bb2c624f5fb15c$var$BottomWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { topPositionForBottomShadow: topPositionForBottomShadow, tableWidth: tableWidth, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_iucfl6": (0, $lD23V.default)(`${__cmplp.topPositionForBottomShadow}px`),
            "--_1lfl5vu": (0, $lD23V.default)(`width: ${__cmplp.tableWidth}px`),
            "--_1lfsua2": (0, $lD23V.default)(__cmplp.theme.shadow.bottom.display),
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswstnw _154i1lgz _1ltvze3t _1bsb1p8o _1e0ch4j2 _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $12bb2c624f5fb15c$var$RightShadow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154ix0bf _94n5x0bf _1ltvv47k _1bsb19bv _wxnd9g9j _16pl9g9j _5hft9g9j",
            __cmplp.className
        ])
    });
});
const $12bb2c624f5fb15c$var$RightWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bke5hq": (0, $lD23V.default)(__cmplp.theme.shadow.right.display),
            "--_10ib6lf": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswstnw _154ize3t _1xi2xy5q _94n5ze3t _1bsbv47k _1e0c13s1",
            typeof __cmplp.height === 'string' ? "_4t3it1jn" : "_4t3it1jn",
            __cmplp.className
        ])
    });
});
const $12bb2c624f5fb15c$var$RightWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bke5hq": (0, $lD23V.default)(__cmplp.theme.shadow.right.display),
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswstnw _154ize3t _1xi2xy5q _94n5ze3t _1bsbv47k _1e0c13s1 _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $12bb2c624f5fb15c$var$LeftShadow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154ix0bf _94n5x0bf _1ltvx0bf _1bsb19bv _wxnd9g9j _16pl9g9j _5hft9g9j",
            __cmplp.className
        ])
    });
});
const $12bb2c624f5fb15c$var$LeftWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1l2g1c7": (0, $lD23V.default)(`${__cmplp.theme.shadow.left.borderWidth}px solid ${__cmplp.theme.header.borderColor}`),
            "--_10ib6lf": (0, $lD23V.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1kl71s3n _kqswstnw _154ize3t _94n5ze3t _1ltvze3t _1bsbv47k",
            __cmplp.theme.shadow.left.computeHeight ? "_4t3it1jn" : "_4t3i1kw7",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7Zhvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef2d0752658237b$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $iOWLl = parcelRequire("iOWLl");
var $0ef2d0752658237b$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state)=>({
        width: (0, $iN58L.getTableContentWidth)(state),
        isVisible: !!(0, $5J7ao.getResizingColumnId)(state)
    }), {})((0, $iOWLl.default));

});
parcelRegister("iOWLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $878293946d7059ac$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
function $878293946d7059ac$export$2e2bcd8739ae039(props) {
    const { width: width, isVisible: isVisible } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($878293946d7059ac$var$Overlay, {
        width: width,
        isVisible: isVisible
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $878293946d7059ac$var$Overlay = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw _kqswstnw _154iidpf _94n5idpf _1ltvidpf _1bsb1hdq _bfhk1bhr",
            __cmplp.isVisible ? "_tzy4105o" : "_tzy4idpf",
            __cmplp.isVisible ? "_v564mmrx" : "_v564b45n",
            __cmplp.className
        ])
    });
});

});




parcelRegister("1IBHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe44d6441b3adff$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $hkadP = parcelRequire("hkadP");

var $c9vCi = parcelRequire("c9vCi");

var $fs1x7 = parcelRequire("fs1x7");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$bfe44d6441b3adff$export$2e2bcd8739ae039 = (initialState)=>(0, $3f2cs.createStore)((0, $aB8eX.enableBatching)((0, $fs1x7.default)), initialState, (0, $hkadP.default)({
        name: 'Table'
    })((0, $3f2cs.applyMiddleware)((0, $e1AU2.createEpicMiddleware)((0, $c9vCi.default)))));

});
parcelRegister("c9vCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54d453bbf7ce98ce$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $aZMX0 = parcelRequire("aZMX0");

var $dpvOh = parcelRequire("dpvOh");

var $66dqE = parcelRequire("66dqE");

var $fdlRE = parcelRequire("fdlRE");

var $4lMCx = parcelRequire("4lMCx");

var $h83ok = parcelRequire("h83ok");

var $4FaQh = parcelRequire("4FaQh");

var $h3wZv = parcelRequire("h3wZv");
var $54d453bbf7ce98ce$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $aZMX0.default), (0, $fdlRE.default), (0, $h3wZv.default), (0, $dpvOh.default), (0, $4lMCx.default), (0, $h83ok.default), (0, $4FaQh.default), (0, $66dqE.default));

});
parcelRegister("aZMX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $348154553d1640ba$export$2e2bcd8739ae039);


var $eeWa5 = parcelRequire("eeWa5");

var $iN58L = parcelRequire("iN58L");

var $4XO5t = parcelRequire("4XO5t");

var $Ifpim = parcelRequire("Ifpim");

var $8UBZI = parcelRequire("8UBZI");

var $he9zu = parcelRequire("he9zu");

var $eowhB = parcelRequire("eowhB");
var $348154553d1640ba$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $he9zu.NAVIGATE_TO_CELL), (action, state)=>{
    const { direction: direction, columnId: columnId, rowId: rowId } = action.payload;
    const visibleColumnIds = (0, $eeWa5.getVisibleColumnIds)(state);
    const loadingRowIdsSet = new Set((0, $iN58L.getVisibleLoadingRowIds)(state));
    const visibleRowIds = (0, $4XO5t.getFlattenedWithAddedRowIds)(state);
    /* activatedFrom is the opposite of direction, as it is the
	 * relative orientation of the cell that navigated to it, and not
	 * the user interaction that caused the navigation.
	 */ switch(direction){
        case 0, $bc003a5da339d04c$export$b29f845fa4b57508:
            return (0, $8UBZI.setActiveCell)({
                columnId: columnId,
                rowId: (0, $eowhB.navigateUp)(visibleRowIds, rowId, loadingRowIdsSet),
                activatedFrom: (0, $bc003a5da339d04c$export$c7c029a231f98d34)
            });
        case 0, $bc003a5da339d04c$export$c7c029a231f98d34:
            return (0, $8UBZI.setActiveCell)({
                columnId: columnId,
                rowId: (0, $eowhB.navigateDown)(visibleRowIds, rowId, loadingRowIdsSet),
                activatedFrom: (0, $bc003a5da339d04c$export$b29f845fa4b57508)
            });
        case 0, $bc003a5da339d04c$export$f981f70d61d1405a:
            return (0, $8UBZI.setActiveCell)({
                columnId: (0, $eowhB.navigateUp)(visibleColumnIds, columnId, new Set()),
                rowId: rowId,
                activatedFrom: (0, $bc003a5da339d04c$export$1cac5500365a4eb4)
            });
        case 0, $bc003a5da339d04c$export$1cac5500365a4eb4:
            return (0, $8UBZI.setActiveCell)({
                columnId: (0, $eowhB.navigateDown)(visibleColumnIds, columnId, new Set()),
                rowId: rowId,
                activatedFrom: (0, $bc003a5da339d04c$export$f981f70d61d1405a)
            });
        default:
            throw new Error('illegal value of the direction property.');
    }
});

});
parcelRegister("Ifpim", function(module, exports) {

$parcel$export(module.exports, "defineTransaction", () => $c3ea0c24b5198eef$export$c19bdc7dbe69198d);

var $aB8eX = parcelRequire("aB8eX");
parcelRequire("aSIuP");
parcelRequire("fp4O3");
parcelRequire("hZWgu");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $e1AU2 = parcelRequire("e1AU2");

var $65i0E = parcelRequire("65i0E");

var $l8crC = parcelRequire("l8crC");

var $kVLXA = parcelRequire("kVLXA");

var $gYkqR = parcelRequire("gYkqR");
const $c3ea0c24b5198eef$var$errorHandler = (0, $gYkqR.errorHandlerFactory)();
const $c3ea0c24b5198eef$export$c19bdc7dbe69198d = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(type, callback)=>(action$, store)=>action$.ofType(type)// @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
        .flatMap((payload)=>{
            const callbackResult = callback ? callback(payload, store.getState()) : [];
            const flatTree = Array.isArray(callbackResult) ? (0, (/*@__PURE__*/$parcel$interopDefault($65i0E)))(callbackResult) : [
                callbackResult
            ];
            const observables = [];
            flatTree.forEach((leaf)=>{
                if (leaf instanceof (0, $kVLXA.Observable)) observables.push(leaf);
                else observables.push((0, $kVLXA.Observable).of(leaf));
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($l8crC)))(observables) === 1) return observables[0];
            return (0, $kVLXA.Observable).zip(...observables, (...resolvedActions)=>// @ts-expect-error - TS2345 - Argument of type 'unknown[]' is not assignable to parameter of type 'Action[]'.
                (0, $aB8eX.batchActions)((0, (/*@__PURE__*/$parcel$interopDefault($65i0E)))(resolvedActions)));
        }).catch($c3ea0c24b5198eef$var$errorHandler);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c3ea0c24b5198eef$var$defaultGeneratePayload = (action)=>action.payload;
const $c3ea0c24b5198eef$export$aec11e7f84966a38 = (type, method, callback, generatePayload)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>action$.ofType(type)// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
        .flatMap((action)=>{
            const observable = method(generatePayload === undefined ? $c3ea0c24b5198eef$var$defaultGeneratePayload(action) : generatePayload(action, store.getState()));
            if (typeof callback !== 'undefined') return observable.map((response)=>{
                const actions = callback ? callback(response, store.getState()) : [];
                if (Array.isArray(actions)) return (0, $aB8eX.batchActions)(actions);
                return actions;
            });
            return observable.ignoreElements();
        }).catch($c3ea0c24b5198eef$var$errorHandler);
const $c3ea0c24b5198eef$export$cc1acdd68c249d8b = (type, before, method, after, generatePayload)=>{
    const optimisticTransaction = $c3ea0c24b5198eef$export$c19bdc7dbe69198d(type, before);
    const apiTransaction = $c3ea0c24b5198eef$export$aec11e7f84966a38(type, method, after, generatePayload);
    return (0, $e1AU2.combineEpics)(optimisticTransaction, apiTransaction);
};

});
parcelRegister("65i0E", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");
/** Used as references for various `Number` constants. */ var $46e12e07abca6e43$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $46e12e07abca6e43$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? $ekcP3(array, $46e12e07abca6e43$var$INFINITY) : [];
}
module.exports = $46e12e07abca6e43$var$flattenDeep;

});

parcelRegister("l8crC", function(module, exports) {

var $hR3Ue = parcelRequire("hR3Ue");

var $jtBGw = parcelRequire("jtBGw");

var $hTJwX = parcelRequire("hTJwX");

var $agVdz = parcelRequire("agVdz");

var $ifYxh = parcelRequire("ifYxh");
/** `Object#toString` result references. */ var $f623ff8b0231a65d$var$mapTag = '[object Map]', $f623ff8b0231a65d$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $f623ff8b0231a65d$var$size(collection) {
    if (collection == null) return 0;
    if ($hTJwX(collection)) return $agVdz(collection) ? $ifYxh(collection) : collection.length;
    var tag = $jtBGw(collection);
    if (tag == $f623ff8b0231a65d$var$mapTag || tag == $f623ff8b0231a65d$var$setTag) return collection.size;
    return $hR3Ue(collection).length;
}
module.exports = $f623ff8b0231a65d$var$size;

});
parcelRegister("agVdz", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $8LQ84 = parcelRequire("8LQ84");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $77a7c84c5ee0b808$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $77a7c84c5ee0b808$var$isString(value) {
    return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
}
module.exports = $77a7c84c5ee0b808$var$isString;

});

parcelRegister("ifYxh", function(module, exports) {

var $dkmPN = parcelRequire("dkmPN");

var $axH2S = parcelRequire("axH2S");

var $61ekh = parcelRequire("61ekh");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $d4a895dd16218f22$var$stringSize(string) {
    return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
}
module.exports = $d4a895dd16218f22$var$stringSize;

});
parcelRegister("dkmPN", function(module, exports) {

var $8hdQS = parcelRequire("8hdQS");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
module.exports = $9b3edb0cff432526$var$asciiSize;

});

parcelRegister("61ekh", function(module, exports) {
/** Used to compose unicode character classes. */ var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
    $461df2ef275f3803$var$rsNonAstral,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair
].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
    $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
    $461df2ef275f3803$var$rsCombo,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair,
    $461df2ef275f3803$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $461df2ef275f3803$var$unicodeSize(string) {
    var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
    while($461df2ef275f3803$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $461df2ef275f3803$var$unicodeSize;

});



parcelRegister("gYkqR", function(module, exports) {

$parcel$export(module.exports, "errorHandlerFactory", () => $14aee29ef2e0034c$export$6a6f72199c8b8578);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("jFVZ1");
parcelRequire("fp4O3");

var $dJl1T = parcelRequire("dJl1T");

var $aMh57 = parcelRequire("aMh57");

var $bweeT = parcelRequire("bweeT");

const $14aee29ef2e0034c$var$LOCATION = 'common.components.virtual-table.ops.common.errors';
const $14aee29ef2e0034c$var$translateJsError = (jsError)=>(0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $bweeT.error)({
        type: (0, $a5fa7cea4b2a1ade$export$78244dbb77cfa6b6),
        message: jsError.message,
        stack: jsError.stack
    }));
const $14aee29ef2e0034c$var$generateErrorAction = (thrownError)=>$14aee29ef2e0034c$var$translateJsError(thrownError);
const $14aee29ef2e0034c$export$6a6f72199c8b8578 = (additionalFailAction)=>(thrownError)=>{
        (0, $aMh57.captureException)($14aee29ef2e0034c$var$LOCATION, thrownError);
        (0, $dJl1T.default).safeErrorWithoutCustomerData($14aee29ef2e0034c$var$LOCATION, thrownError.message || 'Operations error', thrownError);
        const errorAction = $14aee29ef2e0034c$var$generateErrorAction(thrownError);
        if (additionalFailAction) return (0, $kVLXA.Observable).concat(errorAction, (0, $kVLXA.Observable).of(additionalFailAction()));
        return errorAction;
    };

});
parcelRegister("bweeT", function(module, exports) {

$parcel$export(module.exports, "error", () => $e233e50482272892$export$a3bc9b8ed74fc);
const $e233e50482272892$export$103bedf43ba882db = 'ops.common.errors.ERROR';
const $e233e50482272892$export$a3bc9b8ed74fc = (payload)=>({
        type: $e233e50482272892$export$103bedf43ba882db,
        payload: payload
    });

});

const $a5fa7cea4b2a1ade$var$HTTP = 'HTTP';
const $a5fa7cea4b2a1ade$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $a5fa7cea4b2a1ade$var$REDUX = 'REDUX';



parcelRegister("eowhB", function(module, exports) {

$parcel$export(module.exports, "navigateUp", () => $7e7aae0443da0860$export$565581085a0f36e2);
$parcel$export(module.exports, "navigateDown", () => $7e7aae0443da0860$export$876f6f483a97d3b5);

var $fW7cr = parcelRequire("fW7cr");

var $apUNl = parcelRequire("apUNl");
const $7e7aae0443da0860$var$navigateWithStrategy = (items, currentItemId, searchStrategy)=>{
    const selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(items, (item)=>item === currentItemId);
    // Selected item is not found; go to top
    if (selectedIndex === -1) return items[0];
    const nextIndex = searchStrategy(selectedIndex);
    if (nextIndex === -1) return items[0];
    return items[nextIndex];
};
const $7e7aae0443da0860$var$buildSearchStrategy = (searchFn, fallbackFn)=>(selectedIndex)=>{
        const searchResult = searchFn(selectedIndex);
        if (searchResult === -1) return fallbackFn(selectedIndex);
        return searchResult;
    };
const $7e7aae0443da0860$export$565581085a0f36e2 = (items, currentItemId, ineligibleItemsSet)=>$7e7aae0443da0860$var$navigateWithStrategy(items, currentItemId, $7e7aae0443da0860$var$buildSearchStrategy((selectedIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($apUNl)))(items, (item)=>!ineligibleItemsSet.has(item), selectedIndex - 1), ()=>(0, (/*@__PURE__*/$parcel$interopDefault($apUNl)))(items, (item)=>!ineligibleItemsSet.has(item), items.length - 1)));
const $7e7aae0443da0860$export$876f6f483a97d3b5 = (items, currentItemId, ineligibleItemsSet)=>$7e7aae0443da0860$var$navigateWithStrategy(items, currentItemId, $7e7aae0443da0860$var$buildSearchStrategy((selectedIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(items, (item)=>!ineligibleItemsSet.has(item), selectedIndex + 1), ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(items, (item)=>!ineligibleItemsSet.has(item), 0)));

});


parcelRegister("dpvOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $06446dfad5d607e4$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $8Xt3q = parcelRequire("8Xt3q");

var $18NVv = parcelRequire("18NVv");
var $06446dfad5d607e4$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $8Xt3q.default), (0, $18NVv.default));

});
parcelRegister("8Xt3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $91bbba471a241398$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $2CP59 = parcelRequire("2CP59");

var $6SGSX = parcelRequire("6SGSX");
var $91bbba471a241398$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $2CP59.default), (0, $6SGSX.default));

});
parcelRegister("2CP59", function(module, exports) {

$parcel$export(module.exports, "default", () => $68d2fd3407b3d548$export$2e2bcd8739ae039);

var $eiuAu = parcelRequire("eiuAu");

var $Ifpim = parcelRequire("Ifpim");

var $8HIAq = parcelRequire("8HIAq");
var $68d2fd3407b3d548$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $8HIAq.CLEAR_RESIZING_COLUMN), ()=>(0, $eiuAu.setResizingColumn)(undefined));

});
parcelRegister("8HIAq", function(module, exports) {

$parcel$export(module.exports, "CLEAR_RESIZING_COLUMN", () => $223ba584dc692277$export$9939dee145f3882b);
const $223ba584dc692277$export$9939dee145f3882b = 'ops.columns.resizing.clear.CLEAR_RESIZING_COLUMN';
const $223ba584dc692277$export$42ffd38884aecdac = ()=>({
        type: $223ba584dc692277$export$9939dee145f3882b,
        payload: undefined
    });

});


parcelRegister("6SGSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d90ededc8b9eef0c$export$2e2bcd8739ae039);

var $eiuAu = parcelRequire("eiuAu");

var $Ifpim = parcelRequire("Ifpim");

var $hW40f = parcelRequire("hW40f");
var $d90ededc8b9eef0c$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $hW40f.SET_RESIZING_COLUMN), (action)=>(0, $eiuAu.setResizingColumn)(action.payload));

});
parcelRegister("hW40f", function(module, exports) {

$parcel$export(module.exports, "SET_RESIZING_COLUMN", () => $8faeae7721a52579$export$9b07079645db68ce);
const $8faeae7721a52579$export$9b07079645db68ce = 'ops.columns.resizing.set.SET_RESIZING_COLUMN';
const $8faeae7721a52579$export$adaa4cf7ef1b65be = (payload)=>({
        type: $8faeae7721a52579$export$9b07079645db68ce,
        payload: payload
    });

});



parcelRegister("18NVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e20c9974ac31de$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $eAaQB = parcelRequire("eAaQB");

var $jkr7s = parcelRequire("jkr7s");

var $28Fb8 = parcelRequire("28Fb8");
var $25e20c9974ac31de$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $eAaQB.default), (0, $28Fb8.default), (0, $jkr7s.default));

});
parcelRegister("eAaQB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6470631713cc607f$export$2e2bcd8739ae039);

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $eiuAu = parcelRequire("eiuAu");

var $5J7ao = parcelRequire("5J7ao");

var $3EKBz = parcelRequire("3EKBz");

var $Ifpim = parcelRequire("Ifpim");

var $7KdZ6 = parcelRequire("7KdZ6");
var $6470631713cc607f$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $7KdZ6.CLEAR_COLUMN_SORT_ORDER), (action, state)=>{
    const consumerState = (0, $eeWa5.getConsumerState)(state);
    const sortedRowIdsHash = (0, $3EKBz.default)((0, $3W7mX.getAddedRows)(state), (0, $3W7mX.getRowTree)(state), (0, $5J7ao.getActiveSortedColumnConfiguration)(state), false, undefined, (0, $5J7ao.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $eiuAu.setColumnSortOrder)(undefined),
        (0, $eiuAu.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});
parcelRegister("3EKBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5d5d7045b76c31$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $8QpSo = parcelRequire("8QpSo");

var $1v8kM = parcelRequire("1v8kM");

var $1C5Ad = parcelRequire("1C5Ad");

var $9wrcl = parcelRequire("9wrcl");
var $5f5d5d7045b76c31$export$2e2bcd8739ae039 = (0, $8QpSo.default)((lastAddedRows, lastRowTree, lastSortedColumnConfiguration, sortOverrideEnabled, activeSortedColumnConfiguration, lastSortedRowIdsHash, addedRows, rowTree, columnComparators, defaultComparator)=>{
    const newAddedRows = (0, $1C5Ad.default)(lastAddedRows, addedRows);
    // bypass sorting if possible (no new added rows, rowTree didn't change, sortConfiguration didn't change)
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(newAddedRows) && lastRowTree === rowTree && lastSortedColumnConfiguration === activeSortedColumnConfiguration) return lastSortedRowIdsHash;
    return (0, $9wrcl.default)({
        rowTree: rowTree,
        columnComparators: columnComparators,
        defaultComparator: (0, $1v8kM.default)(defaultComparator, columnComparators),
        persistedAddedRows: newAddedRows,
        isSortOverrideEnabled: sortOverrideEnabled,
        activeSortedColumnConfiguration: activeSortedColumnConfiguration,
        sortedRowIdsHash: lastSortedRowIdsHash
    });
});

});
parcelRegister("1C5Ad", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c1deb10449ee553$export$2e2bcd8739ae039);

var $lbWm4 = parcelRequire("lbWm4");

var $8QpSo = parcelRequire("8QpSo");
var $4c1deb10449ee553$export$2e2bcd8739ae039 = (0, $8QpSo.default)((addedRows, nextAddedRows)=>{
    if (nextAddedRows && nextAddedRows.persisted) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(nextAddedRows.persisted, (persistedRow, rowId)=>{
            if (addedRows === undefined || addedRows.persisted === undefined || addedRows.persisted[rowId] === undefined) result[rowId] = persistedRow;
        });
        return result;
    }
    return undefined;
});

});

parcelRegister("9wrcl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ab1407e08597d$export$2e2bcd8739ae039);

var $kPH5D = parcelRequire("kPH5D");

var $lbWm4 = parcelRequire("lbWm4");

var $ggSx2 = parcelRequire("ggSx2");

var $5Ot1C = parcelRequire("5Ot1C");



var $f5kj3 = parcelRequire("f5kj3");
const $a09ab1407e08597d$var$sort = (rowIds, sortOrder, comparator)=>[
        ...rowIds
    ].sort(comparator);
const $a09ab1407e08597d$var$sortRowIds = (rowIds, sortConfiguration, lastSortedRowIds)=>{
    if (rowIds.length === 0) return rowIds;
    const { consumerComparator: consumerComparator, sortOrder: sortOrder, isSortOverrideEnabled: isSortOverrideEnabled } = sortConfiguration;
    const sortAwareConsumerComparator = consumerComparator(sortOrder);
    // either this is the first time sorting, or the user has explicitly sorted the table
    // sort as expressed by the consumer
    if (!lastSortedRowIds || !isSortOverrideEnabled) return $a09ab1407e08597d$var$sort(rowIds, sortOrder, sortAwareConsumerComparator);
    // 2...Nth time sorting
    // any update that isn't an explicit sort we want to maintain order based on the previous
    const lastRowIdsHash = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))(lastSortedRowIds);
    const internalComparator = (rowId1, rowId2)=>{
        // both ids were already present, sort in their old older
        if (lastRowIdsHash[rowId1] !== undefined && lastRowIdsHash[rowId2] !== undefined) return Number(lastRowIdsHash[rowId1]) < Number(lastRowIdsHash[rowId2]) ? -1 : 1;
        // one of the ids is new, sort as expected by the consumer (including order)
        return sortAwareConsumerComparator(rowId1, rowId2);
    };
    return [
        ...rowIds
    ].sort(internalComparator);
};
const $a09ab1407e08597d$var$toLookupHash = (array)=>{
    if (!array) return {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hash = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))((0, (/*@__PURE__*/$parcel$interopDefault($kPH5D)))(array, (element)=>!!element), // eslint-disable-next-line no-return-assign
    (element)=>hash[element] = true);
    return hash;
};
const $a09ab1407e08597d$var$getRowIdsWithoutAddedRows = (rowIds, sortConfiguration, persistedAddedRows, lastSortedRowIds)=>{
    if (sortConfiguration.isSortOverrideEnabled) {
        const lastSortedRowIdsHash = $a09ab1407e08597d$var$toLookupHash(lastSortedRowIds);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Ot1C)))(rowIds, (rowId)=>persistedAddedRows !== undefined && persistedAddedRows[rowId] !== undefined && lastSortedRowIdsHash[rowId] === undefined);
    }
    return rowIds;
};
const $a09ab1407e08597d$var$traverseRows = (rowTree, parentRowId, rowIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash)=>{
    if (rowIds === undefined || rowIds.length === 0) return;
    // filter out added-rows, as they shouldn't be sorted but just inserted afterwards according to their position/anchor
    const sortableRowIds = $a09ab1407e08597d$var$getRowIdsWithoutAddedRows(rowIds, sortConfiguration, persistedAddedRows, sortedRowIdsHash[parentRowId] || []);
    const sortedRowIds = $a09ab1407e08597d$var$sortRowIds(sortableRowIds, sortConfiguration, sortedRowIdsHash[parentRowId] || []);
    const reSortedRowIds = (0, $f5kj3.default)(parentRowId, sortedRowIds, rowTree, persistedAddedRows);
    // eslint-disable-next-line no-param-reassign
    result[parentRowId] = reSortedRowIds;
    reSortedRowIds.forEach((rowId)=>{
        const { childrenIds: childrenIds } = rowTree.rows[rowId];
        $a09ab1407e08597d$var$traverseRows(rowTree, rowId, childrenIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash);
    });
};
const $a09ab1407e08597d$export$3da49b8141c52d70 = (rowTree, sortConfiguration, persistedAddedRows, sortedRowIdsHash)=>{
    const result = {};
    $a09ab1407e08597d$var$traverseRows(rowTree, (0, $ad3622039daefe23$export$59c500c4e33fdb0), rowTree.rootIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash);
    return result;
};
const $a09ab1407e08597d$var$DEFAULT_SORT_ORDER_FOR_COMPARATORS = (0, $960a7067bff9d918$export$6e386ac144cffab5);
const $a09ab1407e08597d$var$getSortConfiguration = (columnComparators, // @ts-expect-error - TS7006 - Parameter 'activeSortedColumnConfiguration' implicitly has an 'any' type.
activeSortedColumnConfiguration, defaultComparator, isSortOverrideEnabled)=>{
    // are we sorting by a particular comparator
    const activeSortedColumnComparator = activeSortedColumnConfiguration && columnComparators ? columnComparators[activeSortedColumnConfiguration.columnId] : undefined;
    // if we are not, use the default comparator
    const consumerComparator = activeSortedColumnComparator || defaultComparator;
    // which of the sort tri-state are we in
    // this is where the tri-state ASC/DESC/UNDEF is reduced to ASC/DESC to
    // keep the tri-state hidden from actual comparator implementations
    const sortOrder = activeSortedColumnConfiguration ? activeSortedColumnConfiguration.sortOrder : $a09ab1407e08597d$var$DEFAULT_SORT_ORDER_FOR_COMPARATORS;
    return {
        consumerComparator: consumerComparator,
        sortOrder: sortOrder,
        isSortOverrideEnabled: isSortOverrideEnabled
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a09ab1407e08597d$export$2e2bcd8739ae039 = ({ rowTree: rowTree, persistedAddedRows: persistedAddedRows, columnComparators: columnComparators, activeSortedColumnConfiguration: activeSortedColumnConfiguration, isSortOverrideEnabled: isSortOverrideEnabled, defaultComparator: defaultComparator, sortedRowIdsHash: sortedRowIdsHash })=>{
    if (!defaultComparator) return {
        [(0, $ad3622039daefe23$export$59c500c4e33fdb0)]: rowTree.rootIds
    };
    const sortConfiguration = $a09ab1407e08597d$var$getSortConfiguration(columnComparators, activeSortedColumnConfiguration, defaultComparator, isSortOverrideEnabled);
    return $a09ab1407e08597d$export$3da49b8141c52d70(rowTree, sortConfiguration, persistedAddedRows, sortedRowIdsHash);
};

});
parcelRegister("kPH5D", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $8BRGu = parcelRequire("8BRGu");

var $bxDef = parcelRequire("bxDef");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $f2a9fed894a6616c$var$filter(collection, predicate) {
    var func = $8LQ84(collection) ? $2GdQn : $8BRGu;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $f2a9fed894a6616c$var$filter;

});

parcelRegister("f5kj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b16ceaba4954d101$export$2e2bcd8739ae039);

var $lbWm4 = parcelRequire("lbWm4");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b16ceaba4954d101$export$2e2bcd8739ae039 = (parentRowId, baseRowIds, rowTree, anchoredRows)=>{
    if (!anchoredRows) return baseRowIds;
    const result = [
        ...baseRowIds
    ];
    // for each added row, insert based on the anchor
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anchoredRows, (anchorRow, anchoredRowId)=>{
        const { anchorId: anchorId, position: position } = anchorRow;
        if (position === 'FIRST') result.unshift(anchoredRowId);
        else if (position === 'LAST') result.push(anchoredRowId);
        else if (anchorId) {
            const anchorRowLocation = result.indexOf(anchorId);
            // the anchor row may not be in the set of currently visible things
            if (anchorRowLocation !== -1) {
                if (position === 'BEFORE') result.splice(anchorRowLocation, 0, anchoredRowId);
                else if (position === 'AFTER') {
                    const spliceOffset = 1;
                    result.splice(anchorRowLocation + spliceOffset, 0, anchoredRowId);
                }
            }
            if (position === 'INSIDE' && anchorId === parentRowId) result.splice(anchorRowLocation + 1, 0, anchoredRowId);
        }
    });
    return result;
};

});




parcelRegister("jkr7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1ca287f40ba6fe8$export$2e2bcd8739ae039);

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $eiuAu = parcelRequire("eiuAu");

var $5J7ao = parcelRequire("5J7ao");

var $3EKBz = parcelRequire("3EKBz");

var $Ifpim = parcelRequire("Ifpim");

var $btMnE = parcelRequire("btMnE");
var $b1ca287f40ba6fe8$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $btMnE.RE_SORT), (action, state)=>{
    const consumerState = (0, $eeWa5.getConsumerState)(state);
    const sortedRowIdsHash = (0, $3EKBz.default)((0, $3W7mX.getAddedRows)(state), (0, $3W7mX.getRowTree)(state), undefined, false, (0, $5J7ao.getActiveSortedColumnConfiguration)(state), (0, $5J7ao.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $eiuAu.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});
parcelRegister("btMnE", function(module, exports) {

$parcel$export(module.exports, "RE_SORT", () => $4370fbfb656b599a$export$e43c6499ab033999);
const $4370fbfb656b599a$export$e43c6499ab033999 = 'ops.columns.sorting.re-sort.RE_SORT';
const $4370fbfb656b599a$export$8f208e436e07f92 = ()=>({
        type: $4370fbfb656b599a$export$e43c6499ab033999
    });

});


parcelRegister("28Fb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a340e54a363908$export$2e2bcd8739ae039);

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $eiuAu = parcelRequire("eiuAu");

var $5J7ao = parcelRequire("5J7ao");

var $3EKBz = parcelRequire("3EKBz");

var $Ifpim = parcelRequire("Ifpim");

var $dRlnz = parcelRequire("dRlnz");
var $04a340e54a363908$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $dRlnz.SET_COLUMN_SORT_ORDER), (action, state)=>{
    const consumerState = (0, $eeWa5.getConsumerState)(state);
    const sortedRowIdsHash = (0, $3EKBz.default)((0, $3W7mX.getAddedRows)(state), (0, $3W7mX.getRowTree)(state), (0, $5J7ao.getActiveSortedColumnConfiguration)(state), false, action.payload, (0, $5J7ao.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $eiuAu.setColumnSortOrder)(action.payload),
        (0, $eiuAu.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});



parcelRegister("66dqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $57cc7da02ca9e50f$export$2e2bcd8739ae039);
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $eiuAu = parcelRequire("eiuAu");

var $dT0KB = parcelRequire("dT0KB");

var $gYkqR = parcelRequire("gYkqR");

var $eir10 = parcelRequire("eir10");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$57cc7da02ca9e50f$export$2e2bcd8739ae039 = (action$)=>{
    const errorHandler = (0, $gYkqR.errorHandlerFactory)();
    return (0, $dT0KB.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $eir10.SET_HEADER_HEIGHT))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .map((action)=>(0, $eiuAu.setHeaderHeight)(action.payload)).catch(errorHandler);
};

});
parcelRegister("dT0KB", function(module, exports) {

$parcel$export(module.exports, "withUnpackedBatchActions", () => $e6ca27aa764a19a3$export$25f000f90e13af6b);

var $aB8eX = parcelRequire("aB8eX");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");
const $e6ca27aa764a19a3$export$25f000f90e13af6b = (action$)=>action$.mergeMap((action)=>{
        if (action.type === (0, $aB8eX.BATCH)) return (0, $kVLXA.Observable).of(...action.payload);
        return (0, $kVLXA.Observable).of(action);
    });

});


parcelRegister("fdlRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cd7420d94824da9$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $4vECO = parcelRequire("4vECO");

var $e5A4Q = parcelRequire("e5A4Q");
var $8cd7420d94824da9$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $4vECO.default), (0, $e5A4Q.default));

});
parcelRegister("4vECO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2780795cfed2c7b5$export$2e2bcd8739ae039);

var $iYxwj = parcelRequire("iYxwj");

var $3W7mX = parcelRequire("3W7mX");

var $eiuAu = parcelRequire("eiuAu");

var $5J7ao = parcelRequire("5J7ao");

var $3EKBz = parcelRequire("3EKBz");

var $Ifpim = parcelRequire("Ifpim");

var $eir10 = parcelRequire("eir10");

var $27wgx = parcelRequire("27wgx");

var $a3fP7 = parcelRequire("a3fP7");
const $2780795cfed2c7b5$var$getScrollbarSize = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) {
        const { body: body } = document;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const scrollbarContainer = document.createElement('div');
        scrollbarContainer.setAttribute('style', `position: absolute;
             width: 100px;
             height: 100px;
             overflow: scroll;
             top: -9999px;`);
        body.appendChild(scrollbarContainer);
        // Pick arbitrary axis, both should have the same bar size
        const scrollbarSize = scrollbarContainer.offsetWidth - scrollbarContainer.clientWidth;
        body.removeChild(scrollbarContainer);
        return scrollbarSize;
    }
    return 0;
};
var $2780795cfed2c7b5$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $a3fP7.SET_STATE_FROM_PROPS), (action, state)=>{
    const { apiState: apiState, theme: theme } = action.payload;
    const { defaultSortedColumn: defaultSortedColumn, ...consumerState } = apiState;
    const sortedRowIdsHash = (0, $3EKBz.default)((0, $3W7mX.getAddedRows)(state), (0, $3W7mX.getRowTree)(state), (0, $5J7ao.getActiveSortedColumnConfiguration)(state), (0, $5J7ao.getIsSortOverrideEnabled)(state), defaultSortedColumn, (0, $5J7ao.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    const setActions = [
        (0, $iYxwj.setConsumerState)(consumerState),
        (0, $eiuAu.setSortedRowIdsHash)(sortedRowIdsHash),
        (0, $eir10.set)(theme.header.height),
        (0, $27wgx.set)(theme.row.borderWidth)
    ];
    if (consumerState.autoRowHeight) // @ts-expect-error - TS2345 - Argument of type 'SetScrollbarSizeAction' is not assignable to parameter of type 'SetSortedRowIdsHashAction | SetHeaderHeightAction | SetConsumerStateAction | SetRowBorderWidthAction'.
    setActions.push((0, $eiuAu.setScrollbarSize)($2780795cfed2c7b5$var$getScrollbarSize()));
    if (defaultSortedColumn) // @ts-expect-error - TS2345 - Argument of type 'SetColumnSortOrderAction' is not assignable to parameter of type 'SetSortedRowIdsHashAction | SetHeaderHeightAction | SetConsumerStateAction | SetRowBorderWidthAction'.
    setActions.push((0, $eiuAu.setColumnSortOrder)(defaultSortedColumn));
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return setActions;
});

});
parcelRegister("iYxwj", function(module, exports) {

$parcel$export(module.exports, "SET_CONSUMER_STATE", () => $228a912f547ae553$export$56c40290cf7dd948);
$parcel$export(module.exports, "setConsumerState", () => $228a912f547ae553$export$9444caca88c67753);
const $228a912f547ae553$export$56c40290cf7dd948 = 'state.consumer.SET_CONSUMER_STATE';
const $228a912f547ae553$export$9444caca88c67753 = (payload)=>({
        type: $228a912f547ae553$export$56c40290cf7dd948,
        payload: payload
    });

});

parcelRegister("27wgx", function(module, exports) {

$parcel$export(module.exports, "SET_ROW_BORDER_WIDTH", () => $b6833acb01d29270$export$a347b798ae4b070c);
$parcel$export(module.exports, "set", () => $b6833acb01d29270$export$adaa4cf7ef1b65be);
const $b6833acb01d29270$export$a347b798ae4b070c = 'ops.rows.row-border.SET_ROW_BORDER_WIDTH';
const $b6833acb01d29270$export$adaa4cf7ef1b65be = (width)=>({
        type: $b6833acb01d29270$export$a347b798ae4b070c,
        payload: width
    });

});


parcelRegister("e5A4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $06aa226d8c58e2be$export$2e2bcd8739ae039);

var $ajpes = parcelRequire("ajpes");

var $iYxwj = parcelRequire("iYxwj");

var $bFTY1 = parcelRequire("bFTY1");

var $eeWa5 = parcelRequire("eeWa5");

var $3W7mX = parcelRequire("3W7mX");

var $eiuAu = parcelRequire("eiuAu");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $3EKBz = parcelRequire("3EKBz");

var $Ifpim = parcelRequire("Ifpim");

var $8UBZI = parcelRequire("8UBZI");

var $8pQu6 = parcelRequire("8pQu6");
const $06aa226d8c58e2be$var$getActiveRowSync = (state, consumerState)=>{
    if ((0, $eeWa5.isInRowNavigationMode)(state)) {
        const activeRowIndex = (0, $iN58L.getActiveRowIndex)(state);
        const { rootIds: rootIds } = consumerState.rowTree;
        if (consumerState.contentKey !== state.consumer.contentKey) return [
            (0, $eiuAu.clearActiveItem)()
        ];
        if (activeRowIndex !== undefined) {
            if (!rootIds.length) return [
                (0, $eiuAu.clearActiveItem)()
            ];
            if (rootIds[activeRowIndex] === undefined) return [
                (0, $8UBZI.setActiveRow)({
                    rowIndex: rootIds.length - 1
                })
            ];
            // Causes the row to refocus in the case that it is rerendered
            return [
                (0, $8UBZI.setActiveRow)({
                    rowIndex: activeRowIndex,
                    setFocusOnRow: true
                })
            ];
        }
    }
    return [];
};
const $06aa226d8c58e2be$var$isSameColumnSet = (state, nextColumns)=>{
    const prevColumnIds = (0, $bFTY1.getAllColumnIds)(state);
    const nextColumnIds = nextColumns.map((column)=>column.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(new Set([
        prevColumnIds
    ]), new Set([
        nextColumnIds
    ]));
};
// Strictly speaking the property we care about is the that the width of
// multiline columns is unchanged, as this may in turn influence cell height
// if any multi-line column is present.
//
// Invalidating this isn't essential, but may save briefly underbuffering w/
// virtualisation.  Hence we use the same set of columns as a proxy for change
// to multiline column width.
const $06aa226d8c58e2be$var$isRowHeightMapStale = (state, nextColumns)=>!$06aa226d8c58e2be$var$isSameColumnSet(state, nextColumns) && (0, $bFTY1.hasAnyMultiLineColumn)(state);
const $06aa226d8c58e2be$var$getRowHeightMappingInvalidation = (state, consumerState)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const nextColumns = Object.values(consumerState.columnTree.columns);
    if ($06aa226d8c58e2be$var$isRowHeightMapStale(state, nextColumns)) return [
        (0, $eiuAu.clearRowHeightMapping)()
    ];
    return [];
};
const $06aa226d8c58e2be$var$getConditionalActions = (state, consumerState)=>[
        ...$06aa226d8c58e2be$var$getActiveRowSync(state, consumerState),
        ...$06aa226d8c58e2be$var$getRowHeightMappingInvalidation(state, consumerState)
    ];
var $06aa226d8c58e2be$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $8pQu6.UPDATE_STATE_FROM_PROPS), (action, state)=>{
    const { defaultSortedColumn: defaultSortedColumn, ...consumerState } = action.payload;
    const sortedRowIdsHash = (0, $3EKBz.default)((0, $3W7mX.getAddedRows)(state), (0, $3W7mX.getRowTree)(state), (0, $5J7ao.getActiveSortedColumnConfiguration)(state), true, (0, $5J7ao.getActiveSortedColumnConfiguration)(state), (0, $5J7ao.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $iYxwj.setConsumerState)(consumerState),
        ...$06aa226d8c58e2be$var$getConditionalActions(state, action.payload),
        (0, $eiuAu.setSortOrderWithOverride)({
            isSortOverrideEnabled: true
        }),
        (0, $eiuAu.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});


parcelRegister("4lMCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f2d473b2f24c93$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $dGuRp = parcelRequire("dGuRp");
var $18f2d473b2f24c93$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $dGuRp.default));

});
parcelRegister("dGuRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $066cba4e32471bd5$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $iHibI = parcelRequire("iHibI");

var $ab3be = parcelRequire("ab3be");
var $066cba4e32471bd5$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $iHibI.default), (0, $ab3be.default));

});
parcelRegister("iHibI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c6a2dcca15ab561$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("8n054");
parcelRequire("d0pqD");
parcelRequire("7qVV7");
parcelRequire("6cbqE");

var $eeWa5 = parcelRequire("eeWa5");

var $eiuAu = parcelRequire("eiuAu");

var $8UBZI = parcelRequire("8UBZI");

var $4bxwW = parcelRequire("4bxwW");
var /* We don't want a cell to blur if we are only doing so to focus another cell. */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$9c6a2dcca15ab561$export$2e2bcd8739ae039 = (action, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>action.ofType((0, $4bxwW.CLEAR_ACTIVE_ITEM)).switchMap(()=>(0, $kVLXA.Observable).timer(50).map(()=>{
            (0, $eeWa5.getActiveItemChangedCallback)(store.getState())(undefined);
            const getActiveRowIdChanged = (0, $eeWa5.getActiveRowIdChangedCallback)(store.getState());
            if (getActiveRowIdChanged != null) getActiveRowIdChanged(undefined);
            return (0, $eiuAu.clearActiveItem)();
        }).takeUntil(action.ofType((0, $8UBZI.SET_ACTIVE_CELL), (0, $8UBZI.SET_ACTIVE_ROW))));

});

parcelRegister("ab3be", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ecd3138f55efed$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $e1AU2 = parcelRequire("e1AU2");

var $kVLXA = parcelRequire("kVLXA");

var $eeWa5 = parcelRequire("eeWa5");

var $eiuAu = parcelRequire("eiuAu");

var $iN58L = parcelRequire("iN58L");

var $dT0KB = parcelRequire("dT0KB");

var $gYkqR = parcelRequire("gYkqR");

var $Ifpim = parcelRequire("Ifpim");

var $8UBZI = parcelRequire("8UBZI");
const $97ecd3138f55efed$export$4237cfdec709360b = (0, $Ifpim.defineTransaction)((0, $8UBZI.SET_ACTIVE_CELL), (action)=>(0, $eiuAu.setActiveItem)(action.payload));
const $97ecd3138f55efed$export$436fa03bfc3ce94c = (action$, store)=>{
    const errorHandler = (0, $gYkqR.errorHandlerFactory)();
    return (0, $dT0KB.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $8UBZI.SET_ACTIVE_ROW))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .mergeMap((action)=>{
        const state = store.getState();
        const activeRowIdChanged = (0, $eeWa5.getActiveRowIdChangedCallback)(state);
        if (activeRowIdChanged != null) {
            const activeRowId = (0, $iN58L.rowIndexToRowId)(state, action.payload.rowIndex);
            activeRowIdChanged(activeRowId);
        }
        return (0, $kVLXA.Observable).of((0, $eiuAu.setActiveItem)(action.payload));
    }).catch(errorHandler);
};
var $97ecd3138f55efed$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($97ecd3138f55efed$export$4237cfdec709360b, $97ecd3138f55efed$export$436fa03bfc3ce94c);

});



parcelRegister("h83ok", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e363013abbc23b$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $hX7H1 = parcelRequire("hX7H1");

var $df0SM = parcelRequire("df0SM");

var $emqfu = parcelRequire("emqfu");

var $3eyvu = parcelRequire("3eyvu");

var $ebaFx = parcelRequire("ebaFx");
var $f1e363013abbc23b$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $hX7H1.default), (0, $emqfu.default), (0, $ebaFx.default), (0, $3eyvu.default), (0, $df0SM.default));

});
parcelRegister("hX7H1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d14c0a08d6340f86$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $kdbgI = parcelRequire("kdbgI");

var $i4f0k = parcelRequire("i4f0k");
var $d14c0a08d6340f86$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $i4f0k.default), (0, $kdbgI.default));

});
parcelRegister("kdbgI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f08da0db2b37c21c$export$2e2bcd8739ae039);

var $eiuAu = parcelRequire("eiuAu");

var $Ifpim = parcelRequire("Ifpim");

var $Xiy7s = parcelRequire("Xiy7s");
var $f08da0db2b37c21c$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $Xiy7s.CLEAR_MULTI_ADD_ANCHOR), ()=>(0, $eiuAu.clearMultiAddAnchor)());

});
parcelRegister("Xiy7s", function(module, exports) {

$parcel$export(module.exports, "CLEAR_MULTI_ADD_ANCHOR", () => $33c59abd9d9d4b64$export$28f3def567195a3c);
const $33c59abd9d9d4b64$export$28f3def567195a3c = 'ops.rows.add-anchor.clear.CLEAR_MULTI_ADD_ANCHOR';
const $33c59abd9d9d4b64$export$42ffd38884aecdac = ()=>({
        type: $33c59abd9d9d4b64$export$28f3def567195a3c
    });

});


parcelRegister("i4f0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfda2866bdcd645d$export$2e2bcd8739ae039);

var $eiuAu = parcelRequire("eiuAu");

var $Ifpim = parcelRequire("Ifpim");

var $dTQhq = parcelRequire("dTQhq");
var $cfda2866bdcd645d$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $dTQhq.SET_MULTI_ADD_ANCHOR), (action)=>(0, $eiuAu.setMultiAddAnchor)(action.payload));

});


parcelRegister("df0SM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cefebe30027df9f2$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("4ma2a");
parcelRequire("64ZAE");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $1bJTy = parcelRequire("1bJTy");

var $3W7mX = parcelRequire("3W7mX");

var $iN58L = parcelRequire("iN58L");

var $g1bZP = parcelRequire("g1bZP");
// Buffer all loading row analytics events for 15s and fire as one event
const $cefebe30027df9f2$var$BUFFER_TIME = 15000;
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$cefebe30027df9f2$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $g1bZP.FIRE_LOADING_ROW_ANALYTICS)).bufferTime($cefebe30027df9f2$var$BUFFER_TIME).do((actions)=>{
        const eventAttributes = [];
        let lastAnalyticsEvent;
        actions.forEach((action)=>{
            const { rowId: rowId, timeVisibleFor: timeVisibleFor, numberOfLoadingRows: numberOfLoadingRows, reasonType: reasonType, analyticsEvent: analyticsEvent } = action.payload;
            const state = store.getState();
            const { displayStart: displayStart, displayEnd: displayEnd } = (0, $iN58L.getVirtualBoundaries)(state);
            // check if the rowId was removed from the tree due to row data update
            const rowStillExists = !!(0, $3W7mX.getRow)(state, rowId);
            // check if the row, if exists, is still in 'loading' state
            const isStillLoading = rowStillExists && (0, $3W7mX.isRowLoading)(state, rowId);
            // check if the row is in the display boundary
            const intRowId = parseInt(rowId, 10);
            const isInDisplayBoundary = intRowId >= 0 && intRowId >= displayStart && intRowId <= displayEnd;
            // gather all event attributes into one for all the events fired within BUFFER_TIME
            eventAttributes.push({
                displayStart: displayStart,
                displayEnd: displayEnd,
                numberOfLoadingRows: numberOfLoadingRows,
                reasonType: reasonType,
                timeVisibleFor: timeVisibleFor,
                rowIdStillExists: !!rowStillExists,
                isInDisplayBoundary: isInDisplayBoundary,
                gotFulfilled: !isStillLoading
            });
            lastAnalyticsEvent = analyticsEvent;
        });
        // fire the event
        lastAnalyticsEvent && (0, $1bJTy.fireOperationalAnalytics)(lastAnalyticsEvent, {
            containerType: 'loadingRow',
            attributes: {
                eventAttributes: eventAttributes
            }
        });
    }).switchMap(()=>(0, $kVLXA.Observable).empty());

});

parcelRegister("emqfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d4fa53916df6f94$export$2e2bcd8739ae039);


var $iN58L = parcelRequire("iN58L");

var $Ifpim = parcelRequire("Ifpim");

var $8UBZI = parcelRequire("8UBZI");

var $eckup = parcelRequire("eckup");
const $1d4fa53916df6f94$var$getNextRowIndex = (state, direction)=>{
    switch(direction){
        case 0, $bc003a5da339d04c$export$b29f845fa4b57508:
            return (0, $iN58L.getPrevActiveRowIndex)(state);
        case 0, $bc003a5da339d04c$export$c7c029a231f98d34:
            return (0, $iN58L.getNextActiveRowIndex)(state);
        default:
            throw new Error('illegal value of the direction property.');
    }
};
var $1d4fa53916df6f94$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $eckup.NAVIGATE_TO_ROW), (action, state)=>(0, $8UBZI.setActiveRow)({
        rowIndex: $1d4fa53916df6f94$var$getNextRowIndex(state, action.payload.direction),
        setFocusOnRow: true
    }));

});

parcelRegister("3eyvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb41baf564c79ba9$export$2e2bcd8739ae039);
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $eiuAu = parcelRequire("eiuAu");

var $dT0KB = parcelRequire("dT0KB");

var $gYkqR = parcelRequire("gYkqR");

var $27wgx = parcelRequire("27wgx");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$cb41baf564c79ba9$export$2e2bcd8739ae039 = (action$)=>{
    const errorHandler = (0, $gYkqR.errorHandlerFactory)();
    return (0, $dT0KB.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $27wgx.SET_ROW_BORDER_WIDTH))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .map((action)=>(0, $eiuAu.setRowBorderWidth)(action.payload)).catch(errorHandler);
};

});

parcelRegister("ebaFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e8bf75790aeb9a$export$2e2bcd8739ae039);

var $eiuAu = parcelRequire("eiuAu");

var $Ifpim = parcelRequire("Ifpim");

var $7LVdM = parcelRequire("7LVdM");
const $41e8bf75790aeb9a$var$batchUpdateRowHeightMappingEpic = (0, $Ifpim.defineTransaction)((0, $7LVdM.BATCH_UPDATE_ROW_HEIGHT_MAPPING), (action)=>(0, $eiuAu.batchUpdateRowHeightMapping)(action.payload.rowIds, action.payload.rowHeightMapping));
var $41e8bf75790aeb9a$export$2e2bcd8739ae039 = $41e8bf75790aeb9a$var$batchUpdateRowHeightMappingEpic;

});


parcelRegister("4FaQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3165994932f20cb$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $fp6Pk = parcelRequire("fp6Pk");

var $c8UrU = parcelRequire("c8UrU");

var $9gdQ8 = parcelRequire("9gdQ8");

var $gYBsv = parcelRequire("gYBsv");

var $la5Ck = parcelRequire("la5Ck");
var $d3165994932f20cb$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $c8UrU.default), (0, $la5Ck.default), (0, $fp6Pk.default), (0, $gYBsv.default), (0, $9gdQ8.default));

});
parcelRegister("fp6Pk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51be03b864416a8$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("eSGL3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $e1AU2 = parcelRequire("e1AU2");

var $kVLXA = parcelRequire("kVLXA");

var $iYxwj = parcelRequire("iYxwj");

var $eeWa5 = parcelRequire("eeWa5");

var $eiuAu = parcelRequire("eiuAu");

var $iN58L = parcelRequire("iN58L");

var $dT0KB = parcelRequire("dT0KB");

var $gYkqR = parcelRequire("gYkqR");
const $a51be03b864416a8$var$DEBOUNCE_MILLIS = 100;
const $a51be03b864416a8$var$handleOffsetChange = (store)=>{
    const state = store.getState();
    const onHorizontalScrollOffsetChanged = (0, $eeWa5.getHorizontalScrollOffsetChangedCallback)(state);
    if (onHorizontalScrollOffsetChanged) {
        const offsetFromLeft = (0, $iN58L.getOffsetFromLeft)(state);
        const offsetFromRight = (0, $iN58L.getOffsetFromRight)(state);
        onHorizontalScrollOffsetChanged({
            offsetFromLeft: offsetFromLeft,
            offsetFromRight: offsetFromRight
        });
    }
    return (0, $kVLXA.Observable).empty();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a51be03b864416a8$var$debouncedEpic = (action$, store)=>{
    const errorHandler = (0, $gYkqR.errorHandlerFactory)();
    return (0, $dT0KB.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $eiuAu.SET_HORIZONTAL_SCROLL_OFFSET), (0, $eiuAu.SET_TABLE_SIZE)).debounceTime($a51be03b864416a8$var$DEBOUNCE_MILLIS).mergeMap(()=>$a51be03b864416a8$var$handleOffsetChange(store)).catch(errorHandler);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a51be03b864416a8$var$consumerStateEpic = (action$, store)=>{
    const errorHandler = (0, $gYkqR.errorHandlerFactory)();
    return (0, $dT0KB.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $iYxwj.SET_CONSUMER_STATE)).mergeMap(()=>$a51be03b864416a8$var$handleOffsetChange(store)).catch(errorHandler);
};
var $a51be03b864416a8$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($a51be03b864416a8$var$debouncedEpic, $a51be03b864416a8$var$consumerStateEpic);

});

parcelRegister("c8UrU", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d558c21819a3e0$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("jFVZ1");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $eiuAu = parcelRequire("eiuAu");

var $5J7ao = parcelRequire("5J7ao");

var $gYkqR = parcelRequire("gYkqR");

var $kSeJ5 = parcelRequire("kSeJ5");
const $95d558c21819a3e0$var$errorHandler = (0, $gYkqR.errorHandlerFactory)();
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d558c21819a3e0$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $kSeJ5.SET_SCROLL_OFFSET))// @ts-expect-error - TS2345 - Argument of type '(action: SetScrollOffsetAction) => Observable<SetVerticalScrollOffsetAction | SetVerticalScrollDeltaAction> | Observable<...>' is not assignable to parameter of type '(value: SetScrollOffsetAction, index: number) => ObservableInput<SetVerticalScrollOffsetAction | SetVerticalScrollDeltaAction>'.
    .mergeMap((action)=>{
        if (action.payload.direction === 'VERTICAL') {
            const lastPos = (0, $5J7ao.getVerticalScrollOffset)(store.getState());
            const delta = lastPos - action.payload.offset;
            return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $eiuAu.setVerticalScrollOffset)(action.payload.offset)), (0, $kVLXA.Observable).of((0, $eiuAu.setVerticalScrollDelta)(delta)));
        }
        if (action.payload.direction === 'HORIZONTAL') return (0, $kVLXA.Observable).of((0, $eiuAu.setHorizontalScrollOffset)(action.payload.offset));
        throw new Error(`The direction property ${action.payload.direction} value is illegal.`);
    }).catch($95d558c21819a3e0$var$errorHandler);

});

parcelRegister("9gdQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $31514d4a6e686d90$export$2e2bcd8739ae039);

var $eiuAu = parcelRequire("eiuAu");

var $Ifpim = parcelRequire("Ifpim");

var $kZksW = parcelRequire("kZksW");
var $31514d4a6e686d90$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $kZksW.SET_SCROLLBAR_SIZE), (action)=>(0, $eiuAu.setScrollbarSize)(action.payload));

});

parcelRegister("gYBsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d0ac9b025a5e8cd$export$2e2bcd8739ae039);


var $bFTY1 = parcelRequire("bFTY1");

var $eiuAu = parcelRequire("eiuAu");

var $iN58L = parcelRequire("iN58L");

var $4XO5t = parcelRequire("4XO5t");

var $Ifpim = parcelRequire("Ifpim");

var $jfml7 = parcelRequire("jfml7");
var $5d0ac9b025a5e8cd$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $jfml7.SCROLL_TO_ROW), (action, state)=>{
    const rowIds = (0, $4XO5t.getFlattenedWithAddedRowIds)(state);
    const rowIndex = rowIds.indexOf(action.payload);
    // if row is invalid/not visible then clear the active item
    if (rowIndex === -1) return (0, $eiuAu.clearActiveItem)();
    // A row is 36px high, including the 1px border. These borders
    // overlap leading to an offset height for scrolling as 36px - 1px
    return [
        (0, $eiuAu.setActiveItem)({
            type: (0, $b7a603c640ae8033$export$4b3489234fd17200),
            rowId: action.payload,
            columnId: (0, $bFTY1.getVisibleCoreColumnIds)(state)[0]
        }),
        (0, $eiuAu.setVerticalScrollOffset)((0, $iN58L.getScrollOffsetForRowIndex)(state, rowIndex))
    ];
});

});

parcelRegister("la5Ck", function(module, exports) {

$parcel$export(module.exports, "default", () => $062ad3872a6436c3$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("eSGL3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $iYxwj = parcelRequire("iYxwj");

var $eeWa5 = parcelRequire("eeWa5");

var $eiuAu = parcelRequire("eiuAu");

var $iN58L = parcelRequire("iN58L");

var $dT0KB = parcelRequire("dT0KB");

var $gYkqR = parcelRequire("gYkqR");
const $062ad3872a6436c3$var$DEBOUNCE_MILLIS = 16;
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$062ad3872a6436c3$export$2e2bcd8739ae039 = (action$, store)=>{
    const errorHandler = (0, $gYkqR.errorHandlerFactory)();
    return (0, $dT0KB.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $eiuAu.SET_VERTICAL_SCROLL_OFFSET), (0, $eiuAu.SET_TABLE_SIZE), (0, $iYxwj.SET_CONSUMER_STATE)).debounceTime($062ad3872a6436c3$var$DEBOUNCE_MILLIS).mergeMap(()=>{
        const state = store.getState();
        const onVerticalScrollOffsetChanged = (0, $eeWa5.getVerticalScrollOffsetChangedCallback)(state);
        if (onVerticalScrollOffsetChanged) {
            const virtualBoundaries = (0, $iN58L.getVirtualBoundaries)(state);
            onVerticalScrollOffsetChanged({
                ...virtualBoundaries,
                offsetFromTop: (0, $iN58L.getOffsetFromTop)(state),
                offsetFromBottom: (0, $iN58L.getOffsetFromBottom)(state)
            });
        }
        return (0, $kVLXA.Observable).empty();
    }).catch(errorHandler);
};

});


parcelRegister("h3wZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ee9821e1a87d2b4$export$2e2bcd8739ae039);

var $eiuAu = parcelRequire("eiuAu");

var $Ifpim = parcelRequire("Ifpim");

var $dnN17 = parcelRequire("dnN17");
var $6ee9821e1a87d2b4$export$2e2bcd8739ae039 = (0, $Ifpim.defineTransaction)((0, $dnN17.SET_TABLE_SIZE), (action)=>(0, $eiuAu.setTableSize)(action.payload));

});


parcelRegister("fs1x7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0cbe7048aa2cfe$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $k35Rk = parcelRequire("k35Rk");

var $d15BB = parcelRequire("d15BB");
var $7b0cbe7048aa2cfe$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    consumer: $k35Rk.default,
    internal: $d15BB.default
});

});
parcelRegister("k35Rk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a97f3e45302175$export$2e2bcd8739ae039);


var $iYxwj = parcelRequire("iYxwj");
const $e4a97f3e45302175$var$initialState = {
    maxDepth: 0,
    addLinkCaption: undefined,
    DetailsPanelComponent: undefined,
    NonTemporaryCellWrapper: undefined,
    autoHeight: true,
    showShadowAtBottom: false,
    navigationMode: (0, $b7a603c640ae8033$export$8ea4ff4da61b68e4),
    rowTree: {
        rows: {},
        rootIds: []
    },
    rowsConfiguration: {},
    addedRows: undefined,
    expandedRowIds: [],
    columnTree: {
        columns: {},
        rootCoreIds: [],
        rootAdditionalIds: []
    },
    expandedColumnIds: [],
    columnWidths: {},
    sortedColumnIds: undefined,
    draggableColumns: false,
    LoadingRowComponent: undefined,
    callbacks: {},
    ariaLabel: undefined
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$e4a97f3e45302175$export$2e2bcd8739ae039 = (state = $e4a97f3e45302175$var$initialState, action)=>{
    switch(action.type){
        case 0, $iYxwj.SET_CONSUMER_STATE:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});



parcelRegister("77TUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa0e741c87f1bba4$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");



var $jdQss = parcelRequire("jdQss");
const $aa0e741c87f1bba4$var$getValueOrFallback = (value, fallback)=>value === undefined ? fallback : value;
const $aa0e741c87f1bba4$var$traverseColumns = (columns, columnMap, parentChildrenIds)=>{
    columns.forEach((column)=>{
        let childrenIds;
        // eslint-disable-next-line no-param-reassign
        columnMap[column.id] = {
            id: column.id,
            title: column.title,
            HeaderComponent: column.HeaderComponent,
            tooltip: column.tooltip,
            defaultWidth: column.minWidth,
            minWidth: column.minWidth,
            maxWidth: column.maxWidth,
            // FSN-4987 Remove resize strategy related logic during cleanup
            resizeStrategy: (0, $960a7067bff9d918$export$4670af9f718b9e66),
            isHideable: false,
            isDraggable: false,
            isMarkup: false,
            isDefaultAdd: false,
            color: undefined,
            childrenIds: childrenIds,
            parentId: undefined,
            canBeMultiLine: $aa0e741c87f1bba4$var$getValueOrFallback(column.canBeMultiLine, false),
            CellComponent: column.CellComponent
        };
        parentChildrenIds.push(column.id);
    });
};
const $aa0e741c87f1bba4$var$transformColumns = (0, $8QpSo.default)((columns)=>{
    const columnTree = {
        columns: {},
        rootCoreIds: [],
        rootAdditionalIds: []
    };
    $aa0e741c87f1bba4$var$traverseColumns(columns, columnTree.columns, columnTree.rootAdditionalIds);
    return columnTree;
});
const $aa0e741c87f1bba4$var$transformRows = (0, $8QpSo.default)((rowIds)=>{
    const rowTree = {
        rootIds: [],
        rows: {}
    };
    rowIds.forEach((id)=>{
        if (!rowTree.rows[id]) rowTree.rows[id] = {
            id: id,
            parentId: undefined,
            childrenIds: []
        };
        // we've reached the root, add ourselves to rootIds
        rowTree.rootIds.push(id);
    });
    return rowTree;
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa0e741c87f1bba4$export$2e2bcd8739ae039 = (props)=>({
        // Table general
        facade: (0, $be36c2c2b492883c$export$88a597d0c7ae97b),
        maxDepth: 0,
        DetailsPanelComponent: undefined,
        NonTemporaryCellWrapper: props.NonTemporaryCellWrapper,
        autoHeight: false,
        showDecalAtBottom: props.showDecalAtBottom,
        navigationMode: props.navigationMode,
        addLinkCaption: undefined,
        addedRows: undefined,
        isContentStale: props.isContentStale,
        shouldSkipVirtualization: props.shouldSkipVirtualization,
        shouldHideLoadingIndicator: props.shouldHideLoadingIndicator,
        shouldRerenderRowOnHover: props.shouldRerenderRowOnHover,
        contentKey: props.contentKey,
        ariaLabel: props.ariaLabel,
        // Rows
        rowTree: $aa0e741c87f1bba4$var$transformRows(props.rowIds),
        rowsConfiguration: props.rowsConfiguration,
        rowHeight: props.defaultRowHeight,
        autoRowHeight: props.autoRowHeight,
        draggableRows: props.draggableRows,
        defaultComparator: undefined,
        expandedRowIds: [],
        // @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'Optional<LoadingRowComponent>'.
        LoadingRowComponent: (0, $jdQss.default),
        disableRowHighlight: props.disableRowHighlight,
        // Columns
        columnTree: $aa0e741c87f1bba4$var$transformColumns(props.columns),
        expandedColumnIds: props.expandedColumnIds,
        columnWidths: props.columnWidths,
        hiddenColumnIds: [],
        minAdditionalColumnsWidth: 0,
        defaultSortedColumn: undefined,
        columnComparators: {},
        sortedColumnIds: undefined,
        draggableColumns: false,
        premiumSLAColumnIds: props.premiumSLAColumnIds,
        callbacks: {
            onActiveRowIdChanged: props.onActiveRowIdChanged,
            onActiveItemChanged: props.onActiveItemChanged,
            onDisplayedRowsChanged: props.onDisplayedRowsChanged,
            onVerticalScrollOffsetChanged: props.onVerticalScrollOffsetChanged,
            onHorizontalScrollOffsetChanged: props.onHorizontalScrollOffsetChanged,
            onRowListFocusFunctionChanged: props.onRowListFocusFunctionChanged,
            onReactPortalContainerRefChanged: props.onReactPortalContainerRefChanged,
            onRowExpansionChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onColumnExpansionChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onColumnMoveRequested: undefined,
            onChangeHiddenColumnsRequested: undefined,
            onRowAddRequested: undefined,
            onClearAddedRowsRequested: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onPersistAddedRowRequested: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancelAddedRowRequested: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSortedColumnChanged: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSortedRowIdsChanged: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }
    });

});
parcelRegister("jdQss", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83e90d758810018$export$2e2bcd8739ae039);

var $1kDks = parcelRequire("1kDks");

var $3W7mX = parcelRequire("3W7mX");

var $5J7ao = parcelRequire("5J7ao");

var $iN58L = parcelRequire("iN58L");

var $lsHL0 = parcelRequire("lsHL0");
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1.
$e83e90d758810018$export$2e2bcd8739ae039 = (0, $1kDks.connect)((state, ownProps)=>({
        virtualBoundaries: (0, $iN58L.getVirtualBoundaries)(state),
        numberOfLoadingRows: (0, $iN58L.getNumberOfLoadingRowsInDisplayBoundary)(state),
        rowHeight: (0, $3W7mX.getRowHeight)(state, ownProps.id),
        tableWidth: (0, $5J7ao.getTableWidth)(state),
        tableHasRightShadow: (0, $iN58L.isHorizontalScrollRightShadowVisible)(state),
        isActiveItem: (0, $iN58L.isActiveRowItem)(state, ownProps.id),
        isRowLeftEdgeVisible: (0, $iN58L.getOffsetFromLeft)(state) === 0,
        isRowRightEdgeVisible: (0, $iN58L.getOffsetFromRight)(state) === 0,
        renderSidebarIcon: ownProps.renderSidebarIcon
    }))((0, $lsHL0.default));

});
parcelRegister("lsHL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9017dab1c32968$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8RXs9 = parcelRequire("8RXs9");

var $aBsQD = parcelRequire("aBsQD");

var $6iCoB = parcelRequire("6iCoB");

var $dsJhF = parcelRequire("dsJhF");
const $ba9017dab1c32968$var$WIDE_SKELETON_WIDTH_PX = 616;
const $ba9017dab1c32968$var$SHORT_SKELETON_WIDTH_PX = 408;
const $ba9017dab1c32968$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS = $ba9017dab1c32968$var$WIDE_SKELETON_WIDTH_PX + 200;
const $ba9017dab1c32968$var$SKELETON_HEIGHT = 20; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba9017dab1c32968$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { rowHeight: rowHeight, noRightMargin: noRightMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1px358m": (0, $lD23V.default)(`${__cmplp.rowHeight}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1qdi _kqswh2mm _1e0c1txw _4cvr1h6o",
            __cmplp.noRightMargin ? "_2hwxze3t" : "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $ba9017dab1c32968$var$shimmer = null;
const $ba9017dab1c32968$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rko1y44 _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhkh3tw _1itk14a4 _12vemgnk _4t3i2nrh _p12f1hdq",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $ba9017dab1c32968$var$LoadingRow extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { id: id, rowHeight: rowHeight, reasonType: reasonType, onRowContentUpdate: onRowContentUpdate } = this.props;
        onRowContentUpdate && onRowContentUpdate(id, rowHeight);
        this.timestampMounted = Date.now();
        this.initialReasonType = reasonType;
        if (this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.addEventListener('focusin', this.props.onFocusCallback);
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isActiveItem && this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
    }
    componentWillUnmount() {
        const { id: id, onUnmount: onUnmount, numberOfLoadingRows: numberOfLoadingRows, virtualBoundaries: { displayStart: displayStart } } = this.props;
        const timeVisibleFor = Date.now() - this.timestampMounted;
        onUnmount && onUnmount(numberOfLoadingRows, displayStart, id, timeVisibleFor, // @ts-expect-error Argument of type 'string' is not assignable to parameter of type 'UIAnalyticsEvent'.
        this.initialReasonType);
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.removeEventListener('focusin', this.props.onFocusCallback);
    }
    baseSkeletonWidth() {
        const { rowIndex: rowIndex } = this.props;
        return rowIndex % 2 ? $ba9017dab1c32968$var$SHORT_SKELETON_WIDTH_PX : $ba9017dab1c32968$var$WIDE_SKELETON_WIDTH_PX;
    }
    skeletonWidth() {
        const { tableWidth: tableWidth } = this.props;
        const baseWidth = this.baseSkeletonWidth();
        if (tableWidth < $ba9017dab1c32968$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS) {
            const scalingFactor = tableWidth / $ba9017dab1c32968$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS;
            return Math.ceil(baseWidth * scalingFactor);
        }
        return baseWidth;
    }
    render() {
        const { rowHeight: rowHeight, tableHasRightShadow: tableHasRightShadow, isActiveItem: isActiveItem, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, onClick: onClick, intl: { formatMessage: formatMessage }, theme: theme } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba9017dab1c32968$var$Wrapper // @ts-expect-error - TS2322 - The expected type comes from property onClick which is declared here on type IntrinsicAttributes & { rowHeight: number; noRightMargin: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
        , {
            onClick: onClick,
            rowHeight: rowHeight,
            noRightMargin: tableHasRightShadow,
            isActiveItem: isActiveItem,
            ref: this.myRef,
            tabIndex: 0,
            "aria-label": formatMessage((0, $dsJhF.default).loadingRow),
            role: "button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba9017dab1c32968$export$8f31e4c4a37b8e9c, {
            width: this.skeletonWidth(),
            height: $ba9017dab1c32968$var$SKELETON_HEIGHT
        }), isActiveItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBsQD.RowHighlight), {
            theme: theme,
            isRowLeftEdgeVisible: isRowLeftEdgeVisible,
            isRowRightEdgeVisible: isRowRightEdgeVisible
        }));
    }
    constructor(...args){
        super(...args), this.myRef = /*#__PURE__*/ (0, $5uXOq.createRef)() // @ts-expect-error - TS2564 - Property 'timestampMounted' has no initializer and is not definitely assigned in the constructor.
        ;
    }
}
var $ba9017dab1c32968$export$2e2bcd8739ae039 = (0, $8RXs9.default)((0, $6iCoB.withTheme)($ba9017dab1c32968$var$LoadingRow));

});
parcelRegister("dsJhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a6503ace978d56c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9a6503ace978d56c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingRow: {
        "id": "virtual-table.app.table.loading-row.loading-row",
        "defaultMessage": "Loading row contents"
    }
});

});





parcelRegister("cHNkc", function(module, exports) {

$parcel$export(module.exports, "createCellsCache", () => $d6c36617a856f8c3$export$b8f5d4dcd5b8c653);

var $5uXOq = parcelRequire("5uXOq");

var $gJBT6 = parcelRequire("gJBT6");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $85IQg = parcelRequire("85IQg");

var $103nj = parcelRequire("103nj");

var $luTJi = parcelRequire("luTJi");
const $d6c36617a856f8c3$var$LOCATION = 'issue-table.view.create-cell.view';
const $d6c36617a856f8c3$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
const $d6c36617a856f8c3$var$cacheResolver = (jsonComponentArgs, mergedColumnProps)=>mergedColumnProps.fieldId;
const $d6c36617a856f8c3$export$24c442202b6913f7 = (jsonComponentArgs, mergedColumnProps, FieldDataSelector)=>class Cell extends (0, $5uXOq.Component) {
        componentDidCatch(error) {
            const { fieldType: fieldType, fieldId: fieldId } = mergedColumnProps;
            const event = {
                fieldDescriptor: JSON.stringify({
                    fieldId: fieldId,
                    fieldType: fieldType
                }),
                privacySafeRowId: JSON.stringify($d6c36617a856f8c3$export$4983e1eef8c41de4(this.props.rowId))
            };
            (0, $dJl1T.default).safeErrorWithoutCustomerData($d6c36617a856f8c3$var$LOCATION, `create cell component failed to render: ${String(error)}`, event);
            (0, $jcw0u.default)({
                meta: {
                    id: 'createCell',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    fieldDescriptor: JSON.stringify({
                        fieldId: fieldId,
                        fieldType: fieldType
                    }),
                    privacySafeRowId: JSON.stringify($d6c36617a856f8c3$export$4983e1eef8c41de4(this.props.rowId))
                },
                // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            if (fieldType === 'com.atlassian.servicedesk:sd-sla-field') (0, $jcw0u.default)({
                meta: {
                    id: 'slaViewCell',
                    packageName: 'jiraIssueTable'
                },
                // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            this.setState({
                hasError: true
            });
        }
        render() {
            if (this.state.hasError === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luTJi.CellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85IQg.default), null));
            const { rowId: rowId, columnId: columnId, isActive: isActive, width: width, onMount: onMount, onUpdate: onUpdate, canBeMultiLine: canBeMultiLine, shouldHydrateFully: shouldHydrateFully } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $103nj.default), {
                rowId: rowId,
                columnId: columnId,
                isActive: isActive,
                shouldHydrateFully: !!shouldHydrateFully,
                width: width,
                onMount: onMount,
                onUpdate: onUpdate,
                canBeMultiLine: canBeMultiLine,
                jsonComponentArgs: jsonComponentArgs,
                mergedColumnProps: mergedColumnProps,
                FieldDataSelector: FieldDataSelector
            });
        }
        constructor(...args){
            super(...args), this.state = {
                hasError: false
            };
        }
    };
const $d6c36617a856f8c3$export$b8f5d4dcd5b8c653 = ()=>// @ts-expect-error - TS2345: Type '[jsonComponentArgs: JsonComponentArgs<T>, mergedColumnProps: MergedColumnProps<T>, FieldDataSelector: ComponentType<FieldDataSelectorProps>]' is not assignable to type '[jsonComponentArgs: JsonComponentArgs<keyof DataSelectorPropsMap>, mergedColumnProps: MergedColumnProps<keyof DataSelectorPropsMap>]'.
    (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($d6c36617a856f8c3$export$24c442202b6913f7, $d6c36617a856f8c3$var$cacheResolver);

});
parcelRegister("103nj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c78da960f7c0676c$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $9pe79 = parcelRequire("9pe79");

var $7NCXO = parcelRequire("7NCXO");

var $dzaTH = parcelRequire("dzaTH");

var $jxVFn = parcelRequire("jxVFn");

var $7647Z = parcelRequire("7647Z");

var $iQFwo = parcelRequire("iQFwo");

var $p64Ah = parcelRequire("p64Ah");

var $2WcTq = parcelRequire("2WcTq");

var $kKsyZ = parcelRequire("kKsyZ");

var $j4Kqr = parcelRequire("j4Kqr");

var $kC4Vh = parcelRequire("kC4Vh");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c78da960f7c0676c$var$mapStateToProps = (state, ownProps)=>({
        TableStateConnector: $j4Kqr.default,
        isCellValid: (0, $dzaTH.isCellValid)(state, ownProps.columnId, ownProps.rowId),
        rowListRef: (0, $7647Z.getRowListRef)(state),
        JsonCell: $kKsyZ.default,
        isUserPickerDisabled: (0, $iQFwo.isUserPickerDisabled)(state)
    });
const $c78da960f7c0676c$var$mapDispatchToProps = {
    onEditStart: (0, $7NCXO.issueEditStartedAction)
};
var $c78da960f7c0676c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: (fieldType)=>({
            name: fieldType
        })
}), (0, $p64Ah.connect)($c78da960f7c0676c$var$mapStateToProps, $c78da960f7c0676c$var$mapDispatchToProps, null, {
    // @ts-expect-error - TS7006 - Parameter 'nextProps' implicitly has an 'any' type. | TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    areStatePropsEqual: (nextProps, prevProps)=>{
        // Stop rendering immediately if the cell isn't valid. This
        // should always be due to the virtual-table rendering the old
        // locations in the first reconciliation, before a second
        // reconciliation kicks in with the new row and column IDs.
        if (!nextProps.isCellValid) return true;
        return (0, $9pe79.default)(nextProps, prevProps);
    }
}), (0, $2WcTq.ReduxAnalyticsData)((state, ownProps)=>({
        attributes: {
            fieldType: ownProps.mergedColumnProps.fieldType,
            tableRowNumber: (0, $jxVFn.getIssueKeyPositionIndex)(state, ownProps.rowId) + 1
        }
    })))((0, $kC4Vh.default));

});
parcelRegister("dzaTH", function(module, exports) {

$parcel$export(module.exports, "isCellValid", () => $0f8ce7c583584938$export$197f9971d7c5eea6);

var $lFJsG = parcelRequire("lFJsG");

var $jxVFn = parcelRequire("jxVFn");
const $0f8ce7c583584938$export$197f9971d7c5eea6 = (state, columnId, rowId)=>(0, $jxVFn.isIssueKnown)(state, rowId) && (0, $lFJsG.isColumnKnown)(state, columnId);

});

parcelRegister("7647Z", function(module, exports) {

$parcel$export(module.exports, "getRowListRef", () => $3efe7b1b52137997$export$3fa6769a2044ea5a);

var $37Hsj = parcelRequire("37Hsj");
const $3efe7b1b52137997$export$3fa6769a2044ea5a = (state)=>(0, $37Hsj.getPersisted)(state).rowListRef;

});

parcelRegister("kKsyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0c04583df2ddf62$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $luTJi = parcelRequire("luTJi");

var $85IQg = parcelRequire("85IQg");
class $e0c04583df2ddf62$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props) {
        if (props.tableInjectedProps.isTableDisabled) return {
            isEditable: false
        };
        return null;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.tableInjectedProps.isTableDisabled === true && this.props.tableInjectedProps.isTableDisabled === false) this.setState({
            // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'SlaDataSelectorProps | ServiceEntityDataSelectorProps | CmdbObjectDataSelectorProps | ... 13 more ... | MeatballMenuDataSelectorProps'.
            isEditable: this.props.fieldData.isEditable || false
        });
    }
    render() {
        const { FieldComponent: FieldComponent, fieldData: fieldData, tableInjectedProps: tableInjectedProps } = this.props;
        const { isEditable: isEditable } = this.state;
        if ((0, $4R6GH.fg)('handle-queues-column-exceptions')) {
            // @ts-expect-error - TS2339 - Property 'fieldRenderedValue' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'. | TS2339 - Property 'fieldCssClass' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'.
            if (fieldData.value != null && fieldData.value.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luTJi.CellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85IQg.default), null));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldComponent, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            dataSelectorProps: {
                ...fieldData,
                isEditable: isEditable
            },
            tableInjectedProps: tableInjectedProps
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'SlaDataSelectorProps | ServiceEntityDataSelectorProps | CmdbObjectDataSelectorProps | ... 13 more ... | MeatballMenuDataSelectorProps'.
            isEditable: this.props.fieldData.isEditable || false
        };
    }
}

});
parcelRegister("luTJi", function(module, exports) {

$parcel$export(module.exports, "CellWrapper", () => $91445afb56e6fd6c$export$4812fadef83edffe);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $91445afb56e6fd6c$export$4812fadef83edffe = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1tke1ylp _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("j4Kqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $549ec19a537454df$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $9pe79 = parcelRequire("9pe79");

var $1GPUJ = parcelRequire("1GPUJ");

var $45OTQ = parcelRequire("45OTQ");

var $dzaTH = parcelRequire("dzaTH");

var $lFJsG = parcelRequire("lFJsG");

var $kMqdJ = parcelRequire("kMqdJ");

var $jxVFn = parcelRequire("jxVFn");

var $iQFwo = parcelRequire("iQFwo");

var $p64Ah = parcelRequire("p64Ah");

var $2ko0D = parcelRequire("2ko0D");
const $549ec19a537454df$var$mapStateToPropsFactory = ()=>{
    const onIssueViewTransitionFactory = (0, $8QpSo.default)((state, issueKey)=>(0, $iQFwo.getOnIssueViewTransitionCallback)(state, issueKey));
    return (state, props)=>({
            isCellValid: (0, $dzaTH.isCellValid)(state, props.fieldDescriptor.fieldId, props.issueKey),
            isFieldLocked: (0, $kMqdJ.getIsFieldLocked)(state, props),
            isLastColumn: (0, $lFJsG.isLastColumn)(state, props.fieldDescriptor.fieldId),
            positionIndex: (0, $jxVFn.getIssueKeyPositionIndex)(state, props.issueKey),
            fieldName: (0, $lFJsG.getColumnTitle)(state, props.fieldDescriptor.fieldId),
            isTableDisabled: (0, $iQFwo.isTableDisabled)(state),
            onIssueViewTransition: onIssueViewTransitionFactory(state, props.issueKey)
        });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $549ec19a537454df$var$mapDispatchToProps = (dispatch, props)=>({
        onFieldLock: (positionIndex)=>dispatch((0, $1GPUJ.lockFieldAction)(props.issueKey, props.fieldDescriptor.fieldId, positionIndex)),
        onFieldUnlock: ()=>dispatch((0, $1GPUJ.unlockFieldAction)(props.issueKey, props.fieldDescriptor.fieldId)),
        onSetEditingFieldPosition: (horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight)=>dispatch((0, $45OTQ.setEditingFieldPositionAction)(horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight))
    });
const $549ec19a537454df$var$issueFieldLockControlsFactory = (0, $8QpSo.default)((positionIndex, onFieldLock, onFieldUnlock)=>({
        onFieldUnlock: onFieldUnlock,
        onFieldLock: ()=>onFieldLock(positionIndex)
    }));
const $549ec19a537454df$var$mergeProps = (stateProps, dispatchProps, ownProps)=>{
    const { positionIndex: positionIndex, isCellValid: _, ...componentStateProps } = stateProps;
    return {
        ...ownProps,
        ...componentStateProps,
        issueFieldLockControls: $549ec19a537454df$var$issueFieldLockControlsFactory(stateProps.positionIndex, dispatchProps.onFieldLock, dispatchProps.onFieldUnlock),
        onSetEditingFieldPosition: dispatchProps.onSetEditingFieldPosition
    };
};
const $549ec19a537454df$var$ConnectedTableStateConnector = (0, $p64Ah.connect)($549ec19a537454df$var$mapStateToPropsFactory, $549ec19a537454df$var$mapDispatchToProps, $549ec19a537454df$var$mergeProps, {
    // @ts-expect-error - TS7006 - Parameter 'nextProps' implicitly has an 'any' type. | TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    areStatePropsEqual: (nextProps, prevProps)=>{
        // Stop rendering immediately if the cell isn't valid.
        if (!nextProps.isCellValid) return true;
        return (0, $9pe79.default)(nextProps, prevProps);
    }
})((0, $2ko0D.default));
var $549ec19a537454df$export$2e2bcd8739ae039 = $549ec19a537454df$var$ConnectedTableStateConnector;

});
parcelRegister("2ko0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d3d485424ef5f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $47d3d485424ef5f8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, prevState) {
        const { isFieldLocked: isFieldLocked, fieldData: fieldData } = props;
        if (!isFieldLocked && fieldData && prevState.cachedFieldData !== fieldData) return {
            cachedFieldData: fieldData
        };
        return null;
    }
    componentWillUnmount() {
        const { isFieldLocked: isFieldLocked, issueFieldLockControls: { onFieldUnlock: onFieldUnlock } } = this.props;
        // unlock, if locked, when unmounting
        isFieldLocked && onFieldUnlock && onFieldUnlock();
    }
    render() {
        const { children: children, issueFieldLockControls: issueFieldLockControls, isFieldLocked: isFieldLocked, fieldData: givenFieldData, isLastColumn: isLastColumn, fieldName: fieldName, onSetEditingFieldPosition: onSetEditingFieldPosition, isTableDisabled: isTableDisabled, onIssueViewTransition: onIssueViewTransition } = this.props;
        const { cachedFieldData: cachedFieldData } = this.state;
        const fieldData = !isFieldLocked && givenFieldData ? givenFieldData : cachedFieldData;
        return children({
            issueFieldLockControls: issueFieldLockControls,
            fieldData: fieldData,
            isLastColumn: isLastColumn,
            fieldName: fieldName,
            onSetEditingFieldPosition: onSetEditingFieldPosition,
            isFieldLocked: isFieldLocked,
            isTableDisabled: isTableDisabled,
            onIssueViewTransition: onIssueViewTransition
        });
    }
    constructor(...args){
        super(...args), this.state = {
            cachedFieldData: null
        };
    }
}

});


parcelRegister("kC4Vh", function(module, exports) {

$parcel$export(module.exports, "default", () => $77572aef0c9e7437$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $dJl1T = parcelRequire("dJl1T");

var $dNVHF = parcelRequire("dNVHF");

var $luTJi = parcelRequire("luTJi");
const $77572aef0c9e7437$var$LOCATION = 'issue-table.view.create-cell.view';
const $77572aef0c9e7437$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
// eslint-disable-next-line jira/react/no-class-components
class $77572aef0c9e7437$var$Cell extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentDidUpdate() {
        const { onUpdate: onUpdate } = this.props;
        if (onUpdate) onUpdate();
    }
    getFieldDescriptor() {
        const { fieldId: fieldId, fieldType: fieldType } = this.props.mergedColumnProps;
        return {
            fieldId: fieldId,
            fieldType: fieldType
        };
    }
    render() {
        const { rowId: rowId, FieldDataSelector: FieldDataSelector } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luTJi.CellWrapper), {
            onClick: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldDataSelector, {
            issueKey: rowId,
            fieldDescriptor: this.getFieldDescriptor()
        }, this.renderField));
    }
    constructor(...args){
        super(...args), this.onClick = ()=>{
            this.props.onClick(this.props.mergedColumnProps.fieldType);
        }, this.renderLockableField = ({ fieldData: fieldData, issueFieldLockControls: issueFieldLockControls, isLastColumn: isLastColumn, fieldName: fieldName, onSetEditingFieldPosition: onSetEditingFieldPosition, isFieldLocked: isFieldLocked, isTableDisabled: isTableDisabled, onIssueViewTransition: onIssueViewTransition })=>{
            const { jsonComponentArgs: jsonComponentArgs, mergedColumnProps: mergedColumnProps, isActive: isActive, shouldHydrateFully: shouldHydrateFully, width: width, rowId: rowId, rowListRef: rowListRef, onEditStart: onEditStart, isUserPickerDisabled: isUserPickerDisabled, JsonCell: JsonCell } = this.props;
            if (fieldData) {
                // @ts-expect-error - TS2339 - Property 'fieldRenderedValue' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'. | TS2339 - Property 'fieldCssClass' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'.
                if (fieldData.fieldRenderedValue != null || fieldData.fieldCssClass != null) {
                    const { canBeMultiLine: canBeMultiLine } = this.props;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNVHF.default), {
                        canBeMultiLine: !!canBeMultiLine,
                        isLastColumn: isLastColumn,
                        doNotRenderTooltip: !!mergedColumnProps.doNotRenderTooltip,
                        ...fieldData
                    });
                }
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const fieldDataType = fieldData.fieldType;
                if (jsonComponentArgs && jsonComponentArgs.fieldType === fieldDataType) {
                    const { FieldComponent: FieldComponent } = jsonComponentArgs;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JsonCell, {
                        FieldComponent: FieldComponent,
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fieldData: fieldData,
                        tableInjectedProps: {
                            fieldId: mergedColumnProps.fieldId,
                            isActive: isActive,
                            issueFieldLockControls: issueFieldLockControls,
                            onEditStart: onEditStart,
                            width: width,
                            shouldHydrateFully: shouldHydrateFully,
                            isLastColumn: isLastColumn,
                            issueKey: rowId,
                            fieldName: fieldName,
                            rowListRef: rowListRef,
                            onSetEditingFieldPosition: onSetEditingFieldPosition,
                            isFieldLocked: isFieldLocked,
                            isUserPickerDisabled: isUserPickerDisabled,
                            isTableDisabled: isTableDisabled,
                            onIssueViewTransition: onIssueViewTransition
                        }
                    });
                }
            } else {
                (0, $dJl1T.default).safeWarnWithoutCustomerData($77572aef0c9e7437$var$LOCATION, `[FD-3358] Rendered an empty cell because a FieldDataSelector returned null without backup data. row-id details: "${JSON.stringify($77572aef0c9e7437$export$4983e1eef8c41de4(rowId))}", column-type: "${mergedColumnProps.fieldType}"`);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
            }
            throw new Error(`[FD-3358] Cannot render cell without either: prerendered html from the data selector OR field json data of the correct type for the current column. row-id details: "${JSON.stringify($77572aef0c9e7437$export$4983e1eef8c41de4(rowId))}", column-type: "${mergedColumnProps.fieldType}", data-field-type: "${// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            fieldData && fieldData.fieldType}", data-css-class: "${fieldData && fieldData.fieldCssClass}"`);
        }, this.renderField = (selectorFieldData)=>{
            const { TableStateConnector: TableStateConnector, rowId: rowId } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TableStateConnector, {
                issueKey: rowId,
                fieldDescriptor: this.getFieldDescriptor(),
                fieldData: selectorFieldData
            }, this.renderLockableField);
        };
    }
}
var $77572aef0c9e7437$export$2e2bcd8739ae039 = (0, $8oe80.default)('field', {
    onClick: 'clicked',
    onEditStart: 'locked'
})($77572aef0c9e7437$var$Cell);

});
parcelRegister("dNVHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd48fdf8bb7e2d1a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react/no-style-attribute */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");
// TODO: FREE-2849 : Revisit the list and add more as required
const $fd48fdf8bb7e2d1a$var$BLOCK_ELEMENTS = 'div, p, h2';
class $fd48fdf8bb7e2d1a$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.onSetRef = (div)=>{
            this.ref = div;
        }, this.onMouseOver = ()=>{
            if (this.props.doNotRenderTooltip) return;
            if (this.ref) {
                /*
       * If there is a 'block' child node, the width of the child is to be taken for the correct calculations.
       * Since we are rendering HTML blob, we need to find out if there are any 'block' child nodes
       */ const targetElement = this.ref.querySelector($fd48fdf8bb7e2d1a$var$BLOCK_ELEMENTS) || this.ref;
                let tooltipText = '';
                // Check if the element has overflown. If yes, set the innerText in state for tooltip to display
                // @ts-expect-error - TS2339 - Property 'offsetWidth' does not exist on type 'Element'.
                if (targetElement && targetElement.scrollWidth > targetElement.offsetWidth) // @ts-expect-error - TS2339 - Property 'innerText' does not exist on type 'Element'.
                tooltipText = targetElement.innerText;
                if (this.state.tooltipText !== tooltipText) this.setState(()=>({
                        tooltipText: tooltipText
                    }));
            }
        };
        this.rawText = '';
        this.hasEllipsis = false;
        this.state = {
            tooltipText: ''
        };
    }
    getContent() {
        const { fieldRenderedValue: fieldRenderedValue, fieldCssClass: fieldCssClass, canBeMultiLine: canBeMultiLine, isLastColumn: isLastColumn } = this.props;
        const innerHtml = {
            __html: fieldRenderedValue
        };
        if (canBeMultiLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // @ts-expect-error - TS2322 - Type '{ padding: string; overflowWrap: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isLastColumn ? $fd48fdf8bb7e2d1a$var$LastColumnMultilineStyle : $fd48fdf8bb7e2d1a$var$NonLastColumnMultilineStyle,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: innerHtml
        });
        return isLastColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd48fdf8bb7e2d1a$var$StyledWrapperLastColumn, {
            ref: this.onSetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            dangerouslySetInnerHTML: innerHtml,
            onMouseOver: this.onMouseOver,
            onFocus: this.onMouseOver,
            role: "textbox",
            tabIndex: 0
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd48fdf8bb7e2d1a$var$BaseStyledWrapper, {
            ref: this.onSetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            dangerouslySetInnerHTML: innerHtml,
            onMouseOver: this.onMouseOver,
            onFocus: this.onMouseOver,
            role: "textbox",
            tabIndex: 0
        });
    }
    render() {
        const { tooltipText: tooltipText } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd48fdf8bb7e2d1a$var$FieldRenderedValueContainer, null, tooltipText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            delay: 0,
            content: tooltipText
        }, this.getContent()) : this.getContent());
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd48fdf8bb7e2d1a$var$FieldRenderedValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
});
const $fd48fdf8bb7e2d1a$var$BaseStyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _ca0qu2gc _u5f31ejb _n3tdu2gc _19bvu2gc _1bto1l2s _o5721q9c _1bsb1osq _vchhusvi _bhp515vq _wrxl15vq _5i651l2s _pg4a1q9c",
            __cmplp.className
        ])
    });
});
const $fd48fdf8bb7e2d1a$var$StyledWrapperLastColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $fd48fdf8bb7e2d1a$var$BaseStyledWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $fd48fdf8bb7e2d1a$var$LastColumnMultilineStyle = {
    padding: `${"var(--ds-space-100, 8px)"}`,
    overflowWrap: 'break-word'
};
const $fd48fdf8bb7e2d1a$var$NonLastColumnMultilineStyle = {
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    overflowWrap: 'break-word'
};

});






parcelRegister("6Zno6", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bf5f30d69f8a35$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8QpSo = parcelRequire("8QpSo");

var $itzrU = parcelRequire("itzrU");

var $gwIPs = parcelRequire("gwIPs");

var $1WkNJ = parcelRequire("1WkNJ");

var $cnBEm = parcelRequire("cnBEm");
const $80bf5f30d69f8a35$var$ANIMATION_TIMEOUT = 200;
const $80bf5f30d69f8a35$var$ASSIGNEE_HEIGHT = 40;
const $80bf5f30d69f8a35$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT = 300;
const $80bf5f30d69f8a35$var$OFFSET_PADDING = 4;
const $80bf5f30d69f8a35$var$BOTTOM_LEFT = 'BOTTOM_LEFT';
const $80bf5f30d69f8a35$var$BOTTOM_RIGHT = 'BOTTOM_RIGHT';
const $80bf5f30d69f8a35$var$TOP_LEFT = 'TOP_LEFT';
const $80bf5f30d69f8a35$var$TOP_RIGHT = 'TOP_RIGHT';
const $80bf5f30d69f8a35$var$DROPDOWN_WIDTH_MARGIN = 7 * (0, $gwIPs.gridSize);
const $80bf5f30d69f8a35$var$DROPDOWN_HEIGHT_MARGIN = 9 * (0, $gwIPs.gridSize);
const $80bf5f30d69f8a35$var$spaceAvailableRightOfField = (tableWidth, horizontalScrollOffset, horizontalOffset)=>tableWidth + horizontalScrollOffset - horizontalOffset > $80bf5f30d69f8a35$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT + $80bf5f30d69f8a35$var$DROPDOWN_WIDTH_MARGIN;
const $80bf5f30d69f8a35$var$spaceAvailableUnderField = (tableHeight, verticalScrollOffset, verticalOffset)=>tableHeight + verticalScrollOffset - verticalOffset > $80bf5f30d69f8a35$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT + $80bf5f30d69f8a35$var$DROPDOWN_HEIGHT_MARGIN;
const $80bf5f30d69f8a35$var$getPositionType = (horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, tableWidth, tableHeight)=>{
    if ($80bf5f30d69f8a35$var$spaceAvailableUnderField(tableHeight, verticalScrollOffset, verticalOffset)) {
        if ($80bf5f30d69f8a35$var$spaceAvailableRightOfField(tableWidth, horizontalScrollOffset, horizontalOffset)) return $80bf5f30d69f8a35$var$BOTTOM_LEFT;
        return $80bf5f30d69f8a35$var$BOTTOM_RIGHT;
    }
    if ($80bf5f30d69f8a35$var$spaceAvailableRightOfField(tableWidth, horizontalScrollOffset, horizontalOffset)) return $80bf5f30d69f8a35$var$TOP_LEFT;
    return $80bf5f30d69f8a35$var$TOP_RIGHT;
};
const $80bf5f30d69f8a35$export$193f85369df210ff = (horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, fieldWidth, tableWidth, tableHeight)=>{
    switch($80bf5f30d69f8a35$var$getPositionType(horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, tableWidth, tableHeight)){
        case $80bf5f30d69f8a35$var$BOTTOM_LEFT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset - $80bf5f30d69f8a35$var$OFFSET_PADDING}px`,
                top: `${verticalOffset + $80bf5f30d69f8a35$var$ASSIGNEE_HEIGHT}px`,
                bottom: undefined
            };
        case $80bf5f30d69f8a35$var$BOTTOM_RIGHT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset + fieldWidth - $80bf5f30d69f8a35$var$OFFSET_PADDING - $80bf5f30d69f8a35$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT}px`,
                top: `${verticalOffset + $80bf5f30d69f8a35$var$ASSIGNEE_HEIGHT}px`,
                bottom: undefined
            };
        case $80bf5f30d69f8a35$var$TOP_LEFT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset - $80bf5f30d69f8a35$var$OFFSET_PADDING}px`,
                top: 'auto',
                bottom: `${-verticalOffset - $80bf5f30d69f8a35$var$OFFSET_PADDING}px`
            };
        default:
            return {
                left: `${horizontalOffset - horizontalScrollOffset + fieldWidth - $80bf5f30d69f8a35$var$OFFSET_PADDING - $80bf5f30d69f8a35$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT}px`,
                top: 'auto',
                bottom: `${-verticalOffset - $80bf5f30d69f8a35$var$OFFSET_PADDING}px`
            };
    }
};
class $80bf5f30d69f8a35$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = (0, $cnBEm.defaultProps);
    }
    render() {
        const { currentPage: currentPage, totalPages: totalPages, onPageChange: onPageChange } = this.props;
        const { Table: Table, showPagination: showPagination, Pagination: Pagination, editingFieldHorizontalOffset: editingFieldHorizontalOffset, editingFieldVerticalOffset: editingFieldVerticalOffset, editingFieldWidth: editingFieldWidth, horizontalScrollOffset: horizontalScrollOffset, verticalScrollOffset: verticalScrollOffset, tableWidth: tableWidth, tableHeight: tableHeight, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset, onActiveRowIdChanged: onActiveRowIdChanged, ...otherProps } = this.props;
        const portalPosition = $80bf5f30d69f8a35$export$193f85369df210ff(editingFieldHorizontalOffset, horizontalScrollOffset, editingFieldVerticalOffset, verticalScrollOffset, editingFieldWidth, tableWidth, tableHeight);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80bf5f30d69f8a35$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80bf5f30d69f8a35$var$TableContainer, {
            animationTimeout: $80bf5f30d69f8a35$var$ANIMATION_TIMEOUT,
            hasPagination: showPagination,
            left: portalPosition.left,
            top: portalPosition.top,
            bottom: portalPosition.bottom
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1WkNJ.IssueContextSubscriber), null, (__, { setIssueKeyContext: setIssueKeyContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Table, {
                ...otherProps,
                onActiveRowIdChanged: this.onSetIssueKeyContextCallback(setIssueKeyContext),
                onUpdateHorizontalScrollOffset: this.onUpdateHorizontalScrollOffset
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzrU.default), {
            in: showPagination,
            classNames: "fade",
            timeout: $80bf5f30d69f8a35$var$ANIMATION_TIMEOUT,
            unmountOnExit: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80bf5f30d69f8a35$var$Animate, {
            timeout: $80bf5f30d69f8a35$var$ANIMATION_TIMEOUT
        }, showPagination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Pagination, {
            currentPage: currentPage,
            totalPages: totalPages,
            onPageChange: onPageChange
        }))));
    }
    constructor(...args){
        super(...args), this.onUpdateHorizontalScrollOffset = (horizontalPositioning)=>{
            const { onHorizontalScrollOffsetChanged: onHorizontalScrollOffsetChanged, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset } = this.props;
            onUpdateHorizontalScrollOffset(horizontalPositioning);
            onHorizontalScrollOffsetChanged && onHorizontalScrollOffsetChanged(horizontalPositioning);
        }, this.onSetIssueKeyContextCallback = (0, $8QpSo.default)((setIssueKeyContext)=>(rowId)=>{
                const isIssueDataLoaded = this.props.loadedIssueKeys.includes(rowId);
                if (isIssueDataLoaded) setIssueKeyContext(rowId);
                else setIssueKeyContext(undefined);
                this.props.onActiveRowIdChanged && this.props.onActiveRowIdChanged(rowId);
            });
    }
}
const $80bf5f30d69f8a35$var$APPROX_PAGINATION_HEIGHT = 48;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80bf5f30d69f8a35$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $80bf5f30d69f8a35$var$TableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { animationTimeout: animationTimeout, hasPagination: hasPagination, left: left, top: top, bottom: bottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1pg9jf5": (0, $lD23V.default)(`all ${__cmplp.animationTimeout}ms ease-in`),
            "--_lr32lc": (0, $lD23V.default)(__cmplp.left),
            "--_1vj9tq": (0, $lD23V.default)(__cmplp.top),
            "--_14iunx0": (0, $lD23V.default)(__cmplp.bottom)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jl1406 _1o9zkb7n _i0dlf1ug _v5641gtb _4t3i1osq _15po1rza _1b1u1wug _jzhkstnw _rg151ter _3c8c1tn0",
            __cmplp.hasPagination && "_n3tdckbl",
            __cmplp.className
        ])
    });
});
const $80bf5f30d69f8a35$var$Animate = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { timeout: timeout, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_g2896q": (0, $lD23V.default)(`all ${__cmplp.timeout}ms ease-in`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _94n5idpf _1xi2idpf _15og6od0 _la5rkb7n _a9jfckbl _11h16od0 _1urkidpf _w97pidpf _fgdaidpf _9xe0idpf _160ykb7n _prrmckbl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cnBEm", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $4a506c200ea5d72e$export$9c21a3269931e1e6);

var $8Rkzz = parcelRequire("8Rkzz");
const $4a506c200ea5d72e$export$9c21a3269931e1e6 = {
    currentPage: 1,
    totalPages: 1,
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};

});




parcelRegister("2Pbdb", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkActionToolbar", () => $3c940cae006d73d1$export$d53c287f3c6193b2);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3c940cae006d73d1$var$AsyncBulkActionToolbarLazy = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9JFJv")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/bulk-actions-toolbar/src/index.tsx"
});
const $3c940cae006d73d1$export$d53c287f3c6193b2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-servicedesk.bulk-actions.toolbar",
        packageName: "atlassian/jira-servicedesk-bulk-actions-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "servicedesk-bulk-actions-toolbar",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c940cae006d73d1$var$AsyncBulkActionToolbarLazy, props)));

});
parcelRegister("9JFJv", function(module, exports) {

let $7168b056090668a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7168b056090668a2$var$load("cM9em"),
    $7168b056090668a2$var$load("fr9NE"),
    $7168b056090668a2$var$load("h2MrD"),
    $7168b056090668a2$var$load("bYT2S"),
    $7168b056090668a2$var$load("5XNXN")
]).then(()=>parcelRequire('cj1rl'));

});


parcelRegister("hbago", function(module, exports) {

$parcel$export(module.exports, "getIssueTableAppProps", () => $6df7acc0b2a26711$export$b7be6dcc4ea236d0);

var $dGvGJ = parcelRequire("dGvGJ");

var $fy6YG = parcelRequire("fy6YG");
const $6df7acc0b2a26711$export$b7be6dcc4ea236d0 = (0, $dGvGJ.createSelector)((0, $fy6YG.getCloudId), (0, $fy6YG.getFabricPfDirUrl), (0, $fy6YG.getAtlassianAccountId), (cloudId, fabricPfDirUrl, atlassianAccountId)=>({
        cloudId: cloudId,
        fabricPfDirUrl: fabricPfDirUrl,
        atlassianAccountId: atlassianAccountId
    }));

});

parcelRegister("jATd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb7dc9288ba42e0$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6sLXW = parcelRequire("6sLXW");

var $fniIF = parcelRequire("fniIF");

var $lHf6h = parcelRequire("lHf6h");

var $627A7 = parcelRequire("627A7");

var $jeVA9 = parcelRequire("jeVA9");

var $3MODP = parcelRequire("3MODP");
const $2eb7dc9288ba42e0$var$mapStateToProps = (state, ownProps)=>{
    const { issueKey: issueKey, fieldDescriptor: { fieldId: fieldId } } = ownProps;
    const isCellFirstFieldInTable = (0, $lHf6h.isFirstFieldInTable)(state, issueKey, fieldId);
    const queueVisible = (0, $jeVA9.isQueueVisible)(state);
    return {
        queueId: (0, $627A7.getQueueId)(state),
        onFieldDataSelection: (0, $lHf6h.getFieldPropsSelector)(state),
        isFirstFieldInTable: isCellFirstFieldInTable,
        isFieldToExperienceTrack: (0, $lHf6h.isFieldToExperienceTrack)(state, issueKey, fieldId),
        isQueueVisible: queueVisible,
        ReadyForUser: $fniIF.ReadyForUser
    };
};
const $2eb7dc9288ba42e0$var$FieldDataSelector = (0, $bC2fB.connect)($2eb7dc9288ba42e0$var$mapStateToProps, {
    onFieldChange: (0, $6sLXW.changeIssueFieldValueAction)
})((0, $3MODP.default));
var $2eb7dc9288ba42e0$export$2e2bcd8739ae039 = $2eb7dc9288ba42e0$var$FieldDataSelector;

});
parcelRegister("3MODP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f433205c99972485$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g0Gtc = parcelRequire("g0Gtc");

var $x9xyg = parcelRequire("x9xyg");

var $dZw8H = parcelRequire("dZw8H");

var $3TTtX = parcelRequire("3TTtX");
const $f433205c99972485$var$renderWithExperienceTracker = (node, { isFieldToExperienceTrack: isFieldToExperienceTrack, fieldDescriptor: { fieldType: fieldType } })=>isFieldToExperienceTrack ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: `queue-cell-${fieldType}`
    }, node) : node;
const $f433205c99972485$var$renderWithReadyForUser = (node, { queueId: queueId, isQueueVisible: isQueueVisible, isFirstFieldInTable: isFirstFieldInTable })=>isQueueVisible && isFirstFieldInTable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TTtX.AgentTableApdexSubmitter), null), node, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReadyOnUpdate), {
        comparer: [
            queueId
        ]
    })) : node;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f433205c99972485$export$2e2bcd8739ae039 = (props)=>{
    const { onFieldChange: onFieldChange, onFieldDataSelection: onFieldDataSelection, fieldDescriptor: fieldDescriptor, issueKey: issueKey, children: children, isQueueVisible: isQueueVisible, isFirstFieldInTable: isFirstFieldInTable } = props;
    const dataSelectorCoordinates = {
        fieldDescriptor: fieldDescriptor,
        issueKey: issueKey
    };
    if (isQueueVisible && isFirstFieldInTable) (0, $x9xyg.setMark)('jsd.performance.profile.queues.firstfield.render');
    const childrenNode = children(onFieldDataSelection(dataSelectorCoordinates, onFieldChange));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, $f433205c99972485$var$renderWithReadyForUser($f433205c99972485$var$renderWithExperienceTracker(childrenNode, props), props));
};

});
parcelRegister("3TTtX", function(module, exports) {

$parcel$export(module.exports, "AgentTableApdexProvider", () => $550b7e3d2ec99e4e$export$28049b03af6e1521);
$parcel$export(module.exports, "AgentTableApdexSubmitter", () => $550b7e3d2ec99e4e$export$d36b2dc23ff59e3d);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fNobW = parcelRequire("fNobW");

var $3TpKp = parcelRequire("3TpKp");

var $hiKo9 = parcelRequire("hiKo9");

var $3HGy4 = parcelRequire("3HGy4");

var $4R6GH = parcelRequire("4R6GH");
const $550b7e3d2ec99e4e$var$context = /*#__PURE__*/ (0, $5uXOq.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
const $550b7e3d2ec99e4e$export$28049b03af6e1521 = ({ children: children, queueId: queueId, isLoading: isLoading, isVisible: isVisible, metricKey: metricKey, metric: metric, category: category, hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache })=>{
    const [finishedQueueId, setFinishedQueueId] = (0, $5uXOq.useState)(null);
    const updateFinishedQueueId = (0, $5uXOq.useCallback)(()=>{
        if (!isLoading) setFinishedQueueId(queueId);
    }, [
        queueId,
        isLoading
    ]);
    const loadingComponent = (0, $4R6GH.fg)('add_ufo_load_hold_to_custom_queue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "agent-table-apdex-provider"
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($550b7e3d2ec99e4e$var$context.Provider, {
        value: updateFinishedQueueId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, // Do not mount initially (when queueId is null) or when switching queueIds (queueId in state mismatches props) or when table is hidden
    finishedQueueId && finishedQueueId === queueId && isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TpKp.JsmPageInteractiveEvent), {
        key: queueId ? (0, $3HGy4.fromQueueIdString)(queueId) : undefined,
        metricKey: metricKey,
        withMarks: (0, $hiKo9.getAgentViewMarks)(),
        metric: metric,
        extra: {
            category: category || 'no-category',
            empty: false,
            hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache
        }
    })) : loadingComponent));
};
const $550b7e3d2ec99e4e$export$d36b2dc23ff59e3d = ()=>{
    const updateFinishedQueueId = (0, $5uXOq.useContext)($550b7e3d2ec99e4e$var$context);
    (0, $5uXOq.useEffect)(updateFinishedQueueId);
    return null;
};

});



parcelRegister("8Dyvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $73afd35154ad63b0$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $bzBCj = parcelRequire("bzBCj");

var $jeVA9 = parcelRequire("jeVA9");

var $bcUtI = parcelRequire("bcUtI");
const $73afd35154ad63b0$var$mapDispatchToProps = {
    onOpenIssue: (0, $bzBCj.openIssueAction)
};
var $73afd35154ad63b0$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        activeIssueKey: (0, $jeVA9.getIssueKeyContext)(state)
    }), $73afd35154ad63b0$var$mapDispatchToProps)((0, $bcUtI.default));

});
parcelRegister("bcUtI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecf7fab3f164ed0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
const $cecf7fab3f164ed0$var$AnalyticsWrapper = (0, $2OMDV.AnalyticsEventToProps)('issue', {
    onKeyDown: 'pressed'
})(({ children: children, onKeyDown: onKeyDown })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cecf7fab3f164ed0$var$Wrapper, {
        role: "presentation",
        onKeyDown: onKeyDown
    }, children));
const $cecf7fab3f164ed0$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
class $cecf7fab3f164ed0$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cecf7fab3f164ed0$var$AnalyticsWrapper, {
            onKeyDown: this.onKeyDown,
            role: "presentation"
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.onKeyDown = (event, analyticsEvent)=>{
            const { onOpenIssue: onOpenIssue, activeIssueKey: activeIssueKey, isDisabled: isDisabled } = this.props;
            if (!isDisabled && activeIssueKey != null) switch(event.key){
                case 'o':
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openIssue', {
                        keyPressed: 'o',
                        issueKey: $cecf7fab3f164ed0$export$4983e1eef8c41de4(activeIssueKey)
                    });
                    onOpenIssue();
                    event.preventDefault();
                    break;
                case 'Enter':
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openIssue', {
                        keyPressed: 'enter',
                        issueKey: $cecf7fab3f164ed0$export$4983e1eef8c41de4(activeIssueKey)
                    });
                    onOpenIssue();
                    event.preventDefault();
                    break;
                default:
                    break;
            }
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cecf7fab3f164ed0$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("aDlXC", function(module, exports) {

$parcel$export(module.exports, "getColumnsForIssueTable", () => $0b3fe2ba6a6f08a2$export$7fd0c43240a64f42);

var $8QpSo = parcelRequire("8QpSo");


var $1jONP = parcelRequire("1jONP");
const $0b3fe2ba6a6f08a2$var$getStylingOverrides = (fieldType)=>{
    if (fieldType === 'assignee' && !(0, $1jONP.getFieldTypesEligibleForJsonDataAsSet)().has(fieldType)) return {
        minWidth: 100,
        maxWidth: 200,
        canBeMultiLine: true
    };
    if (fieldType === 'summary') return {
        minWidth: 262,
        maxWidth: 632,
        canBeMultiLine: true
    };
    return {};
};
const $0b3fe2ba6a6f08a2$export$7fd0c43240a64f42 = (0, $8QpSo.default)((columns, onSortOrderChanged)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    columns.map((column)=>{
        const { id: id, title: title, fieldType: fieldType, currentSorting: currentSorting = (0, $ff4189e925fd251d$export$c53d0f541b41b88e), sortable: sortable } = column;
        return {
            id: id,
            title: title,
            fieldType: fieldType,
            currentSorting: currentSorting,
            onSortOrderChanged: sortable ? onSortOrderChanged : undefined,
            ...$0b3fe2ba6a6f08a2$var$getStylingOverrides(column.fieldType)
        };
    }));
const $0b3fe2ba6a6f08a2$export$cd4e5573fbe2b576 = ()=>document.activeElement;

});

parcelRegister("c6Ds1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09e4b914c4a3206a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8QpSo = parcelRequire("8QpSo");

var $8oe80 = parcelRequire("8oe80");

var $x9xyg = parcelRequire("x9xyg");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $eVPAx = parcelRequire("eVPAx");

var $hPm3c = parcelRequire("hPm3c");

var $dd29Z = parcelRequire("dd29Z");

var $3HGy4 = parcelRequire("3HGy4");

var $8XAvX = parcelRequire("8XAvX");

var $g5X3G = parcelRequire("g5X3G");

var $flhvf = parcelRequire("flhvf");


var $cPF3j = parcelRequire("cPF3j");

var $3TTtX = parcelRequire("3TTtX");
const $09e4b914c4a3206a$var$isEcClientEnabled = ()=>{
    const experiences = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $co1wz.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-inline');
};
// min scroll offset before the offset changed callback is called
const $09e4b914c4a3206a$var$MIN_SCROLL_OFFSET_DELTA = 80;
const $09e4b914c4a3206a$var$hasQueueBecomeVisible = (prevProps, nextProps)=>!prevProps.isQueueVisible && nextProps.isQueueVisible;
const $09e4b914c4a3206a$var$hasQueueOrPageOrSortingChanged = (prevProps, nextProps)=>prevProps.queueId !== nextProps.queueId || prevProps.currentPage !== nextProps.currentPage || prevProps.isLoading !== nextProps.isLoading || prevProps.sortOrder !== nextProps.sortOrder || prevProps.sortedBy !== nextProps.sortedBy;
const $09e4b914c4a3206a$var$onIssueViewTransition = (0, $8QpSo.default)((queueId, projectKey, queueCategory, isQueueTransient, queuesPush, onSetIssueKey)=>{
    const push = (issueKey)=>{
        const path = isQueueTransient ? (0, $dd29Z.getIssueFragment)(issueKey) : `${(0, $dd29Z.getQueueFragment)((0, $3HGy4.fromQueueId)(queueId), queueCategory)}/${issueKey}`;
        queuesPush(path);
        onSetIssueKey(null);
    };
    return (0, $hPm3c.getIssueTransitionOverride)(push);
});
// Init tenantContext for ECClient
const $09e4b914c4a3206a$var$SaveInlineMutations = ()=>{
    (0, $eVPAx.useEcClient)();
    return null;
};
class $09e4b914c4a3206a$export$54ec01a60f47d33d extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), this.onIssueDataRequested = (startIndex)=>{
            const { onIssueDataRequested: onIssueDataRequested, isContentStale: isContentStale } = this.props;
            if (!this.isFirstUpdateAfterQueueChange && !isContentStale) onIssueDataRequested(startIndex);
            this.isFirstUpdateAfterQueueChange = false;
        }, this.onPageChange = (event, newPage, analyticsEvent)=>{
            this.props.onPageChange(event, newPage, analyticsEvent);
        }, this.onSetIssueTableRef = (ref)=>{
            this.issueTableRef = ref;
        }, this.onVerticalScrollOffsetChanged = (verticalPosition)=>{
            const { offsetFromTop: offsetFromTop } = verticalPosition;
            const { onVerticalScrollChanged: onVerticalScrollChanged } = this.props;
            let direction = (0, $36dd7e3255fc2bff$export$57022ca1771ad970);
            if (Math.abs(offsetFromTop - this.prevOffsetFromTop) > $09e4b914c4a3206a$var$MIN_SCROLL_OFFSET_DELTA) {
                // @ts-expect-error - TS2322 - Type '"UP" | "DOWN"' is not assignable to type '"UNCHANGED"'.
                direction = offsetFromTop > this.prevOffsetFromTop ? (0, $36dd7e3255fc2bff$export$28a694fb106a7f62) : (0, $36dd7e3255fc2bff$export$b5ad9376033e98b2);
                this.prevOffsetFromTop = offsetFromTop;
            }
            onVerticalScrollChanged && onVerticalScrollChanged({
                ...verticalPosition,
                direction: direction
            });
        }, this.isFirstUpdateAfterQueueChange = false;
        (0, $x9xyg.setMark)('jsd.performance.profile.queues.issuetable.mount');
        this.initECClientEnabled = $09e4b914c4a3206a$var$isEcClientEnabled();
    }
    componentDidMount() {
        if (this.props.canFocusTable) this.focusTable();
        this.props.onTableChange();
        this.prevOffsetFromTop = 0;
    }
    componentDidUpdate(prevProps) {
        if (this.props.canFocusTable && $09e4b914c4a3206a$var$hasQueueBecomeVisible(prevProps, this.props)) this.focusTable();
        if ($09e4b914c4a3206a$var$hasQueueOrPageOrSortingChanged(prevProps, this.props)) {
            this.isFirstUpdateAfterQueueChange = true;
            if (this.props.canFocusTable) this.focusTable();
            this.scrollToTop();
            this.props.onTableChange();
        }
    }
    scrollToTop() {
        const { issueTableRef: issueTableRef } = this;
        issueTableRef && issueTableRef.scrollToTop();
    }
    focusTable() {
        const { issueTableRef: issueTableRef } = this;
        issueTableRef && issueTableRef.focusContent();
    }
    render() {
        const { columns: columns, onActiveItemChanged: onActiveItemChanged, IssueTable: IssueTable, DemoDripFeed: DemoDripFeed, issueKeys: issueKeys, isContentStale: isContentStale, isLoading: isLoading, isQueueVisible: isQueueVisible, metricKey: metricKey, currentPage: currentPage, totalPages: totalPages, queueId: queueId, queueName: queueName, queueCategory: queueCategory, isQueueTransient: isQueueTransient, projectKey: projectKey, FieldDataSelector: FieldDataSelector, controlPolling: controlPolling, KeyboardShortcutListener: KeyboardShortcutListener, AsyncBulkActionToolbar: AsyncBulkActionToolbar, SelectedIssuesSubscriber: SelectedIssuesSubscriber, appProps: { cloudId: cloudId, fabricPfDirUrl: fabricPfDirUrl, atlassianAccountId: atlassianAccountId }, hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache, useJSMQueueDurationEvent: useJSMQueueDurationEvent, renderSidebarIcon: renderSidebarIcon, shouldRerenderRowOnHover: shouldRerenderRowOnHover, width: width, tableWidth: tableWidth, onSetSelectedIssueKeys: onSetSelectedIssueKeys, onRefreshSidebar: onRefreshSidebar, onSetIssueKey: onSetIssueKey, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($09e4b914c4a3206a$var$OuterContainer, {
            "data-testid": "servicedesk-queues-agent-view.layout.table.out",
            width: tableWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($09e4b914c4a3206a$var$Container, {
            width: width,
            "data-testid": "servicedesk-queues-agent-view.layout.table.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TTtX.AgentTableApdexProvider), {
            queueId: queueId,
            isLoading: isLoading,
            isVisible: isQueueVisible,
            metricKey: metricKey,
            category: queueCategory,
            // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
            metric: (0, $cPF3j.serviceViewPageLoad),
            hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XAvX.default), {
            projectKey: projectKey
        }, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($09e4b914c4a3206a$var$IssueTableAnchor, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
                onError: onNonPremiumSLAColumnError,
                id: "queue-sidebar-bulk-edit-bug-fix"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($09e4b914c4a3206a$var$ToolbarPositioning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AsyncBulkActionToolbar, {
                controlPolling: controlPolling,
                width: tableWidth
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectedIssuesSubscriber, null, ({ issueKeys: selectedIssueKeys })=>{
                onSetSelectedIssueKeys(selectedIssueKeys);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KeyboardShortcutListener, {
                    isDisabled: isContentStale
                }, this.initECClientEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($09e4b914c4a3206a$var$SaveInlineMutations, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueTable, {
                    ref: this.onSetIssueTableRef,
                    isContentStale: isContentStale,
                    isDisabled: isContentStale,
                    columns: columns,
                    issueKeys: issueKeys,
                    selectedIssueKeys: selectedIssueKeys,
                    contentKey: String(queueId),
                    FieldDataSelector: FieldDataSelector,
                    onActiveItemChanged: onActiveItemChanged,
                    onIssueDataRequested: this.onIssueDataRequested,
                    onVerticalScrollOffsetChanged: this.onVerticalScrollOffsetChanged,
                    currentPage: currentPage,
                    onPageChange: this.onPageChange,
                    totalPages: totalPages,
                    appProps: {
                        cloudId: (0, $g5X3G.toCloudId)(cloudId),
                        fabricPfDirUrl: fabricPfDirUrl,
                        atlassianAccountId: atlassianAccountId,
                        premiumSLAColumns: [
                            'issuekey',
                            'summary',
                            'reporter'
                        ]
                    },
                    shouldUseCssForRendering: (0, $4R6GH.fg)('css_support_for_virtual_table') ? true : undefined,
                    onIssueViewTransition: push ? $09e4b914c4a3206a$var$onIssueViewTransition(queueId, projectKey, queueCategory, isQueueTransient, push, onSetIssueKey) : undefined,
                    useJSMQueueDurationEvent: useJSMQueueDurationEvent,
                    renderSidebarIcon: renderSidebarIcon,
                    refreshSidebar: onRefreshSidebar,
                    shouldRerenderRowOnHover: shouldRerenderRowOnHover,
                    ariaLabel: queueName
                }));
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DemoDripFeed, null)));
    }
}
var $09e4b914c4a3206a$export$2e2bcd8739ae039 = (0, $8oe80.default)('queue', {
    onTableChange: 'viewed'
})($09e4b914c4a3206a$export$54ec01a60f47d33d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $09e4b914c4a3206a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.width !== undefined ? "_16jlkb7n _1bsb1efm" : "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $09e4b914c4a3206a$var$OuterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.width !== undefined ? "_bfhkvuon _1e0c1txw _16jlkb7n _1bsb1efm" : "_bfhkvuon _1e0c1txw _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $09e4b914c4a3206a$var$ToolbarPositioning = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iu2gc _1ltvoahv _1pbyowjs",
            __cmplp.className
        ])
    });
});
const $09e4b914c4a3206a$var$IssueTableAnchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eVPAx", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $cc73f0417ca1290f$export$9da409beb25e67da);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $9OXo1 = parcelRequire("9OXo1");

var $6I26d = parcelRequire("6I26d");
const $cc73f0417ca1290f$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $9OXo1.useTenantContext)();
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $5uXOq.useEffect)(()=>{
        (0, $6I26d.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $5uXOq.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $6I26d.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $5uXOq.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $6I26d.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $5uXOq.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $6I26d.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $6I26d.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});

parcelRegister("hPm3c", function(module, exports) {

$parcel$export(module.exports, "overrideTransitionsInCurrentTab", () => $31463fb12cf9ea78$export$d33e462dc45e1561);
$parcel$export(module.exports, "getIssueTransitionOverride", () => $31463fb12cf9ea78$export$e3b6c227a74390b8);
const $31463fb12cf9ea78$export$d33e462dc45e1561 = (push, event)=>{
    const { ctrlKey: ctrlKey, metaKey: metaKey } = event;
    // Let default browser behaviour occur when opening link in new tab/window
    // metaKey for macOS cmd. ctrKey for other OSes.
    if (ctrlKey || metaKey) return;
    event.preventDefault();
    push();
};
const $31463fb12cf9ea78$export$e3b6c227a74390b8 = (push)=>(issueKey, event)=>$31463fb12cf9ea78$export$d33e462dc45e1561(()=>push(issueKey), event);

});



parcelRegister("83KYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $47521b45ded9cff7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $17EoE = parcelRequire("17EoE");
const $47521b45ded9cff7$var$LOCATION = 'servicedesk.queues.agent-view.view.layout.usage-sampler';
const $47521b45ded9cff7$var$INTERVAL = 300000;
class $47521b45ded9cff7$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.intervalId = window.setInterval(()=>this.forceUpdate(), $47521b45ded9cff7$var$INTERVAL);
    }
    componentDidCatch(error) {
        this.setState({
            hasError: true
        });
        (0, $jcw0u.default)({
            meta: {
                id: 'viewLayoutUsageSampling',
                packageName: 'jiraServicedeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
            error: new Error(error)
        });
        (0, $dJl1T.default).safeErrorWithoutCustomerData($47521b45ded9cff7$var$LOCATION, `[FD-3358] Error while sampling usage: ${JSON.stringify(error && error.stack)}`);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.intervalId && window.clearInterval(this.intervalId);
    }
    render() {
        if (this.state.hasError) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17EoE.default), null);
    }
}

});
parcelRegister("17EoE", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f1a0c8b528375e$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $1bJTy = parcelRequire("1bJTy");

var $bC2fB = parcelRequire("bC2fB");

var $3HGy4 = parcelRequire("3HGy4");

var $fy6YG = parcelRequire("fy6YG");

var $lHf6h = parcelRequire("lHf6h");

var $627A7 = parcelRequire("627A7");

var $h4yk3 = parcelRequire("h4yk3");

var $jeVA9 = parcelRequire("jeVA9");

var $agwZO = parcelRequire("agwZO");

var $iQBSc = parcelRequire("iQBSc");
const $47f1a0c8b528375e$var$mapStateToPropsFactory = ()=>{
    // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    const onUpdateFactory = (0, $8QpSo.default)((queueId, state)=>(analyticsEvent)=>{
            (0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
                containerType: 'queue',
                containerId: `${(0, $3HGy4.fromQueueId)(queueId)}`,
                attributes: {
                    isAdmin: (0, $fy6YG.getIsAdmin)(state),
                    cachedIssueCount: (0, $lHf6h.getIssueCacheSize)(state),
                    availableIssueCount: (0, $lHf6h.getIssueCount)(state),
                    timeSinceIssueListInitialized: (0, $agwZO.getTimeSinceIssueListInitialized)(state),
                    isQueueVisible: (0, $jeVA9.isQueueVisible)(state),
                    sortFieldType: (0, $h4yk3.getSortFieldType)(state),
                    sortOrder: (0, $h4yk3.getSortOrder)(state),
                    isDefaultSorting: !(0, $h4yk3.isManuallySorted)(state)
                }
            });
        });
    return (state)=>{
        const queueId = (0, $627A7.getQueueId)(state);
        return {
            onUpdate: onUpdateFactory(queueId, state),
            state: // this is used to force re-renders on every state update due to use of `pure` option in react-redux v5
            state
        };
    };
};
var // @ts-expect-error - TS2769 - Argument of type 'null' is not assignable to parameter of type 'MergeProps<{ onUpdate: (analyticsEvent: any) => void; state: State; }, {}, {}, {}>'.
$47f1a0c8b528375e$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($47f1a0c8b528375e$var$mapStateToPropsFactory, {}, null, {
    // TODO: this option is deprecated react-redux v8
    pure: false,
    shouldHandleStateChanges: false
})((0, $iQBSc.default));

});
parcelRegister("agwZO", function(module, exports) {

$parcel$export(module.exports, "getTimeSinceIssueListInitialized", () => $bd7e115d4fa9010e$export$4a764bf7fdeee8c4);

var $6RCeq = parcelRequire("6RCeq");

var $lHf6h = parcelRequire("lHf6h");
const $bd7e115d4fa9010e$export$4a764bf7fdeee8c4 = (state)=>Math.round((0, $6RCeq.default).now() - (0, $lHf6h.getTimeWhenLastInitialized)(state));

});

parcelRegister("iQBSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6473fefaf001dc1e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");
// eslint-disable-next-line jira/react/no-class-components
class $6473fefaf001dc1e$var$AnalyticsWrapper extends (0, $5uXOq.Component) {
    componentDidUpdate() {
        this.props.onUpdate();
    }
    render() {
        return null;
    }
}
var $6473fefaf001dc1e$export$2e2bcd8739ae039 = (0, $8oe80.default)('UsageSampler', {
    onUpdate: 'sample'
})($6473fefaf001dc1e$var$AnalyticsWrapper);

});



parcelRegister("7Dcqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b85d234d8660788d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ajpes = parcelRequire("ajpes");

var $34ck9 = parcelRequire("34ck9");

var $fW62l = parcelRequire("fW62l");

var $fVnbM = parcelRequire("fVnbM");

var $4n4k5 = parcelRequire("4n4k5");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $gJlZe = parcelRequire("gJlZe");

var $fNobW = parcelRequire("fNobW");


var $8RZJT = parcelRequire("8RZJT");

var $44v1T = parcelRequire("44v1T");

var $co1wz = parcelRequire("co1wz");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $17JMK = parcelRequire("17JMK");

var $eVPAx = parcelRequire("eVPAx");

var $lige1 = parcelRequire("lige1");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $2m0b6 = parcelRequire("2m0b6");

var $aUryc = parcelRequire("aUryc");

var $4wxhn = parcelRequire("4wxhn");

var $79GY5 = parcelRequire("79GY5");

var $4NbaX = parcelRequire("4NbaX");

var $2lO5M = parcelRequire("2lO5M");

var $3HGy4 = parcelRequire("3HGy4");

var $dPLA9 = parcelRequire("dPLA9");

var $kcgTu = parcelRequire("kcgTu");

var $oCMSG = parcelRequire("oCMSG");

var $flhvf = parcelRequire("flhvf");

var $7VuRN = parcelRequire("7VuRN");

var $du3jQ = parcelRequire("du3jQ");

var $6udCd = parcelRequire("6udCd");

var $en9hF = parcelRequire("en9hF");

var $3Sb7F = parcelRequire("3Sb7F");

var $dnw7n = parcelRequire("dnw7n");

var $4oDrj = parcelRequire("4oDrj");
const $b85d234d8660788d$var$isEcClientEnabled = ()=>{
    const experiences = (0, $co1wz.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};
const $b85d234d8660788d$var$JsmRepackagingBannerWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b85d234d8660788d$var$jsmRepackagingBannerStyles
    }, children);
const $b85d234d8660788d$var$SidebarIcon = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnKeyDown = (event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) event.stopPropagation();
    };
    const onTooltipShow = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'queueSideBarIcon'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sideBarIconShown');
    }; // TODO This should flip between sidebar/dialog message when that is implemented
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $en9hF.default).openIssueInSidebarIssueTermRefresh : (0, $en9hF.default).openIssueInSidebar),
        onShow: onTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $en9hF.default).openIssueInSidebarIssueTermRefresh : (0, $en9hF.default).openIssueInSidebar),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4n4k5))), {
            spacing: "spacious",
            label: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $en9hF.default).openIssueInSidebarIssueTermRefresh : (0, $en9hF.default).openIssueInSidebar)
        }),
        appearance: "subtle",
        spacing: "compact",
        onClick: props.onClickHandler,
        onKeyDown: handleOnKeyDown
    }));
};
const $b85d234d8660788d$var$WINDOW_ACTIVE_EVENT = 'visibilitychange'; // eslint-disable-next-line jira/react/no-class-components
class $b85d234d8660788d$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.state = {
            startTime: null
        };
    }
    componentDidMount() {
        const { queue: queue, issueCollection: issueCollection, issueCount: issueCount } = this.props;
        this.prevQueue = queue;
        this.addNavigationEventListeners(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener($b85d234d8660788d$var$WINDOW_ACTIVE_EVENT, this.props.onWindowFocus);
        this.triggerIssuesChange(issueCollection);
        this.triggerIssuesCountChange(issueCount);
        this.setStartTime();
    }
    componentDidUpdate(prevProps) {
        const { onboardingResolved: onboardingResolved, onOnboardingResolved: onOnboardingResolved, issueCount: issueCount, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, onWindowFocus: onWindowFocus, isQueueVisible: isQueueVisible, onPageVisibilityChanged: onPageVisibilityChanged, queue: queue, issueCollection: issueCollection } = this.props; // onAtLeastOneIssueLoaded() lets the monolith know that a issue has loaded (for onboarding purposes)
        if (!onboardingResolved && issueCount > 0) {
            onAtLeastOneIssueLoaded();
            onOnboardingResolved(true);
        }
        if (prevProps.onWindowFocus !== onWindowFocus) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener($b85d234d8660788d$var$WINDOW_ACTIVE_EVENT, prevProps.onWindowFocus); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener($b85d234d8660788d$var$WINDOW_ACTIVE_EVENT, onWindowFocus);
        }
        if (prevProps.isQueueVisible !== isQueueVisible) onPageVisibilityChanged(isQueueVisible);
        prevProps.issueCollection !== issueCollection && this.triggerIssuesChange(issueCollection);
        prevProps.issueCount !== issueCount && this.triggerIssuesCountChange(issueCount);
        this.prevQueue = queue;
    }
    componentWillUnmount() {
        this.removeNavigationEventListeners();
        this.props.onUnmount(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener($b85d234d8660788d$var$WINDOW_ACTIVE_EVENT, this.props.onWindowFocus);
    }
    setStartTime() {
        const { startTime: startTime } = this.state;
        if (!startTime) this.setState({
            startTime: Date.now()
        });
    }
    getIsLoadingState() {
        const { isLoadingIssues: isLoadingIssues, queue: queue } = this.props;
        const { prevQueue: prevQueue } = this;
        if (prevQueue && prevQueue.id !== queue.id) return true;
        return isLoadingIssues;
    }
    isLoadingQueues() {
        const { queue: queue } = this.props;
        const { prevQueue: prevQueue } = this;
        return prevQueue && prevQueue.id !== queue.id;
    }
    addNavigationEventListeners() {
        const { onNavCollapseChange: onNavCollapseChange, sidebarApi: sidebarApi } = this.props;
        if (sidebarApi) {
            const { isCollapsed: isCollapsed, navActions: navActions } = sidebarApi;
            const { collapseStartAdd: collapseStartAdd, collapseStartClear: collapseStartClear, expandStartAdd: expandStartAdd, expandStartClear: expandStartClear } = navActions;
            onNavCollapseChange(isCollapsed);
            collapseStartAdd(()=>onNavCollapseChange(true));
            expandStartAdd(()=>onNavCollapseChange(false));
            this.removeNavListeners = ()=>{
                collapseStartClear();
                expandStartClear();
            };
        } else {
            const navigationApi = (0, $dPLA9.createNavigationApi)();
            navigationApi.then((sidebar)=>{
                onNavCollapseChange(sidebar.isCollapsed());
                const removeCollapseListener = sidebar.onCollapseStart(()=>onNavCollapseChange(true));
                const removeExpandListener = sidebar.onExpandStart(()=>onNavCollapseChange(false));
                this.removeNavListeners = ()=>{
                    removeCollapseListener();
                    removeExpandListener();
                };
            }) // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(()=>{});
        }
    }
    removeNavigationEventListeners() {
        this.removeNavListeners && this.removeNavListeners();
    }
    triggerQueueChange() {
        const { queue: queue, onQueueChanged: onQueueChanged } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.prevQueue?.id, queue.id) || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.prevQueue?.completeJql, queue.completeJql) || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.prevQueue?.columns, queue.columns) || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.prevQueue?.isFavorite, queue.isFavorite)) onQueueChanged(queue);
    }
    triggerIssuesChange(issueCollection) {
        const { onIssuesChanged: onIssuesChanged } = this.props;
        onIssuesChanged && onIssuesChanged(issueCollection.map((issue)=>issue?.key));
    }
    triggerIssuesCountChange(issuesCount) {
        const { onIssuesCountChanged: onIssuesCountChanged } = this.props;
        onIssuesCountChanged?.(issuesCount);
    }
    renderView() {
        const { Table: Table, EmptyQueue: EmptyQueue, EmptyFilteredQueue: EmptyFilteredQueue, isQueueEmpty: isQueueEmpty, isCurrentDataFiltered: isCurrentDataFiltered, shouldShowBadFilterQueryError: shouldShowBadFilterQueryError, onFilterClear: onFilterClear, onIssueChange: onIssueChange, onSetIssueKey: onSetIssueKey, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError, columns: columns, sidebarIssueKey: sidebarIssueKey, sidebarReactKey: sidebarReactKey } = this.props;
        if (this.isLoadingQueues()) // errorBoundary not necessary since core functionality is not visible
        return (0, $4R6GH.fg)('add_ufo_load_hold_to_custom_queue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "table-with-issue-sidebar"
        }) : null;
        if (isCurrentDataFiltered && !this.getIsLoadingState() && shouldShowBadFilterQueryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$EmptyStateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
            eventName: "jsmQueueFiltering failed"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$EmptyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $du3jQ.FilterQueryFailed), {
            onFilterClear: onFilterClear
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Table, null));
        if (isCurrentDataFiltered && isQueueEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$EmptyStateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$EmptyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EmptyFilteredQueue, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Table, null));
        if (isQueueEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EmptyQueue, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$TableWithIssueSidebar, {
            Table: Table,
            onIssueChange: onIssueChange,
            onSetIssueKey: onSetIssueKey,
            columns: columns,
            issueKey: sidebarIssueKey,
            reactKey: sidebarReactKey,
            onError: onNonPremiumSLAColumnError
        });
    }
    renderWithoutSelectedIssuesContainer() {
        const { isInitialized: isInitialized, ErrorState: ErrorState, UsageSampler: UsageSampler, Header: Header, queue: { id: queueId }, NavUpdater: NavUpdater, showIssueFailureError: showIssueFailureError, isQueueVisible: isQueueVisible, ViewTracker: ViewTracker, QueuesBreadcrumb: QueuesBreadcrumb, IssueContextListener: IssueContextListener, ItsmContextListener: ItsmContextListener, baseUrl: baseUrl, projectKey: projectKey, category: category, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError } = this.props;
        const is2DFOCAQExperimentEnabled = category === (0, $oCMSG.NO_CATEGORY) && (0, $4R6GH.fg)('jsm_2d_fo_core_actions_gate');
        const isLoading = this.getIsLoadingState(); // This is a state change during render, which is bad. See the comment
        // around ServiceDeskAnalyticsContext#forceRenderWhileLoading:
        // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/servicedesk/queues-agent-view/src/view/index.tsx#110
        this.triggerQueueChange();
        if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79GY5.default), null);
        if (showIssueFailureError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jsm-fission-decompose-queue-page-header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2lO5M.default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            category: category || (0, $oCMSG.NO_CATEGORY)
        }, (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dnw7n.default), {
                onDeleteComplete: actions.deleteItem
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcgTu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Sb7F.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorState, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dnw7n.default), {
                onDeleteComplete: actions.deleteItem
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Sb7F.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorState, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2lO5M.default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            category: category || (0, $oCMSG.NO_CATEGORY)
        }, (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, {
                queueId: queueId,
                onDeleteComplete: actions.deleteItem
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorState, null))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(QueuesBreadcrumb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueContextListener, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ItsmContextListener, {
            projectKey: projectKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$LayoutContainer, {
            visible: isQueueVisible,
            "data-test-id": "servicedesk-queues-agent-view.layout.layout"
        }, isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewTracker, {
            key: (0, $3HGy4.fromQueueIdString)(queueId),
            queueId: queueId
        }), (category === (0, $oCMSG.INCIDENTS) || category === (0, $oCMSG.POST_INCIDENT_REVIEWS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4NbaX.AsyncPostIncidentReviewBenefitModal), {
            queueCategory: category
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2lO5M.default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            category: category || (0, $oCMSG.NO_CATEGORY)
        }, (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
                onError: onNonPremiumSLAColumnError,
                id: "queue-nav-updater"
            }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NavUpdater, {
                queueId: queueId,
                onQueueIssueCountUpdated: actions.editItemIssueCount,
                onProjectStateHashUpdate: actions.refreshNavItems
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UsageSampler, null)), (0, $4R6GH.fg)('jsm-fission-decompose-queue-page-header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dnw7n.default), {
                onDeleteComplete: actions.deleteItem
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, {
                queueId: queueId,
                onDeleteComplete: actions.deleteItem
            }))), (category === (0, $oCMSG.CHANGES) || category === (0, $oCMSG.INCIDENTS)) && (0, $4R6GH.fg)('enable-assets-in-change-management') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6udCd.JsmAssetsOnboarding), {
            category: category
        }), (0, $4R6GH.fg)('jsm-fission-decompose-queue-page-header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (category === (0, $oCMSG.CHANGES) || category === (0, $oCMSG.PROBLEMS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lige1.JsmRepackagingBanner), {
            workCategory: category,
            renderWrapper: $b85d234d8660788d$var$JsmRepackagingBannerWrapper
        }), category === (0, $oCMSG.POST_INCIDENT_REVIEWS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lige1.JsmRepackagingBanner), {
            workCategory: (0, $oCMSG.INCIDENTS),
            renderWrapper: $b85d234d8660788d$var$JsmRepackagingBannerWrapper
        }), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcgTu.default), null, is2DFOCAQExperimentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8RZJT.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Sb7F.default), null), this.renderView()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, is2DFOCAQExperimentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8RZJT.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Sb7F.default), null), this.renderView())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (category === (0, $oCMSG.CHANGES) || category === (0, $oCMSG.PROBLEMS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lige1.JsmRepackagingBanner), {
            workCategory: category,
            renderWrapper: $b85d234d8660788d$var$JsmRepackagingBannerWrapper
        }), category === (0, $oCMSG.POST_INCIDENT_REVIEWS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lige1.JsmRepackagingBanner), {
            workCategory: (0, $oCMSG.INCIDENTS),
            renderWrapper: $b85d234d8660788d$var$JsmRepackagingBannerWrapper
        }), this.renderView())));
    }
    render() {
        const { queue: { id: queueId }, itsmPractices: itsmPractices, issueCollection: issueCollection, issueCount: issueCount, projectKey: projectKey, projectId: projectId, columns: columns, jql: jql } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            attributes: {
                itsmPractices: itsmPractices
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17JMK.SelectedIssuesContainer), {
            scope: `queue - ${(0, $3HGy4.fromQueueIdString)(queueId)}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUryc.LoadedIssuesContainer), {
            scope: `queue - ${(0, $3HGy4.fromQueueIdString)(queueId)}`,
            queueId: (0, $3HGy4.fromQueueIdString)(queueId),
            projectKey: projectKey,
            projectId: projectId,
            issueCollection: issueCollection,
            totalIssueCount: issueCount,
            columns: columns,
            jql: jql
        }, this.renderWithoutSelectedIssuesContainer())));
    }
}
const { useResizeObserver: $b85d234d8660788d$var$useResizeObserver } = (0, $2m0b6.createResizeObserverHook)({
    debouncePeriod: 50 // optional debouncing of resize notifications
});
const $b85d234d8660788d$var$TableWithIssueSidebar = ({ Table: Table, onIssueChange: onIssueChange, onSetIssueKey: onSetIssueKey, onError: onError, issueKey: issueKey, reactKey: reactKey })=>{
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const [tableWidth, setTableWidth] = (0, $5uXOq.useState)(0);
    const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
    const [startTime, setStartTime] = (0, $5uXOq.useState)(null);
    const throttledSetWidth = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const shouldHideHorizontalBar = false && (0, $4R6GH.fg)('issuelist_ssr_hide_scroll_bars'); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($b85d234d8660788d$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $eVPAx.useEcClient)().saveIssueMutationToCache;
    const ref = (0, $5uXOq.useRef)(null);
    $b85d234d8660788d$var$useResizeObserver({
        ref: ref,
        onResize () {
            setTableWidth(ref.current?.clientWidth ?? 0);
        }
    });
    const onChangeHandler = (event)=>{
        onIssueChange();
        (0, $4wxhn.saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
    };
    const renderSidebarIcon = (0, $5uXOq.useCallback)((selectedIssueKey)=>{
        const onClickHandler = ()=>{
            const sidebarIconClickEvent = createAnalyticsEvent({
                action: 'click',
                actionSubject: 'queueSideBarIcon'
            });
            (0, $8zOmE.fireTrackAnalytics)(sidebarIconClickEvent, 'sideBarIcon clicked');
            onSetIssueKey(selectedIssueKey);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$SidebarIcon, {
            onClickHandler: onClickHandler
        });
    }, [
        createAnalyticsEvent,
        onSetIssueKey
    ]);
    const onJSMQueueDurationEvent = (0, $5uXOq.useCallback)(()=>{
        if (startTime) {
            const duration = Date.now() - startTime;
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueIssue view', {
                duration: duration
            }); // Only fire after the first click
            setStartTime(null);
        }
    }, [
        createAnalyticsEvent,
        startTime
    ]);
    const onSidebarClose = (0, $5uXOq.useCallback)(()=>{
        onSetIssueKey(null);
    }, [
        onSetIssueKey
    ]);
    const onIssueDeleteSuccess = (0, $5uXOq.useCallback)(()=>{
        onSetIssueKey(null);
        onIssueChange();
    }, [
        onIssueChange,
        onSetIssueKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setStartTime(Date.now());
    }, [
        setStartTime
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$ViewWrapper, {
        "data-testid": "servicedesk-queues-agent-view.layout.tablecontainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b85d234d8660788d$var$TableAndSidebarWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: throttledSetWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b85d234d8660788d$var$TableWrapper, {
        "data-testid": "servicedesk-queues-agent-view.layout.table",
        isResizing: isResizing,
        withCssSupport: (0, $4R6GH.fg)('css_support_for_virtual_table'),
        ref: ref,
        shouldHideHorizontalBar: shouldHideHorizontalBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Table, {
        renderSidebarIcon: renderSidebarIcon,
        shouldRerenderRowOnHover: true,
        useJSMQueueDurationEvent: onJSMQueueDurationEvent,
        width: width,
        tableWidth: tableWidth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
        onError: onError,
        id: "sidebar-issue-view"
    }, issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDrj.SidebarIssueView), {
        key: reactKey,
        issueKey: issueKey,
        parentWidth: width,
        onClose: onSidebarClose,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        analyticsSource: (0, $fcf97b7a09088940$export$7063ee6d0035a982),
        setIsResizing: setIsResizing,
        onChange: onChangeHandler
    }))), (0, $4R6GH.fg)('jsm_boards_promo_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VuRN.BoardPromoSpotlight), null));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b85d234d8660788d$var$LayoutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visible: visible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $lD23V.default)((0, $44v1T.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2lx21bp4 _4t3i1l47",
            __cmplp.visible ?? true ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b85d234d8660788d$var$EmptyStateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1c0ioahv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b85d234d8660788d$var$EmptyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _19pk9by0 _18u01ssb _t9ecg9dd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b85d234d8660788d$var$ViewWrapperLegacy = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b85d234d8660788d$var$ViewWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $b85d234d8660788d$var$ViewWrapper = (0, $cSD7y.componentWithFG)('jsm-fission-decompose-queue-page-header', $b85d234d8660788d$var$ViewWrapperNew, $b85d234d8660788d$var$ViewWrapperLegacy); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b85d234d8660788d$var$TableWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withCssSupport: withCssSupport, shouldHideHorizontalBar: shouldHideHorizontalBar, isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jl11wp _p12f1osq",
            __cmplp.withCssSupport || __cmplp.shouldHideHorizontalBar ? "_1reo15vq _18m915vq" : "_1reo1wug _18m9ewfl",
            __cmplp.isResizing ? "_uiztglyw" : "_uizt1wug",
            __cmplp.className
        ])
    });
});
const $b85d234d8660788d$var$TableAndSidebarWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    width: '100%'
});
const $b85d234d8660788d$var$jsmRepackagingBannerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("4n4k5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e439b002f43a5f4e3cda4db0d114175>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32eca9e1c2feaa3e$var$_react = $32eca9e1c2feaa3e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32eca9e1c2feaa3e$var$_sidebarRight = $32eca9e1c2feaa3e$var$_interopRequireDefault((parcelRequire("aRO6g")));

var $32eca9e1c2feaa3e$var$_detailView = $32eca9e1c2feaa3e$var$_interopRequireDefault((parcelRequire("jmEdU")));
function $32eca9e1c2feaa3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SidebarRightIcon.
 * This component is SidebarRightIcon, with `UNSAFE_fallbackIcon` set to "DetailViewIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a sidebar to the right of the viewport edge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32eca9e1c2feaa3e$var$SidebarRightIcon = (props)=>/*#__PURE__*/ $32eca9e1c2feaa3e$var$_react.default.createElement($32eca9e1c2feaa3e$var$_sidebarRight.default, Object.assign({
        LEGACY_fallbackIcon: $32eca9e1c2feaa3e$var$_detailView.default
    }, props));
$32eca9e1c2feaa3e$var$SidebarRightIcon.Name = 'SidebarRightIconMigration';
var $32eca9e1c2feaa3e$var$_default = module.exports.default = $32eca9e1c2feaa3e$var$SidebarRightIcon;

});
parcelRegister("aRO6g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daa753b85adf49eed16fb99089492eb3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e95b773b99220a6$var$_react = $7e95b773b99220a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7e95b773b99220a6$var$_baseNew = $7e95b773b99220a6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7e95b773b99220a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a sidebar to the right of the viewport edge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e95b773b99220a6$var$SidebarRightIcon = (props)=>/*#__PURE__*/ $7e95b773b99220a6$var$_react.default.createElement($7e95b773b99220a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 2.75H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H7.75m0-10.5v10.5m0-10.5H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h5.75M10 5.75h3m-3 3h3"/>`
    }, props));
$7e95b773b99220a6$var$SidebarRightIcon.displayName = 'SidebarRightIcon';
var $7e95b773b99220a6$var$_default = module.exports.default = $7e95b773b99220a6$var$SidebarRightIcon;

});

parcelRegister("jmEdU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e18f45ea4410736a$var$_react = $e18f45ea4410736a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e18f45ea4410736a$var$_sidebarRight = $e18f45ea4410736a$var$_interopRequireDefault((parcelRequire("aRO6g")));
function $e18f45ea4410736a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e18f45ea4410736a$var$DetailViewIcon = (props)=>/*#__PURE__*/ $e18f45ea4410736a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
    }, props, {
        newIcon: $e18f45ea4410736a$var$_sidebarRight.default
    }));
$e18f45ea4410736a$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $e18f45ea4410736a$var$_default = module.exports.default = $e18f45ea4410736a$var$DetailViewIcon;

});


parcelRegister("8RZJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa8768dfd7f13ba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $6a9Wp = parcelRequire("6a9Wp");

var $2hpVg = parcelRequire("2hpVg");

var $3Fq5M = parcelRequire("3Fq5M");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $9inlc = parcelRequire("9inlc");

var $7CMCs = parcelRequire("7CMCs");

var $5Zxxp = parcelRequire("5Zxxp");

var $dAfqg = parcelRequire("dAfqg");

var $90yGq = parcelRequire("90yGq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $lVJAU = parcelRequire("lVJAU");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $4xOey = parcelRequire("4xOey");

var $kgybo = parcelRequire("kgybo");

var $5dX7y = parcelRequire("5dX7y");
const $9fa8768dfd7f13ba$var$EmailRequestSectionMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const openInProductHelp = (0, $5Zxxp.useHelpPanelLink)(true);
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const accountId = (0, $90yGq.useAccountId)();
    const { projectKey: projectKey, isProjectAdmin: isProjectAdmin = false } = projectContext ?? {};
    const { emailAddress: emailAddress, isEmailedRequestCreated: isEmailedRequestCreated, error: error, stopPolling: stopPolling } = (0, $4xOey.default)();
    const { isLoading: isLoading, showSectionMessage: showSectionMessage, dismissSectionMessage: dismissSectionMessage } = (0, $kgybo.useSectionDismiss)(accountId, 'emailRequestIntegrationSectionMessageVisible');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleIPHOpenAndRedirection = (articleId, url)=>{
        openInProductHelp?.(articleId);
        if (url) push(url);
    };
    const handleDismissSectionMessage = (_e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closeSectionMessage', {
            isEmailedRequestCreated: isEmailedRequestCreated
        });
        stopPolling();
        dismissSectionMessage();
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading && !showSectionMessage) stopPolling();
    }, [
        stopPolling,
        isLoading,
        showSectionMessage,
        projectKey
    ]);
    const mailtoLink = emailAddress ? `mailto:${encodeURIComponent(emailAddress)}?subject=${encodeURIComponent(formatMessage((0, $5dX7y.default).defaultEmailSubject))}&body=${encodeURIComponent(formatMessage((0, $5dX7y.default).defaultEmailBody))}` : '#';
    const actions = [
        isEmailedRequestCreated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            key: "add-email",
            onClick: (_e, analyticsEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'addEmailAccount');
                handleIPHOpenAndRedirection((0, $370dc40abdeb5442$export$662fd3d5c7ca97e7), `/jira/servicedesk/projects/${projectKey}/settings/email`);
            }
        }, formatMessage((0, $5dX7y.default).addEmailAccountSectionMessageAction1)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            key: "send-email",
            href: mailtoLink,
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'sendTestEmail');
            },
            linkComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                    ...props,
                    target: "_blank"
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $9fa8768dfd7f13ba$var$sectionMessageActionStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hpVg))), {
            label: formatMessage((0, $5dX7y.default).sendEmailIconLabel)
        }), formatMessage((0, $5dX7y.default).emailRequestSectionMessageAction))),
        isEmailedRequestCreated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            key: "add-email-2",
            onClick: (_e, analyticsEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'readMoreEmailedRequest');
                handleIPHOpenAndRedirection((0, $370dc40abdeb5442$export$a46487d21c2d311));
            }
        }, formatMessage((0, $5dX7y.default).addEmailAccountSectionMessageAction2))
    ].filter(Boolean);
    (0, $5uXOq.useEffect)(()=>{
        if (projectKey && isProjectAdmin && !error && !isLoading && showSectionMessage && emailAddress && isEmailedRequestCreated !== undefined && (0, $6s1PB.expValEquals)('jsm_2d_fo_core_actions', 'cohort', 'variation')) (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}), {
            isEmailedRequestCreated: isEmailedRequestCreated
        });
    }, [
        projectKey,
        isProjectAdmin,
        error,
        isLoading,
        showSectionMessage,
        emailAddress,
        isEmailedRequestCreated,
        createAnalyticsEvent
    ]);
    if (!projectKey || !isProjectAdmin || error || isLoading || !showSectionMessage || !emailAddress || emailAddress === undefined && isEmailedRequestCreated === undefined || !(0, $6s1PB.expValEquals)('jsm_2d_fo_core_actions', 'cohort', 'variation')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9fa8768dfd7f13ba$var$sectionMessageContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: formatMessage(isEmailedRequestCreated ? (0, $5dX7y.default).addEmailAccountSectionMessageTitle : (0, $5dX7y.default).emailRequestSectionMessageTitle),
        appearance: "discovery",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6a9Wp))),
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9fa8768dfd7f13ba$var$closeButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))),
        spacing: "compact",
        label: formatMessage((0, $5dX7y.default).closeSectionMessageIconLabel),
        onClick: handleDismissSectionMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, isEmailedRequestCreated ? formatMessage((0, $5dX7y.default).addEmailAccountSectionMessageDescription) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "end",
        wrap: "wrap"
    }, formatMessage((0, $5dX7y.default).emailRequestSectionMessageDescription, {
        email: emailAddress,
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                href: mailtoLink,
                onClick: (_e, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'emailAddress');
                },
                target: "_blank",
                xcss: $9fa8768dfd7f13ba$var$inlineLinkStyle
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
        spacing: "compact",
        label: formatMessage((0, $5dX7y.default).emailLinkCopyButtonLabel),
        isTooltipDisabled: false,
        onClick: (_e, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'copyEmailAddress');
            (0, $9inlc.copyLinkToClipboard)({
                linkToBeCopied: emailAddress ?? ''
            });
        }
    }))), formatMessage((0, $5dX7y.default).emailRequestSectionMessageDescription2)))));
};
const $9fa8768dfd7f13ba$export$3f9360e58b4db614 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "email-request-section-message-error-boundary",
        packageName: (0, $370dc40abdeb5442$export$b8b9d90f9e5bd72b),
        teamName: (0, $370dc40abdeb5442$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: (0, $370dc40abdeb5442$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9fa8768dfd7f13ba$var$EmailRequestSectionMessage, null)));
const $9fa8768dfd7f13ba$var$sectionMessageActionStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.075',
    fontWeight: 'font.weight.medium'
});
const $9fa8768dfd7f13ba$var$closeButtonStyle = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100'
});
const $9fa8768dfd7f13ba$var$sectionMessageContainerStyle = (0, $8CUq3.xcss)({
    position: 'relative',
    paddingBottom: 'space.300'
});
const $9fa8768dfd7f13ba$var$inlineLinkStyle = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050'
});
var $9fa8768dfd7f13ba$export$2e2bcd8739ae039 = $9fa8768dfd7f13ba$export$3f9360e58b4db614;

});
parcelRegister("2hpVg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43662e724292c2a3f7a9f31ae8f59e23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a9146fe97597a23$var$_react = $1a9146fe97597a23$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1a9146fe97597a23$var$_baseNew = $1a9146fe97597a23$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $1a9146fe97597a23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a9146fe97597a23$var$SendIcon = (props)=>/*#__PURE__*/ $1a9146fe97597a23$var$_react.default.createElement($1a9146fe97597a23$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.679 2.321 6.252 9.753M14.25 1.75l-13.5 5 5.5 3 3 5.5z"/>`
    }, props));
$1a9146fe97597a23$var$SendIcon.displayName = 'SendIcon';
var $1a9146fe97597a23$var$_default = module.exports.default = $1a9146fe97597a23$var$SendIcon;

});

parcelRegister("9inlc", function(module, exports) {

$parcel$export(module.exports, "chatOpsMessageHandler", () => $2480812c9ff584c3$export$6e5d249d884395f6);
$parcel$export(module.exports, "copyLinkToClipboard", () => $2480812c9ff584c3$export$7ace34f0f1e14a04);
$parcel$export(module.exports, "getAppStateForIssueAPIUrl", () => $2480812c9ff584c3$export$18df34c5bd8ea4e8);
$parcel$export(module.exports, "createActionAPIUrl", () => $2480812c9ff584c3$export$42fb79fda2fa7133);
$parcel$export(module.exports, "removeActionAPIUrl", () => $2480812c9ff584c3$export$61a50c25fa3e5d4a);
$parcel$export(module.exports, "getSiteSettingsUrl", () => $2480812c9ff584c3$export$23eb643efe1a9597);
$parcel$export(module.exports, "getProjectIMSettingsUrl", () => $2480812c9ff584c3$export$befcc7e7fe62cbf7);
$parcel$export(module.exports, "getZoomUserAuthorise", () => $2480812c9ff584c3$export$ba910f9a52731174);
$parcel$export(module.exports, "JIRA_SUPPORT_LINK", () => $2480812c9ff584c3$export$4dc85a478189d1be);

var $4R6GH = parcelRequire("4R6GH");

var $bGKwE = parcelRequire("bGKwE");
const $2480812c9ff584c3$export$6e5d249d884395f6 = ({ event: event, onSuccessCallback: onSuccessCallback, onFailedCallback: onFailedCallback, requiredEventId: requiredEventId })=>{
    if (event.origin !== 'https://api-private.stg.atlassian.com' && event.origin !== 'https://api-private.atlassian.com') return;
    if (!event.data || !event.data.event_id || event.data.event_id !== requiredEventId) return;
    const eventData = event.data;
    if (eventData?.data?.success === 'true') onSuccessCallback?.();
    else if (eventData?.data?.success === 'false') onFailedCallback?.();
};
const $2480812c9ff584c3$export$7ace34f0f1e14a04 = ({ linkToBeCopied: linkToBeCopied, onSuccessCallback: onSuccessCallback, onFailedCallback: onFailedCallback })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    ((0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator.clipboard : navigator.clipboard).writeText(linkToBeCopied || '').then(()=>{
        onSuccessCallback?.();
    }).catch(()=>{
        onFailedCallback?.();
    });
};
const $2480812c9ff584c3$export$b419256af6495e9e = (cloudId)=>`/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat`;
const $2480812c9ff584c3$export$18df34c5bd8ea4e8 = ({ cloudId: cloudId, issueId: issueId, projectId: projectId, type: type })=>`${$2480812c9ff584c3$export$b419256af6495e9e(cloudId)}/issue-state?issuerType=${0, $bGKwE.ISSUER_TYPE}&issuerId=${issueId}&chatType=${(0, $bGKwE.APP_INFO_MAP)[type].chatType}&scopeType=${(0, $bGKwE.APP_INFO_MAP)[type].scopeType}&scopeId=${cloudId}&entityType=${0, $bGKwE.ENTITY_TYPE}&entityId=${projectId}&appType=${(0, $bGKwE.APP_INFO_MAP)[type].appType}`;
const $2480812c9ff584c3$export$42fb79fda2fa7133 = ({ cloudId: cloudId, type: type })=>`${$2480812c9ff584c3$export$b419256af6495e9e(cloudId)}/conversations/${type}`;
const $2480812c9ff584c3$export$61a50c25fa3e5d4a = ({ cloudId: cloudId, connectionId: connectionId, issueId: issueId, conversationType: conversationType, type: type })=>`${$2480812c9ff584c3$export$b419256af6495e9e(cloudId)}/conversation?connectionId=${connectionId}&issuerType=${0, $bGKwE.ISSUER_TYPE}&issuerId=${issueId}&conversationType=${conversationType}&appType=${(0, $bGKwE.APP_INFO_MAP)[type].appType}`;
const $2480812c9ff584c3$export$23eb643efe1a9597 = ()=>'/jira/settings/products/ops/jira-service-management-chatops-and-video-tools';
const $2480812c9ff584c3$export$befcc7e7fe62cbf7 = (projectKey)=>`/jira/servicedesk/projects/${projectKey ?? ''}/settings/incident-management?showIMSetting=true`;
const $2480812c9ff584c3$export$ba910f9a52731174 = ({ cloudId: cloudId, issueId: issueId, connectionId: connectionId })=>`${$2480812c9ff584c3$export$b419256af6495e9e(cloudId)}/authorize/zoom/agent?appType=${(0, $bGKwE.APP_INFO_MAP).zoom.appType}&openingURL=https://zoom.us/redirect&issueId=${issueId}&connectionId=${connectionId}`;
const $2480812c9ff584c3$export$4dc85a478189d1be = 'https://support.atlassian.com/contact/';

});
parcelRegister("bGKwE", function(module, exports) {

$parcel$export(module.exports, "APP_INFO_MAP", () => $a60de26054c8155d$export$5506032c24ca5633);
$parcel$export(module.exports, "ISSUER_TYPE", () => $a60de26054c8155d$export$ed8bc28e8a018e1a);
$parcel$export(module.exports, "ENTITY_TYPE", () => $a60de26054c8155d$export$49be827a0aef75dd);
$parcel$export(module.exports, "CONVERSATION_TYPE_MAP", () => $a60de26054c8155d$export$45f9a58a73c2533e);
const $a60de26054c8155d$export$5506032c24ca5633 = {
    zoom: {
        scopeType: 'jsm-chat-ops-zoom-integration',
        chatType: 'zoom',
        appType: 'jsm-zoom-app'
    },
    msteams: {
        scopeType: 'jsm-chat-ops-msteams-integration',
        chatType: 'msteams',
        appType: 'jsm-msteams-app'
    }
};
const $a60de26054c8155d$export$ed8bc28e8a018e1a = 'jsm-issue';
const $a60de26054c8155d$export$49be827a0aef75dd = 'jsm-project';
const $a60de26054c8155d$export$45f9a58a73c2533e = {
    zoom: 'zoom-meeting'
};

});


const $370dc40abdeb5442$export$b8b9d90f9e5bd72b = 'jiraServicedeskEmailRequestIntegrationSectionMessage';
const $370dc40abdeb5442$export$d57b6b390e78d90f = 'itops-mithril';
const $370dc40abdeb5442$export$662fd3d5c7ca97e7 = '5HYkUFADaPTFLqkD2wdA8h';
const $370dc40abdeb5442$export$a46487d21c2d311 = '5HYkUFADaPTFLqkD2wdA8h';

parcelRegister("4xOey", function(module, exports) {

$parcel$export(module.exports, "default", () => $7701365af99dd503$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $dAfqg = parcelRequire("dAfqg");

var $6s1PB = parcelRequire("6s1PB");

var $366gN = parcelRequire("366gN");

const $7701365af99dd503$var$useEmailRequestStatus = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { projectKey: projectKey, isProjectAdmin: isProjectAdmin = false, simplified: simplified } = projectContext ?? {};
    const [emailAddress, setEmailAddress] = (0, $5uXOq.useState)(undefined);
    const [isEmailedRequestCreated, setIsEmailedRequestCreated] = (0, $5uXOq.useState)(undefined);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const intervalIdRef = (0, $5uXOq.useRef)(null);
    const stopPolling = ()=>{
        if (intervalIdRef.current) clearInterval(intervalIdRef.current);
    };
    (0, $5uXOq.useEffect)(()=>{
        setEmailAddress(undefined);
    }, [
        projectContext?.projectKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!projectKey || !isProjectAdmin || !(0, $6s1PB.expValEquals)('jsm_2d_fo_core_actions', 'cohort', 'variation')) return;
        const fetchEmailAddressAndStatus = async ()=>{
            try {
                const response = await (0, $366gN.checkEmailRequestStatus)(projectKey);
                const incomingEmails = response.incomingEmails || [];
                const defaultEmail = simplified ? incomingEmails.find((email)=>email.onDemand === true) : incomingEmails.find((email)=>email.defaultReplyTo === true);
                if (defaultEmail) setEmailAddress(defaultEmail.emailAddress);
                if (!defaultEmail && intervalIdRef.current) clearInterval(intervalIdRef.current);
                if (incomingEmails.some((email)=>email.lastProcessedTime !== 0)) setIsEmailedRequestCreated(true);
                else setIsEmailedRequestCreated(false);
            } catch (e) {
                const errorInstance = e instanceof Error ? e : new Error('Unknown error');
                setError(errorInstance);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'fetchEmailAddressAndStatus',
                        packageName: (0, $370dc40abdeb5442$export$b8b9d90f9e5bd72b),
                        teamName: (0, $370dc40abdeb5442$export$d57b6b390e78d90f)
                    },
                    error: errorInstance,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        fetchEmailAddressAndStatus();
        intervalIdRef.current = setInterval(fetchEmailAddressAndStatus, 5000);
        return ()=>{
            if (intervalIdRef.current !== null) clearInterval(intervalIdRef.current);
        };
    }, [
        simplified,
        projectKey,
        isProjectAdmin
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isEmailedRequestCreated && intervalIdRef.current) clearInterval(intervalIdRef.current);
    }, [
        isEmailedRequestCreated
    ]);
    return {
        emailAddress: emailAddress,
        isEmailedRequestCreated: isEmailedRequestCreated,
        error: error,
        stopPolling: stopPolling
    };
};
var $7701365af99dd503$export$2e2bcd8739ae039 = $7701365af99dd503$var$useEmailRequestStatus;

});
parcelRegister("366gN", function(module, exports) {

$parcel$export(module.exports, "checkEmailRequestStatus", () => $e7c50ce91d5a9ec2$export$476bea31457ed5a5);
$parcel$export(module.exports, "dismissSectionMessageRequest", () => $e7c50ce91d5a9ec2$export$4fe5f001484dbcd0);
$parcel$export(module.exports, "getUserProperty", () => $e7c50ce91d5a9ec2$export$b3126db2ef6e34ed);

var $7f4tk = parcelRequire("7f4tk");

var $eusud = parcelRequire("eusud");
const $e7c50ce91d5a9ec2$export$476bea31457ed5a5 = async (projectKey)=>(0, $7f4tk.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/incomingemail`);
const $e7c50ce91d5a9ec2$var$getUrl = (accountId, key)=>`/rest/api/3/user/properties/${key}?accountId=${accountId}`;
const $e7c50ce91d5a9ec2$export$4fe5f001484dbcd0 = (accountId, key)=>()=>(0, $eusud.performPutRequest)($e7c50ce91d5a9ec2$var$getUrl(accountId, key), {
            body: JSON.stringify(false)
        });
const $e7c50ce91d5a9ec2$export$b3126db2ef6e34ed = (accountId, key)=>(0, $eusud.performGetRequest)($e7c50ce91d5a9ec2$var$getUrl(accountId, key));

});


parcelRegister("kgybo", function(module, exports) {

$parcel$export(module.exports, "useSectionDismiss", () => $74a8995f6be1e05a$export$b5e1194cc0a3087d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $ld2hZ = parcelRequire("ld2hZ");

var $366gN = parcelRequire("366gN");

const $74a8995f6be1e05a$var$handleErrorLogging = (operation, error, attributes)=>{
    (0, $jcw0u.default)({
        meta: {
            id: operation,
            packageName: (0, $370dc40abdeb5442$export$b8b9d90f9e5bd72b),
            teamName: (0, $370dc40abdeb5442$export$d57b6b390e78d90f)
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: attributes
    });
};
const $74a8995f6be1e05a$export$b5e1194cc0a3087d = (accountId, messageKey)=>{
    const [showSectionMessage, setShowSectionMessage] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(!!accountId);
    const getSectionMessageVisibilityState = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const response = await (0, $366gN.getUserProperty)(accountId, messageKey);
            setShowSectionMessage(response.value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setShowSectionMessage(error.statusCode === 404);
            error.statusCode !== 404 && $74a8995f6be1e05a$var$handleErrorLogging('getSectionMessageState', error, {
                messageKey: messageKey
            });
        } finally{
            setIsLoading(false);
        }
    }, [
        messageKey,
        accountId
    ]);
    const { error: dismissSectionMessageError, fetch: fetch } = (0, $ld2hZ.useService)((0, $366gN.dismissSectionMessageRequest)(accountId, messageKey));
    const dismissSectionMessage = (0, $5uXOq.useCallback)(()=>{
        setShowSectionMessage(false);
        accountId && fetch();
    }, [
        fetch,
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (accountId) getSectionMessageVisibilityState();
    }, [
        getSectionMessageVisibilityState,
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (dismissSectionMessageError) $74a8995f6be1e05a$var$handleErrorLogging('dismissSectionMessage', dismissSectionMessageError, {
            messageKey: messageKey
        });
    }, [
        dismissSectionMessageError,
        messageKey
    ]);
    return {
        isLoading: isLoading,
        showSectionMessage: showSectionMessage,
        dismissSectionMessage: dismissSectionMessage
    };
};

});

parcelRegister("5dX7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9404ac164e264a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e9404ac164e264a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emailRequestSectionMessageTitle: {
        "id": "servicedesk-email-request-integration-section-message.email-request-section-message.title",
        "defaultMessage": "Discover how requests come into your queues from email"
    },
    emailRequestSectionMessageDescription: {
        "id": "servicedesk-email-request-integration-section-message.email-request-section-message.description",
        "defaultMessage": "Send a test email to your project's inbox at <link>{email}</link>"
    },
    emailRequestSectionMessageDescription2: {
        "id": "servicedesk-email-request-integration-section-message.email-request-section-message.description-2",
        "defaultMessage": "The email request usually arrives in your queues within 30 seconds, though times may vary by email provider."
    },
    emailRequestSectionMessageAction: {
        "id": "servicedesk-email-request-integration-section-message.email-request-section-message.action",
        "defaultMessage": "Send a test email"
    },
    sendEmailIconLabel: {
        "id": "servicedesk-email-request-integration-section-message.email-request-section-message.send-email-icon-label",
        "defaultMessage": "Send email"
    },
    closeSectionMessageIconLabel: {
        "id": "servicedesk-email-request-integration-section-message.email-request-section-message.close-section-message-icon-label",
        "defaultMessage": "Close section message"
    },
    addEmailAccountSectionMessageTitle: {
        "id": "servicedesk-email-request-integration-section-message.add-email-account-section-message.title",
        "defaultMessage": "Prefer using your own email account to get requests?"
    },
    addEmailAccountSectionMessageDescription: {
        "id": "servicedesk-email-request-integration-section-message.add-email-account-section-message.description",
        "defaultMessage": "No problem! Just connect a custom account and get requests from it in your queues."
    },
    addEmailAccountSectionMessageAction1: {
        "id": "servicedesk-email-request-integration-section-message.add-email-account-section-message.action1",
        "defaultMessage": "Add an email account"
    },
    addEmailAccountSectionMessageAction2: {
        "id": "servicedesk-email-request-integration-section-message.add-email-account-section-message.action2",
        "defaultMessage": "Read more on emailed requests"
    },
    defaultEmailSubject: {
        "id": "servicedesk-email-request-integration-section-message.email-request-section-message.default-email-subject",
        "defaultMessage": "*Test email* Login help"
    },
    defaultEmailBody: {
        "id": "servicedesk-email-request-integration-section-message.email-request-section-message.default-email-body",
        "defaultMessage": "Hey, I can't log in to the system. Can you help me reset my password?"
    },
    emailLinkCopyButtonLabel: {
        "id": "servicedesk-getting-started-page.set-up-basics.review-request-channels.email-link-copy-button-label",
        "defaultMessage": "Copy email address"
    }
});

});


parcelRegister("lige1", function(module, exports) {

$parcel$export(module.exports, "JsmRepackagingBanner", () => $e520683827b67dcb$export$35e7cf278e8fd184);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e520683827b67dcb$var$AsyncJsmRepackagingBanner = (0, $kxZPA.lazy)(()=>(parcelRequire("bNt5D")).then((module)=>module.JsmRepackagingBanner), {
    moduleId: "./src/packages/servicedesk/jsm-repackaging-banner/src/ui/index.tsx"
});
const $e520683827b67dcb$export$35e7cf278e8fd184 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsmRepackagingBanner",
        packageName: "jiraJsmRepackagingBanner",
        fallback: "unmount",
        teamName: "jenga",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-repackaging-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e520683827b67dcb$var$AsyncJsmRepackagingBanner, props)));

});
parcelRegister("bNt5D", function(module, exports) {

let $896ad5ef30f322f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $896ad5ef30f322f0$var$load("isQnH").then(()=>parcelRequire('37f9Z'));

});


parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("aUryc", function(module, exports) {

$parcel$export(module.exports, "LoadedIssuesContainer", () => $16907d3fc1f5147e$export$53928552b3ea6ee2);
$parcel$export(module.exports, "useLoadedIssues", () => $16907d3fc1f5147e$export$982ad9cb800a4cbf);

var $gccSB = parcelRequire("gccSB");

var $16dzj = parcelRequire("16dzj");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $16907d3fc1f5147e$var$getFieldIds = (columns)=>columns.map((col)=>col.id);
const $16907d3fc1f5147e$var$convertIssuesToKeyMap = (loadedIssues)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    loadedIssues.reduce((map, issue)=>{
        if (issue !== undefined && issue !== null) {
            const issueKeyToIdMap = map;
            issueKeyToIdMap[issue.key] = issue.id;
        }
        return map;
    }, {});
const $16907d3fc1f5147e$export$f23754098a438d57 = ()=>({ getState: getState, setState: setState }, { issueCollection: issueCollection, totalIssueCount: totalIssueCount, projectKey: projectKey, projectId: projectId, queueId: queueId, columns: columns, jql: jql })=>{
        const { issueKeyToIdMap: prevIssueKeyToIdMap, totalIssueCount: prevTotalIssueCount } = getState();
        if (!issueCollection || !totalIssueCount) return;
        const issueKeyToIdMap = $16907d3fc1f5147e$var$convertIssuesToKeyMap(issueCollection);
        if (totalIssueCount !== prevTotalIssueCount || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($16dzj)))(Object.keys(issueKeyToIdMap), Object.keys(prevIssueKeyToIdMap)))) {
            const fieldIds = $16907d3fc1f5147e$var$getFieldIds(columns);
            const noUndefinedIssueCollection = issueCollection.filter((item)=>item);
            setState({
                issueKeyToIdMap: issueKeyToIdMap,
                totalIssueCount: totalIssueCount,
                fieldIds: fieldIds,
                issueCollection: noUndefinedIssueCollection,
                projectKey: projectKey,
                projectId: projectId,
                queueId: queueId,
                columns: columns,
                jql: jql
            });
        }
    };
const $16907d3fc1f5147e$var$smartActions = {
    setLoadedIssues: $16907d3fc1f5147e$export$f23754098a438d57
};
const $16907d3fc1f5147e$export$d4c72bab9d6cc13a = {
    issueKeyToIdMap: {},
    totalIssueCount: 0,
    fieldIds: [],
    issueCollection: [],
    queueId: '',
    projectKey: '',
    projectId: 0,
    columns: [],
    jql: ''
};
const $16907d3fc1f5147e$var$Store = (0, $iXqE5.createStore)({
    name: 'loaded-queue',
    initialState: $16907d3fc1f5147e$export$d4c72bab9d6cc13a,
    actions: $16907d3fc1f5147e$var$smartActions
});
const $16907d3fc1f5147e$export$53928552b3ea6ee2 = (0, $gg7kZ.createContainer)($16907d3fc1f5147e$var$Store, {
    onInit: $16907d3fc1f5147e$export$f23754098a438d57,
    onUpdate: $16907d3fc1f5147e$export$f23754098a438d57
});
const $16907d3fc1f5147e$export$b78ba1e2dbc48fb6 = (0, $51nlc.createSubscriber)($16907d3fc1f5147e$var$Store, {
    displayName: 'LoadedIssuesSubscriber'
});
const $16907d3fc1f5147e$export$982ad9cb800a4cbf = (0, $3sQ5x.createHook)($16907d3fc1f5147e$var$Store);
var $16907d3fc1f5147e$export$2e2bcd8739ae039 = $16907d3fc1f5147e$var$Store;

});
parcelRegister("16dzj", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $g7i7g = parcelRequire("g7i7g");

var $7txx8 = parcelRequire("7txx8");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $0cd0e06461d5e057$var$xor = $g7i7g(function(arrays) {
    return $7txx8($2GdQn(arrays, $f3SOL));
});
module.exports = $0cd0e06461d5e057$var$xor;

});
parcelRegister("7txx8", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $7CoLY = parcelRequire("7CoLY");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $7CoLY(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $7CoLY($ekcP3(result, 1), iteratee, comparator);
}
module.exports = $571540db172adafd$var$baseXor;

});



parcelRegister("4wxhn", function(module, exports) {

$parcel$export(module.exports, "saveIssueMutationAnalyticsToCache", () => $47fa0c6a95e9c2da$export$75fba429fd9a065f);

var $co1wz = parcelRequire("co1wz");

var $FTaAj = parcelRequire("FTaAj");

var $82QYR = parcelRequire("82QYR");

var $cz9EJ = parcelRequire("cz9EJ");
const $47fa0c6a95e9c2da$var$isEcClientEnabled = ()=>{
    const experiences = (0, $co1wz.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};
const $47fa0c6a95e9c2da$export$75fba429fd9a065f = (event, createAnalyticsEvent, /* saveIssueMutationToCache from useEcClient() */ saveIssueMutationToCache)=>{
    if ($47fa0c6a95e9c2da$var$isEcClientEnabled() && event?.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
        const mutationFailedAnalyticsPayload = {
            errorMsg: 'FAILED_JSM_ISSUEVIEW',
            error: true
        };
        const analyticsEventObj = createAnalyticsEvent({});
        const analyticsDataKey = {
            analyticsEventObj: analyticsEventObj,
            analyticsMetadata: {
                scenario: 'jsm-issue-view',
                type: event.type
            }
        };
        saveIssueMutationToCache(new (0, $82QYR.default)(event?.issueId, (0, $cz9EJ.MutationSource).UPDATE), analyticsDataKey, mutationFailedAnalyticsPayload);
    }
};

});
parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});


parcelRegister("4NbaX", function(module, exports) {

$parcel$export(module.exports, "AsyncPostIncidentReviewBenefitModal", () => $3de97e6bca1718b3$export$1b5ddc821da26d04);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3de97e6bca1718b3$var$LazyPostIncidentReviewBenefitModal = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("86xsM")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/post-incident-review-tour/src/ui/benefit-modal/index.tsx"
});
const $3de97e6bca1718b3$export$1b5ddc821da26d04 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "postIncidentReviewBenefitModalComponent",
        packageName: "jiraServiceDeskPostIncidentReviewTour",
        teamName: "itsm-agni",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "post-incident-review-benefit-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3de97e6bca1718b3$var$LazyPostIncidentReviewBenefitModal, props)));

});
parcelRegister("86xsM", function(module, exports) {

let $5e68d75a69f22809$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5e68d75a69f22809$var$load("47TwL").then(()=>parcelRequire('2tY3R'));

});


parcelRegister("dPLA9", function(module, exports) {

$parcel$export(module.exports, "createNavigationApi", () => $07497dd18e0c6003$export$b440baa5a08af532);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $07497dd18e0c6003$var$NAVIGATION_API_MODULE = 'servicedesk/jira/api';
// Try to require navigation api over 500ms, otherwise we'll fallback.
const $07497dd18e0c6003$var$REQUIRE_TIMEOUT = 100;
const $07497dd18e0c6003$var$REQUIRE_RETRIES = 5;
const $07497dd18e0c6003$export$b440baa5a08af532 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: $07497dd18e0c6003$var$NAVIGATION_API_MODULE,
        timeout: $07497dd18e0c6003$var$REQUIRE_TIMEOUT,
        tentatives: $07497dd18e0c6003$var$REQUIRE_RETRIES,
        shouldLogError: false
    }).then((jiraApi)=>jiraApi.getNavigationApi());

});

parcelRegister("kcgTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $48314dcbb2695317$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $dC5iT = parcelRequire("dC5iT");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $cgauT = parcelRequire("cgauT");

var $8hPMc = parcelRequire("8hPMc");

var $8gxnr = parcelRequire("8gxnr");

var $1ilU2 = parcelRequire("1ilU2");

var $ehdJY = parcelRequire("ehdJY");

var $bmKPg = parcelRequire("bmKPg");

var $h0hkD = parcelRequire("h0hkD");
const $48314dcbb2695317$var$SPOTLIGHT_TARGET_ID = 'jsm-nav4-queues-popout';
const $48314dcbb2695317$var$SPOTLIGHT_MESSAGE_ID = 'jsm-nav4-queues-popout-spotlight';
const $48314dcbb2695317$var$QueuesPopoutSpotlight = ({ stop: stop, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        onDismiss?.();
        stop?.();
    }, [
        onDismiss,
        stop
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>[
            {
                onClick: onClick,
                text: formatMessage((0, $h0hkD.default).spotlightDismissButtonLabel)
            }
        ], [
        onClick,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: actions,
        dialogPlacement: "right top",
        heading: formatMessage((0, $h0hkD.default).spotlightHeading),
        key: $48314dcbb2695317$var$SPOTLIGHT_TARGET_ID,
        target: $48314dcbb2695317$var$SPOTLIGHT_TARGET_ID,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        messageId: $48314dcbb2695317$var$SPOTLIGHT_MESSAGE_ID,
        messageType: "engagement"
    }, formatMessage((0, $h0hkD.default).spotlightMessage)));
};
const $48314dcbb2695317$var$QueuesPopoutPanelNav4 = ({ children: children })=>{
    const [projectKeyFromPath] = (0, $bmKPg.usePathParam)('projectKey');
    const [practiceFromPath] = (0, $bmKPg.usePathParam)('practiceType');
    const categoryFromPath = (0, $1ilU2.toItsmPractice)(practiceFromPath);
    const [isSpotlightDismissed, setIsSpotlightDismissed] = (0, $5uXOq.useState)(false);
    const categoryStateKey = (0, $8hPMc.getCategoryStateKey)(projectKeyFromPath || '', categoryFromPath);
    const [isPoppedOut] = (0, $8hPMc.usePoppedOutState)(categoryStateKey);
    const onSpotlightDismiss = (0, $5uXOq.useCallback)(()=>{
        setIsSpotlightDismissed(true);
    }, [
        setIsSpotlightDismissed
    ]);
    const practiceQueues = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: $48314dcbb2695317$var$SPOTLIGHT_TARGET_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8gxnr.PracticeQueues), {
        key: categoryStateKey,
        projectKey: projectKeyFromPath || '',
        practice: categoryFromPath
    }))), isPoppedOut && !isSpotlightDismissed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: $48314dcbb2695317$var$SPOTLIGHT_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48314dcbb2695317$var$QueuesPopoutSpotlight, {
        onDismiss: onSpotlightDismiss
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgauT.default), {
        isPoppedOut: isPoppedOut,
        popoutComponent: practiceQueues
    }, children);
};
var $48314dcbb2695317$export$2e2bcd8739ae039 = $48314dcbb2695317$var$QueuesPopoutPanelNav4;

});
parcelRegister("cgauT", function(module, exports) {

$parcel$export(module.exports, "default", () => $237f51dbc2f88c0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $237f51dbc2f88c0a$var$PopoutPanelNav4 = ({ isPoppedOut: isPoppedOut, popoutComponent: popoutComponent, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $237f51dbc2f88c0a$var$rootContainerStyles
    }, isPoppedOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $237f51dbc2f88c0a$var$popoutPanelContainerStyles
    }, popoutComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $237f51dbc2f88c0a$var$mainContentContainerStyles
    }, children));
var $237f51dbc2f88c0a$export$2e2bcd8739ae039 = $237f51dbc2f88c0a$var$PopoutPanelNav4;
// Styles
const $237f51dbc2f88c0a$var$rootContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden'
});
const $237f51dbc2f88c0a$var$popoutPanelContainerStyles = (0, $8CUq3.xcss)({
    borderRightWidth: "var(--ds-border-width, 1px)",
    borderRightColor: 'color.border',
    borderRightStyle: 'solid',
    paddingRight: 'space.150',
    marginRight: 'space.150',
    minWidth: '280px',
    width: '280px',
    overflowY: 'auto'
});
const $237f51dbc2f88c0a$var$mainContentContainerStyles = (0, $8CUq3.xcss)({
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
    width: '100%',
    overflowX: 'hidden'
});

});

parcelRegister("8hPMc", function(module, exports) {

$parcel$export(module.exports, "getCategoryStateKey", () => $8677657bfb4252e7$export$6075a80438f902e4);
$parcel$export(module.exports, "CategoryStateContainer", () => $8677657bfb4252e7$export$d25429b1c35bc216);
$parcel$export(module.exports, "usePoppedOutState", () => $8677657bfb4252e7$export$abcb35f5af9dd85b);
$parcel$export(module.exports, "useLastVisitedQueueId", () => $8677657bfb4252e7$export$c2c81ffd0b8349b);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $tumcC = parcelRequire("tumcC");
const $8677657bfb4252e7$export$f08a5758b7b88593 = 50;
const $8677657bfb4252e7$export$939aa9619c650220 = 2419200000; // 28 days in milliseconds
const $8677657bfb4252e7$var$createUpdateAction = (projectKey, practice, stateKey, value)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const categoryKey = $8677657bfb4252e7$export$6075a80438f902e4(projectKey, practice);
        const newState = {
            ...currentState,
            [categoryKey]: {
                ...currentState[categoryKey] || {},
                [stateKey]: value,
                latestUpdateTimestamp: Date.now()
            }
        };
        setState(newState);
        // Save an evicted state to local storage to prevent unbounded growth.
        const evictedState = (0, $tumcC.getEvictedState)(newState, $8677657bfb4252e7$export$f08a5758b7b88593, $8677657bfb4252e7$export$939aa9619c650220);
        (0, $tumcC.setQueuesCategoryStateInLocalStorage)(evictedState);
    };
const $8677657bfb4252e7$export$e324594224ef24da = {
    updatePoppedOutState: (projectKey, practice, isPoppedOut)=>$8677657bfb4252e7$var$createUpdateAction(projectKey, practice, 'isPoppedOut', isPoppedOut),
    updateLastVisitedQueueId: (projectKey, practice, queueId)=>$8677657bfb4252e7$var$createUpdateAction(projectKey, practice, 'lastVisitedQueueId', queueId),
    updateIsStarredExpanded: (projectKey, practice, isExpanded)=>$8677657bfb4252e7$var$createUpdateAction(projectKey, practice, 'isStarredExpanded', isExpanded),
    updateExpandedGroups: (projectKey, practice, groups)=>$8677657bfb4252e7$var$createUpdateAction(projectKey, practice, 'expandedGroups', groups),
    updateIsAllQueuesOpen: (projectKey, practice, isOpen)=>$8677657bfb4252e7$var$createUpdateAction(projectKey, practice, 'isAllQueuesOpen', isOpen)
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $8677657bfb4252e7$var$initialState = {};
const $8677657bfb4252e7$var$Store = (0, $iXqE5.createStore)({
    name: 'jsm-queues-category-state-store',
    initialState: $8677657bfb4252e7$var$initialState,
    actions: $8677657bfb4252e7$export$e324594224ef24da
});
const $8677657bfb4252e7$export$d25429b1c35bc216 = (0, $gg7kZ.createContainer)($8677657bfb4252e7$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            const stateFromStorage = (0, $tumcC.getQueuesCategoryStateFromLocalStorage)();
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $8677657bfb4252e7$export$abcb35f5af9dd85b = (0, $3sQ5x.createHook)($8677657bfb4252e7$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isPoppedOut || false
});
const $8677657bfb4252e7$export$c2c81ffd0b8349b = (0, $3sQ5x.createHook)($8677657bfb4252e7$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.lastVisitedQueueId || null
});
const $8677657bfb4252e7$export$ef6285e9e3666377 = (0, $3sQ5x.createHook)($8677657bfb4252e7$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isStarredExpanded || false
});
const $8677657bfb4252e7$export$b68699ca40ca80b8 = (0, $3sQ5x.createHook)($8677657bfb4252e7$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.expandedGroups || []
});
const $8677657bfb4252e7$export$6862a7823efdc851 = (0, $3sQ5x.createHook)($8677657bfb4252e7$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isAllQueuesOpen || false
});
const $8677657bfb4252e7$export$6075a80438f902e4 = (projectKey, practice)=>`${projectKey}-${practice}`;

});
parcelRegister("tumcC", function(module, exports) {

$parcel$export(module.exports, "getQueueGroupsNavStateFromLocalStorage", () => $f137928114eddb2d$export$4fd3d85560a2aca5);
$parcel$export(module.exports, "setQueueGroupsNavStateInLocalStorage", () => $f137928114eddb2d$export$ea2ee3f5179c6fdf);
$parcel$export(module.exports, "getQueuesCategoryStateFromLocalStorage", () => $f137928114eddb2d$export$8832e9ccc1e52b0d);
$parcel$export(module.exports, "setQueuesCategoryStateInLocalStorage", () => $f137928114eddb2d$export$a5f3ae7965a4cde5);
$parcel$export(module.exports, "getEvictedState", () => $f137928114eddb2d$export$9aa04626df46f655);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $f137928114eddb2d$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $f137928114eddb2d$export$9b99689db482a6bb = 'queues-category-state';
const $f137928114eddb2d$export$aa821bfb3308a1f5 = (0, $bSSG7.createLocalStorageProvider)('servicedesk_queues');
const $f137928114eddb2d$export$4fd3d85560a2aca5 = ()=>{
    try {
        if ((0, $4R6GH.fg)('jsm_queue_localstorage_compliance')) {
            const item = $f137928114eddb2d$export$aa821bfb3308a1f5.get($f137928114eddb2d$export$3c59a089fdd2614a);
            return item || undefined;
        }
        const state = localStorage.getItem($f137928114eddb2d$export$3c59a089fdd2614a);
        if (state) return JSON.parse(state);
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $f137928114eddb2d$export$ea2ee3f5179c6fdf = (value)=>{
    try {
        if ((0, $4R6GH.fg)('jsm_queue_localstorage_compliance')) {
            $f137928114eddb2d$export$aa821bfb3308a1f5.set($f137928114eddb2d$export$3c59a089fdd2614a, value);
            return;
        }
        localStorage.setItem($f137928114eddb2d$export$3c59a089fdd2614a, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};
const $f137928114eddb2d$export$8832e9ccc1e52b0d = ()=>{
    try {
        if ((0, $4R6GH.fg)('jsm_queue_localstorage_compliance')) {
            const item = $f137928114eddb2d$export$aa821bfb3308a1f5.get($f137928114eddb2d$export$9b99689db482a6bb);
            return item || undefined;
        }
        const state = localStorage.getItem($f137928114eddb2d$export$9b99689db482a6bb);
        if (state) return JSON.parse(state);
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $f137928114eddb2d$export$a5f3ae7965a4cde5 = (value)=>{
    try {
        if ((0, $4R6GH.fg)('jsm_queue_localstorage_compliance')) {
            $f137928114eddb2d$export$aa821bfb3308a1f5.set($f137928114eddb2d$export$9b99689db482a6bb, value);
            return;
        }
        localStorage.setItem($f137928114eddb2d$export$9b99689db482a6bb, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};
const $f137928114eddb2d$export$9aa04626df46f655 = (state, maxCacheLength, maxCacheTime)=>{
    const stateEntries = Object.entries(state);
    const stateLen = stateEntries.length;
    const sortedDescStateEntries = stateEntries.sort((a, b)=>b[1].latestUpdateTimestamp - a[1].latestUpdateTimestamp);
    const numStateValuesToKeep = Math.min(stateLen, maxCacheLength);
    const stateValuesToKeep = sortedDescStateEntries.slice(0, numStateValuesToKeep);
    const oldestAllowedTimestamp = Date.now() - maxCacheTime;
    const newState = {};
    stateValuesToKeep.forEach(([key, value])=>{
        if (value.latestUpdateTimestamp >= oldestAllowedTimestamp) newState[key] = state[key];
    });
    return newState;
};

});


parcelRegister("8gxnr", function(module, exports) {

$parcel$export(module.exports, "PracticeQueues", () => $e6c35769609a81b8$export$9720502a768ac6d4);

var $5uXOq = parcelRequire("5uXOq");

var $eex53 = parcelRequire("eex53");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");

var $g0Gtc = parcelRequire("g0Gtc");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $b2pl3 = parcelRequire("b2pl3");



var $akY45 = parcelRequire("akY45");

var $eLb7r = parcelRequire("eLb7r");

var $gYwHC = parcelRequire("gYwHC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $5MhuD = parcelRequire("5MhuD");

var $emIzB = parcelRequire("emIzB");

var $jF62O = parcelRequire("jF62O");

var $oCMSG = parcelRequire("oCMSG");

var $1ilU2 = parcelRequire("1ilU2");

var $bmKPg = parcelRequire("bmKPg");

var $3aFcM = parcelRequire("3aFcM");

var $dQHRl = parcelRequire("dQHRl");

var $dP3YV = parcelRequire("dP3YV");

var $8hPMc = parcelRequire("8hPMc");

var $cdkPG = parcelRequire("cdkPG");

var $bQmef = parcelRequire("bQmef");

var $3rRyc = parcelRequire("3rRyc");

var $c5aKg = parcelRequire("c5aKg");

var $gKNHL = parcelRequire("gKNHL");

var $2uMQ2 = parcelRequire("2uMQ2");
const $e6c35769609a81b8$var$PracticeQueuesError = ({ onRefresh: onRefresh })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.100"
    }, formatMessage((0, $3rRyc.messages).fetchQueuesError, {
        button: (buttonLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                spacing: "none",
                appearance: "link",
                onClick: onRefresh
            }, buttonLabel)
    }));
};
const $e6c35769609a81b8$var$connectItemAnalytics = {
    actionSubjectId: (0, $d59b407ab907bf7b$export$8d155d2412839524),
    level: 4
};
const $e6c35769609a81b8$var$forgeItemAnalytics = {
    actionSubjectId: (0, $d59b407ab907bf7b$export$8d155d2412839524),
    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
    level: 4
};
const $e6c35769609a81b8$var$PracticeQueuesInternal = ({ practice: practice, projectKey: projectKey })=>{
    const currentCategory = practice || (0, $oCMSG.NO_CATEGORY);
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const [, { updateLastVisitedQueueId: updateLastVisitedQueueId }] = (0, $8hPMc.useLastVisitedQueueId)((0, $8hPMc.getCategoryStateKey)(projectKey, currentCategory));
    const { data: queueConnectItems } = (0, $akY45.useConnectAppNavigationData)(projectKey, (0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource));
    const [queues, queuesLoading, queuesError, methods, refreshQueues] = (0, $jF62O.useCategorizedNavItems)('', projectKey, currentCategory, queueCustomContext);
    const [projectKeyFromPath] = (0, $bmKPg.usePathParam)('projectKey');
    const [queueIdFromPath] = (0, $bmKPg.usePathParam)('queueId');
    const [practiceFromPath] = (0, $bmKPg.usePathParam)('practiceType');
    const categoryFromPath = (0, $1ilU2.toItsmPractice)(practiceFromPath);
    const queueFromPath = queues?.find((queue)=>queue.id === queueIdFromPath);
    const [selectedNavLocation, { updateSelectedNavLocation: updateSelectedNavLocation }] = (0, $dP3YV.useSelectedNavLocation)(queueIdFromPath || '');
    const [groups, groupsLoading, groupsFetchingError, refreshGroups] = (0, $emIzB.usePriorityGroups)(currentCategory, queueCustomContext);
    const [issueCountEnabledQueues, { updateIssueCountEnabledQueues: updateIssueCountEnabledQueues }] = (0, $dQHRl.useIssueCountEnabledQueues)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $3aFcM.useOnFavoritesChanged)(projectKey, practice || (0, $oCMSG.NO_CATEGORY), queues, methods.editItemFavorite);
    const isInvalidNavLocation = (0, $5uXOq.useCallback)(()=>{
        if (queueIdFromPath) {
            if (!queueFromPath?.starred && selectedNavLocation.section === (0, $cdkPG.QueueListSection).STARRED) return true;
        }
        return false;
    }, [
        queueIdFromPath,
        queueFromPath,
        selectedNavLocation
    ]);
    const selectDefaultNavLocation = (0, $5uXOq.useCallback)(()=>{
        if (queueIdFromPath === undefined) return;
        // Queue is in starred section
        if (queueFromPath?.starred) {
            updateSelectedNavLocation(queueIdFromPath, (0, $cdkPG.QueueListSection).STARRED);
            return;
        }
        // Queue is in priority group
        const firstGroupWithQueue = groups.find((group)=>group.queues.includes(Number(queueIdFromPath)));
        if (firstGroupWithQueue) {
            updateSelectedNavLocation(queueIdFromPath, (0, $cdkPG.QueueListSection).PRIORITY_GROUP, firstGroupWithQueue.id);
            return;
        }
        // Queue is in all queues section
        updateSelectedNavLocation(queueIdFromPath, (0, $cdkPG.QueueListSection).ALL_QUEUES);
    }, [
        queueIdFromPath,
        queueFromPath,
        groups,
        updateSelectedNavLocation
    ]);
    const disableIssueCountRefreshForAllQueues = (0, $5uXOq.useCallback)(()=>{
        if (issueCountEnabledQueues.length > 0) {
            methods.enableIssueCountForSelectedQueues([]);
            updateIssueCountEnabledQueues([]);
        }
    }, [
        issueCountEnabledQueues,
        methods,
        updateIssueCountEnabledQueues
    ]);
    const enableIssueCountRefreshForSelectedQueues = (0, $5uXOq.useCallback)((newQueues)=>{
        if (!queues) return;
        // Enable issue-counts for starred queues as well
        const starredQueues = queues.filter((queue)=>queue.starred).map((queue)=>Number(queue.id));
        const queuesToRefresh = Array.from(new Set([
            ...newQueues,
            ...starredQueues
        ]));
        // If the queues to enable have not changed, do nothing
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eex53)))(queuesToRefresh, issueCountEnabledQueues)) return;
        // Refresh issue count for the newly visible queues in the selected group
        const newlyVisibleQueuesInSelectedGroup = queuesToRefresh.filter((queueId)=>!issueCountEnabledQueues.includes(queueId)).map((queueId)=>String(queueId));
        methods.refreshIssueCountForItems(newlyVisibleQueuesInSelectedGroup);
        updateIssueCountEnabledQueues(queuesToRefresh);
        // Enable issue count for the selected queues - group queues only
        methods.enableIssueCountForSelectedQueues(newQueues);
    }, [
        queues,
        methods,
        issueCountEnabledQueues,
        updateIssueCountEnabledQueues
    ]);
    // Enable issue-counts refresh for the correct queues for the current nav location
    (0, $5uXOq.useEffect)(()=>{
        if (!queueIdFromPath) {
            disableIssueCountRefreshForAllQueues();
            return;
        }
        const inSelectedProject = projectKey === projectKeyFromPath;
        const inSelectedCategory = currentCategory === categoryFromPath;
        const shouldUpdateIssueCounts = !inSelectedProject || !inSelectedCategory || groupsLoading || groupsFetchingError || queuesLoading || queuesError;
        if (shouldUpdateIssueCounts) return;
        // If the queue does not have a valid section, set a default location
        if (selectedNavLocation.section === undefined || isInvalidNavLocation()) {
            selectDefaultNavLocation();
            return;
        }
        // update the last visited queue for this category in the local storage
        updateLastVisitedQueueId(projectKey, currentCategory, queueIdFromPath);
        // enable issue count refresh for the selected queues
        const selectedGroup = groups.find((group)=>group.id === selectedNavLocation.groupId);
        enableIssueCountRefreshForSelectedQueues(selectedGroup?.queues || []);
    }, [
        projectKey,
        projectKeyFromPath,
        queueIdFromPath,
        groups,
        groupsLoading,
        groupsFetchingError,
        selectedNavLocation,
        issueCountEnabledQueues,
        selectDefaultNavLocation,
        isInvalidNavLocation,
        disableIssueCountRefreshForAllQueues,
        enableIssueCountRefreshForSelectedQueues,
        updateLastVisitedQueueId,
        currentCategory,
        categoryFromPath,
        queuesLoading,
        queuesError
    ]);
    // analytics
    (0, $5uXOq.useEffect)(()=>{
        if (!queues && !queuesLoading) return;
        if (queuesError) (0, $jcw0u.default)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: queuesError,
            meta: {
                id: 'jsmQueuesListError',
                packageName: 'jiraServicedeskQueuesNav4',
                teamName: 'jsd-shield'
            }
        });
        else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'nav4PracticeQueueNavItemsWithQueueGroups rendered', {
            projectKey: projectKey,
            category: currentCategory,
            packageName: 'jiraServicedeskQueuesNav4',
            teamName: 'jsd-shield'
        });
    }, [
        createAnalyticsEvent,
        currentCategory,
        queues,
        queuesError,
        projectKey,
        queuesLoading
    ]);
    if (queuesError) {
        if (!(0, $4R6GH.fg)('update_viewqueuesnav_instrumentation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6c35769609a81b8$var$PracticeQueuesError, {
            onRefresh: refreshQueues
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: "servicedesk-queues-nav4.common.practice-queues.practice-queues-error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6c35769609a81b8$var$PracticeQueuesError, {
            onRefresh: refreshQueues
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2uMQ2.StarredSection), {
        practice: currentCategory,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKNHL.QueueGroupsSection), {
        projectKey: projectKey,
        currentCategory: currentCategory,
        onGroupDataRefresh: refreshGroups
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bQmef.AllQueuesSection), {
        practice: currentCategory,
        projectKey: projectKey
    }), (!practice || practice === (0, $oCMSG.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eLb7r.ConnectMenu), {
        items: queueConnectItems,
        showIcons: true,
        connectItemAnalytics: $e6c35769609a81b8$var$connectItemAnalytics
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYwHC.ForgeServiceDeskQueueSection), {
        projectKey: projectKey,
        analytics: $e6c35769609a81b8$var$forgeItemAnalytics
    })));
};
const $e6c35769609a81b8$export$10907166f9acd1f7 = ({ practice: practice, projectKey: projectKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5aKg.QueuesExperienceTracker), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6c35769609a81b8$var$PracticeQueuesInternal, {
        practice: practice,
        projectKey: projectKey
    }));
};
const $e6c35769609a81b8$export$9720502a768ac6d4 = (0, $cSD7y.componentWithFG)('update_viewqueuesnav_instrumentation', $e6c35769609a81b8$export$10907166f9acd1f7, $e6c35769609a81b8$var$PracticeQueuesInternal);

});
parcelRegister("eex53", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $a5cc089264689093$var$func = $lVx1a('isEqual', (parcelRequire("ajpes")));

$a5cc089264689093$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $a5cc089264689093$var$func;

});

const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';

const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';

parcelRegister("akY45", function(module, exports) {

$parcel$export(module.exports, "useConnectAppNavigationData", () => $5b59dec833282bfb$export$4e0e21a37979b45e);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $efOLn = parcelRequire("efOLn");
const $5b59dec833282bfb$export$4e0e21a37979b45e = (projectKey, resource)=>{
    const { data: data, ...rest } = (0, $324W5.useResourceWithCustomRouterContext)(resource, {
        matchParams: {
            projectKey: projectKey
        }
    });
    const connectDataItems = (0, $5uXOq.useMemo)(()=>data?.map((0, $efOLn.transformLinkV4))?.filter(Boolean) || null, [
        data
    ]);
    return {
        data: connectDataItems,
        ...rest
    };
};

});

parcelRegister("eLb7r", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $efcaaeb086862273$export$19d0925d424b864a);

var $5uXOq = parcelRequire("5uXOq");

var $au6nA = parcelRequire("au6nA");

var $gwyOw = parcelRequire("gwyOw");
const $efcaaeb086862273$export$19d0925d424b864a = ({ items: items, showIcons: showIcons = false, shouldFilter: shouldFilter = true, connectItemAnalytics: connectItemAnalytics })=>{
    const filteredItems = (0, $au6nA.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gwyOw.ConnectItem), {
            key: item.id,
            item: item,
            showIcons: showIcons,
            analytics: connectItemAnalytics
        })));
};

});
parcelRegister("gwyOw", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $12e5cd4af736273d$export$8bb4bcea44a3c9ea);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $jjUR3 = parcelRequire("jjUR3");

var $4OCke = parcelRequire("4OCke");


var $fkx1e = parcelRequire("fkx1e");

var $bSYPZ = parcelRequire("bSYPZ");

var $f8M0Y = parcelRequire("f8M0Y");

var $aAbfD = parcelRequire("aAbfD");
var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");

var $3TY9o = parcelRequire("3TY9o");

var $5LMr7 = parcelRequire("5LMr7");
const $12e5cd4af736273d$export$8bb4bcea44a3c9ea = ({ item: item, showIcons: showIcons, analytics: analytics, level: level = analytics.level, appId: appId = item.id })=>{
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (showIcons !== true || item.section) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), {
            url: item.iconUrl
        });
    }, [
        showIcons,
        item.iconUrl,
        item.section
    ]);
    const location = (0, $3TY9o.useLocation)();
    const query = (0, $5LMr7.useQuery)();
    const getIsCurrentLocationMatchItemUrl = (0, $5uXOq.useCallback)((itemUrl)=>{
        if (!itemUrl) return false;
        // match pathname and query params
        // code adapted from src/packages/navigation-apps/sidebar/common/src/common/ui/menu-item/main.tsx
        const currentLocation = {
            ...location,
            query: query
        };
        const urlMatcher = (0, $4OCke.matchUrlExact)();
        const itemLocation = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(itemUrl || '/', true);
        // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
        return urlMatcher(currentLocation, itemLocation);
    }, [
        location,
        query
    ]);
    const isItemSelected = (0, $5uXOq.useMemo)(()=>getIsCurrentLocationMatchItemUrl(item.url), [
        item.url,
        getIsCurrentLocationMatchItemUrl
    ]);
    const itemAnalytics = (0, $5uXOq.useMemo)(()=>{
        const initialLevel = analytics.level;
        const currentLevel = level;
        const isNestedItem = currentLevel - initialLevel > 0;
        return {
            ...analytics,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            level: level,
            itemType: isNestedItem ? 'appSubpage' : 'app',
            itemId: item.id,
            parentItemType: isNestedItem ? 'app' : undefined,
            parentItemId: isNestedItem ? appId : undefined
        };
    }, [
        analytics,
        appId,
        level,
        item.id
    ]);
    const getIsChildSelected = (0, $5uXOq.useCallback)((parentItem)=>parentItem.items?.some((child)=>getIsCurrentLocationMatchItemUrl(child.url) || getIsChildSelected(child)) ?? false, [
        getIsCurrentLocationMatchItemUrl
    ]);
    const isChildSelected = (0, $5uXOq.useMemo)(()=>getIsChildSelected(item), [
        item,
        getIsChildSelected
    ]);
    const onItemClick = (0, $5uXOq.useCallback)(()=>{
        item.url != null && addNew(item.url);
    }, [
        addNew,
        item.url
    ]);
    const anchorElement = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // inject style class names used by Connect app js to attach event listener to display modal dialog
        if (item.styleClass) {
            const classes = item.styleClass.split(' ').map((className)=>className.trim()).filter(Boolean).filter((className)=>anchorElement.current?.classList?.contains(className) === false);
            anchorElement.current?.classList?.add(...classes);
        }
    }, [
        item.styleClass
    ]);
    // nested menu items (for 1 App, or 1 menu item of an App)
    if (item.items && item.items.length > 0) {
        const childSections = item.items.filter((child)=>child.section);
        const isAllSectionsUnnamed = childSections.length > 0 && childSections.every((section)=>!section.name);
        const menuContent = item.items.map((child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: child.id
            }, isAllSectionsUnnamed && child.section && index > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aAbfD.Divider), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12e5cd4af736273d$export$8bb4bcea44a3c9ea, {
                item: child,
                showIcons: showIcons,
                level: level ? level + 1 : undefined,
                appId: appId,
                analytics: analytics
            })));
        return item.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
            isDefaultExpanded: item.section || isChildSelected,
            isChildSelected: isChildSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkx1e.default), {
            elemBefore: icon,
            analytics: itemAnalytics
        }, item.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, menuContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, menuContent);
    }
    // if no nested menu items
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSYPZ.default), {
        analytics: itemAnalytics,
        elemBefore: icon,
        href: item.url ?? '',
        isSelected: isItemSelected,
        ref: anchorElement,
        onClick: onItemClick
    }, item.name);
};

});
parcelRegister("fkx1e", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bbdedcb6c6b4aaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cZa9B = parcelRequire("cZa9B");
const $7bbdedcb6c6b4aaf$export$3776992222b2b40f = {
    EXPAND: 'expand',
    COLLAPSE: 'collapse'
};
const $7bbdedcb6c6b4aaf$var$ExpandableMenuItemTriggerWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (event, analyticsEvent, { isExpanded: isExpanded })=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, {
            ...analyticsAttributes,
            expandAction: isExpanded ? $7bbdedcb6c6b4aaf$export$3776992222b2b40f.EXPAND : $7bbdedcb6c6b4aaf$export$3776992222b2b40f.COLLAPSE
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
var $7bbdedcb6c6b4aaf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($7bbdedcb6c6b4aaf$var$ExpandableMenuItemTriggerWithAnalytics);

});

parcelRegister("f8M0Y", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $d43af7d718f087c0$export$fe0464db4dc93ab4);

var $5uXOq = parcelRequire("5uXOq");

var $hRf4g = parcelRequire("hRf4g");

var $dcP6E = parcelRequire("dcP6E");
const $d43af7d718f087c0$export$fe0464db4dc93ab4 = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
        src: url,
        appearance: "subtle"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });

});



parcelRegister("gYwHC", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $3bb28aaecf9e4241$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeServiceDeskQueueSection", () => $3bb28aaecf9e4241$export$a133aa9cc8b5e080);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $LoDvw = parcelRequire("LoDvw");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $7Tlti = parcelRequire("7Tlti");

var $iIGGa = parcelRequire("iIGGa");

var $gTg91 = parcelRequire("gTg91");
const $3bb28aaecf9e4241$export$ed6342e0e28465a6 = (extension, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};
const $3bb28aaecf9e4241$export$a133aa9cc8b5e080 = ({ projectKey: projectKey, analytics: analytics })=>{
    const { data: data } = (0, $iIGGa.useServiceDeskQueueForgeAppsNav4)(projectKey);
    if (!data?.length || !projectKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LoDvw.TriggerAnalyticsWrapper), null, data.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gTg91.ForgeItem), {
            key: extension.id,
            id: extension.id,
            analytics: analytics,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $3bb28aaecf9e4241$export$ed6342e0e28465a6(extension, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
        }
    }));
};

});
parcelRegister("LoDvw", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $d68c1b1fe01b723d$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $d68c1b1fe01b723d$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $d68c1b1fe01b723d$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $d68c1b1fe01b723d$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("iIGGa", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskQueueForgeApps", () => $1febfd879444642e$export$8a2bb837db423089);
$parcel$export(module.exports, "useServiceDeskQueueForgeAppsNav4", () => $1febfd879444642e$export$52b0be0dcb122e71);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $324W5 = parcelRequire("324W5");

var $kKdpt = parcelRequire("kKdpt");
const $1febfd879444642e$export$8a2bb837db423089 = (routeName, parentStack, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $5bkvv.forgeServiceDeskQueueModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const serviceDeskQueueData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $kKdpt.useForgeItemStack)(serviceDeskQueueData, routeName, parentStack);
    return (0, $5uXOq.useMemo)(()=>({
            data: serviceDeskQueueData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        serviceDeskQueueData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $1febfd879444642e$export$52b0be0dcb122e71 = (projectKey)=>$1febfd879444642e$export$8a2bb837db423089(undefined, undefined, projectKey);

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("kKdpt", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $dac9c7c54c5ccbb1$export$462f82a278743d46);

var $5uXOq = parcelRequire("5uXOq");

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");

var $7Tlti = parcelRequire("7Tlti");
const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const matchedExtension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $7Tlti.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});


parcelRegister("gTg91", function(module, exports) {

$parcel$export(module.exports, "ForgeItem", () => $13b8f615493442f4$export$26a5287439a1d287);

var $5uXOq = parcelRequire("5uXOq");

var $fl3Yy = parcelRequire("fl3Yy");

var $fkx1e = parcelRequire("fkx1e");

var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");

var $3TY9o = parcelRequire("3TY9o");

var $f8M0Y = parcelRequire("f8M0Y");

var $dWQjM = parcelRequire("dWQjM");

var $hDE1q = parcelRequire("hDE1q");
const $13b8f615493442f4$export$26a5287439a1d287 = (props)=>{
    const { id: itemId, url: url, showIcon: showIcon, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides, analytics: analytics } = props;
    const location = (0, $3TY9o.useLocation)();
    const shouldExpandAsDefault = (0, $5uXOq.useMemo)(()=>location.pathname.includes(url), [
        url,
        location
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
        return ()=>null;
    }, [
        overrides
    ]);
    const itemAnalytics = (0, $5uXOq.useMemo)(()=>{
        return {
            ...analytics,
            itemType: 'app',
            componentType: 'customItem',
            itemId: itemId
        };
    }, [
        analytics,
        itemId
    ]);
    const expandableItemAnalytics = (0, $5uXOq.useMemo)(()=>{
        return {
            ...itemAnalytics,
            level: 2,
            itemType: 'appSubpage',
            parentItemType: 'app'
        };
    }, [
        itemAnalytics
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDE1q.ForgeItemSimple), {
        ...props,
        analytics: itemAnalytics
    });
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWQjM.ForgeItemExpandable), {
        ...props,
        analytics: itemAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        isDefaultExpanded: shouldExpandAsDefault
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkx1e.default), {
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        testId: `navigation-sidebar.project-menu.forge-app.${itemId}.expandable-menu-item-trigger.root`,
        analytics: itemAnalytics,
        onClick: onNestedMenuItemClick
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWQjM.ForgeItemExpandable), {
        ...props,
        analytics: expandableItemAnalytics
    })));
};

});
parcelRegister("dWQjM", function(module, exports) {

$parcel$export(module.exports, "ForgeItemExpandable", () => $13c9cddc75a5c96e$export$532bd53ddb8882b3);

var $5uXOq = parcelRequire("5uXOq");

var $8kVg1 = parcelRequire("8kVg1");

var $fkx1e = parcelRequire("fkx1e");

var $bSYPZ = parcelRequire("bSYPZ");

var $7C7jZ = parcelRequire("7C7jZ");

var $aAbfD = parcelRequire("aAbfD");
var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");
var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");

var $f8M0Y = parcelRequire("f8M0Y");
const $13c9cddc75a5c96e$var$createPageUrl = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $13c9cddc75a5c96e$var$ForgeItemExpandableWithHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, url: url, section: section, analytics: analytics } = props;
    const subItemAnalytics = (0, $5uXOq.useMemo)(()=>analytics && {
            ...analytics,
            level: analytics && analytics.level + 1
        }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        isDefaultExpanded: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkx1e.default), {
        analytics: analytics
    }, section.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSYPZ.default), {
            key: page.route,
            elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), {
                url: page.icon
            }) : undefined,
            ...getLinkProps($13c9cddc75a5c96e$var$createPageUrl(url, page.route)),
            analytics: subItemAnalytics,
            onClick: ()=>{
                (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)))));
};
const $13c9cddc75a5c96e$var$ForgeItemExpandableWithoutHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, url: url, section: section, analytics: analytics } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSYPZ.default), {
            key: page.route,
            elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), {
                url: page.icon
            }) : undefined,
            ...getLinkProps($13c9cddc75a5c96e$var$createPageUrl(url, page.route)),
            analytics: analytics,
            onClick: ()=>{
                (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)));
};
const $13c9cddc75a5c96e$export$532bd53ddb8882b3 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, analytics: analytics } = props;
    const hasSectionsWithHeader = sections?.some((section)=>!!section.header);
    return sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13c9cddc75a5c96e$var$ForgeItemExpandableWithHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon,
            analytics: analytics
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !hasSectionsWithHeader && index !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aAbfD.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13c9cddc75a5c96e$var$ForgeItemExpandableWithoutHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon,
            analytics: analytics
        })))));
};

});

parcelRegister("hDE1q", function(module, exports) {

$parcel$export(module.exports, "ForgeItemSimple", () => $04ff6fa538c1792f$export$df3259e43d89ee7b);

var $5uXOq = parcelRequire("5uXOq");

var $8kVg1 = parcelRequire("8kVg1");

var $fl3Yy = parcelRequire("fl3Yy");

var $bSYPZ = parcelRequire("bSYPZ");

var $7C7jZ = parcelRequire("7C7jZ");

var $f8M0Y = parcelRequire("f8M0Y");
const $04ff6fa538c1792f$export$df3259e43d89ee7b = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, overrides: overrides, analytics: analytics } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSYPZ.default), {
        analytics: analytics,
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        ...getLinkProps(url, {
            shouldMatchExactPath: false
        }),
        onClick: ()=>{
            (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
                startTime: performance.now()
            });
        }
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});



parcelRegister("5MhuD", function(module, exports) {

$parcel$export(module.exports, "useQueueCustomRouterContext", () => $04b895fed4cbd829$export$f7c5cd815dd083e4);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");
const $04b895fed4cbd829$export$f7c5cd815dd083e4 = (projectKey)=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $5uXOq.useMemo)(()=>projectKey ? {
            matchParams: {
                ...match.params,
                projectKey: projectKey
            }
        } : undefined, [
        match.params,
        projectKey
    ]);
};

});

parcelRegister("emIzB", function(module, exports) {

$parcel$export(module.exports, "usePriorityGroupsActions", () => $da86e17b74592a56$export$aceb895c0a1bdb9);
$parcel$export(module.exports, "usePriorityGroupData", () => $da86e17b74592a56$export$e41417e5a9e40e44);
$parcel$export(module.exports, "usePriorityGroups", () => $da86e17b74592a56$export$9ad7fd5c13dc6dbb);
$parcel$export(module.exports, "useCategorizedGroupsNavItems", () => $da86e17b74592a56$export$7ddc2fd096cdc650);
$parcel$export(module.exports, "useNormalizedPriorityGroups", () => $da86e17b74592a56$export$c2e9f9150500e785);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $dAfqg = parcelRequire("dAfqg");

var $324W5 = parcelRequire("324W5");

var $1WlLE = parcelRequire("1WlLE");

var $koeKL = parcelRequire("koeKL");

var $2YP9W = parcelRequire("2YP9W");

var $bebaD = parcelRequire("bebaD");

var $jF62O = parcelRequire("jF62O");

var $bHygi = parcelRequire("bHygi");
const $da86e17b74592a56$var$updateGroup = (updatedGroup, groups)=>groups.map((g)=>g.id === updatedGroup.id ? {
            ...g,
            name: updatedGroup.name,
            version: updatedGroup.version,
            queues: updatedGroup.queueIds
        } : g);
const $da86e17b74592a56$var$deleteGroup = (id, groups)=>groups.filter((group)=>group.id !== id);
const $da86e17b74592a56$var$updateQueueGroups = (updatedGroups, groups)=>groups.map((group)=>{
        const matchedGroup = updatedGroups?.find((updatedGroup)=>updatedGroup.group.id === group.id);
        if (matchedGroup === undefined) return group;
        return {
            ...group,
            id: matchedGroup.group.id,
            name: matchedGroup.group.name,
            queues: matchedGroup.group.queueIds,
            version: matchedGroup.group.version
        };
    });
const $da86e17b74592a56$var$addQueueToGroupByGroupName = (queueId, updatedGroup, groups)=>groups.map((g)=>updatedGroup.includes(g.name) && !g.queues.includes(queueId) ? {
            ...g,
            queues: [
                ...g.queues,
                queueId
            ]
        } : g);
const $da86e17b74592a56$var$removeQueueFromGroupsByGroupName = (queueId, updatedGroup, groups)=>groups.map((g)=>updatedGroup.includes(g.name) ? {
            ...g,
            queues: g.queues.filter((q)=>q !== queueId)
        } : g);
const $da86e17b74592a56$var$createActions = (update, category, projectId, cloudId)=>({
        updateQueuesInGroup: (id, name, version, newQueues)=>(0, $bHygi.updateGroup)({
                cloudId: cloudId,
                id: id,
                name: name,
                version: version,
                queueIds: newQueues
            }).then((updatedGroup)=>{
                update((data)=>({
                        ...data,
                        [category]: $da86e17b74592a56$var$updateGroup(updatedGroup, data[category])
                    }));
            }),
        renameGroup: (id, newName, version, queues)=>(0, $bHygi.updateGroup)({
                cloudId: cloudId,
                id: id,
                name: newName,
                version: version,
                queueIds: queues
            }).then((updatedGroup)=>{
                update((data)=>({
                        ...data,
                        [category]: $da86e17b74592a56$var$updateGroup(updatedGroup, data[category])
                    }));
            }),
        createGroup: (name)=>(0, $bHygi.createGroup)({
                name: name,
                category: category,
                projectId: projectId,
                cloudId: cloudId,
                queueIds: []
            }).then((createdGroup)=>{
                update((data)=>{
                    const groups = data[category] || [];
                    return {
                        ...data,
                        [category]: [
                            ...groups,
                            {
                                ...createdGroup,
                                queues: createdGroup.queueIds
                            }
                        ]
                    };
                });
            }),
        deleteGroup: (id)=>(0, $bHygi.deleteGroup)({
                cloudId: cloudId,
                id: id
            }).then(()=>{
                update((data)=>({
                        ...data,
                        [category]: $da86e17b74592a56$var$deleteGroup(id, data[category])
                    }));
            }),
        addQueueToGroupByGroupName: (queueId, toUpdateGroups)=>{
            if (toUpdateGroups.length === 0) return;
            update((data)=>({
                    ...data,
                    [category]: $da86e17b74592a56$var$addQueueToGroupByGroupName(queueId, toUpdateGroups, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    data[category])
                }));
        },
        removeQueueFromGroupsByGroupName: (queueId, toUpdateGroups)=>{
            if (toUpdateGroups.length === 0) return;
            update((data)=>({
                    ...data,
                    [category]: $da86e17b74592a56$var$removeQueueFromGroupsByGroupName(queueId, toUpdateGroups, data[category])
                }));
        },
        updateQueueGroupsByGroupId: (queueId, toUpdateGroups)=>(0, $bHygi.updateQueueGroupsByGroupId)({
                cloudId: cloudId,
                projectId: projectId,
                category: category,
                queueId: queueId,
                groupIds: toUpdateGroups
            }).then((updatedGroups)=>{
                update((data)=>({
                        ...data,
                        [category]: $da86e17b74592a56$var$updateQueueGroups(updatedGroups.results, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        data[category])
                    }));
            })
    });
const $da86e17b74592a56$var$fetchPriorityGroupByProjectId = ()=>(0, $4R6GH.fg)('jsm_flash_priority_group_api_optimisation') && !(0, $3HwlS.getWillShowNav4)();
const $da86e17b74592a56$export$aceb895c0a1bdb9 = ()=>{
    const category = (0, $bebaD.useCurrentCategory)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    let update;
    if ($da86e17b74592a56$var$fetchPriorityGroupByProjectId()) // eslint-disable-next-line react-hooks/rules-of-hooks
    update = (0, $2YP9W.useResource)((0, $1WlLE.priorityGroupByProjectIdResource)).update;
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    update = (0, $2YP9W.useResource)((0, $1WlLE.priorityGroupResource)).update;
    const projectId = projectContext?.projectId;
    return (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>$da86e17b74592a56$var$createActions(update, category, projectId?.toString(), cloudId), [
        category,
        cloudId,
        projectId,
        update
    ]);
};
const $da86e17b74592a56$export$e41417e5a9e40e44 = (customContext)=>$da86e17b74592a56$var$fetchPriorityGroupByProjectId() ? (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.priorityGroupByProjectIdResource), customContext) : (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.priorityGroupResource), customContext);
const $da86e17b74592a56$export$9ad7fd5c13dc6dbb = (category, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = $da86e17b74592a56$export$e41417e5a9e40e44(customContext);
    const categorizedGroups = (0, $5uXOq.useMemo)(()=>(data && data[category]) ?? [], [
        category,
        data
    ]);
    return [
        categorizedGroups,
        loading,
        error,
        refresh
    ];
};
const $da86e17b74592a56$export$7ddc2fd096cdc650 = (projectKey, category, customContext)=>{
    const [groups, groupLoading, groupError] = $da86e17b74592a56$export$9ad7fd5c13dc6dbb(category, customContext);
    const [navItems, loading, queueError] = (0, $jF62O.useCategorizedNavItems)('', projectKey, category, customContext);
    return (0, $5uXOq.useMemo)(()=>{
        const isLoading = loading || groupLoading;
        if (isLoading || queueError || groupError) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            [],
            isLoading,
            groupError,
            queueError
        ];
        const normalizedGroups = groups.map((group)=>({
                group: group,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues.map((queueId)=>navItems?.find((item)=>Number.parseInt(item.id, 10) === queueId)).filter((item)=>!!item)
            }));
        return [
            normalizedGroups,
            isLoading,
            groupError,
            queueError
        ];
    }, [
        groupError,
        groupLoading,
        groups,
        loading,
        navItems,
        queueError
    ]);
};
const $da86e17b74592a56$export$c2e9f9150500e785 = ()=>{
    const projectKey = (0, $bebaD.useProjectKey)();
    const category = (0, $bebaD.useCurrentCategory)();
    const [groups, groupLoading] = $da86e17b74592a56$export$9ad7fd5c13dc6dbb(category);
    const [navItems, loading, error] = (0, $jF62O.useCategorizedQueues)('', projectKey, category);
    return (0, $5uXOq.useMemo)(()=>{
        const isLoading = loading || groupLoading;
        if (isLoading || error) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            [],
            isLoading,
            error
        ];
        const normalizedGroups = groups.map((group)=>({
                group: group,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues.map((queueId)=>navItems?.find((item)=>item.id === queueId)).filter((queue)=>!!queue)
            }));
        return [
            normalizedGroups,
            isLoading,
            error
        ];
    }, [
        error,
        groupLoading,
        groups,
        loading,
        navItems
    ]);
};

});
parcelRegister("bHygi", function(module, exports) {

$parcel$export(module.exports, "createGroup", () => $a7a86b8cce8a7c4d$export$856f728536d122cb);
$parcel$export(module.exports, "updateGroup", () => $a7a86b8cce8a7c4d$export$7266cde9e95c4de8);
$parcel$export(module.exports, "deleteGroup", () => $a7a86b8cce8a7c4d$export$ae2679b329fc10b6);
$parcel$export(module.exports, "updateQueueGroupsByGroupId", () => $a7a86b8cce8a7c4d$export$bdf88b9d006a8a43);

var $eusud = parcelRequire("eusud");
const $a7a86b8cce8a7c4d$export$856f728536d122cb = ({ cloudId: cloudId, projectId: projectId, category: category, name: name, queueIds: queueIds })=>{
    const createGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group`;
    const payload = {
        projectId: projectId,
        category: category,
        name: name,
        queueIds: queueIds
    };
    return (0, $eusud.performPostRequest)(createGroupUrl, {
        body: JSON.stringify(payload)
    });
};
const $a7a86b8cce8a7c4d$export$7266cde9e95c4de8 = ({ cloudId: cloudId, id: id, version: version, name: name, queueIds: queueIds })=>{
    const updateGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/${id}`;
    const payload = {
        version: version,
        name: name,
        queueIds: queueIds
    };
    return (0, $eusud.performPutRequest)(updateGroupUrl, {
        body: JSON.stringify(payload)
    });
};
const $a7a86b8cce8a7c4d$export$ae2679b329fc10b6 = ({ cloudId: cloudId, id: id })=>{
    const deleteGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/${id}`;
    return (0, $eusud.performDeleteRequest)(deleteGroupUrl);
};
const $a7a86b8cce8a7c4d$export$bdf88b9d006a8a43 = ({ cloudId: cloudId, projectId: projectId, category: category, queueId: queueId, groupIds: groupIds })=>{
    const batchUpdateQueueGroupsUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/batch/update-queue-groups/${projectId}/${category}`;
    const payload = {
        projectId: projectId,
        category: category,
        queueId: queueId,
        groupIds: groupIds
    };
    return (0, $eusud.performPutRequest)(batchUpdateQueueGroupsUrl, {
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("3aFcM", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $013b5c8cc28ffe09$export$ddf44c597e03063d);

var $5uXOq = parcelRequire("5uXOq");

var $1sWm7 = parcelRequire("1sWm7");

var $dMEgP = parcelRequire("dMEgP");

var $eXQym = parcelRequire("eXQym");

var $4041n = parcelRequire("4041n");
const $013b5c8cc28ffe09$var$updateQueueUsingCallback = (queues, queueItemChanges, editItemFavoriteCallback)=>{
    if (queues) {
        const itemsToRefresh = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(queues, {
                id: id
            });
            if (queue && queue.starred !== value) {
                const isHiddenQueueStarred = queue.canBeHidden === true && value === true;
                editItemFavoriteCallback(id, value);
                if (isHiddenQueueStarred) itemsToRefresh.push(id);
            }
        });
    }
};
const $013b5c8cc28ffe09$export$ddf44c597e03063d = (projectKey, category, queues, editItemFavoriteCallback)=>{
    const { items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const queueItemChanges = items[0, $eXQym.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $5uXOq.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        $013b5c8cc28ffe09$var$updateQueueUsingCallback(queues, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        queueItemChanges, editItemFavoriteCallback);
    }
};

});

parcelRegister("dQHRl", function(module, exports) {

$parcel$export(module.exports, "useIssueCountEnabledQueues", () => $0a5b7d51d6f24cd6$export$99b90062d7e53784);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $0a5b7d51d6f24cd6$export$e324594224ef24da = {
    updateIssueCountEnabledQueues: (queues)=>({ setState: setState })=>{
            setState({
                queues: queues
            });
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $0a5b7d51d6f24cd6$var$initialState = {
    queues: []
};
const $0a5b7d51d6f24cd6$var$Store = (0, $iXqE5.createStore)({
    name: 'jsm-queue-groups-issue-count-enabled-queues-store',
    initialState: $0a5b7d51d6f24cd6$var$initialState,
    actions: $0a5b7d51d6f24cd6$export$e324594224ef24da
});
const $0a5b7d51d6f24cd6$export$99b90062d7e53784 = (0, $3sQ5x.createHook)($0a5b7d51d6f24cd6$var$Store, {
    selector: (state)=>state?.queues
});

});

parcelRegister("dP3YV", function(module, exports) {

$parcel$export(module.exports, "NavigationDetailsContainer", () => $993618e3d128085a$export$29eca0c9cd8a428b);
$parcel$export(module.exports, "useSelectedNavLocation", () => $993618e3d128085a$export$d2f02560e6f207a);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $tumcC = parcelRequire("tumcC");
const $993618e3d128085a$export$dfef0225549f683d = 50;
const $993618e3d128085a$export$a0bac38ed2b058db = 2419200000; // 28 days in milliseconds
const $993618e3d128085a$export$e324594224ef24da = {
    updateSelectedNavLocation: (queueId, selectedSection, selectedGroupId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const currentStateForQueueId = currentState[queueId] || {};
            const newState = {
                ...currentState,
                [queueId]: {
                    ...currentStateForQueueId,
                    selectedSection: selectedSection,
                    selectedGroupId: selectedGroupId,
                    latestUpdateTimestamp: Date.now()
                }
            };
            // setState is a merge operation - passing in an evicted state won't remove data for old queueIds
            setState(newState);
            // Save a evicted state to local storage to prevent unboounded growth.
            const evictedState = (0, $tumcC.getEvictedState)(newState, $993618e3d128085a$export$dfef0225549f683d, $993618e3d128085a$export$a0bac38ed2b058db);
            (0, $tumcC.setQueueGroupsNavStateInLocalStorage)(evictedState);
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $993618e3d128085a$var$initialState = {};
const $993618e3d128085a$var$Store = (0, $iXqE5.createStore)({
    name: 'jsm-queue-groups-nav-location-store',
    initialState: $993618e3d128085a$var$initialState,
    actions: $993618e3d128085a$export$e324594224ef24da
});
const $993618e3d128085a$export$29eca0c9cd8a428b = (0, $gg7kZ.createContainer)($993618e3d128085a$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            const stateFromStorage = (0, $tumcC.getQueueGroupsNavStateFromLocalStorage)();
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $993618e3d128085a$export$d2f02560e6f207a = (0, $3sQ5x.createHook)($993618e3d128085a$var$Store, {
    selector: (state, queueId)=>({
            section: state[queueId]?.selectedSection,
            groupId: state[queueId]?.selectedGroupId
        })
});

});

parcelRegister("cdkPG", function(module, exports) {

$parcel$export(module.exports, "QueueListSection", () => $6ee74db0b1450e94$export$f9e39ac255344f7b);
var $6ee74db0b1450e94$export$f9e39ac255344f7b = /*#__PURE__*/ function(QueueListSection) {
    QueueListSection[QueueListSection["STARRED"] = 0] = "STARRED";
    QueueListSection[QueueListSection["PRIORITY_GROUP"] = 1] = "PRIORITY_GROUP";
    QueueListSection[QueueListSection["ALL_QUEUES"] = 2] = "ALL_QUEUES";
    return QueueListSection;
}({});

});

parcelRegister("bQmef", function(module, exports) {

$parcel$export(module.exports, "AllQueuesSection", () => $ab65d60eb40356e4$export$3db49d1e2b7c929f);

var $5uXOq = parcelRequire("5uXOq");

var $5MhuD = parcelRequire("5MhuD");

var $5Srj8 = parcelRequire("5Srj8");

var $jF62O = parcelRequire("jF62O");

var $bmKPg = parcelRequire("bmKPg");

var $dB1lV = parcelRequire("dB1lV");

var $4UYVJ = parcelRequire("4UYVJ");

var $Yt6er = parcelRequire("Yt6er");

var $64lxo = parcelRequire("64lxo");

var $hSFzl = parcelRequire("hSFzl");
const $ab65d60eb40356e4$export$3db49d1e2b7c929f = ({ projectKey: projectKey, practice: practice })=>{
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const [queueIdFromPath] = (0, $bmKPg.usePathParam)('queueId');
    const [allQueues] = (0, $jF62O.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const popoutConfig = (0, $dB1lV.usePopoutConfig)(projectKey, practice);
    const selectedQueue = (0, $5uXOq.useMemo)(()=>allQueues?.find((queue)=>queue.id === queueIdFromPath), [
        allQueues,
        queueIdFromPath
    ]);
    const isQueueSelected = (0, $4UYVJ.useIsQueueSelected)(selectedQueue, (0, $5Srj8.QueueListSection).ALL_QUEUES);
    const hasSelectedQueue = isQueueSelected && selectedQueue !== undefined;
    if (!allQueues || allQueues.length === 0) return null;
    if (popoutConfig.isPoppedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hSFzl.AllQueuesPopOut), {
        projectKey: projectKey,
        practice: practice
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasSelectedQueue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Yt6er.QueueItem), {
        queue: selectedQueue,
        section: (0, $5Srj8.QueueListSection).ALL_QUEUES
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64lxo.AllQueuesFlyout), {
        projectKey: projectKey,
        practice: practice
    }));
};

});
parcelRegister("5Srj8", function(module, exports) {

$parcel$export(module.exports, "QueueListSection", () => $3b5b2eee2cc09f57$export$f9e39ac255344f7b);
$parcel$export(module.exports, "NavigationCategoryContainer", () => $3b5b2eee2cc09f57$export$ea600ea09fe6bbd);
$parcel$export(module.exports, "useSelectedGroupIdByCategory", () => $3b5b2eee2cc09f57$export$9a1583f58d01a77c);
$parcel$export(module.exports, "useSelectedQueueSectionByCategory", () => $3b5b2eee2cc09f57$export$aca7e7401e11cffa);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aBZ4l = parcelRequire("aBZ4l");
var $3b5b2eee2cc09f57$export$f9e39ac255344f7b = /*#__PURE__*/ function(QueueListSection) {
    QueueListSection[QueueListSection["STARRED"] = 0] = "STARRED";
    QueueListSection[QueueListSection["PRIORITY_GROUP"] = 1] = "PRIORITY_GROUP";
    QueueListSection[QueueListSection["ALL_QUEUES"] = 2] = "ALL_QUEUES";
    return QueueListSection;
}({});
const $3b5b2eee2cc09f57$export$e324594224ef24da = {
    updateCurrentCategorySelectedGroup: (projectKey, practice, selectedGroupId)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                ...getState()[practice] ? {
                    [practice]: {
                        ...getState()[practice],
                        selectedGroupId: selectedGroupId
                    }
                } : {
                    [practice]: {
                        selectedGroupId: selectedGroupId
                    }
                }
            });
            (0, $aBZ4l.setQueueGroupsStateInLocalStorage)(projectKey, getState());
        },
    updatePathCategorySelectedQueueSection: (projectKey, practice, selectedQueueSection)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                ...getState()[practice] ? {
                    [practice]: {
                        ...getState()[practice],
                        selectedQueueSection: selectedQueueSection
                    }
                } : {
                    [practice]: {
                        selectedQueueSection: selectedQueueSection
                    }
                }
            });
            (0, $aBZ4l.setQueueGroupsStateInLocalStorage)(projectKey, getState());
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $3b5b2eee2cc09f57$var$initialState = {};
const $3b5b2eee2cc09f57$var$Store = (0, $iXqE5.createStore)({
    name: 'jsm-navigation-categories-store',
    initialState: $3b5b2eee2cc09f57$var$initialState,
    actions: $3b5b2eee2cc09f57$export$e324594224ef24da
});
const $3b5b2eee2cc09f57$export$ea600ea09fe6bbd = (0, $gg7kZ.createContainer)($3b5b2eee2cc09f57$var$Store, {
    onInit: ()=>({ setState: setState }, { projectKey: projectKey })=>{
            const stateFromStorage = (0, $aBZ4l.getQueueGroupsStateFromLocalStorage)(projectKey);
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $3b5b2eee2cc09f57$export$6676162114f1489a = (0, $3sQ5x.createHook)($3b5b2eee2cc09f57$var$Store);
const $3b5b2eee2cc09f57$export$9a1583f58d01a77c = (0, $3sQ5x.createHook)($3b5b2eee2cc09f57$var$Store, {
    selector: (state, category)=>state[category]?.selectedGroupId
});
const $3b5b2eee2cc09f57$export$aca7e7401e11cffa = (0, $3sQ5x.createHook)($3b5b2eee2cc09f57$var$Store, {
    selector: (state, category)=>state[category]?.selectedQueueSection
});

});
parcelRegister("aBZ4l", function(module, exports) {

$parcel$export(module.exports, "getQueueGroupsStateFromLocalStorage", () => $6763d726b8e20795$export$69c85d62a3ce3c00);
$parcel$export(module.exports, "setQueueGroupsStateInLocalStorage", () => $6763d726b8e20795$export$7475d3423fcf9a14);

var $bSSG7 = parcelRequire("bSSG7");
const $6763d726b8e20795$export$72f6692c81a0e6b3 = 'jsm-queue-groups-state';
const $6763d726b8e20795$export$d8474cff104280f3 = 'selected-group-id';
const $6763d726b8e20795$export$69c85d62a3ce3c00 = (projectKey)=>{
    const localStorageProvider = (0, $bSSG7.createLocalStorageProvider)($6763d726b8e20795$export$72f6692c81a0e6b3);
    try {
        const state = localStorageProvider.get(`${$6763d726b8e20795$export$d8474cff104280f3}-${projectKey}`);
        if (state) return JSON.parse(state);
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $6763d726b8e20795$export$7475d3423fcf9a14 = (projectKey, value)=>{
    const localStorageProvider = (0, $bSSG7.createLocalStorageProvider)($6763d726b8e20795$export$72f6692c81a0e6b3);
    try {
        localStorageProvider.set(`${$6763d726b8e20795$export$d8474cff104280f3}-${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};

});


parcelRegister("dB1lV", function(module, exports) {

$parcel$export(module.exports, "usePopoutConfig", () => $7c2fdf6f59218735$export$2cbd7df9320f5286);

var $5uXOq = parcelRequire("5uXOq");

var $5MhuD = parcelRequire("5MhuD");

var $emIzB = parcelRequire("emIzB");

var $jF62O = parcelRequire("jF62O");

var $bmKPg = parcelRequire("bmKPg");
var $doZTA = parcelRequire("doZTA");

var $8hPMc = parcelRequire("8hPMc");

var $cdkPG = parcelRequire("cdkPG");

var $kLHbr = parcelRequire("kLHbr");
const $7c2fdf6f59218735$var$getPopoutConfig = (isPoppedOut, queueSection)=>({
        isPoppedOut: isPoppedOut,
        highestAvailableSection: isPoppedOut ? queueSection : undefined
    });
const $7c2fdf6f59218735$export$2cbd7df9320f5286 = (projectKey, practice)=>{
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const pathname = location.pathname;
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $jF62O.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const [starredQueues] = (0, $jF62O.useFavouriteNavItems)('', projectKey, practice, queueCustomContext);
    const [isPoppedOut] = (0, $8hPMc.usePoppedOutState)((0, $8hPMc.getCategoryStateKey)(projectKey, practice));
    const [queueIdFromPath] = (0, $bmKPg.usePathParam)('queueId');
    const [groups] = (0, $emIzB.useCategorizedGroupsNavItems)(projectKey, practice, queueCustomContext);
    const isCategorisedViewQueueUrl = (0, $kLHbr.isValidCategorisedViewQueueUrl)(projectKey, practice, queueIdFromPath, pathname);
    const queueFoundInPractice = allQueues?.some((queue)=>queue.id === queueIdFromPath);
    return (0, $5uXOq.useMemo)(()=>{
        // First, determine if the popout is active according to the criteria below
        //  - The popout must be in the popped out state (i.e. the user has clicked the popout button)
        //  - The current URL must be showing a valid view queue page
        //  - The current queue must be part of the practice
        if (!isPoppedOut || !isCategorisedViewQueueUrl || !queueFoundInPractice) return $7c2fdf6f59218735$var$getPopoutConfig(false);
        // Next, if the popout is active, determine the highest available queue section available in this popout
        const hasNonEmptyPriorityGroups = groups?.some((group)=>group.queues.length > 0);
        const hasStarredQueues = starredQueues && starredQueues.length > 0;
        if (hasStarredQueues) return $7c2fdf6f59218735$var$getPopoutConfig(true, (0, $cdkPG.QueueListSection).STARRED);
        if (hasNonEmptyPriorityGroups) return $7c2fdf6f59218735$var$getPopoutConfig(true, (0, $cdkPG.QueueListSection).PRIORITY_GROUP);
        return $7c2fdf6f59218735$var$getPopoutConfig(true, (0, $cdkPG.QueueListSection).ALL_QUEUES);
    }, [
        isPoppedOut,
        isCategorisedViewQueueUrl,
        queueFoundInPractice,
        groups,
        starredQueues
    ]);
};

});
parcelRegister("kLHbr", function(module, exports) {

$parcel$export(module.exports, "isValidViewQueueUrl", () => $a27a9775ab775ec1$export$b1a2a8e908746b71);
$parcel$export(module.exports, "isValidQueuesUrl", () => $a27a9775ab775ec1$export$a13ce3a24252ba88);
$parcel$export(module.exports, "isValidCategorisedViewQueueUrl", () => $a27a9775ab775ec1$export$329289338cdb3da1);
$parcel$export(module.exports, "isValidCategorisedQueuesUrl", () => $a27a9775ab775ec1$export$6d24a4cae21a7dbd);
$parcel$export(module.exports, "useHighestPriorityQueueUrl", () => $a27a9775ab775ec1$export$e82fb154e65954b9);

var $dd29Z = parcelRequire("dd29Z");

var $5MhuD = parcelRequire("5MhuD");

var $jF62O = parcelRequire("jF62O");

var $1ilU2 = parcelRequire("1ilU2");

var $8hPMc = parcelRequire("8hPMc");

var $4UYVJ = parcelRequire("4UYVJ");
const $a27a9775ab775ec1$var$getStrippedPathname = (pathname)=>{
    // strip url params and trailing slashes if they exist
    const pathnameWithoutParams = pathname.split('?')[0];
    const pathnameWithoutTrailingSlash = pathnameWithoutParams.endsWith('/') ? pathnameWithoutParams.slice(0, -1) : pathnameWithoutParams;
    return pathnameWithoutTrailingSlash;
};
const $a27a9775ab775ec1$export$b1a2a8e908746b71 = (projectKey, queueId, pathname)=>{
    if (!queueId) return false;
    const currentPath = $a27a9775ab775ec1$var$getStrippedPathname(pathname);
    const constructedPath = `${$a27a9775ab775ec1$export$96cc9136710988d8(projectKey)}/custom/${queueId}`;
    return currentPath.endsWith(constructedPath);
};
const $a27a9775ab775ec1$export$a13ce3a24252ba88 = (projectKey, pathname)=>pathname.includes($a27a9775ab775ec1$export$96cc9136710988d8(projectKey));
const $a27a9775ab775ec1$export$329289338cdb3da1 = (projectKey, category, queueId, pathname)=>{
    if (!queueId) return false;
    if (!category) return $a27a9775ab775ec1$export$b1a2a8e908746b71(projectKey, queueId, pathname);
    const currentPath = $a27a9775ab775ec1$var$getStrippedPathname(pathname);
    const constructedPath = `${$a27a9775ab775ec1$export$714ec44b3d657788(projectKey, category)}/custom/${queueId}`;
    return currentPath.endsWith(constructedPath);
};
const $a27a9775ab775ec1$export$6d24a4cae21a7dbd = (projectKey, category, pathname)=>{
    if (!category) return $a27a9775ab775ec1$export$a13ce3a24252ba88(projectKey, pathname);
    return pathname.includes($a27a9775ab775ec1$export$714ec44b3d657788(projectKey, category));
};
const $a27a9775ab775ec1$export$714ec44b3d657788 = (projectKey, category)=>{
    if (!category) return $a27a9775ab775ec1$export$96cc9136710988d8(projectKey);
    return `${$a27a9775ab775ec1$export$ebd25648349e3334(projectKey)}/${(0, $dd29Z.QUEUE_ROUTES)[category]}`;
};
const $a27a9775ab775ec1$export$96cc9136710988d8 = (projectKey)=>`${$a27a9775ab775ec1$export$ebd25648349e3334(projectKey)}/queues`;
const $a27a9775ab775ec1$export$ebd25648349e3334 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}`;
const $a27a9775ab775ec1$export$4f6fb26cc9e97438 = (projectKey, category)=>{
    // Need to get all data before returning to avoid hook errors
    const categoryStateKey = (0, $8hPMc.getCategoryStateKey)(projectKey, category);
    const [lastVisitedQueueId] = (0, $8hPMc.useLastVisitedQueueId)(categoryStateKey);
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const [starredQueues] = (0, $jF62O.useFavouriteNavItems)('', projectKey, category, queueCustomContext);
    const [allQueues] = (0, $jF62O.useCategorizedNavItems)('', projectKey, category, queueCustomContext);
    const [filteredGroups] = (0, $4UYVJ.useFilteredCategorizedQueueGroups)(projectKey, (0, $1ilU2.toItsmPractice)(category));
    // Always use the last visited queue if it exists
    if (lastVisitedQueueId) return lastVisitedQueueId;
    // Next best option is to return a starred queue
    if (starredQueues?.length) return starredQueues[0].id;
    // Next best option is to return the first queue in the first group
    if (filteredGroups?.length && filteredGroups[0].queues?.length) return filteredGroups[0].queues[0].id;
    // Final option is to return the first queue in the all queues list
    if (allQueues?.length) return allQueues[0].id;
    return undefined;
};
const $a27a9775ab775ec1$export$e82fb154e65954b9 = (projectKey, category)=>{
    const queueId = $a27a9775ab775ec1$export$4f6fb26cc9e97438(projectKey, category);
    if (!queueId) return '';
    return `${$a27a9775ab775ec1$export$714ec44b3d657788(projectKey, category)}/custom/${queueId}`;
};

});
parcelRegister("4UYVJ", function(module, exports) {

$parcel$export(module.exports, "useIsQueueSelected", () => $f8fa4ed6179cf80f$export$5405660a1c6b0f63);
$parcel$export(module.exports, "useFilteredCategorizedQueueGroups", () => $f8fa4ed6179cf80f$export$7689b1dc3aabf437);

var $5uXOq = parcelRequire("5uXOq");

var $5MhuD = parcelRequire("5MhuD");

var $5Srj8 = parcelRequire("5Srj8");

var $emIzB = parcelRequire("emIzB");

var $oCMSG = parcelRequire("oCMSG");

var $bmKPg = parcelRequire("bmKPg");

var $dP3YV = parcelRequire("dP3YV");
const $f8fa4ed6179cf80f$export$b70190c48788c872 = (queue, priorityGroups, lastSelectedSection, currentSection, selectedGroupId)=>{
    if (currentSection === lastSelectedSection) return currentSection;
    const isStarred = queue.starred;
    const selectedPriorityGroup = priorityGroups.find((group)=>group.id === selectedGroupId);
    const isQueueInSelectedGroup = selectedPriorityGroup?.queues.some((queueInGroup)=>queueInGroup.toString(10) === queue.id);
    if (lastSelectedSection === (0, $5Srj8.QueueListSection).STARRED && !queue.starred) return isQueueInSelectedGroup ? (0, $5Srj8.QueueListSection).PRIORITY_GROUP : (0, $5Srj8.QueueListSection).ALL_QUEUES;
    if (lastSelectedSection === (0, $5Srj8.QueueListSection).PRIORITY_GROUP && !isQueueInSelectedGroup) return isStarred ? (0, $5Srj8.QueueListSection).STARRED : (0, $5Srj8.QueueListSection).ALL_QUEUES;
    if (lastSelectedSection === undefined) {
        if (isStarred) return (0, $5Srj8.QueueListSection).STARRED;
        if (isQueueInSelectedGroup) return (0, $5Srj8.QueueListSection).PRIORITY_GROUP;
        return (0, $5Srj8.QueueListSection).ALL_QUEUES;
    }
    return lastSelectedSection;
};
const $f8fa4ed6179cf80f$export$9bdd97120118ee26 = (queue, priorityGroups, section, lastSelectedSection, lastSelectedGroupId, priorityGroupId)=>{
    const firstPriorityGroupWithQueue = priorityGroups.find((group)=>group.queues.includes(Number(queue.id)))?.id;
    const queueMissingValidHistory = lastSelectedSection === undefined || lastSelectedSection === (0, $5Srj8.QueueListSection).PRIORITY_GROUP && !lastSelectedGroupId;
    const isQueueSelectedBasedOnPriority = {
        [(0, $5Srj8.QueueListSection).STARRED]: queue.starred && !priorityGroupId,
        [(0, $5Srj8.QueueListSection).PRIORITY_GROUP]: !queue.starred && priorityGroupId === firstPriorityGroupWithQueue,
        [(0, $5Srj8.QueueListSection).ALL_QUEUES]: !queue.starred && !firstPriorityGroupWithQueue
    };
    const isQueueSelectedBasedOnHistory = {
        [(0, $5Srj8.QueueListSection).STARRED]: true,
        [(0, $5Srj8.QueueListSection).PRIORITY_GROUP]: lastSelectedGroupId === priorityGroupId,
        [(0, $5Srj8.QueueListSection).ALL_QUEUES]: true
    };
    if (queueMissingValidHistory) return isQueueSelectedBasedOnPriority[section];
    if (section === lastSelectedSection) return isQueueSelectedBasedOnHistory[lastSelectedSection];
    return false;
};
const $f8fa4ed6179cf80f$export$5405660a1c6b0f63 = (queue, section, priorityGroupId)=>{
    const [queueIdFromPath] = (0, $bmKPg.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $dP3YV.useSelectedNavLocation)(queueIdFromPath || '');
    const [priorityGroups] = (0, $emIzB.usePriorityGroups)(queue?.category || (0, $oCMSG.NO_CATEGORY));
    return (0, $5uXOq.useMemo)(()=>queue !== undefined ? $f8fa4ed6179cf80f$export$9bdd97120118ee26(queue, priorityGroups, section, selectedNavLocation.section, selectedNavLocation.groupId, priorityGroupId) : false, [
        priorityGroupId,
        priorityGroups,
        queue,
        section,
        selectedNavLocation.groupId,
        selectedNavLocation.section
    ]);
};
const $f8fa4ed6179cf80f$export$7689b1dc3aabf437 = (projectKey, category)=>{
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const [groups, isLoading, groupError, queueError] = (0, $emIzB.useCategorizedGroupsNavItems)(projectKey, category, queueCustomContext);
    const filteredGroups = (0, $5uXOq.useMemo)(()=>groups.filter((group)=>group.queues.length > 0), [
        groups
    ]);
    return [
        filteredGroups,
        isLoading,
        groupError,
        queueError
    ];
};

});



parcelRegister("Yt6er", function(module, exports) {

$parcel$export(module.exports, "QueueItem", () => $d30b167c10a08a0a$export$1b63de307530e1bc);

var $5uXOq = parcelRequire("5uXOq");

var $hUobS = parcelRequire("hUobS");

var $1sXeC = parcelRequire("1sXeC");

var $16T6Y = parcelRequire("16T6Y");

var $6a9Wp = parcelRequire("6a9Wp");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5Srj8 = parcelRequire("5Srj8");

var $oCMSG = parcelRequire("oCMSG");

var $1ilU2 = parcelRequire("1ilU2");

var $DVljb = parcelRequire("DVljb");

var $eMAVw = parcelRequire("eMAVw");

var $bmKPg = parcelRequire("bmKPg");
var $doZTA = parcelRequire("doZTA");

var $kLHbr = parcelRequire("kLHbr");

var $dP3YV = parcelRequire("dP3YV");

var $8hPMc = parcelRequire("8hPMc");

var $4UYVJ = parcelRequire("4UYVJ");

var $gj19s = parcelRequire("gj19s");

var $idyxU = parcelRequire("idyxU");

var $kkS4O = parcelRequire("kkS4O");
const $d30b167c10a08a0a$var$MAX_BADGE_COUNT = 999;
const $d30b167c10a08a0a$export$d243ff4c233d53f3 = (pathCategorySelectedSection, currentQueueInSection)=>(currentLocation, itemLocation)=>{
        const pathNameMatches = currentLocation.pathname === itemLocation.pathname || currentLocation.pathname.substring(0, currentLocation.pathname.lastIndexOf('/')) === itemLocation.pathname;
        const isSectionMatched = pathCategorySelectedSection === currentQueueInSection;
        return pathNameMatches && isSectionMatched;
    };
const $d30b167c10a08a0a$export$1b63de307530e1bc = ({ Badge: Badge = (0, $16T6Y.default), queue: queue, section: section, projectKey: projectKey, priorityGroupId: priorityGroupId, isQueueInFlyOut: isQueueInFlyOut = false, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $DVljb.useLocale)();
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const pathname = location.pathname;
    const [queueIdFromPath] = (0, $bmKPg.usePathParam)('queueId');
    const [practiceFromPath] = (0, $bmKPg.usePathParam)('practiceType');
    const [projectKeyFromPath] = (0, $bmKPg.usePathParam)('projectKey');
    const categoryFromPath = (0, $1ilU2.toItsmPractice)(practiceFromPath);
    const categoryFromQueue = queue.category || (0, $oCMSG.NO_CATEGORY);
    const [selectedNavLocation, { updateSelectedNavLocation: updateSelectedNavLocation }] = (0, $dP3YV.useSelectedNavLocation)(queueIdFromPath || '');
    const isViewQueueUrl = (0, $kLHbr.isValidCategorisedViewQueueUrl)(projectKey || '', categoryFromQueue, queueIdFromPath, pathname);
    // Is queue selected logic
    const href = `/jira/servicedesk${queue.url}`;
    const queueMatchesRoute = route != null && queueIdFromPath === queue.id && location.pathname.startsWith(href);
    const isQueueSelected = (0, $4UYVJ.useIsQueueSelected)(queue, section, priorityGroupId) && queueMatchesRoute;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isPoppedOut] = (0, $8hPMc.usePoppedOutState)(`${projectKey}-${categoryFromQueue}`);
    (0, $5uXOq.useEffect)(()=>{
        if (isQueueSelected) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queueItemSelected rendered', {
            id: queue.id,
            name: queue.name,
            category: categoryFromQueue,
            section: section,
            priorityGroupId: priorityGroupId,
            isQueueInFlyOut: isQueueInFlyOut,
            isQueueInPopOutPanel: isPoppedOut
        });
    }, [
        categoryFromQueue,
        createAnalyticsEvent,
        isQueueInFlyOut,
        isQueueSelected,
        isPoppedOut,
        priorityGroupId,
        queue.category,
        queue.id,
        queue.name,
        section
    ]);
    // Internal methods
    const getFormattedRelativeLastRefreshedTime = (0, $5uXOq.useCallback)(()=>{
        if (queue.badgeCount === undefined) return formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $idyxU.tooltipMessages).loadingIssueCountTooltipIssueTermRefresh : (0, $idyxU.tooltipMessages).loadingIssueCountTooltip);
        const lastRefreshedTime = queue.lastRefreshedTime || Date.now();
        return formatMessage((0, $idyxU.tooltipMessages).showLastRefreshedTimeTooltip, {
            lastUpdate: (0, $1p96B.formatDistanceStrictWithLocale)(lastRefreshedTime, Date.now(), locale, true)
        });
    }, [
        formatMessage,
        locale,
        queue.badgeCount,
        queue.lastRefreshedTime
    ]);
    const onMenuItemClick = ()=>{
        updateSelectedNavLocation(queue.id, section, priorityGroupId);
    };
    // Should queue show issue count badge
    const inSelectedProject = projectKey === projectKeyFromPath;
    const inSelectedCategory = categoryFromQueue === categoryFromPath;
    const isValidLocation = isViewQueueUrl && inSelectedProject && inSelectedCategory;
    const shouldShowBadgeInSection = {
        [(0, $5Srj8.QueueListSection).STARRED]: true,
        [(0, $5Srj8.QueueListSection).PRIORITY_GROUP]: selectedNavLocation.groupId === priorityGroupId,
        [(0, $5Srj8.QueueListSection).ALL_QUEUES]: isQueueSelected
    };
    const shouldShowBadge = isValidLocation && shouldShowBadgeInSection[section];
    const badgeDisplayValue = shouldShowBadge && ((0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(queue.badgeCount) ? (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(queue.badgeCount) : '-');
    const issueCountBadge = shouldShowBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ()=>getFormattedRelativeLastRefreshedTime()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-is-queue-issue-count-badge": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Badge, {
        max: $d30b167c10a08a0a$var$MAX_BADGE_COUNT
    }, badgeDisplayValue)));
    const starButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkS4O.StarButton), {
        isStarred: queue.starred,
        queueId: queue.id
    });
    // issue count errors
    const shouldShowIssueCountError = queue.shouldSkipIssueCountRefresh && shouldShowBadge;
    const issueCountIcon = shouldShowIssueCountError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gj19s.default), {
        queue: queue
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, issueCountBadge);
    // TODO instrument MenuLinkItem analytics={{ itemId: `queue-${queue.id}`,}} set componentType: customItem, if it's a custom queue (see the spec)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMAVw.MenuLinkItem), {
        href: href,
        isSelected: isQueueSelected && !isQueueInFlyOut,
        onClick: onMenuItemClick,
        elemAfter: issueCountIcon,
        actionsOnHover: starButton,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6a9Wp))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        "aria-label": queue.name,
        ...rest
    }, queue.name);
};

});
parcelRegister("gj19s", function(module, exports) {

$parcel$export(module.exports, "default", () => $406a8040b94fa0e1$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $gb7Oz = parcelRequire("gb7Oz");

var $7paD5 = parcelRequire("7paD5");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $eHJxW = parcelRequire("eHJxW");

var $lpwtK = parcelRequire("lpwtK");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $jF62O = parcelRequire("jF62O");

var $itmJb = parcelRequire("itmJb");

var $1qS8v = parcelRequire("1qS8v");
const $406a8040b94fa0e1$export$9facd8d31b938a25 = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const projectContext = (0, $dAfqg.useProjectContext)();
    const isProjectAdmin = isAdmin || projectContext?.data?.isProjectAdmin || false;
    return {
        isProjectAdmin: isProjectAdmin
    };
};
const $406a8040b94fa0e1$var$learnMoreUrl = 'https://community.atlassian.com/t5/Jira-Service-Management-articles/Managing-queues-at-scale-in-Jira-Service-Management/ba-p/2102021';
const $406a8040b94fa0e1$export$ca8e59510a286136 = ({ queue: queue })=>{
    const [showDialog, setShowDialog] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const [, , , methods] = (0, $jF62O.useCategorizedNavItems)('', project ? project.key : '', queue.category);
    const onReload = (0, $5uXOq.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'ReloadBadQueueButton');
        methods.enableRefreshForQueues([
            queue.id
        ]);
        methods.refreshIssueCountForItems([
            queue.id
        ]);
    }, [
        methods,
        queue.id,
        createAnalyticsEvent
    ]);
    const onEditQueue = (0, $5uXOq.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(`${queue.url}/edit`, '_blank');
        setShowDialog(false);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'EditQueueFromIssueCountErrorDialog'
        }), {
            meta: {
                id: 'ViewEditQueueFromIssueCountErrorDialog',
                packageName: 'jiraNavigationAppsSidebarServicedesk',
                teamName: 'jsd-shield'
            },
            canBeHidden: queue.canBeHidden,
            isStarred: queue.starred
        });
    }, [
        setShowDialog,
        queue.url,
        queue.canBeHidden,
        queue.starred,
        createAnalyticsEvent
    ]);
    const onLearnMoreClick = (0, $5uXOq.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        setShowDialog(false);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'BadQueueLearnMoreButton'); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open($406a8040b94fa0e1$var$learnMoreUrl, '_blank');
    }, [
        createAnalyticsEvent
    ]);
    const learnMoreButton = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            target: "_blank",
            onClick: onLearnMoreClick
        }, formatMessage((0, $1qS8v.messages).learnMoreButtonLabel)), [
        formatMessage,
        onLearnMoreClick
    ]);
    const reloadButton = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            onClick: onReload
        }, formatMessage((0, $1qS8v.messages).reloadButtonLabel)), [
        onReload,
        formatMessage
    ]);
    const editQueueButton = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            onClick: onEditQueue,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                label: "",
                LEGACY_size: "small"
            })
        }, formatMessage((0, $1qS8v.messages).editQueueButtonLabel)), [
        onEditQueue,
        formatMessage
    ]);
    const { isProjectAdmin: isProjectAdmin } = $406a8040b94fa0e1$export$9facd8d31b938a25();
    const userActionButton = isProjectAdmin ? editQueueButton : reloadButton;
    const agentMessage = queue.starred ? (0, $1qS8v.messages).issueCountErrorMessageAgentStarred : (0, $1qS8v.messages).issueCountErrorMessageAgentNotStarred;
    const contentMessage = isProjectAdmin ? (0, $1qS8v.messages).issueCountErrorMessageAdmin : agentMessage;
    const content = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($406a8040b94fa0e1$var$InlineDialogContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($406a8040b94fa0e1$var$InlineDialogHeader, null, formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $1qS8v.messages).issueCountErrorMessageHeaderIssueTermRefresh : (0, $1qS8v.messages).issueCountErrorMessageHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage(contentMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($406a8040b94fa0e1$var$InlineDialogButtons, null, learnMoreButton, userActionButton)), [
        contentMessage,
        formatMessage,
        learnMoreButton,
        userActionButton
    ]);
    const onIssueCountErrorButtonClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2315 - Type 'Mouse Event' is not generic.
    (e)=>{
        e.stopPropagation(); // prevent underlying queue button from being pressed
        e.preventDefault();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'IssueCountErrorButton');
        setShowDialog(!showDialog);
    }, [
        showDialog,
        setShowDialog,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        onClose: ()=>{
            setShowDialog(false);
        },
        content: content,
        isOpen: showDialog,
        messageId: "servicedesk-queues-nav4.common.ui.practice-queues.queue-list.queue-item.issue-count-error-message.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($406a8040b94fa0e1$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onIssueCountErrorButtonClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gb7Oz))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)"
        })
    })));
};
var $406a8040b94fa0e1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $406a8040b94fa0e1$export$ca8e59510a286136;
const $406a8040b94fa0e1$var$InlineDialogContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81oud _p12f3xl8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $406a8040b94fa0e1$var$InlineDialogHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $406a8040b94fa0e1$var$InlineDialogButtons = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0xmi2 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $406a8040b94fa0e1$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _14hp1tcg _jq8g1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $406a8040b94fa0e1$export$7ed12d2a5241e393 = {
    InlineDialogContainer: $406a8040b94fa0e1$var$InlineDialogContainer,
    InlineDialogHeader: $406a8040b94fa0e1$var$InlineDialogHeader,
    InlineDialogButtons: $406a8040b94fa0e1$var$InlineDialogButtons,
    ButtonWrapper: $406a8040b94fa0e1$var$ButtonWrapper
};

});
parcelRegister("gb7Oz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e0a0a976ef89b19918ed893a0e5bd16>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc73bc3d72b7857d$var$_react = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc73bc3d72b7857d$var$_warning = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("34Rrn")));

var $bc73bc3d72b7857d$var$_warning2 = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("hD8l9")));
function $bc73bc3d72b7857d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc73bc3d72b7857d$var$WarningIcon = (props)=>/*#__PURE__*/ $bc73bc3d72b7857d$var$_react.default.createElement($bc73bc3d72b7857d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $bc73bc3d72b7857d$var$_warning2.default
    }, props));
$bc73bc3d72b7857d$var$WarningIcon.Name = 'WarningIconMigration';
var $bc73bc3d72b7857d$var$_default = module.exports.default = $bc73bc3d72b7857d$var$WarningIcon;

});

parcelRegister("1qS8v", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b6b80d8fd1d6f511$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b6b80d8fd1d6f511$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueCountErrorMessageHeader: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-header",
        "defaultMessage": "We can't show the number of issues"
    },
    issueCountErrorMessageAdmin: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-admin",
        "defaultMessage": "There seems to be a problem with the queue's filters. Edit the queue and try again."
    },
    issueCountErrorMessageAgentStarred: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-agent-starred",
        "defaultMessage": "There seems to be a problem with the queue's filters. Contact your admins to edit this queue or remove it from Starred."
    },
    issueCountErrorMessageAgentNotStarred: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-agent-not-starred",
        "defaultMessage": "There seems to be a problem with the queue's filters. Contact your admins to edit this queue."
    },
    learnMoreButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.learn-more-button-label",
        "defaultMessage": "Learn more"
    },
    reloadButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.reload-button-label",
        "defaultMessage": "Reload"
    },
    editQueueButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.edit-queue-button-label",
        "defaultMessage": "Edit queue"
    },
    issueCountErrorMessageHeaderIssueTermRefresh: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-header-issue-term-refresh",
        "defaultMessage": "We can't show the number of work items"
    }
});

});


parcelRegister("idyxU", function(module, exports) {

$parcel$export(module.exports, "tooltipMessages", () => $5745d647f1dcb496$export$4713da6aa4410043);

var $7VHMR = parcelRequire("7VHMR");
const $5745d647f1dcb496$export$4713da6aa4410043 = (0, $7VHMR.defineMessages)({
    loadingIssueCountTooltip: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.loading-issue-count-tooltip",
        "defaultMessage": "Loading the number of issues"
    },
    showLastRefreshedTimeTooltip: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.show-last-refreshed-time-tooltip",
        "defaultMessage": "Last updated {lastUpdate}"
    },
    loadingIssueCountTooltipIssueTermRefresh: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.loading-issue-count-tooltip-issue-term-refresh",
        "defaultMessage": "Loading the number of work items"
    }
});

});

parcelRegister("kkS4O", function(module, exports) {

$parcel$export(module.exports, "StarButton", () => $c06ef269d9ffd903$export$b4b5678234ca6d4d);

var $5uXOq = parcelRequire("5uXOq");

var $hcObS = parcelRequire("hcObS");

var $eXQym = parcelRequire("eXQym");

var $4041n = parcelRequire("4041n");
const $c06ef269d9ffd903$export$b4b5678234ca6d4d = ({ isStarred: isStarred, queueId: queueId })=>{
    const { changeFavorite: changeFavorite } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        isFavorite: isStarred,
        pending: false,
        isSmall: true,
        onClick: (analyticsEvent)=>{
            changeFavorite({
                id: queueId,
                value: !isStarred,
                type: (0, $eXQym.QUEUES_ITEM_TYPE)
            }, analyticsEvent);
        }
    });
};

});


parcelRegister("64lxo", function(module, exports) {

$parcel$export(module.exports, "AllQueuesFlyout", () => $5d8cae6f831e2198$export$6e323880808677df);

var $5uXOq = parcelRequire("5uXOq");

var $i6luQ = parcelRequire("i6luQ");

var $koVbs = parcelRequire("koVbs");

var $5MhuD = parcelRequire("5MhuD");

var $jF62O = parcelRequire("jF62O");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");

var $cMZdB = parcelRequire("cMZdB");

var $9uXVa = parcelRequire("9uXVa");
const $5d8cae6f831e2198$export$6e323880808677df = ({ projectKey: projectKey, practice: practice })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $jF62O.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUDIz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBNLs.FlyoutMenuItemTrigger), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i6luQ))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        })
    }, formatMessage((0, $9uXVa.messages).viewAllQueues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17aWz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cMZdB.AllQueues), {
        projectKey: projectKey,
        practice: practice,
        isFlyOut: true
    })));
};

});
parcelRegister("cMZdB", function(module, exports) {

$parcel$export(module.exports, "AllQueues", () => $9629bd825296ec53$export$4c4b4d372f994d4e);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5MhuD = parcelRequire("5MhuD");

var $5Srj8 = parcelRequire("5Srj8");

var $jF62O = parcelRequire("jF62O");

var $1FdfO = parcelRequire("1FdfO");

var $3FFtj = parcelRequire("3FFtj");

var $9uXVa = parcelRequire("9uXVa");
const $9629bd825296ec53$export$4c4b4d372f994d4e = ({ projectKey: projectKey, practice: practice, isFlyOut: isFlyOut = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $jF62O.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const [filter, setFilter] = (0, $5uXOq.useState)('');
    const searchResultQueues = (0, $5uXOq.useMemo)(()=>allQueues?.filter((queue)=>queue.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) ?? [], [
        allQueues,
        filter
    ]);
    const SearchIconMemo = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        setFilter(event.currentTarget.value);
    }, []);
    const onStopQueueSearch = (0, $5uXOq.useCallback)(()=>{
        const getViewAllQueueSearchEvent = createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'jsmViewAllQueueFlyoutSearch'
        });
        (0, $8zOmE.fireUIAnalytics)(getViewAllQueueSearchEvent, 'stopViewAllQueueSearch', {
            projectKey: projectKey,
            practice: practice
        });
    }, [
        createAnalyticsEvent,
        projectKey,
        practice
    ]);
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, isFlyOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $9uXVa.messages).allQueues))), isFlyOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9629bd825296ec53$var$filterContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isCompact: true,
        value: filter,
        onChange: handleChange,
        "aria-label": formatMessage((0, $9uXVa.messages).searchYourQueue),
        placeholder: formatMessage((0, $9uXVa.messages).searchYourQueue),
        elemBeforeInput: SearchIconMemo,
        onBlur: onStopQueueSearch
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050",
        xcss: $9629bd825296ec53$var$scrollBoxStyles
    }, searchResultQueues.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FFtj.QueueList), {
        queues: searchResultQueues,
        section: (0, $5Srj8.QueueListSection).ALL_QUEUES,
        isQueueListInFlyOut: isFlyOut
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100",
        xcss: $9629bd825296ec53$var$noSearchResultsFoundStyles
    }, formatMessage((0, $9uXVa.messages).noSearchResultsFound)))));
};
const $9629bd825296ec53$var$noSearchResultsFoundStyles = (0, $8CUq3.xcss)({
    fontStyle: 'italic'
});
const $9629bd825296ec53$var$scrollBoxStyles = (0, $8CUq3.xcss)({
    maxHeight: '500px',
    overflow: 'auto',
    scrollbarGutter: 'stable',
    padding: 'space.050'
});
const $9629bd825296ec53$var$filterContainerStyles = (0, $8CUq3.xcss)({
    minHeight: 'space.400',
    paddingRight: 'space.100'
});

});
parcelRegister("3FFtj", function(module, exports) {

$parcel$export(module.exports, "QueueList", () => $f99841866c999e0b$export$6b278a59f65cf1eb);

var $5uXOq = parcelRequire("5uXOq");

var $Yt6er = parcelRequire("Yt6er");
const $f99841866c999e0b$export$6b278a59f65cf1eb = ({ QueueItem: QueueItem = (0, $Yt6er.QueueItem), queues: queues, section: section, projectKey: projectKey, priorityGroupId: priorityGroupId, isQueueListInFlyOut: isQueueListInFlyOut = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, queues.map((queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(QueueItem, {
            key: queue.id,
            queue: queue,
            section: section,
            projectKey: projectKey,
            priorityGroupId: priorityGroupId,
            isQueueInFlyOut: isQueueListInFlyOut
        })));
};

});

parcelRegister("9uXVa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7ba82d690bf95ff8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7ba82d690bf95ff8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    allQueues: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.all-queues",
        "defaultMessage": "All queues"
    },
    viewAllQueues: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.view-all-queues",
        "defaultMessage": "View all queues"
    },
    searchYourQueue: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.search-your-queue",
        "defaultMessage": "Search your queue"
    },
    noSearchResultsFound: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.no-search-results-found",
        "defaultMessage": "No search results found"
    }
});

});



parcelRegister("hSFzl", function(module, exports) {

$parcel$export(module.exports, "AllQueuesPopOut", () => $c9ada127691b2ca6$export$c9909bdf149a8c80);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5MhuD = parcelRequire("5MhuD");

var $jF62O = parcelRequire("jF62O");

var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $bmKPg = parcelRequire("bmKPg");

var $dP3YV = parcelRequire("dP3YV");

var $cdkPG = parcelRequire("cdkPG");

var $cMZdB = parcelRequire("cMZdB");

var $9uXVa = parcelRequire("9uXVa");
const $c9ada127691b2ca6$export$c9909bdf149a8c80 = ({ projectKey: projectKey, practice: practice })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $jF62O.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const [queueIdFromPath] = (0, $bmKPg.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $dP3YV.useSelectedNavLocation)(queueIdFromPath || '');
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        isDefaultExpanded: selectedNavLocation.section === (0, $cdkPG.QueueListSection).ALL_QUEUES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), null, formatMessage((0, $9uXVa.messages).allQueues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cMZdB.AllQueues), {
        projectKey: projectKey,
        practice: practice
    })));
};

});


parcelRegister("3rRyc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $733978ba5695d979$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $733978ba5695d979$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fetchQueuesError: {
        "id": "servicedesk-queues-nav4.common.practice-queues.fetch-queues-error",
        "defaultMessage": "We're unable to load queues data, <button>try again.</button>"
    }
});

});

parcelRegister("c5aKg", function(module, exports) {

$parcel$export(module.exports, "QueuesExperienceTracker", () => $e8848e84cd29e0fe$export$68c534d50bf4d3ae);

var $5uXOq = parcelRequire("5uXOq");

var $aD4Nm = parcelRequire("aD4Nm");

var $2i4sA = parcelRequire("2i4sA");

var $8WmEI = parcelRequire("8WmEI");

var $01Rn4 = parcelRequire("01Rn4");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $e8848e84cd29e0fe$export$68c534d50bf4d3ae = ({ children: children })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        application: (0, $efvDm.JIRA_SERVICE_DESK),
        edition: appEditions.serviceDesk,
        experience: "viewQueuesNav4",
        analyticsSource: "queuesNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
        location: "queues-nav-render-error"
    }, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WmEI.default), {
            handler: (error)=>{
                onExperienceFailure(undefined, {
                    errorMessage: error?.message,
                    errorName: error?.name
                });
            },
            isRethrowEnabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
            op: onExperienceSuccess
        })))));
};

});
parcelRegister("8WmEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fcaf1a018ca6020$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $1fcaf1a018ca6020$var$OnCatch extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            arg: undefined,
            isRethrowEnabled: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const { handler: handler, isRethrowEnabled: isRethrowEnabled, arg: arg } = this.props;
        handler(error, errorInfo, arg);
        if (isRethrowEnabled) throw error;
    }
    render() {
        return this.props.children;
    }
}
var $1fcaf1a018ca6020$export$2e2bcd8739ae039 = $1fcaf1a018ca6020$var$OnCatch;

});


parcelRegister("gKNHL", function(module, exports) {

$parcel$export(module.exports, "QueueGroupsSection", () => $685662c334a07302$export$95e0028b61fb2a1a);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $338xa = parcelRequire("338xa");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5Srj8 = parcelRequire("5Srj8");

var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");
var $1FdfO = parcelRequire("1FdfO");

var $bmKPg = parcelRequire("bmKPg");

var $dP3YV = parcelRequire("dP3YV");

var $4UYVJ = parcelRequire("4UYVJ");

var $3FFtj = parcelRequire("3FFtj");

var $5umL8 = parcelRequire("5umL8");
const $685662c334a07302$export$95e0028b61fb2a1a = ({ projectKey: projectKey, currentCategory: currentCategory, onGroupDataRefresh: onGroupDataRefresh })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [filteredGroups, isLoading, error] = (0, $4UYVJ.useFilteredCategorizedQueueGroups)(projectKey, currentCategory);
    const [queueIdFromPath] = (0, $bmKPg.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $dP3YV.useSelectedNavLocation)(queueIdFromPath || '');
    const isInvalidSelectedNavLocation = queueIdFromPath && selectedNavLocation.section === undefined;
    const ExpandableGroups = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredGroups.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
                key: group.group.id,
                isDefaultExpanded: selectedNavLocation?.groupId === group.group.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), null, group.group.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FFtj.QueueList), {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues,
                section: (0, $5Srj8.QueueListSection).PRIORITY_GROUP,
                projectKey: projectKey,
                priorityGroupId: group.group.id
            }))))), [
        filteredGroups,
        projectKey,
        selectedNavLocation?.groupId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $jcw0u.default)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            meta: {
                id: 'jsmQueueGroupsError',
                packageName: 'jiraServicedeskQueuesNav4',
                teamName: 'jsd-shield'
            }
        });
        else if (filteredGroups && !isLoading && filteredGroups.length > 0) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueGroups rendered', {
            projectKey: projectKey,
            groupSize: filteredGroups.length,
            category: currentCategory,
            packageName: 'jiraServicedeskQueuesNav4',
            teamName: 'jsd-shield'
        });
    }, [
        createAnalyticsEvent,
        currentCategory,
        error,
        filteredGroups,
        isLoading,
        projectKey
    ]);
    // Render loading state
    if (isLoading || isInvalidSelectedNavLocation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), {
        count: 2
    });
    // Render error state
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.100"
    }, formatMessage((0, $5umL8.messages).fetchPriorityGroupError, {
        button: (buttonLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                spacing: "none",
                appearance: "link",
                onClick: onGroupDataRefresh
            }, buttonLabel)
    })));
    return ExpandableGroups;
};

});
parcelRegister("5umL8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $249c465782f4ff3f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $249c465782f4ff3f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fetchPriorityGroupError: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-groups.fetch-priority-group-error",
        "defaultMessage": "We're unable to load data in the priority group, <button>try again.</button>"
    }
});

});


parcelRegister("2uMQ2", function(module, exports) {

$parcel$export(module.exports, "StarredSection", () => $37558d378012ad3f$export$e5f8d87968088916);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5MhuD = parcelRequire("5MhuD");

var $5Srj8 = parcelRequire("5Srj8");

var $jF62O = parcelRequire("jF62O");

var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $bmKPg = parcelRequire("bmKPg");

var $dB1lV = parcelRequire("dB1lV");

var $dP3YV = parcelRequire("dP3YV");

var $3FFtj = parcelRequire("3FFtj");

var $b74Te = parcelRequire("b74Te");
const $37558d378012ad3f$export$e5f8d87968088916 = ({ practice: practice, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const popoutConfig = (0, $dB1lV.usePopoutConfig)(projectKey, practice);
    const [queues] = (0, $jF62O.useFavouriteNavItems)('', projectKey, practice, queueCustomContext);
    const [queueIdFromPath] = (0, $bmKPg.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $dP3YV.useSelectedNavLocation)(queueIdFromPath || '');
    if (!queues || queues.length === 0) return null;
    if (popoutConfig.isPoppedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        isDefaultExpanded: selectedNavLocation.section === (0, $5Srj8.QueueListSection).STARRED
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), null, formatMessage((0, $b74Te.messages).starredHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FFtj.QueueList), {
        queues: queues,
        section: (0, $5Srj8.QueueListSection).STARRED,
        projectKey: projectKey
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, formatMessage((0, $b74Te.messages).starredHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FFtj.QueueList), {
        queues: queues,
        section: (0, $5Srj8.QueueListSection).STARRED,
        projectKey: projectKey
    }));
};

});
parcelRegister("b74Te", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7691e490ed477ad0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7691e490ed477ad0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starredHeader: {
        "id": "servicedesk-queues-nav4.common.practice-queues.starred-section.starred-header",
        "defaultMessage": "Starred"
    }
});

});



parcelRegister("h0hkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a1f9d3fba6cb37b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8a1f9d3fba6cb37b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightHeading: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-heading",
        "defaultMessage": "Work on queues your way"
    },
    spotlightMessage: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-message",
        "defaultMessage": "Choose to work on queues from your main navigation, or pop out queues to keep focused."
    },
    spotlightDismissButtonLabel: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-dismiss-button-label",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("7VuRN", function(module, exports) {

$parcel$export(module.exports, "BoardPromoSpotlight", () => $bc80cdb26d990449$export$106c1938e1a88514);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $jYojg = parcelRequire("jYojg");
const $bc80cdb26d990449$var$BoardPromoSpotlightWithDelay = ()=>{
    const [shouldShowBoardPromoSpotlight, setShouldShowBoardPromoSpotlight] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setShouldShowBoardPromoSpotlight(true);
        }, 2000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return shouldShowBoardPromoSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jYojg.default), null);
};
const $bc80cdb26d990449$export$106c1938e1a88514 = ()=>{
    const emptyFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-servicedesk-queues-board-promotion-spotlight",
        packageName: "jiraServicedeskQueuesAgentView",
        teamName: "jsd-shield",
        fallback: emptyFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc80cdb26d990449$var$BoardPromoSpotlightWithDelay, null));
};

});
parcelRegister("jYojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f76c040025538ef5$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $a5xpi = parcelRequire("a5xpi");

var $1dytg = parcelRequire("1dytg");
const $f76c040025538ef5$var$mapStateToProps = (state)=>({
        isAdmin: (0, $a5xpi.getAppProps)(state).isAdmin || (0, $a5xpi.getAppProps)(state).isJiraAdmin,
        projectKey: (0, $a5xpi.getAppProps)(state).projectKey
    });
var $f76c040025538ef5$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f76c040025538ef5$var$mapStateToProps, {})((0, $1dytg.BoardPromoSpotlightView));

});
parcelRegister("1dytg", function(module, exports) {

$parcel$export(module.exports, "BoardPromoSpotlightView", () => $636f5535cbc37733$export$2b6106a2ccad4bf5);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fqbGj = parcelRequire("fqbGj");

var $k5uoT = parcelRequire("k5uoT");

var $eGLgs = parcelRequire("eGLgs");

var $4R6GH = parcelRequire("4R6GH");

var $7cESw = parcelRequire("7cESw");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gq0sA = parcelRequire("gq0sA");

var $ajlSd = parcelRequire("ajlSd");

var $lVJAU = parcelRequire("lVJAU");

var $g8MEz = parcelRequire("g8MEz");

var $57sG4 = parcelRequire("57sG4");

var $8OmrJ = parcelRequire("8OmrJ");
const $636f5535cbc37733$var$QUEUES_ADMIN_MESSAGE_ID = 'jira-jsm-boards-promotion-admin';
const $636f5535cbc37733$var$QUEUES_AGENT_MESSAGE_ID = 'jira-jsm-boards-promotion-agent';
const $636f5535cbc37733$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $636f5535cbc37733$var$BoardSpotlightShowDecider = ({ stop: stop, isAdmin: isAdmin, projectKey: projectKey, renderSpotlightCard: renderSpotlightCard })=>{
    const { shouldRenderBoardPromotion: shouldRenderBoardPromotion } = (0, $57sG4.useBoardPromotion)(isAdmin, projectKey);
    return shouldRenderBoardPromotion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: isAdmin ? $636f5535cbc37733$var$QUEUES_ADMIN_MESSAGE_ID : $636f5535cbc37733$var$QUEUES_AGENT_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($636f5535cbc37733$export$83d026e3dd5706d, {
        stop: stop
    }, renderSpotlightCard)) : null;
};
const $636f5535cbc37733$export$2b6106a2ccad4bf5 = ({ isAdmin: isAdmin, projectKey: projectKey })=>{
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(true);
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    const renderSpotlightCard = (stop)=>{
        const onDismissOnboarding = ()=>{
            stop?.();
            setShowSpotlight(false);
        };
        const handleEnableBoard = ()=>{
            if (projectKey) {
                const enableBoardsUrl = `/jira/servicedesk/projects/${projectKey}/settings/itsm-features?queues-board-promotion=true`;
                push(enableBoardsUrl);
                onDismissOnboarding();
            }
        };
        const handleLearnMore = ()=>{
            onDismissOnboarding(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open('https://support.atlassian.com/jira-service-management-cloud/docs/manage-your-work-using-a-board/', '_blank', 'noreferrer');
        };
        const renderNudge = ()=>{
            const SpotlightRef = (0, $ajlSd.createOnboardingSpotlight)({
                actions: [
                    isAdmin ? {
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAdminActivationSpotlightDismiss', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            onDismissOnboarding();
                        },
                        content: formatMessage((0, $8OmrJ.default).dismiss),
                        appearance: 'subtle'
                    } : {
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAgentActivationSpotlightLearnMore', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            handleLearnMore();
                        },
                        content: formatMessage((0, $8OmrJ.default).learnMore),
                        appearance: 'subtle'
                    },
                    isAdmin ? {
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAdminActivationSpotlightActivate', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            handleEnableBoard();
                        },
                        content: formatMessage((0, $8OmrJ.default).enable),
                        appearance: 'primary'
                    } : {
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAgentActivationSpotlightOk', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            onDismissOnboarding();
                        },
                        content: formatMessage((0, $8OmrJ.default).ok),
                        appearance: 'primary'
                    }
                ],
                contentMessage: isAdmin ? formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $8OmrJ.default).adminDescriptionIssueTermRefresh : (0, $8OmrJ.default).adminDescription) : formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $8OmrJ.default).agentDescriptionIssueTermRefresh : (0, $8OmrJ.default).agentDescription),
                image: (0, $4R6GH.fg)('jsm_queues_consolidate_jfe_assets') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7cESw.default), {
                    alt: "",
                    width: "320"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($g8MEz))),
                    alt: "",
                    width: "320"
                }),
                headingMessage: formatMessage((0, $8OmrJ.default).heading)
            });
            // eslint-disable-next-line react/no-unstable-nested-components
            return /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                    "aria-label": "promotion",
                    ref: ref
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightRef, null)));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($636f5535cbc37733$var$ModalWrapperStyles, {
            "aria-label": "promotion"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: `board${isAdmin ? 'Admin' : 'Agent'}ActivationSpotlight`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqbGj.NudgeSpotlight), {
            setHidden: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            hidden: !showSpotlight,
            spotlightCard: renderNudge(),
            position: "bottom-end",
            zIndex: (0, $k5uoT.layers).spotlight(),
            hideSpotlightCardOnOutsideClick: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                messageId: isAdmin ? $636f5535cbc37733$var$QUEUES_ADMIN_MESSAGE_ID : $636f5535cbc37733$var$QUEUES_AGENT_MESSAGE_ID,
                name: `board${isAdmin ? 'Admin' : 'Agent'}ActivationSpotlight`,
                projectId: projectId,
                projectType: projectType
            }
        })));
    };
    return showSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($636f5535cbc37733$var$BoardSpotlightShowDecider, {
        isAdmin: isAdmin,
        projectKey: projectKey,
        renderSpotlightCard: renderSpotlightCard
    }) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $636f5535cbc37733$var$ModalWrapperStyles = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _94n5xy5q _1xi2oahv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7cESw", function(module, exports) {

$parcel$export(module.exports, "default", () => $588fd0dd124f2b5c$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $hoVxy = parcelRequire("hoVxy");
const $588fd0dd124f2b5c$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hoVxy)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hoVxy))
});
var $588fd0dd124f2b5c$export$2e2bcd8739ae039 = $588fd0dd124f2b5c$var$Illustration;
const $588fd0dd124f2b5c$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    308
];

});
parcelRegister("hoVxy", function(module, exports) {
module.exports = new URL("board.5d5e74e6.png", import.meta.url).toString();

});


parcelRegister("g8MEz", function(module, exports) {
module.exports = new URL("boards.5d5e74e6.png", import.meta.url).toString();

});

parcelRegister("57sG4", function(module, exports) {

$parcel$export(module.exports, "useBoardPromotion", () => $51b21a9204db516f$export$4d6b304f2ae1fcc0);

var $5uXOq = parcelRequire("5uXOq");

var $b2XdI = parcelRequire("b2XdI");

var $7JXF8 = parcelRequire("7JXF8");
const $51b21a9204db516f$export$4d6b304f2ae1fcc0 = (isAdmin, projectKey)=>{
    const [doesHaveSharedObjectsPermissionEnabled, setDoesHaveSharedObjectsPermissionEnabled] = (0, $5uXOq.useState)();
    const [issueCount, setIssueCount] = (0, $5uXOq.useState)();
    const { data: features } = (0, $b2XdI.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (isAdmin !== undefined && projectKey) {
            (0, $7JXF8.getCreateSharedObjectsPermission)().then((data)=>{
                setDoesHaveSharedObjectsPermissionEnabled(data);
            });
            (0, $7JXF8.getBoardIssueCount)(projectKey).then((data)=>{
                setIssueCount(data);
            });
        }
    }, [
        isAdmin,
        projectKey
    ]);
    const shouldRenderBoardPromotion = (0, $5uXOq.useMemo)(()=>{
        if (features && doesHaveSharedObjectsPermissionEnabled && issueCount !== undefined) {
            const isWithinMaxIssueCountLimit = issueCount < 4000;
            const hasEnabledBoards = $51b21a9204db516f$var$hasUserEnabledBoardsFeature(features);
            if (isAdmin) {
                const permissionEnabled = doesHaveSharedObjectsPermissionEnabled !== undefined && doesHaveSharedObjectsPermissionEnabled === true;
                return isWithinMaxIssueCountLimit && permissionEnabled && !hasEnabledBoards;
            }
            // agent
            return isWithinMaxIssueCountLimit && !hasEnabledBoards;
        }
        return false;
    }, [
        features,
        doesHaveSharedObjectsPermissionEnabled,
        isAdmin,
        issueCount
    ]);
    return {
        shouldRenderBoardPromotion: shouldRenderBoardPromotion
    };
};
const $51b21a9204db516f$var$hasUserEnabledBoardsFeature = (features)=>{
    if (features) return features['jsm-board']?.status === 'ENABLED';
    return false;
};

});
parcelRegister("b2XdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b693b7ac6b5692db$export$2e2bcd8739ae039);

var $6sNnq = parcelRequire("6sNnq");

var $2YP9W = parcelRequire("2YP9W");
const $b693b7ac6b5692db$var$useServiceProjectFeatures = ()=>(0, $2YP9W.useResource)((0, $6sNnq.featuresResource));
var $b693b7ac6b5692db$export$2e2bcd8739ae039 = $b693b7ac6b5692db$var$useServiceProjectFeatures;

});

parcelRegister("7JXF8", function(module, exports) {

$parcel$export(module.exports, "getCreateSharedObjectsPermission", () => $2da0845992e9ee42$export$c96038ddeaebae69);
$parcel$export(module.exports, "getBoardIssueCount", () => $2da0845992e9ee42$export$6d2f1fdc3632246);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $2da0845992e9ee42$export$cb6b2d808818e009 = new (0, $duUGa.UFOExperience)('jsm-board-promotion-get-issue-count', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
const $2da0845992e9ee42$var$PERMISSION_BASE_URL = '/rest/api/3/mypermissions';
const $2da0845992e9ee42$var$CREATE_SHARED_OBJECTS_PERMISSION_PARAM = 'permissions=CREATE_SHARED_OBJECTS';
const $2da0845992e9ee42$export$c96038ddeaebae69 = async ()=>{
    try {
        const myPermission = await (0, $eusud.performGetRequest)(`${$2da0845992e9ee42$var$PERMISSION_BASE_URL}?${$2da0845992e9ee42$var$CREATE_SHARED_OBJECTS_PERMISSION_PARAM}`);
        return myPermission?.permissions?.CREATE_SHARED_OBJECTS?.havePermission;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('queues-agent-view.services.board-promotion.getCreateSharedObjectsPermission', 'Unable to fetch create shared objects permission', error);
        return undefined;
    }
};
const $2da0845992e9ee42$export$6d2f1fdc3632246 = async (projectKey)=>{
    const issueCountBaseUrl = '/rest/api/2/search';
    const jqlParam = encodeURIComponent(`project=${projectKey} and status != Resolved or (status = Resolved and updated >= 1d) ORDER BY Rank ASC`);
    const url = `${issueCountBaseUrl}?jql=${jqlParam}&maxResults=0&fields=id&LIMIT=4001`;
    try {
        $2da0845992e9ee42$export$cb6b2d808818e009.start();
        const issueCount = await (0, $eusud.performGetRequest)(url);
        $2da0845992e9ee42$export$cb6b2d808818e009.success();
        return issueCount?.total;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $2da0845992e9ee42$export$cb6b2d808818e009.failure();
        (0, $dJl1T.default).safeErrorWithoutCustomerData('queues-agent-view.services.board-promotion.getBoardIssueCount', `Unable to fetch jql for unresolved issues in project ${projectKey}`, error);
        return undefined;
    }
};

});


parcelRegister("8OmrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c456c9f1f8608511$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c456c9f1f8608511$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    agentDescription: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.agent-description",
        "defaultMessage": "Get better visibility of the status of your issues. Track the progress of all issues, or use filters to show specific issues. Ask an admin to enable your board."
    },
    adminDescription: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.admin-description",
        "defaultMessage": "Get better visibility of the status of your issues. Track the progress of all issues, or use filters to show specific issues. Enable your board in Features."
    },
    heading: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.heading",
        "defaultMessage": "Visualize your work on a board"
    },
    enable: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.enable",
        "defaultMessage": "Go to Features"
    },
    ok: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.ok",
        "defaultMessage": "OK"
    },
    dismiss: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.dismiss",
        "defaultMessage": "Dismiss"
    },
    learnMore: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.learn-more",
        "defaultMessage": "Learn more"
    },
    agentDescriptionIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.agent-description-issue-term-refresh",
        "defaultMessage": "Get better visibility of the status of your work items. Track the progress of all work items, or use filters to show specific work items. Ask an admin to enable your board."
    },
    adminDescriptionIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.admin-description-issue-term-refresh",
        "defaultMessage": "Get better visibility of the status of your work items. Track the progress of all work items, or use filters to show specific work items. Enable your board in Features."
    }
});

});




parcelRegister("du3jQ", function(module, exports) {

$parcel$export(module.exports, "FilterQueryFailed", () => $59ce0658f0937b48$export$fd20e2768ee7eace);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $4R6GH = parcelRequire("4R6GH");

var $hfT4g = parcelRequire("hfT4g");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $4ptel = parcelRequire("4ptel");

var $2cGP2 = parcelRequire("2cGP2");
const $59ce0658f0937b48$export$fd20e2768ee7eace = ({ onFilterClear: onFilterClear })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $hfT4g.default))({
            imageWidth: 120,
            maxImageWidth: 120,
            maxImageHeight: 160
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ce0658f0937b48$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "servicedesk-queues-agent-view.layout.filter-query-failed.query-failed",
        imageUrl: (0, $4R6GH.fg)('jsm_queues_consolidate_jfe_assets') ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($4ptel))),
        renderImage: (0, $4R6GH.fg)('jsm_queues_consolidate_jfe_assets') ? renderImage : undefined,
        header: formatMessage((0, $2cGP2.default).errorHeader),
        description: formatMessage((0, $2cGP2.default).errorMessage),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            onClick: onFilterClear,
            testId: "servicedesk-queues-agent-view.layout.filter-query-failed.clear-search-button"
        }, formatMessage((0, $2cGP2.default).clearSearch))
    }));
};
const $59ce0658f0937b48$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hfT4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $3698a552de39dca3$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $4oxyh = parcelRequire("4oxyh");
const $3698a552de39dca3$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4oxyh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4oxyh))
});
var $3698a552de39dca3$export$2e2bcd8739ae039 = $3698a552de39dca3$var$Illustration;
const $3698a552de39dca3$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("4oxyh", function(module, exports) {
module.exports = new URL("error-white.e2723ea8.svg", import.meta.url).toString();

});


parcelRegister("4ptel", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("2cGP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea26a6b26bd0746$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4ea26a6b26bd0746$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.error-header",
        "defaultMessage": "We couldn't load your search results"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.error-message",
        "defaultMessage": "Check for typos, or try another search term"
    },
    clearSearch: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.clear-search",
        "defaultMessage": "Clear search"
    }
});

});


parcelRegister("6udCd", function(module, exports) {

$parcel$export(module.exports, "JsmAssetsOnboarding", () => $8177a58eb9eb4d9a$export$2001064adb481776);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jpaiZ = parcelRequire("jpaiZ");

var $eGLgs = parcelRequire("eGLgs");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $d4xRU = parcelRequire("d4xRU");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $aNLeB = parcelRequire("aNLeB");

var $oCMSG = parcelRequire("oCMSG");

var $itmJb = parcelRequire("itmJb");

var $9bzsQ = parcelRequire("9bzsQ");

var $cUNOb = parcelRequire("cUNOb");
const $8177a58eb9eb4d9a$var$OnboardingTrigger = ({ stop: stop = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), category: category, messageId: messageId = 'servicedesk-queues-agent-view.layout.jsm-assets-onboarding.ak-flag', messageType: messageType = 'transactional' })=>{
    const flagId = (0, $5uXOq.useRef)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: isItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    const shouldRender = isItsmProject && (projectContext?.isProjectAdmin || isAdmin);
    const flagMeta = (0, $5uXOq.useMemo)(()=>({
            [(0, $oCMSG.CHANGES)]: {
                title: (0, $cUNOb.default).changeManagementFlagTitle,
                description: (0, $cUNOb.default).changeManagementFlagDescription,
                action: (0, $cUNOb.default).changeManagementFlagActionText,
                actionUrl: `/jira/servicedesk/projects/${projectContext?.projectKey}/settings/change-management?tab=assets`
            },
            [(0, $oCMSG.INCIDENTS)]: {
                title: (0, $cUNOb.default).incidentManagementFlagTitle,
                description: (0, $cUNOb.default).incidentManagementFlagDescription,
                action: (0, $cUNOb.default).incidentManagementFlagActionText,
                actionUrl: `/jira/servicedesk/projects/${projectContext?.projectKey}/settings/incident-management`
            }
        })[category], [
        category,
        projectContext?.projectKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        stop?.();
    }, [
        stop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRender && flagId.current == null) {
            flagId.current = showFlag({
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
                        ...props,
                        // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
                        id: flagId,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpaiZ))), {
                            label: formatMessage(flagMeta.title),
                            color: "currentColor"
                        }),
                        title: formatMessage(flagMeta.title),
                        description: formatMessage(flagMeta.description),
                        // eslint-disable-next-line jira/react-no-inline-function-prop
                        onDismissed: ()=>{
                            if (flagId.current) dismissFlag(flagId.current);
                        },
                        actions: [
                            {
                                href: projectContext?.projectKey ? flagMeta.actionUrl : '/jira',
                                content: formatMessage(flagMeta.action)
                            }
                        ],
                        messageId: messageId,
                        messageType: messageType
                    })
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/73694
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmAssetsOnboardingFlag rendered', {
                category: category
            });
        }
    }, [
        category,
        createAnalyticsEvent,
        dismissFlag,
        flagMeta,
        formatMessage,
        messageId,
        messageType,
        projectContext?.projectKey,
        shouldRender,
        showFlag
    ]);
    return null;
};
const $8177a58eb9eb4d9a$export$2001064adb481776 = ({ category: category })=>{
    const messageId = (0, $9bzsQ.EP_MESSAGES)[category];
    const messageType = 'engagement';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsm-assets-onboarding",
        packageName: "jiraServicedeskAssetsOnboarding",
        teamName: "jenga",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        fallback: null,
        messageId: messageId,
        messageType: messageType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8177a58eb9eb4d9a$var$OnboardingTrigger, {
        category: category,
        messageId: (0, $4R6GH.fg)('choreographed_jsm_assets_onboarding') ? messageId : undefined,
        messageType: (0, $4R6GH.fg)('choreographed_jsm_assets_onboarding') ? messageType : undefined
    })));
};

});
parcelRegister("9bzsQ", function(module, exports) {

$parcel$export(module.exports, "EP_MESSAGES", () => $f7f4af53080404fd$export$80a3323af595e15b);

var $oCMSG = parcelRequire("oCMSG");
const $f7f4af53080404fd$export$80a3323af595e15b = {
    [(0, $oCMSG.CHANGES)]: 'affected-assets-in-jsm-cm',
    [(0, $oCMSG.INCIDENTS)]: 'affected-assets-in-jsm-im'
};

});

parcelRegister("cUNOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb22f423563fd27a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bb22f423563fd27a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    incidentManagementFlagTitle: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.incident-management-flag-title",
        "defaultMessage": "Add Assets objects to incidents"
    },
    incidentManagementFlagDescription: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.incident-management-flag-description",
        "defaultMessage": "Link Assets objects with incidents and gain better insight on your IT infrastructure."
    },
    incidentManagementFlagActionText: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.incident-management-flag-action-text",
        "defaultMessage": "View incident management settings "
    },
    changeManagementFlagTitle: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.change-management-flag-title",
        "defaultMessage": "Add Assets objects to changes"
    },
    changeManagementFlagDescription: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.change-management-flag-description",
        "defaultMessage": "Link Assets objects with changes and gain better insight on your IT infrastructure."
    },
    changeManagementFlagActionText: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.change-management-flag-action-text",
        "defaultMessage": "View change management settings "
    }
});

});


parcelRegister("en9hF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd06ae31b4e31af3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bd06ae31b4e31af3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openIssueInSidebar: {
        "id": "servicedesk.queues.agent-view.layout.open-issue-in-sidebar",
        "defaultMessage": "Open issue in sidebar"
    },
    openIssueInSidebarIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.open-issue-in-sidebar-issue-term-refresh",
        "defaultMessage": "Open work item in sidebar"
    }
});

});

parcelRegister("3Sb7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $070b6d913b7e176a$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $4uvJ3 = parcelRequire("4uvJ3");

var $jeVA9 = parcelRequire("jeVA9");

var $8wfz7 = parcelRequire("8wfz7");

var $31Wuc = parcelRequire("31Wuc");

var $iHgSn = parcelRequire("iHgSn");
const $070b6d913b7e176a$var$mapStateToProps = (state)=>({
        IssueCount: $8wfz7.default,
        IssueSearch: $31Wuc.default,
        isQueuesErrorHeaderDisplayed: (0, $jeVA9.isQueuesErrorHeaderDisplayed)(state)
    });
const $070b6d913b7e176a$var$mapDispatchToProps = {
    renderDisplayError: (0, $4uvJ3.displayQueuesErrorHeaderAction)
};
var $070b6d913b7e176a$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($070b6d913b7e176a$var$mapStateToProps, $070b6d913b7e176a$var$mapDispatchToProps)((0, $iHgSn.default));

});
parcelRegister("8wfz7", function(module, exports) {

$parcel$export(module.exports, "default", () => $63da15974b530257$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");


var $fnQyW = parcelRequire("fnQyW");

var $bzBCj = parcelRequire("bzBCj");

var $hYrcT = parcelRequire("hYrcT");

var $lHf6h = parcelRequire("lHf6h");

var $jeVA9 = parcelRequire("jeVA9");

var $3tNVD = parcelRequire("3tNVD");
const $63da15974b530257$var$mapDispatchToProps = (dispatch)=>({
        onFilterReloadClick: ()=>{
            dispatch((0, $fnQyW.isNewFilterQueryPendingAction)(true));
            dispatch((0, $bzBCj.loadIssuesAction)(0, (0, $36dd7e3255fc2bff$export$be4c1ea173a5271a)));
        }
    });
const $63da15974b530257$var$mapStateToProps = (state)=>({
        issueCount: (0, $lHf6h.getIssueCount)(state),
        isCurrentDataFiltered: (0, $hYrcT.getIsCurrentDataFiltered)(state),
        isLoadingIssues: (0, $jeVA9.isLoadingIssues)(state)
    });
var $63da15974b530257$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($63da15974b530257$var$mapStateToProps, $63da15974b530257$var$mapDispatchToProps)((0, $3tNVD.default));

});
parcelRegister("3tNVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ff2cac31bd9bc1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $jOrGg = parcelRequire("jOrGg");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $fNobW = parcelRequire("fNobW");

var $1wbtX = parcelRequire("1wbtX");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $8rTtw = parcelRequire("8rTtw");
const $c8ff2cac31bd9bc1$export$542fba90cc9c1bd1 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { issueCount: issueCount, isCurrentDataFiltered: isCurrentDataFiltered, isLoadingIssues: isLoadingIssues, onFilterReloadClick: onFilterReloadClick } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleReloadClick = ()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering reloaded');
        onFilterReloadClick();
    };
    if (!isCurrentDataFiltered && issueCount !== 0 && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8ff2cac31bd9bc1$export$e6dfd72ab29f8598, null, formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $8rTtw.default).numberOfIssuesIssueTermRefresh : (0, $8rTtw.default).numberOfIssues, {
        issueCount: issueCount
    }));
    if (isCurrentDataFiltered && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8ff2cac31bd9bc1$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8ff2cac31bd9bc1$var$Layout, null, formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $8rTtw.default).numberOfFilteredIssuesIssueTermRefresh : (0, $8rTtw.default).numberOfFilteredIssues, {
        filteredIssueCount: issueCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c8ff2cac31bd9bc1$var$spacerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: formatMessage((0, $8rTtw.default).refreshResults)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": formatMessage((0, $8rTtw.default).refreshResults),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
            label: formatMessage((0, $8rTtw.default).refreshResults),
            LEGACY_size: "small"
        }),
        "data-testId": "servicedesk-queues-agent-view.layout.queues-details.issue-count.reload-button",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleReloadClick
    }))));
    const skeleton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        height: "24px",
        width: "100px",
        "data-testid": "servicedesk-queues-agent-view.layout.queues-details.issue-count.skeleton"
    });
    if ((0, $4R6GH.fg)('add_ufo_load_hold_to_custom_queue')) return isLoadingIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8ff2cac31bd9bc1$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "issue-count"
    }, skeleton)) : null;
    return isLoadingIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8ff2cac31bd9bc1$export$e6dfd72ab29f8598, null, skeleton) : null;
};
var $c8ff2cac31bd9bc1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $c8ff2cac31bd9bc1$export$542fba90cc9c1bd1;
const $c8ff2cac31bd9bc1$var$Layout = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c8ff2cac31bd9bc1$var$spacerStyles = (0, $8CUq3.xcss)({
    width: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $c8ff2cac31bd9bc1$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq _19pkutpp _otyr1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8rTtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $17be6383827f89f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $17be6383827f89f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    numberOfIssues: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-issues",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} issue}\n            other {{issueCount, number} issues}\n            }"
    },
    numberOfFilteredIssues: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-filtered-issues",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} issue found}\n            other {{filteredIssueCount, number} issues found}\n            }"
    },
    refreshResults: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.refresh-results",
        "defaultMessage": "Refresh results"
    },
    numberOfIssuesIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-issues-issue-term-refresh",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} work item}\n            other {{issueCount, number} work items}\n            }"
    },
    numberOfFilteredIssuesIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-filtered-issues-issue-term-refresh",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} work item found}\n            other {{filteredIssueCount, number} work items found}\n            }"
    }
});

});



parcelRegister("31Wuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e94e226351b9f798$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $bC2fB = parcelRequire("bC2fB");

var $fnQyW = parcelRequire("fnQyW");

var $hYrcT = parcelRequire("hYrcT");

var $627A7 = parcelRequire("627A7");

var $cRA6z = parcelRequire("cRA6z");
const $e94e226351b9f798$var$mapDispatchToProps = (dispatch)=>({
        onChange: (text)=>{
            dispatch((0, $fnQyW.filterQuerySubmittedAction)(text));
        },
        onChangedIsPendingSubmission: (loading)=>dispatch((0, $fnQyW.isNewFilterQueryPendingAction)(loading)),
        onFocusChange: (isFocused)=>dispatch((0, $fnQyW.isFilterFocusedAction)(isFocused))
    });
const $e94e226351b9f798$var$mapStateToProps = (state)=>({
        queueId: (0, $627A7.getQueueId)(state),
        filterQuery: (0, $hYrcT.getCurrentFilterQuery)(state)
    });
var $e94e226351b9f798$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($e94e226351b9f798$var$mapStateToProps, $e94e226351b9f798$var$mapDispatchToProps)((0, $cRA6z.default));

});
parcelRegister("cRA6z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f322b69db8729757$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $ip0rq = parcelRequire("ip0rq");

var $gMMNe = parcelRequire("gMMNe");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $dAfqg = parcelRequire("dAfqg");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $032ey = parcelRequire("032ey");

var $3MTzy = parcelRequire("3MTzy");

var $iToAZ = parcelRequire("iToAZ");

var $8tT2Y = parcelRequire("8tT2Y");
const $f322b69db8729757$var$TextFieldWidth = 240;
const $f322b69db8729757$var$createJQLClause = (text)=>`summary ~ "${text}*" OR description ~ "${text}*"`;
const $f322b69db8729757$var$JQLBuilderIssueSearchView = ({ onChange: onChange, onChangedIsPendingSubmission: onChangedIsPendingSubmission, onFocusChange: onFocusChange })=>{
    const irremovableFilters = (0, $iToAZ.useQueuesFilters)({
        isSimplified: (0, $dAfqg.useIsSimplifiedProject)()
    });
    const hasIrremovableFilters = (irremovableFilters || []).length > 0;
    const projectKey = (0, $dAfqg.useProjectContext)().data?.projectKey;
    (0, $5uXOq.useEffect)(()=>()=>{
            onFocusChange(false);
        }, [
        onFocusChange
    ]); // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
        onChange(query);
        onChangedIsPendingSubmission(true);
    }, 500), [
        onChange
    ]);
    const handleSearchChange = (jql)=>{
        debouncedSearch(jql);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3MTzy.default), {
        query: "",
        userPreferencesData: null,
        analyticsSource: "servicedesk-queues",
        excludedFields: [
            'project'
        ],
        searchModes: [
            (0, $032ey.SEARCH_MODE_BASIC)
        ],
        onUpdate: handleSearchChange,
        ...hasIrremovableFilters ? {
            basicModeVisibleFields: irremovableFilters
        } : {},
        ...projectKey ? {
            projectKeys: [
                projectKey
            ]
        } : {}
    });
};
const $f322b69db8729757$var$OldIssueSearchView = ({ onChange: onChange, onChangedIsPendingSubmission: onChangedIsPendingSubmission, onFocusChange: onFocusChange, queueId: queueId, filterQuery: filterQuery })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { placeholder: placeholder, placeholderIssueTermRefresh: placeholderIssueTermRefresh } = (0, $8tT2Y.default);
    const [value, setValue] = (0, $5uXOq.useState)('');
    const [isIconHovered, setHovered] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setValue('');
    }, [
        queueId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (filterQuery === null) setValue('');
    }, [
        filterQuery
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            onFocusChange(false);
        }, [
        onFocusChange
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
        const filterJQL = query === '' ? null : $f322b69db8729757$var$createJQLClause(query);
        onChange(filterJQL);
        onChangedIsPendingSubmission(true);
    }, 2000), [
        onChange
    ]); // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    const handleSearchChange = (event)=>{
        setValue(event.target.value);
        debouncedSearch(event.target.value);
    };
    const onFocusHandle = ()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering clicked');
        onFocusChange(true);
    };
    const onBlurHandle = ()=>onFocusChange(false);
    const onMouseEnterButton = (0, $5uXOq.useCallback)(()=>setHovered(true), []);
    const onMouseLeaveButton = (0, $5uXOq.useCallback)(()=>setHovered(false), []);
    const clearSearch = ()=>{
        setValue('');
        onChange(null);
        onChangedIsPendingSubmission(true);
    };
    const isSsrContent = (0, $4R6GH.fg)('issuelist_ssr_disable_issue_search_box') && false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f322b69db8729757$var$MinWidthWrapper, {
        isDisabled: isSsrContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isReadOnly: isSsrContent,
        isCompact: true,
        width: $f322b69db8729757$var$TextFieldWidth,
        placeholder: (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage(placeholderIssueTermRefresh) : formatMessage(placeholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gMMNe))), {
            spacing: "spacious",
            label: ""
        }),
        onChange: handleSearchChange,
        value: value,
        onFocus: onFocusHandle,
        onBlur: onBlurHandle,
        elemAfterInput: value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $8tT2Y.default).clearSearch)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f322b69db8729757$var$ClearSearchWrapper, {
            onClick: clearSearch,
            onMouseEnter: onMouseEnterButton,
            onMouseLeave: onMouseLeaveButton,
            "data-testid": "servicedesk-queues-agent-view.layout.queues-details.issue-search.clear-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
            color: isIconHovered ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-disabled, #091E424F)",
            label: formatMessage((0, $8tT2Y.default).clearSearch),
            spacing: "none"
        })))
    }));
};
var $f322b69db8729757$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $cSD7y.componentWithFG)('corcap-2944-add-jqlbuilder-to-jsm-queues', $f322b69db8729757$var$JQLBuilderIssueSearchView, $f322b69db8729757$var$OldIssueSearchView);
const $f322b69db8729757$var$ClearSearchWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _80omtlke _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); /*
     * these styles are used for accommodating smaller screen sizes with the introduction of the split filters
     *
     * the min-width is needed to prevent the text area from shrinking to 0 size
     * the flex-shrink is used to give width priority to the active issue types / portal groups filters
     * the text-overflow is used when the text input is shrunken
     */ 
const $f322b69db8729757$var$MinWidthWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh _1ul953f4 _1o9z15gg _509t1l2s",
            __cmplp.isDisabled ? "_80om13gf" : "_80om1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3MTzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $01a540071e754070$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $4p4kl = parcelRequire("4p4kl");

var $kxZPA = parcelRequire("kxZPA");

const $01a540071e754070$var$JQLBuilderAsync = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5C68j")), {
    moduleId: "./src/packages/jql-builder/jql-builder/src/index.tsx"
});
const $01a540071e754070$var$JQLEditorBasicUIAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-jql-builder",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4p4kl.IssueNavigatorJQLBuilderSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($01a540071e754070$var$JQLBuilderAsync, props));
var $01a540071e754070$export$2e2bcd8739ae039 = $01a540071e754070$var$JQLEditorBasicUIAsync;

});
parcelRegister("4p4kl", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorJQLBuilderSkeleton", () => $fb9c2cbb8213ab8c$export$5be82223ddc28851);
/* jql-builder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $ei1nS = parcelRequire("ei1nS");
const $fb9c2cbb8213ab8c$var$customCssStyles = null;
const $fb9c2cbb8213ab8c$var$containerStyles = {
    height: '52px'
};
const $fb9c2cbb8213ab8c$export$5be82223ddc28851 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ei1nS))),
        containerStyles: $fb9c2cbb8213ab8c$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("hCy6k", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $a2cd0a6153845fd0$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");


var $koVbs = parcelRequire("koVbs");

var $d0Ozr = parcelRequire("d0Ozr");
const $a2cd0a6153845fd0$var$skeletonImageStyles = null;
const $a2cd0a6153845fd0$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2cd0a6153845fd0$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        alt: `${formatMessage((0, $d0Ozr.default).loading)}...`,
        className: (0, $bwpsq.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2cd0a6153845fd0$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d0Ozr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abc81adadf77f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("ei1nS", function(module, exports) {
module.exports = new URL("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg", import.meta.url).toString();

});


parcelRegister("5C68j", function(module, exports) {

let $416542481d59c3b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $416542481d59c3b8$var$load("erMRT").then(()=>parcelRequire('lS41e'));

});


parcelRegister("iToAZ", function(module, exports) {

$parcel$export(module.exports, "useQueuesFilters", () => $42ef8a5ce863bc05$export$e744fcb332e8e0fc);

var $5uXOq = parcelRequire("5uXOq");

var $jYeNO = parcelRequire("jYeNO");

var $30Hlr = parcelRequire("30Hlr");

var $5Dsab = parcelRequire("5Dsab");

var $koVbs = parcelRequire("koVbs");

var $8tT2Y = parcelRequire("8tT2Y");
const $42ef8a5ce863bc05$export$e744fcb332e8e0fc = ({ isSimplified: isSimplified })=>{
    const { data: classicProjectFilters } = (0, $jYeNO.useCalendarFilterResource)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Translate the request type filter, as resource doesnot allow for i18n
    const classicProjectFiltersI18n = classicProjectFilters?.map((item)=>{
        if (typeof item === 'object' && Object.values(item).includes((0, $30Hlr.TARGET_FILTER_TYPE))) return {
            ...item,
            displayName: formatMessage((0, $8tT2Y.default).requestType)
        };
        return item;
    });
    const simplifiedProjectFilters = (0, $5uXOq.useMemo)(()=>[
            {
                ...(0, $5Dsab.TYPE),
                displayName: formatMessage((0, $8tT2Y.default).requestType)
            },
            (0, $5Dsab.STATUS_FIELD_JQL_TERM),
            (0, $5Dsab.ASSIGNEE_FIELD_JQL_TERM)
        ], [
        formatMessage
    ]);
    return isSimplified ? simplifiedProjectFilters : classicProjectFiltersI18n;
};

});
parcelRegister("8tT2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bad8af58b647728$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0bad8af58b647728$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.placeholder",
        "defaultMessage": "Search for issues"
    },
    clearSearch: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.clear-search",
        "defaultMessage": "Clear search"
    },
    placeholderIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.placeholder-issue-term-refresh",
        "defaultMessage": "Search for work items"
    },
    requestType: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.request-type",
        "defaultMessage": "Request type"
    }
});

});




parcelRegister("iHgSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f84aa191777180b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $flhvf = parcelRequire("flhvf");

var $8XCh7 = parcelRequire("8XCh7");
function $f84aa191777180b9$export$2e2bcd8739ae039(props) {
    const [addTopMargin, setAddTopMargin] = (0, $5uXOq.useState)(false);
    const { renderDisplayError: renderDisplayError, IssueCount: IssueCount, IssueSearch: IssueSearch, isQueuesErrorHeaderDisplayed: isQueuesErrorHeaderDisplayed } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleError = (location)=>{
        if (location === 'common.error-boundary.queues-details') setAddTopMargin(true);
        renderDisplayError();
    };
    const handleReload = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    };
    const errorSectionDefaultStyles = (0, $8CUq3.xcss)({
        marginTop: 'space.0'
    });
    const errorMarginTopStyles = (0, $8CUq3.xcss)({
        marginTop: 'space.400'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
        onError: handleError,
        id: "queues-details-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.400",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            errorSectionDefaultStyles,
            addTopMargin && errorMarginTopStyles
        ]
    }, isQueuesErrorHeaderDisplayed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: formatMessage((0, $8XCh7.messages).errorSectionTitle),
        appearance: "error",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            onClick: handleReload
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $8XCh7.messages).reloadPageLinkText))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $8XCh7.messages).errorSectionBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
        onError: renderDisplayError,
        id: "queue-issue-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueSearch, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueCount, null)))));
}

});
parcelRegister("8XCh7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf586c4b9b87e419$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bf586c4b9b87e419$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorSectionTitle: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.error-section-title",
        "defaultMessage": "We currently have an outage"
    },
    errorSectionBody: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.error-section-body",
        "defaultMessage": "We're working hard to resolve temporary glitches with this page. But rest assured, the key functions on this page remain fully operational."
    },
    reloadPageLinkText: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.reload-page-link-text",
        "defaultMessage": "Reload the page"
    }
});

});



parcelRegister("dnw7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $09479f476b7c9383$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $4uvJ3 = parcelRequire("4uvJ3");

var $627A7 = parcelRequire("627A7");

var $3Q2Sf = parcelRequire("3Q2Sf");

var $fsK1c = parcelRequire("fsK1c");
const $09479f476b7c9383$var$mapStateToProps = (state)=>({
        Actions: $3Q2Sf.default,
        queueName: (0, $627A7.getQueueName)(state)
    });
const $09479f476b7c9383$var$mapDispatchToProps = {
    renderDisplayError: (0, $4uvJ3.displayQueuesErrorHeaderAction)
};
var $09479f476b7c9383$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($09479f476b7c9383$var$mapStateToProps, $09479f476b7c9383$var$mapDispatchToProps)((0, $fsK1c.default));

});
parcelRegister("3Q2Sf", function(module, exports) {

$parcel$export(module.exports, "default", () => $946c04432787118f$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $627A7 = parcelRequire("627A7");

var $h4yk3 = parcelRequire("h4yk3");

var $jeVA9 = parcelRequire("jeVA9");

var $flv6P = parcelRequire("flv6P");

var $3DIQl = parcelRequire("3DIQl");

var $OUWkc = parcelRequire("OUWkc");

var $b3aB7 = parcelRequire("b3aB7");

var $3iblU = parcelRequire("3iblU");
const $946c04432787118f$var$mapStateToProps = (state)=>({
        ActionsMenu: $flv6P.default,
        ResetSortingButton: $b3aB7.default,
        FavoriteButton: $3DIQl.default,
        OpenInIssueNavButton: $OUWkc.default,
        canManageQueue: (0, $627A7.canManageQueue)(state),
        isManuallySorted: (0, $h4yk3.isManuallySorted)(state),
        isFavoriteEnabled: !(0, $627A7.isQueueTransient)(state),
        showIssueFailureError: (0, $jeVA9.showIssueFailureError)(state)
    });
var $946c04432787118f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($946c04432787118f$var$mapStateToProps, {})((0, $3iblU.default));

});
parcelRegister("flv6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $df297de4c149f09d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $df297de4c149f09d$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("9FZ2x")), {
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/queues-header/actions/async-actions-menu/actions-menu/index.tsx"
});
const $df297de4c149f09d$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "queues-agent-view-actions-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df297de4c149f09d$var$LoadingComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df297de4c149f09d$var$LazyComponent, props));
var $df297de4c149f09d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $df297de4c149f09d$var$Component;
const $df297de4c149f09d$var$LoadingComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb14no _4t3i1tcg _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9FZ2x", function(module, exports) {

let $70b74aa08144fc80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70b74aa08144fc80$var$load("ifwX8").then(()=>parcelRequire('itvM7'));

});


parcelRegister("3DIQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d3432e1c4b30ef9$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8lxl7 = parcelRequire("8lxl7");

var $bC2fB = parcelRequire("bC2fB");

var $jazcX = parcelRequire("jazcX");

var $627A7 = parcelRequire("627A7");

var $ipNBv = parcelRequire("ipNBv");
const $0d3432e1c4b30ef9$var$mapStateToProps = (state)=>({
        isFavorite: (0, $jazcX.isQueueFavorited)(state),
        queueId: (0, $627A7.getQueueId)(state)
    });
var $0d3432e1c4b30ef9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8lxl7.default)((state)=>({
        attributes: {
            queueId: (0, $627A7.getQueueId)(state),
            isFavorite: !(0, $jazcX.isQueueFavorited)(state)
        }
    })), (0, $bC2fB.connect)($0d3432e1c4b30ef9$var$mapStateToProps, {}))(// @ts-expect-error - Argument of type '({ isFavorite, queueId }: Props) => JSX.Element' is not assignable to parameter of type 'ComponentType<unknown>'.
(0, $ipNBv.default));

});
parcelRegister("ipNBv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed92f677149b5eb$export$2e2bcd8739ae039);
/* eslint-disable jira/react-no-inline-function-prop */ 
var $5uXOq = parcelRequire("5uXOq");

var $hcObS = parcelRequire("hcObS");

var $eXQym = parcelRequire("eXQym");

var $4041n = parcelRequire("4041n");

var $53AcJ = parcelRequire("53AcJ");

var $3HGy4 = parcelRequire("3HGy4");
const $0ed92f677149b5eb$var$FavoriteButton = ({ isFavorite: isFavorite, queueId: queueId })=>{
    const { changeFavorite: changeFavorite, items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const getIsPending = ()=>{
        const queueItemChanges = items[0, $eXQym.QUEUES_ITEM_TYPE];
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const itemChanged = queueItemChanges[(0, $3HGy4.fromQueueIdString)(queueId)];
        return itemChanged ? itemChanged.pending : false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53AcJ.AvailableQueuesConsumer), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
            isFavorite: isFavorite,
            pending: getIsPending(),
            onClick: (analyticsEvent)=>{
                changeFavorite({
                    id: (0, $3HGy4.fromQueueIdString)(queueId),
                    value: !isFavorite,
                    type: (0, $eXQym.QUEUES_ITEM_TYPE)
                }, analyticsEvent);
            }
        }));
};
var $0ed92f677149b5eb$export$2e2bcd8739ae039 = $0ed92f677149b5eb$var$FavoriteButton;

});


parcelRegister("OUWkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee8b8e8186d444d4$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $fy6YG = parcelRequire("fy6YG");

var $627A7 = parcelRequire("627A7");

var $7sQQr = parcelRequire("7sQQr");
const $ee8b8e8186d444d4$var$mapStateToProps = (state)=>({
        projectKey: (0, $fy6YG.getProjectKey)(state),
        queueJql: (0, $627A7.getCompleteJql)(state)
    });
var $ee8b8e8186d444d4$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($ee8b8e8186d444d4$var$mapStateToProps, {})((0, $7sQQr.OpenInIssueNavButton));

});
parcelRegister("7sQQr", function(module, exports) {

$parcel$export(module.exports, "OpenInIssueNavButton", () => $835d6a3f3dd87e4c$export$72e8ee1dd9380293);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7paD5 = parcelRequire("7paD5");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $glSfI = parcelRequire("glSfI");

var $4R6GH = parcelRequire("4R6GH");
const $835d6a3f3dd87e4c$var$getIssueNavUrl = (projectKey, queueJql)=>projectKey ? `/jira/servicedesk/projects/${projectKey}/issues/?jql=${encodeURIComponent(queueJql)}` : `/issues/?jql=${encodeURIComponent(queueJql)}`;
const $835d6a3f3dd87e4c$export$72e8ee1dd9380293 = (_props)=>{
    const { projectKey: projectKey, queueJql: queueJql } = _props;
    const issueNavUrl = $835d6a3f3dd87e4c$var$getIssueNavUrl(projectKey, queueJql);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigateToIssueNavFromQueues', {
            hasProjectKey: typeof projectKey === 'string'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $glSfI.default).openWithIssueNavIssueTermRefresh : (0, $glSfI.default).openWithIssueNav)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "servicedesk-queues-agent-view.layout.queues-header.actions.open-in-issue-nav-button.open-in-issue-nav-button",
        href: issueNavUrl,
        target: "_blank",
        onClick: onClick,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        appearance: "subtle"
    }));
};

});


parcelRegister("b3aB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $205ef70ee1da5e87$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8lxl7 = parcelRequire("8lxl7");

var $iQv12 = parcelRequire("iQv12");

var $bC2fB = parcelRequire("bC2fB");

var $jdGLR = parcelRequire("jdGLR");

var $h4yk3 = parcelRequire("h4yk3");

var $1fsQ5 = parcelRequire("1fsQ5");
var $205ef70ee1da5e87$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onResetSorting: 'resetSorting'
}), (0, $8lxl7.default)((state)=>({
        attributes: {
            fieldId: (0, $h4yk3.getSortedByColumn)(state),
            sortOrder: (0, $h4yk3.getSortOrder)(state)
        }
    })), (0, $bC2fB.connect)(null, {
    onResetSorting: (0, $jdGLR.resetSortOrderAction)
}))((0, $1fsQ5.default));

});
parcelRegister("1fsQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $19284ae7bb53c378$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $8RXs9 = parcelRequire("8RXs9");

var $glSfI = parcelRequire("glSfI");
function $19284ae7bb53c378$export$ce3eb8345b6d11e3(props) {
    const { intl: { formatMessage: formatMessage }, onResetSorting: onResetSorting } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onResetSorting
    }, formatMessage((0, $glSfI.default).resetSorting));
}
var $19284ae7bb53c378$export$2e2bcd8739ae039 = (0, $8RXs9.default)($19284ae7bb53c378$export$ce3eb8345b6d11e3);

});


parcelRegister("3iblU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c840d1ab4c4a9717$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2FOni = parcelRequire("2FOni");

var $4R6GH = parcelRequire("4R6GH");
function $c840d1ab4c4a9717$export$2e2bcd8739ae039({ canManageQueue: canManageQueue, isManuallySorted: isManuallySorted, isFavoriteEnabled: isFavoriteEnabled, onDeleteComplete: onDeleteComplete, showIssueFailureError: showIssueFailureError, ActionsMenu: ActionsMenu, FavoriteButton: FavoriteButton, ResetSortingButton: ResetSortingButton, OpenInIssueNavButton: OpenInIssueNavButton }) {
    const shouldShowResetSortingButton = !showIssueFailureError && !canManageQueue && isManuallySorted;
    const hasMultipleActions = isFavoriteEnabled && (canManageQueue || shouldShowResetSortingButton);
    const shouldHideNotSupportedActions = false && (0, $4R6GH.fg)('remove_load_states_for_smooth_view_queues_ssr');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c840d1ab4c4a9717$var$Wrapper, null, !shouldHideNotSupportedActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FOni.AsyncQueuesAutomationMenu), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OpenInIssueNavButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c840d1ab4c4a9717$var$Spacer, null)), !shouldHideNotSupportedActions && isFavoriteEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteButton, null), !shouldHideNotSupportedActions && hasMultipleActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c840d1ab4c4a9717$var$Spacer, null), !shouldHideNotSupportedActions && canManageQueue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ActionsMenu, {
        onDeleteComplete: onDeleteComplete
    }), !shouldHideNotSupportedActions && shouldShowResetSortingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResetSortingButton, null));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c840d1ab4c4a9717$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c840d1ab4c4a9717$var$Spacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbu2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fsK1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $693dfde1d52d9f72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cS37j = parcelRequire("cS37j");

var $4R6GH = parcelRequire("4R6GH");

var $bS0zk = parcelRequire("bS0zk");

var $flhvf = parcelRequire("flhvf");
function $693dfde1d52d9f72$export$2e2bcd8739ae039(props) {
    const [, setAddTopMargin] = (0, $5uXOq.useState)(false);
    const { queueName: queueName, onDeleteComplete: onDeleteComplete, renderDisplayError: renderDisplayError, Actions: Actions } = props;
    const handleError = (location)=>{
        if (location === 'common.error-boundary.queue-page-header') setAddTopMargin(true);
        renderDisplayError();
    };
    const shouldHideActions = (0, $4R6GH.fg)('remove_load_states_for_smooth_view_queues_ssr') ? false : false && (0, $4R6GH.fg)('issue_list_ssr_hide_top_right_icons');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flhvf.FFErrorBoundary), {
        onError: handleError,
        id: "queue-page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        // hide icons before hydration to disable interactive actions
        actions: shouldHideActions ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Actions, {
            onDeleteComplete: onDeleteComplete
        }),
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bS0zk.default), null)
    }, queueName));
}

});


parcelRegister("4oDrj", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $2e50ec9745c1a416$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9PAwV = parcelRequire("9PAwV");

var $g5X3G = parcelRequire("g5X3G");

var $cyn2E = parcelRequire("cyn2E");

var $kbFbA = parcelRequire("kbFbA");

var $aNOwR = parcelRequire("aNOwR");
const $2e50ec9745c1a416$var$callWhenIdle = (callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.requestIdleCallback(callback);
    else setTimeout(callback, 3000);
};
const $2e50ec9745c1a416$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, parentWidth: parentWidth, setIsResizing: setIsResizing })=>{
    (0, $5uXOq.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        $2e50ec9745c1a416$var$callWhenIdle(()=>{
            (0, $cyn2E.default).preload();
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PAwV.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNOwR.default), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth,
            setIsResizing: setIsResizing
        }, issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e50ec9745c1a416$var$SidebarWrapper, {
            "data-testid": "servicedesk-queues-agent-view.layout.sidebar-issue-app.wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbFbA.SidebarIssueApp), {
            issueKey: (0, $g5X3G.toIssueKey)(issueKey),
            onClose: onClose,
            analyticsSource: analyticsSource,
            onChange: onChange,
            onIssueDeleteSuccess: onIssueDeleteSuccess
        }))));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e50ec9745c1a416$var$SidebarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9PAwV", function(module, exports) {

$parcel$export(module.exports, "JiraDetailPanel", () => $90f8c6fec93ae563$export$93acb63f4e179357);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $34ck9 = parcelRequire("34ck9");

var $b71gk = parcelRequire("b71gk");

var $5e5zm = parcelRequire("5e5zm");
const $90f8c6fec93ae563$var$DetailPanel = ({ children: children, panelWidth: panelWidth })=>{
    const { setWidth: setWidth } = (0, $5e5zm.useDetailPanelActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (panelWidth !== undefined) setWidth(panelWidth);
        return ()=>setWidth(0);
    }, [
        panelWidth,
        setWidth
    ]);
    const throttleSetWidth = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50, {
            leading: true,
            trailing: true
        }), [
        setWidth
    ]);
    return typeof children === 'function' ? children(throttleSetWidth) : children;
};
const $90f8c6fec93ae563$export$93acb63f4e179357 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-detail-panel",
        packageName: "jira-bottom-right-corner-controller",
        render: ()=>typeof props.children === 'function' ? props.children((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))) : props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90f8c6fec93ae563$var$DetailPanel, props));

});

parcelRegister("cyn2E", function(module, exports) {

$parcel$export(module.exports, "default", () => $decb09a56944f3d7$export$2e2bcd8739ae039);

var $kxZPA = parcelRequire("kxZPA");

var // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
$decb09a56944f3d7$export$2e2bcd8739ae039 = (0, $kxZPA.lazy)(()=>(parcelRequire("i8gBA")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

});
parcelRegister("i8gBA", function(module, exports) {

let $d335dacade9f672a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d335dacade9f672a$var$load("kWrFZ"),
    $d335dacade9f672a$var$load("dsiAd"),
    $d335dacade9f672a$var$load("2Lfdl"),
    $d335dacade9f672a$var$load("92sUi"),
    $d335dacade9f672a$var$load("i5RRW"),
    $d335dacade9f672a$var$load("eNmuD"),
    $d335dacade9f672a$var$load("cM9em"),
    $d335dacade9f672a$var$load("fr9NE"),
    $d335dacade9f672a$var$load("hPzOn"),
    $d335dacade9f672a$var$load("h2MrD"),
    $d335dacade9f672a$var$load("bYT2S"),
    $d335dacade9f672a$var$load("cggv6")
]).then(()=>parcelRequire('6qbjz'));

});


parcelRegister("kbFbA", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueApp", () => $40a0cb80947800de$export$e402f7c18d4d7f37);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7eqRV = parcelRequire("7eqRV");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");

var $lb0Dk = parcelRequire("lb0Dk");

var $cyn2E = parcelRequire("cyn2E");
const $40a0cb80947800de$var$PACKAGE_NAME = 'jsmQueueAgentViewSidebar';
const $40a0cb80947800de$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $5uXOq.useState)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        setCurrentIssueKey(issueKey);
    }, [
        issueKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: $40a0cb80947800de$var$PACKAGE_NAME,
        attributes: {
            viewMode: 'SIDEBAR'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: $40a0cb80947800de$var$PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyn2E.default), {
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    }))));
};

});
parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $lb0Dk = parcelRequire("lb0Dk");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("gjEtj", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $c322f875acea1654$export$c3f500e812fb1bb3);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $i2Rm5 = parcelRequire("i2Rm5");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $5uXOq.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});
parcelRegister("gAeCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5368db3a32c0eb20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $x9xyg = parcelRequire("x9xyg");
const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $5uXOq.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $x9xyg.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;

});


parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $hCy6k = parcelRequire("hCy6k");

var $gERis = parcelRequire("gERis");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStyles = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $bf9ca492e3d15685$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gERis))),
        className: (0, $bwpsq.default)([
            "_p12f1ypn _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
        onChange: (state)=>{
            (0, $hhMVP.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("gERis", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});




parcelRegister("aNOwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca58cfb4407beed$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $34ck9 = parcelRequire("34ck9");

var $7D59a = parcelRequire("7D59a");

var $7SRLR = parcelRequire("7SRLR");
const $8ca58cfb4407beed$var$IS_DRAGGING_CLASS_NAME = 'ak-dnd-is-dragging';
const $8ca58cfb4407beed$var$Resizer = ({ parentWidth: parentWidth, children: children, onResize: onResize, setIsResizing: setIsResizing })=>{
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const startX = (0, $5uXOq.useRef)(0);
    const extraWidth = (0, $5uXOq.useRef)(0);
    const onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(()=>{
        const newWidth = Math.max(parentWidth * (0, $7SRLR.getDetailViewWidthRatio)(), (0, $7SRLR.MIN_DETAILS_WIDTH_ISSUE));
        if (newWidth !== width) setWidth(newWidth);
    }, (0, $7SRLR.WINDOW_RESIZE_THROTTLE));
    (0, $5uXOq.useEffect)(()=>{
        setWidth(Math.max(parentWidth * (0, $7SRLR.getDetailViewWidthRatio)(), (0, $7SRLR.MIN_DETAILS_WIDTH_ISSUE)));
    }, [
        parentWidth
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onWindowResize);
        onResize?.(width);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onWindowResize);
        };
    }, [
        onResize,
        onWindowResize,
        width
    ]);
    const onMouseDown = (0, $7D59a.useEvent)((e)=>{
        startX.current = e.clientX + (width - (0, $7SRLR.MIN_DETAILS_WIDTH_ISSUE));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mouseup', onMouseUp);
        setIsResizing(true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.classList.add($8ca58cfb4407beed$var$IS_DRAGGING_CLASS_NAME);
    });
    const onMouseMove = (0, $7D59a.useEvent)((e)=>{
        extraWidth.current = Math.max(startX.current - e.clientX, 0);
        const newWidth = Math.min((0, $7SRLR.MIN_DETAILS_WIDTH_ISSUE) + extraWidth.current, parentWidth / 2);
        if (newWidth !== width) setWidth(newWidth);
    });
    const onMouseUp = (0, $7D59a.useEvent)(()=>{
        startX.current = 0;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mouseup', onMouseUp);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.classList.remove($8ca58cfb4407beed$var$IS_DRAGGING_CLASS_NAME);
        const widthRatio = width === (0, $7SRLR.MIN_DETAILS_WIDTH_ISSUE) ? 0 : width / parentWidth;
        (0, $7SRLR.setDetailViewWidthRatio)(widthRatio);
        setIsResizing(false);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca58cfb4407beed$var$Container, {
        minWidth: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca58cfb4407beed$var$ResizeHandle, {
        onMouseDown: onMouseDown,
        role: "presentation"
    }), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca58cfb4407beed$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_7ypm2r": (0, $lD23V.default)(`${__cmplp.minWidth || 400}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1kdj _1ul9152j _1tke1osq _c71l1osq _18m91wug _1reo15vq _1e0c1txw _2lx2vrvc _4cvr1y6m _bfhkvuon _1pbyb4wl _18u0u2gc _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $8ca58cfb4407beed$var$ResizeHandle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9ftgi _80omuf7j _kqswh2mm _1wpz1fhb _qc5othzt _aetrb3bt _z0aiv77o _1qdgv47k _15l21ssb _clh31i34 _19do1b66 _18postnw _1hfkhloo _gcm1b29m _4tpub29m _1gvg1osq _1kmz1osq",
            __cmplp.className
        ])
    });
});
var $8ca58cfb4407beed$export$2e2bcd8739ae039 = $8ca58cfb4407beed$var$Resizer;

});
parcelRegister("7D59a", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $cc6c832ad15d24e3$export$90fc3a17d93f704c);

var $5uXOq = parcelRequire("5uXOq");
const $cc6c832ad15d24e3$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $5uXOq.useRef)(callback);
    (0, $5uXOq.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $5uXOq.useCallback)((...args)=>callbackRef.current(...args), []);
};

});

parcelRegister("7SRLR", function(module, exports) {

$parcel$export(module.exports, "MIN_DETAILS_WIDTH_ISSUE", () => $16caec3f9a4cacf8$export$b4e0432c87affda2);
$parcel$export(module.exports, "WINDOW_RESIZE_THROTTLE", () => $16caec3f9a4cacf8$export$db1057b88f0c8a04);
$parcel$export(module.exports, "getDetailViewWidthRatio", () => $16caec3f9a4cacf8$export$5a9c556da9744b1b);
$parcel$export(module.exports, "setDetailViewWidthRatio", () => $16caec3f9a4cacf8$export$d194f7c4bdc33538);

var $bSSG7 = parcelRequire("bSSG7");
const $16caec3f9a4cacf8$export$b4e0432c87affda2 = 440;
const $16caec3f9a4cacf8$export$db1057b88f0c8a04 = 350;
const $16caec3f9a4cacf8$var$DETAIL_VIEW_WIDTH_RATIO = 'gh.detailViewWidth';
const $16caec3f9a4cacf8$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jsmqueueagentview');
const $16caec3f9a4cacf8$export$5a9c556da9744b1b = ()=>{
    const value = $16caec3f9a4cacf8$var$localStorage.get($16caec3f9a4cacf8$var$DETAIL_VIEW_WIDTH_RATIO);
    return value ? Number(value) : 0;
};
const $16caec3f9a4cacf8$export$d194f7c4bdc33538 = (ratio)=>$16caec3f9a4cacf8$var$localStorage.set($16caec3f9a4cacf8$var$DETAIL_VIEW_WIDTH_RATIO, ratio);

});






parcelRegister("4S0uJ", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $7307247c9fc02c84$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bAkIV = parcelRequire("bAkIV");
const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page = (0, $bAkIV.default), children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null, children));
var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7307247c9fc02c84$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1jfw _otyridpf _18u01jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bAkIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e769a1b108c1b03$export$2e2bcd8739ae039);

var $cE92Q = parcelRequire("cE92Q");

var $bJcWY = parcelRequire("bJcWY");

var $aZdfU = parcelRequire("aZdfU");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e769a1b108c1b03$export$2e2bcd8739ae039 = (0, $cE92Q.default);

});
parcelRegister("cE92Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4d1a89146de6ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");
function $2f4d1a89146de6ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f4d1a89146de6ed$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $2f4d1a89146de6ed$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $2f4d1a89146de6ed$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $2f4d1a89146de6ed$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $2f4d1a89146de6ed$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $f1WIN.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$pageContentStyles
    }, children)));
};
var $2f4d1a89146de6ed$export$2e2bcd8739ae039 = $2f4d1a89146de6ed$var$Page;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $196a11a7b8c2fbef$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $196a11a7b8c2fbef$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $196a11a7b8c2fbef$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $196a11a7b8c2fbef$export$936829b4511db3e4);
const $196a11a7b8c2fbef$var$defaultGridSize = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$var$defaultGridSize * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$var$defaultGridSize * 5,
    cosy: $196a11a7b8c2fbef$var$defaultGridSize * 2,
    compact: $196a11a7b8c2fbef$var$defaultGridSize * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ephoW.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itnZ9.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92e4fcbfc398e3a4$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $f1WIN.varColumnsNum)}) * ${(0, $f1WIN.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $92e4fcbfc398e3a4$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $f1WIN.varGridSpacing)}))`
});
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $92e4fcbfc398e3a4$var$gridStyles,
            $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varGridSpacing)]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, $f1WIN.varColumnsNum)}))`;
const $11b791725219e059$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, $f1WIN.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $11b791725219e059$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, $f1WIN.varColumnSpan)}) - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $11b791725219e059$var$gridColumnStyles,
            $11b791725219e059$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});




parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1tcYS = parcelRequire("1tcYS");

var $bFU4G = parcelRequire("bFU4G");

var $8Ec39 = parcelRequire("8Ec39");

var $cEm1b = parcelRequire("cEm1b");

var $4R6GH = parcelRequire("4R6GH");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $1tcYS.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $4R6GH.fg)('jfp-magma-concurrent-root-jira-spa') && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $bFU4G.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $4R6GH.fg)('jfp-magma-concurrent-root-jira-spa') && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $4R6GH.fg)('jfp-magma-concurrent-root-jira-spa') && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $bFU4G.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEm1b.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ec39.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("ausru", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b836ce0648ff4e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lkmWu = parcelRequire("lkmWu");

var $34Rrn = parcelRequire("34Rrn");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7CMCs = parcelRequire("7CMCs");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $cNd4s = parcelRequire("cNd4s");

var $cPYJQ = parcelRequire("cPYJQ");
function $36b836ce0648ff4e$var$CipherDeprecationBanner() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jiraQueueViewCipherDeprecationBanner",
        packageName: "jiraSpaAppsServicedeskQueuesAgentView",
        teamName: "jsd-shield"
    }, isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkmWu.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $36b836ce0648ff4e$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
        label: "Warning",
        color: "var(--ds-icon-warning-inverse, #172B4D)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, formatMessage((0, $cPYJQ.default).cipherDeprecationMessage, {
        button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                articleId: "6bSBVhywj4oQDe7rCDr9tT",
                appearance: "subtle-link",
                spacing: "none",
                onClick: (e, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'learnMoreAboutLatestEmailCiphersLink'),
                fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, chunks)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $36b836ce0648ff4e$var$linkTextStyles
            }, chunks))
    })))));
}
const $36b836ce0648ff4e$var$bannerContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    columnGap: 'space.100'
});
const $36b836ce0648ff4e$var$linkTextStyles = (0, $8CUq3.xcss)({
    color: 'color.text.warning.inverse',
    textDecoration: 'underline'
});
var $36b836ce0648ff4e$export$2e2bcd8739ae039 = $36b836ce0648ff4e$var$CipherDeprecationBanner;

});
parcelRegister("cPYJQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae3301e11d5d32c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7ae3301e11d5d32c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cipherDeprecationMessage: {
        "id": "spa-apps-servicedesk-queues-agent-view.content.cipher-deprecation-banner.cipher-deprecation-message",
        "defaultMessage": "Verify that your <button>email server uses the latest ciphers</button> to receive requests and comments from connected email accounts."
    }
});

});



parcelRegister("7DYR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ace41a9f8f324eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1W0cQ = parcelRequire("1W0cQ");

var $l8ruj = parcelRequire("l8ruj");
const $1ace41a9f8f324eb$var$QueuesIssueViewContent = (props)=>{
    const { issueNavigatorData: issueNavigatorData } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "queues-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1W0cQ.default), {
        issueNavigatorData: issueNavigatorData
    }));
};
var $1ace41a9f8f324eb$export$2e2bcd8739ae039 = $1ace41a9f8f324eb$var$QueuesIssueViewContent;

});
parcelRegister("1W0cQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $719e268c3759c45e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");


var $k3PbQ = parcelRequire("k3PbQ");

var $4Eklo = parcelRequire("4Eklo");

var $bYtrC = parcelRequire("bYtrC");

var $9hUca = parcelRequire("9hUca");

var $dd29Z = parcelRequire("dd29Z");

var $l8ruj = parcelRequire("l8ruj");

var $a1E0h = parcelRequire("a1E0h");
let $719e268c3759c45e$var$dispatchExternalAction;
const $719e268c3759c45e$var$getIssueKey = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $4Eklo.parseIssueKey)(window.location.href);
};
const $719e268c3759c45e$var$getPreviousUrl = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const urlParts = window.location.href.split('/');
    return urlParts.slice(0, urlParts.length - 1).join('/');
};
const $719e268c3759c45e$var$queueRoutesPattern = Object.values((0, $dd29Z.QUEUE_ROUTES)).join('|').replace(/\//g, '\\/');
const $719e268c3759c45e$var$QUEUES_URL_REGEX = new RegExp(`.*\\/projects\\/[^/]+\\/(${$719e268c3759c45e$var$queueRoutesPattern})\\/custom\\/.*`);
const $719e268c3759c45e$var$isComingFromQueue = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.match($719e268c3759c45e$var$QUEUES_URL_REGEX);
};
const $719e268c3759c45e$var$REPORTS_URL_REGEX = /.*\/projects\/[^/]+\/reports\/.*/;
const $719e268c3759c45e$var$isComingFromReport = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.match($719e268c3759c45e$var$REPORTS_URL_REGEX);
};
const $719e268c3759c45e$var$isComingFromQueueOrReport = ()=>$719e268c3759c45e$var$isComingFromQueue() || $719e268c3759c45e$var$isComingFromReport();
const $719e268c3759c45e$var$redirectAfterSuccessfulDelete = ()=>()=>{
        (0, $gKZoD.di)(window);
        const issueKey = $719e268c3759c45e$var$getIssueKey();
        const projectKey = (0, $k3PbQ.extractProjectKey)(issueKey);
        let url;
        if ($719e268c3759c45e$var$isComingFromQueueOrReport()) url = $719e268c3759c45e$var$getPreviousUrl();
        else url = `/projects/${projectKey}`;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(url);
    };
(0, $bYtrC.listenToExternalActionFromLegacy)(()=>({
        dispatchExternalAction: $719e268c3759c45e$var$dispatchExternalAction,
        modifiedIssueIssueKey: $719e268c3759c45e$var$getIssueKey()
    }));
const $719e268c3759c45e$var$onDispatchExternalActionRef = (ref)=>{
    if (ref) $719e268c3759c45e$var$dispatchExternalAction = ref;
};
const $719e268c3759c45e$var$getAnalyticsSourceFromUrl = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    if (pathname.includes('section')) return 0, $fcf97b7a09088940$export$7063ee6d0035a982;
    if (pathname.includes('queues')) return 0, $fcf97b7a09088940$export$7063ee6d0035a982;
    return 0, $fcf97b7a09088940$export$5bd5011b6596a0e7;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$719e268c3759c45e$export$2e2bcd8739ae039 = ({ issueNavigatorData: issueNavigatorData } = {})=>{
    (0, $9hUca.markFragmentReady)();
    const issueKey = $719e268c3759c45e$var$getIssueKey();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jsm-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a1E0h.default), {
        backButtonUrl: $719e268c3759c45e$var$isComingFromQueueOrReport() ? $719e268c3759c45e$var$getPreviousUrl() : undefined,
        issueNavigatorData: issueNavigatorData,
        analyticsSource: $719e268c3759c45e$var$getAnalyticsSourceFromUrl(),
        issueKey: issueKey,
        onIssueDeleteSuccess: $719e268c3759c45e$var$redirectAfterSuccessfulDelete(),
        onDispatchExternalActionRef: $719e268c3759c45e$var$onDispatchExternalActionRef
    }));
};

});
parcelRegister("k3PbQ", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $bfdd97e245e93328$export$f1a2e4721b127828);

var $g5X3G = parcelRequire("g5X3G");
const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("4Eklo", function(module, exports) {

$parcel$export(module.exports, "parseIssueKey", () => $91413ecb65c044f0$export$775cba7641fc60e9);

var $g5X3G = parcelRequire("g5X3G");
const $91413ecb65c044f0$export$775cba7641fc60e9 = (href)=>{
    const path = href.split('/').pop();
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    return (0, $g5X3G.toIssueKey)(path.split('?')[0].split('#')[0]);
};

});

parcelRegister("bYtrC", function(module, exports) {

$parcel$export(module.exports, "listenToExternalActionFromLegacy", () => $3ad042b87162e1c7$export$60376d8e2c7d8037);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $3ad042b87162e1c7$export$60376d8e2c7d8037 = (getDispatcherAndModifiedIssue)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        Events.bind('modify-issue-view-via-external-action', (e, payload)=>{
            const { issueKey: issueKey, externalAction: externalAction } = payload;
            const { dispatchExternalAction: dispatchExternalAction, modifiedIssueIssueKey: modifiedIssueIssueKey } = getDispatcherAndModifiedIssue();
            if (issueKey === modifiedIssueIssueKey && externalAction && dispatchExternalAction) dispatchExternalAction(externalAction);
        });
    });
};

});

parcelRegister("9hUca", function(module, exports) {

$parcel$export(module.exports, "markFragmentReady", () => $09e694cdaae84ff1$export$f35671de67f03a2b);
$parcel$export(module.exports, "initialiseMetrics", () => $09e694cdaae84ff1$export$1ac307e078c767d0);
$parcel$export(module.exports, "markIssueStartRendering", () => $09e694cdaae84ff1$export$c039505b02c87616);
$parcel$export(module.exports, "markIssueRender", () => $09e694cdaae84ff1$export$c16cf8a32075f588);
$parcel$export(module.exports, "markIssueLegacyInteractive", () => $09e694cdaae84ff1$export$4d5d547fdbe28097);
$parcel$export(module.exports, "markSPAReadyEndOfCriticalPath", () => $09e694cdaae84ff1$export$a45a77102d75517f);
$parcel$export(module.exports, "markIssueInteractive", () => $09e694cdaae84ff1$export$e57956c4b76a36f);
$parcel$export(module.exports, "markIssueOnPageLoadEvent", () => $09e694cdaae84ff1$export$c30d9392d27ab5a8);
$parcel$export(module.exports, "markStartIssue", () => $09e694cdaae84ff1$export$71cdf78946f275c);
$parcel$export(module.exports, "markIssuePreviewRendered", () => $09e694cdaae84ff1$export$7f5545008a1e5a18);
$parcel$export(module.exports, "setIsInitialRender", () => $09e694cdaae84ff1$export$eedeaa0a5b3bd3d1);
$parcel$export(module.exports, "isFullIssueView", () => $09e694cdaae84ff1$export$db2ef91f6ace96c7);

var $7Jxgt = parcelRequire("7Jxgt");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $gSA3s = parcelRequire("gSA3s");

var $bFU4G = parcelRequire("bFU4G");

var $fDtbf = parcelRequire("fDtbf");

var $x9xyg = parcelRequire("x9xyg");

var $dJl1T = parcelRequire("dJl1T");

var $7N30e = parcelRequire("7N30e");


var $1XsIp = parcelRequire("1XsIp");

var $EKr1h = parcelRequire("EKr1h");

var $72N4j = parcelRequire("72N4j");

var $iAWa3 = parcelRequire("iAWa3");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

var $6y2lk = parcelRequire("6y2lk");

var $Rsnea = parcelRequire("Rsnea");

var $1UioC = parcelRequire("1UioC");

var $jf6us = parcelRequire("jf6us");

var $fdHx2 = parcelRequire("fdHx2");
const $09e694cdaae84ff1$var$LOG_LOCATION = 'issue.metrics';
let $09e694cdaae84ff1$var$state;
const $09e694cdaae84ff1$var$getSsrMark = ()=>{
    const ssrMark = (0, $x9xyg.getMark)((0, $fDtbf.SPA_SSR_RENDERED_MARK));
    if (ssrMark != null) return Math.floor(ssrMark.startTime);
    return null;
};
const $09e694cdaae84ff1$var$setMarkWithError = (markName)=>{
    try {
        (0, $x9xyg.setMark)(markName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($09e694cdaae84ff1$var$LOG_LOCATION, 'Setting performance mark failed', error);
    }
};
const $09e694cdaae84ff1$export$f35671de67f03a2b = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$625e4e4c6eb56930);
};
const $09e694cdaae84ff1$export$1ac307e078c767d0 = (options)=>{
    try {
        const { issueContextActions: issueContextActions, isLoadedWithPage: isLoadedWithPage, isSPA: isSPA, isRecentIssue: isRecentIssue, recentIssuesCount: recentIssuesCount, dataProvider: dataProvider, analyticsSource: analyticsSource, store: store, route: route } = options;
        $09e694cdaae84ff1$var$state = new (0, $jf6us.default)({
            isLoadedWithPage: isLoadedWithPage,
            isSPA: isSPA,
            isRecentIssue: isRecentIssue,
            analyticsSource: analyticsSource,
            recentIssuesCount: recentIssuesCount,
            correlationId: (0, $7Jxgt.v4)(),
            // @ts-expect-error - TS2322 - Type '{ analyticsKey: ApplicationKey | undefined; viewMode: any; issueId: string | undefined; }' is not assignable to type 'MetricsProps'.
            lazyMetricsProps: ()=>(0, $fdHx2.metricsStateSelector)(store.getState()),
            timingDataReporter: ()=>({
                    ...(0, $72N4j.serverTimingSelector)(store.getState()),
                    ...(0, $1XsIp.getFetchIssueNetworkTimes)()
                }),
            issueScaleabilityReporter: (0, $1UioC.issueScaleabilityReporterFactory)(store, issueContextActions),
            dataProvider: dataProvider,
            route: route
        });
        // Marking init of bm3
        (0, $EKr1h.issueViewLoad).mark('metrics_init');
        (0, $EKr1h.issueViewOnPageLoad).mark('metrics_init');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($09e694cdaae84ff1$var$LOG_LOCATION, 'Failed to initialise issue metrics', error);
    }
};
const $09e694cdaae84ff1$export$c039505b02c87616 = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$10082883a7f4ea4d);
    (0, $EKr1h.issueViewLoad).mark($f0ab548eaf57140f$export$10082883a7f4ea4d);
};
const $09e694cdaae84ff1$export$c16cf8a32075f588 = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$7f7b606f70e669e6);
    (0, $EKr1h.issueViewOnPageLoad).mark($f0ab548eaf57140f$export$7f7b606f70e669e6);
};
const $09e694cdaae84ff1$export$4d5d547fdbe28097 = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$b292c195104c50d3);
    (0, $EKr1h.issueViewLoad).mark($f0ab548eaf57140f$export$b292c195104c50d3);
};
const $09e694cdaae84ff1$export$8bc8bca4478fe6d7 = (markTime)=>{
    (0, $EKr1h.issueViewOnPageLoad).mark($f0ab548eaf57140f$export$4d1080224e02ef0b, markTime);
};
const $09e694cdaae84ff1$export$a45a77102d75517f = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$434b58ebadf14df2);
    (0, $EKr1h.issueViewLoad).mark($f0ab548eaf57140f$export$434b58ebadf14df2);
};
const $09e694cdaae84ff1$var$getSharedCustomData = ()=>({
        ...$09e694cdaae84ff1$var$state.getIssueScaleabilityReporter()(),
        ...(0, $Rsnea.getBackendBlockingTime)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueViewLoad: (0, $EKr1h.issueViewLoad)
        }),
        isBentoRecentIssue: $09e694cdaae84ff1$var$state.getIsRecentIssue(),
        bentoRecentIssuesCount: $09e694cdaae84ff1$var$state.getRecentIssuesCount(),
        correlationId: $09e694cdaae84ff1$var$state.getCorrelationId(),
        initialLoadFullPageBundleLoadCount: $09e694cdaae84ff1$var$state.getIsInitial() ? performance.getEntriesByType('resource').filter((x)=>x.name.includes('async-issue-app--full-page')).length : 0
    });
const $09e694cdaae84ff1$export$e57956c4b76a36f = ({ lastTransitionTime: // TODO JIV-14563 Fixup or remove embeddedIssueTTI in BM3 metrics due to broken lastTransitionStartTime
// @ts-expect-error - this has never been wired up correctly, I only just discovered it by adding types for the data that is actually passed through.
lastTransitionTime })=>{
    const isFullIssue = $09e694cdaae84ff1$var$state.getIsFullIssue();
    $09e694cdaae84ff1$var$state.setInteractiveEnd(performance.now());
    if ($09e694cdaae84ff1$var$state) {
        const startTime = lastTransitionTime || $09e694cdaae84ff1$var$state.getStartTime();
        if ($09e694cdaae84ff1$var$state.getIsFullIssue()) (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
        const embeddedCustomData = !isFullIssue ? {
            embeddedIssueFMP: Math.floor($09e694cdaae84ff1$var$state.getFMP()),
            embeddedIssueTTI: Math.floor($09e694cdaae84ff1$var$state.getInteractiveEnd() - startTime),
            analyticsSource: $09e694cdaae84ff1$var$state.getAnalyticsSource(),
            featureFlags: Object.fromEntries((0, $gSA3s.allFeatureFlagsAccessed))
        } : {};
        const perfConfig = {
            stopTime: $09e694cdaae84ff1$var$state.getInteractiveEnd(),
            customData: {
                ...$09e694cdaae84ff1$var$getSharedCustomData(),
                ...embeddedCustomData
            }
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $99gkn.addUFOCustomData)(perfConfig.customData);
        const ufoMetricKey = isFullIssue ? 'issue-view' : 'issue-embed';
        (0, $bFU4G.addApdexToAll)({
            key: ufoMetricKey,
            startTime: isFullIssue ? undefined : (0, $EKr1h.embeddedIssueViewLoad).getData()?.start ?? undefined,
            stopTime: perfConfig.stopTime
        });
        if (isFullIssue) {
            (0, $aOr3t.addBM3TimingsToUFO)((0, $EKr1h.issueViewLoad).getData()?.marks, (0, $EKr1h.issueViewLoad).getData()?.config.timings);
            (0, $iAWa3.afterPaintEmit)(()=>{
                // @ts-expect-error payload type mismatch with optional values
                (0, $EKr1h.issueViewLoad).stop(perfConfig);
            }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $EKr1h.issueViewLoad));
        } else // @ts-expect-error payload type mismatch with optional values
        (0, $EKr1h.issueViewLoad).stop(perfConfig);
        (0, $6y2lk.markUimTtiIssueViewLoaded)();
        if (!isFullIssue) // See markStartIssue for more information.
        {
            if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
        }
    }
};
const $09e694cdaae84ff1$var$getBrowserNavigationMetrics = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0 || !(entries[0] instanceof PerformanceNavigationTiming)) return null;
    const navigation = entries[0];
    return {
        connectEnd: Math.round(navigation.connectEnd),
        connectStart: Math.round(navigation.connectStart),
        domComplete: Math.round(navigation.domComplete),
        domContentLoadedEventEnd: Math.round(navigation.domContentLoadedEventEnd),
        domContentLoadedEventStart: Math.round(navigation.domContentLoadedEventStart),
        domInteractive: Math.round(navigation.domInteractive),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        fetchStart: Math.round(navigation.fetchStart),
        loadEventStart: Math.round(navigation.loadEventStart),
        requestStart: Math.round(navigation.requestStart),
        responseEnd: Math.round(navigation.responseEnd),
        responseStart: Math.round(navigation.responseStart),
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        redirectCount: navigation.redirectCount,
        type: navigation.type
    };
};
const $09e694cdaae84ff1$export$c30d9392d27ab5a8 = ()=>{
    const isFullIssue = $09e694cdaae84ff1$var$state.getIsFullIssue();
    if (!isFullIssue) return;
    if ($09e694cdaae84ff1$var$state) {
        try {
            new PerformanceObserver((entryList)=>{
                entryList.getEntries().forEach((entry)=>$09e694cdaae84ff1$export$8bc8bca4478fe6d7(entry.startTime));
            }).observe({
                type: 'largest-contentful-paint',
                buffered: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        // do nothing
        }
        const customData = {
            ...$09e694cdaae84ff1$var$getSharedCustomData(),
            browserNavigationMetrics: $09e694cdaae84ff1$var$getBrowserNavigationMetrics()
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $EKr1h.issueViewOnPageLoad).stop(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $99gkn.addUFOCustomData)(customData);
    }
};
const $09e694cdaae84ff1$export$71cdf78946f275c = (isFullPage = false)=>{
    (0, $EKr1h.issueViewLoad).start();
    if (!isFullPage) {
        (0, $EKr1h.embeddedIssueViewLoad).start({
            startTime: performance.now()
        });
        /**
		 * All SPA full page loads already start the event delay through the
		 * usePageLoadedSubscriber hook in @atlassian/jira-event-delay-controller.
		 * The embedded views need to start this critical section explicitly here because
		 * there is no equivalent hook that is generically applicable to all experiences.
		 *
		 * The only events that currently leverage the delay mechanism are the automatic
		 * exposure events, so we can avoid the overhead of starting this critical section
		 * if it won't be necessary.
		 */ if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.startLowPriorityEventDelay)();
    }
    if (isFullPage) (0, $EKr1h.issueViewOnPageLoad).start({
        startTime: 0
    });
    (0, $6y2lk.startUimTti)();
};
const $09e694cdaae84ff1$export$7f5545008a1e5a18 = ({ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime })=>{
    const ssrMark = $09e694cdaae84ff1$var$getSsrMark();
    const previewTime = performance.now();
    const startTime = $09e694cdaae84ff1$var$state.getStartTime();
    let fmp = 0;
    if ($09e694cdaae84ff1$var$state.getIsFullIssue()) {
        if (isInitialRender) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        fmp = ssrMark;
        else fmp = previewTime - (lastTransitionStartTime || startTime);
    } else fmp = previewTime - startTime;
    (0, $EKr1h.issueViewLoad).mark($f0ab548eaf57140f$export$62c04f0e896827e3);
    (0, $EKr1h.issueViewOnPageLoad).mark($f0ab548eaf57140f$export$62c04f0e896827e3);
    $09e694cdaae84ff1$var$state.setFMP(fmp);
    $09e694cdaae84ff1$var$state.setPreviewEnd(previewTime);
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$62c04f0e896827e3);
};
const $09e694cdaae84ff1$export$eedeaa0a5b3bd3d1 = (isInitialRender)=>{
    if ($09e694cdaae84ff1$var$state) $09e694cdaae84ff1$var$state.setIsLoadedWithPage(isInitialRender);
};
const $09e694cdaae84ff1$export$db2ef91f6ace96c7 = ()=>$09e694cdaae84ff1$var$state && $09e694cdaae84ff1$var$state.getIsFullIssue();

});
const $f0ab548eaf57140f$export$625e4e4c6eb56930 = 'ISSUE_FRAGMENT_READY_MARK';
const $f0ab548eaf57140f$export$10082883a7f4ea4d = 'ISSUE_START_RENDERING_MARK';
const $f0ab548eaf57140f$export$62c04f0e896827e3 = 'ISSUE_PREVIEW_RENDERED';
const $f0ab548eaf57140f$export$5db08809a3f311ed = 'ISSUE_FETCHED_MARK';
const $f0ab548eaf57140f$export$c21b33196a19ec61 = 'ISSUE_START_FETCHING_DATA';
const $f0ab548eaf57140f$export$e64e32643802b552 = 'ISSUE_READY_FOR_DATA';
const $f0ab548eaf57140f$export$e52cc35f872875f7 = 'ISSUE_DATA_AVAILABLE';
const $f0ab548eaf57140f$export$91b5cb94c32a9b = 'ISSUE_CACHED_CONTENT_LOADED';
const $f0ab548eaf57140f$export$205779a1d31dbc62 = 'ssr.issue.rendered';
const $f0ab548eaf57140f$export$bfb91b09e6b87d3c = 'ISSUE_START_GIRA_FETCH';
const $f0ab548eaf57140f$export$beb8599162403c36 = 'ISSUE_FINISH_GIRA_FETCH';
const $f0ab548eaf57140f$export$3a9e4a905dec520d = 'ISSUE_MOUNTED';
const $f0ab548eaf57140f$export$7f7b606f70e669e6 = 'ISSUE_RENDERED';
const $f0ab548eaf57140f$export$b292c195104c50d3 = 'ISSUE_LEGACY_INTERACTIVE';
const $f0ab548eaf57140f$export$434b58ebadf14df2 = 'ISSUE_SPA_MARKED_READY_END_OF_CRITICAL_PATH';
const $f0ab548eaf57140f$export$4d1080224e02ef0b = 'LCP_CANDIDATE';
const $f0ab548eaf57140f$export$a98a3196940af8fa = 'issueViewCriticalData-agg-suspense';
const $f0ab548eaf57140f$export$7b35970640b1e1c0 = 'issueViewCriticalData-gira-suspense';
const $f0ab548eaf57140f$export$1ea0ab50283b82a8 = 'issueViewCriticalData-redux';

parcelRegister("1XsIp", function(module, exports) {

$parcel$export(module.exports, "clearFetchIssueNetworkTimes", () => $80f3a44fca71778e$export$8d777cefeb6b914e);
$parcel$export(module.exports, "getFetchIssueNetworkTimes", () => $80f3a44fca71778e$export$48cecd0d00931806);

var $7OOGM = parcelRequire("7OOGM");

var $6RCeq = parcelRequire("6RCeq");

var $60SGJ = parcelRequire("60SGJ");
const $80f3a44fca71778e$var$fetchIssueNetworkMarks = [
    (0, $60SGJ.fetchUploadPerf),
    (0, $60SGJ.fetchCommentsPerf),
    (0, $60SGJ.fetchIssuePropertiesPerf),
    (0, $60SGJ.fetchIssueLinkPerf),
    (0, $60SGJ.fetchViewContextPerf),
    (0, $60SGJ.fetchSubtaskTypesPerf),
    (0, $60SGJ.fetchFieldDataPerf),
    (0, $60SGJ.fetchUserAuthPerf)
];
// Data remains the same once called once (for the same issue), so we cache it
// here for future requests for this data due to the calculation wiping the
//  performance marks required to calculate.  It does however need to be reset
// in cases like subtask click throughs when we load a new issue.
let $80f3a44fca71778e$var$fetchIssueNetworkTimes;
const $80f3a44fca71778e$var$calculateFetchIssueNetworkTimes = ()=>{
    const issueNetworkTimes = $80f3a44fca71778e$var$fetchIssueNetworkMarks.reduce((obj, perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        const networkTime = (0, $7OOGM.timeBetweenMarks)(beginMarkName, endMarkName);
        if (networkTime != null && networkTime > 0) {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            const aggregated = {
                ...obj,
                [`${perf.key}_NETWORK`]: networkTime
            };
            // This is vital to clear mark after use.  Or next call will failed to add the mark of same name.
            if ((0, $6RCeq.default).clearMarks) {
                (0, $6RCeq.default).clearMarks(beginMarkName);
                (0, $6RCeq.default).clearMarks(endMarkName);
            }
            return aggregated;
        }
        return obj;
    }, {});
    return issueNetworkTimes;
};
const $80f3a44fca71778e$export$8d777cefeb6b914e = ()=>{
    $80f3a44fca71778e$var$fetchIssueNetworkMarks.forEach((perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        if ((0, $6RCeq.default).clearMarks) {
            (0, $6RCeq.default).clearMarks(beginMarkName);
            (0, $6RCeq.default).clearMarks(endMarkName);
        }
    });
    $80f3a44fca71778e$var$fetchIssueNetworkTimes = null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.ISSUE_DATA_AVAILABLE = null;
};
const $80f3a44fca71778e$export$48cecd0d00931806 = ()=>{
    if (!$80f3a44fca71778e$var$fetchIssueNetworkTimes) $80f3a44fca71778e$var$fetchIssueNetworkTimes = $80f3a44fca71778e$var$calculateFetchIssueNetworkTimes();
    return $80f3a44fca71778e$var$fetchIssueNetworkTimes;
};

});
parcelRegister("7OOGM", function(module, exports) {

$parcel$export(module.exports, "timeBetweenMarks", () => $9a82ffbeaa8b7a7f$export$9c25bf1893ba64c);

var $x9xyg = parcelRequire("x9xyg");
const $9a82ffbeaa8b7a7f$export$9c25bf1893ba64c = (startMarkName, endMarkName)=>{
    const startMark = (0, $x9xyg.getMark)(startMarkName);
    const endMark = (0, $x9xyg.getMark)(endMarkName);
    if (!startMark || !endMark || startMark.startTime > endMark.startTime) return null;
    return endMark.startTime - startMark.startTime;
};

});

parcelRegister("60SGJ", function(module, exports) {

$parcel$export(module.exports, "fetchFieldDataPerf", () => $9e43cd7de2afe373$export$b97d963a8496fa2f);
$parcel$export(module.exports, "fetchCommentsPerf", () => $9e43cd7de2afe373$export$179836a99669cbe7);
$parcel$export(module.exports, "fetchIssueLinkPerf", () => $9e43cd7de2afe373$export$8d0984a0f9f31117);
$parcel$export(module.exports, "fetchSubtaskTypesPerf", () => $9e43cd7de2afe373$export$c1324bd586e9a53a);
$parcel$export(module.exports, "fetchUploadPerf", () => $9e43cd7de2afe373$export$72fcc6cb1cdc70e0);
$parcel$export(module.exports, "fetchUserAuthPerf", () => $9e43cd7de2afe373$export$4052b1eae3373c3b);
$parcel$export(module.exports, "fetchViewContextPerf", () => $9e43cd7de2afe373$export$b4e2588a18d8d980);
$parcel$export(module.exports, "fetchIssuePropertiesPerf", () => $9e43cd7de2afe373$export$2ee73dd298bdfe8a);
const $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $9e43cd7de2afe373$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
const $9e43cd7de2afe373$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
const $9e43cd7de2afe373$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
const $9e43cd7de2afe373$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
const $9e43cd7de2afe373$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
const $9e43cd7de2afe373$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
const $9e43cd7de2afe373$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
const $9e43cd7de2afe373$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
const $9e43cd7de2afe373$export$b97d963a8496fa2f = {
    key: $9e43cd7de2afe373$var$FETCH_FIELD_DATA_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$179836a99669cbe7 = {
    key: $9e43cd7de2afe373$var$FETCH_INITIAL_COMMENTS_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$8d0984a0f9f31117 = {
    key: $9e43cd7de2afe373$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$c1324bd586e9a53a = {
    key: $9e43cd7de2afe373$var$FETCH_SUBTASK_TYPES_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$72fcc6cb1cdc70e0 = {
    key: $9e43cd7de2afe373$var$FETCH_UPLOAD_CONTEXT_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$4052b1eae3373c3b = {
    key: $9e43cd7de2afe373$var$FETCH_USER_AUTH_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$b4e2588a18d8d980 = {
    key: $9e43cd7de2afe373$var$FETCH_VIEW_CONTEXT_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$2ee73dd298bdfe8a = {
    key: $9e43cd7de2afe373$var$FETCH_ISSUE_PROPERTIES_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});


parcelRegister("EKr1h", function(module, exports) {

$parcel$export(module.exports, "issueViewLoad", () => $4f120a802ce83bc9$export$49371c2cc4aaa4f6);
$parcel$export(module.exports, "issueViewOnPageLoad", () => $4f120a802ce83bc9$export$2f6837d06b669285);
$parcel$export(module.exports, "embeddedIssueViewLoad", () => $4f120a802ce83bc9$export$9d773f01a8da623e);
$parcel$export(module.exports, "epicDropdownOpenInteraction", () => $4f120a802ce83bc9$export$8d33579ffe76aa5b);
$parcel$export(module.exports, "epicModalOpenInteraction", () => $4f120a802ce83bc9$export$8f0deabe791d5bb9);

var $dGrdR = parcelRequire("dGrdR");

const $4f120a802ce83bc9$export$49371c2cc4aaa4f6 = (0, $dGrdR.metrics).custom({
    key: 'issue-view-load',
    virtual: true,
    timings: [
        {
            key: 'legacy-tti-2021',
            startMark: 'metrics_init',
            endMark: $f0ab548eaf57140f$export$b292c195104c50d3
        },
        {
            key: 'timeBlockedOnBackend',
            startMark: $f0ab548eaf57140f$export$e64e32643802b552,
            endMark: $f0ab548eaf57140f$export$e52cc35f872875f7
        }
    ]
});
const $4f120a802ce83bc9$export$2f6837d06b669285 = (0, $dGrdR.metrics).custom({
    key: 'issue-view-on-page-load',
    timings: [
        {
            key: 'issue-mounted',
            endMark: $f0ab548eaf57140f$export$3a9e4a905dec520d
        },
        {
            key: 'latest-lcp',
            endMark: $f0ab548eaf57140f$export$4d1080224e02ef0b
        }
    ]
});
const $4f120a802ce83bc9$export$9d773f01a8da623e = (0, $dGrdR.metrics).custom({
    key: 'embedded-issue-view-load',
    until: $4f120a802ce83bc9$export$49371c2cc4aaa4f6,
    include: [
        $4f120a802ce83bc9$export$49371c2cc4aaa4f6
    ]
});
const $4f120a802ce83bc9$export$1e32b6c8e1e31a3d = (0, $dGrdR.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $4f120a802ce83bc9$export$4be279014c4d8d39 = (0, $dGrdR.metrics).pageLoad({
    key: 'service-management.reports.issue'
});
const $4f120a802ce83bc9$export$8d33579ffe76aa5b = (0, $dGrdR.metrics).interaction({
    key: 'issue-epic-dropdown-menu-open'
});
const $4f120a802ce83bc9$export$8f0deabe791d5bb9 = (0, $dGrdR.metrics).interaction({
    key: 'issue-epic-modal-open'
});

});

parcelRegister("72N4j", function(module, exports) {

$parcel$export(module.exports, "serverTimingSelector", () => $2bce567eae8a73a3$export$a0b21c7e17057a47);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $2bce567eae8a73a3$export$8ef68fa2b28a6d0f = (state)=>state.timing;
const $2bce567eae8a73a3$export$a0b21c7e17057a47 = (0, $dGvGJ.createSelector)($2bce567eae8a73a3$export$8ef68fa2b28a6d0f, (0, $bcoYn.isLoadingSelector), (timing, isLoading)=>isLoading ? undefined : timing.server);

});
parcelRegister("bcoYn", function(module, exports) {

$parcel$export(module.exports, "entitiesSelector", () => $468fb8d2be99a4f5$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "projectSelector", () => $468fb8d2be99a4f5$export$852a6c34ff1a2e77);
$parcel$export(module.exports, "uiSelector", () => $468fb8d2be99a4f5$export$185c0864c82372e3);
$parcel$export(module.exports, "entitiesIssueSelector", () => $468fb8d2be99a4f5$export$fa3ac1f794979805);
$parcel$export(module.exports, "entitiesRefreshedOnSelector", () => $468fb8d2be99a4f5$export$c4ebdc93969b82cc);
$parcel$export(module.exports, "flagsSelector", () => $468fb8d2be99a4f5$export$40cfdc5e96db7759);
$parcel$export(module.exports, "projectIdSelector", () => $468fb8d2be99a4f5$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectIdsSelector", () => $468fb8d2be99a4f5$export$9edb3f63d1bd8546);
$parcel$export(module.exports, "projectKeySelector", () => $468fb8d2be99a4f5$export$404de5ac601b84bc);
$parcel$export(module.exports, "projectTypeSelector", () => $468fb8d2be99a4f5$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $468fb8d2be99a4f5$export$d94d544d4b2e1310);
$parcel$export(module.exports, "loggedInUserDetailsSelector", () => $468fb8d2be99a4f5$export$b5a68452fc64275d);
$parcel$export(module.exports, "loggedInUserAvatarUrlSelector", () => $468fb8d2be99a4f5$export$e0efa9c12379be7a);
$parcel$export(module.exports, "loggedInUserDisplayNameSelector", () => $468fb8d2be99a4f5$export$4f56a07246719eb0);
$parcel$export(module.exports, "parentIssueEntitySelector", () => $468fb8d2be99a4f5$export$e10c57d263d23c49);
$parcel$export(module.exports, "loggedInUserTimeZoneSelector", () => $468fb8d2be99a4f5$export$ac6f9fd801c94fff);
$parcel$export(module.exports, "idSelector", () => $468fb8d2be99a4f5$export$66c501bed2fcd648);
$parcel$export(module.exports, "isClassicProjectSelector", () => $468fb8d2be99a4f5$export$45347d9f8a67561b);
$parcel$export(module.exports, "isLoadingSelector", () => $468fb8d2be99a4f5$export$c077f23183070903);
$parcel$export(module.exports, "doNotUseIsLoadingPromiseSelector", () => $468fb8d2be99a4f5$export$2ca9575c7da6bf18);
$parcel$export(module.exports, "isPreviewSelector", () => $468fb8d2be99a4f5$export$b33a1a8958a8d805);
$parcel$export(module.exports, "isCompletedLoadingSelector", () => $468fb8d2be99a4f5$export$9b99fb9e23fc133);
$parcel$export(module.exports, "loadingStageSelector", () => $468fb8d2be99a4f5$export$18bc980d36bf93d);
$parcel$export(module.exports, "isDeleteIssueModalOpenSelector", () => $468fb8d2be99a4f5$export$7cfd3e0dd7059b87);
$parcel$export(module.exports, "isDeletingIssueSelector", () => $468fb8d2be99a4f5$export$d414d8eddcb409e4);
$parcel$export(module.exports, "didIssueDeleteFailSelector", () => $468fb8d2be99a4f5$export$834732624d2c73e1);
$parcel$export(module.exports, "errorSelector", () => $468fb8d2be99a4f5$export$47aec13333381be0);
$parcel$export(module.exports, "errorMessageSelector", () => $468fb8d2be99a4f5$export$9b1097e17c0e6dc2);
$parcel$export(module.exports, "getUserByIdSelector", () => $468fb8d2be99a4f5$export$801a2f2bd4059665);
$parcel$export(module.exports, "parentLevelIssuesSelector", () => $468fb8d2be99a4f5$export$aa8980c49aba4478);
$parcel$export(module.exports, "baseAriSelector", () => $468fb8d2be99a4f5$export$fa12ae06e35ebd67);
$parcel$export(module.exports, "issueAriSelector", () => $468fb8d2be99a4f5$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "epicLinkFieldKeySelector", () => $468fb8d2be99a4f5$export$27abc48b8d528300);
$parcel$export(module.exports, "isEpicSelector", () => $468fb8d2be99a4f5$export$6e8ebe94ad8bb62b);
$parcel$export(module.exports, "isEpicIssueTypeSelector", () => $468fb8d2be99a4f5$export$460d8048474fa8a2);
$parcel$export(module.exports, "getIssueStatusCategoryIdSelector", () => $468fb8d2be99a4f5$export$6395cbfb900cdf4e);
$parcel$export(module.exports, "isServiceDeskSelector", () => $468fb8d2be99a4f5$export$43d733e4b7e8c7d0);

var $dGvGJ = parcelRequire("dGvGJ");

var $2vSU6 = parcelRequire("2vSU6");


var $fOGZN = parcelRequire("fOGZN");

var $g5X3G = parcelRequire("g5X3G");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");
const $468fb8d2be99a4f5$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $468fb8d2be99a4f5$export$852a6c34ff1a2e77 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities ? entities.project : null);
const $468fb8d2be99a4f5$export$185c0864c82372e3 = (state)=>state.ui;
const $468fb8d2be99a4f5$export$27493ac3d8611290 = (state)=>state.agile;
const $468fb8d2be99a4f5$export$fa3ac1f794979805 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.issue);
const $468fb8d2be99a4f5$export$c4ebdc93969b82cc = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.refreshedOn);
const $468fb8d2be99a4f5$export$40cfdc5e96db7759 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.flags);
const $468fb8d2be99a4f5$export$4c9d6034f65d22f4 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? project.projectId : null);
const $468fb8d2be99a4f5$export$9edb3f63d1bd8546 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? [
        project.projectId
    ] : []);
const $468fb8d2be99a4f5$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project ? project.projectKey : null);
const $468fb8d2be99a4f5$export$69316f88206ca90b = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectType ? project.projectType : null);
const $468fb8d2be99a4f5$export$d94d544d4b2e1310 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>!!project && project.isSimplified);
const $468fb8d2be99a4f5$export$b5a68452fc64275d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, $a1ky2.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>loggedInAccountId ? entities.users[loggedInAccountId] : null);
const $468fb8d2be99a4f5$export$e0efa9c12379be7a = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, $a1ky2.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.avatarUrl : null;
});
const $468fb8d2be99a4f5$export$4f56a07246719eb0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, $a1ky2.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.displayName : null;
});
const $468fb8d2be99a4f5$export$e10c57d263d23c49 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.parentIssue);
const $468fb8d2be99a4f5$export$ac6f9fd801c94fff = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$b5a68452fc64275d, (loggedInUser)=>loggedInUser ? loggedInUser.timeZone : undefined);
const $468fb8d2be99a4f5$export$66c501bed2fcd648 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$fa3ac1f794979805, (issue)=>issue && (0, $g5X3G.toIssueId)(issue.id));
const $468fb8d2be99a4f5$export$45347d9f8a67561b = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$d94d544d4b2e1310, (isSimplified)=>!isSimplified);
const $468fb8d2be99a4f5$export$c077f23183070903 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$26d55645375ca9a));
const $468fb8d2be99a4f5$export$2ca9575c7da6bf18 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.doNotUseIsLoadingPromise);
const $468fb8d2be99a4f5$export$b33a1a8958a8d805 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$1b56cc494043d9bf));
const $468fb8d2be99a4f5$export$9b99fb9e23fc133 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$1660a2d7c2fff354));
const $468fb8d2be99a4f5$export$18bc980d36bf93d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage);
const $468fb8d2be99a4f5$export$7cfd3e0dd7059b87 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>!!(ui.issueDeletion && ui.issueDeletion.isDeleteIssueModalOpen));
const $468fb8d2be99a4f5$export$d414d8eddcb409e4 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.isDeletingIssue : false);
const $468fb8d2be99a4f5$export$834732624d2c73e1 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.didIssueDeleteFail : false);
const $468fb8d2be99a4f5$export$47aec13333381be0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.error);
const $468fb8d2be99a4f5$export$9b1097e17c0e6dc2 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.errorMessage);
const $468fb8d2be99a4f5$export$801a2f2bd4059665 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>(userId)=>userId ? entities.users[userId] : undefined);
const $468fb8d2be99a4f5$export$aa8980c49aba4478 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.parentLevelIssues);
const $468fb8d2be99a4f5$export$a60a6c96db10acc4 = ()=>'jira';
const $468fb8d2be99a4f5$export$57c6957997fb7f1d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$69316f88206ca90b, (0, $2vSU6.projectTypeToCanonicalId));
const $468fb8d2be99a4f5$export$fa12ae06e35ebd67 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$a60a6c96db10acc4, (0, $a1ky2.cloudIdSelector), (resourceOwner, cloudId)=>cloudId ? `ari:cloud:${resourceOwner}:${cloudId}` : null);
const $468fb8d2be99a4f5$export$a2cdbba2136e72d3 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$fa12ae06e35ebd67, $468fb8d2be99a4f5$export$66c501bed2fcd648, (baseAri, issueId)=>{
    if (!baseAri || !issueId) return null;
    return `${baseAri}:issue/${issueId}`;
});
const $468fb8d2be99a4f5$export$27abc48b8d528300 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$27493ac3d8611290, (agile)=>agile && agile.epic && agile.epic.key || null);
const $468fb8d2be99a4f5$export$d062a59cf4fc9cec = (fields)=>({}).hasOwnProperty.call(fields, (0, $fOGZN.EPIC_ISSUES));
const $468fb8d2be99a4f5$export$6e8ebe94ad8bb62b = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$d062a59cf4fc9cec(fields));
const $468fb8d2be99a4f5$export$88630f3045704997 = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'hierarchy-level-same-level')) return fields['hierarchy-level-same-level'].value.name === 'Epic';
    return false;
};
const $468fb8d2be99a4f5$export$460d8048474fa8a2 = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$88630f3045704997(fields));
const $468fb8d2be99a4f5$export$697a560dc772eca6 = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'status')) return fields.status.value.statusCategory.id;
};
const $468fb8d2be99a4f5$export$6395cbfb900cdf4e = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$697a560dc772eca6(fields));
const $468fb8d2be99a4f5$export$57e1ff0824f418cd = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$7bead7bb2ab962ba(fields));
const $468fb8d2be99a4f5$export$7bead7bb2ab962ba = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'summary')) return fields.summary.value;
};
const $468fb8d2be99a4f5$export$43d733e4b7e8c7d0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$69316f88206ca90b, (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT));

});
const $fdfab07e3d100124$export$26d55645375ca9a = 'LOADING';
const $fdfab07e3d100124$export$1b56cc494043d9bf = 'PREVIEW';
const $fdfab07e3d100124$export$1660a2d7c2fff354 = 'COMPLETE';

parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $1df76d38eb6e3f90$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, $5fc53.SELECT_CF_TYPE);
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE),
    (0, $5fc53.ORGANIZATION_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});

parcelRegister("a1ky2", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $df15ab6efcbffe76$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $df15ab6efcbffe76$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $df15ab6efcbffe76$export$24984a39db14d8);
$parcel$export(module.exports, "baseUrlSelector", () => $df15ab6efcbffe76$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $df15ab6efcbffe76$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $df15ab6efcbffe76$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $df15ab6efcbffe76$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $df15ab6efcbffe76$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $df15ab6efcbffe76$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $df15ab6efcbffe76$export$b5a643cfff945455);
$parcel$export(module.exports, "issueAriSelector", () => $df15ab6efcbffe76$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "commentAriSelector", () => $df15ab6efcbffe76$export$b600fd41c88f35c8);
$parcel$export(module.exports, "isAnonymousSelector", () => $df15ab6efcbffe76$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $df15ab6efcbffe76$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $df15ab6efcbffe76$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $df15ab6efcbffe76$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $df15ab6efcbffe76$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $df15ab6efcbffe76$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $df15ab6efcbffe76$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $df15ab6efcbffe76$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $df15ab6efcbffe76$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $df15ab6efcbffe76$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $df15ab6efcbffe76$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $df15ab6efcbffe76$export$93badd2a066af8bd);
$parcel$export(module.exports, "appPermissionsSelector", () => $df15ab6efcbffe76$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $df15ab6efcbffe76$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $df15ab6efcbffe76$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $df15ab6efcbffe76$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $df15ab6efcbffe76$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $df15ab6efcbffe76$export$96c87532aec3474a);
$parcel$export(module.exports, "tenantHasActiveProductDiscoveryLicenseSelector", () => $df15ab6efcbffe76$export$f049ad7141428191);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $df15ab6efcbffe76$export$2b8e6729c89e24f5);
$parcel$export(module.exports, "hasActivatedConfluenceWithinThirtyDaysSelector", () => $df15ab6efcbffe76$export$2321d15582b8ce8a);

var $dGvGJ = parcelRequire("dGvGJ");

var $70Rr2 = parcelRequire("70Rr2");
var $lb7qa = parcelRequire("lb7qa");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");
var $pyK8a = parcelRequire("pyK8a");


var $4Pf62 = parcelRequire("4Pf62");

var $k3PbQ = parcelRequire("k3PbQ");

var $fOGZN = parcelRequire("fOGZN");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $dXq4S = parcelRequire("dXq4S");
const $df15ab6efcbffe76$export$c420c9f40402ab6d = (state)=>state.context;
const $df15ab6efcbffe76$export$cb29341089829e17 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $df15ab6efcbffe76$export$24984a39db14d8 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $df15ab6efcbffe76$export$1ca9a92a5f28e233 = (_)=>'';
const $df15ab6efcbffe76$export$767583fcce1653ec = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $df15ab6efcbffe76$export$d22bc6271070f453 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>(0, $g5X3G.toIssueKey)(context.issueKey));
const $df15ab6efcbffe76$export$31efbca30077ec1e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.issueId);
const $df15ab6efcbffe76$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$d22bc6271070f453, (issueKey)=>(0, $k3PbQ.extractProjectKey)(issueKey));
const $df15ab6efcbffe76$export$85a9d212d56669b4 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $df15ab6efcbffe76$export$b5a643cfff945455 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, $g5X3G.toCloudId)(''));
const $df15ab6efcbffe76$export$a2cdbba2136e72d3 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$b5a643cfff945455, $df15ab6efcbffe76$export$31efbca30077ec1e, (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    }));
const $df15ab6efcbffe76$export$b600fd41c88f35c8 = (commentId)=>(0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$b5a643cfff945455, $df15ab6efcbffe76$export$31efbca30077ec1e, (cloudId, issueId)=>`ari:cloud:jira:${cloudId}:issue-comment/${issueId ?? ''}/${commentId}`);
const $df15ab6efcbffe76$export$2335b963a9875096 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $g5X3G.toActivationId)(''));
const $df15ab6efcbffe76$export$a165ec261432d0b8 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $df15ab6efcbffe76$export$f7b7935883444b11 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.locale);
const $df15ab6efcbffe76$export$b62cb5286b153905 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $df15ab6efcbffe76$export$6c7d07328f197de7 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $df15ab6efcbffe76$export$4cbb8c74e98876a5 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$df15ab6efcbffe76$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $fcf97b7a09088940$export$ce88447986394f2d));
const $df15ab6efcbffe76$export$6fbe1dbaf5b67cc5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $fOGZN.standardRoadmapConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$7479ef2453efd3b4 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.softwareConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$245e5ba54167b84a = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$df15ab6efcbffe76$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $fcf97b7a09088940$export$7552fe2669628499));
const $df15ab6efcbffe76$export$43d733e4b7e8c7d0 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.serviceDeskConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$9bffc1987c753bd9 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $df15ab6efcbffe76$export$718e830000b27a0e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $df15ab6efcbffe76$export$8065de5fbcf23af5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $df15ab6efcbffe76$export$5af08fd769c0f0 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.boardType);
const $df15ab6efcbffe76$export$955e7dbf76b61f80 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.boardId);
const $df15ab6efcbffe76$export$93badd2a066af8bd = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $df15ab6efcbffe76$export$b468116a08f9183e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $df15ab6efcbffe76$export$f29192b357e6beca = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $df15ab6efcbffe76$export$5b71e1eb43056b6c = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $df15ab6efcbffe76$export$5fa593caa6a15917 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.isModal);
const $df15ab6efcbffe76$export$631793d49dec78de = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$5fa593caa6a15917, $df15ab6efcbffe76$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $df15ab6efcbffe76$export$1f11fe78e4f22d45 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $df15ab6efcbffe76$export$28ca74e18c8f4529 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $df15ab6efcbffe76$export$beea798086c18f0a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $df15ab6efcbffe76$export$40487a15195e570e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $ef5Xn.LICENSE_STATE_ACTIVE));
const $df15ab6efcbffe76$export$96c87532aec3474a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$f29192b357e6beca, $df15ab6efcbffe76$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $df15ab6efcbffe76$export$2fa17c0746682b0b = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.productDiscovery === (0, $ef5Xn.LICENSE_STATE_ACTIVE));
const $df15ab6efcbffe76$export$f049ad7141428191 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$f29192b357e6beca, $df15ab6efcbffe76$export$2fa17c0746682b0b, (licensedProducts, isProductDiscoveryLicenseActive)=>Boolean(licensedProducts && licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_PRODUCT_DISCOVERY] && isProductDiscoveryLicenseActive));
const $df15ab6efcbffe76$export$747a61878b414bda = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $df15ab6efcbffe76$export$2b8e6729c89e24f5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $70Rr2.default)(new Date());
        const fourteenDaysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, 14));
        const dateToCheck = (0, $eZDAP.default)(confluenceActivationDate);
        return (0, $lb7qa.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});
const $df15ab6efcbffe76$export$2321d15582b8ce8a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $70Rr2.default)(new Date());
        const thirtyDaysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, 31)); // 31 days to account for the 30 day trial
        const dateToCheck = (0, $eZDAP.default)(confluenceActivationDate);
        return (0, $lb7qa.default)(dateToCheck, {
            start: thirtyDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
}); // GALILEO-404 END

});
parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});


parcelRegister("7Ow8a", function(module, exports) {

$parcel$export(module.exports, "fieldsSelector", () => $04968168b83fddb5$export$e1512647ca813bfa);
$parcel$export(module.exports, "fieldByCustomTypeSelector", () => $04968168b83fddb5$export$72dfc619a02c972c);
$parcel$export(module.exports, "customFieldIdSelector", () => $04968168b83fddb5$export$8ad8506b941e30dc);
$parcel$export(module.exports, "fieldSelector", () => $04968168b83fddb5$export$4ee5e7baedf94214);
$parcel$export(module.exports, "issueTypeIdSelector", () => $04968168b83fddb5$export$22410768c09b3a82);
$parcel$export(module.exports, "hasSubtasksSelector", () => $04968168b83fddb5$export$f363078714850fd9);
$parcel$export(module.exports, "hasSubtasksValuesSelector", () => $04968168b83fddb5$export$689f8f96c9d81e1b);
$parcel$export(module.exports, "hasPortfolioChildIssuesSelector", () => $04968168b83fddb5$export$724b8972771ff092);
$parcel$export(module.exports, "hasPortfolioChildIssueValuesSelector", () => $04968168b83fddb5$export$c6d2d4f8e243ac37);
$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $04968168b83fddb5$export$29f34d4d7c528e9c);
$parcel$export(module.exports, "hasChildrenIssueValuesSelector", () => $04968168b83fddb5$export$9034aaa32d45814b);
$parcel$export(module.exports, "childIssuesLimitUrlSelector", () => $04968168b83fddb5$export$762e13908aaafb2d);
$parcel$export(module.exports, "availableFieldIdsSelector", () => $04968168b83fddb5$export$641248fa887fb9ea);
$parcel$export(module.exports, "fieldSchemaConfigurationSelector", () => $04968168b83fddb5$export$3c65874760e68948);
$parcel$export(module.exports, "isFieldEditableSelector", () => $04968168b83fddb5$export$76ece3d8c4244af2);
$parcel$export(module.exports, "fieldNameSelector", () => $04968168b83fddb5$export$2d1abc174b8a710e);
$parcel$export(module.exports, "fieldMetaKeySelector", () => $04968168b83fddb5$export$351970d5fcbd0b29);
$parcel$export(module.exports, "fieldARISelector", () => $04968168b83fddb5$export$f6363cecfaa3a9b0);
$parcel$export(module.exports, "fieldAutoCompleteUrlSelector", () => $04968168b83fddb5$export$d27105f13ab27906);
$parcel$export(module.exports, "fieldAllowedValuesSelector", () => $04968168b83fddb5$export$351dc1c32c2771ea);
$parcel$export(module.exports, "isFieldRequiredSelector", () => $04968168b83fddb5$export$4c5f76e28914074);
$parcel$export(module.exports, "fieldTypeSelector", () => $04968168b83fddb5$export$9e2f15437ff59992);
$parcel$export(module.exports, "fieldPersistedValueSelector", () => $04968168b83fddb5$export$ae4660b0b7ebeee9);
$parcel$export(module.exports, "fieldPendingValueSelector", () => $04968168b83fddb5$export$2ae929653dce6648);
$parcel$export(module.exports, "fieldEditingValueSelector", () => $04968168b83fddb5$export$487becf51bedcd03);
$parcel$export(module.exports, "fieldEditingAdfValueSelector", () => $04968168b83fddb5$export$31406f841bca5b75);
$parcel$export(module.exports, "fieldHtmlValueSelector", () => $04968168b83fddb5$export$e69c8171ecd8fde2);
$parcel$export(module.exports, "isFieldEditingSelector", () => $04968168b83fddb5$export$29e6b1cade110749);
$parcel$export(module.exports, "fieldEditSessionIdSelector", () => $04968168b83fddb5$export$c53ab145ef243c95);
$parcel$export(module.exports, "isFieldWaitingSelector", () => $04968168b83fddb5$export$30e972ebce44d9b8);
$parcel$export(module.exports, "fieldInvalidMessageSelector", () => $04968168b83fddb5$export$d323462f155519c3);
$parcel$export(module.exports, "fieldInvalidSelector", () => $04968168b83fddb5$export$e35f4d21d9739426);
$parcel$export(module.exports, "isRichTextFieldSelector", () => $04968168b83fddb5$export$120a4249e9b3c231);
$parcel$export(module.exports, "richTextFieldIdsSelector", () => $04968168b83fddb5$export$862745d3ab4003e5);
$parcel$export(module.exports, "isRichTextFieldEditingSelector", () => $04968168b83fddb5$export$df9b7004d8b93e46);
$parcel$export(module.exports, "isMultilineFieldSelector", () => $04968168b83fddb5$export$4d0b1fe809ae5e75);
$parcel$export(module.exports, "getEditingMultilineFieldIdsSelector", () => $04968168b83fddb5$export$2469330614f0dba9);

var $dGvGJ = parcelRequire("dGvGJ");

var $1sWm7 = parcelRequire("1sWm7");

var $dJl1T = parcelRequire("dJl1T");


var $69oHP = parcelRequire("69oHP");

var $fOGZN = parcelRequire("fOGZN");

var $5fc53 = parcelRequire("5fc53");


var $a1ky2 = parcelRequire("a1ky2");

var $aOGHX = parcelRequire("aOGHX");

var $3Uijm = parcelRequire("3Uijm");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $04968168b83fddb5$var$STABLE_EMPTY_ARRAY = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $04968168b83fddb5$var$STABLE_EMPTY_OBJECT = {};
const $04968168b83fddb5$export$e1512647ca813bfa = (state)=>state.fields || $04968168b83fddb5$var$STABLE_EMPTY_OBJECT;
const $04968168b83fddb5$var$getFieldByCustomType = (customType, fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(fields, (field)=>(field.schema && field.schema.custom) === customType);
const $04968168b83fddb5$export$46dde968006cd8d4 = (fieldId, fields)=>{
    let field = fields[fieldId];
    const customSystemFields = (0, $fOGZN.specialFields)();
    if (!field && Object.keys(customSystemFields).includes(fieldId)) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        // @ts-expect-error - TS2322 - Type 'Field | undefined' is not assignable to type 'Field'.
        field = $04968168b83fddb5$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $04968168b83fddb5$export$cb67eba45dd11f50 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>!!fields[fieldId]);
const $04968168b83fddb5$export$309344981947f228 = (fieldsState, fieldName)=>Array.isArray(fieldsState[fieldName]?.value) ? fieldsState[fieldName].value.length > 0 : fieldsState[fieldName]?.value != null;
const $04968168b83fddb5$export$72dfc619a02c972c = (customType)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$var$getFieldByCustomType(customType, fields));
const $04968168b83fddb5$export$8ad8506b941e30dc = (customFieldType)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$72dfc619a02c972c(customFieldType), (customField)=>{
        const idCandidates = customField ? customField.key.match(/customfield_(\d+)$/i) : null;
        return idCandidates ? +idCandidates[1] : null;
    });
const $04968168b83fddb5$export$4ee5e7baedf94214 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldId, fields));
const $04968168b83fddb5$var$issueTypeFieldSelector = $04968168b83fddb5$export$4ee5e7baedf94214((0, $fOGZN.ISSUE_TYPE));
const $04968168b83fddb5$export$22410768c09b3a82 = (0, $dGvGJ.createSelector)($04968168b83fddb5$var$issueTypeFieldSelector, (issueType)=>(issueType && issueType.value && issueType.value.id) ?? null);
const $04968168b83fddb5$export$b8de62018cc85a18 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldId, fields));
const $04968168b83fddb5$export$3c65f67962ca81cc = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $e9be48d6d2c01760$export$a5fc282ab2bf9b89)));
const $04968168b83fddb5$export$f363078714850fd9 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes('subtasks'));
const $04968168b83fddb5$export$689f8f96c9d81e1b = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, 'subtasks'));
const $04968168b83fddb5$export$724b8972771ff092 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $fOGZN.PORTFOLIO_CHILD_ISSUES)));
const $04968168b83fddb5$export$c6d2d4f8e243ac37 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, (0, $fOGZN.PORTFOLIO_CHILD_ISSUES)));
const $04968168b83fddb5$export$29f34d4d7c528e9c = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $fOGZN.CHILDREN_ISSUES)));
const $04968168b83fddb5$export$9034aaa32d45814b = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, (0, $fOGZN.CHILDREN_ISSUES)));
const $04968168b83fddb5$export$762e13908aaafb2d = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>{
    const getChildIssueUrlSelector = (fieldId)=>fields?.[fieldId]?.issueLimitUrl || '';
    return getChildIssueUrlSelector;
});
const $04968168b83fddb5$export$9ee3b3f5d4ad4423 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>Object.keys(fields).map((fieldKey)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldKey, fields)).filter(Boolean));
const $04968168b83fddb5$export$641248fa887fb9ea = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>Object.keys(fields));
const $04968168b83fddb5$export$e50b5889a6b86caf = (field)=>field ? field.editable : false;
const $04968168b83fddb5$export$3c65874760e68948 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.configuration && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        field.schema.configuration.reduce((config, { key: key, value: value })=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...config,
                [key]: value
            }), {}));
const $04968168b83fddb5$export$76ece3d8c4244af2 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>$04968168b83fddb5$export$e50b5889a6b86caf(field));
const $04968168b83fddb5$export$2d1abc174b8a710e = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>{
        if (field && field.title) return field.title;
        (0, $dJl1T.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
        return '';
    });
const $04968168b83fddb5$export$d20285fb6e3fb007 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (state, { fieldId: fieldId })=>fieldId, (field, fieldId)=>{
    if (field?.title) return field.title;
    (0, $dJl1T.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
    return '';
});
const $04968168b83fddb5$export$351970d5fcbd0b29 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.key);
const $04968168b83fddb5$export$f6363cecfaa3a9b0 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.ari : undefined);
const $04968168b83fddb5$export$d27105f13ab27906 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.autoCompleteUrl);
const $04968168b83fddb5$export$351dc1c32c2771ea = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.allowedValues : $04968168b83fddb5$var$STABLE_EMPTY_ARRAY);
const $04968168b83fddb5$export$4c5f76e28914074 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.required : false);
const $04968168b83fddb5$export$9e2f15437ff59992 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $69oHP.getFieldType)(field));
const $04968168b83fddb5$export$ae4660b0b7ebeee9 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.value);
const $04968168b83fddb5$export$bf3f8fd2c145740 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (field)=>field?.value);
const $04968168b83fddb5$export$2ae929653dce6648 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $3Uijm.default)(field));
const $04968168b83fddb5$export$487becf51bedcd03 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $aOGHX.default)(field));
const $04968168b83fddb5$export$31406f841bca5b75 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (field)=>field && (0, $aOGHX.getEditingAdfValue)(field));
const $04968168b83fddb5$export$e69c8171ecd8fde2 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.renderedValue);
const $04968168b83fddb5$export$4e96991314eba25 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (field)=>field?.renderedValue);
const $04968168b83fddb5$export$18ec1d851ee244b3 = (field)=>field ? field.editingValue !== undefined : false;
const $04968168b83fddb5$export$29e6b1cade110749 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>$04968168b83fddb5$export$18ec1d851ee244b3(field));
const $04968168b83fddb5$export$c53ab145ef243c95 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>(field ? field.fieldEditSessionId : null) || '');
const $04968168b83fddb5$export$30e972ebce44d9b8 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.pendingValue !== undefined : false);
const $04968168b83fddb5$export$d323462f155519c3 = (fieldId, fallbackInvalidMessage)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (field.isInvalid ? field.invalidMessage || fallbackInvalidMessage : null));
const $04968168b83fddb5$export$e35f4d21d9739426 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>Boolean(field && field.isInvalid));
const $04968168b83fddb5$export$448aaad27e620666 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.renderer);
const $04968168b83fddb5$export$94cc87cea4e06b09 = (fieldType)=>fieldType === (0, $5fc53.TEXT_AREA_CF_TYPE) || fieldType === (0, $fOGZN.ENVIRONMENT) || fieldType === (0, $fOGZN.DESCRIPTION);
const $04968168b83fddb5$export$120a4249e9b3c231 = (fieldId)=>(0, $dGvGJ.createSelector)((0, $a1ky2.isServiceDeskSelector), $04968168b83fddb5$export$9e2f15437ff59992(fieldId), $04968168b83fddb5$export$448aaad27e620666(fieldId), (isServiceDesk, fieldType, fieldRenderer)=>{
        const isDescription = fieldId === (0, $fOGZN.DESCRIPTION);
        const isMultilineRichTextField = $04968168b83fddb5$export$94cc87cea4e06b09(fieldType) && fieldRenderer === (0, $650578330a102f55$export$89b8c5d86c10a68c);
        return isDescription || isMultilineRichTextField;
    });
const $04968168b83fddb5$export$862745d3ab4003e5 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$04968168b83fddb5$export$120a4249e9b3c231(fieldId)(state)));
const $04968168b83fddb5$export$df9b7004d8b93e46 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$862745d3ab4003e5, (state)=>state, (richTextFieldIds, state)=>richTextFieldIds.some((fieldId)=>$04968168b83fddb5$export$29e6b1cade110749(fieldId)(state)));
const $04968168b83fddb5$export$4d0b1fe809ae5e75 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$9e2f15437ff59992(fieldId), (fieldType)=>$04968168b83fddb5$export$94cc87cea4e06b09(fieldType));
const $04968168b83fddb5$export$3263c202444b0e0 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$04968168b83fddb5$export$4d0b1fe809ae5e75(fieldId)(state)));
const $04968168b83fddb5$export$2469330614f0dba9 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$3263c202444b0e0, (state)=>state, (multilineFieldsIds, state)=>multilineFieldsIds.filter((fieldId)=>$04968168b83fddb5$export$29e6b1cade110749(fieldId)(state)));
const $04968168b83fddb5$export$a2fc0905011957cb = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214((0, $fOGZN.FIX_VERSIONS)), $04968168b83fddb5$export$4ee5e7baedf94214((0, $fOGZN.AFFECTS_VERSIONS)), (fixVersions, affectsVersions)=>{
    const ids = [];
    if (fixVersions) ids.push(fixVersions.key);
    if (affectsVersions) ids.push(affectsVersions.key);
    return ids;
});

});
parcelRegister("69oHP", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $53d3f894a8bd7ffe$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1);


var $fOGZN = parcelRequire("fOGZN");

var $5fc53 = parcelRequire("5fc53");
const $53d3f894a8bd7ffe$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $fOGZN.specialFields)();
    return [
        ...(0, $fOGZN.customFieldsToDisplay)().filter((cf)=>!(0, $fOGZN.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $5fc53.FLAGGED_CF_TYPE)
    ];
};
const $53d3f894a8bd7ffe$export$f521834fc2bfcd81 = (custom)=>$53d3f894a8bd7ffe$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $53d3f894a8bd7ffe$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $53d3f894a8bd7ffe$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) || $53d3f894a8bd7ffe$export$b9089a6e41ed43aa(field) === (0, $5fc53.DESCRIPTION_TYPE) : false;
};

});

const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$f7a17147527dd688 = 'flag';

parcelRegister("aOGHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf727673620c8917$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getEditingAdfValue", () => $bf727673620c8917$export$a799cf637c5b7727);

var $3Uijm = parcelRequire("3Uijm");
var /**
 * Returns the first available value for a given field.
 * editingValue => pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf727673620c8917$export$2e2bcd8739ae039 = (field)=>typeof field.editingValue !== 'undefined' ? field.editingValue : (0, $3Uijm.default)(field);
const $bf727673620c8917$export$a799cf637c5b7727 = (field)=>field.editingValue || (0, $3Uijm.getPendingAdfValue)(field);

});
parcelRegister("3Uijm", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9626bc322e3072$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getPendingAdfValue", () => $de9626bc322e3072$export$5012210a9f91b010);
var /**
 * Returns the first available value for a given field, excluding editingValue
 * pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$de9626bc322e3072$export$2e2bcd8739ae039 = (field)=>typeof field.pendingValue !== 'undefined' ? field.pendingValue : field.value;
const $de9626bc322e3072$export$5012210a9f91b010 = (field)=>field.pendingValue || field.adfValue || field.value;

});





parcelRegister("iAWa3", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $8ad29d98765af503$export$dc4c3408669b8f4e);

var $x9xyg = parcelRequire("x9xyg");

const $8ad29d98765af503$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
        (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});

parcelRegister("6y2lk", function(module, exports) {

$parcel$export(module.exports, "startUimTti", () => $a642ea194b4a9d18$export$1422384676f6de7a);
$parcel$export(module.exports, "markUimTtiIssueViewLoaded", () => $a642ea194b4a9d18$export$5a9389b70d93def2);
$parcel$export(module.exports, "stopTTI", () => $a642ea194b4a9d18$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $a642ea194b4a9d18$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $a642ea194b4a9d18$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $a642ea194b4a9d18$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $a642ea194b4a9d18$export$d86f4868694f2aa7);

var $dGrdR = parcelRequire("dGrdR");
const $a642ea194b4a9d18$var$uimInIssueViewTTI = (0, $dGrdR.metrics).interaction({
    key: 'ui-modifications-in-issue-view',
    timings: [
        {
            key: 'issue-view-tti-delta',
            startMark: 'issue-view-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $a642ea194b4a9d18$export$1422384676f6de7a = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.start();
};
const $a642ea194b4a9d18$export$5a9389b70d93def2 = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.mark('issue-view-tti');
};
const $a642ea194b4a9d18$export$30ca4c461fab486c = (customData)=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.stop({
        customData: customData
    });
};
const $a642ea194b4a9d18$export$27f2445288b528c = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.cancel();
};
const $a642ea194b4a9d18$export$7a2709fc1e33401a = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.mark('iframe-load');
};
const $a642ea194b4a9d18$export$cf3893335c93e33b = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.mark('fields-registered');
};
const $a642ea194b4a9d18$export$d86f4868694f2aa7 = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.mark('oninit-resolved');
};

});

parcelRegister("Rsnea", function(module, exports) {

$parcel$export(module.exports, "blockedOnBackendEntryLog", () => $09eba838967fcf46$export$dd1b3502b1e8ca97);
$parcel$export(module.exports, "getBackendBlockingTime", () => $09eba838967fcf46$export$8720c1f879c7ca46);

var $x9xyg = parcelRequire("x9xyg");


var $eR8VP = parcelRequire("eR8VP");

var $5HSWG = parcelRequire("5HSWG");
const $09eba838967fcf46$export$dd1b3502b1e8ca97 = (0, $eR8VP.createBlockedOnBackendEntryLog)();
function $09eba838967fcf46$var$measureBlockingEntry(measureName, backendBlockingStart, backendBlockingEnd) {
    (0, $x9xyg.setMark)(`${measureName}Start`, {
        startTime: backendBlockingStart
    });
    (0, $x9xyg.setMark)(`${measureName}End`, {
        startTime: backendBlockingEnd
    });
    (0, $x9xyg.setMeasure)(`${measureName}`, `${measureName}Start`, `${measureName}End`);
}
const $09eba838967fcf46$export$8720c1f879c7ca46 = (args)=>{
    const { blockingStart: blockingStartOrZero, totalBlockingDuration: totalBlockingDuration } = (0, $5HSWG.getSimplifiedBlockingTime)($09eba838967fcf46$export$dd1b3502b1e8ca97);
    const backendBlockingStart = Math.max(args.issueViewLoad.startTime, blockingStartOrZero);
    // Add the marks to the issueViewLoad BM3 event
    const backendBlockingEnd = backendBlockingStart + totalBlockingDuration;
    args.issueViewLoad.mark($f0ab548eaf57140f$export$e52cc35f872875f7, backendBlockingEnd);
    args.issueViewLoad.mark($f0ab548eaf57140f$export$e64e32643802b552, backendBlockingStart);
    $09eba838967fcf46$export$dd1b3502b1e8ca97.getBlockedOnBackendEntries().forEach(([blockingReason, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>$09eba838967fcf46$var$measureBlockingEntry(`issueView_blockedOnBackend_${blockingReason}`, blockingStart, blockingEnd));
    return {
        issueDataAvailable: backendBlockingEnd,
        issueReadyForData: backendBlockingStart
    };
};

});
parcelRegister("eR8VP", function(module, exports) {

$parcel$export(module.exports, "createBlockedOnBackendEntryLog", () => $03c2930a2b0da0b2$export$44ddca89673a78bc);
const $03c2930a2b0da0b2$export$44ddca89673a78bc = ()=>{
    const blockedOnBackendState = {
        timestamps: {}
    };
    // Internal use, use initialiseBlockedOnBackendStateForUpdatedKey externally
    const clearBlockedOnBackendState = ()=>{
        blockedOnBackendState.timestamps = {};
        blockedOnBackendState.currentKey = undefined;
    };
    // Internal use, use markStartBackendBlockingTimestamp or markEndBackendBlockingTimestamp
    const getOrCreateTimestampsEntryForKey = (blockingReasonKey)=>{
        let blockingDurationTimestamps = blockedOnBackendState.timestamps[blockingReasonKey];
        if (!blockingDurationTimestamps) {
            blockingDurationTimestamps = {};
            blockedOnBackendState.timestamps[blockingReasonKey] = blockingDurationTimestamps;
        }
        return blockingDurationTimestamps;
    };
    /**
	 * Initialise the store for a given key string.
	 * Only resets the state the first if the key string updates from its initial undefined OR if the key updates from the last time this was called
	 */ const initialiseBlockedOnBackendStateForUpdatedKey = (key)=>{
        if (key !== blockedOnBackendState.currentKey) {
            clearBlockedOnBackendState();
            blockedOnBackendState.currentKey = key;
        }
    };
    /**
	 * Fire this to mark the start of being blocked on backend for a given reason.
	 * @param blockingReasonKey An identifier for the reason for blocking. Until state is re-initialised, this reason cannot be used again to start a blocking span. Overlapping reasons will not be double counted
	 * @param timestamp optional, defaults to current time
	 */ const markStartBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingStart) blockingDurationTimestamps.blockingStart = timestamp;
    };
    /**
	 * Fire this to mark the end of being blocked on backend for a given reason
	 * @param blockingReasonKey
	 * @param timestamp optional, defaults to current time
	 */ const markEndBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingEnd) blockingDurationTimestamps.blockingEnd = timestamp;
    };
    /**
	 * Return a list of the entries gathered so far
	 * @param sorted whether the returned results should be sorted based on their start time. true by default
	 */ const getBlockedOnBackendEntries = ({ sorted: sorted = true } = {})=>{
        let entries = Object.entries(blockedOnBackendState.timestamps).filter((entry)=>{
            const [, blockingTimestamps] = entry;
            return blockingTimestamps.blockingStart != null && blockingTimestamps.blockingEnd != null && blockingTimestamps.blockingStart <= blockingTimestamps.blockingEnd;
        });
        if (sorted) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entries = entries.sort(([, { blockingStart: start1 }], [, { blockingStart: start2 }])=>start1 - start2);
        return entries;
    };
    return {
        initialiseBlockedOnBackendStateForUpdatedKey: initialiseBlockedOnBackendStateForUpdatedKey,
        markStartBackendBlockingTimestamp: markStartBackendBlockingTimestamp,
        markEndBackendBlockingTimestamp: markEndBackendBlockingTimestamp,
        getBlockedOnBackendEntries: getBlockedOnBackendEntries
    };
};

});

parcelRegister("5HSWG", function(module, exports) {

$parcel$export(module.exports, "getSimplifiedBlockingTime", () => $f737b8377358abe8$export$580550d1d1ffca6c);

var $fV2OJ = parcelRequire("fV2OJ");
const $f737b8377358abe8$export$580550d1d1ffca6c = (entryLog)=>{
    const blockingTimestampEntries = entryLog.getBlockedOnBackendEntries({
        sorted: true
    });
    const blockingSpans = (0, $fV2OJ.mergeOverlappingBlockingEntries)(blockingTimestampEntries);
    const blockingStartTimes = blockingSpans.map(({ blockingStart: blockingStart })=>blockingStart ?? 0);
    const blockingDurations = blockingSpans.map(({ blockingEnd: blockingEnd, blockingStart: blockingStart })=>blockingEnd - blockingStart);
    const blockingStart = Math.min(...blockingStartTimes.length ? blockingStartTimes : [
        0
    ]);
    const totalBlockingDuration = blockingDurations.reduce((a, b)=>a + b, 0);
    return {
        blockingStart: blockingStart,
        totalBlockingDuration: totalBlockingDuration
    };
};

});
parcelRegister("fV2OJ", function(module, exports) {

$parcel$export(module.exports, "mergeOverlappingBlockingEntries", () => $a9340f8b2f19c6fe$export$e63ec487944afc72);
function $a9340f8b2f19c6fe$export$e63ec487944afc72(blockingTimestampEntriesSortedByStartTime) {
    return blockingTimestampEntriesSortedByStartTime.reduce((nonOverlappingSpans, [, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>{
        const lastSpan = nonOverlappingSpans[nonOverlappingSpans.length - 1];
        if (!lastSpan || blockingStart > lastSpan.blockingEnd) nonOverlappingSpans.push({
            blockingStart: blockingStart,
            blockingEnd: blockingEnd
        }); // add the span as-is to the known non-overlapping spans
        else if (lastSpan.blockingEnd < blockingEnd) lastSpan.blockingEnd = blockingEnd;
        return nonOverlappingSpans;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
}

});



parcelRegister("1UioC", function(module, exports) {

$parcel$export(module.exports, "issueScaleabilityReporterFactory", () => $1f39c5825b4f5e5a$export$9f6c068bd6582299);


var $kuVxL = parcelRequire("kuVxL");

var $fOGZN = parcelRequire("fOGZN");

var $i84pu = parcelRequire("i84pu");

var $b5LNN = parcelRequire("b5LNN");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $gYUjk = parcelRequire("gYUjk");

var $lMzxr = parcelRequire("lMzxr");

var $jMY7o = parcelRequire("jMY7o");

var $hwyJi = parcelRequire("hwyJi");

var $lssfC = parcelRequire("lssfC");

var $d4MOh = parcelRequire("d4MOh");

var $9acDX = parcelRequire("9acDX");

var $ifezr = parcelRequire("ifezr");

var $3Ke60 = parcelRequire("3Ke60");

var $aN61o = parcelRequire("aN61o");

var $5fc53 = parcelRequire("5fc53");

var $dvijh = parcelRequire("dvijh");

var $fKtck = parcelRequire("fKtck");
const $1f39c5825b4f5e5a$var$getCascadingSelectFields = (state)=>Object.values((0, $7Ow8a.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $5fc53.CASCADING_SELECT_CF_TYPE));
const $1f39c5825b4f5e5a$var$getAtlassianTeamFields = (state)=>Object.values((0, $7Ow8a.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1f39c5825b4f5e5a$var$getCascadingSelectOptionChildrenCount = (cascadingSelectFieldValue)=>{
    if (cascadingSelectFieldValue.length === 0) return 0;
    return Object.values(cascadingSelectFieldValue).reduce((accumulatedCount, parentValue)=>accumulatedCount + (parentValue?.children?.length || 1), 0);
};
const $1f39c5825b4f5e5a$var$getCascadingSelectOptionsTotalCount = (state)=>{
    const cascadingSelectFields = $1f39c5825b4f5e5a$var$getCascadingSelectFields(state);
    if (cascadingSelectFields.length === 0) return 0;
    return cascadingSelectFields.reduce((accumulatedCount, cascadingSelectField)=>accumulatedCount + ($1f39c5825b4f5e5a$var$getCascadingSelectOptionChildrenCount(cascadingSelectField.allowedValues) || 1), 0);
};
const $1f39c5825b4f5e5a$export$ae327590f8230d00 = ({ projectKey: projectKey, ecosystem: ecosystem, forge: forge })=>{
    let open = 0;
    let closed = 0;
    if (projectKey !== undefined) {
        // The context groups store the state of open / closed inside local storage, so we need to get access to that
        // here. It's not held in redux which is why we look it up this way.
        const groupLocalStorageName = (0, $i84pu.getGroupLocalStorageName)(projectKey, 'context-group');
        try {
            // It's possible panels are uninstalled and not removed from localstorage, so we need to check they are installed
            // otherwise the analytics may be incorrectly advising how many panels are open
            const installedPanels = [
                ...ecosystem.map((item)=>`${groupLocalStorageName}-${(0, $b5LNN.generateContextPanelId)(item)}`),
                ...forge.map((item)=>`${groupLocalStorageName}-${item.id}`)
            ];
            open = Object.values((0, $i84pu.getGroupsLocalStorage)(installedPanels, (0, $135ded4f9a1460dc$export$e1184c3be46bd7cb))).filter(Boolean).length;
            // Panels may not exist in localStorage but may be installed, in which case they are closed as this is the default state
            closed = installedPanels.length - open;
        } catch  {
        // No action required
        }
    }
    return {
        open: open,
        closed: closed
    };
};
const $1f39c5825b4f5e5a$export$9f6c068bd6582299 = (store, issueContextActions)=>()=>{
        const state = store.getState();
        const { permalinkType: permalinkType } = (0, $fKtck.getPermalinkTypeAndId)() || {};
        const childIssues = (0, $7Ow8a.fieldSelector)((0, $5fc53.CHILDREN_ISSUES))(state);
        const proformaHarmonisation = (0, $7Ow8a.fieldSelector)((0, $5fc53.PROFORMA_FORMS))(state);
        const { open: contextPanelOpenCount, closed: contextPanelClosedCount } = $1f39c5825b4f5e5a$export$ae327590f8230d00({
            projectKey: state?.entities?.project?.projectKey,
            ecosystem: (0, $gYUjk.contextPanelEntitiesSelector)(state),
            forge: (0, $lMzxr.forgeContextPanelsSelector)(state)
        });
        const subtaskCount = (0, $7Ow8a.childIssuesLimitUrlSelector)(state)((0, $fOGZN.SUBTASKS)) && issueContextActions ? (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : (0, $aN61o.subtaskEntitiesSelector)(state).length;
        const childIssuesCount = (0, $7Ow8a.childIssuesLimitUrlSelector)(state)((0, $5fc53.CHILDREN_ISSUES)) && issueContextActions ? (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : childIssues?.value.length ?? 0;
        // If a portfolio issue is over the limit we cannot tell because
        // only the subtasks panel is displayed. Once the portfolio issue
        // type hierarchy level is a value > 1 then we can set this to ">100".
        let portfolioChildIssueCount;
        let actualSubtaskCount;
        let actualChildIssueCount;
        let actualEpicIssueCount;
        let epicIssueCount;
        const subtasks = (0, $7Ow8a.fieldSelector)((0, $fOGZN.SUBTASKS))(state);
        const epicIssues = (0, $7Ow8a.fieldSelector)((0, $fOGZN.EPIC_ISSUES))(state);
        const portfolioChildIssues = (0, $7Ow8a.fieldSelector)((0, $fOGZN.PORTFOLIO_CHILD_ISSUES))(state);
        const getChildIssuesLimitUrl = (0, $7Ow8a.childIssuesLimitUrlSelector)(state);
        const isEpicIssuesOverLimit = Boolean(getChildIssuesLimitUrl((0, $fOGZN.EPIC_ISSUES)));
        const isOverLimit = Boolean(getChildIssuesLimitUrl((0, $fOGZN.SUBTASKS))) || Boolean(getChildIssuesLimitUrl((0, $5fc53.CHILDREN_ISSUES))) || isEpicIssuesOverLimit;
        if (isOverLimit) {
            actualChildIssueCount = childIssues?.originalContentLength ?? 0;
            actualEpicIssueCount = epicIssues?.originalContentLength ?? 0;
            // If epic issue is over the limit, we exclude the subtasks field
            // from the store. So we need to grab the data from the epicIssues field.
            actualSubtaskCount = isEpicIssuesOverLimit ? epicIssues?.otherOriginalChildIssuesLength ?? 0 : subtasks?.originalContentLength ?? 0;
            epicIssueCount = isEpicIssuesOverLimit && issueContextActions ? (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : epicIssues?.originalContentLength ?? 0;
            // If portfolio issue is over the limit, we exclude the portfolio-child-issues field
            // from the store. So we need to grab the data from the subtasks field.
            portfolioChildIssueCount = subtasks?.otherOriginalChildIssuesLength ?? 0;
        } else {
            actualChildIssueCount = childIssues?.value.length ?? 0;
            actualSubtaskCount = subtasks?.value.length ?? 0;
            actualEpicIssueCount = epicIssues?.value.length ?? 0;
            portfolioChildIssueCount = portfolioChildIssues?.value.length ?? 0;
            epicIssueCount = actualEpicIssueCount;
        }
        let iframeCount = null;
        // This is is to check if the document is undefined in SSR. See https://hello.atlassian.net/wiki/x/jnEv2w
        if (typeof document !== 'undefined') iframeCount = document?.querySelectorAll('iframe')?.length;
        // Properties added here show up in:
        // - jira.fe.custom.issue-view-on-page-load
        // - jira.fe.page-load.issue-view
        // - and jira.fe.custom.embedded-issue-view-load
        // Verify these in the BM3 tab of the Chrome Analytics extension.
        return {
            ecosystemGlances: (0, $gYUjk.glancesSelector)(state).length,
            ecosystemContentPanels: (0, $gYUjk.allContentPanelsSelector)(state).length,
            contextPanelOpenCount: contextPanelOpenCount,
            contextPanelClosedCount: contextPanelClosedCount,
            ecosystemActivityPanels: (0, $gYUjk.activityPanelsSelector)(state).length,
            iframeCount: iframeCount,
            hasIframe: Boolean(iframeCount),
            ecosystemCustomsFields: (0, $hwyJi.ecosystemCustomFieldIdsSelector)(state).length,
            childIssues: childIssuesCount,
            linkIssueCount: (0, $9acDX.combinedLinkedIssueCountSelector)(state),
            subtaskCount: subtaskCount,
            actualChildIssueCount: actualChildIssueCount,
            actualSubtaskCount: actualSubtaskCount,
            actualEpicIssueCount: actualEpicIssueCount,
            actualPortfolioChildIssueCount: portfolioChildIssueCount,
            epicIssueCount: epicIssueCount,
            portfolioChildIssueCount: portfolioChildIssueCount,
            issueId: (0, $a1ky2.issueIdSelector)(state),
            commentsTotalCount: (0, $d4MOh.totalCommentsSelector)(state),
            hasCommentPermalink: permalinkType === (0, $dvijh.COMMENTS),
            cascadingSelectCount: $1f39c5825b4f5e5a$var$getCascadingSelectFields(state).length,
            isAtlassianTeamFieldEnabled: $1f39c5825b4f5e5a$var$getAtlassianTeamFields(state).length > 0,
            cascadingSelectOptionsTotalCount: $1f39c5825b4f5e5a$var$getCascadingSelectOptionsTotalCount(state),
            proformaHarmonisationEnabled: proformaHarmonisation ? proformaHarmonisation.value.isHarmonisationEnabled : false,
            hasSubtasksTypes: (0, $3Ke60.isSubtaskTypesPresentSelector)(state),
            issueTypesCount: (0, $ifezr.issueTypesSelector)(state).length,
            issueTypeHierarchyLevel: !(0, $bcoYn.isSimplifiedProjectSelector)(state) ? (0, $lssfC.issueTypeHierarchyLevelSelector)(state) : (0, $jMY7o.hierarchyLevelSelector)(state)
        };
    };

});
const $135ded4f9a1460dc$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $135ded4f9a1460dc$export$e1184c3be46bd7cb = false;
const $135ded4f9a1460dc$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $135ded4f9a1460dc$export$988f0f6f6457039a = 'status-and-approval-spotlight';

parcelRegister("kuVxL", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimitExceededAnalyticsCount", () => $352d0cb4ab81075d$export$8cbe27041ec414b7);
const $352d0cb4ab81075d$export$1e3c128c36bad9a4 = 'CHILD_ISSUES_LIMIT_EXCEEDED';
const $352d0cb4ab81075d$export$8cbe27041ec414b7 = (childIssuesLimit)=>`>${childIssuesLimit}`;

});

parcelRegister("i84pu", function(module, exports) {

$parcel$export(module.exports, "getGroupLocalStorageName", () => $28741fb0cc9e4bb5$export$a3b190a19b138f2e);
$parcel$export(module.exports, "isGroupPanelOpen", () => $28741fb0cc9e4bb5$export$e79995f22545fd3e);
$parcel$export(module.exports, "getGroupsLocalStorage", () => $28741fb0cc9e4bb5$export$d0a5ccc42f3bcd33);
$parcel$export(module.exports, "useGroupLocalStorage", () => $28741fb0cc9e4bb5$export$4e1a840a45fb467c);

var $5uXOq = parcelRequire("5uXOq");
const $28741fb0cc9e4bb5$export$a3b190a19b138f2e = (projectKey, id)=>`group.state.${projectKey}.${id}`;
const $28741fb0cc9e4bb5$export$a7e7b7df48874d2c = (keyName, defaultValue)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const item = window.localStorage.getItem(keyName);
        if (item === 'true') return true;
        if (item === 'false') return false;
        throw Error('Invalid group state value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return defaultValue;
    }
};
const $28741fb0cc9e4bb5$export$e79995f22545fd3e = (projectKey, group, panelId, defaultValue)=>{
    const groupLocalStorageName = $28741fb0cc9e4bb5$export$a3b190a19b138f2e(projectKey, group);
    return $28741fb0cc9e4bb5$export$a7e7b7df48874d2c(`${groupLocalStorageName}-${panelId}`, defaultValue);
};
const $28741fb0cc9e4bb5$export$d0a5ccc42f3bcd33 = (keyNames, initialOpened)=>{
    const items = {};
    keyNames.forEach((key)=>{
        items[key] = $28741fb0cc9e4bb5$export$a7e7b7df48874d2c(key, initialOpened);
    });
    return items;
};
const $28741fb0cc9e4bb5$export$4e1a840a45fb467c = (projectKey, id, initialOpened)=>{
    const keyName = $28741fb0cc9e4bb5$export$a3b190a19b138f2e(projectKey, id);
    const [storedValue, setStoredValue] = (0, $5uXOq.useState)(()=>$28741fb0cc9e4bb5$export$a7e7b7df48874d2c(keyName, initialOpened));
    const setValue = (0, $5uXOq.useCallback)((value)=>{
        try {
            setStoredValue(value);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.localStorage.setItem(keyName, String(value));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (_) {
        // Not decided what we do when we reach here.
        }
    }, [
        keyName
    ]);
    return [
        storedValue,
        setValue
    ];
};

});

parcelRegister("b5LNN", function(module, exports) {

$parcel$export(module.exports, "shouldHideNullUneditableField", () => $8e792d10938fd7f7$export$e7987ba89f8e2996);
$parcel$export(module.exports, "ecosystemGlancesToLayoutItem", () => $8e792d10938fd7f7$export$8dd9174e11169a13);
$parcel$export(module.exports, "ecosystemContextsToLayoutItem", () => $8e792d10938fd7f7$export$ff0381f8ed1f6cc7);
$parcel$export(module.exports, "useForgeGlancesAsLayoutItems", () => $8e792d10938fd7f7$export$969c8278a214a2d9);
$parcel$export(module.exports, "useForgeContextPanelsAsLayoutItems", () => $8e792d10938fd7f7$export$b4095ac407369aa0);
$parcel$export(module.exports, "addChangeboardingRefToFirstItem", () => $8e792d10938fd7f7$export$b7aff69af7ee8f70);
$parcel$export(module.exports, "getPinnedFieldItems", () => $8e792d10938fd7f7$export$7fc9f8048722ede9);
$parcel$export(module.exports, "generateContextPanelId", () => $8e792d10938fd7f7$export$c55ff2c236d30544);

var $1sWm7 = parcelRequire("1sWm7");

var $5cmSg = parcelRequire("5cmSg");

var $2gCtH = parcelRequire("2gCtH");

var $3fAi8 = parcelRequire("3fAi8");

var $41gqO = parcelRequire("41gqO");

var $awmXl = parcelRequire("awmXl");


var $cUUmI = parcelRequire("cUUmI");

var $fOGZN = parcelRequire("fOGZN");

var $2ewrm = parcelRequire("2ewrm");


var $vuOaC = parcelRequire("vuOaC");

var $5fc53 = parcelRequire("5fc53");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");
const $8e792d10938fd7f7$export$87af144309c7a3c5 = (canLogTime, isNativeJiraTimeTrackingEnabled)=>// Here we assume that if the time tracking field is an available field
    // but isNativeJiraTimeTrackingEnabled is false, a 3rd party time tracking app is installed.
    isNativeJiraTimeTrackingEnabled ? !canLogTime : false;
const $8e792d10938fd7f7$var$getFieldByCustomType = (customType, fieldsConfiguration)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(fieldsConfiguration, (field)=>(field.schema && field.schema.custom) === customType);
const $8e792d10938fd7f7$var$getFieldConfiguration = (fieldId, fields)=>{
    const field = fields[fieldId];
    const customSystemFields = (0, $fOGZN.specialFields)();
    const condition = !field && Object.prototype.hasOwnProperty.call(customSystemFields, fieldId);
    if (condition) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        return $8e792d10938fd7f7$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $8e792d10938fd7f7$export$e7987ba89f8e2996 = (itemId, issueFieldsConfig, value, canLogTime, isNativeJiraTimeTrackingEnabled)=>{
    const fieldConfig = $8e792d10938fd7f7$var$getFieldConfiguration(itemId, issueFieldsConfig);
    const fieldType = (0, $vuOaC.getFieldType)(fieldConfig);
    if ((0, $vuOaC.getPanels)().includes(itemId)) return false;
    if (!fieldConfig || fieldType === undefined) return true;
    if ((0, $vuOaC.isEmpty)(value) && !fieldConfig.isEditable) {
        if (itemId === (0, $5fc53.ASSIGNEE_TYPE) || fieldType === (0, $5fc53.REQUEST_TYPE_CF_TYPE) || fieldType === (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)) return false;
        // ARKEN-40: Forge custom fields with readonly and an empty value must still be shown as primary or secondary items
        if ((0, $cUUmI.isForgeField)(fieldConfig)) return false;
        if (itemId === (0, $5fc53.TIME_TRACKING_TYPE)) return $8e792d10938fd7f7$export$87af144309c7a3c5(canLogTime, isNativeJiraTimeTrackingEnabled);
        return true;
    }
    return false;
};
const $8e792d10938fd7f7$export$8dd9174e11169a13 = (ecosystemGlances)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = Object.keys(ecosystemGlances).reduce((acc, next)=>{
        const ecosystem = ecosystemGlances[next];
        const modules = Object.keys(ecosystem).map((moduleKey)=>ecosystem[moduleKey]);
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...acc,
            ...modules
        ];
    }, []);
    return result.map((connectGlance)=>({
            id: `${0, $5fc53.ECOSYSTEM_GLANCE_TYPE}__${connectGlance.appKey}__${connectGlance.moduleKey}`,
            type: (0, $5fc53.ECOSYSTEM_GLANCE_TYPE),
            payload: {
                ...connectGlance,
                glanceType: (0, $awmXl.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $8e792d10938fd7f7$export$ff0381f8ed1f6cc7 = (ecosystemContextPanels)=>{
    const contextPanels = [];
    Object.values(ecosystemContextPanels).forEach((contextPanelObject)=>{
        contextPanels.push(Object.values(contextPanelObject)[0]);
    });
    return contextPanels.map((connectContextPanel)=>({
            id: `${0, $5fc53.ECOSYSTEM_CONTEXT_TYPE}__${connectContextPanel.appKey}__${connectContextPanel.moduleKey}`,
            type: (0, $5fc53.ECOSYSTEM_CONTEXT_TYPE),
            payload: {
                ...connectContextPanel,
                contextPanelType: (0, $awmXl.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $8e792d10938fd7f7$var$ISSUE_TYPE = 'issuetype';
const $8e792d10938fd7f7$export$ea6c3ae2bd3a5510 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const issueId = (0, $2gCtH.useIssueId)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const [permissions] = (0, $17Gip.useProjectPermissions)(projectKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const [issueType] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: $8e792d10938fd7f7$var$ISSUE_TYPE
    });
    return {
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType && issueType.name,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Prop normalisation copied from original redux selector - Props names are exposed externally.
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers
    };
};
const $8e792d10938fd7f7$export$969c8278a214a2d9 = ()=>{
    const [forgeGlances] = (0, $2ewrm.useForgeGlances)();
    return forgeGlances.filter((extension)=>(0, $5cmSg.isExtensionVisible)(extension)).map((forgeGlance)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = forgeGlance;
        return {
            id: id,
            type: (0, $5fc53.FORGE_GLANCE_TYPE),
            payload: {
                label: label,
                title: title,
                status: status,
                icon: icon,
                extension: forgeGlance,
                glanceType: (0, $f17db2727085e590$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id
            }
        };
    });
};
const $8e792d10938fd7f7$export$b4095ac407369aa0 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const { ecosystemEnabled: ecosystemEnabled } = (0, $93Yeu.useProjectConfiguration)(projectKey);
    const [forgeContextPanels] = (0, $2ewrm.useForgeContextPanels)();
    if (!ecosystemEnabled) return [];
    return forgeContextPanels.filter((extension)=>(0, $5cmSg.isExtensionVisible)(extension)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $41gqO.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $41gqO.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                extension: contextPanels,
                contextPanelType: (0, $f17db2727085e590$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
};
const $8e792d10938fd7f7$export$b7aff69af7ee8f70 = (items)=>{
    let wrapperAdded = false;
    const allowedTypes = [
        (0, $41gqO.layoutContainerItemTypes).field,
        (0, $41gqO.layoutContainerItemTypes).panel
    ];
    const disallowedIds = [
        (0, $5fc53.ASSIGNEE_TYPE),
        (0, $5fc53.SLA_PANEL_TYPE)
    ];
    return items.map((item)=>{
        const typename = item.type !== undefined ? item.type : '';
        // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
        if (!wrapperAdded && !disallowedIds.includes(item.id) && allowedTypes.includes(typename)) {
            wrapperAdded = true;
            // if it was added to csat field and csat field to be removed later in servicedesk template, this effectively won't work
            return {
                ...item,
                globalRef: (0, $acf4ef636a959927$export$95ff4d03075475e2)
            };
        }
        return item;
    });
};
const $8e792d10938fd7f7$export$7fc9f8048722ede9 = (dedupedItems, pinnedFields)=>pinnedFields.reduce((result, pinnedId)=>{
        const item = dedupedItems.find((dedupedItem)=>dedupedItem.type === (0, $41gqO.layoutContainerItemTypes).field && dedupedItem.fieldItemId === pinnedId || dedupedItem.type === (0, $41gqO.layoutContainerItemTypes).panel && dedupedItem.panelItemId === pinnedId);
        if (item !== undefined) result.push(item);
        return result;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
const $8e792d10938fd7f7$export$c55ff2c236d30544 = ({ appKey: appKey, moduleKey: moduleKey })=>`${0, $5fc53.ECOSYSTEM_CONTEXT_TYPE}__${appKey}__${moduleKey}`;

});
parcelRegister("41gqO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $b08b2795aecf222d$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $b08b2795aecf222d$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $b08b2795aecf222d$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $b08b2795aecf222d$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $b08b2795aecf222d$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $b08b2795aecf222d$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $b08b2795aecf222d$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $b08b2795aecf222d$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $b08b2795aecf222d$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $b08b2795aecf222d$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $b08b2795aecf222d$export$ad3536b13febb432);
const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $b08b2795aecf222d$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;

});

parcelRegister("awmXl", function(module, exports) {

$parcel$export(module.exports, "FORGE_ENTITY_TYPE", () => $c65c130bf8cdb044$export$6f3804b3f188f650);
$parcel$export(module.exports, "CONNECT_ENTITY_TYPE", () => $c65c130bf8cdb044$export$1b2059a011c9174d);
const $c65c130bf8cdb044$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
const $c65c130bf8cdb044$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $c65c130bf8cdb044$export$38f0fc1cf1f24cba = [
    $c65c130bf8cdb044$export$6f3804b3f188f650,
    $c65c130bf8cdb044$export$1b2059a011c9174d
];

});

/**
 * Opt into the new issue view modal key. To be cleaned up with issue.details.opt-back-in
 * This key is stored in the API and should not be renamed.
 * @see https://hello.atlassian.net/wiki/spaces/JIE/pages/920124493/How+to+re-set+new+Bento+Change+Boarding#Re-set-Opt-In-Back-Modal
 */ const $acf4ef636a959927$export$a3338d0a4845edfa = 'jira.details.opt-in-back.next-reminding-date';
const $acf4ef636a959927$export$26de4b42c139644c = 'jira.user.issue.should.show.welcome.message';
const $acf4ef636a959927$export$ece45f325779a5d5 = 'jira.user.issue.opt.in.back.modal.has.dismissed';
const $acf4ef636a959927$export$4603581e6066a63f = 'jira.user.issue.opt.in.back.banner.has.dismissed';
const $acf4ef636a959927$export$af60a7ae4202be66 = 'issue-details-changeboarding';
const $acf4ef636a959927$export$7b98e5a33c854454 = 30;
const $acf4ef636a959927$export$956fcd3a2e5c48a8 = 'SOFTWARE_ISSUE_STATUS';
const $acf4ef636a959927$export$ebb7dcd60318cfac = 'SERVICEDESK_ISSUE_STATUS';
const $acf4ef636a959927$export$a446d697df3d6b2c = 'SERVICEDESK_REQUEST_PANEL';
const $acf4ef636a959927$export$d3dadb39db0c423 = 'SERVICEDESK_CREATE_COMMENT_ACTIONS';
const $acf4ef636a959927$export$75867eab2abae162 = 'SERVICEDESK_PLACEHOLDER_CREATE_COMMENT_ACTIONS';
const $acf4ef636a959927$export$483d9bcbbd8280a6 = 'status-spotlight';
const $acf4ef636a959927$export$95f98990d7202b31 = 'SHOW_MORE';
const $acf4ef636a959927$export$95ff4d03075475e2 = 'PIN_FIELD';
const $acf4ef636a959927$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $acf4ef636a959927$export$6f48b612d5c03f4d = 'PERMALINK';
const $acf4ef636a959927$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $acf4ef636a959927$export$fa5ad81958817beb = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.details-group';
const $acf4ef636a959927$export$1ba8bc5ff9e50d09 = 'QUICK_ADDS';
const $acf4ef636a959927$export$f9baa44349b5d6b8 = 'JSW_ACTIVITY_FEED_BUTTONS';
const $acf4ef636a959927$export$f49830a0e4ffb3f9 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.sla-group';
const $acf4ef636a959927$export$efb12103a5e32a1e = 'PIN_FIELD_PLACEHOLDER_BANNER';
const $acf4ef636a959927$export$4288bce987c22af4 = 'PINNED_FIELDS_PANEL';
const $acf4ef636a959927$export$ddb80c23a62a41e = 'jira.user.issue.has.seen.quick-actions.change-boarding.message';

parcelRegister("cUUmI", function(module, exports) {

$parcel$export(module.exports, "isForgeField", () => $15b9f0b6efc77660$export$f4484ef180517e0e);
$parcel$export(module.exports, "getForgeFieldType", () => $15b9f0b6efc77660$export$3f8bcfe7fea0362a);

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $5fc53 = parcelRequire("5fc53");
const $15b9f0b6efc77660$export$f4484ef180517e0e = (field)=>field && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(field, 'schema.custom') && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(field.schema.custom) && field.schema.custom.includes('ari:cloud:ecosystem::extension');
const $15b9f0b6efc77660$export$3f8bcfe7fea0362a = (field)=>{
    if (!$15b9f0b6efc77660$export$f4484ef180517e0e(field)) return null;
    if (false) return field.schema.type;
    return 0, $5fc53.FORGE_CUSTOM_FIELD_TYPE;
};

});

parcelRegister("2ewrm", function(module, exports) {

$parcel$export(module.exports, "useForgeGlances", () => $27dec4fa64c988e8$export$dc79f3e7b8a6c3e1);
$parcel$export(module.exports, "useForgeContextPanels", () => $27dec4fa64c988e8$export$a1a589b738ca01b8);
$parcel$export(module.exports, "useForgeDataComplete", () => $27dec4fa64c988e8$export$db75d05b888b2963);
$parcel$export(module.exports, "useForgeCustomField", () => $27dec4fa64c988e8$export$2a006c08e9ab6fc3);
$parcel$export(module.exports, "useForgeActions", () => $27dec4fa64c988e8$export$4f3ebb446fd03f21);
$parcel$export(module.exports, "useForgeLoadingFailed", () => $27dec4fa64c988e8$export$25b2fc6a75c5447b);
$parcel$export(module.exports, "useForgeUimModules", () => $27dec4fa64c988e8$export$37d5ed3ba137e5df);
$parcel$export(module.exports, "useHasBlockedExtensions", () => $27dec4fa64c988e8$export$955dca49c49bfb60);
$parcel$export(module.exports, "useBlockedExtensions", () => $27dec4fa64c988e8$export$61349d0d8e89be3);
$parcel$export(module.exports, "useIsForgeDataEmpty", () => $27dec4fa64c988e8$export$57f2fa4b04feb8c2);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $f7nug = parcelRequire("f7nug");

var $dknBT = parcelRequire("dknBT");
const $27dec4fa64c988e8$export$dc79f3e7b8a6c3e1 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return [
        forge.issueGlance
    ];
};
const $27dec4fa64c988e8$export$a1a589b738ca01b8 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return [
        forge.issueContext
    ];
};
const $27dec4fa64c988e8$export$db75d05b888b2963 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return [
        forge.isForgeDataComplete
    ];
};
const $27dec4fa64c988e8$export$1a3a35919478733d = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return [
        [
            ...forge.customField,
            ...forge.customFieldType
        ]
    ];
};
const $27dec4fa64c988e8$export$2a006c08e9ab6fc3 = (extensionId)=>{
    const [customFieldExtensions] = $27dec4fa64c988e8$export$1a3a35919478733d();
    return (0, $f7nug.useMemoizedStateObject)((0, $5uXOq.useMemo)(()=>customFieldExtensions.find((ext)=>ext.id === extensionId), [
        customFieldExtensions,
        extensionId
    ]));
};
const $27dec4fa64c988e8$export$4f3ebb446fd03f21 = ()=>{
    const [, actions] = (0, $dknBT.useForgeActionsStore)();
    return [
        undefined,
        actions
    ];
};
const $27dec4fa64c988e8$export$25b2fc6a75c5447b = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return forge.isForgeLoadingFailed;
};
const $27dec4fa64c988e8$export$37d5ed3ba137e5df = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return forge.uiModifications;
};
const $27dec4fa64c988e8$export$955dca49c49bfb60 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!forge.blockedExtensions) return false;
        const toOmit = [
            'issueViewBackgroundScript',
            'uiModifications'
        ];
        return Object.values((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(forge.blockedExtensions, toOmit)).some((blockedExtensions)=>blockedExtensions.length > 0);
    }, [
        forge.blockedExtensions
    ]);
};
const $27dec4fa64c988e8$export$61349d0d8e89be3 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return forge.blockedExtensions;
};
const $27dec4fa64c988e8$export$57f2fa4b04feb8c2 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    const isExtensionsEmpty = Object.keys(forge).every((key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        Array.isArray(forge[key]) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        forge[key].length === 0 : true);
    const isBlockedExtensionsEmpty = Object.keys(forge.blockedExtensions).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (key)=>forge.blockedExtensions[key].length === 0);
    return isExtensionsEmpty && isBlockedExtensionsEmpty;
};

});
parcelRegister("f7nug", function(module, exports) {

$parcel$export(module.exports, "useMemoizedStateObject", () => $8c9f7903bb5ef000$export$cc725e2aa41de44a);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
const $8c9f7903bb5ef000$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))))=>{
    const memoizedData = (0, $5uXOq.useRef)(data);
    return (0, $5uXOq.useMemo)(()=>{
        if (!equalityCheck(data, memoizedData.current)) {
            memoizedData.current = data;
            return data;
        }
        return memoizedData.current;
    }, [
        data,
        equalityCheck
    ]);
};

});

parcelRegister("dknBT", function(module, exports) {

$parcel$export(module.exports, "useForgeStore", () => $2746553070b63d5f$export$10f3118dc1498dfc);
$parcel$export(module.exports, "useForgeActionsStore", () => $2746553070b63d5f$export$7dd6be1114d73937);
$parcel$export(module.exports, "ForceStoreContainer", () => $2746553070b63d5f$export$540c057b33607be9);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $e1HQk = parcelRequire("e1HQk");
const $2746553070b63d5f$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-view-layout-forge-apps-service',
    initialState: {
        issueGlance: [],
        issueContext: [],
        issueAction: [],
        issuePanel: [],
        issueActivity: [],
        customField: [],
        issueViewBackgroundScript: [],
        customFieldType: [],
        activeAction: null,
        uiModifications: [],
        isForgeLoadingFailed: false,
        isForgeDataComplete: false,
        blockedExtensions: {
            issueGlance: [],
            issueContext: [],
            issueAction: [],
            issuePanel: [],
            issueActivity: [],
            customField: [],
            issueViewBackgroundScript: [],
            customFieldType: [],
            uiModifications: []
        },
        // Not rate limited
        forgeRateLimitedUntil: 0,
        failedEventsCount: 0
    },
    actions: $e1HQk
});
const $2746553070b63d5f$export$10f3118dc1498dfc = (0, $3sQ5x.createHook)($2746553070b63d5f$export$6f57813fe9f31bf9);
const $2746553070b63d5f$export$7dd6be1114d73937 = (0, $3sQ5x.createHook)($2746553070b63d5f$export$6f57813fe9f31bf9, {
    selector: null
});
const $2746553070b63d5f$export$540c057b33607be9 = (0, $gg7kZ.createContainer)($2746553070b63d5f$export$6f57813fe9f31bf9);

});
parcelRegister("e1HQk", function(module, exports) {

$parcel$export(module.exports, "setForge", () => $02561657ceb6a564$export$8307a9da1b91b3b4);
$parcel$export(module.exports, "setForgeLoadingFailed", () => $02561657ceb6a564$export$7ff580b28fd472d0);
const $02561657ceb6a564$export$8307a9da1b91b3b4 = (forge)=>({ setState: setState })=>{
        setState(forge);
    };
const $02561657ceb6a564$export$7ff580b28fd472d0 = ()=>({ setState: setState })=>{
        setState({
            isForgeLoadingFailed: true
        });
    };

});



const $f17db2727085e590$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';

parcelRegister("vuOaC", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $61748c84e0a1e553$export$be078297eeb6e8a2);
$parcel$export(module.exports, "isEmpty", () => $61748c84e0a1e553$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getAtlassianCustomFieldType", () => $61748c84e0a1e553$export$f521834fc2bfcd81);
$parcel$export(module.exports, "fieldTypeHandler", () => $61748c84e0a1e553$export$b2cc0ead6ce019e3);
$parcel$export(module.exports, "getFieldType", () => $61748c84e0a1e553$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "addGlobalRefToLayoutContainerTemplateItems", () => $61748c84e0a1e553$export$fa197d31f946730e);
$parcel$export(module.exports, "isUnsupportedItem", () => $61748c84e0a1e553$export$3d38168d24278ebb);

var $8LQ84 = parcelRequire("8LQ84");

var $hGgHi = parcelRequire("hGgHi");

var $1QOns = parcelRequire("1QOns");

var $8QpSo = parcelRequire("8QpSo");

var $aIZdc = parcelRequire("aIZdc");

var $4R6GH = parcelRequire("4R6GH");

var $41gqO = parcelRequire("41gqO");


var $cUUmI = parcelRequire("cUUmI");

var $fOGZN = parcelRequire("fOGZN");

var $cNJ33 = parcelRequire("cNJ33");

var $5fc53 = parcelRequire("5fc53");
const $61748c84e0a1e553$export$be078297eeb6e8a2 = ()=>[
        (0, $5fc53.ASSET_ONBOARDING_TYPE),
        (0, $5fc53.DEV_SUMMARY_TYPE),
        (0, $5fc53.KNOWLEDGE_BASE_TYPE),
        ...(0, $4R6GH.fg)('jsm-journey-builder-in-issue-view') ? [
            (0, $5fc53.JOURNEY_PANEL_TYPE)
        ] : [],
        (0, $5fc53.SENTIMENT_TYPE),
        (0, $5fc53.SLA_PANEL_TYPE),
        (0, $5fc53.LINKED_ALERTS_TYPE),
        ...(0, $aIZdc.isFedRamp)() ? [] : [
            (0, $5fc53.CHAT_CHANNEL_TYPE)
        ],
        ...(0, $aIZdc.isFedRamp)() ? [] : [
            (0, $5fc53.MSTEAMS_CHANNEL_TYPE)
        ],
        ...(0, $aIZdc.isFedRamp)() ? [] : [
            (0, $5fc53.ZOOM_MEETING_TYPE)
        ],
        (0, $5fc53.MANAGE_STAKEHOLDERS_TYPE)
    ];
const $61748c84e0a1e553$export$dd1bc94b04021eeb = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(value) && value.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(value) && Object.keys(value).length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(value) && value.type === 'doc' && value.content && Object.keys(value.content).length === 0;
const $61748c84e0a1e553$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $fOGZN.specialFields)();
    return [
        ...(0, $fOGZN.customFieldsToDisplay)().filter((cf)=>!(0, $fOGZN.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $5fc53.FLAGGED_CF_TYPE)
    ];
};
const $61748c84e0a1e553$export$f521834fc2bfcd81 = (custom)=>$61748c84e0a1e553$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $61748c84e0a1e553$export$b2cc0ead6ce019e3 = (fieldConfig, layoutItem)=>{
    const id = (0, $cNJ33.getLayoutItemId)(layoutItem);
    const { type: type } = layoutItem;
    if (type === (0, $41gqO.layoutContainerItemTypes).tab || type === (0, $5fc53.ECOSYSTEM_GLANCE_TYPE) || type === (0, $5fc53.FORGE_GLANCE_TYPE) || type === (0, $5fc53.ECOSYSTEM_CONTEXT_TYPE) || type === (0, $41gqO.FORGE_CONTEXT_TYPE)) return {
        type: type,
        id: id
    };
    if ($61748c84e0a1e553$export$be078297eeb6e8a2().includes(id)) return {
        id: id,
        type: id
    };
    const forgeCustomField = (0, $cUUmI.getForgeFieldType)(fieldConfig);
    if (forgeCustomField !== null) return {
        type: forgeCustomField,
        id: id
    };
    const fieldSchema = fieldConfig?.schema || {};
    const systemType = fieldSchema.system !== null ? fieldSchema.system : '';
    return {
        type: $61748c84e0a1e553$export$f521834fc2bfcd81(fieldSchema.custom) || systemType || fieldSchema.type,
        id: id
    };
};
const $61748c84e0a1e553$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $61748c84e0a1e553$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
/**
 * We can't directly identify `Affected services`, `Change risk` or `Impact`, but we can
 * minimise the number of extra targets by wrapping only 'select' type fields since the above
 * all fit that criteria. `Description` fortunately has a custom type to identify it
 */ const $61748c84e0a1e553$var$fieldsWithGlobalTargets = [
    (0, $5fc53.DESCRIPTION_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.SERVICE_ENTITY_CF_TYPE)
];
const $61748c84e0a1e553$export$fa197d31f946730e = (// Use generic to constrain return type, e.g., passing ContextPanelItem should not return LayoutContainerTemplateItem
items, issueFieldsConfig)=>{
    if (!items || !issueFieldsConfig) return [];
    return items.map((item)=>{
        const { type: type, id: id } = $61748c84e0a1e553$export$b2cc0ead6ce019e3(issueFieldsConfig[(0, $cNJ33.getLayoutItemId)(item)], item);
        if ($61748c84e0a1e553$var$fieldsWithGlobalTargets.includes(type)) return {
            ...item,
            globalRef: `${0, $135ded4f9a1460dc$export$2028cf1423b28cf8}${id}`
        };
        return item;
    });
};
// This typing exists to ensure that we include fields here when adding new ones.
const $61748c84e0a1e553$var$getBaseSupportedItems = (0, $8QpSo.default)(()=>{
    return {
        // @ts-expect-error - TS2322 - Type '{ ecosystemGlance: boolean; forgeGlance: boolean; "com.pyxis.greenhopper.jira:gh-epic-status": true; "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect": true; assignee: true; ... 75 more ...; "com.pyxis.greenhopper.jira:gh-epic-label": true; }' is not assignable to type 'CheckFieldTypeDefinitions<CheckedLegacyFieldTypeDefinitions<boolean>, IgnoredFieldChecks<boolean>>'.
        [(0, $5fc53.ECOSYSTEM_GLANCE_TYPE)]: true,
        [(0, $5fc53.FORGE_GLANCE_TYPE)]: true,
        [(0, $41gqO.FORGE_CONTEXT_TYPE)]: true,
        [(0, $5fc53.ECOSYSTEM_CONTEXT_TYPE)]: true,
        [(0, $5fc53.EPIC_STATUS_TYPE)]: true,
        [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: true,
        [(0, $5fc53.ASSIGNEE_TYPE)]: true,
        [(0, $5fc53.REPORTER_TYPE)]: true,
        [(0, $5fc53.DESCRIPTION_TYPE)]: true,
        [(0, $5fc53.ENVIRONMENT_TYPE)]: true,
        [(0, $5fc53.DUE_DATE_TYPE)]: true,
        [(0, $5fc53.PRIORITY_TYPE)]: true,
        [(0, $5fc53.LABELS_TYPE)]: true,
        [(0, $5fc53.COMPONENTS_TYPE)]: true,
        [(0, $5fc53.SPRINT_TYPE)]: true,
        [(0, $5fc53.STORY_POINTS_TYPE)]: true,
        [(0, $5fc53.EPIC_TYPE)]: true,
        [(0, $5fc53.FIX_VERSIONS_TYPE)]: true,
        [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: true,
        [(0, $5fc53.TIME_TRACKING_TYPE)]: true,
        [(0, $5fc53.TIME_ESTIMATE_TYPE)]: true,
        [(0, $5fc53.LABELS_CF_TYPE)]: true,
        [(0, $5fc53.TEXT_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_USER_CF_TYPE)]: true,
        [(0, $5fc53.PARTICIPANTS_CF_TYPE)]: true,
        [(0, $5fc53.URL_CF_TYPE)]: true,
        [(0, $5fc53.NUMBER_CF_TYPE)]: true,
        [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: true,
        [(0, $5fc53.SELECT_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: true,
        [(0, $5fc53.VERSION_CF_TYPE)]: true,
        [(0, $5fc53.TEXT_AREA_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: true,
        [(0, $5fc53.DATE_CF_TYPE)]: true,
        [(0, $5fc53.GROUP_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: true,
        [(0, $5fc53.USER_CF_TYPE)]: true,
        [(0, $5fc53.PEOPLE_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: true,
        [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: true,
        [(0, $5fc53.DATETIME_CF_TYPE)]: true,
        [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: true,
        [(0, $5fc53.TEAM_CF_TYPE)]: true,
        [(0, $5fc53.PARENT_CF_TYPE)]: true,
        [(0, $5fc53.PARENT_FIELD_TYPE)]: true,
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: true,
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: true,
        [(0, $5fc53.COLOR_CF_TYPE)]: true,
        [(0, $5fc53.REQUEST_TYPE_CF_TYPE)]: true,
        [(0, $5fc53.APPROVALS_CF_TYPE)]: true,
        [(0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)]: true,
        [(0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE)]: true,
        [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)]: true,
        [(0, $5fc53.ASSETS_CF_TYPE)]: true,
        [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: true,
        [(0, $5fc53.APPROVERS_LIST_CF_TYPE)]: true,
        [(0, $5fc53.CMDB_OBJECT_CF_TYPE)]: true,
        [(0, $5fc53.REQUEST_FEEDBACK_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_USER_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_GROUPS_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_STRINGS_CF_TYPE)]: true,
        [(0, $5fc53.READ_ONLY_CF_TYPE)]: true,
        [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: true,
        [(0, $5fc53.FORGE_CUSTOM_FIELD_TYPE)]: true,
        [(0, $5fc53.KNOWLEDGE_BASE_TYPE)]: true,
        [(0, $5fc53.JOURNEY_PANEL_TYPE)]: !false && (0, $4R6GH.fg)('jsm-journey-builder-in-issue-view'),
        [(0, $5fc53.SLA_PANEL_TYPE)]: true,
        [(0, $5fc53.SENTIMENT_TYPE)]: true,
        [(0, $5fc53.DEV_SUMMARY_TYPE)]: true,
        [(0, $5fc53.RELEASES_TYPE)]: true,
        [(0, $5fc53.ASSET_ONBOARDING_TYPE)]: true,
        [(0, $5fc53.LINKED_ALERTS_TYPE)]: true,
        [(0, $5fc53.CHAT_CHANNEL_TYPE)]: !false && !(0, $aIZdc.isFedRamp)(),
        [(0, $5fc53.MSTEAMS_CHANNEL_TYPE)]: !false && !(0, $aIZdc.isFedRamp)(),
        [(0, $5fc53.ZOOM_MEETING_TYPE)]: !false && !(0, $aIZdc.isFedRamp)(),
        [(0, $5fc53.MANAGE_STAKEHOLDERS_TYPE)]: !false,
        [(0, $5fc53.RESPONDERS_CF_TYPE)]: true,
        [(0, $5fc53.MAJOR_INCIDENT_CF_TYPE)]: true,
        [(0, $5fc53.MESSAGE_EDIT_CF_TYPE)]: true,
        [(0, $5fc53.MESSAGE_VIEW_CF_TYPE)]: true,
        [(0, $5fc53.EPIC_NAME_TYPE)]: true,
        [(0, $5fc53.CATEGORY_TYPE)]: true,
        [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: true,
        [(0, $5fc53.SENTIMENT_CF_TYPE)]: true,
        [(0, $5fc53.GOALS_CF_TYPE)]: true,
        [(0, $5fc53.ORGANIZATION_CF_TYPE)]: true
    };
});
const $61748c84e0a1e553$export$3d38168d24278ebb = (type)=>!$61748c84e0a1e553$var$getBaseSupportedItems()[type];

});
parcelRegister("cNJ33", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $0c6b6ff40aad7732$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $0c6b6ff40aad7732$export$355607dae809ec65);

var $41gqO = parcelRequire("41gqO");
const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $41gqO.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $41gqO.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $41gqO.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $41gqO.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});


parcelRegister("17Gip", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $0b32a3d32d712870$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $0b32a3d32d712870$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $0b32a3d32d712870$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $0b32a3d32d712870$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $0b32a3d32d712870$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $0b32a3d32d712870$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $0b32a3d32d712870$export$86c656cdb87052cd);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $khL17 = parcelRequire("khL17");
const $0b32a3d32d712870$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $0b32a3d32d712870$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $0b32a3d32d712870$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $0b32a3d32d712870$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $0b32a3d32d712870$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $0b32a3d32d712870$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $0b32a3d32d712870$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $0b32a3d32d712870$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $0b32a3d32d712870$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $khL17.useProjectPermissionsStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("khL17", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $472e428a487a401f$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $472e428a487a401f$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $472e428a487a401f$export$e8436ef485b33bdb);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $l5qXF = parcelRequire("l5qXF");
const $472e428a487a401f$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $472e428a487a401f$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $l5qXF
});
const $472e428a487a401f$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $472e428a487a401f$export$ccfee65526b322ca;
const $472e428a487a401f$export$4919fa09a3d81224 = (0, $3sQ5x.createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
    selector: $472e428a487a401f$var$getProjectPermissionSelector
});
const $472e428a487a401f$export$e8436ef485b33bdb = (0, $3sQ5x.createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("l5qXF", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $f3418fe5fb58759f$export$53f5cc27627e5fe3);
const $f3418fe5fb58759f$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("gYUjk", function(module, exports) {

$parcel$export(module.exports, "issueViewBackgroundScriptsSelector", () => $e729124ed69c9647$export$eef935056c1a5112);
$parcel$export(module.exports, "issueContentPanelsSelector", () => $e729124ed69c9647$export$80fcdb58a34c02a8);
$parcel$export(module.exports, "isIssueContentPanelCustomisedSelector", () => $e729124ed69c9647$export$7d77b0f1f3d84166);
$parcel$export(module.exports, "canInstallAddonsSelector", () => $e729124ed69c9647$export$779e1275bbd7ba59);
$parcel$export(module.exports, "isIssueCreatedAfterEcosystemOnSelector", () => $e729124ed69c9647$export$528e2c054f1a65f6);
$parcel$export(module.exports, "contextPanelEntitiesSelector", () => $e729124ed69c9647$export$830512515d42357);
$parcel$export(module.exports, "glancesSelector", () => $e729124ed69c9647$export$d73d3447fc053be);
$parcel$export(module.exports, "ecosystemGlancesSelector", () => $e729124ed69c9647$export$df7140249f849373);
$parcel$export(module.exports, "glancePanelSelector", () => $e729124ed69c9647$export$e8938da368c7c5c4);
$parcel$export(module.exports, "allContentPanelsSelector", () => $e729124ed69c9647$export$7bc028a03185fc96);
$parcel$export(module.exports, "ecosystemAllPanelsSelector", () => $e729124ed69c9647$export$47d3fa7df862ae6f);
$parcel$export(module.exports, "ecosystemAddedContentPanelsSelector", () => $e729124ed69c9647$export$a48c28ad36cb708e);
$parcel$export(module.exports, "selectedContentPanelSelector", () => $e729124ed69c9647$export$1a9c93efcb1ffec7);
$parcel$export(module.exports, "activityPanelsSelector", () => $e729124ed69c9647$export$dd6c9850f9e61a72);
$parcel$export(module.exports, "ecosystemActivityPanelsSelector", () => $e729124ed69c9647$export$9222e43f5478367f);

var $dGvGJ = parcelRequire("dGvGJ");

var $183uB = parcelRequire("183uB");

var $Z1q1o = parcelRequire("Z1q1o");

var $eOKTW = parcelRequire("eOKTW");

var $5cmSg = parcelRequire("5cmSg");

var $awmXl = parcelRequire("awmXl");

var $a2FgJ = parcelRequire("a2FgJ");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");


var $4L22Y = parcelRequire("4L22Y");

var $lMzxr = parcelRequire("lMzxr");
const $e729124ed69c9647$export$eef935056c1a5112 = (0, $dGvGJ.createSelector)((0, $4L22Y.forgeEntitiesSelector), (forge)=>(forge.backgroundScripts || []).filter((0, $5cmSg.isExtensionVisible)));
const $e729124ed69c9647$export$80fcdb58a34c02a8 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.issueContentPanels || []);
const $e729124ed69c9647$export$7d77b0f1f3d84166 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>!!entities.issueContentPanels && entities.issueContentPanels.includes((0, $ad485f85fe233a83$export$bdafa6b589be8b30)));
const $e729124ed69c9647$export$779e1275bbd7ba59 = (0, $dGvGJ.createSelector)((0, $hKi22.canAdministerJiraPermissionsSelector), (canAdministerJira)=>canAdministerJira);
const $e729124ed69c9647$export$528e2c054f1a65f6 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.ecosystem && !!entities.ecosystem.ecosystemOnDate && // @ts-expect-error - TS2345 - Argument of type 'AuthoredTimestamp | undefined' is not assignable to parameter of type 'string'.
    Date.parse(entities.createdDate) > entities.ecosystem.ecosystemOnDate);
const $e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject = (obj)=>Object.keys(obj || {}).flatMap((key)=>Object.values(obj ? obj[key] : {}));
const $e729124ed69c9647$var$glanceEntitiesSelector = (0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.glances || {}));
const $e729124ed69c9647$export$830512515d42357 = (0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.contextPanels));
const $e729124ed69c9647$var$contentPanelsEntitiesSelector = (0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.contentPanels));
const $e729124ed69c9647$var$activityPanelsEntitiesSelector = (0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.activityPanels));
const $e729124ed69c9647$export$7fec16e3d5cd5f4e = (selector)=>(0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), selector, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (ecosystemEnabled, otherSelector)=>ecosystemEnabled && otherSelector || []);
const $e729124ed69c9647$export$d73d3447fc053be = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$var$glanceEntitiesSelector, (glanceEntities)=>glanceEntities.map((entity)=>({
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            name: entity.name,
            icon: entity.icon && entity.icon.url && {
                url: entity.icon.url
            },
            label: entity.label,
            status: entity.status,
            type: entity.type,
            glanceType: (0, $awmXl.CONNECT_ENTITY_TYPE)
        }))));
const $e729124ed69c9647$export$df7140249f849373 = (0, $dGvGJ.createSelector)([
    (0, $lMzxr.forgeGlancesSelector),
    $e729124ed69c9647$export$d73d3447fc053be
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $e729124ed69c9647$export$e8938da368c7c5c4 = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.glances && ecosystem.glances[appKey] && ecosystem.glances[appKey][moduleKey]);
const $e729124ed69c9647$export$7bc028a03185fc96 = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$var$contentPanelsEntitiesSelector, (contentPanelEntities)=>contentPanelEntities));
const $e729124ed69c9647$export$47d3fa7df862ae6f = (0, $dGvGJ.createSelector)([
    (0, $lMzxr.forgePanelsSelector),
    $e729124ed69c9647$export$7bc028a03185fc96
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $e729124ed69c9647$var$panelsComparator = (firstPanel, secondPanel)=>{
    // The sort order rule:
    // 1. Forge panels without quick add button (no dateAdded prop)
    // 2. Forge panels sorted by date added (oldest > newest)
    // 3. Connect panels, sorting criteria won't be changed
    if (firstPanel.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
        // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
        const firstValue = firstPanel.dateAdded || 1;
        if (secondPanel.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
            // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
            const secondValue = secondPanel.dateAdded || 1;
            return firstValue - secondValue;
        }
        return firstValue;
    }
    return Infinity;
};
const $e729124ed69c9647$var$sortPanels = (allPanelsToAddedPanels)=>allPanelsToAddedPanels// @ts-expect-error - TS2769 - No overload matches this call.
    .map((panel)=>[].concat(panel)).sort((firstPanel, secondPanel)=>$e729124ed69c9647$var$panelsComparator(firstPanel[0], secondPanel[0]));
const $e729124ed69c9647$export$b2c15e41218fc96 = (firstActivity, secondActivity)=>{
    // The sort order rule:
    // 1. Forge activity ordered alphabetically.
    // 2. Connect panels, sorting criteria won't be changed
    if (firstActivity.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
        const firstValue = firstActivity.name.toLowerCase();
        if (secondActivity.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
            const secondValue = secondActivity.name.toLowerCase();
            if (firstValue < secondValue) return -Infinity;
            if (firstValue > secondValue) return Infinity;
            return 0;
        }
        return Infinity;
    }
    return Infinity;
};
const $e729124ed69c9647$export$a48c28ad36cb708e = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$export$80fcdb58a34c02a8, $e729124ed69c9647$export$47d3fa7df862ae6f, $e729124ed69c9647$export$7d77b0f1f3d84166, $e729124ed69c9647$export$528e2c054f1a65f6, (0, $a1ky2.analyticsSourceSelector), (selectedPanels, allPanels, customised, newIssue, analyticsSource)=>{
    const allPanelsToAddedPanels = allPanels.map((panel)=>{
        // Forge-defined panels
        if (panel.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const forgePanel = panel;
            // For a transition period we always render panels without a quick add button
            if (!forgePanel.iconUrl) return forgePanel;
            const prefix = `${forgePanel.appKey}/${forgePanel.moduleKey}-`;
            const filteredSelectedPanels = selectedPanels.filter((sPanel)=>(0, $eOKTW.isKeyMatchPrefix)(sPanel, prefix)).map((sPanel)=>{
                const panelProperties = (0, $a2FgJ.parseForgeIssuePanel)(sPanel);
                if (panelProperties == null) (0, $Z1q1o.fireOperationalFailedEvent)(analyticsSource, {
                    error: Error(`Panel key doesn't match regexp: ${sPanel}`)
                });
                return panelProperties && {
                    ...forgePanel,
                    dateAdded: panelProperties.added,
                    panelInstanceId: panelProperties.id
                };
            }).filter(Boolean);
            return filteredSelectedPanels.length > 0 && filteredSelectedPanels;
        }
        // Connect-defined panels
        if (!customised && !newIssue) return panel;
        const isSelected = selectedPanels.includes(`${panel.appKey}_${panel.moduleKey}`) || // BENTO-2491 SelectedPanels could be saved using keys without tailing digits
        selectedPanels.includes(`${panel.appKey}_${(0, $a2FgJ.removeTimestamp)(panel.moduleKey, 10)}`) || panel.showByDefault;
        return isSelected && panel;
    });
    const addedPanels = (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))($e729124ed69c9647$var$sortPanels(allPanelsToAddedPanels.filter(Boolean)));
    return addedPanels;
}));
const $e729124ed69c9647$export$9f3aeb87662f360b = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.contentPanels && ecosystem.contentPanels[appKey] && ecosystem.contentPanels[appKey][moduleKey]);
const $e729124ed69c9647$export$1a9c93efcb1ffec7 = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>Boolean(ecosystem && ecosystem.selectedContentPanel && (ecosystem.selectedContentPanel === `${appKey}_${moduleKey}` || ecosystem.selectedContentPanel === `${appKey}_${(0, $a2FgJ.removeTimestamp)(moduleKey, 10)}`)));
const $e729124ed69c9647$export$dd6c9850f9e61a72 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), $e729124ed69c9647$var$activityPanelsEntitiesSelector, (isEcosystemEnabled, activityPanelEntities)=>isEcosystemEnabled ? activityPanelEntities.map((entity)=>({
            name: entity.name,
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            options: entity.options,
            type: (0, $awmXl.CONNECT_ENTITY_TYPE)
        })) : []);
const $e729124ed69c9647$export$9222e43f5478367f = (0, $dGvGJ.createSelector)([
    (0, $lMzxr.forgeIssueActivitySelector),
    $e729124ed69c9647$export$dd6c9850f9e61a72
], (forge, connect)=>[
        ...forge,
        ...connect
    ].sort($e729124ed69c9647$export$b2c15e41218fc96));

});
parcelRegister("Z1q1o", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $0436e469f25e247b$export$add44f896fb31ba3);
$parcel$export(module.exports, "fireUiActionClickedEvent", () => $0436e469f25e247b$export$a645c87ca2607d94);
$parcel$export(module.exports, "fireTrackActionSucceedEvent", () => $0436e469f25e247b$export$435f030e21a120be);
$parcel$export(module.exports, "fireOperationalActionFailedEvent", () => $0436e469f25e247b$export$828a66ad00e9a886);
$parcel$export(module.exports, "fireTrackSavedEvent", () => $0436e469f25e247b$export$1dbf5d2537a38bd8);
$parcel$export(module.exports, "fireOperationalSaveFailedEvent", () => $0436e469f25e247b$export$cda76554fa8eee1d);
$parcel$export(module.exports, "fireUiRemoveClickedEvent", () => $0436e469f25e247b$export$2e4d409fc887e7e);
$parcel$export(module.exports, "fireTrackRemovedEvent", () => $0436e469f25e247b$export$daf10221407e1b30);
$parcel$export(module.exports, "fireOperationalRemoveFailedEvent", () => $0436e469f25e247b$export$d12e864ea545eb36);
$parcel$export(module.exports, "fireUiTriggerSelectedEvent", () => $0436e469f25e247b$export$4d7a3fdb2dd15cbb);
$parcel$export(module.exports, "fireUiCollapseExpandClickedEvent", () => $0436e469f25e247b$export$c157193e598947ac);
$parcel$export(module.exports, "fireTrackUpdateSucceedEvent", () => $0436e469f25e247b$export$98e4a25792520246);
$parcel$export(module.exports, "fireOperationalUpdateFailedEvent", () => $0436e469f25e247b$export$9ee09996d253231a);

var $k2DRb = parcelRequire("k2DRb");

var $8uOa6 = parcelRequire("8uOa6");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");
const $0436e469f25e247b$var$moduleEventId = (0, $9BrHy.getEventId)({
    module: (0, $k2DRb.ISSUE_PANEL_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
});
const $0436e469f25e247b$var$triggerEventId = (0, $9BrHy.getEventId)({
    module: (0, $k2DRb.ISSUE_PANEL_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
});
const $0436e469f25e247b$export$add44f896fb31ba3 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$a645c87ca2607d94 = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).ACTION_CLICKED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$435f030e21a120be = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).ACTION_SUCCEED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$828a66ad00e9a886 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).ACTION_FAILED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$1dbf5d2537a38bd8 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).SAVED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$cda76554fa8eee1d = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).SAVE_FAILED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$2e4d409fc887e7e = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).REMOVE_CLICKED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$daf10221407e1b30 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).REMOVED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$d12e864ea545eb36 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).REMOVE_FAILED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$4d7a3fdb2dd15cbb = (extensionId, source, attributes)=>{
    (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).SELECTED, {
        id: $0436e469f25e247b$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $0436e469f25e247b$export$c157193e598947ac = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).COLLAPSE_EXPAND_CLICKED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$98e4a25792520246 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).UPDATE_SUCCEED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$9ee09996d253231a = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).UPDATE_FAILED, {
        id: $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});
parcelRegister("9BrHy", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $10bc2a9e37d5a5bb$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);

var $k2DRb = parcelRequire("k2DRb");

var $6yg2S = parcelRequire("6yg2S");

var $hBuqR = parcelRequire("hBuqR");
const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, $k2DRb.SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hBuqR.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("eOKTW", function(module, exports) {

$parcel$export(module.exports, "toForgeKey", () => $2db6ad1a44c67382$export$fef910e3c6a21573);
$parcel$export(module.exports, "toForgeKeyWithDate", () => $2db6ad1a44c67382$export$4a8bc976ef8470fb);
$parcel$export(module.exports, "toForgeKeyFromExtensionId", () => $2db6ad1a44c67382$export$72368b9e5ac31f04);
$parcel$export(module.exports, "toConnectKey", () => $2db6ad1a44c67382$export$f1cde82a5f64810e);
$parcel$export(module.exports, "toEcosystemKeys", () => $2db6ad1a44c67382$export$c9483bbc66b4fb20);
$parcel$export(module.exports, "isForgeExtension", () => $2db6ad1a44c67382$export$b0ed77f2dd403096);
$parcel$export(module.exports, "isKeyMatchPrefix", () => $2db6ad1a44c67382$export$75f2b72396a13fc0);

var $k2DRb = parcelRequire("k2DRb");
const $2db6ad1a44c67382$export$fef910e3c6a21573 = (appKey, moduleKey)=>`${appKey}/${moduleKey}`;
const $2db6ad1a44c67382$export$4a8bc976ef8470fb = (appKey, moduleKey, panelInstanceId, dateAdded)=>`${appKey}/${moduleKey}-${panelInstanceId}-${dateAdded}`;
const $2db6ad1a44c67382$export$72368b9e5ac31f04 = (extensionId, panelInstanceId, dateAdded)=>panelInstanceId != null ? `${extensionId}-${panelInstanceId}-${dateAdded}` : `${extensionId}-${0, $k2DRb.NONE_PANEL_INSTANCE_ID}-${dateAdded}`;
const $2db6ad1a44c67382$export$f1cde82a5f64810e = (appKey, moduleKey)=>`${appKey}_${moduleKey}`;
const $2db6ad1a44c67382$export$c9483bbc66b4fb20 = (extensionId)=>{
    const [prefix, appId, envId, ...rest] = extensionId.split('/');
    const appKey = [
        prefix,
        appId,
        envId
    ].join('/');
    const moduleKey = rest.join('/');
    return {
        appKey: appKey,
        moduleKey: moduleKey
    };
};
const $2db6ad1a44c67382$export$b0ed77f2dd403096 = (appKey)=>appKey.startsWith((0, $k2DRb.FORGE_FIELD_TYPE_PREFIX));
const $2db6ad1a44c67382$export$75f2b72396a13fc0 = (key, prefix)=>key.startsWith(prefix) && /^\w+-\d+$/.test(key.slice(prefix.length));

});

parcelRegister("a2FgJ", function(module, exports) {

$parcel$export(module.exports, "removeTimestamp", () => $b16ff4531ea7aeeb$export$8144a1156e1fc1b3);
$parcel$export(module.exports, "parseForgeIssuePanel", () => $b16ff4531ea7aeeb$export$a21b4e384e411f26);
// when input is like 'my-issue-content-panel-5794110541888792068', output is 'my-issue-content-panel'
const $b16ff4531ea7aeeb$export$8144a1156e1fc1b3 = (str, minDigitsLen = 0)=>{
    const indexOfHyphen = str.lastIndexOf('-');
    const tail = str.substr(indexOfHyphen + 1);
    if (/^\d+$/.test(tail) && tail.length >= minDigitsLen) return str.substr(0, indexOfHyphen);
    return str;
};
const $b16ff4531ea7aeeb$export$a21b4e384e411f26 = (panelKey)=>{
    const match = panelKey.match(/^(.*)-(\w+)-(\d+)$/);
    if (match == null) return null;
    const [, extensionId, id, timestamp] = match;
    const added = Number(timestamp);
    return {
        extensionId: extensionId,
        id: id,
        added: added
    };
};

});

parcelRegister("hKi22", function(module, exports) {

$parcel$export(module.exports, "permissionsSelector", () => $73bbd0df9e2a988a$export$7a13e26fbaa74911);
$parcel$export(module.exports, "canBeAssignedToIssuesPermissionsSelector", () => $73bbd0df9e2a988a$export$6da6e9cc5af6cc92);
$parcel$export(module.exports, "canAdministerProjectPermissionsSelector", () => $73bbd0df9e2a988a$export$106fd3c30fc8b230);
$parcel$export(module.exports, "canAdministerJiraPermissionsSelector", () => $73bbd0df9e2a988a$export$adf4ccad5657586d);
$parcel$export(module.exports, "canModifyReporterPermissionsSelector", () => $73bbd0df9e2a988a$export$85a3c8518f632ff1);
$parcel$export(module.exports, "canAssignIssuesPermissionsSelector", () => $73bbd0df9e2a988a$export$f58a91878385514);
$parcel$export(module.exports, "canExportIssueSelector", () => $73bbd0df9e2a988a$export$a409252beda5dd99);
$parcel$export(module.exports, "watchersPermissionsSelector", () => $73bbd0df9e2a988a$export$b3bd1cf4683807d8);
$parcel$export(module.exports, "canViewDevToolsPermissionsSelector", () => $73bbd0df9e2a988a$export$dfc7b576e23ac861);
$parcel$export(module.exports, "canUseServiceDeskAgentFeaturesSelector", () => $73bbd0df9e2a988a$export$1b79be16305d8111);

var $dGvGJ = parcelRequire("dGvGJ");

var $dPSWJ = parcelRequire("dPSWJ");

var $2vSU6 = parcelRequire("2vSU6");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");
const $73bbd0df9e2a988a$var$internalPermissionsSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.permissions);
const $73bbd0df9e2a988a$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm = new Set([
    // In the BE this is not technically a veto'd permission, however it simplifies the FE code to pretend that it is.
    'canUseServiceDeskAgentFeatures',
    // Normal veto'd permissions as per ServiceDeskCollaboratorPermissionOverrideStrategy in BE
    'canEditIssues',
    'canTransitionIssues',
    'canScheduleIssues',
    'canMoveIssue',
    'canAssignIssues',
    'canBeAssignedToIssues',
    'canDeleteIssue',
    'canManageWatchers',
    'canEditAllComments',
    'canDeleteAllComments',
    'canDeleteAllAttachments',
    'canLogWork',
    'canEditOwnWorklogs',
    'canEditAllWorklogs',
    'canDeleteOwnWorklogs',
    'canDeleteAllWorklogs',
    // These should be vetoed, but aren't requested by JFE yet
    'canResolveIssues',
    'canViewReadonlyWorkflow',
    'canCloseIssues',
    'canModifyReporter',
    'canSetIssueSecurity',
    'canArchiveIssue',
    'canUnarchiveIssue'
]);
const $73bbd0df9e2a988a$export$7a13e26fbaa74911 = (0, $dGvGJ.createSelector)((0, $a1ky2.appPermissionsSelector), (0, $bcoYn.projectTypeSelector), $73bbd0df9e2a988a$var$internalPermissionsSelector, (0, $a1ky2.tenantHasActiveServiceDeskLicenseSelector), (applicationPermissions, projectType, permissions, tenantHasActiveServiceDeskLicense)=>{
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && tenantHasActiveServiceDeskLicense) {
        const { canUseServiceDeskAgentFeatures: canUseServiceDeskAgentFeatures } = permissions;
        const hasJsdAppRole = applicationPermissions.hasServiceDeskAccess;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(permissions, (hasPermission, key)=>$73bbd0df9e2a988a$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm.has(key) ? hasPermission && hasJsdAppRole && canUseServiceDeskAgentFeatures : hasPermission);
    }
    return permissions;
});
const $73bbd0df9e2a988a$export$6da6e9cc5af6cc92 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canBeAssignedToIssues);
const $73bbd0df9e2a988a$export$106fd3c30fc8b230 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerProject);
const $73bbd0df9e2a988a$export$adf4ccad5657586d = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerJira);
const $73bbd0df9e2a988a$var$canViewWatchersPermissionsSelector = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canViewWatchers);
const $73bbd0df9e2a988a$var$canManageWatchersPermissionsSelector = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canManageWatchers);
const $73bbd0df9e2a988a$export$85a3c8518f632ff1 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canModifyReporter);
const $73bbd0df9e2a988a$export$f58a91878385514 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canAssignIssues);
const $73bbd0df9e2a988a$export$a409252beda5dd99 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canExportIssue);
const $73bbd0df9e2a988a$export$b3bd1cf4683807d8 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$var$canViewWatchersPermissionsSelector, $73bbd0df9e2a988a$var$canManageWatchersPermissionsSelector, (canViewWatchers, canManageWatchers)=>({
        canViewWatchers: canViewWatchers,
        canManageWatchers: canManageWatchers
    }));
const $73bbd0df9e2a988a$export$ca6b7f39a3de4ff9 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canBrowseUsers);
const $73bbd0df9e2a988a$export$dfc7b576e23ac861 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canViewDevTools);
const $73bbd0df9e2a988a$export$1b79be16305d8111 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canUseServiceDeskAgentFeatures);

});
parcelRegister("dPSWJ", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a12aa8fd8ab9a7da$var$mapValues;

});


const $ad485f85fe233a83$export$bdafa6b589be8b30 = 'issue.content.panel.customised.flag';

parcelRegister("4L22Y", function(module, exports) {

$parcel$export(module.exports, "ecosystemEntitiesSelector", () => $6d9cf82623af37b7$export$8db07a5bb000e56f);
$parcel$export(module.exports, "forgeEntitiesSelector", () => $6d9cf82623af37b7$export$92b32d478f0e29fb);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");

var $7G3DM = parcelRequire("7G3DM");
const $6d9cf82623af37b7$export$8db07a5bb000e56f = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.ecosystem || {});
const $6d9cf82623af37b7$export$92b32d478f0e29fb = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.forge || (0, $7G3DM.initialState));

});
parcelRegister("7G3DM", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $73241870ac7c200f$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $73241870ac7c200f$export$2e2bcd8739ae039);

var $aJ8eZ = parcelRequire("aJ8eZ");

var $jXy0Q = parcelRequire("jXy0Q");

var $akbnA = parcelRequire("akbnA");
const $73241870ac7c200f$export$d4c72bab9d6cc13a = {
    actions: [],
    glances: [],
    issueContexts: [],
    panels: [],
    activities: [],
    customFields: [],
    customFieldTypes: [],
    backgroundScripts: [],
    activeAction: null,
    panelsKeys: {
        newPanels: [],
        collapsedPanels: []
    },
    uiModifications: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73241870ac7c200f$export$2e2bcd8739ae039 = (state = $73241870ac7c200f$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $aJ8eZ.FETCH_FORGE_SUCCESS:
            return {
                ...state,
                actions: action.payload.issueAction,
                glances: action.payload.issueGlance,
                issueContexts: action.payload.issueContext,
                panels: action.payload.issuePanel,
                activities: action.payload.issueActivity,
                customFields: action.payload.customField,
                customFieldTypes: action.payload.customFieldType,
                backgroundScripts: action.payload.issueViewBackgroundScript,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: []
                },
                uiModifications: action.payload.uiModifications
            };
        case 0, $aJ8eZ.FORGE_ISSUE_ACTION_EXEC:
            return {
                ...state,
                activeAction: {
                    action: action.payload,
                    isLoading: true
                }
            };
        case 0, $aJ8eZ.FORGE_ISSUE_ACTION_RENDERED:
            return {
                ...state,
                // @ts-expect-error - TS2322 - Type '{ isLoading: false; action?: Action | undefined; }' is not assignable to type 'ActiveAction'.
                activeAction: {
                    ...state.activeAction,
                    isLoading: false
                }
            };
        case 0, $aJ8eZ.FORGE_ISSUE_ACTION_CLOSE:
            return {
                ...state,
                activeAction: null
            };
        case 0, $aJ8eZ.FORGE_ISSUE_PANEL_ADDED:
            return {
                ...state,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: [
                        ...state.panelsKeys.newPanels,
                        action.payload
                    ]
                }
            };
        case 0, $aJ8eZ.FORGE_NEW_ISSUE_PANEL_UNTRACK:
            {
                const removedPanelKey = action.payload;
                const { panelsKeys: panelsKeys } = state;
                return {
                    ...state,
                    panelsKeys: {
                        ...panelsKeys,
                        newPanels: panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $aJ8eZ.FORGE_ISSUE_PANEL_REMOVED:
            {
                const removedPanelKey = action.payload;
                return {
                    ...state,
                    panelsKeys: {
                        newPanels: state.panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey),
                        collapsedPanels: state.panelsKeys.collapsedPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $aJ8eZ.FORGE_ISSUE_PANEL_UPDATED:
            {
                const { panelKey: panelKey, collapsed: collapsed } = action.payload;
                const updatedCollapsedPanels = collapsed ? Array.from(new Set([
                    ...state.panelsKeys.collapsedPanels,
                    panelKey
                ])) : state.panelsKeys.collapsedPanels.filter((key)=>key !== panelKey);
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: updatedCollapsedPanels
                    }
                };
            }
        case 0, $akbnA.FETCH_ISSUE_SUCCESS:
        case 0, $akbnA.REFRESH_ISSUE_SUCCESS:
        case 0, $jXy0Q.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const collapsedPanels = action.payload.forgeIssueProperties?.collapsedPanels || [];
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: Array.from(new Set([
                            ...state.panelsKeys.collapsedPanels,
                            ...collapsedPanels
                        ]))
                    }
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("aJ8eZ", function(module, exports) {

$parcel$export(module.exports, "FETCH_FORGE_SUCCESS", () => $e621a0f6e2386727$export$b40fce05e753d390);
$parcel$export(module.exports, "fetchForgeSuccess", () => $e621a0f6e2386727$export$1b05a0184822bc74);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_EXEC", () => $e621a0f6e2386727$export$8c062df60fb76839);
$parcel$export(module.exports, "forgeIssueActionExec", () => $e621a0f6e2386727$export$3a189763780c504b);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_RENDERED", () => $e621a0f6e2386727$export$dd307b8c5e0de67d);
$parcel$export(module.exports, "forgeIssueActionRendered", () => $e621a0f6e2386727$export$2484a0b7a9a14f92);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_CLOSE", () => $e621a0f6e2386727$export$d91b51ae909f8e95);
$parcel$export(module.exports, "forgeIssueActionClose", () => $e621a0f6e2386727$export$335a03a463c5945a);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_ADDED", () => $e621a0f6e2386727$export$7d7831d10e022e0);
$parcel$export(module.exports, "forgeIssuePanelAdded", () => $e621a0f6e2386727$export$f24c609edeac582f);
$parcel$export(module.exports, "FORGE_NEW_ISSUE_PANEL_UNTRACK", () => $e621a0f6e2386727$export$d36cecbf4e320d4a);
$parcel$export(module.exports, "forgeNewIssuePanelUntrack", () => $e621a0f6e2386727$export$b93b979485d242c8);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_REMOVED", () => $e621a0f6e2386727$export$798e467d6a4cb5c);
$parcel$export(module.exports, "forgeIssuePanelRemoved", () => $e621a0f6e2386727$export$b584e6f1797702be);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATE_REQUEST", () => $e621a0f6e2386727$export$bb2e005bc0498829);
$parcel$export(module.exports, "forgeIssuePanelUpdateRequest", () => $e621a0f6e2386727$export$c67c4f64ec92ba7f);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATED", () => $e621a0f6e2386727$export$2ce5fe154022894b);
$parcel$export(module.exports, "forgeIssuePanelUpdated", () => $e621a0f6e2386727$export$e2eebb5b364492ce);
const $e621a0f6e2386727$export$b40fce05e753d390 = 'FETCH_FORGE_SUCCESS';
const $e621a0f6e2386727$export$1b05a0184822bc74 = (payload)=>({
        type: $e621a0f6e2386727$export$b40fce05e753d390,
        payload: payload
    });
const $e621a0f6e2386727$export$8c062df60fb76839 = 'FORGE_ISSUE_ACTION_EXEC';
const $e621a0f6e2386727$export$3a189763780c504b = (action)=>({
        type: $e621a0f6e2386727$export$8c062df60fb76839,
        payload: action
    });
const $e621a0f6e2386727$export$dd307b8c5e0de67d = 'FORGE_ISSUE_ACTION_RENDERED';
const $e621a0f6e2386727$export$2484a0b7a9a14f92 = ()=>({
        type: $e621a0f6e2386727$export$dd307b8c5e0de67d
    });
const $e621a0f6e2386727$export$d91b51ae909f8e95 = 'FORGE_ISSUE_ACTION_CLOSE';
const $e621a0f6e2386727$export$335a03a463c5945a = ()=>({
        type: $e621a0f6e2386727$export$d91b51ae909f8e95
    });
const $e621a0f6e2386727$export$7d7831d10e022e0 = 'FORGE_ISSUE_PANEL_ADDED';
const $e621a0f6e2386727$export$f24c609edeac582f = (issuePanelKey)=>({
        type: $e621a0f6e2386727$export$7d7831d10e022e0,
        payload: issuePanelKey
    });
const $e621a0f6e2386727$export$d36cecbf4e320d4a = 'FORGE_NEW_ISSUE_PANEL_UNTRACK';
const $e621a0f6e2386727$export$b93b979485d242c8 = (issuePanelKey)=>({
        type: $e621a0f6e2386727$export$d36cecbf4e320d4a,
        payload: issuePanelKey
    });
const $e621a0f6e2386727$export$798e467d6a4cb5c = 'FORGE_ISSUE_PANEL_REMOVED';
const $e621a0f6e2386727$export$b584e6f1797702be = (issuePanelKey)=>({
        type: $e621a0f6e2386727$export$798e467d6a4cb5c,
        payload: issuePanelKey
    });
const $e621a0f6e2386727$export$bb2e005bc0498829 = 'FORGE_ISSUE_PANEL_UPDATE_REQUEST';
const $e621a0f6e2386727$export$c67c4f64ec92ba7f = (payload)=>({
        type: $e621a0f6e2386727$export$bb2e005bc0498829,
        payload: payload
    });
const $e621a0f6e2386727$export$2ce5fe154022894b = 'FORGE_ISSUE_PANEL_UPDATED';
const $e621a0f6e2386727$export$e2eebb5b364492ce = (payload)=>({
        type: $e621a0f6e2386727$export$2ce5fe154022894b,
        payload: payload
    });

});

parcelRegister("jXy0Q", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST", () => $6d3151fa7c469cff$export$d8a6e69b46d6d184);
$parcel$export(module.exports, "fetchIssueRemoteDataRequest", () => $6d3151fa7c469cff$export$222125e4e0f166e4);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST_LOADING_COMPLETE", () => $6d3151fa7c469cff$export$c511d3093cea9ec6);
$parcel$export(module.exports, "fetchIssueRemoteDataRequestLoadingComplete", () => $6d3151fa7c469cff$export$86a90761307d7be0);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_SUCCESS", () => $6d3151fa7c469cff$export$2cdd723fc40cdd47);
$parcel$export(module.exports, "fetchIssueRemoteDataSuccess", () => $6d3151fa7c469cff$export$615a2d29b149df95);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_FAILURE", () => $6d3151fa7c469cff$export$396f0d977db541d9);
$parcel$export(module.exports, "fetchIssueRemoteDataFailure", () => $6d3151fa7c469cff$export$f7fd18472eaf2b77);
$parcel$export(module.exports, "FETCH_ALL_ISSUE_WHITEBOARDS_SUCCESS", () => $6d3151fa7c469cff$export$7067db2dbaa9931);
$parcel$export(module.exports, "fetchAllIssueWhiteboardsSuccess", () => $6d3151fa7c469cff$export$56e06a2cdd56648f);
const $6d3151fa7c469cff$export$d8a6e69b46d6d184 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST';
const $6d3151fa7c469cff$export$222125e4e0f166e4 = (issueKey)=>({
        type: $6d3151fa7c469cff$export$d8a6e69b46d6d184,
        payload: issueKey
    });
const $6d3151fa7c469cff$export$c511d3093cea9ec6 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST_LOADING_COMPLETE';
const $6d3151fa7c469cff$export$86a90761307d7be0 = ()=>({
        type: $6d3151fa7c469cff$export$c511d3093cea9ec6
    });
const $6d3151fa7c469cff$export$2cdd723fc40cdd47 = 'FETCH_ISSUE_REMOTE_DATA_SUCCESS';
const $6d3151fa7c469cff$export$615a2d29b149df95 = (entities)=>({
        type: $6d3151fa7c469cff$export$2cdd723fc40cdd47,
        payload: entities
    });
const $6d3151fa7c469cff$export$396f0d977db541d9 = 'FETCH_ISSUE_REMOTE_DATA_FAILURE';
const $6d3151fa7c469cff$export$f7fd18472eaf2b77 = ()=>({
        type: $6d3151fa7c469cff$export$396f0d977db541d9
    });
const $6d3151fa7c469cff$export$7067db2dbaa9931 = 'FETCH_ISSUE_WHITEBOARDS_SUCCESS';
const $6d3151fa7c469cff$export$56e06a2cdd56648f = (whiteboardData)=>({
        type: $6d3151fa7c469cff$export$7067db2dbaa9931,
        payload: whiteboardData
    });

});

parcelRegister("akbnA", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $96f907481cd25e73$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $96f907481cd25e73$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $96f907481cd25e73$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $96f907481cd25e73$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $96f907481cd25e73$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $96f907481cd25e73$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $96f907481cd25e73$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $96f907481cd25e73$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $96f907481cd25e73$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $96f907481cd25e73$export$6ce2430992033a55);
const $96f907481cd25e73$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ff7cd1a46115d8ca = ()=>({
        type: $96f907481cd25e73$export$afc8565512ebbf99
    });
const $96f907481cd25e73$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $96f907481cd25e73$export$c32d0e1f370b7914,
        payload: entities
    });
const $96f907481cd25e73$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $96f907481cd25e73$export$625e6e61fad65793 = (failureDescription)=>({
        type: $96f907481cd25e73$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $96f907481cd25e73$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $96f907481cd25e73$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $96f907481cd25e73$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$a7629a657f902cbc = ()=>({
        type: $96f907481cd25e73$export$6b6ca6acd76420d1
    });
const $96f907481cd25e73$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$cbd1c08fb706639c = (entities)=>({
        type: $96f907481cd25e73$export$de11c913f06a7952,
        payload: entities
    });
const $96f907481cd25e73$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $96f907481cd25e73$export$6ce2430992033a55 = ()=>({
        type: $96f907481cd25e73$export$36b76b7384d868f3
    });

});



parcelRegister("lMzxr", function(module, exports) {

$parcel$export(module.exports, "forgeContextPanelsSelector", () => $98da256956b02977$export$94c701814d50fed3);
$parcel$export(module.exports, "forgeGlancesSelector", () => $98da256956b02977$export$92747468cb57714e);
$parcel$export(module.exports, "forgeUiModificationsSelector", () => $98da256956b02977$export$325ea69d1eb5eda0);
$parcel$export(module.exports, "forgeIssueActionsSelector", () => $98da256956b02977$export$9bcd40b01af57823);
$parcel$export(module.exports, "forgePanelsSelector", () => $98da256956b02977$export$ca115d43abfd7206);
$parcel$export(module.exports, "forgeUserCanSaveIssuePanelSelector", () => $98da256956b02977$export$ae25fce59e44b253);
$parcel$export(module.exports, "forgeJustAddedPanelSelector", () => $98da256956b02977$export$9c375a0b9a6e5017);
$parcel$export(module.exports, "forgeActiveIssueActionSelector", () => $98da256956b02977$export$ccad5f28efcec42d);
$parcel$export(module.exports, "forgeIssueDataSelector", () => $98da256956b02977$export$d3cd515b7639ce61);
$parcel$export(module.exports, "forgeIssueActivitySelector", () => $98da256956b02977$export$18ce84b90b4920eb);
$parcel$export(module.exports, "isForgePanelNewToIssueSelector", () => $98da256956b02977$export$97dadedc102bebdf);
$parcel$export(module.exports, "getForgeIssuePanel", () => $98da256956b02977$export$b01f1fc9eba6d8cd);
$parcel$export(module.exports, "forgeIsCollapsedPanelSelector", () => $98da256956b02977$export$3d7856e5c65d2291);

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $eOKTW = parcelRequire("eOKTW");

var $5cmSg = parcelRequire("5cmSg");

var $41gqO = parcelRequire("41gqO");

var $awmXl = parcelRequire("awmXl");

var $a2FgJ = parcelRequire("a2FgJ");

var $g5X3G = parcelRequire("g5X3G");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $lssfC = parcelRequire("lssfC");

var $4L22Y = parcelRequire("4L22Y");
const $98da256956b02977$var$filterExtensions = (list)=>{
    return list.filter((0, $5cmSg.isExtensionVisible));
};
const $98da256956b02977$var$sortIssuePanels = (first, second)=>{
    if (first.name === second.name) return 0;
    return first.name > second.name ? 1 : -1;
};
const $98da256956b02977$export$b302c9df74ede99a = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (0, $a1ky2.issueIdSelector), (0, $a1ky2.issueKeySelector), (0, $lssfC.issueTypeNameSelector), (0, $bcoYn.projectIdSelector), (0, $a1ky2.projectKeySelector), (0, $bcoYn.projectTypeSelector), (permissions, issueId, issueKey, issueType, projectId, projectKey, projectType)=>({
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Instead of dumping permissions as is we'd like to normalize prop names a bit
        // as they are exposed externally and have to look respectable
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canArchiveIssue: permissions.canArchiveIssue,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUnarchiveIssue: permissions.canUnarchiveIssue,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers,
        canExportIssue: permissions.canExportIssue
    }));
const $98da256956b02977$export$94c701814d50fed3 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.issueContexts)) return [];
    return forge.issueContexts.filter((extension)=>(0, $5cmSg.isExtensionVisible)(extension)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $41gqO.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $41gqO.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                contextPanelType: (0, $awmXl.FORGE_ENTITY_TYPE),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
});
const $98da256956b02977$export$92747468cb57714e = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.glances)) return [];
    return $98da256956b02977$var$filterExtensions(forge.glances).map((extension)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = extension;
        return {
            title: title,
            label: label,
            status: status,
            icon: icon,
            extension: extension,
            glanceType: (0, $awmXl.FORGE_ENTITY_TYPE),
            // Legacy props, too much refactoring needed in order to get rid of them
            moduleKey: id,
            appKey: id
        };
    });
});
const $98da256956b02977$export$325ea69d1eb5eda0 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.uiModifications)) return [];
    return forge.uiModifications;
});
const $98da256956b02977$export$9bcd40b01af57823 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $98da256956b02977$var$filterExtensions(forge.actions).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        return {
            id: id,
            title: title,
            extension: extension,
            type: (0, $awmXl.FORGE_ENTITY_TYPE)
        };
    });
});
const $98da256956b02977$export$ca115d43abfd7206 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.panels)) return [];
    return $98da256956b02977$var$filterExtensions(forge.panels).filter((extension)=>extension.properties.icon != null).map((extension)=>{
        const { id: id, properties: { title: title, icon: icon, allowMultiple: allowMultiple } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $eOKTW.toEcosystemKeys)(id);
        return {
            name: title,
            tooltip: title,
            iconUrl: icon,
            extension: extension,
            allowMultiple: !!allowMultiple,
            showByDefault: false,
            type: (0, $awmXl.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    }).sort($98da256956b02977$var$sortIssuePanels);
});
const $98da256956b02977$export$ae25fce59e44b253 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, issueViewStaticContext)=>isEcosystemEnabled && issueViewStaticContext.canEditIssues);
const $98da256956b02977$export$9c375a0b9a6e5017 = (panelKey)=>(0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.selectedContentPanel === panelKey);
const $98da256956b02977$export$38dd8c9ba1d48d98 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields)) return [];
    return $98da256956b02977$var$filterExtensions(forge.customFields);
});
const $98da256956b02977$export$9cef69a20109a92c = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFieldTypes)) return [];
    return $98da256956b02977$var$filterExtensions(forge.customFieldTypes);
});
const $98da256956b02977$export$2f1d736b0e7e1293 = (0, $dGvGJ.createSelector)($98da256956b02977$export$38dd8c9ba1d48d98, (fields)=>fields.length > 0);
const $98da256956b02977$export$252a589d17b14921 = (0, $dGvGJ.createSelector)($98da256956b02977$export$9cef69a20109a92c, (fieldsTypes)=>fieldsTypes.length > 0);
const $98da256956b02977$export$89b67d7e4e300f7d = (0, $dGvGJ.createSelector)($98da256956b02977$export$2f1d736b0e7e1293, $98da256956b02977$export$252a589d17b14921, (hasCustomFields, hasCustomFieldTypes)=>hasCustomFields || hasCustomFieldTypes);
const $98da256956b02977$export$e824cf91ff446be9 = (0, $dGvGJ.createSelector)($98da256956b02977$export$38dd8c9ba1d48d98, $98da256956b02977$export$9cef69a20109a92c, (customFields, customFieldTypes)=>[
        ...customFields,
        ...customFieldTypes
    ]);
const $98da256956b02977$export$ccad5f28efcec42d = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled) return null;
    return forge.activeAction || null;
});
const $98da256956b02977$export$e04b25b621339356 = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>fields[fieldId]?.schema.custom || '');
const $98da256956b02977$export$fbab82209930cdab = (0, $dGvGJ.createSelector)($98da256956b02977$export$e824cf91ff446be9, $98da256956b02977$export$e04b25b621339356, (forgeFields, extensionId)=>{
    const extension = forgeFields.find((field)=>field.id === extensionId);
    return extension || null;
});
const $98da256956b02977$export$7640f867620fe598 = (0, $dGvGJ.createSelector)($98da256956b02977$export$fbab82209930cdab, (extension)=>{
    if (!extension) return false;
    const hasRenderingFunction = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(extension.properties.function);
    const hasFormatterDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(extension.properties.formatter);
    return !hasRenderingFunction && hasFormatterDefined;
});
const $98da256956b02977$export$d3cd515b7639ce61 = (0, $dGvGJ.createSelector)((0, $a1ky2.issueKeySelector), (0, $a1ky2.issueIdSelector), (0, $lssfC.issueTypeIdSelector), (0, $lssfC.issueTypeNameSelector), (0, $a1ky2.projectKeySelector), (0, $bcoYn.projectIdSelector), (0, $bcoYn.projectTypeSelector), (issueKey, issueId, issueTypeId, issueType, projectKey, projectId, projectType)=>({
        issue: {
            key: issueKey,
            id: issueId,
            type: issueType,
            typeId: issueTypeId
        },
        project: {
            id: projectId !== null ? (0, $g5X3G.toProjectId)(projectId.toString()) : projectId,
            key: projectKey,
            type: projectType
        }
    }));
const $98da256956b02977$export$18ce84b90b4920eb = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $98da256956b02977$var$filterExtensions(forge.activities).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $eOKTW.toEcosystemKeys)(id);
        return {
            name: title,
            extension: extension,
            type: (0, $awmXl.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    });
});
const $98da256956b02977$export$97dadedc102bebdf = (0, $dGvGJ.createSelector)((0, $4L22Y.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.newPanels.includes(issuePanelKey));
const $98da256956b02977$export$b01f1fc9eba6d8cd = (forgePanelKey)=>(0, $dGvGJ.createSelector)($98da256956b02977$export$ca115d43abfd7206, (panels)=>{
        const { extensionId: extensionId } = (0, $a2FgJ.parseForgeIssuePanel)(forgePanelKey) || {};
        return panels.find((panel)=>extensionId === panel.extension.id);
    });
const $98da256956b02977$export$3d7856e5c65d2291 = (0, $dGvGJ.createSelector)((0, $4L22Y.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.collapsedPanels.includes(issuePanelKey));

});
parcelRegister("lssfC", function(module, exports) {

$parcel$export(module.exports, "createFullIssueUrl", () => $470f41730d0b2b6c$export$f107e3172d0c8a79);
$parcel$export(module.exports, "issueTypeSelector", () => $470f41730d0b2b6c$export$c5a236f192993436);
$parcel$export(module.exports, "issueUrlSelector", () => $470f41730d0b2b6c$export$7855e152de23b9ca);
$parcel$export(module.exports, "fullIssueUrlSelector", () => $470f41730d0b2b6c$export$14eeb219bfe6649b);
$parcel$export(module.exports, "issueTypeNameSelector", () => $470f41730d0b2b6c$export$477df8db13e4dac3);
$parcel$export(module.exports, "issueTypeHierarchyLevelSelector", () => $470f41730d0b2b6c$export$2bcfec06e5c80ef6);
$parcel$export(module.exports, "issueTypeIdSelector", () => $470f41730d0b2b6c$export$22410768c09b3a82);
$parcel$export(module.exports, "issueTypeIconUrlSelector", () => $470f41730d0b2b6c$export$4cf7e4622f7b8aee);
$parcel$export(module.exports, "isIssueTypeFieldEditableSelector", () => $470f41730d0b2b6c$export$580b385a93b77724);
$parcel$export(module.exports, "getParentIssuesSelector", () => $470f41730d0b2b6c$export$1e6d1c8ba22c2162);

var $dGvGJ = parcelRequire("dGvGJ");

var $fOGZN = parcelRequire("fOGZN");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");
// @ts-expect-error - TS2304 - Cannot find name 'BaseUrl'. | TS7006 - Parameter 'issueKey' implicitly has an 'any' type.
const $470f41730d0b2b6c$var$createRelativeIssueUrl = (baseUrl, issueKey)=>`${baseUrl ? baseUrl.replace(/\/?$/, '/') : '/'}browse/${issueKey}`;
const $470f41730d0b2b6c$export$f107e3172d0c8a79 = (baseUrl, issueKey)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.protocol}//${window.location.host}${$470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issueKey)}`;
const $470f41730d0b2b6c$var$issueTypeFieldSelector = (0, $7Ow8a.fieldSelector)((0, $fOGZN.ISSUE_TYPE));
const $470f41730d0b2b6c$var$subtaskIssueFieldSelector = (0, $7Ow8a.fieldSelector)((0, $fOGZN.SUBTASK_PARENT));
const $470f41730d0b2b6c$var$portfolioParentFieldSelector = (0, $7Ow8a.fieldSelector)((0, $fOGZN.PARENT));
const $470f41730d0b2b6c$export$c5a236f192993436 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$issueTypeFieldSelector, (issueType)=>issueType && issueType.value);
const $470f41730d0b2b6c$export$7855e152de23b9ca = (0, $dGvGJ.createSelector)((0, $a1ky2.baseUrlSelector), (0, $a1ky2.issueKeySelector), $470f41730d0b2b6c$var$createRelativeIssueUrl);
const $470f41730d0b2b6c$export$14eeb219bfe6649b = (0, $dGvGJ.createSelector)((0, $a1ky2.baseUrlSelector), (0, $a1ky2.issueKeySelector), $470f41730d0b2b6c$export$f107e3172d0c8a79);
const $470f41730d0b2b6c$export$477df8db13e4dac3 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.name);
const $470f41730d0b2b6c$export$2bcfec06e5c80ef6 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>{
    if (!issueType) return null;
    return issueType && issueType.hierarchyLevel;
});
const $470f41730d0b2b6c$export$22410768c09b3a82 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.id);
const $470f41730d0b2b6c$export$4cf7e4622f7b8aee = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.iconUrl);
const $470f41730d0b2b6c$export$580b385a93b77724 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$issueTypeFieldSelector, (issueType)=>issueType && Boolean(issueType.editable));
const $470f41730d0b2b6c$var$transformParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.summary,
        key: issue.key,
        url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $470f41730d0b2b6c$var$transformSubtaskParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.fields.summary,
        key: issue.key,
        url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $470f41730d0b2b6c$var$transformPortfolioParentIssue = (value, baseUrl)=>value && value.data ? {
        summary: value.data.summary,
        key: value.data.key,
        url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, value.data.key),
        issueTypeName: value.data.issueTypeName || '',
        issueTypeIconUrl: value.data.issueTypeIconUrl || ''
    } : null;
const $470f41730d0b2b6c$export$77f9f02e63a0906f = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$portfolioParentFieldSelector, (0, $a1ky2.baseUrlSelector), (portfolioParentIssue, baseUrl)=>$470f41730d0b2b6c$var$transformPortfolioParentIssue(portfolioParentIssue && portfolioParentIssue.value, baseUrl));
const $470f41730d0b2b6c$var$subtaskIssueParentSelector = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$subtaskIssueFieldSelector, (0, $a1ky2.baseUrlSelector), (subtaskIssue, baseUrl)=>$470f41730d0b2b6c$var$transformSubtaskParentIssue(subtaskIssue && subtaskIssue.value, baseUrl));
const $470f41730d0b2b6c$var$parentIssueSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.parentIssueEntitySelector), (0, $a1ky2.baseUrlSelector), (parentIssue, baseUrl)=>$470f41730d0b2b6c$var$transformParentIssue(parentIssue, baseUrl));
const $470f41730d0b2b6c$export$dfeb83ef40558422 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$parentIssueSelector, $470f41730d0b2b6c$var$subtaskIssueParentSelector, $470f41730d0b2b6c$export$77f9f02e63a0906f, (parentIssue, subtaskIssue, portfolioParentIssue)=>parentIssue || subtaskIssue || portfolioParentIssue);
const $470f41730d0b2b6c$export$1e6d1c8ba22c2162 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$parentIssueSelector, (parentIssue)=>[
        parentIssue
    ].filter(Boolean));

});



parcelRegister("jMY7o", function(module, exports) {

$parcel$export(module.exports, "supportedChildIssueTypesEntitiesSelector", () => $67134f469e001b64$export$1e8043fccfcba3b9);
$parcel$export(module.exports, "supportsChildCreationSelector", () => $67134f469e001b64$export$1af32b549149f3d9);
$parcel$export(module.exports, "parentLevelIssueTypeIdsSelector", () => $67134f469e001b64$export$be50776e2ae27cf6);
$parcel$export(module.exports, "parentLevelIssueTypeNamesSelector", () => $67134f469e001b64$export$57b3549670d3627b);
$parcel$export(module.exports, "sameLevelIssueTypesIdsSelector", () => $67134f469e001b64$export$a81bfe971074142b);
$parcel$export(module.exports, "hierarchyLevelSelector", () => $67134f469e001b64$export$4f7eb1d272a8015);
$parcel$export(module.exports, "isIssueBaseLevel", () => $67134f469e001b64$export$d9c73da87a448c4);
$parcel$export(module.exports, "canLinkToParentSelector", () => $67134f469e001b64$export$5530450eb840ecb2);

var $dGvGJ = parcelRequire("dGvGJ");

var $g4tDr = parcelRequire("g4tDr");

var $5fc53 = parcelRequire("5fc53");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $6UM3P = parcelRequire("6UM3P");
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $67134f469e001b64$var$childLevelValueSelector = (0, $7Ow8a.fieldPersistedValueSelector)((0, $5fc53.HIERARCHY_LEVEL_BELOW)) || null;
const $67134f469e001b64$var$isChildLevelSubtaskLevelSelector = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$childLevelValueSelector, (childLevelFieldValue)=>{
    if (!childLevelFieldValue) return false;
    return (0, $g4tDr.isSubtaskHierarchyLevel)(childLevelFieldValue.level);
});
const $67134f469e001b64$export$7a45e255c239753 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$childLevelValueSelector, (childLevelValue)=>childLevelValue && childLevelValue.issueTypes || []);
const $67134f469e001b64$export$1e8043fccfcba3b9 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), $67134f469e001b64$export$7a45e255c239753, (entities, supportedIssueTypes)=>{
    const allIssueTypes = entities.issueTypes;
    const supportedIssueTypeIds = supportedIssueTypes.map((issueType)=>issueType.id);
    return allIssueTypes.filter(// @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    (issueType)=>supportedIssueTypeIds.indexOf(issueType.id) !== -1);
});
const $67134f469e001b64$export$1af32b549149f3d9 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), $67134f469e001b64$export$7a45e255c239753, $67134f469e001b64$var$isChildLevelSubtaskLevelSelector, (0, $bcoYn.isSimplifiedProjectSelector), (permissions, supportedChildIssueTypes, isChildLevelSubtask, isSimplifiedProject)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length && (isSimplifiedProject ? true : !isChildLevelSubtask));
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $67134f469e001b64$var$parentLevelValueSelector = (0, $7Ow8a.fieldPersistedValueSelector)((0, $5fc53.HIERARCHY_LEVEL_ABOVE)) || null;
const $67134f469e001b64$export$55a6507420d37093 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && (parentLevelValue.name || null));
const $67134f469e001b64$export$be50776e2ae27cf6 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypeIds.map(String) || []);
const $67134f469e001b64$export$57b3549670d3627b = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypes.map((type)=>type.name).filter((name)=>name) || []);
const $67134f469e001b64$export$121e4a84c99db916 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$be50776e2ae27cf6, (parentLevelValue)=>parentLevelValue.length > 0);
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $67134f469e001b64$var$sameLevelValueSelector = (0, $7Ow8a.fieldPersistedValueSelector)((0, $5fc53.HIERARCHY_LEVEL_SAME_LEVEL)) || null;
const $67134f469e001b64$export$26996c7f0f08c0d8 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>{
    if (!sameLevelFieldValue) return false;
    return (0, $g4tDr.isSubtaskHierarchyLevel)(sameLevelFieldValue.level);
});
const $67134f469e001b64$export$a81bfe971074142b = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? sameLevelFieldValue.issueTypeIds.map(String) : []);
const $67134f469e001b64$export$4f7eb1d272a8015 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? (0, $g4tDr.toHierarchyLevel)(sameLevelFieldValue.level) : null);
const $67134f469e001b64$export$d9c73da87a448c4 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$4f7eb1d272a8015, (level)=>{
    if (level == null) // Some product types (JSM, Core, ...) do not support hierarchies at all and will not return this field.
    // For these, all issues are considered to be "Base" level.
    return true;
    return (0, $g4tDr.isBaseHierarchyLevel)(level);
});
const $67134f469e001b64$export$5530450eb840ecb2 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$55a6507420d37093, (0, $6UM3P.canEditIssuesSelector), $67134f469e001b64$export$121e4a84c99db916, (parentLevelName, shouldShowAddParent, hasParentIssueTypeId)=>Boolean(parentLevelName) && shouldShowAddParent && hasParentIssueTypeId);

});
parcelRegister("6UM3P", function(module, exports) {

$parcel$export(module.exports, "canEditIssuesSelector", () => $ab04ad11f2d2260b$export$cdd6892c8add3e54);
$parcel$export(module.exports, "canLinkIssuesSelector", () => $ab04ad11f2d2260b$export$50487d0d29271836);

var $dGvGJ = parcelRequire("dGvGJ");

var $hKi22 = parcelRequire("hKi22");
const $ab04ad11f2d2260b$export$a7a483ca0afc4ab3 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canCloneIssue);
const $ab04ad11f2d2260b$export$c1f4ef01259b4eb = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canDeleteIssue);
const $ab04ad11f2d2260b$export$2f9dd165cbf0c5ea = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canMoveIssue);
const $ab04ad11f2d2260b$export$cdd6892c8add3e54 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canEditIssues);
const $ab04ad11f2d2260b$export$f48030c6644c0c4d = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canAdministerJira || permissions.canAdministerProject);
const $ab04ad11f2d2260b$export$4e8dac873f71d13e = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canAssignIssues);
const $ab04ad11f2d2260b$export$50487d0d29271836 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canLinkIssues);

});


parcelRegister("hwyJi", function(module, exports) {

$parcel$export(module.exports, "ecosystemCustomFieldIdsSelector", () => $7ea8e744bda72f86$export$c16e6010c2ccc7b2);

var $dGvGJ = parcelRequire("dGvGJ");

var $69oHP = parcelRequire("69oHP");

var $fOGZN = parcelRequire("fOGZN");

var $7Ow8a = parcelRequire("7Ow8a");
const $7ea8e744bda72f86$export$1caf4359a6680b64 = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $69oHP.getFieldType)(fields[id]);
        return type && (0, $fOGZN.customFieldsToDisplay)().includes(type);
    }));
const $7ea8e744bda72f86$export$c16e6010c2ccc7b2 = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $69oHP.getFieldType)(fields[id]);
        return type && (0, $fOGZN.ecosystemCustomFields).includes(type);
    }));

});

parcelRegister("d4MOh", function(module, exports) {

$parcel$export(module.exports, "entitiesCommentsSelector", () => $1d69b1e69b91ee0e$export$2bcb958351592bb9);
$parcel$export(module.exports, "totalCommentsSelector", () => $1d69b1e69b91ee0e$export$3873a5701cda7746);
$parcel$export(module.exports, "startIndexCommentsSelector", () => $1d69b1e69b91ee0e$export$10621129a0e171e5);
$parcel$export(module.exports, "loadedCommentsSelector", () => $1d69b1e69b91ee0e$export$c3802eebab78988b);
$parcel$export(module.exports, "commentsPageInfoSelector", () => $1d69b1e69b91ee0e$export$bf7222a172daf33c);
$parcel$export(module.exports, "isLoadingMoreCommentsSelector", () => $1d69b1e69b91ee0e$export$5d4ebbdab84a3a1);
$parcel$export(module.exports, "hasScrolledPermalinkCommentSelector", () => $1d69b1e69b91ee0e$export$3190c124f9d4af8a);
$parcel$export(module.exports, "loadingMoreChildCommentsSelector", () => $1d69b1e69b91ee0e$export$59d9db30c7503d0f);
$parcel$export(module.exports, "loadingStageSelector", () => $1d69b1e69b91ee0e$export$18bc980d36bf93d);
$parcel$export(module.exports, "commentAuthorSelector", () => $1d69b1e69b91ee0e$export$6f6ac03c75ab3545);
$parcel$export(module.exports, "commentUpdateAuthorSelector", () => $1d69b1e69b91ee0e$export$7190d6fab16715b8);
$parcel$export(module.exports, "commentEditingBodySelector", () => $1d69b1e69b91ee0e$export$3e2634438f2a9b1a);
$parcel$export(module.exports, "commentEditingVisibilitySelector", () => $1d69b1e69b91ee0e$export$3c2f8c0a34054ef7);
$parcel$export(module.exports, "commentEditingOrViewBodyAdfSelector", () => $1d69b1e69b91ee0e$export$b0e0bc0c48cf00e6);
$parcel$export(module.exports, "commentOutsiderCommentSelector", () => $1d69b1e69b91ee0e$export$e7022c391905c53f);
$parcel$export(module.exports, "commentBodyHtmlSelector", () => $1d69b1e69b91ee0e$export$b9c6e85825c49cba);
$parcel$export(module.exports, "commentIsDeletedSelector", () => $1d69b1e69b91ee0e$export$e6360edf7c25f03d);
$parcel$export(module.exports, "commentRepliesSelector", () => $1d69b1e69b91ee0e$export$9fdd1ba68d7464f1);
$parcel$export(module.exports, "childCommentsPageInfoSelector", () => $1d69b1e69b91ee0e$export$f8de4e824ff1662d);
$parcel$export(module.exports, "commentCreatedDateSelector", () => $1d69b1e69b91ee0e$export$b580f3d971b4e6fb);
$parcel$export(module.exports, "commentUpdatedDateSelector", () => $1d69b1e69b91ee0e$export$8b9935e49715b2d6);
$parcel$export(module.exports, "commentEditedSelector", () => $1d69b1e69b91ee0e$export$eff4fd551b2f55a1);
$parcel$export(module.exports, "pendingCommentSelector", () => $1d69b1e69b91ee0e$export$d63578bef1057cae);
$parcel$export(module.exports, "commentIsOptimisticSelector", () => $1d69b1e69b91ee0e$export$be047268481f07d8);
$parcel$export(module.exports, "commentSaveFailedSelector", () => $1d69b1e69b91ee0e$export$72075ae8ef4d6f6a);
$parcel$export(module.exports, "commentHasDeleteModalSelector", () => $1d69b1e69b91ee0e$export$c756ab72f25508bb);
$parcel$export(module.exports, "commentVisibilitySelector", () => $1d69b1e69b91ee0e$export$2cf9d22f626e5db0);
$parcel$export(module.exports, "isThreadedCommentsEnabledSelector", () => $1d69b1e69b91ee0e$export$f81b9f2c3f00b89b);
$parcel$export(module.exports, "commentEditingOrViewVisibilitySelector", () => $1d69b1e69b91ee0e$export$82fbf902093fe491);
$parcel$export(module.exports, "commentEditingEventOccurredAtSelector", () => $1d69b1e69b91ee0e$export$d820e1c3ac105e35);
$parcel$export(module.exports, "commentEventOccurredAtSelector", () => $1d69b1e69b91ee0e$export$9c8937d1bd8cf4a);
$parcel$export(module.exports, "commentJsdIncidentActivityViewHiddenSelector", () => $1d69b1e69b91ee0e$export$8c7be677b9a2cbf3);
$parcel$export(module.exports, "commentEditSessionContainsAttachmentsUsageSelector", () => $1d69b1e69b91ee0e$export$2a2670a8fb40391d);
$parcel$export(module.exports, "isInternalCommentSelector", () => $1d69b1e69b91ee0e$export$b99aa78c1374f9fe);
$parcel$export(module.exports, "isEditingInternalCommentSelector", () => $1d69b1e69b91ee0e$export$54205c8c886a2b43);
$parcel$export(module.exports, "canAddCommentsSelector", () => $1d69b1e69b91ee0e$export$a34c155854eb296b);
$parcel$export(module.exports, "canDeleteCommentSelector", () => $1d69b1e69b91ee0e$export$8cc876bb72dc09b7);
$parcel$export(module.exports, "canEditCommentSelector", () => $1d69b1e69b91ee0e$export$eb110f3a00a8432);
$parcel$export(module.exports, "visibleCommentIdsSelector", () => $1d69b1e69b91ee0e$export$3b3d01d442cb684a);
$parcel$export(module.exports, "sortedVisibleCommentIdsSelector", () => $1d69b1e69b91ee0e$export$81c523e14f04df2d);
$parcel$export(module.exports, "latestCommentCreatedTimeSelector", () => $1d69b1e69b91ee0e$export$92f90914a92d6fe7);
$parcel$export(module.exports, "getPersistedLatestCommentTimeSelector", () => $1d69b1e69b91ee0e$export$219697701c39ce2b);
$parcel$export(module.exports, "getUnreadCommentCountSelector", () => $1d69b1e69b91ee0e$export$567463de4ddebb27);
$parcel$export(module.exports, "isEditingCommentSelector", () => $1d69b1e69b91ee0e$export$6eba3f548a7f384e);
$parcel$export(module.exports, "commentSessionIdSelector", () => $1d69b1e69b91ee0e$export$239be48dfe5d80ba);
$parcel$export(module.exports, "getEditingCommentIdsSelector", () => $1d69b1e69b91ee0e$export$3a00787e516c672c);
$parcel$export(module.exports, "commentIdsSelector", () => $1d69b1e69b91ee0e$export$4c04cd370caea884);
$parcel$export(module.exports, "isEditingAnyCommentSelector", () => $1d69b1e69b91ee0e$export$2e24e984817b4c7b);
$parcel$export(module.exports, "isAddCommentEditorExpandedSelector", () => $1d69b1e69b91ee0e$export$5373a6bfd674797c);
$parcel$export(module.exports, "addCommentEditorForceFocusSelector", () => $1d69b1e69b91ee0e$export$37aee7d1ec9d42d3);
$parcel$export(module.exports, "isCommentEditorOpenSelector", () => $1d69b1e69b91ee0e$export$6df0ef2ac2b35c13);
$parcel$export(module.exports, "isCommentAttachmentInProgressSelector", () => $1d69b1e69b91ee0e$export$f140c5c89826efc6);
$parcel$export(module.exports, "isCommentVisibilityRestrictionSupportedSelector", () => $1d69b1e69b91ee0e$export$2ce513eb85289331);
$parcel$export(module.exports, "isReplyingToCommentSelector", () => $1d69b1e69b91ee0e$export$ab64c511f5921cdf);
$parcel$export(module.exports, "isCommentReplyEditorOpenSelector", () => $1d69b1e69b91ee0e$export$d89d07d36d57d778);
$parcel$export(module.exports, "replyContentSelector", () => $1d69b1e69b91ee0e$export$bb44f1aa6771eeb6);
$parcel$export(module.exports, "replyingToAuthorSelector", () => $1d69b1e69b91ee0e$export$6fe69cb268473af1);
$parcel$export(module.exports, "commentParentIdSelector", () => $1d69b1e69b91ee0e$export$9f25935861e23f9b);
$parcel$export(module.exports, "hasPublicCommentsSelector", () => $1d69b1e69b91ee0e$export$f3cffcd4d32274f6);

var $dGvGJ = parcelRequire("dGvGJ");

var $dMEgP = parcelRequire("dMEgP");

var $g7reD = parcelRequire("g7reD");

var $8ikER = parcelRequire("8ikER");

var $2vSU6 = parcelRequire("2vSU6");


var $g2C8o = parcelRequire("g2C8o");

var $32bya = parcelRequire("32bya");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $2QmDq = parcelRequire("2QmDq");

const $1d69b1e69b91ee0e$export$9832028921909a8f = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.pendingDeletedIds);
const $1d69b1e69b91ee0e$export$2bcb958351592bb9 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.comments);
const $1d69b1e69b91ee0e$export$3873a5701cda7746 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.totalComments);
const $1d69b1e69b91ee0e$export$10621129a0e171e5 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.commentsStartIndex);
const $1d69b1e69b91ee0e$export$c3802eebab78988b = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.loadedComments);
const $1d69b1e69b91ee0e$export$bf7222a172daf33c = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.commentsPageInfo);
const $1d69b1e69b91ee0e$export$5d4ebbdab84a3a1 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.isLoadingMoreComments);
const $1d69b1e69b91ee0e$export$3190c124f9d4af8a = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.hasScrolledPermalinkComment);
const $1d69b1e69b91ee0e$export$cb15fb58f04e4339 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.pendingSavedValues);
const $1d69b1e69b91ee0e$var$deleteModalCommentIdSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.deleteModalCommentId);
const $1d69b1e69b91ee0e$export$59d9db30c7503d0f = (commentId)=>(0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments?.childButtonLoadingState?.[commentId] ?? null);
const $1d69b1e69b91ee0e$export$18bc980d36bf93d = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.loadingStage);
const $1d69b1e69b91ee0e$export$f82d111da9150583 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, $1d69b1e69b91ee0e$export$cb15fb58f04e4339, (comments, optimisticComments)=>{
    if (!(0, $4R6GH.fg)('threaded_comments_new_analytics')) return {
        ...comments,
        ...optimisticComments
    };
    const allComments = {
        ...comments
    };
    for(const key in optimisticComments)if (Object.prototype.hasOwnProperty.call(comments, key)) allComments[key] = {
        ...allComments[key],
        ...optimisticComments[key]
    };
    else allComments[key] = optimisticComments[key];
    return allComments;
});
const $1d69b1e69b91ee0e$var$commentSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, (comments)=>comments[commentId]);
const $1d69b1e69b91ee0e$var$persistedCommentSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, (comments)=>comments[commentId]);
// If the user is anonymous, then they are not considered comment author
const $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (0, $a1ky2.accountIdloggedInUserSelector), (comment, loggedInUserId)=>loggedInUserId !== null && loggedInUserId === (comment && comment.authorId));
const $1d69b1e69b91ee0e$var$authorSelector = (commentId, authorIdPropertyName)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (0, $bcoYn.getUserByIdSelector), (comment, userByIdSelector)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'OptimisticComment | PersistedComment'.
        comment && comment[authorIdPropertyName] ? userByIdSelector(comment[authorIdPropertyName]) : null);
const $1d69b1e69b91ee0e$var$uiAllCommentsSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui && ui.comments || null);
const $1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentEditors || null);
const $1d69b1e69b91ee0e$var$uiCommentEditorSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector, (uiCommentEditors)=>uiCommentEditors && uiCommentEditors[commentId] || null);
const $1d69b1e69b91ee0e$export$6f6ac03c75ab3545 = (commentId)=>$1d69b1e69b91ee0e$var$authorSelector(commentId, 'authorId');
const $1d69b1e69b91ee0e$export$7190d6fab16715b8 = (commentId)=>$1d69b1e69b91ee0e$var$authorSelector(commentId, 'updateAuthorId');
const $1d69b1e69b91ee0e$export$3e2634438f2a9b1a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.editingValue || null);
const $1d69b1e69b91ee0e$export$3c2f8c0a34054ef7 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.visibility || null);
const $1d69b1e69b91ee0e$export$b0e0bc0c48cf00e6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3e2634438f2a9b1a(commentId), $1d69b1e69b91ee0e$var$commentSelector(commentId), (editingComment, comment)=>editingComment || comment && comment.bodyAdf || null);
const $1d69b1e69b91ee0e$export$e7022c391905c53f = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.jsdAuthorCanSeeRequest : null);
const $1d69b1e69b91ee0e$export$b9c6e85825c49cba = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.bodyHtml : null);
const $1d69b1e69b91ee0e$export$e6360edf7c25f03d = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.isDeleted : null);
const $1d69b1e69b91ee0e$export$9fdd1ba68d7464f1 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$persistedCommentSelector(commentId), $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (comment, allComments, deletedIds)=>{
        if (comment?.childCommentIds && comment.childCommentIds.size > 0) {
            const nonDeletedReplies = Array.from(comment.childCommentIds).filter((id)=>!deletedIds.includes(id) && allComments[id]);
            if (nonDeletedReplies.length > 0) return nonDeletedReplies.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(allComments)).sort($1d69b1e69b91ee0e$var$compareComments).map((sortedComment)=>sortedComment.id);
        }
        return null;
    });
const $1d69b1e69b91ee0e$export$f8de4e824ff1662d = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$persistedCommentSelector(commentId), (comment)=>comment?.childCommentsPageInfo ?? {});
const $1d69b1e69b91ee0e$export$b580f3d971b4e6fb = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.createdDate : null);
const $1d69b1e69b91ee0e$export$8b9935e49715b2d6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.updatedDate : null);
const $1d69b1e69b91ee0e$export$eff4fd551b2f55a1 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.edited : null);
const $1d69b1e69b91ee0e$export$d63578bef1057cae = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$cb15fb58f04e4339, (pendingComments)=>pendingComments[commentId]);
const $1d69b1e69b91ee0e$export$be047268481f07d8 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d63578bef1057cae(commentId), (pendingComment)=>!!pendingComment);
const $1d69b1e69b91ee0e$export$72075ae8ef4d6f6a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d63578bef1057cae(commentId), (pendingComment)=>!!(pendingComment && pendingComment.hasSaveFailed));
const $1d69b1e69b91ee0e$export$c756ab72f25508bb = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$deleteModalCommentIdSelector, (deleteModalCommentId)=>deleteModalCommentId === commentId);
const $1d69b1e69b91ee0e$export$2cf9d22f626e5db0 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), $1d69b1e69b91ee0e$export$8f158a3cc48edde6(commentId), $1d69b1e69b91ee0e$export$f81b9f2c3f00b89b, (comment, parent, isThreadedCommentsEnabled)=>{
        if (isThreadedCommentsEnabled && parent && !parent.isDeleted) return parent.visibility || (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC);
        return comment ? comment.visibility : (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC);
    });
const $1d69b1e69b91ee0e$var$commentIsInternalSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.isInternal : false);
const $1d69b1e69b91ee0e$export$82fbf902093fe491 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3c2f8c0a34054ef7(commentId), $1d69b1e69b91ee0e$export$2cf9d22f626e5db0(commentId), (editingVisibility, visibility)=>editingVisibility || visibility);
const $1d69b1e69b91ee0e$export$d820e1c3ac105e35 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.eventOccurredAt || null);
const $1d69b1e69b91ee0e$export$9c8937d1bd8cf4a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && comment.eventOccurredAt ? comment.eventOccurredAt : null);
const $1d69b1e69b91ee0e$export$9b5c22d8443e21d6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d820e1c3ac105e35(commentId), $1d69b1e69b91ee0e$export$9c8937d1bd8cf4a(commentId), (editingEventOccurredAt, eventOccurredAt)=>editingEventOccurredAt || eventOccurredAt);
const $1d69b1e69b91ee0e$export$8c7be677b9a2cbf3 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && typeof comment.jsdIncidentActivityViewHidden === 'boolean' ? comment.jsdIncidentActivityViewHidden : null);
const $1d69b1e69b91ee0e$export$2a2670a8fb40391d = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>!!comment?.editSessionContainsAttachmentsUsage);
const $1d69b1e69b91ee0e$export$b99aa78c1374f9fe = (commentId)=>(0, $dGvGJ.createSelector)((0, $a1ky2.isServiceDeskSelector), $1d69b1e69b91ee0e$var$commentIsInternalSelector(commentId), (isServiceDeskComment, isInternal)=>isServiceDeskComment && isInternal);
const $1d69b1e69b91ee0e$export$54205c8c886a2b43 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (commentEditor)=>commentEditor?.isInternal ?? true);
const $1d69b1e69b91ee0e$export$a34c155854eb296b = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canAddComments);
const $1d69b1e69b91ee0e$export$8cc876bb72dc09b7 = (commentId)=>(0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canDeleteAllComments || permissions.canDeleteOwnComments && isUserCommentAuthor);
const $1d69b1e69b91ee0e$export$eb110f3a00a8432 = (commentId)=>(0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canEditAllComments || permissions.canEditOwnComments && isUserCommentAuthor);
const $1d69b1e69b91ee0e$var$mapIdToCommentSortInfo = (comments)=>(id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate),
            eventOccurredAt: comment.eventOccurredAt ? new Date(comment.eventOccurredAt) : null,
            size: comment?.childCommentIds?.size ?? 0
        };
    };
const $1d69b1e69b91ee0e$var$compareComments = (a, b)=>{
    if (a.eventOccurredAt && b.eventOccurredAt && (0, $g7reD.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return (0, $g7reD.default)(a.createdDate, b.createdDate);
    const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
    const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
    return (0, $g7reD.default)(dateForA, dateForB);
};
const $1d69b1e69b91ee0e$var$visibleCommentIdsSelectorOld = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map((id)=>({
            id: id,
            createdDate: new Date(comments[id].createdDate)
        })).sort((a, b)=>(0, $g7reD.default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
    return sortedIds;
});
const $1d69b1e69b91ee0e$var$visibleCommentIdsSelectorNew = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(comments)).sort($1d69b1e69b91ee0e$var$compareComments).map((comment)=>comment.id);
    return sortedIds;
});
const $1d69b1e69b91ee0e$export$3b3d01d442cb684a = (0, $32bya.selectorWithCondition)(()=>(0, $4R6GH.fg)('jsm-timelines-phase-2'), $1d69b1e69b91ee0e$var$visibleCommentIdsSelectorNew, $1d69b1e69b91ee0e$var$visibleCommentIdsSelectorOld);
const $1d69b1e69b91ee0e$var$compareCommentsInclSortOrderType = (sortOrderType)=>(a, b)=>{
        if (a.eventOccurredAt && b.eventOccurredAt && (0, $g7reD.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return sortOrderType === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, $g7reD.default)(a.createdDate, b.createdDate) : (0, $8ikER.default)(a.createdDate, b.createdDate);
        const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
        const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
        return sortOrderType === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, $g7reD.default)(dateForA, dateForB) : (0, $8ikER.default)(dateForA, dateForB);
    };
const $1d69b1e69b91ee0e$export$f81b9f2c3f00b89b = (0, $dGvGJ.createSelector)((0, $bcoYn.projectTypeSelector), $1d69b1e69b91ee0e$export$f82d111da9150583, (projectType, allComments)=>(projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && allComments && Object.keys(allComments).length > 0 && (0, $6s1PB.expVal)('threaded_comments_ga', 'isEnabled', false));
const $1d69b1e69b91ee0e$var$sortedVisibleCommentIdsSelectorOld = (0, $dGvGJ.createSelector)((0, $2QmDq.getSelectedActivitySortOrder), $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, $1d69b1e69b91ee0e$export$f81b9f2c3f00b89b, (sortOrderType, comments, deletedIds, isThreadedCommentsEnabled)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && isThreadedCommentsEnabled || !deletedIds.includes(id)) && (isThreadedCommentsEnabled ? !comments[id].parentId : true));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map((id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate),
            ...isThreadedCommentsEnabled ? {
                size: comment?.childCommentIds?.size ?? 0
            } : {}
        };
    }).sort((a, b)=>sortOrderType === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, $g7reD.default)(a.createdDate, b.createdDate) : (0, $8ikER.default)(a.createdDate, b.createdDate)).map((comment)=>{
        if (isThreadedCommentsEnabled) return {
            id: comment.id,
            size: comment?.size ?? 0
        };
        return comment.id;
    });
    return sortedIds;
});
const $1d69b1e69b91ee0e$var$sortedVisibleCommentIdsSelectorNew = (0, $dGvGJ.createSelector)((0, $2QmDq.getSelectedActivitySortOrder), $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, $1d69b1e69b91ee0e$export$f81b9f2c3f00b89b, (sortOrderType, comments, deletedIds, isThreadedCommentsEnabled)=>{
    // filter out any comments currently pending deletion and replies as well
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && isThreadedCommentsEnabled || !deletedIds.includes(id)) && (isThreadedCommentsEnabled ? !comments[id].parentId : true));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(comments)).sort($1d69b1e69b91ee0e$var$compareCommentsInclSortOrderType(sortOrderType)).map((comment)=>{
        if (isThreadedCommentsEnabled) return {
            id: comment.id,
            size: comment.size
        };
        return comment.id;
    });
    return sortedIds;
});
const $1d69b1e69b91ee0e$export$81c523e14f04df2d = (0, $32bya.selectorWithCondition)(()=>(0, $4R6GH.fg)('jsm-timelines-phase-2'), $1d69b1e69b91ee0e$var$sortedVisibleCommentIdsSelectorNew, $1d69b1e69b91ee0e$var$sortedVisibleCommentIdsSelectorOld);
const $1d69b1e69b91ee0e$export$92f90914a92d6fe7 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$81c523e14f04df2d, (0, $2QmDq.getSelectedActivitySortOrder), $1d69b1e69b91ee0e$export$f82d111da9150583, (sortedCommentIds, sortOrderType, allComments)=>{
    if (sortedCommentIds.length === 0) return;
    const maybeLatestCommentId = sortedCommentIds[sortOrderType === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c) ? 0 : sortedCommentIds.length - 1];
    const commentId = typeof maybeLatestCommentId === 'string' ? maybeLatestCommentId : maybeLatestCommentId.id;
    return allComments[commentId].createdDate;
});
const $1d69b1e69b91ee0e$export$219697701c39ce2b = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.latestCommentCreatedTime);
const $1d69b1e69b91ee0e$export$567463de4ddebb27 = (0, $dGvGJ.createSelector)((0, $a1ky2.accountIdloggedInUserSelector), $1d69b1e69b91ee0e$export$219697701c39ce2b, $1d69b1e69b91ee0e$export$81c523e14f04df2d, $1d69b1e69b91ee0e$export$f82d111da9150583, (currentUserId, latestCommentTime, sortedCommentIds, allComments)=>{
    return sortedCommentIds.filter((comment)=>{
        const commentId = typeof comment === 'string' ? comment : comment.id;
        const { createdDate: createdDate, authorId: authorId } = allComments[commentId];
        if (currentUserId === authorId) return false;
        return !latestCommentTime || new Date(createdDate) > new Date(latestCommentTime);
    })?.length || 0;
});
const $1d69b1e69b91ee0e$export$6eba3f548a7f384e = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (commentEditor)=>!!commentEditor && commentEditor.isEditing);
const $1d69b1e69b91ee0e$export$239be48dfe5d80ba = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentSessionId || null);
const $1d69b1e69b91ee0e$export$3a00787e516c672c = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3b3d01d442cb684a, (state)=>state, (visibleCommentIds, state)=>visibleCommentIds.filter((commentId)=>$1d69b1e69b91ee0e$export$6eba3f548a7f384e(commentId)(state)));
const $1d69b1e69b91ee0e$export$4c04cd370caea884 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, (comments)=>comments ? Object.keys(comments).filter((key)=>typeof comments[key] === 'object') : []);
const $1d69b1e69b91ee0e$export$2e24e984817b4c7b = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$4c04cd370caea884, (state)=>state, (commentIds, state)=>commentIds.some((id)=>$1d69b1e69b91ee0e$export$6eba3f548a7f384e(id)(state)));
const $1d69b1e69b91ee0e$export$5373a6bfd674797c = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.addCommentEditorExpand || false);
const $1d69b1e69b91ee0e$export$37aee7d1ec9d42d3 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.addCommentEditorForceFocus || 0);
const $1d69b1e69b91ee0e$export$6df0ef2ac2b35c13 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$5373a6bfd674797c, $1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector, (isAddCommentEditorExpanded, commentEditors)=>isAddCommentEditorExpanded || (commentEditors ? (0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(commentEditors).some((editor)=>editor.isEditing) : false));
const $1d69b1e69b91ee0e$export$f140c5c89826efc6 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.isCommentAttachmentInProgress);
const $1d69b1e69b91ee0e$export$2ce513eb85289331 = (0, $dGvGJ.createSelector)((0, $bcoYn.isSimplifiedProjectSelector), (0, $bcoYn.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)));
const $1d69b1e69b91ee0e$var$replyingToCommentIdSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.replyingToCommentId);
const $1d69b1e69b91ee0e$export$ab64c511f5921cdf = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToCommentIdSelector, (replyingToCommentId)=>replyingToCommentId === commentId);
const $1d69b1e69b91ee0e$export$d89d07d36d57d778 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToCommentIdSelector, (replyingToCommentId)=>!!replyingToCommentId);
const $1d69b1e69b91ee0e$export$bb44f1aa6771eeb6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3e2634438f2a9b1a(`${(0, $7a0695d910e98a34$export$56251dcfec1ad08d)}-${commentId}`), (editingComment)=>editingComment || undefined);
const $1d69b1e69b91ee0e$var$replyingToAuthorIdSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.replyingToAuthorId);
const $1d69b1e69b91ee0e$export$6fe69cb268473af1 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToAuthorIdSelector, (0, $bcoYn.getUserByIdSelector), (replyingToAuthorId, getUserById)=>getUserById(replyingToAuthorId));
const $1d69b1e69b91ee0e$export$9f25935861e23f9b = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && comment.parentId);
const $1d69b1e69b91ee0e$export$8f158a3cc48edde6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9f25935861e23f9b(commentId), (comments, parentId)=>parentId ? comments[parentId] : undefined);
const $1d69b1e69b91ee0e$export$f3cffcd4d32274f6 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, (comments)=>Object.values(comments).some((comment)=>comment.isInternal === false));

});
// Activity sort order
const $c97bf8752afb1bcb$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $c97bf8752afb1bcb$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("g2C8o", function(module, exports) {

$parcel$export(module.exports, "SAVE_COMMENT_LOADING", () => $a2ddc97999af5bc9$export$ea56f55e95ac48c4);
$parcel$export(module.exports, "SAVE_CHILD_COMMENT_LOADING_PREFIX", () => $a2ddc97999af5bc9$export$7feea57d9f7d329e);
$parcel$export(module.exports, "LOADING", () => $a2ddc97999af5bc9$export$26d55645375ca9a);
$parcel$export(module.exports, "COMPLETE", () => $a2ddc97999af5bc9$export$1660a2d7c2fff354);
$parcel$export(module.exports, "COMMENT_VISIBILITY_PUBLIC", () => $a2ddc97999af5bc9$export$5dd24cf16d0bbf18);
$parcel$export(module.exports, "ActionButton", () => $a2ddc97999af5bc9$export$cfc7921d29ef7b80);

const $a2ddc97999af5bc9$export$34e5759f24cbaeac = (value)=>value;
const $a2ddc97999af5bc9$export$ea56f55e95ac48c4 = 'SAVE_COMMENT_LOADING';
const $a2ddc97999af5bc9$export$7feea57d9f7d329e = 'SAVE_CHILD_COMMENT_LOADING_';
const $a2ddc97999af5bc9$export$26d55645375ca9a = 'LOADING';
const $a2ddc97999af5bc9$export$1660a2d7c2fff354 = 'COMPLETE';
const $a2ddc97999af5bc9$export$5dd24cf16d0bbf18 = {
    type: (0, $b276debff3ef22b6$export$a3863626f98a38c2),
    value: ''
};
const $a2ddc97999af5bc9$export$cfc7921d29ef7b80 = {
    PREVIOUS: 'PREVIOUS',
    NEXT: 'NEXT'
};

});
const $b276debff3ef22b6$export$537a061b2f9c8800 = 'group';
const $b276debff3ef22b6$export$28a8bb936dce2def = 'role';
const $b276debff3ef22b6$export$a3863626f98a38c2 = 'public';


parcelRegister("32bya", function(module, exports) {

$parcel$export(module.exports, "selectorWithCondition", () => $269c1eb4b07b4fa1$export$6be2ebff06b95055);
const $269c1eb4b07b4fa1$export$6be2ebff06b95055 = (condition, selectorTrue, selectorFalse)=>{
    const selector = (...args)=>{
        if (condition()) return selectorTrue(...args);
        return selectorFalse(...args);
    };
    return selector;
};

});

parcelRegister("2QmDq", function(module, exports) {

$parcel$export(module.exports, "getSelectedActivityItem", () => $9baa1155ae0bb232$export$49b8848afae8c381);
$parcel$export(module.exports, "getSelectedActivitySortOrder", () => $9baa1155ae0bb232$export$7091381d8f3bc5cc);
$parcel$export(module.exports, "getActivityFeedInViewPort", () => $9baa1155ae0bb232$export$50e1cbd5557ceae1);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $9baa1155ae0bb232$var$getUiActivityFeed = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.activityFeed);
const $9baa1155ae0bb232$export$49b8848afae8c381 = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivityItem);
const $9baa1155ae0bb232$export$7091381d8f3bc5cc = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivitySortOrder);
const $9baa1155ae0bb232$export$50e1cbd5557ceae1 = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed.isActivityFeedInViewPort ?? true);

});

const $7a0695d910e98a34$export$c4134c813c47beb0 = 'NEW_OPTIMISTIC_COMMENT';
const $7a0695d910e98a34$export$56251dcfec1ad08d = 'NEW_OPTIMISTIC_COMMENT_REPLY';


parcelRegister("9acDX", function(module, exports) {

$parcel$export(module.exports, "isIssueLinksEnabledSelector", () => $2fb14f2dbdb6e11c$export$a8cf8910b8314c1a);
$parcel$export(module.exports, "remoteIssuesSelector", () => $2fb14f2dbdb6e11c$export$13978ee723866c4d);
$parcel$export(module.exports, "optimisticLinksDataSelector", () => $2fb14f2dbdb6e11c$export$819781ef7e99d6c7);
$parcel$export(module.exports, "hasCombinedIssueLinksSelector", () => $2fb14f2dbdb6e11c$export$8b1b2dfb6701d22c);
$parcel$export(module.exports, "combinedLinkedIssueCountSelector", () => $2fb14f2dbdb6e11c$export$7e10bfdc67ac9362);
$parcel$export(module.exports, "combinedLinksSelector", () => $2fb14f2dbdb6e11c$export$a101eb6fc884a8a0);
$parcel$export(module.exports, "issueLinkSelector", () => $2fb14f2dbdb6e11c$export$b82f4900195f5854);
$parcel$export(module.exports, "linkedIssueSelector", () => $2fb14f2dbdb6e11c$export$f5f26ceb5c86ee0);
$parcel$export(module.exports, "quickAddClickedCountSelector", () => $2fb14f2dbdb6e11c$export$d545d81c8e208408);
$parcel$export(module.exports, "isOpenedFromJsmSimilarIssuesSelector", () => $2fb14f2dbdb6e11c$export$3bf48255064c85d5);
$parcel$export(module.exports, "quickAddClickedIssueSelector", () => $2fb14f2dbdb6e11c$export$2c43c6abed5983de);
$parcel$export(module.exports, "shouldDisplayAddLinksSelector", () => $2fb14f2dbdb6e11c$export$5757979a0baa9c47);
$parcel$export(module.exports, "shouldDisplayRelatedIssuePanelSelector", () => $2fb14f2dbdb6e11c$export$eea0e617974abf06);
$parcel$export(module.exports, "canCreateLinkedIssueSelector", () => $2fb14f2dbdb6e11c$export$99914e520087b170);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $4f8Oj = parcelRequire("4f8Oj");

var $h6fst = parcelRequire("h6fst");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $bkUsp = parcelRequire("bkUsp");

var $bcoYn = parcelRequire("bcoYn");

var $1uvGd = parcelRequire("1uvGd");
/**
 * selectors for issue links
 *
 * issue links state looks like
 * issueLinks: {
 *  issueLinks: [
 *      link1,
 *      link2
 *  ],
 *  linkedIssueKeys: ['KEY-1', 'KEY-2'],
 *  linkedIssues: {
 *      'KEY-1': issue1,
 *      'KEY-2': issue2
 *  }
 * }
 */ const $2fb14f2dbdb6e11c$var$issueLinksRootSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.issueLinks);
const $2fb14f2dbdb6e11c$export$a8cf8910b8314c1a = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (root)=>!!root);
const $2fb14f2dbdb6e11c$var$linksDataSelector = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.issueLinks);
const $2fb14f2dbdb6e11c$export$13978ee723866c4d = (state)=>state.entities.remoteIssueLinks.remoteIssues;
const $2fb14f2dbdb6e11c$export$819781ef7e99d6c7 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (issueLinks)=>issueLinks && (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(issueLinks, (link)=>link.isOptimistic));
const $2fb14f2dbdb6e11c$var$linkedIssuesSelector = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.linkedIssues);
const $2fb14f2dbdb6e11c$export$701dc165268e44de = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks?.linkedIssueKeys || []);
const $2fb14f2dbdb6e11c$export$3c65f67962ca81cc = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (links)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(links));
const $2fb14f2dbdb6e11c$export$8b1b2dfb6701d22c = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteLinks)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(links) || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(remoteLinks));
const $2fb14f2dbdb6e11c$export$7e10bfdc67ac9362 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$701dc165268e44de, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteLinks)=>links.length + remoteLinks.length);
const $2fb14f2dbdb6e11c$export$f9c1778e36ca60f9 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, $2fb14f2dbdb6e11c$var$linkedIssuesSelector, (0, $1uvGd.jpdDeliverLinkTypeIdSelector), (links, issues, jpdDeliverLinkTypeId)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(links)) return (0, (/*@__PURE__*/$parcel$interopDefault($h6fst)))(links).filter((link)=>!link.isDeleted && !!link.linkedIssueKey)// Filter out links with jpd delivery link typeId and direction === "OUTWARD" and they are displayed in separate Ideas section
    .filter($2fb14f2dbdb6e11c$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues)).map((link)=>({
            ...link,
            linkedIssue: issues[link.linkedIssueKey]
        })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((linksMap, link)=>Object.assign(linksMap, {
            [link.typeName]: [
                ...linksMap[link.typeName] || [],
                link
            ]
        }), {});
    return null;
});
function $2fb14f2dbdb6e11c$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues) {
    return (link)=>{
        if (jpdDeliverLinkTypeId && (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view')) {
            const isImplementsLink = link.typeId === jpdDeliverLinkTypeId;
            const isOutwardLink = link.direction === (0, $bkUsp.OUTWARD_LINK_DIRECTION);
            const isIdea = issues[link.linkedIssueKey]?.issueProjectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT);
            if (isIdea && isImplementsLink && isOutwardLink) return false;
        }
        return true;
    };
}
const $2fb14f2dbdb6e11c$export$a101eb6fc884a8a0 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$f9c1778e36ca60f9, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteIssues)=>{
    if (links == null && remoteIssues.length === 0) return null;
    const extractBasicIssueDetails = (remoteIssueLinkEntity)=>({
            id: remoteIssueLinkEntity.remoteIssueId,
            issueKey: remoteIssueLinkEntity.issueKey,
            issueLink: remoteIssueLinkEntity.issueLinkUrl,
            issueSummary: remoteIssueLinkEntity.summary,
            issueTypeIconUrl: remoteIssueLinkEntity.iconUrl
        });
    // FIXME: JIV-15410 - expected to return IssueLink[]
    return remoteIssues.reduce((combinedLinks, remoteIssue)=>{
        const { issueDetails: issueDetails, relationship: relationship, id: id, issueKey: issueKey, issueLinkUrl: issueLinkUrl, remoteIssueLinkError: remoteIssueLinkError, globalId: globalId, isSaved: isSaved, isLoading: isLoading, isOptimistic: isOptimistic, hasError: hasError, isDeleted: isDeleted } = remoteIssue;
        if (relationship != null && isDeleted !== true) return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...combinedLinks,
            [relationship]: [
                ...combinedLinks[relationship] || [],
                {
                    id: id.toString(),
                    direction: (0, $bkUsp.OUTWARD_LINK_DIRECTION),
                    typeName: relationship,
                    linkedIssueKey: issueKey,
                    linkedIssue: issueDetails || extractBasicIssueDetails(remoteIssue),
                    isRemote: true,
                    globalId: globalId,
                    remoteServerHostname: new URL(issueLinkUrl).hostname,
                    remoteIssueLinkError: remoteIssueLinkError,
                    isSaved: isSaved,
                    isLoading: isLoading,
                    isOptimistic: isOptimistic,
                    hasError: hasError
                }
            ]
        };
        return combinedLinks;
    }, {
        ...links
    });
});
const $2fb14f2dbdb6e11c$export$b82f4900195f5854 = (issueLinkId)=>(0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (links)=>links && links[issueLinkId] || null);
const $2fb14f2dbdb6e11c$export$f5f26ceb5c86ee0 = (issueKey)=>(0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linkedIssuesSelector, (linkedIssues)=>linkedIssues && linkedIssues[issueKey] || null);
const $2fb14f2dbdb6e11c$export$d545d81c8e208408 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClicked);
const $2fb14f2dbdb6e11c$export$3bf48255064c85d5 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>!!issueLinks?.isOpenedFromJsmSimilarIssues);
const $2fb14f2dbdb6e11c$export$2c43c6abed5983de = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClickedIssue);
const $2fb14f2dbdb6e11c$export$5757979a0baa9c47 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$d545d81c8e208408, (count)=>!!count);
const $2fb14f2dbdb6e11c$export$eea0e617974abf06 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.aiLinkedIssueSuggestion);
const $2fb14f2dbdb6e11c$export$99914e520087b170 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.canCreateLinkedIssue);

});
parcelRegister("h6fst", function(module, exports) {

var $7Q2q6 = parcelRequire("7Q2q6");

var $jHlUS = parcelRequire("jHlUS");

var $jtBGw = parcelRequire("jtBGw");

var $hTJwX = parcelRequire("hTJwX");

var $agVdz = parcelRequire("agVdz");

var $cY2dI = parcelRequire("cY2dI");

var $f1B3k = parcelRequire("f1B3k");

var $eUuIg = parcelRequire("eUuIg");

var $jx6Tp = parcelRequire("jx6Tp");

var $dMEgP = parcelRequire("dMEgP");
/** `Object#toString` result references. */ var $c72efce4841a6f93$var$mapTag = '[object Map]', $c72efce4841a6f93$var$setTag = '[object Set]';
/** Built-in value references. */ var $c72efce4841a6f93$var$symIterator = $7Q2q6 ? $7Q2q6.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $c72efce4841a6f93$var$toArray(value) {
    if (!value) return [];
    if ($hTJwX(value)) return $agVdz(value) ? $jx6Tp(value) : $jHlUS(value);
    if ($c72efce4841a6f93$var$symIterator && value[$c72efce4841a6f93$var$symIterator]) return $cY2dI(value[$c72efce4841a6f93$var$symIterator]());
    var tag = $jtBGw(value), func = tag == $c72efce4841a6f93$var$mapTag ? $f1B3k : tag == $c72efce4841a6f93$var$setTag ? $eUuIg : $dMEgP;
    return func(value);
}
module.exports = $c72efce4841a6f93$var$toArray;

});
parcelRegister("cY2dI", function(module, exports) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $970ccf8c01557998$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = $970ccf8c01557998$var$iteratorToArray;

});


parcelRegister("bkUsp", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $1e4a31a537751af2$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $1e4a31a537751af2$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $1e4a31a537751af2$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $1e4a31a537751af2$export$4b7bcc27238c61b9);
const $1e4a31a537751af2$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $1e4a31a537751af2$export$5dec99d71ec794ba = 'OUTWARD';
const $1e4a31a537751af2$export$6cdcf74878b11d34 = 'BOTH';
const $1e4a31a537751af2$export$4b7bcc27238c61b9 = {
    [$1e4a31a537751af2$export$b5e2b68b0fa7f1c8]: $1e4a31a537751af2$export$b5e2b68b0fa7f1c8,
    [$1e4a31a537751af2$export$5dec99d71ec794ba]: $1e4a31a537751af2$export$5dec99d71ec794ba,
    [$1e4a31a537751af2$export$6cdcf74878b11d34]: $1e4a31a537751af2$export$6cdcf74878b11d34
};

});

parcelRegister("1uvGd", function(module, exports) {

$parcel$export(module.exports, "jpdDeliverLinkTypeIdSelector", () => $20ab26563cc602b2$export$c25a0be5d19458d3);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $20ab26563cc602b2$export$c25a0be5d19458d3 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.jpdDeliveryIssueLinkTypeId);

});


parcelRegister("ifezr", function(module, exports) {

$parcel$export(module.exports, "issueTypesSelector", () => $1b8b68c890f5544b$export$f5378064bf877b95);
$parcel$export(module.exports, "hasUnsupportedType", () => $1b8b68c890f5544b$export$1f59505fa2d77635);
$parcel$export(module.exports, "issueTypesForClassicProjectEpicSelector", () => $1b8b68c890f5544b$export$a0efcb09d3e23dc1);
$parcel$export(module.exports, "fetchIssueTypesStatusSelector", () => $1b8b68c890f5544b$export$bfbb65ccb13a16eb);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $bcoYn = parcelRequire("bcoYn");

var $lssfC = parcelRequire("lssfC");
const $1b8b68c890f5544b$export$f5378064bf877b95 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.issueTypes);
// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by JIRA.
const $1b8b68c890f5544b$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $1b8b68c890f5544b$var$isRequiredFieldProvided = (fieldName)=>$1b8b68c890f5544b$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
// A field is considered 'unsupported' if not provided by JIRA,
// has no default value, and is a `required` field.
const $1b8b68c890f5544b$var$hasUnsupportedRequiredField = (fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    !!Object.keys(fields).find((fieldName)=>!$1b8b68c890f5544b$var$isRequiredFieldProvided(fieldName) && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        !fields[fieldName].hasDefaultValue && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        fields[fieldName].required);
const $1b8b68c890f5544b$export$1f59505fa2d77635 = (issueType)=>(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueType.fields) || $1b8b68c890f5544b$var$hasUnsupportedRequiredField(issueType.fields);
const $1b8b68c890f5544b$export$a0efcb09d3e23dc1 = (0, $dGvGJ.createSelector)($1b8b68c890f5544b$export$f5378064bf877b95, (0, $lssfC.issueTypeSelector), (0, $bcoYn.isEpicSelector), (issueTypes, currentIssueType, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isCurrentIssueAnEpic)=>{
    const epicIssueTypeId = isCurrentIssueAnEpic && currentIssueType && currentIssueType.id;
    return issueTypes.filter(// @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'number' and 'string | boolean | undefined' have no overlap.
    (issueType)=>!issueType.subtask && issueType.id !== epicIssueTypeId);
});
const $1b8b68c890f5544b$export$bfbb65ccb13a16eb = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.fetchIssueTypesStatus);

});

parcelRegister("3Ke60", function(module, exports) {

$parcel$export(module.exports, "subtaskTypesSelector", () => $e14dab62dd4bafa5$export$86a4f97fc27a0c44);
$parcel$export(module.exports, "isSubtaskTypesPresentSelector", () => $e14dab62dd4bafa5$export$9a147dcac364dd81);
$parcel$export(module.exports, "hasUnsupportedTypeSelector", () => $e14dab62dd4bafa5$export$3fbfbdcf57f34c2);

var $dGvGJ = parcelRequire("dGvGJ");

var $ifezr = parcelRequire("ifezr");
const $e14dab62dd4bafa5$export$86a4f97fc27a0c44 = (0, $dGvGJ.createSelector)((0, $ifezr.issueTypesSelector), (issueTypes)=>issueTypes.filter((type)=>type.subtask));
const $e14dab62dd4bafa5$export$9a147dcac364dd81 = (0, $dGvGJ.createSelector)($e14dab62dd4bafa5$export$86a4f97fc27a0c44, (subtaskTypes)=>subtaskTypes.length >= 1);
const $e14dab62dd4bafa5$export$3fbfbdcf57f34c2 = (0, $dGvGJ.createSelector)($e14dab62dd4bafa5$export$86a4f97fc27a0c44, (subtaskTypes)=>!!subtaskTypes.find((0, $ifezr.hasUnsupportedType)));

});

parcelRegister("aN61o", function(module, exports) {

$parcel$export(module.exports, "isSubtaskSelector", () => $37d2c831d03fb4f0$export$15fea4741156936);
$parcel$export(module.exports, "subtaskEntitiesSelector", () => $37d2c831d03fb4f0$export$17e529874841c746);
$parcel$export(module.exports, "hasSubtasksSelector", () => $37d2c831d03fb4f0$export$f363078714850fd9);
$parcel$export(module.exports, "canCreateSubtaskSelector", () => $37d2c831d03fb4f0$export$151aaebeef1cfe63);

var $dGvGJ = parcelRequire("dGvGJ");


var $fOGZN = parcelRequire("fOGZN");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $gnp10 = parcelRequire("gnp10");

var $jMY7o = parcelRequire("jMY7o");

var $lssfC = parcelRequire("lssfC");

var $fbv6S = parcelRequire("fbv6S");

var $3Ke60 = parcelRequire("3Ke60");
const $37d2c831d03fb4f0$export$15fea4741156936 = (0, $dGvGJ.createSelector)((0, $lssfC.issueTypeSelector), (issueType)=>!!(issueType && issueType.subtask));
const $37d2c831d03fb4f0$export$17e529874841c746 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.subtasks);
const $37d2c831d03fb4f0$export$f363078714850fd9 = (0, $dGvGJ.createSelector)($37d2c831d03fb4f0$export$17e529874841c746, (0, $7Ow8a.childIssuesLimitUrlSelector), (subtasks, getChildIssuesLimitUrl)=>subtasks.length > 0 || Boolean(getChildIssuesLimitUrl((0, $fOGZN.SUBTASKS))));
const $37d2c831d03fb4f0$export$899afcd59181acbb = (0, $dGvGJ.createSelector)((0, $bcoYn.isSimplifiedProjectSelector), (0, $jMY7o.isIssueBaseLevel), (0, $gnp10.hasChildrenIssuesSelector), $37d2c831d03fb4f0$export$f363078714850fd9, (isSimplifiedProject, issueBaseLevel, hasChildrenIssues, hasSubtasks)=>isSimplifiedProject ? issueBaseLevel && hasChildrenIssues : hasSubtasks);
const $37d2c831d03fb4f0$export$58b46fbc7ab224f6 = (0, $dGvGJ.createSelector)((0, $3Ke60.hasUnsupportedTypeSelector), (0, $fbv6S.projectHasSubtaskValidatorsSelector), (hasRequiredFields, hasSubtaskValidators)=>hasRequiredFields || hasSubtaskValidators);
const $37d2c831d03fb4f0$export$94f22e5d109e9b04 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), ({ jiraSettings: jiraSettings })=>jiraSettings.subtasksConfiguration.enabled);
const $37d2c831d03fb4f0$export$151aaebeef1cfe63 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), $37d2c831d03fb4f0$export$15fea4741156936, (0, $3Ke60.isSubtaskTypesPresentSelector), $37d2c831d03fb4f0$export$58b46fbc7ab224f6, (0, $a1ky2.isMobileSelector), (0, $a1ky2.isBitbucketSelector), (0, $a1ky2.isServiceDeskSelector), (0, $bcoYn.isSimplifiedProjectSelector), $37d2c831d03fb4f0$export$94f22e5d109e9b04, (0, $bcoYn.projectSelector), ({ canCreateSubtask: canCreateSubtask }, isSubtask, typesPresent, shouldUseFallbackDialog, isMobile, isBitbucket, isServicedesk, isSimplified, subtasksEnabled, project)=>{
    const shouldHideForMobileOrBitbucket = shouldUseFallbackDialog ? isMobile || isBitbucket : false;
    const isProjectActive = (project?.projectStatus ?? (0, $cd476f3ecebdab63$export$62113557945f790a)) === (0, $cd476f3ecebdab63$export$62113557945f790a);
    const shouldShowSubtask = isServicedesk ? !isSimplified : true;
    return !!(canCreateSubtask && !isSubtask && typesPresent && !shouldHideForMobileOrBitbucket && shouldShowSubtask && subtasksEnabled && isProjectActive);
});

});
parcelRegister("gnp10", function(module, exports) {

$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $29aeec2b4781c452$export$29f34d4d7c528e9c);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $5fc53 = parcelRequire("5fc53");

var $7Ow8a = parcelRequire("7Ow8a");
const $29aeec2b4781c452$var$childrenIssueSelector = (0, $7Ow8a.fieldSelector)((0, $5fc53.CHILDREN_ISSUES));
const $29aeec2b4781c452$export$29f34d4d7c528e9c = (0, $dGvGJ.createSelector)($29aeec2b4781c452$var$childrenIssueSelector, (0, $7Ow8a.childIssuesLimitUrlSelector), (childrenIssues, getChildIssuesLimitUrl)=>childrenIssues ? !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(childrenIssues.value) || Boolean(getChildIssuesLimitUrl((0, $5fc53.CHILDREN_ISSUES))) : false);

});

parcelRegister("fbv6S", function(module, exports) {

$parcel$export(module.exports, "projectHasSubtaskValidatorsSelector", () => $cb6f2b5c3e56bbb6$export$ecfed315b19a7565);

var $dGvGJ = parcelRequire("dGvGJ");

const $cb6f2b5c3e56bbb6$var$hasSubtaskValidators = (hasValidators)=>hasValidators.status === (0, $5d539a63717f8747$export$4c02edeb1b5e410a) && hasValidators.value;
const $cb6f2b5c3e56bbb6$var$unknown = (hasValidators)=>hasValidators.status === (0, $5d539a63717f8747$export$26d55645375ca9a) || hasValidators.status === (0, $5d539a63717f8747$export$d71930f7f5807a72);
const $cb6f2b5c3e56bbb6$export$ecfed315b19a7565 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.validators, (validators)=>{
    const val = validators.projectHasSubtaskValidators;
    return $cb6f2b5c3e56bbb6$var$hasSubtaskValidators(val) || $cb6f2b5c3e56bbb6$var$unknown(val);
});

});
const $5d539a63717f8747$export$26d55645375ca9a = 'LOADING';
const $5d539a63717f8747$export$d71930f7f5807a72 = 'FAILED';
const $5d539a63717f8747$export$4c02edeb1b5e410a = 'LOADED';



parcelRegister("dvijh", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $1403612d0fe1296c$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $1403612d0fe1296c$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $1403612d0fe1296c$export$b18d061fc042df1a);
const $1403612d0fe1296c$export$4cab9dfa8fc858f4 = 'Comments';
const $1403612d0fe1296c$export$df36fc05622c402 = 'Worklog';
const $1403612d0fe1296c$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});

parcelRegister("fKtck", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $11ab2af1eff70e7f$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $11ab2af1eff70e7f$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $11ab2af1eff70e7f$export$b66f3e03c722c21c);
$parcel$export(module.exports, "PermalinkType", () => (parcelRequire("dvijh")).PermalinkType);

var $8QpSo = parcelRequire("8QpSo");

var $ebyGx = parcelRequire("ebyGx");

var $gKZoD = parcelRequire("gKZoD");

var $dvijh = parcelRequire("dvijh");
const $11ab2af1eff70e7f$export$58d3deae755361f = (0, $8QpSo.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parseUrl(searchString).query;
    if (params[(0, $dvijh.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $dvijh.COMMENTS),
        permalinkId: params[(0, $dvijh.PermalinkType).COMMENTS]
    };
    if (params[(0, $dvijh.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $dvijh.WORKLOG),
        permalinkId: params[(0, $dvijh.PermalinkType).WORKLOG]
    };
    return null;
});
const $11ab2af1eff70e7f$export$f72cac1fa8a03e80 = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $11ab2af1eff70e7f$export$58d3deae755361f(window.location.search);
};
const $11ab2af1eff70e7f$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $11ab2af1eff70e7f$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $11ab2af1eff70e7f$export$b66f3e03c722c21c = (id, permalinkType)=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $dvijh.PermalinkType).WORKLOG ? (0, $dvijh.PermalinkType).COMMENTS : (0, $dvijh.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});


parcelRegister("jf6us", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bdbb34cd5461e74$export$2e2bcd8739ae039);
class $6bdbb34cd5461e74$export$2e2bcd8739ae039 {
    constructor(state){
        this.hasLoadedEditor = false;
        this.startTime = Math.floor(performance.now()) // start time in origin relative  millis
        ;
        this.immutableState = state;
        this.isLoadedWithPage = state.isLoadedWithPage;
    }
    lazyMetricsProps() {
        return this.immutableState.lazyMetricsProps;
    }
    getDataProvider() {
        return this.immutableState.dataProvider;
    }
    getIsFullIssue() {
        return this.immutableState.analyticsSource === 'full-issue';
    }
    getIsLoadedWithPage() {
        return this.immutableState.isLoadedWithPage;
    }
    setIsLoadedWithPage(newValue) {
        this.isLoadedWithPage = newValue;
    }
    getIsSPA() {
        return this.immutableState.isSPA;
    }
    getIsRecentIssue() {
        return this.immutableState.isRecentIssue;
    }
    getRecentIssuesCount() {
        return this.immutableState.recentIssuesCount;
    }
    getAnalyticsSource() {
        return this.immutableState.analyticsSource;
    }
    getCorrelationId() {
        return this.immutableState.correlationId;
    }
    getIssueScaleabilityReporter() {
        return this.immutableState.issueScaleabilityReporter;
    }
    getStartTime() {
        return this.startTime;
    }
    setPreviewEnd(end) {
        this.previewEnd = end === null ? 0 : Math.floor(end);
    }
    getPreviewEnd() {
        return this.previewEnd;
    }
    setFMP(end) {
        this.fmp = end === null ? 0 : Math.floor(end);
    }
    getFMP() {
        return this.fmp;
    }
    setInteractiveEnd(millisSinceEpoch) {
        this.interactiveEnd = millisSinceEpoch;
    }
    getInteractiveEnd() {
        return this.interactiveEnd;
    }
    setTrueInteractiveEnd(millisSinceEpoch) {
        this.trueInteractiveEnd = Math.floor(millisSinceEpoch);
    }
    getTrueInteractiveEnd() {
        return Math.floor(this.trueInteractiveEnd);
    }
    getHasLoadedEditor() {
        return this.hasLoadedEditor;
    }
    getIsInitial() {
        return this.getIsFullIssue() && !this.getIsSPA();
    }
    getLocation() {
        const { route: route } = this.immutableState;
        const routeName = route?.name;
        return routeName || '';
    }
}

});

parcelRegister("fdHx2", function(module, exports) {

$parcel$export(module.exports, "metricsStateSelector", () => $e53f50d927a7fce5$export$8cfb2e5f509cb762);

var $dGvGJ = parcelRequire("dGvGJ");

var $fuw6O = parcelRequire("fuw6O");

var $a1ky2 = parcelRequire("a1ky2");
const $e53f50d927a7fce5$export$8cfb2e5f509cb762 = (0, $dGvGJ.createSelector)((0, $a1ky2.applicationKeySelector), (0, $a1ky2.viewModeSelector), (0, $a1ky2.issueIdSelector), (analyticsKey, viewMode, issueId)=>({
        analyticsKey: analyticsKey,
        viewMode: (0, $fuw6O.getSafeViewMode)(viewMode),
        issueId: issueId
    }));

});
parcelRegister("fuw6O", function(module, exports) {

$parcel$export(module.exports, "getSafeViewMode", () => $f501923c845d9095$export$abc152b4d639d329);
const $f501923c845d9095$var$getViewMode = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.localStorage && window.localStorage.getItem('gh.ghx-issue-fragment-view-mode') || 'default';
const $f501923c845d9095$var$mapPredefinedViewMode = (predefinedViewMode)=>{
    switch(predefinedViewMode){
        case 'MODAL':
            return 'modal';
        case 'SIDEBAR':
            return 'sidebar';
        default:
            return null;
    }
};
const $f501923c845d9095$export$abc152b4d639d329 = (predefinedViewMode = null)=>$f501923c845d9095$var$mapPredefinedViewMode(predefinedViewMode) || $f501923c845d9095$var$getViewMode().replace(/"/g, '');

});



parcelRegister("a1E0h", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74b2d5db613050c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");

var $7eqRV = parcelRequire("7eqRV");

var $5gJcp = parcelRequire("5gJcp");

var $eVPAx = parcelRequire("eVPAx");

var $2NMNM = parcelRequire("2NMNM");

var $9noxX = parcelRequire("9noxX");

var $4wxhn = parcelRequire("4wxhn");

var $ebuBP = parcelRequire("ebuBP");

var $g5X3G = parcelRequire("g5X3G");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $kxZPA = parcelRequire("kxZPA");

var $lVJAU = parcelRequire("lVJAU");
const $d74b2d5db613050c$var$isEcClientEnabled = ()=>{
    const experiences = (0, $co1wz.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};

const $d74b2d5db613050c$export$8c70dcc4643464f8 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("i8gBA")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $d74b2d5db613050c$export$5aebed4b5cba826a = ({ backButtonUrl: backButtonUrl, issueNavigatorData: issueNavigatorData, issueKey: issueKey, onDispatchExternalActionRef: onDispatchExternalActionRef, onIssueDeleteSuccess: onIssueDeleteSuccess, analyticsSource: analyticsSource, ServiceDeskAnalyticsContext: ServiceDeskAnalyticsContext = (0, $9noxX.ServiceDeskAnalyticsContext) })=>{
    const routerActions = (0, $lVJAU.useRouterActions)();
    const [selectedIssueKey, setIssueKey] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($d74b2d5db613050c$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $eVPAx.useEcClient)().saveIssueMutationToCache;
    const onIssueKeyChange = (data)=>{
        setIssueKey(data.toIssueKey);
        (0, $dJl1T.default).safeInfoWithoutCustomerData('jsm.issue.view.issue-key-change', 'Invalid issue key, redirecting to correct issue key');
        routerActions.push(`/browse/${data.toIssueKey}`);
    };
    const onChangeHandler = (event)=>{
        (0, $4wxhn.saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebuBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ServiceDeskAnalyticsContext, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: "servicedesk-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d74b2d5db613050c$export$8c70dcc4643464f8, {
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        analyticsSource: analyticsSource,
        backButtonUrl: backButtonUrl,
        dispatchExternalActionRef: onDispatchExternalActionRef,
        shouldSetInitialFocus: true,
        isLoadedWithPage: true,
        issueKey: (0, $g5X3G.toIssueKey)(selectedIssueKey) || issueKey,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        issueMaxWidth: (0, $5gJcp.getIssueContainerMaxWidth)(),
        onChange: onChangeHandler,
        issueNavigatorData: issueNavigatorData
    }))));
};
const $d74b2d5db613050c$var$getAnalyticsSourceFromUrl = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    if (pathname.includes('reports')) return 'viewReportIssue';
    return 'viewQueueIssue';
};
const $d74b2d5db613050c$var$WrappedIssueView = (0, $jzjy1.AnalyticsSource)($d74b2d5db613050c$var$getAnalyticsSourceFromUrl(), (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($d74b2d5db613050c$export$5aebed4b5cba826a);
const $d74b2d5db613050c$var$IssueViewContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d74b2d5db613050c$var$WrappedIssueView, props);
var $d74b2d5db613050c$export$2e2bcd8739ae039 = $d74b2d5db613050c$var$IssueViewContainer;

});
parcelRegister("5gJcp", function(module, exports) {

$parcel$export(module.exports, "HEADER_BREADCRUMBS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$eb0ef5297b0cdc23);
$parcel$export(module.exports, "HEADER_BREADCRUMBS_END_MARK_KEY", () => $0350c967e71738f5$export$9c0a7052eb43d49c);
$parcel$export(module.exports, "HEADER_ACTIONS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$ff64d9f93169b1f0);
$parcel$export(module.exports, "HEADER_ACTIONS_END_MARK_KEY", () => $0350c967e71738f5$export$e696e07345d019c7);
$parcel$export(module.exports, "ISSUE_NAME_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$39f2c7a88d6952c7);
$parcel$export(module.exports, "ISSUE_NAME_END_MARK_KEY", () => $0350c967e71738f5$export$6b38db117e6a59c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$e4ec603cd2ae64c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_END_MARK_KEY", () => $0350c967e71738f5$export$485e8138df2fade3);
$parcel$export(module.exports, "CONTENT_ITEMS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$37c39403f63dfe50);
$parcel$export(module.exports, "CONTENT_ITEMS_END_MARK_KEY", () => $0350c967e71738f5$export$bcac34901554ce05);
$parcel$export(module.exports, "ACTIVITY_FEED_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$cfd354167a2170f3);
$parcel$export(module.exports, "ACTIVITY_FEED_END_MARK_KEY", () => $0350c967e71738f5$export$e20857c483438d46);
$parcel$export(module.exports, "FOOTNOTE_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$2f7e8d259a68175d);
$parcel$export(module.exports, "FOOTNOTE_END_MARK_KEY", () => $0350c967e71738f5$export$8c4857e697bb9a6b);
$parcel$export(module.exports, "ISSUE_STATUS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$6669013ba0004c0);
$parcel$export(module.exports, "ISSUE_STATUS_END_MARK_KEY", () => $0350c967e71738f5$export$ff2ebe781d7bd44e);
$parcel$export(module.exports, "defaultRatioRightColumn", () => $0350c967e71738f5$export$7fec582ac43ca9da);
$parcel$export(module.exports, "getIssueContainerMaxWidth", () => $0350c967e71738f5$export$c76181843186885);
const $0350c967e71738f5$export$eb0ef5297b0cdc23 = 'HEADER_BREADCRUMBS_BEGIN_MARK';
const $0350c967e71738f5$export$9c0a7052eb43d49c = 'HEADER_BREADCRUMBS_END_MARK';
const $0350c967e71738f5$export$ff64d9f93169b1f0 = 'HEADER_ACTIONS_BEGIN_MARK';
const $0350c967e71738f5$export$e696e07345d019c7 = 'HEADER_ACTIONS_END_MARK';
const $0350c967e71738f5$export$39f2c7a88d6952c7 = 'ISSUE_NAME_BEGIN_MARK';
const $0350c967e71738f5$export$6b38db117e6a59c3 = 'ISSUE_NAME_END_MARK';
const $0350c967e71738f5$export$e4ec603cd2ae64c3 = 'QUICK_ADD_ITEMS_BEGIN_MARK';
const $0350c967e71738f5$export$485e8138df2fade3 = 'QUICK_ADD_ITEMS_END_MARK';
const $0350c967e71738f5$export$37c39403f63dfe50 = 'CONTENT_ITEMS_BEGIN_MARK';
const $0350c967e71738f5$export$bcac34901554ce05 = 'CONTENT_ITEMS_END_MARK';
const $0350c967e71738f5$export$cfd354167a2170f3 = 'ACTIVITY_FEED_BEGIN_MARK';
const $0350c967e71738f5$export$e20857c483438d46 = 'ACTIVITY_FEED_END_MARK';
const $0350c967e71738f5$export$2f7e8d259a68175d = 'FOOTNOTE_BEGIN_MARK';
const $0350c967e71738f5$export$8c4857e697bb9a6b = 'FOOTNOTE_END_MARK';
const $0350c967e71738f5$export$6669013ba0004c0 = 'ISSUE_STATUS_BEGIN_MARK';
const $0350c967e71738f5$export$ff2ebe781d7bd44e = 'ISSUE_STATUS_END_MARK';
const $0350c967e71738f5$export$7fec582ac43ca9da = 0.35;
const $0350c967e71738f5$export$c76181843186885 = ()=>1680;

});

parcelRegister("ebuBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c071e939b06924f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bjGZV = parcelRequire("bjGZV");
const $1c071e939b06924f$export$e809a659e11e6855 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bjGZV.FullPageIssueContainer), null, props.children);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c071e939b06924f$export$2e2bcd8739ae039 = ({ ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c071e939b06924f$export$e809a659e11e6855, rest);

});
parcelRegister("bjGZV", function(module, exports) {

$parcel$export(module.exports, "FullPageIssueContainer", () => $70e5c13e9d9b58f1$export$f4550b4a355415eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $70e5c13e9d9b58f1$export$f4550b4a355415eb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jQ7vZ", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $9fff0bf09ea99829$export$ae316f0eeb712a36);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $9fff0bf09ea99829$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $doZTA.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $5uXOq.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});






//# sourceMappingURL=async-servicedesk-queues-agent-and-issue-view.d8ec4a1f.js.map
